/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
// removed moment_js from core
// customized by tzd

(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-datepicker", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    // Datepicker

    var active = false, dropdown;

    UI.component('datepicker', {

        defaults: {
            mobile: false,
            weekstart: 1,
            i18n: {
                months        : ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
                weekdays      : ['Dom','Seg','Ter','Qua','Qui','Sex','Sab']
            },
            format: "DD.MM.YYYY",
            offsettop: 5,
            maxDate: false,
            minDate: false,
            pos: 'auto',
            addClass: '',
            template: function(data, opts) {

                var content = '', i;

                content += '<div class="uk-datepicker-nav uk-clearfix">';
                content += '<a href="" class="uk-datepicker-previous"></a>';
                content += '<a href="" class="uk-datepicker-next"></a>';

                if (UI.formSelect) {

                    var currentyear = (new Date()).getFullYear(), options = [], months, years, minYear, maxYear;

                    for (i=0;i<opts.i18n.months.length;i++) {
                        if(i==data.month) {
                            options.push('<option value="'+i+'" selected>'+opts.i18n.months[i]+'</option>');
                        } else {
                            options.push('<option value="'+i+'">'+opts.i18n.months[i]+'</option>');
                        }
                    }

                    months = '<span class="uk-form-select">'+ opts.i18n.months[data.month] + '<select class="update-picker-month">'+options.join('')+'</select></span>';

                    // --

                    options = [];

                    minYear = data.minDate ? data.minDate.year() : currentyear - 50;
                    maxYear = data.maxDate ? data.maxDate.year() : currentyear + 20;

                    for (i=minYear;i<=maxYear;i++) {
                        if (i == data.year) {
                            options.push('<option value="'+i+'" selected>'+i+'</option>');
                        } else {
                            options.push('<option value="'+i+'">'+i+'</option>');
                        }
                    }

                    years  = '<span class="uk-form-select">'+ data.year + '<select class="update-picker-year">'+options.join('')+'</select></span>';

                    content += '<div class="uk-datepicker-heading">'+ months + ' ' + years +'</div>';

                } else {
                    content += '<div class="uk-datepicker-heading">'+ opts.i18n.months[data.month] +' '+ data.year+'</div>';
                }

                content += '</div>';

                content += '<table class="uk-datepicker-table">';
                content += '<thead>';
                for(i = 0; i < data.weekdays.length; i++) {
                    if (data.weekdays[i]) {
                        content += '<th>'+data.weekdays[i]+'</th>';
                    }
                }
                content += '</thead>';

                content += '<tbody>';
                for(i = 0; i < data.days.length; i++) {
                    if (data.days[i] && data.days[i].length){
                        content += '<tr>';
                        for(var d = 0; d < data.days[i].length; d++) {
                            if (data.days[i][d]) {
                                var day = data.days[i][d],
                                    cls = [];

                                if(!day.inmonth) cls.push("uk-datepicker-table-muted");
                                if(day.selected) cls.push("uk-active");
                                if(day.disabled) cls.push('uk-datepicker-date-disabled uk-datepicker-table-muted');

                                content += '<td><a href="" class="'+cls.join(" ")+'" data-date="'+day.day.format()+'">'+day.day.format("D")+'</a></td>';
                            }
                        }
                        content += '</tr>';
                    }
                }
                content += '</tbody>';

                content += '</table>';

                return content;
            }
        },

        boot: function() {

            UI.$win.on("resize orientationchange", function() {

                if (active) {
                    active.hide();
                }
            });

            // init code
            UI.$html.on("focus.datepicker.uikit", "[data-uk-datepicker]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("datepicker")) {
                    e.preventDefault();
                    UI.datepicker(ele, UI.Utils.options(ele.attr("data-uk-datepicker")));
                    ele.trigger("focus");
                }
            });

            UI.$html.on("click focus", '*', function(e) {

                var target = UI.$(e.target);

                if (active && target[0] != dropdown[0] && !target.data("datepicker") && !target.parents(".uk-datepicker:first").length) {
                    active.hide();
                }
            });
        },

        init: function() {

            // use native datepicker on touch devices
            if (UI.support.touch && this.element.attr('type')=='date' && !this.options.mobile) {
                return;
            }

            var $this = this;

            this.current  = this.element.val() ? moment(this.element.val(), this.options.format) : moment();

            this.on("click focus", function(){
                if (active!==$this) $this.pick(this.value ? this.value:($this.options.minDate ? $this.options.minDate :''));
            }).on("change", function(){
                if ($this.element.val() && !moment($this.element.val(), $this.options.format).isValid()) {
                    $this.element.val(moment().format($this.options.format));
                }
            });

            // init dropdown
            if (!dropdown) {

                dropdown = UI.$('<div class="uk-dropdown uk-datepicker '+$this.options.addClass+'"></div>');

                dropdown.on("click", ".uk-datepicker-next, .uk-datepicker-previous, [data-date]", function(e){

                    e.stopPropagation();
                    e.preventDefault();

                    var ele = UI.$(this);

                    if (ele.hasClass('uk-datepicker-date-disabled')) return false;

                    if (ele.is('[data-date]')) {
                        active.current = moment(ele.data("date"));
                        active.element.val(active.current.format(active.options.format)).trigger("change");
                        dropdown.removeClass('uk-dropdown-shown');
                        setTimeout(function() {
                            dropdown.removeClass('uk-dropdown-active')
                        },280);
                        active.hide();
                    } else {
                        active.add((ele.hasClass("uk-datepicker-next") ? 1:-1), "months");
                    }
                });

                dropdown.on('change', '.update-picker-month, .update-picker-year', function(){

                    var select = UI.$(this);
                    active[select.is('.update-picker-year') ? 'setYear':'setMonth'](Number(select.val()));
                });

                dropdown.appendTo("body");
            }
        },

        pick: function(initdate) {

            var offset = this.element.offset(),
                offset_left = parseInt(offset.left),
                offset_top = parseInt(offset.top),
                css = {
                    'left': offset_left,
                    'right': ""
                };

            this.current  = isNaN(initdate) ? moment(initdate, this.options.format):moment();
            this.initdate = this.current.format("YYYY-MM-DD");

            this.update();

            if (UI.langdirection == 'right' || ( window.innerWidth - offset_left - dropdown.outerWidth() < 0 ) ) {
                css.right = (window.innerWidth - (window.innerWidth - $('body').width())) - (css.left + this.element.outerWidth());
                css.left  = "";
            }

            var posTop    = (offset_top - this.element.outerHeight() + this.element.height()) - this.options.offsettop - dropdown.outerHeight(),
                posBottom = offset_top + this.element.outerHeight() + this.options.offsettop;

            css.top = posBottom;

            if (this.options.pos == 'top') {
                css.top = posTop;
                dropdown.addClass('dp-top');
            } else if(this.options.pos == 'auto' && (window.innerHeight - posBottom - dropdown.outerHeight() + UI.$win.scrollTop() < 0 && posTop >= 0) ) {
                css.top = posTop;
                dropdown.addClass('dp-top');
            }

            css.minWidth = dropdown.actual('outerWidth');

            dropdown.css(css).addClass('uk-dropdown-active uk-dropdown-shown');

            this.trigger('show.uk.datepicker');

            active = this;
        },

        add: function(unit, value) {
            this.current.add(unit, value);
            this.update();
        },

        setMonth: function(month) {
            this.current.month(month);
            this.update();
        },

        setYear: function(year) {
            this.current.year(year);
            this.update();
        },

        update: function() {

            var data = this.getRows(this.current.year(), this.current.month()),
                tpl  = this.options.template(data, this.options);

            dropdown.html(tpl);

            this.trigger('update.uk.datepicker');
        },

        getRows: function(year, month) {

            var opts   = this.options,
                now    = moment().format('YYYY-MM-DD'),
                days   = [31, (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month],
                before = new Date(year, month, 1, 12).getDay(),
                data   = {"month":month, "year":year,"weekdays":[],"days":[], "maxDate": false, "minDate": false},
                row    = [];

            if (opts.maxDate!==false){
                data.maxDate = isNaN(opts.maxDate) ? moment(opts.maxDate, opts.format) : moment().add(opts.maxDate, 'days');
            }

            if (opts.minDate!==false){
                data.minDate = isNaN(opts.minDate) ? moment(opts.minDate, opts.format) : moment().add(opts.minDate-1, 'days');
            }

            data.weekdays = (function(){

                for (var i=0, arr=[]; i < 7; i++) {

                    var day = i + (opts.weekstart || 0);

                    while (day >= 7) {
                        day -= 7;
                    }

                    arr.push(opts.i18n.weekdays[day]);
                }

                return arr;
            })();

            if (opts.weekstart && opts.weekstart > 0) {
                before -= opts.weekstart;
                if (before < 0) {
                    before += 7;
                }
            }

            var cells = days + before, after = cells;

            while(after > 7) { after -= 7; }

            cells += 7 - after;

            var day, isDisabled, isSelected, isToday, isInMonth;

            for (var i = 0, r = 0; i < cells; i++) {

                day        = new Date(year, month, 1 + (i - before), 12);
                isDisabled = (data.minDate && data.minDate > day) || (data.maxDate && day > data.maxDate);
                isInMonth  = !(i < before || i >= (days + before));

                day = moment(day);

                isSelected = this.initdate == day.format("YYYY-MM-DD");
                isToday    = now == day.format("YYYY-MM-DD");

                row.push({"selected": isSelected, "today": isToday, "disabled": isDisabled, "day":day, "inmonth":isInMonth});

                if (++r === 7) {
                    data.days.push(row);
                    row = [];
                    r = 0;
                }
            }

            return data;
        },

        hide: function() {

            if (active && active === this) {
                dropdown.removeClass('uk-dropdown-shown');
                setTimeout(function() {
                    dropdown.removeClass('uk-dropdown-active dp-top')
                },280);
                active = false;
                this.trigger('hide.uk.datepicker');
            }
        }
    });

    UI.Utils.moment = moment();

    return UI.datepicker;
});
/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-timepicker", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";


    UI.component('timepicker', {

        defaults: {
            format : '24h',
            delay  : 0,
            start  : 0,
            end    : 24
        },

        boot: function() {

            // init code
            UI.$html.on("focus.timepicker.uikit", "[data-uk-timepicker]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("timepicker")) {
                    var obj = UI.timepicker(ele, UI.Utils.options(ele.attr("data-uk-timepicker")));

                    setTimeout(function(){
                        obj.autocomplete.input.focus();
                    }, 40);
                }
            });
        },

        init: function() {

            var $this  = this, times = getTimeRange(this.options.start, this.options.end), container;

            this.options.minLength = 0;
            this.options.template  = '<ul class="uk-nav uk-nav-autocomplete uk-autocomplete-results">{{~items}}<li data-value="{{$item.value}}"><a class="needsclick">{{$item.value}}</a></li>{{/items}}</ul>';

            this.options.source = function(release) {
                release(times[$this.options.format] || times['12h']);
            };

            if (this.element.is('input')) {
                this.element.wrap('<div class="uk-autocomplete"></div>');
                container = this.element.parent();
            } else {
                container = this.element.addClass('uk-autocomplete');
            }

            this.autocomplete = UI.autocomplete(container, this.options);
            this.autocomplete.dropdown.addClass('uk-dropdown-small uk-dropdown-scrollable');

            this.autocomplete.on('show.uk.autocomplete', function() {

                var selected = $this.autocomplete.dropdown.find('[data-value="'+$this.autocomplete.input.val()+'"]');

                setTimeout(function(){
                    $this.autocomplete.pick(selected, true);
                }, 10);
            });

            this.autocomplete.input.on('focus', function(){

                $this.autocomplete.value = Math.random();
                $this.autocomplete.triggercomplete();

            }).on('blur', UI.Utils.debounce(function() {
                $this.checkTime();
            }, 100));

            this.element.data("timepicker", this);
        },

        checkTime: function() {

            var arr, timeArray, meridian = 'AM', hour, minute, time = this.autocomplete.input.val();

            if (this.options.format == '12h') {
                arr = time.split(' ');
                timeArray = arr[0].split(':');
                meridian = arr[1];
            } else {
                timeArray = time.split(':');
            }

            hour   = parseInt(timeArray[0], 10);
            minute = parseInt(timeArray[1], 10);

            if (isNaN(hour))   hour = 0;
            if (isNaN(minute)) minute = 0;

            if (this.options.format == '12h') {
                if (hour > 12) {
                    hour = 12;
                } else if (hour < 0) {
                    hour = 12;
                }

                if (meridian === 'am' || meridian === 'a') {
                    meridian = 'AM';
                } else if (meridian === 'pm' || meridian === 'p') {
                    meridian = 'PM';
                }

                if (meridian !== 'AM' && meridian !== 'PM') {
                    meridian = 'AM';
                }

            } else {

                if (hour >= 24) {
                    hour = 23;
                } else if (hour < 0) {
                    hour = 0;
                }
            }

            if (minute < 0) {
                minute = 0;
            } else if (minute >= 60) {
                minute = 0;
            }

            this.autocomplete.input.val(this.formatTime(hour, minute, meridian)).trigger('change');
        },

        formatTime: function(hour, minute, meridian) {
            hour = hour < 10 ? '0' + hour : hour;
            minute = minute < 10 ? '0' + minute : minute;
            return hour + ':' + minute + (this.options.format == '12h' ? ' ' + meridian : '');
        }
    });

    // helper

    function getTimeRange(start, end) {

        start = start || 0;
        end   = end || 24;

        var times = {'12h':[], '24h':[]}, i, h;

        for (i = start, h=''; i<end; i++) {

            h = ''+i;

            if (i<10)  h = '0'+h;

            times['24h'].push({value: (h+':00')});
            times['24h'].push({value: (h+':30')});

            if (i === 0) {
                h = 12;
                times['12h'].push({value: (h+':00 AM')});
                times['12h'].push({value: (h+':30 AM')});
            }

            if (i > 0 && i<13 && i!==12) {
                times['12h'].push({value: (h+':00 AM')});
                times['12h'].push({value: (h+':30 AM')});
            }

            if (i >= 12) {

                h = h-12;
                if (h === 0) h = 12;
                if (h < 10) h = '0'+String(h);

                times['12h'].push({value: (h+':00 PM')});
                times['12h'].push({value: (h+':30 PM')});
            }
        }

        return times;
    }

});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(core) {
    if (typeof define == "function" && define.amd) { // AMD

        define("uikit", function(){

            var uikit = window.UIkit || core(window, window.jQuery, window.document);

            uikit.load = function(res, req, onload, config) {

                var resources = res.split(','), load = [], i, base = (config.config && config.config.uikit && config.config.uikit.base ? config.config.uikit.base : "").replace(/\/+$/g, "");

                if (!base) {
                    throw new Error( "Please define base path to UIkit in the requirejs config." );
                }

                for (i = 0; i < resources.length; i += 1) {
                    var resource = resources[i].replace(/\./g, '/');
                    load.push(base+'/components/'+resource);
                }

                req(load, function() {
                    onload(uikit);
                });
            };

            return uikit;
        });
    }

    if (!window.jQuery) {
        throw new Error( "UIkit requires jQuery" );
    }

    if (window && window.jQuery) {
        core(window, window.jQuery, window.document);
    }


})(function(global, $, doc) {

    "use strict";

    var UI = {}, _UI = global.UIkit ? Object.create(global.UIkit) : undefined;

    UI.version = '2.24.3';

    UI.noConflict = function() {
        // restore UIkit version
        if (_UI) {
            global.UIkit = _UI;
            $.UIkit      = _UI;
            $.fn.uk      = _UI.fn;
        }

        return UI;
    };

    UI.prefix = function(str) {
        return str;
    };

    // cache jQuery
    UI.$ = $;

    UI.$doc  = UI.$(document);
    UI.$win  = UI.$(window);
    UI.$html = UI.$('html');

    UI.support = {};
    UI.support.transition = (function() {

        var transitionEnd = (function() {

            var element = doc.body || doc.documentElement,
                transEndEventNames = {
                    WebkitTransition : 'webkitTransitionEnd',
                    MozTransition    : 'transitionend',
                    OTransition      : 'oTransitionEnd otransitionend',
                    transition       : 'transitionend'
                }, name;

            for (name in transEndEventNames) {
                if (element.style[name] !== undefined) return transEndEventNames[name];
            }
        }());

        return transitionEnd && { end: transitionEnd };
    })();

    UI.support.animation = (function() {

        var animationEnd = (function() {

            var element = doc.body || doc.documentElement,
                animEndEventNames = {
                    WebkitAnimation : 'webkitAnimationEnd',
                    MozAnimation    : 'animationend',
                    OAnimation      : 'oAnimationEnd oanimationend',
                    animation       : 'animationend'
                }, name;

            for (name in animEndEventNames) {
                if (element.style[name] !== undefined) return animEndEventNames[name];
            }
        }());

        return animationEnd && { end: animationEnd };
    })();

    // requestAnimationFrame polyfill
    //https://github.com/darius/requestAnimationFrame
    (function() {

        Date.now = Date.now || function() { return new Date().getTime(); };

        var vendors = ['webkit', 'moz'];
        for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
            var vp = vendors[i];
            window.requestAnimationFrame = window[vp+'RequestAnimationFrame'];
            window.cancelAnimationFrame = (window[vp+'CancelAnimationFrame']
                                       || window[vp+'CancelRequestAnimationFrame']);
        }
        if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) // iOS6 is buggy
            || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
            var lastTime = 0;
            window.requestAnimationFrame = function(callback) {
                var now = Date.now();
                var nextTime = Math.max(lastTime + 16, now);
                return setTimeout(function() { callback(lastTime = nextTime); },
                                  nextTime - now);
            };
            window.cancelAnimationFrame = clearTimeout;
        }
    }());

    UI.support.touch = (
        ('ontouchstart' in document) ||
        (global.DocumentTouch && document instanceof global.DocumentTouch)  ||
        (global.navigator.msPointerEnabled && global.navigator.msMaxTouchPoints > 0) || //IE 10
        (global.navigator.pointerEnabled && global.navigator.maxTouchPoints > 0) || //IE >=11
        false
    );

    UI.support.mutationobserver = (global.MutationObserver || global.WebKitMutationObserver || null);

    UI.Utils = {};

    UI.Utils.isFullscreen = function() {
        return document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.fullscreenElement || false;
    };

    UI.Utils.str2json = function(str, notevil) {
        try {
            if (notevil) {
                return JSON.parse(str
                    // wrap keys without quote with valid double quote
                    .replace(/([\$\w]+)\s*:/g, function(_, $1){return '"'+$1+'":';})
                    // replacing single quote wrapped ones to double quote
                    .replace(/'([^']+)'/g, function(_, $1){return '"'+$1+'"';})
                );
            } else {
                return (new Function("", "var json = " + str + "; return JSON.parse(JSON.stringify(json));"))();
            }
        } catch(e) { return false; }
    };

    UI.Utils.debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    UI.Utils.removeCssRules = function(selectorRegEx) {
        var idx, idxs, stylesheet, _i, _j, _k, _len, _len1, _len2, _ref;

        if(!selectorRegEx) return;

        setTimeout(function(){
            try {
              _ref = document.styleSheets;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                stylesheet = _ref[_i];
                idxs = [];
                stylesheet.cssRules = stylesheet.cssRules;
                for (idx = _j = 0, _len1 = stylesheet.cssRules.length; _j < _len1; idx = ++_j) {
                  if (stylesheet.cssRules[idx].type === CSSRule.STYLE_RULE && selectorRegEx.test(stylesheet.cssRules[idx].selectorText)) {
                    idxs.unshift(idx);
                  }
                }
                for (_k = 0, _len2 = idxs.length; _k < _len2; _k++) {
                  stylesheet.deleteRule(idxs[_k]);
                }
              }
            } catch (_error) {}
        }, 0);
    };

    UI.Utils.isInView = function(element, options) {

        var $element = $(element);

        if (!$element.is(':visible')) {
            return false;
        }

        var window_left = UI.$win.scrollLeft(), window_top = UI.$win.scrollTop(), offset = $element.offset(), left = offset.left, top = offset.top;

        options = $.extend({topoffset:0, leftoffset:0}, options);

        if (top + $element.height() >= window_top && top - options.topoffset <= window_top + UI.$win.height() &&
            left + $element.width() >= window_left && left - options.leftoffset <= window_left + UI.$win.width()) {
          return true;
        } else {
          return false;
        }
    };

    UI.Utils.checkDisplay = function(context, initanimation) {

        var elements = UI.$('[data-uk-margin], [data-uk-grid-match], [data-uk-grid-margin], [data-uk-check-display]', context || document), animated;

        if (context && !elements.length) {
            elements = $(context);
        }

        elements.trigger('display.uk.check');

        // fix firefox / IE animations
        if (initanimation) {

            if (typeof(initanimation)!='string') {
                initanimation = '[class*="uk-animation-"]';
            }

            elements.find(initanimation).each(function(){

                var ele  = UI.$(this),
                    cls  = ele.attr('class'),
                    anim = cls.match(/uk\-animation\-(.+)/);

                ele.removeClass(anim[0]).width();

                ele.addClass(anim[0]);
            });
        }

        return elements;
    };

    UI.Utils.options = function(string) {

        if ($.type(string)!='string') return string;

        if (string.indexOf(':') != -1 && string.trim().substr(-1) != '}') {
            string = '{'+string+'}';
        }

        var start = (string ? string.indexOf("{") : -1), options = {};

        if (start != -1) {
            try {
                options = UI.Utils.str2json(string.substr(start));
            } catch (e) {}
        }

        return options;
    };

    UI.Utils.animate = function(element, cls) {

        var d = $.Deferred();

        element = UI.$(element);
        cls     = cls;

        element.css('display', 'none').addClass(cls).one(UI.support.animation.end, function() {
            element.removeClass(cls);
            d.resolve();
        }).width();

        element.css('display', '');

        return d.promise();
    };

    UI.Utils.uid = function(prefix) {
        return (prefix || 'id') + (new Date().getTime())+"RAND"+(Math.ceil(Math.random() * 100000));
    };

    UI.Utils.template = function(str, data) {

        var tokens = str.replace(/\n/g, '\\n').replace(/\{\{\{\s*(.+?)\s*\}\}\}/g, "{{!$1}}").split(/(\{\{\s*(.+?)\s*\}\})/g),
            i=0, toc, cmd, prop, val, fn, output = [], openblocks = 0;

        while(i < tokens.length) {

            toc = tokens[i];

            if(toc.match(/\{\{\s*(.+?)\s*\}\}/)) {
                i = i + 1;
                toc  = tokens[i];
                cmd  = toc[0];
                prop = toc.substring(toc.match(/^(\^|\#|\!|\~|\:)/) ? 1:0);

                switch(cmd) {
                    case '~':
                        output.push("for(var $i=0;$i<"+prop+".length;$i++) { var $item = "+prop+"[$i];");
                        openblocks++;
                        break;
                    case ':':
                        output.push("for(var $key in "+prop+") { var $val = "+prop+"[$key];");
                        openblocks++;
                        break;
                    case '#':
                        output.push("if("+prop+") {");
                        openblocks++;
                        break;
                    case '^':
                        output.push("if(!"+prop+") {");
                        openblocks++;
                        break;
                    case '/':
                        output.push("}");
                        openblocks--;
                        break;
                    case '!':
                        output.push("__ret.push("+prop+");");
                        break;
                    default:
                        output.push("__ret.push(escape("+prop+"));");
                        break;
                }
            } else {
                output.push("__ret.push('"+toc.replace(/\'/g, "\\'")+"');");
            }
            i = i + 1;
        }

        fn  = new Function('$data', [
            'var __ret = [];',
            'try {',
            'with($data){', (!openblocks ? output.join('') : '__ret = ["Not all blocks are closed correctly."]'), '};',
            '}catch(e){__ret = [e.message];}',
            'return __ret.join("").replace(/\\n\\n/g, "\\n");',
            "function escape(html) { return String(html).replace(/&/g, '&amp;').replace(/\"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');}"
        ].join("\n"));

        return data ? fn(data) : fn;
    };

    UI.Utils.events       = {};
    UI.Utils.events.click = UI.support.touch ? 'tap' : 'click';

    global.UIkit = UI;

    // deprecated

    UI.fn = function(command, options) {

        var args = arguments, cmd = command.match(/^([a-z\-]+)(?:\.([a-z]+))?/i), component = cmd[1], method = cmd[2];

        if (!UI[component]) {
            $.error("UIkit component [" + component + "] does not exist.");
            return this;
        }

        return this.each(function() {
            var $this = $(this), data = $this.data(component);
            if (!data) $this.data(component, (data = UI[component](this, method ? undefined : options)));
            if (method) data[method].apply(data, Array.prototype.slice.call(args, 1));
        });
    };

    $.UIkit          = UI;
    $.fn.uk          = UI.fn;

    UI.langdirection = UI.$html.attr("dir") == "rtl" ? "right" : "left";

    UI.components    = {};

    UI.component = function(name, def) {

        var fn = function(element, options) {

            var $this = this;

            this.UIkit   = UI;
            this.element = element ? UI.$(element) : null;
            this.options = $.extend(true, {}, this.defaults, options);
            this.plugins = {};

            if (this.element) {
                this.element.data(name, this);
            }

            this.init();

            (this.options.plugins.length ? this.options.plugins : Object.keys(fn.plugins)).forEach(function(plugin) {

                if (fn.plugins[plugin].init) {
                    fn.plugins[plugin].init($this);
                    $this.plugins[plugin] = true;
                }

            });

            this.trigger('init.uk.component', [name, this]);

            return this;
        };

        fn.plugins = {};

        $.extend(true, fn.prototype, {

            defaults : {plugins: []},

            boot: function(){},
            init: function(){},

            on: function(a1,a2,a3){
                return UI.$(this.element || this).on(a1,a2,a3);
            },

            one: function(a1,a2,a3){
                return UI.$(this.element || this).one(a1,a2,a3);
            },

            off: function(evt){
                return UI.$(this.element || this).off(evt);
            },

            trigger: function(evt, params) {
                return UI.$(this.element || this).trigger(evt, params);
            },

            find: function(selector) {
                return UI.$(this.element ? this.element: []).find(selector);
            },

            proxy: function(obj, methods) {

                var $this = this;

                methods.split(' ').forEach(function(method) {
                    if (!$this[method]) $this[method] = function() { return obj[method].apply(obj, arguments); };
                });
            },

            mixin: function(obj, methods) {

                var $this = this;

                methods.split(' ').forEach(function(method) {
                    if (!$this[method]) $this[method] = obj[method].bind($this);
                });
            },

            option: function() {

                if (arguments.length == 1) {
                    return this.options[arguments[0]] || undefined;
                } else if (arguments.length == 2) {
                    this.options[arguments[0]] = arguments[1];
                }
            }

        }, def);

        this.components[name] = fn;

        this[name] = function() {

            var element, options;

            if (arguments.length) {

                switch(arguments.length) {
                    case 1:

                        if (typeof arguments[0] === "string" || arguments[0].nodeType || arguments[0] instanceof jQuery) {
                            element = $(arguments[0]);
                        } else {
                            options = arguments[0];
                        }

                        break;
                    case 2:

                        element = $(arguments[0]);
                        options = arguments[1];
                        break;
                }
            }

            if (element && element.data(name)) {
                return element.data(name);
            }

            return (new UI.components[name](element, options));
        };

        if (UI.domready) {
            UI.component.boot(name);
        }

        return fn;
    };

    UI.plugin = function(component, name, def) {
        this.components[component].plugins[name] = def;
    };

    UI.component.boot = function(name) {

        if (UI.components[name].prototype && UI.components[name].prototype.boot && !UI.components[name].booted) {
            UI.components[name].prototype.boot.apply(UI, []);
            UI.components[name].booted = true;
        }
    };

    UI.component.bootComponents = function() {

        for (var component in UI.components) {
            UI.component.boot(component);
        }
    };


    // DOM mutation save ready helper function

    UI.domObservers = [];
    UI.domready     = false;

    UI.ready = function(fn) {

        UI.domObservers.push(fn);

        if (UI.domready) {
            fn(document);
        }
    };

    UI.on = function(a1,a2,a3){

        if (a1 && a1.indexOf('ready.uk.dom') > -1 && UI.domready) {
            a2.apply(UI.$doc);
        }

        return UI.$doc.on(a1,a2,a3);
    };

    UI.one = function(a1,a2,a3){

        if (a1 && a1.indexOf('ready.uk.dom') > -1 && UI.domready) {
            a2.apply(UI.$doc);
            return UI.$doc;
        }

        return UI.$doc.one(a1,a2,a3);
    };

    UI.trigger = function(evt, params) {
        return UI.$doc.trigger(evt, params);
    };

    UI.domObserve = function(selector, fn) {

        if(!UI.support.mutationobserver) return;

        fn = fn || function() {};

        UI.$(selector).each(function() {

            var element  = this,
                $element = UI.$(element);

            if ($element.data('observer')) {
                return;
            }

            try {

                var observer = new UI.support.mutationobserver(UI.Utils.debounce(function(mutations) {
                    fn.apply(element, []);
                    $element.trigger('changed.uk.dom');
                }, 50));

                // pass in the target node, as well as the observer options
                observer.observe(element, { childList: true, subtree: true });

                $element.data('observer', observer);

            } catch(e) {}
        });
    };

    UI.init = function(root) {

        root = root || document;

        UI.domObservers.forEach(function(fn){
            fn(root);
        });
    };

    UI.on('domready.uk.dom', function(){

        UI.init();

        if (UI.domready) UI.Utils.checkDisplay();
    });

    document.addEventListener('DOMContentLoaded', function(){

        var domReady = function() {

            UI.$body = UI.$('body');

            UI.ready(function(context){
                UI.domObserve('[data-uk-observe]');
            });

            UI.on('changed.uk.dom', function(e) {
                UI.init(e.target);
                UI.Utils.checkDisplay(e.target);
            });

            UI.trigger('beforeready.uk.dom');

            UI.component.bootComponents();

            // custom scroll observer
            requestAnimationFrame((function(){

                var memory = {x: window.pageXOffset, y:window.pageYOffset}, dir;

                var fn = function(){

                    if (memory.x != window.pageXOffset || memory.y != window.pageYOffset) {

                        dir = {x: 0 , y: 0};

                        if (window.pageXOffset != memory.x) dir.x = window.pageXOffset > memory.x ? 1:-1;
                        if (window.pageYOffset != memory.y) dir.y = window.pageYOffset > memory.y ? 1:-1;

                        memory = {
                            "dir": dir, "x": window.pageXOffset, "y": window.pageYOffset
                        };

                        UI.$doc.trigger('scrolling.uk.document', [memory]);
                    }

                    requestAnimationFrame(fn);
                };

                if (UI.support.touch) {
                    UI.$html.on('touchmove touchend MSPointerMove MSPointerUp pointermove pointerup', fn);
                }

                if (memory.x || memory.y) fn();

                return fn;

            })());

            // run component init functions on dom
            UI.trigger('domready.uk.dom');

            if (UI.support.touch) {

                // remove css hover rules for touch devices
                // UI.Utils.removeCssRules(/\.uk-(?!navbar).*:hover/);

                // viewport unit fix for uk-height-viewport - should be fixed in iOS 8
                if (navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {

                    UI.$win.on('load orientationchange resize', UI.Utils.debounce((function(){

                        var fn = function() {
                            $('.uk-height-viewport').css('height', window.innerHeight);
                            return fn;
                        };

                        return fn();

                    })(), 100));
                }
            }

            UI.trigger('afterready.uk.dom');

            // mark that domready is left behind
            UI.domready = true;
        };

        if (document.readyState == 'complete' || document.readyState == 'interactive') {
            setTimeout(domReady);
        }

        return domReady;

    }());

    // add touch identifier class
    UI.$html.addClass(UI.support.touch ? "uk-touch" : "uk-notouch");

    // add uk-hover class on tap to support overlays on touch devices
    if (UI.support.touch) {

        var hoverset = false,
            exclude,
            hovercls = 'uk-hover',
            selector = '.uk-overlay, .uk-overlay-hover, .uk-overlay-toggle, .uk-animation-hover, .uk-has-hover';

        UI.$html.on('mouseenter touchstart MSPointerDown pointerdown', selector, function() {

            if (hoverset) $('.'+hovercls).removeClass(hovercls);

            hoverset = $(this).addClass(hovercls);

        }).on('mouseleave touchend MSPointerUp pointerup', function(e) {

            exclude = $(e.target).parents(selector);

            if (hoverset) {
                hoverset.not(exclude).removeClass(hovercls);
            }
        });
    }

    return UI;
});

//  Based on Zeptos touch.js
//  https://raw.github.com/madrobby/zepto/master/src/touch.js
//  Zepto.js may be freely distributed under the MIT license.

;(function($){

  if ($.fn.swipeLeft) {
    return;
  }


  var touch = {}, touchTimeout, tapTimeout, swipeTimeout, longTapTimeout, longTapDelay = 750, gesture;

  function swipeDirection(x1, x2, y1, y2) {
    return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? (x1 - x2 > 0 ? 'Left' : 'Right') : (y1 - y2 > 0 ? 'Up' : 'Down');
  }

  function longTap() {
    longTapTimeout = null;
    if (touch.last) {
      if ( touch.el !== undefined ) touch.el.trigger('longTap');
      touch = {};
    }
  }

  function cancelLongTap() {
    if (longTapTimeout) clearTimeout(longTapTimeout);
    longTapTimeout = null;
  }

  function cancelAll() {
    if (touchTimeout)   clearTimeout(touchTimeout);
    if (tapTimeout)     clearTimeout(tapTimeout);
    if (swipeTimeout)   clearTimeout(swipeTimeout);
    if (longTapTimeout) clearTimeout(longTapTimeout);
    touchTimeout = tapTimeout = swipeTimeout = longTapTimeout = null;
    touch = {};
  }

  function isPrimaryTouch(event){
    return event.pointerType == event.MSPOINTER_TYPE_TOUCH && event.isPrimary;
  }

  $(function(){
    var now, delta, deltaX = 0, deltaY = 0, firstTouch;

    if ('MSGesture' in window) {
      gesture = new MSGesture();
      gesture.target = document.body;
    }

    $(document)
      .on('MSGestureEnd gestureend', function(e){

        var swipeDirectionFromVelocity = e.originalEvent.velocityX > 1 ? 'Right' : e.originalEvent.velocityX < -1 ? 'Left' : e.originalEvent.velocityY > 1 ? 'Down' : e.originalEvent.velocityY < -1 ? 'Up' : null;

        if (swipeDirectionFromVelocity && touch.el !== undefined) {
          touch.el.trigger('swipe');
          touch.el.trigger('swipe'+ swipeDirectionFromVelocity);
        }
      })
      // MSPointerDown: for IE10
      // pointerdown: for IE11
      .on('touchstart MSPointerDown pointerdown', function(e){

        if(e.type == 'MSPointerDown' && !isPrimaryTouch(e.originalEvent)) return;

        firstTouch = (e.type == 'MSPointerDown' || e.type == 'pointerdown') ? e : e.originalEvent.touches[0];

        now      = Date.now();
        delta    = now - (touch.last || now);
        touch.el = $('tagName' in firstTouch.target ? firstTouch.target : firstTouch.target.parentNode);

        if(touchTimeout) clearTimeout(touchTimeout);

        touch.x1 = firstTouch.pageX;
        touch.y1 = firstTouch.pageY;

        if (delta > 0 && delta <= 250) touch.isDoubleTap = true;

        touch.last = now;
        longTapTimeout = setTimeout(longTap, longTapDelay);

        // adds the current touch contact for IE gesture recognition
        if (gesture && ( e.type == 'MSPointerDown' || e.type == 'pointerdown' || e.type == 'touchstart' ) ) {
          gesture.addPointer(e.originalEvent.pointerId);
        }

      })
      // MSPointerMove: for IE10
      // pointermove: for IE11
      .on('touchmove MSPointerMove pointermove', function(e){

        if (e.type == 'MSPointerMove' && !isPrimaryTouch(e.originalEvent)) return;

        firstTouch = (e.type == 'MSPointerMove' || e.type == 'pointermove') ? e : e.originalEvent.touches[0];

        cancelLongTap();
        touch.x2 = firstTouch.pageX;
        touch.y2 = firstTouch.pageY;

        deltaX += Math.abs(touch.x1 - touch.x2);
        deltaY += Math.abs(touch.y1 - touch.y2);
      })
      // MSPointerUp: for IE10
      // pointerup: for IE11
      .on('touchend MSPointerUp pointerup', function(e){

        if (e.type == 'MSPointerUp' && !isPrimaryTouch(e.originalEvent)) return;

        cancelLongTap();

        // swipe
        if ((touch.x2 && Math.abs(touch.x1 - touch.x2) > 30) || (touch.y2 && Math.abs(touch.y1 - touch.y2) > 30)){

          swipeTimeout = setTimeout(function() {
            if ( touch.el !== undefined ) {
              touch.el.trigger('swipe');
              touch.el.trigger('swipe' + (swipeDirection(touch.x1, touch.x2, touch.y1, touch.y2)));
            }
            touch = {};
          }, 0);

        // normal tap
        } else if ('last' in touch) {

          // don't fire tap when delta position changed by more than 30 pixels,
          // for instance when moving to a point and back to origin
          if (isNaN(deltaX) || (deltaX < 30 && deltaY < 30)) {
            // delay by one tick so we can cancel the 'tap' event if 'scroll' fires
            // ('tap' fires before 'scroll')
            tapTimeout = setTimeout(function() {

              // trigger universal 'tap' with the option to cancelTouch()
              // (cancelTouch cancels processing of single vs double taps for faster 'tap' response)
              var event = $.Event('tap');
              event.cancelTouch = cancelAll;
              if ( touch.el !== undefined ) touch.el.trigger(event);

              // trigger double tap immediately
              if (touch.isDoubleTap) {
                if ( touch.el !== undefined ) touch.el.trigger('doubleTap');
                touch = {};
              }

              // trigger single tap after 250ms of inactivity
              else {
                touchTimeout = setTimeout(function(){
                  touchTimeout = null;
                  if ( touch.el !== undefined ) touch.el.trigger('singleTap');
                  touch = {};
                }, 250);
              }
            }, 0);
          } else {
            touch = {};
          }
          deltaX = deltaY = 0;
        }
      })
      // when the browser window loses focus,
      // for example when a modal dialog is shown,
      // cancel all ongoing events
      .on('touchcancel MSPointerCancel', cancelAll);

    // scrolling the window indicates intention of the user
    // to scroll, not tap or swipe, so cancel all ongoing events
    $(window).on('scroll', cancelAll);
  });

  ['swipe', 'swipeLeft', 'swipeRight', 'swipeUp', 'swipeDown', 'doubleTap', 'tap', 'singleTap', 'longTap'].forEach(function(eventName){
    $.fn[eventName] = function(callback){ return $(this).on(eventName, callback); };
  });
})(jQuery);

(function(UI) {

    "use strict";

    var stacks = [];

    UI.component('stackMargin', {

        defaults: {
            cls: 'uk-margin-small-top',
            rowfirst: false
        },

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-margin]", context).each(function() {

                    var ele = UI.$(this), obj;

                    if (!ele.data("stackMargin")) {
                        obj = UI.stackMargin(ele, UI.Utils.options(ele.attr("data-uk-margin")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            this.columns = [];

            UI.$win.on('resize orientationchange', (function() {

                var fn = function() {
                    $this.process();
                };

                UI.$(function() {
                    fn();
                    UI.$win.on("load", fn);
                });

                return UI.Utils.debounce(fn, 20);
            })());

            UI.$html.on("changed.uk.dom", function(e) {
                $this.process();
            });

            this.on("display.uk.check", function(e) {
                if (this.element.is(":visible")) this.process();
            }.bind(this));

            stacks.push(this);
        },

        process: function() {

            var $this = this;

            this.columns = this.element.children();

            UI.Utils.stackMargin(this.columns, this.options);

            if (!this.options.rowfirst) {
                return this;
            }

            // Mark first column elements
            var pos_cache = this.columns.removeClass(this.options.rowfirst).filter(':visible').first().position();

            if (pos_cache) {
                this.columns.each(function() {
                    UI.$(this)[UI.$(this).position().left == pos_cache.left ? 'addClass':'removeClass']($this.options.rowfirst);
                });
            }

            return this;
        },

        revert: function() {
            this.columns.removeClass(this.options.cls);
            return this;
        }
    });


    // responsive element e.g. iframes

    (function(){

        var elements = [], check = function(ele) {

            if (!ele.is(':visible')) return;

            var width  = ele.parent().width(),
                iwidth = ele.data('width'),
                ratio  = (width / iwidth),
                height = Math.floor(ratio * ele.data('height'));

            ele.css({'height': (width < iwidth) ? height : ele.data('height')});
        };

        UI.component('responsiveElement', {

            defaults: {},

            boot: function() {

                // init code
                UI.ready(function(context) {

                    UI.$("iframe.uk-responsive-width, [data-uk-responsive]", context).each(function() {

                        var ele = UI.$(this), obj;

                        if (!ele.data("responsiveIframe")) {
                            obj = UI.responsiveElement(ele, {});
                        }
                    });
                });
            },

            init: function() {

                var ele = this.element;

                if (ele.attr('width') && ele.attr('height')) {

                    ele.data({

                        'width' : ele.attr('width'),
                        'height': ele.attr('height')

                    }).on('display.uk.check', function(){
                        check(ele);
                    });

                    check(ele);

                    elements.push(ele);
                }
            }
        });

        UI.$win.on('resize load', UI.Utils.debounce(function(){

            elements.forEach(function(ele){
                check(ele);
            });

        }, 15));

    })();



    // helper

    UI.Utils.stackMargin = function(elements, options) {

        options = UI.$.extend({
            'cls': 'uk-margin-small-top'
        }, options);

        options.cls = options.cls;

        elements = UI.$(elements).removeClass(options.cls);

        var skip         = false,
            firstvisible = elements.filter(":visible:first"),
            offset       = firstvisible.length ? (firstvisible.position().top + firstvisible.outerHeight()) - 1 : false; // (-1): weird firefox bug when parent container is display:flex

        if (offset === false || elements.length == 1) return;

        elements.each(function() {

            var column = UI.$(this);

            if (column.is(":visible")) {

                if (skip) {
                    column.addClass(options.cls);
                } else {

                    if (column.position().top >= offset) {
                        skip = column.addClass(options.cls);
                    }
                }
            }
        });
    };

    UI.Utils.matchHeights = function(elements, options) {

        elements = UI.$(elements).css('min-height', '');
        options  = UI.$.extend({ row : true }, options);

        var matchHeights = function(group){

            if (group.length < 2) return;

            var max = 0;

            group.each(function() {
                max = Math.max(max, UI.$(this).outerHeight());
            }).each(function() {

                var element = UI.$(this),
                    height  = max - (element.css('box-sizing') == 'border-box' ? 0 : (element.outerHeight() - element.height()));

                element.css('min-height', height + 'px');
            });
        };

        if (options.row) {

            elements.first().width(); // force redraw

            setTimeout(function(){

                var lastoffset = false, group = [];

                elements.each(function() {

                    var ele = UI.$(this), offset = ele.offset().top;

                    if (offset != lastoffset && group.length) {

                        matchHeights(UI.$(group));
                        group  = [];
                        offset = ele.offset().top;
                    }

                    group.push(ele);
                    lastoffset = offset;
                });

                if (group.length) {
                    matchHeights(UI.$(group));
                }

            }, 0);

        } else {
            matchHeights(elements);
        }
    };

    (function(cacheSvgs){

        UI.Utils.inlineSvg = function(selector, root) {

            var images = UI.$(selector || 'img[src$=".svg"]', root || document).each(function(){

                var img = UI.$(this),
                    src = img.attr('src');

                if (!cacheSvgs[src]) {

                    var d = UI.$.Deferred();

                    UI.$.get(src, {nc: Math.random()}, function(data){
                        d.resolve(UI.$(data).find('svg'));
                    });

                    cacheSvgs[src] = d.promise();
                }

                cacheSvgs[src].then(function(svg) {

                    var $svg = UI.$(svg).clone();

                    if (img.attr('id')) $svg.attr('id', img.attr('id'));
                    if (img.attr('class')) $svg.attr('class', img.attr('class'));
                    if (img.attr('style')) $svg.attr('style', img.attr('style'));

                    if (img.attr('width')) {
                        $svg.attr('width', img.attr('width'));
                        if (!img.attr('height'))  $svg.removeAttr('height');
                    }

                    if (img.attr('height')){
                        $svg.attr('height', img.attr('height'));
                        if (!img.attr('width')) $svg.removeAttr('width');
                    }

                    img.replaceWith($svg);
                });
            });
        };

        // init code
        UI.ready(function(context) {
            UI.Utils.inlineSvg('[data-uk-svg]', context);
        });

    })({});

})(UIkit);

(function(UI) {

    "use strict";

    UI.component('smoothScroll', {

        boot: function() {

            // init code
            UI.$html.on("click.smooth-scroll.uikit", "[data-uk-smooth-scroll]", function(e) {
                var ele = UI.$(this);

                if (!ele.data("smoothScroll")) {
                    var obj = UI.smoothScroll(ele, UI.Utils.options(ele.attr("data-uk-smooth-scroll")));
                    ele.trigger("click");
                }

                return false;
            });
        },

        init: function() {

            var $this = this;

            this.on("click", function(e) {
                e.preventDefault();
                scrollToElement(UI.$(this.hash).length ? UI.$(this.hash) : UI.$("body"), $this.options);
            });
        }
    });

    function scrollToElement(ele, options) {

        options = UI.$.extend({
            duration: 1000,
            transition: 'easeOutExpo',
            offset: 0,
            complete: function(){}
        }, options);

        // get / set parameters
        var target    = ele.offset().top - options.offset,
            docheight = UI.$doc.height(),
            winheight = window.innerHeight;

        if ((target + winheight) > docheight) {
            target = docheight - winheight;
        }

        // animate to target, fire callback when done
        UI.$("html,body").stop().animate({scrollTop: target}, options.duration, options.transition).promise().done(options.complete);
    }

    UI.Utils.scrollToElement = scrollToElement;

    if (!UI.$.easing.easeOutExpo) {
        UI.$.easing.easeOutExpo = function(x, t, b, c, d) { return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b; };
    }

})(UIkit);

(function(UI) {

    "use strict";

    var $win           = UI.$win,
        $doc           = UI.$doc,
        scrollspies    = [],
        checkScrollSpy = function() {
            for(var i=0; i < scrollspies.length; i++) {
                window.requestAnimationFrame.apply(window, [scrollspies[i].check]);
            }
        };

    UI.component('scrollspy', {

        defaults: {
            "target"     : false,
            "cls"        : "uk-scrollspy-inview",
            "initcls"    : "uk-scrollspy-init-inview",
            "topoffset"  : 0,
            "leftoffset" : 0,
            "repeat"     : false,
            "delay"      : 0
        },

        boot: function() {

            // listen to scroll and resize
            $doc.on("scrolling.uk.document", checkScrollSpy);
            $win.on("load resize orientationchange", UI.Utils.debounce(checkScrollSpy, 50));

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-scrollspy]", context).each(function() {

                    var element = UI.$(this);

                    if (!element.data("scrollspy")) {
                        var obj = UI.scrollspy(element, UI.Utils.options(element.attr("data-uk-scrollspy")));
                    }
                });
            });
        },

        init: function() {

            var $this = this, inviewstate, initinview, togglecls = this.options.cls.split(/,/), fn = function(){

                var elements     = $this.options.target ? $this.element.find($this.options.target) : $this.element,
                    delayIdx     = elements.length === 1 ? 1 : 0,
                    toggleclsIdx = 0;

                elements.each(function(idx){

                    var element     = UI.$(this),
                        inviewstate = element.data('inviewstate'),
                        inview      = UI.Utils.isInView(element, $this.options),
                        toggle      = element.data('ukScrollspyCls') || togglecls[toggleclsIdx].trim();

                    if (inview && !inviewstate && !element.data('scrollspy-idle')) {

                        if (!initinview) {
                            element.addClass($this.options.initcls);
                            $this.offset = element.offset();
                            initinview = true;

                            element.trigger("init.uk.scrollspy");
                        }

                        element.data('scrollspy-idle', setTimeout(function(){

                            element.addClass("uk-scrollspy-inview").toggleClass(toggle).width();
                            element.trigger("inview.uk.scrollspy");

                            element.data('scrollspy-idle', false);
                            element.data('inviewstate', true);

                        }, $this.options.delay * delayIdx));

                        delayIdx++;
                    }

                    if (!inview && inviewstate && $this.options.repeat) {

                        if (element.data('scrollspy-idle')) {
                            clearTimeout(element.data('scrollspy-idle'));
                        }

                        element.removeClass("uk-scrollspy-inview").toggleClass(toggle);
                        element.data('inviewstate', false);

                        element.trigger("outview.uk.scrollspy");
                    }

                    toggleclsIdx = togglecls[toggleclsIdx + 1] ? (toggleclsIdx + 1) : 0;

                });
            };

            fn();

            this.check = fn;

            scrollspies.push(this);
        }
    });


    var scrollspynavs = [],
        checkScrollSpyNavs = function() {
            for(var i=0; i < scrollspynavs.length; i++) {
                window.requestAnimationFrame.apply(window, [scrollspynavs[i].check]);
            }
        };

    UI.component('scrollspynav', {

        defaults: {
            "cls"          : 'uk-active',
            "closest"      : false,
            "topoffset"    : 0,
            "leftoffset"   : 0,
            "smoothscroll" : false
        },

        boot: function() {

            // listen to scroll and resize
            $doc.on("scrolling.uk.document", checkScrollSpyNavs);
            $win.on("resize orientationchange", UI.Utils.debounce(checkScrollSpyNavs, 50));

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-scrollspy-nav]", context).each(function() {

                    var element = UI.$(this);

                    if (!element.data("scrollspynav")) {
                        var obj = UI.scrollspynav(element, UI.Utils.options(element.attr("data-uk-scrollspy-nav")));
                    }
                });
            });
        },

        init: function() {

            var ids     = [],
                links   = this.find("a[href^='#']").each(function(){ if(this.getAttribute("href").trim()!=='#') ids.push(this.getAttribute("href")); }),
                targets = UI.$(ids.join(",")),

                clsActive  = this.options.cls,
                clsClosest = this.options.closest || this.options.closest;

            var $this = this, inviews, fn = function(){

                inviews = [];

                for (var i=0 ; i < targets.length ; i++) {
                    if (UI.Utils.isInView(targets.eq(i), $this.options)) {
                        inviews.push(targets.eq(i));
                    }
                }

                if (inviews.length) {

                    var navitems,
                        scrollTop = $win.scrollTop(),
                        target = (function(){
                            for(var i=0; i< inviews.length;i++){
                                if(inviews[i].offset().top >= scrollTop){
                                    return inviews[i];
                                }
                            }
                        })();

                    if (!target) return;

                    if ($this.options.closest) {
                        links.blur().closest(clsClosest).removeClass(clsActive);
                        navitems = links.filter("a[href='#"+target.attr("id")+"']").closest(clsClosest).addClass(clsActive);
                    } else {
                        navitems = links.removeClass(clsActive).filter("a[href='#"+target.attr("id")+"']").addClass(clsActive);
                    }

                    $this.element.trigger("inview.uk.scrollspynav", [target, navitems]);
                }
            };

            if (this.options.smoothscroll && UI.smoothScroll) {
                links.each(function(){
                    UI.smoothScroll(this, $this.options.smoothscroll);
                });
            }

            fn();

            this.element.data("scrollspynav", this);

            this.check = fn;
            scrollspynavs.push(this);

        }
    });

})(UIkit);

(function(UI){

    "use strict";

    var toggles = [];

    UI.component('toggle', {

        defaults: {
            target    : false,
            cls       : 'uk-hidden',
            animation : false,
            duration  : 200
        },

        boot: function(){

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-toggle]", context).each(function() {
                    var ele = UI.$(this);

                    if (!ele.data("toggle")) {
                        var obj = UI.toggle(ele, UI.Utils.options(ele.attr("data-uk-toggle")));
                    }
                });

                setTimeout(function(){

                    toggles.forEach(function(toggle){
                        toggle.getToggles();
                    });

                }, 0);
            });
        },

        init: function() {

            var $this = this;

            this.aria = (this.options.cls.indexOf('uk-hidden') !== -1);

            this.getToggles();

            this.on("click", function(e) {
                if ($this.element.is('a[href="#"]')) e.preventDefault();
                $this.toggle();
            });

            toggles.push(this);
        },

        toggle: function() {

            if(!this.totoggle.length) return;

            if (this.options.animation && UI.support.animation) {

                var $this = this, animations = this.options.animation.split(',');

                if (animations.length == 1) {
                    animations[1] = animations[0];
                }

                animations[0] = animations[0].trim();
                animations[1] = animations[1].trim();

                this.totoggle.css('animation-duration', this.options.duration+'ms');

                this.totoggle.each(function(){

                    var ele = UI.$(this);

                    if (ele.hasClass($this.options.cls)) {

                        ele.toggleClass($this.options.cls);

                        UI.Utils.animate(ele, animations[0]).then(function(){
                            ele.css('animation-duration', '');
                            UI.Utils.checkDisplay(ele);
                        });

                    } else {

                        UI.Utils.animate(this, animations[1]+' uk-animation-reverse').then(function(){
                            ele.toggleClass($this.options.cls).css('animation-duration', '');
                            UI.Utils.checkDisplay(ele);
                        });

                    }

                });

            } else {
                this.totoggle.toggleClass(this.options.cls);
                UI.Utils.checkDisplay(this.totoggle);
            }

            this.updateAria();

        },

        getToggles: function() {
            this.totoggle = this.options.target ? UI.$(this.options.target):[];
            this.updateAria();
        },

        updateAria: function() {
            if (this.aria && this.totoggle.length) {
                this.totoggle.each(function(){
                    UI.$(this).attr('aria-hidden', UI.$(this).hasClass('uk-hidden'));
                });
            }
        }
    });

})(UIkit);

(function(UI) {

    "use strict";

    UI.component('alert', {

        defaults: {
            "fade": true,
            "duration": 200,
            "trigger": ".uk-alert-close"
        },

        boot: function() {

            // init code
            UI.$html.on("click.alert.uikit", "[data-uk-alert]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("alert")) {

                    var alert = UI.alert(ele, UI.Utils.options(ele.attr("data-uk-alert")));

                    if (UI.$(e.target).is(alert.options.trigger)) {
                        e.preventDefault();
                        alert.close();
                    }
                }
            });
        },

        init: function() {

            var $this = this;

            this.on("click", this.options.trigger, function(e) {
                e.preventDefault();
                $this.close();
            });
        },

        close: function() {

            var element       = this.trigger("close.uk.alert"),
                removeElement = function () {
                    this.trigger("closed.uk.alert").remove();
                }.bind(this);

            if (this.options.fade) {
                element.css("overflow", "hidden").css("max-height", element.height()).animate({
                    "height"         : 0,
                    "opacity"        : 0,
                    "padding-top"    : 0,
                    "padding-bottom" : 0,
                    "margin-top"     : 0,
                    "margin-bottom"  : 0
                }, this.options.duration, removeElement);
            } else {
                removeElement();
            }
        }

    });

})(UIkit);

(function(UI) {

    "use strict";

    UI.component('buttonRadio', {

        defaults: {
            "activeClass": 'uk-active',
            "target": ".uk-button"
        },

        boot: function() {

            // init code
            UI.$html.on("click.buttonradio.uikit", "[data-uk-button-radio]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("buttonRadio")) {

                    var obj    = UI.buttonRadio(ele, UI.Utils.options(ele.attr("data-uk-button-radio"))),
                        target = UI.$(e.target);

                    if (target.is(obj.options.target)) {
                        target.trigger("click");
                    }
                }
            });
        },

        init: function() {

            var $this = this;

            // Init ARIA
            this.find($this.options.target).attr('aria-checked', 'false').filter('.' + $this.options.activeClass).attr('aria-checked', 'true');

            this.on("click", this.options.target, function(e) {

                var ele = UI.$(this);

                if (ele.is('a[href="#"]')) e.preventDefault();

                $this.find($this.options.target).not(ele).removeClass($this.options.activeClass).blur();
                ele.addClass($this.options.activeClass);

                // Update ARIA
                $this.find($this.options.target).not(ele).attr('aria-checked', 'false');
                ele.attr('aria-checked', 'true');

                $this.trigger("change.uk.button", [ele]);
            });

        },

        getSelected: function() {
            return this.find('.' + this.options.activeClass);
        }
    });

    UI.component('buttonCheckbox', {

        defaults: {
            "activeClass": 'uk-active',
            "target": ".uk-button"
        },

        boot: function() {

            UI.$html.on("click.buttoncheckbox.uikit", "[data-uk-button-checkbox]", function(e) {
                var ele = UI.$(this);

                if (!ele.data("buttonCheckbox")) {

                    var obj    = UI.buttonCheckbox(ele, UI.Utils.options(ele.attr("data-uk-button-checkbox"))),
                        target = UI.$(e.target);

                    if (target.is(obj.options.target)) {
                        target.trigger("click");
                    }
                }
            });
        },

        init: function() {

            var $this = this;

            // Init ARIA
            this.find($this.options.target).attr('aria-checked', 'false').filter('.' + $this.options.activeClass).attr('aria-checked', 'true');

            this.on("click", this.options.target, function(e) {
                var ele = UI.$(this);

                if (ele.is('a[href="#"]')) e.preventDefault();

                ele.toggleClass($this.options.activeClass).blur();

                // Update ARIA
                ele.attr('aria-checked', ele.hasClass($this.options.activeClass));

                $this.trigger("change.uk.button", [ele]);
            });

        },

        getSelected: function() {
            return this.find('.' + this.options.activeClass);
        }
    });


    UI.component('button', {

        defaults: {},

        boot: function() {

            UI.$html.on("click.button.uikit", "[data-uk-button]", function(e) {
                var ele = UI.$(this);

                if (!ele.data("button")) {

                    var obj = UI.button(ele, UI.Utils.options(ele.attr("data-uk-button")));
                    ele.trigger("click");
                }
            });
        },

        init: function() {

            var $this = this;

            // Init ARIA
            this.element.attr('aria-pressed', this.element.hasClass("uk-active"));

            this.on("click", function(e) {

                if ($this.element.is('a[href="#"]')) e.preventDefault();

                $this.toggle();
                $this.trigger("change.uk.button", [$this.element.blur().hasClass("uk-active")]);
            });

        },

        toggle: function() {
            this.element.toggleClass("uk-active");

            // Update ARIA
            this.element.attr('aria-pressed', this.element.hasClass("uk-active"));
        }
    });

})(UIkit);


(function(UI) {

    "use strict";

    var active = false, hoverIdle, flips = {
        'x': {
            "bottom-left"   : 'bottom-right',
            "bottom-right"  : 'bottom-left',
            "bottom-center" : 'bottom-right',
            "top-left"      : 'top-right',
            "top-right"     : 'top-left',
            "top-center"    : 'top-right',
            "left-top"      : 'right',
            "left-bottom"   : 'right-bottom',
            "left-center"   : 'right-center',
            "right-top"     : 'left',
            "right-bottom"  : 'left-bottom',
            "right-center"  : 'left-center'
        },
        'y': {
            "bottom-left"   : 'top-left',
            "bottom-right"  : 'top-right',
            "bottom-center" : 'top-center',
            "top-left"      : 'bottom-left',
            "top-right"     : 'bottom-right',
            "top-center"    : 'bottom-center',
            "left-top"      : 'top-left',
            "left-bottom"   : 'left-bottom',
            "left-center"   : 'top-left',
            "right-top"     : 'top-left',
            "right-bottom"  : 'bottom-left',
            "right-center"  : 'top-left'
        },
        'xy': {

        }
    };

    UI.component('dropdown', {

        defaults: {
           'mode'            : 'hover',
           'pos'             : 'bottom-left',
           'offset'          : 0,
           'remaintime'      : 800,
           'justify'         : false,
           'boundary'        : UI.$win,
           'delay'           : 0,
           'dropdownSelector': '.uk-dropdown,.uk-dropdown-blank',
           'hoverDelayIdle'  : 250,
           'preventflip'     : false
        },

        remainIdle: false,

        boot: function() {

            var triggerevent = UI.support.touch ? "click" : "mouseenter";

            // init code
            UI.$html.on(triggerevent+".dropdown.uikit", "[data-uk-dropdown]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("dropdown")) {

                    var dropdown = UI.dropdown(ele, UI.Utils.options(ele.attr("data-uk-dropdown")));

                    if (triggerevent=="click" || (triggerevent=="mouseenter" && dropdown.options.mode=="hover")) {
                        dropdown.element.trigger(triggerevent);
                    }

                    if (dropdown.element.find(dropdown.options.dropdownSelector).length) {
                        e.preventDefault();
                    }
                }
            });
        },

        init: function() {

            var $this = this;

            this.dropdown     = this.find(this.options.dropdownSelector);
            this.offsetParent = this.dropdown.parents().filter(function() {
                return UI.$.inArray(UI.$(this).css('position'), ['relative', 'fixed', 'absolute']) !== -1;
            }).slice(0,1);

            this.centered  = this.dropdown.hasClass('uk-dropdown-center');
            this.justified = this.options.justify ? UI.$(this.options.justify) : false;

            this.boundary  = UI.$(this.options.boundary);

            if (!this.boundary.length) {
                this.boundary = UI.$win;
            }

            // legacy DEPRECATED!
            if (this.dropdown.hasClass('uk-dropdown-up')) {
                this.options.pos = 'top-left';
            }
            if (this.dropdown.hasClass('uk-dropdown-flip')) {
                this.options.pos = this.options.pos.replace('left','right');
            }
            if (this.dropdown.hasClass('uk-dropdown-center')) {
                this.options.pos = this.options.pos.replace(/(left|right)/,'center');
            }
            //-- end legacy

            // Init ARIA
            this.element.attr('aria-haspopup', 'true');
            this.element.attr('aria-expanded', this.element.hasClass("uk-open"));

            if (this.options.mode == "click" || UI.support.touch) {

                this.on("click.uikit.dropdown", function(e) {

                    var $target = UI.$(e.target);

                    if (!$target.parents($this.options.dropdownSelector).length) {

                        if ($target.is("a[href='#']") || $target.parent().is("a[href='#']") || ($this.dropdown.length && !$this.dropdown.is(":visible")) ){
                            e.preventDefault();
                        }

                        $target.blur();
                    }

                    if (!$this.element.hasClass('uk-open')) {

                        $this.show();

                    } else {

                        if (!$this.dropdown.find(e.target).length || $target.is(".uk-dropdown-close") || $target.parents(".uk-dropdown-close").length) {
                            $this.hide();
                        }
                    }
                });

            } else {

                this.on("mouseenter", function(e) {

                    $this.trigger('pointerenter.uk.dropdown', [$this]);

                    if ($this.remainIdle) {
                        clearTimeout($this.remainIdle);
                    }

                    if (hoverIdle) {
                        clearTimeout(hoverIdle);
                    }

                    if (active && active == $this) {
                        return;
                    }

                    // pseudo manuAim
                    if (active && active != $this) {

                        hoverIdle = setTimeout(function() {
                            hoverIdle = setTimeout($this.show.bind($this), $this.options.delay);
                        }, $this.options.hoverDelayIdle);

                    } else {

                        hoverIdle = setTimeout($this.show.bind($this), $this.options.delay);
                    }

                }).on("mouseleave", function() {

                    if (hoverIdle) {
                        clearTimeout(hoverIdle);
                    }

                    $this.remainIdle = setTimeout(function() {
                        if (active && active == $this) $this.hide();
                    }, $this.options.remaintime);

                    $this.trigger('pointerleave.uk.dropdown', [$this]);

                }).on("click", function(e){

                    var $target = UI.$(e.target);

                    if ($this.remainIdle) {
                        clearTimeout($this.remainIdle);
                    }

                    if (active && active == $this) {
                        if (!$this.dropdown.find(e.target).length || $target.is(".uk-dropdown-close") || $target.parents(".uk-dropdown-close").length) {
                            $this.hide();
                        }
                        return;
                    }

                    if ($target.is("a[href='#']") || $target.parent().is("a[href='#']")){
                        e.preventDefault();
                    }

                    $this.show();
                });
            }
        },

        show: function(){

            UI.$html.off("click.outer.dropdown");

            if (active && active != this) {
                active.hide(true);
            }

            if (hoverIdle) {
                clearTimeout(hoverIdle);
            }

            this.trigger('beforeshow.uk.dropdown', [this]);

            this.checkDimensions();
            this.element.addClass('uk-open');

            // Update ARIA
            this.element.attr('aria-expanded', 'true');

            this.trigger('show.uk.dropdown', [this]);

            UI.Utils.checkDisplay(this.dropdown, true);
            active = this;

            this.registerOuterClick();
        },

        hide: function(force) {

            this.trigger('beforehide.uk.dropdown', [this, force]);

            this.element.removeClass('uk-open');

            if (this.remainIdle) {
                clearTimeout(this.remainIdle);
            }

            this.remainIdle = false;

            // Update ARIA
            this.element.attr('aria-expanded', 'false');

            this.trigger('hide.uk.dropdown', [this, force]);

            if (active == this) active = false;
        },

        registerOuterClick: function(){

            var $this = this;

            UI.$html.off("click.outer.dropdown");

            setTimeout(function() {

                UI.$html.on("click.outer.dropdown", function(e) {

                    if (hoverIdle) {
                        clearTimeout(hoverIdle);
                    }

                    var $target = UI.$(e.target);

                    if (active == $this && !$this.element.find(e.target).length) {
                        $this.hide(true);
                        UI.$html.off("click.outer.dropdown");
                    }
                });
            }, 10);
        },

        checkDimensions: function() {

            if (!this.dropdown.length) return;

            // reset
            this.dropdown.removeClass('uk-dropdown-top uk-dropdown-bottom uk-dropdown-left uk-dropdown-right uk-dropdown-stack').css({
                'top-left':'',
                'left':'',
                'margin-left' :'',
                'margin-right':''
            });

            if (this.justified && this.justified.length) {
                this.dropdown.css("min-width", "");
            }

            var $this          = this,
                pos            = UI.$.extend({}, this.offsetParent.offset(), {width: this.offsetParent[0].offsetWidth, height: this.offsetParent[0].offsetHeight}),
                posoffset      = this.options.offset,
                dropdown       = this.dropdown,
                offset         = dropdown.show().offset() || {left: 0, top: 0},
                width          = dropdown.outerWidth(),
                height         = dropdown.outerHeight(),
                boundarywidth  = this.boundary.width(),
                boundaryoffset = this.boundary[0] !== window && this.boundary.offset() ? this.boundary.offset(): {top:0, left:0},
                dpos           = this.options.pos;

            var variants =  {
                    "bottom-left"   : {top: 0 + pos.height + posoffset, left: 0},
                    "bottom-right"  : {top: 0 + pos.height + posoffset, left: 0 + pos.width - width},
                    "bottom-center" : {top: 0 + pos.height + posoffset, left: 0 + pos.width / 2 - width / 2},
                    "top-left"      : {top: 0 - height - posoffset, left: 0},
                    "top-right"     : {top: 0 - height - posoffset, left: 0 + pos.width - width},
                    "top-center"    : {top: 0 - height - posoffset, left: 0 + pos.width / 2 - width / 2},
                    "left-top"      : {top: 0, left: 0 - width - posoffset},
                    "left-bottom"   : {top: 0 + pos.height - height, left: 0 - width - posoffset},
                    "left-center"   : {top: 0 + pos.height / 2 - height / 2, left: 0 - width - posoffset},
                    "right-top"     : {top: 0, left: 0 + pos.width + posoffset},
                    "right-bottom"  : {top: 0 + pos.height - height, left: 0 + pos.width + posoffset},
                    "right-center"  : {top: 0 + pos.height / 2 - height / 2, left: 0 + pos.width + posoffset}
                },
                css = {},
                pp;

            pp = dpos.split('-');
            css = variants[dpos] ? variants[dpos] : variants['bottom-left'];

            // justify dropdown
            if (this.justified && this.justified.length) {
                justify(dropdown.css({left:0}), this.justified, boundarywidth);
            } else {

                if (this.options.preventflip !== true) {

                    var fdpos;

                    switch(this.checkBoundary(pos.left + css.left, pos.top + css.top, width, height, boundarywidth)) {
                        case "x":
                            if(this.options.preventflip !=='x') fdpos = flips['x'][dpos] || 'right-top';
                            break;
                        case "y":
                            if(this.options.preventflip !=='y') fdpos = flips['y'][dpos] || 'top-left';
                            break;
                        case "xy":
                            if(!this.options.preventflip) fdpos = flips['xy'][dpos] || 'right-bottom';
                            break;
                    }

                    if (fdpos) {

                        pp  = fdpos.split('-');
                        css = variants[fdpos] ? variants[fdpos] : variants['bottom-left'];

                        // check flipped
                        if (this.checkBoundary(pos.left + css.left, pos.top + css.top, width, height, boundarywidth)) {
                            pp  = dpos.split('-');
                            css = variants[dpos] ? variants[dpos] : variants['bottom-left'];
                        }
                    }
                }
            }

            if (width > boundarywidth) {
                dropdown.addClass("uk-dropdown-stack");
                this.trigger('stack.uk.dropdown', [this]);
            }

            dropdown.css(css).css("display", "").addClass('uk-dropdown-'+pp[0]);
        },

        checkBoundary: function(left, top, width, height, boundarywidth) {

            var axis = "";

            if (left < 0 || ((left - UI.$win.scrollLeft())+width) > boundarywidth) {
               axis += "x";
            }

            if ((top - UI.$win.scrollTop()) < 0 || ((top - UI.$win.scrollTop())+height) > window.innerHeight) {
               axis += "y";
            }

            return axis;
        }
    });


    UI.component('dropdownOverlay', {

        defaults: {
           'justify' : false,
           'cls'     : '',
           'duration': 200
        },

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-dropdown-overlay]", context).each(function() {
                    var ele = UI.$(this);

                    if (!ele.data("dropdownOverlay")) {
                        UI.dropdownOverlay(ele, UI.Utils.options(ele.attr("data-uk-dropdown-overlay")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            this.justified = this.options.justify ? UI.$(this.options.justify) : false;
            this.overlay   = this.element.find('uk-dropdown-overlay');

            if (!this.overlay.length) {
                this.overlay = UI.$('<div class="uk-dropdown-overlay"></div>').appendTo(this.element);
            }

            this.overlay.addClass(this.options.cls);

            this.on({

                'beforeshow.uk.dropdown': function(e, dropdown) {
                    $this.dropdown = dropdown;

                    if ($this.justified && $this.justified.length) {
                        justify($this.overlay.css({'display':'block', 'margin-left':'','margin-right':''}), $this.justified, $this.justified.outerWidth());
                    }
                },

                'show.uk.dropdown': function(e, dropdown) {

                    var h = $this.dropdown.dropdown.outerHeight(true);

                    $this.dropdown.element.removeClass('uk-open');

                    $this.overlay.stop().css('display', 'block').animate({height: h}, $this.options.duration, function() {

                       $this.dropdown.dropdown.css('visibility', '');
                       $this.dropdown.element.addClass('uk-open');

                       UI.Utils.checkDisplay($this.dropdown.dropdown, true);
                    });

                    $this.pointerleave = false;
                },

                'hide.uk.dropdown': function() {
                    $this.overlay.stop().animate({height: 0}, $this.options.duration);
                },

                'pointerenter.uk.dropdown': function(e, dropdown) {
                    clearTimeout($this.remainIdle);
                },

                'pointerleave.uk.dropdown': function(e, dropdown) {
                    $this.pointerleave = true;
                }
            });


            this.overlay.on({

                'mouseenter': function() {
                    if ($this.remainIdle) {
                        clearTimeout($this.dropdown.remainIdle);
                        clearTimeout($this.remainIdle);
                    }
                },

                'mouseleave': function(){

                    if ($this.pointerleave && active) {

                        $this.remainIdle = setTimeout(function() {
                           if(active) active.hide();
                        }, active.options.remaintime);
                    }
                }
            })
        }

    });


    function justify(ele, justifyTo, boundarywidth, offset) {

        ele           = UI.$(ele);
        justifyTo     = UI.$(justifyTo);
        boundarywidth = boundarywidth || window.innerWidth;
        offset        = offset || ele.offset();

        if (justifyTo.length) {

            var jwidth = justifyTo.outerWidth();

            ele.css("min-width", jwidth);

            if (UI.langdirection == 'right') {

                var right1   = boundarywidth - (justifyTo.offset().left + jwidth),
                    right2   = boundarywidth - (ele.offset().left + ele.outerWidth());

                ele.css("margin-right", right1 - right2);

            } else {
                ele.css("margin-left", justifyTo.offset().left - offset.left);
            }
        }
    }

})(UIkit);

(function(UI) {

    "use strict";

    var grids = [];

    UI.component('gridMatchHeight', {

        defaults: {
            "target"        : false,
            "row"           : true,
            "ignorestacked" : false
        },

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-grid-match]", context).each(function() {
                    var grid = UI.$(this), obj;

                    if (!grid.data("gridMatchHeight")) {
                        obj = UI.gridMatchHeight(grid, UI.Utils.options(grid.attr("data-uk-grid-match")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            this.columns  = this.element.children();
            this.elements = this.options.target ? this.find(this.options.target) : this.columns;

            if (!this.columns.length) return;

            UI.$win.on('load resize orientationchange', (function() {

                var fn = function() {
                    $this.match();
                };

                UI.$(function() { fn(); });

                return UI.Utils.debounce(fn, 50);
            })());

            UI.$html.on("changed.uk.dom", function(e) {
                $this.columns  = $this.element.children();
                $this.elements = $this.options.target ? $this.find($this.options.target) : $this.columns;
                $this.match();
            });

            this.on("display.uk.check", function(e) {
                if(this.element.is(":visible")) this.match();
            }.bind(this));

            grids.push(this);
        },

        match: function() {

            var firstvisible = this.columns.filter(":visible:first");

            if (!firstvisible.length) return;

            var stacked = Math.ceil(100 * parseFloat(firstvisible.css('width')) / parseFloat(firstvisible.parent().css('width'))) >= 100;

            if (stacked && !this.options.ignorestacked) {
                this.revert();
            } else {
                UI.Utils.matchHeights(this.elements, this.options);
            }

            return this;
        },

        revert: function() {
            this.elements.css('min-height', '');
            return this;
        }
    });

    UI.component('gridMargin', {

        defaults: {
            cls      : 'uk-grid-margin',
            rowfirst : 'uk-row-first'
        },

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-grid-margin]", context).each(function() {
                    var grid = UI.$(this), obj;

                    if (!grid.data("gridMargin")) {
                        obj = UI.gridMargin(grid, UI.Utils.options(grid.attr("data-uk-grid-margin")));
                    }
                });
            });
        },

        init: function() {

            var stackMargin = UI.stackMargin(this.element, this.options);
        }
    });

})(UIkit);

(function(UI) {

    "use strict";

    var active = false, activeCount = 0, $html = UI.$html, body;

    UI.component('modal', {

        defaults: {
            keyboard: true,
            bgclose: true,
            minScrollHeight: 150,
            center: false,
            modal: true
        },

        scrollable: false,
        transition: false,
        hasTransitioned: true,

        init: function() {

            if (!body) body = UI.$('body');

            if (!this.element.length) return;

            var $this = this;

            this.paddingdir = "padding-" + (UI.langdirection == 'left' ? "right":"left");
            this.dialog     = this.find(".uk-modal-dialog");

            this.active     = false;

            // Update ARIA
            this.element.attr('aria-hidden', this.element.hasClass("uk-open"));

            this.on("click", ".uk-modal-close", function(e) {
                e.preventDefault();
                $this.hide();
            }).on("click", function(e) {

                var target = UI.$(e.target);

                if (target[0] == $this.element[0] && $this.options.bgclose) {
                    $this.hide();
                }
            });
        },

        toggle: function() {
            return this[this.isActive() ? "hide" : "show"]();
        },

        show: function() {

            if (!this.element.length) return;

            var $this = this;

            if (this.isActive()) return;

            if (this.options.modal && active) {
                active.hide(true);
            }

            this.element.removeClass("uk-open").show();
            this.resize();

            if (this.options.modal) {
                active = this;
            }

            this.active = true;

            activeCount++;

            if (UI.support.transition) {
                this.hasTransitioned = false;
                this.element.one(UI.support.transition.end, function(){
                    $this.hasTransitioned = true;
                }).addClass("uk-open");
            } else {
                this.element.addClass("uk-open");
            }

            $html.addClass("uk-modal-page").height(); // force browser engine redraw

            // Update ARIA
            this.element.attr('aria-hidden', 'false');

            this.element.trigger("show.uk.modal");

            UI.Utils.checkDisplay(this.dialog, true);

            return this;
        },

        hide: function(force) {

            if (!force && UI.support.transition && this.hasTransitioned) {

                var $this = this;

                this.one(UI.support.transition.end, function() {
                    $this._hide();
                }).removeClass("uk-open");

            } else {

                this._hide();
            }

            return this;
        },

        resize: function() {

            var bodywidth  = body.width();

            this.scrollbarwidth = window.innerWidth - bodywidth;

            body.css(this.paddingdir, this.scrollbarwidth);

            this.element.css('overflow-y', this.scrollbarwidth ? 'scroll' : 'auto');

            if (!this.updateScrollable() && this.options.center) {

                var dh  = this.dialog.outerHeight(),
                pad = parseInt(this.dialog.css('margin-top'), 10) + parseInt(this.dialog.css('margin-bottom'), 10);

                if ((dh + pad) < window.innerHeight) {
                    this.dialog.css({'top': (window.innerHeight/2 - dh/2) - pad });
                } else {
                    this.dialog.css({'top': ''});
                }
            }
        },

        updateScrollable: function() {

            // has scrollable?
            var scrollable = this.dialog.find('.uk-overflow-container:visible:first');

            if (scrollable.length) {

                scrollable.css('height', 0);

                var offset = Math.abs(parseInt(this.dialog.css('margin-top'), 10)),
                dh     = this.dialog.outerHeight(),
                wh     = window.innerHeight,
                h      = wh - 2*(offset < 20 ? 20:offset) - dh;

                scrollable.css({
                    'max-height': (h < this.options.minScrollHeight ? '':h),
                    'height':''
                });

                return true;
            }

            return false;
        },

        _hide: function() {

            this.active = false;
            if (activeCount > 0) activeCount--;
            else activeCount = 0;

            this.element.hide().removeClass('uk-open');

            // Update ARIA
            this.element.attr('aria-hidden', 'true');

            if (!activeCount) {
                $html.removeClass('uk-modal-page');
                body.css(this.paddingdir, "");
            }

            if(active===this) active = false;

            this.trigger('hide.uk.modal');
        },

        isActive: function() {
            return this.active;
        }

    });

    UI.component('modalTrigger', {

        boot: function() {

            // init code
            UI.$html.on("click.modal.uikit", "[data-uk-modal]", function(e) {

                var ele = UI.$(this);

                if (ele.is("a")) {
                    e.preventDefault();
                }

                if (!ele.data("modalTrigger")) {
                    var modal = UI.modalTrigger(ele, UI.Utils.options(ele.attr("data-uk-modal")));
                    modal.show();
                }

            });

            // close modal on esc button
            UI.$html.on('keydown.modal.uikit', function (e) {

                if (active && e.keyCode === 27 && active.options.keyboard) { // ESC
                    e.preventDefault();
                    active.hide();
                }
            });

            UI.$win.on("resize orientationchange", UI.Utils.debounce(function(){
                if (active) active.resize();
            }, 150));
        },

        init: function() {

            var $this = this;

            this.options = UI.$.extend({
                "target": $this.element.is("a") ? $this.element.attr("href") : false
            }, this.options);

            this.modal = UI.modal(this.options.target, this.options);

            this.on("click", function(e) {
                e.preventDefault();
                $this.show();
            });

            //methods
            this.proxy(this.modal, "show hide isActive");
        }
    });

    UI.modal.dialog = function(content, options) {

        var modal = UI.modal(UI.$(UI.modal.dialog.template).appendTo("body"), options);

        modal.on("hide.uk.modal", function(){
            if (modal.persist) {
                modal.persist.appendTo(modal.persist.data("modalPersistParent"));
                modal.persist = false;
            }
            modal.element.remove();
        });

        setContent(content, modal);

        return modal;
    };

    UI.modal.dialog.template = '<div class="uk-modal"><div class="uk-modal-dialog" style="min-height:0;"></div></div>';

    UI.modal.alert = function(content, options) {

        options = UI.$.extend(true, {bgclose:false, keyboard:false, modal:false, labels:UI.modal.labels}, options);

        var modal = UI.modal.dialog(([
            '<div class="uk-margin uk-modal-content">'+String(content)+'</div>',
            '<div class="uk-modal-footer uk-text-right"><button class="uk-button uk-button-primary uk-modal-close">'+options.labels.Ok+'</button></div>'
        ]).join(""), options);

        modal.on('show.uk.modal', function(){
            setTimeout(function(){
                modal.element.find('button:first').focus();
            }, 50);
        });

        return modal.show();
    };

    UI.modal.confirm = function(content, onconfirm, oncancel) {

        var options = arguments.length > 1 && arguments[arguments.length-1] ? arguments[arguments.length-1] : {};

        onconfirm = UI.$.isFunction(onconfirm) ? onconfirm : function(){};
        oncancel  = UI.$.isFunction(oncancel) ? oncancel : function(){};
        options   = UI.$.extend(true, {bgclose:false, keyboard:false, modal:false, labels:UI.modal.labels}, UI.$.isFunction(options) ? {}:options);

        var modal = UI.modal.dialog(([
            '<div class="uk-margin uk-modal-content">'+String(content)+'</div>',
            '<div class="uk-modal-footer uk-text-right"><button class="uk-button js-modal-confirm-cancel">'+options.labels.Cancel+'</button> <button class="uk-button uk-button-primary js-modal-confirm">'+options.labels.Ok+'</button></div>'
        ]).join(""), options);

        modal.element.find(".js-modal-confirm, .js-modal-confirm-cancel").on("click", function(){
            UI.$(this).is('.js-modal-confirm') ? onconfirm() : oncancel();
            modal.hide();
        });

        modal.on('show.uk.modal', function(){
            setTimeout(function(){
                modal.element.find('.js-modal-confirm').focus();
            }, 50);
        });

        return modal.show();
    };

    UI.modal.prompt = function(text, value, onsubmit, options) {

        onsubmit = UI.$.isFunction(onsubmit) ? onsubmit : function(value){};
        options  = UI.$.extend(true, {bgclose:false, keyboard:false, modal:false, labels:UI.modal.labels}, options);

        var modal = UI.modal.dialog(([
            text ? '<div class="uk-modal-content uk-form">'+String(text)+'</div>':'',
            '<div class="uk-margin-small-top uk-modal-content uk-form"><p><input type="text" class="uk-width-1-1"></p></div>',
            '<div class="uk-modal-footer uk-text-right"><button class="uk-button uk-modal-close">'+options.labels.Cancel+'</button> <button class="uk-button uk-button-primary js-modal-ok">'+options.labels.Ok+'</button></div>'
        ]).join(""), options),

        input = modal.element.find("input[type='text']").val(value || '').on('keyup', function(e){
            if (e.keyCode == 13) {
                modal.element.find(".js-modal-ok").trigger('click');
            }
        });

        modal.element.find(".js-modal-ok").on("click", function(){
            if (onsubmit(input.val())!==false){
                modal.hide();
            }
        });

        modal.on('show.uk.modal', function(){
            setTimeout(function(){
                input.focus();
            }, 50);
        });

        return modal.show();
    };

    UI.modal.blockUI = function(content, options) {

        var modal = UI.modal.dialog(([
            '<div class="uk-margin uk-modal-content">'+String(content || '<div class="uk-text-center">...</div>')+'</div>'
        ]).join(""), UI.$.extend({bgclose:false, keyboard:false, modal:false}, options));

        modal.content = modal.element.find('.uk-modal-content:first');

        return modal.show();
    };


    UI.modal.labels = {
        'Ok': 'Confirmar',
        'Cancel': 'Cancelar'
    };


    // helper functions
    function setContent(content, modal){

        if(!modal) return;

        if (typeof content === 'object') {

            // convert DOM object to a jQuery object
            content = content instanceof jQuery ? content : UI.$(content);

            if(content.parent().length) {
                modal.persist = content;
                modal.persist.data("modalPersistParent", content.parent());
            }
        }else if (typeof content === 'string' || typeof content === 'number') {
                // just insert the data as innerHTML
                content = UI.$('<div></div>').html(content);
        }else {
                // unsupported data type!
                content = UI.$('<div></div>').html('UIkit.modal Error: Unsupported data type: ' + typeof content);
        }

        content.appendTo(modal.element.find('.uk-modal-dialog'));

        return modal;
    }

})(UIkit);

(function(UI) {

    "use strict";

    UI.component('nav', {

        defaults: {
            "toggle": ">li.uk-parent > a[href='#']",
            "lists": ">li.uk-parent > ul",
            "multiple": false
        },

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-nav]", context).each(function() {
                    var nav = UI.$(this);

                    if (!nav.data("nav")) {
                        var obj = UI.nav(nav, UI.Utils.options(nav.attr("data-uk-nav")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            this.on("click.uikit.nav", this.options.toggle, function(e) {
                e.preventDefault();
                var ele = UI.$(this);
                $this.open(ele.parent()[0] == $this.element[0] ? ele : ele.parent("li"));
            });

            this.find(this.options.lists).each(function() {
                var $ele   = UI.$(this),
                    parent = $ele.parent(),
                    active = parent.hasClass("uk-active");

                $ele.wrap('<div style="overflow:hidden;height:0;position:relative;"></div>');
                parent.data("list-container", $ele.parent()[active ? 'removeClass':'addClass']('uk-hidden'));

                // Init ARIA
                parent.attr('aria-expanded', parent.hasClass("uk-open"));

                if (active) $this.open(parent, true);
            });

        },

        open: function(li, noanimation) {

            var $this = this, element = this.element, $li = UI.$(li), $container = $li.data('list-container');

            if (!this.options.multiple) {

                element.children('.uk-open').not(li).each(function() {

                    var ele = UI.$(this);

                    if (ele.data('list-container')) {
                        ele.data('list-container').stop().animate({height: 0}, function() {
                            UI.$(this).parent().removeClass('uk-open').end().addClass('uk-hidden');
                        });
                    }
                });
            }

            $li.toggleClass('uk-open');

            // Update ARIA
            $li.attr('aria-expanded', $li.hasClass('uk-open'));

            if ($container) {

                if ($li.hasClass('uk-open')) {
                    $container.removeClass('uk-hidden');
                }

                if (noanimation) {

                    $container.stop().height($li.hasClass('uk-open') ? 'auto' : 0);

                    if (!$li.hasClass('uk-open')) {
                        $container.addClass('uk-hidden');
                    }

                    this.trigger('display.uk.check');

                } else {

                    $container.stop().animate({
                        height: ($li.hasClass('uk-open') ? getHeight($container.find('ul:first')) : 0)
                    }, function() {

                        if (!$li.hasClass('uk-open')) {
                            $container.addClass('uk-hidden');
                        } else {
                            $container.css('height', '');
                        }

                        $this.trigger('display.uk.check');
                    });
                }
            }
        }
    });


    // helper

    function getHeight(ele) {
        var $ele = UI.$(ele), height = "auto";

        if ($ele.is(":visible")) {
            height = $ele.outerHeight();
        } else {
            var tmp = {
                position: $ele.css("position"),
                visibility: $ele.css("visibility"),
                display: $ele.css("display")
            };

            height = $ele.css({position: 'absolute', visibility: 'hidden', display: 'block'}).outerHeight();

            $ele.css(tmp); // reset element
        }

        return height;
    }

})(UIkit);

(function(UI) {

    "use strict";

    var scrollpos = {x: window.scrollX, y: window.scrollY},
        $win      = UI.$win,
        $doc      = UI.$doc,
        $html     = UI.$html,
        Offcanvas = {

        show: function(element) {

            element = UI.$(element);

            if (!element.length) return;

            var $body     = UI.$('body'),
                bar       = element.find(".uk-offcanvas-bar:first"),
                rtl       = (UI.langdirection == "right"),
                flip      = bar.hasClass("uk-offcanvas-bar-flip") ? -1:1,
                dir       = flip * (rtl ? -1 : 1),

                scrollbarwidth =  window.innerWidth - $body.width();

            scrollpos = {x: window.pageXOffset, y: window.pageYOffset};

            element.addClass("uk-active");

            $body.css({"width": window.innerWidth - scrollbarwidth, "height": window.innerHeight}).addClass("uk-offcanvas-page");
            $body.css((rtl ? "margin-right" : "margin-left"), (rtl ? -1 : 1) * (bar.outerWidth() * dir)).width(); // .width() - force redraw

            $html.css('margin-top', scrollpos.y * -1);

            bar.addClass("uk-offcanvas-bar-show");

            this._initElement(element);

            bar.trigger('show.uk.offcanvas', [element, bar]);

            // Update ARIA
            element.attr('aria-hidden', 'false');
        },

        hide: function(force) {

            var $body = UI.$('body'),
                panel = UI.$(".uk-offcanvas.uk-active"),
                rtl   = (UI.langdirection == "right"),
                bar   = panel.find(".uk-offcanvas-bar:first"),
                finalize = function() {
                    $body.removeClass("uk-offcanvas-page").css({"width": "", "height": "", "margin-left": "", "margin-right": ""});
                    panel.removeClass("uk-active");

                    bar.removeClass("uk-offcanvas-bar-show");
                    $html.css('margin-top', '');
                    window.scrollTo(scrollpos.x, scrollpos.y);
                    bar.trigger('hide.uk.offcanvas', [panel, bar]);

                    // Update ARIA
                    panel.attr('aria-hidden', 'true');
                };

            if (!panel.length) return;

            if (UI.support.transition && !force) {

                $body.one(UI.support.transition.end, function() {
                    finalize();
                }).css((rtl ? "margin-right" : "margin-left"), "");

                setTimeout(function(){
                    bar.removeClass("uk-offcanvas-bar-show");
                }, 0);

            } else {
                finalize();
            }
        },

        _initElement: function(element) {

            if (element.data("OffcanvasInit")) return;

            element.on("click.uk.offcanvas swipeRight.uk.offcanvas swipeLeft.uk.offcanvas", function(e) {

                var target = UI.$(e.target);

                if (!e.type.match(/swipe/)) {

                    if (!target.hasClass("uk-offcanvas-close")) {
                        if (target.hasClass("uk-offcanvas-bar")) return;
                        if (target.parents(".uk-offcanvas-bar:first").length) return;
                    }
                }

                e.stopImmediatePropagation();
                Offcanvas.hide();
            });

            element.on("click", "a[href*='#']", function(e){

                var link = UI.$(this),
                    href = link.attr("href");

                if (href == "#") {
                    return;
                }

                UI.$doc.one('hide.uk.offcanvas', function() {

                    var target;

                    try {
                        target = UI.$(link[0].hash);
                    } catch (e){
                        target = '';
                    }

                    if (!target.length) {
                        target = UI.$('[name="'+link[0].hash.replace('#','')+'"]');
                    }

                    if (target.length && UI.Utils.scrollToElement) {
                        UI.Utils.scrollToElement(target, UI.Utils.options(link.attr('data-uk-smooth-scroll') || '{}'));
                    } else {
                        window.location.href = href;
                    }
                });

                Offcanvas.hide();
            });

            element.data("OffcanvasInit", true);
        }
    };

    UI.component('offcanvasTrigger', {

        boot: function() {

            // init code
            $html.on("click.offcanvas.uikit", "[data-uk-offcanvas]", function(e) {

                e.preventDefault();

                var ele = UI.$(this);

                if (!ele.data("offcanvasTrigger")) {
                    var obj = UI.offcanvasTrigger(ele, UI.Utils.options(ele.attr("data-uk-offcanvas")));
                    ele.trigger("click");
                }
            });

            $html.on('keydown.uk.offcanvas', function(e) {

                if (e.keyCode === 27) { // ESC
                    Offcanvas.hide();
                }
            });
        },

        init: function() {

            var $this = this;

            this.options = UI.$.extend({
                "target": $this.element.is("a") ? $this.element.attr("href") : false
            }, this.options);

            this.on("click", function(e) {
                e.preventDefault();
                Offcanvas.show($this.options.target);
            });
        }
    });

    UI.offcanvas = Offcanvas;

})(UIkit);

(function(UI) {

    "use strict";

    var Animations;

    UI.component('switcher', {

        defaults: {
            connect   : false,
            toggle    : ">*",
            active    : 0,
            animation : false,
            duration  : 200,
            swiping   : true
        },

        animating: false,

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-switcher]", context).each(function() {
                    var switcher = UI.$(this);

                    if (!switcher.data("switcher")) {
                        var obj = UI.switcher(switcher, UI.Utils.options(switcher.attr("data-uk-switcher")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            this.on("click.uikit.switcher", this.options.toggle, function(e) {
                e.preventDefault();
                $this.show(this);
            });

            if (this.options.connect) {

                this.connect = UI.$(this.options.connect);

                this.connect.find(".uk-active").removeClass(".uk-active");

                // delegate switch commands within container content
                if (this.connect.length) {

                    // Init ARIA for connect
                    this.connect.children().attr('aria-hidden', 'true');

                    this.connect.on("click", '[data-uk-switcher-item]', function(e) {

                        e.preventDefault();

                        var item = UI.$(this).attr('data-uk-switcher-item');

                        if ($this.index == item) return;

                        switch(item) {
                            case 'next':
                            case 'previous':
                                $this.show($this.index + (item=='next' ? 1:-1));
                                break;
                            default:
                                $this.show(parseInt(item, 10));
                        }
                    });

                    if (this.options.swiping) {

                        this.connect.on('swipeRight swipeLeft', function(e) {
                            e.preventDefault();
                            if(!window.getSelection().toString()) {
                                $this.show($this.index + (e.type == 'swipeLeft' ? 1 : -1));
                            }
                        });
                    }
                }

                var toggles = this.find(this.options.toggle),
                    active  = toggles.filter(".uk-active");

                if (active.length) {
                    this.show(active, false);
                } else {

                    if (this.options.active===false) return;

                    active = toggles.eq(this.options.active);
                    this.show(active.length ? active : toggles.eq(0), false);
                }

                // Init ARIA for toggles
                toggles.not(active).attr('aria-expanded', 'false');
                active.attr('aria-expanded', 'true');

                this.on('changed.uk.dom', function() {
                    $this.connect = UI.$($this.options.connect);
                });
            }

        },

        show: function(tab, animate) {

            if (this.animating) {
                return;
            }

            if (isNaN(tab)) {
                tab = UI.$(tab);
            } else {

                var toggles = this.find(this.options.toggle);

                tab = tab < 0 ? toggles.length-1 : tab;
                tab = toggles.eq(toggles[tab] ? tab : 0);
            }

            var $this     = this,
                toggles   = this.find(this.options.toggle),
                active    = UI.$(tab),
                animation = Animations[this.options.animation] || function(current, next) {

                    if (!$this.options.animation) {
                        return Animations.none.apply($this);
                    }

                    var anim = $this.options.animation.split(',');

                    if (anim.length == 1) {
                        anim[1] = anim[0];
                    }

                    anim[0] = anim[0].trim();
                    anim[1] = anim[1].trim();

                    return coreAnimation.apply($this, [anim, current, next]);
                };

            if (animate===false || !UI.support.animation) {
                animation = Animations.none;
            }

            if (active.hasClass("uk-disabled")) return;

            // Update ARIA for Toggles
            toggles.attr('aria-expanded', 'false');
            active.attr('aria-expanded', 'true');

            toggles.filter(".uk-active").removeClass("uk-active");
            active.addClass("uk-active");

            if (this.options.connect && this.connect.length) {

                this.index = this.find(this.options.toggle).index(active);

                if (this.index == -1 ) {
                    this.index = 0;
                }

                this.connect.each(function() {

                    var container = UI.$(this),
                        children  = UI.$(container.children()),
                        current   = UI.$(children.filter('.uk-active')),
                        next      = UI.$(children.eq($this.index));

                        $this.animating = true;

                        animation.apply($this, [current, next]).then(function(){

                            current.removeClass("uk-active");
                            next.addClass("uk-active");

                            // Update ARIA for connect
                            current.attr('aria-hidden', 'true');
                            next.attr('aria-hidden', 'false');

                            UI.Utils.checkDisplay(next, true);

                            $this.animating = false;

                        });
                });
            }

            this.trigger("show.uk.switcher", [active]);
        }
    });

    Animations = {

        'none': function() {
            var d = UI.$.Deferred();
            d.resolve();
            return d.promise();
        },

        'fade': function(current, next) {
            return coreAnimation.apply(this, ['uk-animation-fade', current, next]);
        },

        'slide-bottom': function(current, next) {
            return coreAnimation.apply(this, ['uk-animation-slide-bottom', current, next]);
        },

        'slide-top': function(current, next) {
            return coreAnimation.apply(this, ['uk-animation-slide-top', current, next]);
        },

        'slide-vertical': function(current, next, dir) {

            var anim = ['uk-animation-slide-top', 'uk-animation-slide-bottom'];

            if (current && current.index() > next.index()) {
                anim.reverse();
            }

            return coreAnimation.apply(this, [anim, current, next]);
        },

        'slide-left': function(current, next) {
            return coreAnimation.apply(this, ['uk-animation-slide-left', current, next]);
        },

        'slide-right': function(current, next) {
            return coreAnimation.apply(this, ['uk-animation-slide-right', current, next]);
        },

        'slide-horizontal': function(current, next, dir) {

            var anim = ['uk-animation-slide-right', 'uk-animation-slide-left'];

            if (current && current.index() > next.index()) {
                anim.reverse();
            }

            return coreAnimation.apply(this, [anim, current, next]);
        },

        'scale': function(current, next) {
            return coreAnimation.apply(this, ['uk-animation-scale-up', current, next]);
        }
    };

    UI.switcher.animations = Animations;


    // helpers

    function coreAnimation(cls, current, next) {

        var d = UI.$.Deferred(), clsIn = cls, clsOut = cls, release;

        if (next[0]===current[0]) {
            d.resolve();
            return d.promise();
        }

        if (typeof(cls) == 'object') {
            clsIn  = cls[0];
            clsOut = cls[1] || cls[0];
        }

        UI.$body.css('overflow-x', 'hidden'); // fix scroll jumping in iOS

        release = function() {

            if (current) current.hide().removeClass('uk-active '+clsOut+' uk-animation-reverse');

            next.addClass(clsIn).one(UI.support.animation.end, function() {

                next.removeClass(''+clsIn+'').css({opacity:'', display:''});

                d.resolve();

                UI.$body.css('overflow-x', '');

                if (current) current.css({opacity:'', display:''});

            }.bind(this)).show();
        };

        next.css('animation-duration', this.options.duration+'ms');

        if (current && current.length) {

            current.css('animation-duration', this.options.duration+'ms');

            current.css('display', 'none').addClass(clsOut+' uk-animation-reverse').one(UI.support.animation.end, function() {
                release();
            }.bind(this)).css('display', '');

        } else {
            next.addClass('uk-active');
            release();
        }

        return d.promise();
    }

})(UIkit);

(function(UI) {

    "use strict";

    UI.component('tab', {

        defaults: {
            'target'    : '>li:not(.uk-tab-responsive, .uk-disabled)',
            'connect'   : false,
            'active'    : 0,
            'animation' : false,
            'duration'  : 200,
            'swiping'   : true
        },

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-tab]", context).each(function() {

                    var tab = UI.$(this);

                    if (!tab.data("tab")) {
                        var obj = UI.tab(tab, UI.Utils.options(tab.attr("data-uk-tab")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            this.current = false;

            this.on("click.uikit.tab", this.options.target, function(e) {

                e.preventDefault();

                if ($this.switcher && $this.switcher.animating) {
                    return;
                }

                var current = $this.find($this.options.target).not(this);

                current.removeClass("uk-active").blur();

                $this.trigger("change.uk.tab", [UI.$(this).addClass("uk-active"), $this.current]);

                $this.current = UI.$(this);

                // Update ARIA
                if (!$this.options.connect) {
                    current.attr('aria-expanded', 'false');
                    UI.$(this).attr('aria-expanded', 'true');
                }
            });

            if (this.options.connect) {
                this.connect = UI.$(this.options.connect);
            }

            // init responsive tab
            this.responsivetab = UI.$('<li class="uk-tab-responsive uk-active"><a></a></li>').append('<div class="uk-dropdown uk-dropdown-small"><ul class="uk-nav uk-nav-dropdown"></ul><div>');

            this.responsivetab.dropdown = this.responsivetab.find('.uk-dropdown');
            this.responsivetab.lst      = this.responsivetab.dropdown.find('ul');
            this.responsivetab.caption  = this.responsivetab.find('a:first');

            if (this.element.hasClass("uk-tab-bottom")) this.responsivetab.dropdown.addClass("uk-dropdown-up");

            // handle click
            this.responsivetab.lst.on('click.uikit.tab', 'a', function(e) {

                e.preventDefault();
                e.stopPropagation();

                var link = UI.$(this);

                $this.element.children('li:not(.uk-tab-responsive)').eq(link.data('index')).trigger('click');
            });

            this.on('show.uk.switcher change.uk.tab', function(e, tab) {
                $this.responsivetab.caption.html(tab.text());
            });

            this.element.append(this.responsivetab);

            // init UIkit components
            if (this.options.connect) {
                this.switcher = UI.switcher(this.element, {
                    'toggle'    : '>li:not(.uk-tab-responsive)',
                    'connect'   : this.options.connect,
                    'active'    : this.options.active,
                    'animation' : this.options.animation,
                    'duration'  : this.options.duration,
                    'swiping'   : this.options.swiping
                });
            }

            UI.dropdown(this.responsivetab, {"mode": "click"});

            // init
            $this.trigger("change.uk.tab", [this.element.find(this.options.target).not('.uk-tab-responsive').filter('.uk-active')]);

            this.check();

            UI.$win.on('resize orientationchange', UI.Utils.debounce(function(){
                if ($this.element.is(":visible"))  $this.check();
            }, 100));

            this.on('display.uk.check', function(){
                if ($this.element.is(":visible"))  $this.check();
            });
        },

        check: function() {

            var children = this.element.children('li:not(.uk-tab-responsive)').removeClass('uk-hidden');

            if (!children.length) {
                this.responsivetab.addClass('uk-hidden');
                return;
            }

            var top          = (children.eq(0).offset().top + Math.ceil(children.eq(0).height()/2)),
                doresponsive = false,
                item, link, clone;

            this.responsivetab.lst.empty();

            children.each(function(){

                if (UI.$(this).offset().top > top) {
                    doresponsive = true;
                }
            });

            if (doresponsive) {

                for (var i = 0; i < children.length; i++) {

                    item  = UI.$(children.eq(i));
                    link  = item.find('a');

                    if (item.css('float') != 'none' && !item.attr('uk-dropdown')) {

                        if (!item.hasClass('uk-disabled')) {

                            clone = item[0].outerHTML.replace('<a ', '<a data-index="'+i+'" ');

                            this.responsivetab.lst.append(clone);
                        }

                        item.addClass('uk-hidden');
                    }
                }
            }

            this.responsivetab[this.responsivetab.lst.children('li').length ? 'removeClass':'addClass']('uk-hidden');
        }
    });

})(UIkit);

(function(UI){

    "use strict";

    UI.component('cover', {

        defaults: {
            automute : true
        },

        boot: function() {

            // auto init
            UI.ready(function(context) {

                UI.$("[data-uk-cover]", context).each(function(){

                    var ele = UI.$(this);

                    if(!ele.data("cover")) {
                        var plugin = UI.cover(ele, UI.Utils.options(ele.attr("data-uk-cover")));
                    }
                });
            });
        },

        init: function() {

            this.parent = this.element.parent();

            UI.$win.on('load resize orientationchange', UI.Utils.debounce(function(){
                this.check();
            }.bind(this), 100));

            this.on("display.uk.check", function(e) {
                if(this.element.is(":visible")) this.check();
            }.bind(this));

            this.check();

            if (this.element.is('iframe') && this.options.automute) {

                var src = this.element.attr('src');

                this.element.attr('src', '').on('load', function(){

                    this.contentWindow.postMessage('{ "event": "command", "func": "mute", "method":"setVolume", "value":0}', '*');

                }).attr('src', [src, (src.indexOf('?') > -1 ? '&':'?'), 'enablejsapi=1&api=1'].join(''));
            }
        },

        check: function() {

            this.element.css({
                'width'  : '',
                'height' : ''
            });

            this.dimension = {w: this.element.width(), h: this.element.height()};

            if (this.element.attr('width') && !isNaN(this.element.attr('width'))) {
                this.dimension.w = this.element.attr('width');
            }

            if (this.element.attr('height') && !isNaN(this.element.attr('height'))) {
                this.dimension.h = this.element.attr('height');
            }

            this.ratio     = this.dimension.w / this.dimension.h;

            var w = this.parent.width(), h = this.parent.height(), width, height;

            // if element height < parent height (gap underneath)
            if ((w / this.ratio) < h) {

                width  = Math.ceil(h * this.ratio);
                height = h;

            // element width < parent width (gap to right)
            } else {

                width  = w;
                height = Math.ceil(w / this.ratio);
            }

            this.element.css({
                'width'  : width,
                'height' : height
            });
        }
    });

})(UIkit);

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {
    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-accordion", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }
})(function(UI){

    "use strict";

    UI.component('accordion', {

        defaults: {
            showfirst  : true,
            collapse   : true,
            animate    : true,
            easing     : 'swing',
            duration   : 300,
            toggle     : '.uk-accordion-title',
            containers : '.uk-accordion-content',
            clsactive  : 'uk-active'
        },

        boot:  function() {

            // init code
            UI.ready(function(context) {

                setTimeout(function(){

                    UI.$("[data-uk-accordion]", context).each(function(){

                        var ele = UI.$(this);

                        if(!ele.data("accordion")) {
                            UI.accordion(ele, UI.Utils.options(ele.attr('data-uk-accordion')));
                        }
                    });

                }, 0);
            });
        },

        init: function() {

            var $this = this;

            this.element.on('click.uikit.accordion', this.options.toggle, function(e) {

                e.preventDefault();

                $this.toggleItem(UI.$(this).data('wrapper'), $this.options.animate, $this.options.collapse);
            });

            this.update();

            if (this.options.showfirst) {
                this.toggleItem(this.toggle.eq(0).data('wrapper'), false, false);
            }
        },

        toggleItem: function(wrapper, animated, collapse) {

            var $this = this;

            wrapper.data('toggle').toggleClass(this.options.clsactive);
            wrapper.data('content').toggleClass(this.options.clsactive);

            var active = wrapper.data('toggle').hasClass(this.options.clsactive);

            if (collapse) {
                this.toggle.not(wrapper.data('toggle')).removeClass(this.options.clsactive);
                this.content.not(wrapper.data('content')).removeClass(this.options.clsactive)
                    .parent().stop().css('overflow', 'hidden').animate({ height: 0 }, {easing: this.options.easing, duration: animated ? this.options.duration : 0}).attr('aria-expanded', 'false');
            }

            wrapper.stop().css('overflow', 'hidden');

            if (animated) {

                wrapper.animate({ height: active ? getHeight(wrapper.data('content')) : 0 }, {easing: this.options.easing, duration: this.options.duration, complete: function() {

                    if (active) {
                        wrapper.css({'overflow': '', 'height': 'auto'});
                        UI.Utils.checkDisplay(wrapper.data('content'));
                    }

                    $this.trigger('display.uk.check');
                }});

            } else {

                wrapper.height(active ? 'auto' : 0);

                if (active) {
                    wrapper.css({'overflow': ''});
                    UI.Utils.checkDisplay(wrapper.data('content'));
                }

                this.trigger('display.uk.check');
            }

            // Update ARIA
            wrapper.attr('aria-expanded', active);

            this.element.trigger('toggle.uk.accordion', [active, wrapper.data('toggle'), wrapper.data('content')]);
        },

        update: function() {

            var $this = this, $content, $wrapper, $toggle;

            this.toggle = this.find(this.options.toggle);
            this.content = this.find(this.options.containers);

            this.content.each(function(index) {

                $content = UI.$(this);

                if ($content.parent().data('wrapper')) {
                    $wrapper = $content.parent();
                } else {
                    $wrapper = UI.$(this).wrap('<div data-wrapper="true" style="overflow:hidden;height:0;position:relative;"></div>').parent();

                    // Init ARIA
                    $wrapper.attr('aria-expanded', 'false');
                }

                $toggle = $this.toggle.eq(index);

                $wrapper.data('toggle', $toggle);
                $wrapper.data('content', $content);
                $toggle.data('wrapper', $wrapper);
                $content.data('wrapper', $wrapper);
            });

            this.element.trigger('update.uk.accordion', [this]);
        }

    });

    // helper

    function getHeight(ele) {

        var $ele = UI.$(ele), height = "auto";

        if ($ele.is(":visible")) {
            height = $ele.outerHeight();
        } else {

            var tmp = {
                position   : $ele.css("position"),
                visibility : $ele.css("visibility"),
                display    : $ele.css("display")
            };

            height = $ele.css({position: 'absolute', visibility: 'hidden', display: 'block'}).outerHeight();

            $ele.css(tmp); // reset element
        }

        return height;
    }

    return UI.accordion;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-autocomplete", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    var active;

    UI.component('autocomplete', {

        defaults: {
            minLength: 3,
            param: 'search',
            method: 'post',
            delay: 300,
            loadingClass: 'uk-loading',
            flipDropdown: false,
            skipClass: 'uk-skip',
            hoverClass: 'uk-active',
            source: null,
            renderer: null,

            // template

            template: '<ul class="uk-nav uk-nav-autocomplete uk-autocomplete-results">{{~items}}<li data-value="{{$item.value}}"><a>{{$item.value}}</a></li>{{/items}}</ul>'
        },

        visible  : false,
        value    : null,
        selected : null,

        boot: function() {

            // init code
            UI.$html.on("focus.autocomplete.uikit", "[data-uk-autocomplete]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("autocomplete")) {
                    UI.autocomplete(ele, UI.Utils.options(ele.attr("data-uk-autocomplete")));
                }
            });

            // register outer click for autocompletes
            UI.$html.on("click.autocomplete.uikit", function(e) {
                if (active && e.target!=active.input[0]) active.hide();
            });
        },

        init: function() {

            var $this   = this,
                select  = false,
                trigger = UI.Utils.debounce(function(e) {
                    if(select) {
                        return (select = false);
                    }
                    $this.handle();
                }, this.options.delay);


            this.dropdown = this.find('.uk-dropdown');
            this.template = this.find('script[type="text/autocomplete"]').html();
            this.template = UI.Utils.template(this.template || this.options.template);
            this.input    = this.find("input:first").attr("autocomplete", "off");

            if (!this.dropdown.length) {
               this.dropdown = UI.$('<div class="uk-dropdown"></div>').appendTo(this.element);
            }

            if (this.options.flipDropdown) {
                this.dropdown.addClass('uk-dropdown-flip');
            }

            this.dropdown.attr('aria-expanded', 'false');

            this.input.on({
                "keydown": function(e) {

                    if (e && e.which && !e.shiftKey) {

                        switch (e.which) {
                            case 13: // enter
                                select = true;

                                if ($this.selected) {
                                    e.preventDefault();
                                    $this.select();
                                }
                                break;
                            case 38: // up
                                e.preventDefault();
                                $this.pick('prev', true);
                                break;
                            case 40: // down
                                e.preventDefault();
                                $this.pick('next', true);
                                break;
                            case 27:
                            case 9: // esc, tab
                                $this.hide();
                                break;
                            default:
                                break;
                        }
                    }

                },
                "keyup": trigger
            });

            this.dropdown.on("click", ".uk-autocomplete-results > *", function(){
                $this.select();
            });

            this.dropdown.on("mouseover", ".uk-autocomplete-results > *", function(){
                $this.pick(UI.$(this));
            });

            this.triggercomplete = trigger;
        },

        handle: function() {

            var $this = this, old = this.value;

            this.value = this.input.val();

            if (this.value.length < this.options.minLength) return this.hide();

            if (this.value != old) {
                $this.request();
            }

            return this;
        },

        pick: function(item, scrollinview) {

            var $this    = this,
                items    = UI.$(this.dropdown.find('.uk-autocomplete-results').children(':not(.'+this.options.skipClass+')')),
                selected = false;

            if (typeof item !== "string" && !item.hasClass(this.options.skipClass)) {
                selected = item;
            } else if (item == 'next' || item == 'prev') {

                if (this.selected) {
                    var index = items.index(this.selected);

                    if (item == 'next') {
                        selected = items.eq(index + 1 < items.length ? index + 1 : 0);
                    } else {
                        selected = items.eq(index - 1 < 0 ? items.length - 1 : index - 1);
                    }

                } else {
                    selected = items[(item == 'next') ? 'first' : 'last']();
                }

                selected = UI.$(selected);
            }

            if (selected && selected.length) {
                this.selected = selected;
                items.removeClass(this.options.hoverClass);
                this.selected.addClass(this.options.hoverClass);

                // jump to selected if not in view
                if (scrollinview) {

                    var top       = selected.position().top,
                        scrollTop = $this.dropdown.scrollTop(),
                        dpheight  = $this.dropdown.height();

                    if (top > dpheight ||  top < 0) {
                        $this.dropdown.scrollTop(scrollTop + top);
                    }
                }
            }
        },

        select: function() {

            if(!this.selected) return;

            var data = this.selected.data();

            this.trigger("selectitem.uk.autocomplete", [data, this]);

            if (data.value) {
                this.input.val(data.value).trigger('change');
            }

            this.hide();
        },

        show: function() {
            if (this.visible) return;
            this.visible = true;
            this.element.addClass("uk-open");

            if (active && active!==this) {
                active.hide();
            }

            active = this;

            // Update aria
            this.dropdown.attr('aria-expanded', 'true');

            return this;
        },

        hide: function() {
            if (!this.visible) return;
            this.visible = false;
            this.element.removeClass("uk-open");

            if (active === this) {
                active = false;
            }

            // Update aria
            this.dropdown.attr('aria-expanded', 'false');

            return this;
        },

        request: function() {

            var $this   = this,
                release = function(data) {

                    if(data) {
                        $this.render(data);
                    }

                    $this.element.removeClass($this.options.loadingClass);
                };

            this.element.addClass(this.options.loadingClass);

            if (this.options.source) {

                var source = this.options.source;

                switch(typeof(this.options.source)) {
                    case 'function':

                        this.options.source.apply(this, [release]);

                        break;

                    case 'object':

                        if(source.length) {

                            var items = [];

                            source.forEach(function(item){
                                if(item.value && item.value.toLowerCase().indexOf($this.value.toLowerCase())!=-1) {
                                    items.push(item);
                                }
                            });

                            release(items);
                        }

                        break;

                    case 'string':

                        var params ={};

                        params[this.options.param] = this.value;

                        UI.$.ajax({
                            url: this.options.source,
                            data: params,
                            type: this.options.method,
                            dataType: 'json'
                        }).done(function(json) {
                            release(json || []);
                        });

                        break;

                    default:
                        release(null);
                }

            } else {
                this.element.removeClass($this.options.loadingClass);
            }
        },

        render: function(data) {

            this.dropdown.empty();

            this.selected = false;

            if (this.options.renderer) {

                this.options.renderer.apply(this, [data]);

            } else if(data && data.length) {

                this.dropdown.append(this.template({"items":data}));
                this.show();

                this.trigger('show.uk.autocomplete');
            }

            return this;
        }
    });

    return UI.autocomplete;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
// removed moment_js from core
// customized by tzd

(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-datepicker", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    // Datepicker

    var active = false, dropdown;

    UI.component('datepicker', {

        defaults: {
            mobile: false,
            weekstart: 1,
            i18n: {
                months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
                weekdays      : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
            },
            format: "DD.MM.YYYY",
            offsettop: 5,
            maxDate: false,
            minDate: false,
            pos: 'auto',
            addClass: '',
            template: function(data, opts) {

                var content = '', i;

                content += '<div class="uk-datepicker-nav uk-clearfix">';
                content += '<a href="" class="uk-datepicker-previous"></a>';
                content += '<a href="" class="uk-datepicker-next"></a>';

                if (UI.formSelect) {

                    var currentyear = (new Date()).getFullYear(), options = [], months, years, minYear, maxYear;

                    for (i=0;i<opts.i18n.months.length;i++) {
                        if(i==data.month) {
                            options.push('<option value="'+i+'" selected>'+opts.i18n.months[i]+'</option>');
                        } else {
                            options.push('<option value="'+i+'">'+opts.i18n.months[i]+'</option>');
                        }
                    }

                    months = '<span class="uk-form-select">'+ opts.i18n.months[data.month] + '<select class="update-picker-month">'+options.join('')+'</select></span>';

                    // --

                    options = [];

                    minYear = data.minDate ? data.minDate.year() : currentyear - 50;
                    maxYear = data.maxDate ? data.maxDate.year() : currentyear + 20;

                    for (i=minYear;i<=maxYear;i++) {
                        if (i == data.year) {
                            options.push('<option value="'+i+'" selected>'+i+'</option>');
                        } else {
                            options.push('<option value="'+i+'">'+i+'</option>');
                        }
                    }

                    years  = '<span class="uk-form-select">'+ data.year + '<select class="update-picker-year">'+options.join('')+'</select></span>';

                    content += '<div class="uk-datepicker-heading">'+ months + ' ' + years +'</div>';

                } else {
                    content += '<div class="uk-datepicker-heading">'+ opts.i18n.months[data.month] +' '+ data.year+'</div>';
                }

                content += '</div>';

                content += '<table class="uk-datepicker-table">';
                content += '<thead>';
                for(i = 0; i < data.weekdays.length; i++) {
                    if (data.weekdays[i]) {
                        content += '<th>'+data.weekdays[i]+'</th>';
                    }
                }
                content += '</thead>';

                content += '<tbody>';
                for(i = 0; i < data.days.length; i++) {
                    if (data.days[i] && data.days[i].length){
                        content += '<tr>';
                        for(var d = 0; d < data.days[i].length; d++) {
                            if (data.days[i][d]) {
                                var day = data.days[i][d],
                                    cls = [];

                                if(!day.inmonth) cls.push("uk-datepicker-table-muted");
                                if(day.selected) cls.push("uk-active");
                                if(day.disabled) cls.push('uk-datepicker-date-disabled uk-datepicker-table-muted');

                                content += '<td><a href="" class="'+cls.join(" ")+'" data-date="'+day.day.format()+'">'+day.day.format("D")+'</a></td>';
                            }
                        }
                        content += '</tr>';
                    }
                }
                content += '</tbody>';

                content += '</table>';

                return content;
            }
        },

        boot: function() {

            UI.$win.on("resize orientationchange", function() {

                if (active) {
                    active.hide();
                }
            });

            // init code
            UI.$html.on("focus.datepicker.uikit", "[data-uk-datepicker]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("datepicker")) {
                    e.preventDefault();
                    UI.datepicker(ele, UI.Utils.options(ele.attr("data-uk-datepicker")));
                    ele.trigger("focus");
                }
            });

            UI.$html.on("click focus", '*', function(e) {

                var target = UI.$(e.target);

                if (active && target[0] != dropdown[0] && !target.data("datepicker") && !target.parents(".uk-datepicker:first").length) {
                    active.hide();
                }
            });
        },

        init: function() {

            // use native datepicker on touch devices
            if (UI.support.touch && this.element.attr('type')=='date' && !this.options.mobile) {
                return;
            }

            var $this = this;

            this.current  = this.element.val() ? moment(this.element.val(), this.options.format) : moment();

            this.on("click focus", function(){
                if (active!==$this) $this.pick(this.value ? this.value:($this.options.minDate ? $this.options.minDate :''));
            }).on("change", function(){
                if ($this.element.val() && !moment($this.element.val(), $this.options.format).isValid()) {
                    $this.element.val(moment().format($this.options.format));
                }
            });

            // init dropdown
            if (!dropdown) {

                dropdown = UI.$('<div class="uk-dropdown uk-datepicker '+$this.options.addClass+'"></div>');

                dropdown.on("click", ".uk-datepicker-next, .uk-datepicker-previous, [data-date]", function(e){

                    e.stopPropagation();
                    e.preventDefault();

                    var ele = UI.$(this);

                    if (ele.hasClass('uk-datepicker-date-disabled')) return false;

                    if (ele.is('[data-date]')) {
                        active.current = moment(ele.data("date"));
                        active.element.val(active.current.format(active.options.format)).trigger("change");
                        dropdown.removeClass('uk-dropdown-shown');
                        setTimeout(function() {
                            dropdown.removeClass('uk-dropdown-active')
                        },280);
                        active.hide();
                    } else {
                        active.add((ele.hasClass("uk-datepicker-next") ? 1:-1), "months");
                    }
                });

                dropdown.on('change', '.update-picker-month, .update-picker-year', function(){

                    var select = UI.$(this);
                    active[select.is('.update-picker-year') ? 'setYear':'setMonth'](Number(select.val()));
                });

                dropdown.appendTo("body");
            }
        },

        pick: function(initdate) {

            var offset = this.element.offset(),
                offset_left = parseInt(offset.left),
                offset_top = parseInt(offset.top),
                css = {
                    'left': offset_left,
                    'right': ""
                };

            this.current  = isNaN(initdate) ? moment(initdate, this.options.format):moment();
            this.initdate = this.current.format("YYYY-MM-DD");

            this.update();

            if (UI.langdirection == 'right' || ( window.innerWidth - offset_left - dropdown.outerWidth() < 0 ) ) {
                css.right = (window.innerWidth - (window.innerWidth - $('body').width())) - (css.left + this.element.outerWidth());
                css.left  = "";
            }

            var posTop    = (offset_top - this.element.outerHeight() + this.element.height()) - this.options.offsettop - dropdown.outerHeight(),
                posBottom = offset_top + this.element.outerHeight() + this.options.offsettop;

            css.top = posBottom;

            if (this.options.pos == 'top') {
                css.top = posTop;
                dropdown.addClass('dp-top');
            } else if(this.options.pos == 'auto' && (window.innerHeight - posBottom - dropdown.outerHeight() + UI.$win.scrollTop() < 0 && posTop >= 0) ) {
                css.top = posTop;
                dropdown.addClass('dp-top');
            }

            css.minWidth = dropdown.actual('outerWidth');

            dropdown.css(css).addClass('uk-dropdown-active uk-dropdown-shown');

            this.trigger('show.uk.datepicker');

            active = this;
        },

        add: function(unit, value) {
            this.current.add(unit, value);
            this.update();
        },

        setMonth: function(month) {
            this.current.month(month);
            this.update();
        },

        setYear: function(year) {
            this.current.year(year);
            this.update();
        },

        update: function() {

            var data = this.getRows(this.current.year(), this.current.month()),
                tpl  = this.options.template(data, this.options);

            dropdown.html(tpl);

            this.trigger('update.uk.datepicker');
        },

        getRows: function(year, month) {

            var opts   = this.options,
                now    = moment().format('YYYY-MM-DD'),
                days   = [31, (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month],
                before = new Date(year, month, 1, 12).getDay(),
                data   = {"month":month, "year":year,"weekdays":[],"days":[], "maxDate": false, "minDate": false},
                row    = [];

            if (opts.maxDate!==false){
                data.maxDate = isNaN(opts.maxDate) ? moment(opts.maxDate, opts.format) : moment().add(opts.maxDate, 'days');
            }

            if (opts.minDate!==false){
                data.minDate = isNaN(opts.minDate) ? moment(opts.minDate, opts.format) : moment().add(opts.minDate-1, 'days');
            }

            data.weekdays = (function(){

                for (var i=0, arr=[]; i < 7; i++) {

                    var day = i + (opts.weekstart || 0);

                    while (day >= 7) {
                        day -= 7;
                    }

                    arr.push(opts.i18n.weekdays[day]);
                }

                return arr;
            })();

            if (opts.weekstart && opts.weekstart > 0) {
                before -= opts.weekstart;
                if (before < 0) {
                    before += 7;
                }
            }

            var cells = days + before, after = cells;

            while(after > 7) { after -= 7; }

            cells += 7 - after;

            var day, isDisabled, isSelected, isToday, isInMonth;

            for (var i = 0, r = 0; i < cells; i++) {

                day        = new Date(year, month, 1 + (i - before), 12);
                isDisabled = (data.minDate && data.minDate > day) || (data.maxDate && day > data.maxDate);
                isInMonth  = !(i < before || i >= (days + before));

                day = moment(day);

                isSelected = this.initdate == day.format("YYYY-MM-DD");
                isToday    = now == day.format("YYYY-MM-DD");

                row.push({"selected": isSelected, "today": isToday, "disabled": isDisabled, "day":day, "inmonth":isInMonth});

                if (++r === 7) {
                    data.days.push(row);
                    row = [];
                    r = 0;
                }
            }

            return data;
        },

        hide: function() {

            if (active && active === this) {
                dropdown.removeClass('uk-dropdown-shown');
                setTimeout(function() {
                    dropdown.removeClass('uk-dropdown-active dp-top')
                },280);
                active = false;
                this.trigger('hide.uk.datepicker');
            }
        }
    });

    UI.Utils.moment = moment();

    return UI.datepicker;
});
/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-form-password", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    UI.component('formPassword', {

        defaults: {
            "lblShow": "Mostrar",
            "lblHide": "Esconder"
        },

        boot: function() {
            // init code
            UI.$html.on("click.formpassword.uikit", "[data-uk-form-password]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("formPassword")) {

                    e.preventDefault();

                    UI.formPassword(ele, UI.Utils.options(ele.attr("data-uk-form-password")));
                    ele.trigger("click");
                }
            });
        },

        init: function() {

            var $this = this;

            this.on("click", function(e) {

                e.preventDefault();

                if($this.input.length) {
                    var type = $this.input.attr("type");
                    $this.input.attr("type", type=="text" ? "password":"text");
                    $this.element.html($this.options[type=="text" ? "lblShow":"lblHide"]);
                }
            });

            this.input = this.element.next("input").length ? this.element.next("input") : this.element.prev("input");
            this.element.html(this.options[this.input.is("[type='password']") ? "lblShow":"lblHide"]);


            this.element.data("formPassword", this);
        }
    });

    return UI.formPassword;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-form-select", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    UI.component('formSelect', {

        defaults: {
            'target': '>span:first',
            'activeClass': 'uk-active'
        },

        boot: function() {
            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-form-select]", context).each(function(){

                    var ele = UI.$(this);

                    if (!ele.data("formSelect")) {
                        UI.formSelect(ele, UI.Utils.options(ele.attr("data-uk-form-select")));
                    }
                });
            });
        },

        init: function() {
            var $this = this;

            this.target  = this.find(this.options.target);
            this.select  = this.find('select');

            // init + on change event
            this.select.on("change", (function(){

                var select = $this.select[0], fn = function(){

                    try {
                        $this.target.text(select.options[select.selectedIndex].text);
                    } catch(e) {}

                    $this.element[$this.select.val() ? 'addClass':'removeClass']($this.options.activeClass);

                    return fn;
                };

                return fn();
            })());

            this.element.data("formSelect", this);
        }
    });

    return UI.formSelect;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-grid", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    UI.component('grid', {

        defaults: {
            colwidth  : 'auto',
            animation : true,
            duration  : 300,
            gutter    : 0,
            controls  : false,
            filter    : false
        },

        boot:  function() {

            // init code
            UI.ready(function(context) {

                UI.$('[data-uk-grid]', context).each(function(){

                    var ele = UI.$(this);

                    if(!ele.data("grid")) {
                        UI.grid(ele, UI.Utils.options(ele.attr('data-uk-grid')));
                    }
                });
            });
        },

        init: function() {

            var $this = this, gutter = String(this.options.gutter).trim().split(' ');

            this.gutterv  = parseInt(gutter[0], 10);
            this.gutterh  = parseInt((gutter[1] || gutter[0]), 10);

            // make sure parent element has the right position property
            this.element.css({'position': 'relative'});

            this.controls = null;

            if (this.options.controls) {

                this.controls = UI.$(this.options.controls);

                // filter
                this.controls.on('click', '[data-uk-filter]', function(e){
                    e.preventDefault();
                    $this.filter(UI.$(this).data('ukFilter'));
                });

                // sort
                this.controls.on('click', '[data-uk-sort]', function(e){
                    e.preventDefault();
                    var cmd = UI.$(this).attr('data-uk-sort').split(':');
                    $this.sort(cmd[0], cmd[1]);
                });
            }

            UI.$win.on('load resize orientationchange', UI.Utils.debounce(function(){

                if ($this.currentfilter) {
                    $this.filter($this.currentfilter);
                } else {
                    this.updateLayout();
                }

            }.bind(this), 100));

            this.on('display.uk.check', function(){
                if ($this.element.is(":visible"))  $this.updateLayout();
            });

            UI.$html.on("changed.uk.dom", function(e) {
                $this.updateLayout();
            });

            if (this.options.filter !== false) {
                this.filter(this.options.filter);
            } else {
                this.updateLayout();
            }
        },

        _prepareElements: function() {

            var children = this.element.children(':not([data-grid-prepared])'), css;

            // exit if no already prepared elements found
            if (!children.length) {
                return;
            }

            css = {
                'position'   : 'absolute',
                'box-sizing' : 'border-box',
                'width'      : this.options.colwidth == 'auto' ? '' : this.options.colwidth
            };

            if (this.options.gutter) {

                css['padding-left']   = this.gutterh;
                css['padding-bottom'] = this.gutterv;

                this.element.css('margin-left', this.gutterh * -1);
            }

            children.attr('data-grid-prepared', 'true').css(css);
        },

        updateLayout: function(elements) {

            this._prepareElements();

            elements = elements || this.element.children(':visible');

            var children  = elements,
                maxwidth  = this.element.width() + (2*this.gutterh) + 2,
                left      = 0,
                top       = 0,
                positions = [],

                item, width, height, pos, i, z, max, size;

            this.trigger('beforeupdate.uk.grid', [children]);

            children.each(function(index){

                size   = getElementSize(this);

                item   = UI.$(this);
                width  = size.outerWidth;
                height = size.outerHeight;
                left   = 0;
                top    = 0;

                for (i=0,max=positions.length;i<max;i++) {

                    pos = positions[i];

                    if (left <= pos.aX) { left = pos.aX; }
                    if (maxwidth < (left + width)) { left = 0; }
                    if (top <= pos.aY) { top = pos.aY; }
                }

                positions.push({
                    "ele"    : item,
                    "top"    : top,
                    "left"   : left,
                    "width"  : width,
                    "height" : height,
                    "aY"     : (top  + height),
                    "aX"     : (left + width)
                });
            });

            var posPrev, maxHeight = 0;

            // fix top
            for (i=0,max=positions.length;i<max;i++) {

                pos = positions[i];
                top = 0;

                for (z=0;z<i;z++) {

                    posPrev = positions[z];

                    // (posPrev.left + 1) fixex 1px bug when using % based widths
                    if (pos.left < posPrev.aX && (posPrev.left +1) < pos.aX) {
                        top = posPrev.aY;
                    }
                }

                pos.top = top;
                pos.aY  = top + pos.height;

                maxHeight = Math.max(maxHeight, pos.aY);
            }

            maxHeight = maxHeight - this.gutterv;

            if (this.options.animation) {

                this.element.stop().animate({'height': maxHeight}, 100);

                positions.forEach(function(pos){
                    pos.ele.stop().animate({"top": pos.top, "left": pos.left, opacity: 1}, this.options.duration);
                }.bind(this));

            } else {

                this.element.css('height', maxHeight);

                positions.forEach(function(pos){
                    pos.ele.css({"top": pos.top, "left": pos.left, opacity: 1});
                }.bind(this));
            }

            // make sure to trigger possible scrollpies etc.
            setTimeout(function() {
                UI.$doc.trigger('scrolling.uk.document');
            }, 2 * this.options.duration * (this.options.animation ? 1:0));

            this.trigger('afterupdate.uk.grid', [children]);
        },

        filter: function(filter) {

            this.currentfilter = filter;

            filter = filter || [];

            if (typeof(filter) === 'number') {
                filter = filter.toString();
            }

            if (typeof(filter) === 'string') {
                filter = filter.split(/,/).map(function(item){ return item.trim(); });
            }

            var $this = this, children = this.element.children(), elements = {"visible": [], "hidden": []}, visible, hidden;

            children.each(function(index){

                var ele = UI.$(this), f = ele.attr('data-uk-filter'), infilter = filter.length ? false : true;

                if (f) {

                    f = f.split(/,/).map(function(item){ return item.trim(); });

                    filter.forEach(function(item){
                        if (f.indexOf(item) > -1) infilter = true;
                    });
                }

                elements[infilter ? "visible":"hidden"].push(ele);
            });

            // convert to jQuery collections
            elements.hidden  = UI.$(elements.hidden).map(function () {return this[0];});
            elements.visible = UI.$(elements.visible).map(function () {return this[0];});

            elements.hidden.attr('aria-hidden', 'true').filter(':visible').fadeOut(this.options.duration);
            elements.visible.attr('aria-hidden', 'false').filter(':hidden').css('opacity', 0).show();

            $this.updateLayout(elements.visible);

            if (this.controls && this.controls.length) {
                this.controls.find('[data-uk-filter]').removeClass('uk-active').filter('[data-uk-filter="'+filter+'"]').addClass('uk-active');
            }
        },

        sort: function(by, order){

            order = order || 1;

            // covert from string (asc|desc) to number
            if (typeof(order) === 'string') {
                order = order.toLowerCase() == 'desc' ? -1 : 1;
            }

            var elements = this.element.children();

            elements.sort(function(a, b){

                a = UI.$(a);
                b = UI.$(b);

                return (b.data(by) || '') < (a.data(by) || '') ? order : (order*-1);

            }).appendTo(this.element);

            this.updateLayout(elements.filter(':visible'));

            if (this.controls && this.controls.length) {
                this.controls.find('[data-uk-sort]').removeClass('uk-active').filter('[data-uk-sort="'+by+':'+(order == -1 ? 'desc':'asc')+'"]').addClass('uk-active');
            }
        }
    });


    /*!
    * getSize v1.2.2
    * measure size of elements
    * MIT license
    * https://github.com/desandro/get-size
    */
    var _getSize = (function(){

        var prefixes = 'Webkit Moz ms Ms O'.split(' ');
        var docElemStyle = document.documentElement.style;

        function getStyleProperty( propName ) {
            if ( !propName ) {
                return;
            }

            // test standard property first
            if ( typeof docElemStyle[ propName ] === 'string' ) {
                return propName;
            }

            // capitalize
            propName = propName.charAt(0).toUpperCase() + propName.slice(1);

            // test vendor specific properties
            var prefixed;
            for ( var i=0, len = prefixes.length; i < len; i++ ) {
                prefixed = prefixes[i] + propName;
                if ( typeof docElemStyle[ prefixed ] === 'string' ) {
                    return prefixed;
                }
            }
        }

        // -------------------------- helpers -------------------------- //

        // get a number from a string, not a percentage
        function getStyleSize( value ) {
            var num = parseFloat( value );
            // not a percent like '100%', and a number
            var isValid = value.indexOf('%') === -1 && !isNaN( num );
            return isValid && num;
        }

        function noop() {}

        var logError = typeof console === 'undefined' ? noop : function( message ) {
            console.error( message );
        };

        // -------------------------- measurements -------------------------- //

        var measurements = [
            'paddingLeft',
            'paddingRight',
            'paddingTop',
            'paddingBottom',
            'marginLeft',
            'marginRight',
            'marginTop',
            'marginBottom',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth',
            'borderBottomWidth'
        ];

        function getZeroSize() {
            var size = {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0,
                outerWidth: 0,
                outerHeight: 0
            };
            for ( var i=0, len = measurements.length; i < len; i++ ) {
                var measurement = measurements[i];
                size[ measurement ] = 0;
            }
            return size;
        }


        // -------------------------- setup -------------------------- //

        var isSetup = false;
        var getStyle, boxSizingProp, isBoxSizeOuter;

        /**
        * setup vars and functions
        * do it on initial getSize(), rather than on script load
        * For Firefox bug https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        */
        function setup() {
            // setup once
            if ( isSetup ) {
                return;
            }
            isSetup = true;

            var getComputedStyle = window.getComputedStyle;
            getStyle = ( function() {
                var getStyleFn = getComputedStyle ?
                function( elem ) {
                    return getComputedStyle( elem, null );
                } :
                function( elem ) {
                    return elem.currentStyle;
                };

                return function getStyle( elem ) {
                    var style = getStyleFn( elem );
                    if ( !style ) {
                        logError( 'Style returned ' + style +
                        '. Are you running this code in a hidden iframe on Firefox? ' +
                        'See http://bit.ly/getsizebug1' );
                    }
                    return style;
                };
            })();

            // -------------------------- box sizing -------------------------- //

            boxSizingProp = getStyleProperty('boxSizing');

            /**
            * WebKit measures the outer-width on style.width on border-box elems
            * IE & Firefox measures the inner-width
            */
            if ( boxSizingProp ) {
                var div = document.createElement('div');
                div.style.width = '200px';
                div.style.padding = '1px 2px 3px 4px';
                div.style.borderStyle = 'solid';
                div.style.borderWidth = '1px 2px 3px 4px';
                div.style[ boxSizingProp ] = 'border-box';

                var body = document.body || document.documentElement;
                body.appendChild( div );
                var style = getStyle( div );

                isBoxSizeOuter = getStyleSize( style.width ) === 200;
                body.removeChild( div );
            }

        }

        // -------------------------- getSize -------------------------- //

        function getSize( elem ) {
            setup();

            // use querySeletor if elem is string
            if ( typeof elem === 'string' ) {
                elem = document.querySelector( elem );
            }

            // do not proceed on non-objects
            if ( !elem || typeof elem !== 'object' || !elem.nodeType ) {
                return;
            }

            var style = getStyle( elem );

            // if hidden, everything is 0
            if ( style.display === 'none' ) {
                return getZeroSize();
            }

            var size = {};
            size.width = elem.offsetWidth;
            size.height = elem.offsetHeight;

            var isBorderBox = size.isBorderBox = !!( boxSizingProp &&
                style[ boxSizingProp ] && style[ boxSizingProp ] === 'border-box' );

            // get all measurements
            for ( var i=0, len = measurements.length; i < len; i++ ) {
                var measurement = measurements[i];
                var value = style[ measurement ];

                var num = parseFloat( value );
                // any 'auto', 'medium' value will be 0
                size[ measurement ] = !isNaN( num ) ? num : 0;
            }

            var paddingWidth = size.paddingLeft + size.paddingRight;
            var paddingHeight = size.paddingTop + size.paddingBottom;
            var marginWidth = size.marginLeft + size.marginRight;
            var marginHeight = size.marginTop + size.marginBottom;
            var borderWidth = size.borderLeftWidth + size.borderRightWidth;
            var borderHeight = size.borderTopWidth + size.borderBottomWidth;

            var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

            // overwrite width and height if we can get it from style
            var styleWidth = getStyleSize( style.width );
            if ( styleWidth !== false ) {
                size.width = styleWidth +
                // add padding and border unless it's already including it
                ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
            }

            var styleHeight = getStyleSize( style.height );
            if ( styleHeight !== false ) {
                size.height = styleHeight +
                // add padding and border unless it's already including it
                ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
            }

            size.innerWidth = size.width - ( paddingWidth + borderWidth );
            size.innerHeight = size.height - ( paddingHeight + borderHeight );

            size.outerWidth = size.width + marginWidth;
            size.outerHeight = size.height + marginHeight;

            return size;
        }

        return getSize;

    })();

    function getElementSize(ele) {
        return _getSize(ele);
    }
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) { // AMD
        define("uikit-lightbox", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    var modal, cache = {};

    UI.component('lightbox', {

        defaults: {
            "group"      : false,
            "duration"   : 400,
            "keyboard"   : true
        },

        index : 0,
        items : false,

        boot: function() {

            UI.$html.on('click', '[data-uk-lightbox]', function(e){

                e.preventDefault();

                var link = UI.$(this);

                if (!link.data("lightbox")) {

                    UI.lightbox(link, UI.Utils.options(link.attr("data-uk-lightbox")));
                }

                link.data("lightbox").show(link);
            });

            // keyboard navigation
            UI.$doc.on('keyup', function(e) {

                if (modal && modal.is(':visible') && modal.lightbox.options.keyboard) {

                    e.preventDefault();

                    switch(e.keyCode) {
                        case 37:
                            modal.lightbox.previous();
                            break;
                        case 39:
                            modal.lightbox.next();
                            break;
                    }
                }
            });
        },

        init: function() {

            var siblings = [];

            this.index    = 0;
            this.siblings = [];

            if (this.element && this.element.length) {

                var domSiblings  = this.options.group ? UI.$([
                    '[data-uk-lightbox*="'+this.options.group+'"]',
                    "[data-uk-lightbox*='"+this.options.group+"']"
                ].join(',')) : this.element;

                domSiblings.each(function() {

                    var ele = UI.$(this);

                    siblings.push({
                        'source': ele.attr('href'),
                        'title' : ele.attr('data-title') || ele.attr('title'),
                        'type'  : ele.attr("data-lightbox-type") || 'auto',
                        'link'  : ele
                    });
                });

                this.index    = domSiblings.index(this.element);
                this.siblings = siblings;

            } else if (this.options.group && this.options.group.length) {
                this.siblings = this.options.group;
            }

            this.trigger('lightbox-init', [this]);
        },

        show: function(index) {

            this.modal = getModal(this);

            // stop previous animation
            this.modal.dialog.stop();
            this.modal.content.stop();

            var $this = this, promise = UI.$.Deferred(), data, item;

            index = index || 0;

            // index is a jQuery object or DOM element
            if (typeof(index) == 'object') {

                this.siblings.forEach(function(s, idx){

                    if (index[0] === s.link[0]) {
                        index = idx;
                    }
                });
            }

            // fix index if needed
            if ( index < 0 ) {
                index = this.siblings.length - index;
            } else if (!this.siblings[index]) {
                index = 0;
            }

            item   = this.siblings[index];

            data = {
                "lightbox" : $this,
                "source"   : item.source,
                "type"     : item.type,
                "index"    : index,
                "promise"  : promise,
                "title"    : item.title,
                "item"     : item,
                "meta"     : {
                    "content" : '',
                    "width"   : null,
                    "height"  : null
                }
            };

            this.index = index;

            this.modal.content.empty();

            if (!this.modal.is(':visible')) {
                this.modal.content.css({width:'', height:''}).empty();
                this.modal.modal.show();
            }

            this.modal.loader.removeClass('uk-hidden');

            promise.promise().done(function() {

                $this.data = data;
                $this.fitSize(data);

            }).fail(function(){

                data.meta.content = '<div class="uk-position-cover uk-flex uk-flex-middle uk-flex-center"><strong>Loading resource failed!</strong></div>';
                data.meta.width   = 400;
                data.meta.height  = 300;

                $this.data = data;
                $this.fitSize(data);
            });

            $this.trigger('showitem.uk.lightbox', [data]);
        },

        fitSize: function() {

            var $this    = this,
                data     = this.data,
                pad      = this.modal.dialog.outerWidth() - this.modal.dialog.width(),
                dpadTop  = parseInt(this.modal.dialog.css('margin-top'), 10),
                dpadBot  = parseInt(this.modal.dialog.css('margin-bottom'), 10),
                dpad     = dpadTop + dpadBot,
                content  = data.meta.content,
                duration = $this.options.duration;

            if (this.siblings.length > 1) {

                content = [
                    content,
                    '<a href="#" class="uk-slidenav uk-slidenav-contrast uk-slidenav-previous uk-hidden-touch" data-lightbox-previous></a>',
                    '<a href="#" class="uk-slidenav uk-slidenav-contrast uk-slidenav-next uk-hidden-touch" data-lightbox-next></a>'
                ].join('');
            }

            // calculate width
            var tmp = UI.$('<div>&nbsp;</div>').css({
                'opacity'   : 0,
                'position'  : 'absolute',
                'top'       : 0,
                'left'      : 0,
                'width'     : '100%',
                'max-width' : $this.modal.dialog.css('max-width'),
                'padding'   : $this.modal.dialog.css('padding'),
                'margin'    : $this.modal.dialog.css('margin')
            }), maxwidth, maxheight, w = data.meta.width, h = data.meta.height;

            tmp.appendTo('body').width();

            maxwidth  = tmp.width();
            maxheight = window.innerHeight - dpad;

            tmp.remove();

            this.modal.dialog.find('.uk-modal-caption').remove();

            if (data.title) {
                this.modal.dialog.append('<div class="uk-modal-caption">'+data.title+'</div>');
                maxheight -= this.modal.dialog.find('.uk-modal-caption').outerHeight();
            }

            if (maxwidth < data.meta.width) {

                h = Math.floor( h * (maxwidth / w) );
                w = maxwidth;
            }

            if (maxheight < h) {

                h = Math.floor(maxheight);
                w = Math.ceil(data.meta.width * (maxheight/data.meta.height));
            }

            this.modal.content.css('opacity', 0).width(w).html(content);

            if (data.type == 'iframe') {
                this.modal.content.find('iframe:first').height(h);
            }

            var dh   = h + pad,
                t    = Math.floor(window.innerHeight/2 - dh/2) - dpad;

            if (t < 0) { t = 0; }

            this.modal.closer.addClass('uk-hidden');

            if ($this.modal.data('mwidth') == w &&  $this.modal.data('mheight') == h) {
                duration = 0;
            }

            this.modal.dialog.animate({width: w + pad, height: h + pad, top: t }, duration, 'swing', function() {
                $this.modal.loader.addClass('uk-hidden');
                $this.modal.content.css({width:''}).animate({'opacity': 1}, function() {
                    $this.modal.closer.removeClass('uk-hidden');
                });

                $this.modal.data({'mwidth': w, 'mheight': h});
            });
        },

        next: function() {
            this.show(this.siblings[(this.index+1)] ? (this.index+1) : 0);
        },

        previous: function() {
            this.show(this.siblings[(this.index-1)] ? (this.index-1) : this.siblings.length-1);
        }
    });


    // Plugins

    UI.plugin('lightbox', 'image', {

        init: function(lightbox) {

            lightbox.on("showitem.uk.lightbox", function(e, data){

                if (data.type == 'image' || data.source && data.source.match(/\.(jpg|jpeg|png|gif|svg)$/i)) {

                    var resolve = function(source, width, height) {

                        data.meta = {
                            "content" : '<img class="uk-responsive-width" width="'+width+'" height="'+height+'" src ="'+source+'">',
                            "width"   : width,
                            "height"  : height
                        };

                        data.type = 'image';

                        data.promise.resolve();
                    };

                    if (!cache[data.source]) {

                        var img = new Image();

                        img.onerror = function(){
                            data.promise.reject('Loading image failed');
                        };

                        img.onload = function(){
                            cache[data.source] = {width: img.width, height: img.height};
                            resolve(data.source, cache[data.source].width, cache[data.source].height);
                        };

                        img.src = data.source;

                    } else {
                        resolve(data.source, cache[data.source].width, cache[data.source].height);
                    }
                }
            });
        }
    });

    UI.plugin("lightbox", "youtube", {

        init: function(lightbox) {

            var youtubeRegExp = /(\/\/.*?youtube\.[a-z]+)\/watch\?v=([^&]+)&?(.*)/,
                youtubeRegExpShort = /youtu\.be\/(.*)/;


            lightbox.on("showitem.uk.lightbox", function(e, data){

                var id, matches, resolve = function(id, width, height) {

                    data.meta = {
                        'content': '<iframe src="//www.youtube.com/embed/'+id+'" width="'+width+'" height="'+height+'" style="max-width:100%;"></iframe>',
                        'width': width,
                        'height': height
                    };

                    data.type = 'iframe';

                    data.promise.resolve();
                };

                if (matches = data.source.match(youtubeRegExp)) {
                    id = matches[2];
                }

                if (matches = data.source.match(youtubeRegExpShort)) {
                    id = matches[1];
                }

                if (id) {

                    if(!cache[id]) {

                        var img = new Image(), lowres = false;

                        img.onerror = function(){
                            cache[id] = {width:640, height:320};
                            resolve(id, cache[id].width, cache[id].height);
                        };

                        img.onload = function(){
                            //youtube default 404 thumb, fall back to lowres
                            if (img.width == 120 && img.height == 90) {
                                if (!lowres) {
                                    lowres = true;
                                    img.src = '//img.youtube.com/vi/' + id + '/0.jpg';
                                } else {
                                    cache[id] = {width: 640, height: 320};
                                    resolve(id, cache[id].width, cache[id].height);
                                }
                            } else {
                                cache[id] = {width: img.width, height: img.height};
                                resolve(id, img.width, img.height);
                            }
                        };

                        img.src = '//img.youtube.com/vi/'+id+'/maxresdefault.jpg';

                    } else {
                        resolve(id, cache[id].width, cache[id].height);
                    }

                    e.stopImmediatePropagation();
                }
            });
        }
    });


    UI.plugin("lightbox", "vimeo", {

        init: function(lightbox) {

            var regex = /(\/\/.*?)vimeo\.[a-z]+\/([0-9]+).*?/, matches;


            lightbox.on("showitem.uk.lightbox", function(e, data){

                var id, resolve = function(id, width, height) {

                    data.meta = {
                        'content': '<iframe src="//player.vimeo.com/video/'+id+'" width="'+width+'" height="'+height+'" style="width:100%;box-sizing:border-box;"></iframe>',
                        'width': width,
                        'height': height
                    };

                    data.type = 'iframe';

                    data.promise.resolve();
                };

                if (matches = data.source.match(regex)) {

                    id = matches[2];

                    if(!cache[id]) {

                        UI.$.ajax({
                            type     : 'GET',
                            url      : 'http://vimeo.com/api/oembed.json?url=' + encodeURI(data.source),
                            jsonp    : 'callback',
                            dataType : 'jsonp',
                            success  : function(data) {
                                cache[id] = {width:data.width, height:data.height};
                                resolve(id, cache[id].width, cache[id].height);
                            }
                        });

                    } else {
                        resolve(id, cache[id].width, cache[id].height);
                    }

                    e.stopImmediatePropagation();
                }
            });
        }
    });

    UI.plugin("lightbox", "video", {

        init: function(lightbox) {

            lightbox.on("showitem.uk.lightbox", function(e, data){


                var resolve = function(source, width, height) {

                    data.meta = {
                        'content': '<video class="uk-responsive-width" src="'+source+'" width="'+width+'" height="'+height+'" controls></video>',
                        'width': width,
                        'height': height
                    };

                    data.type = 'video';

                    data.promise.resolve();
                };

                if (data.type == 'video' || data.source.match(/\.(mp4|webm|ogv)$/i)) {

                    if (!cache[data.source]) {

                        var vid = UI.$('<video style="position:fixed;visibility:hidden;top:-10000px;"></video>').attr('src', data.source).appendTo('body');

                        var idle = setInterval(function() {

                            if (vid[0].videoWidth) {
                                clearInterval(idle);
                                cache[data.source] = {width: vid[0].videoWidth, height: vid[0].videoHeight};
                                resolve(data.source, cache[data.source].width, cache[data.source].height);
                                vid.remove();
                            }

                        }, 20);

                    } else {
                        resolve(data.source, cache[data.source].width, cache[data.source].height);
                    }
                }
            });
        }
    });


    function getModal(lightbox) {

        if (modal) {
            modal.lightbox = lightbox;
            return modal;
        }

        // init lightbox container
        modal = UI.$([
            '<div class="uk-modal">',
                '<div class="uk-modal-dialog uk-modal-dialog-lightbox uk-slidenav-position" style="margin-left:auto;margin-right:auto;width:200px;height:200px;top:'+Math.abs(window.innerHeight/2 - 200)+'px;">',
                    '<a href="#" class="uk-modal-close uk-close uk-close-alt"></a>',
                    '<div class="uk-lightbox-content"></div>',
                    '<div class="uk-modal-spinner uk-hidden"></div>',
                '</div>',
            '</div>'
        ].join('')).appendTo('body');

        modal.dialog  = modal.find('.uk-modal-dialog:first');
        modal.content = modal.find('.uk-lightbox-content:first');
        modal.loader  = modal.find('.uk-modal-spinner:first');
        modal.closer  = modal.find('.uk-close.uk-close-alt');
        modal.modal   = UI.modal(modal, {modal:false});

        // next / previous
        modal.on("swipeRight swipeLeft", function(e) {
            modal.lightbox[e.type=='swipeLeft' ? 'next':'previous']();
        }).on("click", "[data-lightbox-previous], [data-lightbox-next]", function(e){
            e.preventDefault();
            modal.lightbox[UI.$(this).is('[data-lightbox-next]') ? 'next':'previous']();
        });

        // destroy content on modal hide
        modal.on("hide.uk.modal", function(e) {
            modal.content.html('');
        });

        UI.$win.on('load resize orientationchange', UI.Utils.debounce(function(e){
            if (modal.is(':visible') && !UI.Utils.isFullscreen()) modal.lightbox.fitSize();
        }.bind(this), 100));

        modal.lightbox = lightbox;

        return modal;
    }

    UI.lightbox.create = function(items, options) {

        if (!items) return;

        var group = [], o;

        items.forEach(function(item) {

            group.push(UI.$.extend({
                'source' : '',
                'title'  : '',
                'type'   : 'auto',
                'link'   : false
            }, (typeof(item) == 'string' ? {'source': item} : item)));
        });

        o = UI.lightbox(UI.$.extend({}, options, {'group':group}));

        return o;
    };

    return UI.lightbox;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
/*
 * Based on Nestable jQuery Plugin - Copyright (c) 2012 David Bushell - http://dbushell.com/
 */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-nestable", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI) {

    "use strict";

    var hasTouch     = 'ontouchstart' in window,
        html         = UI.$html,
        touchedlists = [],
        $win         = UI.$win,
        draggingElement;

    var eStart  = hasTouch ? 'touchstart'  : 'mousedown',
        eMove   = hasTouch ? 'touchmove'   : 'mousemove',
        eEnd    = hasTouch ? 'touchend'    : 'mouseup',
        eCancel = hasTouch ? 'touchcancel' : 'mouseup';


    UI.component('nestable', {

        defaults: {
            listBaseClass   : 'uk-nestable',
            listClass       : 'uk-nestable-list',
            listItemClass   : 'uk-nestable-item',
            dragClass       : 'uk-nestable-dragged',
            movingClass     : 'uk-nestable-moving',
            emptyClass      : 'uk-nestable-empty',
            handleClass     : '',
            collapsedClass  : 'uk-collapsed',
            placeholderClass: 'uk-nestable-placeholder',
            noDragClass     : 'uk-nestable-nodrag',
            group           : false,
            maxDepth        : 10,
            threshold       : 20,
            idlethreshold   : 10,
        },

        boot: function() {

            // adjust document scrolling
            UI.$html.on('mousemove touchmove', function(e) {

                if (draggingElement) {

                    var top = draggingElement.offset().top;

                    if (top < UI.$win.scrollTop()) {
                        UI.$win.scrollTop(UI.$win.scrollTop() - Math.ceil(draggingElement.height()/2));
                    } else if ( (top + draggingElement.height()) > (window.innerHeight + UI.$win.scrollTop()) ) {
                        UI.$win.scrollTop(UI.$win.scrollTop() + Math.ceil(draggingElement.height()/2));
                    }
                }
            });

            // init code
            UI.ready(function(context) {

                UI.$("[data-uk-nestable]", context).each(function(){

                    var ele = UI.$(this);

                    if (!ele.data("nestable")) {
                        UI.nestable(ele, UI.Utils.options(ele.attr("data-uk-nestable")));
                    }
                });
            });
        },

        init: function() {

            var $this = this;

            Object.keys(this.options).forEach(function(key){

                if(String(key).indexOf('Class')!=-1) {
                    $this.options['_'+key] = '.' + $this.options[key];
                }
            });

            this.find(this.options._listItemClass).find(">ul").addClass(this.options.listClass);

            this.checkEmptyList();

            this.reset();
            this.element.data('nestable-group', this.options.group || UI.Utils.uid('nestable-group'));

            this.find(this.options._listItemClass).each(function() {
                $this.setParent(UI.$(this));
            });

            this.on('click', '[data-nestable-action]', function(e) {

                if ($this.dragEl || (!hasTouch && e.button !== 0)) {
                    return;
                }

                e.preventDefault();

                var target = UI.$(e.currentTarget),
                    action = target.data('nestableAction'),
                    item   = target.closest($this.options._listItemClass);

                if (action === 'collapse') {
                    $this.collapseItem(item);
                }
                if (action === 'expand') {
                    $this.expandItem(item);
                }
                if (action === 'toggle') {
                    $this.toggleItem(item);
                }
            });

            var onStartEvent = function(e) {

                var handle = UI.$(e.target);

                if (e.target === $this.element[0]) {
                    return;
                }

                if (handle.is($this.options._noDragClass) || handle.closest($this.options._noDragClass).length) {
                    return;
                }

                if (handle.is('[data-nestable-action]') || handle.closest('[data-nestable-action]').length) {
                    return;
                }

                if ($this.options.handleClass && !handle.hasClass($this.options.handleClass)) {

                    if ($this.options.handleClass) {
                        handle = handle.closest($this.options._handleClass);
                    }
                }

                if (!handle.length || $this.dragEl || (!hasTouch && e.button !== 0) || (hasTouch && e.touches.length !== 1)) {
                    return;
                }

                if (e.originalEvent && e.originalEvent.touches) {
                    e = evt.originalEvent.touches[0];
                }

                $this.delayMove = function(evt) {

                    evt.preventDefault();
                    $this.dragStart(e);
                    $this.trigger('start.uk.nestable', [$this]);

                    $this.delayMove = false;
                };

                $this.delayMove.x         = parseInt(e.pageX, 10);
                $this.delayMove.y         = parseInt(e.pageY, 10);
                $this.delayMove.threshold = $this.options.idlethreshold;

                e.preventDefault();
            };

            var onMoveEvent = function(e) {

                if (e.originalEvent && e.originalEvent.touches) {
                    e = e.originalEvent.touches[0];
                }

                if ($this.delayMove && (Math.abs(e.pageX - $this.delayMove.x) > $this.delayMove.threshold || Math.abs(e.pageY - $this.delayMove.y) > $this.delayMove.threshold)) {

                    if (!window.getSelection().toString()) {
                        $this.delayMove(e);
                    } else {
                        $this.delayMove = false;
                    }
                }

                if ($this.dragEl) {
                    e.preventDefault();
                    $this.dragMove(e);
                    $this.trigger('move.uk.nestable', [$this]);
                }
            };

            var onEndEvent = function(e) {

                if ($this.dragEl) {
                    e.preventDefault();
                    $this.dragStop(hasTouch ? e.touches[0] : e);
                }

                draggingElement = false;
                $this.delayMove = false;
            };

            if (hasTouch) {
                this.element[0].addEventListener(eStart, onStartEvent, false);
                window.addEventListener(eMove, onMoveEvent, false);
                window.addEventListener(eEnd, onEndEvent, false);
                window.addEventListener(eCancel, onEndEvent, false);
            } else {
                this.on(eStart, onStartEvent);
                $win.on(eMove, onMoveEvent);
                $win.on(eEnd, onEndEvent);
            }

        },

        serialize: function() {

            var data,
                depth = 0,
                list  = this,
                step  = function(level, depth) {

                    var array = [ ], items = level.children(list.options._listItemClass);

                    items.each(function() {

                        var li    = UI.$(this),
                            item  = {}, attribute,
                            sub   = li.children(list.options._listClass);

                        for (var i = 0; i < li[0].attributes.length; i++) {
                            attribute = li[0].attributes[i];
                            if (attribute.name.indexOf('data-') === 0) {
                                item[attribute.name.substr(5)] = UI.Utils.str2json(attribute.value);
                            }
                        }

                        if (sub.length) {
                            item.children = step(sub, depth + 1);
                        }

                        array.push(item);

                    });
                    return array;
                };

            data = step(list.element, depth);

            return data;
        },

        list: function(options) {

            var data  = [],
                list  = this,
                depth = 0,
                step  = function(level, depth, parent) {

                    var items = level.children(options._listItemClass);

                    items.each(function(index) {
                        var li   = UI.$(this),
                            item = UI.$.extend({parent_id: (parent ? parent : null), depth: depth, order: index}, li.data()),
                            sub  = li.children(options._listClass);

                        data.push(item);

                        if (sub.length) {
                            step(sub, depth + 1, li.data(options.idProperty || 'id'));
                        }
                    });
                };

            options = UI.$.extend({}, list.options, options);

            step(list.element, depth);

            return data;
        },

        reset: function() {

            this.mouse = {
                offsetX   : 0,
                offsetY   : 0,
                startX    : 0,
                startY    : 0,
                lastX     : 0,
                lastY     : 0,
                nowX      : 0,
                nowY      : 0,
                distX     : 0,
                distY     : 0,
                dirAx     : 0,
                dirX      : 0,
                dirY      : 0,
                lastDirX  : 0,
                lastDirY  : 0,
                distAxX   : 0,
                distAxY   : 0
            };
            this.moving     = false;
            this.dragEl     = null;
            this.dragRootEl = null;
            this.dragDepth  = 0;
            this.hasNewRoot = false;
            this.pointEl    = null;

            for (var i=0; i<touchedlists.length; i++) {
                this.checkEmptyList(touchedlists[i]);
            }

            touchedlists = [];
        },

        toggleItem: function(li) {
            this[li.hasClass(this.options.collapsedClass) ? "expandItem":"collapseItem"](li);
        },

        expandItem: function(li) {
            li.removeClass(this.options.collapsedClass);
        },

        collapseItem: function(li) {
            var lists = li.children(this.options._listClass);
            if (lists.length) {
                li.addClass(this.options.collapsedClass);
            }
        },

        expandAll: function() {
            var list = this;
            this.find(list.options._listItemClass).each(function() {
                list.expandItem(UI.$(this));
            });
        },

        collapseAll: function() {
            var list = this;
            this.find(list.options._listItemClass).each(function() {
                list.collapseItem(UI.$(this));
            });
        },

        setParent: function(li) {

            if (li.children(this.options._listClass).length) {
                li.addClass("uk-parent");
            }
        },

        unsetParent: function(li) {
            li.removeClass('uk-parent '+this.options.collapsedClass);
            li.children(this.options._listClass).remove();
        },

        dragStart: function(e) {

            var mouse    = this.mouse,
                target   = UI.$(e.target),
                dragItem = target.closest(this.options._listItemClass),
                offset   = dragItem.offset();

            this.placeEl = dragItem;

            mouse.offsetX = e.pageX - offset.left;
            mouse.offsetY = e.pageY - offset.top;

            mouse.startX = mouse.lastX = offset.left;
            mouse.startY = mouse.lastY = offset.top;

            this.dragRootEl = this.element;

            this.dragEl = UI.$('<ul></ul>').addClass(this.options.listClass + ' ' + this.options.dragClass).append(dragItem.clone());
            this.dragEl.css('width', dragItem.width());
            this.placeEl.addClass(this.options.placeholderClass);

            draggingElement = this.dragEl;

            this.tmpDragOnSiblings = [dragItem[0].previousSibling, dragItem[0].nextSibling];

            UI.$body.append(this.dragEl);

            this.dragEl.css({
                left : offset.left,
                top  : offset.top
            });

            // total depth of dragging item
            var i, depth, items = this.dragEl.find(this.options._listItemClass);

            for (i = 0; i < items.length; i++) {
                depth = UI.$(items[i]).parents(this.options._listClass+','+this.options._listBaseClass).length;
                if (depth > this.dragDepth) {
                    this.dragDepth = depth;
                }
            }

            html.addClass(this.options.movingClass);
        },

        dragStop: function(e) {

            var el       = UI.$(this.placeEl),
                root     = this.placeEl.parents(this.options._listBaseClass+':first');

            this.placeEl.removeClass(this.options.placeholderClass);
            this.dragEl.remove();

            if (this.element[0] !== root[0]) {

                root.trigger('change.uk.nestable',[root.data('nestable'), el, 'added']);
                this.element.trigger('change.uk.nestable', [this, el, 'removed']);

            } else {
                this.element.trigger('change.uk.nestable',[this, el, "moved"]);
            }

            this.trigger('stop.uk.nestable', [this, el]);

            this.reset();

            html.removeClass(this.options.movingClass);
        },

        dragMove: function(e) {
            var list, parent, prev, next, depth,
                opt      = this.options,
                mouse    = this.mouse,
                maxDepth = this.dragRootEl ? this.dragRootEl.data('nestable').options.maxDepth : opt.maxDepth;

            this.dragEl.css({
                left : e.pageX - mouse.offsetX,
                top  : e.pageY - mouse.offsetY
            });

            // mouse position last events
            mouse.lastX = mouse.nowX;
            mouse.lastY = mouse.nowY;
            // mouse position this events
            mouse.nowX  = e.pageX;
            mouse.nowY  = e.pageY;
            // distance mouse moved between events
            mouse.distX = mouse.nowX - mouse.lastX;
            mouse.distY = mouse.nowY - mouse.lastY;
            // direction mouse was moving
            mouse.lastDirX = mouse.dirX;
            mouse.lastDirY = mouse.dirY;
            // direction mouse is now moving (on both axis)
            mouse.dirX = mouse.distX === 0 ? 0 : mouse.distX > 0 ? 1 : -1;
            mouse.dirY = mouse.distY === 0 ? 0 : mouse.distY > 0 ? 1 : -1;
            // axis mouse is now moving on
            var newAx   = Math.abs(mouse.distX) > Math.abs(mouse.distY) ? 1 : 0;

            // do nothing on first move
            if (!mouse.moving) {
                mouse.dirAx  = newAx;
                mouse.moving = true;
                return;
            }

            // calc distance moved on this axis (and direction)
            if (mouse.dirAx !== newAx) {
                mouse.distAxX = 0;
                mouse.distAxY = 0;
            } else {
                mouse.distAxX += Math.abs(mouse.distX);
                if (mouse.dirX !== 0 && mouse.dirX !== mouse.lastDirX) {
                    mouse.distAxX = 0;
                }
                mouse.distAxY += Math.abs(mouse.distY);
                if (mouse.dirY !== 0 && mouse.dirY !== mouse.lastDirY) {
                    mouse.distAxY = 0;
                }
            }
            mouse.dirAx = newAx;

            /**
             * move horizontal
             */
            if (mouse.dirAx && mouse.distAxX >= opt.threshold) {
                // reset move distance on x-axis for new phase
                mouse.distAxX = 0;
                prev = this.placeEl.prev('li');

                // increase horizontal level if previous sibling exists and is not collapsed
                if (mouse.distX > 0 && prev.length && !prev.hasClass(opt.collapsedClass)) {

                    // cannot increase level when item above is collapsed
                    list = prev.find(opt._listClass).last();

                    // check if depth limit has reached
                    depth = this.placeEl.parents(opt._listClass+','+opt._listBaseClass).length;

                    if (depth + this.dragDepth <= maxDepth) {

                        // create new sub-level if one doesn't exist
                        if (!list.length) {
                            list = UI.$('<ul/>').addClass(opt.listClass);
                            list.append(this.placeEl);
                            prev.append(list);
                            this.setParent(prev);
                        } else {
                            // else append to next level up
                            list = prev.children(opt._listClass).last();
                            list.append(this.placeEl);
                        }
                    }
                }

                // decrease horizontal level
                if (mouse.distX < 0) {

                    // we cannot decrease the level if an item precedes the current one
                    next = this.placeEl.next(opt._listItemClass);
                    if (!next.length) {

                        // get parent ul of the list item
                        var parentUl = this.placeEl.closest([opt._listBaseClass, opt._listClass].join(','));
                        // try to get the li surrounding the ul
                        var surroundingLi = parentUl.closest(opt._listItemClass);

                        // if the ul is inside of a li (meaning it is nested)
                        if (surroundingLi.length) {
                            // we can decrease the horizontal level
                            surroundingLi.after(this.placeEl);
                            // if the previous parent ul is now empty
                            if (!parentUl.children().length) {
                                this.unsetParent(surroundingLi);
                            }
                        }
                    }
                }
            }

            var isEmpty = false;

            // find list item under cursor
            var pointX = e.pageX - (window.pageXOffset || document.scrollLeft || 0),
                pointY = e.pageY - (window.pageYOffset || document.documentElement.scrollTop);
            this.pointEl = UI.$(document.elementFromPoint(pointX, pointY));

            if (opt.handleClass && this.pointEl.hasClass(opt.handleClass)) {

                this.pointEl = this.pointEl.closest(opt._listItemClass);

            } else {

                var nestableitem = this.pointEl.closest(opt._listItemClass);

                if (nestableitem.length) {
                    this.pointEl = nestableitem;
                }
            }

            if (this.placeEl.find(this.pointEl).length) {
                return;
            }

            if (this.pointEl.data('nestable') && !this.pointEl.children().length) {
                isEmpty = true;
                this.checkEmptyList(this.pointEl);
            } else if (!this.pointEl.length || !this.pointEl.hasClass(opt.listItemClass)) {
                return;
            }

            // find parent list of item under cursor
            var pointElRoot = this.element,
                tmpRoot     = this.pointEl.closest(this.options._listBaseClass),
                isNewRoot   = pointElRoot[0] != tmpRoot[0];

            /**
             * move vertical
             */
            if (!mouse.dirAx || isNewRoot || isEmpty) {

                // check if groups match if dragging over new root
                if (isNewRoot && opt.group !== tmpRoot.data('nestable-group')) {
                    return;
                } else {
                    touchedlists.push(pointElRoot);
                }

                // check depth limit
                depth = this.dragDepth - 1 + this.pointEl.parents(opt._listClass+','+opt._listBaseClass).length;

                if (depth > maxDepth) {
                    return;
                }

                var before = e.pageY < (this.pointEl.offset().top + this.pointEl.height() / 2);

                parent = this.placeEl.parent();

                if (isEmpty) {
                    this.pointEl.append(this.placeEl);
                } else if (before) {
                    this.pointEl.before(this.placeEl);
                } else {
                    this.pointEl.after(this.placeEl);
                }

                if (!parent.children().length) {
                    if (!parent.data("nestable")) this.unsetParent(parent.parent());
                }

                this.checkEmptyList(this.dragRootEl);
                this.checkEmptyList(pointElRoot);

                // parent root list has changed
                if (isNewRoot) {
                    this.dragRootEl = tmpRoot;
                    this.hasNewRoot = this.element[0] !== this.dragRootEl[0];
                }
            }
        },

        checkEmptyList: function(list) {

            list  = list ? UI.$(list) : this.element;

            if (this.options.emptyClass) {
                list[!list.children().length ? 'addClass':'removeClass'](this.options.emptyClass);
            }
        }

    });

    return UI.nestable;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-notify", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    var containers = {},
        messages   = {},

        notify     =  function(options){

            if (UI.$.type(options) == 'string') {
                options = { message: options };
            }

            if (arguments[1]) {
                options = UI.$.extend(options, UI.$.type(arguments[1]) == 'string' ? {status:arguments[1]} : arguments[1]);
            }

            return (new Message(options)).show();
        },
        closeAll  = function(group, instantly){

            var id;

            if (group) {
                for(id in messages) { if(group===messages[id].group) messages[id].close(instantly); }
            } else {
                for(id in messages) { messages[id].close(instantly); }
            }
        };

    var Message = function(options){

        this.options = UI.$.extend({}, Message.defaults, options);

        this.uuid    = UI.Utils.uid("notifymsg");
        this.element = UI.$([

            '<div class="uk-notify-message">',
                '<a class="uk-close"></a>',
                '<div></div>',
            '</div>'

        ].join('')).data("notifyMessage", this);

        this.content(this.options.message);

        // status
        if (this.options.status) {
            this.element.addClass('uk-notify-message-'+this.options.status);
            this.currentstatus = this.options.status;
        }

        this.group = this.options.group;

        messages[this.uuid] = this;

        if(!containers[this.options.pos]) {
            containers[this.options.pos] = UI.$('<div class="uk-notify uk-notify-'+this.options.pos+'"></div>').appendTo('body').on("click", ".uk-notify-message", function(){

                var message = UI.$(this).data("notifyMessage");

                message.element.trigger('manualclose.uk.notify', [message]);
                message.close();
            });
        }
    };


    UI.$.extend(Message.prototype, {

        uuid: false,
        element: false,
        timout: false,
        currentstatus: "",
        group: false,

        show: function() {

            if (this.element.is(":visible")) return;

            var $this = this;

            containers[this.options.pos].show().prepend(this.element);

            var marginbottom = parseInt(this.element.css("margin-bottom"), 10);

            this.element.css({"opacity":0, "margin-top": -1*this.element.outerHeight(), "margin-bottom":0}).animate({"opacity":1, "margin-top": 0, "margin-bottom":marginbottom}, function(){

                if ($this.options.timeout) {

                    var closefn = function(){ $this.close(); };

                    $this.timeout = setTimeout(closefn, $this.options.timeout);

                    $this.element.hover(
                        function() { clearTimeout($this.timeout); },
                        function() { $this.timeout = setTimeout(closefn, $this.options.timeout);  }
                    );
                }

            });

            return this;
        },

        close: function(instantly) {

            var $this    = this,
                finalize = function(){
                    $this.element.remove();

                    if (!containers[$this.options.pos].children().length) {
                        containers[$this.options.pos].hide();
                    }

                    $this.options.onClose.apply($this, []);
                    $this.element.trigger('close.uk.notify', [$this]);

                    delete messages[$this.uuid];
                };

            if (this.timeout) clearTimeout(this.timeout);

            if (instantly) {
                finalize();
            } else {
                this.element.animate({"opacity":0, "margin-top": -1* this.element.outerHeight(), "margin-bottom":0}, function(){
                    finalize();
                });
            }
        },

        content: function(html){

            var container = this.element.find(">div");

            if(!html) {
                return container.html();
            }

            container.html(html);

            return this;
        },

        status: function(status) {

            if (!status) {
                return this.currentstatus;
            }

            this.element.removeClass('uk-notify-message-'+this.currentstatus).addClass('uk-notify-message-'+status);

            this.currentstatus = status;

            return this;
        }
    });

    Message.defaults = {
        message: "",
        status: "",
        timeout: 5000,
        group: null,
        pos: 'top-center',
        onClose: function() {}
    };

    UI.notify          = notify;
    UI.notify.message  = Message;
    UI.notify.closeAll = closeAll;

    return notify;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-slideshow", ["uikit"], function() {
            return component || addon(UIkit);
        });
    }

})(function(UI) {

    "use strict";

    var Animations, playerId = 0;

    UI.component('slideshow', {

        defaults: {
            animation          : "fade",
            duration           : 500,
            height             : "auto",
            start              : 0,
            autoplay           : false,
            autoplayInterval   : 7000,
            videoautoplay      : true,
            videomute          : true,
            slices             : 15,
            pauseOnHover       : true,
            kenburns           : false,
            kenburnsanimations : [
                'uk-animation-middle-left',
                'uk-animation-top-right',
                'uk-animation-bottom-left',
                'uk-animation-top-center',
                '', // middle-center
                'uk-animation-bottom-right'
            ]
        },

        current  : false,
        interval : null,
        hovering : false,

        boot: function() {

            // init code
            UI.ready(function(context) {

                UI.$('[data-uk-slideshow]', context).each(function() {

                    var slideshow = UI.$(this);

                    if (!slideshow.data("slideshow")) {
                        UI.slideshow(slideshow, UI.Utils.options(slideshow.attr("data-uk-slideshow")));
                    }
                });
            });
        },

        init: function() {

            var $this = this, canvas, kbanimduration;

            this.container     = this.element.hasClass('uk-slideshow') ? this.element : UI.$(this.find('.uk-slideshow'));
            this.slides        = this.container.children();
            this.slidesCount   = this.slides.length;
            this.current       = this.options.start;
            this.animating     = false;
            this.triggers      = this.find('[data-uk-slideshow-item]');
            this.fixFullscreen = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) && this.container.hasClass('uk-slideshow-fullscreen'); // viewport unit fix for height:100vh - should be fixed in iOS 8

            if (this.options.kenburns) {

                kbanimduration = this.options.kenburns === true ? '15s': this.options.kenburns;

                if (!String(kbanimduration).match(/(ms|s)$/)) {
                    kbanimduration += 'ms';
                }

                if (typeof(this.options.kenburnsanimations) == 'string') {
                    this.options.kenburnsanimations = this.options.kenburnsanimations.split(',');
                }
            }

            this.slides.each(function(index) {

                var slide = UI.$(this),
                    media = slide.children('img,video,iframe').eq(0);

                slide.data('media', media);
                slide.data('sizer', media);

                if (media.length) {

                    var placeholder;

                    switch(media[0].nodeName) {
                        case 'IMG':

                            var cover = UI.$('<div class="uk-cover-background uk-position-cover"></div>').css({'background-image':'url('+ media.attr('src') + ')'});

                            if (media.attr('width') && media.attr('height')) {
                                placeholder = UI.$('<canvas></canvas>').attr({width:media.attr('width'), height:media.attr('height')});
                                media.replaceWith(placeholder);
                                media = placeholder;
                                placeholder = undefined;
                            }

                            media.css({width: '100%',height: 'auto', opacity:0});
                            slide.prepend(cover).data('cover', cover);
                            break;

                        case 'IFRAME':

                            var src = media[0].src, iframeId = 'sw-'+(++playerId);

                            media
                                .attr('src', '').on('load', function(){

                                    if (index !== $this.current || (index == $this.current && !$this.options.videoautoplay)) {
                                        $this.pausemedia(media);
                                    }

                                    if ($this.options.videomute) {

                                        $this.mutemedia(media);

                                        var inv = setInterval((function(ic) {
                                            return function() {
                                                $this.mutemedia(media);
                                                if (++ic >= 4) clearInterval(inv);
                                            }
                                        })(0), 250);
                                    }

                                })
                                .data('slideshow', $this)  // add self-reference for the vimeo-ready listener
                                .attr('data-player-id', iframeId)  // add frameId for the vimeo-ready listener
                                .attr('src', [src, (src.indexOf('?') > -1 ? '&':'?'), 'enablejsapi=1&api=1&player_id='+iframeId].join(''))
                                .addClass('uk-position-absolute');

                            // disable pointer events
                            if(!UI.support.touch) media.css('pointer-events', 'none');

                            placeholder = true;

                            if (UI.cover) {
                                UI.cover(media);
                                media.attr('data-uk-cover', '{}');
                            }

                            break;

                        case 'VIDEO':
                            media.addClass('uk-cover-object uk-position-absolute');
                            placeholder = true;

                            if ($this.options.videomute) $this.mutemedia(media);
                    }

                    if (placeholder) {

                        canvas  = UI.$('<canvas></canvas>').attr({'width': media[0].width, 'height': media[0].height});
                        var img = UI.$('<img style="width:100%;height:auto;">').attr('src', canvas[0].toDataURL());

                        slide.prepend(img);
                        slide.data('sizer', img);
                    }

                } else {
                    slide.data('sizer', slide);
                }

                if ($this.hasKenBurns(slide)) {

                    slide.data('cover').css({
                        '-webkit-animation-duration': kbanimduration,
                        'animation-duration': kbanimduration
                    });
                }
            });

            this.on("click.uikit.slideshow", '[data-uk-slideshow-item]', function(e) {

                e.preventDefault();

                var slide = UI.$(this).attr('data-uk-slideshow-item');

                if ($this.current == slide) return;

                switch(slide) {
                    case 'next':
                    case 'previous':
                        $this[slide=='next' ? 'next':'previous']();
                        break;
                    default:
                        $this.show(parseInt(slide, 10));
                }

                $this.stop();
            });

            // Set start slide
            this.slides.attr('aria-hidden', 'true').eq(this.current).addClass('uk-active').attr('aria-hidden', 'false');
            this.triggers.filter('[data-uk-slideshow-item="'+this.current+'"]').addClass('uk-active');

            UI.$win.on("resize load", UI.Utils.debounce(function() {
                $this.resize();

                if ($this.fixFullscreen) {
                    $this.container.css('height', window.innerHeight);
                    $this.slides.css('height', window.innerHeight);
                }
            }, 100));

            // chrome image load fix
            setTimeout(function(){
                $this.resize();
            }, 80);

            // Set autoplay
            if (this.options.autoplay) {
                this.start();
            }

            if (this.options.videoautoplay && this.slides.eq(this.current).data('media')) {
                this.playmedia(this.slides.eq(this.current).data('media'));
            }

            if (this.options.kenburns) {
                this.applyKenBurns(this.slides.eq(this.current));
            }

            this.container.on({
                mouseenter: function() { if ($this.options.pauseOnHover) $this.hovering = true;  },
                mouseleave: function() { $this.hovering = false; }
            });

            this.on('swipeRight swipeLeft', function(e) {
                $this[e.type=='swipeLeft' ? 'next' : 'previous']();
            });

            this.on('display.uk.check', function(){
                if ($this.element.is(":visible")) {

                    $this.resize();

                    if ($this.fixFullscreen) {
                        $this.container.css('height', window.innerHeight);
                        $this.slides.css('height', window.innerHeight);
                    }
                }
            });
        },


        resize: function() {

            if (this.container.hasClass('uk-slideshow-fullscreen')) return;

            var height = this.options.height;

            if (this.options.height === 'auto') {

                height = 0;

                this.slides.css('height', '').each(function() {
                    height = Math.max(height, UI.$(this).height());
                });
            }

            this.container.css('height', height);
            this.slides.css('height', height);
        },

        show: function(index, direction) {

            if (this.animating || this.current == index) return;

            this.animating = true;

            var $this        = this,
                current      = this.slides.eq(this.current),
                next         = this.slides.eq(index),
                dir          = direction ? direction : this.current < index ? 1 : -1,
                currentmedia = current.data('media'),
                animation    = Animations[this.options.animation] ? this.options.animation : 'fade',
                nextmedia    = next.data('media'),
                finalize     = function() {

                    if (!$this.animating) return;

                    if (currentmedia && currentmedia.is('video,iframe')) {
                        $this.pausemedia(currentmedia);
                    }

                    if (nextmedia && nextmedia.is('video,iframe')) {
                        $this.playmedia(nextmedia);
                    }

                    next.addClass("uk-active").attr('aria-hidden', 'false');
                    current.removeClass("uk-active").attr('aria-hidden', 'true');

                    $this.animating = false;
                    $this.current   = index;

                    UI.Utils.checkDisplay(next, '[class*="uk-animation-"]:not(.uk-cover-background.uk-position-cover)');

                    $this.trigger('show.uk.slideshow', [next, current, $this]);
                };

            $this.applyKenBurns(next);

            // animation fallback
            if (!UI.support.animation) {
                animation = 'none';
            }

            current = UI.$(current);
            next    = UI.$(next);

            $this.trigger('beforeshow.uk.slideshow', [next, current, $this]);

            Animations[animation].apply(this, [current, next, dir]).then(finalize);

            $this.triggers.removeClass('uk-active');
            $this.triggers.filter('[data-uk-slideshow-item="'+index+'"]').addClass('uk-active');
        },

        applyKenBurns: function(slide) {

            if (!this.hasKenBurns(slide)) {
                return;
            }

            var animations = this.options.kenburnsanimations,
                index      = this.kbindex || 0;


            slide.data('cover').attr('class', 'uk-cover-background uk-position-cover').width();
            slide.data('cover').addClass(['uk-animation-scale', 'uk-animation-reverse', animations[index].trim()].join(' '));

            this.kbindex = animations[index + 1] ? (index+1):0;
        },

        hasKenBurns: function(slide) {
            return (this.options.kenburns && slide.data('cover'));
        },

        next: function() {
            this.show(this.slides[this.current + 1] ? (this.current + 1) : 0, 1);
        },

        previous: function() {
            this.show(this.slides[this.current - 1] ? (this.current - 1) : (this.slides.length - 1), -1);
        },

        start: function() {

            this.stop();

            var $this = this;

            this.interval = setInterval(function() {
                if (!$this.hovering) $this.next();
            }, this.options.autoplayInterval);

        },

        stop: function() {
            if (this.interval) clearInterval(this.interval);
        },

        playmedia: function(media) {

            if (!(media && media[0])) return;

            switch(media[0].nodeName) {
                case 'VIDEO':

                    if (!this.options.videomute) {
                        media[0].muted = false;
                    }

                    media[0].play();
                    break;
                case 'IFRAME':

                    if (!this.options.videomute) {
                        media[0].contentWindow.postMessage('{ "event": "command", "func": "unmute", "method":"setVolume", "value":1}', '*');
                    }

                    media[0].contentWindow.postMessage('{ "event": "command", "func": "playVideo", "method":"play"}', '*');
                    break;
            }
        },

        pausemedia: function(media) {

            switch(media[0].nodeName) {
                case 'VIDEO':
                    media[0].pause();
                    break;
                case 'IFRAME':
                    media[0].contentWindow.postMessage('{ "event": "command", "func": "pauseVideo", "method":"pause"}', '*');
                    break;
            }
        },

        mutemedia: function(media) {

            switch(media[0].nodeName) {
                case 'VIDEO':
                    media[0].muted = true;
                    break;
                case 'IFRAME':
                    media[0].contentWindow.postMessage('{ "event": "command", "func": "mute", "method":"setVolume", "value":0}', '*');
                    break;
            }
        }
    });

    Animations = {

        'none': function() {

            var d = UI.$.Deferred();
            d.resolve();
            return d.promise();
        },

        'scroll': function(current, next, dir) {

            var d = UI.$.Deferred();

            current.css('animation-duration', this.options.duration+'ms');
            next.css('animation-duration', this.options.duration+'ms');

            next.css('opacity', 1).one(UI.support.animation.end, function() {

                current.removeClass(dir == -1 ? 'uk-slideshow-scroll-backward-out' : 'uk-slideshow-scroll-forward-out');
                next.css('opacity', '').removeClass(dir == -1 ? 'uk-slideshow-scroll-backward-in' : 'uk-slideshow-scroll-forward-in');
                d.resolve();

            }.bind(this));

            current.addClass(dir == -1 ? 'uk-slideshow-scroll-backward-out' : 'uk-slideshow-scroll-forward-out');
            next.addClass(dir == -1 ? 'uk-slideshow-scroll-backward-in' : 'uk-slideshow-scroll-forward-in');
            next.width(); // force redraw

            return d.promise();
        },

        'swipe': function(current, next, dir) {

            var d = UI.$.Deferred();

            current.css('animation-duration', this.options.duration+'ms');
            next.css('animation-duration', this.options.duration+'ms');

            next.css('opacity', 1).one(UI.support.animation.end, function() {

                current.removeClass(dir === -1 ? 'uk-slideshow-swipe-backward-out' : 'uk-slideshow-swipe-forward-out');
                next.css('opacity', '').removeClass(dir === -1 ? 'uk-slideshow-swipe-backward-in' : 'uk-slideshow-swipe-forward-in');
                d.resolve();

            }.bind(this));

            current.addClass(dir == -1 ? 'uk-slideshow-swipe-backward-out' : 'uk-slideshow-swipe-forward-out');
            next.addClass(dir == -1 ? 'uk-slideshow-swipe-backward-in' : 'uk-slideshow-swipe-forward-in');
            next.width(); // force redraw

            return d.promise();
        },

        'scale': function(current, next, dir) {

            var d = UI.$.Deferred();

            current.css('animation-duration', this.options.duration+'ms');
            next.css('animation-duration', this.options.duration+'ms');

            next.css('opacity', 1);

            current.one(UI.support.animation.end, function() {

                current.removeClass('uk-slideshow-scale-out');
                next.css('opacity', '');
                d.resolve();

            }.bind(this));

            current.addClass('uk-slideshow-scale-out');
            current.width(); // force redraw

            return d.promise();
        },

        'fade': function(current, next, dir) {

            var d = UI.$.Deferred();

            current.css('animation-duration', this.options.duration+'ms');
            next.css('animation-duration', this.options.duration+'ms');

            next.css('opacity', 1);

            // for plain text content slides - looks smoother
            if (!(next.data('cover') || next.data('placeholder'))) {

                next.css('opacity', 1).one(UI.support.animation.end, function() {
                    next.removeClass('uk-slideshow-fade-in');
                }).addClass('uk-slideshow-fade-in');
            }

            current.one(UI.support.animation.end, function() {

                current.removeClass('uk-slideshow-fade-out');
                next.css('opacity', '');
                d.resolve();

            }.bind(this));

            current.addClass('uk-slideshow-fade-out');
            current.width(); // force redraw

            return d.promise();
        }
    };

    UI.slideshow.animations = Animations;

    // Listen for messages from the vimeo player
    window.addEventListener('message', function onMessageReceived(e) {

        var data = e.data, iframe;

        if (typeof(data) == 'string') {

            try {
                data = JSON.parse(data);
            } catch(err) {
                data = {};
            }
        }

        if (e.origin && e.origin.indexOf('vimeo') > -1 && data.event == 'ready' && data.player_id) {
            iframe = UI.$('[data-player-id="'+ data.player_id+'"]');

            if (iframe.length) {
                iframe.data('slideshow').mutemedia(iframe);
            }
        }
    }, false);

});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
/*
  * Based on nativesortable - Copyright (c) Brian Grinstead - https://github.com/bgrins/nativesortable
  */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-sortable", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    var supportsTouch       = ('ontouchstart' in window) || (window.DocumentTouch && document instanceof DocumentTouch),
        draggingPlaceholder, currentlyDraggingElement, currentlyDraggingTarget, dragging, moving, clickedlink, delayIdle, touchedlists, moved, overElement;

    function closestSortable(ele) {

        ele = UI.$(ele);

        do {
            if (ele.data('sortable')) {
                return ele;
            }
            ele = UI.$(ele).parent();
        } while(ele.length);

        return ele;
    }

    UI.component('sortable', {

        defaults: {

            animation        : 150,
            threshold        : 10,

            childClass       : 'uk-sortable-item',
            placeholderClass : 'uk-sortable-placeholder',
            overClass        : 'uk-sortable-over',
            draggingClass    : 'uk-sortable-dragged',
            dragMovingClass  : 'uk-sortable-moving',
            baseClass        : 'uk-sortable',
            noDragClass      : 'uk-sortable-nodrag',
            emptyClass       : 'uk-sortable-empty',
            dragCustomClass  : '',
            handleClass      : false,
            group            : false,

            stop             : function() {},
            start            : function() {},
            change           : function() {}
        },

        boot: function() {

            // auto init
            UI.ready(function(context) {

                UI.$("[data-uk-sortable]", context).each(function(){

                    var ele = UI.$(this);

                    if(!ele.data("sortable")) {
                        UI.sortable(ele, UI.Utils.options(ele.attr("data-uk-sortable")));
                    }
                });
            });

            UI.$html.on('mousemove touchmove', function(e) {

                if (delayIdle) {

                    var src = e.originalEvent.targetTouches ? e.originalEvent.targetTouches[0] : e;

                    if (Math.abs(src.pageX - delayIdle.pos.x) > delayIdle.threshold || Math.abs(src.pageY - delayIdle.pos.y) > delayIdle.threshold) {
                        delayIdle.apply(src);
                    }
                }

                if (draggingPlaceholder) {

                    if (!moving) {
                        moving = true;
                        draggingPlaceholder.show();

                        draggingPlaceholder.$current.addClass(draggingPlaceholder.$sortable.options.placeholderClass);
                        draggingPlaceholder.$sortable.element.children().addClass(draggingPlaceholder.$sortable.options.childClass);

                        UI.$html.addClass(draggingPlaceholder.$sortable.options.dragMovingClass);
                    }

                    var offset = draggingPlaceholder.data('mouse-offset'),
                        left   = parseInt(e.originalEvent.pageX, 10) + offset.left,
                        top    = parseInt(e.originalEvent.pageY, 10) + offset.top;

                    draggingPlaceholder.css({'left': left, 'top': top });

                    // adjust document scrolling

                    if (top + (draggingPlaceholder.height()/3) > document.body.offsetHeight) {
                        return;
                    }

                    if (top < UI.$win.scrollTop()) {
                        UI.$win.scrollTop(UI.$win.scrollTop() - Math.ceil(draggingPlaceholder.height()/3));
                    } else if ( (top + (draggingPlaceholder.height()/3)) > (window.innerHeight + UI.$win.scrollTop()) ) {
                        UI.$win.scrollTop(UI.$win.scrollTop() + Math.ceil(draggingPlaceholder.height()/3));
                    }
                }
            });

            UI.$html.on('mouseup touchend', function(e) {

                delayIdle = clickedlink = false;

                // dragging?
                if (!currentlyDraggingElement || !draggingPlaceholder) {
                    // completely reset dragging attempt. will cause weird delay behavior elsewise
                    currentlyDraggingElement = draggingPlaceholder = null;
                    return;
                }

                // inside or outside of sortable?
                var sortable  = closestSortable(e.target),
                    component = draggingPlaceholder.$sortable,
                    ev        = { type: e.type };

                if (sortable[0]) {
                    component.dragDrop(ev, component.element);
                }
                component.dragEnd(ev, component.element);
            });
        },

        init: function() {

            var $this   = this,
                element = this.element[0];

            touchedlists = [];

            this.checkEmptyList();

            this.element.data('sortable-group', this.options.group ? this.options.group : UI.Utils.uid('sortable-group'));

            var handleDragStart = delegate(function(e) {

                if (e.data && e.data.sortable) {
                    return;
                }

                var $target = UI.$(e.target),
                    $link   = $target.is('a[href]') ? $target:$target.parents('a[href]');

                if ($target.is(':input')) {
                    return;
                }

                e.preventDefault();

                if (!supportsTouch && $link.length) {

                    $link.one('click', function(e){
                        e.preventDefault();
                    }).one('mouseup', function(){
                        if(!moved) $link.trigger('click');
                    });
                }

                e.data = e.data || {};

                e.data.sortable = element;

                return $this.dragStart(e, this);
            });

            var handleDragOver = delegate(function(e) {

                if (!currentlyDraggingElement) {
                    return true;
                }

                if (e.preventDefault) {
                    e.preventDefault();
                }

                return false;
            });

            var handleDragEnter = delegate(UI.Utils.debounce(function(e) {
                return $this.dragEnter(e, this);
            }), 40);

            var handleDragLeave = delegate(function(e) {

                // Prevent dragenter on a child from allowing a dragleave on the container
                var previousCounter = $this.dragenterData(this);
                $this.dragenterData(this, previousCounter - 1);

                // This is a fix for child elements firing dragenter before the parent fires dragleave
                if (!$this.dragenterData(this)) {
                    UI.$(this).removeClass($this.options.overClass);
                    $this.dragenterData(this, false);
                }
            });

            var handleTouchMove = delegate(function(e) {

                if (!currentlyDraggingElement ||
                    currentlyDraggingElement === this ||
                    currentlyDraggingTarget === this) {
                    return true;
                }

                $this.element.children().removeClass($this.options.overClass);
                currentlyDraggingTarget = this;

                $this.moveElementNextTo(currentlyDraggingElement, this);

                return prevent(e);
            });

            // Bind/unbind standard mouse/touch events as a polyfill.
            function addDragHandlers() {
                if (supportsTouch) {
                    element.addEventListener("touchmove", handleTouchMove, false);
                } else {
                    element.addEventListener('mouseover', handleDragEnter, false);
                    element.addEventListener('mouseout', handleDragLeave, false);
                }

                // document.addEventListener("selectstart", prevent, false);
            }

            function removeDragHandlers() {
                if (supportsTouch) {
                    element.removeEventListener("touchmove", handleTouchMove, false);
                } else {
                    element.removeEventListener('mouseover', handleDragEnter, false);
                    element.removeEventListener('mouseout', handleDragLeave, false);
                }

                // document.removeEventListener("selectstart", prevent, false);
            }

            this.addDragHandlers    = addDragHandlers;
            this.removeDragHandlers = removeDragHandlers;

            function handleDragMove(e) {

                if (!currentlyDraggingElement) {
                    return;
                }

                $this.dragMove(e, $this);
            }

            function delegate(fn) {

                return function(e) {

                    var touch, target, context;

                    if (e) {
                        touch  = (supportsTouch && e.touches && e.touches[0]) || { };
                        target = touch.target || e.target;

                        // Fix event.target for a touch event
                        if (supportsTouch && document.elementFromPoint) {
                            target = document.elementFromPoint(e.pageX - document.body.scrollLeft, e.pageY - document.body.scrollTop);
                        }

                        overElement = UI.$(target);
                    }

                    if (UI.$(target).hasClass($this.options.childClass)) {
                        fn.apply(target, [e]);
                    } else if (target !== element) {

                        // If a child is initiating the event or ending it, then use the container as context for the callback.
                        context = moveUpToChildNode(element, target);

                        if (context) {
                            fn.apply(context, [e]);
                        }
                    }
                };
            }

            window.addEventListener(supportsTouch ? 'touchmove' : 'mousemove', handleDragMove, false);
            element.addEventListener(supportsTouch ? 'touchstart': 'mousedown', handleDragStart, false);
        },

        dragStart: function(e, elem) {

            moved    = false;
            moving   = false;
            dragging = false;

            var $this    = this,
                target   = UI.$(e.target);

            if (!supportsTouch && e.button==2) {
                return;
            }

            if ($this.options.handleClass) {

                var handle = target.hasClass($this.options.handleClass) ? target : target.closest('.'+$this.options.handleClass, $this.element);

                if (!handle.length) {
                    //e.preventDefault();
                    return;
                }
            }

            if (target.is('.'+$this.options.noDragClass) || target.closest('.'+$this.options._noDragClass).length) {
                return;
            }

            // prevent dragging if taget is a form field
            if (target.is(':input')) {
                return;
            }

            currentlyDraggingElement = elem;

            // init drag placeholder
            if (draggingPlaceholder) {
                draggingPlaceholder.remove();
            }

            var $current = UI.$(currentlyDraggingElement), offset = $current.offset();

            delayIdle = {

                pos       : { x:e.pageX, y:e.pageY },
                threshold : $this.options.threshold,
                apply     : function(evt) {

                    draggingPlaceholder = UI.$('<div class="'+([$this.options.draggingClass, $this.options.dragCustomClass].join(' '))+'"></div>').css({
                        display : 'none',
                        top     : offset.top,
                        left    : offset.left,
                        width   : $current.width(),
                        height  : $current.height(),
                        padding : $current.css('padding')
                    }).data({
                        'mouse-offset': {
                            'left'   : offset.left - parseInt(evt.pageX, 10),
                            'top'    : offset.top  - parseInt(evt.pageY, 10)
                        },
                        'origin' : $this.element,
                        'index'  : $current.index()
                    }).append($current.html()).appendTo('body');

                    draggingPlaceholder.$current  = $current;
                    draggingPlaceholder.$sortable = $this;

                    $current.data({
                        'start-list': $current.parent(),
                        'start-index': $current.index(),
                        'sortable-group': $this.options.group
                    });

                    $this.addDragHandlers();

                    $this.options.start(this, currentlyDraggingElement);
                    $this.trigger('start.uk.sortable', [$this, currentlyDraggingElement]);

                    moved     = true;
                    delayIdle = false;
                }
            };
        },

        dragMove: function(e, elem) {

            overElement = UI.$(document.elementFromPoint(e.pageX - (document.body.scrollLeft || document.scrollLeft || 0), e.pageY - (document.body.scrollTop || document.documentElement.scrollTop || 0)));

            var overRoot     = overElement.closest('.'+this.options.baseClass),
                groupOver    = overRoot.data("sortable-group"),
                $current     = UI.$(currentlyDraggingElement),
                currentRoot  = $current.parent(),
                groupCurrent = $current.data("sortable-group"),
                overChild;

            if (overRoot[0] !== currentRoot[0] && groupCurrent !== undefined && groupOver === groupCurrent) {

                overRoot.data('sortable').addDragHandlers();

                touchedlists.push(overRoot);
                overRoot.children().addClass(this.options.childClass);

                // swap root
                if (overRoot.children().length > 0) {
                    overChild = overElement.closest('.'+this.options.childClass);

                    if (overChild.length) {
                        overChild.before($current);
                    } else {
                        overRoot.append($current);
                    }

                } else { // empty list
                    overElement.append($current);
                }

                UIkit.$doc.trigger('mouseover');
            }

            this.checkEmptyList();
            this.checkEmptyList(currentRoot);
        },

        dragEnter: function(e, elem) {

            if (!currentlyDraggingElement || currentlyDraggingElement === elem) {
                return true;
            }

            var previousCounter = this.dragenterData(elem);

            this.dragenterData(elem, previousCounter + 1);

            // Prevent dragenter on a child from allowing a dragleave on the container
            if (previousCounter === 0) {

                var currentlist = UI.$(elem).parent(),
                    startlist   = UI.$(currentlyDraggingElement).data("start-list");

                if (currentlist[0] !== startlist[0]) {

                    var groupOver    = currentlist.data('sortable-group'),
                        groupCurrent = UI.$(currentlyDraggingElement).data("sortable-group");

                    if ((groupOver ||  groupCurrent) && (groupOver != groupCurrent)) {
                        return false;
                    }
                }

                UI.$(elem).addClass(this.options.overClass);
                this.moveElementNextTo(currentlyDraggingElement, elem);
            }

            return false;
        },

        dragEnd: function(e, elem) {

            var $this = this;

            // avoid triggering event twice
            if (currentlyDraggingElement) {
                // TODO: trigger on right element?
                this.options.stop(elem);
                this.trigger('stop.uk.sortable', [this]);
            }

            currentlyDraggingElement = null;
            currentlyDraggingTarget  = null;

            touchedlists.push(this.element);
            touchedlists.forEach(function(el, i) {
                UI.$(el).children().each(function() {
                    if (this.nodeType === 1) {
                        UI.$(this).removeClass($this.options.overClass)
                            .removeClass($this.options.placeholderClass)
                            .removeClass($this.options.childClass);
                        $this.dragenterData(this, false);
                    }
                });
            });

            touchedlists = [];

            UI.$html.removeClass(this.options.dragMovingClass);

            this.removeDragHandlers();

            if (draggingPlaceholder) {
                draggingPlaceholder.remove();
                draggingPlaceholder = null;
            }
        },

        dragDrop: function(e, elem) {

            if (e.type === 'drop') {

                if (e.stopPropagation) {
                    e.stopPropagation();
                }

                if (e.preventDefault) {
                    e.preventDefault();
                }
            }

            this.triggerChangeEvents();
        },

        triggerChangeEvents: function() {

            // trigger events once
            if (!currentlyDraggingElement) return;

            var $current = UI.$(currentlyDraggingElement),
                oldRoot  = draggingPlaceholder.data("origin"),
                newRoot  = $current.closest('.'+this.options.baseClass),
                triggers = [],
                el       = UI.$(currentlyDraggingElement);

            // events depending on move inside lists or across lists
            if (oldRoot[0] === newRoot[0] && draggingPlaceholder.data('index') != $current.index() ) {
                triggers.push({sortable: this, mode: 'moved'});
            } else if (oldRoot[0] != newRoot[0]) {
                triggers.push({sortable: UI.$(newRoot).data('sortable'), mode: 'added'}, {sortable: UI.$(oldRoot).data('sortable'), mode: 'removed'});
            }

            triggers.forEach(function (trigger, i) {
                trigger.sortable.element.trigger('change.uk.sortable', [trigger.sortable, el, trigger.mode]);
            });
        },

        dragenterData: function(element, val) {

            element = UI.$(element);

            if (arguments.length == 1) {
                return parseInt(element.data('child-dragenter'), 10) || 0;
            } else if (!val) {
                element.removeData('child-dragenter');
            } else {
                element.data('child-dragenter', Math.max(0, val));
            }
        },

        moveElementNextTo: function(element, elementToMoveNextTo) {

            dragging = true;

            var $this    = this,
                list     = UI.$(element).parent().css('min-height', ''),
                next     = isBelow(element, elementToMoveNextTo) ? elementToMoveNextTo : elementToMoveNextTo.nextSibling,
                children = list.children(),
                count    = children.length;

            if (!$this.options.animation) {
                elementToMoveNextTo.parentNode.insertBefore(element, next);
                UI.Utils.checkDisplay($this.element.parent());
                return;
            }

            list.css('min-height', list.height());

            children.stop().each(function(){
                var ele = UI.$(this),
                    offset = ele.position();

                    offset.width = ele.width();

                ele.data('offset-before', offset);
            });

            elementToMoveNextTo.parentNode.insertBefore(element, next);

            UI.Utils.checkDisplay($this.element.parent());

            children = list.children().each(function() {
                var ele    = UI.$(this);
                ele.data('offset-after', ele.position());
            }).each(function() {
                var ele    = UI.$(this),
                    before = ele.data('offset-before');
                ele.css({'position':'absolute', 'top':before.top, 'left':before.left, 'min-width':before.width });
            });

            children.each(function(){

                var ele    = UI.$(this),
                    before = ele.data('offset-before'),
                    offset = ele.data('offset-after');

                    ele.css('pointer-events', 'none').width();

                    setTimeout(function(){
                        ele.animate({'top':offset.top, 'left':offset.left}, $this.options.animation, function() {
                            ele.css({'position':'','top':'', 'left':'', 'min-width': '', 'pointer-events':''}).removeClass($this.options.overClass).removeData('child-dragenter');
                            count--;
                            if (!count) {
                                list.css('min-height', '');
                                UI.Utils.checkDisplay($this.element.parent());
                            }
                        });
                    }, 0);
            });
        },

        serialize: function() {

            var data = [], item, attribute;

            this.element.children().each(function(j, child) {
                item = {};
                for (var i = 0; i < child.attributes.length; i++) {
                    attribute = child.attributes[i];
                    if (attribute.name.indexOf('data-') === 0) {
                        item[attribute.name.substr(5)] = UI.Utils.str2json(attribute.value);
                    }
                }
                data.push(item);
            });

            return data;
        },

        checkEmptyList: function(list) {

            list  = list ? UI.$(list) : this.element;

            if (this.options.emptyClass) {
                list[!list.children().length ? 'addClass':'removeClass'](this.options.emptyClass);
            }
        }
    });

    // helpers

    function isBelow(el1, el2) {

        var parent = el1.parentNode;

        if (el2.parentNode != parent) {
            return false;
        }

        var cur = el1.previousSibling;

        while (cur && cur.nodeType !== 9) {
            if (cur === el2) {
                return true;
            }
            cur = cur.previousSibling;
        }

        return false;
    }

    function moveUpToChildNode(parent, child) {
        var cur = child;
        if (cur == parent) { return null; }

        while (cur) {
            if (cur.parentNode === parent) {
                return cur;
            }

            cur = cur.parentNode;
            if ( !cur || !cur.ownerDocument || cur.nodeType === 11 ) {
                break;
            }
        }
        return null;
    }

    function prevent(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        e.returnValue = false;
    }

    return UI.sortable;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-sticky", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    var $win         = UI.$win,
        $doc         = UI.$doc,
        sticked      = [],
        direction    = 1;

    UI.component('sticky', {

        defaults: {
            top          : 0,
            bottom       : 0,
            animation    : '',
            clsinit      : 'uk-sticky-init',
            clsactive    : 'uk-active',
            clsinactive  : '',
            getWidthFrom : '',
            showup      : false,
            boundary     : false,
            media        : false,
            target       : false,
            disabled     : false
        },

        boot: function() {

            // should be more efficient than using $win.scroll(checkscrollposition):
            UI.$doc.on('scrolling.uk.document', function(e, data) {
                if (!data || !data.dir) return;
                direction = data.dir.y;
                checkscrollposition();
            });

            UI.$win.on('resize orientationchange', UI.Utils.debounce(function() {

                if (!sticked.length) return;

                for (var i = 0; i < sticked.length; i++) {
                    sticked[i].reset(true);
                    //sticked[i].self.computeWrapper();
                }

                checkscrollposition();
            }, 100));

            // init code
            UI.ready(function(context) {

                setTimeout(function(){

                    UI.$("[data-uk-sticky]", context).each(function(){

                        var $ele = UI.$(this);

                        if(!$ele.data("sticky")) {
                            UI.sticky($ele, UI.Utils.options($ele.attr('data-uk-sticky')));
                        }
                    });

                    checkscrollposition();
                }, 0);
            });
        },

        init: function() {

            var wrapper  = UI.$('<div class="uk-sticky-placeholder"></div>'), boundary = this.options.boundary, boundtoparent;

            this.wrapper = this.element.css('margin', 0).wrap(wrapper).parent();

            this.computeWrapper();

            if (boundary) {

                if (boundary === true || boundary[0] === '!') {

                    boundary      = boundary === true ? this.wrapper.parent() : this.wrapper.closest(boundary.substr(1));
                    boundtoparent = true;

                } else if (typeof boundary === "string") {
                    boundary = UI.$(boundary);
                }
            }

            this.sticky = {
                self          : this,
                options       : this.options,
                element       : this.element,
                currentTop    : null,
                wrapper       : this.wrapper,
                init          : false,
                getWidthFrom  : UI.$(this.options.getWidthFrom || this.wrapper),
                boundary      : boundary,
                boundtoparent : boundtoparent,
                top           : 0,
                calcTop       : function() {

                    var top = this.options.top;

                    // dynamic top parameter
                    if (this.options.top && typeof(this.options.top) == 'string') {

                        // e.g. 50vh
                        if (this.options.top.match(/^(-|)(\d+)vh$/)) {
                            top = window.innerHeight * parseInt(this.options.top, 10)/100;
                        // e.g. #elementId, or .class-1,class-2,.class-3 (first found is used)
                        } else {

                            var topElement = UI.$(this.options.top).first();

                            if (topElement.length && topElement.is(':visible')) {
                                top = -1 * ((topElement.offset().top + topElement.outerHeight()) - this.wrapper.offset().top);
                            }
                        }

                    }

                    this.top = top;
                },

                reset: function(force) {

                    this.calcTop();

                    var finalize = function() {
                        this.element.css({"position":"", "top":"", "width":"", "left":"", "margin":"0"});
                        this.element.removeClass([this.options.animation, 'uk-animation-reverse', this.options.clsactive].join(' '));
                        this.element.addClass(this.options.clsinactive);
                        this.element.trigger('inactive.uk.sticky');

                        this.currentTop = null;
                        this.animate    = false;
                    }.bind(this);


                    if (!force && this.options.animation && UI.support.animation && !UI.Utils.isInView(this.wrapper)) {

                        this.animate = true;

                        this.element.removeClass(this.options.animation).one(UI.support.animation.end, function(){
                            finalize();
                        }).width(); // force redraw

                        this.element.addClass(this.options.animation+' '+'uk-animation-reverse');
                    } else {
                        finalize();
                    }
                },

                check: function() {

                    if (this.options.disabled) {
                        return false;
                    }

                    if (this.options.media) {

                        switch(typeof(this.options.media)) {
                            case 'number':
                                if (window.innerWidth < this.options.media) {
                                    return false;
                                }
                                break;
                            case 'string':
                                if (window.matchMedia && !window.matchMedia(this.options.media).matches) {
                                    return false;
                                }
                                break;
                        }
                    }

                    var scrollTop      = $win.scrollTop(),
                        documentHeight = $doc.height(),
                        dwh            = documentHeight - window.innerHeight,
                        extra          = (scrollTop > dwh) ? dwh - scrollTop : 0,
                        elementTop     = this.wrapper.offset().top,
                        etse           = elementTop - this.top - extra,
                        active         = (scrollTop  >= etse);

                    if (active && this.options.showup) {

                        // set inactiv if scrolling down
                        if (direction == 1) {
                            active = false;
                        }

                        // set inactive when wrapper is still in view
                        if (direction == -1 && !this.element.hasClass(this.options.clsactive) && UI.Utils.isInView(this.wrapper)) {
                            active = false;
                        }
                    }

                    return active;
                }
            };

            this.sticky.calcTop();

            sticked.push(this.sticky);
        },

        update: function() {
            checkscrollposition(this.sticky);
        },

        enable: function() {
            this.options.disabled = false;
            this.update();
        },

        disable: function(force) {
            this.options.disabled = true;
            this.sticky.reset(force);
        },

        computeWrapper: function() {

            this.wrapper.css({
                'height' : ['absolute','fixed'].indexOf(this.element.css('position')) == -1 ? this.element.outerHeight() : '',
                'float'  : this.element.css('float') != 'none' ? this.element.css('float') : '',
                'margin' : this.element.css('margin')
            });

            if (this.element.css('position') == 'fixed') {
                this.element.css({
                    width: this.sticky.getWidthFrom.length ? this.sticky.getWidthFrom.width() : this.element.width()
                });
            }
        }
    });

    function checkscrollposition(direction) {

        var stickies = arguments.length ? arguments : sticked;

        if (!stickies.length || $win.scrollTop() < 0) return;

        var scrollTop       = $win.scrollTop(),
            documentHeight  = $doc.height(),
            windowHeight    = $win.height(),
            dwh             = documentHeight - windowHeight,
            extra           = (scrollTop > dwh) ? dwh - scrollTop : 0,
            newTop, containerBottom, stickyHeight, sticky;

        for (var i = 0; i < stickies.length; i++) {

            sticky = stickies[i];

            if (!sticky.element.is(":visible") || sticky.animate) {
                continue;
            }

            if (!sticky.check()) {

                if (sticky.currentTop !== null) {
                    sticky.reset();
                }

            } else {

                if (sticky.top < 0) {
                    newTop = 0;
                } else {
                    stickyHeight = sticky.element.outerHeight();
                    newTop = documentHeight - stickyHeight - sticky.top - sticky.options.bottom - scrollTop - extra;
                    newTop = newTop < 0 ? newTop + sticky.top : sticky.top;
                }

                if (sticky.boundary && sticky.boundary.length) {

                    var bTop = sticky.boundary.offset().top;

                    if (sticky.boundtoparent) {
                        containerBottom = documentHeight - (bTop + sticky.boundary.outerHeight()) + parseInt(sticky.boundary.css('padding-bottom'));
                    } else {
                        containerBottom = documentHeight - bTop - parseInt(sticky.boundary.css('margin-top'));
                    }

                    newTop = (scrollTop + stickyHeight) > (documentHeight - containerBottom - (sticky.top < 0 ? 0 : sticky.top)) ? (documentHeight - containerBottom) - (scrollTop + stickyHeight) : newTop;
                }


                if (sticky.currentTop != newTop) {

                    sticky.element.css({
                        position : "fixed",
                        top      : newTop,
                        width    : sticky.getWidthFrom.length ? sticky.getWidthFrom.width() : sticky.element.width(),
                        left     : sticky.wrapper.offset().left
                    });

                    if (!sticky.init) {

                        sticky.element.addClass(sticky.options.clsinit);

                        if (location.hash && scrollTop > 0 && sticky.options.target) {

                            var $target = UI.$(location.hash);

                            if ($target.length) {

                                setTimeout((function($target, sticky){

                                    return function() {

                                        sticky.element.width(); // force redraw

                                        var offset       = $target.offset(),
                                            maxoffset    = offset.top + $target.outerHeight(),
                                            stickyOffset = sticky.element.offset(),
                                            stickyHeight = sticky.element.outerHeight(),
                                            stickyMaxOffset = stickyOffset.top + stickyHeight;

                                        if (stickyOffset.top < maxoffset && offset.top < stickyMaxOffset) {
                                            scrollTop = offset.top - stickyHeight - sticky.options.target;
                                            window.scrollTo(0, scrollTop);
                                        }
                                    };

                                })($target, sticky), 0);
                            }
                        }
                    }

                    sticky.element.addClass(sticky.options.clsactive).removeClass(sticky.options.clsinactive);
                    sticky.element.trigger('active.uk.sticky');
                    sticky.element.css('margin', '');

                    if (sticky.options.animation && sticky.init && !UI.Utils.isInView(sticky.wrapper)) {
                        sticky.element.addClass(sticky.options.animation);
                    }

                    sticky.currentTop = newTop;
                }
            }

            sticky.init = true;
        }
    }

    return UI.sticky;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {
    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-tooltip", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    var $tooltip,   // tooltip container
        tooltipdelay, checkdelay;

    UI.component('tooltip', {

        defaults: {
            "offset": 5,
            "pos": "top",
            "animation": false,
            "delay": 0, // in miliseconds
            "cls": "",
            "activeClass": "uk-active",
            "src": function(ele) {
                var title = ele.attr('title');

                if (title !== undefined) {
                    ele.data('cached-title', title).removeAttr('title');
                }

                return ele.data("cached-title");
            }
        },

        tip: "",

        boot: function() {

            // init code
            UI.$html.on("mouseenter.tooltip.uikit focus.tooltip.uikit", "[data-uk-tooltip]", function(e) {
                var ele = UI.$(this);

                if (!ele.data("tooltip")) {
                    UI.tooltip(ele, UI.Utils.options(ele.attr("data-uk-tooltip")));
                    ele.trigger("mouseenter");
                }
            });
        },

        init: function() {

            var $this = this;

            if (!$tooltip) {
                $tooltip = UI.$('<div class="uk-tooltip"></div>').appendTo("body");
            }

            this.on({
                focus      : function(e) { $this.show(); },
                blur       : function(e) { $this.hide(); },
                mouseenter : function(e) { $this.show(); },
                mouseleave : function(e) { $this.hide(); }
            });
        },

        show: function() {

            this.tip = typeof(this.options.src) === "function" ? this.options.src(this.element) : this.options.src;

            if (tooltipdelay)     clearTimeout(tooltipdelay);
            if (checkdelay)       clearTimeout(checkdelay);

            if (typeof(this.tip) === 'string' ? !this.tip.length:true) return;

            $tooltip.stop().css({"top": -2000, "visibility": "hidden"}).removeClass(this.options.activeClass).show();
            $tooltip.html('<div class="uk-tooltip-inner">' + this.tip + '</div>');

            var $this      = this,
                pos        = UI.$.extend({}, this.element.offset(), {width: this.element[0].offsetWidth, height: this.element[0].offsetHeight}),
                width      = $tooltip[0].offsetWidth,
                height     = $tooltip[0].offsetHeight,
                offset     = typeof(this.options.offset) === "function" ? this.options.offset.call(this.element) : this.options.offset,
                position   = typeof(this.options.pos) === "function" ? this.options.pos.call(this.element) : this.options.pos,
                tmppos     = position.split("-"),
                tcss       = {
                    "display"    : "none",
                    "visibility" : "visible",
                    "top"        : (pos.top + pos.height + height),
                    "left"       : pos.left
                };


            // prevent strange position
            // when tooltip is in offcanvas etc.
            if (UI.$html.css('position')=='fixed' || UI.$body.css('position')=='fixed'){
                var bodyoffset = UI.$('body').offset(),
                    htmloffset = UI.$('html').offset(),
                    docoffset  = {'top': (htmloffset.top + bodyoffset.top), 'left': (htmloffset.left + bodyoffset.left)};

                pos.left -= docoffset.left;
                pos.top  -= docoffset.top;
            }


            if ((tmppos[0] == "left" || tmppos[0] == "right") && UI.langdirection == 'right') {
                tmppos[0] = tmppos[0] == "left" ? "right" : "left";
            }

            var variants =  {
                "bottom"  : {top: pos.top + pos.height + offset, left: pos.left + pos.width / 2 - width / 2},
                "top"     : {top: pos.top - height - offset, left: pos.left + pos.width / 2 - width / 2},
                "left"    : {top: pos.top + pos.height / 2 - height / 2, left: pos.left - width - offset},
                "right"   : {top: pos.top + pos.height / 2 - height / 2, left: pos.left + pos.width + offset}
            };

            UI.$.extend(tcss, variants[tmppos[0]]);

            if (tmppos.length == 2) tcss.left = (tmppos[1] == 'left') ? (pos.left) : ((pos.left + pos.width) - width);

            var boundary = this.checkBoundary(tcss.left, tcss.top, width, height);

            if(boundary) {

                switch(boundary) {
                    case "x":

                        if (tmppos.length == 2) {
                            position = tmppos[0]+"-"+(tcss.left < 0 ? "left": "right");
                        } else {
                            position = tcss.left < 0 ? "right": "left";
                        }

                        break;

                    case "y":
                        if (tmppos.length == 2) {
                            position = (tcss.top < 0 ? "bottom": "top")+"-"+tmppos[1];
                        } else {
                            position = (tcss.top < 0 ? "bottom": "top");
                        }

                        break;

                    case "xy":
                        if (tmppos.length == 2) {
                            position = (tcss.top < 0 ? "bottom": "top")+"-"+(tcss.left < 0 ? "left": "right");
                        } else {
                            position = tcss.left < 0 ? "right": "left";
                        }

                        break;

                }

                tmppos = position.split("-");

                UI.$.extend(tcss, variants[tmppos[0]]);

                if (tmppos.length == 2) tcss.left = (tmppos[1] == 'left') ? (pos.left) : ((pos.left + pos.width) - width);
            }


            tcss.left -= UI.$body.position().left;

            tooltipdelay = setTimeout(function(){

                $tooltip.css(tcss).attr("class", ["uk-tooltip", "uk-tooltip-"+position, $this.options.cls].join(' '));

                if ($this.options.animation) {
                    $tooltip.css({opacity: 0, display: 'block'}).addClass($this.options.activeClass).animate({opacity: 1}, parseInt($this.options.animation, 10) || 400);
                } else {
                    $tooltip.show().addClass($this.options.activeClass);
                }

                tooltipdelay = false;

                // close tooltip if element was removed or hidden
                checkdelay = setInterval(function(){
                    if(!$this.element.is(':visible')) $this.hide();
                }, 150);

            }, parseInt(this.options.delay, 10) || 0);
        },

        hide: function() {
            if(this.element.is("input") && this.element[0]===document.activeElement) return;

            if(tooltipdelay) clearTimeout(tooltipdelay);
            if (checkdelay)  clearTimeout(checkdelay);

            $tooltip.stop();

            if (this.options.animation) {

                var $this = this;

                $tooltip.fadeOut(parseInt(this.options.animation, 10) || 400, function(){
                    $tooltip.removeClass($this.options.activeClass)
                });

            } else {
                $tooltip.hide().removeClass(this.options.activeClass);
            }
        },

        content: function() {
            return this.tip;
        },

        checkBoundary: function(left, top, width, height) {

            var axis = "";

            if(left < 0 || ((left - UI.$win.scrollLeft())+width) > window.innerWidth) {
               axis += "x";
            }

            if(top < 0 || ((top - UI.$win.scrollTop())+height) > window.innerHeight) {
               axis += "y";
            }

            return axis;
        }
    });

    return UI.tooltip;
});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-timepicker", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";


    UI.component('timepicker', {

        defaults: {
            format : '24h',
            delay  : 0,
            start  : 0,
            end    : 24
        },

        boot: function() {

            // init code
            UI.$html.on("focus.timepicker.uikit", "[data-uk-timepicker]", function(e) {

                var ele = UI.$(this);

                if (!ele.data("timepicker")) {
                    var obj = UI.timepicker(ele, UI.Utils.options(ele.attr("data-uk-timepicker")));

                    setTimeout(function(){
                        obj.autocomplete.input.focus();
                    }, 40);
                }
            });
        },

        init: function() {

            var $this  = this, times = getTimeRange(this.options.start, this.options.end), container;

            this.options.minLength = 0;
            this.options.template  = '<ul class="uk-nav uk-nav-autocomplete uk-autocomplete-results">{{~items}}<li data-value="{{$item.value}}"><a class="needsclick">{{$item.value}}</a></li>{{/items}}</ul>';

            this.options.source = function(release) {
                release(times[$this.options.format] || times['12h']);
            };

            if (this.element.is('input')) {
                this.element.wrap('<div class="uk-autocomplete"></div>');
                container = this.element.parent();
            } else {
                container = this.element.addClass('uk-autocomplete');
            }

            this.autocomplete = UI.autocomplete(container, this.options);
            this.autocomplete.dropdown.addClass('uk-dropdown-small uk-dropdown-scrollable');

            this.autocomplete.on('show.uk.autocomplete', function() {

                var selected = $this.autocomplete.dropdown.find('[data-value="'+$this.autocomplete.input.val()+'"]');

                setTimeout(function(){
                    $this.autocomplete.pick(selected, true);
                }, 10);
            });

            this.autocomplete.input.on('focus', function(){

                $this.autocomplete.value = Math.random();
                $this.autocomplete.triggercomplete();

            }).on('blur', UI.Utils.debounce(function() {
                $this.checkTime();
            }, 100));

            this.element.data("timepicker", this);
        },

        checkTime: function() {

            var arr, timeArray, meridian = 'AM', hour, minute, time = this.autocomplete.input.val();

            if (this.options.format == '12h') {
                arr = time.split(' ');
                timeArray = arr[0].split(':');
                meridian = arr[1];
            } else {
                timeArray = time.split(':');
            }

            hour   = parseInt(timeArray[0], 10);
            minute = parseInt(timeArray[1], 10);

            if (isNaN(hour))   hour = 0;
            if (isNaN(minute)) minute = 0;

            if (this.options.format == '12h') {
                if (hour > 12) {
                    hour = 12;
                } else if (hour < 0) {
                    hour = 12;
                }

                if (meridian === 'am' || meridian === 'a') {
                    meridian = 'AM';
                } else if (meridian === 'pm' || meridian === 'p') {
                    meridian = 'PM';
                }

                if (meridian !== 'AM' && meridian !== 'PM') {
                    meridian = 'AM';
                }

            } else {

                if (hour >= 24) {
                    hour = 23;
                } else if (hour < 0) {
                    hour = 0;
                }
            }

            if (minute < 0) {
                minute = 0;
            } else if (minute >= 60) {
                minute = 0;
            }

            this.autocomplete.input.val(this.formatTime(hour, minute, meridian)).trigger('change');
        },

        formatTime: function(hour, minute, meridian) {
            hour = hour < 10 ? '0' + hour : hour;
            minute = minute < 10 ? '0' + minute : minute;
            return hour + ':' + minute + (this.options.format == '12h' ? ' ' + meridian : '');
        }
    });

    // helper

    function getTimeRange(start, end) {

        start = start || 0;
        end   = end || 24;

        var times = {'12h':[], '24h':[]}, i, h;

        for (i = start, h=''; i<end; i++) {

            h = ''+i;

            if (i<10)  h = '0'+h;

            times['24h'].push({value: (h+':00')});
            times['24h'].push({value: (h+':30')});

            if (i === 0) {
                h = 12;
                times['12h'].push({value: (h+':00 AM')});
                times['12h'].push({value: (h+':30 AM')});
            }

            if (i > 0 && i<13 && i!==12) {
                times['12h'].push({value: (h+':00 AM')});
                times['12h'].push({value: (h+':30 AM')});
            }

            if (i >= 12) {

                h = h-12;
                if (h === 0) h = 12;
                if (h < 10) h = '0'+String(h);

                times['12h'].push({value: (h+':00 PM')});
                times['12h'].push({value: (h+':30 PM')});
            }
        }

        return times;
    }

});

/*! UIkit 2.24.3 | http://www.getuikit.com | (c) 2014 YOOtheme | MIT License */
(function(addon) {

    var component;

    if (window.UIkit) {
        component = addon(UIkit);
    }

    if (typeof define == "function" && define.amd) {
        define("uikit-upload", ["uikit"], function(){
            return component || addon(UIkit);
        });
    }

})(function(UI){

    "use strict";

    UI.component('uploadSelect', {

        init: function() {
            var $this = this;

            this.on("change", function() {
                xhrupload($this.element[0].files, $this.options);
                var twin = $this.element.clone(true).data('uploadSelect', $this);
                $this.element.replaceWith(twin);
                $this.element = twin;
            });
        }
    });

    UI.component('uploadDrop', {

        defaults: {
            'dragoverClass': 'uk-dragover'
        },

        init: function() {

            var $this = this, hasdragCls = false;

            this.on("drop", function(e){

                if (e.dataTransfer && e.dataTransfer.files) {

                    e.stopPropagation();
                    e.preventDefault();

                    $this.element.removeClass($this.options.dragoverClass);
                    $this.element.trigger('dropped.uk.upload', [e.dataTransfer.files]);

                    xhrupload(e.dataTransfer.files, $this.options);
                }

            }).on("dragenter", function(e){
                e.stopPropagation();
                e.preventDefault();
            }).on("dragover", function(e){
                e.stopPropagation();
                e.preventDefault();

                if (!hasdragCls) {
                    $this.element.addClass($this.options.dragoverClass);
                    hasdragCls = true;
                }
            }).on("dragleave", function(e){
                e.stopPropagation();
                e.preventDefault();
                $this.element.removeClass($this.options.dragoverClass);
                hasdragCls = false;
            });
        }
    });


    UI.support.ajaxupload = (function() {

        function supportFileAPI() {
            var fi = document.createElement('INPUT'); fi.type = 'file'; return 'files' in fi;
        }

        function supportAjaxUploadProgressEvents() {
            var xhr = new XMLHttpRequest(); return !! (xhr && ('upload' in xhr) && ('onprogress' in xhr.upload));
        }

        function supportFormData() {
            return !! window.FormData;
        }

        return supportFileAPI() && supportAjaxUploadProgressEvents() && supportFormData();
    })();

    if (UI.support.ajaxupload){
        UI.$.event.props.push("dataTransfer");
    }

    function xhrupload(files, settings) {

        if (!UI.support.ajaxupload){
            return this;
        }

        settings = UI.$.extend({}, xhrupload.defaults, settings);

        if (!files.length){
            return;
        }

        if (settings.allow !== '*.*') {

            for(var i=0,file;file=files[i];i++) {

                if(!matchName(settings.allow, file.name)) {

                    if(typeof(settings.notallowed) == 'string') {
                       alert(settings.notallowed);
                    } else {
                       settings.notallowed(file, settings);
                    }
                    return;
                }
            }
        }

        var complete = settings.complete;

        if (settings.single){

            var count    = files.length,
                uploaded = 0,
                allow    = true;

                settings.beforeAll(files);

                settings.complete = function(response, xhr){

                    uploaded = uploaded + 1;

                    complete(response, xhr);

                    if (settings.filelimit && uploaded >= settings.filelimit){
                        allow = false;
                    }

                    if (allow && uploaded<count){
                        upload([files[uploaded]], settings);
                    } else {
                        settings.allcomplete(response, xhr);
                    }
                };

                upload([files[0]], settings);

        } else {

            settings.complete = function(response, xhr){
                complete(response, xhr);
                settings.allcomplete(response, xhr);
            };

            upload(files, settings);
        }

        function upload(files, settings){

            // upload all at once
            var formData = new FormData(), xhr = new XMLHttpRequest();

            if (settings.before(settings, files)===false) return;

            for (var i = 0, f; f = files[i]; i++) { formData.append(settings.param, f); }
            for (var p in settings.params) { formData.append(p, settings.params[p]); }

            // Add any event handlers here...
            xhr.upload.addEventListener("progress", function(e){
                var percent = (e.loaded / e.total)*100;
                settings.progress(percent, e);
            }, false);

            xhr.addEventListener("loadstart", function(e){ settings.loadstart(e); }, false);
            xhr.addEventListener("load",      function(e){ settings.load(e);      }, false);
            xhr.addEventListener("loadend",   function(e){ settings.loadend(e);   }, false);
            xhr.addEventListener("error",     function(e){ settings.error(e);     }, false);
            xhr.addEventListener("abort",     function(e){ settings.abort(e);     }, false);

            xhr.open(settings.method, settings.action, true);

            if (settings.type=="json") {
                xhr.setRequestHeader("Accept", "application/json");
            }

            xhr.onreadystatechange = function() {

                settings.readystatechange(xhr);

                if (xhr.readyState==4){

                    var response = xhr.responseText;

                    if (settings.type=="json") {
                        try {
                            response = UI.$.parseJSON(response);
                        } catch(e) {
                            response = false;
                        }
                    }

                    settings.complete(response, xhr);
                }
            };
            settings.beforeSend(xhr);
            xhr.send(formData);
        }
    }

    xhrupload.defaults = {
        'action': '',
        'single': true,
        'method': 'POST',
        'param' : 'files[]',
        'params': {},
        'allow' : '*.*',
        'type'  : 'text',
        'filelimit': false,

        // events
        'before'          : function(o){},
        'beforeSend'      : function(xhr){},
        'beforeAll'       : function(){},
        'loadstart'       : function(){},
        'load'            : function(){},
        'loadend'         : function(){},
        'error'           : function(){},
        'abort'           : function(){},
        'progress'        : function(){},
        'complete'        : function(){},
        'allcomplete'     : function(){},
        'readystatechange': function(){},
        'notallowed'      : function(file, settings){ alert('Only the following file types are allowed: '+settings.allow); }
    };

    function matchName(pattern, path) {

        var parsedPattern = '^' + pattern.replace(/\//g, '\\/').
            replace(/\*\*/g, '(\\/[^\\/]+)*').
            replace(/\*/g, '[^\\/]+').
            replace(/((?!\\))\?/g, '$1.') + '$';

        parsedPattern = '^' + parsedPattern + '$';

        return (path.match(new RegExp(parsedPattern, 'i')) !== null);
    }

    UI.Utils.xhrupload = xhrupload;

    return xhrupload;
});

// http://getuikit.com/docs/documentation_javascript.html#js-override

if (typeof UIkit !== 'undefined') {
    UIkit.on('beforeready.uk.dom', function () {

        // accrodion
        if (typeof UIkit.components.accordion !== "undefined") { // check if accordion component is defined
            $.extend(UIkit.components.accordion.prototype.defaults, {
                easing: $.bez([ 0.4,0,0.2,1 ]),
                duration: 200
            });
        }

        // dropdown
        if (typeof UIkit.components.dropdown.prototype !== "undefined") { // check if dropdown component is defined

            $.extend(UIkit.components.dropdown.prototype.defaults, {
                remaintime: 150,
                delay: 50
            });

            (function() {
                var old_show_function = UIkit.components.dropdown.prototype.show;

                UIkit.components.dropdown.prototype.show = function() {

                    this.dropdown
                        .css({
                            'min-width': this.dropdown.outerWidth()
                        })
                        .addClass('uk-dropdown-active uk-dropdown-shown');

                    return old_show_function.apply(this, arguments);
                }
            })();

            (function() {
                var old_hide_function = UIkit.components.dropdown.prototype.hide;

                UIkit.components.dropdown.prototype.hide = function() {

                    var this_dropdown = this.dropdown;

                    this_dropdown.removeClass('uk-dropdown-shown');

                    var dropdown_timeout = setTimeout(function() {
                        this_dropdown.removeClass('uk-dropdown-active')
                    },280);

                    return old_hide_function.apply(this, arguments);
                }
            })();

        }

        // modal
        if (typeof UIkit.components.modal !== "undefined") { // check if modal component is defined
            $.extend(UIkit.components.modal.prototype.defaults, {
                center: true
            });

            UIkit.modal.dialog.template = '<div class="uk-modal uk-modal-dialog-replace"><div class="uk-modal-dialog" style="min-height:0;"></div></div>';
            $('body')
                .on('show.uk.modal', '.uk-modal-dialog-replace', function () {
                    // customize uikit dialog
                    setTimeout(function () {
                        var dialogReplace = $('.uk-modal-dialog-replace');
                        if (dialogReplace.find('.uk-button-primary').length) {
                            var actionBtn = dialogReplace.find('.uk-button-primary').toggleClass('uk-button-primary md-btn-flat-primary');
                            if (actionBtn.next('button')) {
                                actionBtn.next('button').after(actionBtn);
                            }
                        }
                        if (dialogReplace.find('.uk-button').length) {
                            dialogReplace.find('.uk-button').toggleClass('uk-button md-btn md-btn-flat');
                        }
                        if (dialogReplace.find('.uk-margin-small-top').length) {
                            dialogReplace.find('.uk-margin-small-top').toggleClass('uk-margin-small-top uk-margin-top');
                        }
                        var dialogInput = dialogReplace.find('input.uk-width-1-1');
                        if (dialogInput.length) {
                            dialogInput.toggleClass('uk-width-1-1 md-input');

                            if(!dialogInput.closest('.md-input-wrapper').length) {

                                dialogInput.wrap('<div class="md-input-wrapper"/>');
                                dialogInput
                                    .on('focus', function () {
                                        dialogInput.closest('.md-input-wrapper').addClass('md-input-focus')
                                    })
                                    .on('blur',function () {
                                        dialogInput.closest('.md-input-wrapper').removeClass('md-input-focus');
                                        if (dialogInput.val() != '') {
                                            dialogInput.closest('.md-input-wrapper').addClass('md-input-filled')
                                        } else {
                                            dialogInput.closest('.md-input-wrapper').removeClass('md-input-filled')
                                        }
                                    })
                                    .closest('.md-input-wrapper').append('<span class="md-input-bar"/>');
                            }

                            if (dialogInput.val() != '') {
                                dialogInput.closest('.md-input-wrapper').addClass('md-input-filled')
                            }

                        }
                        if (dialogReplace.find('.uk-form').length) {
                            dialogReplace.find('.uk-form').removeClass('uk-form');
                        }
                    }, 50)
                });
        }

        // tooltip
        if (typeof UIkit.components.tooltip !== "undefined") { // check if tooltip component is defined
            $.extend(UIkit.components.tooltip.prototype.defaults, {
                animation: 280,
                offset: 8
            });
        }

        // sortable
        if (typeof UIkit.components.sortable !== "undefined") { // check if sortable component is defined
            if(Modernizr.touch) {
                $('[data-uk-sortable]').children().addClass('needsclick');
            }
        }

    });
}

// uikit custom
altair_uikit = {
    reinitialize_grid_margin: function() {
        $("[data-uk-grid-margin]").each(function() {
            var element = $(this);
            if (!element.data("gridMargin")) {
                $.UIkit.gridMargin(element, $.UIkit.Utils.options(element.attr("data-uk-grid-margin")));
            }
        });
        $(window).resize();
    }
};


/*!
* DataTables UIKit integration
* author: tzd
*/

(function(window, document, undefined){

    var factory = function( $, DataTable ) {
        "use strict";


        /* Set the defaults for DataTables initialisation */
        $.extend( true, DataTable.defaults, {
            dom:
            "<'dt-uikit-header'<'uk-grid'<'uk-width-medium-2-3'l><'uk-width-medium-1-3'f>>>" +
            "<'uk-overflow-container'tr>" +
            "<'dt-uikit-footer'<'uk-grid'<'uk-width-medium-3-10'i><'uk-width-medium-7-10'p>>>",
            renderer: 'uikit',
            "order": []
        } );


        /* Default class modification */
        $.extend( DataTable.ext.classes, {
            sWrapper:      "dataTables_wrapper form-inline dt-uikit",
            sFilterInput:  "md-input",
            sLengthSelect: "dt-selectize",
            "sPaging":     ""
        } );

        /* Bootstrap paging button renderer */
        DataTable.ext.renderer.pageButton.uikit = function ( settings, host, idx, buttons, page, pages ) {
            var api     = new DataTable.Api( settings );
            var classes = settings.oClasses;
            var lang    = settings.oLanguage.oPaginate;
            var btnDisplay, btnClass, counter=0;

            var attach = function( container, buttons ) {
                var i, ien, node, button;
                var clickHandler = function ( e ) {
                    e.preventDefault();
                    if ( !$(e.currentTarget).hasClass('disabled') ) {
                        api.page( e.data.action ).draw( false );
                    }
                };

                for ( i=0, ien=buttons.length ; i<ien ; i++ ) {
                    button = buttons[i];

                    if ( $.isArray( button ) ) {
                        attach( container, button );
                    }
                    else {
                        btnDisplay = '';
                        btnClass = '';

                        switch ( button ) {
                            case 'ellipsis':
                                btnDisplay = '&hellip;';
                                btnClass = 'uk-disabled';
                                break;

                            case 'first':
                                btnDisplay = '<i class="uk-icon-angle-double-left"/>';
                                btnClass = button + (page > 0 ?
                                    '' : ' uk-disabled');
                                break;

                            case 'previous':
                                btnDisplay = lang.sPrevious;
                                btnClass = button + (page > 0 ?
                                    '' : ' uk-disabled');
                                break;

                            case 'next':
                                btnDisplay = lang.sNext;
                                btnClass = button + (page < pages-1 ?
                                    '' : ' uk-disabled');
                                break;

                            case 'last':
                                btnDisplay = '<i class="uk-icon-angle-double-right"/>';
                                btnClass = button + (page < pages-1 ?
                                    '' : ' uk-disabled');
                                break;

                            default:
                                btnDisplay = button + 1;
                                btnClass = page === button ?
                                    'uk-active' : '';
                                break;
                        }

                        if ( btnDisplay ) {
                            node = $('<li>', {
                                'class': classes.sPageButton+' '+btnClass,
                                'id': idx === 0 && typeof button === 'string' ?
                                settings.sTableId +'_'+ button :
                                    null
                            } )
                                .append( $('<a>', {
                                    'href': '#',
                                    'aria-controls': settings.sTableId,
                                    'data-dt-idx': counter,
                                    'tabindex': settings.iTabIndex
                                } )
                                    .html( btnDisplay )
                            )
                                .appendTo( container );

                            settings.oApi._fnBindAction(
                                node, {action: button}, clickHandler
                            );

                            counter++;
                        }
                    }
                }
            };

            var activeEl;

            try {
                activeEl = $(document.activeElement).data('dt-idx');
            }
            catch (e) {}

            attach(
                $(host).empty().html('<ul class="uk-pagination"/>').children('ul'),
                buttons
            );

            if ( activeEl ) {
                $(host).find( '[data-dt-idx='+activeEl+']' ).focus();
            }
        };


        /*
         * TableTools uikit compatibility
        */
        if ( DataTable.TableTools ) {
            $.extend( true, DataTable.TableTools.classes, {
                "container": "DTTT uk-text-right",
                "buttons": {
                    "normal": "md-btn DTTT_btn",
                    "disabled": "md-btn-disabled"
                },
                "collection": {
                    "container": "DTTT_dropdown dropdown-menu",
                    "buttons": {
                        "normal": "",
                        "disabled": "disabled"
                    }
                },
                "print": {
                    "info": "DTTT_print_info"
                },
                "select": {
                    "row": "active"
                }
            } );

            // Have the collection use a uikit compatible drop down
            $.extend( true, DataTable.TableTools.DEFAULTS.oTags, {
                "collection": {
                    "container": "ul",
                    "button": "li",
                    "liner": "a"
                }
            } );
        }


    };

    setTimeout(function() {
        $('body').on( 'init.dt', '.dt-uikit', function () {
            var $this = $(this);
            if(!$this.hasClass('md-processed')) {
                var dt_filter = $(this).find('.dataTables_filter'),
                    search_label = dt_filter.children('label').text();

                dt_filter.find('.md-input').attr('placeholder',search_label).unwrap();

                dt_filter.contents().filter(function(){
                    return (this.nodeType == 3);
                }).remove();

                $this
                    .find('.md-input').attr({
                        'md-input': ''
                    })
                    .end()
                    // initilaize selectize
                    .find('.dt-selectize').selectize({
                        onDropdownOpen: function($dropdown) {
                            $dropdown
                                .hide()
                                .velocity('slideDown', {
                                    duration: 280,
                                    easing: [ 0.4,0,0.2,1 ]
                                })
                        },
                        onDropdownClose: function($dropdown) {
                            $dropdown
                                .show()
                                .velocity('slideUp', {
                                    duration: 280,
                                    easing: [ 0.4,0,0.2,1 ]
                                })
                        }
                    })
                    .end()
                    .find('.ColVis_MasterButton').addClass('md-btn')
                    .end()
                    .addClass('md-processed');
            }
        })
    });


// Define as an AMD module if possible
    if ( typeof define === 'function' && define.amd ) {
        define( ['jquery', 'datatables'], factory );
    }
    else if ( typeof exports === 'object' ) {
        // Node/CommonJS
        factory( require('jquery'), require('datatables') );
    }
    else if ( jQuery ) {
        // Otherwise simply initialise as normal, stopping multiple evaluation
        factory( jQuery, jQuery.fn.dataTable );
    }


})(window, document);
/*
* File:        jquery.dataTables.columnFilter.js
* Version:     1.5.6.
* Author:      Jovan Popovic 
* 
* Copyright 2011-2014 Jovan Popovic, all rights reserved.
*
* This source file is free software, under either the GPL v2 license or a
* BSD style license, as supplied with this software.
* 
* This source file is distributed in the hope that it will be useful, but 
* WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY 
* or FITNESS FOR A PARTICULAR PURPOSE. 
* 
* Parameters:"
* @sPlaceHolder                 String      Place where inline filtering function should be placed ("tfoot", "thead:before", "thead:after"). Default is "tfoot"
* @sRangeSeparator              String      Separator that will be used when range values are sent to the server-side. Default value is "~".
* @sRangeFormat                 string      Default format of the From ... to ... range inputs. Default is From {from} to {to}
* @aoColumns                    Array       Array of the filter settings that will be applied on the columns
*/
(function ($) {


    $.fn.columnFilter = function (options) {

        var asInitVals, i, label, th;

        //var sTableId = "table";
        var sRangeFormat = "From {from} to {to}";
        //Array of the functions that will override sSearch_ parameters
        var afnSearch_ = new Array();
        var aiCustomSearch_Indexes = new Array();

        var oFunctionTimeout = null;

        var fnOnFiltered = function () { };

        function _fnGetColumnValues(oSettings, iColumn, bUnique, bFiltered, bIgnoreEmpty) {
            ///<summary>
            ///Return values in the column
            ///</summary>
            ///<param name="oSettings" type="Object">DataTables settings</param>
            ///<param name="iColumn" type="int">Id of the column</param>
            ///<param name="bUnique" type="bool">Return only distinct values</param>
            ///<param name="bFiltered" type="bool">Return values only from the filtered rows</param>
            ///<param name="bIgnoreEmpty" type="bool">Ignore empty cells</param>

            // check that we have a column id
            if (typeof iColumn == "undefined") return new Array();

            // by default we only wany unique data
            if (typeof bUnique == "undefined") bUnique = true;

            // by default we do want to only look at filtered data
            if (typeof bFiltered == "undefined") bFiltered = true;

            // by default we do not wany to include empty values
            if (typeof bIgnoreEmpty == "undefined") bIgnoreEmpty = true;

            // list of rows which we're going to loop through
            var aiRows;

            // use only filtered rows
            if (bFiltered == true) aiRows = oSettings.aiDisplay;
            // use all rows
            else aiRows = oSettings.aiDisplayMaster; // all row numbers

            // set up data array	
            var asResultData = new Array();

            for (var i = 0, c = aiRows.length; i < c; i++) {
                var iRow = aiRows[i];
                var aData = oTable.fnGetData(iRow);
                var sValue = aData[iColumn];

                // ignore empty values?
                if (bIgnoreEmpty == true && sValue.length == 0) continue;

                // ignore unique values?
                else if (bUnique == true && jQuery.inArray(sValue, asResultData) > -1) continue;

                // else push the value onto the result data array
                else asResultData.push(sValue);
            }

            return asResultData.sort();
        }

        function _fnColumnIndex(iColumnIndex) {
            if (properties.bUseColVis)
                return iColumnIndex;
            else
                return oTable.fnSettings().oApi._fnVisibleToColumnIndex(oTable.fnSettings(), iColumnIndex);
            //return iColumnIndex;
            //return oTable.fnSettings().oApi._fnColumnIndexToVisible(oTable.fnSettings(), iColumnIndex);
        }

        function fnCreateInput(oTable, regex, smart, bIsNumber, iFilterLength, iMaxLenght) {
            var sCSSClass = "text_filter form-control";
            if (bIsNumber)
                sCSSClass = "number_filter form-control";

            label = label.replace(/(^\s*)|(\s*$)/g, "");
            var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
            var search_init = 'search_init ';
            var inputvalue = label;
            if (currentFilter != '' && currentFilter != '^') {
                if (bIsNumber && currentFilter.charAt(0) == '^')
                    inputvalue = currentFilter.substr(1); //ignore trailing ^
                else
                    inputvalue = currentFilter;
                search_init = '';
            }

            var input = $('<input type="text" class="md-input ' + search_init + sCSSClass + '" value="' + inputvalue + '" rel="' + i + '" md-input />');
            if (iMaxLenght != undefined && iMaxLenght != -1) {
                input.attr('maxlength', iMaxLenght);
            }
            th.html(input);
            if (bIsNumber)
                th.wrapInner('<span class="filter_column filter_number" />');
            else
                th.wrapInner('<span class="filter_column filter_text" />');

            asInitVals[i] = label;
            var index = i;

            if (bIsNumber && !oTable.fnSettings().oFeatures.bServerSide) {
                input.keyup(function () {
                    /* Filter on the column all numbers that starts with the entered value */
                    oTable.fnFilter('^' + this.value, _fnColumnIndex(index), true, false); //Issue 37
                    fnOnFiltered();
                });
            } else {
                input.keyup(function () {
                    if (oTable.fnSettings().oFeatures.bServerSide && iFilterLength != 0) {
                        //If filter length is set in the server-side processing mode
                        //Check has the user entered at least iFilterLength new characters

                        var currentFilter = oTable.fnSettings().aoPreSearchCols[index].sSearch;
                        var iLastFilterLength = $(this).data("dt-iLastFilterLength");
                        if (typeof iLastFilterLength == "undefined")
                            iLastFilterLength = 0;
                        var iCurrentFilterLength = this.value.length;
                        if (Math.abs(iCurrentFilterLength - iLastFilterLength) < iFilterLength
                        //&& currentFilter.length == 0 //Why this?
					        ) {
                            //Cancel the filtering
                            return;
                        }
                        else {
                            //Remember the current filter length
                            $(this).data("dt-iLastFilterLength", iCurrentFilterLength);
                        }
                    }
                    /* Filter on the column (the index) of this element */
                    oTable.fnFilter(this.value, _fnColumnIndex(index), regex, smart); //Issue 37
                    fnOnFiltered();
                });
            }

            input.focus(function () {
                if ($(this).hasClass("search_init")) {
                    $(this).removeClass("search_init");
                    this.value = "";
                }
            });
            input.blur(function () {
                if (this.value == "") {
                    $(this).addClass("search_init");
                    this.value = asInitVals[index];
                }
            });
        }

        function fnCreateRangeInput(oTable) {

			//var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
            th.html(_fnRangeLabelPart(0));
            var sFromId = oTable.attr("id") + '_range_from_' + i;
            var from = $('<input type="text" class="number_range_filter form-control" id="' + sFromId + '" rel="' + i + '"/>');
            th.append(from);
            th.append(_fnRangeLabelPart(1));
            var sToId = oTable.attr("id") + '_range_to_' + i;
            var to = $('<input type="text" class="number_range_filter form-control" id="' + sToId + '" rel="' + i + '"/>');
            th.append(to);
            th.append(_fnRangeLabelPart(2));
            th.wrapInner('<span class="filter_column filter_number_range form-control" />');
            var index = i;
            aiCustomSearch_Indexes.push(i);



            //------------start range filtering function


            /* 	Custom filtering function which will filter data in column four between two values
            *	Author: 	Allan Jardine, Modified by Jovan Popovic
            */
            //$.fn.dataTableExt.afnFiltering.push(
            oTable.dataTableExt.afnFiltering.push(
	        function (oSettings, aData, iDataIndex) {
	            if (oTable.attr("id") != oSettings.sTableId)
	                return true;
	            // Try to handle missing nodes more gracefully
	            if (document.getElementById(sFromId) == null)
	                return true;
	            var iMin = document.getElementById(sFromId).value * 1;
	            var iMax = document.getElementById(sToId).value * 1;
	            var iValue = aData[_fnColumnIndex(index)] == "-" ? 0 : aData[_fnColumnIndex(index)] * 1;
	            if (iMin == "" && iMax == "") {
	                return true;
	            }
	            else if (iMin == "" && iValue <= iMax) {
	                return true;
	            }
	            else if (iMin <= iValue && "" == iMax) {
	                return true;
	            }
	            else if (iMin <= iValue && iValue <= iMax) {
	                return true;
	            }
	            return false;
	        }
        );
            //------------end range filtering function



            $('#' + sFromId + ',#' + sToId, th).keyup(function () {

                var iMin = document.getElementById(sFromId).value * 1;
                var iMax = document.getElementById(sToId).value * 1;
                if (iMin != 0 && iMax != 0 && iMin > iMax)
                    return;

                oTable.fnDraw();
                fnOnFiltered();
            });


        }


        function fnCreateDateRangeInput(oTable) {

            var aoFragments = sRangeFormat.split(/[}{]/);

            th.html("");
            //th.html(_fnRangeLabelPart(0));
            var sFromId = oTable.attr("id") + '_range_from_' + i;
            var from = $('<input type="text" class="date_range_filter form-control" id="' + sFromId + '" rel="' + i + '"/>');
            from.datepicker();
            //th.append(from);
            //th.append(_fnRangeLabelPart(1));
            var sToId = oTable.attr("id") + '_range_to_' + i;
            var to = $('<input type="text" class="date_range_filter form-control" id="' + sToId + '" rel="' + i + '"/>');
            //th.append(to);
            //th.append(_fnRangeLabelPart(2));

            for (ti = 0; ti < aoFragments.length; ti++) {

                if (aoFragments[ti] == properties.sDateFromToken) {
                    th.append(from);
                } else {
                    if (aoFragments[ti] == properties.sDateToToken) {
                        th.append(to);
                    } else {
                        th.append(aoFragments[ti]);
                    }
                }
                

            }


            th.wrapInner('<span class="filter_column filter_date_range" />');
            to.datepicker();
            var index = i;
            aiCustomSearch_Indexes.push(i);


            //------------start date range filtering function

            //$.fn.dataTableExt.afnFiltering.push(
            oTable.dataTableExt.afnFiltering.push(
	        function (oSettings, aData, iDataIndex) {
	            if (oTable.attr("id") != oSettings.sTableId)
	                return true;

	            var dStartDate = from.datepicker("getDate");

	            var dEndDate = to.datepicker("getDate");

	            if (dStartDate == null && dEndDate == null) {
	                return true;
	            }

	            var dCellDate = null;
	            try {
	                if (aData[_fnColumnIndex(index)] == null || aData[_fnColumnIndex(index)] == "")
	                    return false;
	                dCellDate = $.datepicker.parseDate($.datepicker.regional[""].dateFormat, aData[_fnColumnIndex(index)]);
	            } catch (ex) {
	                return false;
	            }
	            if (dCellDate == null)
	                return false;


	            if (dStartDate == null && dCellDate <= dEndDate) {
	                return true;
	            }
	            else if (dStartDate <= dCellDate && dEndDate == null) {
	                return true;
	            }
	            else if (dStartDate <= dCellDate && dCellDate <= dEndDate) {
	                return true;
	            }
	            return false;
	        }
        );
            //------------end date range filtering function

            $('#' + sFromId + ',#' + sToId, th).change(function () {
                oTable.fnDraw();
                fnOnFiltered();
            });


        }

        function fnCreateColumnSelect(oTable, aData, iColumn, nTh, sLabel, bRegex, oSelected, bMultiselect) {
            if (aData == null)
                aData = _fnGetColumnValues(oTable.fnSettings(), iColumn, true, false, true);
            var index = iColumn;
            var currentFilter = oTable.fnSettings().aoPreSearchCols[i].sSearch;
            if (currentFilter == null || currentFilter == "")//Issue 81
                currentFilter = oSelected;

            var r = '<select class="search_init select_filter form-control" rel="' + i + '"><option value="" class="search_init">' + sLabel + '</option>';
			if(bMultiselect) {
				r = '<select class="search_init select_filter form-control" rel="' + i + '" multiple>';
			}
            var j = 0;
            var iLen = aData.length;
            for (j = 0; j < iLen; j++) {
                if (typeof (aData[j]) != 'object') {
                    var selected = '';
                    if (escape(aData[j]) == currentFilter
                        || escape(aData[j]) == escape(currentFilter)
                        )
                        selected = 'selected '
                    r += '<option ' + selected + ' value="' + escape(aData[j]) + '">' + aData[j] + '</option>';
                }
                else {
                    var selected = '';
                    if (bRegex) {
                        //Do not escape values if they are explicitely set to avoid escaping special characters in the regexp
                        if (aData[j].value == currentFilter) selected = 'selected ';
                        r += '<option ' + selected + 'value="' + aData[j].value + '">' + aData[j].label + '</option>';
                    } else {
                        if (escape(aData[j].value) == currentFilter) selected = 'selected ';
                        r += '<option ' + selected + 'value="' + escape(aData[j].value) + '">' + aData[j].label + '</option>';
                    }
                }
            }

            var select = $(r + '</select>');
            nTh.html(select);
            nTh.wrapInner('<span class="filter_column filter_select" />');
			
			if(bMultiselect) {
				select.change(function () {
					if ($(this).val() != "") {
						$(this).removeClass("search_init");
					} else {
						$(this).addClass("search_init");
					}
					var selectedOptions = $(this).val();
					var asEscapedFilters = [];
					if(selectedOptions==null || selectedOptions==[]){
						var re = '^(.*)$';
					}else{
						$.each( selectedOptions, function( i, sFilter ) {
							asEscapedFilters.push( fnRegExpEscape( sFilter ) );
						} );
						var re = '^(' + asEscapedFilters.join('|') + ')$';
					}
					 
					oTable.fnFilter( re, index, true, false );
				});
			} else {
				select.change(function () {
					//var val = $(this).val();
					if ($(this).val() != "") {
						$(this).removeClass("search_init");
					} else {
						$(this).addClass("search_init");
					}
					if (bRegex)
						oTable.fnFilter($(this).val(), iColumn, bRegex); //Issue 41
					else
						oTable.fnFilter(unescape($(this).val()), iColumn); //Issue 25
					fnOnFiltered();
				});
				if (currentFilter != null && currentFilter != "")//Issue 81
					oTable.fnFilter(unescape(currentFilter), iColumn);
			}
        }

        function fnCreateSelect(oTable, aData, bRegex, oSelected, bMultiselect) {
            var oSettings = oTable.fnSettings();
            if ( (aData == null || typeof(aData) == 'function' ) && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
                // Add a function to the draw callback, which will check for the Ajax data having 
                // been loaded. Use a closure for the individual column elements that are used to 
                // built the column filter, since 'i' and 'th' (etc) are locally "global".
                oSettings.aoDrawCallback.push({
                    "fn": (function (iColumn, nTh, sLabel) {
                        return function (oSettings) {
                            // Only rebuild the select on the second draw - i.e. when the Ajax
                            // data has been loaded.
                            if (oSettings.iDraw == 2 && oSettings.sAjaxSource != null && oSettings.sAjaxSource != "" && !oSettings.oFeatures.bServerSide) {
                                return fnCreateColumnSelect(oTable, aData && aData(oSettings.aoData, oSettings), _fnColumnIndex(iColumn), nTh, sLabel, bRegex, oSelected, bMultiselect); //Issue 37
                            }
                        };
                    })(i, th, label),
                    "sName": "column_filter_" + i
                });
            }
            // Regardless of the Ajax state, build the select on first pass
            fnCreateColumnSelect(oTable, typeof(aData) == 'function' ? null: aData, _fnColumnIndex(i), th, label, bRegex, oSelected, bMultiselect); //Issue 37

        }
		 
		function fnRegExpEscape( sText ) { 
			return sText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"); 
		};

		function fnCreateDropdown(aData) {
			var index = i;
			var r = '<div class="dropdown select_filter form-control"><a class="dropdown-toggle" data-toggle="dropdown" href="#">' + label + '<b class="caret"></b></a><ul class="dropdown-menu" role="menu"><li data-value=""><a>Show All</a></li>', j, iLen = aData.length;

			for (j = 0; j < iLen; j++) {
				r += '<li data-value="' + aData[j] + '"><a>' + aData[j] + '</a></li>';
			}
			var select = $(r + '</ul></div>');
			th.html(select);
			th.wrapInner('<span class="filterColumn filter_select" />');
			select.find('li').click(function () {
				oTable.fnFilter($(this).data('value'), index);
			});
		}
		
		
        function fnCreateCheckbox(oTable, aData) {

            if (aData == null)
                aData = _fnGetColumnValues(oTable.fnSettings(), i, true, true, true);
            var index = i;

            var r = '', j, iLen = aData.length;

            //clean the string
            var localLabel = label.replace('%', 'Perc').replace("&", "AND").replace("$", "DOL").replace("£", "STERL").replace("@", "AT").replace(/\s/g, "_");
            localLabel = localLabel.replace(/[^a-zA-Z 0-9]+/g, '');
            //clean the string

            //button label override
            var labelBtn = label;
            if (properties.sFilterButtonText != null || properties.sFilterButtonText != undefined) {
                labelBtn = properties.sFilterButtonText;
            }

            var relativeDivWidthToggleSize = 10;
            var numRow = 12; //numero di checkbox per colonna
            var numCol = Math.floor(iLen / numRow);
            if (iLen % numRow > 0) {
                numCol = numCol + 1;
            };

            //count how many column should be generated and split the div size
            var divWidth = 100 / numCol - 2;

            var divWidthToggle = relativeDivWidthToggleSize * numCol;

            if (numCol == 1) {
                divWidth = 20;
            }

            var divRowDef = '<div style="float:left; min-width: ' + divWidth + '%; " >';
            var divClose = '</div>';

            var uniqueId = oTable.attr("id") + localLabel;
            var buttonId = "chkBtnOpen" + uniqueId;
            var checkToggleDiv = uniqueId + "-flt-toggle";
            r += '<button id="' + buttonId + '" class="checkbox_filter btn btn-default" > ' + labelBtn + '</button>'; //filter button witch open dialog
            r += '<div id="' + checkToggleDiv + '" '
            	+ 'title="' + label + '" '
                + 'rel="' + i + '" '
            	+ 'class="toggle-check ui-widget-content ui-corner-all"  style="width: ' + (divWidthToggle) + '%; " >'; //dialog div
            //r+= '<div align="center" style="margin-top: 5px; "> <button id="'+buttonId+'Reset" class="checkbox_filter" > reset </button> </div>'; //reset button and its div
            r += divRowDef;

            for (j = 0; j < iLen; j++) {

                //if last check close div
                if (j % numRow == 0 && j != 0) {
                    r += divClose + divRowDef;
                }

                var sLabel = aData[j];
                var sValue = aData[j];

                if (typeof (aData[j]) == 'object') {
                    sLabel = aData[j].label;
                    sValue = aData[j].value;
                }

                //check button
                r += '<input class="search_init checkbox_filter btn btn-default" type="checkbox" id= "' + uniqueId + '_cb_' + sValue + '" name= "' + localLabel + '" value="' + sValue + '" >' + sLabel + '<br/>';

                var checkbox = $(r);
                th.html(checkbox);
                th.wrapInner('<span class="filter_column filter_checkbox" />');
                //on every checkbox selection
                checkbox.change(function () {

                    var search = '';
                    var or = '|'; //var for select checks in 'or' into the regex
                    var resSize = $('input:checkbox[name="' + localLabel + '"]:checked').size();
                    $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index) {

                        //search = search + ' ' + $(this).val();
                        //concatenation for selected checks in or
                        if ((index == 0 && resSize == 1)
                				|| (index != 0 && index == resSize - 1)) {
                            or = '';
                        }
                        //trim
                        search = search.replace(/^\s+|\s+$/g, "");
                        search = search + $(this).val() + or;
                        or = '|';

                    });


                    if (search != "") {
                        $('input:checkbox[name="' + localLabel + '"]').removeClass("search_init");
                    } else {
                        $('input:checkbox[name="' + localLabel + '"]').addClass("search_init");
                    }
                    /* Old code for setting search_init CSS class on checkboxes if any of them is checked
                    for (var jj = 0; jj < iLen; jj++) {
                        if (search != "") {
                            $('#' + aData[jj]).removeClass("search_init");
                        } else {
                            $('#' + aData[jj]).addClass("search_init");
                        }
                    }
                    */

                    //execute search
                    oTable.fnFilter(search, index, true, false);
                    fnOnFiltered();
                });
            }

            //filter button
            $('#' + buttonId).button();
            //dialog
            $('#' + checkToggleDiv).dialog({
                //height: 140,
                autoOpen: false,
                //show: "blind",
                hide: "blind",
                buttons: [{
                    text: "Reset",
                    click: function () {
                        //$('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
                        $('input:checkbox[name="' + localLabel + '"]:checked').each(function (index3) {
                            $(this).attr('checked', false);
                            $(this).addClass("search_init");
                        });
                        oTable.fnFilter('', index, true, false);
                        fnOnFiltered();
                        return false;
                    }
                },
							{
							    text: "Close",
							    click: function () { $(this).dialog("close"); }
							}
						]
            });


            $('#' + buttonId).click(function () {

                $('#' + checkToggleDiv).dialog('open');
                var target = $(this);
                $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
                    at: 'bottom',
                    of: target
                });

                return false;
            });

            var fnOnFilteredCurrent = fnOnFiltered;

            fnOnFiltered = function () {
                var target = $('#' + buttonId);
                $('#' + checkToggleDiv).dialog("widget").position({ my: 'top',
                    at: 'bottom',
                    of: target
                });
                fnOnFilteredCurrent();
            };
            //reset
            /*
            $('#'+buttonId+"Reset").button();
            $('#'+buttonId+"Reset").click(function(){
            $('#'+buttonId).removeClass("filter_selected"); //LM remove border if filter selected
            $('input:checkbox[name="'+localLabel+'"]:checked').each(function(index3) {
            $(this).attr('checked', false);
            $(this).addClass("search_init");
            });
            oTable.fnFilter('', index, true, false);
            return false;
            }); 
            */
        }




        function _fnRangeLabelPart(iPlace) {
            switch (iPlace) {
                case 0:
                    return sRangeFormat.substring(0, sRangeFormat.indexOf("{from}"));
                case 1:
                    return sRangeFormat.substring(sRangeFormat.indexOf("{from}") + 6, sRangeFormat.indexOf("{to}"));
                default:
                    return sRangeFormat.substring(sRangeFormat.indexOf("{to}") + 4);
            }
        }




        var oTable = this;

        var defaults = {
            sPlaceHolder: "foot",
            sRangeSeparator: "~",
            iFilteringDelay: 500,
            aoColumns: null,
            sRangeFormat: "From {from} to {to}",
            sDateFromToken: "from",
            sDateToToken: "to"
        };

        var properties = $.extend(defaults, options);

        return this.each(function () {

            if (!oTable.fnSettings().oFeatures.bFilter)
                return;
            asInitVals = new Array();

            var aoFilterCells = oTable.fnSettings().aoFooter[0];

            var oHost = oTable.fnSettings().nTFoot; //Before fix for ColVis
            var sFilterRow = "tr"; //Before fix for ColVis

            if (properties.sPlaceHolder == "head:after") {
                var tr = $("tr:first", oTable.fnSettings().nTHead).detach();
                //tr.appendTo($(oTable.fnSettings().nTHead));
                if (oTable.fnSettings().bSortCellsTop) {
                    tr.prependTo($(oTable.fnSettings().nTHead));
                    //tr.appendTo($("thead", oTable));
                    aoFilterCells = oTable.fnSettings().aoHeader[1];
                }
                else {
                    tr.appendTo($(oTable.fnSettings().nTHead));
                    //tr.prependTo($("thead", oTable));
                    aoFilterCells = oTable.fnSettings().aoHeader[0];
                }

                sFilterRow = "tr:last";
                oHost = oTable.fnSettings().nTHead;

            } else if (properties.sPlaceHolder == "head:before") {

                if (oTable.fnSettings().bSortCellsTop) {
                    var tr = $("tr:first", oTable.fnSettings().nTHead).detach();
                    tr.appendTo($(oTable.fnSettings().nTHead));
                    aoFilterCells = oTable.fnSettings().aoHeader[1];
                } else {
                    aoFilterCells = oTable.fnSettings().aoHeader[0];
                }
                /*else {
                //tr.prependTo($("thead", oTable));
                sFilterRow = "tr:first";
                }*/

                sFilterRow = "tr:first";

                oHost = oTable.fnSettings().nTHead;

                
            }

            //$(sFilterRow + " th", oHost).each(function (index) {//bug with ColVis
            $(aoFilterCells).each(function (index) {//fix for ColVis
                i = index;
                var aoColumn = { type: "text",
                    bRegex: false,
                    bSmart: true,
                    iMaxLenght: -1,
                    iFilterLength: 0
                };
                if (properties.aoColumns != null) {
                    if (properties.aoColumns.length < i || properties.aoColumns[i] == null)
                        return;
                    aoColumn = properties.aoColumns[i];
                }
                //label = $(this).text(); //Before fix for ColVis
                label = $($(this)[0].cell).text(); //Fix for ColVis
                if (aoColumn.sSelector == null) {
                    //th = $($(this)[0]);//Before fix for ColVis
                    th = $($(this)[0].cell); //Fix for ColVis
                }
                else {
                    th = $(aoColumn.sSelector);
                    if (th.length == 0)
                        th = $($(this)[0].cell);
                }

                if (aoColumn != null) {
                    if (aoColumn.sRangeFormat != null)
                        sRangeFormat = aoColumn.sRangeFormat;
                    else
                        sRangeFormat = properties.sRangeFormat;
                    switch (aoColumn.type) {
                        case "null":
                            break;
                        case "number":
                            fnCreateInput(oTable, true, false, true, aoColumn.iFilterLength, aoColumn.iMaxLenght);
                            break;
                        case "select":
                            if (aoColumn.bRegex != true)
                                aoColumn.bRegex = false;
                            fnCreateSelect(oTable, aoColumn.values, aoColumn.bRegex, aoColumn.selected, aoColumn.multiple);
                            break;
                        case "number-range":
                            fnCreateRangeInput(oTable);
                            break;
                        case "date-range":
                            fnCreateDateRangeInput(oTable);
                            break;
                        case "checkbox":
                            fnCreateCheckbox(oTable, aoColumn.values);
                            break;
						case "twitter-dropdown":
						case "dropdown":
                            fnCreateDropdown(aoColumn.values);
                            break;
                        case "text":
                        default:
                            bRegex = (aoColumn.bRegex == null ? false : aoColumn.bRegex);
                            bSmart = (aoColumn.bSmart == null ? false : aoColumn.bSmart);
                            fnCreateInput(oTable, bRegex, bSmart, false, aoColumn.iFilterLength, aoColumn.iMaxLenght);
                            break;

                    }
                }
            });

            for (j = 0; j < aiCustomSearch_Indexes.length; j++) {
                //var index = aiCustomSearch_Indexes[j];
                var fnSearch_ = function () {
                    var id = oTable.attr("id");
                    return $("#" + id + "_range_from_" + aiCustomSearch_Indexes[j]).val() + properties.sRangeSeparator + $("#" + id + "_range_to_" + aiCustomSearch_Indexes[j]).val()
                }
                afnSearch_.push(fnSearch_);
            }

            if (oTable.fnSettings().oFeatures.bServerSide) {

                var fnServerDataOriginal = oTable.fnSettings().fnServerData;

                oTable.fnSettings().fnServerData = function (sSource, aoData, fnCallback) {

                    for (j = 0; j < aiCustomSearch_Indexes.length; j++) {
                        var index = aiCustomSearch_Indexes[j];

                        for (k = 0; k < aoData.length; k++) {
                            if (aoData[k].name == "sSearch_" + index)
                                aoData[k].value = afnSearch_[j]();
                        }
                    }
                    aoData.push({ "name": "sRangeSeparator", "value": properties.sRangeSeparator });

                    if (fnServerDataOriginal != null) {
                        try {
                            fnServerDataOriginal(sSource, aoData, fnCallback, oTable.fnSettings()); //TODO: See Issue 18
                        } catch (ex) {
                            fnServerDataOriginal(sSource, aoData, fnCallback);
                        }
                    }
                    else {
                        $.getJSON(sSource, aoData, function (json) {
                            fnCallback(json)
                        });
                    }
                };

            }

        });

    };




})(jQuery);
/*
 * debouncedresize: special jQuery event that happens once after a window resize
 *
 * latest ORIGINAL version and complete README available on Github:
 * https://github.com/louisremi/jquery-smartresize
 * latest Bower package can be found also on Github:
 * https://github.com/AndrewDryga/jQuery.Easing
 *
 * Copyright 2012 @louis_remi
 * Licensed under the MIT license.
 *
 * This saved you an hour of work?
 * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
 */
(function($) {

var $event = $.event,
	$special,
	resizeTimeout;

$special = $event.special.debouncedresize = {
	setup: function() {
		$( this ).on( "resize", $special.handler );
	},
	teardown: function() {
		$( this ).off( "resize", $special.handler );
	},
	handler: function( event, execAsap ) {
		// Save the context
		var context = this,
			args = arguments,
			dispatch = function() {
				// set correct event type
				event.type = "debouncedresize";
				$event.dispatch.apply( context, args );
			};

		if ( resizeTimeout ) {
			clearTimeout( resizeTimeout );
		}

		execAsap ?
			dispatch() :
			resizeTimeout = setTimeout( dispatch, $special.threshold );
	},
	threshold: 150
};

})(jQuery);

!function(e,t){function n(e,t){h(e).push(t)}function r(r,a,i){var s=r.children(a.headerTag),o=r.children(a.bodyTag);s.length>o.length?$(X,"contents"):s.length<o.length&&$(X,"titles");var l=a.startIndex;if(i.stepCount=s.length,a.saveState&&e.cookie){var d=e.cookie(R+m(r)),u=parseInt(d,0);!isNaN(u)&&u<i.stepCount&&(l=u)}i.currentIndex=l,s.each(function(a){var i=e(this),s=o.eq(a),l=s.data("mode"),d=null==l?Y.html:g(Y,/^\s*$/.test(l)||isNaN(l)?l:parseInt(l,0)),u=d===Y.html||s.data("url")===t?"":s.data("url"),c=d!==Y.html&&"1"===s.data("loaded"),f=e.extend({},te,{title:i.html(),content:d===Y.html?s.html():"",contentUrl:u,contentMode:d,contentLoaded:c});n(r,f)})}function a(e){e.triggerHandler("canceled")}function i(e,t){return e.currentIndex-t}function s(t,n){var r=l(t);t.unbind(r).removeData("uid").removeData("options").removeData("state").removeData("steps").removeData("eventNamespace").find(".actions a").unbind(r),t.removeClass(n.clearFixCssClass+" vertical");var a=t.find(".content > *");a.removeData("loaded").removeData("mode").removeData("url"),a.removeAttr("id").removeAttr("role").removeAttr("tabindex").removeAttr("class").removeAttr("style")._removeAria("labelledby")._removeAria("hidden"),t.find(".content > [data-mode='async'],.content > [data-mode='iframe']").empty();var i=e('<{0} class="{1}"></{0}>'.format(t.get(0).tagName,t.attr("class"))),s=t._id();return null!=s&&""!==s&&i._id(s),i.html(t.find(".content").html()),t.after(i),t.remove(),i}function o(e,t){var n=e.find(".steps li").eq(t.currentIndex);e.triggerHandler("finishing",[t.currentIndex])?(n.addClass("done").removeClass("error"),e.triggerHandler("finished",[t.currentIndex])):n.addClass("error")}function l(e){var t=e.data("eventNamespace");return null==t&&(t="."+m(e),e.data("eventNamespace",t)),t}function d(e,t){var n=m(e);return e.find("#"+n+V+t)}function u(e,t){var n=m(e);return e.find("#"+n+W+t)}function c(e,t){var n=m(e);return e.find("#"+n+G+t)}function f(e){return e.data("options")}function p(e){return e.data("state")}function h(e){return e.data("steps")}function v(e,t){var n=h(e);return(0>t||t>=n.length)&&$(J),n[t]}function m(e){var t=e.data("uid");return null==t&&(t=e._id(),null==t&&(t="steps-uid-".concat(K),e._id(t)),K++,e.data("uid",t)),t}function g(e,n){if(Q("enumType",e),Q("keyOrValue",n),"string"==typeof n){var r=e[n];return r===t&&$("The enum key '{0}' does not exist.",n),r}if("number"==typeof n){for(var a in e)if(e[a]===n)return n;$("Invalid enum value '{0}'.",n)}else $("Invalid key or value type.")}function C(e,t,n){return T(e,t,n,I(n,1))}function b(e,t,n){return T(e,t,n,i(n,1))}function x(e,t,n,r){if((0>r||r>=n.stepCount)&&$(J),!(t.forceMoveForward&&r<n.currentIndex)){var a=n.currentIndex;return e.triggerHandler("stepChanging",[n.currentIndex,r])?(n.currentIndex=r,j(e,t,n),q(e,t,n,a),S(e,t,n),F(e,t,n),U(e,t,n,r,a,function(){e.triggerHandler("stepChanged",[r,a])})):e.find(".steps li").eq(a).addClass("error"),!0}}function I(e,t){return e.currentIndex+t}function y(t){var n=e.extend(!0,{},ne,t);return this.each(function(){var t=e(this),a={currentIndex:n.startIndex,currentStep:null,stepCount:0,transitionElement:null};t.data("options",n),t.data("state",a),t.data("steps",[]),r(t,n,a),L(t,n,a),D(t,n),n.autoFocus&&0===K&&d(t,n.startIndex).focus(),t.triggerHandler("init",[n.startIndex])})}function _(t,n,r,a,i){(0>a||a>r.stepCount)&&$(J),i=e.extend({},te,i),A(t,a,i),r.currentIndex!==r.stepCount&&r.currentIndex>=a&&(r.currentIndex++,j(t,n,r)),r.stepCount++;var s=t.find(".content"),o=e("<{0}>{1}</{0}>".format(n.headerTag,i.title)),l=e("<{0}></{0}>".format(n.bodyTag));return(null==i.contentMode||i.contentMode===Y.html)&&l.html(i.content),0===a?s.prepend(l).prepend(o):u(t,a-1).after(l).after(o),O(t,r,l,a),P(t,n,r,o,a),E(t,n,r,a),a===r.currentIndex&&q(t,n,r),S(t,n,r),t}function A(e,t,n){h(e).splice(t,0,n)}function w(t){var n=e(this),r=f(n),a=p(n);if(r.suppressPaginationOnFocus&&n.find(":focus").is(":input"))return t.preventDefault(),!1;var i={left:37,right:39};t.keyCode===i.left?(t.preventDefault(),b(n,r,a)):t.keyCode===i.right&&(t.preventDefault(),C(n,r,a))}function F(t,n,r){if(r.stepCount>0){var a=r.currentIndex,i=v(t,a);if(!n.enableContentCache||!i.contentLoaded)switch(g(Y,i.contentMode)){case Y.iframe:t.find(".content > .body").eq(r.currentIndex).empty().html('<iframe src="'+i.contentUrl+'" frameborder="0" scrolling="no" />').data("loaded","1");break;case Y.async:var s=u(t,a)._aria("busy","true").empty().append(H(n.loadingTemplate,{text:n.labels.loading}));e.ajax({url:i.contentUrl,cache:!1}).done(function(e){s.empty().html(e)._aria("busy","false").data("loaded","1"),t.triggerHandler("contentLoaded",[a])})}}}function T(e,t,n,r){var a=n.currentIndex;if(r>=0&&r<n.stepCount&&!(t.forceMoveForward&&r<n.currentIndex)){var i=d(e,r),s=i.parent(),o=s.hasClass("disabled");return s._enableAria(),i.click(),a===n.currentIndex&&o?(s._enableAria(!1),!1):!0}return!1}function k(t){t.preventDefault();var n=e(this),r=n.parent().parent().parent().parent(),i=f(r),s=p(r),l=n.attr("href");switch(l.substring(l.lastIndexOf("#")+1)){case"cancel":a(r);break;case"finish":o(r,s);break;case"next":C(r,i,s);break;case"previous":b(r,i,s)}}function S(e,t,n){if(t.enablePagination){var r=e.find(".actions a[href$='#finish']").parent(),a=e.find(".actions a[href$='#next']").parent();if(!t.forceMoveForward){var i=e.find(".actions a[href$='#previous']").parent();i._enableAria(n.currentIndex>0)}t.enableFinishButton&&t.showFinishButtonAlways?(r._enableAria(n.stepCount>0),a._enableAria(n.stepCount>1&&n.stepCount>n.currentIndex+1)):(r._showAria(t.enableFinishButton&&n.stepCount===n.currentIndex+1),a._showAria(0===n.stepCount||n.stepCount>n.currentIndex+1)._enableAria(n.stepCount>n.currentIndex+1||!t.enableFinishButton))}}function q(t,n,r,a){var i=d(t,r.currentIndex),s=e('<span class="current-info audible">'+n.labels.current+" </span>"),o=t.find(".content > .title");if(null!=a){var l=d(t,a);l.parent().addClass("done").removeClass("error")._selectAria(!1),o.eq(a).removeClass("current").next(".body").removeClass("current"),s=l.find(".current-info"),i.focus()}i.prepend(s).parent()._selectAria().removeClass("done")._enableAria(),o.eq(r.currentIndex).addClass("current").next(".body").addClass("current")}function E(e,t,n,r){for(var a=m(e),i=r;i<n.stepCount;i++){var s=a+V+i,o=a+W+i,l=a+G+i,d=e.find(".title").eq(i)._id(l);e.find(".steps a").eq(i)._id(s)._aria("controls",o).attr("href","#"+l).html(H(t.titleTemplate,{index:i+1,title:d.html()})),e.find(".body").eq(i)._id(o)._aria("labelledby",l)}}function D(e,t){var n=l(e);e.bind("canceled"+n,t.onCanceled),e.bind("contentLoaded"+n,t.onContentLoaded),e.bind("finishing"+n,t.onFinishing),e.bind("finished"+n,t.onFinished),e.bind("init"+n,t.onInit),e.bind("stepChanging"+n,t.onStepChanging),e.bind("stepChanged"+n,t.onStepChanged),t.enableKeyNavigation&&e.bind("keyup"+n,w),e.find(".actions a").bind("click"+n,k)}function M(e,t,n,r){return 0>r||r>=n.stepCount||n.currentIndex===r?!1:(N(e,r),n.currentIndex>r&&(n.currentIndex--,j(e,t,n)),n.stepCount--,c(e,r).remove(),u(e,r).remove(),d(e,r).parent().remove(),0===r&&e.find(".steps li").first().addClass("first"),r===n.stepCount&&e.find(".steps li").eq(r).addClass("last"),E(e,t,n,r),S(e,t,n),!0)}function N(e,t){h(e).splice(t,1)}function L(t,n,r){var a='<{0} class="{1}">{2}</{0}>',i=g(Z,n.stepsOrientation),s=i===Z.vertical?" vertical":"",o=e(a.format(n.contentContainerTag,"content "+n.clearFixCssClass,t.html())),l=e(a.format(n.stepsContainerTag,"steps "+n.clearFixCssClass,'<ul role="tablist"></ul>')),d=o.children(n.headerTag),u=o.children(n.bodyTag);t.attr("role","application").empty().append(l).append(o).addClass(n.cssClass+" "+n.clearFixCssClass+s),u.each(function(n){O(t,r,e(this),n)}),d.each(function(a){P(t,n,r,e(this),a)}),q(t,n,r),B(t,n,r)}function O(e,t,n,r){var a=m(e),i=a+W+r,s=a+G+r;n._id(i).attr("role","tabpanel")._aria("labelledby",s).addClass("body step-"+r).attr("data-step",r)._showAria(t.currentIndex===r)}function B(e,t,n){if(t.enablePagination){var r='<{0} class="actions {1}"><ul role="menu" aria-label="{2}">{3}</ul></{0}>',a='<li class="button_{0}"><a href="#{0}" role="menuitem">{1}</a></li>',i="";t.forceMoveForward||(i+=a.format("previous",t.labels.previous)),i+=a.format("next",t.labels.next),t.enableFinishButton&&(i+=a.format("finish",t.labels.finish)),t.enableCancelButton&&(i+=a.format("cancel",t.labels.cancel)),e.append(r.format(t.actionContainerTag,t.clearFixCssClass,t.labels.pagination,i)),S(e,t,n),F(e,t,n)}}function H(e,n){for(var r=e.match(/#([a-z]*)#/gi),a=0;a<r.length;a++){var i=r[a],s=i.substring(1,i.length-1);n[s]===t&&$("The key '{0}' does not exist in the substitute collection!",s),e=e.replace(i,n[s])}return e}function P(t,n,r,a,i){var s=m(t),o=s+V+i,d=s+W+i,u=s+G+i,c=t.find(".steps > ul"),f=H(n.titleTemplate,{index:i+1,title:a.html()}),p=e('<li role="tab"><a id="'+o+'" href="#'+u+'" aria-controls="'+d+'">'+f+"</a></li>");p._enableAria(n.enableAllSteps||r.currentIndex>i),r.currentIndex>i&&p.addClass("done"),a._id(u).attr("tabindex","-1").addClass("title"),0===i?c.prepend(p):c.find("li").eq(i-1).after(p),0===i&&c.find("li").removeClass("first").eq(i).addClass("first"),i===r.stepCount-1&&c.find("li").removeClass("last").eq(i).addClass("last"),p.children("a").bind("click"+l(t),z)}function j(t,n,r){n.saveState&&e.cookie&&e.cookie(R+m(t),r.currentIndex)}function U(t,n,r,a,i,s){var o=t.find(".content > .body"),l=g(ee,n.transitionEffect),d=n.transitionEffectSpeed,u=o.eq(a),c=o.eq(i);switch(l){case ee.fade:case ee.slide:var f=l===ee.fade?"fadeOut":"slideUp",h=l===ee.fade?"fadeIn":"slideDown";r.transitionElement=u,c[f](d,function(){var t=e(this)._showAria(!1).parent().parent(),n=p(t);n.transitionElement&&(n.transitionElement[h](d,function(){e(this)._showAria()}).promise().done(s),n.transitionElement=null)});break;case ee.slideLeft:var v=c.outerWidth(!0),m=a>i?-v:v,C=a>i?v:-v;e.when(c.animate({left:m},d,function(){e(this)._showAria(!1)}),u.css("left",C+"px")._showAria().animate({left:0},d)).done(s);break;default:e.when(c._showAria(!1),u._showAria()).done(s)}}function z(t){t.preventDefault();var n=e(this),r=n.parent().parent().parent().parent(),a=f(r),i=p(r),s=i.currentIndex;if(n.parent().is(":not(.disabled):not(.current)")){var o=n.attr("href"),l=parseInt(o.substring(o.lastIndexOf("-")+1),0);x(r,a,i,l)}return s===i.currentIndex?(d(r,s).focus(),!1):void 0}function $(e){throw arguments.length>1&&(e=e.format(Array.prototype.slice.call(arguments,1))),new Error(e)}function Q(e,t){null==t&&$("The argument '{0}' is null or undefined.",e)}e.fn.extend({_aria:function(e,t){return this.attr("aria-"+e,t)},_removeAria:function(e){return this.removeAttr("aria-"+e)},_enableAria:function(e){return null==e||e?this.removeClass("disabled")._aria("disabled","false"):this.addClass("disabled")._aria("disabled","true")},_showAria:function(e){return null==e||e?this.show()._aria("hidden","false"):this.hide()._aria("hidden","true")},_selectAria:function(e){return null==e||e?this.addClass("current")._aria("selected","true"):this.removeClass("current")._aria("selected","false")},_id:function(e){return e?this.attr("id",e):this.attr("id")}}),String.prototype.format||(String.prototype.format=function(){for(var t=1===arguments.length&&e.isArray(arguments[0])?arguments[0]:arguments,n=this,r=0;r<t.length;r++){var a=new RegExp("\\{"+r+"\\}","gm");n=n.replace(a,t[r])}return n});var K=0,R="jQu3ry_5teps_St@te_",V="-t-",W="-p-",G="-h-",J="Index out of range.",X="One or more corresponding step {0} are missing.";e.fn.steps=function(t){return e.fn.steps[t]?e.fn.steps[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist on jQuery.steps"):y.apply(this,arguments)},e.fn.steps.add=function(e){var t=p(this);return _(this,f(this),t,t.stepCount,e)},e.fn.steps.count=function(){var e=p(this);return e.stepCount},e.fn.steps.destroy=function(){return s(this,f(this))},e.fn.steps.finish=function(){o(this,p(this))},e.fn.steps.getCurrentIndex=function(){return p(this).currentIndex},e.fn.steps.getCurrentStep=function(){return v(this,p(this).currentIndex)},e.fn.steps.getStep=function(e){return v(this,e)},e.fn.steps.insert=function(e,t){return _(this,f(this),p(this),e,t)},e.fn.steps.next=function(){return C(this,f(this),p(this))},e.fn.steps.previous=function(){return b(this,f(this),p(this))},e.fn.steps.remove=function(e){return M(this,f(this),p(this),e)},e.fn.steps.setStep=function(e){var t=f(this),n=p(this);return x(this,t,n,e)},e.fn.steps.skip=function(e){throw new Error("Not yet implemented!")};var Y=e.fn.steps.contentMode={html:0,iframe:1,async:2},Z=e.fn.steps.stepsOrientation={horizontal:0,vertical:1},ee=e.fn.steps.transitionEffect={none:0,fade:1,slide:2,slideLeft:3},te=e.fn.steps.stepModel={title:"",content:"",contentUrl:"",contentMode:Y.html,contentLoaded:!1},ne=e.fn.steps.defaults={headerTag:"h1",bodyTag:"div",contentContainerTag:"div",actionContainerTag:"div",stepsContainerTag:"div",cssClass:"wizard",clearFixCssClass:"clearfix",stepsOrientation:Z.horizontal,titleTemplate:"<span class=\"number\">#index#</span> <span class='title'>#title#</span>",loadingTemplate:'<span class="spinner"></span> #text#',autoFocus:!1,enableAllSteps:!1,enableKeyNavigation:!0,enablePagination:!0,suppressPaginationOnFocus:!0,enableContentCache:!0,enableCancelButton:!1,enableFinishButton:!0,preloadContent:!1,showFinishButtonAlways:!1,forceMoveForward:!1,saveState:!1,startIndex:0,transitionEffect:ee.none,transitionEffectSpeed:280,onStepChanging:function(e,t,n){return!0},onStepChanged:function(e,t,n){},onCanceled:function(e){},onFinishing:function(e,t){return!0},onFinished:function(e,t){},onContentLoaded:function(e,t){},onInit:function(e,t){},labels:{cancel:"Cancel",current:"current step:",pagination:"Pagination",finish:"Finish",next:"Next <i class='material-icons'>&#xE315;</i>",previous:"<i class='material-icons'>&#xE314;</i> Previous",loading:"Loading ..."}}}(jQuery);
/**
 * Binds a TinyMCE widget to <textarea> elements.
 */
angular.module('ui.tinymce', [])
    .value('uiTinymceConfig', {})
    .directive('uiTinymce', ['$rootScope', '$compile', '$timeout', '$window', '$sce', 'uiTinymceConfig', function($rootScope, $compile, $timeout, $window, $sce, uiTinymceConfig) {
        uiTinymceConfig = uiTinymceConfig || {};
        var generatedIds = 0;
        var ID_ATTR = 'ui-tinymce';
        if (uiTinymceConfig.baseUrl) {
            tinymce.baseURL = uiTinymceConfig.baseUrl;
        }

        return {
            require: ['ngModel', '^?form'],
            link: function(scope, element, attrs, ctrls) {
                if (!$window.tinymce) {
                    return;
                }

                var ngModel = ctrls[0],
                    form = ctrls[1] || null;

                var expression, options = {}, tinyInstance,
                    updateView = function(editor) {
                        var content = editor.getContent({format: options.format}).trim();
                        content = $sce.trustAsHtml(content);

                        ngModel.$setViewValue(content);
                        if (!$rootScope.$$phase) {
                            scope.$apply();
                        }
                    };

                function toggleDisable(disabled) {
                    if (disabled) {
                        ensureInstance();

                        if (tinyInstance) {
                            tinyInstance.getBody().setAttribute('contenteditable', false);
                        }
                    } else {
                        ensureInstance();

                        if (tinyInstance && !tinyInstance.settings.readonly) {
                            tinyInstance.getBody().setAttribute('contenteditable', true);
                        }
                    }
                }

                // generate an ID
                attrs.$set('id', ID_ATTR + '-' + generatedIds++);

                expression = {};

                angular.extend(expression, scope.$eval(attrs.uiTinymce));

                var setupOptions = {
                    // Update model when calling setContent
                    // (such as from the source editor popup)
                    setup: function(ed) {
                        ed.on('init', function() {
                            ngModel.$render();
                            ngModel.$setPristine();
                            if (form) {
                                form.$setPristine();
                            }
                        });

                        // Update model on button click
                        ed.on('ExecCommand', function() {
                            ed.save();
                            updateView(ed);
                        });

                        // Update model on change
                        ed.on('change', function() {
                            ed.save();
                            updateView(ed);
                        });

                        ed.on('blur', function() {
                            element[0].blur();
                        });

                        // Update model when an object has been resized (table, image)
                        ed.on('ObjectResized', function() {
                            ed.save();
                            updateView(ed);
                        });

                        ed.on('remove', function() {
                            element.remove();
                        });

                        if (expression.setup) {
                            expression.setup(ed, {
                                updateView: updateView
                            });
                        }
                    },
                    format: expression.format || 'html',
                    selector: '#' + attrs.id
                };
                // extend options with initial uiTinymceConfig and
                // options from directive attribute value
                angular.extend(options, uiTinymceConfig, expression, setupOptions);
                // Wrapped in $timeout due to $tinymce:refresh implementation, requires
                // element to be present in DOM before instantiating editor when
                // re-rendering directive
                $timeout(function() {
                    tinymce.init(options);
                    toggleDisable(scope.$eval(attrs.ngDisabled));
                });

                ngModel.$formatters.unshift(function(modelValue) {
                    return modelValue ? $sce.trustAsHtml(modelValue) : '';
                });

                ngModel.$parsers.unshift(function(viewValue) {
                    return viewValue ? $sce.getTrustedHtml(viewValue) : '';
                });

                ngModel.$render = function() {
                    ensureInstance();

                    var viewValue = ngModel.$viewValue ?
                        $sce.getTrustedHtml(ngModel.$viewValue) : '';

                    // instance.getDoc() check is a guard against null value
                    // when destruction & recreation of instances happen
                    if (tinyInstance &&
                        tinyInstance.getDoc()
                    ) {
                        tinyInstance.setContent(viewValue);
                        // Triggering change event due to TinyMCE not firing event &
                        // becoming out of sync for change callbacks
                        tinyInstance.fire('change');
                    }
                };

                attrs.$observe('disabled', toggleDisable);

                // This block is because of TinyMCE not playing well with removal and
                // recreation of instances, requiring instances to have different
                // selectors in order to render new instances properly
                scope.$on('$tinymce:refresh', function(e, id) {
                    var eid = attrs.id;
                    if (angular.isUndefined(id) || id === eid) {
                        var parentElement = element.parent();
                        var clonedElement = element.clone();
                        clonedElement.removeAttr('id');
                        clonedElement.removeAttr('style');
                        clonedElement.removeAttr('aria-hidden');
                        tinymce.execCommand('mceRemoveEditor', false, eid);
                        parentElement.append($compile(clonedElement)(scope));
                    }
                });

                scope.$on('$destroy', function() {
                    ensureInstance();

                    if (tinyInstance) {
                        tinyInstance.remove();
                        tinyInstance = null;
                    }
                });

                function ensureInstance() {
                    if (!tinyInstance) {
                        tinyInstance = tinymce.get(attrs.id);
                    }
                }
            }
        };
    }]);
'use strict';

/**
 * Module to use Switchery as a directive for angular.
 * @TODO implement Switchery as a service, https://github.com/abpetkov/switchery/pull/11
 */
angular.module('NgSwitchery', [])
    .directive('uiSwitch', ['$window', '$timeout','$log', '$parse', function($window, $timeout, $log, $parse) {

        /**
         * Initializes the HTML element as a Switchery switch.
         *
         * $timeout is in place as a workaround to work within angular-ui tabs.
         *
         * @param scope
         * @param elem
         * @param attrs
         * @param ngModel
         */

        function hex2rgba(hex,opacity){
            hex = hex.replace('#','');
            var r = parseInt(hex.substring(0,2), 16),
                g = parseInt(hex.substring(2,4), 16),
                b = parseInt(hex.substring(4,6), 16);

            return 'rgba('+r+','+g+','+b+','+opacity/100+')';
        }

        function linkSwitchery(scope, elem, attrs, ngModel) {
            if(!ngModel) return false;

            var options = {
                color: attrs.color ? hex2rgba(attrs.color, 50) : hex2rgba('#009688',50),
                jackColor: attrs.color ? hex2rgba(attrs.color, 100) : hex2rgba('#009688',100),
                secondaryColor: attrs.secondaryColor ? hex2rgba(attrs.secondaryColor, 50) : 'rgba(0, 0, 0,0.26)',
                jackSecondaryColor: attrs.secondaryColor ? hex2rgba(attrs.secondaryColor, 100) : '#fafafa',
                className: attrs.class
            };

            var switcher;
            var previousDisabledValue;
            // Watch for attribute changes to recreate the switch if the 'disabled' attribute changes
            attrs.$observe('disabled', function(value) {
                if (value == undefined || value == previousDisabledValue) {
                    return;
                } else {
                    previousDisabledValue = value;
                }
                initializeSwitch(true,true);
            });

            function initializeSwitch(init,disabled) {
                $timeout(function() {
                    // Remove any old switcher
                    if(disabled) {
                        angular.element(switcher.switcher).remove();
                    }
                    if (init) {
                        // (re)create switcher to reflect latest state of the checkbox element
                        switcher = new $window.Switchery(elem[0], options);
                    }
                    var element = switcher.element;
                    element.checked = scope.initValue;
                    switcher.setPosition(false);
                    element.addEventListener('change',function(evt) {
                        scope.$apply(function() {
                            ngModel.$setViewValue(element.checked);
                        })
                    });
                }, 0);
            }
            initializeSwitch(true,false);

            scope.$watch('initValue', function(newValue, oldValue) {
                initializeSwitch(false,false);
            });

        }

        return {
            require: 'ngModel',
            restrict: 'AE',
            scope : {
                initValue : '=ngModel'
            },
            link: linkSwitchery
        }
    }]);
/*
* Angular Selectize
* v 1.2.3
* https://github.com/machineboy2045/angular-selectize
*/

/*global $:Selectize */

angular
    .module('selectize', [])
    .value('selectizeConfig', {})
    .directive("selectize", [
        'selectizeConfig',
        function (selectizeConfig) {
            return {
                restrict: 'EA',
                require: '^ngModel',
                scope: {
                    ngModel: '=',
                    config: '=?',
                    options: '=?',
                    ngDisabled: '=',
                    ngRequired: '&'
                },
                link: function (scope, element, attrs, modelCtrl) {
                    if (!Selectize) {
                        throw new Error("Selectize JavaScript library should be loaded before using this angular module.");
                    }

                    Selectize.defaults.maxItems = null; //default to tag editor
                    Selectize.defaults.hideSelected = true;

                    if(attrs.position) {
                        scope.posBottom = attrs.position;
                    }

                    Selectize.defaults.onDropdownOpen = function($dropdown) {
                        $dropdown
                            .hide()
                            .velocity('slideDown', {
                                begin: function() {
                                    if (typeof scope.posBottom !== 'undefined') {
                                        $dropdown.css({'margin-top':'0'})
                                    }
                                },
                                duration: 200,
                                easing: [ 0.4,0,0.2,1 ]
                            })
                    };
                    Selectize.defaults.onDropdownClose = function($dropdown) {
                        $dropdown
                            .show()
                            .velocity('slideUp', {
                                complete: function() {
                                    if (typeof posBottom !== 'undefined') {
                                        $dropdown.css({'margin-top': ''})
                                    }
                                },
                                duration: 200,
                                easing: [ 0.4,0,0.2,1 ]
                            });
                    };

                    var selectize,
                        config = angular.extend({}, Selectize.defaults, selectizeConfig, scope.config);

                    modelCtrl.$isEmpty = function (val) {
                        return (val === undefined || val === null || !val.length); //override to support checking empty arrays
                    };

                    function createItem(input) {
                        var data = {};
                        data[config.labelField] = input;
                        data[config.valueField] = input;
                        return data;
                    }

                    function toggle(disabled) {
                        disabled ? selectize.disable() : selectize.enable();
                    }

                    var validate = function () {
                        var isInvalid = (scope.ngRequired() || attrs.required || config.required) && modelCtrl.$isEmpty(scope.ngModel);
                        modelCtrl.$setValidity('required', !isInvalid);
                    };

                    function generateOptions(data) {
                        if (!data)
                            return [];

                        data = angular.isArray(data) ? data : [data];

                        return $.map(data, function (opt) {
                            return typeof opt === 'string' ? createItem(opt) : opt;
                        });
                    }

                    function updateSelectize() {
                        validate();

                        selectize.$control.toggleClass('ng-valid', modelCtrl.$valid);
                        selectize.$control.toggleClass('ng-invalid', modelCtrl.$invalid);
                        selectize.$control.toggleClass('ng-dirty', modelCtrl.$dirty);
                        selectize.$control.toggleClass('ng-pristine', modelCtrl.$pristine);

                        var value = selectize.items.slice();
                        if (config.maxItems === 1) {
                            value = value[0];
                        }
                        if (!angular.equals(value, scope.ngModel)) {
                            selectize.addOption(generateOptions(scope.ngModel));
                            selectize.setValue(scope.ngModel);
                        }
                    }

                    var onChange = config.onChange,
                        onOptionAdd = config.onOptionAdd;

                    config.onChange = function () {
                        var args = arguments;
                        scope.$evalAsync(function () {
                            var value = selectize.items.slice();
                            if (config.maxItems === 1) {
                                value = value[0];
                            }
                            if (!angular.equals(value, scope.ngModel)) {
                                modelCtrl.$setViewValue(value);
                                if (onChange) {
                                    onChange.apply(this, args);
                                }
                            }
                        });
                    };

                    config.onOptionAdd = function (value, data) {
                        if (scope.options.indexOf(data) === -1)
                            scope.options.push(data);

                        if (onOptionAdd) {
                            onOptionAdd.apply(this, arguments);
                        }
                    };

                    // ngModel (ie selected items) is included in this because if no options are specified, we
                    // need to create the corresponding options for the items to be visible
                    //scope.options = generateOptions((scope.options || config.options || scope.ngModel).slice());

                    scope.generatedOptions = generateOptions( (scope.options || config.options || scope.ngModel).slice() );
                    scope.options.length = 0;
                    scope.generatedOptions.forEach(function (item) {
                        scope.options.push(item);
                    });


                    var angularCallback = config.onInitialize;

                    config.onInitialize = function () {
                        selectize = element[0].selectize;
                        //selectize.addOption(scope.options);
                        selectize.addOption(scope.generatedOptions);
                        selectize.setValue(scope.ngModel);

                        //provides a way to access the selectize element from an
                        //angular controller
                        if (angularCallback) {
                            angularCallback(selectize);
                        }

                        scope.$watch('options', function () {
                            scope.generatedOptions = generateOptions( (scope.options || config.options || scope.ngModel).slice() );
                            scope.options.length = 0;
                            scope.generatedOptions.forEach(function (item) {
                                scope.options.push(item);
                            });
                            selectize.clearOptions();
                            selectize.addOption(scope.generatedOptions);
                            selectize.setValue(scope.ngModel);
                            //selectize.clearOptions();
                            //selectize.addOption(scope.options);
                            //selectize.setValue(scope.ngModel);
                        }, true);

                        scope.$watchCollection('ngModel', updateSelectize);
                        scope.$watch('ngDisabled', toggle);
                    };

                    element.after('<div class="selectize_fix"></div>');

                    element.selectize(config);

                    element.on('$destroy', function () {
                        if (selectize) {
                            selectize.destroy();
                            element = null;
                        }
                    });
                }
            };
        }
    ]);

    // tooltip
    Selectize.define('tooltip', function (options) {
        var self = this;
        this.setup = (function () {
            var original = self.setup;
            return function () {
                original.apply(this, arguments);
                var $wrapper = this.$wrapper,
                    $input = this.$input;
                if ($input.attr('title')) {
                    $wrapper
                        .attr('title', $input.attr('title'))
                        .attr('data-uk-tooltip', $input.attr('data-uk-tooltip'));
                }
            };
        })();
    });
/*! angular-retina - v0.3.1 - 2015-08-24
 * https://github.com/jrief/angular-retina
 * Copyright (c) 2015 Jacob Rief; Licensed MIT */
// Add support for Retina displays when using element attribute "ng-src".
// This module overrides the built-in directive "ng-src" with one which
// distinguishes between standard or high-resolution (Retina) displays.
(function (angular, undefined) {
    'use strict';
    var infix = '@2x', data_url_regex = /^data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    var ngRetina = angular.module('ngRetina', []).config([
        '$provide',
        function ($provide) {
            $provide.decorator('ngSrcDirective', [
                '$delegate',
                function ($delegate) {
                    $delegate[0].compile = function (element, attrs) {
                    };
                    return $delegate;
                }
            ]);
        }
    ]);
    ngRetina.provider('ngRetina', function () {
        this.setInfix = function (value) {
            infix = value;
        };
        this.$get = angular.noop;
    });
    ngRetina.directive('ngSrc', [
        '$window',
        '$http',
        function ($window, $http) {
            var msie = parseInt((/msie (\d+)/.exec($window.navigator.userAgent.toLowerCase()) || [])[1], 10);
            var isRetina = function () {
                var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), ' + '(-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
                if ($window.devicePixelRatio > 1)
                    return true;
                return $window.matchMedia && $window.matchMedia(mediaQuery).matches;
            }();
            function getHighResolutionURL(url) {
                var parts = url.split('.');
                if (parts.length < 2)
                    return url;
                parts[parts.length - 2] += infix;
                return parts.join('.');
            }
            return function (scope, element, attrs) {
                function setImgSrc(img_url) {
                    attrs.$set('src', img_url);
                    if (msie)
                        element.prop('src', img_url);
                }
                function set2xVariant(img_url) {
                    var img_url_2x = null;
                    if (angular.isUndefined(attrs.at2x))
                        img_url_2x = $window.sessionStorage.getItem(img_url);
                    else
                        img_url_2x = attrs.at2x;
                    if (!img_url_2x) {
                        img_url_2x = getHighResolutionURL(img_url);
                        $http.head(img_url_2x).success(function (data, status) {
                            setImgSrc(img_url_2x);
                            $window.sessionStorage.setItem(img_url, img_url_2x);
                        }).error(function (data, status, headers, config) {
                            setImgSrc(img_url);
                            $window.sessionStorage.setItem(img_url, img_url);
                        });
                    } else {
                        setImgSrc(img_url_2x);
                    }
                }
                attrs.$observe('ngSrc', function (value) {
                    if (!value)
                        return;
                    if (isRetina && angular.isUndefined(attrs.noretina) && typeof $window.sessionStorage === 'object' && element[0].tagName === 'IMG' && !value.match(data_url_regex)) {
                        set2xVariant(value);
                    } else {
                        setImgSrc(value);
                    }
                });
            };
        }
    ]);
}(window.angular));
/*
* Usage
*
* <prism-highlight class="language-css">
*      body {
*         color: red;
*      }
* </prism-highlight>
*
* the files prismjs and prism css must be included in HTML, use class "language-XXX" to specify language
*/
;'use strict';
angular
    .module('ngPrism', [])
    .directive('prismHighlight', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.ready(function() {
                    $timeout(function() {
                        Prism.highlightElement(element[0]);
                    })
                });
            }
        }
    });

var buildChartDirective = function (chartType) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            data: "=",
            options: "="
        },
        link: function (scope, element, attrs) {

            var options = {};
            if (scope.options) {
                options = scope.options;
            }

            var span = document.createElement('span');
            span.textContent = scope.data.join();

            if (!attrs.class) {
                span.className = "peity";
            } else {
                span.className = attrs.class;
            }

            if (element[0].nodeType === 8) {
                element.replaceWith(span);
            } else {
                element[0].appendChild(span);
            }

            if(options.height) {
                element.height(options.height);
            }

            var chart = jQuery(span).peity(chartType, options);

            return scope.$watch('data', function() {
                return chart
                    .text(scope.data)
                    .change();
            });

        }
    };
};

angular
    .module('angular-peity', [])
    .directive('peityPieChart', function () {
        return buildChartDirective("pie");
    })
    .directive('peityDonutChart', function () {
        return buildChartDirective("donut");
    })

    .directive('peityBarChart', function () {
        return buildChartDirective("bar");
    })
    .directive('peityLineChart', function () {
        return buildChartDirective("line");
    });



angular
    .module('metricsGraphics', [])
    .directive('metricsGraphics', function($window, $timeout) {
    return {
        restrict: 'A',
        scope: {
            data: '=',
            options: '='
        },
        link: function(scope, element) {

            if(!scope.data) {
                return;
            }

            var options = {
                baselines: [],
                description: null,
                right: 20,
                title: null,
                height: element.height() || 240,
                x_accessor: null,
                y_accessor: null
            };

            // override default options with values from the scope
            if (scope.options) {
                Object.keys(scope.options).forEach(function(key) {
                    options[key] = scope.options[key];
                });
            }

            var el = element[0];

            options.target = '#' + el.id;

            function make_graph(options, el) {
                options.width = el.offsetWidth || '100%';
                MG.data_graphic(options);
            }

            // create the chart
            scope.$watch('data', function(){
                make_graph(options,el);
            });

            scope.update_chart = function() {
                // Reset timeout
                $timeout.cancel(scope.resizingTimer);
                // Add a timeout to not call the resizing function every pixel
                scope.resizingTimer = $timeout( function() {
                    make_graph(options,el);
                    return scope.$apply();
                }, 280);
            };

            angular.element($window).on('resize', scope.update_chart);

            scope.$on("$destroy", function() {
                $(window).off('resize', scope.update_chart);
            });

        }
    };
});
angular
    .module('directive.ionSlider', [])
    .directive('ionSlider', [
        '$document',
        function($document) {
            "use strict";
            return {
                restrict: 'EA',
                require: 'ngModel',
                scope: true,
                template: '<input type="text" />',
                link: function(scope, element, attrs, ngModel) {

                    var input = element.find('input'),
                        isDouble = attrs.type === 'double';

                    input.ionRangeSlider({
                        grid: attrs.grid,
                        hide_min_max: attrs.hide_min_max,
                        values: scope.$eval(attrs.values),
                        min_prefix: attrs.minPrefix,
                        max_prefix: attrs.maxPrefix,
                        min_postfix: attrs.minPostfix,
                        max_postfix: attrs.maxPostfix,
                        min: +attrs.min,
                        max: +attrs.max,
                        type: attrs.type,
                        prefix: attrs.prefix,
                        from_min: attrs.fromMin,
                        from_max: attrs.fromMax,
                        from_shadow: attrs.fromShadow,
                        to_min: attrs.toMin,
                        to_max: attrs.toMax,
                        to_shadow: attrs.toShadow,
                        grid_num: attrs.gridNum,
                        force_edges: attrs.forceEdges
                    });

                    var slider = input.data("ionRangeSlider");

                    ngModel.$render = function() {
                        var options;
                        if(isDouble) {
                            options = ngModel.$viewValue || {};
                        } else {
                            options = {
                                from: ngModel.$viewValue
                            };
                        }
                        slider.update(options);
                    };
                    input.on('change', function() {
                        ngModel.$setViewValue(isDouble ? {from: input.data("from"), to: input.data("to")} : input.data("from"));
                    });
                    element.on('mousedown', function() {
                        if(!scope.$eval(attrs.ngDisabled)) {
                            $document.one('mouseup', function() {
                                scope.$emit('sliderSlideFinished');
                            });
                        }
                    });
                    scope.$watch(attrs.ngDisabled, function(disabled) {
                        slider.update({
                            disable: disabled
                        });
                    });
                    scope.$on('$destroy', function() {
                        slider.destroy();
                    });
                }
            };
        }
    ]);
// https://github.com/fronteed/icheck/issues/62#issuecomment-128480101
;'use strict';
angular
    .module('icheck', [])
    .directive('icheck', function ($timeout, $parse) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function ($scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    var value;
                    value = $attrs['value'];

                    $scope.$watch($attrs['ngModel'], function (newValue) {
                        $(element).iCheck('update');
                    });

                    $scope.$watch($attrs['ngDisabled'], function (newValue) {
                        $(element).iCheck(newValue ? 'disable' : 'enable');
                        $(element).iCheck('update');
                    });

                    return $(element).iCheck({
                        checkboxClass: 'icheckbox_md',
                        radioClass: 'iradio_md',
                        increaseArea: '20%'
                    }).on('ifChanged', function (event) {
                        if ( !!$(element).data('parsley-multiple') ) {
                            $(element).parsley().validate();
                        }
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function () {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                    }).on('ifClicked', function (event) {
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function () {
                                //set up for radio buttons to be de-selectable
                                if (ngModel.$viewValue != value)
                                    return ngModel.$setViewValue(value);
                                else
                                    ngModel.$setViewValue(null);
                                ngModel.$render();
                            });
                        }
                    });
                });
            }
        };
    });
(function() {
    'use strict';
    angular
        .module('ngCountup', [])
        .directive('countUp', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                ngModel: '='
            },
            link: function(scope, element, attrs) {
                return scope.$parent.$watch(attrs.ngModel, function(newVal, oldVal) {
                    var numDecimals, opts;
                    if ((newVal != null) && newVal !== oldVal) {
                        opts = {};
                        if (attrs.prefix != null) {
                            opts.prefix = attrs.prefix;
                        }
                        if (attrs.suffix != null) {
                            opts.suffix = attrs.suffix;
                        }
                        if (attrs.separator != null) {
                            opts.separator = attrs.separator;
                        }
                        if (attrs.decimal != null) {
                            opts.decimal = attrs.decimal;
                        }
                        numDecimals = 0;
                        if ((attrs.numDecimals != null) && attrs.numDecimals >= 0) {
                            numDecimals = attrs.numDecimals;
                        }
                        if (newVal == null) {
                            newVal = 0;
                        }
                        if (oldVal == null) {
                            oldVal = 0;
                        }
                        return new CountUp(attrs.id, oldVal, newVal, numDecimals, 2, opts).start();
                    }
                });
            }
        };
    });

}).call(this);
/**
 * Binds a CodeMirror widget to a <textarea> element.
 */
angular.module('ui.codemirror', [])
    .constant('uiCodemirrorConfig', {})
    .directive('uiCodemirror', uiCodemirrorDirective);

/**
 * @ngInject
 */
function uiCodemirrorDirective($timeout, uiCodemirrorConfig) {
    'use strict';

    return {
        restrict: 'EA',
        require: '?ngModel',
        compile: function compile() {

            // Require CodeMirror
            if (angular.isUndefined(window.CodeMirror)) {
                throw new Error('ui-codemirror needs CodeMirror to work... (o rly?)');
            }

            return postLink;
        }
    };

    function postLink(scope, iElement, iAttrs, ngModel) {

        scope.handles = [];

        var codemirrorOptions = angular.extend(
            { value: iElement.text() },
            uiCodemirrorConfig.codemirror || {},
            scope.$eval(iAttrs.uiCodemirror),
            scope.$eval(iAttrs.uiCodemirrorOpts)
        );

        var codemirror = newCodemirrorEditor(iElement, codemirrorOptions);

        configOptionsWatcher(
            codemirror,
            iAttrs.uiCodemirror || iAttrs.uiCodemirrorOpts,
            scope
        );

        configNgModelLink(codemirror, ngModel, scope);

        configUiRefreshAttribute(codemirror, iAttrs.uiRefresh, scope);

        // Allow access to the CodeMirror instance through a broadcasted event
        // eg: $broadcast('CodeMirror', function(cm){...});
        scope.handles.push(scope.$on('CodeMirror', function(event, callback) {
            if (angular.isFunction(callback)) {
                callback(codemirror);
            } else {
                throw new Error('the CodeMirror event requires a callback function');
            }
        }));

        // onLoad callback
        if (angular.isFunction(codemirrorOptions.onLoad)) {
            codemirrorOptions.onLoad(codemirror);
        }

        scope.handles.push(scope.$on('$destroy', function(){
            angular.forEach(scope.handles, function(unbind){
                unbind();
            });
            scope.handles = null;
        }));
    }

    function newCodemirrorEditor(iElement, codemirrorOptions) {
        var codemirrot;

        if (iElement[0].tagName === 'TEXTAREA') {
            // Might bug but still ...
            codemirrot = window.CodeMirror.fromTextArea(iElement[0], codemirrorOptions);
        } else {
            iElement.html('');
            codemirrot = new window.CodeMirror(function(cm_el) {
                iElement.append(cm_el);
            }, codemirrorOptions);
        }

        return codemirrot;
    }

    function configOptionsWatcher(codemirrot, uiCodemirrorAttr, scope) {
        if (!uiCodemirrorAttr) { return; }

        var codemirrorDefaultsKeys = Object.keys(window.CodeMirror.defaults);
        scope.handles.push(scope.$watch(uiCodemirrorAttr, updateOptions, true));
        function updateOptions(newValues, oldValue) {
            if (!angular.isObject(newValues)) { return; }
            codemirrorDefaultsKeys.forEach(function(key) {
                if (newValues.hasOwnProperty(key)) {

                    if (oldValue && newValues[key] === oldValue[key]) {
                        return;
                    }

                    codemirrot.setOption(key, newValues[key]);
                }
            });
        }
    }

    function configNgModelLink(codemirror, ngModel, scope) {
        if (!ngModel) { return; }
        // CodeMirror expects a string, so make sure it gets one.
        // This does not change the model.
        ngModel.$formatters.push(function(value) {
            if (angular.isUndefined(value) || value === null) {
                return '';
            } else if (angular.isObject(value) || angular.isArray(value)) {
                throw new Error('ui-codemirror cannot use an object or an array as a model');
            }
            return value;
        });


        // Override the ngModelController $render method, which is what gets called when the model is updated.
        // This takes care of the synchronizing the codeMirror element with the underlying model, in the case that it is changed by something else.
        ngModel.$render = function() {
            //Code mirror expects a string so make sure it gets one
            //Although the formatter have already done this, it can be possible that another formatter returns undefined (for example the required directive)
            var safeViewValue = ngModel.$viewValue || '';
            codemirror.setValue(safeViewValue);
        };


        // Keep the ngModel in sync with changes from CodeMirror
        codemirror.on('change', function(instance) {
            var newValue = instance.getValue();
            if (newValue !== ngModel.$viewValue) {
                scope.$evalAsync(function() {
                    ngModel.$setViewValue(newValue);
                });
            }
        });
    }

    function configUiRefreshAttribute(codeMirror, uiRefreshAttr, scope) {
        if (!uiRefreshAttr) { return; }

        scope.handles.push(scope.$watch(uiRefreshAttr, function(newVal, oldVal) {
            // Skip the initial watch firing
            if (newVal !== oldVal) {
                $timeout(function() {
                    codeMirror.refresh();
                });
            }
        }));
    }

}
(function (root, factory) {
    // AMD
    if (typeof define === 'function' && define.amd) define(['angular'], factory);
    // Global
    else factory(angular);
}(this, function (angular) {

    angular
        .module('ckeditor', [])
        .directive('ckeditor', ['$parse', ckeditorDirective]);

    // Polyfill setImmediate function.
    var setImmediate = window && window.setImmediate ? window.setImmediate : function (fn) {
        setTimeout(fn, 0);
    };

    /**
     * CKEditor directive.
     *
     * @example
     * <div ckeditor="options" ng-model="content" ready="onReady()"></div>
     */

    function ckeditorDirective($parse) {
        return {
            restrict: 'A',
            require: ['ckeditor', 'ngModel'],
            controller: [
                '$scope',
                '$element',
                '$attrs',
                '$parse',
                '$q',
                ckeditorController
            ],
            link: function (scope, element, attrs, ctrls) {
                // get needed controllers
                var controller = ctrls[0]; // our own, see below
                var ngModelController = ctrls[1];

                // Initialize the editor content when it is ready.
                controller.ready().then(function initialize() {
                    // Sync view on specific events.
                    ['dataReady', 'change', 'blur', 'saveSnapshot'].forEach(function (event) {
                        controller.onCKEvent(event, function syncView() {
                            ngModelController.$setViewValue(controller.instance.getData() || '');
                        });
                    });

                    controller.instance.setReadOnly(!! attrs.readonly);
                    attrs.$observe('readonly', function (readonly) {
                        controller.instance.setReadOnly(!! readonly);
                    });

                    // Defer the ready handler calling to ensure that the editor is
                    // completely ready and populated with data.
                    setImmediate(function () {
                        $parse(attrs.ready)(scope);
                    });
                });

                // Set editor data when view data change.
                ngModelController.$render = function syncEditor() {
                    controller.ready().then(function () {
                        controller.instance.setData(ngModelController.$viewValue || '');
                    });
                };
            }
        };
    }

    /**
     * CKEditor controller.
     */

    function ckeditorController($scope, $element, $attrs, $parse, $q) {
        var config = $parse($attrs.ckeditor)($scope) || {};
        var editorElement = $element[0];
        var instance;
        var readyDeferred = $q.defer(); // a deferred to be resolved when the editor is ready

        // Create editor instance.
        if (editorElement.hasAttribute('contenteditable') &&
            editorElement.getAttribute('contenteditable').toLowerCase() == 'true') {
            instance = this.instance = CKEDITOR.inline(editorElement, config);
        }
        else {
            instance = this.instance = CKEDITOR.replace(editorElement, config);
        }

        /**
         * Listen on events of a given type.
         * This make all event asynchronous and wrapped in $scope.$apply.
         *
         * @param {String} event
         * @param {Function} listener
         * @returns {Function} Deregistration function for this listener.
         */

        this.onCKEvent = function (event, listener) {
            instance.on(event, asyncListener);

            function asyncListener() {
                var args = arguments;
                setImmediate(function () {
                    applyListener.apply(null, args);
                });
            }

            function applyListener() {
                var args = arguments;
                $scope.$apply(function () {
                    listener.apply(null, args);
                });
            }

            // Return the deregistration function
            return function $off() {
                instance.removeListener(event, applyListener);
            };
        };

        this.onCKEvent('instanceReady', function() {
            readyDeferred.resolve(true);
        });

        /**
         * Check if the editor if ready.
         *
         * @returns {Promise}
         */
        this.ready = function ready() {
            return readyDeferred.promise;
        };

        // Destroy editor when the scope is destroyed.
        $scope.$on('$destroy', function onDestroy() {
            // do not delete too fast or pending events will throw errors
            readyDeferred.promise.then(function() {
                instance.destroy(false);
            });
        });
    }
}));
// https://github.com/itamarwe/angular-chartist
(function () {
    var angularChartist = angular.module('angular-chartist', []);

    angularChartist
        .directive('chartist', function ($window) {
        var linkFn = function (scope, elm, attrs) {
            var data, options, responsiveOptions, selector, updateChart, deepWatchData, deepWatchOptions, deepwatch, type;
            data = scope.data;
            options = scope.options;
            responsiveOptions = scope.responsiveOptions;
            deepwatch = scope.deepWatch;
            selector = "#" + scope.ngId;
            type = scope.type || 'line';
            elm.attr('id', scope.ngId);

            updateChart = function () {

                if (type === 'line'){
                    Chartist.Line(selector, data, options, responsiveOptions);
                }else if (type === 'bar'){
                    Chartist.Bar(selector, data, options, responsiveOptions);
                }else if (type === 'pie'){
                    Chartist.Pie(selector, data, options, responsiveOptions);
                }
            };

            scope.$watch('data', function (newValue, oldValue) {
                data = newValue;
                updateChart();
            }, deepWatchData);

            scope.$watch('options', function (newValue, oldValue) {
                options = newValue;
                updateChart();
            }, deepWatchOptions);

            updateChart();


            angular.element($window).on('resize', updateChart);

            scope.$on("$destroy", function() {
                $(window).off('resize', updateChart);
            });

        };

        return {
            restrict: 'EA',
            template: '<div class="ct-chart chartist"></div>',
            replace: true,
            scope: {
                data: '=',
                options: '=',
                ngId: '@',
                type: '@',
                responsiveOptions: '=',
                deepWatchData: '=',
                deepWatchOptions: '='
            },
            link: linkFn
        };
    });
})();
;'use strict';
(function($){"use strict";$.fn.extend({counter:function(options){var defaults={type:"char",count:"down",goal:140,text:true,target:false,append:true,translation:"",msg:"",container_class:""};var $countObj="",countIndex="",noLimit=false,options=$.extend({},defaults,options);var methods={init:function($obj){var objID=$obj.attr("id"),counterID=objID+"_count";methods.isLimitless();$countObj=$("<span id="+counterID+"/>");var counterDiv=$("<div/>").attr("id",objID+"_counter").append($countObj).append(" "+methods.setMsg());if(options.container_class&&options.container_class.length){counterDiv.addClass(options.container_class)}if(!options.target||!$(options.target).length){options.append?counterDiv.insertAfter($obj):counterDiv.insertBefore($obj)}else{options.append?$(options.target).append(counterDiv):$(options.target).prepend(counterDiv)}methods.bind($obj)},bind:function($obj){$obj.bind("keypress.counter keydown.counter keyup.counter blur.counter focus.counter change.counter paste.counter",methods.updateCounter);$obj.bind("keydown.counter",methods.doStopTyping);$obj.trigger("keydown")},isLimitless:function(){if(options.goal==="sky"){options.count="up";noLimit=true;return noLimit}},setMsg:function(){if(options.msg!==""){return options.msg}if(options.text===false){return""}if(noLimit){if(options.msg!==""){return options.msg}else{return""}}this.text=options.translation||"character word left max";this.text=this.text.split(" ");this.chars="s ( )".split(" ");this.msg=null;switch(options.type){case"char":if(options.count===defaults.count&&options.text){this.msg=this.text[0]+this.chars[1]+this.chars[0]+this.chars[2]+" "+this.text[2]}else if(options.count==="up"&&options.text){this.msg=this.text[0]+this.chars[0]+" "+this.chars[1]+options.goal+" "+this.text[3]+this.chars[2]}break;case"word":if(options.count===defaults.count&&options.text){this.msg=this.text[1]+this.chars[1]+this.chars[0]+this.chars[2]+" "+this.text[2]}else if(options.count==="up"&&options.text){this.msg=this.text[1]+this.chars[1]+this.chars[0]+this.chars[2]+" "+this.chars[1]+options.goal+" "+this.text[3]+this.chars[2]}break;default:}return this.msg},getWords:function(val){if(val!==""){return $.trim(val).replace(/\s+/g," ").split(" ").length}else{return 0}},updateCounter:function(e){var $this=$(this);if(countIndex<0||countIndex>options.goal){methods.passedGoal($this)}if(options.type===defaults.type){if(options.count===defaults.count){countIndex=options.goal-$this.val().length;if(countIndex<=0){$countObj.text("0")}else{$countObj.text(countIndex)}}else if(options.count==="up"){countIndex=$this.val().length;$countObj.text(countIndex)}}else if(options.type==="word"){if(options.count===defaults.count){countIndex=methods.getWords($this.val());if(countIndex<=options.goal){countIndex=options.goal-countIndex;$countObj.text(countIndex)}else{$countObj.text("0")}}else if(options.count==="up"){countIndex=methods.getWords($this.val());$countObj.text(countIndex)}}return},doStopTyping:function(e){var keys=[46,8,9,35,36,37,38,39,40,32];if(methods.isGoalReached(e)){if(e.keyCode!==keys[0]&&e.keyCode!==keys[1]&&e.keyCode!==keys[2]&&e.keyCode!==keys[3]&&e.keyCode!==keys[4]&&e.keyCode!==keys[5]&&e.keyCode!==keys[6]&&e.keyCode!==keys[7]&&e.keyCode!==keys[8]){if(options.type===defaults.type){return false}else if(e.keyCode!==keys[9]&&e.keyCode!==keys[1]&&options.type!=defaults.type){return true}else{return false}}}},isGoalReached:function(e,_goal){if(noLimit){return false}if(options.count===defaults.count){_goal=0;return countIndex<=_goal?true:false}else{_goal=options.goal;return countIndex>=_goal?true:false}},wordStrip:function(numOfWords,text){var wordCount=text.replace(/\s+/g," ").split(" ").length;text=$.trim(text);if(numOfWords<=0||numOfWords===wordCount){return text}else{text=$.trim(text).split(" ");text.splice(numOfWords,wordCount,"");return $.trim(text.join(" "))}},passedGoal:function($obj){var userInput=$obj.val();if(options.type==="word"){$obj.val(methods.wordStrip(options.goal,userInput))}if(options.type==="char"){$obj.val(userInput.substring(0,options.goal))}if(options.type==="down"){$countObj.val("0")}if(options.type==="up"){$countObj.val(options.goal)}}};return this.each(function(){methods.init($(this))})}})})(jQuery);

angular
    .module('char-counter', [])
    .directive('charCounter', [
        '$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, elem, attrs) {

                    var $this = $(elem),
                        thisGoal = attrs['maxlength'] ? attrs['maxlength'] : 80;

                    $timeout(function() {
                        $this.counter({
                            container_class: 'text-count-wrapper',
                            msg: ' / '+ thisGoal,
                            goal: thisGoal,
                            count: 'up'
                        });

                        if($this.closest('.md-input-wrapper').length) {
                            $this.closest('.md-input-wrapper').addClass('md-input-wrapper-count')
                        }
                    })

                }
            }
        }
    ]);
;'use strict';
angular
    .module('textarea-autosize', [])
    .directive('textareaAutosize', [
        '$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                link: function(scope, elem, attrs) {
                    autosize($(elem));
                    $timeout(function() {
                        scope.$apply(function () {
                            autosize.update($(elem))
                        });
                    })
                }
            }
        }
    ]);
// http://getuikit.com/docs/documentation_javascript.html#js-override

if (typeof UIkit !== 'undefined') {
    UIkit.on('beforeready.uk.dom', function () {

        // accrodion
        if (typeof UIkit.components.accordion !== "undefined") { // check if accordion component is defined
            $.extend(UIkit.components.accordion.prototype.defaults, {
                easing: $.bez([ 0.4,0,0.2,1 ]),
                duration: 200
            });
        }

        // dropdown
        if (typeof UIkit.components.dropdown.prototype !== "undefined") { // check if dropdown component is defined

            $.extend(UIkit.components.dropdown.prototype.defaults, {
                remaintime: 150,
                delay: 50
            });

            (function() {
                var old_show_function = UIkit.components.dropdown.prototype.show;

                UIkit.components.dropdown.prototype.show = function() {

                    this.dropdown
                        .css({
                            'min-width': this.dropdown.outerWidth()
                        })
                        .addClass('uk-dropdown-active uk-dropdown-shown');

                    return old_show_function.apply(this, arguments);
                }
            })();

            (function() {
                var old_hide_function = UIkit.components.dropdown.prototype.hide;

                UIkit.components.dropdown.prototype.hide = function() {

                    var this_dropdown = this.dropdown;

                    this_dropdown.removeClass('uk-dropdown-shown');

                    var dropdown_timeout = setTimeout(function() {
                        this_dropdown.removeClass('uk-dropdown-active')
                    },280);

                    return old_hide_function.apply(this, arguments);
                }
            })();

        }

        // modal
        if (typeof UIkit.components.modal !== "undefined") { // check if modal component is defined
            $.extend(UIkit.components.modal.prototype.defaults, {
                center: true
            });

            UIkit.modal.dialog.template = '<div class="uk-modal uk-modal-dialog-replace"><div class="uk-modal-dialog" style="min-height:0;"></div></div>';
            $('body')
                .on('show.uk.modal', '.uk-modal-dialog-replace', function () {
                    // customize uikit dialog
                    setTimeout(function () {
                        var dialogReplace = $('.uk-modal-dialog-replace');
                        if (dialogReplace.find('.uk-button-primary').length) {
                            var actionBtn = dialogReplace.find('.uk-button-primary').toggleClass('uk-button-primary md-btn-flat-primary');
                            if (actionBtn.next('button')) {
                                actionBtn.next('button').after(actionBtn);
                            }
                        }
                        if (dialogReplace.find('.uk-button').length) {
                            dialogReplace.find('.uk-button').toggleClass('uk-button md-btn md-btn-flat');
                        }
                        if (dialogReplace.find('.uk-margin-small-top').length) {
                            dialogReplace.find('.uk-margin-small-top').toggleClass('uk-margin-small-top uk-margin-top');
                        }
                        var dialogInput = dialogReplace.find('input.uk-width-1-1');
                        if (dialogInput.length) {
                            dialogInput.toggleClass('uk-width-1-1 md-input');

                            if(!dialogInput.closest('.md-input-wrapper').length) {

                                dialogInput.wrap('<div class="md-input-wrapper"/>');
                                dialogInput
                                    .on('focus', function () {
                                        dialogInput.closest('.md-input-wrapper').addClass('md-input-focus')
                                    })
                                    .on('blur',function () {
                                        dialogInput.closest('.md-input-wrapper').removeClass('md-input-focus');
                                        if (dialogInput.val() != '') {
                                            dialogInput.closest('.md-input-wrapper').addClass('md-input-filled')
                                        } else {
                                            dialogInput.closest('.md-input-wrapper').removeClass('md-input-filled')
                                        }
                                    })
                                    .closest('.md-input-wrapper').append('<span class="md-input-bar"/>');
                            }

                            if (dialogInput.val() != '') {
                                dialogInput.closest('.md-input-wrapper').addClass('md-input-filled')
                            }

                        }
                        if (dialogReplace.find('.uk-form').length) {
                            dialogReplace.find('.uk-form').removeClass('uk-form');
                        }
                    }, 50)
                });
        }

        // tooltip
        if (typeof UIkit.components.tooltip !== "undefined") { // check if tooltip component is defined
            $.extend(UIkit.components.tooltip.prototype.defaults, {
                animation: 280,
                offset: 8
            });
        }

        // sortable
        if (typeof UIkit.components.sortable !== "undefined") { // check if sortable component is defined
            if(Modernizr.touch) {
                $('[data-uk-sortable]').children().addClass('needsclick');
            }
        }

    });
}

// uikit custom
altair_uikit = {
    reinitialize_grid_margin: function() {
        $("[data-uk-grid-margin]").each(function() {
            var element = $(this);
            if (!element.data("gridMargin")) {
                $.UIkit.gridMargin(element, $.UIkit.Utils.options(element.attr("data-uk-grid-margin")));
            }
        });
        $(window).resize();
    }
};

(function () {
  'use strict';

  angular
    .module('app.template.directives', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function ukNotification($window) {
    return {
      restrict: 'A',
      scope: {
        message: '@',
        status: '@?',
        timeout: '@?',
        group: '@?',
        position: '@?',
        callback: '&?'
      },
      link: function (scope, elem, attrs) {

        var w = angular.element($window),
            $element = $(elem);

        scope.showNotify = function() {
          var thisNotify = UIkit.notify({
            message: scope.message,
            status: scope.status ? scope.status : '',
            timeout: scope.timeout ? scope.timeout : 5000,
            group: scope.group ? scope.group : '',
            pos: scope.position ? scope.position : 'top-center',
            onClose: function() {
              $('body').find('.md-fab-wrapper').css('margin-bottom','');
              clearTimeout(thisNotify.timeout);

              if(scope.callback) {
                if( angular.isFunction(scope.callback()) ) {
                  scope.$apply(scope.callback());
                } else {
                  console.log('Callback is not a function');
                }
              }
            }
          });
          if(((w.width() < 768) && ((scope.position == 'bottom-right') || (scope.position == 'bottom-left') || (scope.position == 'bottom-center') ) ) || (scope.position == 'bottom-right')) {
            var thisNotify_height = $(thisNotify.element).outerHeight(),
              spacer = (w.width() < 768) ? -6 : 8;
             $('body').find('.md-fab-wrapper').css('margin-bottom',thisNotify_height + spacer);
            }
        };

        $element.on("click", function(){
          if($('body').find('.uk-notify-message').length) {
            $('body').find('.uk-notify-message').click();
            setTimeout(function() {
              scope.showNotify();
            },450);
          } else {
            scope.showNotify();
          }
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('ukNotification', ukNotification);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ukHtmlEditor($timeout) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        $timeout(function() {
          UIkit.htmleditor(elem[0], {
            'toolbar': '',
            'height': '240'
          });
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('ukHtmlEditor', ukHtmlEditor);

})();

(function () {
  'use strict';

  /** @ngInject */
  function singleCard($window,$timeout) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {

        var $md_card_single = $(elem),
        w = angular.element($window);

        function md_card_content_height() {
          var content_height = w.height() - ((48 * 2) + 12);
          $md_card_single.find('.md-card-content').innerHeight(content_height);
        }

        $timeout(function() {
          md_card_content_height();
        },100);

        w.on('resize', function(e) {
          // Reset timeout
          $timeout.cancel(scope.resizingTimer);
          // Add a timeout to not call the resizing function every pixel
          scope.resizingTimer = $timeout( function() {
            md_card_content_height();
            return scope.$apply();
          }, 280);
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('singleCard', singleCard);

})();

(function () {
  'use strict';

  /** @ngInject */
  function sidebarSecondaryToggle($rootScope, $window, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      template: '<a href="#" id="sSwitch_secondary" class="sSwitch sSwitch_right" ng-show="sidebar_secondary" ng-click="toggleSecondarySidebar($event)"><span class="sSwitchIcon"></span></a>',
      link: function (scope, el, attrs) {
        scope.toggleSecondarySidebar = function ($event) {
          $event.preventDefault();
          $rootScope.secondarySidebarActive = !$rootScope.secondarySidebarActive;
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('sidebarSecondaryToggle', sidebarSecondaryToggle);

})();

(function () {
  'use strict';

  /** @ngInject */
  function sidebarSecondary($rootScope, $window, $timeout, variables) {
    return {
      restrict: 'A',
      link: function(scope,el,attrs) {
        $rootScope.sidebar_secondary = true;

        if(attrs.toggleHidden == 'large') {
          $rootScope.secondarySidebarHiddenLarge = true;
        }

        // chat
        var $sidebar_secondary = $(el);
        if($sidebar_secondary.find('.md-list.chat_users').length) {

          $('.md-list.chat_users').children('li').on('click',function() {
            $('.md-list.chat_users').velocity("transition.slideRightBigOut", {
              duration: 280,
              easing: variables.easing_swiftOut,
              complete: function() {
                $sidebar_secondary
                  .find('.chat_box_wrapper')
                  .addClass('chat_box_active')
                  .velocity("transition.slideRightBigIn", {
                    duration: 280,
                    easing: variables.easing_swiftOut,
                    begin: function() {
                      $sidebar_secondary.addClass('chat_sidebar');
                    }
                 });
               }
            });
          });

          $sidebar_secondary
            .find('.chat_sidebar_close')
            .on('click',function() {
              $sidebar_secondary
                .find('.chat_box_wrapper')
                .removeClass('chat_box_active')
                .velocity("transition.slideRightBigOut", {
                  duration: 280,
                  easing: variables.easing_swiftOut,
                  complete: function () {
                    $sidebar_secondary.removeClass('chat_sidebar');
                    $('.md-list.chat_users').velocity("transition.slideRightBigIn", {
                      duration: 280,
                      easing: variables.easing_swiftOut
                  });
                }
              });
          });

          if($sidebar_secondary.find('.uk-tab').length) {
          $sidebar_secondary.find('.uk-tab').on('change.uk.tab',function(event, active_item, previous_item) {
            if($(active_item).hasClass('chat_sidebar_tab') && $sidebar_secondary.find('.chat_box_wrapper').hasClass('chat_box_active')) {
              $sidebar_secondary.addClass('chat_sidebar');
            } else {
              $sidebar_secondary.removeClass('chat_sidebar');
            }
          });
          }
        }
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('sidebarSecondary', sidebarSecondary);

})();

(function () {
  'use strict';

  /** @ngInject */
  function sidebarPrimaryToggle($rootScope, $window, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: '<a id="sSwitch_primary" href="#" class="sSwitch sSwitch_left" ng-click="togglePrimarySidebar($event)" ng-hide="miniSidebarActive || topMenuActive"><span class="sSwitchIcon"></span></a>',
      link: function (scope, el, attrs) {
        scope.togglePrimarySidebar = function ($event) {

          $event.preventDefault();

          if($rootScope.primarySidebarActive) {
            $rootScope.primarySidebarHiding = true;
            if($rootScope.largeScreen) {
              $timeout(function() {
                $rootScope.primarySidebarHiding = false;
                $(window).resize();
              },280);
            }
          } else {
            if($rootScope.largeScreen) {
              $timeout(function() {
                $(window).resize();
              });
            }
          }
          
          $rootScope.primarySidebarActive = !$rootScope.primarySidebarActive;

          if( !$rootScope.largeScreen ) {
            $rootScope.hide_content_sidebar = $rootScope.primarySidebarActive ? true : false;
          }

          if($rootScope.primarySidebarOpen) {
            $rootScope.primarySidebarOpen = false;
            $rootScope.primarySidebarActive = false;
          }
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('sidebarPrimaryToggle', sidebarPrimaryToggle);

})();

(function() {
    'use strict';

    /** @ngInject */
    function sidebarPrimary($rootScope, $window, $timeout, variables) {
        return {
            restrict: 'A',
            scope: 'true',
            link: function(scope, el, attr) {
                scope.submenuToggle = function($event) {
                    $event.preventDefault();

                    var $this = $($event.currentTarget),
                        $sidebar_main = angular.element('#sidebar_main'),
                        slideToogle = $this.next('ul').is(':visible') ? 'slideUp' : 'slideDown';

                    $this.next('ul')
                        .velocity(slideToogle, {
                            duration: 400,
                            easing: variables.easing_swiftOut,
                            begin: function() {
                                if (slideToogle == 'slideUp') {
                                    $(this).closest('.submenu_trigger').removeClass('act_section');
                                } else {
                                    if ($rootScope.menuAccordionMode) {
                                        $this.closest('li').siblings('.submenu_trigger').each(function() {
                                            $(this).children('ul').velocity('slideUp', {
                                                duration: 500,
                                                easing: variables.easing_swiftOut,
                                                begin: function() {
                                                    $(this).closest('.submenu_trigger').removeClass('act_section');
                                                }
                                            });
                                        });
                                    }
                                    $(this).closest('.submenu_trigger').addClass('act_section');
                                }
                            },
                            complete: function() {
                                if (slideToogle !== 'slideUp') {
                                    var scrollContainer = $sidebar_main.find(".scroll-content").length ? $sidebar_main.find(".scroll-content") : $sidebar_main.find(".scrollbar-inner");
                                    $this.closest('.act_section').velocity("scroll", {
                                        duration: 500,
                                        easing: variables.easing_swiftOut,
                                        container: scrollContainer
                                    });
                                }
                            }
                        });
                };
            }
        };
    }

    angular
        .module('app.template.directives')
        .directive('sidebarPrimary', sidebarPrimary);

})();

(function () {
  'use strict';

  /** @ngInject */
  function printPage() {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var message = attrs['printMessage'];
        $(elem).on('click', function(e) {
          e.preventDefault();
          UIkit.modal.confirm(message ? message : 'Do you want to print this page?', function () {
            // wait for dialog to fully hide
            setTimeout(function () {
              window.print();
            }, 300);
          }, {
            labels: {
              'Ok': 'print'
            }
          });
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('printPage', printPage);

})();

(function () {
  'use strict';

  /** @ngInject */
  function addImageProp($rootScope, utils) {
    return {
      restrict: 'E',
      scope: {
        width: '=',
        height: '=',
        style: '@?'
      },
      template: '<img src="assets/img/spinners/{{style}}{{imgDensity}}.gif" alt="" ng-attr-width="{{width}}" ng-attr-height="{{height}}">',
      link: function (scope, elem, attrs) {

        scope.width = scope.width ? scope.width : 32;
        scope.height = scope.height ? scope.height : 32;
        scope.style = scope.style ? scope.style : 'spinner';
        scope.imgDensity = utils.isHighDensity() ? '@2x' : '' ;

        attrs.$observe('warning', function() {
          scope.style = 'spinner_warning';
        });

        attrs.$observe('success', function() {
          scope.style = 'spinner_success';
        });

        attrs.$observe('danger', function() {
          scope.style = 'spinner_danger';
        });

        attrs.$observe('small', function() {
          scope.style = 'spinner_small';
        });

        attrs.$observe('medium', function() {
          scope.style = 'spinner_medium';
        });

        attrs.$observe('large', function() {
          scope.style = 'spinner_large';
        });

      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('addImageProp', addImageProp);

})();

(function () {
  'use strict';

  /** @ngInject */
  function pageTitle($rootScope, $timeout) {
    return {
      restrict: 'A',
      link: function() {
        var listener = function(event, toState) {
          var default_title = 'Altair Admin';
          $timeout(function() {
            $rootScope.page_title = (toState.data && toState.data.pageTitle) ? default_title + ' - ' + toState.data.pageTitle : default_title;
          });
        };
        $rootScope.$on('$stateChangeSuccess', listener);
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('pageTitle', pageTitle);

})();

(function () {
  'use strict';

  /** @ngInject */
  function onLastRepeat($timeout) {
    return function (scope, element, attrs) {
      if (scope.$last) {
        $timeout(function () {
          scope.$emit('onLastRepeat', element, attrs);
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('onLastRepeat', onLastRepeat);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mdPreloader() {
    return {
      restrict: 'E',
      scope: {
        width: '=',
        height: '=',
        strokeWidth: '=',
        style: '@?'
      },
      template: '<div class="md-preloader{{style}}"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" ng-attr-height="{{ height }}" ng-attr-width="{{ width }}" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" ng-attr-stroke-width="{{ strokeWidth }}"/></svg></div>',
      link: function (scope, elem, attr) {

        scope.width = scope.width ? scope.width : 48;
        scope.height = scope.height ? scope.height : 48;
        scope.strokeWidth = scope.strokeWidth ? scope.strokeWidth : 4;

        attr.$observe('warning', function() {
          scope.style = ' md-preloader-warning';
        });

        attr.$observe('success', function() {
          scope.style = ' md-preloader-success';
        });

        attr.$observe('danger', function() {
          scope.style = ' md-preloader-danger';
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mdPreloader', mdPreloader);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mdInput($timeout) {
    return {
      restrict: 'A',
      scope: {
      ngModel: '='
      },
      controller: function ($scope, $element) {
        var $elem = $($element);
        $scope.updateInput = function() {
          // clear wrapper classes
          $elem.closest('.md-input-wrapper').removeClass('md-input-wrapper-danger md-input-wrapper-success md-input-wrapper-disabled');

          if($elem.hasClass('md-input-danger')) {
            $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-danger');
          }

          if($elem.hasClass('md-input-success')) {
            $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-success');
          }

          if($elem.prop('disabled')) {
            $elem.closest('.md-input-wrapper').addClass('md-input-wrapper-disabled');
          }

          if($elem.hasClass('label-fixed')) {
            $elem.closest('.md-input-wrapper').addClass('md-input-filled');
          }

          if($elem.val() != '') {
            $elem.closest('.md-input-wrapper').addClass('md-input-filled');
          }
        };
      },
      link: function (scope, elem, attrs) {

        var $elem = $(elem);

        $timeout(function() {
          if(!$elem.hasClass('md-input-processed')) {
            if ($elem.prev('label').length) {
              $elem.prev('label').andSelf().wrapAll('<div class="md-input-wrapper"/>');
            } else if ($elem.siblings('[data-uk-form-password]').length) {
              elem.siblings('[data-uk-form-password]').andSelf().wrapAll('<div class="md-input-wrapper"/>');
            } else {
              $elem.wrap('<div class="md-input-wrapper"/>');
            }

            $elem
              .addClass('md-input-processed')
              .closest('.md-input-wrapper')
              .append('<span class="md-input-bar"/>');
          }

          scope.updateInput();

        });

        scope.$watch(function() {
          return $elem.attr('class'); },
          function(newValue,oldValue){
            if(newValue != oldValue) {
              scope.updateInput();
            }
          }
        );

        scope.$watch(function() {
          return $elem.val(); },
          function(newValue,oldValue){
            if( !$elem.is(':focus') && (newValue != oldValue) ) {
              scope.updateInput();
            }
          }
        );

        $elem.on('focus', function() {
          $elem.closest('.md-input-wrapper').addClass('md-input-focus');
        })
        .on('blur', function() {
          $timeout(function() {
            $elem.closest('.md-input-wrapper').removeClass('md-input-focus');
            if($elem.val() == '') {
              $elem.closest('.md-input-wrapper').removeClass('md-input-filled');
            } else {
              $elem.closest('.md-input-wrapper').addClass('md-input-filled');
            }
          },100);
        });

      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mdInput', mdInput);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mdFabToolbar(variables, $document) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, elem, attrs) {

        var $fab_toolbar = $(elem);

        $fab_toolbar
        .children('i')
        .on('click', function(e) {
          e.preventDefault();

          var toolbarItems = $fab_toolbar.children('.md-fab-toolbar-actions').children().length;

          $fab_toolbar.addClass('md-fab-animated');

          var FAB_padding = !$fab_toolbar.hasClass('md-fab-small') ? 16 : 24,
          FAB_size = !$fab_toolbar.hasClass('md-fab-small') ? 64 : 44;

          setTimeout(function() {
            $fab_toolbar.width((toolbarItems*FAB_size + FAB_padding));
          },140);

          setTimeout(function() {
            $fab_toolbar.addClass('md-fab-active');
          },420);

        });

        $($document).on('click scroll', function(e) {
          if( $fab_toolbar.hasClass('md-fab-active') ) {
            if (!$(e.target).closest($fab_toolbar).length) {

              $fab_toolbar.css('width','')
                .removeClass('md-fab-active');

              setTimeout(function() {
                $fab_toolbar.removeClass('md-fab-animated');
              },140);
            }
          }
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mdFabToolbar', mdFabToolbar);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mdFabSpeedDial(variables) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, elem, attrs) {
        $(elem).append('<i class="material-icons md-fab-action-close" style="display:none">&#xE5CD;</i>')
          .on('click',function(e) {
            e.preventDefault();

            var $this = $(this),
              $this_wrapper = $this.closest('.md-fab-wrapper');

            if(!$this_wrapper.hasClass('md-fab-active')) {
              $this_wrapper.addClass('md-fab-active');
            } else {
              $this_wrapper.removeClass('md-fab-active');
            }

            $this.velocity({
              scale: 0
            },{
              duration: 140,
              easing: variables.easing_swiftOut,
              complete: function() {
                $this.children().toggle();
                $this.velocity({
                  scale: 1
                },{
                  duration: 140,
                  easing: variables.easing_swiftOut
                });
              }
            });
          })
          .closest('.md-fab-wrapper').find('.md-fab-small')
          .on('click',function() {
            $(this).closest('.md-fab-wrapper').removeClass('md-fab-active');
          });
        }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mdFabSpeedDial', mdFabSpeedDial);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mdFabSheet(variables, $document) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, elem, attrs) {
        var $fab_sheet = $(elem);

        $fab_sheet.children('i').on('click', function(e) {
          e.preventDefault();

          var sheetItems = $fab_sheet.children('.md-fab-sheet-actions').children('a').length;

          $fab_sheet.addClass('md-fab-animated');

          setTimeout(function() {
            $fab_sheet
              .width('240px')
              .height(sheetItems*40 + 8);
          },140);

          setTimeout(function() {
            $fab_sheet.addClass('md-fab-active');
          },280);

        });

        $($document).on('click scroll', function(e) {
          if( $fab_sheet.hasClass('md-fab-active') ) {
            if (!$(e.target).closest($fab_sheet).length) {
              $fab_sheet.css({
                'height':'',
                'width':''
              })
              .removeClass('md-fab-active');

              setTimeout(function() {
                $fab_sheet.removeClass('md-fab-animated');
              },140);
            }
          }
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mdFabSheet', mdFabSheet);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mainSearchShow($rootScope, $window, variables) {
    return {
      restrict: 'E',
      template: '<a href="#" id="main_search_btn" class="user_action_icon" ng-click="showSearch($event)"><i class="material-icons md-24 md-light">&#xE8B6;</i></a>',
      replace: true,
      scope: true,
      link: function(scope,el,attr) {
        scope.showSearch = function($event) {
        $event.preventDefault();

        $('#header_main')
          .children('.header_main_content')
          .velocity("transition.slideUpBigOut", {
            duration: 280,
            easing: variables.easing_swiftOut,
            begin: function() {
              $rootScope.mainSearchActive = true;
            },
            complete: function() {
              $('#header_main')
                .children('.header_main_search_form')
                .velocity("transition.slideDownBigIn", {
                duration: 280,
                easing: variables.easing_swiftOut,
                complete: function() {
                  $('.header_main_search_input').focus();
                }
              });
            }
          });
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mainSearchShow', mainSearchShow);

})();

(function () {
  'use strict';

  /** @ngInject */
  function mainSearchHide($rootScope, $window, variables) {
    return {
      restrict: 'E',
      template: '<i class="md-icon header_main_search_close material-icons" ng-click="hideSearch($event)">&#xE5CD;</i>',
      replace: true,
      scope: true,
      link: function(scope,el,attr) {
        scope.hideSearch = function ($event) {
          $event.preventDefault();

          var $header_main = $('#header_main');

          $header_main
            .children('.header_main_search_form')
            .velocity("transition.slideUpBigOut", {
            duration: 280,
            easing: variables.easing_swiftOut,
            begin: function() {
              $header_main.velocity("reverse");
              $rootScope.mainSearchActive = false;
            },
            complete: function() {
              $header_main
                .children('.header_main_content')
                .velocity("transition.slideDownBigIn", {
                duration: 280,
                easing: variables.easing_swiftOut,
                complete: function() {
                  $('.header_main_search_input').blur().val('');
                }
              });
            }
          });
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('mainSearchHide', mainSearchHide);

})();

(function () {
  'use strict';

  /** @ngInject */
  function listOutside($window,$timeout) {
    return {
      restrict: 'A',
      link: function (scope, elem, attr) {

        var $md_list_outside_wrapper = $(elem), w = angular.element($window);

        function md_list_outside_height() {
          // var content_height = w.height() - ((48 * 2) + 10);
          var content_height = 100;
          $md_list_outside_wrapper.height(content_height);
        }

        md_list_outside_height();

        w.on('resize', function(e) {
          // Reset timeout
          $timeout.cancel(scope.resizingTimer);
          // Add a timeout to not call the resizing function every pixel
          scope.resizingTimer = $timeout( function() {
            md_list_outside_height();
            return scope.$apply();
          }, 280);
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('listOutside', listOutside);

})();

(function () {
  'use strict';

  /** @ngInject */
  function hierarchicalSlide($timeout, $rootScope) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, elem, attrs) {

        var $this = $(elem),
        baseDelay = 100;

        var add_animation = function(children,context,childrenLength) {
          children.each(function(index) {
            $(this).css({
              '-webkit-animation-delay': (index * baseDelay) + "ms",
              'animation-delay': (index * baseDelay) + "ms"
            });
          });

          $this.waypoint({
            handler: function() {
              $this.addClass('hierarchical_slide_inView');

              $timeout(function() {
                $this.removeClass('hierarchical_slide hierarchical_slide_inView');
                children.css({
                  '-webkit-animation-delay': '',
                  'animation-delay': ''
                });
              }, (childrenLength*baseDelay)+1200 );
              this.destroy();
            },
            context: context[0],
            offset: '90%'
          });
        };

        $rootScope.$watch('pageLoaded',function() {
          if($rootScope.pageLoaded) {
            var thisChildren = attrs['slideChildren'] ? $this.children(attrs['slideChildren']) : $this.children(),
              thisContext = attrs['slideContext'] ? $this.closest(attrs['slideContext']) : 'window',
              thisChildrenLength = thisChildren.length;

            if(thisChildrenLength >= 1) {
              $timeout(function() {
                add_animation(thisChildren,thisContext,thisChildrenLength);
              },560);
            }
          }
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('hierarchicalSlide', hierarchicalSlide);

})();

(function () {
  'use strict';

  /** @ngInject */
  function hierarchicalShow($timeout, $rootScope) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, elem, attrs) {
        var parent_el = $(elem),
          baseDelay = 60;

        var add_animation = function(children,length) {
          children.each(function(index) {
            $(this).css({
              '-webkit-animation-delay': (index * baseDelay) + "ms",
              'animation-delay': (index * baseDelay) + "ms"
            });
          })
          .end()
          .waypoint({
            element: elem[0],
            handler: function() {
              parent_el.addClass('hierarchical_show_inView');
              setTimeout(function() {
                parent_el
                .removeClass('hierarchical_show hierarchical_show_inView fast_animation')
                .children()
                .css({
                  '-webkit-animation-delay': '',
                  'animation-delay': ''
                });
              }, (length*baseDelay)+1200 );

              this.destroy();
            },
            context: window,
            offset: '90%'
          });
        };

        $rootScope.$watch('pageLoaded',function() {
          if($rootScope.pageLoaded) {
            var children = parent_el.children(),
            children_length = children.length;

            $timeout(function() {
              add_animation(children,children_length);
            },560);
          }
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('hierarchicalShow', hierarchicalShow);

})();

(function () {
  'use strict';

  /** @ngInject */
  function fullScreenToggle() {
    return {
      restrict: 'A',
        link: function (scope, elem, attrs) {
        $(elem).on('click', function(e) {
          e.preventDefault();
          screenfull.toggle();
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('fullScreenToggle', fullScreenToggle);

})();

(function () {
  'use strict';

  /** @ngInject */
  function documentEvents($rootScope, $window, $timeout,variables) {
    return {
      restrict: 'A',
      link: function(scope,el,attr) {
        var hidePrimarySidebar = function() {
          $rootScope.primarySidebarActive = false;
          $rootScope.primarySidebarOpen = false;
          $rootScope.hide_content_sidebar = false;
          $rootScope.primarySidebarHiding = true;
          $timeout(function() {
          $rootScope.primarySidebarHiding = false;
          },280);
        };

        var hideSecondarySidebar = function() {
          $rootScope.secondarySidebarActive = false;
        };

        var hideMainSearch = function() {
          var $header_main = $('#header_main');

          $header_main
            .children('.header_main_search_form')
            .velocity("transition.slideUpBigOut", {
              duration: 280,
              easing: variables.easing_swiftOut,
              begin: function() {
                $header_main.velocity("reverse");
                $rootScope.mainSearchActive = false;
              },
              complete: function() {
                $header_main
                  .children('.header_main_content')
                  .velocity("transition.slideDownBigIn", {
                    duration: 280,
                    easing: variables.easing_swiftOut,
                    complete: function() {
                      $('.header_main_search_input').blur().val('');
                    }
                  });
              }
            });
          };

        // hide components on $document click
        scope.onClick = function ($event) {
          // primary sidebar
          if( $rootScope.primarySidebarActive && !$($event.target).closest('#sidebar_main').length && !$($event.target).closest('#sSwitch_primary').length && !$rootScope.largeScreen) {
            hidePrimarySidebar();
          }
          // secondary sidebar
          if( $rootScope.secondarySidebarActive && !$($event.target).closest('#sidebar_secondary').length && !$($event.target).closest('#sSwitch_secondary').length) {
            hideSecondarySidebar();
          }
          // main search form
          if( $rootScope.mainSearchActive && !$($event.target).closest('.header_main_search_form').length && !$($event.target).closest('#main_search_btn').length) {
            hideMainSearch();
          }
          // style switcher
          if( $rootScope.styleSwitcherActive && !$($event.target).closest('#style_switcher').length) {
            $rootScope.styleSwitcherActive = false;
          }
        };

        // hide components on key press (esc)
        scope.onKeyUp = function ($event) {
          // primary sidebar
          if( $rootScope.primarySidebarActive && !$rootScope.largeScreen && $event.keyCode == 27) {
            hidePrimarySidebar();
          }
          // secondary sidebar
          if( $rootScope.secondarySidebarActive && $event.keyCode == 27) {
            hideSecondarySidebar();
          }
          // main search form
          if( $rootScope.mainSearchActive && $event.keyCode == 27) {
            hideMainSearch();
          }
          // style switcher
          if( $rootScope.styleSwitcherActive && $event.keyCode == 27) {
            $rootScope.styleSwitcherActive = false;
          }
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('documentEvents', documentEvents);

})();

(function () {
  'use strict';

  /** @ngInject */
  function customScrollbar($rootScope) {
    return {
      restrict: 'A',
      scope: true,
      link: function (scope, el, attrs) {

        // check if mini sidebar is enabled
        if(attrs['id'] == 'sidebar_main' && $rootScope.miniSidebarActive) {
          return;
        }

        $(el).addClass('uk-height-1-1').wrapInner("<div class='scrollbar-inner'></div>");

        if(Modernizr.touch) {
          $(el).children('.scrollbar-inner').addClass('touchscroll');
        } else {
          $(el).children('.scrollbar-inner').scrollbar({
            disableBodyScroll: true,
            scrollx: false,
            duration: 100
          });
        }
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('customScrollbar', customScrollbar);

})();

(function () {
  'use strict';

  /** @ngInject */
  function contentSidebar($rootScope,$document) {
    return {
      restrict: 'A',
      link: function(scope,el,attr) {

        if(!$rootScope.header_double_height) {
          $rootScope.$watch('hide_content_sidebar', function() {
            if($rootScope.hide_content_sidebar) {
              $('#page_content').css('max-height', $('html').height() - 40);
              // $('html').css({
              //   'paddingRight': scrollbarWidth(),
              //   'overflow': 'hidden'
              // });
            } else {
              $('#page_content').css('max-height','');
              $('html').css({
                'paddingRight': '',
                'overflow': ''
              });
            }
          });
        }
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('contentSidebar', contentSidebar);

})();

(function () {
  'use strict';

  /** @ngInject */
  function cardToggle(variables) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardToggle($event)">&#xE316;</i>',
      link: function (scope, el, attrs) {
        scope.cardToggle = function ($event) {
          $event.preventDefault();

          var $this = $(el),
            thisCard = $this.closest('.md-card');

          $(thisCard).toggleClass('md-card-collapsed').children('.md-card-content').slideToggle('280', variables.bez_easing_swiftOut);

          $this.velocity({
            scale: 0,
            opacity: 0.2
          }, {
            duration: 280,
            easing: variables.easing_swiftOut,
            complete: function() {
              if ($(thisCard).hasClass('md-card-collapsed')){
                $this.html('&#xE313;');
              } else{
                $this.html('&#xE316;');
              }

              $this.velocity('reverse');
            }
          });
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('cardToggle', cardToggle);

})();

(function () {
  'use strict';

  /** @ngInject */
  function cardOverlayToggle($timeout,utils) {
    return {
      restrict: 'E',
      template: '<i class="md-icon material-icons" ng-click="toggleOverlay($event)">&#xE5D4;</i>',
      replace: true,
      scope: true,
      link: function (scope, el, attrs) {

        if(el.closest('.md-card').hasClass('md-card-overlay-active')) {
          el.html('&#xE5CD;');
        }

        scope.toggleOverlay = function ($event) {
          $event.preventDefault();

          if(!el.closest('.md-card').hasClass('md-card-overlay-active')) {
            el.html('&#xE5CD;')
              .closest('.md-card').addClass('md-card-overlay-active');
          } else {
            el.html('&#xE5D4;')
              .closest('.md-card').removeClass('md-card-overlay-active');
          }
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('cardOverlayToggle', cardOverlayToggle);

})();

(function () {
  'use strict';

  /** @ngInject */
  function cardFullscreenDeactivate($rootScope, $window, variables) {
    return {
      restrict: 'E',
      replace: true,
      template: '<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left" ng-show="card_fullscreen" ng-click="cardFullscreenDeactivate($event)">&#xE5C4;</span>',
      link: function (scope, el, attrs) {
        scope.cardFullscreenDeactivate = function ($event) {
        $event.preventDefault();

        // get card placeholder width/height and offset
        var $thisPlaceholderCard = $('.md-card-placeholder'),
          mdPlaceholderCard_h = $thisPlaceholderCard.height(),
          mdPlaceholderCard_w = $thisPlaceholderCard.width(),
          mdPlaceholderCard_offset_top = $thisPlaceholderCard.offset().top,
          mdPlaceholderCard_offset_left = $thisPlaceholderCard.offset().left,

        $thisCard = $('.md-card-fullscreen');

        $thisCard
          // resize card to original size
          .velocity({
            height: mdPlaceholderCard_h,
            width: mdPlaceholderCard_w
          },{
            duration: 600,
            easing: variables.easing_swiftOut,
            begin: function(elements) {
              // hide fullscreen content
              $thisCard.find('.md-card-fullscreen-content').velocity("transition.slideDownOut",{ duration: 280, easing: variables.easing_swiftOut });
              $rootScope.card_fullscreen = false;
            },
            complete: function(elements) {
              $rootScope.hide_content_sidebar = false;
            }
          })
          // move card to original position
          .velocity({
            left: mdPlaceholderCard_offset_left,
            top: mdPlaceholderCard_offset_top
          },{
            duration: 600,
            easing: variables.easing_swiftOut,
            complete: function(elements) {
              // remove some styles added by velocity.js
              $thisCard.removeClass('md-card-fullscreen').css({
                width: '',
                height: '',
                left: '',
                top: ''
              });
              // remove card placeholder
              $thisPlaceholderCard.remove();
                $(window).resize();
              }
          });
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('cardFullscreenDeactivate', cardFullscreenDeactivate);

})();

(function () {
  'use strict';

  /** @ngInject */
  function cardFullscreenActivate($rootScope, variables) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: '<i class="md-icon material-icons md-card-fullscreen-activate" ng-click="cardFullscreenActivate($event)">&#xE5D0;</i>',
      link: function (scope, el, attrs) {
        scope.cardFullscreenActivate = function ($event) {
          $event.preventDefault();

          var $thisCard = $(el).closest('.md-card'),
            mdCard_h = $thisCard.height(),
            mdCard_w = $thisCard.width();

          // create placeholder for card
          $thisCard.after('<div class="md-card-placeholder" style="width:'+ mdCard_w+'px;height:'+ mdCard_h+'px;"/>');
          // add overflow hidden to #page_content (fix for ios)
          //$body.addClass('md-card-fullscreen-active');
          // add width/height to card (preserve original size)
          $thisCard
            .addClass('md-card-fullscreen')
            .css({
              'width': mdCard_w,
              'height': mdCard_h
            })
            // animate card to top/left position
            .velocity({
              left: 0,
              top: 0
              },{
                duration: 600,
                easing: variables.easing_swiftOut,
                begin: function(elements) {
                  $rootScope.card_fullscreen = true;
                  $rootScope.hide_content_sidebar = true;
                  // add back button
                  //$thisCard.find('.md-card-toolbar').prepend('<span class="md-icon md-card-fullscreen-deactivate material-icons uk-float-left">&#xE5C4;</span>');
                  //altair_page_content.hide_content_sidebar();
              }
            })
            // resize card to full width/height
            .velocity({
              height: '100%',
              width: '100%'
            },{
              duration: 600,
              easing: variables.easing_swiftOut,
              complete: function(elements) {
                // activate onResize callback for some js plugins
                //$(window).resize();
                // show fullscreen content
                thisCard.find('.md-card-fullscreen-content').velocity("transition.slideUpBigIn", {
                  duration: 600,
                  easing: variables.easing_swiftOut,
                  complete: function(elements) {
                    // activate onResize callback for some js plugins
                    $(window).resize();
                  }
              });
            }
          });
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('cardFullscreenActivate', cardFullscreenActivate);

})();

(function () {
  'use strict';

  /** @ngInject */
  function cardClose(utils) {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      template: '<i class="md-icon material-icons md-card-toggle" ng-click="cardClose($event)">&#xE14C;</i>',
      link: function (scope, el, attrs) {
        scope.cardClose = function ($event) {
          $event.preventDefault();

            var $this = $(el),
              thisCard = $this.closest('.md-card'),
              removeCard = function() {
                (thisCard).remove();
              };

            utils.card_show_hide(thisCard,undefined,removeCard);
        };
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('cardClose', cardClose);

})();

(function () {
  'use strict';

  /** @ngInject */
  function addImageProp($timeout, utils) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        elem.on('load', function () {
          $timeout(function() {
            var w = !utils.isHighDensity() ? $(elem).width() : $(elem).width()/2,
            h = !utils.isHighDensity() ? $(elem).height() : $(elem).height()/2;
            $(elem).attr('width',w).attr('height',h);
          });
        });
      }
    };
  }

  angular
    .module('app.template.directives')
    .directive('addImageProp', addImageProp);

})();

(function () {
  'use strict';

  angular
    .module('app.template.filters', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function momentDate() {
    return function(x,date_format_i,date_format_o) {
      if(x) {
        if(date_format_i) {
          return moment(x, date_format_i).format(date_format_o);
        } else {
          return moment(new Date(x)).format(date_format_o);
        }
      }
      else return null;
    };
  }

  angular
    .module('app.template.filters')
    .filter('momentDate', momentDate);

})();

(function () {
  'use strict';

  /** @ngInject */
  function initials() {
    return function(x) {
      if(x) {
        return x.split(' ').map(function (s) {
          return s.charAt(0);
        }).join('');
      } else {
        return null;
      }
    };
  }

  angular
    .module('app.template.filters')
    .filter('initials', initials);

})();

(function () {
  'use strict';

  angular
    .module('app.template.factories', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function windowDimensions($window) {
    return {
      height: function() {
        return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      },
      width: function() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      }
    };
  }

  angular
    .module('app.template.factories')
    .factory('windowDimensions', windowDimensions);

})();

(function () {
  'use strict';

  /** @ngInject */
  function utils() {
    return {
      // Util for finding an object by its 'id' property among an array
      findByItemId: function findById(a, id) {
        for (var i = 0; i < a.length; i++) {
          if (a[i].item_id == id) return a[i];
        }
        return null;
      },
      // serialize form
      serializeObject: function(form) {
        var o = {};
        var a = form.serializeArray();
        $.each(a, function() {
          if (o[this.name] !== undefined) {
            if (!o[this.name].push) {
              o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
          } else {
            o[this.name] = this.value || '';
          }
        });
        return o;
      },
      // high density test
      isHighDensity: function() {
        return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3));
      },
      // touch device test
      isTouchDevice: function() {
        return !!('ontouchstart' in window);
      },
      // local storage test
      lsTest: function() {
        var test = 'test';
        try {
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          return true;
        } catch(e) {
          return false;
        }
      },
      // show/hide card
      card_show_hide: function(card,begin_callback,complete_callback,callback_element) {
        $(card).velocity({
          scale: 0,
          opacity: 0.2
        }, {
          duration: 400,
          easing: [ 0.4,0,0.2,1 ],
          // on begin callback
          begin: function () {
            if (typeof begin_callback !== 'undefined') {
              begin_callback(callback_element);
            }
          },
          // on complete callback
          complete: function () {
            if (typeof complete_callback !== 'undefined') {
              complete_callback(callback_element);
            }
          }
        })
        .velocity('reverse');
      }
    };
  }

  angular
    .module('app.template.factories')
    .factory('utils', utils);

})();

(function () {
  'use strict';

  /** @ngInject */
  function printToConsole($rootScope) {
    var handler = { active: false };
    handler.toggle = function () { handler.active = !handler.active; };

    if (handler.active) {
      console.log($state + ' = ' + $state.current.name);
      console.log($stateParams + '=' + $stateParams);
      console.log($state_full_url + '=' + $state.$current.url.source);
      console.log(Card_fullscreen + '=' + card_fullscreen);

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        console.log("$stateChangeStart --- event, toState, toParams, fromState, fromParams");
        console.log(arguments);
      });
      $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        console.log("$stateChangeError --- event, toState, toParams, fromState, fromParams, error");
        console.log(arguments);
      });
      $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        console.log("$stateChangeSuccess --- event, toState, toParams, fromState, fromParams");
        console.log(arguments);
      });
      $rootScope.$on('$viewContentLoading', function (event, viewConfig) {
        console.log("$viewContentLoading --- event, viewConfig");
        console.log(arguments);
      });
      $rootScope.$on('$viewContentLoaded', function (event) {
        console.log("$viewContentLoaded --- event");
        console.log(arguments);
      });
      $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
        console.log("$stateNotFound --- event, unfoundState, fromState, fromParams");
        console.log(arguments);
      });
    }

    return handler;
  }

  angular
    .module('app.template.factories')
    .factory('printToConsole', printToConsole);

})();


(function () {
  'use strict';

  angular
    .module('app.template', [
      
      //pasta modules  
      'angular-chartist',
      'metricsGraphics',
      'selectize',
      'icheck',
      'ngCountup',
      'angular-peity',
      'NgSwitchery',
       
       //  
      'app.template.directives',
      'app.template.factories',
      'app.template.filters',
      
      
    ]);
})();

(function () {
    'use strict';

    angular
        .module('app', [
            'angularTrix',
            'angularUUID2',
            'angular-here-maps',
            'angular-google-analytics',
            'angularUtils.directives.dirPagination',
            'datatables',
            'datatables.buttons',
            'dndLists',
            'fcsa-number',
            'idf.br-filters',
            // 'angular.filter',
            // 'srph.infinite-scroll',

            'ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngJSONPath',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'restangular',
            'sun.scrollable',
            'toastr',
            'ui.router',
            'ngIdle',
            'infinite-scroll',
            '720kb.tooltips',
            'ngCsv',
            'cp.ng.fix-image-orientation',
            'ui.mask',
            'naif.base64',
            
            'app.baseCompany',
            'app.baseApp',
            'app.push',
            'app.pushlog',
            'app.attendance',
            'app.category',
            'app.cliente',
            'app.company',
            'app.constants',
            'app.config',
            'app.configuracao',
            'app.common',
            'app.dashboard',
            'app.dashboardApp',
            'app.dashboardCompany',
            'app.dashboardGeral',
            'app.dashboardMenuApp',
            'app.directives',
            'app.form',
            'app.login',
            'app.log',
            'app.messagepriority',
            'app.messagetemplate',
            'app.papel',
            'app.painel',
            'app.services',
            'app.servico',
            'app.signalr',
            'app.situacao',
            'app.template',
            'app.usuarioadmin',            
            'app.relatorios',
            'app.modal'
        ]);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Less',
        'url': 'http://lesscss.org/',
        'description': 'Less extends the CSS language, adding features that allow variables, mixins, functions and many other techniques.',
        'logo': 'less.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.cliente', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function ClienteService(Common, Restangular, RestangularAuth, APPLICATION) {

        //app/appcompany?appcompanyid=a3173397-2670-476d-91a2-815b60846afe 

        function postApps(body) {
            return RestangularAuth.all('manager/appcompany/user').post(body);
        }


        function getApps(appCompanyId) {
            return RestangularAuth.one('manager/app/appcompany').get(appCompanyId);
        }

        function post(usuario, appId) {
            // return RestangularAuth.all('mobile/account').post(usuario);

            return Restangular.all('mobile/account').post(usuario,
                undefined, { 'Content-Type': 'application/json', 'AppId': appId });
        }

        function getDashBoard() {
            return RestangularAuth.all('manager/account/GetDashboardUsers').customGET();
        }

        function get(company, filters) {
            return RestangularAuth.one('manager/account/' + company.id + '/users').get(filters);
        }

        function getMobile(company, filters) {
            return RestangularAuth.one('manager/appcompany/mobileusers').get(filters);
        }

        function enableDisableUser(id) {
            return RestangularAuth.one('manager/account/' + id + '/EnableDisable').put();
        }

        function enableDisableUserBeta(appId, userId) {
            return RestangularAuth.one('manager/account/' + appId + '/' + userId + '/EnableDisableBeta').put();
        }

        function enableDisableUserBetaNew(appId, userId, publishLevelBeta) {
            return RestangularAuth.one('manager/account/' + appId + '/' + userId + '/' + publishLevelBeta + '/EnableDisableBeta').put();
        }

        function getStatusSources() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusConta);
            return deferred.promise;
        }

        function getStatusEmailSources() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusEmailConta);
            return deferred.promise;
        }

        function forgotPasswordById(userId) {
            return RestangularAuth.all('manager/account/RecoverPassword').post({ userId: userId});
        }

        function getDropdown(filters) {
            return RestangularAuth.all('clientes/resumido').getList(filters);
        }

        function getById(id) {
            return RestangularAuth.one('manager/account/', id).get();
        }

        function getDetailById(object) {
            return RestangularAuth.one('manager/account/' + object.id + '/UserMobileDetailById').get(object);
        }

        function getUserProfileById(id) {
            return RestangularAuth.one('manager/account/' + id + '/profile').get();
        }

        function updateUserProfile(id, user) {
            return RestangularAuth.one('manager/account/profile', id).customPUT(user);
        }

        function deleteAll(ids) {
            return RestangularAuth.one('clientes', ids).remove();
        }

        function confirmEmail(userId) {
            return RestangularAuth.all('manager/account/ResendEmailConfirmation').post({ userId: userId });
        }

        function confirmEmailWithPassword(userId, password) {
            return RestangularAuth.all('manager/account/ResendEmailConfirmation').post({ userId: userId }, { password: password });
        }

        function getDocumentTypes() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.documentTypes);
            return deferred.promise;
        }

        function getGender() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.sex);
            return deferred.promise;
        }

        function getGenderForListing() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusGender);
            return deferred.promise;
        }

        function getBetaStatus() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.genericStatus);
            return deferred.promise;
        }

        function confirmUnconfirmEmail(id) {
            return RestangularAuth.one('manager/account/' + id + '/ConfirmUnconfirmEmail').put();
        }

        return {
            postApps: postApps,
            getApps: getApps,
            post: post,
            getDashBoard: getDashBoard,
            get: get,
            getMobile: getMobile,
            getDropdown: getDropdown,
            getById: getById,
            getDetailById: getDetailById,
            getUserProfileById: getUserProfileById,
            updateUserProfile: updateUserProfile,
            deleteAll: deleteAll,
            enableDisableUser: enableDisableUser,
            enableDisableUserBeta: enableDisableUserBeta,
            enableDisableUserBetaNew: enableDisableUserBetaNew,
            getStatusSources: getStatusSources,
            confirmEmail: confirmEmail,
            getStatusEmailSources: getStatusEmailSources,
            getDocumentTypes: getDocumentTypes,
            getGender: getGender,
            confirmEmailWithPassword: confirmEmailWithPassword,
            getGenderForListing: getGenderForListing,
            getBetaStatus: getBetaStatus,
            forgotPasswordById:forgotPasswordById,
            confirmUnconfirmEmail:confirmUnconfirmEmail
        };
    }

    angular
        .module('app.cliente')
        .factory('Cliente', ClienteService);

})();

(function () {
  'use strict';

  /** @ngInject */
  function ClienteListController(DashboardCompany, $controller, $interval, $rootScope, $scope, $q, Cliente, Company, Common, APPLICATION, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, $timeout, $compile, $state, Security, RestangularAuth, moment) {
    var vm = this;

    //$rootScope.primarySidebarActive = false;
    $scope.$on('enableUser', function (event, data) {
      vm.pesquisar(vm.filters);
    });


    var COMPANY = Company.getCompanySelected();
    /*function userListTreatmentEnable(user){
      if(vm.userListening.id === user.id) {
        console.dir('teste');
        user.enabled = vm.userListening.enabled;
      }
    }*/

    //Permissões
    vm.isUsuarioCadastrarPermitido = false;
    vm.isUsuarioVisualizarPermitido = false; //Detalhar    
    vm.isUsuarioPesquisarPermitido = false;
    vm.configurarPermissoes = function () {
      vm.isUsuarioCadastrarPermitido = false; //(Decisão para a não permissão de cadastro de usuario mobile no admin.) Security.exitsProfilePermission({ id: 1, name: "Usuários App", action: "C" });
      vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Usuários App", action: "R" });
      vm.isUsuarioPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Usuários App", action: "S" });
    };

    vm.detailClient = function (id, $index) {
      //focus selected item, change its color to white
      $timeout(function () {
        vm.selectedIndex = $index;
      }, 250);
      $state.go('private.painel.cliente.list.detail', { 'id': id, 'hidePreloader': 1 });
    };

    vm.exportData = function () {
        var blob = new Blob([document.getElementById('exportable').innerHTML], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        saveAs(blob, "Usuarios.xls");
    };

    vm.getClientes = function (filters) {
      vm.isLoading = true;
      return Cliente.getMobile(COMPANY, filters).then(function (clientes) {
        clientes.result.forEach(clientListTreatment);
        vm.clientes = clientes.result;
        vm.excel = [];

        for (var i = 0; i < vm.clientes.length; i++) {
          var name = vm.clientes[i].profiles[0].name ? vm.clientes[i].profiles[0].name + ' ' + vm.clientes[i].profiles[0].surname : 'Sem nome cadastrado.';
          var mail = vm.clientes[i].profiles[0].mail ? vm.clientes[i].profiles[0].mail : 'Sem email cadastrado.';
          var address = vm.clientes[i].profiles[0].address.addressLine1 ? vm.clientes[i].profiles[0].address.addressLine1 + ', ' + vm.clientes[i].profiles[0].address.district + ', ' + vm.clientes[i].profiles[0].address.number + ', ' + vm.clientes[i].profiles[0].address.city + ' - ' + vm.clientes[i].profiles[0].address.state : 'Sem endereco cadastrado.';
          var documentNumber = vm.clientes[i].profiles[0].documentNumber ? vm.clientes[i].profiles[0].documentNumber : 'Sem documento cadastrado.';
          var sex = vm.clientes[i].profiles[0].sex ? vm.clientes[i].profiles[0].sex : 'Sem dados cadastrados.';
          var phone = vm.clientes[i].profiles[0].phone.phoneNumber ? vm.clientes[i].profiles[0].phone.areaCode + vm.clientes[i].profiles[0].phone.phoneNumber : 'Sem telefone cadastrado.';
          var specialty = vm.clientes[i].profiles[0].specialty ? vm.clientes[i].profiles[0].specialty : 'Sem especialidade cadastrada.';
          var crm = vm.clientes[i].profiles[0].crm ? vm.clientes[i].profiles[0].crm : 'Sem CRM cadastrado.';
          var birthDate = vm.clientes[i].profiles[0].birthDate && vm.clientes[i].profiles[0].birthDate.indexOf(' ') > -1 ? vm.clientes[i].profiles[0].birthDate.split(' ')[0] : 'Sem data cadastrada.';
          
          vm.excel.push({ Nome: name, Email: mail, Endereco: address, Documento: documentNumber, Sexo: sex, Telefone: phone, Especialidade: specialty, CRM: crm, BirthDate: birthDate});

          try {
            var canvas = document.createElement(APPLICATION.STRING_CANVAS);
            var context = canvas.getContext(APPLICATION.STRING_2D);
            var img = document.createElement(APPLICATION.STRING_IMG);
            var base64String = APPLICATION.NULL;
            img.src = APPLICATION.STRING_BASE_IMG_AZURE + vm.clientes[i].appId + APPLICATION.STRING_BAR + vm.clientes[i].id + APPLICATION.STRING_BAR + vm.clientes[i].id + APPLICATION.STRING_JPG;
            context.drawImage(img, APPLICATION.INT_DEZ, APPLICATION.INT_DEZ);
            base64String = canvas.toDataURL();
            base64String = base64String.replace(APPLICATION.STRING_DATA_PNG, APPLICATION.STRING_DATA_JPEG);
            vm.clientes[i].imageNewOrientation = base64String;
          } catch (e) {
            console.log(e);
          }          
        }

        vm.itensShowing = clientes.itensShowing;
        vm.total = clientes.total;
        if (clientes.result.length > 0) {
          vm.qntdUsers = clientes.result[0].qntdTotalUsers;
          formatarHorarios(vm.clientes.result);          
        }
        vm.isLoading = false;
        return vm.clientes;
      });
    };

    vm.isLastPage = false;
    vm.itensPorPagina = 10;

    vm.getNextPageClientes = function () {
      vm.filters.pageNumber += 1;
      vm.filters.totalItens = vm.itensPorPagina;
      vm.busy = true;
      // vm.isLoadingAttendances = true;
      Cliente.getMobile(COMPANY, vm.filters).then(function (clientes) {
        vm.clientes = vm.clientes.concat(clientes.result);
        // vm.isLoadingAttendances = false;
        if (clientes.result.length < vm.itensPorPagina) {
          vm.isLastPage = true;
        }
      }).finally(function () {
        vm.busy = false;
      });
    };

    vm.getStatusSources = function () {
      return Cliente.getStatusSources().then(function (result) {
        vm.selectize_sources_status = result;
        return vm.selectize_sources_status;
      });
    };

    vm.getStatusEmailSources = function () {
      return Cliente.getStatusEmailSources().then(function (result) {
        vm.selectize_sources_status_email = result;
        return vm.selectize_sources_status_email;
      });
    };

    vm.getGender = function () {
      return Cliente.getGenderForListing().then(function (result) {
        vm.selectize_gender_data = result;
        return vm.selectize_gender_data;
      });
    };

    vm.getBetaStatus = function () {
      return Cliente.getBetaStatus().then(function (result) {
        vm.selectize_beta_data = result;
        return vm.selectize_beta_data;
      });
    };

    function clientListTreatment(cliente) {
      cliente.registerDate = cliente.registerDate.substr(0, 10);
    }


    function formatarHorarios(clientes) {
      vm.clientes.forEach(function (item) {
        var date = moment.utc(item.dtCadastro, "DD/MM/YYYY HH:mm:ss").toDate();
        var localTime = moment.utc(date).toDate();
        localTime = moment(localTime).format("DD/MM/YYYY HH:mm:ss");
        item.dtCadastro = localTime;

      }, this);
    }

    vm.confirm = function (clientes) {
      var msg;
      var operacao;
      if (clientes.enabled) { msg = "Deseja realmente desativar o usuário " + clientes.userName + "?"; operacao = 'DA' }
      else { msg = "Deseja realmente reativar o usuário " + clientes.userName + "?"; operacao = 'AT' }
      UIkit.modal.confirm(msg, function () {
        vm.isLoading = true;
        Cliente.enableDisableUser(clientes.id).then(function (result) {
          if (result) {
            Common.messageSuccess('Usuário', operacao, 'M');
          } else {
            Common.mensagemError(result);
          }
          vm.init();
        }).finally(function () {
          vm.pesquisar(vm.filters);
          vm.isLoading = false;
        });
      });
    };

    vm.validateDate = function (filters) {
      // Validação de data inicial, deve ser menor que a final.
      if (filters.DateIni) {
        var dateIniDivide = filters.DateIni.toString().indexOf('.') >= 0 ? filters.DateIni.toString().split('.') : filters.DateIni.toString().split('/');
        if (dateIniDivide.length == 3) {
          var dateIniParse = Date.parse(dateIniDivide[1] + '/' + dateIniDivide[0] + '/' + dateIniDivide[2] + ' 00:00:00');

          if (new Date(dateIniParse) > new Date()) {
            Common.mensagemError('A data inicial não pode ser maior que a data atual.');
            return false;
          }

          if (filters.DateEnd) {
            var dateEndDivide = filters.DateEnd.toString().indexOf('.') >= 0 ? filters.DateEnd.toString().split('.') : filters.DateEnd.toString().split('/');

            if (dateEndDivide.length == 3) {
              var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

              if (new Date(dateIniParse) > new Date(dateEndParse)) {
                Common.mensagemError('A data inicial não pode ser maior que a data final.');
                return false;
              }

              // Calcula a diferença entre as datas.
              var timeDiff = Math.abs(new Date(dateEndParse).getTime() - new Date(dateIniParse).getTime());
              var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

              // Período de datas não pode ser maior que 6 meses.
              if (diffDays > 180) {
                Common.mensagemError('Período pesquisado não pode ser maior que 6 meses.');
                return false;
              }

            } else {
              Common.mensagemError('Data final incorreta.');
              return false;
            }
          }
        } else {
          Common.mensagemError('Data inicial incorreta.');
          return false;
        }
      }

      // Validação de data final, deve ser menor que a atual.
      if (filters.DateEnd) {
        var dateEndDivide = filters.DateEnd.toString().indexOf('.') >= 0 ? filters.DateEnd.toString().split('.') : filters.DateEnd.toString().split('/');
        if (dateEndDivide.length == 3) {
          var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

          if (new Date(dateEndParse) > new Date()) {
            Common.mensagemError('A data final não pode ser maior que a data atual.');
            return false;
          }
        } else {
          Common.mensagemError('Data final incorreta.');
          return false;
        }
      }

      return true;
    }

    vm.pesquisar = function (filters) {
      filters.pageNumber = 1;
      filters.totalItens = vm.itensPorPagina;
      filters.DocumentNumber = filters.Cpf;
      if (vm.validateDate(filters)) {
        vm.getClientes(filters).then(function(clients){
          if(clients && clients.length > 0){
            vm.detailClient(clients[0].id, 0);
          }
        });
      }
    };

    // var getClientesDataTables = function () {
    //     var defer = $q.defer();
    //     RestangularAuth.all('clientes').getList().then(function (result) {
    //         defer.resolve(result.data);
    //     });
    //     return defer.promise;
    // };

    function botaoStatus(data, type, full, meta) {
      if (data.stAtivo) {
        return '<td class="uk-text-center">' +
          '<span class="uk-badge uk-badge-notification uk-badge-success" title="Cliente Ativo"> Ativo </span>' +
          '</td>'
      }
      return '<td class="uk-text-center">' +
        ' <span class="uk-badge uk-badge-notification uk-badge-danger" title="Cliente Inativo"> Inativo </span>' +
        '</td>'
    }

    function botoesAcao(data, type, full, meta) {
      return '<td class="uk-text-center">' +
        '<a href="#/admin/cliente/detail/' + data.id + '"' + '><i class="md-icon material-icons">&#xE8F4;</i></a>' +
        '</td>';
    }


    function iniciarComponentes() {

      vm.dtOptions = DTOptionsBuilder
        .newOptions()
        .withPaginationType('full_numbers')
        .withDisplayLength(10)
        .withDOM('rtip') //original: lfrtip
        .withLanguage(APPLICATION.dataTablesLanguage)
        .withOption('initComplete', function () {
          $timeout(function () {
            $compile($('.dt-uikit .md-input'))($scope);
          })
        });

      vm.selectize_sources_status_config = {
        plugins: {
          'remove_button': {
            label: ''
          }
        },
        maxItems: 1,
        valueField: 'id',
        labelField: 'propertyName',
        searchField: 'searchPropertyName',
        create: false,
        render: {
          option: function (sources, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(sources.propertyName) + '</span>' +
              '</div>';
          },
          item: function (sources, escape) {
            return '<div class="item">' + escape(sources.propertyName) + '</div>';
          }
        }
      };

      vm.selectize_sources_status_email_config = {
        plugins: {
          'remove_button': {
            label: ''
          }
        },
        maxItems: 1,
        valueField: 'id',
        labelField: 'propertyName',
        searchField: 'searchPropertyName',
        create: false,
        render: {
          option: function (sources, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(sources.propertyName) + '</span>' +
              '</div>';
          },
          item: function (sources, escape) {
            return '<div class="item">' + escape(sources.propertyName) + '</div>';
          }
        }
      };

      vm.selectize_status = APPLICATION.statusLogico;
      var status = vm.selectize_status;
      vm.selectize_status_config = {
        plugins: {
          'remove_button': {
            label: ''
          }
        },
        maxItems: null,
        valueField: 'id',
        labelField: 'descricao',
        searchField: 'descricao',
        create: false,
        render: {
          option: function (status, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(status.descricao) + '</span>' +
              '</div>';
          },
          item: function (status, escape) {
            return '<div class="item">' + escape(status.descricao) + '</div>';
          }
        }
      };

      vm.selectize_gender = { options: [] };
      vm.selectize_gender.options = vm.selectize_gender_data;
      vm.selectize_gender_config = {
        create: false,
        maxItems: 1,
        placeholder: 'Todos',
        valueField: 'id',
        labelField: 'descricao',
        searchField: 'descricao',
        render: {
          option: function (status, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(status.descricao) + '</span>' +
              '</div>';
          },
          item: function (status, escape) {
            return '<div class="item">' + escape(status.descricao) + '</div>';
          }
        }
      };

      vm.selectize_beta = { options: [] };
      vm.selectize_beta.options = vm.selectize_beta_data;
      vm.selectize_beta_config = {
        create: false,
        maxItems: 1,
        placeholder: 'Todos',
        valueField: 'id',
        labelField: 'description',
        searchField: 'description',
        render: {
          option: function (status, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(status.description) + '</span>' +
              '</div>';
          },
          item: function (status, escape) {
            return '<div class="item">' + escape(status.description) + '</div>';
          }
        }
      };

      vm.dtColumnDefs = [
        DTColumnDefBuilder.newColumnDef(0),
        DTColumnDefBuilder.newColumnDef(1),
        DTColumnDefBuilder.newColumnDef(2),
        DTColumnDefBuilder.newColumnDef(3),
        DTColumnDefBuilder.newColumnDef(4),
        DTColumnDefBuilder.newColumnDef(5),
        DTColumnDefBuilder.newColumnDef(6)
      ];
    }

    function resetFiltros() {
      vm.filters.stsAtivoIds = [];
    }

    vm.carregarFiltros = function () {
      vm.applications = [];
      vm.selectize_config = {
          plugins: { remove_button: { label: '' } },
          maxItems: 1,
          valueField: APPLICATION.STRING_ID,
          labelField: APPLICATION.STRING_DESCRIPTION,
          create: APPLICATION.BOOLEAN_FALSE,
          sortField: {
              field: 'description',
              direction: 'asc'
          },
          render: {
              option: function (sources, escape) {
                  return '<div class="option">' +
                      '<span class="title">' + escape(sources.description) + '</span>' +
                      '</div>';
              },
              item: function (sources, escape) {
                  return '<div class="item">' + escape(sources.description) + '</div>';
              }
          }
      };

      vm.isLoadingFiltros = true;
      vm.getStatusSources().then(function () {
        vm.getStatusEmailSources().then(function () {
          vm.getGender().then(function () {
            vm.getBetaStatus().then(function () {
              iniciarComponentes();
            });
          });
        });
      });
      vm.isLoadingFiltros = false;
    };

    vm.getApplicationsNew = function (item, companyKey) {
        vm.isLoadingMenuApp = true;
        return Company.getCompanyApps(companyKey, true).then(function (applications) {
            var appSelecionada = DashboardCompany.obterAppSelecionada();

            if (appSelecionada && appSelecionada.local) {
                vm.appCompany = {};
                vm.appCompany.name = appSelecionada.local.name;
                vm.temporaryAppCompany = appSelecionada.local.id;
            } else {
                vm.appCompany = {};
                vm.appCompany.name = "Selecione o app";
                vm.temporaryAppCompany = null;
            }
        
            var applicationsPermissions = [];
            var mtAccountPermissions = JSON.parse(localStorage.getItem('mt-account-permissions'));

            if (applications) {
                for (var j = 0; j < applications.length; j++) {
                    if (mtAccountPermissions) {
                        for (var i = 0; i < mtAccountPermissions.length; i++) {                    
                            if (
                                (applications[j] && mtAccountPermissions[i]) &&
                                ((applications[j].id == mtAccountPermissions[i].appCompanyId) ||
                                (applications[j].app.id == mtAccountPermissions[i].appCompanyId))
                                ) {
                                applicationsPermissions.push(applications[j]);
                                break;
                            }
                        }
                    }
                }
            }
            

            vm.isLoadingMenuApp = false;
            vm.applications = applicationsPermissions;
            return vm.applications;
        });
    };

    vm.addAppCompany = function (cliente) {
        vm.getApps();
        var modal = UIkit.modal('.modalAddApp', {keyboard:false, bgclose:false});
        modal.show();
    };    

    vm.resetFormModalApp = function(form) {

      if (form) {
          vm.modalAddApp = {};
          vm.cancelModal = true;
      }

      var modal = UIkit.modal('.modalAddApp', {keyboard:false, bgclose:false});
      modal.hide();
      $scope.formApp.$setPristine();
      $scope.formApp.$setUntouched();
    }

    vm.getApps = function() {
      vm.appList = [];
      var appCompany = DashboardCompany.obterAppSelecionada();
      if(appCompany){
        return Cliente.getApps(appCompany.id).then(function (clientes) {
          if (clientes) {
            for (var i = 0; i < clientes.length; i++) {
              if (clientes[i].appCompanyId == appCompany.id) {
                if (clientes[i].app) {
                  vm.appList.push({ id: clientes[i].app.id, description: clientes[i].app.name });  
                }              
              }
            }
          }
  
          if (vm.appList && vm.appList.length == 1) {
            vm.modalAddApp.app = vm.appList[0].id;
            vm.disableAppList = true;
          } else if (vm.appList && vm.appList.length > 1) {
            vm.modalAddApp.app = null;
            vm.disableAppList = false;
          } else {
            vm.modalAddApp.app = 'Não existem apps associados.';
            vm.disableAppList = true;
          }
        });
      }
    };

    vm.submitApp = function() {
      var body = {};
      body.AppCompanyId = vm.appCompany.id;
      body.AppId = vm.modalAddApp.app;
      body.UserName = vm.modalAddApp.email;

      return Cliente.postApps(body).then(function (response) {
        Common.messageSuccess(response);
        var modal = UIkit.modal('.modalAddApp', {keyboard:false, bgclose:false});
        modal.hide();
        vm.init();
        return;
      });
    }

    vm.init = function () {
      vm.appList = [];
      vm.modalAddApp = {};
      vm.disableAppList = false;
      vm.getApps();
      vm.cancelModal = false;      
      vm.filters = {};
      vm.filters.limit = 999999;
      vm.filters.Enabled = 'true';
      vm.filters.Roles = ['Mobile'];
      vm.filters.pageNumber = 1;
      vm.filters.totalItens = vm.itensPorPagina;
      if(vm.appCompany){
        vm.filters.appCompanyId = vm.appCompany.id;
      }
      vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
      var today = moment().format(vm.datePickerFormat.format);
      //vm.filters.DateIni = moment().add(-1, 'months').format(vm.datePickerFormat.format);
      //vm.filters.DateEnd = today;
      vm.carregarFiltros();
      vm.getClientes(vm.filters).then(function(clients){
        if(clients && clients.length > 0){
          vm.detailClient(clients[0].id, 0);
        }
      });;
    };

    vm.configurarPermissoes();
    vm.accessIsAllowed = vm.isUsuarioVisualizarPermitido;
    angular.extend(this, $controller('BaseApp', {$scope: this}));
  }

  angular.module('app.cliente')
    .controller('ClienteListController', ClienteListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ClienteDetailController(DashboardCompany, $controller, $interval, $rootScope, $scope, $stateParams, Cliente, Login, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security) {
        var vm = this;
        vm.id = $stateParams.id;
        

        //Permissões
        vm.isUsuarioEditarPermitido = false;
        vm.isUsuarioInativarPermitido = false;
        vm.isUsuarioReenviarEmailPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isUsuarioEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Usuários App", action: "U" });
            vm.isUsuarioInativarPermitido = Security.exitsProfilePermission({ id: 4, name: "Usuários App", action: "AD" });
            vm.isUsuarioReenviarEmailPermitido = Security.exitsProfilePermission({ id: 5, name: "Usuários App", action: "RE" });
            vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Usuários App", action: "R" });
        };

        vm.getCliente = function () {
            vm.isLoadingDetail = true;
            var object = {};
            object.id = vm.id;
            object.appCompanyId = vm.appCompany.id;
            return Cliente.getDetailById(object).then(function (cliente) {
                vm.cliente = cliente;
                /* formatarHorario();*/
                vm.isLoadingDetail = false;
                return vm.cliente;
            });
        };

        vm.getHistorico = function () {
            vm.isLoadingChamados = true;
            return Cliente.getHistorico(vm.cliente.Email).then(function (historico) {
                vm.chamados = historico;
                vm.isLoadingChamados = false;
                return vm.chamados;
            });
        };

        function formatarHorario() {
            var localTime = moment.utc(vm.cliente.dtCadastro).toDate();
            localTime = moment(localTime).format("DD/MM/YYYY HH:mm:ss");
            vm.cliente.dtCadastro = localTime;
        }

        vm.getSuspensoes = function () {
            vm.isLoading = true;
            return Cliente.getSuspensoes(vm.id).then(function (suspensoes) {
                vm.suspensoes = suspensoes;
                vm.isLoading = false;
                return vm.suspensoes;
            });
        };

        vm.confirmSendEmail = function (usuario) {
            var operacao = 'E';
            var username = usuario && usuario.profiles.length > 0 && usuario.profiles[0].name ? usuario.profiles[0].name : 'este usuário';
            var msg = "Deseja realmente enviar um novo e-mail de confirmação para: " + username + "?";

            UIkit.modal.confirm(msg, function () {
                vm.isLoadingDetail = true;
                // Cliente.confirmEmailWithPassword(usuario.id, 'Abc123').then(function(result) {
                Cliente.confirmEmail(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('E-mail', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    vm.init();
                })
                    .finally(function () {
                        vm.isLoadingDetail = false;
                    });
            });
        };

        vm.confirmSendForgotPasswordEmail = function (usuario) {
            var operacao = 'E';
            var username = usuario && usuario.profiles.length > 0 && usuario.profiles[0].name ? usuario.profiles[0].name : 'este usuário';
            var msg = "Deseja realmente enviar um novo e-mail de redefinição de senha para: " + username + "?";
            UIkit.modal.confirm(msg, function () {
                vm.isLoadingDetail = true;
                // $timeout(function () {
                Cliente.forgotPasswordById(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('E-mail', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    vm.init();
                })
                    .finally(function () {
                        vm.isLoadingDetail = false;
                    });
                // }, 1000);
            });
        };

        /*vm.getMotivoSuspensao = function (itemSuspensaoId) {
            vm.isLoadingModal = true;
            return Cliente.getSuspensaoById(itemSuspensaoId).then(function (motivoSuspensao) {
                vm.motivoSuspensao = motivoSuspensao;
                vm.motivoSuspensao.dtSuspensao = moment(vm.motivoSuspensao.dtSuspensao).format(vm.datePickerFormat.format);
                vm.DATA_RETORNO = vm.motivoSuspensao.dtRetorno;

                if (vm.motivoSuspensao.id && !vm.motivoSuspensao.dtRetorno) {
                    vm.motivoSuspensao.dtRetorno = moment().format(vm.datePickerFormat.format);
                } else {
                    if (vm.motivoSuspensao.dtRetorno) {
                        vm.motivoSuspensao.dtRetorno = moment(vm.motivoSuspensao.dtRetorno).format(vm.datePickerFormat.format);
                    }
                }
                vm.isLoadingModal = false;
                return vm.motivoSuspensao;
            });
        };*/

        vm.abrirModal = function () {
            if (vm.suspensoes.length > 0) {
                // if ((vm.suspensoes[0].dtRetorno == undefined) || (moment(vm.suspensoes[0].dtRetorno).format(vm.datePickerFormat.format) > moment().format(vm.datePickerFormat.format))) {
                if (vm.suspensoes[0].dtRetorno == undefined) {
                    Common.mensagemError("Esse cliente já está suspenso!");
                } else {
                    abrirModal();
                }
            } else {
                abrirModal();
            }
        }

        vm.abrirModalChamados = function () {

            vm.getHistorico();

            var modal = UIkit.modal("#modal_overflow");
            modal.show();

        }

        vm.fecharModal = function () {
            fecharModal();
        }

        vm.confirmExcluir = function (cliente) {
            UIkit.modal.confirm('Deseja realmente excluir o cliente ' + cliente.Name + '?', function () {
                Cliente.deleteAll(vm.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Cliente', 'D', 'M');
                        $state.go('private.painel.cliente.list');
                    } else {
                        Common.mensagemError(result);
                    }
                })
            });

        };

        vm.submit = function (motivoSuspensao) {
            if (motivoSuspensao) {
                if (motivoSuspensao.id) {
                    vm.putMotivoSuspensao(motivoSuspensao);
                } else {
                    vm.postMotivoSuspensao(motivoSuspensao);
                }
            }
        };

        function abrirModal() {
            var modal = UIkit.modal("#modal_header_footer");
            modal.show();
            resetModal();
        }

        function fecharModal() {
            var modal = UIkit.modal("#modal_header_footer");
            modal.hide();
            resetModal();

        }

        function resetModal() {
            vm.isLoadingModal = false;
            vm.motivoSuspensao = {};
            var hoje = moment().format(vm.datePickerFormat.format);
            vm.motivoSuspensao.dtSuspensao = hoje;
        }

        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2)
            ];

        }

        //Validação das datas
        $scope.$watch(
            'vm.motivoSuspensao.dtSuspensao',
            function () {
                var result = Common.validateData(vm.motivoSuspensao.dtSuspensao, vm.motivoSuspensao.dtRetorno);
                if (!result) {
                    vm.motivoSuspensao.dtSuspensao = undefined;
                    Common.mensagemError('Data inicial não pode ser maior que data final.');
                }
            }
        );

        vm.confirm = function (clientes) {
            var msg;
            var operacao;
            if (clientes.enabled) { msg = "Deseja realmente desativar o usuário " + clientes.userName + "?"; operacao = 'DA' }
            else { msg = "Deseja realmente reativar o usuário " + clientes.userName + "?"; operacao = 'AT' }

            UIkit.modal.confirm(msg, function () {
                vm.isLoading = true;
                Cliente.enableDisableUser(clientes.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Usuário', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    $scope.$emit('enableUser', result);
                    vm.init();
                }).finally(function () {
                    vm.pesquisar(vm.filters);
                    vm.isLoading = false;
                });
            });
        };

        vm.confirmEmail = function (clientes) {
            var msg;
            var operacao;
            if (clientes.emailConfirmed) { msg = "Deseja realmente desconfirmar o e-mail do usuário " + clientes.userName + "?"; operacao = 'DE' }
            else { msg = "Deseja realmente confirmar o e-mail do usuário " + clientes.userName + "?"; operacao = 'CO' }

            UIkit.modal.confirm(msg, function () {
                vm.isLoading = true;
                Cliente.confirmUnconfirmEmail(clientes.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('E-mail', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    $scope.$emit('enableUser', result);
                    vm.init();
                }).finally(function () {
                    vm.pesquisar(vm.filters);
                    vm.isLoading = false;
                });
            });
        };

        vm.confirmBeta = function (clientes) {
            var msg;
            var operacao = 'A';
            if (clientes.beta) { msg = "Deseja realmente remover a permissão beta do usuário " + clientes.userName + "?"; }
            else { msg = "Deseja realmente ativar a permissão beta para o usuário  " + clientes.userName + "?"; }

            UIkit.modal.confirm(msg, function () {
                vm.isLoading = true;
                var publishLevelBeta = !vm.cliente.beta ? true : false;
                Cliente.enableDisableUserBetaNew(vm.appComapy.id, clientes.id, publishLevelBeta).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Usuário', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    //$scope.$emit('enableUser', result);
                    vm.init();
                }).finally(function () {
                    vm.pesquisar(vm.filters);
                    vm.isLoading = false;
                });
            });
        };

        $scope.$watch(
            'vm.motivoSuspensao.dtRetorno',
            function () {
                var result = Common.validateData(vm.motivoSuspensao.dtSuspensao, vm.motivoSuspensao.dtRetorno);
                if (!result) {
                    vm.motivoSuspensao.dtRetorno = undefined;
                    Common.mensagemError('Data inicial não pode ser maior que data final.');
                }
            }
        );

        vm.init = function () {
            vm.configurarPermissoes();
            vm.motivoSuspensao = {};

            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            var hoje = moment().format(vm.datePickerFormat.format);
            vm.motivoSuspensao.dtSuspensao = hoje;

            iniciarComponentes();
            vm.getCliente().then(function () {
                iniciarComponentes();                
            });
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isUsuarioVisualizarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
    }

    angular.module('app.cliente')
        .controller('ClienteDetailController', ClienteDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ClienteCreateController(DashboardCompany, $http, $interval, $rootScope, $scope, $state, $stateParams, Common, Cliente, Security, APPLICATION) {
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        var vm = this;
        vm.operacao = 'Cadastrar';

        vm.configurarPermissoes = function () {
            vm.isUsuarioEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Usuários App", action: "U" });
            vm.isUsuarioInativarPermitido = Security.exitsProfilePermission({ id: 4, name: "Usuários App", action: "AD" });
            vm.isUsuarioReenviarEmailPermitido = Security.exitsProfilePermission({ id: 5, name: "Usuários App", action: "RE" });
            vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Usuários App", action: "R" });
        };

        vm.configureImage = function() {
            vm.update = false;
        };

        vm.getCliente = function (id) {
            vm.isLoading = true;
            vm.update = true;
            //return Cliente.getUserProfileById(id).then(function (cliente) {
            Cliente.getById(id).then(function (cliente) {    
                vm.photoAzure = APPLICATION.STRING_BASE_IMG_AZURE + cliente.appId + APPLICATION.STRING_BAR + cliente.id + APPLICATION.STRING_BAR + cliente.id + APPLICATION.STRING_JPG;;
            });
            
            return Cliente.getUserProfileById(id).then(function (cliente) {                
                vm.cliente = cliente;
                vm.cliente.email = cliente.mail;
                vm.cliente.openingHour1 = cliente.openingHour != null ? cliente.openingHour.split('-')[0] : '00:00';
                vm.cliente.openingHour2 = cliente.openingHour != null ? cliente.openingHour.split('-')[1] : '00:00';
                vm.cliente.birthDate = vm.cliente.birthDate ? vm.cliente.birthDate.split(' ')[0] : null;
                vm.cliente.documentType = 'CPF';
                vm.isLoading = false;
                return vm.cliente;
            });
        };


        vm.getCep = function(cep) {
            try {
                $.get( routeWebApiCorreios.replace('@cep', cep), function( data ) {
                    if (data) {
                        vm.cliente.address = !vm.cliente.address ? {} : vm.cliente.address;
                        vm.cliente.address.addressLine1 = data.logradouro;
                        vm.cliente.address.district = data.bairro;
                        vm.cliente.address.city = data.localidade;
                        vm.cliente.address.state = data.uf;
                        vm.cliente.address.zipCode = data.cep;
                    }
                }).fail(function() {
                    vm.cliente.address = {};
                });
            } catch (e) {
                console.log(e);
            }
        };

        vm.getGender = function () {
            return Cliente.getGender().then(function (result) {
                vm.selectize_gender_data = result;
                return vm.selectize_gender_data;
            });
        };

        vm.getDocuments = function () {
            return Cliente.getDocumentTypes().then(function (result) {
                vm.selectize_docs_data = result;
                return vm.selectize_docs_data;
            });
        };


        vm.carregarFiltros = function () {
            vm.isLoading = true;
            vm.getGender().then(function () {
                vm.getDocuments().then(function () {
                    iniciarComponentes();
                    vm.isLoading = false;
                });
            });
        };

        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.cliente.list', { id: vm.id });
                } else {
                    $state.go('private.painel.cliente.list');
                }
            });
        };

        vm.submit = function (cliente) {
            if ((vm.cliente && vm.cliente.documentNumber) && vm.invalidCpf || vm.invalidCnpj) {
                return false;
            }

            if (vm.cliente && !vm.cliente.documentNumber) {
                vm.cliente.documentType = null;
            }

            if (vm.cliente && vm.cliente.documentNumber && vm.cliente.documentType == 'CPF') {
                 var retorno = vm.validateCpf(vm.cliente.documentNumber);
                 vm.cliente.documentNumber = !retorno ? null : vm.cliente.documentNumber;

                 if (!retorno) {
                    return retorno;   
                 }                 
            } else if (vm.cliente && vm.cliente.documentNumber && vm.cliente.documentType == 'CNPJ') {
                var retorno = vm.validateCnpj(vm.cliente.documentNumber);
                vm.cliente.documentNumber = !retorno ? null : vm.cliente.documentNumber;
                
                if (!retorno) {
                    return retorno;   
                }
            }

            if (vm.photo && vm.photo.base64) {
                cliente.photos = [];
                cliente.photos.push({ base64: vm.photo.base64 });
            }            

            cliente.OpeningHour = cliente.openingHour1 + '-' + cliente.openingHour2;
            cliente.phone.text = cliente.phone.phoneNumber;
            if (cliente) {
                if (cliente.id) {
                    vm.putCliente(cliente);
                } else {
                    vm.postCliente(cliente);
                }
            }
        };

        vm.postCliente = function (cliente) {
            vm.isLoading = true;

            // Senha gerada: 6 dígitos, números, caractere maiúsculo, minúsculo e especial.
            //var password = Common.generatePassword(8);

            // Senha gerada: 6 dígitos, 3 letras (a-j) e 3 números (0-9).
            //var password = Common.generatePasswordEasy();

            // Específico para o Fleury, a pedido da cliente Mariana Degasperi.
            var password = 'Abc123';

            cliente.password = password;
            cliente.confirmPassword = password;
            cliente.registerOrigin = "web";
            cliente.DocumentType = "CNPJ";
            
            Cliente.post(cliente, vm.appCompany.app.id).then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Usuário Mobile', 'I', 'M');
                        vm.isLoading = false;
                        $state.go('private.painel.cliente.list');
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putCliente = function (cliente) {
            vm.isLoading = true;
            Cliente.updateUserProfile(cliente.id, cliente).then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Usuário Mobile', 'A', 'M');
                        vm.isLoading = false;
                        //$state.go('private.painel.cliente.detail', { id: cliente.id });
                        $state.go('private.painel.cliente.list');
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            })
        };

        function iniciarComponentes() {

            // Configurações do combo.
            vm.selectize_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                searchField: APPLICATION.STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            vm.selectize_gender = { options: [] };
            vm.selectize_gender.options = vm.selectize_gender_data;
            vm.selectize_gender_config = {
                create: false,
                maxItems: 1,
                placeholder: '',
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao'
            };

            vm.selectize_docs = { options: [] };
            vm.selectize_docs.options = vm.selectize_docs_data;
            vm.selectize_docs_config = {
                create: false,
                maxItems: 1,
                placeholder: '',
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao'
            };
        }

        vm.cleanDocumentNumberError = function() {
            vm.invalidCpf = false;
            vm.invalidCnpj = false;
            if (vm.cliente) {
                vm.cliente.documentNumber = null;
            }
        };

        vm.validateCpf = function(strCpf) {
            vm.invalidCpf = false;

            var soma;
            var resto;
            soma = 0;
            if (strCpf == "00000000000") {
                vm.invalidCpf = true;
                return false;
            }

            if (!strCpf || strCpf.length < 11) {
                //vm.invalidCpf = true;
                return false;
            }

            for (var i = 1; i <= 9; i++) {
                soma = soma + parseInt(strCpf.substring(i - 1, i)) * (11 - i);
            }

            resto = soma % 11;

            if (resto == 10 || resto == 11 || resto < 2) {
                resto = 0;
            } else {
                resto = 11 - resto;
            }

            if (resto != parseInt(strCpf.substring(9, 10))) {
                vm.invalidCpf = true;
                return false;
            }

            soma = 0;

            for (var i = 1; i <= 10; i++) {
                soma = soma + parseInt(strCpf.substring(i - 1, i)) * (12 - i);
            }
            resto = soma % 11;

            if (resto == 10 || resto == 11 || resto < 2) {
                resto = 0;
            } else {
                resto = 11 - resto;
            }

            if (resto != parseInt(strCpf.substring(10, 11))) {
                vm.invalidCpf = true;
                return false;
            }

            vm.invalidCpf = false;
            return true;
        };

        vm.validateCnpj = function(cnpj) {
            vm.invalidCnpj = false;

            if (!cnpj || cnpj.length < 14) {
                //vm.invalidCnpj = true;
                return false;
            }

            cnpj = cnpj.replace(/[^\d]+/g,'');
         
            if(cnpj == '') {
                //vm.invalidCnpj = true;
                return false;
            }
             
            if (cnpj.length != 14) {
                //vm.invalidCnpj = true;
                return false;
            }
         
            // Elimina CNPJs invalidos conhecidos
            if (cnpj == "00000000000000" || 
                cnpj == "11111111111111" || 
                cnpj == "22222222222222" || 
                cnpj == "33333333333333" || 
                cnpj == "44444444444444" || 
                cnpj == "55555555555555" || 
                cnpj == "66666666666666" || 
                cnpj == "77777777777777" || 
                cnpj == "88888888888888" || 
                cnpj == "99999999999999") {
                vm.invalidCnpj = true;
                return false;
            }
                 
            // Valida DVs
            var tamanho = cnpj.length - 2
            var numeros = cnpj.substring(0,tamanho);
            var digitos = cnpj.substring(tamanho);
            var soma = 0;
            var pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
              soma += numeros.charAt(tamanho - i) * pos--;
              if (pos < 2)
                    pos = 9;
            }
            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) {
                vm.invalidCnpj = true;
                return false;
            }
                 
            tamanho = tamanho + 1;
            numeros = cnpj.substring(0,tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (var i = tamanho; i >= 1; i--) {
              soma += numeros.charAt(tamanho - i) * pos--;
              if (pos < 2)
                    pos = 9;
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) {
                vm.invalidCnpj = true;
                return false;
            }
                   
            vm.invalidCnpj = false;
            return true;
            
        }

        vm.init = function () {
            vm.update = false;

            vm.listSex = [];
            vm.listSex.push({ id: 'Masculino', description: 'Masculino' });
            vm.listSex.push({ id: 'Feminino', description: 'Feminino' });

            vm.listDocumentType = [];
            vm.listDocumentType.push({ id: 'CPF', description: 'CPF' });
            vm.listDocumentType.push({ id: 'CNPJ', description: 'CNPJ' });
            vm.listDocumentType.push({ id: 'RNE', description: 'RNE' });

            vm.listSpecialty = ["Acupuntura", "Alergia e Imunologia", "Anestesiologia", "Angiologia", "Cancerologia", "Cardiologia", "Cirurgia Cardiovascular", "Cirurgia da Mão", "Cirurgia de cabeça e pescoço", "Cirurgia do Aparelho Digestivo", "Cirurgia Geral", "Cirurgia Pediátrica", "Cirurgia Plástica", "Cirurgia Torácica", "Cirurgia Vascular", "Clínica Médica", "Coloproctologia", "Dermatologia", "Endocrinologia e Metabologia", "Endoscopia", "Gastroenterologia", "Genética médica", "Geriatria", "Ginecologia e obstetrícia", "Hematologia e Hemoterapia", "Homeopatia", "Infectologia", "Mastologia", "Medicina de Família e Comunidade", "Medicina do Trabalho", "Medicina do Tráfego", "Medicina Esportiva", "Medicina Física e Reabilitação", "Medicina Intensiva", "Medicina Legal e Perícia Médica", "Medicina Nuclear", "Medicina Preventiva e Social", "Nefrologia", "Neurocirurgia", "Neurologia", "Nutrologia", "Obstetrícia", "Oftalmologia", "Ortopedia e Traumatologia", "Otorrinolaringologia", "Patologia", "Patologia Clínica/Medicina laboratorial", "Pediatria", "Pneumologia", "Psiquiatria", "Radiologia e Diagnóstico por Imagem", "Radioterapia", "Reumatologia", "Urologia"];

            vm.cliente = {};
            vm.cliente.documentType = 'CPF';

            vm.invalidCpf = false;
            vm.invalidCnpj = false;

            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            vm.carregarFiltros();

            vm.isEdicao = false;
            vm.id = $stateParams.id;

            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }

            if (vm.isEdicao) {
                vm.operacao = 'Editar';
                vm.getCliente(vm.id).then(function () {
                    vm.carregarFiltros();
                });
            }
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isUsuarioEditarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this})); 
    }

    angular.module('app.cliente')
        .controller('ClienteCreateController', ClienteCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.usuarioadmin', []);
})();

(function () {
    'use strict';

    function UsuarioAdminService(Common, RestangularAuth, APPLICATION) {


        function post(usuario, company) {
            // return RestangularAuth.all('manager/account').post(usuario);

            return RestangularAuth.all('manager/account').post(usuario,
                undefined, { 'Content-Type': 'application/json', 'CompanyId': company.id });
        }
        
        function get(company, filters) {
            return RestangularAuth.one('manager/account/' + company.id + '/users').get(filters);
        }

        function getByAppCompany(company, appCompanyId, filters) {
            return RestangularAuth.all('manager/account/' + company.id + '/' + appCompanyId + '/users').getList(filters);
        }

        function getById(id) {
            return RestangularAuth.one('manager/account', id).get();
        }

        function getUserProfileById(id) {
            return RestangularAuth.one('manager/account/' + id + '/profile').get();
        }

        function updateUserProfile(id, user) {
            return RestangularAuth.one('manager/account/profile', id).customPUT(user);
        }

        function getCompanyApps(id){
            return RestangularAuth.one('manager/account/' + id.toString() +'/appcompany').get();
        }

        function getStatusSources() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusConta);
            return deferred.promise;
        }

        function verifyEmail(email){
            var result = RestangularAuth.one('manager/account/' + email.toString() + '/isavailable').customGET();
            console.dir(result);
            console.dir(result.restangularCollection);
            return result;
        }

        function forgotPasswordById(userId) {
            return RestangularAuth.all('manager/account/RecoverPassword').post({ userId: userId});
        }

        function getStatusEmailSources() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusEmailConta);
            return deferred.promise;
        }

        function getProfiles(usuarioId) {
            return RestangularAuth.all('manager/account/getProfiles?userId=' + usuarioId.toString()).getList();
        }

        function getProfilesCombo() {
            return RestangularAuth.all('usuarios/perfis').getList();
        }

        function enableDisableUser(id) {
            return RestangularAuth.one('manager/account/' + id + '/EnableDisable').put();
        }

        function confirmEmail(userId) {
            return RestangularAuth.all('manager/account/ResendEmailConfirmation').post({ userId: userId, name: '' });
        }

        function changePassword(usuario) {
            return RestangularAuth.all('manager/account/ChangePassword').post(usuario);
        }

        function getRoles(company) {
            return RestangularAuth.all('manager/roles').getList({ companyId: company.id });
        }

        function putUserRole(roles, company) {
            return RestangularAuth.all('manager/account/roles').post(roles,
                undefined, { 'Content-Type': 'application/json', 'CompanyId': company.id });
        }

        var service = {
            getProfiles: getProfiles,
            get: get,
            getProfilesCombo: getProfilesCombo,
            getById: getById,
            getUserProfileById: getUserProfileById,
            updateUserProfile: updateUserProfile,
            post: post,
            changePassword: changePassword,
            enableDisableUser: enableDisableUser,
            confirmEmail: confirmEmail,
            getStatusSources: getStatusSources,
            getStatusEmailSources: getStatusEmailSources,
            getRoles: getRoles,
            putUserRole: putUserRole,
            getCompanyApps: getCompanyApps,
            verifyEmail: verifyEmail,
            forgotPasswordById:forgotPasswordById,
            getByAppCompany:getByAppCompany
        };

        return service;
    }

    UsuarioAdminService.$inject = ['Common', 'RestangularAuth', 'APPLICATION'];

    angular
        .module('app.usuarioadmin')
        .factory('UsuarioAdmin', UsuarioAdminService);


})();

(function () {
    'use strict';

    /** @ngInject */
    function UsuarioListController($stateParams, $controller, DashboardCompany, $interval, $rootScope, $scope, UsuarioAdmin, Common, Company, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, Security, Painel) {
        var vm = this;

        var COMPANY = Company.getCompanySelected();
        vm.company = COMPANY;
        
        //$rootScope.primarySidebarActive = true;

        //Permissões
        vm.isUsuarioCadastrarPermitido = false;
        vm.isUsuarioVisualizarPermitido = false; //Detalhar    
        vm.isUsuarioPesquisarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isUsuarioCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Colaboradores", action: "C" });
            vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Colaboradores", action: "R" });
            vm.isUsuarioPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Colaboradores", action: "S" });
        };

        $scope.$on('enableUser', function (event, data) {
            vm.pesquisar(vm.filters);
        });

        vm.getStatusSources = function () {
            return UsuarioAdmin.getStatusSources().then(function (result) {
                vm.selectize_sources_status = result;
                return vm.selectize_sources_status;
            });
        };

        vm.getStatusEmailSources = function () {
            return UsuarioAdmin.getStatusEmailSources().then(function (result) {
                vm.selectize_sources_status_email = result;
                return vm.selectize_sources_status_email;
            });
        };

        vm.getUsuarios = function (filter) {
            vm.isLoading = true;
            return UsuarioAdmin.get(COMPANY, filter).then(function (usuarios) {
                vm.isLoading = false;
                usuarios.result.forEach(userListTreatment);
                usuarios.result.forEach(getExtraInfo);
                vm.usuarios = usuarios.result;
                vm.total = usuarios.total;
                vm.itensShowing = usuarios.itensShowing;
                if (usuarios.result.length > 0) {
                    vm.qntdUsers = usuarios.result[0].qntdTotalUsers;
                    vm.detailUsuario(usuarios.result[0].id, 0, usuarios.result[0].extraRole);
                }
                return vm.usuarios;
            });
        };

        vm.getRoles = function () {
            return UsuarioAdmin.getRoles(COMPANY).then(function (result) {
                vm.roles = result;
                vm.selectize_roles_update = _.filter(result, function (o)                
                { return !_.includes(o.name.toUpperCase(), "mobile".toUpperCase()); });
                vm.selectize_roles_update.push({name: 'Todos'});                
                return vm.roles;
            });
        };

        vm.getApplications = function (companyKey) {
            return Painel.getCompanyApps().then(function (applications) {                
                vm.applications = applications;
                vm.selectize_apps_update = vm.applications;
                vm.selectize_apps_update.push({id: '', name:'Todos'});
                return vm.applications;
            });
        };

        vm.detailUsuario = function (id, $index, role) {
            //focus selected item, change its color to white
            $timeout(function () {
                vm.selectedIndex = $index;
            }, 250);
            $state.go('private.painel.usuario.list.detail', { 'id': id, 'hidePreloader': 1, 'papel': role });
        };

        vm.isLastPage = false;
        vm.itensPorPagina = 10;        

        vm.getNextPageUsuarios = function () {
            vm.copied.pageNumber += 1;
            vm.copied.totalItens += vm.itensPorPagina;
            vm.busy = true;
            // vm.isLoadingAttendances = true;
            UsuarioAdmin.get(COMPANY, vm.copied).then(function (usuarios) {
                usuarios.result.forEach(userListTreatment);
                usuarios.result.forEach(getExtraInfo);                                
                if (usuarios.result.length > 0) {
                    vm.qntdUsers = usuarios.result[0].qntdTotalUsers;
                    vm.detailUsuario(usuarios.result[0].id, 0, usuarios.result[0].extraRole);
                }
                vm.usuarios = vm.usuarios.concat(usuarios.result);
                // vm.isLoadingAttendances = false;
                if (usuarios.result.length < vm.itensPorPagina) {
                    vm.isLastPage = true;
                }
            }).finally(function () {
                vm.busy = false;
            });
        };

        function userListTreatment(user) {
            user.registerDate = user.registerDate.substr(0, 10);
        }

        vm.confirm = function (usuario) {
            var msg;
            var operacao;
            if (usuario.enabled) { msg = "Deseja realmente desativar o usuário " + usuario.userName + "?"; operacao = 'DA' }
            else { msg = "Deseja realmente reativar o usuário " + usuario.userName + "?"; operacao = 'AT' }

            UIkit.modal.confirm(msg, function () {
                vm.isLoading = true;
                vm.isLoadingDetail = true;
                UsuarioAdmin.enableDisableUser(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Usuário', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    vm.init();
                }).finally(function () {
                    vm.isLoading = false;
                });
            });
        };

        vm.confirmSendEmail = function (usuario) {
            var operacao = 'E';
            var msg = "Deseja realmente enviar um novo e-mail de confirmação para: " + usuario.userName + "?";

            UIkit.modal.confirm(msg, function () {
                vm.isLoading = true;
                UsuarioAdmin.confirmEmail(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('E-mail', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    vm.init();
                })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            });
        };

        vm.validateDate = function (filters) {
            // Validação de data inicial, deve ser menor que a final.
            if (filters.DateIni) {
                var dateIniDivide = filters.DateIni.toString().indexOf('.') >= 0 ? filters.DateIni.toString().split('.') : filters.DateIni.toString().split('/');
                if (dateIniDivide.length == 3) {
                    var dateIniParse = Date.parse(dateIniDivide[1] + '/' + dateIniDivide[0] + '/' + dateIniDivide[2] + ' 00:00:00');

                    if (new Date(dateIniParse) > new Date()) {
                        Common.mensagemError('A data inicial não pode ser maior que a data atual.');
                        return false;
                    }

                    if (filters.DateEnd) {
                        var dateEndDivide = filters.DateEnd.toString().indexOf('.') >= 0 ? filters.DateEnd.toString().split('.') : filters.DateEnd.toString().split('/');

                        if (dateEndDivide.length == 3) {
                            var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

                            if (new Date(dateIniParse) > new Date(dateEndParse)) {
                                Common.mensagemError('A data inicial não pode ser maior que a data final.');
                                return false;
                            }

                            // Calcula a diferença entre as datas.
                            var timeDiff = Math.abs(new Date(dateEndParse).getTime() - new Date(dateIniParse).getTime());
                            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                            // Período de datas não pode ser maior que 6 meses.
                            if (diffDays > 180) {
                                Common.mensagemError('Período pesquisado não pode ser maior que 6 meses.');
                                return false;
                            }

                        } else {
                            Common.mensagemError('Data final incorreta.');
                            return false;
                        }
                    }
                } else {
                    Common.mensagemError('Data inicial incorreta.');
                    return false;
                }
            }

            // Validação de data final, deve ser menor que a atual.
            if (filters.DateEnd) {
                var dateEndDivide = filters.DateEnd.toString().indexOf('.') >= 0 ? filters.DateEnd.toString().split('.') : filters.DateEnd.toString().split('/');
                if (dateEndDivide.length == 3) {
                    var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

                    if (new Date(dateEndParse) > new Date()) {
                        Common.mensagemError('A data final não pode ser maior que a data atual.');
                        return false;
                    }
                } else {
                    Common.mensagemError('Data final incorreta.');
                    return false;
                }
            }

            return true;
        }

        vm.pesquisar = function (filters) {
            filters.pageNumber = 1;
            filters.totalItens = vm.itensPorPagina;

            if (vm.validateDate(filters)) {
                vm.copied = angular.copy(filters);
                if (vm.copied.Roles == undefined || vm.copied.Roles.length == 0) {
                    vm.roleNames = [];
                    vm.selectize_roles_update.forEach(function (element) {
                        if(element.name.toUpperCase() !== 'TODOS'){
                            vm.roleNames.push(element.name);
                        }
                    }, this);                    
                    vm.copied.Roles = vm.roleNames;
                    vm.copied.AppCompanyId = vm.filters.AppCompanyId                    
                }
                vm.getUsuarios(vm.copied);
            }
        };

        vm.carregarFiltrosAndSearch = function () {
            vm.isLoadingFiltros = true;
            vm.getRoles().then(function () {
                vm.getStatusSources().then(function () {
                    vm.getStatusEmailSources().then(function () {
                        vm.getApplications(vm.companyKey).then(function (){
                            initComponents();
                            vm.pesquisar(vm.filters);
                            vm.isLoadingFiltros = false;
                        });
                    });
                });
            });
        };

        function getExtraInfo(user) {
            if (user.roles && user.roles.length > 0) {
                user.extraRole = '';
                for (var i = 0; i < user.roles.length; i++) {
                    var retorno = _.find(vm.roles, function (o) { return o.id == user.roles[i].role.id });
                    if (retorno && !_.includes(user.extraRole, retorno.name)) {
                        user.extraRole = retorno ? user.extraRole + '/' + retorno.name : '';                        
                    }
                }
                user.extraRole = user.extraRole.substring(1);
            }
        }

        

        function initComponents() {
            vm.selectize_status = APPLICATION.statusLogico;
            var status = vm.selectize_status;
            vm.selectize_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.descricao) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.descricao) + '</div>';
                    }
                }
            };

            var perfis = vm.selectize_perfis;
            vm.selectize_perfis_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao',
                create: false,
                render: {
                    option: function (perfis, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(perfis.Name) + '</span>' +
                            '</div>';
                    },
                    item: function (perfis, escape) {
                        return '<div class="item">' + escape(perfis.Name) + '</div>';
                    }
                }
            };

            vm.selectize_sources_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.propertyName) + '</div>';
                    }
                }
            };

            vm.selectize_sources_status_email_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'searchPropertyName',
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.propertyName) + '</div>';
                    }
                }
            };

            var roles = vm.selectize_roles_update;
            vm.selectize_roles_update_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                placeholder: "Todos",
                valueField: 'name',
                labelField: 'name',
                searchField: 'name',
                create: false,
                render: {
                    option: function (roles, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(roles.name) + '</span>' +
                            '</div>';
                    },
                    item: function (roles, escape) {
                        return '<div class="item">' + escape(roles.name) + '</div>';
                    }
                }
            };

            var apps = vm.selectize_apps_update;
            vm.selectize_apps_update_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'name',
                searchField: 'id',
                create: false,
                render: {
                    option: function (apps, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(apps.name) + '</span>' +
                            '</div>';
                    },
                    item: function (apps, escape) {
                        return '<div class="item">' + escape(apps.name) + '</div>';
                    }
                }
            };
        }



        vm.init = function () {
            //vm.configureProfiles();
            vm.companySelected = Company.getCompanySelected();
            vm.companyKey = vm.companySelected.id;
            vm.configurarPermissoes();
            vm.filters = {};
            vm.filters.limit = 999999;
            vm.filters.Enabled = true;
            vm.filters.Roles = [];
            vm.filters.Apps = [];
            vm.filters.pageNumber = 1;
            vm.filters.totalItens = vm.itensPorPagina;
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            var today = moment().format(vm.datePickerFormat.format);
            vm.carregarFiltrosAndSearch();
            
            var companyKey = '';
            DashboardCompany.removerAppSelecionada();
            $rootScope.$broadcast('reload-menu');            
            if (!$stateParams.key) {
                vm.companySelected = Company.getCompanySelected();
                companyKey = vm.companySelected.id;
            } else {
                companyKey = $stateParams.key;
            }
            vm.isLoading = true;
            vm.getApplications(companyKey).then(function (data) {
                vm.isLoading = false;
            });
        };

        //vm.init();
        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isUsuarioVisualizarPermitido;
        angular.extend(this, $controller('BaseCompany', {$scope: this}));
    }

    angular.module('app.usuarioadmin')
        .controller('UsuarioListController', UsuarioListController);

})();
(function () {
    'use strict';

    /** @ngInject */
    function UsuarioDetailController($interval, $controller, $rootScope, $scope, $stateParams, UsuarioAdmin, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security, Cliente, Login, Company, Painel) { //
        var vm = this;
        vm.id = $stateParams.id;
        vm.extraRole = $stateParams.papel;
        var COMPANY = Company.getCompanySelected();

        //Permissões
        vm.isUsuarioEditarPermitido = false;
        vm.isUsuarioInativarPermitido = false;
        vm.isUsuarioReenviarEmailPermitido = false;
        vm.isUsuarioVisualizarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isUsuarioEditarPermitido = Security.exitsProfilePermission({ id: 1, name: "Colaboradores", action: "U" });
            vm.isUsuarioInativarPermitido = Security.exitsProfilePermission({ id: 2, name: "Colaboradores", action: "AD" });
            vm.isUsuarioReenviarEmailPermitido = Security.exitsProfilePermission({ id: 3, name: "Colaboradores", action: "RE" });
            vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Colaboradores", action: "R" });
        };

        vm.confirmSendEmail = function (usuario) {
            var operacao = 'E';
            var username = usuario && usuario.profiles.length > 0 && usuario.profiles[0].name ? usuario.profiles[0].name : 'este usuário';
            var msg = "Deseja realmente enviar um novo e-mail de confirmação para: " + username + "?";

            UIkit.modal.confirm(msg, function () {
                vm.isLoadingDetail = true;
                // $timeout(function () {
                    Cliente.confirmEmail(usuario.id).then(function (result) {
                        if (result) {
                            Common.messageSuccess('E-mail', operacao, 'M');
                        } else {
                            Common.mensagemError(result);
                        }
                        vm.init();
                    })
                        .finally(function () {
                            vm.isLoadingDetail = false;
                        });
                // }, 1000);
            });
        };         

        vm.confirmSendForgotPasswordEmail = function (usuario) {
            var operacao = 'E';
            var username = usuario && usuario.profiles.length > 0 && usuario.profiles[0].name ? usuario.profiles[0].name : 'este usuário';
            var msg = "Deseja realmente enviar um novo e-mail de redefinição de senha para: " + username + "?";
            UIkit.modal.confirm(msg, function () {
                vm.isLoadingDetail = true;
                // $timeout(function () {
                UsuarioAdmin.forgotPasswordById(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('E-mail', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    vm.init();
                })
                    .finally(function () {
                        vm.isLoadingDetail = false;
                    });
                // }, 1000);
            });
        };


        vm.getUsuario = function () {
            vm.isLoadingDetail = true;
            return UsuarioAdmin.getById(vm.id).then(function (usuario) {
                vm.usuario = usuario;
                vm.usuario.extraRole = vm.extraRole;
                vm.isLoadingDetail = false;
                return vm.usuario;
            });
        };

        vm.confirm = function (usuario) {
            var msg;
            var operacao;
            if (usuario.enabled) { msg = "Deseja realmente desativar o usuário " + usuario.userName + "?"; operacao = 'DA' }
            else { msg = "Deseja realmente reativar o usuário " + usuario.userName + "?"; operacao = 'AT' }

            UIkit.modal.confirm(msg, function () {
                vm.isLoading = true;
                UsuarioAdmin.enableDisableUser(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Usuário', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    $scope.$emit('enableUser', result);
                    vm.init();
                }).finally(function () {
                    vm.pesquisar(vm.filters);
                    vm.isLoading = false;
                });
            });
        };

        // vm.getApplications = function (id) {
        //     return UsuarioAdmin.getCompanyApps(id).then(function (applications) {                
        //         vm.applications = applications.result;
        //         return vm.applications;
        //     });
        // };

        vm.getApplications = function () {
            
            return Painel.getCompanyApps(COMPANY.id, null).then(function (applications) {
                vm.selectize_apps = applications;
                vm.selectize_apps = _.map(vm.selectize_apps).map(function (x) {
                    return { id: x.id, name: x.app.name, local: x.name, logoSecondary: x.logoSecondary }
                });
                /*altera o objeto de usuario para envio com as apps*/
                //if (!vm.usuario.roles) {
                    vm.usuario.roles = [];
                //}
                vm.selectize_apps.forEach(function (element) {
                    vm.usuario.roles.push({ appCompanyId: element.id, appCompanyName: element.name, local: element.local, logoSecondary: element.logoSecondary, companyId: COMPANY.id });
                }, this);

                return vm.selectize_apps;
            });
        };

        vm.getUserAppWithRoles = function (userKey) {
            return Company.getCompaniesByUser(userKey).then(function (userAppRoles) {
                vm.userAppRoles = _.filter(userAppRoles, function (o) { return o.appCompanyId });
                vm.userAppRoles = _.map(vm.userAppRoles).map(function (x) {
                    return { appCompanyId: x.appCompanyId, name: x.role.name, logoSecondary: x.logoSecondary }
                });
                /*altera o objeto de usuario para envio com as apps, associado aos respectivos papeis*/
                vm.userAppRoles.forEach(function (element) { 
                    var item = _.find(vm.usuario.roles, function (o) { return element.appCompanyId == o.appCompanyId });
                    if (item) { item.name = element.name; }
                }, this);
                return vm.userAppRoles;
            });
        };

        vm.addRoles = function (usuario) {
            var msg;
            var operacao;
            if (usuario.enabled) { msg = "Deseja realmente desativar o usuário " + usuario.userName + "?"; operacao = 'DA' }
            else { msg = "Deseja realmente reativar o usuário " + usuario.userName + "?"; operacao = 'AT' }
            UIkit.modal.confirm(msg, function () {
                UsuarioAdmin.enableDisableUser(usuario.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Usuário', operacao, 'M');
                    } else {
                        Common.mensagemError(result);
                    }
                    vm.init();
                })
            });
        };

        vm.init = function () {
            //Permissões            
            vm.configurarPermissoes();

            vm.isLoading = true;
            vm.getUsuario().then(function () {
                vm.getApplications().then(function (data) {
                    vm.getUserAppWithRoles(vm.id).then(function (data) {
                        vm.isLoading = false;
                    });
                });
            });
        };
        

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isUsuarioVisualizarPermitido;
        angular.extend(this, $controller('BaseCompany', {$scope: this}));
    }

    angular.module('app.usuarioadmin')
        .controller('UsuarioDetailController', UsuarioDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function UsuarioCreateController(Auth, $controller, Session, Login, DashboardCompany, $compile, $interval, $rootScope, $scope, $state, $stateParams, $timeout, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, Common, Company, UsuarioAdmin, Security, Painel) {
        var vm = this;
        vm.operacao = 'Cadastrar';
        vm.semAcesso = 'Sem acesso';

        var COMPANY = Company.getCompanySelected();
        vm.company = COMPANY;

        vm.openModalConfirmacaoDeCancelamento = function() {
            var modalConfirmCancelamento = UIkit.modal('.cancelar', {keyboard:false, bgclose:false});
            modalConfirmCancelamento.show();
        }
        vm.isUsuarioVisualizarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Colaboradores", action: "R" });
            vm.isUsuarioEditarPermitido = Security.exitsProfilePermission({ id: 1, name: "Colaboradores", action: "U" });
            vm.isUsuarioCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Colaboradores", action: "C" });
        };
       
        /* Apenas apps -- considerar atritbuto "id" de fora do objeto app - refere-se ao appCompanyId*/
        vm.getApplications = function () {
            return Painel.getCompanyApps(COMPANY.id, null).then(function (applications) {
                vm.selectize_apps = applications;
                vm.selectize_apps = _.map(vm.selectize_apps).map(function (x) {
                    return { id: x.id, name: x.app.name, local: x.name, logoSecondary: x.logoSecondary }
                });
                /*altera o objeto de usuario para envio com as apps*/
                if (!vm.usuario.roles) {
                    vm.usuario.roles = [];
                }
                vm.selectize_apps.forEach(function (element) {
                    vm.usuario.roles.push({ appCompanyId: element.id, appCompanyName: element.name, local: element.local, logoSecondary: element.logoSecondary, companyId: COMPANY.id });
                }, this);

                return vm.selectize_apps;
            });
        };

        /* Apenas papeis */
        vm.getRoles = function () {
            return UsuarioAdmin.getRoles(COMPANY).then(function (result) {
                result.push({ id: null, name: vm.semAcesso });
                vm.selectize_roles = _.filter(result, function (o)
                { return !_.includes(o.name.toUpperCase(), "mobile".toUpperCase()); });
                vm.selectize_roles = _.map(vm.selectize_roles).map(function (x) {
                    return { id: x.id, name: x.name }
                });
                return vm.selectize_roles;
            });
        };

        vm.emailIsAvailable = function(){  
            return UsuarioAdmin.verifyEmail(vm.usuario.email).then(function (result){                    
                return vm.emailIsNotAvailable = !result.isAvailable;    
            });            
        }

        /* Associacao papeis/apps do usuário - apenas se houver vm.id */
        vm.getUserAppWithRoles = function (userKey) {
            return Company.getCompaniesByUser(userKey).then(function (userAppRoles) {
                vm.userAppRoles = _.filter(userAppRoles, function (o) { return o.appCompanyId });
                vm.userAppRoles = _.map(vm.userAppRoles).map(function (x) {
                    return { appCompanyId: x.appCompanyId, name: x.role.name }
                });

                /*altera o objeto de usuario para envio com as apps, associado aos respectivos papeis*/
                vm.userAppRoles.forEach(function (element) {
                    var item = _.find(vm.usuario.roles, function (o) { return element.appCompanyId == o.appCompanyId });
                    if (item) { item.name = element.name; }
                }, this);
                return vm.userAppRoles;
            });
        };

        vm.getUsuario = function (id) {
            return UsuarioAdmin.getUserProfileById(id).then(function (usuario) {
                vm.usuario = usuario;
                vm.usuario.email = usuario.mail;
                return vm.usuario;
            });
        };

        vm.getUsuarioRoleInfo = function (id) {
            return UsuarioAdmin.getById(id).then(function (usuario) {
                vm.usuarioRoleData = usuario;
                return vm.usuarioRoleData;
            });
        };

        vm.postUserRoles = function (roles) {
            return UsuarioAdmin.putUserRole(roles, COMPANY).then(function (result) {
                return result;
            });
        };

        vm.carregarFiltros = function () {
            vm.getApplications().then(function () {
                vm.getRoles().then(function () {
                    if (vm.id) {
                        //obtem dados da role do usuario apos carregamento das roles
                        vm.getUsuarioRoleInfo(vm.id).then(function () {
                            vm.selectize_roles.push({ id: '0', description: "Sem acesso" });
                            vm.roleGeral = _.find(vm.selectize_roles, function (o)
                            { return o.id == _.find(vm.usuarioRoleData.roles, function (o) { return !o.appCompanyId && o.role.companyId == COMPANY.id }).role.id }).name;

                            vm.getUserAppWithRoles(vm.id).then(function () {
                                iniciarComponentes();
                                vm.isLoading = false;
                            });
                        });
                    } else {
                        iniciarComponentes();
                        vm.isLoading = false;
                    }
                });
            });
        };

        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.usuario.list', { id: vm.id });
                } else {
                    $state.go('private.painel.usuario.list');
                }
            });
        };

        function adjustRolesArray(usuario) {
            /*remove itens com papel sem acesso do array de roles para o envio*/
            var modifiedRolesArray = [];
            if (usuario.roles) {
                for (var i = 0; i < usuario.roles.length; i++) {
                    if (usuario.roles[i].name) {
                        //usuario.roles[i].name = "Admin";
                        modifiedRolesArray.push(usuario.roles[i]);
                    }
                }
                /*adicionar role geral para o array*/
                modifiedRolesArray.push({
                    name: vm.roleGeral,
                    companyId: COMPANY.id,
                    appCompanyId: null
                })
                usuario.roles = modifiedRolesArray;
            }

            return usuario;
        }
        vm.submit = function (usuario) {
            if(vm.emailIsNotAvailable){
                Common.mensagemError("Informe um e-mail que esteja disponível.");
                return;
            }

            if (!vm.roleGeral || vm.roleGeral == vm.semAcesso) {
                Common.mensagemError("Informe o papel do usuário.");
                return;
            }

            for (var i = 0; i < usuario.roles.length; i++) {
                if (usuario.roles[i].name && usuario.roles[i].name == vm.semAcesso) {
                    usuario.roles[i].name = null;
                }
            }

            if (usuario) {
                vm.isLoading = true;
                usuario = adjustRolesArray(usuario);
                if (usuario.id) {
                    vm.putUsuario(usuario);
                } else {
                    vm.postUsuario(usuario);
                }
            }
        };

        vm.postUsuario = function (usuario) {
            vm.isLoading = true;
            var usuarioForSending = angular.copy(usuario);
            //usuarioForSending.roles = undefined;

            UsuarioAdmin.post(usuarioForSending, COMPANY).then(function (result) {
                if (result) {
                    if (result.id) {
                        vm.postUserRoles({ userId: result.id, roles: usuario.roles }).then(function (result) {
                            Common.messageSuccess('Usuário', 'I', 'M');
                            $state.go('private.painel.usuario.list');
                            vm.isLoading = false;
                        }).catch(function (result) {
                            Common.mensagemError(result);
                            vm.isLoading = false;
                        });
                    }
                }
            }).catch(function (result) {
                vm.isLoading = false;
            });
        };

        vm.userProfiles = function (profiles) {
            var permissions = [];
            var permission = {
                permissionId: '',
                name: '',
                actions: ''
            };

            if (profiles) {
                for (var i = 0; i < profiles.length; i++) {
                    permission = new Object();
                    permission.permissionId = profiles[i].functionalityId;
                    permission.name = profiles[i].name;
                    permission.funcionalidadeInicial = profiles[i].initial;
                    var actions = [];

                    for (var j = 0; j < profiles[i].actions.length; j++) {
                        actions.push({ actionId: profiles[i].actions[j].id, name: profiles[i].actions[j].description, letter: profiles[i].actions[j].letter });
                    }

                    permission.actions = angular.copy(actions);
                    permissions.push(permission);
                }
            }

            return permissions;
        };

        vm.getAllUserAppWithRoles = function (userKey) {
            return Company.getCompaniesByUser(userKey).then(function (userAppRoles) {
                return userAppRoles;
            });
        };

        vm.putUsuario = function (usuario) {
            vm.isLoading = true;

            var usuarioForSending = angular.copy(usuario);
            usuarioForSending.roles = undefined;

            vm.postUserRoles({ userId: vm.id, roles: usuario.roles }).then(function (result) {
                UsuarioAdmin.updateUserProfile(usuario.id, usuarioForSending).then(function (result) {
                        if (result && result.id) {
                            var reload =false;
                            if (usuario.userId == vm.usuario.userId) {
                                reload = true;
                            }
                            Common.messageSuccess('Usuário', 'A', 'M');
                            vm.isLoading = false;
                            $state.go('private.painel.usuario.list', {}, {reload: reload});
                        }
                        else {
                            Common.mensagemError(result);
                            vm.isLoading = false;
                        }
                    })
                }).catch(function (result) {
                    //Common.mensagemError(result);
                    vm.isLoading = false;
                });
        };

        vm.removerAssociacao = function (index) {
            // vm.usuario.roles.splice(index, 1);
            vm.usuario.roles[index].name = undefined;
        };

        // vm.addAssociacao = function () {
        //     vm.usuario.roles.push({ appCompanyId: undefined, role: undefined });
        // };

        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(9999)
                .withDOM('r') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3)
            ];

            var roles = vm.selectize_roles;
            vm.selectize_roles_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                placeholder: "",
                valueField: 'name',
                labelField: 'name',
                searchField: 'name',
                create: false,
                render: {
                    option: function (roles, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(roles.name) + '</span>' +
                            '</div>';
                    },
                    item: function (roles, escape) {
                        return '<div class="item">' + escape(roles.name) + '</div>';
                    }
                }
            };

            var apps = vm.selectize_apps;
            vm.selectize_apps_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Escolha o aplicativo',
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                render: {
                    option: function (apps, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(apps.name) + '</span>' +
                            '</div>';
                    },
                    item: function (apps, escape) {
                        return '<div class="item">' + escape(apps.name) + '</div>';
                    }
                }
            };

            vm.selectize_roles_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Sem acesso',
                valueField: 'name',
                labelField: 'name',
                searchField: 'name',
                render: {
                    option: function (roles, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(roles.name) + '</span>' +
                            '</div>';
                    },
                    item: function (roles, escape) {
                        return '<div class="item">' + escape(roles.name) + '</div>';
                    }
                }
            };
        }

        vm.init = function () {
            vm.usuario = { roles: [] };
            vm.isEdicao = false;
            vm.id = $stateParams.id;
            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }
            if (vm.isEdicao) {
                vm.operacao = 'Editar';
                vm.isLoading = true;
                vm.getUsuario(vm.id).then(function () {
                    vm.carregarFiltros();
                });
            } else {
                vm.isLoading = true;
                vm.carregarFiltros();
            }
            
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isUsuarioEditarPermitido || vm.isUsuarioCadastrarPermitido;
        angular.extend(this, $controller('BaseCompany', {$scope: this}));
    }

    angular.module('app.usuarioadmin')
        .controller('UsuarioCreateController', UsuarioCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.situacao', []);      
})();


(function () {
    'use strict';

    /** @ngInject */
    function SituacaoService(Common, RestangularAuth, APPLICATION) {

        function get(filters, appCompanyId) {
            return RestangularAuth.all('manager/attendance/situation').getList(filters,
                undefined, { 'Content-Type': 'application/json', 'AppCompanyId': appCompanyId });
        }

        function getSituationTypes(filters, appCompanyId) {
            return RestangularAuth.all('manager/attendance/situation/type').getList(filters,
                undefined, { 'Content-Type': 'application/json', 'AppCompanyId': appCompanyId });
        }

        function getById(id, appCompanyId) {
            return RestangularAuth.one('manager/attendance/situation', id).get();
        }

        function post(situacao, appCompanyId) {
            return RestangularAuth.all('manager/attendance/situation').post(situacao,
                undefined, { 'Content-Type': 'application/json', 'AppCompanyId': appCompanyId });
        }

        function put(id, situacao, appCompanyId) {
            return RestangularAuth.one('manager/attendance/situation/' + id).customPUT(situacao);
        }


        function deleteAll(ids, appCompanyId) {
            return RestangularAuth.one('manager/attendance/situation', ids).remove(
                undefined, { 'Content-Type': 'application/json', 'AppCompanyId': appCompanyId });
        }

        return {
            get: get,
            getSituationTypes: getSituationTypes,
            getById: getById,
            post: post,
            put: put,
            deleteAll: deleteAll
        };
    }

    angular
        .module('app.situacao')
        .factory('Situacao', SituacaoService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function SituacaoListController(DashboardCompany, $controller, $interval, $rootScope, $scope, Situacao, Company, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, Security) {        
        var vm = this;
        //Permissões   
        vm.isSituacaoVisualizarPermitido     
        vm.isSituacaoCadastrarPermitido = false;
        vm.isSituacaoEditarPermitido = false;
        vm.isSituacaoPesquisarPermitido = false;
        vm.isSituacaoExcluirPermitido = false;
        vm.isSituacaoAtivarPermitido = false;

        vm.configurarPermissoes = function () {
            vm.isSituacaoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "R" });
            vm.isSituacaoCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "C" });
            vm.isSituacaoEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Situações", action: "U" });
            vm.isSituacaoPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Situações", action: "S" });
            vm.isSituacaoExcluirPermitido = Security.exitsProfilePermission({ id: 4, name: "Situações", action: "D" });
            vm.isSituacaoAtivarPermitido = Security.exitsProfilePermission({ id: 5, name: "Situações", action: "AD" });
        };

        vm.getSituacoes = function (filters) {
            vm.isLoading = true;
            return Situacao.get(filters, vm.appCompany.id).then(function (situacoes) {
                vm.situacoes = situacoes;
                vm.isLoading = false;
                return vm.situacoes;
            });
        };

        vm.archiveSituation = function (item) {
            vm.isLoading = true;
            item.isActive = item.isActive ? false : true;

            Situacao.put(item.id, item, vm.appCompany.id).then(function (result) {
                if (result) {
                    Common.messageSuccess('Situação', 'A', 'F');
                    vm.isLoading = false;
                    vm.init();
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.confirmExcluir = function (situacao) {
            UIkit.modal.confirm('Deseja realmente excluir a situação ' + situacao.description + '?', function () {
                vm.isLoading = true;
                Situacao.deleteAll(situacao.id, vm.appCompany.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Situação', 'D', 'F');
                    } else {
                        Common.mensagemError(result + ".");
                    }
                    vm.isLoading = false;
                    vm.init();
                }).finally(function () {
                    vm.isLoading = false;
                });
            });
        };
        
        vm.pesquisar = function (filters) {
            vm.getSituacoes(vm.filters);
        };

        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1)
            ];
        }

        vm.init = function () {
            vm.configurarPermissoes();
            vm.filters = {};
            iniciarComponentes();
            vm.pesquisar(vm.filters);
        };

        vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "R" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();        
    }

    angular.module('app.situacao')
        .controller('SituacaoListController', SituacaoListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function SituacaoDetailController(DashboardCompany, $controller, $interval, $filter, $rootScope, $scope, $stateParams, Situacao, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security) { //        
        var vm = this;
        vm.id = $stateParams.id;

        var APP = DashboardCompany.obterAppSelecionada();

        //Permissões
        vm.isSituacaoDeletarPermitido = false;
        vm.isSituacaoEditarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isSituacaoDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "D" });
            vm.isSituacaoEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Situações", action: "U" });
        };

        vm.getSituacao = function () {
            return Situacao.getById(vm.id).then(function (situacao) {
                vm.situacao = situacao;
                return vm.situacao;
            });
        };

        vm.getTiposSituacao = function () {
            return Situacao.getSituationTypes(null, APP.id).then(function (result) {
                vm.tiposSituacao = result;
                return vm.tiposSituacao;
            });
        };

        vm.confirmExcluir = function (situacao) {
            UIkit.modal.confirm('Deseja realmente excluir a situação ' + situacao.description + '?', function () {
                vm.isLoading = true;
                Situacao.deleteAll(situacao.id, APP.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Situação', 'D', 'F');
                        $state.go('private.painel.situacao.list');
                    } else {
                        Common.mensagemError(result + ".");
                    }
                    vm.isLoading = false;
                }).finally(function () {
                    vm.isLoading = false;
                });
            });
        };


        vm.init = function () {
            vm.configurarPermissoes();
            vm.isLoading = true;
            vm.getSituacao().then(function () {
                vm.getTiposSituacao().then(function () {
                    vm.situacao.type = _.find(vm.tiposSituacao, function (o) { return o.valor == vm.situacao.type }).name;
                    vm.isLoading = false;
                });
            });

        };

        vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "R" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();        
    }

    angular.module('app.situacao')
        .controller('SituacaoDetailController', SituacaoDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function SituacaoCreateController(Category, $controller, DashboardCompany, $filter, $interval, $timeout, $rootScope, $scope, $state, $stateParams, Common, Company, Security, APPLICATION, Situacao, Session) {        
        var vm = this;
        vm.operacao = 'Cadastrar';

        var APP = DashboardCompany.obterAppSelecionada();

        vm.isSituacaoAtivarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isSituacaoAtivarPermitido = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "AD" });
        };

        vm.getSituacao = function (id) {
            return Situacao.getById(id).then(function (situacao) {
                vm.situacao = situacao;
                vm.situacao.iconColor = '#' + vm.situacao.iconColor;
                return vm.situacao;
            });
        };

        vm.getTiposSituacao = function () {
            return Situacao.getSituationTypes(null, APP.id).then(function (result) {
                vm.selectize_types_data = result;
                return vm.selectize_types_data;
            });
        };

        vm.getIcons = function () {
            vm.iconsCode = Category.iconsListMobileCare();                       
        }

        vm.openModalIcons = function () {
            var modal = UIkit.modal(".modalIcons");
            modal.show();

        }

        vm.selectIcon = function (item) {
            vm.situacao = vm.situacao != null ? vm.situacao : {};
            vm.situacao.icon = item.id;
            var modal = UIkit.modal(".modalIcons");
            modal.hide();
        }


        vm.carregarFiltros = function () {
            vm.isLoading = true;
            vm.getTiposSituacao().then(function () {
                vm.getIcons();
                iniciarComponentes();
                vm.isLoading = false;
            });
        };

        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.situacao.detail', { id: vm.id });
                } else {
                    $state.go('private.painel.situacao.list');
                }
            });
        };


        vm.submit = function (situacao) {
            situacao.iconColor = situacao.iconColor.replace('#', '');
            if (situacao) {
                if (situacao.id) {
                    vm.putSituacao(situacao, situacao.id);
                } else {
                    vm.postSituacao(situacao);
                }
            }
        };

        vm.openModalConfirmacaoDeCancelamento = function() {
            var modalConfirmCancelamento = UIkit.modal('.cancelar', {keyboard:false, bgclose:false});
            modalConfirmCancelamento.show();
        }

        vm.postSituacao = function (situacao) {
            vm.isLoading = true;
            Situacao.post(situacao, APP.id).then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Situação', 'I', 'F');
                        vm.isLoading = false;
                        $state.go('private.painel.situacao.list.detail', { id: result.id });
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putSituacao = function (situacao, id) {
            vm.isLoading = true;
            Situacao.put(id, situacao, APP.id).then(function (result) {
                if (result) {
                    Common.messageSuccess('Situação', 'A', 'F');
                    vm.isLoading = false;
                    $state.go('private.painel.situacao.list.detail', { id: id });
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        function iniciarComponentes() {
            vm.selectize_types = { options: [] };
            vm.selectize_types.options = vm.selectize_types_data;
            vm.selectize_types_config = {
                create: false,
                maxItems: 1,
                placeholder: '',
                valueField: 'valor',
                labelField: 'name',
                searchField: 'name',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.name) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.name) + '</div>';
                    },
                }
            };
        }

        vm.init = function () {
            vm.situacao = {};
            vm.situacao.iconColor = '#000';
            vm.configurarPermissoes();
            vm.carregarFiltros();
            vm.isEdicao = false;
            vm.id = $stateParams.id;

            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }

            if (vm.isEdicao) {
                vm.operacao = 'Editar';
                vm.getSituacao(vm.id).then(function () {
                    vm.carregarFiltros();
                });
            }
        };

        vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "C" })
            || Security.exitsProfilePermission({ id: 2, name: "Situações", action: "U" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();
    }

    angular.module('app.situacao')
        .controller('SituacaoCreateController', SituacaoCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.signalr', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function SignalRService($rootScope, APPLICATION) {

        function signalRHubProxyFactory(serverUrl, hubName, startOptions) {
            var connection = $.hubConnection(APPLICATION.webApiUri);
            var proxy = connection.createHubProxy(hubName);
            connection.logging = true;

            // proxy.on('getDashBoard', function (data) {});
            // proxy.on('getNotificacaoChamados', function (data) {});
            
            // proxy.on('notificarNovoChamadoGeral', function (data) {});
            // proxy.on('notificarNovoChamadoDashboard', function (data) {});

            connection.start(startOptions).done(function () {                
                // proxy.invoke('iniciarDashboard');
                // proxy.invoke('iniciarNotificacaoChamados');

            }).fail(function (reason) {
                console.log("SignalR connection failed: " + reason);
            });

            return {
                on: function (eventName, callback) {
                    proxy.on(eventName, function (result) {
                        $rootScope.$apply(function () {
                            if (callback) {
                                callback(result);
                            }
                        });
                    });
                },
                off: function (eventName, callback) {
                    proxy.off(eventName, function (result) {
                        $rootScope.$apply(function () {
                            if (callback) {
                                callback(result);
                            }
                        });
                    });
                },
                invoke: function (methodName, callback) {
                    proxy.invoke(methodName)
                        .done(function (result) {
                            $rootScope.$apply(function () {
                                if (callback) {
                                    callback(result);
                                }
                            });
                        });
                },
                connection: connection
            };
        };

        return {
            signalRHubProxyFactory: signalRHubProxyFactory
        };

    }

    angular
        .module('app.signalr')
        .factory('SignalR', SignalRService);

})();
(function () {
  'use strict';

  angular
    .module('app.servico', []);
})();


(function() {
    'use strict';

    /** @ngInject */
    function ServicoService(Common, RestangularAuth, Restangular, APPLICATION) {

        function get(filters) {
            return RestangularAuth.all('servicos').getList(filters);
        }

        function getStatus() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.status);
            return deferred.promise;
        }

        function getById(id) {
            return RestangularAuth.one('servicos', id).get();
        }

        function getByCategorySimple(filters){
            return RestangularAuth.all('manager/attendance/service/simple?CategoryId=' + filters.id).getList();
        }

        function getByCategory(filters) {
            return RestangularAuth.all('manager/attendance/service?CategoryId=' + filters.id).getList();
        }

        function deleteById(id) {
            return RestangularAuth.one('manager/attendance/service/'+id).remove();
        }

        function clone(servico, id) {
            return RestangularAuth.all('manager/attendance/service/'+id+'/copy').post(servico);
        }

        function post(servico) {
            return RestangularAuth.all('manager/attendance/service').post(servico);
        }

        function postAccessPermissions(servico, roleId) {
            var roles = {};
            roles.roleId = roleId;
            return RestangularAuth.all('manager/attendance/service/'+servico.id+'/accesspermission').post(roles);
        }

        function postSituationService(service, situations) {
            return RestangularAuth.all('manager/attendance/workflow/service/'+service.id+'/situation').post(situations);
        }

        function postReasons(service, reasons) {
            return RestangularAuth.all('manager/attendance/workflow/service/'+service.id+'/situation/'+reasons[0].serviceSituationId+'/reason').post(reasons);
        }

        function postIntegration(servico, integration) {
            return RestangularAuth.all('manager/attendance/workflow/service/'+servico.id+'/situation/'+integration.serviceSituationId+'/integrationconfig').post(integration);
        }

        function deleteAccessPermissions(servico, id) {
            return RestangularAuth.one('manager/attendance/service/'+servico.id+'/accesspermission/'+id).remove();
        }

        function deleteIntegration(servico, integration) {
            return RestangularAuth.one('manager/attendance/workflow/service/'+servico.id+'/situation/'+integration.serviceSituationId+'/integrationconfig').remove();
        }

        function deleteSituationService(servico, situation) {
            return RestangularAuth.one('manager/attendance/workflow/service/'+servico.id+'/situation/'+situation.id).remove();
        }

        function deleteReasons(servico, situation, reasons) {
            return RestangularAuth.all('manager/attendance/workflow/service/'+servico.id+'/situation/'+situation.id+'/reason').customPUT(reasons);    
        }

        function deleteWorkFlow(servico, situation, reasons) {
            return RestangularAuth.all('manager/attendance/workflow/service/'+servico.id+'/situation/'+situation.id+'/availableSituation').customPUT(reasons);    
        }

        function postItemWorkFlow(item) {
            var list = [];
            var itemNew = {};
            itemNew.serviceSituationId = item.serviceSituationId;
            itemNew.situationId = item.situationId;
            list.push(itemNew);
            return RestangularAuth.all('manager/attendance/workflow/service/'+item.serviceId+'/situation/'+itemNew.serviceSituationId+'/availableSituation').post(list);
        }

        /*function post(servico) {
            return RestangularAuth.all('manager/attendance/service/'++'/accesspermission').post(servico);
        }*/

        function setUpdateService(service) {
            var filters = {};
            filters.Description = service.description;
            filters.Id = service.id;
            filters.ParentId = service.parentId;
            filters.CategoryId = service.category.id;
            filters.SlaId = service.slaId;

            return Restangular.all('manager/attendance/service/PutSlaService').customPUT(service);
        }

        function updateService(service) {
            return RestangularAuth.all('manager/attendance/service/' + service.id).customPUT(service);
        }

        function updateServiceSituations(service, situation) {
            return RestangularAuth.all('manager/attendance/workflow/service/'+service.id+'/situation/'+situation.id).customPUT(situation);
        }

        function getFormServicoById(id) {
            return RestangularAuth.one('servicos/' + id + '/formularios').get();

            // var deferred = Common.$q.defer();
            // RestangularAuth.one('servicos/' + id + '/formularios').get().then(function(formulario) {
            //     formulario.options = {
            //         bar: 'bar-' + formulario.cor,
            //         button: 'button-' + formulario.cor,
            //         cor: formulario.cor,
            //         icone: formulario.icone,
            //     };
            //     deferred.resolve(formulario);
            // }).catch(function(error) {
            //     deferred.reject(error);
            // });
            // return deferred.promise;
        }

        // function getFormulario(id) {
        //     var deferred = Common.$q.defer();
        //     RestangularAuth.one('formularios', id).get().then(function(formulario) {
        //         formulario.options = {
        //             bar: 'bar-' + formulario.cor,
        //             button: 'button-' + formulario.cor,
        //             cor: formulario.cor,
        //             icone: formulario.icone,
        //         };
        //         deferred.resolve(formulario);
        //     }).catch(function(error) {
        //         deferred.reject(error);
        //     });
        //     return deferred.promise;
        // };

        return {
            get: get,
            getStatus: getStatus,
            getById: getById,
            getByCategory: getByCategory,
            deleteById: deleteById,
            post: post,
            clone: clone,
            postItemWorkFlow: postItemWorkFlow,
            postSituationService: postSituationService,
            postIntegration: postIntegration,
            deleteIntegration: deleteIntegration,
            postReasons: postReasons,
            getFormServicoById: getFormServicoById,
            setUpdateService: setUpdateService,
            updateService: updateService,
            updateServiceSituations: updateServiceSituations,
            postAccessPermissions: postAccessPermissions,
            deleteAccessPermissions: deleteAccessPermissions,
            deleteSituationService: deleteSituationService,
            deleteReasons: deleteReasons,
            deleteWorkFlow: deleteWorkFlow,
            getByCategorySimple:getByCategorySimple

            // getFormulario: getFormulario
        };
    }

    angular
        .module('app.servico')
        .factory('Servico', ServicoService);

})();
(function() {
    'use strict';

    /** @ngInject */
    function ServicoListController($interval, $rootScope, $scope, Servico, Attendance, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile) {
        var vm = this;
        var STRING_CLASS_COMPILE = '.dt-uikit .md-input';

        /// <description>
        /// Método responsável por obter os serviços.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getServicos = function(filters) {
            vm.isLoading = true;
            return Attendance.getServicos(filters).then(function(servicos) {
                vm.servicos = servicos;
                vm.isLoading = false;
                return vm.servicos;
            });
        };

        /// <description>
        /// Método responsável pela pesquisa dos dados.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.search = function(filters) {
            vm.getServicos(filters);
        }
        
        /// <description>
        /// Método responsável pela inicialização dos componentes da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.initComponents = function() {
            // Definição do options do datatables do angularjs.
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(10)
                .withDOM(APPLICATION.STRING_WITH_DOM_DEFAULT)
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withPaginationType(APPLICATION.STRING_FULL_NUMBERS_NO_ELLIPSIS)
                .withOption(APPLICATION.STRING_INIT_COMPLETE, function() {
                    $timeout(function() {
                        $compile($(STRING_CLASS_COMPILE))($scope);
                    })
            });
                
            // Definição da quantidade de colunas (caso seja adicionada ou removida uma coluna, deve-se recalcular a quantidade aqui).
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2)
            ];
        }

        /// <description>
        /// Método responsável pela inicialização da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.init = function() {
            vm.filters = {};
            vm.filters.limit = 999999;
            vm.filters.Enabled = true;  
            vm.filters.stsAtivoIds = 1;          
            vm.initComponents();
            vm.search(vm.filters);
        };

        vm.init();
    }

    angular.module('app.servico')
        .controller('ServicoListController', ServicoListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function ServicoDetailController($interval, $rootScope, $scope, $state, $stateParams, Servico, Attendance, APPLICATION, Common, Security) {
        var vm = this;
        vm.id = $stateParams.id;

        /// <description>
        /// Método responsável por configurar as permissões.
        /// </description>
        /// <author>
        /// Legadoa.
        /// </author>
        vm.isServicoEditarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isServicoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "R" });
            vm.isServicoCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "C" });
            vm.isServicoEditarPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "U" });
            vm.isServicoPesquisarPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "S" });
            vm.isServicoExcluirPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "D" });
            vm.isServicoReenviarEmailPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "RE" });
            vm.isServicoAtivarPermitido = Security.exitsProfilePermission({ id: 1, name: "Serviços", action: "AD" });
        };

        /// <description>
        /// Método responsável por obter o serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getServico = function () {
            vm.isLoading = true;
            vm.filters.id = vm.id;
            return Attendance.getServicos(vm.filters).then(function (servicos) {
                vm.servico = servicos[0];
                vm.filters.slaTimeSeconds = (vm.servico.slaTimeSeconds / 3600);
                vm.isLoading = false;
                return vm.servico;
            });
        };

        /// <description>
        /// Método responsável pela validação do preenchimento numérico do campo SLA.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.validate = function (evt) {
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
            var regex = APPLICATION.STRING_PATTERN_ONLY_NUMBERS;

            if (theEvent.keyCode == 8) {
                return true;
            }

            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        }

        /// <description>
        /// Método responsável pela atualização do SLA do serviço (específico, atualiza apenas o SLA do serviço).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.setUpdateService = function (filters) {
            var regex = APPLICATION.STRING_PATTERN_ONLY_NUMBERS;

            if (filters.slaTimeSeconds && regex.test(filters.slaTimeSeconds)) {
                vm.servico.SlaTimeSeconds = (filters.slaTimeSeconds * 3600);
                vm.servico.CategoryId = vm.servico.category.id;
                vm.servico.ParentId = vm.servico.parentId;
                vm.servico.ServiceId = vm.servico.id;
                // return Servico.setUpdateService(vm.servico).then(function (response) {
                    return Servico.updateService(vm.servico).then(function (response) {
                    if (response) {
                        Common.messageSuccess(APPLICATION.STRING_MSG_TEMPO_SLA_ALTERADO_COM_SUCESSO);
                        $state.go(APPLICATION.STRING_ROUTE_SERVICE_LIST);
                    }
                    return response;
                });
            } else {
                Common.mensagemError(APPLICATION.STRING_MSG_INFORME_TEMPO_SLA_EM_HORAS);
            }
        }

        vm.updateReason = function (item, form, index) {
            var fieldName = 'reasonField' + index;

            if (item.reasons[0] != undefined && (item.reasons[0].length === 0 || !item.reasons[0].trim())) {
                form[fieldName].$setPristine();
                item.$edit = false;
            }

            if (form[fieldName].$invalid) {
                return;
            }
            item.$edit = false;
        }

        vm.removeItem = function (item, index) {
            vm.servico.availableStates.splice(index, 1);

        };

        /// <description>
        /// Método responsável pela inicialização da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.init = function () {
            vm.configurarPermissoes();
            vm.filters = {};
            vm.selectize_sla = [];
            vm.getServico();
        };

        vm.init();
    }

    angular.module('app.servico')
        .controller('ServicoDetailController', ServicoDetailController);

})();

(function() {
    'use strict';

    /** @ngInject */
    function ServicoCreateController($interval, $rootScope, $scope, $state, $stateParams, Servico, Common, jsonPath) {
        var vm = this;
        vm.operacao = 'Visualizar';

        vm.getFormularioServico = function(id) {
            return Servico.getFormServicoById(id).then(function(formServico) {
                vm.formulario = formServico;
                vm.formulario.options = {
                    bar: 'bar-' + formServico.cor,
                    button: 'button-' + formServico.cor,
                    cor: formServico.cor,
                    icone: formServico.icone,
                };
                return vm.formulario;
            });
        };

        // vm.getFormulario = function(id) {
        //     return Servico.getFormulario(id).then(function(formulario) {
        //         vm.formulario = formulario;
        //         return vm.formulario;
        //     });
        // };

        vm.carregarForm = function() {
            vm.isLoading = true;
            vm.getFormularioServico(vm.id).then(function(result) {
                // vm.getFormulario(result.items[0].id).then(function() {
                //
                //});
                vm.isLoading = false;
            });
        };

        vm.isFormularioQuestaoVisivel = function(formularioQuestao) {
            var visivel = formularioQuestao.visivelInicial;

            if (formularioQuestao.formularioQuestaoVisibilidades.length) {
                angular.forEach(formularioQuestao.formularioQuestaoVisibilidades, function(formularioQuestaoVisibilidade) {
                    var formularioQuestaoOpcaoIds = jsonPath(formularioQuestaoVisibilidade, '$..formularioQuestaoOpcaoId');
                    var ngModelIds = jsonPath(vm.formulario, '$..ngModel.id');
                    if (ngModelIds && _.every(formularioQuestaoOpcaoIds, function(e) { return _.includes(ngModelIds, e); })) {
                        visivel = formularioQuestaoVisibilidade.visivel;
                    }
                });
            }

            if (!visivel) {
                formularioQuestao.ngModel = null;
            }

            return visivel;
        };

        vm.inputName = function(id) {
            return 'formulario-questao-' + id;
        };

        vm.init = function() {
            vm.isEdicao = false;
            vm.id = $stateParams.id;
            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }
            if (vm.isEdicao) {
                vm.operacao = 'Visualizar';
                vm.carregarForm();
            }
        };

        vm.init();
    }

    angular.module('app.servico')
        .controller('ServicoCreateController', ServicoCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.services', []);
})();

(function () {
    'use strict';

    function SecurityService(Session, SECURITY, DashboardCompany, Company) {

        var profiles = [];
        var user = [];


        function getProfilesUser() {
            return Session.getObjectLocalStorage('mt-account-permissions');
        }

        function setProfilesUser(profiles) {
            Session.setObjectLocalStorage('mt-account-permissions', profiles);
        }

        function exitsProfilePermission(profile) {
            profiles = getProfilesUser();

            var appSelecionada = DashboardCompany.obterAppSelecionada();
            var companySelecionada = Company.getCompanySelected();
            if (appSelecionada) {
                var result = _.find(profiles, function (o) { return o.appCompanyId && o.appCompanyId.toUpperCase() == appSelecionada.id.toUpperCase() });
                if (result) {
                    profiles = result.permissions;
                }
            } else {
                var result = _.find(profiles, function (o) { return !o.appCompanyId && o.companyId == companySelecionada.id });
                if (result) {
                    profiles = result.permissions;
                }
            }

            if (profiles) {
                for (var i = 0; i < profiles.length; i++) {
                    if (profiles[i].name == profile.name) {
                        for (var j = 0; j < profiles[i].actions.length; j++) {
                            if (profiles[i].actions[j].letter == profile.action) {
                                return true;
                            }
                        }
                    }
                }
            }
        }

        function getCurrentPermission() {
            profiles = getProfilesUser();

            var appSelecionada = DashboardCompany.obterAppSelecionada();
            var companySelecionada = Company.getCompanySelected();
            if (appSelecionada) {
                var result = _.find(profiles, function (o) { return o.appCompanyId && o.appCompanyId.toUpperCase() == appSelecionada.id.toUpperCase() });
                if (result) {
                    return result;
                }
            } else {
                var result = _.find(profiles, function (o) { return !o.appCompanyId && o.companyId == companySelecionada.id });
                if (result) {
                    return result;
                }
            }
        }

        

        function getAccessKey() {
            return Session.getLocalStorage(SECURITY.accessKey);
        }

        function setAccessKey(accessKey) {
            Session.setLocalStorage(SECURITY.accessKey, accessKey);
        }

        function getAccessToken() {
            return Session.getLocalStorage(SECURITY.accessToken);
        }

        function setAccessToken(accessToken) {
            // Session.setLocalStorage(SECURITY.accessToken, accessToken);
            Session.setLocalStorage(SECURITY.accessToken, accessToken);
        }

        function setRefreshToken(refreshToken) {
            // Session.setLocalStorage(SECURITY.refreshToken, refreshToken);
            Session.setLocalStorage(SECURITY.refreshToken, refreshToken);
        }

        var service = {
            getProfilesUser: getProfilesUser,
            setProfilesUser: setProfilesUser,
            exitsProfilePermission: exitsProfilePermission,
            setAccessKey: setAccessKey,
            getAccessKey: getAccessKey,
            getAccessToken: getAccessToken,
            setAccessToken: setAccessToken,
            setRefreshToken: setRefreshToken,
            getCurrentPermission: getCurrentPermission
        };

        return service;
    }

    SecurityService.$inject = ['Session', 'SECURITY', 'DashboardCompany', 'Company'];

    angular
        .module('app.services')
        .factory('Security', SecurityService);

})();

(function(){
  'user strict';

  /** @ngInject */
  function RestangularAuth(Restangular, Session, APPLICATION) {

    return Restangular.withConfig(function(RestangularConfigurer) {

      RestangularConfigurer.addRequestInterceptor(function(element, operation, what, url) {
        // Obtem o appCompanyId selecionado.
        var appCompanyId = Session && Session.getObjectLocalStorage(APPLICATION.applicationSelected) ? 
        Session.getObjectLocalStorage(APPLICATION.applicationSelected).id : null;

        // Obtem o access-token do usuário logado.
        var token = Session && Session.getToken() ? Session.getToken() : null;

        // Verifica se existe um local selecionado e informa o mesmo no header.
        if (appCompanyId) {
          RestangularConfigurer.setDefaultHeaders({
            'AppCompanyId': appCompanyId,
            'Authorization': 'Bearer ' + token
          });
        } else {
          RestangularConfigurer.setDefaultHeaders({
            'Authorization': 'Bearer ' + token
          });
        }

        return element;

      });
    });

  }

  RestangularAuth.$inject = ['Restangular', 'Session', 'APPLICATION'];

  angular
    .module('app.services')
    .factory('RestangularAuth', RestangularAuth);

})();

(function () {
    'use strict';

    angular
        .module('app.relatorios', [])
        .filter('secondsToDateTime', [function() {		   
		    return function(seconds) {
				if(seconds < 0){
					seconds = seconds * -1;
				}
			    var days = Math.floor(seconds/86400);
			    var hours = Math.floor((seconds % 86400) / 3600);
			    var mins = Math.floor(((seconds % 86400) % 3600) / 60);
			    var secs = ((seconds % 86400) % 3600) % 60;
			    return (days > 0 ? days+'d ' : '') + ('00'+hours).slice(-2) +'h ' + ('00'+mins).slice(-2)+'min ' + ('00'+secs).slice(-2) + 's';
		    };
		}]);	
})();


(function () {
    'use strict';

    /** @ngInject */
    function RelatoriosService(Common, Restangular, RestangularAuth, Security, APPLICATION) {

        function getSinteticReport(filters) {
            var clonedFilter = JSON.parse(JSON.stringify(filters));           
            return RestangularAuth.all('manager/attendance/report/sintetic').getList(clonedFilter);
        }  

        function getAnaliticReport(filters) {
            var clonedFilter = JSON.parse(JSON.stringify(filters));           
            return RestangularAuth.all('manager/attendance/report/analitic').getList(clonedFilter);
        }        

        function getMessages(filters) {
            var clonedFilter = angular.copy(filters);
            clonedFilter.dtInicio = Common.convertToUtcDateString(clonedFilter.dtInicio);
            clonedFilter.dtFim = Common.convertToUtcDateString(clonedFilter.dtFim);

            if (clonedFilter.dtFim == undefined) {
                clonedFilter.dtFim = clonedFilter.dtInicio;
            }

            return Restangular.all('manager/messenger/api/message').getList(clonedFilter);
        }

        function getMessage(id) {
            return Restangular.one('mobile/messenger/api/message', id).get();
        }

        function updateMessage(message) { //customPUT needed due to routing differences
            return Restangular.one('manager/messenger/api/message', message.id).customPUT(message);
        }

        function getMessageStatusCombo() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.messageStatus);
            return deferred.promise;
        }

        return {
            getSinteticReport: getSinteticReport,
            getAnaliticReport: getAnaliticReport,
            getMessages: getMessages,
            getMessage: getMessage,
            updateMessage: updateMessage,
            getMessageStatusCombo: getMessageStatusCombo
        };
    }

    angular
        .module('app.relatorios')
        .factory('Relatorios', RelatoriosService);

})();

(function () {
    'use strict';

    /** @ngInject */
    function MensagensListController($interval, $rootScope, $scope, Relatorios, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, MessagePriority, Security, Session) {
        var vm = this;

        //Permissões
        vm.isMessageReportEditarPermitido = false;

        vm.configurarPermissoes = function () {
            vm.isMessageReportEditarPermitido = Security.exitsProfilePermission({ id: 1, name: "Relatorio Mensagens", action: "U" });
        };

        vm.getRelatorio = function (filters) {
            vm.isLoading = true;
            filters.offset = 1;
            filters.limit = 100000;
            filters.sort = '-dtCreated';
            filters.statusIds = [true, false]; //show deleted messages aswell
            /*
            Perfil ADMIN: poderá ter acesso a todas as mensagens enviadas;
            Perfil BÁSICO: o usuário terá acesso somente às mensagens que foram enviadas por ele.
            */
            var isAdmin = !!+Session.getIsAdmin();
            if (!isAdmin) {
                var crm = Session.getCrm();
                filters.senderCrm = crm ? crm.replace(/\D/g, '') : "";
            }
            return Relatorios.getMessages(filters).then(function (relatorio) {
                vm.relatorio = relatorio;
                vm.isLoading = false;
                return vm.relatorio;
            });
        };

        vm.getMessage = function (id) {
            vm.isLoadingModal = true;
            return Relatorios.getMessage(id).then(function (result) {
                vm.message = result;
                vm.isLoadingModal = false;
                return vm.message;
            });
        };

        vm.putMessage = function (message) {
            vm.isLoadingModal = true;
            var currentTimestamp = moment().format('YYYY-MM-DD[T]HH:mm:ss');
            //todo: This logic may change if switchs remain editable
            if (message.isNoShow && !message.dtNowShow) {
                message.dtNowShow = currentTimestamp;
            }
            if (message.isPhoneContact && !message.dtPhoneContact) {
                message.dtPhoneContact = currentTimestamp;
            }
            Relatorios.updateMessage(message).then(function (result) {
                if (result && result > 0) {
                    Common.messageSuccess('Mensagem', 'A', 'F');
                    vm.isLoadingModal = false;
                    vm.closeModal('#modalEditMessage');
                    vm.pesquisar(vm.filters);
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoadingModal = false;
            });
        };

        vm.getMessagePriorities = function (filters) {
            return MessagePriority.get().then(function (messagePriorities) {
                vm.selectize_priorities = messagePriorities;
                return vm.selectize_priorities;
            });
        };


        vm.getMessageStatus = function () {
            return Relatorios.getMessageStatusCombo().then(function (status) {
                vm.selectize_status = status;
                return vm.selectize_status;
            });
        };

        vm.pesquisar = function (filters) {
            //necessário iniciar os componentes novamente para exibir os filtros atualizados no relatório gerado
            iniciarComponentes();
            vm.getRelatorio(vm.filters);
        };

        vm.carregarFiltros = function () {
            vm.isLoadingFiltros = true;
            vm.getMessagePriorities().then(function () {
                vm.getMessageStatus().then(function () {
                    iniciarComponentes();
                    vm.isLoadingFiltros = false;
                });
            });
        };

        function getDescricaoObjeto(objetoFiltro, objetoSelectize) {
            var array = [];
            if (objetoFiltro) {
                objetoFiltro.forEach(function (element) {
                    objetoSelectize.forEach(function (elementSelectize) {
                        if (element == elementSelectize.id) {
                            array.push(elementSelectize.description);
                            return false;
                        }
                    }, this);
                }, this);

                return array;
            }
            return null;
        }

        function getSingleDescricaoObjeto(valorFiltro, objetoSelectize) {
            var valor = undefined;
            if (valorFiltro) {
                valor = _.find(objetoSelectize, function (o) { return o.id == valorFiltro }).description;
                return valor;
            }
            return null;
        }

        function iniciarComponentes() {

            var mensagemFiltros = [

                Common.concatString("Destinatário: ", vm.filters.receiverName),
                Common.concatString("Remetente: ", vm.filters.senderName),
                Common.concatString("Prioridade da mensagem: ", getDescricaoObjeto(vm.filters.messagePriorityIds, vm.selectize_priorities)),
                Common.concatString("Telefone: ", vm.filters.telephoneNumber),
                Common.concatString("Exame: ", vm.filters.examName),
                Common.concatString("Paciente: ", vm.filters.patientName),
                Common.concatString("Status da mensagem: ", getSingleDescricaoObjeto(vm.filters.messageReportStatusIds, vm.selectize_status)),
            ]
                .filter(function (val) { return val; })
                .join('\n');

            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(10)
                .withDOM('rtip')
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                })
                // .withOption('responsive', true)
                // .withOption('autoWidth', true)
                .withButtons([
                    // {
                    //     extend: "csvHtml5",
                    //     title: "Sabesp - " + vm.filters.dtInicio + " à " + vm.filters.dtFim,
                    //     exportOptions: {
                    //         //columns: ':visible'
                    //         columns: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27]
                    //     },
                    //     exportData: { decodeEntities: true }
                    // },
                    {
                        extend: "excel",
                        title: "Achados Críticos - " + vm.filters.dtInicio + " à " + vm.filters.dtFim,
                        exportOptions: {
                            //columns: ':visible'
                            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27]
                        },
                        //CharSet: "utf8",
                        exportData: { decodeEntities: true }
                    },
                    // {
                    //     extend: "pdf",
                    //     title: "Sabesp - " + vm.filters.dtInicio + " à " + vm.filters.dtFim,
                    //     message: mensagemFiltros,
                    //     orientation: 'landscape',
                    //     pageSize: 'LEGAL',
                    //     exportOptions: {
                    //         //columns: ':visible'
                    //         columns: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27]
                    //     },
                    //     exportData: { decodeEntities: true }
                    // },


                    // {
                    //     extend: 'print',
                    //     customize: function (win) {
                    //         $(win.document.body).find('table')
                    //             .addClass('compact')
                    //             .css('font-size', '6pt');
                    //     },
                    //     text: 'Imprimir',
                    //     autoPrint: true,
                    //     title: "Achados Críticos - " + vm.filters.dtInicio + " à " + vm.filters.dtFim,
                    //     message: mensagemFiltros.replace(/\r?\n/g, '<br />'),
                    //     exportOptions: {
                    //         //columns: ':visible'
                    //         columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27]
                    //     }
                    // }
                ]);
            ;

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1).notVisible(),
                DTColumnDefBuilder.newColumnDef(2).notVisible(),
                DTColumnDefBuilder.newColumnDef(3).notVisible(),
                DTColumnDefBuilder.newColumnDef(4).notVisible(),
                DTColumnDefBuilder.newColumnDef(5).notVisible(),
                DTColumnDefBuilder.newColumnDef(6).notVisible(),
                DTColumnDefBuilder.newColumnDef(7).notVisible(),
                DTColumnDefBuilder.newColumnDef(8).notVisible(),
                DTColumnDefBuilder.newColumnDef(9),
                DTColumnDefBuilder.newColumnDef(10).notVisible(),
                DTColumnDefBuilder.newColumnDef(11),
                DTColumnDefBuilder.newColumnDef(12),
                DTColumnDefBuilder.newColumnDef(13).notVisible(),
                DTColumnDefBuilder.newColumnDef(14),
                DTColumnDefBuilder.newColumnDef(15),
                DTColumnDefBuilder.newColumnDef(16),
                DTColumnDefBuilder.newColumnDef(17),
                DTColumnDefBuilder.newColumnDef(18).notVisible(),
                DTColumnDefBuilder.newColumnDef(19).notVisible(),
                DTColumnDefBuilder.newColumnDef(20).notVisible(),
                DTColumnDefBuilder.newColumnDef(21),
                DTColumnDefBuilder.newColumnDef(22).notVisible(),
                DTColumnDefBuilder.newColumnDef(23),
                DTColumnDefBuilder.newColumnDef(24).notVisible(),
                DTColumnDefBuilder.newColumnDef(25).notVisible(),
                DTColumnDefBuilder.newColumnDef(26).notVisible(),
                DTColumnDefBuilder.newColumnDef(27).notVisible(),
                DTColumnDefBuilder.newColumnDef(28),
            ];

            var polos = vm.selectize_priorities;
            vm.selectize_priorities_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (polos, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(polos.description) + '</span>' +
                            '</div>';
                    },
                    item: function (polos, escape) {
                        return '<div class="item">' + escape(polos.description) + '</div>';
                    }
                }
            };

            var status = vm.selectize_status;
            vm.selectize_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.description) + '</div>';
                    }
                }
            };

            vm.selectize_bool_status = APPLICATION.genericBool;
            var bool_status = vm.selectize_bool_status;
            vm.selectize_bool_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.description) + '</div>';
                    }
                }
            };
        }

        //Validação das datas
        var dtInicioClb1 = $scope.$watch(
            'vm.filters.dtInicio',
            function () {
                // iniciarComponentes();
                var result = Common.validateData(vm.filters.dtInicio, vm.filters.dtFim);
                if (!result) {
                    vm.filters.dtInicio = undefined;
                    Common.mensagemError('Data inicial não pode ser maior que data final.');
                }
            }
        );

        var dtFimClb2 = $scope.$watch(
            'vm.filters.dtFim',
            function () {
                // iniciarComponentes();
                var result = Common.validateData(vm.filters.dtInicio, vm.filters.dtFim);
                if (!result) {
                    vm.filters.dtFim = undefined;
                    Common.mensagemError('Data inicial não pode ser maior que data final.');
                }
            }
        );


        $scope.$on('$destroy', function () {
            [
                dtInicioClb1,
                dtFimClb2
            ].forEach(function (fn) {
                fn();
            });
        });

        vm.modalMessageOpenProcess = function (id) {
            vm.message = {};
            vm.getMessage(id).then(function () {
                //
            });
        };

        vm.closeModal = function (modalTitle) {
            var modal = UIkit.modal(modalTitle);
            modal.hide();
        };

        vm.init = function () {
            vm.configurarPermissoes();
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            vm.hoje = moment().format(vm.datePickerFormat.format);
            vm.filters = {};
            vm.filters.dtInicio = moment().add(-1, 'days').format(vm.datePickerFormat.format); //moment("2015-11-01").format(vm.datePickerFormat.format);;
            vm.filters.dtFim = vm.hoje;
            vm.carregarFiltros();
            $timeout(function () { //workaround for messed up restangular requests
                vm.pesquisar(vm.filters);
            }, 700);
        };

        vm.init();
    }

    angular.module('app.relatorios')
        .controller('MensagensListController', MensagensListController);

})();

/**
 * Created by caeta on 16/09/2016.
 */
(function () {
    'use strict';

    /** @ngInject */
    function AtendimentoListController(UsuarioAdmin, $controller, $interval, $rootScope, $scope, CustomModal, Attendance, Relatorios, Category, Servico, Security, Cliente, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, DashboardCompany, Company) {        
        var vm = this;
        var STRING_ID = 'id';
        var STRING_NAME = 'name';
        var STRING_USER_ID = 'userId';
        var STRING_DESCRIPTION = 'description';  
        var COMPANY = Company.getCompanySelected();

        $rootScope.primarySidebarActive = true;
        
        //Permissões
        vm.isReportVisualizarPermitido = false; //No use        
        vm.configurarPermissoes = function () {
            vm.isReportVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Relatório Analítico", action: "R" });
        };

        // Exibe os serviços específicos para a categoria selecionada.
        vm.changeCategory = function () {
            var listServices = [];

            if (vm.filters.categoryId == null) {
                vm.selectize_sources_services = vm.selectize_sources_services_backup;
            } else {
                for (var i = 0; i < vm.selectize_sources_services_backup.length; i++) {
                    if (vm.selectize_sources_services_backup[i].category.id == vm.filters.categoryId) {
                        listServices.push(vm.selectize_sources_services_backup[i]);
                    }
                }
                vm.selectize_sources_services = listServices;
            }
        };

        vm.getRelatorio = function (filters) {
            if(vm.validateDate(vm.filters)){
               vm.isLoading = true;                
                return Relatorios.getAnaliticReport(filters).then(function (relatorio) {
                    var filtersClient = {};
                    var appSelecionada = DashboardCompany.obterAppSelecionada();
                    filtersClient.Roles = ['Mobile'];
                    UsuarioAdmin.get(COMPANY, filters).then(function (clientes) {
                        vm.clientes = clientes;
                        var categoriesList = {};
                        Category.getLeafs().then(function (response) {
                            categoriesList = response.itens;

                            for (var i = 0; i < relatorio.length; i++) {
                                for (var j = 0; j < categoriesList.length; j++) { 
                                    if (relatorio[i].form && relatorio[i].form.categoryId == categoriesList[j].id) {
                                        relatorio[i].category = categoriesList[j];
                                        break;
                                    }

                                    if (!clientes || clientes.length == 0) {
                                        break;
                                    } else {
                                        break;
                                        for (var j = 0; j < clientes.length; j++) {
                                            if (relatorio[i].userId == clientes[j].id) {
                                                relatorio[i].addressLine1 = clientes[j].profiles[0].address.addressLine1;
                                                relatorio[i].district = clientes[j].profiles[0].address.district;
                                                relatorio[i].city = clientes[j].profiles[0].address.city;
                                                relatorio[i].zipCode = clientes[j].profiles[0].address.zipCode;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                            vm.totalItens = parseInt(relatorio.length);
                            vm.processedItens = parseInt(0);
                            vm.processingImages = parseInt(0);
                            if(relatorio.length > 0){
                                relatorio.forEach(listaAtendimentoTreatment);
                            }else{
                                vm.processingImages = parseInt(100);
                            }

                            vm.relatorio = relatorio;
                            vm.isLoading = false;







var bottom = 0; /* Position of first page number - 0 for bottom of first page */
            var pagNum = 2; /* First sequence - Second number */

              /* For each 10 paragraphs, this function: clones the h3 with a new page number */
              $("tr").each(function() {
                bottom -= 100;
                var botString = bottom.toString();
                var $counter = $('h3.pag1').clone().removeClass('pag1');
                $counter.css("bottom", botString + "vh");
                var numString = pagNum.toString();
                $counter.addClass("pag" + numString);
                ($counter).insertBefore('.insert');
                pagNum = parseInt(numString);
                pagNum++; /* Next number */
              });
              var pagTotal = $('.pag').length; /* Gets the total amount of pages by total classes of paragraphs */
              var pagTotalString = pagTotal.toString();
              $("h3[class^=pag]").each(function() {
                /* Gets the numbers of each classes and pages */
                var numId = this.className.match(/\d+/)[0];
                document.styleSheets[0].addRule('h3.pag' + numId + '::before', 'content: "Page ' + numId + ' of ' + pagTotalString + '";');
              });



                            return vm.relatorio;
                        });
                    });
                });
            } 
        };

        vm.setPic = function (pic) {
          var imgTempLocal = document.createElement("IMG");
          imgTempLocal.src = pic.link;

          vm.imgTemp = {};

          vm.imgTemp.width = imgTempLocal.width > 1200 ? 800 + 'px' : imgTempLocal.width + 'px';
          vm.imgTemp.height = imgTempLocal.width > 1200 ? 'auto' : imgTempLocal.height + 'px';
          vm.imgTemp.link = pic.link;
        };
            

        vm.getRelatorioByCheck = function (filters) {
           if(vm.validateDate(vm.filters)){
                vm.isLoadingTable = true;

                $timeout(function () {                                        
                    return Attendance.getAttendances(filters).then(function (relatorio) {
                        var categoriesList = {};
                        Category.getLeafs().then(function (response) {
                            categoriesList = response.itens;

                            for (var i = 0; i < relatorio.length; i++) {
                                for (var j = 0; j < categoriesList.length; j++) { 
                                    if (relatorio[i].form.categoryId == categoriesList[j].id) {
                                        relatorio[i].category = categoriesList[j];
                                        break;
                                    }

                                    for (var j = 0; j < vm.clientes.length; j++) {
                                        if (relatorio[i].userId == vm.clientes[j].id) {
                                            relatorio[i].addressLine1 = vm.clientes[j].profiles[0].address.addressLine1;
                                            relatorio[i].district = vm.clientes[j].profiles[0].address.district;
                                            relatorio[i].city = vm.clientes[j].profiles[0].address.city;
                                            relatorio[i].zipCode = vm.clientes[j].profiles[0].address.zipCode;
                                            break;
                                        }
                                    }
                                }
                            }
                            vm.totalItens = parseInt(relatorio.length);
                            vm.processedItens = parseInt(0);
                            vm.processingImages = parseInt(0);
                            if(relatorio.length > 0){
                                relatorio.forEach(listaAtendimentoTreatment);
                            }else{
                                vm.processingImages = parseInt(100);
                            }
                            vm.relatorio = relatorio;
                            vm.isLoadingTable = false;
                            return vm.relatorio;
                        });
                    });
                }, 300);
            };
       };

        function listaAtendimentoTreatment(atendimento) {
            atendimento.attendanceDate = atendimento.attendanceDate.substr(0, 16);
            if(atendimento.dateSLA != undefined) {
                atendimento.dateSLA = atendimento.dateSLA.substr(0, 16);
            }else{
                atendimento.dateSLA = " - ";
            }

            if(atendimento.dateFinishProcess != undefined){
                atendimento.dateFinishProcess = atendimento.dateFinishProcess.substr(0, 16);
            }else{
                atendimento.dateFinishProcess = " - ";
            }


            atendimento.answersNoImg = atendimento.anwsersForm.filter(getAnswerWithouImages);
            atendimento.aswersOnlyImages = atendimento.anwsersForm.filter(getAnswerOnlyImages);

            Attendance.getFormImagesInFiles(atendimento.id, vm.appCompany).then(function (images) { 
                  atendimento.aswersOnlyImages.forEach(function(item){
                    item.images = [];
                    item.fieldValue.forEach(function(imgName){
                        var img = images.forEach(function(imgSource){
                            if(imgName.toString().toLowerCase().trim() == imgSource.name.toString().toLowerCase().trim()){
                                item.images.push(imgSource) ;
                            }
                        });  
                        
                    });                    
                  });  
                  vm.processedItens++;
                  vm.processingImages = vm.processedItens / vm.totalItens * 100;               
            });    
        }

        function getAnswerWithouImages(item){
            return item.fieldType.toUpperCase() != "IMAGE";
        }

        function getAnswerOnlyImages(item){
            if(item.fieldType.toUpperCase() == "IMAGE"){
                item.fieldValue = item.fieldValue.filter(function(fil){
                    return fil.trim().length > 0;
                })
                return true;    
            }
            return false;
        }        

        vm.validateDate = function(filters) {
            // Validação de data final, deve ser menor que a atual.
            if (vm.dateEndSet) {
                var dateEndDivide = vm.dateEndSet.toString().indexOf('.') >= 0 ? vm.dateEndSet.toString().split('.') : vm.dateEndSet.toString().split('/');
                if (dateEndDivide.length == 3) {
                    var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

                    if (new Date(dateEndParse) > new Date()) {
                        Common.mensagemError('A data final não pode ser maior que a data atual.');
                        return false;
                    }
                } else {
                    Common.mensagemError('Data final incorreta.');
                    return false;
                }
            }

            // Validação de data inicial, deve ser menor que a final.
            if (vm.dateIniSet) {
                var dateIniDivide = vm.dateIniSet.toString().indexOf('.') >= 0? vm.dateIniSet.toString().split('.') : vm.dateIniSet.toString().split('/');
                if (dateIniDivide.length == 3) {
                    var dateIniParse = Date.parse(dateIniDivide[1] + '/' + dateIniDivide[0] + '/' + dateIniDivide[2] + ' 00:00:00');
                    vm.filters.dateIni = new Date(dateIniParse);
                    if (new Date(dateIniParse) > new Date()) {
                        Common.mensagemError('A data inicial não pode ser maior que a data atual.');
                        return false;
                    }

                    if (vm.dateEndSet) {
                        var dateEndDivide = vm.dateEndSet.toString().indexOf('.') >= 0 ? vm.dateEndSet.toString().split('.') : vm.dateEndSet.toString().split('/');

                        if (dateEndDivide.length == 3) {
                            var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');
                            vm.filters.DateEnd = new Date(dateEndParse);

                            if (new Date(dateIniParse) > new Date(dateEndParse)) {
                                Common.mensagemError('A data inicial não pode ser maior que a data final.');
                                return false;
                            }

                            // Calcula a diferença entre as datas.
                            var timeDiff = Math.abs(new Date(dateEndParse).getTime() - new Date(dateIniParse).getTime());
                            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
                            
                            // Período de datas não pode ser maior que 6 meses.
                            if (diffDays > 180) {
                                Common.mensagemError('Período pesquisado não pode ser maior que 6 meses.');
                                return false;
                            }

                        } else {
                            Common.mensagemError('Data final incorreta.');
                            return false;
                        }
                    }
                } else {
                    Common.mensagemError('Data inicial incorreta.');
                    return false;
                }
            }

            return true;
        }

        vm.pesquisar = function (filters) {
            if (vm.validateDate(filters)) {
                initComponents();
                vm.getRelatorio(filters);
            }
        };

        vm.pesquisarByCheck = function (filters) {
            vm.isLoadingTable = true;
            initComponents();
            $timeout(function() {
                vm.isLoadingTable = false;
            }, 500);            
        };

        vm.loadFilters = function() {
            vm.configurarPermissoes(); 
            vm.isLoading = true;
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;

            if ($rootScope.filterAttendanceRelatorio != null) {
                vm.filters = $rootScope.filterAttendanceRelatorio;
                vm.filters.pagStart = 0;
                vm.filters.pagEnd = 999;

                if (vm.filters.categoryDescription) {
                    vm.filters.categoryId = vm.filters.categoryDescription;
                }

                $rootScope.filterAttendanceRelatorio = null;
            } else {
                var datePickerFormat = APPLICATION.uiKitDatePickerFormat;
                var today = moment().format(datePickerFormat.format);
                vm.isLoadingAttendances = false;
                vm.isLoadingFiltros = false;
                vm.filters = {};
                // vm.dateIniSet = '29/06/2017';
                // vm.dateEndSet = '29/06/2017';
                vm.filters.pagStart = 0;
                vm.filters.pagEnd = 9999;
                vm.busy = false;
            }
            vm.filters.includeSubItens = true;
            vm.selectize_sources_categories = [];
            vm.selectize_sources_services = [];
            vm.selectize_sources_situations = [];
            vm.isLoadingFiltros = true;
            vm.usuarioIsLoad = false;

            // Categorias.
            Category.getLeafs().then(function (result) {
                vm.selectize_sources_categories = result.itens;
                var filters = {};
                filters.IntegratorType = 'Web';
                // Serviços.
                Attendance.getServicos(filters).then(function (result) {
                    vm.selectize_sources_services = result;  
                    vm.selectize_sources_services_backup = result;     
                    // Situações.      
                    Attendance.getSituations().then(function (result) {
                        vm.selectize_sources_situations = result; 
                        initComponents();
                        vm.isLoadingFiltros = false; 

                        //vm.pesquisar(vm.filters); 
                        vm.relatorio = []; //Ivy solicitou que ao entrar na tela não realizasse a pesquisa, mas esperar pelos parâmetros informados pelo user.
                        var appSelecionada = DashboardCompany.obterAppSelecionada();                        
                        vm.isLoading = false;
                    });
                });
            });          
        };

        vm.loadFiltersByCheck = function() {
            vm.pesquisarByCheck(vm.filters);    
        };

        function initComponents() {
            var categories = vm.selectize_sources_categories;
            vm.selectize_sources_categories_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            var services = vm.selectize_sources_services;
            vm.selectize_sources_services_config = {
                plugins: {
                    remove_button: {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: STRING_ID,
                labelField: STRING_DESCRIPTION,
                searchField: STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            var situations = vm.selectize_sources_situations;
            vm.selectize_sources_situations_config = {
                plugins: {
                    remove_button: {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: STRING_ID,
                labelField: STRING_DESCRIPTION,
                searchField: STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            vm.printDiv = function (divName) {
                 var printContents = document.getElementById(divName).innerHTML;
                 var win = window.open('','Relatório Analítico de Solicitações');                
                 win.document.write('<html>');
                 win.document.write('<head>');
                 
                 
                 win.document.write('<script src=\"https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js\"></script>');
                 win.document.write('<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/css/uikit.min.css\" />');
                 win.document.write('<script src=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/js/uikit.min.js\"></script>');
                 win.document.write('<link rel=\"stylesheet\" href=\"cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/css/uikit.min.css\" media=\"all\" />');
                 win.document.write('<script src=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/js/uikit.min.js\"></script>');
                 win.document.write('<style>');
                 win.document.write('.columnHeader{font-size:11px;}');
                 win.document.write('.columnValue{margin-left:12px; font-size:9px;}');                 
                 win.document.write('.sectionDivisor{margin: 0px 0px 0px 0px; border: 1px 0px 0px 0px solid #AAAAAA; height: 1px;}');                                  
                 win.document.write('.reportTitle{margin:5px 0px 5px 0px; text-align:center;}');                 
                 win.document.write('</style>');
                 win.document.write('<title> Relatório Analítico de Solicitações</title>');
                 win.document.write('</head>');
                 win.document.write('<body>');
                 win.document.write(printContents);
                 win.document.write('<style>');
                 // Gabriel Souza: adição da paginação no relatório, subtitulo e data da solicitação do relatório.
                 win.document.write('@page { margin-top: 100px; margin-left: 20px; margin-bottom: 40px; margin-right: 20px; counter-increment: page !important; @bottom-right { padding-right:20px !important; content: "Page " counter(page) !important; }}');                 
                 win.document.write('</style>');
                 win.document.write('</body>');
                 win.document.write('</html>');
                 win.focus();
                 setTimeout(function(){
                        win.print();
                        win.close(); 
                 },1000);                 
            };


            vm.period;
            if (vm.dateIniSet && vm.dateEndSet) vm.period = vm.dateIniSet + " à " + vm.dateEndSet;
            else if (vm.dateIniSet && !vm.dateEndSet) vm.period = "A partir de " + vm.dateIniSet;
            else if (!vm.dateIniSet && vm.dateEndSet) vm.period = "Até " + vm.dateEndSet;
            else if (!vm.dateIniSet && vm.dateEndSet) vm.period = "Até " + vm.dateEndSet;
            else if (!vm.dateIniSet && !vm.dateEndSet) vm.period = "";
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(1)
                .withDOM('rtip')
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withPaginationType('full_numbers')
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtOptionsExportable = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(9999999)
                .withDOM('rtip')
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withPaginationType('full_numbers')
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });
            
        }        

        vm.confirmDataAbertura = function(checked) {
            vm.visibleDataAbertura = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmNumeroOcorrencia = function(checked) {
            vm.visibleNumeroOcorrencia = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmCategoria = function(checked) {
            vm.visibleCategoria = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmServico = function(checked) {
            vm.visibleServico = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmNomeUsuario = function(checked) {
            vm.visibleNomeUsuario = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmEmailUsuario = function(checked) {
            vm.visibleEmailUsuario = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmEndereco = function(checked) {
            vm.visibleEndereco = checked;
            vm.loadFiltersByCheck();
        }

        vm.confirmSituacao = function(checked) {
            vm.visibleSituacao = checked;
            vm.loadFiltersByCheck();
        }

        vm.init = function () {  
            vm.visibleDataAbertura = true;
            vm.visibleNumeroOcorrencia = true;
            vm.visibleCategoria = true;
            vm.visibleServico = true;
            vm.visibleNomeUsuario = true;
            vm.visibleEmailUsuario = true;
            vm.visibleEndereco = true;
            vm.visibleSituacao = true;

            vm.loadFilters(); 
        };

        vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Relatórios de Relacionamento", action: "R" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();
    }



    angular.module('app.relatorios')
        .controller('AtendimentoListController', AtendimentoListController);

})();

/**
 * Created by caeta on 16/09/2016.
 */
(function () {
    'use strict';

    /** @ngInject */
    function AtendimentoSinteticoListController(DashboardCompany, $controller, Company, UsuarioAdmin, $interval, $rootScope, $filter, $scope, Relatorios, Category, Servico, Cliente, Attendance, Security, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile) {        
        var vm = this;
        var STRING_ID = 'id';
        var STRING_NAME = 'name';
        var STRING_USER_ID = 'userId';
        var STRING_DESCRIPTION = 'description';  
        var COMPANY = Company.getCompanySelected();

        $rootScope.primarySidebarActive = true;

        //Permissões
        vm.isReportVisualizarPermitido = false; //No use        
        vm.configurarPermissoes = function () {
            vm.isReportVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Relatório Sintético", action: "R" });
        };

        // Exibe os serviços específicos para a categoria selecionada.
        vm.changeCategory = function () {
            var listServices = [];

            if (vm.filters.categoryId == null) {
                vm.selectize_sources_services = vm.selectize_sources_services_backup;
            } else {
                for (var i = 0; i < vm.selectize_sources_services_backup.length; i++) {
                    if (vm.selectize_sources_services_backup[i].category.id == vm.filters.categoryId) {
                        listServices.push(vm.selectize_sources_services_backup[i]);
                    }
                }
                vm.selectize_sources_services = listServices;
            }
        };

        vm.getRelatorio = function (filters) {
            if(vm.validateDate(filters)){
                vm.isLoading = true;
                Relatorios.getSinteticReport(filters).then(function (relatorio) {
                    vm.relatorio = relatorio;
                    vm.isLoading = false;
                });
            }
        }; 

        vm.enableCategory = function (){
            vm.filters.groupByCategory = !vm.filters.groupByCategory;
        };

        vm.enableService = function(){
            vm.filters.groupByService = !vm.filters.groupByService;
        };

        vm.enableSituation = function(){
            vm.filters.groupBySituation = !vm.filters.groupBySituation;            
        };    

        vm.enableUser  = function(){
            vm.filters.groupByUser = !vm.filters.groupByUser;                        
        };      

        vm.setGroupPeriodType = function(option){
            switch(option){
                case 0: //Dia e hora
                    vm.filters.periodType = 1; 
                break;
                case 1: //Por dia
                    vm.filters.periodType = 2;
                break;              
                case 2: //Por mês
                    vm.filters.periodType = 3;
                break;
                case 3: //Por Ano
                    vm.filters.periodType = 4;
                break;
                default:
                break;
            }           
        };     

        vm.validateDate = function(filters) {
            // Validação de data final, deve ser menor que a atual.
            if (vm.dateEndSet) {
                var dateEndDivide = vm.dateEndSet.toString().indexOf('.') >= 0 ? vm.dateEndSet.toString().split('.') : vm.dateEndSet.toString().split('/');
                if (dateEndDivide.length == 3) {
                    var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

                    if (new Date(dateEndParse) > new Date()) {
                        Common.mensagemError('A data final não pode ser maior que a data atual.');
                        return false;
                    }
                } else {
                    Common.mensagemError('Data final incorreta.');
                    return false;
                }
            }

            // Validação de data inicial, deve ser menor que a final.
            if (vm.dateIniSet) {
                var dateIniDivide = vm.dateIniSet.toString().indexOf('.') >= 0? vm.dateIniSet.toString().split('.') : vm.dateIniSet.toString().split('/');
                if (dateIniDivide.length == 3) {
                    var dateIniParse = Date.parse(dateIniDivide[1] + '/' + dateIniDivide[0] + '/' + dateIniDivide[2] + ' 00:00:00');
                    vm.filters.dateIni = new Date(dateIniParse);
                    if (new Date(dateIniParse) > new Date()) {
                        Common.mensagemError('A data inicial não pode ser maior que a data atual.');
                        return false;
                    }

                    if (vm.dateEndSet) {
                        var dateEndDivide = vm.dateEndSet.toString().indexOf('.') >= 0 ? vm.dateEndSet.toString().split('.') : vm.dateEndSet.toString().split('/');

                        if (dateEndDivide.length == 3) {
                            var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');
                            vm.filters.DateEnd = new Date(dateEndParse);

                            if (new Date(dateIniParse) > new Date(dateEndParse)) {
                                Common.mensagemError('A data inicial não pode ser maior que a data final.');
                                return false;
                            }

                            // Calcula a diferença entre as datas.
                            var timeDiff = Math.abs(new Date(dateEndParse).getTime() - new Date(dateIniParse).getTime());
                            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)); 
                            
                            // Período de datas não pode ser maior que 6 meses.
                            if (diffDays > 180) {
                                Common.mensagemError('Período pesquisado não pode ser maior que 6 meses.');
                                return false;
                            }

                        } else {
                            Common.mensagemError('Data final incorreta.');
                            return false;
                        }
                    }
                } else {
                    Common.mensagemError('Data inicial incorreta.');
                    return false;
                }
            }

            return true;
        }

        vm.search = function (filters) {
            if (vm.validateDate(filters)) {
                initComponents();
                vm.showCategory = filters.groupByCategory;
                vm.showService = filters.groupByService;
                vm.showSituation = filters.groupBySituation;
                vm.showUser = filters.groupByUser;
                if(!vm.showCategory){
                    vm.filters.categoryId = null;
                }
                if(!vm.showService){
                    vm.filters.serviceIds = [];
                }
                if(!vm.showSituation){
                    vm.filters.situationIds = [];
                }
                if(!vm.showUser){
                    vm.filters.userDescription = null;
                }
                vm.getRelatorio(filters);
            }
        };

        vm.loadFilters = function() {
            vm.configurarPermissoes(); 
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            vm.hoje = moment().format(vm.datePickerFormat.format); 

            vm.filters = {};
            vm.dateIniSet = moment().add(-5, 'months').format(vm.datePickerFormat.format);
            vm.dateEndSet = vm.hoje;
            vm.filters.periodType = 3;
            vm.filters.groupByCategory = false;
            vm.filters.groupByService = false;
            vm.filters.groupBySituation = false;
            vm.filters.groupByUser = false;
            vm.selectize_sources_categories = [];
            vm.selectize_sources_services = [];
            vm.selectize_sources_situations = [];
            vm.showCategory = false;
            vm.showService = false;
            vm.showSituation = false
            vm.showUser = false;
            vm.isLoadingFiltros = true;
            vm.usuarioIsLoad = false;

            // Categorias.
            Category.get().then(function (result) {
                vm.selectize_sources_categories = result.itens;
                var filters = {};
                filters.IntegratorType = 'Web';
                // Serviços.
                Attendance.getServicos(filters).then(function (result) {
                    vm.selectize_sources_services = result;  
                    vm.selectize_sources_services_backup = result;       
                    // Situações.      
                    Attendance.getSituations().then(function (result) {
                        vm.selectize_sources_situations = result; 
                        initComponents();
                        vm.isLoadingFiltros = false; 

                        vm.search(vm.filters);

                        // Usuários.              
                        UsuarioAdmin.get(COMPANY, filters).then(function (result) {
                            var lista = [];
                            var item = {};
                            for (var i = 0; i < result.length; i++) {
                                item = {};
                                item = result[i].profiles[0];
                                lista.push(item);
                            }
                            vm.selectize_sources_users = lista;  
                            vm.usuarioIsLoad = true;              
                        });
                    });
                });
            });          
        };

        function initComponents() {
            var categories = vm.selectize_sources_categories;
            vm.selectize_sources_categories_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            var services = vm.selectize_sources_services;
            vm.selectize_sources_services_config = {
                plugins: {
                    remove_button: {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: STRING_ID,
                labelField: STRING_DESCRIPTION,
                searchField: STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            var situations = vm.selectize_sources_situations;
            vm.selectize_sources_situations_config = {
                plugins: {
                    remove_button: {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: STRING_ID,
                labelField: STRING_DESCRIPTION,
                searchField: STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            var users = vm.selectize_sources_users;
            vm.selectize_sources_users_config = {
                plugins: {
                    remove_button: {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: STRING_USER_ID,
                labelField: STRING_NAME,
                searchField: STRING_NAME,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.name) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.name) + '</div>';
                    }
                }
            };

            var period;
            if(vm.dateIniSet && vm.dateEndSet) period = vm.dateIniSet + " à " + vm.dateEndSet;
            else if(vm.dateIniSet && !vm.dateEndSet) period = vm.dateIniSet + " à " + vm.hoje;
            else if(!vm.dateIniSet && vm.dateEndSet) period = vm.dateEndSet;
            else if(!vm.dateIniSet && !vm.dateEndSet) period = "";
            //full_numbers_no_ellipses
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(10)
                .withDOM('rtip')
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withPaginationType('full_numbers')
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                })
                .withButtons([
                    {
                        extend: "excel",
                        title: APPLICATION.companyName + period,
                        exportOptions: {
                            columns: ':visible'
                        },
                        CharSet: "utf8",
                        exportData: { decodeEntities: true }
                    },
                    {
                        extend: "pdf",
                        title: APPLICATION.companyName + ' - ' + period,
                        orientation: 'landscape',
                        pageSize: 'LEGAL',
                        exportOptions: {
                            columns: ':visible'
                        },
                        exportData: { decodeEntities: true }
                    },
                    {
                        extend: 'print',
                        customize: function (win) {
                            $(win.document.body).find('table')
                                .addClass('compact')
                                .css('font-size', '6pt');
                        },
                        text: 'Imprimir',
                        autoPrint: true,
                        title: APPLICATION.companyName + ' - ' + period,
                        exportOptions: {
                            columns: ':visible'
                        }
                    }
                ]);
            ;

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
            ];
        }

        vm.init = function () {
            vm.loadFilters();
            vm.search(vm.filters);
        };

        vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Relatórios de Relacionamento", action: "R" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();
    }

    angular.module('app.relatorios')
        .controller('AtendimentoSinteticoListController', AtendimentoSinteticoListController);

})();

(function () {
  'use strict';

  angular
    .module('app.pushlog', []);
})();

/**
 * Created by caeta on 16/09/2016.
 */
(function () {
    'use strict';

    /** @ngInject */
 function AtendimentoListController($interval, $controller, $rootScope, $state, $scope, $window, DashboardCompany, Push, Session, CustomModal, Relatorios, Category, Servico, Security, Cliente, Attendance, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile) {
        var vm = this;            
        //$rootScope.primarySidebarActive = false;
        //Permissões       
        vm.isMensagemCadastrarPermitido = false;
        vm.isMensagemEditarPermitido = false;
        vm.isMensagemPesquisarPermitido = false;
        vm.isMensagemDeletarPermitido = false;
        vm.isMensagemVisualizarPermitido = false;

        vm.configurarPermissoes = function () {
            vm.isMensagemCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagens", action: "C" });
            vm.isMensagemEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagens", action: "U" });
            vm.isMensagemPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Mensagens", action: "S" });
            vm.isMensagemDeletarPermitido = Security.exitsProfilePermission({ id: 4, name: "Mensagens", action: "D" });
            vm.isMensagemVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
        };

        vm.getMensagens = function (filters) {
            filters.sendPush = undefined;
            filters.sendInbox = undefined;
            if (_.find(vm.filters.selectize_tiposModel, function (o) { return o == "0" })) {
                filters.sendPush = true;
            }
            if (_.find(vm.filters.selectize_tiposModel, function (o) { return o == "1" })) {
                filters.sendInbox = true;
            }
            if (vm.filters.selectize_tiposModel == undefined || vm.filters.selectize_tiposModel.length == 0) {
                filters.sendPush = undefined;
                filters.sendInbox = undefined;
            }

            return vm.getMensagensInner(filters);
        };

        vm.getMensagensInner = function (filters) {
            vm.isLoading = true;
            return Push.get(filters).then(function (mensagens) {
                vm.mensagens = mensagens;
                //formatTimeZones();
                vm.isLoading = false;
                return vm.mensagens;
            });
        };

        vm.getTiposMensagem = function () {
            return Push.getTiposMensagem().then(function (tipos) {
                vm.selectize_tipos = tipos;
                return vm.selectize_tipos;
            });
        };

        vm.search = function (filters) {
            var elem = angular.element("#colunaAttendances")[0];
            if (elem) {
                elem.scrollTop = 0;
            }
            $window.scrollTo(0, 0);

            //dates validation with incomplete input
            if (vm.filters.dtCreatedStart && vm.filters.dtCreatedStart.length < 10) {
                vm.filters.dtCreatedStart = undefined;
            }
            if (vm.filters.dtCreatedEnd && vm.filters.dtCreatedEnd.length < 10) {
                vm.filters.dtCreatedEnd = undefined;
            }
            if (vm.filters.dtScheduleStart && vm.filters.dtScheduleStart.length < 10) {
                vm.filters.dtScheduleStart = undefined;
            }
            if (vm.filters.dtScheduleEnd && vm.filters.dtScheduleEnd.length < 10) {
                vm.filters.dtScheduleEnd = undefined;
            }
            if (vm.filters.dtSentStart && vm.filters.dtSentStart.length < 10) {
                vm.filters.dtSentStart = undefined;
            }
            if (vm.filters.dtSentEnd && vm.filters.dtSentEnd.length < 10) {
                vm.filters.dtSentEnd = undefined;
            }


            vm.getMensagens(filters).then(function (data) {
                if (data.length > 0) {
                    //necessário para o botão de refresh da página
                    vm.FILTERS_REFRESH = JSON.parse(JSON.stringify(filters));
                    vm.detailMensagem(data[0].id, 0);
                }
            });
        };

        $scope.$on('reloadAfterDeletion', function (event, data) {
            vm.search(vm.filters);
        });

        vm.loadFilters = function () {
            vm.isLoadingFiltros = true;
            vm.getTiposMensagem().then(function () {
                initComponents();
                vm.isLoadingFiltros = false;
            });
        };


        vm.detailMensagem = function (id, $index) {
            $timeout(function () {
                vm.selectedIndex = $index;
            }, 250);
            $state.go('private.painel.mensagemlog.list.detail', { 'id': id, 'hidePreloader': 1 });

        };

        function initComponents() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
                DTColumnDefBuilder.newColumnDef(4),
                DTColumnDefBuilder.newColumnDef(5),
                DTColumnDefBuilder.newColumnDef(6)
            ];

            var status = vm.selectize_tipos;
            vm.selectize_tipos_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.descricao) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.descricao) + '</div>';
                    }
                }
            };
        };

        //workaround para menu 'Mensageria' ao clicar mais de uma vez
        function abrirMenu() {
            var $sidebar_main = angular.element('#sidebar_main');
            var slideToogle = 'slideDown';
            var ul = angular.element('#Mensageria');
            var variables = [0.4, 0, 0.2, 1];
            ul.velocity(slideToogle, {
                duration: 400,
                easing: variables,
                begin: function () {
                    if (slideToogle == 'slideUp') {
                        $(this).closest('.submenu_trigger').removeClass('act_section');
                    } else {
                        if ($rootScope.menuAccordionMode) {
                            $this.closest('li').siblings('.submenu_trigger').each(function () {
                                $(this).children('ul').velocity('slideUp', {
                                    duration: 500,
                                    easing: variables,
                                    begin: function () {
                                        $(this).closest('.submenu_trigger').removeClass('act_section');
                                    }
                                });
                            });
                        }
                        $(this).closest('.submenu_trigger').addClass('act_section');
                    }
                },
                complete: function () {
                    if (slideToogle !== 'slideUp') {
                        var scrollContainer = $sidebar_main.find(".scroll-content").length ? $sidebar_main.find(".scroll-content") : $sidebar_main.find(".scrollbar-inner");
                        // $this.closest('.act_section').velocity("scroll", {
                        //     duration: 500,
                        //     easing: variables,
                        //     container: scrollContainer
                        // });
                    }
                }
            });
        };

        //Validação das datas
        var dtCreatedStart = $scope.$watch(
            'vm.filters.dtCreatedStart',
            function () {
                if (vm.filters.dtCreatedStart && vm.filters.dtCreatedStart.length >= 16) {
                    var result = Common.validateData(vm.filters.dtCreatedStart, vm.filters.dtCreatedEnd);
                    if (!result) {
                        vm.filters.dtCreatedStart = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtCreatedEnd = $scope.$watch(
            'vm.filters.dtCreatedEnd',
            function () {
                if (vm.filters.dtCreatedEnd && vm.filters.dtCreatedEnd.length >= 16) {
                    var result = Common.validateData(vm.filters.dtCreatedStart, vm.filters.dtCreatedEnd);
                    if (!result) {
                        vm.filters.dtCreatedEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );

        var dtScheduleStart = $scope.$watch(
            'vm.filters.dtScheduleStart',
            function () {
                if (vm.filters.dtScheduleStart && vm.filters.dtScheduleStart.length >= 16) {
                    var result = Common.validateData(vm.filters.dtScheduleStart, vm.filters.dtScheduleEnd);
                    if (!result) {
                        vm.filters.dtScheduleStart = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtScheduleEnd = $scope.$watch(
            'vm.filters.dtScheduleEnd',
            function () {
                if (vm.filters.dtScheduleEnd && vm.filters.dtScheduleEnd.length >= 16) {
                    var result = Common.validateData(vm.filters.dtScheduleStart, vm.filters.dtScheduleEnd);
                    if (!result) {
                        vm.filters.dtScheduleEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtSentStart = $scope.$watch(
            'vm.filters.dtSentStart',
            function () {
                if (vm.filters.dtSentStart && vm.filters.dtSentStart.length >= 16) {
                    var result = Common.validateData(vm.filters.dtSentStart, vm.filters.dtSentEnd);
                    if (!result) {
                        vm.filters.dtSentStart = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtSentEnd = $scope.$watch(
            'vm.filters.dtSentEnd',
            function () {
                if (vm.filters.dtSentEnd && vm.filters.dtSentEnd.length >= 16) {
                    var result = Common.validateData(vm.filters.dtSentStart, vm.filters.dtSentEnd);
                    if (!result) {
                        vm.filters.dtSentEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }

            }
        );

        $scope.$on('$destroy', function () {
            [
                dtCreatedStart,
                dtCreatedEnd,
                dtScheduleStart,
                dtScheduleEnd,
                dtSentStart,
                dtSentEnd
            ].forEach(function (fn) {
                fn();
            });
        });

        vm.init = function () {
            vm.configurarPermissoes();
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormatDateTime;
            vm.filters = {};
            vm.filters.source = 'api';
            vm.filters.appCompanyId = vm.appCompany.id;
            vm.loadFilters();
            vm.getMensagens(vm.filters).then(function (data) {
                abrirMenu();
                if (data.length > 0) {
                    //necessário para o botão de refresh da página
                    vm.FILTERS_REFRESH = JSON.parse(JSON.stringify(vm.filters));
                    vm.detailMensagem(data[0].id, 0);
                }
            });
        };
        
        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isMensagemVisualizarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();
    }


    angular.module('app.pushlog')
        .controller('PushLogListController', AtendimentoListController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PushLogDetailController($interval, $controller, $http, $timeout, $rootScope, $scope, $stateParams, Attendance, Category, DashboardCompany, APPLICATION, Common, Security, Login, Push) {
    var vm = this;    
    vm.count = 0;

    //Permissões       
    vm.isMensagemEditarPermitido = false;
    vm.isMensagemDeletarPermitido = false;

    vm.configurarPermissoes = function () {
      vm.isMensagemCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagens", action: "C" });
      vm.isMensagemEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagens", action: "U" });
      vm.isMensagemPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Mensagens", action: "S" });
      vm.isMensagemDeletarPermitido = Security.exitsProfilePermission({ id: 4, name: "Mensagens", action: "D" });
      vm.isMensagemVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
  };


    vm.getMensagem = function (id) {
      return Push.getById(id).then(function (mensagem) {
        vm.mensagem = mensagem;
        return mensagem;
      });
    };

    vm.getEsperado = function (filters) {
      return Push.getEsperado(filters).then(function (esperado) {
        vm.esperado = esperado;
        return vm.esperado;
      });
    };

    vm.getAlcancado = function (filters) {
      return Push.getAlcancado(filters).then(function (alcancado) {
        vm.alcancado = alcancado;
        return vm.alcancado;
      });
    };

    vm.confirmRemoval = function (form) {
      UIkit.modal.confirm('Deseja realmente excluir essa mensagem?', function () {
        vm.isLoading = true;
        Push.deleteAll(form.id).then(function (result) {
          Common.messageSuccess('Mensagem', 'D', 'F');
          $scope.$emit('reloadAfterDeletion', result);
          vm.isLoading = false;
          vm.init();
        }).catch(function () {
          Common.mensagemError(result);
          vm.isLoading = false;
        }).finally(function () {
          vm.isLoading = false;
        });
      });
    };




    function atualizarGrid() {
      UIkit.$html.trigger('changed.uk.dom');
      $('#fotosDiv').trigger('display.uk.check');
      UIkit.init('#fotosDiv');

      $('#detalheDiv').trigger('display.uk.check');
      UIkit.init('#detalheDiv');

      $('#acatCancelDiv').trigger('display.uk.check');
      UIkit.init('#acatCancelDiv');
      UIkit.$html.trigger('changed.uk.dom');
    }


    vm.init = function () {
      vm.configurarPermissoes();
      //iniciarComponentes();
      var id = $stateParams.id;
      vm.isLoadingDetail = true;
      vm.getMensagem(id).then(function () {
        //vm.getEsperado().then(function () {
        //vm.getAlcancado().then(function () {
        vm.isLoadingDetail = false;
        $timeout(function () {
          atualizarGrid();
        }, 700).then(function () {
          atualizarGrid();
        });
      });
      //});
      //});
    };
    //vm.init();
    vm.configurarPermissoes();
    vm.accessIsAllowed = vm.isMensagemVisualizarPermitido;
    angular.extend(this, $controller('BaseApp', {$scope: this}));
  }

  angular.module('app.pushlog')
    .controller('PushLogDetailController', PushLogDetailController);

})();

(function () {
  'use strict';

  angular
    .module('app.push', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function PushService(Common, RestangularAuth, APPLICATION, Session) {

        function post(push) {
            return RestangularAuth.all('manager/messenger/message').post(push);
        }

        function postNew(push, appSelecionado) {
            var token = Session && Session.getToken() ? Session.getToken() : null;

            RestangularAuth.setDefaultHeaders({
                'Content-Type': 'application/json', 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });

            return RestangularAuth.all('manager/messenger/message').post(push);
        }

        function put(id, push) {
            return RestangularAuth.one('manager/messenger/message/' + id).customPUT(push);
        }

        function putNew(id, push, appSelecionado) {
            var token = Session && Session.getToken() ? Session.getToken() : null;

            RestangularAuth.setDefaultHeaders({
                'Content-Type': 'application/json', 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });

            return RestangularAuth.one('manager/messenger/message/' + id).customPUT(push);
        }

        function get(filters) {
            var clonedFilter = JSON.parse(JSON.stringify(filters));

            // Data de Criacao
            if (clonedFilter.dtCreatedStart) {
                // if (clonedFilter.dtCreatedStartHour) {
                //     clonedFilter.dtCreatedStart = Common.convertToUtcDateTimeString(clonedFilter.dtCreatedStart, clonedFilter.dtCreatedStartHour);
                // } else {
                //     clonedFilter.dtCreatedStart = Common.convertToUtcDateString(clonedFilter.dtCreatedStart);
                // }

                clonedFilter.dtCreatedStart = Common.convertToUtcDateTimeString(clonedFilter.dtCreatedStart.split(" ")[0], clonedFilter.dtCreatedStart.split(" ")[1], 'start');
            }
            if (clonedFilter.dtCreatedEnd) {
                // if (clonedFilter.dtCreatedEndHour) {
                //     clonedFilter.dtCreatedEnd = Common.convertToUtcDateTimeString(clonedFilter.dtCreatedEnd, clonedFilter.dtCreatedEndHour);
                // } else {
                //     clonedFilter.dtCreatedEnd = Common.convertToUtcDateString(clonedFilter.dtCreatedEnd);
                // }
                clonedFilter.dtCreatedEnd = Common.convertToUtcDateTimeString(clonedFilter.dtCreatedEnd.split(" ")[0], clonedFilter.dtCreatedEnd.split(" ")[1], 'end');
            }
            // Data de Agendamento
            if (clonedFilter.dtScheduleStart) {
                // if (clonedFilter.dtScheduleStartHour) {
                //     clonedFilter.dtScheduleStart = Common.convertToUtcDateTimeString(clonedFilter.dtScheduleStart, clonedFilter.dtScheduleStartHour);
                // } else {
                //     clonedFilter.dtScheduleStart = Common.convertToUtcDateString(clonedFilter.dtScheduleStart);
                // }
                clonedFilter.dtScheduleStart = Common.convertToUtcDateTimeString(clonedFilter.dtScheduleStart.split(" ")[0], clonedFilter.dtScheduleStart.split(" ")[1], 'start');
            }
            if (clonedFilter.dtScheduleEnd) {
                // if (clonedFilter.dtScheduleEndHour) {
                //     clonedFilter.dtScheduleEnd = Common.convertToUtcDateTimeString(clonedFilter.dtScheduleEnd, clonedFilter.dtScheduleEndHour);
                // } else {
                //     clonedFilter.dtScheduleEnd = Common.convertToUtcDateString(clonedFilter.dtScheduleEnd);
                // }
                clonedFilter.dtScheduleEnd = Common.convertToUtcDateTimeString(clonedFilter.dtScheduleEnd.split(" ")[0], clonedFilter.dtScheduleEnd.split(" ")[1], 'end');
            }
            // Data do Envio
            if (clonedFilter.dtSentStart) {
                // if (clonedFilter.dtSentStartHour) {
                //     clonedFilter.dtSentStart = Common.convertToUtcDateTimeString(clonedFilter.dtSentStart, clonedFilter.dtSentStartHour);
                // } else {
                //     clonedFilter.dtSentStart = Common.convertToUtcDateString(clonedFilter.dtSentStart);
                // }
                clonedFilter.dtSentStart = Common.convertToUtcDateTimeString(clonedFilter.dtSentStart.split(" ")[0], clonedFilter.dtSentStart.split(" ")[1], 'start');
            }
            if (clonedFilter.dtSentEnd) {
                // if (clonedFilter.dtSentEndHour) {
                //     clonedFilter.dtSentEnd = Common.convertToUtcDateTimeString(clonedFilter.dtSentEnd, clonedFilter.dtSentEndHour);
                // } else {
                //     clonedFilter.dtSentEnd = Common.convertToUtcDateString(clonedFilter.dtSentEnd);
                // }
                clonedFilter.dtSentEnd = Common.convertToUtcDateTimeString(clonedFilter.dtSentEnd.split(" ")[0], clonedFilter.dtSentEnd.split(" ")[1], 'end');
            }


            return RestangularAuth.all('manager/messenger/message').getList(clonedFilter);
        }

        function getById(id) {
            return RestangularAuth.one('manager/messenger/message', id).get();
        }

        function simulate(push) {
            return RestangularAuth.all('manager/account/findusers?count=true', push).post(push);
        }

        function simulateWithDetails(push) {
            return RestangularAuth.all('manager/account/findusers?showdetails=true', push).post(push);
        } 

        function getEsperado(filters) {
            //return RestangularAuth.one('/account/UsersToMessage?count=false', id).get();
        }

        function getAlcancado(filters) {
            //return RestangularAuth.one('/account/UsersToMessage?count=false', id).get();
        }


        function getTiposMensagem() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.tipoMensagem);
            return deferred.promise;
        }

        function deleteAll(ids) {
            return RestangularAuth.one('manager/messenger/message', ids).remove();
        }

        function getAcoes() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.mensagemAcoes);
            return deferred.promise;
        }

        function especialidadesMensagem() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.especialidadeMensagens);
            return deferred.promise;
        }

        return {
            post: post,
            postNew: postNew,
            put: put,
            putNew: putNew,
            get: get,
            simulate: simulate,
            simulateWithDetails: simulateWithDetails,
            getTiposMensagem: getTiposMensagem,
            deleteAll: deleteAll,
            getById: getById,
            getAcoes: getAcoes,
            especialidadesMensagem: especialidadesMensagem
            // getAttendancesHistoryPush: getAttendancesHistoryPush,
            // saveAttendancesHistoryPush: saveAttendancesHistoryPush
        };
    }

    angular
        .module('app.push')
        .factory('Push', PushService);
})();

/**
 * Created by caeta on 16/09/2016.
 */
(function () {
    'use strict';

    /** @ngInject */
    function AtendimentoListController($interval, $controller, $rootScope, $state, $scope, $window, DashboardCompany, Push, Session, CustomModal, Relatorios, Category, Servico, Security, Cliente, Attendance, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile) {        
        var vm = this;            
        $rootScope.primarySidebarActive = true;
        //Permissões       
        vm.isMensagemCadastrarPermitido = false;
        vm.isMensagemEditarPermitido = false;
        vm.isMensagemPesquisarPermitido = false;
        vm.isMensagemDeletarPermitido = false;
        vm.isMensagemVisualizarPermitido = false;

        vm.configurarPermissoes = function () {
            vm.isMensagemCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagens", action: "C" });
            vm.isMensagemEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagens", action: "U" });
            vm.isMensagemPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Mensagens", action: "S" });
            vm.isMensagemDeletarPermitido = Security.exitsProfilePermission({ id: 4, name: "Mensagens", action: "D" });
            vm.isMensagemVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
        };

        vm.getMensagens = function (filters) {
            filters.sendPush = undefined;
            filters.sendInbox = undefined;
            if (_.find(vm.filters.selectize_tiposModel, function (o) { return o == "0" })) {
                filters.sendPush = true;
            }
            if (_.find(vm.filters.selectize_tiposModel, function (o) { return o == "1" })) {
                filters.sendInbox = true;
            }
            if (vm.filters.selectize_tiposModel == undefined || vm.filters.selectize_tiposModel.length == 0) {
                filters.sendPush = undefined;
                filters.sendInbox = undefined;
            }

            return vm.getMensagensInner(filters);
        };

        vm.getMensagensInner = function (filters) {
            vm.isLoading = true;
            return Push.get(filters).then(function (mensagens) {
                vm.mensagens = mensagens;
                //formatTimeZones();
                vm.isLoading = false;
                return vm.mensagens;
            });
        };

        vm.getTiposMensagem = function () {
            return Push.getTiposMensagem().then(function (tipos) {
                vm.selectize_tipos = tipos;
                return vm.selectize_tipos;
            });
        };

        vm.search = function (filters) {
            var elem = angular.element("#colunaAttendances")[0];
            if (elem) {
                elem.scrollTop = 0;
            }
            $window.scrollTo(0, 0);

            //dates validation with incomplete input
            if (vm.filters.dtCreatedStart && vm.filters.dtCreatedStart.length < 10) {
                vm.filters.dtCreatedStart = undefined;
            }
            if (vm.filters.dtCreatedEnd && vm.filters.dtCreatedEnd.length < 10) {
                vm.filters.dtCreatedEnd = undefined;
            }
            if (vm.filters.dtScheduleStart && vm.filters.dtScheduleStart.length < 10) {
                vm.filters.dtScheduleStart = undefined;
            }
            if (vm.filters.dtScheduleEnd && vm.filters.dtScheduleEnd.length < 10) {
                vm.filters.dtScheduleEnd = undefined;
            }
            if (vm.filters.dtSentStart && vm.filters.dtSentStart.length < 10) {
                vm.filters.dtSentStart = undefined;
            }
            if (vm.filters.dtSentEnd && vm.filters.dtSentEnd.length < 10) {
                vm.filters.dtSentEnd = undefined;
            }


            vm.getMensagens(filters).then(function (data) {
                if (data.length > 0) {
                    //necessário para o botão de refresh da página
                    vm.FILTERS_REFRESH = JSON.parse(JSON.stringify(filters));
                    vm.detailMensagem(data[0].id, 0);
                }
            });
        };

        $scope.$on('reloadAfterDeletion', function (event, data) {
            vm.search(vm.filters);
        });

        vm.loadFilters = function () {
            vm.isLoadingFiltros = true;
            vm.getTiposMensagem().then(function () {
                initComponents();
                vm.isLoadingFiltros = false;
            });
        };


        vm.detailMensagem = function (id, $index) {
            $timeout(function () {
                vm.selectedIndex = $index;
            }, 250);
            $state.go('private.painel.mensagem.list.detail', { 'id': id, 'hidePreloader': 1 });

        };

        function initComponents() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
                DTColumnDefBuilder.newColumnDef(4),
                DTColumnDefBuilder.newColumnDef(5),
                DTColumnDefBuilder.newColumnDef(6)
            ];

            var status = vm.selectize_tipos;
            vm.selectize_tipos_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.descricao) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.descricao) + '</div>';
                    }
                }
            };
        };

        //workaround para menu 'Mensageria' ao clicar mais de uma vez
        function abrirMenu() {
            var $sidebar_main = angular.element('#sidebar_main');
            var slideToogle = 'slideDown';
            var ul = angular.element('#Mensageria');
            var variables = [0.4, 0, 0.2, 1];
            ul.velocity(slideToogle, {
                duration: 400,
                easing: variables,
                begin: function () {
                    if (slideToogle == 'slideUp') {
                        $(this).closest('.submenu_trigger').removeClass('act_section');
                    } else {
                        if ($rootScope.menuAccordionMode) {
                            $this.closest('li').siblings('.submenu_trigger').each(function () {
                                $(this).children('ul').velocity('slideUp', {
                                    duration: 500,
                                    easing: variables,
                                    begin: function () {
                                        $(this).closest('.submenu_trigger').removeClass('act_section');
                                    }
                                });
                            });
                        }
                        $(this).closest('.submenu_trigger').addClass('act_section');
                    }
                },
                complete: function () {
                    if (slideToogle !== 'slideUp') {
                        var scrollContainer = $sidebar_main.find(".scroll-content").length ? $sidebar_main.find(".scroll-content") : $sidebar_main.find(".scrollbar-inner");
                        // $this.closest('.act_section').velocity("scroll", {
                        //     duration: 500,
                        //     easing: variables,
                        //     container: scrollContainer
                        // });
                    }
                }
            });
        };

        //Validação das datas
        var dtCreatedStart = $scope.$watch(
            'vm.filters.dtCreatedStart',
            function () {
                if (vm.filters.dtCreatedStart && vm.filters.dtCreatedStart.length >= 16) {
                    var result = Common.validateData(vm.filters.dtCreatedStart, vm.filters.dtCreatedEnd);
                    if (!result) {
                        vm.filters.dtCreatedStart = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtCreatedEnd = $scope.$watch(
            'vm.filters.dtCreatedEnd',
            function () {
                if (vm.filters.dtCreatedEnd && vm.filters.dtCreatedEnd.length >= 16) {
                    var result = Common.validateData(vm.filters.dtCreatedStart, vm.filters.dtCreatedEnd);
                    if (!result) {
                        vm.filters.dtCreatedEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );

        var dtScheduleStart = $scope.$watch(
            'vm.filters.dtScheduleStart',
            function () {
                if (vm.filters.dtScheduleStart && vm.filters.dtScheduleStart.length >= 16) {
                    var result = Common.validateData(vm.filters.dtScheduleStart, vm.filters.dtScheduleEnd);
                    if (!result) {
                        vm.filters.dtScheduleStart = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtScheduleEnd = $scope.$watch(
            'vm.filters.dtScheduleEnd',
            function () {
                if (vm.filters.dtScheduleEnd && vm.filters.dtScheduleEnd.length >= 16) {
                    var result = Common.validateData(vm.filters.dtScheduleStart, vm.filters.dtScheduleEnd);
                    if (!result) {
                        vm.filters.dtScheduleEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtSentStart = $scope.$watch(
            'vm.filters.dtSentStart',
            function () {
                if (vm.filters.dtSentStart && vm.filters.dtSentStart.length >= 16) {
                    var result = Common.validateData(vm.filters.dtSentStart, vm.filters.dtSentEnd);
                    if (!result) {
                        vm.filters.dtSentStart = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtSentEnd = $scope.$watch(
            'vm.filters.dtSentEnd',
            function () {
                if (vm.filters.dtSentEnd && vm.filters.dtSentEnd.length >= 16) {
                    var result = Common.validateData(vm.filters.dtSentStart, vm.filters.dtSentEnd);
                    if (!result) {
                        vm.filters.dtSentEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }

            }
        );

        $scope.$on('$destroy', function () {
            [
                dtCreatedStart,
                dtCreatedEnd,
                dtScheduleStart,
                dtScheduleEnd,
                dtSentStart,
                dtSentEnd
            ].forEach(function (fn) {
                fn();
            });
        });

        vm.init = function () {            
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormatDateTime;
            vm.filters = {};
            vm.filters.source = 'web';
            vm.filters.appCompanyId = vm.appCompany.id;
            vm.loadFilters();
            vm.getMensagens(vm.filters).then(function (data) {
                abrirMenu();
                if (data.length > 0) {
                    //necessário para o botão de refresh da página
                    vm.FILTERS_REFRESH = JSON.parse(JSON.stringify(vm.filters));
                    vm.detailMensagem(data[0].id, 0);
                }
            });
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isMensagemVisualizarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();
    }

    angular.module('app.push')
        .controller('PushListController', AtendimentoListController);

})();

(function () {
  'use strict';

  /** @ngInject */
  function PushDetailController($interval, $controller, $http, $timeout, $rootScope, $scope, $stateParams, Attendance, DashboardCompany,Category, APPLICATION, Common, Security, Login, Push) {
    var vm = this;        
    vm.count = 0;

    //Permissões       
    vm.isMensagemEditarPermitido = false;
    vm.isMensagemDeletarPermitido = false;

    vm.configurarPermissoes = function () {
      vm.isMensagemCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagens", action: "C" });
      vm.isMensagemEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagens", action: "U" });
      vm.isMensagemPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Mensagens", action: "S" });
      vm.isMensagemDeletarPermitido = Security.exitsProfilePermission({ id: 4, name: "Mensagens", action: "D" });
      vm.isMensagemVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
  };


    vm.getMensagem = function (id) {
      return Push.getById(id).then(function (mensagem) {
        vm.mensagem = mensagem;
        return mensagem;
      });
    };

    vm.getEsperado = function (filters) {
      return Push.getEsperado(filters).then(function (esperado) {
        vm.esperado = esperado;
        return vm.esperado;
      });
    };

    vm.getAlcancado = function (filters) {
      return Push.getAlcancado(filters).then(function (alcancado) {
        vm.alcancado = alcancado;
        return vm.alcancado;
      });
    };

    vm.confirmRemoval = function (form) {
      UIkit.modal.confirm('Deseja realmente excluir essa mensagem?', function () {
        vm.isLoading = true;
        Push.deleteAll(form.id).then(function (result) {
          Common.messageSuccess('Mensagem', 'D', 'F');
          $scope.$emit('reloadAfterDeletion', result);
          vm.isLoading = false;
          vm.init();
        }).catch(function () {
          Common.mensagemError(result);
          vm.isLoading = false;
        }).finally(function () {
          vm.isLoading = false;
        });
      });
    };




    function atualizarGrid() {
      UIkit.$html.trigger('changed.uk.dom');
      $('#fotosDiv').trigger('display.uk.check');
      UIkit.init('#fotosDiv');

      $('#detalheDiv').trigger('display.uk.check');
      UIkit.init('#detalheDiv');

      $('#acatCancelDiv').trigger('display.uk.check');
      UIkit.init('#acatCancelDiv');
      UIkit.$html.trigger('changed.uk.dom');
    }


    vm.init = function () {
      vm.configurarPermissoes();
      //iniciarComponentes();
      var id = $stateParams.id;
      vm.isLoadingDetail = true;
      vm.getMensagem(id).then(function () {
        //vm.getEsperado().then(function () {
        //vm.getAlcancado().then(function () {
        vm.isLoadingDetail = false;
        $timeout(function () {
          atualizarGrid();
        }, 700).then(function () {
          atualizarGrid();
        });
      });
      //});
      //});
    };
    //vm.init();
    vm.configurarPermissoes();
    vm.accessIsAllowed = vm.isMensagemVisualizarPermitido;
    angular.extend(this, $controller('BaseApp', {$scope: this}));
  }

  angular.module('app.push')
    .controller('PushDetailController', PushDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function PushCreateController(DashboardCompany, $controller, Category, $compile, $interval, $rootScope, $scope, $state, $stateParams, $timeout, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, Common, Company, Push, Security, Cliente, Session) {
        var vm = this;        
        vm.operacao = 'Cadastrar';

        vm.configurarPermissoes = function () {
            vm.isMensagemCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagens", action: "C" });
            vm.isMensagemEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagens", action: "U" });
            vm.isMensagemPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Mensagens", action: "S" });
            vm.isMensagemDeletarPermitido = Security.exitsProfilePermission({ id: 4, name: "Mensagens", action: "D" });
            vm.isMensagemVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
        };

        vm.openModalConfirmacaoDeCancelamento = function() {
            var modalConfirmCancelamento = UIkit.modal('.cancelar', {keyboard:false, bgclose:false});
            modalConfirmCancelamento.show();
        }

        vm.getClassField = function(field) {
            return APPLICATION.STRING_POINT + field;
        }

        vm.getTiposMensagem = function () {
            return Push.getTiposMensagem().then(function (tipos) {
                vm.selectize_tipos = tipos;
                return vm.selectize_tipos;
            });
        };

        vm.getAcoes = function () {
            return Push.getAcoes().then(function (acoes) {
                vm.selectize_acoes = acoes;
                return vm.selectize_acoes;
            });
        };

        vm.getEspecialidadesMensagem = function () {
            return Push.especialidadesMensagem().then(function (specs) {
                vm.selectize_especialidadesMensagem = specs;
                return vm.selectize_especialidadesMensagem;
            });
        };

        vm.getUsuarios = function (filters) {
            vm.isLoadingFilters = true;
            return Cliente.getMobile(vm.appCompany, filters).then(function (clientes) {
                vm.selectize_usuarios = clientes.result;
                vm.isLoadingFilters = false;
                if (vm.id && vm.push.tipoEnvio == 1) {
                    //vm.formatUsersSelected(vm.push.targets.userids);
                }

                for(var i = 0; i < vm.selectedUsers.length; i++) {
                    for(var j = 0; j < vm.selectize_usuarios.length; j++) {
                        if (vm.selectedUsers[i].id == vm.selectize_usuarios[j].id) {
                            vm.selectize_usuarios[j].checked = vm.selectedUsers[i].checked;
                            break;
                        }
                    }
                }

                return vm.selectize_usuarios;
            });
        };

        vm.getGender = function () {
            return Cliente.getGenderForListing().then(function (result) {
                vm.selectize_gender_data = result;
                return vm.selectize_gender_data;
            });
        };

        vm.changeSelectTab = function (tab) {
            vm.selectedTab = tab;
        };

        vm.getPush = function (id) {
            return Push.getById(id).then(function (push) {
                vm.push = push;
                vm.push.tiposArray = !vm.push.tiposArray ? [] : vm.push.tiposArray;
                if (vm.push.sendPush) {
                    vm.push.tiposArray.push("0");
                }
                if (vm.push.sendInbox) {
                    vm.push.tiposArray.push("1");
                }

                if (vm.push.sendToAll) {
                    vm.push.tipoEnvio = 0;
                } else if (vm.push.targets) {
                    if (vm.push.targets.userids && vm.push.targets.userids.length > 0) {
                        vm.push.tipoEnvio = 1;
                    } else {
                        vm.push.tipoEnvio = 2;
                    }
                }

                if (vm.push.scheduleToDate) {
                    vm.push.momentoEnvio = 1;
                    var schedule = vm.push.scheduleToDate;
                    vm.push.scheduleToDate = schedule.split(" ")[0];
                    vm.push.scheduleToDateHour = schedule.split(" ")[1];

                } else {
                    vm.push.momentoEnvio = 0;
                }
                return vm.push;
            });
        };

        vm.addUsersSelected = function (item) {
            var found = false;
            for(var i = 0; i < vm.selectedUsers.length; i++) {
                if (vm.selectedUsers[i].id == item.id) {
                    found = true;
                    if(item.checked){
                        vm.selectedUsers[i].checked = true;
                    }
                    else{
                        vm.selectedUsers.splice(vm.selectedUsers.indexOf(vm.selectedUsers[i]), 1);                
                    }
                    break;
                }
            }
            if(!found)
                vm.selectedUsers.push(item);
        };        
        
        vm.removeUsersSelected = function (item) {
            if(item.checked == false){
                vm.selectedUsers.splice(vm.selectedUsers.indexOf(item), 1);                
                for(var j = 0; j < vm.selectize_usuarios.length; j++) {
                    if (item.id == vm.selectize_usuarios[j].id) {
                        vm.selectize_usuarios[j].checked = false;
                        break;
                    }
                }
            }
        };        

        vm.pesquisarUsuarios = function (filters) {
            vm.getUsuarios(filters);
        };

        vm.validarConteudo = function (tipo) {
            return _.find(vm.push.tiposArray, function (o) { return o == tipo });
        }

        vm.carregarFiltros = function () {
            vm.isLoading = true;
            vm.getIcons();
            vm.getTiposMensagem().then(function () {
                vm.getAcoes().then(function () {
                    //vm.getUsuarios(vm.usuarioFilters).then(function () {
                    vm.getGender().then(function () {
                        vm.getEspecialidadesMensagem().then(function () {
                            iniciarComponentes();
                            vm.isLoading = false;
                        });
                    });
                    //});
                });
            });
        };

        vm.closeModal = function (modalTitle) {
            var modal = UIkit.modal(modalTitle);
            modal.hide();
        };

        vm.adicionarAcao = function (acao) {
            if (acao) {

                if (vm.push.actions == undefined) {
                    vm.push.actions = [];
                }

                if (_.find(vm.push.actions, function (o) { return o.name == acao })) {
                    Common.mensagemError('Ação já inserida!');
                    return;
                }


                if (vm.push.tiposArray == undefined || vm.push.tiposArray.length == 0) {
                    vm.push.tiposArray.push('0');
                }
                if (_.find(vm.push.tiposArray, function (o) { return o == '0' }) && (vm.push.actions.length > 0)) {
                    Common.mensagemError('Envio Push só permite um tipo de ação!');
                    return;
                }

                var addedAcao = angular.copy(_.find(vm.selectize_acoes, function (o) { return o.name == acao }));
                addedAcao.parameters.push({ title: undefined, value: undefined })

                vm.push.actions.push(addedAcao);
                Common.messageSuccess('Ação', 'I', 'F');
            }
        };

        vm.adicionarParametro = function (parametros) {
            if (parametros) {
                if (_.find(vm.customPropertiesFormObject.parameters, function (o) { return o.value == parametros.value })) {
                    Common.mensagemError('Valor do parâmetro já inserido!');
                    return;
                }

                if (!parametros.value) {
                    Common.mensagemError('Campo valor é obrigatório!');
                    return;
                }
                vm.customPropertiesFormObject.parameters.push({ title: parametros.title, value: parametros.value });
                vm.tempCustomPropertiesForm = {};
            }
        };

        vm.inserirNovoParametro = function (actionItem) {
            actionItem.parameters.push({ title: undefined, value: undefined })
        };


        vm.removerAcao = function (index) {
            UIkit.modal.confirm('Deseja realmente excluir essa ação e todos os parâmetros associados?', function () {
                vm.push.actions.splice(index, 1);
                Common.messageSuccess('Ação', 'D', 'F');
            });
        };

        vm.removerParametro = function (list, index) {
            UIkit.modal.confirm('Deseja realmente excluir esse parâmetro?', function () {
                list.splice(index, 1);
                Common.messageSuccess('Parâmetro', 'D', 'M');
            });
        };

        vm.clearTargets = function () {
            //Será tratado no momento do envio
            // if (vm.push.targets == undefined) {
            //     vm.push.targets = {};
            // }
        }

        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.mensagem.list', { id: vm.id });
                } else {
                    $state.go('private.painel.mensagem.list');
                }
            });
        };

        vm.submit = function (push) {

            push = adjustForSending(push);

            if (push.tipoEnvio == 1) {
                if (!push.targets.userids || push.targets.userids.length == 0) {
                    Common.mensagemError("Adicione pelo menos um usuário.");
                    return;
                }
            }


            if (push.tipoEnvio == 2) { //validacao nenhum critério preenchido
                if (
                    (push.targets.bornIn == undefined || (push.targets.bornIn && !push.targets.bornIn.dtIni && !push.targets.bornIn.dtEnd)) &&
                    (push.targets.registeredIn == undefined || (push.targets.registeredIn && !push.targets.registeredIn.dtIni && !push.targets.registeredIn.dtEnd)) &&
                    (push.targets.gender == undefined || !push.targets.gender) &&
                    (push.targets.specialty == undefined || push.targets.specialty.length == 0) &&
                    (push.targets.addressCity == undefined || push.targets.addressCity.length == 0) &&
                    (push.targets.addressCountry == undefined || push.targets.addressCountry.length == 0) &&
                    (push.targets.addressState == undefined || push.targets.addressState.length == 0)
                ) {
                    Common.mensagemError("Adicione pelo menos um critério.");
                    return;
                }
            }

            if (vm.submitAction == 'enviar') {
                if (push.sendToAll) {
                    UIkit.modal.confirm('Deseja realmente enviar para todos os usuários?', function () {
                        vm.confirmSubmit(push);
                    });
                } else {
                    vm.confirmSubmit(push);
                }
            }

            if (vm.submitAction == 'simular') {
                var simulatedPush = {};
                simulatedPush.appCompanyId = push.appCompanyId;
                simulatedPush.userids = push.targets.userids;
                simulatedPush.bornIn = push.targets.bornIn;
                simulatedPush.registeredIn = push.targets.registeredIn;
                simulatedPush.gender = push.targets.gender;
                simulatedPush.specialty = push.targets.specialty;
                simulatedPush.addressCity = push.targets.addressCity;
                simulatedPush.addressState = push.targets.addressState;
                simulatedPush.addressCountry = push.targets.addressCountry;
                vm.simulatePush(simulatedPush);
            }


        };

        vm.confirmSubmit = function (push) {
            if (push) {
                vm.isLoading = true;
                //ajusta data de agendamento aqui, para nao impactar no componente do front. Caso o envio seja incorreto
                if (push.momentoEnvio == 1) {
                   var date = push.scheduleToDate;
                   var day = date ? date.substring(0, 2) : null;
                   var month = date ? date.substring(3, 5) : null;
                   var year = date ? date.substring(6, 10) : null;
                   vm.dateUp = new Date(month + '/' + day + '/' + year + ' ' + push.scheduleToDateHour) > new Date();

                    push.scheduleToDate = Common.convertToDateTime(push.scheduleToDate, push.scheduleToDateHour);
                    // push.scheduleToDate = Common.convertToUtcDateTimeString(push.scheduleToDate, push.scheduleToDateHour);
                } else {
                    push.scheduleToDate = undefined;
                }
                if (push.id) {
                    vm.putPush(push);
                } else {
                    vm.postPush(push);
                }
            }
        };

        vm.postPush = function (push) {
            vm.isLoading = true;
            Push.postNew(push, vm.appCompany).then(function (result) {
                //if (result && result.message) {
                    //Common.messageSuccess('Mensagem', 'I', 'M');
                    if (vm.dateUp) {
                        Common.mensagemSucesso("Mensagem agendada.");
                    } else {
                        Common.mensagemSucesso("Mensagem enviada.");
                    }
                    
                    vm.isLoading = false;
                    $state.go('private.painel.mensagem.list');
                    return;
                //}

                // if (result && !result.id) {
                //     Common.messageSuccess(result);
                //     vm.isLoading = false;
                //     $state.go('private.painel.mensagem.list');
                //     return;
                // }

                //Common.mensagemError(result);
                vm.isLoading = false;

            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putPush = function (push) {
            vm.isLoading = true;
            Push.putNew(push.id, push, vm.appCompany).then(function (result) {
                if (result && result > 0) {
                    Common.messageSuccess('Mensagem', 'A', 'F');
                    vm.isLoading = false;
                    $state.go('private.painel.mensagem.list');
                    return;
                }
                if (result && !result.id) {
                    Common.messageSuccess(result);
                    vm.isLoading = false;
                    $state.go('private.painel.mensagem.list');
                    return;
                }
                Common.mensagemError(result);
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.simulatePush = function (push) {
            vm.isLoading = true;
            Push.simulate(push).then(function (result) {
                if (result) {
                    UIkit.modal.alert('Público esperado: ' + result + ' usuário(s).');
                    vm.isLoading = false;
                } else {
                    // Common.mensagemError(result);
                    UIkit.modal.alert('Público esperado: Nenhum usuário.');
                    vm.isLoading = false;
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.simulateWithDetails = function (push) {
            var newPush = { userids: [] };
            newPush.appCompanyId = push.appCompanyId;
            newPush.userids = push.targets.userids;
            return Push.simulateWithDetails(newPush).then(function (result) {
                vm.selectedUsers = result;
                return vm.selectedUsers;
            });
        };

        vm.getIcons = function () {
            vm.iconsCode = Category.iconsListMobileCare();
        }

        vm.openModalIcons = function (action) {
            vm.selectedAction = action;
            var modalIcons = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES), {keyboard:false, bgclose:false});
            modalIcons.show();
        }

        vm.selectIcon = function (iconItem) {
            vm.selectedAction.icon = iconItem.id;
            vm.selectedAction.icon = vm.selectedAction.icon.replace('&#x', '')
            var modal = UIkit.modal(".modalIcons");
            modal.hide();
        }


        function adjustForSending(push) {
            var newPush = push;//_.cloneDeep(push);
            newPush.author = Session.getAccessKey();
            newPush.source = 'web';
            newPush.sendToAll = false;
            newPush.sendInbox = undefined;
            newPush.sendPush = undefined;
            newPush.level = 1;


            if (vm.validarConteudo('0') && !vm.validarConteudo('1')) { //Somente push
                newPush.subjectPush = newPush.subject;
                newPush.content = undefined;
                newPush.sendPush = true;
            }

            if (!vm.validarConteudo('0') && vm.validarConteudo('1')) { //Somente inbox
                newPush.contentPush = undefined;
                newPush.subjectPush = undefined;
                newPush.sendInbox = true;
            }

            if (vm.validarConteudo('0') && vm.validarConteudo('1')) { //inbox E push
                newPush.subjectPush = newPush.subject;
                newPush.sendInbox = true;
                newPush.sendPush = true;
            }

            if (newPush.tipoEnvio == 0) {//brodcast
                newPush.sendToAll = true;
                newPush.targets = {};
            }

            if (newPush.tipoEnvio == 1) {//por usuario
                newPush.targets.bornIn = {};
                newPush.targets.registeredIn = {};
                newPush.targets.gender = undefined;
                newPush.targets.specialty = [];
                newPush.targets.addressCity = [];
                newPush.targets.addressCountry = [];
                newPush.targets.addressState = [];
                //
                newPush.targets.userids = [];

                vm.selectedUsers.forEach(function (item) {
                    newPush.targets.userids.push(item.id);
                }, this);

            }

            if (newPush.tipoEnvio == 2) {//por criterio
                newPush.targets.userids = [];
            }
            return newPush;
        }

        function iniciarComponentes() {
            var status = vm.selectize_tipos;
            vm.selectize_tipos_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.descricao) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.descricao) + '</div>';
                    }
                }
            };

            var acoes = vm.selectize_acoes;
            vm.selectize_acoes_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'name',
                labelField: 'title',
                searchField: 'title',
                create: false,
                render: {
                    option: function (acoes, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(acoes.title) + '</span>' +
                            '</div>';
                    },
                    item: function (acoes, escape) {
                        return '<div class="item">' + escape(acoes.title) + '</div>';
                    }
                }
            };

            var users = vm.selectize_usuarios;
            vm.selectize_usuarios_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: 'id',
                labelField: 'userName',
                searchField: 'userName',
                create: false,
                render: {
                    option: function (users, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(users.userName) + '</span>' +
                            '</div>';
                    },
                    item: function (users, escape) {
                        return '<div class="item">' + escape(users.userName) + '</div>';
                    }
                }
            };

            var gender = vm.selectize_gender_data;
            vm.selectize_gender_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Todos',
                valueField: 'descricao',
                labelField: 'descricao',
                searchField: 'descricao',
                render: {
                    option: function (especMensagem, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(especMensagem.descricao) + '</span>' +
                            '</div>';
                    },
                    item: function (especMensagem, escape) {
                        return '<div class="item">' + escape(especMensagem.descricao) + '</div>';
                    }
                }
            };

            var especMensagem = vm.selectize_especialidadesMensagem;
            vm.selectize_especialidadesMensagem_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                valueField: 'value',
                labelField: 'text',
                searchField: 'text',
                create: false,
                render: {
                    option: function (especMensagem, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(especMensagem.text) + '</span>' +
                            '</div>';
                    },
                    item: function (especMensagem, escape) {
                        return '<div class="item">' + escape(especMensagem.text) + '</div>';
                    }
                }
            };


            //opcoes para targets
            // vm.myOptions1 = [];
            vm.myOptions2 = [];
            vm.myOptions3 = [];
            vm.myOptions4 = [];
            // vm.myConfig1 = {
            //     plugins: {
            //         'remove_button': {
            //             label: ''
            //         }
            //     },
            //     create: true,
            //     onChange: function (value) {
            //         console.log('onChange', value)
            //     },
            //     // maxItems: 1,
            //     // required: true,
            // }
            vm.myConfig2 = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                create: true,
                onChange: function (value) {
                    console.log('onChange', value)
                },
                // maxItems: 1,
                // required: true,
            }

            vm.myConfig3 = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                create: true,
                onChange: function (value) {
                    console.log('onChange', value)
                },
                // maxItems: 1,
                // required: true,
            }

            vm.myConfig4 = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                create: true,
                onChange: function (value) {
                    console.log('onChange', value)
                },
                // maxItems: 1,
                // required: true,
            }



            vm.selectize_targetOptions = [];
            vm.targetOptions_config = {
                create: true
            };
        }

        var dtCreatedStart = $scope.$watch(
            'vm.push.targets.registeredIn.dtIni',
            function () {

                if (vm.push.targets && vm.push.targets.registeredIn) {
                    var result = Common.validateData(vm.push.targets.registeredIn.dtIni, vm.push.targets.registeredIn.dtEnd);
                    if (!result) {
                        vm.push.targets.registeredIn.dtIni = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }

            }
        );
        var dtCreatedEnd = $scope.$watch(
            'vm.push.targets.registeredIn.dtEnd',
            function () {
                if (vm.push.targets && vm.push.targets.registeredIn) {
                    var result = Common.validateData(vm.push.targets.registeredIn.dtIni, vm.push.targets.registeredIn.dtEnd);
                    if (!result) {
                        vm.push.targets.registeredIn.dtEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );

        var dtBornStart = $scope.$watch(
            'vm.push.targets.bornIn.dtIni',
            function () {
                if (vm.push.targets && vm.push.targets.bornIn) {
                    var result = Common.validateData(vm.push.targets.bornIn.dtIni, vm.push.targets.bornIn.dtEnd);
                    if (!result) {
                        vm.push.targets.bornIn.dtIni = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );
        var dtBornEnd = $scope.$watch(
            'vm.push.targets.bornIn.dtEnd',
            function () {
                if (vm.push.targets && vm.push.targets.bornIn) {
                    var result = Common.validateData(vm.push.targets.bornIn.dtIni, vm.push.targets.bornIn.dtEnd);
                    if (!result) {
                        vm.push.targets.bornIn.dtEnd = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );

        var scheduleToDate = $scope.$watch(
            'vm.push.scheduleToDate',
            function () {
                if (vm.push.scheduleToDate && vm.push.scheduleToDateHour) {
                    var date = new Date(vm.push.scheduleToDate.substring(6, 11),
                        vm.push.scheduleToDate.substring(3, 5) - 1,
                        vm.push.scheduleToDate.substring(0, 2));
                    date.setHours(vm.push.scheduleToDateHour.split(":")[0]);
                    date.setMinutes(vm.push.scheduleToDateHour.split(":")[1]);
                    var actualDate = new Date();
                    if (actualDate > date) {
                        vm.push.scheduleToDate = undefined;
                        vm.push.scheduleToDateHour = undefined;
                        Common.mensagemError('Data do agendamento não pode ser menor que a data atual.');
                    }
                }
            }
        );

        var scheduleToDateHour = $scope.$watch(
            'vm.push.scheduleToDateHour',
            function () {
                if (vm.push.scheduleToDate) {
                    var date = new Date(vm.push.scheduleToDate.substring(6, 11),
                        vm.push.scheduleToDate.substring(3, 5) - 1,
                        vm.push.scheduleToDate.substring(0, 2));

                    if (vm.push.scheduleToDateHour) {
                        date.setHours(vm.push.scheduleToDateHour.split(":")[0]);
                        date.setMinutes(vm.push.scheduleToDateHour.split(":")[1]);
                    }
                    var actualDate = new Date();
                    if (actualDate > date) {
                        vm.push.scheduleToDate = undefined;
                        vm.push.scheduleToDateHour = undefined;
                        Common.mensagemError('Data do agendamento não pode ser menor que a data atual.');
                    }
                }
            }
        );

        $scope.$on('$destroy', function () {
            [
                dtCreatedStart,
                dtCreatedEnd,
                dtBornStart,
                dtBornEnd,
                scheduleToDateHour,
                scheduleToDate
            ].forEach(function (fn) {
                fn();
            });
        });

        vm.init = function () {
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormatDateTime;
            vm.datePickerFormatNotime = APPLICATION.uiKitDatePickerFormat;
            // vm.usuarioFilters = {};
            // vm.usuarioFilters.limit = 999999;
            // vm.usuarioFilters.Enabled = 'true';
            // vm.usuarioFilters.Roles = ['Mobile'];
            // //vm.filters.pageNumber = 1;
            // //vm.filters.totalItens = vm.itensPorPagina;
            // vm.usuarioFilters.appCompanyId = vm.appCompany.id;

            vm.push = { tiposArray: [], targets: {} };
            vm.selectedUsers = [];
            vm.isEdicao = false;
            vm.id = $stateParams.id;
            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }
            if (vm.isEdicao) {
                vm.operacao = 'Editar';
                vm.isLoading = true;
                vm.getPush(vm.id).then(function () {
                    if (vm.push.tipoEnvio == 1) {
                        vm.simulateWithDetails(vm.push).then(function () {
                            vm.carregarFiltros();
                        });
                    } else {
                        vm.carregarFiltros();
                    }
                });
            } else {
                vm.isLoading = true;
                vm.carregarFiltros();
            }
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isMensagemCadastrarPermitido || vm.isMensagemEditarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
    }

    angular.module('app.push')
        .controller('PushCreateController', PushCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.papel', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function PapelService(Common, RestangularAuth, APPLICATION) {

        function get(filters) {
            /*obrigatorio passar companyId como filtro */
            return RestangularAuth.all('manager/roles').getList(filters);
        }

        function getById(id) {
            return RestangularAuth.one('manager/roles', id).get();
        }

        function getSuperPermissionsInfo() {
            return RestangularAuth.one('manager/roles/super').get();
        }

        function getSpecificRolePermissionsInfo(id) {
            return RestangularAuth.one('manager/roles', id).get();
        }

        function post(papel) {
            return RestangularAuth.all('manager/roles').post(papel);
        }

        function put(id, papel) {
            return RestangularAuth.one('manager/roles/' + id).customPUT(papel);
        }

        function deleteAll(ids) {
            return RestangularAuth.one('manager/roles', ids).remove();
        }

        return {
            get: get,
            getById: getById,
            getSuperPermissionsInfo: getSuperPermissionsInfo,
            getSpecificRolePermissionsInfo: getSpecificRolePermissionsInfo,
            post: post,
            put: put,
            deleteAll: deleteAll          
        };
    }

    angular
        .module('app.papel')
        .factory('Papel', PapelService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function PapelListController($stateParams, $controller, DashboardCompany, $interval, $rootScope, $scope, Papel, Company, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, Security, Painel) {
        var vm = this;

        var COMPANY = Company.getCompanySelected();
        vm.company = COMPANY;

        //Permissões        
        vm.isPapelCadastrarPermitido = false;
        vm.isPapelEditarPermitido = false;
        vm.isPapelPesquisarPermitido = false;
        vm.isPapelExcluirPermitido = false;
        vm.isPapelVisualizarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isPapelCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Papéis", action: "C" });
            vm.isPapelEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Papéis", action: "U" });
            vm.isPapelPesquisarPermitido = Security.exitsProfilePermission({ id: 3, name: "Papéis", action: "S" });
            vm.isPapelExcluirPermitido = Security.exitsProfilePermission({ id: 4, name: "Papéis", action: "D" });
            vm.isPapelVisualizarPermitido = Security.exitsProfilePermission({ id: 4, name: "Papéis", action: "R" });
        };

        vm.getPapeis = function (filters) {
            vm.isLoading = true;
            filters.companyId = COMPANY.id;
            return Papel.get(filters).then(function (papeis) {
                vm.papeis = papeis;
                vm.isLoading = false;
                return vm.papeis;
            });
        };

        vm.confirmExcluir = function (papel) {
            UIkit.modal.confirm('Deseja realmente excluir o papel ' + papel.name + '?', function () {
                vm.isLoading = true;
                Papel.deleteAll(papel.id).then(function (result) {
                    // if (result) {
                    Common.messageSuccess('Papel', 'D', 'M');
                    // } else {
                    //     Common.mensagemError("Esse item não pode ser excluído.");
                    // }
                    vm.isLoading = false;
                    vm.init();
                }).finally(function () {
                    vm.isLoading = false;
                });
            });

        };

        vm.pesquisar = function (filters) {
            vm.getPapeis(vm.filters);
        };

        vm.getApplications = function (companyKey) {
            return Painel.getCompanyApps(companyKey, true).then(function (applications) {                
                vm.applications = applications;
                vm.selectize_apps_update = vm.applications;
                return vm.applications;
            });
        };
        
        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1)
            ];
        }

        vm.init = function () {
            vm.configurarPermissoes();
            vm.filters = {};
            iniciarComponentes();
            vm.pesquisar(vm.filters);

            vm.companySelected = Company.getCompanySelected();
            vm.companyKey = vm.companySelected.id;

            var companyKey = '';
            DashboardCompany.removerAppSelecionada();
            $rootScope.$broadcast('reload-menu');
            //vm.configureProfiles();
            if (!$stateParams.key) {
                vm.companySelected = Company.getCompanySelected();
                companyKey = vm.companySelected.id;
            } else {
                companyKey = $stateParams.key;
            }
            vm.isLoading = true;
            vm.getApplications(companyKey).then(function (data) {
                vm.isLoading = false;
            });

            $rootScope.$broadcast('reload-menu-app');
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isPapelVisualizarPermitido;
        angular.extend(this, $controller('BaseCompany', {$scope: this})); 
    }

    angular.module('app.papel')
        .controller('PapelListController', PapelListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function PapelDetailController(DashboardCompany, $controller, $interval, $filter, $rootScope, $scope, $stateParams, Papel, Company, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security) { //
        var vm = this;
        vm.operacao = 'Cadastrar';

        var COMPANY = Company.getCompanySelected();
        vm.company = COMPANY;

        //Permissões
        vm.isPapelDeletarPermitido = false;
        vm.isPapelEditarPermitido = false;
        vm.isPapelVisualizarPermitido =false;
        vm.configurarPermissoes = function () {
            vm.isPapelDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Papéis", action: "D" });
            vm.isPapelEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Papéis", action: "U" });
            vm.isPapelVisualizarPermitido = Security.exitsProfilePermission({ id: 4, name: "Papéis", action: "R" });
        };

        vm.getSuper = function (id) {
            return Papel.getSuperPermissionsInfo().then(function (result) {
                //permissoes formatadas da super role para selecao

                //remover funcionalidades que nao sejam super admin mtm - company C14BB58C-9B02-E711-8207-D0509950276C
                if (COMPANY.id.toUpperCase() != 'C14BB58C-9B02-E711-8207-D0509950276C') {
                    result.permissions = _.filter(result.permissions, function (o)
                    { return !o.isSuperAdmin; });
                }

                var result = _.chain(result.permissions)
                    .groupBy("modulo")
                    .pairs()
                    .map(function (currentItem) {
                        return _.object(_.zip(["modulo", "permissions"], currentItem));
                    })
                    .value();
                vm.superPermissions = result;
                return vm.superPermissions;
            });
        };

        vm.getPapel = function (id) {
            return Papel.getById(id).then(function (papel) {
                vm.papel = papel;
                //permissoes formatadas especificas da role, troca-se o id da action fraca pelo id do super
                vm.formatPermissionsSelected(papel.permissions);
                return;
            });
        };

        /* REFATORACAO PARA USO COM DESIGN TABULAR E CHECKBOXES - ESTILO REDMIN */
        vm.formatPermissionsSelected = function (userPermissions) {
            userPermissions.forEach(function (rawElement, index) {
                var checkedActionsCount = 0;
                rawElement.actions.forEach(function (element) {
                    var result = findRealId(rawElement.name, element.description);
                    if (result) {
                        if (result.checked) {
                            checkedActionsCount++;
                        }
                    }
                }, this);
                //Check do fieldset inteiro
                vm.superPermissions.forEach(function (item, index) {
                    var permissionValue = _.find(item.permissions, function (o) { return o.name == rawElement.name });
                    if (permissionValue) {
                        if (permissionValue.actions.length == checkedActionsCount) {
                            permissionValue.checked = true;
                        }
                    }
                }, this);
            }, this);
        };

        function findRealId(permissionName, actionDescription) {
            for (var i = 0; i < vm.superPermissions.length; i++) {
                for (var t = 0; t < vm.superPermissions[i].permissions.length; t++) {
                    for (var j = 0; j < vm.superPermissions[i].permissions[t].actions.length; j++) {
                        if (vm.superPermissions[i].permissions[t].name == permissionName &&
                            vm.superPermissions[i].permissions[t].actions[j].description == actionDescription) {
                            vm.superPermissions[i].permissions[t].actions[j].checked = true;
                            return vm.superPermissions[i].permissions[t].actions[j];
                        }
                    }
                }
            }
        }

        function sendArrayData() {
            for (var i = 0; i < vm.superPermissions.length; i++) {
                for (var t = 0; t < vm.superPermissions[i].permissions.length; t++) {
                    for (var j = 0; j < vm.superPermissions[i].permissions[t].actions.length; j++) {
                        if (vm.superPermissions[i].permissions[t].actions[j].checked) {
                            vm.selectedPermissions.push(vm.superPermissions[i].permissions[t].actions[j].id);
                        }
                    }
                }
            }
            return vm.selectedPermissions;
        }

        vm.batchSelectActions = function (permissionId, isSelect) {
            vm.superPermissions.forEach(function (item, index) {
                var actions = _.find(item.permissions, function (o) { return o.id == permissionId });
                if (actions) {
                    actions.actions.forEach(function (element) {
                        element.checked = isSelect;
                    }, this);
                }
            }, this);
        };
        /* FIM REFATORACAO PARA USO COM DESIGN TABULAR E CHECKBOXES - ESTILO REDMIN */

        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.papel.detail', { id: vm.id });
                } else {
                    $state.go('private.painel.papel.list');
                }
            });
        };

        vm.submit = function (papel) {
            vm.postedPapel = { identityRole: {}, actions: [] };
            vm.postedPapel.identityRole.name = papel.name;
            vm.postedPapel.actions = sendArrayData();
            if (papel) {
                if (papel.id) {
                    vm.putPapel(vm.postedPapel, papel.id);
                } else {
                    vm.postedPapel.identityRole.companyId = COMPANY.id;
                    vm.postPapel(vm.postedPapel);
                }
            }
        };

        vm.postPapel = function (papel) {
            vm.isLoading = true;
            Papel.post(papel).then(function (result) {
                if (result) {
                    if (result.roleId) {
                        Common.messageSuccess('Papel', 'I', 'M');
                        vm.isLoading = false;
                        $state.go('private.painel.papel.list');
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putPapel = function (papel, id) {
            vm.isLoading = true;
            Papel.put(id, papel).then(function (result) {
                if (result) {
                    Common.messageSuccess('Papel', 'A', 'M');
                    vm.isLoading = false;
                    $state.go('private.painel.papel.detail', { id: id });
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        function iniciarComponentes() {
            vm.selectize_permissions = { options: [] };
            vm.selectize_permissions.options = vm.superPermissions;
            vm.selectize_permissions_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                create: false,
                maxItems: null,
                // placeholder: 'Informe as permissões',
                valueField: 'actionId',
                labelField: 'permission',
                searchField: 'permission',
                render: {
                    option: function (apps, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(apps.permission) + '</span>' +
                            '</div>';
                    },
                    item: function (apps, escape) {
                        return '<div class="item">' + escape(apps.permission) + '</div>';
                    }
                }
            };
        }

        vm.init = function () {
            vm.configurarPermissoes();
            vm.isLoading = true;
            vm.isEdicao = false;
            vm.id = $stateParams.id;

            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }
            vm.selectedPermissions = [];
            vm.getSuper().then(function () {
                if (vm.isEdicao) {
                    vm.operacao = 'Editar';
                    vm.getPapel(vm.id).then(function () {
                        iniciarComponentes();

                        $timeout(function () {
                            vm.isLoading = false;
                        }, 1600);

                    });
                } else {
                    iniciarComponentes();

                    $timeout(function () {
                        vm.isLoading = false;
                    }, 1600);
                }
            });
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isPapelVisualizarPermitido;
        angular.extend(this, $controller('BaseCompany', {$scope: this})); 
    }

    angular.module('app.papel')
        .controller('PapelDetailController', PapelDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function PapelCreateController(DashboardCompany, $controller, $filter, $interval, $timeout, $rootScope, $scope, $state, $stateParams, Common, Company, Security, APPLICATION, Papel, Session) {
        var vm = this;
        vm.operacao = 'Cadastrar';

        var COMPANY = Company.getCompanySelected();
        vm.company = COMPANY;

        vm.isPapelDeletarPermitido = false;
        vm.isPapelEditarPermitido = false;
        vm.isPapelVisualizarPermitido =false;
        vm.configurarPermissoes = function () {
            vm.isPapelDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Papéis", action: "D" });
            vm.isPapelEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Papéis", action: "U" });
            vm.isPapelVisualizarPermitido = Security.exitsProfilePermission({ id: 4, name: "Papéis", action: "R" });
            vm.isPapelCadastrarPermitido = Security.exitsProfilePermission({ id: 1, name: "Papéis", action: "C" });
        };
        
        vm.openModalConfirmacaoDeCancelamento = function() {
            var modalConfirmCancelamento = UIkit.modal('.cancelar', {keyboard:false, bgclose:false});
            modalConfirmCancelamento.show();
        }

        vm.getSuper = function (id) {
            return Papel.getSuperPermissionsInfo().then(function (result) {
                //permissoes formatadas da super role para selecao


                //remover funcionalidades que nao sejam super admin mtm - company C14BB58C-9B02-E711-8207-D0509950276C
                if (COMPANY.id.toUpperCase() != 'C14BB58C-9B02-E711-8207-D0509950276C') {
                    result.permissions = _.filter(result.permissions, function (o)
                    { return !o.isSuperAdmin; });
                }

                var result = _.chain(result.permissions)
                    .groupBy("modulo")
                    .pairs()
                    .map(function (currentItem) {
                        return _.object(_.zip(["modulo", "permissions"], currentItem));
                    })
                    .value();
                vm.superPermissions = result;
                return vm.superPermissions;
            });
        };

        vm.getPapel = function (id) {
            return Papel.getById(id).then(function (papel) {
                vm.papel = papel;
                //permissoes formatadas especificas da role, troca-se o id da action fraca pelo id do super
                vm.formatPermissionsSelected(papel.permissions);
                return;
            });
        };

        /* REFATORACAO PARA USO COM DESIGN TABULAR E CHECKBOXES - ESTILO REDMIN */
        vm.formatPermissionsSelected = function (userPermissions) {
            userPermissions.forEach(function (rawElement, index) {
                var checkedActionsCount = 0;
                rawElement.actions.forEach(function (element) {
                    var result = findRealId(rawElement.name, element.description);
                    if (result) {
                        if (result.checked) {
                            checkedActionsCount++;
                        }
                    }
                }, this);
                //Check do fieldset inteiro
                vm.superPermissions.forEach(function (item, index) {
                    var permissionValue = _.find(item.permissions, function (o) { return o.name == rawElement.name });
                    if (permissionValue) {
                        if (permissionValue.actions.length == checkedActionsCount) {
                            permissionValue.checked = true;
                        }
                    }
                }, this);
            }, this);
        };

        function findRealId(permissionName, actionDescription) {
            for (var i = 0; i < vm.superPermissions.length; i++) {
                for (var t = 0; t < vm.superPermissions[i].permissions.length; t++) {
                    for (var j = 0; j < vm.superPermissions[i].permissions[t].actions.length; j++) {
                        if (vm.superPermissions[i].permissions[t].name == permissionName &&
                            vm.superPermissions[i].permissions[t].actions[j].description == actionDescription) {
                            vm.superPermissions[i].permissions[t].actions[j].checked = true;
                            return vm.superPermissions[i].permissions[t].actions[j];
                        }
                    }
                }
            }
        }

        function sendArrayData() {
            for (var i = 0; i < vm.superPermissions.length; i++) {
                for (var t = 0; t < vm.superPermissions[i].permissions.length; t++) {
                    for (var j = 0; j < vm.superPermissions[i].permissions[t].actions.length; j++) {
                        if (vm.superPermissions[i].permissions[t].actions[j].checked) {
                            vm.selectedPermissions.push(vm.superPermissions[i].permissions[t].actions[j].id);
                        }
                    }
                }
            }
            return vm.selectedPermissions;
        }

        vm.batchSelectActions = function (permissionId, isSelect) {
            vm.superPermissions.forEach(function (item, index) {
                var actions = _.find(item.permissions, function (o) { return o.id == permissionId });
                if (actions) {
                    actions.actions.forEach(function (element) {
                        element.checked = isSelect;
                    }, this);
                }
            }, this);
        };
        /* FIM REFATORACAO PARA USO COM DESIGN TABULAR E CHECKBOXES - ESTILO REDMIN */

        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.papel.detail', { id: vm.id });
                } else {
                    $state.go('private.painel.papel.list');
                }
            });
        };

        vm.submit = function (papel) {
            vm.postedPapel = { identityRole: {}, actions: [] };
            vm.postedPapel.identityRole.name = papel.name;
            vm.postedPapel.actions = sendArrayData();
            if (papel) {
                if (papel.id) {
                    vm.putPapel(vm.postedPapel, papel.id);
                } else {
                    vm.postedPapel.identityRole.companyId = COMPANY.id;
                    vm.postPapel(vm.postedPapel);
                }
            }
        };

        vm.postPapel = function (papel) {
            vm.isLoading = true;
            Papel.post(papel).then(function (result) {
                if (result) {
                    if (result.roleId) {
                        Common.messageSuccess('Papel', 'I', 'M');
                        vm.isLoading = false;
                        $state.go('private.painel.papel.list');
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putPapel = function (papel, id) {
            vm.isLoading = true;
            Papel.put(id, papel).then(function (result) {
                if (result) {
                    Common.messageSuccess('Papel', 'A', 'M');
                    vm.isLoading = false;
                    $state.go('private.painel.papel.list.detail', { id: id });
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        function iniciarComponentes() {
            vm.selectize_permissions = { options: [] };
            vm.selectize_permissions.options = vm.superPermissions;
            vm.selectize_permissions_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                create: false,
                maxItems: null,
                // placeholder: 'Informe as permissões',
                valueField: 'actionId',
                labelField: 'permission',
                searchField: 'permission',
                render: {
                    option: function (apps, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(apps.permission) + '</span>' +
                            '</div>';
                    },
                    item: function (apps, escape) {
                        return '<div class="item">' + escape(apps.permission) + '</div>';
                    }
                }
            };
        }

        vm.init = function () {
            vm.isLoading = true;
            vm.isEdicao = false;
            vm.id = $stateParams.id;

            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }
            vm.selectedPermissions = [];
            vm.getSuper().then(function () {
                if (vm.isEdicao) {
                    vm.operacao = 'Editar';
                    vm.getPapel(vm.id).then(function () {
                        iniciarComponentes();

                        $timeout(function () {
                            vm.isLoading = false;
                        }, 1600);

                    });
                } else {
                    iniciarComponentes();

                    $timeout(function () {
                        vm.isLoading = false;
                    }, 1600);
                }
            });
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed =vm.isPapelCadastrarPermitido || vm.isPapelEditarPermitido;
        angular.extend(this, $controller('BaseCompany', {$scope: this})); 
    }

    angular.module('app.papel')
        .controller('PapelCreateController', PapelCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.painel', [])
    .filter('custom_unique', function() {
      return function(collection, selectedKey) {
         var output = [], 
             keys = [];
   
         angular.forEach(collection, function(item) {
            var key = item.id;
            if(!selectedKey || (selectedKey && key !== selectedKey)){
                if(keys.indexOf(key) === -1) {
                    keys.push(key);
                    output.push(item);
                }
            }
         });
   
         return output;
      };
   });;
})();

(function () {
    'use strict';

    /** @ngInject */
    function PainelService(Common, RestangularAuth, APPLICATION, COMPANY, Company, Session, $q) {

        // Utilizar apenas no primeiro request. Salvas os apps na session para utilização das telas subsequentes. 
        // Deve ser chamado apenas na inicialização do painel. Os demais deverão utilizar o: 'getAppList'.
        function resolveApps() {
            // Recupera a companie selecionada para obter os apps dela.
            var companie = Session.getCompanyLocalStorage(COMPANY.companySelected);
            if(companie){
                return Company.getCompanyApps(companie.id, true, false).then(function(applications){
                    // Delete entao salve: Atualiza a session em toda chamada.
                    for(var i = 0; i < applications.length; i++){
                        applications[i] = {
                            id: applications[i].id,
                            name:applications[i].name,
                            app: {
                                id: applications[i].app.id,
                                name: applications[i].app.name
                            },
                            company: {
                                id: applications[i].company.id,
                                name: applications[i].company.name,
                            },
                            appStyle: applications[i].appStyle
                        }
                    }
                    Session.delObjectLocalStorage(APPLICATION.apps);
                    Session.setObjectLocalStorage(APPLICATION.apps, applications);                                            
                    return true;
                }).catch(function(e){
                    return false;
                });
            }
        }

        // Busca na session a lista de apps requisitadas pelo painel. Evita multiplas requisições nas telas de content.
        // $q: Força o retorno como promisse para resolver na chamada da funcao.
        function getCompanyApps() {
            var apps = Session.getObjectLocalStorage(APPLICATION.apps);
            // Se não houver nenhum dado na session chama o resolveApps então vao ser inseridos os devidos apps na session.
            if(!apps){
                return resolveApps().then(function(result){
                    if(result){
                        return $q.when(Session.getObjectLocalStorage(APPLICATION.apps));
                    }
                })
            }
            return $q.when(apps);
        }

        function getSections(appSelecionado) {            
            return [
                {
                    id: '9AD29BDC-ED03-4CA2-AA33-9A6CA5885A8C',
                    title: "Home Geral",
                    icon: "&#xE871;",
                    link: "private.painel.dashboard.geral",
                    isVisible: true,
                    allowCustomize: true,
                    resetApp: true
                },
                {
                    id: 'B2F27857-268A-40DA-B771-8A82E34725D6',
                    title: "Endpoints",
                    icon: "&#xe88a;",
                    link: "private.painel.dashboard.main",
                    isVisible: true,
                    allowCustomize: true,
                    resetApp: true
                },
                {
                    id: '90368DF0-6391-4897-958F-37AEDEAACEF3',
                    title: 'Colaboradores',
                    link: 'private.painel.usuario.list',
                    icon: '&#xE8D3;',
                    isVisible: false,
                    allowCustomize: true,
                    resetApp: true
                },
                {
                    id: 'F8E7C0A7-2051-4732-B65F-B63A34C94CFD',
                    title: "Papéis",
                    link: "private.painel.papel.list",
                    icon: '&#xE32A;',
                    isVisible: false,
                    allowCustomize: true,
                    resetApp: true
                },
    
                {
                    id: 'menuItem',
                    title: appSelecionado ? appSelecionado.name : '',
                    logo: appSelecionado ? '' : '', //primeira condicao: vm.appSelecionado.logoSecondary, removido temporariamente por conta de performance
                    link: '',
                    isVisible: false,
                    visibleOnSelectedAppOnly: true,
                    allowCustomize: true,
                    appInfoMenuDivider: true
                },
    
                {
                    id: '4b7f8e64-b23c-47fc-bd64-6ab0a69cc95f',
                    icon: "&#xE1B1;",
                    title: 'Home App',
                    link: 'private.painel.dashboard.menuapp',
                    isVisible: false,
                    visibleOnSelectedAppOnly: true,
                    allowCustomize: true
                },
    
                {
                    id: '435CD00F-9708-43CA-A7C3-271EF8D30F47',
                    icon: "&#xE8D3;",
                    title: 'Usuários Mobile',
                    link: 'private.painel.cliente.list',
                    isVisible: false,
                    visibleOnSelectedAppOnly: true,
                    allowCustomize: true
                },
    
                {
                    id: -1, 
                    title: 'Atendimento', 
                    icon: '&#xE89C;',
                    isVisible: true, 
                    allowCustomize: true,
                    visibleOnSelectedAppOnly: true,
                    submenu: [
                        {
                            id: '9CFEEDBB-B53A-4C22-9D4B-7B3E2A99E216',
                            title: 'Dashboard',
                            link: "private.painel.dashboard.relacionamento",
                            isVisible: false,
                            visibleOnSelectedAppOnly: true
                        },
                        {
                            id: '24182737-BE77-4EB2-BBB1-55545407594A',
                            title: 'Solicitações',
                            link: "private.painel.attendance.list",
                            isVisible: false,
                            visibleOnSelectedAppOnly: true
                        },
                        {
                            id: '2ACA73DD-82BA-4E6F-8CE9-0F82D50D8695',
                            title: 'Relatórios',
                            link: "",
                            isVisible: false,
                            visibleOnSelectedAppOnly: true,
                            submenu: [
                                {
                                    id: '2ACA73DD-82BA-4E6F-8CE9-0F82D50D8695',
                                    title: "Relatório Analítico",
                                    link: "private.painel.atendimento.list",
                                    isVisible: false,
                                    visibleOnSelectedAppOnly: true
                                },
                                {
                                    id: '2ACA73DD-82BA-4E6F-8CE9-0F82D50D8695',
                                    title: "Relatório Sintético",
                                    link: "private.painel.atendimento.grouplist",
                                    isVisible: false,
                                    visibleOnSelectedAppOnly: true
                                }
                            ]
                        },
                        {
                            id: '7002FB67-3CA4-4B13-9312-C02278E49EAA',
                            title: 'Configurações',
                            link: "",
                            isVisible: false,
                            visibleOnSelectedAppOnly: true,
                            submenu: [
                                {
                                    id: 'E5CC51FF-D8FA-49C6-8DC7-C2350E7A10DA',
                                    title: 'Categorias e Serviços',
                                    link: "private.painel.category.list",
                                    isVisible: true,
                                    visibleOnSelectedAppOnly: true
                                },
                                {
                                    id: '32E0D0BA-0428-4242-9948-367E1A801C28',
                                    title: 'Forms de Atendimento',
                                    link: 'private.painel.attendance.form.list',
                                    isVisible: false,
                                    visibleOnSelectedAppOnly: true
                                },
                                {
                                    id: 'C4E2693B-BEBE-49E2-A350-67A90A14FC6B',
                                    title: 'Situações',
                                    link: "private.painel.situacao.list",
                                    isVisible: false,
                                    visibleOnSelectedAppOnly: true
                                },
                            ]
                        }
                    ]
                },
                {
                    id: 'BB5D88DD-B5E2-4BB9-98B5-DD3D61F0BC1B',
                    title: 'Questionários ',
                    icon: '&#xE7F2;',
                    isVisible: false,
                    visibleOnSelectedAppOnly: true,
                    allowCustomize: true,
                    link: 'private.painel.pesquisa.form.list'
                },
                {
                    id: '2eb6b377-1cae-4290-8f71-203fb4d6c486',
                    title: 'Forms de Coleta ',
                    icon: '&#xE85D;',
                    isVisible: false,
                    visibleOnSelectedAppOnly: true,
                    allowCustomize: true,
                    link: 'private.painel.coleta.form.list'
                },
                {
                    id: -1, 
                    title: 'Mensageria', 
                    icon: '&#xe0c9;', 
                    isVisible: true, 
                    allowCustomize: true, 
                    visibleOnSelectedAppOnly: true,
                    submenu: [
                        {
                            id: 'A718C875-3801-468F-9F36-600C577D064C',
                            title: 'Mensagens',
                            link: "private.painel.mensagem.list",
                            isVisible: false,
                            visibleOnSelectedAppOnly: true
                        },
                        {
                            id: 'A718C875-3801-468F-9F36-600C577D064C',
                            title: 'Log da API',
                            link: "private.painel.mensagemlog.list",
                            isVisible: false,
                            visibleOnSelectedAppOnly: true
                        },
                    ]
                },
                {
                    id: '61C9BCC3-B98E-4CAD-ABFF-1F8CA14D1624',
                    title: 'Forms de Integração ',
                    icon: '&#xE8B8;',
                    isVisible: false,
                    visibleOnSelectedAppOnly: true,
                    allowCustomize: true,
                    link: 'private.painel.integracao.form.list'
                }
            ];
        }

        function init() {}
        init();

        return {
            resolveApps: resolveApps,
            getCompanyApps:getCompanyApps,
            getSections:getSections
        };
    }
    PainelService.$inject = ['Common', 'RestangularAuth', 'APPLICATION', 'COMPANY', 'Company', 'Session', '$q'];
    angular
        .module('app.painel')
        .factory('Painel', PainelService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function PainelController($q, $timeout, $stateParams, $scope, $window, $rootScope, Login, Session, $state, DashboardCompany, Security, Configuracao, Company, APPLICATION, Common, UsuarioAdmin, Painel) {
        var vm = this;
        vm.usuarioLogado = Session.getNomeUsuario();

        //region Template Itens
        angular.element('#menu_top').children('[data-uk-dropdown]').on('show.uk.dropdown', function () {
            $timeout(function () {
                angular.element($window).resize();
            }, 280);
        });
        //endregion
        //region Watchers
        $scope.$on('onLastRepeat', function (scope, element, attrs) {
            $timeout(function () {
                if (!$rootScope.miniSidebarActive) {
                    // activate current section
                    angular.element('#sidebar_main').find('.current_section > a').trigger('click');
                } else {
                    // add tooltips to mini sidebar
                    var tooltip_elem = angular.element('#sidebar_main').find('.menu_tooltip');
                    tooltip_elem.each(function (k, v) {
                        var $that = angular.element(v);

                        $that.attr('title', $that.find('.menu_title').text());
                        // TODO: 'UIkit' is not defined
                        UIkit.tooltip($that, {});
                    });
                }
            });
        });
        
        $rootScope.$on('reload-company', function (event, args) { //ao selecionar app em dashboard.company.controller
            vm.company = Company.getCompanySelected();
            var companyId = vm.company ? vm.company.id: '';
            vm.appSelecionado = DashboardCompany.obterAppSelecionada();
            var appCompanyId = vm.appSelecionado ? vm.appSelecionado.id: '';
            vm.isLoadingApp =true;
            return vm.setPermissions(companyId, appCompanyId).then(function(){
                vm.personalizaMenu(vm.permissions, vm.appSelecionado);
                return Painel.resolveApps().then(function (result) {
                    vm.getApplications().then(function (data) {
                        vm.isLoadingApp =false;
                        $rootScope.modalCompany.hide();
                        if((!vm.appSelecionado && $state.current.name !== 'private.painel.dashboard.geral' && (!args || args && !args.isInit)) || $state.current.name === 'private.painel'){
                            $state.go('private.painel.dashboard.geral');
                        }
                    }).catch(function(){
                        $rootScope.modalCompany.hide();
                    });
                }).catch(function(){
                    $rootScope.modalCompany.hide();
                });
            }).catch(function(){
                $rootScope.modalCompany.hide();
            });
        });

        $rootScope.$on('reload-menu', function (event, toState) { //ao selecionar app em dashboard.company.controller
            vm.appSelecionado = DashboardCompany.obterAppSelecionada();
            var appCompanyId = vm.appSelecionado ? vm.appSelecionado.id: null;
            vm.company = Company.getCompanySelected();
            var companyId = vm.company ? vm.company.id: null;
            return vm.setPermissions(companyId, appCompanyId).then(function(){
                vm.personalizaMenu(vm.permissions, vm.appSelecionado);
            });
        });

        $rootScope.$on('update-appCompany', function(event){
            vm.appSelecionado = DashboardCompany.obterAppSelecionada();
        });
        //endregion
        //region Route Configuration
        vm.acessarRota = function (rota, resetApp) {
            $state.go(rota);
            var appCompany = DashboardCompany.obterAppSelecionada();
            if(resetApp){
                DashboardCompany.removerAppSelecionada();
                vm.appSelecionado = null;
            }
        }
        //endregion
        //region User Configuration and Actions
        vm.getAccountProfile = function () {
            vm.isLoadingModal = true;
            return Login.getAccountProfile(Session.getAccessKey()).then(function (accountInfo) {
                vm.accountInfo = accountInfo;
                vm.isLoadingModal = false;
                return vm.accountInfo;
            });
        };

        vm.submit = function (configuracao) {
            vm.postConfiguracao(configuracao);
        };

        function mapAccountProfile(accountInfo) {
            vm.accountInfoPut = {
                phone: {}
            };
            vm.accountInfoPut.profileId = accountInfo.profiles[0].id;
            vm.accountInfoPut.name = accountInfo.profiles[0].name;
            vm.accountInfoPut.surname = accountInfo.profiles[0].surname;
            vm.accountInfoPut.email = accountInfo.profiles[0].mail;
            vm.accountInfoPut.phone.phoneNumber = accountInfo.profiles[0].phone.phoneNumber;
            return vm.accountInfoPut;
        }

        vm.submitAccountProfile = function (accountInfo) {
            if (accountInfo) {
                vm.putAccountProfile(mapAccountProfile(accountInfo));
            }
        };

        vm.putAccountProfile = function (accountInfo) {
            vm.isLoadingModal = true;
            accountInfo.userClaims = undefined;
            Login.putAccountProfile(Session.getAccessKey(), accountInfo).then(function (result) {
                //if (result && result > 0) {
                //TODO: necessário corrigir gateway - AccountMobileController - linha 137 - retorno incorreto, mesmo sendo sucesso
                Common.messageSuccess('Perfil', 'A', 'M');
                var modal = UIkit.modal("#modal_header_footer_account");
                modal.hide();
                vm.isLoadingModal = false;
                //} else {
                //  Common.mensagemError(result);
                //}
            }).catch(function () {
                vm.isLoadingModal = false;
            });
        };        
        
        vm.submitTrocaSenha = function (user) {
            vm.isLoading = true;
            UsuarioAdmin.changePassword({ OldPassword: user.senhaAtual, NewPassword: user.password, ConfirmPassword: user.password, userId: Session.getAccessKey() }).then(function (result) {
                if (result) {
                    var modal = UIkit.modal("#modal_header_footer_senha");
                    Common.messageSuccess('Senha', 'A', 'F');
                    modal.hide();
                } else {
                    Common.mensagemError(result.data);
                }
            }).finally(function () {
                vm.isLoading = false;
            });
        };

        vm.abrirModalSenha = function () {
            vm.user = undefined;
            vm.formSenha.$setPristine();
            var modal = UIkit.modal("#modal_header_footer_senha");
            modal.show();
        }

        vm.fecharModalSenha = function () {
            var modal = UIkit.modal("#modal_header_footer_senha");
            modal.hide();
        }

        vm.fecharModalAccount = function () {
            var modal = UIkit.modal("#modal_header_footer_account");
            modal.hide();
        }

        function checkPassword(pass) {
            var mask = [/[0-9]/, /[a-z]/, /[A-Z]/, /[^A-Z-0-9]/i];
            if (pass == null)
                return -1;
            var s = 0;
            if (pass.length < 6)
                return 0;
            for (var i in mask)
                if (mask[i].test(pass))
                    s++
            return s * 25;
        }

        vm.calcularForcaSenha = function () {
            if (vm.user && vm.user.password) {
                return checkPassword(vm.user.password);
            }
            return;
        };
        //endregion
        //region Company/AppCompany
        vm.getApplications = function () {
            return Painel.getCompanyApps().then(function (applications) {
                var applicationsPermissions = [];
                var mtAccountPermissions = JSON.parse(localStorage.getItem('mt-account-permissions'));

                if (applications) {
                    for (var j = 0; j < applications.length; j++) {
                        if (mtAccountPermissions) {
                            for (var i = 0; i < mtAccountPermissions.length; i++) {
                                if (
                                    (applications[j] && mtAccountPermissions[i]) &&
                                    ((applications[j].id == mtAccountPermissions[i].appCompanyId) ||
                                        (applications[j].app.id == mtAccountPermissions[i].appCompanyId))
                                ) {
                                    applicationsPermissions.push(applications[j]);
                                    break;
                                }
                            }
                        }
                    }
                }

                
                vm.applications = applicationsPermissions;
                return vm.applications;
            });
        };

        vm.getCompanies = function (userKey) {
            return Company.getCompaniesByUser(userKey).then(function (companies) {
                vm.companies = [];
                companies.forEach(function (element) {
                    if (element && element.role && element.role.company && element.role.company.enable) {
                        vm.companies.push(element.role.company);
                    }
                }, this);

                //necessario para escolha da empresa na copia do form
                $rootScope.userCompanies = vm.companies;
                $rootScope.$broadcast("userCompanies");
            });
        };

        vm.permissions = [];        
        vm.translatePermissions = function (permissions) {
            var listPermissions = [];

            if (permissions) {
                for (var i = 0; i < permissions.length; i++) {
                    listPermissions.push(permissions[i].permissionId);
                }    
            }
                        
            return $q.when(listPermissions);
        };

        vm.personalizaMenu = function (permissionsParam, appSelecionada) {
            vm.isLoadingMenu = true;
            var permissions = [];
            vm.translatePermissions(permissionsParam).then(function (data) {
                vm.sectionsShowed = angular.copy(vm.sections);
                permissions = data;
                var item = undefined;
                //menu base,raiz,pai
                for (var i = 0; i < vm.sections.length; i++) {
                    if (vm.sections[i].allowCustomize) {
                        item = typeof vm.sections[i].id == "string" ? vm.sections[i].id.toLowerCase() : vm.sections[i].id;
                        var index = permissions.indexOf(item);
                        if (index > -1) {
                            if (vm.sections[i].visibleOnSelectedAppOnly) {
                                if (appSelecionada) {
                                    vm.sectionsShowed[i].isVisible = true;
                                }

                            } else {
                                vm.sectionsShowed[i].isVisible = true;
                            }
                        }

                        if (vm.sections[i].visibleOnSelectedAppOnly && appSelecionada && vm.sections[i].appInfoMenuDivider) {
                            vm.sectionsShowed[i].isVisible = true;
                        }

                        //menu submenu
                        if (vm.sections[i].submenu) {
                            var cont = 0;
                            for (var j = 0; j < vm.sections[i].submenu.length; j++) {
                                item = typeof vm.sections[i].submenu[j].id == "string" ? vm.sections[i].submenu[j].id.toLowerCase() : vm.sections[i].submenu[j].id;
                                var index = permissions.indexOf(item);
                                if (index > -1) {


                                    var menuItem = _.find(vm.sections, { submenu: [{ id: permissions[index].toUpperCase() }] });
                                    var menuItemVisibleOnSelectedAppOnlyValue = _.find(menuItem.submenu, function (o) { return o.id.toUpperCase() == permissions[index].toUpperCase() }).visibleOnSelectedAppOnly;
                                    if (menuItemVisibleOnSelectedAppOnlyValue) {
                                        if (appSelecionada) {
                                            vm.sectionsShowed[i].submenu[j].isVisible = true;
                                            cont++;
                                        }
                                    } else {
                                        vm.sectionsShowed[i].submenu[j].isVisible = true;
                                        cont++;
                                    }

                                }
                            }
                            //Verifica submenu vazio. Necessário para remover menu pai quando submenu está vazio.
                            if (cont == 0) {
                                vm.sectionsShowed[i].isVisible = false;
                            }
                        }
                    }
                }

                $timeout(function () {
                    vm.isLoadingMenu = false;
                }, 500);

            });
        };
       
        vm.setPermissions = function(companyId, appCompanyId){
            return Session.getUserAuth().then(function (userAuth) {
                var result = null;
                if(companyId){
                    result = _.find(userAuth.permissions, function (o) { return !o.appCompanyId && o.companyId.toUpperCase() == companyId.toUpperCase() });
                }else if(appCompanyId){
                    result= _.find(userAuth.permissions, function (o) { return o.appCompanyId && o.appCompanyId.toUpperCase() == appSelecionada.id.toUpperCase() });
                } 

                if (result) {
                    vm.permissions = result.permissions;
                } else {
                    vm.permissions = [];
                }
            });
        }
        
        vm.selectCompany = function (companyId, allowReloadAdmin) {
            $rootScope.modalCompany = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_APPCOMPANYS);
            $rootScope.allowReloadAdmin = !!allowReloadAdmin;

            DashboardCompany.removerAppSelecionada();
            vm.appSelecionado = null;

            if (companyId) {
                vm.company = _.find(vm.companies, function (o) { return o.id == companyId });
            }

            Company.setCompanySelected(vm.company);            
            $rootScope.$broadcast('reload-company');
        };

        vm.selectCompanyInit = function (allowReloadAdmin) {            
            $rootScope.modalCompany = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_APPCOMPANYS);
            $rootScope.allowReloadAdmin = !!allowReloadAdmin;

            var company = Company.getCompanySelected();
            var appSelecionada = DashboardCompany.obterAppSelecionada();
            vm.appSelecionado = appSelecionada;            
            vm.company = company ? company : vm.companies[0];
            Company.setCompanySelected(vm.company);
            $rootScope.$broadcast('reload-company', {isInit: true});
            
            return $q.when(vm.company);          
        };

        vm.selectAppCompany = function (app, redirect) {
            $rootScope.modalAppCompany = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_CONFIGAPPCOMPANYS);
            vm.temporaryAppCompanyId = app;
            var tempAppCompany = {};
            for (var i = 0; i < vm.applications.length; i++) {
                if (vm.temporaryAppCompanyId == vm.applications[i].id) {
                    tempAppCompany = vm.applications[i];
                    break;
                }
            }

            DashboardCompany.selecionarApp(tempAppCompany).then(function(){
                $rootScope.$broadcast('reload-menu'); 
                $rootScope.modalAppCompany.hide();
                $state.go('private.painel.dashboard.menuapp');
                $rootScope.$broadcast('set-appCompany');
            }).catch(function(){
                $rootScope.modalAppCompany.hide();
            });
        };  
        //endregion
        //region Inicializadores
        function iniciarComponentes() {
            var companies = vm.companies;
            vm.appCompanies = [];
            vm.applications = [];
            vm.appCompany = {};
            vm.permissions = [];
            vm.company = {};
            vm.isLoadingApp = false;
            vm.selectize_companies_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                create: false,
                sortField: {
                    field: 'name',
                    direction: 'asc'
                },
                render: {
                    option: function (companies, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(companies.name) + '</span>' +
                            '</div>';
                    },
                    item: function (companies, escape) {
                        return '<div class="item">' + escape(companies.name) + '</div>';
                    }
                }
            };
        }

        vm.init = function () {
            vm.sections = Painel.getSections();
            $rootScope.primarySidebarActive = true;
            iniciarComponentes();

            return Session.getUserAuth().then(function (userAuth) {
                if (userAuth && userAuth.accessToken && userAuth.userName && userAuth.permissions) {
                    return vm.getCompanies(userAuth.accessKey).then(function () {
                        if (vm.companies.length) {
                            vm.selectCompanyInit();
                        } else {
                            console.log("usuário não está associado a nenhuma empresa.")                            
                        }
                    });
                } else {
                    $state.go('public.login');
                }
            });
        };

        vm.init();
        //endregion
        
    }


    angular.module('app.painel')
        .controller('PainelController', PainelController);

})();


(function () {
  'use strict';

  angular
    .module('app.messagetemplate', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function MessageTemplateService(Common, Restangular, APPLICATION) {

        function get(filters) {
            return Restangular.all('manager/messenger/api/messagetemplate').getList(filters);
        }

        function deleteAll(ids) {
            return Restangular.one('manager/messenger/api/messagetemplate', ids).remove();
        }

        function getById(id) {
            return Restangular.one('manager/messenger/api/messagetemplate', id).get();
        }

        function post(motivo) {
            return Restangular.all('manager/messenger/api/messagetemplate').post(motivo);
        }

        function getLevelsCombo() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.messageTemplateLevelsPosting);
            return deferred.promise;
        }


        return {
            get: get,
            deleteAll: deleteAll,
            getById: getById,
            post: post,
            getLevelsCombo: getLevelsCombo
        };
    }

    angular
        .module('app.messagetemplate')
        .factory('MessageTemplate', MessageTemplateService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function MessageTemplateListController($interval, $rootScope, $scope, MessageTemplate, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, Security, MessagePriority, Session) {
        var vm = this;

        //Permissões
        vm.isMessageTemplateDeletarPermitido = false;
        vm.isMessageTemplateCadastrarPermitido = false;
        vm.isMessageTemplateEditarPermitido = false;

        vm.configurarPermissoes = function () {
            vm.isMessageTemplateDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagem Padrão", action: "D" });
            vm.isMessageTemplateEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagem Padrão", action: "U" });
            vm.isMessageTemplateCadastrarPermitido = Security.exitsProfilePermission({ id: 3, name: "Mensagem Padrão", action: "C" });
        };


        vm.getMessageTemplates = function (filters) {
            vm.isLoading = true;
            return MessageTemplate.get(filters).then(function (messageTemplates) {
                vm.messageTemplates = messageTemplates;
                /*Perfil ADMIN: poderá ter acesso a todas as mensagens padrões cadastradas.
                Perfil BÁSICO: terá acesso somente às mensagens padrões que foram cadastradas por usuários
                configurados com o perfil básico.
                */
                var isAdmin = !!+Session.getIsAdmin();
                if (!isAdmin) {
                    vm.messageTemplates = _.filter(vm.messageTemplates, function (o) { return !o.userIsAdmin; });
                }
                vm.isLoading = false;
                return vm.messageTemplates;
            });
        };

        vm.getMessagePriorities = function (filters) {
            return MessagePriority.get().then(function (messagePriorities) {
                vm.selectize_priorities = messagePriorities;
                return vm.selectize_priorities;
            });
        };


        vm.carregarFiltros = function () {
            vm.isLoadingFiltros = true;
            vm.getMessagePriorities().then(function () {
                iniciarComponentes();
                vm.isLoadingFiltros = false;
            });
        };

        vm.confirmExcluir = function (messageTemplate) {

            UIkit.modal.confirm('Deseja realmente excluir a Mensagem Padrão ' + messageTemplate.title + '?', function () {
                vm.isLoading = true;
                MessageTemplate.deleteAll(messageTemplate.id).then(function (result) {
                    // if (result) {
                    Common.messageSuccess('Mensagem Padrão', 'D', 'F');
                    // } else {
                    //     Common.mensagemError("Esse item não pode ser excluído.");
                    // }
                    vm.isLoading = false;
                    vm.init();
                }).finally(function () {
                    vm.isLoading = false;
                });
            });

        };

        vm.pesquisar = function (filters) {
            vm.getMessageTemplates(vm.filters);
        };


        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
                DTColumnDefBuilder.newColumnDef(4)


            ];

            vm.selectize_status = APPLICATION.genericStatus;
            var status = vm.selectize_status;
            vm.selectize_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.description) + '</div>';
                    }
                }
            };


            var polos = vm.selectize_priorities;
            vm.selectize_priorities_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (polos, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(polos.description) + '</span>' +
                            '</div>';
                    },
                    item: function (polos, escape) {
                        return '<div class="item">' + escape(polos.description) + '</div>';
                    }
                }
            };


        }

        vm.init = function () {
            vm.configurarPermissoes();
            vm.filters = {};
            vm.carregarFiltros();
            $timeout(function () { //workaround for messed up restangular requests
                vm.pesquisar(vm.filters);                 
            }, 500)
           
        };

        vm.init();
    }

    angular.module('app.messagetemplate')
        .controller('MessageTemplateListController', MessageTemplateListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function MessageTemplateDetailController($interval, $rootScope, $scope, $stateParams, MessageTemplate, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security) { //
        var vm = this;
        vm.id = $stateParams.id;

        //Permissões
        vm.isMessageTemplateDeletarPermitido = false;
        vm.isMessageTemplateEditarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isMessageTemplateDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Mensagem Padrão", action: "D" });
            vm.isMessageTemplateEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Mensagem Padrão", action: "U" });
        };

        vm.getMessageTemplate = function () {
            vm.isLoading = true;
            return MessageTemplate.getById(vm.id).then(function (messageTemplate) {
                vm.messageTemplate = messageTemplate;
                vm.isLoading = false;
                return vm.messageTemplate;
            });
        };

        vm.confirmExcluir = function (messageTemplate) {
            UIkit.modal.confirm('Deseja realmente excluir a Mensagem Padrão ' + messageTemplate.title + '?', function () {
                vm.isLoading = true;
                MessageTemplate.deleteAll(vm.id).then(function (result) {
                    // if (result) {
                    Common.messageSuccess('Mensagem Padrão', 'D', 'F');
                    $state.go('private.painel.messagetemplate.list');
                    // } else {
                    //     Common.mensagemError("Esse item não pode ser excluído.");
                    // }
                    vm.isLoading = false;
                }).finally(function () {
                    vm.isLoading = false;
                });
            });

        };

        vm.init = function () {
            vm.configurarPermissoes();
            vm.getMessageTemplate().then(function () {
                //
            });

        };

        vm.init();
    }

    angular.module('app.messagetemplate')
        .controller('MessageTemplateDetailController', MessageTemplateDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function MessageTemplateCreateController($interval, $rootScope, $scope, $state, $stateParams, Common, MessageTemplate, Security, APPLICATION, MessagePriority, Session) {
        var vm = this;
        vm.operacao = 'Cadastrar';

        vm.getMessageTemplate = function (id) {
            vm.isLoading = true;
            return MessageTemplate.getById(id).then(function (messageTemplate) {
                vm.messageTemplate = messageTemplate;
                vm.isLoading = false;
                return vm.messageTemplate;
            });
        };

        vm.getMessagePriorities = function () {
            return MessagePriority.get({ statusIds: [true] }).then(function (result) {
                vm.selectize_priorities_data = result;
                return vm.selectize_priorities_data;
            });
        };

        vm.carregarFiltros = function () {
            vm.isLoading = true;
            vm.getMessagePriorities().then(function () {
                if (vm.isEdicao) {
                    //if message priority has been deactivated, then deassociate with template
                    if (!_.find(vm.selectize_priorities_data, function (o) { return o.id == vm.messageTemplate.messagePriority.id })) {
                        vm.messageTemplate.messagePriority = {};
                    }
                }
                iniciarComponentes();
                vm.isLoading = false;
            });
        };


        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.messagetemplate.detail', { id: vm.id });
                } else {
                    $state.go('private.painel.messagetemplate.list');
                }
            });
        };

        vm.submit = function (messageTemplate) {
            if (messageTemplate) {                
                if (messageTemplate.id) {
                    vm.putMessageTemplate(messageTemplate);
                } else {
                    vm.postMessageTemplate(messageTemplate);
                }
            }
        };

        vm.postMessageTemplate = function (messageTemplate) {
            vm.isLoading = true;
            messageTemplate.userId = Session.getAccessKey();
            messageTemplate.userProfileId = Session.getRole();
            messageTemplate.userIsAdmin = !!+Session.getIsAdmin();

            MessageTemplate.post(messageTemplate).then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Mensagem Padrão', 'I', 'F');
                        vm.isLoading = false;
                        $state.go('private.painel.messagetemplate.list');
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putMessageTemplate = function (messageTemplate) {
            vm.isLoading = true;
            messageTemplate.put().then(function (result) {
                if (result && result > 0) {
                    Common.messageSuccess('Mensagem Padrão', 'A', 'F');
                    vm.isLoading = false;
                    $state.go('private.painel.messagetemplate.detail', { id: messageTemplate.id });
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        function iniciarComponentes() {

            vm.selectize_priorities = { options: [] };
            vm.selectize_priorities.options = vm.selectize_priorities_data;
            vm.selectize_priorities_config = {
                create: false,
                maxItems: 1,
                placeholder: '',
                valueField: 'id',
                labelField: 'description',
                searchField: 'description'
            };
        }

        vm.init = function () {
            vm.isEdicao = false;
            vm.id = $stateParams.id;

            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
            }

            vm.carregarFiltros();

            if (vm.isEdicao) {
                vm.operacao = 'Editar';
                vm.getMessageTemplate(vm.id).then(function () {
                    vm.carregarFiltros();
                });
            }



        };

        vm.init();
    }

    angular.module('app.messagetemplate')
        .controller('MessageTemplateCreateController', MessageTemplateCreateController);

})();

(function () {
  'use strict';

  angular
    .module('app.messagepriority', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function MessagePriorityService(Common, Restangular, APPLICATION) {

        function get(filters) {
            return Restangular.all('manager/messenger/api/messagepriority').getList(filters);
        }

        function deleteAll(ids) {
            return Restangular.one('manager/messenger/api/messagepriority', ids).remove();
        }

        function getById(id) {
            return Restangular.one('manager/messenger/api/messagepriority', id).get();
        }

        function post(motivo) {
            return Restangular.all('manager/messenger/api/messagepriority').post(motivo);
        }

        function getLevelsCombo() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.messagePriorityLevelsPosting);
            return deferred.promise;
        }


        return {
            get: get,
            deleteAll: deleteAll,
            getById: getById,
            post: post,
            getLevelsCombo: getLevelsCombo
        };
    }

    angular
        .module('app.messagepriority')
        .factory('MessagePriority', MessagePriorityService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function MessagePriorityListController($interval, $rootScope, $scope, MessagePriority, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, Security) {
        var vm = this;

        //Permissões
        vm.isMessagePriorityDeletarPermitido = false;
        vm.isMessagePriorityCadastrarPermitido = false;
        vm.isMessagePriorityEditarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isMessagePriorityDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Prioridade da Mensagem", action: "D" });
            vm.isMessagePriorityEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Prioridade da Mensagem", action: "U" });
            vm.isMessagePriorityCadastrarPermitido = Security.exitsProfilePermission({ id: 3, name: "Prioridade da Mensagem", action: "C" });
        };


        vm.getMessagePriorities = function (filters) {
            vm.isLoading = true;
            return MessagePriority.get(filters).then(function (messagePriorities) {
                vm.messagePriorities = messagePriorities;
                vm.isLoading = false;
                return vm.messagePriorities;
            });
        };



        vm.confirmExcluir = function (messagePriority) {

            UIkit.modal.confirm('Deseja realmente excluir a Prioridade da Mensagem ' + messagePriority.description + '?', function () {
                vm.isLoading = true;
                MessagePriority.deleteAll(messagePriority.id).then(function (result) {
                    // if (result) {
                    Common.messageSuccess('Prioridade da Mensagem', 'D', 'F');
                    // } else {
                    //     Common.mensagemError("Esse item não pode ser excluído.");
                    // }
                    vm.isLoading = false;
                    vm.init();
                }).finally(function () {
                    vm.isLoading = false;
                });
            });

        };

        vm.pesquisar = function (filters) {
            vm.getMessagePriorities(vm.filters);
        };


        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
                DTColumnDefBuilder.newColumnDef(4),
                DTColumnDefBuilder.newColumnDef(5)

            ];

            vm.selectize_status = APPLICATION.genericStatus;
            var status = vm.selectize_status;
            vm.selectize_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.description) + '</div>';
                    }
                }
            };

            vm.selectize_bool_status = APPLICATION.genericBool;
            var bool_status = vm.selectize_bool_status;
            vm.selectize_bool_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.description) + '</div>';
                    }
                }
            };

            vm.selectize_priorities = APPLICATION.messagePriorityLevelsFiltering;
            var priorities = vm.selectize_priorities;
            vm.selectize_priorities_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: "Todos",
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="item">' + escape(status.description) + '</div>';
                    }
                }
            };


        }

        vm.init = function () {
            vm.configurarPermissoes();
            vm.filters = {};
            iniciarComponentes();
            vm.pesquisar(vm.filters);
        };

        vm.init();
    }

    angular.module('app.messagepriority')
        .controller('MessagePriorityListController', MessagePriorityListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function MessagePriorityDetailController($interval, $rootScope, $scope, $stateParams, MessagePriority, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security) { //
        var vm = this;
        vm.id = $stateParams.id;

        //Permissões
        vm.isMessagePriorityDeletarPermitido = false;
        vm.isMessagePriorityEditarPermitido = false;
        vm.configurarPermissoes = function () {
            vm.isMessagePriorityDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Prioridade da Mensagem", action: "D" });
            vm.isMessagePriorityEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Prioridade da Mensagem", action: "U" });
        };

        vm.getMessagePriority = function () {
            vm.isLoading = true;
            return MessagePriority.getById(vm.id).then(function (messagePriority) {
                vm.messagePriority = messagePriority;
                vm.isLoading = false;
                return vm.messagePriority;
            });
        };

        vm.confirmExcluir = function (messagePriority) {
            UIkit.modal.confirm('Deseja realmente excluir a Prioridade da Mensagem ' + messagePriority.description + '?', function () {
                vm.isLoading = true;
                MessagePriority.deleteAll(vm.id).then(function (result) {
                    // if (result) {
                    Common.messageSuccess('Prioridade da Mensagem', 'D', 'F');
                    $state.go('private.painel.messagepriority.list');
                    // } else {
                    //     Common.mensagemError("Esse item não pode ser excluído.");
                    // }
                    vm.isLoading = false;
                }).finally(function () {
                    vm.isLoading = false;
                });
            });

        };

        vm.init = function () {
            vm.configurarPermissoes();
            vm.getMessagePriority().then(function () {

            });

        };

        vm.init();
    }

    angular.module('app.messagepriority')
        .controller('MessagePriorityDetailController', MessagePriorityDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function MessagePriorityCreateController($interval, $rootScope, $scope, $state, $stateParams, Common, MessagePriority, Security, APPLICATION) {
        var vm = this;
        vm.operacao = 'Cadastrar';

        vm.getMessagePriority = function (id) {
            vm.isLoading = true;
            return MessagePriority.getById(id).then(function (messagePriority) {
                vm.messagePriority = messagePriority;
                vm.isLoading = false;
                return vm.messagePriority;
            });
        };

        vm.getLevels = function () {
            return MessagePriority.getLevelsCombo().then(function (result) {
                vm.selectize_priorities_data = result;
                return vm.selectize_priorities_data;
            });
        };

        vm.carregarFiltros = function () {
            vm.isLoading = true;
            vm.getLevels().then(function () {
                iniciarComponentes();
                vm.isLoading = false;
            });
        };


        vm.cancelar = function () {
            UIkit.modal.confirm('Deseja realmente cancelar?', function () {
                if (vm.id) {
                    $state.go('private.painel.messagepriority.detail', { id: vm.id });
                } else {
                    $state.go('private.painel.messagepriority.list');
                }
            });
        };

        vm.submit = function (messagePriority) {
            if (messagePriority) {
                if (messagePriority.id) {
                    vm.putMessagePriority(messagePriority);
                } else {
                    vm.postMessagePriority(messagePriority);
                }
            }
        };

        vm.postMessagePriority = function (messagePriority) {
            vm.isLoading = true;
            MessagePriority.post(messagePriority).then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Prioridade da Mensagem', 'I', 'F');
                        vm.isLoading = false;
                        $state.go('private.painel.messagepriority.list');
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putMessagePriority = function (messagePriority) {
            vm.isLoading = true;
            messagePriority.put().then(function (result) {
                if (result && result > 0) {
                    Common.messageSuccess('Prioridade da Mensagem', 'A', 'F');
                    vm.isLoading = false;
                    $state.go('private.painel.messagepriority.detail', { id: messagePriority.id });
                } else {
                    Common.mensagemError(result);
                }
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        function iniciarComponentes() {

            vm.selectize_priorities = { options: [] };
            vm.selectize_priorities.options = vm.selectize_priorities_data;
            vm.selectize_priorities_config = {
                create: false,
                maxItems: 1,
                placeholder: '',
                valueField: 'id',
                labelField: 'description',
                searchField: 'description'
            };
        }

        vm.init = function () {

            vm.carregarFiltros();

            vm.isEdicao = false;
            vm.id = $stateParams.id;

            if (vm.id) {
                vm.isEdicao = true;
            } else {
                vm.isEdicao = false;
                vm.messagePriority = { level: 'Crítico', isTopCritical: true };
            }

            if (vm.isEdicao) {
                vm.operacao = 'Editar';
                vm.getMessagePriority(vm.id).then(function () {
                    vm.carregarFiltros();
                });
            }



        };

        vm.init();
    }

    angular.module('app.messagepriority')
        .controller('MessagePriorityCreateController', MessagePriorityCreateController);

})();

(function () {
    'use strict';



    /** @ngInject */
    function MainController($rootScope, $state, AUTH_EVENTS, Session) {
        var vm = this;

        // var lstnrClb1 = $rootScope.$on(AUTH_EVENTS.notAuthenticated, function() {
        //     Session.destroy();
        //     $state.go('public.login');
        // });

        var lstnrClb2 = $rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
            Session.destroy();
            $state.go('public.login');
        });

        var lstnrClb3 = $rootScope.$on(AUTH_EVENTS.alreadyAuthenticated, function () {

            var permissions = Session.getPermissions();

            //for (var i = 0; i < permissions.length; i++) {
            //if (permissions[i].permissionId === 3) { // Usuário possui acesso ao dashboard
            $state.go('private.painel.attendance');
            //    return;
            //}
            //}
        });

        var lstnrClb4 = $rootScope.$on(AUTH_EVENTS.logoutSuccess, function () {
            Session.destroy();
            $state.go('public.login');
        });

        $rootScope.$on('$destroy', function () {
            [
                // lstnrClb1,
                lstnrClb2,
                lstnrClb3,
                lstnrClb4
            ].forEach(function (fn) {
                fn();
            });
        });

        // vm.awesomeThings = [];
        // vm.classAnimation = '';
        // vm.creationDate = 1453399779957;
        // vm.showToastr = showToastr;

        // activate();

        // function activate() {
        //   getWebDevTec();
        //   $timeout(function() {
        //     vm.classAnimation = 'rubberBand';
        //   }, 4000);
        // }

        // function showToastr() {
        //   toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
        //   vm.classAnimation = '';
        // }

        // function getWebDevTec() {
        //   vm.awesomeThings = webDevTec.getTec();

        //   angular.forEach(vm.awesomeThings, function(awesomeThing) {
        //     awesomeThing.rank = Math.random();
        //   });
        // }
    }

    angular
        .module('app')
        .controller('MainController', MainController);

})();

(function () {
  'use strict';

  function runModule($http, $rootScope, $state, $window, Auth, AUTH_EVENTS) {
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      var authorizedRoles = toState && toState.data ? toState.data.authorizedRoles : null;
      $rootScope.allowReloadAdmin = true;
      // if (!Auth.isAuthorized(authorizedRoles)) {
      //   event.preventDefault();
      //   if (Auth.isAuthenticated()) {
      //     $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
      //   }
      //} else {



      if (Auth.isAuthenticated()) { //Auth.isAuthorized(authorizedRoles) && 
        if (['public.login', 'public.esqueceusenha', 'public.recuperarsenha'].indexOf(toState.name) > -1) {
          //$rootScope.$broadcast(AUTH_EVENTS.alreadyAuthenticated);
          if (!fromState.abstract) {
            event.preventDefault();
            $state.go(fromState.name);
          }
        } else {
          if (fromState.abstract) {
            //event.preventDefault();
            //$state.go(toState.name);
            $rootScope.allowReloadAdmin = false; //nao permite atualizar pagina
          }
          $rootScope.allowReloadAdminLogin = fromState.name == 'public.login' && fromState.abstract == undefined ? true : false; //login apenas
        }
      }
      //}
    });

  }

  runModule.$inject = ['$http', '$rootScope', '$state', '$window', 'Auth', 'AUTH_EVENTS'];

  //   function configHttpProvider($httpProvider, SECURITY) {

  //     $httpProvider.interceptors.push(['$injector', function ($injector) {
  //       return $injector.get('AuthInterceptor');
  //     }]);

  //     $httpProvider.interceptors.push(function () {
  //       return {
  //         request: function (config) {

  //           var accessToken = sessionStorage.getItem(SECURITY.accessToken);
  //           var accessKey = sessionStorage.getItem(SECURITY.accessKey);

  //           if (config.headers.Accept.indexOf('application/json') > -1 && accessToken) {
  //             config.headers.Authorization = 'Bearer ' + accessToken;
  //             config.headers.AccessKey = accessKey;
  //           }
  //           return config;
  //         },
  //         response: function (response) {
  //           return response;
  //         }
  //       };
  //     });
  //   }

  angular
    .module('app.login', ['app.constants'])
    .constant('AUTH_EVENTS', {
      loginSuccess: 'auth-login-success',
      loginFailed: 'auth-login-failed',
      logoutSuccess: 'auth-logout-success',
      sessionTimeout: 'auth-session-timeout',
      notAuthenticated: 'auth-not-authenticated',
      notAuthorized: 'auth-not-authorized',
      alreadyAuthenticated: 'already-authenticated'
    })
    .constant('USER_ROLES', {
      all: '*',
      admin: 'ADMIN',
      guest: 'guest'
    })
    .run(runModule)
  // .config(configHttpProvider);
})();

/**
 * Created by caeta on 16/08/2016.
 */
(function() {
    'use strict';

    function ChangeTemporaryPasswordCtrl($rootScope, $state, Common, Login, $http, $stateParams ) {
        var vm = this;
        vm.submit = function(model) {
            vm.isLoading = true;
            var md = {
                UserId: $state.params.userId,
                Token: $state.params.codeRecoverPassword,
                Code: $state.params.code,
                NewPassword: model.password,
                ConfirmPassword: model.confirmPassword
            }
            var regexNumber = new RegExp("[0-9]");
            var regexUpperChars = new RegExp("[A-Z]");
            var regexNormalChars = new RegExp("[a-z]");
            if(!(regexNumber.test(md.NewPassword) && regexUpperChars.test(md.NewPassword) && regexNormalChars.test(md.NewPassword))){
                Common.mensagemError("A senha deve ser alfanumérica de no mínimo seis dígitos com pelo menos um caractere maiúsculo e minúsculo.");
                vm.isLoading =false;
            }else {
                Login.changeTemporaryPassword(md).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Senha', 'A', 'F');
                        $state.go('public.login');
                    }
                    else {
                        Common.error(result);
                    }
                })
                vm.isLoading = false;
            }
        };

        vm.init = function() {
        };

        vm.init();

    }

    ChangeTemporaryPasswordCtrl.$inject = ['$rootScope', '$state', 'Common', 'Login', '$stateParams', '$http'];

    angular.module('app.login')
        .controller('ChangeTemporaryPasswordCtrl', ChangeTemporaryPasswordCtrl);
})();

(function () {
    'use strict';

    function SessionService($q, APPLICATION, COMPANY, SECURITY) {
        //Sobrecarga dos métodos setObj e getObj
        Storage.prototype.setObj = function (key, obj) {
            return this.setItem(key, JSON.stringify(obj));
        };

        Storage.prototype.getObj = function (key) {
            return JSON.parse(this.getItem(key));
        };

        // this.create = function (token, nomeUsuario, userRole, permissions, companyKey, accessKey) {
        this.create = function (token, nomeUsuario, userRole, permissions, accessKey, refreshToken, accountUserEmail, accountUserCompany, accountIsAdmin, accountCrm) {
            this.nomeUsuario = nomeUsuario;
            this.userRole = userRole;
            this.token = token;
            localStorage.setItem(SECURITY.accessToken, token);
            localStorage.setItem(SECURITY.refreshToken, refreshToken);
            localStorage.setItem(SECURITY.accountUserName, nomeUsuario);
            localStorage.setItem(SECURITY.accountRole, userRole);
            localStorage.setObj(SECURITY.accountPermissions, permissions);
            //localStorage.setItem(COMPANY.companySelected, companyKey); 
            localStorage.setItem(SECURITY.accessKey, accessKey);
            localStorage.setItem(SECURITY.accountUserEmail, accountUserEmail);
            localStorage.setItem(SECURITY.accountUserCompany, accountUserCompany);
            localStorage.setItem(SECURITY.accountIsAdmin, accountIsAdmin);
            localStorage.setItem(SECURITY.accountCrm, accountCrm);

        };

        this.refresh = function (token, refreshToken) {
            localStorage.setItem(SECURITY.accessToken, token);
            localStorage.setItem(SECURITY.refreshToken, refreshToken);
        };

        this.destroy = function () {
            this.nomeUsuario = null;
            this.userRole = null;
            this.token = null;
            this.typeAutorization = null;
            this.permissions = null;

            localStorage.removeItem(SECURITY.accessToken);
            localStorage.removeItem(SECURITY.refreshToken);
            localStorage.removeItem(SECURITY.accessKey);
            localStorage.removeItem(SECURITY.accountUserName);
            localStorage.removeItem(SECURITY.accountRole);
            localStorage.removeItem(SECURITY.accountPermissions);
            localStorage.removeItem(SECURITY.autorizationResponse);            

            localStorage.removeItem(APPLICATION.apps);
            localStorage.removeItem(APPLICATION.applicationSelected);
            localStorage.removeItem(COMPANY.companySelected);
            localStorage.removeItem(SECURITY.accessKey);

            localStorage.removeItem(SECURITY.accountUserEmail);
            localStorage.removeItem(SECURITY.accountUserCompany);
            localStorage.removeItem(SECURITY.accountIsAdmin); 
            localStorage.removeItem(SECURITY.accountCrm);           
            localStorage.removeItem('access-token-user-manager');
            localStorage.removeItem('debug');            
        };

        this.restore = function () {
            if (!this.nomeUsuario &&
                !this.userRole &&
                !this.token &&
                !this.typeAutorization &&
                !this.permissions &&
                localStorage.getItem(SECURITY.accessToken) &&
                localStorage.getItem(SECURITY.accountUserName) &&
                localStorage.getItem(SECURITY.accountRole) &&
                localStorage.getObj(SECURITY.accountPermissions)
            ) {

                this.create(
                    localStorage.getItem(SECURITY.accessToken),
                    localStorage.getItem(SECURITY.accountUserName),
                    localStorage.getItem(SECURITY.accountRole),
                    localStorage.getObj(SECURITY.accountPermissions),
                    localStorage.getItem(SECURITY.accessKey),
                    localStorage.getItem(SECURITY.refreshToken),
                    localStorage.getItem(SECURITY.accountUserEmail),
                    localStorage.getItem(SECURITY.accountUserCompany),
                    localStorage.getItem(SECURITY.accountIsAdmin),
                    localStorage.getItem(SECURITY.accountCrm)                    
                );
            }
        };

        this.getAccessKey = function () {
            return localStorage.getItem(SECURITY.accessKey);
        };

        this.getNomeUsuario = function () {
            var usuario = localStorage.getItem(SECURITY.accountUserName);
            return usuario;
        };

        this.getToken = function () {
            return localStorage.getItem(SECURITY.accessToken);
        };

        this.getRefreshToken = function () {
            return localStorage.getItem(SECURITY.refreshToken);
        };


        this.getPermissions = function () {
            return localStorage.getObj(SECURITY.accountPermissions); // localStorage.getItem(SECURITY.accountPermissions);
        };

        this.getEmailUsuario = function () {
            var usuario = localStorage.getItem(SECURITY.accountUserEmail);
            return usuario;
        };

        this.getCompanyKey = function () { //user company key. Not in use
            return localStorage.getItem(SECURITY.accountUserCompany);
        };

        this.getIsAdmin = function () {
            return localStorage.getItem(SECURITY.accountIsAdmin);
        };

        this.getRole = function () {
            return localStorage.getItem(SECURITY.accountRole);
        };

        this.getCrm = function () {
            return localStorage.getItem(SECURITY.accountCrm);
        };

        this.getUserAuth = function () {

            var userAuth = {
                accessKey: this.getAccessKey(),
                accessToken: this.getToken(),
                refreshToken: this.getRefreshToken(),
                userName: this.getNomeUsuario(),
                permissions: this.getPermissions(),
                userEmail: this.getEmailUsuario(),
                userCompany: this.getCompanyKey(),
                accountIsAdmin: this.getIsAdmin(),
                accountRole: this.getRole(),
                accountCrm: this.getCrm()
            };

            return $q.when(userAuth);
        };

        this.setLocalStorage = function (key, value) {
            localStorage.setItem(key, value);
        };

        this.setLocalStorage = function (key, value) {
            localStorage.setItem(key, value);
        };

        this.getLocalStorage = function (key) {
            return localStorage.getItem(key);
        };

        this.getLocalStorage = function (key) {
            return localStorage.getItem(key);
        };

        this.setObjectLocalStorage = function (key, value) {
            localStorage.setItem(key, JSON.stringify(value));
        };

        function isJson(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        }
        this.getCompanyLocalStorage = function (key) {
            var item = localStorage.getItem(key);
            if (item != null && typeof (item) == 'string') {
                if (isJson(item))
                    return JSON.parse(item);
                return item;
                //
            };
        };

        this.getObjectLocalStorage = function (key) {
            return JSON.parse(localStorage.getItem(key));
        };

        this.delObjectLocalStorage = function (key) {
            localStorage.removeItem(key);
        };

        this.isUserAuth = function () {
            // var isAuth = false;
            // this.getUserAuth().then(function (user) {
            //     debugger;
            //     if (user) {
            //         if (user.accessKey) { //&& user.permissions.length
            //             isAuth = true;
            //         }
            //     }
            //     return isAuth;
            // }).finally(function (user) {
            //     return isAuth;
            // });
            return this.getAccessKey() ? true : false;
        };

        return this;
    }

    angular
        .module('app.login')
        .service('Session', SessionService);

})();

(function() {
    'use strict';

    function RecuperarSenhaCtrl($rootScope, $state, Common, Login, $location) {
        var vm = this;

        // function isMobile() {
        //     var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        //     if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        //         return true;

        //     }
        //     else if (userAgent.match(/Android/i)) {

        //         return true;
        //     }
        //     else {
        //         return false;
        //     }
        // }        


        vm.userId = $location.search().CodigoNovaSenha;
        vm.idCliente = $location.search().CodigoNovaSenhaMobile;

        vm.isRecoverProcessValid = true;

        vm.submit = function(user) {

            if (vm.idCliente) {
                vm.isLoading = true;
                Login.updatePasswordCliente({ senha: user.password, codigoNovaSenhaMobile: vm.idCliente }).then(function(result) {
                    if (result) {
                        Common.messageSuccess('Senha', 'A', 'F');
                        $state.go('public.login');
                    } else {
                        Common.mensagemError(result.data);
                    }
                }).finally(function() {
                    vm.isLoading = false;
                });

            } else {
                vm.isLoading = true;
                Login.updatePassword({ senha: user.password, codigoNovaSenha: vm.userId }).then(function(result) {
                    if (result) {
                        Common.messageSuccess('Senha', 'A', 'F');
                        $state.go('public.login');
                    } else {
                        Common.mensagemError(result.data);
                    }
                }).finally(function() {
                    vm.isLoading = false;
                });
            }

        };


        vm.init = function() {
            vm.isLoading = true;
            if (vm.idCliente) {
                Login.verifyExpirationLimitForPasswordChangeCliente(vm.idCliente).then(function(result) {                  
                    if (result) {
                        vm.isRecoverProcessValid = true;
                    } else {
                        vm.isRecoverProcessValid = false;
                    }
                }).catch(function() {
                    vm.isRecoverProcessValid = false;
                    vm.isLoading = false;
                }).finally(function() {
                    vm.isLoading = false;
                });
            }
            else {
                Login.verifyExpirationLimitForPasswordChange(vm.userId).then(function(result) {
                    vm.isLoading = true;
                    if (result) {
                        vm.isRecoverProcessValid = true;
                    } else {
                        vm.isRecoverProcessValid = false;
                    }

                }).catch(function() {
                    vm.isRecoverProcessValid = false;
                    vm.isLoading = false;
                }).finally(function() {
                    vm.isLoading = false;
                });
            }
        };

        vm.init();

    }

    RecuperarSenhaCtrl.$inject = ['$rootScope', '$state', 'Common', 'Login', '$location'];

    angular.module('app.login')
        .controller('RecuperarSenhaCtrl', RecuperarSenhaCtrl);
})();


(function () {
    'use strict';

    function LoginService(Common, Restangular, RestangularAuth, Session, $http, $q, APPLICATION, $rootScope) {

        function authentication(user) {
            Session.delObjectLocalStorage(APPLICATION.applicationSelected);
            Restangular.setDefaultHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
            $rootScope.lastCodeRequest = null;

            return Restangular
                .all('mobile/account/auth')
                .post('grant_type=password&username=' + user.username + '&password=' + user.password,
                undefined, { 'Content-Type': 'application/x-www-form-urlencoded' });

        }

        function refreshToken(refreshToken) {
            return Restangular.all('token').post(
                [
                    'grant_type=refresh_token',
                    'refresh_token=' + refreshToken,
                    'client_id=' + APPLICATION.clientId
                    // 'client_secret=' + CONFIG.clientSecret
                ].join('&'), {}, { 'Content-Type': 'application/x-www-form-urlencoded' });
        }

        function forgotPassword(mail) {
            return Restangular.all('manager/account/RecoverPassword').post({ email: mail, name: '' });
        }

        function verifyExpirationLimitForPasswordChange(changeKey) {
            return Restangular.one('usuarios/verificarExpiracao/' + changeKey).get();
        }

        function verifyExpirationLimitForPasswordChangeCliente(changeKey) {
            return Restangular.one('clientes/verificarExpiracao/' + changeKey).get();
        }

        function updatePassword(passwordData) {
            return Restangular.one('usuarios/esqueceusenha').customPUT(passwordData);
        }

        function updatePasswordCliente(passwordData) {
            return Restangular.one('clientes/esqueceusenha').customPUT(passwordData);
        }

        function ativar(id) {
            return Restangular.one('clientes/verificar/' + id).get();
        }

        function changeTemporaryPassword(model) {
            return Restangular.all('manager/account/changeTemporaryPassword').post(model);
        }

        function getProfiles(roleIds) {
            var token = Session && Session.getToken() ? Session.getToken() : null;

            RestangularAuth.setDefaultHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + token
            });

            var rolesDistinct = [];
            $.each(roleIds.profileIds, function(index, value) {
                if ($.inArray(value, rolesDistinct) === -1) {
                    rolesDistinct.push(value);
                }
            });
            roleIds.profileIds = rolesDistinct;

            return RestangularAuth.all('manager/account/permission/userpermissions').getList(roleIds);
        }

        function getAccountProfile(userId) {
            var token = Session && Session.getToken() ? Session.getToken() : null;
            RestangularAuth.setDefaultHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + token
            });

            return RestangularAuth.one('manager/account/' + userId).get();
        }

        function putAccountProfile(userId, accountInfo) {
            // return Restangular.one('manager/account/' + userId).customPUT(accountInfo);

            return Restangular.one('mobile/account/' + userId).customPUT(accountInfo,
                undefined, undefined, { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + localStorage.getItem('mt-access-token') });
        }

        function forgotLogin(user) {
            return Restangular.all('manager/account/recoverLogin').post(user, { 'Content-Type': 'application/json'});
        }

        var service = {
            authentication: authentication,
            refreshToken: refreshToken,
            forgotPassword: forgotPassword,
            verifyExpirationLimitForPasswordChange: verifyExpirationLimitForPasswordChange,
            verifyExpirationLimitForPasswordChangeCliente: verifyExpirationLimitForPasswordChangeCliente,
            updatePassword: updatePassword,
            updatePasswordCliente: updatePasswordCliente,
            ativar: ativar,
            changeTemporaryPassword: changeTemporaryPassword,
            getProfiles: getProfiles,
            getAccountProfile: getAccountProfile,
            putAccountProfile: putAccountProfile,
            forgotLogin: forgotLogin
        };

        return service;
    }

    LoginService.$inject = ['Common', 'Restangular', 'RestangularAuth', 'Session', '$http', '$q', 'APPLICATION', '$rootScope'];

    angular
        .module('app.login')
        .factory('Login', LoginService);
})();

(function () {
    'use strict';

    function LoginCtrl($rootScope, $state, Auth, AUTH_EVENTS, Common, Idle, APPLICATION, CustomModal, Session, DashboardCompany) {
        var vm = this;

        vm.appVersion = webVersion;

        vm.submit = function (user) {
            var modal = UIkit.modal.blockUI('<div class=\'uk-text-center\'>Aguarde...<br/><img class=\'uk-margin-top\' src=\'assets/img/spinners/spinner.gif\' alt=\'\'>');
            Auth.login(user).then(function (user) {
                modal.hide();
                if (user) { //&& (user.accountIsAdmin == 1 || user.accountIsAdmin == '1')) {
                    //Idle.watch();
                    //encontrarRotaInicial(user);    

                    // $state.go('private.painel.dashboard.main');
                    //DashboardCompany.removerAppSelecionada();
                    //DashboardCompany.removerAppSelecionada();
                    // $rootScope.$broadcast('reload-menu');
                    $state.go('private.painel'); //para ativar o metodo do painel primeiro, antes do dashboard

                } else {
                    Common.mensagemError('Este usuário não é um usuário Web.');
                    $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
                }
            }).catch(function (errors) {
                modal.hide();
            });
        };

        function encontrarRotaInicial(user) {
            for (var i = 0; i < user.permissions.length; i++) {
                if (user.permissions[i].funcionalidadeInicial) {
                    var state = traduzirRota(user.permissions[i].name);
                    $state.go(state);
                }
            }
        };

        function traduzirRota(tela) {
            switch (tela) {
                case 'Mensagem Padrão':
                    return "private.painel.messagetemplate.list";
                case 'Relatorio Mensagens':
                    return "private.painel.relatorio";
                case 'Prioridade da Mensagem':
                    return "private.painel.messagepriority.list";
                default:
                    return "private.painel";
            }

        }

        vm.init = function () {
            vm.userLabel = 'Email';
            //TODO: apagar depois
            vm.user = {};
            // vm.user = {
            //     username: '4534534543@sharklasers.com',
            //     password: 'Cgpass@1'
            // }
        };

        //ALTAIR TEMPLATE CODE BELOW
        var $login_card = $('#login_card'),
            $login_form = $('#login_form'),
            $login_help = $('#login_help'),
            $register_form = $('#register_form'),
            $login_password_reset = $('#login_password_reset');

        var login_form_show = function () {
            $login_form
                .show()
                .siblings()
                .hide();
        };

        var login_help_show = function () {
            $login_help
                .show()
                .siblings()
                .hide();
        };


        vm.loginHelp = function ($event, operacaoRecuperacao) {
            $event.preventDefault();
            vm.operacaoRecuperacao = operacaoRecuperacao;
            //card_show_hide($login_card, undefined, login_help_show, undefined);
            $state.go('public.esqueceusenha', { op: vm.operacaoRecuperacao, email: vm.user.username });
        };

        vm.backToLogin = function ($event) {
            $event.preventDefault();
            //$scope.registerFormActive = false;
            card_show_hide($login_card, undefined, login_form_show, undefined);
        };

        function card_show_hide(card, begin_callback, complete_callback, callback_element) {
            $(card).velocity({
                scale: 0,
                opacity: 0.2
            }, {
                    duration: 400,
                    easing: [0.4, 0, 0.2, 1],
                    // on begin callback
                    begin: function () {
                        if (typeof begin_callback !== 'undefined') {
                            begin_callback(callback_element);
                        }
                    },
                    // on complete callback
                    complete: function () {
                        if (typeof complete_callback !== 'undefined') {
                            complete_callback(callback_element);
                        }
                    }
                })
                .velocity('reverse');
        };

        vm.init();

    }

    LoginCtrl.$inject = ['$rootScope', '$state', 'Auth', 'AUTH_EVENTS', 'Common', 'Idle', 'APPLICATION', 'Session', 'DashboardCompany'];

    angular.module('app.login')
        .controller('LoginCtrl', LoginCtrl);
})();


(function () {
    'use strict';

    function EsqueceuSenhaCtrl($rootScope, $state, $stateParams, Common, Login) {
        var vm = this;

        function submitRecuperarSenha(user) {
            if (!Common.emailIsValid(user.email)) return;
            vm.isLoading = true;
            Login.forgotPassword(user.email).then(function (result) {
                if (result) {
                    Common.messageSuccess('E-mail', 'E', 'M');
                    $state.go('public.login');
                } else {
                    //Common.mensagemError(result);
                }
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function submitRecuperarLogin(user) {
            vm.isLoading = true;
            Login.forgotLogin(user).then(function (result) {
                if (result) {
                    Common.messageSuccess('E-mail', 'E', 'M');
                    $state.go('public.login');
                } //else {
                // Common.mensagemError(result);
                // }
                // }).catch(function (result) {
                //     Common.mensagemError(result);
                //     vm.isLoading = false;
            }).finally(function () {
                vm.isLoading = false;
            });
        }


        vm.submit = function (user) {
            if (vm.op == 'recuperarSenha') {
                submitRecuperarSenha(user);
            } else {
                submitRecuperarLogin(user);
            }
        };


        vm.init = function () {
            vm.user = {};
            vm.op = $stateParams.op;
            vm.email = $stateParams.email;
            if (vm.email) {
                vm.user.email = vm.email;
            }
        };
        vm.init();

    }

    EsqueceuSenhaCtrl.$inject = ['$rootScope', '$state', '$stateParams', 'Common', 'Login'];

    angular.module('app.login')
        .controller('EsqueceuSenhaCtrl', EsqueceuSenhaCtrl);
})();


(function () {
    'use strict';

    function AuthService(Common, Login, Company, Restangular, Session, USER_ROLES, Security, APPLICATION) {

        var authService = {};

        authService.profiles = [];

        authService.login = function (user) {
            return Login.authentication(user).then(function (response) {
                localStorage.setItem('mtm-user-authorization-response', JSON.stringify(response));
                return authService.userAutorization(response, user);
            })

        };

        authService.isAuthenticated = function () {
            var status = Session.isUserAuth();
            if (!status) {
                Session.restore();
            }
            return !!Session.getAccessKey();
        };

        authService.isAuthorized = function (authorizedRoles) {
            return true;
            // if (!angular.isArray(authorizedRoles)) {
            //     authorizedRoles = [authorizedRoles];
            // }

            // return (authorizedRoles.indexOf(USER_ROLES.guest) !== -1 || (authService.isAuthenticated() && authorizedRoles.indexOf(Session.userRole) !== -1));
        };

        var userAppRoles;
        authService.getAllUserAppWithRoles = function (userKey) {
            return Company.getCompaniesByUser(userKey).then(function (userAppRoles) {
                return userAppRoles;
            });
        };

        authService.userAutorization = function (response) {
            var userPermissions = [];
            var userAuth = null;
            if (response) {
                var acessKey = '';
                acessKey = response.userId;
                
                Security.setAccessKey(acessKey);
                Security.setAccessToken(response.access_token);
                Security.setRefreshToken(response.refresh_token);

                return authService.getAllUserAppWithRoles(acessKey).then(function (rolesResult) {

                    var permissionsArray = [];
                    var profiles = [];
                    rolesResult.forEach(function (element) {
                        profiles.push({ roleId: element.role.id, appCompanyId: element.appCompanyId ? element.appCompanyId : undefined, companyId: element.role.companyId });
                    });
                    return Login.getProfiles({
                        profileIds: profiles.map(function (element) {
                            return element.roleId;
                        })
                    }).then(function (permissionsResult) {

                        permissionsResult.forEach(function (element) {
                            userPermissions = authService.userProfiles(element.permissions);
                            permissionsArray.push({ roleId: element.roleId, permissions: userPermissions });
                        }, this);

                        profiles.forEach(function (element) {
                            element.permissions = _.find(permissionsArray, function (o) { return o.roleId.toUpperCase() == element.roleId.toUpperCase() }).permissions;
                        }, this);

                        Session.create(response.access_token, response.name ? response.name : response.userName, response.roleId, profiles,
                            acessKey, response.refresh_token, response.username, response.idEmpresa, response.stsAdmin, response.crm);

                        //     //if (userPermissions.length) {
                        userAuth = Session.getUserAuth();
                        return userAuth;
                        //     //}
                    });
                });
            }
            else {
                return userAuth;
            }
        };

        authService.userProfiles = function (profiles) {
            var permissions = [];
            var permission = {
                permissionId: '',
                name: '',
                actions: ''
            };

            if (profiles) {
                for (var i = 0; i < profiles.length; i++) {
                    permission = new Object();
                    permission.permissionId = profiles[i].functionalityId;
                    permission.name = profiles[i].name;
                    permission.funcionalidadeInicial = profiles[i].initial;
                    var actions = [];

                    for (var j = 0; j < profiles[i].actions.length; j++) {
                        actions.push({ actionId: profiles[i].actions[j].id, name: profiles[i].actions[j].description, letter: profiles[i].actions[j].letter });
                    }

                    permission.actions = angular.copy(actions);
                    permissions.push(permission);
                }
            }

            return permissions;
        };

        return authService;

        // authService.isLogout = function() {

        //     var status = false;
        //     return status;
        // };
    }

    AuthService.$inject = ['Common', 'Login', 'Company', 'Restangular', 'Session', 'USER_ROLES', 'Security', 'APPLICATION'];

    angular
        .module('app.login')
        .service('Auth', AuthService);

})();

(function () {
  'use strict';

  function AuthInterceptorService($rootScope, $q, AUTH_EVENTS) {
    return {
      responseError: function (response) {
        $rootScope.$broadcast({
          401: AUTH_EVENTS.notAuthenticated,
          403: AUTH_EVENTS.notAuthorized,
          419: AUTH_EVENTS.sessionTimeout,
          440: AUTH_EVENTS.sessionTimeout
        }[response.status], response);
        return $q.reject(response);
      }
    };
  }

  AuthInterceptorService.$inject = ['$rootScope', '$q', 'AUTH_EVENTS'];

  angular
    .module('app.login')
    .factory('AuthInterceptor', AuthInterceptorService);

})();

(function() {
    'use strict';

    function AtivacaoCtrl($rootScope, $state, Common, Login, $location) {
        var vm = this;

        vm.id = $location.search().Id;

        vm.isAtivacaoProcessValid = undefined;

        vm.init = function() {
            vm.isLoading = true;
            Login.ativar(vm.id).then(function(result) {                
                if (result) {
                    vm.isAtivacaoProcessValid = true;
                } else {
                    vm.isAtivacaoProcessValid = false;
                }
            }).finally(function() {
                vm.isLoading = false;
            });
        };

        vm.init();

    }

    AtivacaoCtrl.$inject = ['$rootScope', '$state', 'Common', 'Login', '$location'];

    angular.module('app.login')
        .controller('AtivacaoCtrl', AtivacaoCtrl);
})();


(function () {
  'use strict';

  angular
    .module('app.log', []);
})();

(function() {
    'use strict';

    function LogService(Common, RestangularAuth, APPLICATION) {

        function get(filters) {
            var clonedFilter = JSON.parse(JSON.stringify(filters));
            clonedFilter.dtInicial = Common.convertToDate(clonedFilter.dtInicial);
            clonedFilter.dtFim = Common.convertToDate(clonedFilter.dtFim);
            return RestangularAuth.all('log').getList(clonedFilter, {objeto: JSON.stringify(clonedFilter)});

        }

        function getById(id) {
            return RestangularAuth.one('log', id).get();
        }


        var service = {
            get: get,
            getById: getById
        };

        return service;
    }

    LogService.$inject = ['Common', 'RestangularAuth'];

    angular
        .module('app.log')
        .factory('Log', LogService);


})();

(function () {
    'use strict';

    /** @ngInject */
    function LogListController($interval, $rootScope, $scope, Log, Common, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, PoloManutencao, Security) {
        var vm = this;

        // //Permissões
        // vm.isLogEdPermitido = false;
        // vm.isLogCadastrarPermitido = false;
        // vm.configurarPermissoes = function() {
        //     vm.isLogDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Log", action: "D" });
        //     vm.isLogCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Log", action: "C" });
        // };

        vm.searchKey = '';

        vm.primeiraPagina = function () {
            vm.filters.continuationToken = undefined;
            vm.tokenArray = [];
            vm.getLogs(vm.filters);
        }

        vm.anteriorPagina = function () {
            vm.filters.continuationToken = vm.tokenArray.pop();
            vm.getLogsAnterior(vm.filters);
        }

        vm.proximaPagina = function () {
            if (vm.filters.continuationToken == undefined) {
                UIkit.notify({ message: "<div class='uk-text-center'><span>" + 'Não existem mais resultados.' + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
            } else {
                vm.getLogs(vm.filters);
            }
        }

        vm.getLogs = function (filters) {
            // vm.isLoading = true;
            return Log.get(filters).then(function (logs) {
                vm.logs = logs;
                vm.filters.continuationToken = vm.logs.continuationToken;

                if (vm.logs.continuationToken != undefined) {
                    vm.tokenArray.push(JSON.parse(JSON.stringify(vm.filters.continuationToken))); //adiciona a pilha de tokens para permitir a navegaçao
                }

                // vm.isLoading = false;
                return vm.logs;
            });
        };

        vm.getLogsAnterior = function (filters) {
            vm.isLoading = true;
            return Log.get(filters).then(function (logs) {
                vm.logs = logs;
                vm.filters.continuationToken = vm.logs.continuationToken;
                vm.isLoading = false;
                return vm.logs;
            });
        };

        vm.pesquisar = function (filters) {
            vm.isLoading = true;
            vm.searchKey = Common.guid();
            vm.filters.searchKey = vm.searchKey;
            vm.getLogs(vm.filters);
        };


        function iniciarComponentes() {
            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(1000)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
                DTColumnDefBuilder.newColumnDef(4),
                DTColumnDefBuilder.newColumnDef(5),
                DTColumnDefBuilder.newColumnDef(6)
            ];

            vm.selectize_status = { options: [] };
            vm.selectize_status.options = APPLICATION.statusBooleano;
            vm.selectize_status_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Erro',
                valueField: 'id',
                labelField: 'descricao',
                searchField: 'descricao'
            };

            vm.selectize_requisicao = { options: [] };
            vm.selectize_requisicao.options = APPLICATION.requisicoes;
            vm.selectize_requisicao_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Requisição',
                valueField: 'descricao',
                labelField: 'descricao',
                searchField: 'descricao'
            };

        }

        //Validação das datas
        $scope.$watch(
            'vm.filters.dtInicial',
            function () {
                var result = Common.validateData(vm.filters.dtInicial, vm.filters.dtFim);
                if (!result) {
                    vm.filters.dtInicial = undefined;
                    Common.mensagemError('Data inicial não pode ser maior que data final.');
                }
            }
        );

        $scope.$watch(
            'vm.filters.dtFim',
            function () {
                var result = Common.validateData(vm.filters.dtInicial, vm.filters.dtFim);
                if (!result) {
                    vm.filters.dtFim = undefined;
                    Common.mensagemError('Data inicial não pode ser maior que data final.');
                }
            }
        );

        var lstnrClb1 = $rootScope.$on('carregar-logs', function (event, args) {
            vm.logs = [];
            if (args.resultado.searchKey == vm.searchKey) {
                if (args.resultado.logs.Items != null) {
                    vm.logs = args.resultado.logs.Items
                }
            }
            vm.isLoading = false;
        });

        $scope.$on('$destroy', function () {
            [
                lstnrClb1
            ].forEach(function (fn) {
                fn();
            });
        });

        vm.init = function () {
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            var hoje = moment().format(vm.datePickerFormat.format);
            vm.isLoadingChamados = false;
            vm.isLoadingFiltros = false;
            vm.isLoading = false;
            vm.filters = {};
            vm.filters.limit = 999999;
            vm.filters.dtInicial = hoje;//moment().add(-1, 'days').format(vm.datePickerFormat.format);
            vm.filters.dtFim = hoje;
            vm.filters.continuationToken = undefined;

            vm.tokenArray = [];

            iniciarComponentes();
            // vm.pesquisar(vm.filters);
        };

        vm.init();
    }

    angular.module('app.log')
        .controller('LogListController', LogListController);

})();

(function() {
    'use strict';

    /** @ngInject */
    function LogDetailController($interval, $rootScope, $scope, $stateParams, Log, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION) { //
        var vm = this;
        vm.id = $stateParams.id;
        

        vm.getLog = function() {
            vm.isLoading = true;
            return Log.getById(vm.id).then(function(log) {
                vm.log = log;
                vm.isLoading = false;
                return vm.log;
            });
        };


        vm.init = function() {
            vm.getLog().then(function() {
               //
            });

        };

        vm.init();
    }

    angular.module('app.log')
        .controller('LogDetailController', LogDetailController);

})();

(function () {
  'use strict';

  angular
    .module('app.form', []);
})();

(function () {
    'use strict';

    /** @ngInject */
    function FormStatisticsController($anchorScroll, $controller, $location, $rootScope, $scope, $state, $stateParams, $timeout, $window, uuid2, Category, DashboardCompany, Common, Form, APPLICATION, FORMS, DTOptionsBuilder, DTColumnBuilder, $compile, moment, Security) {
        var vm = this

        vm.init = function(){
            vm.isLoading = true;
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            vm.modulo = $stateParams.modulo;
            vm.formId = $stateParams.id;
            vm.formName = $stateParams.formName; 
            vm.showCustomPeriodSearch = false;
            vm.filter = {};
            vm.filter.modulo = vm.modulo;
            vm.filter.formId = vm.formId;
            vm.filter.searchRootById = true;
            vm.selectize_config = {};  
            vm.cleanGraph();
            vm.defaultPatterColor = ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#7cb342','#e53935'];
            vm.defaultPatterColorNPS = ['#388E3C', '#666666', '#D32F2F'];
            vm.configComponents();
            vm.optionDataComponent();

            vm.search(vm.filter);
        };

        vm.goRoute = function (action, formId, formName){
            Form.routeGo(vm.modulo, action, formId, formName);
        }

        vm.cleanGraph  = function(){
            vm.generalVisionData = null;
            vm.singleChoiceData = [];
            vm.multipleChoiceData = [];
            vm.freeTextData = [];
            vm.imageData = [];
            vm.npsData = [];
        }

        vm.configComponents = function(){
            vm.selectize_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE,
                placeholder: "-- Selecione --",               
                sortField: {
                    field: 'description',
                    direction: 'asc'
                },
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.description) + '</div>';
                    }
                }
            };

            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withDisplayLength(7)
                .withDOM('rtip')
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withPaginationType('full_numbers')
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile(angular.element('.dt-uikit .md-input'))($scope);
                    })
                });
        }

        vm.optionDataComponent = function(){
            vm.selectize_period_options = [
                {id: 0, description: 'Definir Período'},
                {id: 1, description: 'Esta Semana'},
                {id: 2, description: 'Este Mês'},
                {id: 3, description: 'Este Ano'},
                {id: 4, description: 'Últimos 7 dias'},
                {id: 5, description: 'Últimos 30 dias'},
                {id: 6, description: 'Últimos 90 dias'},
                {id: 7, description: 'Últimos 180 dias'},
                {id: 8, description: 'Últimos 365 dias'}];
        }

        vm.changeSubmissionPeriod = function(){
           switch(parseInt(vm.filter.periodType)){
                case 0: //Custom Data
                    vm.filter.dateIni = null;
                    vm.filter.dateEnd = null;
                    vm.showCustomPeriodSearch = true  
                break;
                case 1: //Por Semana
                    vm.filter.dateIni = moment().startOf('week').format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break; 
                case 2: //Por Mês
                    vm.filter.dateIni = moment().startOf('month').format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;             
                case 3: //Por Ano
                    vm.filter.dateIni = moment().startOf('year').format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 4: //Últimos 7 dias
                    vm.filter.dateIni = moment().day(-7).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 5: //Últimos 30 dias
                    vm.filter.dateIni = moment().day(-30).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 6: //Últimos 90 dias
                    vm.filter.dateIni = moment().day(-90).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 7: //Últimos 180 dias
                    vm.filter.dateIni = moment().day(-180).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 8: //Últimos 365 dias
                    vm.filter.dateIni = moment().day(-365).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                default:
                break;
            }

            if(parseInt(vm.filter.periodType) != 0 && vm.showCustomPeriodSearch == true) {
                vm.showCustomPeriodSearch = false;
            }
        }

        
        var $dp_start = angular.element('#uk_dp_start'),
            $dp_end = angular.element('#uk_dp_end');

        var start_date = UIkit.datepicker($dp_start, {
            format:'DD/MM/YYYY'
        });

        var end_date = UIkit.datepicker($dp_end, {
            format:'DD/MM/YYYY'
        });

        $dp_start.on('change',function() {
            end_date.options.minDate = $dp_start.val();
        });

        $dp_end.on('change',function() {
            start_date.options.maxDate = $dp_end.val();
        });

        // Calcula a transposta de uma matriz.
        vm.transposeMatrix = function transpose(a) {
            return Object.keys(a[0]).map(function(c) {
                return a.map(function(r) { return r[c]; });
            });
        }

        
        vm.search = function(filter){
            vm.isLoadingGraph = true;
            vm.isLoadingFreeText = true;
            vm.isLoadingImages = true;
            vm.hasInfo = false;

            vm.cleanGraph();

            Form.getFormSubmissionStatistics(filter).then(function(graphData){
                /////////////////////// Graph: General Information ///////////////////////                                
                vm.xLabels = ['x'];
                vm.valueLabels = ['Respostas'];
                vm.xLabels = vm.xLabels.concat(graphData.generalVision.xLabels);
                vm.valueLabels = vm.valueLabels.concat(graphData.generalVision.valueLabels);
                vm.xFormat = graphData.groupByMonth ? '%m/%Y':'%d/%m/%Y';

                if(graphData.generalVision.answersCount > 0){
                    vm.generalVisionData = graphData.generalVision
                }

                if(graphData.generalVision.answersCount > 0 || graphData.singleChoice.lenght > 0 || graphData.multipleChoice.lenght > 0 || graphData.nps.lenght > 0){
                    vm.hasInfo = true;
                }

                $timeout(function () {
                    c3.generate({
                        bindto: '#c3_generalVision',
                        data: {
                            x:'x',
                            columns: [
                                vm.xLabels,
                                vm.valueLabels
                            ],
                            empty: { 
                                label: { 
                                    text: "Nenhuma informação disponível" 
                                }   
                            }                    
                        }, 
                        axis: {
                            x: {
                                type: 'timeseries',                       
                                tick: {                                
                                    format: vm.xFormat
                                }
                            },
                            y:{
                                min: 0,
                                tick:{
                                     format: d3.format('d')
                                }
                            }
                        },
                        colors: {
                            pattern: vm.defaultPatterColor
                        },
                        padding: {
                            right: 20
                        }
                    });
                }, 100);

                /////////////////////// Info p/ Renderização do Graficos ////////////////////                  
                graphData.singleChoice.forEach(function(item){
                    vm.singleChoiceData.push(item);
                });
                graphData.multipleChoice.forEach(function(item){
                    vm.multipleChoiceData.push(item);
                });
                graphData.nps.forEach(function(item){
                    vm.npsData.push(item);
                });

                /////////////////////// Graph: Simple Select ////////////////////////////////                  
                // Timer para plotagem do html.
                $timeout(function () {
                    var index = 0;
                    graphData.singleChoice.forEach(function(item){

                        // faz a transposta da matriz afim de associar cada valor ao label correspondente.
                        var matriz = [item.xLabels, item.valueLabels];
                        var matrizTransposed = vm.transposeMatrix(matriz);
                        c3.generate({
                            bindto: '#c3_simpleSelect_' + index,
                            data: {
                                columns: matrizTransposed,
                                type: 'bar',
                                empty: { 
                                    label: { 
                                        text: "Nenhuma informação disponível" 
                                    }   
                                }                    
                            },                     
                            colors: {
                                pattern: vm.defaultPatterColor
                            },
                            padding: {
                                right: 20
                            }
                        });
                        c3.generate({
                            bindto: '#c3_pie_simpleSelect_' + index,
                            data: {
                                columns: matrizTransposed,
                                type: 'pie',
                                empty: { 
                                    label: { 
                                        text: "Nenhuma informação disponível" 
                                    }   
                                }                    
                            },                     
                            colors: {
                                pattern: vm.defaultPatterColor
                            },
                            padding: {
                                right: 20
                            },
                            legend: {
                                show: false
                            }
                        });
                        index++;
                    });
                }, 100);
                
                /////////////////////// Graph: Multiple Select //////////////////////////////                  
                // Timer para plotagem do html.
                $timeout(function () {
                    var index = 0;
                    graphData.multipleChoice.forEach(function(item){

                        // faz a transposta da matriz afim de associar cada valor ao label correspondente.
                        var matriz = [item.xLabels, item.valueLabels];
                        var matrizTransposed = vm.transposeMatrix(matriz);
                        c3.generate({
                            bindto: '#c3_multipleSelect_' + index,
                            data: {
                                columns: matrizTransposed,
                                type: 'bar',
                                empty: { 
                                    label: { 
                                        text: "Nenhuma informação disponível" 
                                    }   
                                }                    
                            },                     
                            colors: {
                                pattern: vm.defaultPatterColor
                            },
                            padding: {
                                right: 20
                            }
                        });
                        c3.generate({
                            bindto: '#c3_pie_multipleSelect_' + index,
                            data: {
                                columns: matrizTransposed,
                                type: 'pie',
                                empty: { 
                                    label: { 
                                        text: "Nenhuma informação disponível" 
                                    }   
                                }                    
                            },                     
                            colors: {
                                pattern: vm.defaultPatterColor
                            },
                            padding: {
                                right: 20
                            },
                            legend: {
                                show: false
                            }
                        });
                        index++;
                    });
                }, 100);

                /////////////////////// Graph: NPS //////////////////////////////////////////                  
                // Timer para plotagem do html.
                $timeout(function () {
                    var index = 0;
                    graphData.nps.forEach(function(item){

                        // faz a transposta da matriz afim de associar cada valor ao label correspondente.
                        var matriz = [item.xLabels, item.valueLabels];
                        var matrizTransposed = vm.transposeMatrix(matriz);
                        c3.generate({
                            bindto: '#c3_nps_' + index,
                            data: {
                                columns: matrizTransposed,
                                type: 'bar',
                                empty: { 
                                    label: { 
                                        text: "Nenhuma informação disponível" 
                                    }   
                                }                    
                            },                     
                            color: {
                                pattern: vm.defaultPatterColorNPS
                            },
                            padding: {
                                right: 20
                            }
                        });
                        c3.generate({
                            bindto: '#c3_pie_nps_' + index,
                            data: {
                                columns: matrizTransposed,
                                type: 'pie',
                                empty: { 
                                    label: { 
                                        text: "Nenhuma informação disponível" 
                                    }   
                                }                    
                            },                     
                            color: {
                                pattern: vm.defaultPatterColorNPS
                            },
                            padding: {
                                right: 20
                            },
                            legend: {
                                show: false
                            }
                        });
                        index++;
                    });
                }, 100);             

                vm.isLoadingGraph = false;                
            }).catch(function () {
                vm.isLoadingGraph = false;
            }); 

            /////////////////////// Data Table: Free Tex ////////////////////////////////                  
            Form.getFormSubmissionStatisticsFreeText(filter).then(function(graphDataFreeText){
                if(graphDataFreeText.freeText.lenght > 0){
                    vm.hasInfo = true;
                }
                graphDataFreeText.freeText.forEach(function(item){
                    vm.freeTextData.push(item);
                });
                vm.isLoadingFreeText = false;
            }).catch(function () {
                vm.isLoadingFreeText = false;
            }); 

            /////////////////////// Data Table: Image ///////////////////////////////////                  
            //Time out para load do appSelecionado.
            $timeout(function() {
                Form.getFormSubmissionStatisticsImage(filter, vm.appCompany).then(function(graphDataImage){
                    if(graphDataImage.image.lenght > 0){
                        vm.hasInfo = true;
                    }
                    graphDataImage.image.forEach(function(item){
                        vm.imageData.push(item);                        
                    });
                    vm.isLoadingImages = false;
                }).catch(function () {
                    vm.isLoadingImages = false;
                }); 

            }, 100);
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////
        vm.printListReport = function (divName) {
             var printContents = document.getElementById(divName).innerHTML;
             var win = window.open('','Lista de Respostas');                
             win.document.write('<html>');
             win.document.write('<head>');
             win.document.write('<style>');
             win.document.write('.heading_list {  text-align:center !important; border-top: 1px solid #000 !important; border-bottom: 1px solid #000 !important;} ');
             win.document.write('ul, li{ list-style-type: none; padding-top 80px !important;} ');
             win.document.write('</style>');
             win.document.write('<title>Lista de Respostas</title>');
             win.document.write('</head>');
             win.document.write('<body>');
             win.document.write(printContents);
             win.document.write('<style>');             
             win.document.write('@page { margin-top: 100px; margin-left: 20px; margin-bottom: 40px; margin-right: 20px; counter-increment: page !important; @bottom-right { padding-right:20px !important; content: "Page " counter(page) !important; }}');                 
             win.document.write('</style>');
             win.document.write('</body>');
             win.document.write('</html>');
             win.focus();
             setTimeout(function(){
                    win.print();
                    win.close(); 
             },1000);                 
        };  

        vm.printDetailReport = function(divName){
             var printContents = document.getElementById(divName).innerHTML;
             var win = window.open('','Detalhamento da Resposta');                
             win.document.write('<html>');
             win.document.write('<head>');
             win.document.write('<script src=\"https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js\"></script>');
             win.document.write('<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/css/uikit.min.css\" />');
             win.document.write('<script src=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/js/uikit.min.js\"></script>');
             win.document.write('<link rel=\"stylesheet\" href=\"cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/css/uikit.min.css\" media=\"all\" />');
             win.document.write('<script src=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/js/uikit.min.js\"></script>');
             win.document.write('<style>');
             win.document.write('.reportTitle{margin:5px 0px 5px 0px; text-align:center;}');                 
             win.document.write('.subFormPrint{text-align:center !important; border: 1px solid #000 !important;}');                              
             win.document.write('.titlePrint{text-align:center !important; border: 1px solid #000 !important;}');                 
             win.document.write('.answerPrint{border-bottom: 1px solid #000 !important;}');                 
             win.document.write('label{font-weight: bold !important;}');                 
             win.document.write('</style>');
             win.document.write('<title> Detalhamento da Resposta</title>');
             win.document.write('</head>');
             win.document.write('<body>');
             win.document.write(printContents);
             win.document.write('<style>');
             // Gabriel Souza: adição da paginação no relatório, subtitulo e data da solicitação do relatório.
             win.document.write('@page { margin-top: 100px; margin-left: 20px; margin-bottom: 40px; margin-right: 20px; counter-increment: page !important; @bottom-right { padding-right:20px !important; content: "Page " counter(page) !important; }}');                 
             win.document.write('</style>');
             win.document.write('</body>');
             win.document.write('</html>');
             win.focus();
             setTimeout(function(){
                    win.print();
                    win.close(); 
             },1000);  
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////
        vm.modulo = $stateParams.modulo;
        vm.configurarPermissoes = function () {
            if (vm.modulo == 'Relacionamento') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Relacionamento", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Relacionamento", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "S" });                
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "C" });
            } else if (vm.modulo == 'Integracao') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Integração", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Integração", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "C" });
            } else if (vm.modulo == 'Nps') {
                vm.moduloPretty = 'Formulários de Pesquisa de Opinião';
                //TODO: Gerar permissões para modulo NPS
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                
                vm.isFormEstatisticaPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSumarioPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                
                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });

            }else if(vm.modulo == "FormGeral"){
                vm.moduloPretty = 'Formulários Gerais';
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "C" });

                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });

                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
            }            
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isFormSubmissionsPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
    }

    angular.module('app.form')
        .controller('FormStatisticsController', FormStatisticsController);

})();


(function () {
    'use strict';

    /** @ngInject */
    function FormService(Common, RestangularAuth, FORMS, APPLICATION, Session, $state) {

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //------------------------------------------------- Categorias dos Formulários --------------------------------
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        function getPublishLevel() {
            return RestangularAuth.all('manager/forms/publishlevel').getList();
        }

        function getCategories(filters) {
            return RestangularAuth.all('manager/forms').customGET("category", filters);
        }

        function getCategoriesLeafs(filters) {
             return RestangularAuth.all("manager/forms/category").customGET("leafs", filters);
        }

        function deleteCategoriesAll(ids) {
            return RestangularAuth.one('manager/forms/category', ids).remove();
        }

        function deleteCategoryById(id) {
            return RestangularAuth.one('manager/forms/category/'+id).remove();
        }

        function getCategoryById(id) {
            return RestangularAuth.one('manager/forms/category/').customGET(id.toString());
        }

        function postCategory(category) {
            return RestangularAuth.all('manager/forms/category').post(category);
        }

        function putCategory(category) {
            return RestangularAuth.all('manager/forms/category/' + category.id).customPUT(category);
        }

        function postCategoryReason(motivo) {
            return RestangularAuth.all('manager/forms/category').post(motivo);
        }

        function iconsListMobileCare() {
            var iconsCategory = [];
            
            iconsCategory.push({ id: '&#xe9da' });
            iconsCategory.push({ id: '&#xe98a' });
            iconsCategory.push({ id: '&#xe91b' });
            iconsCategory.push({ id: '&#xe922' });
            iconsCategory.push({ id: '&#xe972' });
            iconsCategory.push({ id: '&#xe98b' });
            iconsCategory.push({ id: '&#xe98c' });
            iconsCategory.push({ id: '&#xe98d' });
            iconsCategory.push({ id: '&#xe98e' });
            iconsCategory.push({ id: '&#xe98f' });
            iconsCategory.push({ id: '&#xe990' });
            iconsCategory.push({ id: '&#xe991' });
            iconsCategory.push({ id: '&#xe992' });
            iconsCategory.push({ id: '&#xe90f' });
            iconsCategory.push({ id: '&#xe993' });
            iconsCategory.push({ id: '&#xe980' });
            iconsCategory.push({ id: '&#xe994' });
            iconsCategory.push({ id: '&#xe981' });
            iconsCategory.push({ id: '&#xe097' });
            iconsCategory.push({ id: '&#xe996' });
            iconsCategory.push({ id: '&#xe997' });
            iconsCategory.push({ id: '&#xe096' });
            iconsCategory.push({ id: '&#xe999' });
            iconsCategory.push({ id: '&#xe99a' });
            iconsCategory.push({ id: '&#xe96d' });
            iconsCategory.push({ id: '&#xe107' });
            iconsCategory.push({ id: '&#xe99c' });
            iconsCategory.push({ id: '&#xe99b' });
            iconsCategory.push({ id: '&#xe99d' });
            iconsCategory.push({ id: '&#xe99f' });
            iconsCategory.push({ id: '&#xe99e' });
            iconsCategory.push({ id: '&#xe92d' });
            iconsCategory.push({ id: '&#xe92f' });
            iconsCategory.push({ id: '&#xe9a0' });
            iconsCategory.push({ id: '&#xe9a1' });
            iconsCategory.push({ id: '&#xe9a2' });
            iconsCategory.push({ id: '&#xe9a3' });
            iconsCategory.push({ id: '&#xe983' });
            iconsCategory.push({ id: '&#xe9a4' });
            iconsCategory.push({ id: '&#xe930' });
            iconsCategory.push({ id: '&#xe97c' });
            iconsCategory.push({ id: '&#xe910' });
            iconsCategory.push({ id: '&#xe911' });
            iconsCategory.push({ id: '&#xe912' });
            iconsCategory.push({ id: '&#xe9a5' });
            iconsCategory.push({ id: '&#xe9a6' });
            iconsCategory.push({ id: '&#xe97b' });
            iconsCategory.push({ id: '&#xe97b' });
            iconsCategory.push({ id: '&#xe9a9' });
            iconsCategory.push({ id: '&#xe9a7' });
            iconsCategory.push({ id: '&#xe9a8' });
            iconsCategory.push({ id: '&#xe901' });
            iconsCategory.push({ id: '&#xe116' });
            iconsCategory.push({ id: '&#xe9aa' });
            iconsCategory.push({ id: '&#xe9ab' });
            iconsCategory.push({ id: '&#xe9ac' });
            iconsCategory.push({ id: '&#xe945' });
            iconsCategory.push({ id: '&#xe946' });
            iconsCategory.push({ id: '&#xe947' });
            iconsCategory.push({ id: '&#xe948' });
            iconsCategory.push({ id: '&#xe9ad' });
            iconsCategory.push({ id: '&#xe9ae' });
            iconsCategory.push({ id: '&#xe9af' });
            iconsCategory.push({ id: '&#xe042' });
            iconsCategory.push({ id: '&#xe929' });
            iconsCategory.push({ id: '&#xe043' });
            iconsCategory.push({ id: '&#xe92a' });
            iconsCategory.push({ id: '&#xe92c' });
            iconsCategory.push({ id: '&#xe041' });
            iconsCategory.push({ id: '&#xe92e' });
            iconsCategory.push({ id: '&#xe040' });
            iconsCategory.push({ id: '&#xe92b' });
            iconsCategory.push({ id: '&#xe94a' });
            iconsCategory.push({ id: '&#xe94b' });
            iconsCategory.push({ id: '&#xe9b0' });
            iconsCategory.push({ id: '&#xe9b1' });
            iconsCategory.push({ id: '&#xe9b3' });
            iconsCategory.push({ id: '&#xe9b2' });
            iconsCategory.push({ id: '&#xe9b5' });
            iconsCategory.push({ id: '&#xe9b6' });
            iconsCategory.push({ id: '&#xe9b7' });
            iconsCategory.push({ id: '&#xe96b' });
            iconsCategory.push({ id: '&#xe932' });
            iconsCategory.push({ id: '&#xe933' });
            iconsCategory.push({ id: '&#xe913' });
            iconsCategory.push({ id: '&#xe111' });
            iconsCategory.push({ id: '&#xe90e' });
            iconsCategory.push({ id: '&#xe979' });
            iconsCategory.push({ id: '&#xe9b8' });
            iconsCategory.push({ id: '&#xe117' });
            iconsCategory.push({ id: '&#xe9b9' });
            iconsCategory.push({ id: '&#xe9ba' });
            iconsCategory.push({ id: '&#xe95b' });
            iconsCategory.push({ id: '&#xe954' });
            iconsCategory.push({ id: '&#xe955' });
            iconsCategory.push({ id: '&#xe956' });
            iconsCategory.push({ id: '&#xe957' });
            iconsCategory.push({ id: '&#xe958' });
            iconsCategory.push({ id: '&#xe959' });
            iconsCategory.push({ id: '&#xe9bb' });
            iconsCategory.push({ id: '&#xe967' });
            iconsCategory.push({ id: '&#xe926' });
            iconsCategory.push({ id: '&#xe927' });
            iconsCategory.push({ id: '&#xe9bd' });
            iconsCategory.push({ id: '&#xe9bc' });
            iconsCategory.push({ id: '&#xe9be' });
            iconsCategory.push({ id: '&#xe934' });
            iconsCategory.push({ id: '&#xe9bf' });
            iconsCategory.push({ id: '&#xe935' });
            iconsCategory.push({ id: '&#xe914' });
            iconsCategory.push({ id: '&#xe915' });
            iconsCategory.push({ id: '&#xe971' });
            iconsCategory.push({ id: '&#xe110' });
            iconsCategory.push({ id: '&#xe9c0' });
            iconsCategory.push({ id: '&#xe982' });
            iconsCategory.push({ id: '&#xe9c4' });
            iconsCategory.push({ id: '&#xe9c5' });
            iconsCategory.push({ id: '&#xe995' });
            iconsCategory.push({ id: '&#xe96c' });
            iconsCategory.push({ id: '&#xe975' });
            iconsCategory.push({ id: '&#xe9c6' });
            iconsCategory.push({ id: '&#xe9c7' });
            iconsCategory.push({ id: '&#xe9c8' });
            iconsCategory.push({ id: '&#xe9c9' });
            iconsCategory.push({ id: '&#xe917' });
            iconsCategory.push({ id: '&#xe900' });
            iconsCategory.push({ id: '&#xe94c' });
            iconsCategory.push({ id: '&#xe918' });
            iconsCategory.push({ id: '&#xe9ca' });
            iconsCategory.push({ id: '&#xe919' });
            iconsCategory.push({ id: '&#xe9cb' });
            iconsCategory.push({ id: '&#xe91a' });
            iconsCategory.push({ id: '&#xe9e6' });
            iconsCategory.push({ id: '&#xe9f8' });
            iconsCategory.push({ id: '&#xea0b' });
            iconsCategory.push({ id: '&#xe9cc' });
            iconsCategory.push({ id: '&#xe9cd' });
            iconsCategory.push({ id: '&#xe9ce' });
            iconsCategory.push({ id: '&#xe9cf' });
            iconsCategory.push({ id: '&#xe91c' });
            iconsCategory.push({ id: '&#xe91d' });
            iconsCategory.push({ id: '&#xe90c' });
            iconsCategory.push({ id: '&#xe962' });
            iconsCategory.push({ id: '&#xe966' });
            iconsCategory.push({ id: '&#xe9d0' });
            iconsCategory.push({ id: '&#xe122' });
            iconsCategory.push({ id: '&#xe9d1' });
            iconsCategory.push({ id: '&#xe9d2' });
            iconsCategory.push({ id: '&#xe9d3' });
            iconsCategory.push({ id: '&#xe976' });
            iconsCategory.push({ id: '&#xe90d' });
            iconsCategory.push({ id: '&#xe95c' });
            iconsCategory.push({ id: '&#xe95d' });
            iconsCategory.push({ id: '&#xe9d4' });
            iconsCategory.push({ id: '&#xe9d5' });
            iconsCategory.push({ id: '&#xe9d6' });
            iconsCategory.push({ id: '&#xe005' });
            iconsCategory.push({ id: '&#xe984' });
            iconsCategory.push({ id: '&#xe908' });
            iconsCategory.push({ id: '&#xe936' });
            iconsCategory.push({ id: '&#xe937' });
            iconsCategory.push({ id: '&#xe9d7' });
            iconsCategory.push({ id: '&#xe938' });
            iconsCategory.push({ id: '&#xe939' });
            iconsCategory.push({ id: '&#xe909' });
            iconsCategory.push({ id: '&#xe9d8' });
            iconsCategory.push({ id: '&#xe071' });
            iconsCategory.push({ id: '&#xe9d9' });
            iconsCategory.push({ id: '&#xe93a' });
            iconsCategory.push({ id: '&#xe93b' });
            iconsCategory.push({ id: '&#xe96f' });
            iconsCategory.push({ id: '&#xe9dc' });
            iconsCategory.push({ id: '&#xe9db' });
            iconsCategory.push({ id: '&#xe93d' });
            iconsCategory.push({ id: '&#xe998' });
            iconsCategory.push({ id: '&#xe112' });
            iconsCategory.push({ id: '&#xe9dd' });
            iconsCategory.push({ id: '&#xe9de' });
            iconsCategory.push({ id: '&#xe9c1' });
            iconsCategory.push({ id: '&#xe973' });
            iconsCategory.push({ id: '&#xe90a' });
            iconsCategory.push({ id: '&#xe90b' });
            iconsCategory.push({ id: '&#xe974' });
            iconsCategory.push({ id: '&#xe9df' });
            iconsCategory.push({ id: '&#xe9e1' });
            iconsCategory.push({ id: '&#xe9e0' });
            iconsCategory.push({ id: '&#xe048' });
            iconsCategory.push({ id: '&#xe94d' });
            iconsCategory.push({ id: '&#xe113' });
            iconsCategory.push({ id: '&#xe9e2' });
            iconsCategory.push({ id: '&#xe9e3' });
            iconsCategory.push({ id: '&#xe115' });
            iconsCategory.push({ id: '&#xe9e4' });
            iconsCategory.push({ id: '&#xe9e5' });
            iconsCategory.push({ id: '&#xe93c' });
            iconsCategory.push({ id: '&#xe95a' });
            iconsCategory.push({ id: '&#xe9e7' });
            iconsCategory.push({ id: '&#xe9e8' });
            iconsCategory.push({ id: '&#xe9e9' });
            iconsCategory.push({ id: '&#xe9ea' });
            iconsCategory.push({ id: '&#xe9eb' });
            iconsCategory.push({ id: '&#xe91e' });
            iconsCategory.push({ id: '&#xe91f' });
            iconsCategory.push({ id: '&#xe9ec' });
            iconsCategory.push({ id: '&#xe9c2' });
            iconsCategory.push({ id: '&#xe9ed' });
            iconsCategory.push({ id: '&#xe9c3' });
            iconsCategory.push({ id: '&#xe128' });
            iconsCategory.push({ id: '&#xe123' });
            iconsCategory.push({ id: '&#xe034' });
            iconsCategory.push({ id: '&#xe001' });
            iconsCategory.push({ id: '&#xe9ee' });
            iconsCategory.push({ id: '&#xe970' });
            iconsCategory.push({ id: '&#xe9f5' });
            iconsCategory.push({ id: '&#xe9ef' });
            iconsCategory.push({ id: '&#xe9f0' });
            iconsCategory.push({ id: '&#xe9f1' });
            iconsCategory.push({ id: '&#xe9f2' });
            iconsCategory.push({ id: '&#xe9f3' });
            iconsCategory.push({ id: '&#xe9f4' });
            iconsCategory.push({ id: '&#xe93e' });
            iconsCategory.push({ id: '&#xe949' });
            iconsCategory.push({ id: '&#xe9f6' });
            iconsCategory.push({ id: '&#xe9f7' });
            iconsCategory.push({ id: '&#xe9f9' });
            iconsCategory.push({ id: '&#xe9fa' });
            iconsCategory.push({ id: '&#xe9fb' });
            iconsCategory.push({ id: '&#xe9fc' });
            iconsCategory.push({ id: '&#xe964' });
            iconsCategory.push({ id: '&#xe9fd' });
            iconsCategory.push({ id: '&#xe96a' });
            iconsCategory.push({ id: '&#xe969' });
            iconsCategory.push({ id: '&#xe9fe' });
            iconsCategory.push({ id: '&#xe97a' });
            iconsCategory.push({ id: '&#xe968' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe9ff' });
            iconsCategory.push({ id: '&#xea00' });
            iconsCategory.push({ id: '&#xe95f' });
            iconsCategory.push({ id: '&#xe907' });
            iconsCategory.push({ id: '&#xe902' });
            iconsCategory.push({ id: '&#xe903' });
            iconsCategory.push({ id: '&#xe904' });
            iconsCategory.push({ id: '&#xe961' });
            iconsCategory.push({ id: '&#xea01' });
            iconsCategory.push({ id: '&#xea02' });
            iconsCategory.push({ id: '&#xea03' });
            iconsCategory.push({ id: '&#xea0c' });
            iconsCategory.push({ id: '&#xe916' });
            iconsCategory.push({ id: '&#xea04' });
            iconsCategory.push({ id: '&#xea05' });
            iconsCategory.push({ id: '&#xe93f' });
            iconsCategory.push({ id: '&#xe94e' });
            iconsCategory.push({ id: '&#xe905' });
            iconsCategory.push({ id: '&#xea06' });
            iconsCategory.push({ id: '&#xea1a' });
            iconsCategory.push({ id: '&#xe057' });
            iconsCategory.push({ id: '&#xea07' });
            iconsCategory.push({ id: '&#xe96e' });
            iconsCategory.push({ id: '&#xea08' });
            iconsCategory.push({ id: '&#xea09' });
            iconsCategory.push({ id: '&#xe985' });
            iconsCategory.push({ id: '&#xe986' });
            iconsCategory.push({ id: '&#xea0a' });
            iconsCategory.push({ id: '&#xe97d' });
            iconsCategory.push({ id: '&#xe97e' });
            iconsCategory.push({ id: '&#xe97f' });
            iconsCategory.push({ id: '&#xe076' });
            iconsCategory.push({ id: '&#xe046' });
            iconsCategory.push({ id: '&#xe94f' });
            iconsCategory.push({ id: '&#xe047' });
            iconsCategory.push({ id: '&#xe045' });
            iconsCategory.push({ id: '&#xe951' });
            iconsCategory.push({ id: '&#xe044' });
            iconsCategory.push({ id: '&#xe952' });
            iconsCategory.push({ id: '&#xe940' });
            iconsCategory.push({ id: '&#xe941' });
            iconsCategory.push({ id: '&#xea0d' });
            iconsCategory.push({ id: '&#xea0e' });
            iconsCategory.push({ id: '&#xea0f' });
            iconsCategory.push({ id: '&#xea2b' });
            iconsCategory.push({ id: '&#xe942' });
            iconsCategory.push({ id: '&#xe943' });
            iconsCategory.push({ id: '&#xea10' });
            iconsCategory.push({ id: '&#xea11' });
            iconsCategory.push({ id: '&#xe965' });
            iconsCategory.push({ id: '&#xea12' });
            iconsCategory.push({ id: '&#xea13' });
            iconsCategory.push({ id: '&#xea14' });
            iconsCategory.push({ id: '&#xe950' });
            iconsCategory.push({ id: '&#xea15' });
            iconsCategory.push({ id: '&#xea16' });
            iconsCategory.push({ id: '&#xe944' });
            iconsCategory.push({ id: '&#xea18' });
            iconsCategory.push({ id: '&#xea17' });
            iconsCategory.push({ id: '&#xea19' });
            iconsCategory.push({ id: '&#xe987' });
            iconsCategory.push({ id: '&#xea1b' });
            iconsCategory.push({ id: '&#xe906' });
            iconsCategory.push({ id: '&#xea1c' });
            iconsCategory.push({ id: '&#xea1e' });
            iconsCategory.push({ id: '&#xea1d' });
            iconsCategory.push({ id: '&#xea21' });
            iconsCategory.push({ id: '&#xea1f' });
            iconsCategory.push({ id: '&#xea20' });
            iconsCategory.push({ id: '&#xe921' });
            iconsCategory.push({ id: '&#xe920' });
            iconsCategory.push({ id: '&#xe95e' });
            iconsCategory.push({ id: '&#xe953' });
            iconsCategory.push({ id: '&#xea23' });
            iconsCategory.push({ id: '&#xea22' });
            iconsCategory.push({ id: '&#xe924' });
            iconsCategory.push({ id: '&#xe923' });
            iconsCategory.push({ id: '&#xe925' });
            iconsCategory.push({ id: '&#xe928' });
            iconsCategory.push({ id: '&#xe960' });
            iconsCategory.push({ id: '&#xe963' });
            iconsCategory.push({ id: '&#xea24' });
            iconsCategory.push({ id: '&#xe988' });
            iconsCategory.push({ id: '&#xea25' });
            iconsCategory.push({ id: '&#xea26' });
            iconsCategory.push({ id: '&#xea29' });
            iconsCategory.push({ id: '&#xea27' });
            iconsCategory.push({ id: '&#xea28' });
            iconsCategory.push({ id: '&#xe989' });
            iconsCategory.push({ id: '&#xea2a' });
            iconsCategory.push({ id: '&#xe037' });
            iconsCategory.push({ id: '&#xe038' });

            return iconsCategory;
        }

        function iconsList() {
            var iconsCategory = [];
            var iconsCategoryCode = [];

            iconsCategory.push({ description : '3d_rotation &#xe84d'});
            iconsCategory.push({ description : 'ac_unit &#xeb3b'});
            iconsCategory.push({ description : 'access_alarm &#xe190'});
            iconsCategory.push({ description : 'access_alarms &#xe191'});
            iconsCategory.push({ description : 'access_time &#xe192'});
            iconsCategory.push({ description : 'accessibility &#xe84e'});
            iconsCategory.push({ description : 'accessible &#xe914'});
            iconsCategory.push({ description : 'account_balance &#xe84f'});
            iconsCategory.push({ description : 'account_balance_wallet &#xe850'});
            iconsCategory.push({ description : 'account_box &#xe851'});
            iconsCategory.push({ description : 'account_circle &#xe853'});
            iconsCategory.push({ description : 'adb &#xe60e'});
            iconsCategory.push({ description : 'add &#xe145'});
            iconsCategory.push({ description : 'add_a_photo &#xe439'});
            iconsCategory.push({ description : 'add_alarm &#xe193'});
            iconsCategory.push({ description : 'add_alert &#xe003'});
            iconsCategory.push({ description : 'add_box &#xe146'});
            iconsCategory.push({ description : 'add_circle &#xe147'});
            iconsCategory.push({ description : 'add_circle_outline &#xe148'});
            iconsCategory.push({ description : 'add_location &#xe567'});
            iconsCategory.push({ description : 'add_shopping_cart &#xe854'});
            iconsCategory.push({ description : 'add_to_photos &#xe39d'});
            iconsCategory.push({ description : 'add_to_queue &#xe05c'});
            iconsCategory.push({ description : 'adjust &#xe39e'});
            iconsCategory.push({ description : 'airline_seat_flat &#xe630'});
            iconsCategory.push({ description : 'airline_seat_flat_angled &#xe631'});
            iconsCategory.push({ description : 'airline_seat_individual_suite &#xe632'});
            iconsCategory.push({ description : 'airline_seat_legroom_extra &#xe633'});
            iconsCategory.push({ description : 'airline_seat_legroom_normal &#xe634'});
            iconsCategory.push({ description : 'airline_seat_legroom_reduced &#xe635'});
            iconsCategory.push({ description : 'airline_seat_recline_extra &#xe636'});
            iconsCategory.push({ description : 'airline_seat_recline_normal &#xe637'});
            iconsCategory.push({ description : 'airplanemode_active &#xe195'});
            iconsCategory.push({ description : 'airplanemode_inactive &#xe194'});
            iconsCategory.push({ description : 'airplay &#xe055'});
            iconsCategory.push({ description : 'airport_shuttle &#xeb3c'});
            iconsCategory.push({ description : 'alarm &#xe855'});
            iconsCategory.push({ description : 'alarm_add &#xe856'});
            iconsCategory.push({ description : 'alarm_off &#xe857'});
            iconsCategory.push({ description : 'alarm_on &#xe858'});
            iconsCategory.push({ description : 'album &#xe019'});
            iconsCategory.push({ description : 'all_inclusive &#xeb3d'});
            iconsCategory.push({ description : 'all_out &#xe90b'});
            iconsCategory.push({ description : 'android &#xe859'});
            iconsCategory.push({ description : 'announcement &#xe85a'});
            iconsCategory.push({ description : 'apps &#xe5c3'});
            iconsCategory.push({ description : 'archive &#xe149'});
            iconsCategory.push({ description : 'arrow_back &#xe5c4'});
            iconsCategory.push({ description : 'arrow_downward &#xe5db'});
            iconsCategory.push({ description : 'arrow_drop_down &#xe5c5'});
            iconsCategory.push({ description : 'arrow_drop_down_circle &#xe5c6'});
            iconsCategory.push({ description : 'arrow_drop_up &#xe5c7'});
            iconsCategory.push({ description : 'arrow_forward &#xe5c8'});
            iconsCategory.push({ description : 'arrow_upward &#xe5d8'});
            iconsCategory.push({ description : 'art_track &#xe060'});
            iconsCategory.push({ description : 'aspect_ratio &#xe85b'});
            iconsCategory.push({ description : 'assessment &#xe85c'});
            iconsCategory.push({ description : 'assignment &#xe85d'});
            iconsCategory.push({ description : 'assignment_ind &#xe85e'});
            iconsCategory.push({ description : 'assignment_late &#xe85f'});
            iconsCategory.push({ description : 'assignment_return &#xe860'});
            iconsCategory.push({ description : 'assignment_returned &#xe861'});
            iconsCategory.push({ description : 'assignment_turned_in &#xe862'});
            iconsCategory.push({ description : 'assistant &#xe39f'});
            iconsCategory.push({ description : 'assistant_photo &#xe3a0'});
            iconsCategory.push({ description : 'attach_file &#xe226'});
            iconsCategory.push({ description : 'attach_money &#xe227'});
            iconsCategory.push({ description : 'attachment &#xe2bc'});
            iconsCategory.push({ description : 'audiotrack &#xe3a1'});
            iconsCategory.push({ description : 'autorenew &#xe863'});
            iconsCategory.push({ description : 'av_timer &#xe01b'});
            iconsCategory.push({ description : 'backspace &#xe14a'});
            iconsCategory.push({ description : 'backup &#xe864'});
            iconsCategory.push({ description : 'battery_alert &#xe19c'});
            iconsCategory.push({ description : 'battery_charging_full &#xe1a3'});
            iconsCategory.push({ description : 'battery_full &#xe1a4'});
            iconsCategory.push({ description : 'battery_std &#xe1a5'});
            iconsCategory.push({ description : 'battery_unknown &#xe1a6'});
            iconsCategory.push({ description : 'beach_access &#xeb3e'});
            iconsCategory.push({ description : 'beenhere &#xe52d'});
            iconsCategory.push({ description : 'block &#xe14b'});
            iconsCategory.push({ description : 'bluetooth &#xe1a7'});
            iconsCategory.push({ description : 'bluetooth_audio &#xe60f'});
            iconsCategory.push({ description : 'bluetooth_connected &#xe1a8'});
            iconsCategory.push({ description : 'bluetooth_disabled &#xe1a9'});
            iconsCategory.push({ description : 'bluetooth_searching &#xe1aa'});
            iconsCategory.push({ description : 'blur_circular &#xe3a2'});
            iconsCategory.push({ description : 'blur_linear &#xe3a3'});
            iconsCategory.push({ description : 'blur_off &#xe3a4'});
            iconsCategory.push({ description : 'blur_on &#xe3a5'});
            iconsCategory.push({ description : 'book &#xe865'});
            iconsCategory.push({ description : 'bookmark &#xe866'});
            iconsCategory.push({ description : 'bookmark_border &#xe867'});
            iconsCategory.push({ description : 'border_all &#xe228'});
            iconsCategory.push({ description : 'border_bottom &#xe229'});
            iconsCategory.push({ description : 'border_clear &#xe22a'});
            iconsCategory.push({ description : 'border_color &#xe22b'});
            iconsCategory.push({ description : 'border_horizontal &#xe22c'});
            iconsCategory.push({ description : 'border_inner &#xe22d'});
            iconsCategory.push({ description : 'border_left &#xe22e'});
            iconsCategory.push({ description : 'border_outer &#xe22f'});
            iconsCategory.push({ description : 'border_right &#xe230'});
            iconsCategory.push({ description : 'border_style &#xe231'});
            iconsCategory.push({ description : 'border_top &#xe232'});
            iconsCategory.push({ description : 'border_vertical &#xe233'});
            iconsCategory.push({ description : 'branding_watermark &#xe06b'});
            iconsCategory.push({ description : 'brightness_1 &#xe3a6'});
            iconsCategory.push({ description : 'brightness_2 &#xe3a7'});
            iconsCategory.push({ description : 'brightness_3 &#xe3a8'});
            iconsCategory.push({ description : 'brightness_4 &#xe3a9'});
            iconsCategory.push({ description : 'brightness_5 &#xe3aa'});
            iconsCategory.push({ description : 'brightness_6 &#xe3ab'});
            iconsCategory.push({ description : 'brightness_7 &#xe3ac'});
            iconsCategory.push({ description : 'brightness_auto &#xe1ab'});
            iconsCategory.push({ description : 'brightness_high &#xe1ac'});
            iconsCategory.push({ description : 'brightness_low &#xe1ad'});
            iconsCategory.push({ description : 'brightness_medium &#xe1ae'});
            iconsCategory.push({ description : 'broken_image &#xe3ad'});
            iconsCategory.push({ description : 'brush &#xe3ae'});
            iconsCategory.push({ description : 'bubble_chart &#xe6dd'});
            iconsCategory.push({ description : 'bug_report &#xe868'});
            iconsCategory.push({ description : 'build &#xe869'});
            iconsCategory.push({ description : 'burst_mode &#xe43c'});
            iconsCategory.push({ description : 'business &#xe0af'});
            iconsCategory.push({ description : 'business_center &#xeb3f'});
            iconsCategory.push({ description : 'cached &#xe86a'});
            iconsCategory.push({ description : 'cake &#xe7e9'});
            iconsCategory.push({ description : 'call &#xe0b0'});
            iconsCategory.push({ description : 'call_end &#xe0b1'});
            iconsCategory.push({ description : 'call_made &#xe0b2'});
            iconsCategory.push({ description : 'call_merge &#xe0b3'});
            iconsCategory.push({ description : 'call_missed &#xe0b4'});
            iconsCategory.push({ description : 'call_missed_outgoing &#xe0e4'});
            iconsCategory.push({ description : 'call_received &#xe0b5'});
            iconsCategory.push({ description : 'call_split &#xe0b6'});
            iconsCategory.push({ description : 'call_to_action &#xe06c'});
            iconsCategory.push({ description : 'camera &#xe3af'});
            iconsCategory.push({ description : 'camera_alt &#xe3b0'});
            iconsCategory.push({ description : 'camera_enhance &#xe8fc'});
            iconsCategory.push({ description : 'camera_front &#xe3b1'});
            iconsCategory.push({ description : 'camera_rear &#xe3b2'});
            iconsCategory.push({ description : 'camera_roll &#xe3b3'});
            iconsCategory.push({ description : 'cancel &#xe5c9'});
            iconsCategory.push({ description : 'card_giftcard &#xe8f6'});
            iconsCategory.push({ description : 'card_membership &#xe8f7'});
            iconsCategory.push({ description : 'card_travel &#xe8f8'});
            iconsCategory.push({ description : 'casino &#xeb40'});
            iconsCategory.push({ description : 'cast &#xe307'});
            iconsCategory.push({ description : 'cast_connected &#xe308'});
            iconsCategory.push({ description : 'center_focus_strong &#xe3b4'});
            iconsCategory.push({ description : 'center_focus_weak &#xe3b5'});
            iconsCategory.push({ description : 'change_history &#xe86b'});
            iconsCategory.push({ description : 'chat &#xe0b7'});
            iconsCategory.push({ description : 'chat_bubble &#xe0ca'});
            iconsCategory.push({ description : 'chat_bubble_outline &#xe0cb'});
            iconsCategory.push({ description : 'check &#xe5ca'});
            iconsCategory.push({ description : 'check_box &#xe834'});
            iconsCategory.push({ description : 'check_box_outline_blank &#xe835'});
            iconsCategory.push({ description : 'check_circle &#xe86c'});
            iconsCategory.push({ description : 'chevron_left &#xe5cb'});
            iconsCategory.push({ description : 'chevron_right &#xe5cc'});
            iconsCategory.push({ description : 'child_care &#xeb41'});
            iconsCategory.push({ description : 'child_friendly &#xeb42'});
            iconsCategory.push({ description : 'chrome_reader_mode &#xe86d'});
            iconsCategory.push({ description : 'class &#xe86e'});
            iconsCategory.push({ description : 'clear &#xe14c'});
            iconsCategory.push({ description : 'clear_all &#xe0b8'});
            iconsCategory.push({ description : 'close &#xe5cd'});
            iconsCategory.push({ description : 'closed_caption &#xe01c'});
            iconsCategory.push({ description : 'cloud &#xe2bd'});
            iconsCategory.push({ description : 'cloud_circle &#xe2be'});
            iconsCategory.push({ description : 'cloud_done &#xe2bf'});
            iconsCategory.push({ description : 'cloud_download &#xe2c0'});
            iconsCategory.push({ description : 'cloud_off &#xe2c1'});
            iconsCategory.push({ description : 'cloud_queue &#xe2c2'});
            iconsCategory.push({ description : 'cloud_upload &#xe2c3'});
            iconsCategory.push({ description : 'code &#xe86f'});
            iconsCategory.push({ description : 'collections &#xe3b6'});
            iconsCategory.push({ description : 'collections_bookmark &#xe431'});
            iconsCategory.push({ description : 'color_lens &#xe3b7'});
            iconsCategory.push({ description : 'colorize &#xe3b8'});
            iconsCategory.push({ description : 'comment &#xe0b9'});
            iconsCategory.push({ description : 'compare &#xe3b9'});
            iconsCategory.push({ description : 'compare_arrows &#xe915'});
            iconsCategory.push({ description : 'computer &#xe30a'});
            iconsCategory.push({ description : 'confirmation_number &#xe638'});
            iconsCategory.push({ description : 'contact_mail &#xe0d0'});
            iconsCategory.push({ description : 'contact_phone &#xe0cf'});
            iconsCategory.push({ description : 'contacts &#xe0ba'});
            iconsCategory.push({ description : 'content_copy &#xe14d'});
            iconsCategory.push({ description : 'content_cut &#xe14e'});
            iconsCategory.push({ description : 'content_paste &#xe14f'});
            iconsCategory.push({ description : 'control_point &#xe3ba'});
            iconsCategory.push({ description : 'control_point_duplicate &#xe3bb'});
            iconsCategory.push({ description : 'copyright &#xe90c'});
            iconsCategory.push({ description : 'create &#xe150'});
            iconsCategory.push({ description : 'create_new_folder &#xe2cc'});
            iconsCategory.push({ description : 'credit_card &#xe870'});
            iconsCategory.push({ description : 'crop &#xe3be'});
            iconsCategory.push({ description : 'crop_16_9 &#xe3bc'});
            iconsCategory.push({ description : 'crop_3_2 &#xe3bd'});
            iconsCategory.push({ description : 'crop_5_4 &#xe3bf'});
            iconsCategory.push({ description : 'crop_7_5 &#xe3c0'});
            iconsCategory.push({ description : 'crop_din &#xe3c1'});
            iconsCategory.push({ description : 'crop_free &#xe3c2'});
            iconsCategory.push({ description : 'crop_landscape &#xe3c3'});
            iconsCategory.push({ description : 'crop_original &#xe3c4'});
            iconsCategory.push({ description : 'crop_portrait &#xe3c5'});
            iconsCategory.push({ description : 'crop_rotate &#xe437'});
            iconsCategory.push({ description : 'crop_square &#xe3c6'});
            iconsCategory.push({ description : 'dashboard &#xe871'});
            iconsCategory.push({ description : 'data_usage &#xe1af'});
            iconsCategory.push({ description : 'date_range &#xe916'});
            iconsCategory.push({ description : 'dehaze &#xe3c7'});
            iconsCategory.push({ description : 'delete &#xe872'});
            iconsCategory.push({ description : 'delete_forever &#xe92b'});
            iconsCategory.push({ description : 'delete_sweep &#xe16c'});
            iconsCategory.push({ description : 'description &#xe873'});
            iconsCategory.push({ description : 'desktop_mac &#xe30b'});
            iconsCategory.push({ description : 'desktop_windows &#xe30c'});
            iconsCategory.push({ description : 'details &#xe3c8'});
            iconsCategory.push({ description : 'developer_board &#xe30d'});
            iconsCategory.push({ description : 'developer_mode &#xe1b0'});
            iconsCategory.push({ description : 'device_hub &#xe335'});
            iconsCategory.push({ description : 'devices &#xe1b1'});
            iconsCategory.push({ description : 'devices_other &#xe337'});
            iconsCategory.push({ description : 'dialer_sip &#xe0bb'});
            iconsCategory.push({ description : 'dialpad &#xe0bc'});
            iconsCategory.push({ description : 'directions &#xe52e'});
            iconsCategory.push({ description : 'directions_bike &#xe52f'});
            iconsCategory.push({ description : 'directions_boat &#xe532'});
            iconsCategory.push({ description : 'directions_bus &#xe530'});
            iconsCategory.push({ description : 'directions_car &#xe531'});
            iconsCategory.push({ description : 'directions_railway &#xe534'});
            iconsCategory.push({ description : 'directions_run &#xe566'});
            iconsCategory.push({ description : 'directions_subway &#xe533'});
            iconsCategory.push({ description : 'directions_transit &#xe535'});
            iconsCategory.push({ description : 'directions_walk &#xe536'});
            iconsCategory.push({ description : 'disc_full &#xe610'});
            iconsCategory.push({ description : 'dns &#xe875'});
            iconsCategory.push({ description : 'do_not_disturb &#xe612'});
            iconsCategory.push({ description : 'do_not_disturb_alt &#xe611'});
            iconsCategory.push({ description : 'do_not_disturb_off &#xe643'});
            iconsCategory.push({ description : 'do_not_disturb_on &#xe644'});
            iconsCategory.push({ description : 'dock &#xe30e'});
            iconsCategory.push({ description : 'domain &#xe7ee'});
            iconsCategory.push({ description : 'done &#xe876'});
            iconsCategory.push({ description : 'done_all &#xe877'});
            iconsCategory.push({ description : 'donut_large &#xe917'});
            iconsCategory.push({ description : 'donut_small &#xe918'});
            iconsCategory.push({ description : 'drafts &#xe151'});
            iconsCategory.push({ description : 'drag_handle &#xe25d'});
            iconsCategory.push({ description : 'drive_eta &#xe613'});
            iconsCategory.push({ description : 'dvr &#xe1b2'});
            iconsCategory.push({ description : 'edit &#xe3c9'});
            iconsCategory.push({ description : 'edit_location &#xe568'});
            iconsCategory.push({ description : 'eject &#xe8fb'});
            iconsCategory.push({ description : 'email &#xe0be'});
            iconsCategory.push({ description : 'enhanced_encryption &#xe63f'});
            iconsCategory.push({ description : 'equalizer &#xe01d'});
            iconsCategory.push({ description : 'error &#xe000'});
            iconsCategory.push({ description : 'error_outline &#xe001'});
            iconsCategory.push({ description : 'euro_symbol &#xe926'});
            iconsCategory.push({ description : 'ev_station &#xe56d'});
            iconsCategory.push({ description : 'event &#xe878'});
            iconsCategory.push({ description : 'event_available &#xe614'});
            iconsCategory.push({ description : 'event_busy &#xe615'});
            iconsCategory.push({ description : 'event_note &#xe616'});
            iconsCategory.push({ description : 'event_seat &#xe903'});
            iconsCategory.push({ description : 'exit_to_app &#xe879'});
            iconsCategory.push({ description : 'expand_less &#xe5ce'});
            iconsCategory.push({ description : 'expand_more &#xe5cf'});
            iconsCategory.push({ description : 'explicit &#xe01e'});
            iconsCategory.push({ description : 'explore &#xe87a'});
            iconsCategory.push({ description : 'exposure &#xe3ca'});
            iconsCategory.push({ description : 'exposure_neg_1 &#xe3cb'});
            iconsCategory.push({ description : 'exposure_neg_2 &#xe3cc'});
            iconsCategory.push({ description : 'exposure_plus_1 &#xe3cd'});
            iconsCategory.push({ description : 'exposure_plus_2 &#xe3ce'});
            iconsCategory.push({ description : 'exposure_zero &#xe3cf'});
            iconsCategory.push({ description : 'extension &#xe87b'});
            iconsCategory.push({ description : 'face &#xe87c'});
            iconsCategory.push({ description : 'fast_forward &#xe01f'});
            iconsCategory.push({ description : 'fast_rewind &#xe020'});
            iconsCategory.push({ description : 'favorite &#xe87d'});
            iconsCategory.push({ description : 'favorite_border &#xe87e'});
            iconsCategory.push({ description : 'featured_play_list &#xe06d'});
            iconsCategory.push({ description : 'featured_video &#xe06e'});
            iconsCategory.push({ description : 'feedback &#xe87f'});
            iconsCategory.push({ description : 'fiber_dvr &#xe05d'});
            iconsCategory.push({ description : 'fiber_manual_record &#xe061'});
            iconsCategory.push({ description : 'fiber_new &#xe05e'});
            iconsCategory.push({ description : 'fiber_pin &#xe06a'});
            iconsCategory.push({ description : 'fiber_smart_record &#xe062'});
            iconsCategory.push({ description : 'file_download &#xe2c4'});
            iconsCategory.push({ description : 'file_upload &#xe2c6'});
            iconsCategory.push({ description : 'filter &#xe3d3'});
            iconsCategory.push({ description : 'filter_1 &#xe3d0'});
            iconsCategory.push({ description : 'filter_2 &#xe3d1'});
            iconsCategory.push({ description : 'filter_3 &#xe3d2'});
            iconsCategory.push({ description : 'filter_4 &#xe3d4'});
            iconsCategory.push({ description : 'filter_5 &#xe3d5'});
            iconsCategory.push({ description : 'filter_6 &#xe3d6'});
            iconsCategory.push({ description : 'filter_7 &#xe3d7'});
            iconsCategory.push({ description : 'filter_8 &#xe3d8'});
            iconsCategory.push({ description : 'filter_9 &#xe3d9'});
            iconsCategory.push({ description : 'filter_9_plus &#xe3da'});
            iconsCategory.push({ description : 'filter_b_and_w &#xe3db'});
            iconsCategory.push({ description : 'filter_center_focus &#xe3dc'});
            iconsCategory.push({ description : 'filter_drama &#xe3dd'});
            iconsCategory.push({ description : 'filter_frames &#xe3de'});
            iconsCategory.push({ description : 'filter_hdr &#xe3df'});
            iconsCategory.push({ description : 'filter_list &#xe152'});
            iconsCategory.push({ description : 'filter_none &#xe3e0'});
            iconsCategory.push({ description : 'filter_tilt_shift &#xe3e2'});
            iconsCategory.push({ description : 'filter_vintage &#xe3e3'});
            iconsCategory.push({ description : 'find_in_page &#xe880'});
            iconsCategory.push({ description : 'find_replace &#xe881'});
            iconsCategory.push({ description : 'fingerprint &#xe90d'});
            iconsCategory.push({ description : 'first_page &#xe5dc'});
            iconsCategory.push({ description : 'fitness_center &#xeb43'});
            iconsCategory.push({ description : 'flag &#xe153'});
            iconsCategory.push({ description : 'flare &#xe3e4'});
            iconsCategory.push({ description : 'flash_auto &#xe3e5'});
            iconsCategory.push({ description : 'flash_off &#xe3e6'});
            iconsCategory.push({ description : 'flash_on &#xe3e7'});
            iconsCategory.push({ description : 'flight &#xe539'});
            iconsCategory.push({ description : 'flight_land &#xe904'});
            iconsCategory.push({ description : 'flight_takeoff &#xe905'});
            iconsCategory.push({ description : 'flip &#xe3e8'});
            iconsCategory.push({ description : 'flip_to_back &#xe882'});
            iconsCategory.push({ description : 'flip_to_front &#xe883'});
            iconsCategory.push({ description : 'folder &#xe2c7'});
            iconsCategory.push({ description : 'folder_open &#xe2c8'});
            iconsCategory.push({ description : 'folder_shared &#xe2c9'});
            iconsCategory.push({ description : 'folder_special &#xe617'});
            iconsCategory.push({ description : 'font_download &#xe167'});
            iconsCategory.push({ description : 'format_align_center &#xe234'});
            iconsCategory.push({ description : 'format_align_justify &#xe235'});
            iconsCategory.push({ description : 'format_align_left &#xe236'});
            iconsCategory.push({ description : 'format_align_right &#xe237'});
            iconsCategory.push({ description : 'format_bold &#xe238'});
            iconsCategory.push({ description : 'format_clear &#xe239'});
            iconsCategory.push({ description : 'format_color_fill &#xe23a'});
            iconsCategory.push({ description : 'format_color_reset &#xe23b'});
            iconsCategory.push({ description : 'format_color_text &#xe23c'});
            iconsCategory.push({ description : 'format_indent_decrease &#xe23d'});
            iconsCategory.push({ description : 'format_indent_increase &#xe23e'});
            iconsCategory.push({ description : 'format_italic &#xe23f'});
            iconsCategory.push({ description : 'format_line_spacing &#xe240'});
            iconsCategory.push({ description : 'format_list_bulleted &#xe241'});
            iconsCategory.push({ description : 'format_list_numbered &#xe242'});
            iconsCategory.push({ description : 'format_paint &#xe243'});
            iconsCategory.push({ description : 'format_quote &#xe244'});
            iconsCategory.push({ description : 'format_shapes &#xe25e'});
            iconsCategory.push({ description : 'format_size &#xe245'});
            iconsCategory.push({ description : 'format_strikethrough &#xe246'});
            iconsCategory.push({ description : 'format_textdirection_l_to_r &#xe247'});
            iconsCategory.push({ description : 'format_textdirection_r_to_l &#xe248'});
            iconsCategory.push({ description : 'format_underlined &#xe249'});
            iconsCategory.push({ description : 'forum &#xe0bf'});
            iconsCategory.push({ description : 'forward &#xe154'});
            iconsCategory.push({ description : 'forward_10 &#xe056'});
            iconsCategory.push({ description : 'forward_30 &#xe057'});
            iconsCategory.push({ description : 'forward_5 &#xe058'});
            iconsCategory.push({ description : 'free_breakfast &#xeb44'});
            iconsCategory.push({ description : 'fullscreen &#xe5d0'});
            iconsCategory.push({ description : 'fullscreen_exit &#xe5d1'});
            iconsCategory.push({ description : 'functions &#xe24a'});
            iconsCategory.push({ description : 'g_translate &#xe927'});
            iconsCategory.push({ description : 'gamepad &#xe30f'});
            iconsCategory.push({ description : 'games &#xe021'});
            iconsCategory.push({ description : 'gavel &#xe90e'});
            iconsCategory.push({ description : 'gesture &#xe155'});
            iconsCategory.push({ description : 'get_app &#xe884'});
            iconsCategory.push({ description : 'gif &#xe908'});
            iconsCategory.push({ description : 'golf_course &#xeb45'});
            iconsCategory.push({ description : 'gps_fixed &#xe1b3'});
            iconsCategory.push({ description : 'gps_not_fixed &#xe1b4'});
            iconsCategory.push({ description : 'gps_off &#xe1b5'});
            iconsCategory.push({ description : 'grade &#xe885'});
            iconsCategory.push({ description : 'gradient &#xe3e9'});
            iconsCategory.push({ description : 'grain &#xe3ea'});
            iconsCategory.push({ description : 'graphic_eq &#xe1b8'});
            iconsCategory.push({ description : 'grid_off &#xe3eb'});
            iconsCategory.push({ description : 'grid_on &#xe3ec'});
            iconsCategory.push({ description : 'group &#xe7ef'});
            iconsCategory.push({ description : 'group_add &#xe7f0'});
            iconsCategory.push({ description : 'group_work &#xe886'});
            iconsCategory.push({ description : 'hd &#xe052'});
            iconsCategory.push({ description : 'hdr_off &#xe3ed'});
            iconsCategory.push({ description : 'hdr_on &#xe3ee'});
            iconsCategory.push({ description : 'hdr_strong &#xe3f1'});
            iconsCategory.push({ description : 'hdr_weak &#xe3f2'});
            iconsCategory.push({ description : 'headset &#xe310'});
            iconsCategory.push({ description : 'headset_mic &#xe311'});
            iconsCategory.push({ description : 'healing &#xe3f3'});
            iconsCategory.push({ description : 'hearing &#xe023'});
            iconsCategory.push({ description : 'help &#xe887'});
            iconsCategory.push({ description : 'help_outline &#xe8fd'});
            iconsCategory.push({ description : 'high_quality &#xe024'});
            iconsCategory.push({ description : 'highlight &#xe25f'});
            iconsCategory.push({ description : 'highlight_off &#xe888'});
            iconsCategory.push({ description : 'history &#xe889'});
            iconsCategory.push({ description : 'home &#xe88a'});
            iconsCategory.push({ description : 'hot_tub &#xeb46'});
            iconsCategory.push({ description : 'hotel &#xe53a'});
            iconsCategory.push({ description : 'hourglass_empty &#xe88b'});
            iconsCategory.push({ description : 'hourglass_full &#xe88c'});
            iconsCategory.push({ description : 'http &#xe902'});
            iconsCategory.push({ description : 'https &#xe88d'});
            iconsCategory.push({ description : 'image &#xe3f4'});
            iconsCategory.push({ description : 'image_aspect_ratio &#xe3f5'});
            iconsCategory.push({ description : 'import_contacts &#xe0e0'});
            iconsCategory.push({ description : 'import_export &#xe0c3'});
            iconsCategory.push({ description : 'important_devices &#xe912'});
            iconsCategory.push({ description : 'inbox &#xe156'});
            iconsCategory.push({ description : 'indeterminate_check_box &#xe909'});
            iconsCategory.push({ description : 'info &#xe88e'});
            iconsCategory.push({ description : 'info_outline &#xe88f'});
            iconsCategory.push({ description : 'input &#xe890'});
            iconsCategory.push({ description : 'insert_chart &#xe24b'});
            iconsCategory.push({ description : 'insert_comment &#xe24c'});
            iconsCategory.push({ description : 'insert_drive_file &#xe24d'});
            iconsCategory.push({ description : 'insert_emoticon &#xe24e'});
            iconsCategory.push({ description : 'insert_invitation &#xe24f'});
            iconsCategory.push({ description : 'insert_link &#xe250'});
            iconsCategory.push({ description : 'insert_photo &#xe251'});
            iconsCategory.push({ description : 'invert_colors &#xe891'});
            iconsCategory.push({ description : 'invert_colors_off &#xe0c4'});
            iconsCategory.push({ description : 'iso &#xe3f6'});
            iconsCategory.push({ description : 'keyboard &#xe312'});
            iconsCategory.push({ description : 'keyboard_arrow_down &#xe313'});
            iconsCategory.push({ description : 'keyboard_arrow_left &#xe314'});
            iconsCategory.push({ description : 'keyboard_arrow_right &#xe315'});
            iconsCategory.push({ description : 'keyboard_arrow_up &#xe316'});
            iconsCategory.push({ description : 'keyboard_backspace &#xe317'});
            iconsCategory.push({ description : 'keyboard_capslock &#xe318'});
            iconsCategory.push({ description : 'keyboard_hide &#xe31a'});
            iconsCategory.push({ description : 'keyboard_return &#xe31b'});
            iconsCategory.push({ description : 'keyboard_tab &#xe31c'});
            iconsCategory.push({ description : 'keyboard_voice &#xe31d'});
            iconsCategory.push({ description : 'kitchen &#xeb47'});
            iconsCategory.push({ description : 'label &#xe892'});
            iconsCategory.push({ description : 'label_outline &#xe893'});
            iconsCategory.push({ description : 'landscape &#xe3f7'});
            iconsCategory.push({ description : 'language &#xe894'});
            iconsCategory.push({ description : 'laptop &#xe31e'});
            iconsCategory.push({ description : 'laptop_chromebook &#xe31f'});
            iconsCategory.push({ description : 'laptop_mac &#xe320'});
            iconsCategory.push({ description : 'laptop_windows &#xe321'});
            iconsCategory.push({ description : 'last_page &#xe5dd'});
            iconsCategory.push({ description : 'launch &#xe895'});
            iconsCategory.push({ description : 'layers &#xe53b'});
            iconsCategory.push({ description : 'layers_clear &#xe53c'});
            iconsCategory.push({ description : 'leak_add &#xe3f8'});
            iconsCategory.push({ description : 'leak_remove &#xe3f9'});
            iconsCategory.push({ description : 'lens &#xe3fa'});
            iconsCategory.push({ description : 'library_add &#xe02e'});
            iconsCategory.push({ description : 'library_books &#xe02f'});
            iconsCategory.push({ description : 'library_music &#xe030'});
            iconsCategory.push({ description : 'lightbulb_outline &#xe90f'});
            iconsCategory.push({ description : 'line_style &#xe919'});
            iconsCategory.push({ description : 'line_weight &#xe91a'});
            iconsCategory.push({ description : 'linear_scale &#xe260'});
            iconsCategory.push({ description : 'link &#xe157'});
            iconsCategory.push({ description : 'linked_camera &#xe438'});
            iconsCategory.push({ description : 'list &#xe896'});
            iconsCategory.push({ description : 'live_help &#xe0c6'});
            iconsCategory.push({ description : 'live_tv &#xe639'});
            iconsCategory.push({ description : 'local_activity &#xe53f'});
            iconsCategory.push({ description : 'local_airport &#xe53d'});
            iconsCategory.push({ description : 'local_atm &#xe53e'});
            iconsCategory.push({ description : 'local_bar &#xe540'});
            iconsCategory.push({ description : 'local_cafe &#xe541'});
            iconsCategory.push({ description : 'local_car_wash &#xe542'});
            iconsCategory.push({ description : 'local_convenience_store &#xe543'});
            iconsCategory.push({ description : 'local_dining &#xe556'});
            iconsCategory.push({ description : 'local_drink &#xe544'});
            iconsCategory.push({ description : 'local_florist &#xe545'});
            iconsCategory.push({ description : 'local_gas_station &#xe546'});
            iconsCategory.push({ description : 'local_grocery_store &#xe547'});
            iconsCategory.push({ description : 'local_hospital &#xe548'});
            iconsCategory.push({ description : 'local_hotel &#xe549'});
            iconsCategory.push({ description : 'local_laundry_service &#xe54a'});
            iconsCategory.push({ description : 'local_library &#xe54b'});
            iconsCategory.push({ description : 'local_mall &#xe54c'});
            iconsCategory.push({ description : 'local_movies &#xe54d'});
            iconsCategory.push({ description : 'local_offer &#xe54e'});
            iconsCategory.push({ description : 'local_parking &#xe54f'});
            iconsCategory.push({ description : 'local_pharmacy &#xe550'});
            iconsCategory.push({ description : 'local_phone &#xe551'});
            iconsCategory.push({ description : 'local_pizza &#xe552'});
            iconsCategory.push({ description : 'local_play &#xe553'});
            iconsCategory.push({ description : 'local_post_office &#xe554'});
            iconsCategory.push({ description : 'local_printshop &#xe555'});
            iconsCategory.push({ description : 'local_see &#xe557'});
            iconsCategory.push({ description : 'local_shipping &#xe558'});
            iconsCategory.push({ description : 'local_taxi &#xe559'});
            iconsCategory.push({ description : 'location_city &#xe7f1'});
            iconsCategory.push({ description : 'location_disabled &#xe1b6'});
            iconsCategory.push({ description : 'location_off &#xe0c7'});
            iconsCategory.push({ description : 'location_on &#xe0c8'});
            iconsCategory.push({ description : 'location_searching &#xe1b7'});
            iconsCategory.push({ description : 'lock &#xe897'});
            iconsCategory.push({ description : 'lock_open &#xe898'});
            iconsCategory.push({ description : 'lock_outline &#xe899'});
            iconsCategory.push({ description : 'looks &#xe3fc'});
            iconsCategory.push({ description : 'looks_3 &#xe3fb'});
            iconsCategory.push({ description : 'looks_4 &#xe3fd'});
            iconsCategory.push({ description : 'looks_5 &#xe3fe'});
            iconsCategory.push({ description : 'looks_6 &#xe3ff'});
            iconsCategory.push({ description : 'looks_one &#xe400'});
            iconsCategory.push({ description : 'looks_two &#xe401'});
            iconsCategory.push({ description : 'loop &#xe028'});
            iconsCategory.push({ description : 'loupe &#xe402'});
            iconsCategory.push({ description : 'low_priority &#xe16d'});
            iconsCategory.push({ description : 'loyalty &#xe89a'});
            iconsCategory.push({ description : 'mail &#xe158'});
            iconsCategory.push({ description : 'mail_outline &#xe0e1'});
            iconsCategory.push({ description : 'map &#xe55b'});
            iconsCategory.push({ description : 'markunread &#xe159'});
            iconsCategory.push({ description : 'markunread_mailbox &#xe89b'});
            iconsCategory.push({ description : 'memory &#xe322'});
            iconsCategory.push({ description : 'menu &#xe5d2'});
            iconsCategory.push({ description : 'merge_type &#xe252'});
            iconsCategory.push({ description : 'message &#xe0c9'});
            iconsCategory.push({ description : 'mic &#xe029'});
            iconsCategory.push({ description : 'mic_none &#xe02a'});
            iconsCategory.push({ description : 'mic_off &#xe02b'});
            iconsCategory.push({ description : 'mms &#xe618'});
            iconsCategory.push({ description : 'mode_comment &#xe253'});
            iconsCategory.push({ description : 'mode_edit &#xe254'});
            iconsCategory.push({ description : 'monetization_on &#xe263'});
            iconsCategory.push({ description : 'money_off &#xe25c'});
            iconsCategory.push({ description : 'monochrome_photos &#xe403'});
            iconsCategory.push({ description : 'mood &#xe7f2'});
            iconsCategory.push({ description : 'mood_bad &#xe7f3'});
            iconsCategory.push({ description : 'more &#xe619'});
            iconsCategory.push({ description : 'more_horiz &#xe5d3'});
            iconsCategory.push({ description : 'more_vert &#xe5d4'});
            iconsCategory.push({ description : 'motorcycle &#xe91b'});
            iconsCategory.push({ description : 'mouse &#xe323'});
            iconsCategory.push({ description : 'move_to_inbox &#xe168'});
            iconsCategory.push({ description : 'movie &#xe02c'});
            iconsCategory.push({ description : 'movie_creation &#xe404'});
            iconsCategory.push({ description : 'movie_filter &#xe43a'});
            iconsCategory.push({ description : 'multiline_chart &#xe6df'});
            iconsCategory.push({ description : 'music_note &#xe405'});
            iconsCategory.push({ description : 'music_video &#xe063'});
            iconsCategory.push({ description : 'my_location &#xe55c'});
            iconsCategory.push({ description : 'nature &#xe406'});
            iconsCategory.push({ description : 'nature_people &#xe407'});
            iconsCategory.push({ description : 'navigate_before &#xe408'});
            iconsCategory.push({ description : 'navigate_next &#xe409'});
            iconsCategory.push({ description : 'navigation &#xe55d'});
            iconsCategory.push({ description : 'near_me &#xe569'});
            iconsCategory.push({ description : 'network_cell &#xe1b9'});
            iconsCategory.push({ description : 'network_check &#xe640'});
            iconsCategory.push({ description : 'network_locked &#xe61a'});
            iconsCategory.push({ description : 'network_wifi &#xe1ba'});
            iconsCategory.push({ description : 'new_releases &#xe031'});
            iconsCategory.push({ description : 'next_week &#xe16a'});
            iconsCategory.push({ description : 'nfc &#xe1bb'});
            iconsCategory.push({ description : 'no_encryption &#xe641'});
            iconsCategory.push({ description : 'no_sim &#xe0cc'});
            iconsCategory.push({ description : 'not_interested &#xe033'});
            iconsCategory.push({ description : 'note &#xe06f'});
            iconsCategory.push({ description : 'note_add &#xe89c'});
            iconsCategory.push({ description : 'notifications &#xe7f4'});
            iconsCategory.push({ description : 'notifications_active &#xe7f7'});
            iconsCategory.push({ description : 'notifications_none &#xe7f5'});
            iconsCategory.push({ description : 'notifications_off &#xe7f6'});
            iconsCategory.push({ description : 'notifications_paused &#xe7f8'});
            iconsCategory.push({ description : 'offline_pin &#xe90a'});
            iconsCategory.push({ description : 'ondemand_video &#xe63a'});
            iconsCategory.push({ description : 'opacity &#xe91c'});
            iconsCategory.push({ description : 'open_in_browser &#xe89d'});
            iconsCategory.push({ description : 'open_in_new &#xe89e'});
            iconsCategory.push({ description : 'open_with &#xe89f'});
            iconsCategory.push({ description : 'pages &#xe7f9'});
            iconsCategory.push({ description : 'pageview &#xe8a0'});
            iconsCategory.push({ description : 'palette &#xe40a'});
            iconsCategory.push({ description : 'pan_tool &#xe925'});
            iconsCategory.push({ description : 'panorama &#xe40b'});
            iconsCategory.push({ description : 'panorama_fish_eye &#xe40c'});
            iconsCategory.push({ description : 'panorama_horizontal &#xe40d'});
            iconsCategory.push({ description : 'panorama_vertical &#xe40e'});
            iconsCategory.push({ description : 'panorama_wide_angle &#xe40f'});
            iconsCategory.push({ description : 'party_mode &#xe7fa'});
            iconsCategory.push({ description : 'pause &#xe034'});
            iconsCategory.push({ description : 'pause_circle_filled &#xe035'});
            iconsCategory.push({ description : 'pause_circle_outline &#xe036'});
            iconsCategory.push({ description : 'payment &#xe8a1'});
            iconsCategory.push({ description : 'people &#xe7fb'});
            iconsCategory.push({ description : 'people_outline &#xe7fc'});
            iconsCategory.push({ description : 'perm_camera_mic &#xe8a2'});
            iconsCategory.push({ description : 'perm_contact_calendar &#xe8a3'});
            iconsCategory.push({ description : 'perm_data_setting &#xe8a4'});
            iconsCategory.push({ description : 'perm_device_information &#xe8a5'});
            iconsCategory.push({ description : 'perm_identity &#xe8a6'});
            iconsCategory.push({ description : 'perm_media &#xe8a7'});
            iconsCategory.push({ description : 'perm_phone_msg &#xe8a8'});
            iconsCategory.push({ description : 'perm_scan_wifi &#xe8a9'});
            iconsCategory.push({ description : 'person &#xe7fd'});
            iconsCategory.push({ description : 'person_add &#xe7fe'});
            iconsCategory.push({ description : 'person_outline &#xe7ff'});
            iconsCategory.push({ description : 'person_pin &#xe55a'});
            iconsCategory.push({ description : 'person_pin_circle &#xe56a'});
            iconsCategory.push({ description : 'personal_video &#xe63b'});
            iconsCategory.push({ description : 'pets &#xe91d'});
            iconsCategory.push({ description : 'phone &#xe0cd'});
            iconsCategory.push({ description : 'phone_android &#xe324'});
            iconsCategory.push({ description : 'phone_bluetooth_speaker &#xe61b'});
            iconsCategory.push({ description : 'phone_forwarded &#xe61c'});
            iconsCategory.push({ description : 'phone_in_talk &#xe61d'});
            iconsCategory.push({ description : 'phone_iphone &#xe325'});
            iconsCategory.push({ description : 'phone_locked &#xe61e'});
            iconsCategory.push({ description : 'phone_missed &#xe61f'});
            iconsCategory.push({ description : 'phone_paused &#xe620'});
            iconsCategory.push({ description : 'phonelink &#xe326'});
            iconsCategory.push({ description : 'phonelink_erase &#xe0db'});
            iconsCategory.push({ description : 'phonelink_lock &#xe0dc'});
            iconsCategory.push({ description : 'phonelink_off &#xe327'});
            iconsCategory.push({ description : 'phonelink_ring &#xe0dd'});
            iconsCategory.push({ description : 'phonelink_setup &#xe0de'});
            iconsCategory.push({ description : 'photo &#xe410'});
            iconsCategory.push({ description : 'photo_album &#xe411'});
            iconsCategory.push({ description : 'photo_camera &#xe412'});
            iconsCategory.push({ description : 'photo_filter &#xe43b'});
            iconsCategory.push({ description : 'photo_library &#xe413'});
            iconsCategory.push({ description : 'photo_size_select_actual &#xe432'});
            iconsCategory.push({ description : 'photo_size_select_large &#xe433'});
            iconsCategory.push({ description : 'photo_size_select_small &#xe434'});
            iconsCategory.push({ description : 'picture_as_pdf &#xe415'});
            iconsCategory.push({ description : 'picture_in_picture &#xe8aa'});
            iconsCategory.push({ description : 'picture_in_picture_alt &#xe911'});
            iconsCategory.push({ description : 'pie_chart &#xe6c4'});
            iconsCategory.push({ description : 'pie_chart_outlined &#xe6c5'});
            iconsCategory.push({ description : 'pin_drop &#xe55e'});
            iconsCategory.push({ description : 'place &#xe55f'});
            iconsCategory.push({ description : 'play_arrow &#xe037'});
            iconsCategory.push({ description : 'play_circle_filled &#xe038'});
            iconsCategory.push({ description : 'play_circle_outline &#xe039'});
            iconsCategory.push({ description : 'play_for_work &#xe906'});
            iconsCategory.push({ description : 'playlist_add &#xe03b'});
            iconsCategory.push({ description : 'playlist_add_check &#xe065'});
            iconsCategory.push({ description : 'playlist_play &#xe05f'});
            iconsCategory.push({ description : 'plus_one &#xe800'});
            iconsCategory.push({ description : 'poll &#xe801'});
            iconsCategory.push({ description : 'polymer &#xe8ab'});
            iconsCategory.push({ description : 'pool &#xeb48'});
            iconsCategory.push({ description : 'portable_wifi_off &#xe0ce'});
            iconsCategory.push({ description : 'portrait &#xe416'});
            iconsCategory.push({ description : 'power &#xe63c'});
            iconsCategory.push({ description : 'power_input &#xe336'});
            iconsCategory.push({ description : 'power_settings_new &#xe8ac'});
            iconsCategory.push({ description : 'pregnant_woman &#xe91e'});
            iconsCategory.push({ description : 'present_to_all &#xe0df'});
            iconsCategory.push({ description : 'print &#xe8ad'});
            iconsCategory.push({ description : 'priority_high &#xe645'});
            iconsCategory.push({ description : 'public &#xe80b'});
            iconsCategory.push({ description : 'publish &#xe255'});
            iconsCategory.push({ description : 'query_builder &#xe8ae'});
            iconsCategory.push({ description : 'question_answer &#xe8af'});
            iconsCategory.push({ description : 'queue &#xe03c'});
            iconsCategory.push({ description : 'queue_music &#xe03d'});
            iconsCategory.push({ description : 'queue_play_next &#xe066'});
            iconsCategory.push({ description : 'radio &#xe03e'});
            iconsCategory.push({ description : 'radio_button_checked &#xe837'});
            iconsCategory.push({ description : 'radio_button_unchecked &#xe836'});
            iconsCategory.push({ description : 'rate_review &#xe560'});
            iconsCategory.push({ description : 'receipt &#xe8b0'});
            iconsCategory.push({ description : 'recent_actors &#xe03f'});
            iconsCategory.push({ description : 'record_voice_over &#xe91f'});
            iconsCategory.push({ description : 'redeem &#xe8b1'});
            iconsCategory.push({ description : 'redo &#xe15a'});
            iconsCategory.push({ description : 'refresh &#xe5d5'});
            iconsCategory.push({ description : 'remove &#xe15b'});
            iconsCategory.push({ description : 'remove_circle &#xe15c'});
            iconsCategory.push({ description : 'remove_circle_outline &#xe15d'});
            iconsCategory.push({ description : 'remove_from_queue &#xe067'});
            iconsCategory.push({ description : 'remove_red_eye &#xe417'});
            iconsCategory.push({ description : 'remove_shopping_cart &#xe928'});
            iconsCategory.push({ description : 'reorder &#xe8fe'});
            iconsCategory.push({ description : 'repeat &#xe040'});
            iconsCategory.push({ description : 'repeat_one &#xe041'});
            iconsCategory.push({ description : 'replay &#xe042'});
            iconsCategory.push({ description : 'replay_10 &#xe059'});
            iconsCategory.push({ description : 'replay_30 &#xe05a'});
            iconsCategory.push({ description : 'replay_5 &#xe05b'});
            iconsCategory.push({ description : 'reply &#xe15e'});
            iconsCategory.push({ description : 'reply_all &#xe15f'});
            iconsCategory.push({ description : 'report &#xe160'});
            iconsCategory.push({ description : 'report_problem &#xe8b2'});
            iconsCategory.push({ description : 'restaurant &#xe56c'});
            iconsCategory.push({ description : 'restaurant_menu &#xe561'});
            iconsCategory.push({ description : 'restore &#xe8b3'});
            iconsCategory.push({ description : 'restore_page &#xe929'});
            iconsCategory.push({ description : 'ring_volume &#xe0d1'});
            iconsCategory.push({ description : 'room &#xe8b4'});
            iconsCategory.push({ description : 'room_service &#xeb49'});
            iconsCategory.push({ description : 'rotate_90_degrees_ccw &#xe418'});
            iconsCategory.push({ description : 'rotate_left &#xe419'});
            iconsCategory.push({ description : 'rotate_right &#xe41a'});
            iconsCategory.push({ description : 'rounded_corner &#xe920'});
            iconsCategory.push({ description : 'router &#xe328'});
            iconsCategory.push({ description : 'rowing &#xe921'});
            iconsCategory.push({ description : 'rss_feed &#xe0e5'});
            iconsCategory.push({ description : 'rv_hookup &#xe642'});
            iconsCategory.push({ description : 'satellite &#xe562'});
            iconsCategory.push({ description : 'save &#xe161'});
            iconsCategory.push({ description : 'scanner &#xe329'});
            iconsCategory.push({ description : 'schedule &#xe8b5'});
            iconsCategory.push({ description : 'school &#xe80c'});
            iconsCategory.push({ description : 'screen_lock_landscape &#xe1be'});
            iconsCategory.push({ description : 'screen_lock_portrait &#xe1bf'});
            iconsCategory.push({ description : 'screen_lock_rotation &#xe1c0'});
            iconsCategory.push({ description : 'screen_rotation &#xe1c1'});
            iconsCategory.push({ description : 'screen_share &#xe0e2'});
            iconsCategory.push({ description : 'sd_card &#xe623'});
            iconsCategory.push({ description : 'sd_storage &#xe1c2'});
            iconsCategory.push({ description : 'search &#xe8b6'});
            iconsCategory.push({ description : 'security &#xe32a'});
            iconsCategory.push({ description : 'select_all &#xe162'});
            iconsCategory.push({ description : 'send &#xe163'});
            iconsCategory.push({ description : 'sentiment_dissatisfied &#xe811'});
            iconsCategory.push({ description : 'sentiment_neutral &#xe812'});
            iconsCategory.push({ description : 'sentiment_satisfied &#xe813'});
            iconsCategory.push({ description : 'sentiment_very_dissatisfied &#xe814'});
            iconsCategory.push({ description : 'sentiment_very_satisfied &#xe815'});
            iconsCategory.push({ description : 'settings &#xe8b8'});
            iconsCategory.push({ description : 'settings_applications &#xe8b9'});
            iconsCategory.push({ description : 'settings_backup_restore &#xe8ba'});
            iconsCategory.push({ description : 'settings_bluetooth &#xe8bb'});
            iconsCategory.push({ description : 'settings_brightness &#xe8bd'});
            iconsCategory.push({ description : 'settings_cell &#xe8bc'});
            iconsCategory.push({ description : 'settings_ethernet &#xe8be'});
            iconsCategory.push({ description : 'settings_input_antenna &#xe8bf'});
            iconsCategory.push({ description : 'settings_input_component &#xe8c0'});
            iconsCategory.push({ description : 'settings_input_composite &#xe8c1'});
            iconsCategory.push({ description : 'settings_input_hdmi &#xe8c2'});
            iconsCategory.push({ description : 'settings_input_svideo &#xe8c3'});
            iconsCategory.push({ description : 'settings_overscan &#xe8c4'});
            iconsCategory.push({ description : 'settings_phone &#xe8c5'});
            iconsCategory.push({ description : 'settings_power &#xe8c6'});
            iconsCategory.push({ description : 'settings_remote &#xe8c7'});
            iconsCategory.push({ description : 'settings_system_daydream &#xe1c3'});
            iconsCategory.push({ description : 'settings_voice &#xe8c8'});
            iconsCategory.push({ description : 'share &#xe80d'});
            iconsCategory.push({ description : 'shop &#xe8c9'});
            iconsCategory.push({ description : 'shop_two &#xe8ca'});
            iconsCategory.push({ description : 'shopping_basket &#xe8cb'});
            iconsCategory.push({ description : 'shopping_cart &#xe8cc'});
            iconsCategory.push({ description : 'short_text &#xe261'});
            iconsCategory.push({ description : 'show_chart &#xe6e1'});
            iconsCategory.push({ description : 'shuffle &#xe043'});
            iconsCategory.push({ description : 'signal_cellular_4_bar &#xe1c8'});
            iconsCategory.push({ description : 'signal_cellular_connected_no_internet_4_bar &#xe1cd'});
            iconsCategory.push({ description : 'signal_cellular_no_sim &#xe1ce'});
            iconsCategory.push({ description : 'signal_cellular_null &#xe1cf'});
            iconsCategory.push({ description : 'signal_cellular_off &#xe1d0'});
            iconsCategory.push({ description : 'signal_wifi_4_bar &#xe1d8'});
            iconsCategory.push({ description : 'signal_wifi_4_bar_lock &#xe1d9'});
            iconsCategory.push({ description : 'signal_wifi_off &#xe1da'});
            iconsCategory.push({ description : 'sim_card &#xe32b'});
            iconsCategory.push({ description : 'sim_card_alert &#xe624'});
            iconsCategory.push({ description : 'skip_next &#xe044'});
            iconsCategory.push({ description : 'skip_previous &#xe045'});
            iconsCategory.push({ description : 'slideshow &#xe41b'});
            iconsCategory.push({ description : 'slow_motion_video &#xe068'});
            iconsCategory.push({ description : 'smartphone &#xe32c'});
            iconsCategory.push({ description : 'smoke_free &#xeb4a'});
            iconsCategory.push({ description : 'smoking_rooms &#xeb4b'});
            iconsCategory.push({ description : 'sms &#xe625'});
            iconsCategory.push({ description : 'sms_failed &#xe626'});
            iconsCategory.push({ description : 'snooze &#xe046'});
            iconsCategory.push({ description : 'sort &#xe164'});
            iconsCategory.push({ description : 'sort_by_alpha &#xe053'});
            iconsCategory.push({ description : 'spa &#xeb4c'});
            iconsCategory.push({ description : 'space_bar &#xe256'});
            iconsCategory.push({ description : 'speaker &#xe32d'});
            iconsCategory.push({ description : 'speaker_group &#xe32e'});
            iconsCategory.push({ description : 'speaker_notes &#xe8cd'});
            iconsCategory.push({ description : 'speaker_notes_off &#xe92a'});
            iconsCategory.push({ description : 'speaker_phone &#xe0d2'});
            iconsCategory.push({ description : 'spellcheck &#xe8ce'});
            iconsCategory.push({ description : 'star &#xe838'});
            iconsCategory.push({ description : 'star_border &#xe83a'});
            iconsCategory.push({ description : 'star_half &#xe839'});
            iconsCategory.push({ description : 'stars &#xe8d0'});
            iconsCategory.push({ description : 'stay_current_landscape &#xe0d3'});
            iconsCategory.push({ description : 'stay_current_portrait &#xe0d4'});
            iconsCategory.push({ description : 'stay_primary_landscape &#xe0d5'});
            iconsCategory.push({ description : 'stay_primary_portrait &#xe0d6'});
            iconsCategory.push({ description : 'stop &#xe047'});
            iconsCategory.push({ description : 'stop_screen_share &#xe0e3'});
            iconsCategory.push({ description : 'storage &#xe1db'});
            iconsCategory.push({ description : 'store &#xe8d1'});
            iconsCategory.push({ description : 'store_mall_directory &#xe563'});
            iconsCategory.push({ description : 'straighten &#xe41c'});
            iconsCategory.push({ description : 'streetview &#xe56e'});
            iconsCategory.push({ description : 'strikethrough_s &#xe257'});
            iconsCategory.push({ description : 'style &#xe41d'});
            iconsCategory.push({ description : 'subdirectory_arrow_left &#xe5d9'});
            iconsCategory.push({ description : 'subdirectory_arrow_right &#xe5da'});
            iconsCategory.push({ description : 'subject &#xe8d2'});
            iconsCategory.push({ description : 'subscriptions &#xe064'});
            iconsCategory.push({ description : 'subtitles &#xe048'});
            iconsCategory.push({ description : 'subway &#xe56f'});
            iconsCategory.push({ description : 'supervisor_account &#xe8d3'});
            iconsCategory.push({ description : 'surround_sound &#xe049'});
            iconsCategory.push({ description : 'swap_calls &#xe0d7'});
            iconsCategory.push({ description : 'swap_horiz &#xe8d4'});
            iconsCategory.push({ description : 'swap_vert &#xe8d5'});
            iconsCategory.push({ description : 'swap_vertical_circle &#xe8d6'});
            iconsCategory.push({ description : 'switch_camera &#xe41e'});
            iconsCategory.push({ description : 'switch_video &#xe41f'});
            iconsCategory.push({ description : 'sync &#xe627'});
            iconsCategory.push({ description : 'sync_disabled &#xe628'});
            iconsCategory.push({ description : 'sync_problem &#xe629'});
            iconsCategory.push({ description : 'system_update &#xe62a'});
            iconsCategory.push({ description : 'system_update_alt &#xe8d7'});
            iconsCategory.push({ description : 'tab &#xe8d8'});
            iconsCategory.push({ description : 'tab_unselected &#xe8d9'});
            iconsCategory.push({ description : 'tablet &#xe32f'});
            iconsCategory.push({ description : 'tablet_android &#xe330'});
            iconsCategory.push({ description : 'tablet_mac &#xe331'});
            iconsCategory.push({ description : 'tag_faces &#xe420'});
            iconsCategory.push({ description : 'tap_and_play &#xe62b'});
            iconsCategory.push({ description : 'terrain &#xe564'});
            iconsCategory.push({ description : 'text_fields &#xe262'});
            iconsCategory.push({ description : 'text_format &#xe165'});
            iconsCategory.push({ description : 'textsms &#xe0d8'});
            iconsCategory.push({ description : 'texture &#xe421'});
            iconsCategory.push({ description : 'theaters &#xe8da'});
            iconsCategory.push({ description : 'thumb_down &#xe8db'});
            iconsCategory.push({ description : 'thumb_up &#xe8dc'});
            iconsCategory.push({ description : 'thumbs_up_down &#xe8dd'});
            iconsCategory.push({ description : 'time_to_leave &#xe62c'});
            iconsCategory.push({ description : 'timelapse &#xe422'});
            iconsCategory.push({ description : 'timeline &#xe922'});
            iconsCategory.push({ description : 'timer &#xe425'});
            iconsCategory.push({ description : 'timer_10 &#xe423'});
            iconsCategory.push({ description : 'timer_3 &#xe424'});
            iconsCategory.push({ description : 'timer_off &#xe426'});
            iconsCategory.push({ description : 'title &#xe264'});
            iconsCategory.push({ description : 'toc &#xe8de'});
            iconsCategory.push({ description : 'today &#xe8df'});
            iconsCategory.push({ description : 'toll &#xe8e0'});
            iconsCategory.push({ description : 'tonality &#xe427'});
            iconsCategory.push({ description : 'touch_app &#xe913'});
            iconsCategory.push({ description : 'toys &#xe332'});
            iconsCategory.push({ description : 'track_changes &#xe8e1'});
            iconsCategory.push({ description : 'traffic &#xe565'});
            iconsCategory.push({ description : 'train &#xe570'});
            iconsCategory.push({ description : 'tram &#xe571'});
            iconsCategory.push({ description : 'transfer_within_a_station &#xe572'});
            iconsCategory.push({ description : 'transform &#xe428'});
            iconsCategory.push({ description : 'translate &#xe8e2'});
            iconsCategory.push({ description : 'trending_down &#xe8e3'});
            iconsCategory.push({ description : 'trending_flat &#xe8e4'});
            iconsCategory.push({ description : 'trending_up &#xe8e5'});
            iconsCategory.push({ description : 'tune &#xe429'});
            iconsCategory.push({ description : 'turned_in &#xe8e6'});
            iconsCategory.push({ description : 'turned_in_not &#xe8e7'});
            iconsCategory.push({ description : 'tv &#xe333'});
            iconsCategory.push({ description : 'unarchive &#xe169'});
            iconsCategory.push({ description : 'undo &#xe166'});
            iconsCategory.push({ description : 'unfold_less &#xe5d6'});
            iconsCategory.push({ description : 'unfold_more &#xe5d7'});
            iconsCategory.push({ description : 'update &#xe923'});
            iconsCategory.push({ description : 'usb &#xe1e0'});
            iconsCategory.push({ description : 'verified_user &#xe8e8'});
            iconsCategory.push({ description : 'vertical_align_bottom &#xe258'});
            iconsCategory.push({ description : 'vertical_align_center &#xe259'});
            iconsCategory.push({ description : 'vertical_align_top &#xe25a'});
            iconsCategory.push({ description : 'vibration &#xe62d'});
            iconsCategory.push({ description : 'video_call &#xe070'});
            iconsCategory.push({ description : 'video_label &#xe071'});
            iconsCategory.push({ description : 'video_library &#xe04a'});
            iconsCategory.push({ description : 'videocam &#xe04b'});
            iconsCategory.push({ description : 'videocam_off &#xe04c'});
            iconsCategory.push({ description : 'videogame_asset &#xe338'});
            iconsCategory.push({ description : 'view_agenda &#xe8e9'});
            iconsCategory.push({ description : 'view_array &#xe8ea'});
            iconsCategory.push({ description : 'view_carousel &#xe8eb'});
            iconsCategory.push({ description : 'view_column &#xe8ec'});
            iconsCategory.push({ description : 'view_comfy &#xe42a'});
            iconsCategory.push({ description : 'view_compact &#xe42b'});
            iconsCategory.push({ description : 'view_day &#xe8ed'});
            iconsCategory.push({ description : 'view_headline &#xe8ee'});
            iconsCategory.push({ description : 'view_list &#xe8ef'});
            iconsCategory.push({ description : 'view_module &#xe8f0'});
            iconsCategory.push({ description : 'view_quilt &#xe8f1'});
            iconsCategory.push({ description : 'view_stream &#xe8f2'});
            iconsCategory.push({ description : 'view_week &#xe8f3'});
            iconsCategory.push({ description : 'vignette &#xe435'});
            iconsCategory.push({ description : 'visibility &#xe8f4'});
            iconsCategory.push({ description : 'visibility_off &#xe8f5'});
            iconsCategory.push({ description : 'voice_chat &#xe62e'});
            iconsCategory.push({ description : 'voicemail &#xe0d9'});
            iconsCategory.push({ description : 'volume_down &#xe04d'});
            iconsCategory.push({ description : 'volume_mute &#xe04e'});
            iconsCategory.push({ description : 'volume_off &#xe04f'});
            iconsCategory.push({ description : 'volume_up &#xe050'});
            iconsCategory.push({ description : 'vpn_key &#xe0da'});
            iconsCategory.push({ description : 'vpn_lock &#xe62f'});
            iconsCategory.push({ description : 'wallpaper &#xe1bc'});
            iconsCategory.push({ description : 'warning &#xe002'});
            iconsCategory.push({ description : 'watch &#xe334'});
            iconsCategory.push({ description : 'watch_later &#xe924'});
            iconsCategory.push({ description : 'wb_auto &#xe42c'});
            iconsCategory.push({ description : 'wb_cloudy &#xe42d'});
            iconsCategory.push({ description : 'wb_incandescent &#xe42e'});
            iconsCategory.push({ description : 'wb_iridescent &#xe436'});
            iconsCategory.push({ description : 'wb_sunny &#xe430'});
            iconsCategory.push({ description : 'wc &#xe63d'});
            iconsCategory.push({ description : 'web &#xe051'});
            iconsCategory.push({ description : 'web_asset &#xe069'});
            iconsCategory.push({ description : 'weekend &#xe16b'});
            iconsCategory.push({ description : 'whatshot &#xe80e'});
            iconsCategory.push({ description : 'widgets &#xe1bd'});
            iconsCategory.push({ description : 'wifi &#xe63e'});
            iconsCategory.push({ description : 'wifi_lock &#xe1e1'});
            iconsCategory.push({ description : 'wifi_tethering &#xe1e2'});
            iconsCategory.push({ description : 'work &#xe8f9'});
            iconsCategory.push({ description : 'wrap_text &#xe25b'});
            iconsCategory.push({ description : 'youtube_searched_for &#xe8fa'});
            iconsCategory.push({ description : 'zoom_in &#xe8ff'});
            iconsCategory.push({ description : 'zoom_out &#xe900'});
            iconsCategory.push({ description : 'zoom_out_map &#xe56b'});

            for (var i = 0; i < iconsCategory.length; i++) {
                iconsCategoryCode.push({ id: iconsCategory[i].description.split(' ')[1] });
            }

            return iconsCategoryCode;
        }
        

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //------------------------------------------------- Forms -----------------------------------------------------
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function get(filters) {
            return RestangularAuth.all('manager/forms').getList(filters);
        }

        function getSimple(filters) {
            return RestangularAuth.all('manager/forms/simple').getList(filters);
        }

        function getById(id) {
            return RestangularAuth.one('manager/forms', id).get();
        }

        function post(form) {
            return RestangularAuth.all('manager/forms').post(form);
        }

        function archiveForm(formId) {
            return RestangularAuth.all('manager/forms/' + formId + '/archive').post(form);
        }

        function deleteAll(ids) {
            return RestangularAuth.one('manager/forms', ids).remove();
        }

        function copyForm(formId, ToappCompanyId, modulo, publishLevelId, formNewTitle) {
            return RestangularAuth.all('manager/forms/copy/' + formId + '/toapp/' + ToappCompanyId + '/' + modulo + '/'+ publishLevelId + '/' + formNewTitle).post();
        }

        //Categoria de Formulario
        function getFormCategory(filters) {
            return RestangularAuth.all('manager/forms/category').getList(filters);
        }

        function deleteAllFormCategory(ids) {
            return RestangularAuth.one('manager/forms/category', ids).remove();
        }

        function getByIdFormCategory(id) {
            return RestangularAuth.one('manager/forms/category', id).get();
        }

        function postFormCategory(cat) {
            return RestangularAuth.all('manager/forms/category').post(cat);
        }

        function geListMappings(appCompanyId) {
            return RestangularAuth.one('manager/appcompany/mapping/' + appCompanyId).get();
            //return RestangularAuth.one('manager/integration/mapping/forms').get();
        }
        //

        function getModulos() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.modulos);
            return deferred.promise;
        }

        function getFormTemplates() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.formComponents);
            return deferred.promise;
        }

        function getBehaviorProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.behaviorProperties);
            return deferred.promise;
        }

        function getTypeDateProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.typeDateProperties);
            return deferred.promise;
        }

        function getTypeNumberProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.typeNumberProperties);
            return deferred.promise;
        }

        function getLogicalConditionalProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.logicalConditionals);
            return deferred.promise;
        }

        function getLogicalOperatorsProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.logicalOperators);
            return deferred.promise;
        }

        function getTextTypeFreeTextComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.textTypeFreeTextComponent);
            return deferred.promise;
        }

        function getMethodSelectsComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.methodSelectsComponent);
            return deferred.promise;
        }

        function getSelectTypeSimpleSelectComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.selectTypeSimpleSelectComponent);
            return deferred.promise;
        }

        function getSelectTypeMultipleSelectComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.selectTypeMultipleSelectComponent);
            return deferred.promise;
        }

        function getDateTimeTypeDateTimeComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.dateTimeTypeDateTimeComponent);
            return deferred.promise;
        }

        function getNumberTypeNumberComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.numberTypeNumberComponent);
            return deferred.promise;
        }

        function getOriginImageComponentProperties() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.originImageComponent);
            return deferred.promise;
        }

        function getStatus() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusLogico);
            return deferred.promise;
        }

        function getTooltips() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.tooltips);
            return deferred.promise;
        }

        function getConditionTypes() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.conditionTypes);
            return deferred.promise;
        }

        function getparametersTypes() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.parametersTypes);
            return deferred.promise;
        }

        /*Codes below related to RPN*/
        function getRpnTemplates() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.rpnComponents);
            return deferred.promise;
        }

        function getReservedWords() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.reserverdWords);
            return deferred.promise;
        }

        function getArithmeticOperators() {
            var deferred = Common.$q.defer();
            deferred.resolve(FORMS.arithmeticOperators);
            return deferred.promise;
        }

        function getArchiveStatus() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.archiveBool);
            return deferred.promise;
        }

        function getFormSubmissions(filter){
            return RestangularAuth.all('manager/forms').customGET("submissions", filter);
        }

        function getFormSubmissionDetail(id, appSelecionado) {
            var token = Session && Session.getToken() ? Session.getToken() : null;
            return RestangularAuth.one('manager/forms/submissions/').customGET(id.toString(), undefined, { 
                'Content-Type': 'application/json', 
                'AppId': appSelecionado.app.id, 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });
        }

        function getFormSubmissionStatistics(filter){
            return RestangularAuth.one('manager/forms/submissions').customGET('statistics', filter);
        }
        function getFormSubmissionStatisticsFreeText(filter){
            return RestangularAuth.one('manager/forms/submissions/statistics').customGET('freetext', filter);
        }
        function getFormSubmissionStatisticsImage(filter, appSelecionado){
            var token = Session && Session.getToken() ? Session.getToken() : null;
            return RestangularAuth.one('manager/forms/submissions/statistics').customGET('image', filter, {
                'Content-Type': 'application/json', 
                'AppId': appSelecionado.app.id, 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });
        }

        function routeGo (modulo, action, formId, formName){
            var base = 'private.painel';
            var params = null;
            if(modulo === 'Relacionamento'){
                base = base + '.attendance'
            }else if(modulo === 'Nps'){
                base = base + '.pesquisa'
            }else if(modulo === 'FormGeral'){
                base = base + '.coleta'
            }else if(modulo === 'Integracao'){
                base = base + '.integracao'
            }

            if(action === 'back'){
                $state.go(base + '.form.list', {reload: false});
            }else if(action === 'create'){
                $state.go(base + '.form.list.create', {reload: false});
            }else if(action === 'edit'){
                $state.go(base + '.form.list.edit', {id:formId, reload: false});
            }else if(action === 'submissions'){
                $state.go(base + '.form.list.answers', {id:formId, formName: formName, reload: false});
            }else if(action === 'statistic'){
                $state.go(base + '.form.list.statistics', {id:formId, formName: formName, reload: false});
            }
        }     

        return {
            getFormTemplates: getFormTemplates,
            getBehaviorProperties: getBehaviorProperties,
            getTypeDateProperties: getTypeDateProperties,
            getTypeNumberProperties: getTypeNumberProperties,
            getLogicalConditionalProperties: getLogicalConditionalProperties,
            getLogicalOperatorsProperties: getLogicalOperatorsProperties,
            getTextTypeFreeTextComponentProperties: getTextTypeFreeTextComponentProperties,
            getMethodSelectsComponentProperties: getMethodSelectsComponentProperties,
            getSelectTypeSimpleSelectComponentProperties: getSelectTypeSimpleSelectComponentProperties,
            getSelectTypeMultipleSelectComponentProperties: getSelectTypeMultipleSelectComponentProperties,
            getDateTimeTypeDateTimeComponentProperties: getDateTimeTypeDateTimeComponentProperties,
            getNumberTypeNumberComponentProperties: getNumberTypeNumberComponentProperties,
            getOriginImageComponentProperties: getOriginImageComponentProperties,
            getById: getById,
            post: post,
            archiveForm: archiveForm,
            deleteAll: deleteAll,
            get: get,
            getSimple: getSimple,
            getStatus: getStatus,
            getTooltips: getTooltips,
            getConditionTypes: getConditionTypes,
            getparametersTypes : getparametersTypes,
            getRpnTemplates: getRpnTemplates,
            getReservedWords: getReservedWords,
            getArithmeticOperators: getArithmeticOperators,
            copyForm: copyForm,
            getFormCategory: getFormCategory,
            deleteAllFormCategory: deleteAllFormCategory,
            getByIdFormCategory: getByIdFormCategory,
            postFormCategory: postFormCategory,
            getArchiveStatus: getArchiveStatus,
            getModulos: getModulos,
            geListMappings: geListMappings,
            getCategories:getCategories,
            getCategoriesLeafs:getCategoriesLeafs,
            deleteCategoriesAll:deleteCategoriesAll,
            deleteCategoryById:deleteCategoryById,
            getCategoryById:getCategoryById,
            postCategory:postCategory,
            putCategory:putCategory,
            postCategoryReason:postCategoryReason,
            iconsListMobileCare:iconsListMobileCare,
            getFormSubmissions:getFormSubmissions,
            getFormSubmissionDetail: getFormSubmissionDetail,
            getFormSubmissionStatistics: getFormSubmissionStatistics,
            getFormSubmissionStatisticsFreeText: getFormSubmissionStatisticsFreeText,
            getFormSubmissionStatisticsImage: getFormSubmissionStatisticsImage,
            getPublishLevel:getPublishLevel,
            routeGo:routeGo
        };
    }

    angular
        .module('app.form')
        .factory('Form', FormService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function FormListController($filter, $controller, $interval, $rootScope, $scope, Attendance, DashboardCompany, Form, Common, Company, Security, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, $stateParams) {
        var vm = this;        
        vm.modulo = $stateParams.modulo;

        //Authorization credentials
        vm.isFormDeletarPermitido = false;
        vm.isFormCadastrarPermitido = false;
        vm.isFormEditarPermitido = false;
        vm.configurarPermissoes = function () {
            if (vm.modulo == 'Relacionamento') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Relacionamento", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Relacionamento", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "S" });                
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "C" });
            } else if (vm.modulo == 'Integracao') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Integração", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Integração", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "C" });
            } else if (vm.modulo == 'Nps') {
                vm.moduloPretty = 'Formulários de Pesquisa de Opinião';
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                
                vm.isFormEstatisticaPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSumarioPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                
                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });

            }else if(vm.modulo == "FormGeral"){
                vm.moduloPretty = 'Formulários Gerais';
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "C" });

                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });

                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
            }            

        };


        // ---------------------- TOOGLE -----------------------
        vm.toggle = function(field, animationSlow) {
            if (animationSlow) {
                $(field).toggle(APPLICATION.STRING_SLOW);
            } else {
                $(field).toggle();    
            }            
        };

        vm.getHashTagField = function(field) {
            return APPLICATION.STRING_HASHTAG + field;
        }
        // ---------------------- END TOOGLE -------------------

        // Inicio da região referente a categorias
        vm.getLeafsCategories = function (filters) {
            vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;
            vm.isLoading = APPLICATION.BOOLEAN_TRUE;            

            // Listagem das categorias folhas.
            return Form.getCategoriesLeafs(filters).then(function (categories) {
                // Obtém os itens das categorias folha.
                vm.listLeafsCategories = categories.itens;                
                return vm.listLeafsCategories;
            });
        };

        vm.addRecursiveSubCategories = function(list) {
            if (list.subCategories && list.subCategories.length > 0) {
                for (var j = APPLICATION.INT_ZERO; j < list.subCategories.length; j++) {
                    if (list.subCategories[j].subCategories && list.subCategories[j].subCategories.length > 0) {
                        list.subCategories[j].marginLeft = (list.subCategories[j].level * 30) + 'px';
                        vm.newListCategoriesHierarchy.push(list.subCategories[j]);
                        vm.addRecursiveSubCategories(list.subCategories[j]);
                    } else {
                        list.subCategories[j].marginLeft = (list.subCategories[j].level * 30) + 'px';
                        vm.newListCategoriesHierarchy.push(list.subCategories[j]);
                        vm.addRecursiveSubCategories(list.subCategories[j]);
                    }                    
                }
            }
        };

        vm.calculateCategories = function() {
            vm.tempListCategory = JSON.parse(JSON.stringify(vm.newListCategories));

            for (var i = APPLICATION.INT_ZERO; i < vm.tempListCategory.length; i++) {
                vm.newListCategoriesHierarchy.push(vm.tempListCategory[i]);
                vm.addRecursiveSubCategories(vm.tempListCategory[i]);
            }

            return vm.newListCategoriesHierarchy;
        };

        vm.getCategoryByIdSpecific = function(list) {
            if (list && list.length > APPLICATION.INT_ZERO) {
                if (!list[APPLICATION.INT_ZERO].parentId) {
                    return Form.getCategoryById(list[APPLICATION.INT_ZERO].id).then(function (category) {
                        category.formsCount = list[APPLICATION.INT_ZERO].formsCount;
                        vm.newListCategories.push(category);
                        list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.getCategoryByIdSpecific(list);
                    });      
                } else {
                    list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.getCategoryByIdSpecific(list);
                }              
            } else {
                var categories = {};
                //categories.itens = vm.newListCategories;
                categories.itens = vm.calculateCategories();

                for (var i = APPLICATION.INT_ZERO; i < categories.itens.length; i++) {
                    for (var j = APPLICATION.INT_ZERO; j < vm.categoriesFather.length; j++) {
                        if (categories.itens[i].id == vm.categoriesFather[j].id) {
                            categories.itens[i].formsCount = vm.categoriesFather[j].formsCount;
                            break;
                        }
                    }                    
                }

                // Salva a lista de categorias e o backup para a pesquisa.
                vm.categories = categories.itens;
                vm.categories_backup = categories.itens;

                if (vm.categories && vm.selectedCategoryItem) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                        if (!vm.categories[i].subCategories || vm.categories[i].subCategories.length == APPLICATION.INT_ZERO) {
                            if (vm.categories[i].description == vm.selectedCategoryItem.description) {
                                vm.categories = vm.cleanSelectedCategorie(vm.categories);
                                vm.selectedCategory = vm.categories[i].description;
                                vm.selectedCategoryItem = vm.categories[i];
                                vm.categories[i].isSelected = true;
                                vm.filters.categoryId = vm.categories[i].id;
                                vm.getForms(vm.filters);
                                break;
                            }
                        }
                    }
                }


                if (!vm.categories[vm.selectedCategoryIndex]) {
                    // Verifica se existem categorias na lista.
                    if (vm.categories.length > APPLICATION.INT_ZERO) {
                        // Seleciona a primeira categoria da lista.
                        vm.selectedCategory = vm.categories[APPLICATION.INT_ZERO].description;

                        var itemSelectedFuture = {}; 
                        var indexItemSelectedFuture = APPLICATION.INT_ZERO; 

                        for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                            if (!vm.categories[i].subCategories || vm.categories[i].subCategories.length == APPLICATION.INT_ZERO) {
                                itemSelectedFuture = vm.categories[i];
                                indexItemSelectedFuture = i;
                                break;
                            }
                        }  

                        vm.selectForm(itemSelectedFuture, indexItemSelectedFuture);                     
                    } else {
                        vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;
                    }
                }         

                // Interrompe os loadings.
                vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
                vm.isLoading = APPLICATION.BOOLEAN_FALSE;

                vm.categoryModal = {};
                vm.categoryModal.parentId = APPLICATION.INT_ZERO;
                
                // Retorna a listagem de categorias.
                return vm.categories;
            }            
        };

        vm.getCategoryById = function(list) {
            if (list && list.length > APPLICATION.INT_ZERO) {
                if (!list[APPLICATION.INT_ZERO].parentId) {
                    return Category.getCategoryById(list[APPLICATION.INT_ZERO].id).then(function (category) {
                        category.formsCount = list[APPLICATION.INT_ZERO].formsCount;
                        vm.newListCategories.push(category);
                        list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.getCategoryById(list);
                    });      
                } else {
                    list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.getCategoryById(list);
                }              
            } else {
                var categories = {};
                //categories.itens = vm.newListCategories;
                categories.itens = vm.calculateCategories();

                for (var i = APPLICATION.INT_ZERO; i < categories.itens.length; i++) {
                    for (var j = APPLICATION.INT_ZERO; j < vm.categoriesFather.length; j++) {
                        if (categories.itens[i].id == vm.categoriesFather[j].id) {
                            categories.itens[i].formsCount = vm.categoriesFather[j].formsCount;
                            break;
                        }
                    }                    
                }

                // Salva a lista de categorias e o backup para a pesquisa.
                vm.categories = categories.itens;
                vm.categories_backup = categories.itens;

                // Aplica o filtro de busca por publish level se existir.
                vm.searchByArchivedPublishLevel();   
                vm.searchByArchivedPublishLevelService();           

                // Verifica se existem categorias na lista.
                if (vm.categories.length > APPLICATION.INT_ZERO) {
                    // Seleciona a primeira categoria da lista.
                    vm.selectedCategory = vm.categories[APPLICATION.INT_ZERO].description;

                    var itemSelectedFuture = {}; 
                    var indexItemSelectedFuture = APPLICATION.INT_ZERO; 

                    for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                        if (!vm.categories[i].subCategories || vm.categories[i].subCategories.length == APPLICATION.INT_ZERO) {
                            itemSelectedFuture = vm.categories[i];
                            indexItemSelectedFuture = i;
                            break;
                        }
                    }

                    // Efetua a busca dos serviços daquela categoria.
                    vm.selectForm(itemSelectedFuture, indexItemSelectedFuture);
                } else {
                    // Informa o usuário que não existe categoria na lista.
                    vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;
                }

                // Interrompe os loadings.
                vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
                vm.isLoading = APPLICATION.BOOLEAN_FALSE;
                
                // Retorna a listagem de categorias.
                return vm.categories;
            }            
        };

        vm.getCategories = function (filters) {
            vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;
            vm.isLoading = APPLICATION.BOOLEAN_TRUE;            

            // Listagem das categorias folhas.
            return Form.getCategories(filters).then(function (categories) {
                vm.categories = [];
                vm.categoriesFather = [];
                vm.newListCategories = [];
                vm.newListCategoriesHierarchy = [];

                var categoriesFatherTemp = JSON.parse(JSON.stringify(categories.itens));

                if (categoriesFatherTemp) {
                    for (var i = APPLICATION.INT_ZERO; i < categoriesFatherTemp.length; i++) {
                        if (categoriesFatherTemp[i].formsCount == 0) {
                            vm.categoriesFather.push(categoriesFatherTemp[i]);
                        }
                    }
                }

                //vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: 'Sem categoria pai'});

                vm.getCategoryByIdSpecific(categories.itens);
                //vm.getCategoryById(categories.itens);
            });
        };

        vm.cleanSelectedCategorie = function(list) {
            if (list) {
                for (var i = 0; i < list.length; i++) {
                    list[i].isSelected = false;
                }    
            }   

            vm.filters.categoryId = null;
            return list;         
        }

        vm.submitCategory = function(category) {            
            vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_TRUE;
            vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;
            var itemCategoryUpdated = {};

            vm.categoryModal.parentId = vm.categoryModal.parentId == APPLICATION.INT_ZERO ? null : vm.categoryModal.parentId;
            category.description = vm.categoryModal.description;
            category.icon = vm.categoryModal.icon;
            category.isActive = vm.categoryModal.isActive;
            category.parentId = vm.categoryModal.parentId;
            category.publishLevelId  = vm.categoryModal.publishLevelId;

            // Verifica se a requisição é de cadastro ou atualização.
            if (vm.category && vm.category.create) {
                for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFather.length; i++) {
                    if (vm.categoriesFather[i].id == category.parentId) {
                        category.level = (vm.categoriesFather[i].level + 1);
                        break;
                    }
                }                
                category.modulo = vm.modulo;

                // Efetua o cadastro da categoria.
                return Form.postCategory(category).then(function (response) {
                    Form.getCategoriesLeafs().then(function (categories) { vm.listLeafsCategories = categories.itens; });
                    Common.messageSuccess(APPLICATION.STRING_MSG_CATEGORIA_CADASTRADA);
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    vm.closeModalCategory();
                    vm.category = {}; 

                    // Listagem das categorias.
                    return Form.getCategories(vm.filters).then(function (categories) {
                        vm.categories = [];
                        vm.categoriesFather = [];
                        vm.newListCategories = [];
                        vm.newListCategoriesHierarchy = [];

                        vm.categoriesFather = JSON.parse(JSON.stringify(categories.itens));

                        if (vm.categoriesFather) {
                            for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFather.length; i++) {
                                if (vm.categoriesFather[i].servicesCount > 0) {
                                    vm.categoriesFather.splice(i, APPLICATION.INT_UM);
                                }
                            }
                        }

                        vm.selectedCategoryIndex = null;
                        vm.selectedCategoryItem = category;

                        vm.getCategoryByIdSpecific(categories.itens);

                        vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_MSG_SEM_CATEGORIA_PAI});

                        vm.categoryModal = {};
                        vm.categoryModal.parentId = APPLICATION.INT_ZERO;
                    });
                }, function(error) {
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    vm.closeModalCategory();
                    vm.category = {}; 
                });
            } else if (vm.category && vm.category.update) {
                itemCategoryUpdated.id = category.id;
                itemCategoryUpdated.description = category.description;
                itemCategoryUpdated.appCompanyId = category.appCompanyId;
                itemCategoryUpdated.icon = category.icon;
                itemCategoryUpdated.isActive = category.isActive;
                itemCategoryUpdated.publishLevelId = category.publishLevelId;
                itemCategoryUpdated.parentId = vm.categoryModal.parentId;

                // Efetua a atualização da categoria.
                return Form.putCategory(itemCategoryUpdated).then(function (response) {
                    Form.getCategoriesLeafs().then(function (categories) { vm.listLeafsCategories = categories.itens; });
                    Common.messageSuccess(APPLICATION.STRING_MSG_CATEGORIA_ATUALIZADA);
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    vm.closeModalCategory();
                    vm.category = {};
                    
                    // Listagem das categorias.
                    return Form.getCategories(vm.filters).then(function (categories) {
                        vm.categories = [];
                        vm.categoriesFather = [];
                        vm.newListCategories = [];
                        vm.newListCategoriesHierarchy = [];

                        vm.categoriesFather = JSON.parse(JSON.stringify(categories.itens));

                        if (vm.categoriesFather) {
                            for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFather.length; i++) {
                                if (vm.categoriesFather[i].servicesCount > 0) {
                                    vm.categoriesFather.splice(i, APPLICATION.INT_UM);
                                }
                            }
                        }

                        vm.getCategoryByIdSpecific(categories.itens);

                        vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_MSG_SEM_CATEGORIA_PAI});

                        vm.categoryModal = {};
                        vm.categoryModal.parentId = APPLICATION.INT_ZERO;
                    });
                }, function(error) {
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    vm.closeModalCategory();
                    vm.category = {}; 
                });
            }
        } 

        vm.selectIconCategory = function(item) {
            vm.category = vm.category ? vm.category : {};
            vm.category.icon = item.id;
            vm.categoryModal.icon = item.id;
            var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_CATEGORIAS), {keyboard:false, bgclose:false});
            modal.show();
        }

        vm.openModalCopyForm =  function(item){
            vm.selectedCopyFormItem = item;
            vm.copyFormOptions = {};
            vm.copyFormOptions.formNewTitle = 'Cópia de ' + item.title;
            var modal = UIkit.modal(vm.getClassField('modalCopyForm'), {keyboard:false, bgclose:false});
            modal.show();
        }

        vm.openModalCategory = function(item, create, update, detail) {
            vm.category = item != APPLICATION.NULL ? item : {};
            vm.category.create = create;
            vm.category.update = update;
            vm.category.detail = detail;
            vm.categoryModal = {};
            vm.categoryModal.parentId = APPLICATION.INT_ZERO;

            if (item) {                
                vm.categoryModal.description = item.description;
                vm.categoryModal.icon = item.icon;
                vm.categoryModal.isActive = item.isActive;
                vm.categoryModal.parentId = item.parentId;
                vm.categoryModal.publishLevelId = item.publishLevelId;
            }else{
                vm.categoryModal.isActive = true;
            }

            // ByPass no ng-if - lentidão do angular.
            if (create) {
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_SALVAR_CATEGORIA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA));                
            } else if (detail) {
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA));
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_SALVAR_CATEGORIA));
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA));                
            } else {
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_SALVAR_CATEGORIA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA));
            }

            if (vm.category.isActive || !item) {
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_INATIVA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA_MODAL));
            } else {
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA_MODAL));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_INATIVA));
            }
            
            var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_CATEGORIAS), {keyboard:false, bgclose:false});
            modal.show();            
        }

        vm.openModalCategoryIcons = function() {
            if ((vm.category || !vm.category) && !vm.category.detail) {
                var modalIcons = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES), {keyboard:false, bgclose:false});
                modalIcons.show();
            }
        }

        vm.closeModalCategory = function() {
            $timeout(function() {
                document.getElementById(APPLICATION.STRING_SRV_BTN_MDL_CAT).click();
            }, 200);
        };

        vm.hide = function(field) {
            $(field).hide();
        };

        vm.show = function(field) {
            $(field).show();
        };

        vm.getClassField = function(field) {
            return APPLICATION.STRING_POINT + field;
        }
        // Fim da região referente a categoria

        vm.selectForm = function(item, index) {
            if (!item.subCategories || item.subCategories.length == 0) {
                vm.isLoading = APPLICATION.BOOLEAN_TRUE
                vm.categories = vm.cleanSelectedCategorie(vm.categories);
                vm.categories[index].isSelected = true;
                vm.filters.categoryId = vm.categories[index].id;
                vm.selectedCategory = item.description;
                vm.selectedCategoryItem = item;
                vm.selectedCategoryIndex = index;                
                vm.getForms(vm.filters);
            }
        };

        vm.getForms = function (filters) {
            var filterCopy = JSON.parse(JSON.stringify(filters));
            filterCopy.appCompanyId = vm.appCompany.id;            
            filterCopy.activeIds = true;
            vm.isLoading = APPLICATION.BOOLEAN_FALSE
            return vm.getFormsInner(filterCopy);
        };

        vm.getStatus = function () {
            return Form.getArchiveStatus().then(function (status) {
                vm.selectize_status = status;
                return vm.selectize_status;
            });
        };

        vm.getModulos = function () {
            return Form.getModulos().then(function (status) {
                vm.selectize_modulos = status;
                vm.selectize_modulos = $filter('orderBy')(vm.selectize_modulos, 'name');
                return vm.selectize_modulos;
            });
        };

        vm.getFormsInner = function (filters) {
            vm.isLoading = true;
            return Form.getSimple(filters).then(function (forms) {
                vm.forms = forms;
                formatTimeZones();
                vm.isLoading = false;
                return vm.forms;
            });
        };

        vm.getFormCategories = function () {
            return Form.getFormCategory().then(function (properties) {
                vm.selectize_category = properties;
                return vm.selectize_category;
            });
        };

        vm.getApplications = function (companyKey) {
            vm.isLoadingApps = true;
            return Company.getCompanyApps(companyKey, true).then(function (applications) {
                var applicationsListToCombo = [];
                var rolesListNew = angular.copy(JSON.parse(localStorage.getItem('mt-account-permissions')));

                for (var i = 0; i < applications.length; i++) {
                    for (var j = 0; j < rolesListNew.length; j++) {
                        if (applications[i].id == rolesListNew[j].appCompanyId) {
                            applicationsListToCombo.push(applications[i]);
                            break;
                        }
                    }
                }

                vm.applications = applicationsListToCombo;
                vm.applications = $filter('orderBy')(vm.applications, 'name');
                vm.isLoadingApps = false;
                return vm.applications;
            });
        };        

        vm.copyForm = function (form, formId, ToappCompanyId, modulo, publishLevelId, formNewTitle) {
            UIkit.modal.confirm('Deseja realmente copiar o formulário ' + form.title + '?', function () {
                vm.isLoading = true;
                Form.copyForm(formId, ToappCompanyId, modulo, publishLevelId, formNewTitle).then(function (result) {
                    if (result) {
                        // vm.search(vm.filters);
                        Common.messageSuccess('Formulário', 'C', 'M');
                        var modal = UIkit.modal("#modalCopyForm");
                        modal.hide();
                    }
                    vm.isLoading = false;
                    vm.init();
                }).catch(function () {
                    vm.isLoading = false;
                });
            });
        };

        vm.confirmRemoval = function (form) {
            UIkit.modal.confirm('Deseja realmente excluir o formulário ' + form.title + '?' +
                '<br><span style="font-size:14px; z-index:100000 !important;" class="uk-text-muted">Atenção: Todos os dados do formulário serão perdidos e ' +
                'não poderão ser recuperados!</span>', function () {
                    vm.isLoading = true;                            
                    Attendance.isFormInUse(form.id).then(function (atResult) {
                        if (!atResult) {
                            Form.deleteAll(form.id).then(function (result) {
                                if (result) {
                                    Common.messageSuccess('Formulário', 'D', 'M');
                                    var index = vm.forms.indexOf(form);
                                    vm.forms.splice(index-1, index);
                                } else {
                                    Common.mensagemError('Erro ao excluir formulário(s).');
                                }
                                //vm.init();
                            }).finally(function () {
                                vm.isLoading = false;
                            });
                        }
                        if (atResult) {
                            Common.mensagemError('Erro ao excluir. Esse formulário está em uso.');
                            vm.isLoading = false;
                        }
                    });
                });
        };

        vm.confirmCategoryRemoval = function(item) {
            UIkit.modal.confirm('Deseja realmente excluir o formulário ' + item.description + '?', function () {
                vm.isLoadingCategory = true;                            
                 vm.isLoading = true;
                Form.deleteCategoryById(item.id).then(function (result) {
                    if (result) {
                        Common.messageSuccess('Categoria', 'D', 'F');
                    } else {
                        Common.mensagemError('Erro ao excluir a categoria.');
                    }
                    vm.init();
                }).finally(function () {
                    vm.isLoading = false;
                });
            });
        }

        vm.confirmArchiving = function (form, acao) {
            UIkit.modal.confirm('Deseja realmente ' + acao + ' o formulário ' + form.title + '?', function () {
                vm.isLoading = true;
                Attendance.isFormInUse(form.id).then(function (atResult) {

                    if (atResult && acao == 'arquivar') {
                        Common.mensagemError('Erro ao arquivar. Esse formulário está em uso.');
                        vm.isLoading = false;
                        return;
                    }

                    Form.archiveForm(form.id).then(function (result) {
                        if (result > 0) {
                            // Common.messageSuccess('Formulário', 'AR', 'M');
                            Common.messageSuccess('Formulário', 'A', 'M');
                        } else {
                            Common.mensagemError('Erro ao atualizar formulário(s).');
                        }
                        vm.isLoading = false;
                        vm.init();
                    });


                });
            });
        };

        vm.search = function (filters) {            
            vm.getForms(filter);
        };

        vm.carregarFiltros = function () {
            vm.isLoadingFiltros = true;
            vm.getFormCategories().then(function () {
                vm.getStatus().then(function () {
                    vm.filters.active = "true";
                    vm.getModulos().then(function () {
                        //initComponents();
                        
                        vm.isLoadingFiltros = false;
                    });
                });
            });
        };

        function retryGetForm(maxRetries, fn) {
            return fn().then(function () {
                vm.isLoading = false;
            }).catch(function (err) {
                if (maxRetries <= 0) {
                    // var errorMessage = 'Você não possui rede de dados ativa. Por favor, verifique suas configurações e tente novamente.';
                    // Common.mensagemError(errorMessage);
                    // return;                    
                    //throw err;
                    //return;
                    // $state.go('private.painel.form.list');
                    //$state.go('public.login');

                    vm.isLoading = false;
                    return;
                }
                return retryGetForm(maxRetries - 1, fn);
            });
        }

        var lstnrClb2 = $rootScope.$on("userCompanies", function () {
            //vm.companies = angular.copy();
            var companiesListToCombo = [];
            var companiesListNew = angular.copy($rootScope.userCompanies);
            var rolesListNew = angular.copy(JSON.parse(localStorage.getItem('mt-account-permissions')));

            for (var i = 0; i < companiesListNew.length; i++) {
                for (var j = 0; j < rolesListNew.length; j++) {
                    if (companiesListNew[i].id == rolesListNew[j].companyId) {
                        companiesListToCombo.push(companiesListNew[i]);
                        break;
                    }
                }
            }

            vm.companies = companiesListToCombo;
            vm.companies = $filter('orderBy')(vm.companies, 'name');
            vm.isLoadingUserCompanies = false;
        });

        $rootScope.$on('$destroy', function () {
            [
                lstnrClb2,
            ].forEach(function (fn) {
                fn();
            });
        });

        vm.resetInfos = function() {
            vm.filters = {};
            vm.wizard1 = APPLICATION.BOOLEAN_TRUE;
            vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard3 = APPLICATION.BOOLEAN_FALSE;

            vm.category = {};
            vm.category.detail = APPLICATION.BOOLEAN_FALSE;
            vm.category.update = APPLICATION.BOOLEAN_FALSE;
            vm.category.create = APPLICATION.BOOLEAN_FALSE;

            vm.form = {};
            vm.form.detail = APPLICATION.BOOLEAN_FALSE;
            vm.form.update = APPLICATION.BOOLEAN_FALSE;
            vm.form.create = APPLICATION.BOOLEAN_FALSE;
        };

        vm.getArchived = function () {
            vm.archiveList.push({id: null, description: APPLICATION.STRING_TODOS});
            vm.archiveList.push({ id: "true", description: APPLICATION.STRING_SIM_MIN });
            vm.archiveList.push({ id: "false", description: APPLICATION.STRING_NAO_MIN });
        };

        vm.getIcons = function() {
            vm.iconsCategoryCode = Form.iconsListMobileCare();
            vm.getPublishLevel();
        }

        vm.getPublishLevel = function () {
            // Listagem de publish level.
            return Form.getPublishLevel().then(function (publishLevels) {
                // Salva a lista de publish level para a pesquisa e para o modal.
                vm.selectize_publish_levels_modal = JSON.parse(JSON.stringify(publishLevels));
                //vm.selectize_publish_levels_modal.push({id: APPLICATION.INT_ZERO, description: 'Selecione uma situação'});
                vm.selectize_publish_levels = JSON.parse(JSON.stringify(publishLevels));
                vm.selectize_publish_levels_search = JSON.parse(JSON.stringify(publishLevels));

                // Adiciona o item de pesquisa por todos.
                vm.selectize_publish_levels.push({id: APPLICATION.STRING_NUMERO_0, description: APPLICATION.STRING_TODOS});
                vm.selectize_publish_levels_search.push({id: APPLICATION.STRING_NUMERO_0, description: APPLICATION.STRING_TODOS});
                
                // Retorna a listagem de publish level.
                return vm.selectize_publish_levels;
            });
        };


        vm.initComponents = function() {

            vm.resetInfos();
            vm.getIcons();
            vm.getArchived();
            vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;

            vm.showErrorModalCloneService = true;
            if ($rootScope.userCompanies != undefined) {
                var companiesListToCombo = [];
                var companiesListNew = angular.copy($rootScope.userCompanies);
                var rolesListNew = angular.copy(JSON.parse(localStorage.getItem('mt-account-permissions')));

                for (var i = 0; i < companiesListNew.length; i++) {
                    for (var j = 0; j < rolesListNew.length; j++) {
                        if (companiesListNew[i].id == rolesListNew[j].companyId) {
                            companiesListToCombo.push(companiesListNew[i]);
                            break;
                        }
                    }
                }

                vm.companies = companiesListToCombo;
                vm.companies = $filter('orderBy')(vm.companies, 'name');
                vm.isLoadingUserCompanies = false;
            }

            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3)
            ];

            vm.selectize_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE,
                placeholder: "-- Selecione --",               
                sortField: {
                    field: 'description',
                    direction: 'asc'
                },
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    },
                }
            };

            vm.selectize_companies_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                // placeholder: "Selecione a empresa",
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                create: false,
                render: {
                    option: function (companies, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(companies.name) + '</span>' +
                            '</div>';
                    },
                    item: function (companies, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(companies.name) + '</div>';
                    }
                }
            };


            vm.selectize_apps_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                valueField: 'id',
                labelField: 'name',
                searchField: 'name',
                create: false,
                render: {
                    option: function (apps, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(apps.name) + ' - ' + escape(apps.app.name) + '</span>' +
                            '</div>';
                    },
                    item: function (apps, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(apps.name) + ' - ' + escape(apps.app.name) + '</div>';
                    }
                }
            };

            vm.selectize_category_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Categoria do formulário *',
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
            };

            // var status = vm.selectize_status;
            vm.selectize_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: null,
                placeholder: 'Todos',
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(status.description) + '</div>';
                    }
                }
            };
        };

        function formatTimeZones() {
            vm.forms.forEach(function (item) {
                var date = moment.utc(item.dtCreated, "DD/MM/YYYY HH:mm:ss").toDate();
                var localTime = moment.utc(date).toDate();
                localTime = moment(localTime).format("DD/MM/YYYY");
                item.dtCreated = localTime;
                if (item.dtLastUpdate) {
                    date = moment.utc(item.dtLastUpdate, "DD/MM/YYYY HH:mm:ss").toDate();
                    localTime = moment.utc(date).toDate();
                    localTime = moment(localTime).format("DD/MM/YYYY");
                    item.dtLastUpdate = localTime;
                }
            }, this);
        };

        vm.goRoute = function (action, formId, formName){
            Form.routeGo(vm.modulo, action, formId, formName);
        }       

        vm.init = function () {
            vm.applications =[];
            vm.isLoadingUserCompanies = true;
            vm.selectize_config = [];
            vm.selectize_companies_config = [];
            vm.companies = [];
            vm.copyFormOptions = {};
            vm.selectize_publish_levels = [];
            vm.selectize_publish_levels_search = [];
            vm.selectize_publish_levels_modal = [];
            vm.selectize_forms = [];
            vm.selectize_apps_config = [];
            vm.selectize_forms_add = [];
            vm.listLeafsCategories = [];
            vm.categories = [];
            vm.categoriesFather = [];
            vm.newListCategories = [];
            vm.newListCategoriesHierarchy = [];
            vm.archiveList = [];
            vm.selectize_status = [];
            vm.filters = {};            
            vm.categoryFilters = {};

            vm.initComponents();            
            vm.carregarFiltros();
            vm.filters.modulo = vm.modulo;               
            vm.categoryFilters.modulo = vm.modulo;
            if(vm.modulo == "Nps" || vm.modulo == "FormGeral"){
                vm.uk_class_by_modulo = "uk-width-7-10 uk-overflow-container uk-border-right uk-height-1-1";
                vm.layoutConfig = 1;
                vm.getCategories(vm.categoryFilters);              
            }else if(vm.modulo == "Relacionamento" || vm.modulo == "Integracao" ){
                vm.uk_class_by_modulo = "uk-width-1-1 uk-overflow-container uk-border-right uk-height-1-1";
                vm.layoutConfig = 2;
                vm.getForms(vm.filters);
            }            
        };
        
        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isFormVisualizarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();       
    }

    angular.module('app.form')
        .controller('FormListController', FormListController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function FormCreateController($anchorScroll, $controller, $location, $rootScope, $scope, $state, $stateParams, $timeout, $window, uuid2, Category, DashboardCompany, Common, Form, APPLICATION, FORMS, Security) {        
        var vm = this
        vm.operation = 'Cadastrar';
        vm.optionsTableLimit = 100;
        //TODO: remove deleted items from dependencies array (low priority)

        //hides sidebar menu - class sidebar_main_active
        $rootScope.primarySidebarActive = true;

        var appSelecionada = DashboardCompany.obterAppSelecionada();

        var sets = ['visibleRuleSet', 'requiredRuleSet', 'readOnlyRuleSet', 'validationRuleSet'];

        vm.models = {
            selected: undefined,
            components: undefined
        };

        vm.form = {
            children: [
                {
                    ruleControlId: uuid2.newguid(),
                    immutableTitle: 'Página',
                    title: 'Página 1',
                    draggableType: 'container',
                    type: 'SubForm',
                    dropType: 'subform',
                    icon: 'folder',
                    componentIcon: '&#xe9c9',
                    minOccurs: '1',
                    maxOccurs: '1',
                    isRepeatable: false,
                    children: [],
                    allowedTypes: ['item', 'repeatGroup']
                }
            ],
            finalMessage: 'Formulário enviado com sucesso!',
            okButtonLabel: 'Enviar'
        };

        vm.getForm = function (id) {
            vm.isLoading = true;
            return Form.getById(id).then(function (form) {
                vm.form = form;
                buildMissingDataTree(vm.form.children);
                vm.modulo = vm.form.modulo;
                vm.isLoading = false;
                return vm.form;
            });
        };

        vm.getFormTemplates = function () {
            return Form.getFormTemplates().then(function (components) {
                vm.models.components = components;
                return vm.models.components;
            });
        };

        vm.getFormCategories = function () {
            vm.isLoading = true;
            var filter = {};
            filter.modulo = vm.modulo;
            return Form.getFormCategory(filter).then(function (properties) {
                vm.selectize_category.options = properties;
                vm.isLoading = false;
                return vm.selectize_category;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.getBehaviorProperties = function () {
            return Form.getBehaviorProperties().then(function (properties) {
                vm.selectize_behaviors.options = properties;
                return vm.selectize_behaviors;
            });
        };

        vm.getTypeNumberProperties = function () {
            return Form.getTypeNumberProperties().then(function (properties) {
                vm.selectize_type_number.options = properties;
                return vm.selectize_type_number;
            });
        };        

        vm.getTypeDateProperties = function () {
            return Form.getTypeDateProperties().then(function (properties) {
                vm.selectize_type_date.options = properties;
                return vm.selectize_type_date;
            });
        };        

        vm.getLogicalConditionalProperties = function () {
            return Form.getLogicalConditionalProperties().then(function (properties) {
                vm.selectize_logicalConditional.options = properties;
                return vm.selectize_logicalConditional;
            });
        };

        vm.getLogicalOperatorsProperties = function () {
            return Form.getLogicalOperatorsProperties().then(function (properties) {
                vm.selectize_logicalOperators.options = properties;
                return vm.selectize_logicalOperators;
            });
        };

        vm.getTextTypeFreeTextComponentProperties = function () {
            return Form.getTextTypeFreeTextComponentProperties().then(function (properties) {
                vm.selectize_textTypeFreeTextComponent.options = properties;
                return vm.selectize_textTypeFreeTextComponent;
            });
        };

        vm.getMethodSelectsComponentProperties = function () {
            // return Form.getMethodSelectsComponentProperties().then(function (properties) {
            return Form.geListMappings(appSelecionada.id).then(function (properties) {
                vm.selectize_methodSelectsComponent.options = properties.mapping.forms ? properties.mapping.forms : [];
                return vm.selectize_methodSelectsComponent;
            });
        };

        vm.getSelectTypeSimpleSelectComponentProperties = function () {
            return Form.getSelectTypeSimpleSelectComponentProperties().then(function (properties) {
                vm.selectize_selectTypeSimpleSelectComponent.options = properties;
                return vm.selectize_selectTypeSimpleSelectComponent;
            });
        };

        vm.getSelectTypeMultipleSelectComponentProperties = function () {
            return Form.getSelectTypeMultipleSelectComponentProperties().then(function (properties) {
                vm.selectize_selectTypeMultipleSelectComponent.options = properties;
                return vm.selectize_selectTypeMultipleSelectComponent;
            });
        };

        vm.getDateTimeTypeDateTimeComponentProperties = function () {
            return Form.getDateTimeTypeDateTimeComponentProperties().then(function (properties) {
                vm.selectize_dateTimeTypeDateTimeComponent.options = properties;
                return vm.selectize_dateTimeTypeDateTimeComponent;
            });
        };

        vm.getNumberTypeNumberComponentProperties = function () {
            return Form.getNumberTypeNumberComponentProperties().then(function (properties) {
                vm.selectize_numberTypeNumberComponent.options = properties;
                vm.focusedComponent = !vm.focusedComponent ? {} : vm.focusedComponent;
                vm.focusedComponent.numberType = !vm.focusedComponent.numberType || vm.focusedComponent.numberType == 'Nothing' ? 'Integer' : vm.focusedComponent.numberType;
                return vm.selectize_numberTypeNumberComponent;
            });
        };

        vm.getOriginImageComponentProperties = function () {
            return Form.getOriginImageComponentProperties().then(function (properties) {
                vm.selectize_originImageComponent.options = properties;
                return vm.selectize_originImageComponent;
            });
        };

        vm.getTooltips = function () {
            return Form.getTooltips().then(function (properties) {
                vm.tooltips = properties;
                return vm.tooltips;
            });
        };

        vm.getConditionTypesProperties = function () {
            return Form.getConditionTypes().then(function (properties) {
                vm.selectize_conditionTypes.options = properties;
                return vm.selectize_conditionTypes;
            });
        };

        vm.getParametersTypesProperties = function () {
            return Form.getparametersTypes().then(function (properties) {
                vm.selectize_parametersTypes.options = properties;
                return vm.selectize_parametersTypes;
            });
        };

        vm.getReservedWordsProperties = function () {
            return Form.getReservedWords().then(function (properties) {
                vm.selectize_reservedWords.options = properties;
                return vm.selectize_reservedWords;
            });
        };

        vm.getArithmeticOperatorsProperties = function () {
            return Form.getArithmeticOperators().then(function (properties) {
                vm.selectize_arithmeticOperators.options = properties;
                return vm.selectize_arithmeticOperators;
            });
        };

        vm.detailComponent = function (fieldComponent) {
            vm.typeFocusedComponentDate = fieldComponent && fieldComponent.dateTimeType == 'Date' ? true : false;
            vm.focusedComponent = fieldComponent;

            fieldComponent.numberType = fieldComponent.type == 'Number' && (!fieldComponent.numberType || fieldComponent.numberType == 'Nothing') ? 'Integer' : fieldComponent.numberType;
            //vm.focusedComponent.typeDate ='DayMonthYear';

            if (vm.focusedComponent.ruleConfig == undefined) {
                vm.focusedComponent.ruleConfig = {
                    screenRevision: true,
                    requiredBehavior: 'Never',
                    visibleBehavior: 'Always',
                    readOnlyBehavior: 'Never',
                    requiredRuleSet: [],
                    visibleRuleSet: [],
                    readOnlyRuleSet: [],
                    validationRuleSet: [], //refactored for RPN solution
                    //validationRuleSet: {},
                    dependencies: []
                }
            }
            $timeout(function () {
                $location.hash('detailColumn');
                $anchorScroll();
            })

            mapComponentSpecificProperties(vm.focusedComponent);
        };

        var idsArray = [];
        function checkNestedRuleIds(itemTree) {
            _.each(itemTree, function (item) {
                idsArray.push(item.ruleControlId);
                if (item.children && item.children.length > 0) {
                    checkNestedRuleIds(item.children);
                }
            });
            return idsArray;
        };

        vm.removeComponent = function (list, index, ruleControlId, item) {
            if(list.length == 1 && item.type == "SubForm")
            {
                Common.mensagemError('Não é permitido excluir todas as páginas do formulário.');
                return;
            }
            /*If component is deleted, then all rules that have this component associated 
            in componentOrderLeft or componentOrderRight field,
            also must be deleted*/
            UIkit.modal.confirm('Deseja realmente excluir o campo ' + item.title + '?', function () {

                /**Remove all components and ruleas associated inside subform as well */
                if (item.type == 'SubForm') {
                    idsArray = [];
                    var itemsResult = checkNestedRuleIds(item.children);
                    itemsResult.push(ruleControlId);
                    ruleControlId = angular.copy(itemsResult);
                }

                buildCascadeDeleteRuleSetTree(vm.form.children, ruleControlId);
                list.splice(index, 1);
                vm.focusedComponent = undefined;
                Common.messageSuccess('Campo', 'D', 'M');
            });
        };

        vm.adjustFormArray = function (form) {
            setOrderField(form);
            setDependencies(form);
            setRpnRules(form);
            adjustFormIdentifiers(form.children);
        };

        vm.generateComponentGuidId = function (item) {
            if (item.ruleControlId) {
                return item.ruleControlId;
            }
            return uuid2.newguid();
        };

        vm.dropCallback = function (event, index, item) {
            item.ruleControlId = vm.generateComponentGuidId(item);
            vm.models.selected = item;
            vm.detailComponent(item);
            return item;
        };

        vm.dropItemManually = function (item, isCopy, isContainer, index, list) {
            if (item.dropType != "subform" && !isCopy) {
                Common.mensagemError('Arraste e solte em um sub-formulário.');
            } else {
                var newItem = angular.copy(item);
                if (isCopy)
                {
                    newItem.ruleControlId = uuid2.newguid();
                    newItem.rootParent = uuid2.newguid();
                }
                if(isContainer)
                {
                    if (isCopy) {
                        for(var i = 0; i < newItem.children.length; i++){
                            newItem.children[i].ruleControlId = uuid2.newguid();
                            newItem.children[i].rootParent = uuid2.newguid();
                        }
                        newItem.title = 'Nova Página';
                    }
                    vm.form.children.splice(index+1, 0, newItem);
                }
                else
                {
                    list.splice(index+1, 0, newItem);
                }                

                vm.models.selected = newItem;
                vm.detailComponent(newItem);
                $timeout(function () {
                    $('#FieldsTab').click();
                    $('#middleColumn').scrollTop($('#middleColumn')[0].scrollHeight);
                })
            }
        };

        /* Perfumaria form validations */
        vm.textTypeStateChanged = function (textType) {
            if (textType.length > 0) {
                vm.focusedComponent.allowMultipleLine = textType == 'FreeText';
                var result = _.find(vm.selectize_textTypeFreeTextComponent.options, 'id', textType).validationRuleSet;
                _.remove(vm.focusedComponent.ruleConfig.validationRuleSet, function (value) {
                    return value.isTextTypeValidationSet == true
                });
                for (var i = 0; i < vm.focusedComponent.ruleConfig.validationRuleSet.length; i++) {
                    var element = vm.focusedComponent.ruleConfig.validationRuleSet[i];
                    element.order = i;
                }
                if (result.regularExpression && result.validationMessage) {                    
                    var object = { structuredRule: [] }
                    object.id = uuid2.newguid();
                    object.isTextTypeValidationSet = true; //specific for this only
                    object.order = vm.focusedComponent.ruleConfig.validationRuleSet.length;
                    object.title = result.validationMessage;
                    object.rule = '@THIS #' + result.regularExpression + ' IsValid';
                    object.message = result.validationMessage;
                    object.structuredRule.push({
                        "immutableTitle": "Expressão",
                        "title": "Expressão",
                        "draggableType": "rpnItem",
                        "type": "SimpleExpression",
                        "dropType": "item",
                        "icon": "functions",
                        "componentIcon": "functions",
                        "conditionTypeOrderLeft": "ByComponent",
                        "componentOrderLeft": "@THIS",
                        "logicalCondition": "IsValid",
                        // "conditionTypeOrderRight": "ByRegularExpression",
                        "conditionTypeOrderRight": undefined,
                        "componentOrderRight": result.regularExpression
                    });
                    vm.focusedComponent.ruleConfig.validationRuleSet.push(object);
                }
            }
        };

        vm.visibleBehaviourStateChanged = function (behaviour) {
            if (behaviour.length > 0) {
                if (behaviour == 'Never') {
                    vm.focusedComponent.ruleConfig.requiredBehavior = 'Never';
                    vm.focusedComponent.ruleConfig.readOnlyBehavior = 'Never';
                }
            }
        };

        vm.readOnlyBehaviourStateChanged = function (behaviour) {
            if (behaviour.length > 0) {
                if (behaviour == 'Always') {
                    vm.focusedComponent.ruleConfig.requiredBehavior = 'Never';
                }
            }
        };

        vm.dateTimeTodayStateChanged = function () {
            vm.focusedComponent.afterDays = undefined;
            vm.focusedComponent.beforeDays = undefined;
            vm.focusedComponent.afterIsInsideRange = undefined;
            vm.focusedComponent.beforeIsInsideRange = undefined;
            vm.focusedComponent.hrInitialRange = undefined;
            vm.focusedComponent.hrEndRange = undefined;
            vm.focusedComponent.dtInitialRange = undefined;
            vm.focusedComponent.dtEndRange = undefined;
        };

        vm.imageMinQtdImagesStateChanged = function (quant) {
            if (quant > 0) {
                vm.focusedComponent.ruleConfig.requiredBehavior = 'Always';
            }
        };

        vm.conditionTypeStateChanged = function (item) {
            if (item.conditionType) {
                if (item.conditionType.length > 0) {
                    item.componentOrderRight = undefined;
                }
            }
        };

        vm.simpleSelectTypeStateChangedLstnrClb1 = $scope.$watch('vm.focusedComponent.selectType', function (new_fieldcontainer, old_fieldcontainer) {

            if (typeof old_fieldcontainer === 'undefined') return;
            var yeOrNoObject = [];
            yeOrNoObject.push({ text: 'Sim', value: '1', checked: false });
            yeOrNoObject.push({ text: 'Não', value: '0', checked: false });
            if (new_fieldcontainer && new_fieldcontainer.length > 0) {
                if (vm.focusedComponent.options) {
                    vm.optionsForCompare = angular.copy(vm.focusedComponent.options);
                    vm.optionsForCompare.forEach(function (v) { delete v.id });
                }
                if (new_fieldcontainer == 'YesOrNo') {
                    if (!angular.equals(vm.optionsForCompare, yeOrNoObject) && vm.optionsForCompare) {
                        UIkit.modal.confirm('Deseja realmente alterar para Sim/Não?' +
                            '<br><span style="font-size:14px" class="uk-text-muted">Já existem opções cadastradas para esse componente.</span>', function () {
                                //Desejo
                                vm.focusedComponent.options = angular.copy(yeOrNoObject);
                                //O campo só pode ter ou lista de valor ou conexao externa. Nunca os dois                                
                                vm.focusedComponent.externalDataSource = undefined;
                            }, function () {
                                //Não desejo
                                vm.focusedComponent.selectType = old_fieldcontainer;
                                return false;
                            });
                    } else {
                        vm.focusedComponent.options = angular.copy(yeOrNoObject);
                    }
                } else {
                    if (angular.equals(vm.optionsForCompare, yeOrNoObject)) {
                        vm.focusedComponent.options = [];
                    }
                }
            }
        });

        vm.npsSelectTypeStateChangedLstnrClb1 = $scope.$watch('vm.focusedComponent.npsSelectType', function (new_fieldcontainer, old_fieldcontainer) {

            if (typeof old_fieldcontainer === 'undefined') return;
            var yeOrNoObject = [];
            yeOrNoObject.push({ text: 'Sim', value: '1', checked: false });
            yeOrNoObject.push({ text: 'Não', value: '0', checked: false });
            if (new_fieldcontainer && new_fieldcontainer.length > 0) {
                if (vm.focusedComponent.options) {
                    vm.optionsForCompare = angular.copy(vm.focusedComponent.options);
                    vm.optionsForCompare.forEach(function (v) { delete v.id });
                }
                if (new_fieldcontainer == 'YesOrNo') {
                    if (!angular.equals(vm.optionsForCompare, yeOrNoObject) && vm.optionsForCompare) {
                        UIkit.modal.confirm('Deseja realmente alterar para Sim/Não?' +
                            '<br><span style="font-size:14px" class="uk-text-muted">Já existem opções cadastradas para esse componente.</span>', function () {
                                //Desejo
                                vm.focusedComponent.options = angular.copy(yeOrNoObject);
                                //O campo só pode ter ou lista de valor ou conexao externa. Nunca os dois                                
                                vm.focusedComponent.externalDataSource = undefined;
                            }, function () {
                                //Não desejo
                                vm.focusedComponent.npsSelectType = old_fieldcontainer;
                                return false;
                            });
                    } else {
                        vm.focusedComponent.options = angular.copy(yeOrNoObject);
                    }
                } else {
                    if (angular.equals(vm.optionsForCompare, yeOrNoObject)) {
                        vm.focusedComponent.options = [];
                    }
                }
            }
        });


        vm.checkedOptionSelectionsStateChanged = function (type, index, boolValue) {
            if (type == 'SimpleSelect' || type == 'NpsSelect') {
                if (boolValue) {
                    if (vm.options.length > 0) {
                        for (var i = 0; i < vm.options.length; i++) {
                            if (index != i) {
                                vm.options[i].checked = false;
                            }
                        }
                    }
                }
            }
        };

        vm.checkNullObjectProperties = function (object) {
            for (var prop in object) {
                if (object.hasOwnProperty(prop)) {
                    return false
                }
            }
            return true;
        }
        /* End of Perfumaria form validations */

        // vm.modalRuleOpenProcess = function (field, modalTitle, removalId) {
        //     updateRuleComponents(removalId);
        //     vm.modalTitle = modalTitle;
        //     //merely alias for ruleConfig (requiredRuleSet, visibleRuleSet or validationRuleSet)   
        //     vm.ruleField = field;
        //     //new temp var: vm.requiredRuleSet, vm.visibleRuleSet or vm.validationRuleSet
        //     vm[vm.ruleField] = angular.copy(vm.focusedComponent.ruleConfig[vm.ruleField]);
        //     vm.ruleItem_form = {};
        //     vm.noteActive = false;
        // };

        vm.modalOptionsOpenProcess = function () {

            vm.listOptionsType = angular.copy(vm.focusedComponent.listOptionsType);
            vm.listOptionsType = !vm.listOptionsType || vm.listOptionsType == undefined ? 0 : vm.listOptionsType;
            vm.adjustListOptions();
            updateParametersListComponents(vm.focusedComponent.ruleControlId);
            vm.options = angular.copy(vm.focusedComponent.options);
            vm.bulkInsert = false;
            vm.optionsValues = undefined;
            if (vm.options == undefined || vm.options.length == 0) {
                vm.options = [];
                vm.addOptionsCondition();
            }
            //join need 'cause both list types are in same modal now
            vm.modalExternalDataSourceOpenProcess();
            vm.tempUrlParams = {};
            vm.tempUrlParams.type = 'ByValue';
        };

        vm.adjustListOptions = function () {
            $timeout(function () {
                if (vm.listOptionsType == 0) {
                    $('#manualList').click();
                }
                if (vm.listOptionsType == 1) {
                    $('#connectionList').click();
                }
            })
        };

        vm.selectListOptionsTab = function (listOptionsType) {
            vm.listOptionsType = listOptionsType;
            if (vm.listOptionsType == 1) {
                vm.bulkInsert = false;
            }
        }

        vm.hasValues = function (obj) {
            return !_.isEmpty(obj);
        };

        vm.modalExternalDataSourceOpenProcess = function () {
            vm.tempExternalDataSource = angular.copy(vm.focusedComponent.externalConnection);
            if (vm.tempExternalDataSource == undefined || _.isEmpty(vm.tempExternalDataSource)) {
                vm.tempExternalDataSource = {};
                vm.tempExternalDataSource.name = "open-conection";
            }
            if (vm.tempExternalDataSource.parameters == undefined || _.isEmpty(vm.tempExternalDataSource.parameters))
            {
                vm.tempExternalDataSource.parameters = [];
                vm.tempExternalDataSource.parameters[0] = {};
                vm.tempExternalDataSource.parameters[0].title = "querystring";
                vm.tempExternalDataSource.parameters[0].urlParams = {};
            }
        };

        vm.modalCustomPropertiesFormOpenProcess = function () {
            vm.tempCustomPropertiesForm = {};
            if (vm.form.customProperties == undefined) {
                vm.form.customProperties = {};
            }
            vm.customPropertiesFormObject = angular.copy(vm.form.customProperties);
            if (vm.customPropertiesFormObject == undefined || _.isEmpty(vm.customPropertiesFormObject)) {
                vm.customPropertiesFormObject = {};
            }
        };

        vm.modalCustomPropertiesComponentOpenProcess = function () {
            vm.tempCustomPropertiesComponent = {};
            if (vm.focusedComponent.customProperties == undefined) {
                vm.focusedComponent.customProperties = {};
            }
            vm.customPropertiesComponentObject = angular.copy(vm.focusedComponent.customProperties);
            if (vm.customPropertiesComponentObject == undefined || _.isEmpty(vm.customPropertiesComponentObject)) {
                vm.customPropertiesComponentObject = {};
            }
        };

        vm.addRuleCondition = function () {
            vm[vm.ruleField].push({ logicalOperator: 'And', conditionType: 'ByValue', logicalCondition: 'HasValue', componentOrderLeft: undefined, componentOrderRight: undefined });
        };

        vm.addOptionsCondition = function () {
            vm.options.push({ text: undefined, value: undefined, checked: false, icon: undefined });
        };

        vm.addOptionsCondition = function (index) {
            vm.options.splice(index + 1, 0, { text: undefined, value: undefined, checked: false, icon: undefined });
            $timeout(function () { $('#formOptionsText' + (index+1)).focus(); }, 300);            
        };

        vm.addHeaderCondition = function (tempObject) {
            if (vm.tempExternalDataSource.headers == undefined || _.isEmpty(vm.tempExternalDataSource.headers)) {
                vm.tempExternalDataSource.headers = {};
            }
            if (tempObject.key && tempObject.value) {
                vm.tempExternalDataSource.headers[tempObject.key] = tempObject.value;
                vm.tempHeader = {};
            }
        };

        vm.translateParamValue = function (value) {
            var result = value;
            if (result == undefined || !result) {
                return undefined;
            }
            _.each(vm.selectize_components.options, function (item) {
                result = result.replace(item.id, item.propertyName);
            });
            return result;
        }

        vm.addUrlParamsCondition = function (tempObject) {
            if (vm.tempExternalDataSource.parameters[0].urlParams == undefined || _.isEmpty(vm.tempExternalDataSource.parameters[0].urlParams)) {
                vm.tempExternalDataSource.parameters[0].urlParams = {};
            }
			if(vm.tempUrlParams.type == 'ByValue')
			{
				if (tempObject.key && tempObject.value) {
					vm.tempExternalDataSource.parameters[0].urlParams[tempObject.key] = tempObject.value;
                    vm.tempUrlParams = {};
                    vm.tempUrlParams.type = 'ByValue';
				}
			}
			else
			{
				if (tempObject.key && tempObject.component) {
					vm.tempExternalDataSource.parameters[0].urlParams[tempObject.key] = tempObject.component;
                    vm.tempUrlParams = {};
                    vm.tempUrlParams.type = 'ByValue';
				}
			}
        }; 

        vm.addCustomPropertiesFormCondition = function (tempObject) {
            if (tempObject.key && tempObject.value) {
                vm.customPropertiesFormObject[tempObject.key] = tempObject.value;
                vm.tempCustomPropertiesForm = {};
            }
        };

        vm.addCustomPropertiesComponentCondition = function (tempObject) {
            if (tempObject.key && tempObject.value) {
                vm.customPropertiesComponentObject[tempObject.key] = tempObject.value;
                vm.tempCustomPropertiesComponent = {};
            }
        };

        vm.removeRuleCondition = function (index) {
            vm[vm.ruleField].splice(index, 1);
        };

        vm.removeOptionsCondition = function (index) {
            vm.options.splice(index, 1);
        };

        vm.removeHeaderCondition = function (keyName) {
            // delete vm.headerObject[keyName];
            delete vm.tempExternalDataSource.headers[keyName];
        };

        vm.removeUrlParamsCondition = function (keyName) {
            // delete vm.headerObject[keyName];
            delete vm.tempExternalDataSource.parameters[0].urlParams[keyName];
        };

        vm.removeCustomPropertiesFormCondition = function (keyName) {
            delete vm.customPropertiesFormObject[keyName];
        };

        vm.removeCustomPropertiesComponentCondition = function (keyName) {
            delete vm.customPropertiesComponentObject[keyName];
        };

        vm.saveRuleModal = function () {
            vm.focusedComponent.ruleConfig[vm.ruleField] = angular.copy(vm[vm.ruleField]);
            vm.closeModal("#modalRuleConfig");
        };

        vm.confirmedSaveOptionsModal = function () {
            if (vm.listOptionsType == 0) {
                if (vm.focusedComponent.type == 'SimpleSelect' || vm.focusedComponent.type == 'NpsSelect') {
                    if (vm.options.length > 0) {
                        var cont = 0;
                        var contNumbersOnly = 0;
                        for (var i = 0; i < vm.options.length; i++) {
                            if (vm.options[i].checked) {
                                cont++;
                            }

                            if (isNaN(vm.options[i].value)) {
                                contNumbersOnly++;
                            }
                        }
                        if (cont > 1) {
                            Common.mensagemError('Esse componente apenas permite um valor padrão selecionado!');
                            return;
                        }

                        if (contNumbersOnly > 1 && vm.focusedComponent.type == 'NpsSelect') {
                            Common.mensagemError('Componente NPS apenas permite valores numéricos!');
                            return;
                        }
                    }
                }
                _.remove(vm.options, function(item){
                    return !item.text;
                });
                vm.focusedComponent.options = angular.copy(vm.options);
                vm.focusedComponent.externalConnection = undefined;
            }
            if (vm.listOptionsType == 1) {
                vm.focusedComponent.externalConnection = angular.copy(vm.tempExternalDataSource);
                //O campo só pode ter ou lista de valor ou conexao externa. Nunca os dois
                vm.focusedComponent.options = undefined;
                //vm.closeModal("#modalExternalDataSourceConfig");
            }
            vm.focusedComponent.listOptionsType = angular.copy(vm.listOptionsType);
            vm.closeModal("#modalOptionsConfig");
            return true;
        };

        vm.saveOptionsModal = function () {
            var selectedOption = '';
            var removedOption = '';

            if (vm.listOptionsType == 0) {
                selectedOption = 'Lista manual';
                removedOption = 'Lista por conexão';
            } else {
                selectedOption = 'Lista por conexão';
                removedOption = 'Lista manual';
            }
            
            var manualWithItem = vm.options.length > 0 && !_.isEmpty(vm.options[0].text);
            var conectionWithItem = vm.tempExternalDataSource.path != undefined || !_.isEmpty(vm.tempExternalDataSource.parameters[0].urlParams);
            
            if ((vm.listOptionsType == 1 && manualWithItem) || (vm.listOptionsType == 0 && conectionWithItem))
                UIkit.modal.confirm('Você selecionou a opção ' + selectedOption + '. Todos os dados referentes à ' + removedOption + ' serão perdidos. Deseja continuar?', 
                    vm.confirmedSaveOptionsModal,
                    function () {
                        return false;
                    }
                );
            else
                vm.confirmedSaveOptionsModal();
        };

        vm.cancelbulkInsertOptionsModal = function () {
            delete vm.optionsValues;
            vm.bulkInsert = false;
        };

        vm.bulkInsertOptionsModal = function (csvString) {
            if (vm.optionsValues) {
                var lines = csvString.split('\n');
                var dataValues = lines.map(function (dataLine) { return dataLine.split(';'); });
                vm.options = [];
                for (var i = 0; i < dataValues.length; i++) {
                    var rowValues = dataValues[i];
                    if(rowValues[0])
                    {
                        var selectedValue = rowValues[1];
                        if(selectedValue == undefined) 
                            selectedValue = "";
                        vm.options.push({ text: rowValues[0], value: selectedValue, checked: rowValues[2] == 'true', icon: undefined });
                    }
                }
                delete vm.optionsValues;
                vm.bulkInsert = false;
            }
        };

        vm.insertInLote = function() {
            vm.optionsValues = '';
            vm.bulkInsert = true;

            if (vm.options) {
                for (var i = 0; i < vm.options.length; i++) {
                    if (vm.options[i].text) {
                        var selectValue = vm.options[i].value == undefined ? "" : vm.options[i].value;
                        vm.optionsValues += vm.options[i].text + ';' + selectValue + ';' + vm.options[i].checked + ';' + "\n";
                    }                    
                }
            }
        };

        vm.saveExternalDataSourceModal = function () {
            vm.focusedComponent.externalConnection = angular.copy(vm.tempExternalDataSource);
            //O campo só pode ter ou lista de valor ou conexao externa. Nunca os dois
            vm.focusedComponent.options = undefined;
            //vm.closeModal("#modalExternalDataSourceConfig");
        };

        vm.saveCustomPropertiesFormModal = function () {
            vm.form.customProperties = angular.copy(vm.customPropertiesFormObject);
            vm.closeModal("#modalCustomPropertiesFormConfig");
        };

        vm.saveCustomPropertiesComponentModal = function () {
            vm.focusedComponent.customProperties = angular.copy(vm.customPropertiesComponentObject);
            vm.closeModal("#modalCustomPropertiesComponentConfig");
        };

        vm.closeModal = function (modalTitle) {
            var modal = UIkit.modal(modalTitle);
            modal.hide();
        };

        vm.saveForm = function (form) {
            if (form.children.length == 0) {
                UIkit.modal.alert('Por favor adicione pelo menos um campo ao seu formulário!')
                return;
            }
            if (!findNoSubFormsTree(form.children)) {
                UIkit.modal.alert('Por favor, adicione pelo menos um Subformulário.');
                return;
            }
            if (findEmptySubFormsTree(form.children)) {
                UIkit.modal.alert('Por favor, reveja seu formulário! Existem Subformulário(s) e(ou) Grupo(s) de Repetição vazio(s).');
                return;
            }

            function innerSaving() {
                if (findStepHeaderSubFormsAvailability(form.children) && form.hasStepsHeader) {
                    form.hasStepsHeader = false;
                    //UIkit.modal.alert('Você solicitou a exibição de cabeçalho de etapas para Subformulário. Por favor, adicione pelo menos um Subformulário!');
                }
                vm.adjustFormArray(form);
                if (form.id) {
                    vm.putForm(form);
                } else {
                    vm.postForm(form);
                }
            };

            // UIkit.modal.confirm('Deseja salvar e continuar a edição?', function () {
            //     vm.saveExit = false;
            //     innerSaving();
            //     return true;
            // }, function () {
            //     vm.saveExit = true;
            //     innerSaving();
            //     return false;
            // }
            //     // { labels: { 'Ok': 'Salvar e continuar', 'Cancel': 'Salvar e sair' } }
            // );

            innerSaving();
        };

        vm.postForm = function (form) {
            vm.isLoading = true;
            form.appCompanyId = appSelecionada.id;
            form.modulo = vm.modulo;
            Form.post(form).then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Formulário', 'I', 'M');
                        vm.isLoading = false;
                        if (vm.saveExit) {
                            vm.goRoute('back', null, null);
                            // $state.go('private.painel.form.list', { modulo: vm.modulo });
                        } else {
                            vm.goRoute('edit', result.id, null);
                            // $state.go('private.painel.form.edit', { id: result.id });
                        }
                    } else {
                        Common.mensagemError(result);
                        vm.isLoading = false;
                    }
                }
                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.putForm = function (form) {
            vm.isLoading = true;
            form.put().then(function (result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Formulário', 'A', 'M');
                        vm.isLoading = false;
                        if (vm.saveExit) {
                            vm.goRoute('back', null, null);
                            // $state.go('private.painel.form.list', { modulo: vm.modulo });
                        } else {
                            vm.goRoute('edit', result.id, null);
                            // $state.go('private.painel.form.edit', { id: result.id });
                        }
                    } else {
                        Common.mensagemError('Erro ao atualizar registro.');
                        vm.isLoading = false;
                    }
                }
                else {
                    //null return when nothing has changed
                    Common.messageSuccess('Formulário', 'A', 'M');
                    vm.isLoading = false;
                    if (vm.saveExit) {
                        vm.goRoute('back', null, null);
                        // $state.go('private.painel.form.list', { modulo: vm.modulo });
                    } else {
                        vm.goRoute('edit', form.id, null);
                        // $state.go('private.painel.form.edit', { id: form.id });
                    }
                    //Common.mensagemError('Erro ao atualizar registro.');
                    //$state.go('private.painel.form.list');
                }

                vm.isLoading = false;
            }).catch(function () {
                vm.isLoading = false;
            });
        };

        vm.cancelForm = function () {
            UIkit.modal.confirm('Deseja realmente cancelar ' + (vm.operation.toLowerCase() === 'editar'? 'a edição': 'o cadastro') + ' do formulário?' +
                '<br><span style="font-size:14px" class="uk-text-muted">Atenção: Todos as alterações serão perdidas!</span>', function () {
                    vm.goRoute('back', null, null);
                    // $state.go('private.painel.form.list', { modulo: vm.modulo });
                },
                function () {
                    //do nothing
                }
                // { labels: { 'Ok': 'Sim', 'Cancel': 'Não' } }

            );
        };

        vm.copyToClipboard = function (data) {
            angular.element('<textarea/>')
                .css({ 'opacity': '0', 'position': 'fixed' })
                .text(JSON.stringify(data))
                .appendTo(angular.element($window.document.body))
                .select()
                .each(function () { document.execCommand('copy') })
                .remove();
            Common.messageSuccess('Formulário', 'C', 'M');
        }

        vm.getIcons = function () {
            vm.iconsCode = Category.iconsListMobileCare();
        }

        vm.openModalIcons = function () {
            var modal = UIkit.modal(".modalIcons");
            modal.show();

        }

        vm.selectIcon = function (item) {
            vm.focusedComponent.componentIcon = item.id;
            var modal = UIkit.modal(".modalIcons");
            modal.hide();
        }

        vm.captureKeyboardEvent = function (event) {
            if (event.keyCode == 27) {
                //allow modal exit if no changes have been made
                if (angular.equals(vm.ruleItem_form, vm.ruleItem_formEscCompare)) {
                    $timeout(function () {
                        angular.element('#modalRuleConfigCloseButton').trigger('click');
                        angular.element('#rpnRulePropertyCloseButton').trigger('click');
                    });
                } else {
                    UIkit.modal.confirm('Existem alterações não salvas. Deseja realmente sair?', function () {
                        $timeout(function () {
                            angular.element('#modalRuleConfigCloseButton').trigger('click');
                            angular.element('#rpnRulePropertyCloseButton').trigger('click');
                        });
                    }, function () {
                        focusHtmlComponent('modalRuleConfig');
                        return false;
                    }
                        // { labels: { 'Ok': 'Sim', 'Cancel': 'Não' } }
                    );
                }
            }
        }

        function setOrderField(form) {
            //count up 'order' field (for sorting purposes)
            buildSortedTree(form.children);
        };

        function setDependencies(form) {
            buildDependenciesTree(form.children);
        };

        function setRpnRules(form) {
            buildRpnRulesTree(form.children);
        };

        function buildSortedTree(tree) {
            var cont = 0;
            _.each(tree, function (item) {
                cont++;
                item.order = cont;
                if (item.children && item.children.length > 0) {
                    buildSortedTree(item.children);
                }
            });
        };

        function buildMissingDataTree(tree) {
            //Mapping to add missing fields to array and avoid problems with ng-repeat and 'track by' with drag component
            _.each(tree, function (item) {
                if (item.type == 'SubForm') {
                    item.draggableType = 'container';
                    if (item.minOccurs == 1 && item.maxOccurs == 1) {
                        item.immutableTitle = 'Página';
                        item.isRepeatable = false;
                        item.dropType = 'subform';
                        item.allowedTypes = ['item', 'repeatGroup'];
                    } else {
                        item.immutableTitle = 'Grupo de Repetição';
                        item.isRepeatable = true;
                        item.dropType = 'repeatGroup';
                        item.allowedTypes = ['item'];
                    }
                } else {
                    item.draggableType = 'item';
                    item.dropType = 'item';
                }
                var result = translateTypeInfo(item, item.type, item.immutableTitle);
                item.immutableTitle = result.immutableTitle;
                item.icon = result.icon;
                if (item.children && item.children.length > 0) {
                    buildMissingDataTree(item.children);
                }
            });
        };

        function buildComponentsDrodownDataTree(tree, removalId, parentTitle) {
            _.each(tree, function (item) {
                vm.dropdownTitle = parentTitle + '/' + item.title;
                //remove the component (self) from component rules dropdown list and subforms aswell (bussiness logic) 
                if (item.ruleControlId != removalId && item.type != 'SubForm') {
                    vm.dropDownArray.push({ propertyName: vm.dropdownTitle.charAt(0) === '/' ? vm.dropdownTitle.slice(1) : vm.dropdownTitle, id: '@' + item.ruleControlId });
                }
                if (item.children && item.children.length > 0) {
                    buildComponentsDrodownDataTree(item.children, removalId, vm.dropdownTitle);
                }
            });
            return vm.dropDownArray;
        };

        function buildComponentsDrodownDataTreeForUrlParameters(tree, removalId, parentTitle) {
            _.each(tree, function (item) {
                vm.dropdownTitle = parentTitle + '/' + item.title;
                //remove the component (self) from component rules dropdown list and subforms aswell (bussiness logic) 
                if (item.ruleControlId != removalId && item.type != 'SubForm') {
                    vm.dropDownArray.push({ propertyName: vm.dropdownTitle.charAt(0) === '/' ? vm.dropdownTitle.slice(1) : vm.dropdownTitle, id: item.ruleControlId });
                }
                if (item.children && item.children.length > 0) {
                    buildComponentsDrodownDataTreeForUrlParameters(item.children, removalId, vm.dropdownTitle);
                }
            });
            return vm.dropDownArray;
        };

        function checkCascadeDeleteRuleSetTree(structuredRuleTree, deletedItem) {
            _.each(structuredRuleTree, function (item) {

                if (_.isArray(deletedItem)) {
                    _.each(deletedItem, function (item) {
                        _.remove(structuredRuleTree, function (value) {
                            return (value.componentOrderLeft && value.componentOrderLeft.replace('@', '') == item)
                                || (value.componentOrderRight && value.componentOrderRight.replace('@', '') == item)
                        });
                    });
                } else {
                    _.remove(structuredRuleTree, function (value) {
                        return (value.componentOrderLeft && value.componentOrderLeft.replace('@', '') == deletedItem)
                            || (value.componentOrderRight && value.componentOrderRight.replace('@', '') == deletedItem)
                    });
                }
                if (item && item.structuredRule && item.structuredRule.length > 0) {
                    checkCascadeDeleteRuleSetTree(item.structuredRule, deletedItem);
                }
            });
        };

        function buildCascadeDeleteRuleSetTree(tree, ruleControlId) {
            _.each(tree, function (item) {
                if (item.ruleConfig) {
                    _.each(sets, function (set) {
                        _.each(item.ruleConfig[set], function (value) {
                            checkCascadeDeleteRuleSetTree(value.structuredRule, ruleControlId);
                        });
                    });
                }
                if (item.children && item.children.length > 0) {
                    buildCascadeDeleteRuleSetTree(item.children, ruleControlId);
                }
            });
        }

        function checkDependenciesTree(structuredRuleTree, formTree, loopItem) {
            var guidRegexValidation = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
            var fatherComponent = {};
            _.each(structuredRuleTree, function (item) {

                if (guidRegexValidation.test(item.componentOrderLeft)) {
                    var test = item.componentOrderLeft.match(guidRegexValidation)[0];
                    fatherComponent = findDependencyComponentTree(formTree, test);
                    pushDependencyComponent(fatherComponent, loopItem.ruleControlId);
                }
                if (guidRegexValidation.test(item.componentOrderRight)) {
                    var test = item.componentOrderRight.match(guidRegexValidation)[0];
                    fatherComponent = findDependencyComponentTree(formTree, test);
                    pushDependencyComponent(fatherComponent, loopItem.ruleControlId);
                }

                if (item.structuredRule && item.structuredRule.length > 0) {
                    checkDependenciesTree(item.structuredRule, formTree, loopItem);
                }
            });
        };

        function buildDependenciesTree(tree) {
            _.each(tree, function (item) {
                if (item.ruleConfig) {
                    //item.ruleConfig.dependencies = []; //buggy
                    _.each(sets, function (set) {
                        _.each(item.ruleConfig[set], function (value) {
                            checkDependenciesTree(value.structuredRule, vm.form.children, item);
                        });
                    });
                }
                if (item.children && item.children.length > 0) {
                    buildDependenciesTree(item.children);
                }
            });
        };

        var operandsArray = [];
        var operatorsArray = [];
        function checkRpnRulesTree(structuredRuleTree, depth) {

            if (typeof depth == 'number')
                depth++;
            else
                depth = 1;

            _.each(structuredRuleTree, function (item) {

                var componentOrderLeft;
                var componentOrderRight;
                var logicalCondition;

                componentOrderLeft = item.componentOrderLeft;
                componentOrderRight = item.componentOrderRight;
                logicalCondition = item.logicalCondition;

                // Left side //ATTENTION. NOT IN USE ANYMORE, LEFT SIDE IS ALWAYS COMPONENT NOW
                if (item.conditionTypeOrderLeft == "ByValue") {
                    componentOrderLeft = !item.componentOrderLeft ? '\"\"' : '\"' + item.componentOrderLeft + '\"';
                }
                if (item.conditionTypeOrderLeft == "ByRegularExpression") {
                    componentOrderLeft = '#' + item.componentOrderLeft;
                }

                if (item.conditionTypeOrderLeft == "ByExpression") {
                    componentOrderLeft = [item.componentOrderLeftOperandLeft,
                    '\"' + item.componentOrderLeftOperandRight + '\"',
                    item.componentOrderLeftArithmeticOperator].join(' ');
                }

                //Right Side
                if (item.conditionTypeOrderRight == "ByValue") {
                    componentOrderRight = !item.componentOrderRight ? '\"\"' : '\"' + item.componentOrderRight + '\"';
                }
                //no need for this anymore, 'IsValid' will be enough as IsValid == ByRegularExpression
                // if (item.conditionTypeOrderRight == "ByRegularExpression") {
                if (item.logicalCondition == "IsValid") {
                    componentOrderRight = '#' + item.componentOrderRight;
                }

                if (item.conditionTypeOrderRight == "ByExpression") {
                    componentOrderRight = [item.componentOrderRightOperandLeft,
                    '\"' + item.componentOrderRightOperandRight + '\"',
                    item.componentOrderRightArithmeticOperator].join(' ');
                }

                if (item.logicalCondition == "MinLenght") {
                    logicalCondition = 'GreaterOrEqualThan';
                    componentOrderRight = '!' + item.componentOrderRight;
                }
                if (item.logicalCondition == "MaxLenght") {
                    logicalCondition = 'LessOrEqualThan'
                    componentOrderRight = '!' + item.componentOrderRight;
                }

                operandsArray.push(componentOrderLeft);
                operandsArray.push(componentOrderRight);
                operandsArray.push(logicalCondition);

                var logicalOperatorInserted = item.logicalOperator ? operatorsArray.push({ logicalOperator: item.logicalOperator, depth: depth }) : null;



                if (item.structuredRule && item.structuredRule.length > 0) {
                    checkRpnRulesTree(item.structuredRule, depth);
                }
            });

            var sortedOperatorsArray = operatorsArray.sort(Common.compareValues('depth', 'desc'));
            sortedOperatorsArray = _.map(sortedOperatorsArray).map(function (x) {
                return x.logicalOperator
            });
            return operandsArray.concat(sortedOperatorsArray).join(' ');
        };

        function buildRpnRulesTree(tree) {
            _.each(tree, function (item) {
                if (item.ruleConfig) {
                    _.each(sets, function (set) {
                        _.each(item.ruleConfig[set], function (value) {
                            var assembledRule = checkRpnRulesTree(value.structuredRule, 0).replace(/\s+/g, " ").trim();
                            value.rule = assembledRule;
                            operandsArray = [];
                            operatorsArray = [];
                        });
                    });
                }
                if (item.children && item.children.length > 0) {
                    buildRpnRulesTree(item.children);
                }
            });
        };

        function findDependencyComponentTree(items, id) {
            var i = 0, found;
            for (; i < items.length; i++) {
                if (items[i].ruleControlId === id) {
                    return items[i];
                } else if (_.isArray(items[i].children)) {
                    found = findDependencyComponentTree(items[i].children, id);
                    if (found) {
                        return found;
                    }
                }
            }
        };

        function findEmptySubFormsTree(items) {
            var i = 0, found;
            for (; i < items.length; i++) {
                if (_.isArray(items[i].children)) {
                    if (items[i].children.length == 0) {
                        return true;
                    } else {
                        findEmptySubFormsTree(items[i].children);
                    }
                }
            }
        };

        function findNoSubFormsTree(items) {
            var i = 0, found;
            for (; i < items.length; i++) {
                if (_.isArray(items[i].children)) {
                    if (items[i].type == 'SubForm') {
                        return true;
                    } else {
                        findEmptySubFormsTree(items[i].children);
                    }
                }
            }
        };

        function findStepHeaderSubFormsAvailability(tree) {
            var cont = 0;
            _.each(tree, function (item) {
                if (item.type == 'SubForm') {
                    cont++;
                }
                if (item.children && item.children.length > 0) {
                    findStepHeaderSubFormsAvailability(item.children);
                }
            });
            return cont == 0;
        };

        function adjustFormIdentifiers(tree) {
            _.each(tree, function (item) {
                if (!item.identifier) {
                    item.identifier = item.title ? item.title : 'identificador';
                    item.identifier = item.identifier.replace(/ /g, '_') + '_' + Common.generatePassword(5);
                }
                if (item.children && item.children.length > 0) {
                    adjustFormIdentifiers(item.children);
                }
            });
        };

        function pushDependencyComponent(fatherComponent, ruleControlId) {
            if (fatherComponent.ruleConfig.dependencies == undefined) {
                fatherComponent.ruleConfig.dependencies = [];
            }
            if (!_.includes(fatherComponent.ruleConfig.dependencies, ruleControlId)) {
                fatherComponent.ruleConfig.dependencies.push(ruleControlId);
            }
        };

        function translateTypeInfo(item, type, componentFilter) {
            var result = _.filter(vm.models.components, 'type', type);
            //manual mapping is necessary: for date (datetime, date, hour) and number (integer, decimal) components
            if (result.length > 1) {
                if (type == 'Number') {
                    result = _.find(vm.models.components, 'numberType', item.numberType);
                }
                if (type == 'DateTime') {
                    result = _.find(vm.models.components, 'dateTimeType', item.dateTimeType);
                }
            } else {
                result = result[0];
            }

            if (componentFilter == 'Página') {
                result = _.find(vm.models.components, function (o) { return o.type == type && o.minOccurs == 1 && o.maxOccurs == 1; });
            }

            if (componentFilter == 'Grupo de Repetição') {
                result = _.find(vm.models.components, function (o) { return o.type == type && o.minOccurs != 1 && o.maxOccurs != 1; });
            }

            return result;
        };

        function updateRuleComponents(removalId) {
            vm.dropDownArray = [];
            vm.dropdownTitle = '';
            vm.selectize_components.options = buildComponentsDrodownDataTree(vm.form.children, removalId, '');
            vm.selectize_components.options.unshift({ propertyName: 'Esse componente', id: '@THIS' });
            vm.selectize_arithmeticExpressionJoined.options = angular.copy(vm.selectize_reservedWords.options.concat(vm.selectize_components.options));
        };

        function updateParametersListComponents(removalId) {
            vm.dropDownArray = [];
            vm.dropdownTitle = '';
            vm.selectize_components.options = buildComponentsDrodownDataTreeForUrlParameters(vm.form.children, removalId, '');
        };

        function mapComponentSpecificProperties(component) {
            //ATTENTION: Moved to array init on application.constants.js
            //Mapping to load properties in detail view
            //Also loads default values (for new components only)
            // if (!component.id) {
            //     //DateTime component
            //     if (component.type == 'DateTime') {
            //         component.dateTimeType = 'DateTime';
            //     }
            //     //Image component
            //     if (component.type == 'Image') {
            //         component.originImage = 'Both';
            //     }
            //     //Number component
            //     if (component.type == 'Number') {
            //         component.numberType = 'Integer';
            //     }
            // }
        };

        function focusHtmlComponent(elementId) {
            $timeout(function () {
                var element = $window.document.getElementById(elementId);
                if (element)
                    element.focus();
            });
        };


        function initComponents() {
            vm.selectize_type_number = { options: [] };
            vm.selectize_type_date = { options: [] };
            vm.selectize_behaviors = { options: [] };
            vm.selectize_logicalConditional = { options: [] };
            vm.selectize_logicalOperators = { options: [] };
            vm.selectize_textTypeFreeTextComponent = { options: [] };
            vm.selectize_methodSelectsComponent = { options: [] };
            vm.selectize_selectTypeSimpleSelectComponent = { options: [] };
            vm.selectize_selectTypeMultipleSelectComponent = { options: [] };
            vm.selectize_dateTimeTypeDateTimeComponent = { options: [] };
            vm.selectize_numberTypeNumberComponent = { options: [] };
            vm.selectize_originImageComponent = { options: [] };
            vm.selectize_category = { options: [] };
            vm.selectize_conditionTypes = { options: [] };
            vm.selectize_parametersTypes = { options: [] };
            vm.selectize_components = { options: [] };
            vm.selectize_reservedWords = { options: [] };
            vm.selectize_arithmeticOperators = { options: [] };
            vm.selectize_arithmeticExpressionJoined = { options: [] };
            vm.selectize_publish_levels_modal = { options: [] };            

            vm.selectize_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE,
                placeholder: "-- Selecione --",               
                sortField: {
                    field: 'description',
                    direction: 'asc'
                },
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.description) + '</div>';
                    },
                }
            };

            vm.selectize_category_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Categoria do formulário *',
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.description) + '</div>';
                    },
                }
            };

            vm.selectize_behaviors_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_type_date_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_type_number_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_logicalConditional_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_logicalOperators_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_textTypeFreeTextComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_methodSelectsComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'identifier',
                labelField: 'identifier',
                searchField: 'identifier',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.identifier) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.identifier) + '</div>';
                    },
                }
            };

            vm.selectize_selectTypeSimpleSelectComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_selectTypeMultipleSelectComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_dateTimeTypeDateTimeComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_numberTypeNumberComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_originImageComponent_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_conditionTypes_config = {
                create: false,
                maxItems: 1,
                //placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_parametersTypes_config = {
                create: false,
                maxItems: 1,
                //placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
            };

            vm.selectize_components_config = {
                create: false,
                openOnFocus: true,
                maxItems: 1,
                placeholder: 'Escolha o componente...',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {
                    item: function (item, escape) {
                        return '<div title="' + item.propertyName + '">' +
                            ('<span class="item uk-text-break">'
                                + escape(Common.truncateMiddleString(item.propertyName, 80)) + '</span>' + '</div>');
                    }
                }
            };

            vm.selectize_reservedWords_config = {
                create: false,
                maxItems: 1,
                placeholder: 'Escolha a palavra...',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_arithmeticOperators_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="option">' +
                        '<span class="title">' + escape(sources.propertyName) + '</span>' +
                        '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };

            vm.selectize_arithmeticExpressionJoined_config = {
                create: false,
                maxItems: 1,
                // placeholder: 'Selecione',
                valueField: 'id',
                labelField: 'propertyName',
                searchField: 'propertyName',
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.propertyName) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.propertyName) + '</div>';
                    },
                }
            };
        };

        /* Watchers and field validation*/
        /*Datetime properties watchers*/
        var dtStartClb1 = $scope.$watch(
            'vm.focusedComponent.dtInitialRange',
            function () {
                if (vm.focusedComponent) {
                    var result = Common.validateData(vm.focusedComponent.dtInitialRange, vm.focusedComponent.dtEndRange);
                    if (!result) {
                        vm.focusedComponent.dtInitialRange = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );

        var dtEndClb2 = $scope.$watch(
            'vm.focusedComponent.dtEndRange',
            function () {
                if (vm.focusedComponent) {
                    var result = Common.validateData(vm.focusedComponent.dtInitialRange, vm.focusedComponent.dtEndRange);
                    if (!result) {
                        vm.focusedComponent.dtEndRange = undefined;
                        Common.mensagemError('Data inicial não pode ser maior que data final.');
                    }
                }
            }
        );

        /*Range validation (min,max) for Number, Image and Repeat Group*/
        vm.validateRange = function (initialFieldName, endFieldName, isInitialField) {
            if (vm.focusedComponent) {
                var result = Common.validateRange(vm.focusedComponent[initialFieldName], vm.focusedComponent[endFieldName]);
                if (!result) {
                    if (isInitialField) {
                        vm.focusedComponent[initialFieldName] = undefined;
                    } else {
                        vm.focusedComponent[endFieldName] = undefined;
                    }
                    Common.mensagemError('Valor inicial não pode ser maior que valor final.');
                }
            }
        };

        $scope.$on('$destroy', function () {
            [
                dtStartClb1,
                dtEndClb2,
                vm.simpleSelectTypeStateChangedLstnrClb1,
                vm.npsSelectTypeStateChangedLstnrClb1
            ].forEach(function (fn) {
                fn();
            });
        });
        /* End of watchers */


        /** Codes below related to RPN
         * 
         * 
         */

        vm.rpnModels = {
            selected: undefined,
            components: undefined
        };

        vm.getRpnTemplates = function () {
            return Form.getRpnTemplates().then(function (components) {
                vm.rpnModels.components = components;
                return vm.rpnModels.components;
            });
        };

        vm.dropRpnItemManually = function (item) {
            var newItem = angular.copy(item);
            vm.ruleItem_form.structuredRule == undefined ?
                vm.ruleItem_form.structuredRule = [] :
                vm.ruleItem_form.structuredRule.push(newItem);
            vm.rpnModels.selected = newItem;
            vm.adjustLogicalOperatorField(vm.ruleItem_form.structuredRule);
        };

        vm.removeRpnComponent = function (list, index) {
            UIkit.modal.confirm('Deseja realmente excluir esse item?', function () {
                list.splice(index, 1);
                vm.adjustLogicalOperatorField(vm.ruleItem_form.structuredRule);
                Common.messageSuccess('Item', 'D', 'M');
            });
        };

        vm.copyRpnComponent = function (item) {
            var newItem = angular.copy(item);
            vm.ruleItem_form.structuredRule.push(newItem);
            vm.rpnModels.selected = newItem;
            vm.adjustLogicalOperatorField(vm.ruleItem_form.structuredRule);
        };

        vm.sorterFuncRule = function (rule) {
            return parseInt(rule.order);
        };

        vm.openRuleItem = function ($event, $index, ruleItem, field, modalTitle, removalId) {
            var ruleItem = angular.copy(ruleItem);
            $event.preventDefault();
            updateRuleComponents(removalId);
            vm.modalTitle = modalTitle;
            vm.ruleField = field;
            vm[vm.ruleField] = angular.copy(vm.focusedComponent.ruleConfig[vm.ruleField]);
            vm.ruleItem_form = {
                index: $index,
                id: ruleItem.id,
                message: ruleItem.message,
                structuredRule: ruleItem.structuredRule,
                order: ruleItem.order,
                title: ruleItem.title
            };
            vm.ruleItem_formEscCompare = angular.copy(vm.ruleItem_form);
            focusHtmlComponent('modalRuleConfig');
        };

        vm.newRuleItem = function ($event, field, modalTitle, removalId) {
            $event.preventDefault();
            updateRuleComponents(removalId);
            vm.modalTitle = modalTitle;
            vm.ruleField = field;
            vm[vm.ruleField] = angular.copy(vm.focusedComponent.ruleConfig[vm.ruleField]);
            var totalRules = vm.focusedComponent.ruleConfig[field].length + 1;
            vm.ruleItem_form = {
                title: 'Regra ' + totalRules,
                structuredRule: []
            };
            vm.ruleItem_formEscCompare = angular.copy(vm.ruleItem_form);
            focusHtmlComponent('modalRuleConfig');
        };

        vm.saveRuleItem = function ($event) {
            $event.preventDefault();
            vm.adjustLogicalOperatorField(vm.ruleItem_form.structuredRule);
            var index = vm.ruleItem_form.index;
            if (!vm.ruleItem_form.structuredRule || vm.ruleItem_form.structuredRule.length == 0) {
                Common.mensagemError('Adicione pelo menos uma expressão!');
                return;
            }

            if (vm.ruleItem_form && vm.ruleItem_form.structuredRule && vm.ruleItem_form.structuredRule.length > 0) {
                if(!vm.validateRules(vm.ruleItem_form.structuredRule))
                    return;
            }

            //update
            if (vm.ruleItem_form.id) {
                vm[vm.ruleField][index] = angular.copy(vm.ruleItem_form);
                vm[vm.ruleField][index].order = index;
                Common.messageSuccess('Regra', 'A', 'F');
            } else {
                //save
                vm.ruleItem_form.id = uuid2.newguid();
                var newRule = angular.copy(vm.ruleItem_form);
                newRule.order = vm[vm.ruleField].length;
                vm[vm.ruleField].push(newRule);
                //vm.openRuleItem($event, vm[vm.ruleField].length - 1, vm[vm.ruleField][vm[vm.ruleField].length - 1]);
                Common.messageSuccess('Regra', 'I', 'F');
            }
            vm.saveRuleModal();
        };

        vm.validateRules = function (list){
            for (var i = 0; i < list.length; i++) {
                if (list[i].dropType == 'subform') 
                {
                    if (!list[i].structuredRule || list[i].structuredRule.length == 0) 
                    {
                        Common.mensagemError('Adicione pelo menos uma expressão ao container!');
                        return false;
                    } else {
                        return vm.validateRules(list[i].structuredRule);
                    }
                } else {
                    if (!list[i].componentOrderLeft &&
                    !list[i].componentOrderLeftArithmeticOperator &&
                    !list[i].componentOrderLeftOperandLeft &&
                    !list[i].componentOrderLeftOperandRight &&
                    !list[i].componentOrderRight &&
                    !list[i].componentOrderRightArithmeticOperator &&
                    !list[i].componentOrderRightOperandLeft &&
                    !list[i].componentOrderRightOperandRight &&
                    !list[i].conditionTypeOrderLeft &&
                    !list[i].conditionTypeOrderRight
                    ) {
                        Common.mensagemError('As expressões não podem ser vazias.');
                        return false;
                    }
                }                    
            }
            return true;
        };

        vm.copyRuleItem = function (rule, ruleField) {
            var copiedRule = angular.copy(rule);
            copiedRule.id = uuid2.newguid();
            copiedRule.title = 'Cópia de ' + copiedRule.title;
            copiedRule.order = vm.focusedComponent.ruleConfig[ruleField].length;
            vm.focusedComponent.ruleConfig[ruleField].push(copiedRule);
            Common.messageSuccess('Regra', 'C', 'F');
        };


        vm.removeRuleItem = function (ruleField, index) {
            UIkit.modal.confirm('Deseja realmente excluir essa regra?', function () {
                vm.focusedComponent.ruleConfig[ruleField].splice(index, 1);
                for (var i = 0; i < vm.focusedComponent.ruleConfig[ruleField].length; i++) {
                    var element = vm.focusedComponent.ruleConfig[ruleField][i];
                    element.order = i;
                }
                Common.messageSuccess('Regra', 'D', 'F');
            });
        };

        vm.moveItem = function (list, origin, destination) {
            var temp = list[destination];
    
            if (temp) {
                list[destination] = list[origin];
                list[destination].order = destination;
                list[origin] = temp;                  
                list[origin].order = origin;  
            }            
        };

        vm.listItemUp = function (itemIndex, list) {
            vm.moveItem(list, itemIndex, itemIndex - 1);
        };
    
        vm.listItemDown = function (itemIndex, list) {
            vm.moveItem(list, itemIndex, itemIndex + 1);
        };

        vm.rpnPropertyModalOpen = function (item, isItem, index) {
            vm.isLoadingModal = true;
            UIkit.modal('#rpnRuleProperty', { modal: false, bgclose: false, center: true }).show();
            $timeout(function () {
                vm.rpnProperty_IsItem = isItem;
                vm.rpnProperty_Index = index;
                vm.rpnProperty = angular.copy(item);
                vm.rpnPropertyOriginal = item;
                vm.isLoadingModal = false;
            }, 200);

            //TODO: fix $digest already in progress error. Code below
            focusHtmlComponent('rpnRuleProperty');
            focusHtmlComponent('logicalComponentFormLeft');
            angular.element('#logicalComponentFormLeft').trigger('click');

        };

        vm.saveRpnPropertyModalModal = function () {
            vm.rpnPropertyOriginal.logicalOperator = vm.rpnProperty.logicalOperator;
            vm.rpnPropertyOriginal.conditionTypeOrderLeft = vm.rpnProperty.conditionTypeOrderLeft;
            vm.rpnPropertyOriginal.componentOrderLeft = vm.rpnProperty.componentOrderLeft;
            vm.rpnPropertyOriginal.logicalCondition = vm.rpnProperty.logicalCondition;
            vm.rpnPropertyOriginal.conditionTypeOrderRight = vm.rpnProperty.conditionTypeOrderRight;
            vm.rpnPropertyOriginal.componentOrderRight = vm.rpnProperty.componentOrderRight;

            vm.rpnPropertyOriginal.componentOrderLeftOperandLeft = vm.rpnProperty.componentOrderLeftOperandLeft;
            vm.rpnPropertyOriginal.componentOrderLeftArithmeticOperator = vm.rpnProperty.componentOrderLeftArithmeticOperator;
            vm.rpnPropertyOriginal.componentOrderLeftOperandRight = vm.rpnProperty.componentOrderLeftOperandRight;

            vm.rpnPropertyOriginal.componentOrderRightOperandLeft = vm.rpnProperty.componentOrderRightOperandLeft;
            vm.rpnPropertyOriginal.componentOrderRightArithmeticOperator = vm.rpnProperty.componentOrderRightArithmeticOperator;
            vm.rpnPropertyOriginal.componentOrderRightOperandRight = vm.rpnProperty.componentOrderRightOperandRight;

            // it's now done in functoin checkRpnRulesTree
            // if (vm.rpnProperty.conditionTypeOrderLeft == 'ByExpression') {
            //     vm.rpnProperty.componentOrderLeft = [vm.rpnProperty.componentOrderLeftOperandLeft,
            //     vm.rpnProperty.componentOrderLeftOperandRight,
            //     vm.rpnProperty.componentOrderLeftArithmeticOperator].join(' ');
            //     vm.rpnPropertyOriginal.componentOrderLeft = vm.rpnProperty.componentOrderLeft;
            // }

            // if (vm.rpnProperty.conditionTypeOrderRight == 'ByExpression') {
            //     vm.rpnProperty.componentOrderRight = [vm.rpnProperty.componentOrderRightOperandLeft,
            //     vm.rpnProperty.componentOrderRightOperandRight,
            //     vm.rpnProperty.componentOrderRightArithmeticOperator].join(' ');
            //     vm.rpnPropertyOriginal.componentOrderRight = vm.rpnProperty.componentOrderRight;
            // }

            vm.closeModal("#rpnRuleProperty");
        };

        vm.rpnPropertyConditionTypeStateChanged = function (isLeft) {
            if (isLeft) {
                vm.rpnProperty.componentOrderLeft = undefined;
                vm.rpnProperty.componentOrderLeftOperandLeft = undefined;
                vm.rpnProperty.componentOrderLeftArithmeticOperator = undefined;
                vm.rpnProperty.componentOrderLeftOperandRight = undefined;
            } else {
                vm.rpnProperty.componentOrderRight = undefined;
                vm.rpnProperty.componentOrderRightOperandLeft = undefined;
                vm.rpnProperty.componentOrderRightArithmeticOperator = undefined;
                vm.rpnProperty.componentOrderRightOperandRight = undefined;
            }
        };

        function focusComponentRight() {
            focusHtmlComponent('rpnRuleProperty');
            focusHtmlComponent('logicalComponentFormRight');
            angular.element('#logicalComponentFormRight').trigger('click');
        }

        vm.rpnPropertyLogicalConditionalStateChanged = function () {

            vm.reloadLogicalCondition = true;
            vm.getConditionTypesProperties().then(function () {
                vm.reloadLogicalCondition = false;
                if (vm.rpnProperty.logicalCondition != undefined) {

                    // //reseting
                    // vm.rpnProperty.conditionTypeOrderRight = undefined;
                    // vm.rpnPropertyConditionTypeStateChanged(false);

                    vm.isDisabled = false;
                    if (vm.rpnProperty.logicalCondition == 'IsValid') {
                        //no need for this anymore, 'IsValid' will be enough as IsValid == ByRegularExpression
                        // vm.rpnProperty.conditionTypeOrderRight = 'ByRegularExpression'; 
                        vm.rpnProperty.conditionTypeOrderRight = undefined;
                        vm.isDisabled = true;
                        focusComponentRight();
                        return;
                    }
                    if (vm.rpnProperty.logicalCondition == 'MinLenght' || vm.rpnProperty.logicalCondition == 'MaxLenght' || vm.rpnProperty.logicalCondition == 'Between') {
                        vm.rpnProperty.conditionTypeOrderRight = 'ByValue';
                        vm.isDisabled = true;
                        focusComponentRight();
                        return;
                    }

                    vm.rpnProperty.conditionTypeOrderRight = vm.rpnProperty.conditionTypeOrderRight == undefined ? 'ByValue' : vm.rpnProperty.conditionTypeOrderRight;
                    focusComponentRight();
                }
            });

        };

        vm.adjustLogicalOperatorField = function (tree) { //ruleItem_form.structuredRule
            //remove logical Operator if index 0. Add "And" on reordered rules
            //vm.ruleItem_form.structuredRule
            var cont = 0;
            _.each(tree, function (item) {
                cont++;
                if (cont == 1) {
                    item.logicalOperator = undefined;
                }
                if (cont > 1 && !item.logicalOperator) {
                    item.logicalOperator = 'AND';
                }
                if (item.structuredRule && item.structuredRule.length > 0) {
                    vm.adjustLogicalOperatorField(item.structuredRule);
                }
            });
        };

        vm.ruleSorter = function (rule) {
            return parseInt(rule.order);
        };

        vm.translateOps = function (op, value, conditionType) {
            var result = value;
            if (result == undefined || !result) {
                if (conditionType == 'ByValue') {
                    return 'vazio';
                }
                return undefined;
            }
            if (op == 'logicalOperator') {
                _.each(FORMS.logicalOperators, function (item) {
                    result = result.replace(item.id, item.propertyName);
                });
            }
            if (op == 'componentOrderLeft' || op == 'componentOrderRight' || op == 'componentOrderLeftOperandLeft' || op == 'componentOrderRightOperandLeft') {
                _.each(FORMS.reserverdWords, function (item) {
                    result = result.replace(item.id, item.propertyName);
                });

                _.each(vm.selectize_components.options, function (item) {
                    result = result.replace(item.id, item.propertyName);
                });
            }
            if (op == 'logicalCondition') {
                _.each(FORMS.logicalConditionals, function (item) {
                    result = result.replace(item.id, item.propertyName);
                });
            }
            return result;
        };

        vm.goRoute = function (action, formId, formName){
            Form.routeGo(vm.modulo, action, formId, formName);
        } 

        //Init        
        vm.init = function () {
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            vm.getIcons();
            initComponents();

            Form.getPublishLevel().then(function (publishLevels) {
                // Salva a lista de publish level para o formulário.
                vm.selectize_publish_levels_modal = JSON.parse(JSON.stringify(publishLevels));
            });

            vm.getFormTemplates().then(function () {
                vm.getTypeNumberProperties().then(function () {
                    vm.getTypeDateProperties().then(function () {
                        vm.getBehaviorProperties().then(function () {
                            vm.getFormCategories().then(function () {
                                vm.getLogicalConditionalProperties().then(function () {
                                    vm.getLogicalOperatorsProperties().then(function () {
                                        vm.getTextTypeFreeTextComponentProperties().then(function () {
                                            vm.getMethodSelectsComponentProperties().then(function () {
                                                vm.getSelectTypeSimpleSelectComponentProperties().then(function () {
                                                    vm.getSelectTypeMultipleSelectComponentProperties().then(function () {
                                                        vm.getDateTimeTypeDateTimeComponentProperties().then(function () {
                                                            vm.getNumberTypeNumberComponentProperties().then(function () {
                                                                vm.getOriginImageComponentProperties().then(function () {
                                                                    vm.getTooltips().then(function () {
                                                                        vm.getConditionTypesProperties().then(function () {
                                                                            vm.getParametersTypesProperties().then(function () {
                                                                                vm.getRpnTemplates().then(function () {
                                                                                    vm.getReservedWordsProperties().then(function () {
                                                                                        vm.getArithmeticOperatorsProperties().then(function () {
                                                                                        });
                                                                                    });
                                                                                });
                                                                            });
                                                                        });
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });

            vm.typeFocusedComponentDate = false;

            vm.isEdition = false;
            vm.id = $stateParams.id;
            vm.modulo = $stateParams.modulo;
            if (vm.id) {
                vm.isEdition = true;
            } else {
                vm.isEdition = false;
            }

            if (vm.isEdition) {
                vm.operation = 'Editar';
                vm.getForm(vm.id);
            }
        };

        vm.modulo = $stateParams.modulo;
        vm.configurarPermissoes = function () {
            if (vm.modulo == 'Relacionamento') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Relacionamento", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Relacionamento", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "S" });                
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "C" });
            } else if (vm.modulo == 'Integracao') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Integração", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Integração", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "C" });
            } else if (vm.modulo == 'Nps') {
                vm.moduloPretty = 'Formulários de Pesquisa de Opinião';
                //TODO: Gerar permissões para modulo NPS
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                
                vm.isFormEstatisticaPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSumarioPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                
                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });

            }else if(vm.modulo == "FormGeral"){
                vm.moduloPretty = 'Formulários Gerais';
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "C" });

                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });

                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
            }            
        };

        //vm.init();
        vm.configurarPermissoes();
        vm.accessIsAllowed =vm.isFormCadastrarPermitido || vm.isFormEditarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
    }

    angular.module('app.form')
        .controller('FormCreateController', FormCreateController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function FormAnswersController($anchorScroll, $controller, $location, $rootScope, $scope, $state, $stateParams, $timeout, $window, uuid2, Category, DashboardCompany, Common, Form, APPLICATION, moment, $document, Security) {        
        var vm = this;        

        vm.init = function(){
            vm.loadingDetail = true;
            vm.loadingList = true;
            vm.submissionsGroup = [];
            vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            vm.modulo = $stateParams.modulo;
            vm.formId = $stateParams.id;
            vm.formName = $stateParams.formName;
            vm.showCustomPeriodSearch = false;
            vm.filter = {};
            vm.filter.modulo = vm.modulo;
            vm.filter.formId = vm.formId;
            vm.filter.searchRootById = true;
            vm.selectize_config = {};  
           
            
            vm.configComponents();
            vm.optionDataComponent();

            vm.search(vm.filter);
        };

        vm.goRoute = function (action, formId, formName){
            Form.routeGo(vm.modulo, action, formId, formName);
        }

        vm.configComponents = function(){
            vm.selectize_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE,
                placeholder: "-- Selecione --",               
                sortField: {
                    field: 'description',
                    direction: 'asc'
                },
                render: {                   
                    option: function (sources, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(sources.description) + '</div>';
                    }
                }
            };
        }

        vm.optionDataComponent = function(){
            vm.selectize_period_options = [
                {id: 0, description: 'Definir Período'},
                {id: 1, description: 'Esta Semana'},
                {id: 2, description: 'Este Mês'},
                {id: 3, description: 'Este Ano'},
                {id: 4, description: 'Últimos 7 dias'},
                {id: 5, description: 'Últimos 30 dias'},
                {id: 6, description: 'Últimos 90 dias'},
                {id: 7, description: 'Últimos 180 dias'},
                {id: 8, description: 'Últimos 365 dias'}];
        }

        vm.changeSubmissionPeriod = function(){
           switch(parseInt(vm.filter.periodType)){
                case 0: //Custom Data
                    vm.filter.dateIni = null;
                    vm.filter.dateEnd = null;
                    vm.showCustomPeriodSearch = true  
                break;
                case 1: //Por Semana
                    vm.filter.dateIni = moment().startOf('week').format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break; 
                case 2: //Por Mês
                    vm.filter.dateIni = moment().startOf('month').format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;             
                case 3: //Por Ano
                    vm.filter.dateIni = moment().startOf('year').format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 4: //Últimos 7 dias
                    vm.filter.dateIni = moment().day(-7).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 5: //Últimos 30 dias
                    vm.filter.dateIni = moment().day(-30).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 6: //Últimos 90 dias
                    vm.filter.dateIni = moment().day(-90).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 7: //Últimos 180 dias
                    vm.filter.dateIni = moment().day(-180).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                case 8: //Últimos 365 dias
                    vm.filter.dateIni = moment().day(-365).format(vm.datePickerFormat.format);
                    vm.filter.dateEnd = moment().endOf('day').format(vm.datePickerFormat.format);
                break;
                default:
                break;
            }

            if(parseInt(vm.filter.periodType) != 0 && vm.showCustomPeriodSearch == true) {
                vm.showCustomPeriodSearch = false;
            }
        }

        
        var $dp_start = angular.element('#uk_dp_start'),
            $dp_end = angular.element('#uk_dp_end');

        var start_date = UIkit.datepicker($dp_start, {
            format:'DD/MM/YYYY'
        });

        var end_date = UIkit.datepicker($dp_end, {
            format:'DD/MM/YYYY'
        });

        $dp_start.on('change',function() {
            end_date.options.minDate = $dp_start.val();
        });

        $dp_end.on('change',function() {
            start_date.options.maxDate = $dp_end.val();
        });


        vm.search = function(filter){
            Form.getFormSubmissions(filter).then(function(submissionsGroup){
                vm.submissionsGroup = submissionsGroup;
                if(vm.submissionsGroup.length > 0 && vm.submissionsGroup[0].submissions.length > 0){                    
                    vm.submissionDetail(vm.submissionsGroup[0].submissions[0], "0|0");             
                }else{
                    vm.loadingDetail = false;        
                }
                vm.loadingList = false;
            });
        }

        vm.submissionDetail = function(item, index){
            vm.loadingDetail = true;
            $timeout(function () {
                vm.selectedIndex = index;
            }, 250);

            Form.getFormSubmissionDetail(item.id, vm.appCompany).then(function(submissionDetail){
                vm.submissonDetail = submissionDetail;
                vm.loadingDetail = false;
            });
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////
        vm.printListReport = function (divName) {
             var printContents = $document[0].getElementById(divName).innerHTML;
             var win = $window.open('','Lista de Respostas');                
             win.document.write('<html>');
             win.document.write('<head>');
             win.document.write('<style>');
             win.document.write('.heading_list {  text-align:center !important; border-top: 1px solid #000 !important; border-bottom: 1px solid #000 !important;} ');
             win.document.write('ul, li{ list-style-type: none; padding-top 80px !important;} ');
             win.document.write('</style>');
             win.document.write('<title>Lista de Respostas</title>');
             win.document.write('</head>');
             win.document.write('<body>');
             win.document.write(printContents);
             win.document.write('<style>');             
             win.document.write('@page { margin-top: 100px; margin-left: 20px; margin-bottom: 40px; margin-right: 20px; counter-increment: page !important; @bottom-right { padding-right:20px !important; content: "Page " counter(page) !important; }}');                 
             win.document.write('</style>');
             win.document.write('</body>');
             win.document.write('</html>');
             win.focus();
             $timeout(function(){
                    win.print();
                    win.close(); 
             },1000);                 
        };  

        vm.printDetailReport = function(divName){
             var printContents = $document[0].getElementById(divName).innerHTML;
             var win = $window.open('','Detalhamento da Resposta');                
             win.document.write('<html>');
             win.document.write('<head>');
             win.document.write('<script src=\"https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js\"></script>');
             win.document.write('<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/css/uikit.min.css\" />');
             win.document.write('<script src=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/js/uikit.min.js\"></script>');
             win.document.write('<link rel=\"stylesheet\" href=\"cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/css/uikit.min.css\" media=\"all\" />');
             win.document.write('<script src=\"https://cdnjs.cloudflare.com/ajax/libs/uikit/2.27.4/js/uikit.min.js\"></script>');
             win.document.write('<style>');
             win.document.write('.reportTitle{margin:5px 0px 5px 0px; text-align:center;}');                 
             win.document.write('.subFormPrint{text-align:center !important; border: 1px solid #000 !important;}');                              
             win.document.write('.titlePrint{text-align:center !important; border: 1px solid #000 !important;}');                 
             win.document.write('.answerPrint{border-bottom: 1px solid #000 !important;}');                 
             win.document.write('label{font-weight: bold !important;}');                 
             win.document.write('</style>');
             win.document.write('<title> Detalhamento da Resposta</title>');
             win.document.write('</head>');
             win.document.write('<body>');
             win.document.write(printContents);
             win.document.write('<style>');
             // Gabriel Souza: adição da paginação no relatório, subtitulo e data da solicitação do relatório.
             win.document.write('@page { margin-top: 100px; margin-left: 20px; margin-bottom: 40px; margin-right: 20px; counter-increment: page !important; @bottom-right { padding-right:20px !important; content: "Page " counter(page) !important; }}');                 
             win.document.write('</style>');
             win.document.write('</body>');
             win.document.write('</html>');
             win.focus();
             $timeout(function(){
                    win.print();
                    win.close(); 
             },1000);  
        }

        ///////////////////////////////////////////////////////////////////////////////////////////////////////
        vm.modulo = $stateParams.modulo;
        vm.configurarPermissoes = function () {
            if (vm.modulo == 'Relacionamento') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Relacionamento", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Relacionamento", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "S" });                
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Relacionamento", action: "C" });
            } else if (vm.modulo == 'Integracao') {
                vm.moduloPretty = 'Formulários de ' +vm.modulo;
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Integração", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Integração", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Integração", action: "C" });
            } else if (vm.modulo == 'Nps') {
                vm.moduloPretty = 'Formulários de Pesquisa de Opinião';
                //TODO: Gerar permissões para modulo NPS
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });
                
                vm.isFormEstatisticaPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSumarioPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
                
                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Pesquisa", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Pesquisa", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Pesquisa", action: "S" });

            }else if(vm.modulo == "FormGeral"){
                vm.moduloPretty = 'Formulários Gerais';
                vm.isFormVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });
                vm.isFormDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isFormCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isFormEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isFormPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
                vm.isFormCopiarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "C" });

                vm.isFormSubmissionsPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });

                vm.isCategoryDeletarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "D" });
                vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Formulários de Coleta", action: "C" });
                vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Formulários de Coleta", action: "U" });
                vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Formulários de Coleta", action: "S" });
            }            
        };

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isFormSubmissionsPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        // vm.init();
    }

    angular.module('app.form')
        .controller('FormAnswersController', FormAnswersController);

})();

(function () {
  'use strict';

  angular
    .module('app.dashboardMenuApp', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function DashboardMenuAppService(Common, RestangularAuth, APPLICATION, Session) {

        var appSelecionada;

        function get() {
            return RestangularAuth.one('dashboard').get();
        }

        function getApps(idCompany) {
            return RestangularAuth.all('dashboard/apps').getList();
        }

        function getApp(id) {
            return RestangularAuth.one('dashboard/apps', id).get();
        }

        function selecionarApp(app) {
            appSelecionada = app;
            Session.setObjectLocalStorage(APPLICATION.applicationSelected, app);
        }

        function obterAppSelecionada() {
            appSelecionada = Session.getObjectLocalStorage(APPLICATION.applicationSelected);
            return appSelecionada;
        }

        function removerAppSelecionada() {
            Session.delObjectLocalStorage(APPLICATION.applicationSelected);
        }

        function init() {
            obterAppSelecionada();
        }
        init();

        return {
            get: get,
            getApps: getApps,
            getApp: getApp,
            selecionarApp: selecionarApp,
            obterAppSelecionada: obterAppSelecionada,
            removerAppSelecionada: removerAppSelecionada
        };
    }

    angular
        .module('app.dashboardMenuApp')
        .factory('DashboardMenuApp', DashboardMenuAppService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function DashboardMenuAppController(APPLICATION, $controller, $interval, $rootScope, $scope, $state, $stateParams, $window, Company, DashboardCompany, Common, Painel, Security) {
        var vm = this;


        vm.configurarPermissoes = function () {
            vm.isHomeVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Home", action: "R" });
            vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Usuários App", action: "R" });
            vm.isDashboardVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Dashboard de Relacionamento", action: "R" });            
            vm.isAttendanceVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Solicitações/Atendimentos", action: "R" });
            vm.isRelAnaliticoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Relatórios de Relacionamento", action: "R" });
            vm.isRelSinteticoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Relatórios de Relacionamento", action: "R" });
            vm.isCategoryVisualizarPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_UM, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "R" });
            vm.isFormRelacionamentoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Relacionamento", action: "R" });
            vm.isFormIntegracaoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Integração", action: "R" });
            vm.isFormNPSVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Pesquisa", action: "R" });
            vm.isFormColetaPermitido = Security.exitsProfilePermission({ id: 1, name: "Formulários de Coleta", action: "R" });
            vm.isSituacaoVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Situações", action: "R" });
            vm.isMensagemVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
            vm.isLogApiVisualizarPermitido = Security.exitsProfilePermission({ id: 5, name: "Mensagens", action: "R" });
        };
        vm.getApplications = function (companyKey) {
            return Painel.getCompanyApps(companyKey, true).then(function (applications) {
                var applicationsPermissions = [];
                var mtAccountPermissions = JSON.parse(localStorage.getItem('mt-account-permissions'));

                if (applications) {
                    for (var j = 0; j < applications.length; j++) {
                        if (mtAccountPermissions) {
                            for (var i = 0; i < mtAccountPermissions.length; i++) {                    
                                if (
                                    (applications[j] && mtAccountPermissions[i]) &&
                                    ((applications[j].id == mtAccountPermissions[i].appCompanyId) ||
                                    (applications[j].app.id == mtAccountPermissions[i].appCompanyId))
                                    ) {
                                    applicationsPermissions.push(applications[j]);
                                    break;
                                }
                            }
                        }                        
                    }
                }                

                //vm.applications = applications;
                vm.applications = applicationsPermissions;
                return vm.applications;
            });
        };

        vm.init = function () {
            var companyKey = '';
            //vm.configureProfiles();
            if (!$stateParams.key) {
                vm.companySelected = Company.getCompanySelected();
                companyKey = vm.companySelected.id;
            } else {
                companyKey = $stateParams.key;
            }
            vm.isLoading = true;
            vm.getApplications(companyKey).then(function (data) {
                vm.isLoading = false;
            });
        };       

        vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isHomeVisualizarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this})); 
    }

    angular.module('app.dashboardMenuApp')
        .controller('DashboardMenuAppController', DashboardMenuAppController);

})();



(function () {
	'use strict';

	angular
		.module('app.dashboard', [])
	.filter('range', function() {
		return function(input, total) {
			total = parseInt(total);

			for (var i=0; i<total; i++) {
				input.push(i);
			}

			return input;
		};
	});
})();


(function() {
    'use strict';

    /** @ngInject */
    function DashboardService(Common, RestangularAuth) {

        function get(filter) {
            return RestangularAuth.one('manager/attendance/dashboard').get(filter);
        }

        return {
            get: get
        };
    }

    angular
        .module('app.dashboard')
        .factory('Dashboard', DashboardService);

})();
(function () {
	'use strict';

	/** @ngInject */
	function DashboardController(DashboardCompany, $controller, $interval, $rootScope, $scope, $timeout, $state, $window, Dashboard, Cliente, APPLICATION, Attendance, Common, SignalR, Security) {
		var vm = this;
		vm.isDashboardVisualizarPermitido = false;
		vm.configurarPermissoes = function () {
            vm.isDashboardVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Dashboard de Relacionamento", action: "R" });            
        };
		var pInterval;
		vm.updateDashBoard = false;
		$rootScope.primarySidebarActive = true;

		/// <description>
		/// Lógica necessária para efetuar a atualização do dashboard em um intervalo de um minuto e meio.
		/// </description>
		/// <author>
		/// Gabriel Souza.
		/// </author>
		var promise = $interval(function () {
			if(vm.validateDate(vm.filters)){
				vm.updateDashBoard = true;
				//Seta quantidade de graficos para renderização antes da plotagem. !Importante, pois sem isso, a primeira requisição os gráficos não aparecem.
				Dashboard.get(vm.filters).then(function (graphResult) {
					vm.graphCount = parseInt(graphResult.dashItens.length);
				}).catch(function (err) {
					$rootScope.modalDashboard.hide();
				});			

				//Inicializa os graficos.
				Dashboard.get(vm.filters).then(function (graphResult) {
					vm.initDashboard(graphResult);
					vm.ultimaAtualizacao = new Date();					
				}).catch(function (err) {
					$rootScope.modalDashboard.hide();
				});
				vm.DateIniHeader = vm.DateIniSet;
				vm.DateEndHeader = vm.DateEndSet;	
			}
		}, 90000);

		/// <description>
		/// Lógica necessária para efetuar o destroy na atualização do dash ao sair da tela.
		/// </description>
		/// <author>
		/// Gabriel Souza.
		/// </author>
		$scope.$on('$destroy', function () {
			vm.updateDashBoard = false;
			if (promise)
				$interval.cancel(promise);
		});		

		/// <description>
		/// Método responsável pelo carregamento dos dados do dashboard para gráficos.
		/// </description>
		/// <author>
		/// Gabriel Souza.
		/// </author>
		vm.initDashboard = function (graphResult) {
			vm.index = 0;
			vm.graphServiceNames = [];			
			graphResult.dashItens.forEach(vm.loopTroughGraphData);

			$rootScope.modalDashboard.hide();				
			vm.updateDashBoard = false;
		};

		vm.setDefaultDate = function(option){
			vm.periodUpdated = false;
			
			switch(option){
				case 0: //Custom Data
					vm.DateIniSet = null;
					vm.DateEndSet = null;
					vm.filters.DateInitial = null;
					vm.filters.DateEnd = null;				
				break;
				case 1: //Por Dia
					vm.DateIniSet = moment().startOf('day').format(vm.datePickerFormat.format);
					vm.DateEndSet = moment().endOf('day').format(vm.datePickerFormat.format);					
				break;				
				case 2: //Por Semana
					vm.DateIniSet = moment().startOf('week').format(vm.datePickerFormat.format);
					vm.DateEndSet = moment().endOf('day').format(vm.datePickerFormat.format);
				break;
				case 3: //Por Mês
					vm.DateIniSet = moment().startOf('month').format(vm.datePickerFormat.format);
					vm.DateEndSet = moment().endOf('day').format(vm.datePickerFormat.format);
				break;
				case 4: //Por Ano
					vm.DateIniSet = moment().startOf('year').format(vm.datePickerFormat.format);
					vm.DateEndSet = moment().endOf('day').format(vm.datePickerFormat.format);
				break;
				default:
				break;
			}			
			vm.periodUpdated = true;
		};

		
		vm.loopTroughGraphData = function(item)
		{
			vm.graphServiceNames.push(item.serviceDescription);			
			var c3chart_bar_stacked_id = 'c3_chart_bar_stacked_'+ vm.index.toString();
			vm.stackedColumnsName = ['columnsName'];
			vm.stackedSlaIn = ['SLA Vigente'];
			vm.stackedSlaOut = ['SLA Expirado'];
			vm.donutData = [];
			vm.defaultPatterColor = ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#7cb342','#e53935'];
			vm.patterDonutColor = ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#7cb342','#e53935'];
			vm.showDateGraphByType = false;
			item.graphByType.infoGraphs.forEach(vm.loopTroughSpecifGraphDataByType);
			if(!vm.showDateGraphByType){
				vm.stackedSlaIn = [];
				vm.stackedSlaOut = [];
			}
			vm.defaultIndexColor = 0;
			vm.showDateGraphBySituation = false;
			item.graphBySituation.infoGraphs.forEach(vm.loopTroughSpecifGraphDataBySituation);
			if(!vm.showDateGraphBySituation){
				vm.donutData = [];
			}

        	var c3chart_bar_stacked = c3.generate({
                bindto: '#'+c3chart_bar_stacked_id,
                data: {
                	x:'columnsName',
                    columns: [
                    	vm.stackedColumnsName,
                    	vm.stackedSlaIn,
                    	vm.stackedSlaOut 
                    ],
                    empty: { 
                    	label: { 
                    		text: "Nenhuma informação disponível" 
                    	}   
                    },
                    type: 'bar',
                    groups: [
                        ['SLA Vigente', 'SLA Expirado']
                    ]
                }, 
                axis: {
			        x: {
			            type: 'category'
			        },
			        y: {			        	
			            tick: {
			                format: function (d) {
			                    return (parseInt(d) == d) ? d : null;
			                }
			            }
			        }
			    },                  
                grid: {                    	
                    y: {
                        lines: [
                            {
                                value: 0
                            }
                        ]
                    }
                },                    
                colors: {
                    pattern: vm.defaultPatterColor
                }
            });                

            $($window).on('debouncedresize', c3chart_bar_stacked.resize());

            $scope.$on('$destroy', function () {
                $($window).off('debouncedresize', c3chart_bar_stacked.resize());
                c3chart_bar_stacked.destroy();
            });	

            // donut chart
            var c3chart_donut_id = 'c3_chart_donut_'+ vm.index.toString();
            if ( $('#'+c3chart_donut_id).length ) {

                var c3chart_donut = c3.generate({
                    bindto: '#'+c3chart_donut_id,
                    data: {
                        columns: vm.donutData,
                        type : 'donut',
                        onclick: function (d, i) { console.log("onclick", d, i); },
                        onmouseover: function (d, i) { console.log("onmouseover", d, i); },
                        onmouseout: function (d, i) { console.log("onmouseout", d, i); },
                        empty: { 
                        	label: { 
                        		text: "Nenhuma informação disponível"
                        	}   
                        }

                    },
                    donut: {
                    	label:{
                    		format: function (value, ratio) { return value; }
                    	},
                        title: "",
                        width: 55
                    },
                    color: {
                        pattern: vm.patterDonutColor
                    }
                });

                

                $($window).on('debouncedresize', c3chart_donut.resize());

                $scope.$on('$destroy', function () {
                    $($window).off('debouncedresize', c3chart_donut.resize());
                    c3chart_donut.destroy();
                });

            }
            vm.index++;	
		};

		vm.loopTroughSpecifGraphDataByType = function(item)
		{
			vm.stackedColumnsName.push(item.situationType);
			var _totalInSla = parseInt(item.totalInSla);
			var _totalOutSla = parseInt(item.totalOutSla);
			vm.stackedSlaIn.push(_totalInSla);
			vm.stackedSlaOut.push(_totalOutSla);
			if(vm.showDateGraphByType && _totalInSla > 0 || _totalOutSla > 0){
				vm.showDateGraphByType = true;
			}

		};

		vm.loopTroughSpecifGraphDataBySituation = function(item)
		{
			var data = [item.situationDescription, item.total]
			vm.donutData.push(data);
			if(item.color){
				vm.patterDonutColor.push(item.color);
			}else {
				vm.patterDonutColor.push(vm.defaultPatterColor[vm.defaultIndexColor]);
				vm.defaultIndexColor++;
			}
			if(item.total > 0 && !vm.showDateGraphBySituation){
				vm.showDateGraphBySituation = true;
			}
		};

		/// <description>
		/// Método responsável pelo carregamento dos dados iniciais, filtros do dashboard.
		/// </description>
		/// <author>
		/// Caetano Neto.
		/// </author>
		vm.loadFilters = function () {
			vm.isLoadingFiltros = true;
			vm.filters = {};
			vm.filters.serviceIds = [];
			vm.setDefaultDate(2);
			vm.DateIniHeader = vm.DateIniSet;
			vm.DateEndHeader = vm.DateEndSet;
			vm.selectize_sources_services = [];

			Attendance.getServicos().then(function (servicesList) {
				servicesList.forEach(vm.populateServiceOptionsDefault);
                vm.selectize_sources_services = servicesList;
                vm.isLoadingFiltros = false;
            });

            vm.initComponents();
		};

		vm.populateServiceOptionsDefault = function(service)
        {
        	vm.filters.serviceIds.push(service.id);
        };

		/// <description>
        /// Método responsável pela inicialização dos componentes de combo da tela.
        /// </description>
        /// <author>
        /// Caetano Neto.
        /// </author>
        vm.initComponents = function () {
            // Combo de serviços.
            vm.selectize_sources_services_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: null,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                searchField: APPLICATION.STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };
        };	

		
		vm.pesquisar = function (filters) {
			if(vm.validateDate(filters)){
               	$rootScope.modalDashboard = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_DASHBOARD);
				//Seta quantidade de graficos para renderização antes da plotagem. !Importante, pois sem isso, a primeira requisição os gráficos não aparecem.
				Dashboard.get(filters).then(function (graphResult) {
					vm.graphCount = parseInt(graphResult.dashItens.length);
				}).catch(function (err) {
					$rootScope.modalDashboard.hide();
				});			

				//Inicializa os graficos.
				Dashboard.get(filters).then(function (graphResult) {
					vm.initDashboard(graphResult);
					vm.ultimaAtualizacao = new Date();
					$rootScope.modalDashboard.hide();
				}).catch(function (err) {
					$rootScope.modalDashboard.hide();
				});	
				vm.DateIniHeader = vm.DateIniSet;
				vm.DateEndHeader = vm.DateEndSet;
            }
        };        

        vm.validateDate = function (filters) {
            // Validação de data inicial, deve ser menor que a final.
            if (vm.DateIniSet) {
                var dateIniDivide = vm.DateIniSet.toString().indexOf('.') >= 0 ? vm.DateIniSet.toString().split('.') : vm.DateIniSet.toString().split('/');
                if (dateIniDivide.length == 3) {
                    var dateIniParse = Date.parse(dateIniDivide[1] + '/' + dateIniDivide[0] + '/' + dateIniDivide[2] + ' 00:00:00');
					filters.DateInitial = new Date(dateIniParse);
                    if (filters.DateInitial > new Date()) {
                        Common.mensagemError('A data inicial não pode ser maior que a data atual.');
                        return false;
                    }

                    if (vm.DateEndSet) {
                        var dateEndDivide = vm.DateEndSet.toString().indexOf('.') >= 0 ? vm.DateEndSet.toString().split('.') : vm.DateEndSet.toString().split('/');

                        if (dateEndDivide.length == 3) {
                            var dateEndParse = Date.parse(dateEndDivide[1] + '/' + dateEndDivide[0] + '/' + dateEndDivide[2] + ' 00:00:00');

                            filters.DateEnd = new Date(dateEndParse);
                            if ( filters.DateInitial > filters.DateEnd) {
                                Common.mensagemError('A data inicial não pode ser maior que a data final.');
                                return false;
                            }

                            // Calcula a diferença entre as datas.
                            var timeDiff = Math.abs(new Date(dateEndParse).getTime() - new Date(dateIniParse).getTime());
                            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                            // Período de datas não pode ser maior que 6 meses.
                            if (diffDays > 365) {
                                Common.mensagemError('Período pesquisado não pode ser maior que 1 ano.');
                                return false;
                            }

                        } else {
                            Common.mensagemError('Data final incorreta.');
                            return false;
                        }
                    }
                } else {
                    Common.mensagemError('Data inicial incorreta.');
                    return false;
                }
            }
            return true;
        }

        vm.openSearchDashboard = function(item, create, update, detail) {          
            var modal = UIkit.modal(vm.getClassField('searchDashBoard'));
            modal.show();
        }

        vm.getClassField = function(field) {
            return APPLICATION.STRING_POINT + field;
        }
		/// <description>
		/// Método responsável pela inicialização da tela.
		/// </description>
		/// <author>
		/// Gabriel Souza.
		/// </author>
		vm.init = function () {
			vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
			vm.periodUpdated = true;
			$rootScope.modalDashboard = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_DASHBOARD);
			vm.loadFilters();			
			vm.initializingDash = true;
			if(vm.validateDate(vm.filters)){
				//Seta quantidade de graficos para renderização antes da plotagem. !Importante, pois sem isso, a primeira requisição os gráficos não aparecem.
				Dashboard.get(vm.filters).then(function (graphResult) {
					vm.graphCount = parseInt(graphResult.dashItens.length);
				}).catch(function (err) {
					$rootScope.modalDashboard.hide();
				});			

				//Inicializa os graficos.
				Dashboard.get(vm.filters).then(function (graphResult) {
					vm.initDashboard(graphResult);
					vm.ultimaAtualizacao = new Date();
					vm.initializingDash = false;
				}).catch(function (err) {
					$rootScope.modalDashboard.hide();
				});			
			}
		};		

		vm.configurarPermissoes();
        vm.accessIsAllowed = vm.isDashboardVisualizarPermitido;
        angular.extend(this, $controller('BaseApp', {$scope: this})); 
	}

	angular.module('app.dashboard')
		.controller('DashboardController', DashboardController);

})();






(function () {
  'use strict';

  angular
    .module('app.dashboardGeral', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function DashboardGeralService(Common, RestangularAuth, APPLICATION, Session) {

        var appSelecionada;

        function get() {
            return RestangularAuth.one('dashboard').get();
        }

        function getApps(idCompany) {
            return RestangularAuth.all('dashboard/apps').getList();
        }

        function getApp(id) {
            return RestangularAuth.one('dashboard/apps', id).get();
        }

        function selecionarApp(app) {
            appSelecionada = app;
            Session.setObjectLocalStorage(APPLICATION.applicationSelected, app);
        }

        function obterAppSelecionada() {
            appSelecionada = Session.getObjectLocalStorage(APPLICATION.applicationSelected);
            return appSelecionada;
        }

        function removerAppSelecionada() {
            Session.delObjectLocalStorage(APPLICATION.applicationSelected);
        }

        function init() {
            obterAppSelecionada();
        }
        init();

        return {
            get: get,
            getApps: getApps,
            getApp: getApp,
            selecionarApp: selecionarApp,
            obterAppSelecionada: obterAppSelecionada,
            removerAppSelecionada: removerAppSelecionada
        };
    }

    angular
        .module('app.dashboardGeral')
        .factory('DashboardGeral', DashboardGeralService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function DashboardGeralController(DashboardCompany, $rootScope, Security) {
        var vm = this;  
        vm.isUsuarioVisualizarPermitido = Security.exitsProfilePermission({ id: 2, name: "Colaboradores", action: "R" });
        vm.isPapelVisualizarPermitido = Security.exitsProfilePermission({ id: 4, name: "Papéis", action: "R" });

        vm.init = function () {
            DashboardCompany.removerAppSelecionada();
            $rootScope.$broadcast('reload-menu'); 
        };
        vm.init();
    }

    angular.module('app.dashboardGeral')
        .controller('DashboardGeralController', DashboardGeralController);

})();



(function () {
  'use strict';

  angular
    .module('app.dashboardCompany', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function DashboardCompanyService(Common, Company, RestangularAuth, APPLICATION, Session) {

        var appSelecionada;

        function get() {
            return RestangularAuth.one('dashboard').get();
        }

        function getApps(idCompany) {
            return RestangularAuth.all('dashboard/apps').getList();
        }

        function getApp(id) {
            return RestangularAuth.one('dashboard/apps', id).get();
        }

        function selecionarApp(app) {
            appSelecionada = app;
            return Company.getSingleCompanyApp(app.id).then(function(result){
                if(!result){
                    return;
                }        
                removerAppSelecionada();        
                result ={
                        id: result.id,
                        name:result.name,
                        app: {
                            id: result.app.id,
                            name: result.app.name
                        },
                        company: {
                            id: result.company.id,
                            name: result.company.name,
                        },
                        appStyle: result.appStyle
                }
                Session.setObjectLocalStorage(APPLICATION.applicationSelected, result);
            });
        }

        function obterAppSelecionada() {
            appSelecionada = Session.getObjectLocalStorage(APPLICATION.applicationSelected);
            if(!appSelecionada){
                return null;
            }            
            return appSelecionada;
        }

        function removerAppSelecionada() {
            Session.delObjectLocalStorage(APPLICATION.applicationSelected);
        }

        function init() {
            obterAppSelecionada();
        }
        init();

        return {
            get: get,
            getApps: getApps,
            getApp: getApp,
            selecionarApp: selecionarApp,
            obterAppSelecionada: obterAppSelecionada,
            removerAppSelecionada: removerAppSelecionada
        };
    }

    angular
        .module('app.dashboardCompany')
        .factory('DashboardCompany', DashboardCompanyService);

})();
(function () {
    'use strict';

    /** @ngInject */
    function DashboardCompanyController($interval, $rootScope, $scope, $state, $stateParams, $window, Company, DashboardCompany, Common, Painel, APPLICATION) {

        var vm = this;
        var COMPANY = Company.getCompanySelected();
        vm.company = COMPANY;

        vm.getApplications = function (companyKey) {
            return Company.getCompanyApps(companyKey).then(function (applications) {
                var applicationsPermissions = [];
                var mtAccountPermissions = JSON.parse(localStorage.getItem('mt-account-permissions'));

                if (applications) {
                    for (var j = 0; j < applications.length; j++) {
                        if (mtAccountPermissions) {
                            for (var i = 0; i < mtAccountPermissions.length; i++) {                    
                                if (
                                    (applications[j] && mtAccountPermissions[i]) &&
                                    ((applications[j].id == mtAccountPermissions[i].appCompanyId) ||
                                    (applications[j].app.id == mtAccountPermissions[i].appCompanyId))
                                    ) {
                                    applicationsPermissions.push(applications[j]);
                                    break;
                                }
                            }
                        }
                    }
                }

                //vm.applications = applications;
                vm.applications = applicationsPermissions;
                return vm.applications;
            });
        };

        vm.selecionarApp = function (local, app, appCompanyId) {
            $rootScope.modalAppCompany = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_CONFIGAPPCOMPANYS);
            var appCompany = {};
            appCompany.id = appCompanyId;
            appCompany.app = app;
            DashboardCompany.selecionarApp(appCompany).then(function(){
                $state.go('private.painel.dashboard.menuapp');
                $rootScope.$broadcast('reload-menu');
                $rootScope.modalAppCompany.hide(); 
            });
        };

        vm.init = function () {
            vm.isLoading = true;
            
            var company = Company.getCompanySelected();
            var companyId = company ? company.id : null;
            DashboardCompany.removerAppSelecionada();
            $rootScope.$broadcast('reload-menu');  
            vm.getApplications(companyId).then(function (data) {
                vm.isLoading = false;
            });
        };

        vm.init();

    }

    angular.module('app.dashboardCompany')
        .controller('DashboardCompanyController', DashboardCompanyController);

})();



(function () {
  'use strict';

  angular
    .module('app.dashboardApp', []);
})();


(function() {
    'use strict';

    /** @ngInject */
    function DashboardAppService(Common, RestangularAuth, APPLICATION) {

        function get() {
            return RestangularAuth.one('dashboard').get();
        }

        return {
            get: get,
        };
    }

    angular
        .module('app.dashboardApp')
        .factory('DashboardApp', DashboardAppService);

})();
(function () {
	'use strict';

	/** @ngInject */
	function DashboardAppController($interval, $rootScope, $scope, $timeout, $state, $window, DashboardApp, DashboardCompany, Cliente, Company, APPLICATION, Attendance, Common, SignalR) {
		var vm = this;
		vm.appSelecionado = DashboardCompany.obterAppSelecionada();
		vm.company = Company.getCompanySelected();


		// var vm = this;
		// var pInterval;
		// vm.updateDashBoard = false;
		// $rootScope.primarySidebarActive = false;

		// /// <description>
		// /// Lógica necessária para efetuar a atualização do dashboard em um intervalo de um minuto e meio.
		// /// </description>
		// /// <author>
		// /// Gabriel Souza.
		// /// </author>
		// var promise = $interval(function () {
		// 	console.log(APPLICATION.STRING_MSG_ATUALIZANDO_DASHBOARD);
		// 	vm.updateDashBoard = true;
		// 	Cliente.getDashBoard().then(function (responseUsers) {
		// 		vm.initAttendances(responseUsers);
		// 	}).catch(function (err) {
		// 		$rootScope.modalDashboard.hide();
		// 	});
		// }, 90000);

		// /// <description>
		// /// Lógica necessária para efetuar o destroy na atualização do dash ao sair da tela.
		// /// </description>
		// /// <author>
		// /// Gabriel Souza.
		// /// </author>
		// $scope.$on('$destroy', function () {
		// 	if (promise)
		// 		$interval.cancel(promise);
		// });

		// /// <description>
		// /// Método responsável pelo carregamento dos dados do dashboard para usuários.
		// /// </description>
		// /// <author>
		// /// Gabriel Souza.
		// /// </author>
		// vm.initUsers = function () {
		// 	$rootScope.modalDashboard = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_CARREGANDO_DASHBOARD);
		// 	Cliente.getDashBoard().then(function (responseUsers) {
		// 		vm.initAttendances(responseUsers);
		// 	}).catch(function (err) {
		// 		$rootScope.modalDashboard.hide();
		// 	});
		// }

		// /// <description>
		// /// Método responsável pelo carregamento dos dados do dashboard para gráficos.
		// /// </description>
		// /// <author>
		// /// Gabriel Souza.
		// /// </author>
		// vm.initAttendances = function (responseUsers) {
		// 	var filters = { months: 1 };

		// 	if (vm.updateDashBoard) {
		// 		$rootScope.modalDashboard = UIkit.modal.blockUI(APPLICATION.STRING_MODAL_ATUALIZANDO_DASHBOARD);
		// 	}

		// 	Attendance.getDashBoardDefaults(filters).then(function (responseAttendance) {
		// 		vm.qntUsers = responseUsers.qntUsers;
		// 		vm.qntUsersConfirmed = responseUsers.qntUsersConfirmed;
		// 		vm.qntUsersNotConfirmed = responseUsers.qntUsersNotConfirmed;
		// 		vm.qntUsersActive = responseUsers.qntUsersActive;

		// 		vm.qntPreCadastro = responseAttendance.chamadosGerais.qntPreCadastro;
		// 		vm.qntRegistroAmostra = responseAttendance.chamadosGerais.qntRegistroAmostra;
		// 		vm.qntRegistroAmostraSwab = responseAttendance.chamadosGerais.qntRegistroAmostraSwab;
		// 		vm.qntSolicitacaoKit = responseAttendance.chamadosGerais.qntSolicitacaoKit;

		// 		vm.dynamicStats = [
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_1,
		// 				title: APPLICATION.STRING_CLIENTES_CADASTRADOS,
		// 				count: vm.qntUsers,
		// 				chart_options: {
		// 					height: 28,
		// 					width: 48,
		// 					fill: ["#d84315"],
		// 					padding: 0.2
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_2,
		// 				title: APPLICATION.STRING_CLIENTES_AGUARDANDO_CONFIRMACAO,
		// 				count: vm.qntUsersNotConfirmed,
		// 				chart_options: {
		// 					height: 28,
		// 					width: 64,
		// 					fill: "#d1e4f6",
		// 					stroke: "#0288d1"
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_3,
		// 				title: APPLICATION.STRING_CLIENTES_CONFIRMADOS,
		// 				count: vm.qntUsersConfirmed,
		// 				chart_data: ['64/100'],
		// 				chart_options: {
		// 					height: 24,
		// 					width: 24,
		// 					fill: ["#8bc34a", "#eee"]
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_4,
		// 				title: APPLICATION.STRING_CLIENTES_ATIVOS,
		// 				count: vm.qntUsersActive,
		// 				chart_options: {
		// 					height: 28,
		// 					width: 64,
		// 					fill: "#efebe9",
		// 					stroke: "#5d4037"
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_5,
		// 				title: APPLICATION.STRING_PRE_CADASTRO_30_DIAS,
		// 				count: vm.qntPreCadastro,
		// 				chart_options: {
		// 					height: 28,
		// 					width: 48,
		// 					fill: ["#d84315"],
		// 					padding: 0.2
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_6,
		// 				title: APPLICATION.STRING_REGISTRO_AMOSTRA_30_DIAS,
		// 				count: vm.qntRegistroAmostra,
		// 				chart_options: {
		// 					height: 28,
		// 					width: 64,
		// 					fill: "#d1e4f6",
		// 					stroke: "#0288d1"
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_7,
		// 				title: APPLICATION.STRING_REGISTRO_AMOSTRA_SWAB_30_DIAS,
		// 				count: vm.qntRegistroAmostraSwab,
		// 				chart_data: ['64/100'],
		// 				chart_options: {
		// 					height: 24,
		// 					width: 24,
		// 					fill: ["#8bc34a", "#eee"]
		// 				}
		// 			},
		// 			{
		// 				id: APPLICATION.STRING_NUMERO_8,
		// 				title: APPLICATION.STRING_SOLICITACAO_KITS_30_DIAS,
		// 				count: vm.qntSolicitacaoKit,
		// 				chart_options: {
		// 					height: 28,
		// 					width: 64,
		// 					fill: "#efebe9",
		// 					stroke: "#5d4037"
		// 				}
		// 			}
		// 		];

		// 		$rootScope.$on('onLastRepeat', function (scope, element, attrs) {
		// 			vm.dynamicStats[0].count = vm.qntUsers.toString();
		// 			vm.dynamicStats[1].count = vm.qntUsersNotConfirmed.toString();
		// 			vm.dynamicStats[2].count = vm.qntUsersConfirmed.toString();
		// 			vm.dynamicStats[3].count = vm.qntUsersActive.toString();
		// 			vm.dynamicStats[4].count = vm.qntPreCadastro.toString();
		// 			vm.dynamicStats[5].count = vm.qntRegistroAmostra.toString();
		// 			vm.dynamicStats[6].count = vm.qntRegistroAmostraSwab.toString();
		// 			vm.dynamicStats[7].count = vm.qntSolicitacaoKit.toString();
		// 		});

		// 		// GRAFICO  (HOJE)
		// 		var c3chart_spline_id = '#c3_chart_spline_hoje';
		// 		if ($(c3chart_spline_id).length) {
		// 			vm.c3chart_spline = c3.generate({
		// 				bindto: c3chart_spline_id,
		// 				data: {
		// 					columns: [
		// 						responseAttendance.chamadosHoje.listaPreCadastroHoje,
		// 						responseAttendance.chamadosHoje.listaRegistroAmostra,
		// 						responseAttendance.chamadosHoje.listaRegistroAmostraSwab,
		// 						responseAttendance.chamadosHoje.listaSolicitacaoKit
		// 					],
		// 					types: {
		// 						Abertas: 'area',
		// 						Acatadas: 'area',
		// 						Canceladas: 'area'
		// 					}
		// 				},
		// 				axis: {
		// 					x: {
		// 						type: 'category',
		// 						categories: responseAttendance.chamadosHoje.tempo
		// 					}
		// 				},
		// 				color: {
		// 					pattern: ['rgb(227, 225, 56)', 'rgb(124, 179, 66)', '#999']
		// 				}
		// 			});

		// 			$($window).on('debouncedresize', function () {
		// 				vm.c3chart_spline.resize()
		// 			});
		// 		}

		// 		// CHAMADOS ABERTOS SLA 3 DIAS - REGISTRO DE AMOSTRA
		// 		var c3_chart_registro_amostra_sla_3_dias = '#c3_chart_registro_amostra_sla_3_dias';
		// 		var solicidacaoEnviada = responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasSolicitacaoEnviada[1];
		// 		var emTransito = responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasEmTransito[1];
		// 		var finalizada = responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasFinalizada[1];
		// 		var emProcessamento = responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasEmProcessamento[1];
		// 		var emValidacao = responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasEmValidacao[1];
		// 		var cancelada = responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasCancelada[1];

		// 		if (solicidacaoEnviada == 0 & emTransito == 0 & finalizada == 0) {
		// 			vm.semDadosRegistroAmostra = true;
		// 		}
		// 		if ($(c3_chart_registro_amostra_sla_3_dias).length) {

		// 			vm.c3_chart_registro_amostra_sla_3_dias = c3.generate({
		// 				bindto: c3_chart_registro_amostra_sla_3_dias,
		// 				data: {
		// 					columns: [
		// 						responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasSolicitacaoEnviada,
		// 						responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasEmTransito,
		// 						responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasFinalizada,
		// 						responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasEmProcessamento,
		// 						responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasEmValidacao,
		// 						responseAttendance.chamadosQntRegistroAmostraSla3Dias.qntRegistroAmostraSla3DiasCancelada
		// 					],
		// 					type: 'donut',
		// 				},
		// 				donut: {
		// 					title: "",
		// 					width: 80,
		// 					label: {
		// 						format: function (value, ratio, id) {
		// 							return d3.format('')(value);
		// 						}
		// 					}
		// 				},
		// 				color: {
		// 					pattern: ['rgb(227, 225, 56)', 'rgb(124, 179, 66)', '#999', '#551A8B', '#FFA500', '#ff0000']
		// 				}
		// 			});

		// 			$($window).on('debouncedresize', function () {
		// 				vm.c3_chart_registro_amostra_sla_3_dias.resize();
		// 			});
		// 		}

		// 		// CHAMADOS ABERTOS SLA 3 DIAS - REGISTRO DE AMOSTRA COM SWAB
		// 		var c3_chart_swab_sla_3_dias = '#c3_chart_swab_sla_3_dias';
		// 		var solicidacaoEnviada = responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasSolicitacaoEnviada[1];
		// 		var emTransito = responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasEmTransito[1];
		// 		var finalizada = responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasFinalizada[1];
		// 		var emProcessamento = responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasEmProcessamento[1];
		// 		var emValidacao = responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasEmValidacao[1];
		// 		var cancelada = responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasCancelada[1];

		// 		if (solicidacaoEnviada == 0 & emTransito == 0 & finalizada == 0) {
		// 			vm.semDadosRegistroAmostraSwab = true;
		// 		}

		// 		if ($(c3_chart_swab_sla_3_dias).length) {

		// 			vm.c3_chart_swab_sla_3_dias = c3.generate({
		// 				bindto: c3_chart_swab_sla_3_dias,
		// 				data: {
		// 					columns: [
		// 						responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasSolicitacaoEnviada,
		// 						responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasEmTransito,
		// 						responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasFinalizada,
		// 						responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasEmProcessamento,
		// 						responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasEmValidacao,
		// 						responseAttendance.chamadosQntRegistroAmostraComSwabSla3Dias.qntRegistroAmostraSwabSla3DiasCancelada
		// 					],
		// 					type: 'donut',
		// 				},
		// 				donut: {
		// 					title: "",
		// 					width: 80,
		// 					label: {
		// 						format: function (value, ratio, id) {
		// 							return d3.format('')(value);
		// 						}
		// 					}
		// 				},
		// 				color: {
		// 					pattern: ['rgb(227, 225, 56)', 'rgb(124, 179, 66)', '#999', '#551A8B', '#FFA500', '#ff0000']
		// 				}
		// 			});

		// 			$($window).on('debouncedresize', function () {
		// 				vm.c3_chart_swab_sla_3_dias.resize();
		// 			});
		// 		}

		// 		// CHAMADOS ABERTOS SLA 3 DIAS - SOLICITAÇÃO DE KIT
		// 		var c3_chart_kit_sla_3_dias = '#c3_chart_kit_sla_3_dias';
		// 		var solicidacaoEnviada = responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasSolicitacaoEnviada[1];
		// 		var emTransito = responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasEmTransito[1];
		// 		var finalizada = responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasFinalizada[1];
		// 		var emProcessamento = responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasEmProcessamento[1];
		// 		var emValidacao = responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasEmValidacao[1];
		// 		var cancelada = responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasCancelada[1];
		// 		if (solicidacaoEnviada == 0 & emTransito == 0 & finalizada == 0) {
		// 			vm.semDadoSolicitacaoKit = true;
		// 		}

		// 		if ($(c3_chart_kit_sla_3_dias).length) {

		// 			vm.c3_chart_kit_sla_3_dias = c3.generate({
		// 				bindto: c3_chart_kit_sla_3_dias,
		// 				data: {
		// 					columns: [
		// 						responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasSolicitacaoEnviada,
		// 						responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasEmTransito,
		// 						responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasFinalizada,
		// 						responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasEmProcessamento,
		// 						responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasEmValidacao,
		// 						responseAttendance.chamadosQntSolicitacaoKitSla3Dias.qntSolicitacaoKitSla3DiasCancelada
		// 					],
		// 					type: 'donut',
		// 				},
		// 				donut: {
		// 					title: "",
		// 					width: 80,
		// 					label: {
		// 						format: function (value, ratio, id) {
		// 							return d3.format('')(value);
		// 						}
		// 					}
		// 				},
		// 				color: {
		// 					pattern: ['rgb(227, 225, 56)', 'rgb(124, 179, 66)', '#999', '#551A8B', '#FFA500', '#ff0000']
		// 				}
		// 			});

		// 			$($window).on('debouncedresize', function () {
		// 				vm.c3_chart_kit_sla_3_dias.resize();
		// 			});
		// 		}

		// 		$rootScope.modalDashboard.hide();
		// 		vm.updateDashBoard = false;
		// 	});
		// }

		// /// <description>
		// /// Método responsável pelo carregamento dos dados iniciais, filtros do dashboard.
		// /// </description>
		// /// <author>
		// /// Gabriel Souza.
		// /// </author>
		// vm.loadFilters = function () {
		// 	vm.qntUsers = 0;
		// 	vm.qntUsersConfirmed = 0;
		// 	vm.qntUsersNotConfirmed = 0;
		// 	vm.qntUsersActive = 0;
		// 	vm.semDadosRegistroAmostra = false;
		// 	vm.semDadosRegistroAmostraSwab = false;
		// 	vm.semDadoSolicitacaoKit = false;
		// };

		// /// <description>
		// /// Método responsável pela inicialização da tela.
		// /// </description>
		// /// <author>
		// /// Gabriel Souza.
		// /// </author>
		// vm.init = function () {
		// 	vm.loadFilters();
		// 	vm.initUsers();
		// };

		// vm.init();
	}

	angular.module('app.dashboardApp')
		.controller('DashboardAppController', DashboardAppController);

})();






/**
 * Created by Luiz on 04/05/2016.
 */
(function () {
  'use strict';

  angular
    .module('app.modal', []);
})();

/**
 * Created by Luiz on 04/05/2016.
 */

(function () {
  'use strict';
  function CustomModal(Common) {

    var lang = sessionStorage.getItem('lang');
    var showModal = function (modalSelector) {
      var modal = UIkit.modal(modalSelector);
      if (modal.isActive())  modal.hide();
      modal.options = {bgclose: false};
      modal.show();
    };

    var closeModal = function (modalSelector, validate) {
      lang = sessionStorage.getItem('lang');
      if (validate) {
        UIkit.modal.confirm('Você tem certeza que deseja fechar esta janela? ', function () {
          close(modalSelector);
          return true;
        }, {
          labels: {
            'Ok': 'CONFIRMAR',
            'Cancel': 'CANCELAR'
          }
        });
        return false;
      }
      else {
        close(modalSelector);
        return true;
      }
    };

    var close = function (modalSelector) {
      lang = sessionStorage.getItem('lang');
      var modal = UIkit.modal(modalSelector);
      if (modal.isActive())  modal.hide();
    };

    return {
      showModal: showModal,
      closeModal: closeModal
    };

  }

  CustomModal.$inject = ['Common'];
  angular
    .module('app.modal')
    .factory('CustomModal', CustomModal);
})();

/**
 * Created by Luiz on 04/05/2016.
 */
(function () {
  'use strict';


  /** @ngInject */
  function CustomModalController($rootScope, $state, AUTH_EVENTS, Session, CustomModal) {
    var vm = this;
    vm.showModal = function (modal) {
      CustomModal.showModal(modal);
    };

    vm.closeModal = function (modal, validate) {
      return CustomModal.closeModal(modal, validate);
    }
  }

  angular
    .module('app.modal')
    .controller('CustomModalController', CustomModalController);

})();


(function () {
  'use strict';

  angular
    .module('app.directives', []);
})();

(function () {
  'use strict';

  function uiDate() {
    // return {
    //   require: '?ngModel',
    //   link: function($scope, element, attrs, controller) {
    //     element.mask("99/99/9999",{completed: function() {
    //       controller.$setViewValue(Date.parse(this.val(),"dd/MM/yyyy"));
    //       $scope.$apply();
    //     }});
    //   }
    // };

   //  return {
   //    require: 'ngModel',
   //    link: function(scope, element, attrs, ngModelController) {
   //     ngModelController.$parsers.push(function(data) {

   //            //View -> Model
   //            var date = Date.parseExact(data,'dd/MM/yyyy');

   //            // if the date field is not a valid date
   //            // then set a 'date' error flag by calling $setValidity
   //            ngModelController.$setValidity('date', date!=null);
   //            return date == null ? undefined : date;
   //          });
   //     ngModelController.$formatters.push(function(data) {
   //            //Model -> View
   //            return $filter('date')(data, 'dd/MM/yyyy');
   //          });
   //   }
   // }
 }
 angular
 .module('app.directives')
 .directive('uiDate', uiDate);

})();


(function() {
    'use strict';

    function numberMask($parse) {
        return function(scope, element, attrs) {
            var min = parseInt(attrs.min, 10) || 0,
                max = parseInt(attrs.max, 10) || 10,
                value = element.val();
            element.on('keyup', function(e) {
                if (!between(element.val(), min, max)) {
                    element.val(value);
                } else {
                    value = element.val();
                }
            });

            function between(n, min, max) { return n >= min && n <= max; }
        }
    }


    angular
        .module('app.directives')
        .directive('numberMask', numberMask);

})();
(function () {
  'use strict';

  function mtValueMin() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
            scope.$watch(attr.mtValueMin, function () {
                ctrl.$setViewValue(ctrl.$viewValue);
            });
            var minValidator = function (value) {
                var min = scope.$eval(attr.mtValueMin) || 0;

                if (value && (value < min)) {
                    ctrl.$setValidity('mtValueMin', false);
                    return undefined;
                } else {
                    ctrl.$setValidity('mtValueMin', true);
                    return value;
                }
            };

            ctrl.$parsers.push(minValidator);
            ctrl.$formatters.push(minValidator);
        }
    };
  }

  angular
    .module('app.directives')
    .directive('mtValueMin', mtValueMin);

})();


(function () {
  'use strict';

  function mtValueMax() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
            scope.$watch(attr.mtValueMax, function () {
                ctrl.$setViewValue(ctrl.$viewValue);
            });
            var maxValidator = function (value) {
                var max = scope.$eval(attr.mtValueMax) || Infinity;
                if (value && value > max) {
                    ctrl.$setValidity('mtValueMax', false);
                    return undefined;
                } else {
                    ctrl.$setValidity('mtValueMax', true);
                    return value;
                }
            };

            ctrl.$parsers.push(maxValidator);
            ctrl.$formatters.push(maxValidator);
        }
    };
  }

  angular
    .module('app.directives')
    .directive('mtValueMax', mtValueMax);

})();


(function () {
  'use strict';

  function mtValidateSubmit($parse) {
    return {
      restrict: 'A',
      require: 'form',
      link: function (scope, element, attrs, ctrl) {
        var fn = $parse(attrs.mtValidateSubmit);
        element.bind('submit', function (event) {
          scope.$broadcast('show-errors-check-validity');
          // if form is not valid cancel it.
          if (!ctrl.$valid) {
            return false;
          }
          scope.$apply(function () {
            fn(scope, {$event: event});
          });
        });
      }
    };
  }

  mtValidateSubmit.$inject = ['$parse'];

  angular
    .module('app.directives')
    .directive('mtValidateSubmit', mtValidateSubmit);

})();

(function () {
  'use strict';

  function mtUiSelectRequired($parse) {
    return {
      require: 'ngModel',
      link: function postLink(scope, element, attrs, ngModel) {
            ngModel.$validators.required = function (value) {
              //console.log('value: ' + value);
              //console.log('angular.isString(value): ' + angular.isString(value));

              var valido = false;
              if (value) {
                valido = true;
              }
              return valido;

              //return angular.isString(value);
            };
        }
    };
  }

  mtUiSelectRequired.$inject = ['$parse'];

  angular
    .module('app.directives')
    .directive('mtUiSelectRequired', mtUiSelectRequired);

})();

(function () {
  'use strict';

  function mtUiSelectMultipleRequired($parse) {
    return {
      require: 'ngModel',
      link: function postLink(scope, element, attrs, ngModel) {
            ngModel.$validators.required = function (value) {
                return angular.isArray(value) && value.length > 0;
            };
        }
    };
  }

  mtUiSelectMultipleRequired.$inject = ['$parse'];

  angular
    .module('app.directives')
    .directive('mtUiSelectMultipleRequired', mtUiSelectMultipleRequired);

})();

(function () {
  'use strict';

  function mtShowErrors($timeout) {

    return {
      restrict: 'A',
      require:  '^form',
      scope: {
        mtShowErrors: '='
      },
      link: function (scope, element, attrs, ctrl) {
        // find the text box element, which has the 'name' attribute
        var inputEl = element[0].querySelector('[name]');
        // convert the native text box element to an angular element
        var inputNgEl = angular.element(inputEl);
        // get the name on the text box so we know the property to check
        // on the form controller
        var inputName = scope.mtShowErrors || inputNgEl.attr('name');

        // only apply the has-error class after the user leaves the text box
        inputNgEl.bind('blur', function () {
          element.toggleClass('has-error', ctrl[inputName].$invalid);
        });

        scope.$on('show-errors-check-validity', function () {
          element.toggleClass('has-error', ctrl[inputName].$invalid);
        });

        scope.$on('show-errors-reset', function () {
          $timeout(function () {
            element.removeClass('has-error');
          }, 0, false);
        });

      }
    };

  }

  mtShowErrors.$inject = ['$timeout'];

  angular
    .module('app.directives')
    .directive('mtShowErrors', mtShowErrors);

})();
(function () {
  'use strict';

  function mtSetFocus($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        $timeout(function () {
          element[0].focus();
        }, 100);
      }
    };
  }

  mtSetFocus.$inject = ['$timeout'];

  angular
    .module('app.directives')
    .directive('mtSetFocus', mtSetFocus);

})();

(function () {
  'use strict';

  function mtRightLink() {
    var rightLink = angular.element(document.querySelector('#right-link'));
    return {
      restrict: 'A',
      link: function (scope, element) {

        rightLink.append(element);

        scope.$on(
          '$destroy',
          function () {
            element.remove();
          }
        );

      }
    };
  }

  angular
    .module('app.directives')
    .directive('mtRightLink', mtRightLink);

})();


(function () {
  'use strict';

  function mtResetErrors() {
    return {
      restrict: 'A',
      scope: {
        krResetObject: '='
      },
      link: function (scope, element) {
        element.bind('click', function () {
          if (angular.isObject(scope.krResetObject)) {
            scope.krResetObject = {};
          }
          scope.$broadcast('show-errors-reset');
        });
      }
    };
  }

  angular
    .module('app.directives')
    .directive('mtResetErrors', mtResetErrors);

})();

(function () {
  'use strict';

  function pwCheck() {
    



    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
            var firstPassword = '#' + attrs.pwCheck;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    // console.info(elem.val() === $(firstPassword).val());
                    ctrl.$setValidity('pwmatch', elem.val() === $(firstPassword).val());
                });
            });
        }
    };
  



  }

  angular
    .module('app.directives')
    .directive('pwCheck', pwCheck);

})();


(function () {
  'use strict';

  function mtLeftLink() {
    var leftLink = angular.element(document.querySelector('#left-link'));
    return {
      restrict: 'A',
      link: function (scope, element) {

        leftLink.append(element);

        scope.$on(
          '$destroy',
          function () {
            element.remove();
          }
        );

      }
    };
  }

  angular
    .module('app.directives')
    .directive('mtLeftLink', mtLeftLink);

})();


(function () {
  'use strict';

  function lowerThan() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, $element, $attrs, ctrl) {
            
          var validate = function(viewValue) {

            var comparisonModel = $attrs.lowerThan;

            if(!viewValue || !comparisonModel) {
              // It's valid because we have nothing to compare against
              ctrl.$setValidity('lowerThan', true);
            }
            else
            {
              // It's valid if model is lower than the model we're comparing against
              ctrl.$setValidity('lowerThan', viewValue < comparisonModel);
            }

            return viewValue;
          };

          ctrl.$parsers.unshift(validate);
          ctrl.$formatters.push(validate);

          $attrs.$observe('lowerThan', function(comparisonModel){
            // Whenever the comparison model changes we'll re-validate
            return validate(ctrl.$viewValue);
          });
        }
    };
  }

  angular
    .module('app.directives')
    .directive('lowerThan', lowerThan);

})();


// angular.module('app.directives').directive('graphCanvasRefresh', ['$compile', function($compile) {
//     function link(scope, elem, attrs) {

//         function refreshDOM() {
//             var markup = '<canvas id="mycanvas"  linechart options="vm.lineOptions" data="vm.singleBarDataDay" class="chart-report chart-pie" ></canvas>';
//             var el = angular.element(markup);
//             compiled = $compile(el);
//             elem.html('');
//             elem.append(el);
//             compiled(scope);
//         };

//     // Refresh the DOM when the attribute value is changed
//     scope.$watch(attrs.graphCanvasRefresh, function(value) {
//       console.log("refreshDOM")
//       refreshDOM();
//   });

//     // Clean the DOM on destroy
//     scope.$on('$destroy', function() {
//         elem.html('');
//     });
// };

// return  {
//     link: link
// };
// }]);

(function () {
  'use strict';

  function fileModel($parse) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;
            
        element.bind('change', function () {
          scope.$apply(function () {

            //var input = element[0].getElementsByTagName('input');

            //console.log('1: ', input);
            //var input = angular.element(document.querySelector('#button'));

            //console.log('input: ', input.files);

            modelSetter(scope, element[0].files[0]);
            //console.log('file: ', element[0].files[0]);
          });
        });
      }
    };
  }

  fileModel.$inject = ['$parse'];

  angular
    .module('app.directives')
    .directive('fileModel', fileModel);

})();
(function () {
  'use strict';

  function dateField($filter) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModelController) {
       ngModelController.$parsers.push(function(data) {
              //View -> Model
              //console.log('data', data);
              var date = Date.parseExact(data,"dd/MM/yyyy");
              //console.log('date', date);
              ngModelController.$setValidity('date', date!=null);
              return date;
            });
       ngModelController.$formatters.push(function(data) {
              //Model -> View
              //console.log('filter date', $filter('date')(data, "dd/MM/yyyy"));
              return $filter('date')(data,"dd/MM/yyyy");
            });
     }
   };
 }
 dateField.$inject = ['$filter'];

 angular
 .module('app.directives')
 .directive('dateField', dateField);

})();


(function () {
    'use strict';

    function customHeight() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var heightValue = scope.$eval(attrs.customHeightValue);
                function setHeight() {
                    var offset = $(element).offset();
                    var contentHeight = window.innerHeight;
                    var aHeight = 0;

                    aHeight = contentHeight - offset.top - heightValue;
                    angular.element(element).css('height', aHeight + 'px');
                }

                setTimeout(function () {
                    setHeight();
                }, 500);


                $(window).resize(function () {
                    setHeight();
                });
            }
        };
    }

    angular
        .module('app.directives')
        .directive('customHeight', customHeight);

})();
(function () {
  'use strict';

  function awDatepickerPattern() {
   return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope,elem,attrs,ngModelCtrl) {
      // console.log('attrs', attrs.awDatepickerPattern);
      // var dRegex = new RegExp(attrs.awDatepickerPattern);

      ngModelCtrl.$parsers.unshift(function(value) {

        if (typeof value === 'string') {
          var date = Date.parseExact(value,"dd/MM/yyyy")
          // var isValid = dRegex.test(value);
          ngModelCtrl.$setValidity('date',date!=null);
          if(date==null){
           return undefined;
         }
       }

       return value;
     });

    }
  };
}
angular
.module('app.directives')
.directive('awDatepickerPattern', awDatepickerPattern);

})();


(function () {
    'use strict';

    function autoHeight() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var autoHeightFull = scope.$eval(attrs.autoHeightFullHeight);
                function setHeight() {
                    var offset = $(element).offset();
                    var contentHeight = window.innerHeight;
                    var aHeight = 0;

                    aHeight = contentHeight - offset.top - 60;
                    if (autoHeightFull) {
                        aHeight = contentHeight - offset.top;
                    }
                    angular.element(element).css('height', aHeight + 'px');
                }

                function setHeightFullFalse() {
                    var offset = $(element).offset();
                    var contentHeight = window.innerHeight;
                    var aHeight = 0;

                    aHeight = contentHeight - offset.top - 15;
                    if (autoHeightFull) {
                        aHeight = contentHeight - offset.top;
                    }
                    angular.element(element).css('height', aHeight + 'px');
                }
                
                if (autoHeightFull) {
                    setTimeout(function () {
                        setHeight();
                    }, 500);
                } else {
                    setTimeout(function () {
                        setHeightFullFalse();
                    }, 500);
                }


                $(window).resize(function () {
                    setHeight();
                });
            }
        };
    }

    angular
        .module('app.directives')
        .directive('autoHeight', autoHeight);

})();
(function () {
  'use strict';
  
  angular
    .module('app.constants', []);
})();

(function () {
    'use strict';

    var SECURITY = {
        accessToken: 'mt-access-token',
        refreshToken: 'mt-refresh-token',
        accessKey: 'mt-access-key',
        accountUserName: 'mt-account-user-name',
        accountRole: 'mt-account-role',
        accountPermissions: 'mt-account-permissions',

        accountUserEmail: 'mt-account-user-Email',
        accountUserCompany: 'mt-account-user-company',
        accountIsAdmin: 'mt-account-user-admin', 
        accountCrm: 'mt-account-crm',       
        autorizationResponse: 'mtm-user-authorization-response'        
    };

    angular
        .module('app.constants')
        .constant('SECURITY', SECURITY);

})();
(function () {
    'use strict';

    var FORMS = {
        formComponents: [
            {
                immutableTitle: 'Página', title: 'Nova Página', draggableType: 'container', type: 'SubForm', dropType: 'subform', icon: 'folder', componentIcon: '&#xe9c9', minOccurs: '1', maxOccurs: '1', isRepeatable: false, children: [], allowedTypes: ['item', 'repeatGroup']
            }, //&#xf07b
            { immutableTitle: 'Texto Livre', title: 'Texto Livre', draggableType: 'item', type: 'FreeText', icon: 'short_text', componentIcon: '&#xe991', textType: 'FreeText', dropType: 'item' }, //&#xf036
            { immutableTitle: 'Título', title: 'Título', draggableType: 'item', type: 'Title', icon: 'format_size', componentIcon: '&#xe956', dropType: 'item' }, //&#xf034
            { immutableTitle: 'Descritivo', title: 'Descritivo', draggableType: 'item', type: 'Observation', icon: 'help_outline', componentIcon: '&#xe94b', dropType: 'item' },
            { immutableTitle: 'Seleção Simples', title: 'Seleção Simples', draggableType: 'item', type: 'SimpleSelect', icon: 'radio_button_checked', componentIcon: '&#xe929', selectType: 'List', dropType: 'item' }, //&#xf192
            { immutableTitle: 'Seleção Múltipla', title: 'Seleção Múltipla', draggableType: 'item', type: 'MultipleSelect', icon: 'check_box', componentIcon: '&#xe94f', multipleSelectType: 'Button', dropType: 'item' },
            { immutableTitle: 'NPS', title: 'NPS', draggableType: 'item', type: 'NpsSelect', icon: 'mood', componentIcon: '&#xe9e6', npsSelectType: 'List', dropType: 'item' }, //&#xf192
            { immutableTitle: 'Data', title: 'Data', draggableType: 'item', type: 'DateTime', icon: 'date_range', componentIcon: '&#xe910', dateTimeType: 'Date', today: false, dropType: 'item' }, //&#xf073
            { immutableTitle: 'Hora', title: 'Hora', draggableType: 'item', type: 'DateTime', icon: 'access_time', componentIcon: '&#xe9b1', dateTimeType: 'Time', today: false, dropType: 'item' }, //&#xf017
            //{ immutableTitle: 'Data + Hora', title: 'Data + Hora', draggableType: 'item', type: 'DateTime', icon: 'today', componentIcon: '', dateTimeType: 'DateTime', today: false, dropType: 'item' },
            { immutableTitle: 'Numérico', title: 'Numérico', draggableType: 'item', type: 'Number', icon: 'looks_two', componentIcon: '&#xe9ac', numberType: 'Nothing', dropType: 'item' }, //&#xf162
            //{ immutableTitle: 'Inteiro', title: 'Inteiro', draggableType: 'item', type: 'Number', icon: 'looks_two', componentIcon: '&#xe9ac', numberType: 'Integer', dropType: 'item' }, //&#xf162
            //{ immutableTitle: 'Decimal', title: 'Decimal', draggableType: 'item', type: 'Number', icon: 'looks_3', componentIcon: '&#xe9ac', numberType: 'Decimal', dropType: 'item' }, //&#xf12b
            { immutableTitle: 'Localização', title: 'Localização', draggableType: 'item', type: 'Location', icon: 'place', componentIcon: '', dropType: 'item' },
            { immutableTitle: 'Imagem', title: 'Imagem', draggableType: 'item', type: 'Image', icon: 'camera_alt', componentIcon: '&#xe912', originImage: 'Both', dropType: 'item' }, //&#xf030
            { immutableTitle: 'Áudio', title: 'Áudio', draggableType: 'item', type: 'Audio', icon: 'audiotrack', componentIcon: '', dropType: 'item' },
            { immutableTitle: 'Assinatura', title: 'Assinatura', draggableType: 'item', type: 'Signature', icon: 'create', componentIcon: '', dropType: 'item' },
            { immutableTitle: 'QrCode', title: 'QrCode', draggableType: 'item', type: 'QrCode', icon: 'view_week', componentIcon: '', dropType: 'item' },
            //{ immutableTitle: 'Barcode', title: 'Barcode', draggableType: 'item', type: 'QrCode', icon: 'view_week', componentIcon: '', dropType: 'item' },
            { immutableTitle: 'Desenho Livre', title: 'Desenho Livre', draggableType: 'item', type: 'Sketch', icon: 'gesture', componentIcon: '', dropType: 'item' },
            { immutableTitle: 'Campo Oculto', title: 'Campo Oculto', draggableType: 'item', type: 'Hidden', icon: 'visibility_off', componentIcon: '&#xe923', dropType: 'item' },
            // {
            // immutableTitle: 'Grupo de Repetição', title: 'Grupo de Repetição', draggableType: 'container', type: 'SubForm', dropType: 'repeatGroup', icon: 'repeat', componentIcon: '', isRepeatable: true, children: [], allowedTypes: ['item'],
            // },

        ],

        behaviorProperties: [
            { propertyName: 'Nunca', id: 'Never' },
            { propertyName: 'Somente quando', id: 'WhenOnly' },
            { propertyName: 'Sempre', id: 'Always' },
        ],

        typeDateProperties: [
            { propertyName: 'Selecione', id: 'Nothing' },
            { propertyName: 'Normal (dd/mm/yyyy)', id: 'DayMonthYear' },
            { propertyName: 'Dia e Mês (dd/mm)', id: 'DayMonth' },
            { propertyName: 'Mês e Ano (mm/yyyy)', id: 'MonthYear' }
        ],

        typeNumberProperties: [
            { propertyName: 'Inteiro', id: 'Integer' },
            { propertyName: 'Decimal', id: 'Decimal' }
        ],

        logicalOperators: [
            { propertyName: 'E', id: 'AND' },
            { propertyName: 'Ou', id: 'OR' },
        ],

        textTypeFreeTextComponent: [
            { propertyName: 'Cep', id: 'Cep', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            { propertyName: 'Cpf', id: 'Cpf', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            { propertyName: 'E-mail', id: 'Email', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            // { propertyName: 'Cep', id: 'Cep', validationRuleSet: { regularExpression: '^([0-9]{2}.[0-9]{3}-[0-9]{3})|([0-9]{8})$', validationMessage: 'Cep inválido!' } },
            // { propertyName: 'Cpf', id: 'Cpf', validationRuleSet: { regularExpression: '^(\\d{3}\\.\\d{3}\\.\\d{3}-\\d{2})|(\\d{11})$', validationMessage: 'Cpf inválido!' } },
            // { propertyName: 'E-mail', id: 'Email', validationRuleSet: { regularExpression: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$', validationMessage: 'E-mail inválido!' } },
            { propertyName: 'Nome próprio', id: 'Captalize', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            { propertyName: 'Senha', id: 'Password', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            { propertyName: 'Telefone', id: 'Phone', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            //{ propertyName: 'Telefone', id: 'Phone', validationRuleSet: { regularExpression: '^[1-9]{2}[2-9][0-9]{7,8}$', validationMessage: 'Telefone inválido!' } },
            { propertyName: 'Texto Livre', id: 'FreeText', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
            // { propertyName: 'Url', id: 'Url', validationRuleSet: { regularExpression: '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,5}(:[0-9]{1,5})?(\\/.*)?$', validationMessage: 'Url inválida!' } },
            // { propertyName: 'Html', id: 'Html', validationRuleSet: { regularExpression: undefined, validationMessage: undefined } },
        ],

        methodSelectsComponent: [
            { propertyName: 'GET', id: 'GET' },
            // { propertyName: 'POST', id: 'POST' }
        ],

        selectTypeSimpleSelectComponent: [
            { propertyName: 'Radio', id: 'Radio' },
            { propertyName: 'Lista', id: 'List' },
            { propertyName: 'Sim/Não', id: 'YesOrNo' },
            { propertyName: 'Slider', id: 'Slider' }
            // { propertyName: 'Button', id: 'Button' }
        ],

        selectTypeMultipleSelectComponent: [
            { propertyName: 'Button', id: 'Button' },
            { propertyName: 'Checkbox', id: 'CheckBox' }
        ],

        dateTimeTypeDateTimeComponent: [
            { propertyName: 'Data + Hora', id: 'DateTime' },
            { propertyName: 'Somente data', id: 'Date' },
            { propertyName: 'Somente hora', id: 'Time' },
        ],

        numberTypeNumberComponent: [
            { propertyName: 'Inteiro', id: 'Integer' },
            { propertyName: 'Decimal', id: 'Decimal' }
        ],

        originImageComponent: [
            { propertyName: 'Câmera', id: 'Camera' },
            { propertyName: 'Galeria', id: 'Gallery' },
            { propertyName: 'Câmera/Galeria', id: 'Both' },
        ],

        logicalConditionals: [
            { propertyName: 'Não é igual à', id: 'NotEquals', intId: '1' },
            { propertyName: 'É igual à', id: 'Equals', intId: '0' },
            { propertyName: 'Maior que', id: 'GreaterThan', intId: '2' },
            { propertyName: 'Maior ou igual que', id: 'GreaterOrEqualThan', intId: '3' },
            { propertyName: 'Menor que', id: 'LessThan', intId: '4' },
            { propertyName: 'Menor ou igual que', id: 'LessOrEqualThan', intId: '5' },
            { propertyName: 'Está entre', id: 'Between', intId: '6' }, //em notacao vai virar valor com |
            { propertyName: 'É validado por (apenas expressão regular)', id: 'IsValid', intId: '7' },
            { propertyName: 'Possui quantidade mínima de', id: 'MinLenght', intId: '8' }, //minlenght/maxlenght (em notacao vai virar LessOrEqualThan/GreaterOrEqualThan + exclamação '!')
            { propertyName: 'Possui quantidade máxima de', id: 'MaxLenght', intId: '9' } //minlenght/maxlenght (em notacao vai virar LessOrEqualThan/GreaterOrEqualThan + exclamação '!')
        ],

        conditionTypes: [
            { propertyName: 'Por componente', id: 'ByComponent' }, //@THIS
            { propertyName: 'Por palavra reservada', id: 'ByReservedWord' }, //$TODAY, $WORKDAY, $SATURDAY, $SUNDAY, $NOW
            { propertyName: 'Por valor', id: 'ByValue' }, //texto, numero inteiro, numero decimal, booleano, data, hora,etc
            //{ propertyName: 'Por expressão regular', id: 'ByRegularExpression' }, //#
            { propertyName: 'Por expressão aritmética', id: 'ByExpression' }, //(+, -, *,/)
        ],

        parametersTypes: [
            { propertyName: 'Por componente', id: 'ByComponent' }, //@THIS
            { propertyName: 'Por valor', id: 'ByValue' }, //texto, numero inteiro, numero decimal, booleano, data, hora,etc
        ],

        reserverdWords: [
            { propertyName: 'HOJE', id: '$TODAY' },
            { propertyName: 'DIADESEMANA', id: '$WORKDAY' },
            { propertyName: 'SÁBADO', id: '$SATURDAY' },
            { propertyName: 'DOMINGO', id: '$SUNDAY' },
            { propertyName: 'AGORA', id: '$NOW' },
        ],
        arithmeticOperators: [
            { propertyName: 'mais', id: '+' },
            { propertyName: 'menos', id: '-' },
            { propertyName: 'multiplicado por', id: '*' },
            { propertyName: 'dividido por', id: '/' }
        ],
        submissionCategory: [
            { propertyName: 'Formulário', id: 'X' }
        ],



        tooltips: {
            titulos: 'Rótulo que será exibido para indicar ao usuário o que deve ser informado na questão.',
            permitir_multiplas_linhas: 'Define se o campo deve ou não permitir a quebra de linha.',
            tamanho_maximo: 'Campo numérico para definir a quantidade máxima de caracteres que podem ser digitados no campo.',
            identificador: 'Como o campo será identificado no formulário. Esse campo é obrigatório. Caso seja nulo, será usado o título do formulário.',
            dica_de_texto: 'Texto que aparece no campo enquanto o campo não foi preenchido ainda.',
            resposta_inicial: 'Valor que virá preenchido no campo por padrão. Pode facilitar em caso de ser um campo que raramente vai ter um valor diferente do padrão.',
            obrigatorio: 'Define se o formulário só pode ser enviado com esse campo preenchido.',
            visivel: 'Define quando o campo deve ser exibido ou mostrado no formulário. Você pode configurar para ele aparecer apenas a depender da resposta de outros campos, por exemplo.',
            tipo_data: 'Define se o campo é do tipo data sem dia (mm/yyyy) ou data sem ano (dd/mm).',
            tipo_periodo: 'Define se o campo é do tipo período com faixa para duas datas.',
            somente_leitura: 'Defina se o campo pode ter o valor alterado ou não ou mesmo se ele só pode ser alterado em alguma condição específica. Por exemplo, o campo tem uma resposta inicial definida e se algum outro campo do formulário tiver determinada resposta, este campo é habilitado para edição.',
            editar_propriedades_customizadas: 'Dados genéricos utilizados para diversos fins, como por exemplo "definição de mensagens de sucesso", "e integração".',

            texto_livre_tipo: 'Define o tipo de informação a ser inserida. De acordo com o tipo do campo, o formulário vai criar uma máscara no campo e mudar o teclado exibido no aplicativo de celular para ajudar no preenchimento dos dados.',

            selecao_fonte_dados_externa: 'Você pode utilizar uma fonte externa que contenha as opções para esse campo. O campo será atualizado automaticamente com as opções dessa fonte.',
            selecao_url: 'Endereço a partir do qual são enviadas as opções para esse campo.',
            selecao_login: 'Login para acessar o endereço enviado com as opções do campo.',

            selecao_simples_tipo: 'Selecione se o campo será uma "Lista" de campos onde somente um pode ser selecionado ou uma opção mais simples para marcar apenas "Sim ou não" em uma questão.',

            selecao_multipla: 'Selecione se deverá ser mostrada uma lista com várias opções disponíveis onde se pode escolher mais de uma (Checkbox) ou se essa lista deve ser mostrada como um botão na tela.',
            selecao_multipla_editar_opcoes: 'Altere as opções de resposta para a questão.',

            data_datas: 'O usuário só poderá preencher uma data entre a data inicial e final escolhidas nesses campos',
            hora_horas: 'O usuário só poderá preencher um horário a partir da hora inicial até a hora final.',
            data_hora_inicial: 'O usuário só poderá preencher uma data entre a data inicial e final escolhidas nesses campos.',
            data_hora_final: 'O usuário só poderá preencher como resposta uma data e um horário a partir da data/hora inicial até a data/hora final.',

            inteiro_decimal_intervalo_inicial: 'Valor mínimo a ser preenchido.',
            inteiro_decimal_intervalo_final: 'Valor máximo a ser preenchido.',
            decimal_places: 'A quantidade de casas decimais permitidas pelo componente.',

            localizacao_obter_formulario_aberto: 'Define se a localização será indicada pelo usuário (Manual) ou pelo mobile (Automática).',
            localizacao_permitir_alteracao_manual: 'Habilita a sugestão do endereço como autocomplemento à digitação do usuário.',
            localizacao_usar_mapas: 'Habilita a seleção do endereço utilizando o arrasto no mapa.',

            imagem_quantidade_minima: 'Mínimo de imagens que podem ser enviadas.',
            imagem_quantidade_maxima: 'Máximo de imagens que podem ser enviadas.',
            imagem_origem: 'Escolha se o usuário poderá abrir a câmera do celular para enviar fotos, se deverá enviar fotos da galeria ou se os dois modos serão habilitados.',

            barcode_permitir_alteracao_valor: 'Permite a edição do valor do código de barras identificado.',

            repeticao_minima: 'Quantidade mínima de respostas que devem ser enviadas.',
            repeticao_maxima: 'Quantidade máxima de respostas que devem ser enviadas.',

            revisao_tela: 'Define se o campo será exibido na tela de revisão do formulário',

            editar_opcoes: 'Insira os valores que serão exibidos na seleção.',

            validacao_campo: 'Define as regras de validação do campo.',
            validacao_expressao: 'Expressão que deverá ser utilizada para validação.',
            validacao_mensagem: 'Mensagem de retorno quando a condição da expressão for verdadeira.',
            datetime_today: 'Permitir períodos considerando a data de preenchimento do formulário.',

            datetime_before: 'Variação cronológica inicial do período.',
            datetime_after: 'Variação cronológica final do período.',
            sub_form_review: 'Subformulário específico para revisão de tela antes do envio',
            audio_duracao: 'Duração do arquivo de áudio',
            info_title: 'Adicione informações mais detalhadas sobre o campo.',
            step_title: 'Título destinado para o cabeçalho de etapas dos subformulários.'

        },
        /*Codes below related to RPN*/
        rpnComponents: [
            { immutableTitle: 'Expressão', title: 'Expressão', draggableType: 'rpnItem', type: 'SimpleExpression', dropType: 'item', icon: 'functions', componentIcon: 'functions' },
            { immutableTitle: 'Container', title: 'Container', draggableType: 'rpnContainer', type: 'SubForm', dropType: 'subform', icon: 'web_asset', componentIcon: 'web_asset', structuredRule: [], allowedTypes: ['item', 'repeatGroup', 'subform'] }
        ],

    };

    angular
        .module('app.constants')
        .constant('FORMS', FORMS);

})();

(function () {
  'use strict';

  var COMPANY = {
    companySelected : 'mt-company-selected'
  };

  angular
    .module('app.constants')
    .constant('COMPANY', COMPANY);

})();
(function () {
    'use strict';

    var APPLICATION = {
        companyName: 'MobileCare Manager',
        clientId: 'ngAuthApp',
        notificationAppKey: '???',
        itemsPerPageTables: 10,
        applicationSelected: 'mt-application-selected',
        apps: 'mt-apps',
        messageModalDetailSelected: 'mt-modal-app-message-detail',
        webImgManager: routeWebImg,
        //webApiUri: 'http://localhost:50177/', //Local
        webApiUri: routeWebApi, //Desenvolvimento
        // webApiUri: '', //Homologação
        // webApiUri: '', //Beta
        // webApiUri: '', //Produção
        googleAnalyticsAccountId: '',
        uiKitDatePickerFormat: { format: 'DD/MM/YYYY', i18n: { months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'], weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'] } },
        uiKitDatePickerFormatReports: { format: 'DD-MM-YYYY', i18n: { months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'], weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'] } },
        uiKitDatePickerFormatDateTime: { format: 'DD/MM/YYYY HH:mm', i18n: { months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'], weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'] } },
        status: [
            {
                "id": 0,
                "descricao": "Aberto"
            },
            {
                "id": 1,
                "descricao": "Acatado"
            },
            {
                "id": 2,
                "descricao": "Cancelado"
            }
        ],
        ocurrenceSources: [
            { propertyName: 'Mobile', id: '1' },
            { propertyName: 'Web', id: '2' }
        ],
        statusConta: [
            { propertyName: 'Ativa', id: 'true' },
            { propertyName: 'Inativa', id: 'false' },
            { propertyName: 'Todas', id: ' ' }
        ],
        statusEmailConta: [
            { propertyName: 'Confirmado', id: 'true' },
            { propertyName: 'Não Confirmado', id: 'false' },
            { propertyName: 'Todos', id: ' ' }
        ],
        statusLogico: [
            {
                "id": 0,
                "descricao": "Inativo"
            },
            {
                "id": 1,
                "descricao": "Ativo"
            }
        ],
        statusLogicoAtivo: [
            {
                "id": 1,
                "descricao": "Ativo"
            }
        ],
        statusBooleano: [
            {
                "id": 0,
                "descricao": "Não"
            },
            {
                "id": 1,
                "descricao": "Sim"
            },
            {
                "id": -1,
                "descricao": "Todos"
            }

        ],
        genericStatus: [
            {
                "id": 'true',
                "description": "Ativo"
            },
            {
                "id": 'false',
                "description": "Inativo"
            }
        ],
        genericBool: [
            {
                "id": 'true',
                "description": "Sim"
            },
            {
                "id": 'false',
                "description": "Não"
            }
        ],
        archiveBool: [
            {
                "id": 'true',
                "description": "Não arquivado"
            },
            {
                "id": 'false',
                "description": "Arquivado"
            }
        ],
        messagePriorityLevelsFiltering: [
            {
                "id": 1,
                "description": "Leve"
            },
            {
                "id": 2,
                "description": "Moderado"
            },
            {
                "id": 3,
                "description": "Crítico"
            }
        ],
        messagePriorityLevelsPosting: [
            {
                "id": "Leve",
                "description": "Leve"
            },
            {
                "id": "Moderado",
                "description": "Moderado"
            },
            {
                "id": "Crítico",
                "description": "Crítico"
            }
        ],
        messageStatus: [
            {
                "id": 1,
                "description": "Criada"
            },
            {
                "id": 2,
                "description": "Recebida"
            },
            {
                "id": 3,
                "description": "Lida"
            },
            {
                "id": -1,
                "description": "Todos"
            }
        ],
        achadosRoleStatus: [
            {
                "id": "EAC79140-4D00-49A7-BB5B-7708A87DB86A",
                "description": "Achados Críticos - Perfil Admin"
            },
            {
                "id": "D2F72DB7-81C5-4310-9AEB-C85A9BB88F3D",
                "description": "Achados Críticos - Perfil Básico"
            }
        ],
        requisicoes: [
            {
                "id": 0,
                "descricao": "GET"
            },
            {
                "id": 1,
                "descricao": "POST"
            },
            {
                "id": 2,
                "descricao": "PUT"
            },
            {
                "id": 3,
                "descricao": "DELETE"
            },
            {
                "id": -1,
                "descricao": "Todos"
            }
        ],
        prazos: [
            {
                "id": 0,
                "descricao": "24 horas"
            },
            {
                "id": 1,
                "descricao": "48 horas"
            }

        ],
        plataformas: [
            {
                "id": 2,
                "descricao": "iOS"
            },
            {
                "id": 4,
                "descricao": "Android"
            }

        ],
        sex: [
            {
                "id": "Masculino",
                "descricao": "Masculino",
            },
            {
                "id": "Feminino",
                "descricao": "Feminino"
            }

        ],
        documentTypes: [
            {
                "id": "CPF",
                "descricao": "CPF",
            },
            {
                "id": "Passaporte",
                "descricao": "Passaporte"
            }

        ],
        dataTablesLanguage: {
            "sEmptyTable": "Nenhum registro encontrado",
            "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
            "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
            "sInfoFiltered": "(Filtrados de _MAX_ registros)",
            "sInfoPostFix": "",
            "sInfoThousands": ".",
            "sLengthMenu": "_MENU_ resultados por página",
            "sLoadingRecords": "Carregando...",
            "sProcessing": "Processando...",
            "sZeroRecords": "Nenhum registro encontrado",
            "sSearch": "Pesquisar",
            "oPaginate": {
                "sNext": "Próximo",
                "sPrevious": "Anterior",
                "sFirst": "Primeiro",
                "sLast": "Último"
            },
            "oAria": {
                "sSortAscending": ": Ordenar colunas de forma ascendente",
                "sSortDescending": ": Ordenar colunas de forma descendente"
            }
        },
        modulos: [
            {
                "id": "Relacionamento",
                "name": "Relacionamento"
            },
            {
                "id": "Integracao",
                "name": "Integração"
            },
            {
                "id": "Nps",
                "name": "Pesquisa de Satisfação (NPS)"
            },
            {
                "id": "FormGeral",
                "name": "Formulário Geral"
            }
        ],
        STRING_HASHTAG: '#',
        STRING_SLOW: 'slow',
        STRING_STYLE: 'style',
        STRING_SRV_DIV_RSN_LST: 'divReasonsList',
        STRING_SRV_BTN_MDL_CAT: 'btnCloseModalCategory',
        STRING_SRV_BTN_MDL_SIT_SER: 'btnCloseModalSituationOfService',
        STRING_30_DIAS: ' (30 dias)',
        STRING_ROUTE_SERVICE_LIST: 'private.painel.servico.list',
        STRING_MODAL_CARREGANDO_APPCOMPANYS: '<div class=\'uk-text-center\'>Carregando Endpoints...<br/><img class=\'uk-margin-top\' src=\'assets/img/spinners/spinner.gif\' alt=\'\'>',
        STRING_MODAL_CARREGANDO_CONFIGAPPCOMPANYS: '<div class=\'uk-text-center\'>Carregando configurações do Endpoint...<br/><img class=\'uk-margin-top\' src=\'assets/img/spinners/spinner.gif\' alt=\'\'>',
        STRING_MODAL_CARREGANDO_DASHBOARD: '<div class=\'uk-text-center\'>Carregando Dashboard...<br/><img class=\'uk-margin-top\' src=\'assets/img/spinners/spinner.gif\' alt=\'\'>',
        STRING_MODAL_ATUALIZANDO_DASHBOARD: '<div class=\'uk-text-center\'>Atualizando Dashboard...<br/><img class=\'uk-margin-top\' src=\'assets/img/spinners/spinner.gif\' alt=\'\'>',
        STRING_MSG_PERIODO_PESQUISADO_NAO_PODE_SER_MAIOR_QUE_6_MESES: 'Período pesquisado não pode ser maior que 6 meses.',
        STRING_MSG_DATA_INICIAL_NAO_PODE_SER_MAIOR_QUE_FINAL: 'A data inicial não pode ser maior que a data final.',
        STRING_MSG_DATA_INICIAL_NAO_PODE_SER_MAIOR_QUE_ATUAL: 'A data inicial não pode ser maior que a data atual.',
        STRING_MSG_DATA_FINAL_NAO_PODE_SER_MAIOR_QUE_ATUAL: 'A data final não pode ser maior que a data atual.',
        STRING_TAG_DYNAMIC_FORM: "<body style='font-family:Kyrial Sans Pro; font-size:17px;'>",
        STRING_MSG_DATA_INICIAL_INCORRETA: 'Data inicial incorreta.',
        STRING_MSG_DATA_FINAL_INCORRETA: 'Data final incorreta.',
        STRING_MSG_SEM_CATEGORIA_PAI: 'Sem categoria pai',
        STRING_MSG_INFORME_SITUACAO: 'Informe uma situação.',
        STRING_MSG_INFORME_JUSTIFICATIVA: 'Informe uma justificativa.',
        STRING_MSG_NOTIFICACAO_ENVIADA_COM_SUCESSO: 'Notificação enviada com sucesso.',
        STRING_MSG_SITUACAO_ATUALIZADA_COM_SUCESSO: 'Situação atualizada com sucesso.',
        STRING_MSG_FLUXO_ATENDIMENTO_CADASTRADO_SUCESSO: 'Fluxo de atendimento cadastrado com sucesso.',
        STRING_MSG_FLUXO_ATENDIMENTO_ATUALIZADO_SUCESSO: 'Fluxo de atendimento atualizado com sucesso.',
        STRING_MSG_JUSTIFICATIVAS_ATUALIZADAS_SUCESSO: 'Justificativas atualizadas com sucesso.',
        STRING_MSG_PERMISSOES_ATUALIZADAS_SUCESSO: 'Permissões atualizadas com sucesso.',
        STRING_MSG_SITUACOES_ATUALIZADAS_SUCESSO: 'Situações atualizadas com sucesso.',
        STRING_MSG_SERVICO_CADASTRADO_SUCESSO: 'Serviço cadastrado com sucesso.',
        STRING_MSG_SERVICO_ATUALIZADO_SUCESSO: 'Serviço atualizado com sucesso.',
        STRING_MSG_SERVICO_EXCLUIDO_SUCESSO: 'Serviço excluído com sucesso!',
        STRING_MSG_ATUALIZANDO_DASHBOARD: 'Atualizando dashboard..',
        STRING_MSG_TEMPO_SLA_ALTERADO_COM_SUCESSO: 'Serviço alterado com sucesso.',//'Tempo de SLA alterado com sucesso.',
        STRING_MSG_INFORME_TEMPO_SLA_EM_HORAS: 'Informe o tempo de SLA em horas.',
        STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA: "Nenhuma categoria selecionada.",
        STRING_MSG_CATEGORIA_CADASTRADA: "Categoria cadastrada com sucesso!",
        STRING_MSG_CATEGORIA_ATUALIZADA: "Categoria atualizada com sucesso!",
        STRING_MSG_CATEGORIA_EXCLUIDA: 'Categoria excluída com sucesso!',
        STRING_MSG_SERVICO_COPIADO_SUCESSO: 'Serviço copiado com sucesso!',
        STRING_MSG_SITUACAO_JA_ADICIONADA: 'Situação já foi adicionada.',
        STRING_MSG_SITUACAO_REMOVIDA: 'Situação removida.',
        STRING_MSG_EXISTE_SITUACAO_PADRAO: 'Já existe uma situação padrão definida, deseja substituir?',
        STRING_MSG_SELECIONE_MENSAGEM_PUSH_INBOX: 'Você selecionou <span style="color:red;">Notificar por Push / Notificar Inbox</span> em Comportamento, informe a mensagem a ser enviada.',
        STRING_MSG_INFORME_CAMPOS_OBRIGATORIOS_COMUNICACAO_EXTERNA: 'Informe os campos obrigatórios (<span style="color:red;">*</span>) na comunicação externa por email.',
        STRING_MSG_INFORME_INTEGRACAO_EXTERNA: 'Informe o tipo da integração na comunicação externa.',
        STRING_MSG_NAO_EXISTE_MAPEAMENTO: 'Não existe mapeamento cadastrado.',
        STRING_MSG_DESEJA_EXCLUIR_CATEGORIA: 'Deseja realmente excluir esta categoria "',
        STRING_MSG_DESEJA_EXCLUIR_SERVICO: 'Deseja realmente excluir este serviço "',
        STRING_MSG_DESEJA_EXCLUIR_SITUACAO: 'Deseja realmente excluir esta situação "',
        STRING_CATEGORIAS_RELACIONAMENTO: 'Categorias de Relacionamento',
        STRING_GUID_EMPTY: '00000000-0000-0000-0000-000000000000',
        STRING_CLIENTES_CADASTRADOS: 'Clientes Mobile Cadastrados',
        STRING_CLIENTES_AGUARDANDO_CONFIRMACAO: 'Clientes Mobile Aguardando Confirmação',
        STRING_CLIENTES_CONFIRMADOS: 'Clientes Mobile Confirmados',
        STRING_CLIENTES_ATIVOS: 'Clientes Mobile Ativos',
        STRING_PRE_CADASTRO_30_DIAS: 'Pré Cadastro (30 dias)',
        STRING_REGISTRO_AMOSTRA_30_DIAS: 'Registro de Amostra (30 dias)',
        STRING_REGISTRO_AMOSTRA_SWAB_30_DIAS: 'Registro de Amostra com Swab (30 dias)',
        STRING_SOLICITACAO_KITS_30_DIAS: 'Solicitação de Kits (30 dias)',
        STRING_CAMPO_CATEGORIA_ATIVA: 'categoryIsActive',
        STRING_CAMPO_SALVAR_CATEGORIA: 'btnSaveCategory',
        STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA: 'btnAddCategoryIcon',
        STRING_CAMPO_CATEGORIA_INATIVA: 'inactiveCategory',
        STRING_CAMPO_CATEGORIA_ATIVA_MODAL: 'activeCategory',
        STRING_CAMPO_MODAL_CATEGORIAS: 'modalCategorias',
        STRING_CAMPO_MODAL_ICONES: 'modalIcons',
        STRING_CAMPO_MODAL_ICONES_SERVICE: 'modalIconsService',
        STRING_CAMPO_MODAL_ADD_SITUACAO_SERVICO: 'modalAddSituationOfService',
        STRING_BASE_IMG_AZURE: 'https://mobilecare.blob.core.windows.net/',
        STRING_CAMPO_TAB_SITUACAO_MODAL: 'tabSituationsModal',
        STRING_CAMPO_SERVICE_BOARD: 'scrum_board',
        STRING_CAMPO_MAIN_BOARD: 'main_board',
        STRING_CAMPO_SERVICE_ADD: 'service-add',
        STRING_CAMPO_DIV_ABA1: 'div-aba1',
        STRING_CAMPO_DIV_ABA2: 'div-aba2',
        STRING_CAMPO_DIV_ABA3: 'div-aba3',
        STRING_CAMPO_DIV_ABA4: 'div-aba4',
        STRING_CAMPO_CHK_NAO: 'chkNao',
        STRING_CAMPO_CHK_EMAIL: 'chkEmail',
        STRING_CAMPO_CHK_EXTERNA: 'chkExterna',
        STRING_COLUMN_ORDER: 'attendanceDate',
        STRING_COLUMN_ORDER_ATTENDANCE_DATE: 'attendanceDate',
        STRING_COLUMN_ORDER_SERVICE: 'serviceId',
        STRING_COLUMN_ORDER_PROTOCOL: 'protocol',
        STRING_COLUMN_ORDER_USER: 'userName',
        STRING_FULL_NUMBERS_NO_ELLIPSIS: 'full_numbers_no_ellipses',
        STRING_WITH_DOM_DEFAULT: 'rtip',
        STRING_INIT_COMPLETE: 'initComplete',
        STRING_PATTERN_ONLY_NUMBERS: /^[0-9]*$/,
        STRING_CARREGANDO: 'Carregando...',
        STRING_CADASTRAR: 'Cadastrar...',
        STRING_ARQUIVADO: 'Arquivado',
        STRING_DESCRIPTION: 'description',
        STRING_ZERO_HORA: ' 00:00:00',
        STRING_CANCELED: 'CANCELADA',
        STRING_FINISH: 'FINALIZADA',
        STRING_USER_ID: 'userId',
        STRING_NAME: 'name',
        STRING_DADOS: 'DADOS',
        STRING_SWAB: 'SWAB',
        STRING_DAYS: 'days',
        STRING_SIM: 'SIM',
        STRING_NAO: 'NÃO',
        STRING_SIM_MIN: 'Sim',
        STRING_NAO_MIN: 'Não',
        STRING_IMG: 'IMG',
        STRING_WEB: 'Web',
        STRING_CANVAS: 'canvas',
        STRING_2D: '2d',
        STRING_TAG_HTML: '<html>',
        STRING_TAG_HTML_CLOSE: '</html>',
        STRING_TAG_BODY_CLOSE: '</body>',
        STRING_SPACE: ' ',
        STRING_TAG_ITALIC: '<i>',
        STRING_TAG_ITALIC_CLOSE: '</i>',
        STRING_TAG_BOLD: '<b>',
        STRING_TAG_BOLD_CLOSE: '</b>',
        STRING_EMPTY: '',
        STRING_POINT: '.',
        STRING_ID: 'id',
        STRING_SITUATION_ID: 'situationId',
        STRING_ITENS_CREATE: 'itensCreate',
        STRING_BAR: '/',
        STRING_QUESTION: '"?',
        STRING_HOUR: 'h',
        STRING_300PX: '300px;',
        STRING_500PX: '500px;',
        STRING_NULL: 'null',
        STRING_NUMERO_0: '0',
        STRING_NUMERO_1: '1',
        STRING_NUMERO_2: '2',
        STRING_NUMERO_3: '3',
        STRING_NUMERO_4: '4',
        STRING_NUMERO_5: '5',
        STRING_NUMERO_6: '6',
        STRING_NUMERO_7: '7',
        STRING_NUMERO_8: '8',
        STRING_NUMERO_9: '9',
        STRING_JSON: '.json',
        STRING_JPG: '.jpg',
        STRING_XML: '.xml',
        STRING_DATA_PNG: 'data:image/png;',
        STRING_DATA_JPEG: 'data:image/jpeg;',
        STRING_BASE64: 'base64,',
        INT_ZERO: 0,
        INT_UM: 1,
        INT_DOIS: 2,
        INT_TRES: 3,
        INT_QUATRO: 4,
        INT_CINCO: 5,
        INT_SEIS: 6,
        INT_SETE: 7,
        INT_OITO: 8,
        INT_NOVE: 9,
        INT_DEZ: 10,
        INT_HORA: 3600,
        BOOLEAN_TRUE: true,
        BOOLEAN_FALSE: false,
        NULL: null,
        STRING_TODOS: 'Todos',
        STRING_SELECIONE: 'Selecione',
        STRING_RELACIONAMENTO: 'Relacionamento',
        STRING_CATEGORIAS: 'Categorias',
        COMPANIES_TEMP:
        [
            {
                "id": "82fdc0e7-10ed-4ca3-bc22-67427304e7a0",
                "role": {
                    "company": {
                        "id": "b7c247f6-8a8d-454e-9ca8-f09ae4436dab",
                        "name": "Santa Izabel",
                        "acronym": "HSI",
                        "enable": true
                    },
                    "companyId": "b7c247f6-8a8d-454e-9ca8-f09ae4436dab",
                    "id": "7E9FEDD3-119D-4966-A30F-1919D6BD887F",
                    "name": "Admin"
                }
            },
            {
                "id": "82fdc0e7-10ed-4ca3-bc22-67427304e7a1",
                "role": {
                    "company": {
                        "id": "B7C247F6-8A8D-454E-9CA8-F09AE4436DA1",
                        "name": "Empresa 2",
                        "acronym": "Empresa 2",
                        "enable": true
                    },
                    "companyId": "B7C247F6-8A8D-454E-9CA8-F09AE4436DA1",
                    "id": "7E9FEDD3-119D-4966-A30F-1919D6BD887F",
                    "name": "Admin"
                }
            }
        ],
        statusGender: [
            {
                "id": 0,
                "descricao": "Masculino"
            },
            {
                "id": 1,
                "descricao": "Feminino"
            }
        ],
        statusSla: [
            {
                "id": 0,
                "description": "Dentro da SLA"
            },
            {
                "id": 1,
                "description": "SLA Excedida"
            }
        ],
        tipoMensagem: [
            {
                "id": 0,
                "descricao": "Push"
            },
            {
                "id": 1,
                "descricao": "Inbox"
            }
        ],
        mensagemAcoes: [
            {
                "name": "call",
                "title": "Ligar",
                "path": "",
                "parameters": []
            },
            {
                "name": "email",
                "title": "E-mail",
                "path": "",
                "parameters": []
            },
            {
                "name": "link",
                "title": "Abrir URL",
                "path": "",
                "parameters": []
            }
        ],
        especialidadeMensagens: [
                  {
                     "text": "Alergia e imunologia",
                     "value": "4"
                  },
                  {
                     "text": "Anatomopatologia",
                     "value": "5"
                  },
                  {
                     "text": "Anestesiologia",
                     "value": "6"
                  },
                  {
                     "text": "Angiologia",
                     "value": "7"
                  },
                  {
                     "text": "Broncoscopia",
                     "value": "97"
                  },
                  {
                     "text": "Bucomaxilo",
                     "value": "99"
                  },
                  {
                     "text": "Cardiologia",
                     "value": "9"
                  },
                  {
                     "text": "Cardiologia intervencionista",
                     "value": "98"
                  },
                  {
                     "text": "Cirurgia cabeça e pescoço",
                     "value": "72"
                  },
                  {
                     "text": "Cirurgia cardíaca",
                     "value": "8"
                  },
                  {
                     "text": "Cirurgia cardiovascular",
                     "value": "10"
                  },
                  {
                     "text": "Cirurgia geral",
                     "value": "11"
                  },
                  {
                     "text": "Cirurgia pediátrica",
                     "value": "12"
                  },
                  {
                     "text": "Cirurgia plástica",
                     "value": "13"
                  },
                  {
                     "text": "Cirurgia torácica",
                     "value": "82"
                  },
                  {
                     "text": "Cirurgia vascular",
                     "value": "14"
                  },
                  {
                     "text": "Clínica geral",
                     "value": "15"
                  },
                  {
                     "text": "Dermatologia",
                     "value": "16"
                  },
                  {
                     "text": "Eletrofisiológica",
                     "value": "94"
                  },
                  {
                     "text": "Endocrinologia/metabologia",
                     "value": "19"
                  },
                  {
                     "text": "Endoscopia digestiva",
                     "value": "52"
                  },
                  {
                     "text": "Gastrenterologia",
                     "value": "21"
                  },
                  {
                     "text": "Genética clinica",
                     "value": "61"
                  },
                  {
                     "text": "Geriatria",
                     "value": "44"
                  },
                  {
                     "text": "Ginecologia",
                     "value": "22"
                  },
                  {
                     "text": "Ginecologia/obstetrícia",
                     "value": "73"
                  },
                  {
                     "text": "Hematologia",
                     "value": "23"
                  },
                  {
                     "text": "Hemoterapia",
                     "value": "24"
                  },
                  {
                     "text": "Infectologia",
                     "value": "63"
                  },
                  {
                     "text": "Intensivista",
                     "value": "20"
                  },
                  {
                     "text": "Mastologia",
                     "value": "56"
                  },
                  {
                     "text": "Medicina do trabalho",
                     "value": "50"
                  },
                  {
                     "text": "Medicina geral comunitária",
                     "value": "74"
                  },
                  {
                     "text": "Medicina nuclear",
                     "value": "25"
                  },
                  {
                     "text": "Nefrologia",
                     "value": "26"
                  },
                  {
                     "text": "Neurocirurgia",
                     "value": "27"
                  },
                  {
                     "text": "Neurologia",
                     "value": "28"
                  },
                  {
                     "text": "Neuroradiologia",
                     "value": "0"
                  },
                  {
                     "text": "Nutricionista",
                     "value": "3"
                  },
                  {
                     "text": "Nutrologia",
                     "value": "64"
                  },
                  {
                     "text": "Obstetrícia",
                     "value": "29"
                  },
                  {
                     "text": "Odontologia",
                     "value": "30"
                  },
                  {
                     "text": "Oftalmologia",
                     "value": "31"
                  },
                  {
                     "text": "Oncologia cirúrgica",
                     "value": "18"
                  },
                  {
                     "text": "Oncologia clínica/cancerologia",
                     "value": "32"
                  },
                  {
                     "text": "Oncologia pediátrica",
                     "value": "17"
                  },
                  {
                     "text": "Ortodontia",
                     "value": "87"
                  },
                  {
                     "text": "Ortopedia/traumatologia",
                     "value": "33"
                  },
                  {
                     "text": "Otorrinolaringologia",
                     "value": "34"
                  },
                  {
                     "text": "Patologia clinica",
                     "value": "35"
                  },
                  {
                     "text": "Pediatria",
                     "value": "36"
                  },
                  {
                     "text": "Plantonista",
                     "value": "58"
                  },
                  {
                     "text": "Pneumologia/tisiologia",
                     "value": "37"
                  },
                  {
                     "text": "Proctologia",
                     "value": "38"
                  },
                  {
                     "text": "Psiquiatria",
                     "value": "39"
                  },
                  {
                     "text": "Radiologia",
                     "value": "40"
                  },
                  {
                     "text": "Radiologia intervencionista",
                     "value": "80"
                  },
                  {
                     "text": "Radioterapia",
                     "value": "43"
                  },
                  {
                     "text": "Reumatologia",
                     "value": "41"
                  },
                  {
                     "text": "Urologia",
                     "value": "46"
                  }
               ]
    };

    angular
        .module('app.constants')
        .constant('APPLICATION', APPLICATION);

})();

(function () {
  'use strict';

  angular
    .module('app.configuracao', []);
})();


(function() {
    'use strict';

    /** @ngInject */
    function ConfiguracaoService(Common, RestangularAuth) {

        function get() {
            return RestangularAuth.one('configuracoes').get();
        }

        function post(config) {
            return RestangularAuth.all('configuracoes').post(config);
        }

        return {
            get: get,
            post: post

        };
    }

    angular
        .module('app.configuracao')
        .factory('Configuracao', ConfiguracaoService);

})();
(function() {
    'use strict';

    /** @ngInject */
    function ConfiguracaoController($rootScope, $scope, Configuracao, Common) {
        var vm = this;


        vm.getConfiguracao = function(id) {
            vm.isLoading = true;
            return Configuracao.get().then(function(configuracao) {
                vm.configuracao = configuracao;
                vm.isLoading = false;
                return vm.configuracao;
            });
        };


        vm.submit = function(configuracao) {
            vm.postConfiguracao(configuracao);
        };

        vm.postConfiguracao = function(configuracao) {
            Configuracao.post(configuracao).then(function(result) {
                if (result) {
                    if (result.id) {
                        Common.messageSuccess('Configuração', 'A', 'F');
                    } else {
                        Common.mensagemError(result);
                    }
                }
            });
        };

        vm.init = function() {
            vm.getConfiguracao();

        };

        vm.init();
    }

    angular.module('app.configuracao')
        .controller('ConfiguracaoController', ConfiguracaoController);

})();

(function () {
  'use strict';

  angular
    .module('app.config', []);
})();

(function () {
  'use strict';

  /** @ngInject */
  function configToastr(toastrConfig) {

    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

  }

  angular
    .module('app.config')
    .config(configToastr);

})();

(function () {
    'use strict';

    /** @ngInject */
    function configRestangular(APPLICATION, RestangularProvider) {
        // Obtem o access-token do usuário logado.
        var authorization = localStorage.getItem('mt-access-token') ? 
        'Bearer ' + localStorage.getItem('mt-access-token') : null;

        RestangularProvider.setDefaultHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
        RestangularProvider.setBaseUrl(APPLICATION.webApiUri + 'api/');

        RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response, deferred) {
            var extractedData;

            extractedData = data;

            // .. to look for getList operations
            // if (what === 'chamados' && operation === 'getList') {
            if ((
                what === 'chamados' ||
                what.indexOf('formularios') > -1 ||
                what === 'servicos' ||
                what === 'clientes' ||
                what === 'clientes/resumido' ||
                what === 'motivos' ||
                what === 'usuarios' ||
                what === 'log' ||
                what === 'formularios' ||
                what === 'manager/messenger/api/message' ||
                what === 'manager/forms/category' ||
                what.indexOf('manager/appcompany') > -1
                //what.indexOf('appcompany') > -1
            )
                && operation === 'getList') {
                // .. and handle the data and meta data
                extractedData = data.items ? data.items : data.result ? data.result : data.itens ? data.itens : [];
                extractedData.pages = data.pages;
                extractedData.links = data.links;
                extractedData.totalCount = data.totalCount ? data.totalCount : undefined
                extractedData.continuationToken = data.continuationToken ? data.continuationToken : undefined //especificamente para o log
                // extractedData.meta = data.data.meta;
            }

            if ((what.indexOf('forms') > -1) && operation === 'get') {
                // .. and handle the data and meta data
                extractedData = data.result ? data.result : {};
            }

            return extractedData;
        });

        //  RestangularProvider.setRequestSuffix('.json');
    }

    angular
        .module('app.config')
        .config(configRestangular);

})();

(function() {
    'use strict';

    /** @ngInject */
    function configIdle(IdleProvider, KeepaliveProvider, TitleProvider) {
        IdleProvider.idle(240 * 60); // 4 hours idle (min * 60)
        IdleProvider.timeout(30); // after 30 seconds idle, time the user out
        KeepaliveProvider.interval(5 * 60); // 5 minute keep-alive ping
        TitleProvider.enabled(false); 
        
    }

    angular
        .module('app.config')
        .config(configIdle);

})();

(function () {
    'use strict';

    /** @ngInject */
    function configHttpProvider($httpProvider) {

        $httpProvider.interceptors.push(['$injector', function ($injector) {
            return $injector.get('AuthInterceptor');
        }]);

        $httpProvider.interceptors.push(['$injector', '$q', '$rootScope', 'AUTH_EVENTS', 'Session', function ($injector, $q, $rootScope, AUTH_EVENTS, Session) {

            //Problemas de concorrencia: https://github.com/mgonto/restangular/issues/1032

            var _queue = [];

            /**
             * Executes the top function on the queue (if any).
             */
            function _executeTop() {
                if (_queue.length === 0) {
                    return;
                }
                _queue[0]();
            }


            return {
                /**
                    * Blocks each request on the queue. If the first request, processes immediately.
                    */
                request: function (config) {
                    if (config.url.substring(0, 4) == 'http') {
                        var deferred = $q.defer();
                        _queue.push(function () {
                            deferred.resolve(config);
                        });
                        if (_queue.length === 1) {
                            _executeTop();
                        }
                        return deferred.promise;
                    } else {
                        return config;
                    }
                },
                /**
                 * After each response completes, unblocks the next request.
                 */
                response: function (response) {
                    if (response.config.url.substring(0, 4) == 'http') {
                        _queue.shift();
                        _executeTop();
                    }
                    return response;
                },
                /**
                 * After each response errors, unblocks the next request.
                 */
                requestError: function (rejection) {
                    return $q.reject(rejection);
                },
                responseError: function (rejection) {

                    var Common = $injector.get('Common');
                    var errorTitle, errorMessage;
                    if (rejection.status === -1) {
                        errorTitle = 'Não foi possível conectar com o servidor';
                        errorMessage = 'O servidor encontra-se com problemas de resposta nas requisições. Se o erro persistir, entre em contato com o suporte.'
                        //errorMessage = 'Você não possui rede de dados ativa. Por favor, verifique suas configurações e tente novamente.';

                    } else if (rejection.status === 500) {
                        errorTitle = 'Erro ao processar a requisição';
                        errorMessage = 'Erro ao processar a requisição. Por favor, tente novamente. Se o erro persistir, entre em contato com o suporte.';
                    } else if (rejection.status === 400) {
                        errorTitle = 'Erro ao processar a requisição';
                        errorMessage = 'Erro ao processar a requisição. Por favor, tente novamente. Se o erro persistir, entre em contato com o suporte.';

                        if (rejection.data.message) {
                            errorMessage = rejection.data.message;
                        } else if (rejection.data.error_description) {
                            errorMessage = rejection.data.error_description;
                        } else {
                            errorMessage = "Não foi possível realizar a operação";
                        }

                        if (rejection.config.url.indexOf('/api/mobile/account/auth') > -1) {
                            errorTitle = 'Credenciais inválidas!';
                            errorMessage = 'Credenciais inválidas!';//rejection.data.error_description;
                        }

                    } else if (rejection.status === 401) {
                         if (rejection.data.message) {
                            errorMessage = rejection.data.message;
                        } else if (rejection.data.error_description) {
                            errorMessage = rejection.data.error_description;
                        } else {
                            errorMessage = "Credenciais inválidas ou Usuário inativo";
                        }
                        
                        // var $http = $injector.get('$http');
                        // var Login = $injector.get('Login');
                        // var deferred = $q.defer();
                        // if (Session.getRefreshToken()) {

                        //     Login.refreshToken(Session.getRefreshToken()).then(function (oauth) {
                        //         Session.refresh(oauth.access_token, oauth.refresh_token);

                        //         rejection.config.headers.Authorization = 'Bearer ' + oauth.access_token;

                        //         $http(rejection.config).then(function (response) {
                        //             deferred.resolve(response);
                        //         }, function (response) {
                        //             deferred.reject(response);
                        //         });

                        //     }).catch(function (err) {

                        //         if ($rootScope.modalDashboard != undefined) {
                        //             $rootScope.modalDashboard.hide();
                        //         }

                        //         Session.destroy();
                        //         $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
                        //     });

                        // } else {

                        //     return $q.reject(rejection);

                        // }

                        // return deferred.promise;
                    } else if (rejection.status === 404) {
                        errorTitle = 'Requisição não existe!';
                        errorMessage = 'A requisição não existe. Entre em contato com o suporte.';
                    }
                    else if (rejection.status === 405) {
                        errorTitle = 'Requisição não permitida pelo servidor!';
                        errorMessage = 'A requisição não é permitida pelo servidor.';
                    }
                    else if (rejection.status === 409) {
                        errorTitle = 'Ação não permitida!';
                        errorMessage = rejection.data;
                    }
                    if (errorMessage) {
                        Common.errorMessage(rejection, errorTitle, errorMessage);
                    }

                    if (rejection.config.url.substring(0, 4) == 'http') {
                        _queue.shift();
                        _executeTop();
                    }
                    return $q.reject(rejection);

                    //return $q.reject(rejection);
                }
            };
        }]);

    }

    angular
        .module('app.config')
        .config(configHttpProvider);

})();

(function () {
  'use strict';

  /** @ngInject */
  function configHereMaps(MapConfigProvider) {

      MapConfigProvider.setOptions({
          appId: '6r944Lo5gaLMc2N9XpMC',
          appCode: '_MPD5uhqfdCZwJqpt6ju2g',
          libraries: 'ui,mapevents', //pano
          //pixelRatio: 2, // Optional (Default: 1)
          //pixelPerInch: 320 // Optional (Default: 72)
          useHTTPS: true
      });

  }

  angular
    .module('app.config')
    .config(configHereMaps);

})();

(function () {
  'use strict';

  /** @ngInject */
  function configGoogleAnalytics(AnalyticsProvider, APPLICATION) {

    AnalyticsProvider
      .logAllCalls(true)
      // .startOffline(true)
      .trackPages(false)
      // .trackUrlParams(true)
      // .ignoreFirstPageLoad(true)
      // .setPageEvent('$stateChangeSuccess')
      .setAccount({
        tracker: APPLICATION.googleAnalyticsAccountId,
        trackEvent: true
      });

  }

  angular
    .module('app.config')
    .config(configGoogleAnalytics);

})();

(function () {
  'use strict';

  angular
    .module('app.company', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function CompanyService(Common, RestangularAuth, Session, COMPANY, APPLICATION) {

        function getCompaniesByUser(userKey) {
            return RestangularAuth.all('manager/account/' + userKey + '/role').getList();
        }

        function getCompanyApps(companyKey, associated, image) {            
            return RestangularAuth.all('manager/appcompany/').customGETLIST('simple',{ companyId: companyKey, 
                associated: associated,
                status: [1,2,3], //fixed
                enable: true, //fixed
                image:image
            });
        }

        function getSingleCompanyApp(id) {
            return RestangularAuth.one('manager/appcompany/'+id+'/simple').get();
        }

        function setCompanySelected(company) {
            Session.setObjectLocalStorage(COMPANY.companySelected, company);
        }

        function getCompanySelected() {
            return Session.getCompanyLocalStorage(COMPANY.companySelected);
        }


        return {
            getCompaniesByUser: getCompaniesByUser,
            getCompanyApps: getCompanyApps,
            setCompanySelected: setCompanySelected,
            getCompanySelected: getCompanySelected,
            getSingleCompanyApp: getSingleCompanyApp
        };
    }

    angular
        .module('app.company')
        .factory('Company', CompanyService);

})();
(function () {
  'use strict';

  angular
    .module('app.common', []);
})();

(function () {
    'use strict';

    function CommonService($filter, $log, $q, $timeout, $rootScope, AUTH_EVENTS) {

        var cadastrar = '';
        var atualizar = '';
        var remover = '';
        var enviar = '';
        var desativar = "";
        var ativar = "";
        var copiar = "";
        var confirmar = "";
        var desconfirmar = "";

        function error(argument) {
            switch (argument.status) {
                case 404:
                    UIkit.notify({ message: "<div class='uk-text-center'><span>" + 'A requisição não existe. Entre em contato com o suporte.' + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                    return null;
                case 401:
                    UIkit.notify({ message: "<div class='uk-text-center'><span>" + 'Login e/ou senha inválido(s).' + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                    return null;
                case 405:
                    UIkit.notify({ message: "<div class='uk-text-center'><span>" + 'Requisição não permitida pelo servidor.' + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                    return null;
                default:
                    UIkit.notify({ message: argument.data && argument.data.message ? "<div class='uk-text-center'><span>" + argument.data.message + "</span></div>" : "<div class='uk-text-center'><span>" + 'Verifique sua conexão e tente novamente.' + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
            }
        }

        //Massimo
        function errorMessage(rejection, errorTitle, errorMessage) {
            if (rejection.status === 404) {
                UIkit.notify({ message: rejection.data && rejection.data.Message ? "<div class='uk-text-center'><span>" + rejection.data.Message + "</span></div>" : "<div class='uk-text-center'><span>" + errorMessage + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                return null;
            } if (rejection.status === 401) {
                var flag = false;

                if (rejection && rejection.data && rejection.data.error == 'invalid_grant') {
                    UIkit.notify({ message: "<div class='uk-text-center'><span>" + errorMessage + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                    flag = true;
                }

                if (!flag) {
                    if ($rootScope.lastCodeRequest != rejection.status) {
                        UIkit.notify({ message: "<div class='uk-text-center'><span>Seu acesso expirou. Efetue login novamente.</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                    }

                    $rootScope.lastCodeRequest = rejection.status;    
                }               

                return $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
            } else {
                UIkit.notify({ message: "<div class='uk-text-center'><span>" + errorMessage + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
                return null;
            }
        }

        function mensagemError(mensagem) {
            UIkit.notify({ message: "<div class='uk-text-center'><span>" + mensagem + "</span></div>", status: 'danger', timeout: 3000, pos: 'top-center' });
            return null;
        }

        function mensagemAtention(mensagem) {
            UIkit.notify({ message: "<div class='uk-text-center'><span>" + mensagem + "</span></div>", status: 'warning', timeout: 3000, pos: 'top-center' });
            return null;
        }

        function mensagemSucesso(mensagem) {
            UIkit.notify({ message: "<div class='uk-text-center'><span>" + mensagem + "</span></div>", status: 'success', timeout: 3000, pos: 'top-center' });
            return null;
        }

        function validateRolesRequired(value) {
            return !_.isEmpty(value);
        }

        function retornaMensagemSucess(objeto, operacao, genero) {
            var message = '';
            var msgOperacao = '';

            if (genero === 'M') {
                cadastrar = 'cadastrado';
                atualizar = 'atualizado';
                remover = 'removido';
                enviar = 'enviado';
                desativar = 'desativado';
                ativar = 'ativado';
                copiar = 'copiado';
                confirmar = 'confirmado';
                desconfirmar = 'desconfirmado';
            }
            else {
                cadastrar = 'cadastrada';
                atualizar = 'atualizada';
                remover = 'removida';
                enviar = 'enviada';
                desativar = 'desativada';
                ativar = 'ativada';
                copiar = 'copiada';
                confirmar = 'confirmada';
                desconfirmar = 'desconfirmada';
            }

            if (operacao === 'I') {
                msgOperacao = cadastrar;
            }
            else if (operacao === 'A') {
                msgOperacao = atualizar;
            }
            else if (operacao === 'E') {
                msgOperacao = enviar;
            }
            else if (operacao === 'DA') {
                msgOperacao = desativar;
            }
            else if (operacao === 'AT') {
                msgOperacao = ativar;
            }
            else if (operacao === 'CO') {
                msgOperacao = confirmar;
            }
            else if (operacao === 'DE') {
                msgOperacao = desconfirmar;
            }
            else if (operacao === 'C') {
                msgOperacao = copiar;
            }
            else {
                msgOperacao = remover;
            }
            message = objeto + ' ' + msgOperacao + ' com sucesso.';

            return message;
        }

        function messageSuccess(objeto, operacao, genero) {
            var message;
            if (objeto && operacao && genero) {
                message = retornaMensagemSucess(objeto, operacao, genero);
            } else {
                message = objeto;
            }


            UIkit.notify({ message: "<div class='uk-text-center'><span>" + message + "</span></div>", status: 'success', timeout: 3000, pos: 'top-center' });

        }

        function dynamicSort(property) {
            var sortOrder = 1;
            if (property[0] === '-') {
                sortOrder = -1;
                property = property.substr(1);
            }
            return function (a, b) {
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                return result * sortOrder;
            };
        }

        function sortArrOfObjectsByParam(arrToSort, strObjParamToSortBy, sortAscending) {
            if (arrToSort.length > 0) {
                if (sortAscending === undefined) {
                    sortAscending = true;
                }

                if (sortAscending) {
                    arrToSort.sort(function (a, b) {
                        return a[strObjParamToSortBy].toLowerCase() > b[strObjParamToSortBy].toLowerCase();
                    });
                } else {
                    arrToSort.sort(function (a, b) {
                        return a[strObjParamToSortBy].toLowerCase() < b[strObjParamToSortBy].toLowerCase();
                    });
                }
            }
        }

        function dynamicSortMultiple() {
            /*
             * save the arguments object as it will be overwritten
             * note that arguments object is an array-like object
             * consisting of the names of the properties to sort by
             */
            var props = arguments;
            return function (obj1, obj2) {
                var i = 0, result = 0, numberOfProperties = props.length;
                /* try getting a different result from 0 (equal)
                 * as long as we have extra properties to compare
                 */
                while (result === 0 && i < numberOfProperties) {
                    result = dynamicSort(props[i])(obj1, obj2);
                    i++;
                }
                return result;
            };
        }

        /* calcula a idade considerando os parâmetros
         * 'nascimento' e 'hoje' como objetos Date
         */
        function calculaIdade(nascimento, hoje) {
            return Math.floor(Math.ceil(Math.abs(nascimento.getTime() - hoje.getTime()) / (1000 * 3600 * 24)) / 365.25);
        }

        function formataNumeroTelefone(ddd, numero) {
            var length = numero.length;
            var telefoneFormatado;

            if (length === 8) {
                telefoneFormatado = '(' + ddd + ') ' + numero.substring(0, 4) + '-' + numero.substring(4, 8);
            } else if (length === 9) {
                telefoneFormatado = '(' + ddd + ') ' + numero.substring(0, 5) + '-' + numero.substring(5, 9);
            }
            return telefoneFormatado;
        }

        function sortArrOfObjectsByParam(arrToSort, strObjParamToSortBy, sortAscending) {
            if (sortAscending === undefined) {
                sortAscending = true;  // default to true
            }

            if (sortAscending) {
                arrToSort.sort(function (a, b) {
                    return a[strObjParamToSortBy].toLowerCase() > b[strObjParamToSortBy].toLowerCase();
                });
            }
            else {
                arrToSort.sort(function (a, b) {
                    return a[strObjParamToSortBy].toLowerCase() < b[strObjParamToSortBy].toLowerCase();
                });
            }
        }

        function getQtdsGrid() {
            var num = ['10', '50', '100', '150', '200', '500', '1000', 'Todos'];
            return $q.when(num);
        }

        function getPeriodos() {
            var resultado = [
                { id: 0, descricao: 'Definir período' },
                { id: 1, descricao: 'Última semana' },
                { id: 2, descricao: 'Últimos 15 dias' },
                { id: 3, descricao: 'Último mês' },
                { id: 4, descricao: 'Últimos 3 meses' },
                { id: 5, descricao: 'Últimos 6 meses' }
            ];
            return $q.when(resultado);
        }

        function getDaysMonthNow(month, year) {
            var day = '';
            var days = [];
            if (month != undefined) {
                var data = new Date(year, (month.id), 0);

                day = daysInMonth(data);


                var i = 1;

                while (i <= day) {
                    if (i < 10) {
                        days.push('0' + i);
                    } else {
                        days.push(i.toString());
                    }
                    i++;
                }
            }
            return $q.when(days);
        }

        /*{id: 4, description: 'Último mês'},*/
        function getPeriods() {
            var result = [
                { id: 0, description: 'Definir período' },
                { id: 1, description: 'Últimos 7 dias' },
                { id: 2, description: 'Últimos 14 dias' },
                { id: 3, description: 'Últimos 30 dias' },
                { id: 4, description: 'Mês atual' },
                { id: 5, description: 'Últimos 3 meses' },
                { id: 6, description: 'Últimos 12 meses' },
                { id: 7, description: 'Hoje' },
                { id: 8, description: 'Ontem' },

            ];
            return $q.when(result);
        }

        function daysInMonth(anyDateInMonth) {
            return new Date(anyDateInMonth.getYear(),
                anyDateInMonth.getMonth() + 1,
                0).getDate();
        }

        function validateData(dtInicio, dtFim) {

            if ((dtInicio == undefined) || (dtFim == undefined) || (dtFim == "")) {
                return true;
            } else {
                var dtInicio = new Date($filter('date')(dtInicio, 'dd/MM/yyyy').substring(6, 11),
                    $filter('date')(dtInicio, 'dd/MM/yyyy').substring(3, 5),
                    $filter('date')(dtInicio, 'dd/MM/yyyy').substring(0, 2));

                var dtFim = new Date($filter('date')(dtFim, 'dd/MM/yyyy').substring(6, 11),
                    $filter('date')(dtFim, 'dd/MM/yyyy').substring(3, 5),
                    $filter('date')(dtFim, 'dd/MM/yyyy').substring(0, 2));

                if (dtInicio > dtFim) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        function validateDataMilisecondsActual(dtBase) {

            if ((dtInicio == undefined) || (dtFim == undefined) || (dtFim == "")) {
                return true;
            } else {
                var dtInicio = new Date($filter('date')(dtInicio, 'dd/MM/yyyy').substring(6, 11),
                    $filter('date')(dtInicio, 'dd/MM/yyyy').substring(3, 5),
                    $filter('date')(dtInicio, 'dd/MM/yyyy').substring(0, 2));

                var dtFim = new Date($filter('date')(dtFim, 'dd/MM/yyyy').substring(6, 11),
                    $filter('date')(dtFim, 'dd/MM/yyyy').substring(3, 5),
                    $filter('date')(dtFim, 'dd/MM/yyyy').substring(0, 2));

                if (dtInicio > dtFim) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        function validateRange(initialRange, endRange) {

            if ((initialRange == undefined || initialRange.length == 0) || (endRange == undefined || endRange.length == 0)) {
                return true;
            } else {
                var initialRange = parseFloat(initialRange);
                var endRange = parseFloat(endRange);

                if (initialRange > endRange) {
                    return false;
                } else {
                    return true;
                }
            }
        }

        function generateValidFilter(filters) {
            if ((filters == undefined) && (filters == null) && (filters.length == 0)) {
                return ''
            }
            var url = '?';
            for (var key in filters) {
                if ((filters[key] != undefined) && (filters[key] != null) && (filters[key].length > 0)) {
                    url = url + key + '=' + filters[key] + '&';
                }

            }
            if (url === '?') {
                return '';
            }

            return url.substring(0, url.length - 1);
        }


        function convertToDate(dateField) {
            if ((dateField != undefined) && (dateField != null) && (dateField.length > 0)) {
                return new Date(dateField.substring(6, 11),
                    dateField.substring(3, 5) - 1,
                    dateField.substring(0, 2));
            }

            return;
        }

        function convertToDateTime(dateField, timeField) {
            if ((dateField != undefined) && (dateField != null) && (dateField.length > 0)) {
                var date = new Date(dateField.substring(6, 11),
                    dateField.substring(3, 5) - 1,
                    dateField.substring(0, 2));

                date.setHours(timeField.split(":")[0]);
                date.setMinutes(timeField.split(":")[1]);

                return date.toLocaleString();;
            }

            return;
        }

        function convertToUtcDateString(dateField) {
            if ((dateField != undefined) && (dateField != null) && (dateField.length > 0)) {
                //2016-12-13T00:00:00.000Z
                var stringDate = dateField.substring(6, 11) + '-' + dateField.substring(3, 5) + '-' + dateField.substring(0, 2) + 'T00:00:00.000Z';
                return stringDate;
            }

            return;
        }

        function convertToUtcDateTimeString(dateField, hourField, startOrEnd) {
            if ((dateField != undefined) && (dateField != null) && (dateField.length > 0)) {
                //2016-12-13T00:00:00.000Z
                if (hourField == undefined) {
                    if (startOrEnd == 'start') {
                        hourField = '00:00'
                    }
                    if (startOrEnd == 'end') {
                        hourField = '23:59'
                    }
                }
                var stringDate = dateField.substring(6, 11) + '-' + dateField.substring(3, 5) + '-' + dateField.substring(0, 2) + 'T' + hourField + ':00.000Z';
                return stringDate;
            }

            return;
        }

        function returnRand() {
            var randomization = Math.random().toString();
            var lengthNumbers = randomization.length;
            var sort = randomization.substring(lengthNumbers, lengthNumbers - 1);
            return sort;
        }

        function generatePasswordEasy() {
            var retorno = 'Abc123';
            var letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];

            retorno = letters[returnRand()].toUpperCase() + letters[returnRand()] + letters[returnRand()]
                + returnRand() + returnRand() + returnRand();

            return retorno;
        }

        function generatePassword(len) {
            var pwd = [], cc = String.fromCharCode, R = Math.random, rnd, i;
            pwd.push(cc(48 + (0 | R() * 10))); // push a number
            pwd.push(cc(65 + (0 | R() * 26))); // push an upper case letter

            for (i = 2; i < len; i++) {
                rnd = 0 | R() * 62; // generate upper OR lower OR number
                pwd.push(cc(48 + rnd + (rnd > 9 ? 7 : 0) + (rnd > 35 ? 6 : 0)));
            }

            // shuffle letters in password
            return pwd.sort(function () { return R() - .5; }).join('');
        }

        function formatarCPFExibicaoApenas(v) {
            if (v != undefined) {
                if (v.length <= 14) { //CPF

                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")

                    //Coloca um ponto entre o terceiro e o quarto dígitos
                    //de novo (para o segundo bloco de números)
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")

                    //Coloca um hífen entre o terceiro e o quarto dígitos
                    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2")

                    return v;
                }
            }
        }

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
                s4() + '-' + s4() + s4() + s4();
        }

        function buildRandomArray(length) {
            var arr = [];
            for (var i = 0; i < (length || 10); i++) {
                var fill = [];
                arr.push(guid());
            }
            return arr;
        }


        function concatString(title, entity) {
            if (entity) {
                if (Object.prototype.toString.call(entity) === '[object Array]') {
                    if (entity.length > 0) {
                        return title + entity.filter(function (val) { return val; }).join(', ');
                    }
                    return "";
                } else {
                    return title + entity;
                }
            }
            return "";
        };

        function emailIsValid(email) {
            var regexEmail = new RegExp("[a-zA-Z0-9][a-zA-Z0-9._-]+@([a-zA-Z0-9._-]+.)[a-zA-Z-0-9]{2,3}");
            if (!regexEmail.test(email)) { mensagemError("E-mail inválido."); return false; }
            return true;
        }

        function truncateMiddleString(fullStr, strLen, separator) {
            if (fullStr.length <= strLen) return fullStr;

            separator = separator || '...';

            var sepLen = separator.length,
                charsToShow = strLen - sepLen,
                frontChars = Math.ceil(charsToShow / 2),
                backChars = Math.floor(charsToShow / 2);

            return fullStr.substr(0, frontChars) +
                separator +
                fullStr.substr(fullStr.length - backChars);
        };

        function toDate(date, format) {
            //necessary workaround for  momentjs to work :)   
            /* Situation:
            1. First click on datetime component -  dtInitialRange field format: "28/09/2016 07:00" returned from json
            2. Second click on the same datetime component - dtInitialRange field is now a momentJs date
            3. User reorders list (dragging), then momentJs date reference is lost
            4. Third clicks returns "2016-09-28T07:00:00.000Z". Date.parse check will fix the issue with Invalid Date error
            */
            if (typeof date == 'string') {
                var timestamp = Date.parse(date);
                if (!isNaN(timestamp)) {
                    date = moment.utc(timestamp).format("DD/MM/YYYY hh:mm");
                }
            }
            if (typeof date != 'string') {
                date = date.format("DD/MM/YYYY hh:mm");
            }
            //end of workaround
            var normalized = date.replace(/[^a-zA-Z0-9]/g, '-');
            var normalizedFormat = format.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
            var formatItems = normalizedFormat.split('-');
            var dateItems = normalized.split('-');

            var monthIndex = formatItems.indexOf("mm");
            var dayIndex = formatItems.indexOf("dd");
            var yearIndex = formatItems.indexOf("yyyy");
            var hourIndex = formatItems.indexOf("hh");
            var minutesIndex = formatItems.indexOf("ii");
            var secondsIndex = formatItems.indexOf("ss");

            var today = new Date();

            var year = yearIndex > -1 ? dateItems[yearIndex] : today.getFullYear();
            var month = monthIndex > -1 ? dateItems[monthIndex] - 1 : today.getMonth() - 1;
            var day = dayIndex > -1 ? dateItems[dayIndex] : today.getDate();

            var hour = hourIndex > -1 ? dateItems[hourIndex] : today.getHours();
            var minute = minutesIndex > -1 ? dateItems[minutesIndex] : today.getMinutes();
            var second = secondsIndex > -1 ? dateItems[secondsIndex] : today.getSeconds();

            return new Date(year, month, day, hour, minute, second);
        };

        function checkNested(obj /*, level1, level2, ... levelN*/) {
            var args = Array.prototype.slice.call(arguments, 1);
            debugger;
            for (var i = 0; i < args.length; i++) {
                if (!obj || !obj.hasOwnProperty(args[i])) {
                    return false;
                }
                obj = obj[args[i]];
            }
            return true;
        }

        function compareValues(key, order) {
            return function (a, b) {
                if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                    // property doesn't exist on either object
                    return 0;
                }

                var varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
                var varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

                var comparison = 0;
                if (varA > varB) {
                    comparison = 1;
                } else if (varA < varB) {
                    comparison = -1;
                }
                return order == 'desc' ? comparison * -1 : comparison;
            };
        }

        var service = {
            $q: $q,
            $timeout: $timeout,
            error: error,
            errorMessage: errorMessage,
            validateRolesRequired: validateRolesRequired,
            messageSuccess: messageSuccess,
            dynamicSort: dynamicSort,
            dynamicSortMultiple: dynamicSortMultiple,
            calculaIdade: calculaIdade,
            //jsonPath: jsonPath,
            mensagemError: mensagemError,
            mensagemAtention: mensagemAtention,
            mensagemSucesso: mensagemSucesso,
            formataNumeroTelefone: formataNumeroTelefone,
            sortArrOfObjectsByParam: sortArrOfObjectsByParam,
            getQtdsGrid: getQtdsGrid,
            getPeriodos: getPeriodos,
            getDaysMonthNow: getDaysMonthNow,
            getPeriods: getPeriods,
            daysInMonth: daysInMonth,
            validateData: validateData,
            validateDataMilisecondsActual: validateDataMilisecondsActual,
            validateRange: validateRange,
            generateValidFilter: generateValidFilter,
            convertToDate: convertToDate,
            convertToDateTime: convertToDateTime,
            convertToUtcDateString: convertToUtcDateString,
            convertToUtcDateTimeString: convertToUtcDateTimeString,
            formatarCPFExibicaoApenas: formatarCPFExibicaoApenas,
            guid: guid,
            concatString: concatString,
            emailIsValid: emailIsValid,
            generatePassword: generatePassword,
            generatePasswordEasy: generatePasswordEasy,
            buildRandomArray: buildRandomArray,
            truncateMiddleString: truncateMiddleString,
            toDate: toDate,
            checkNested: checkNested,
            compareValues: compareValues
        };

        return service;
    }

    CommonService.$inject = ['$filter', '$log', '$q', '$timeout', '$rootScope', 'AUTH_EVENTS'];

    angular
        .module('app.common')
        .factory('Common', CommonService);

})();

(function () {
  'use strict';

  angular
    .module('app.category', ['ckeditor']);
})();


(function() {
    'use strict';

    /** @ngInject */
    function CategoryService(Common, RestangularAuth, APPLICATION, Restangular) {

        function get(filters) {
            return RestangularAuth.all("manager/attendance").customGET("category", {PagIsAscending: true});
        }

        function getLeafs(filters) {
            return RestangularAuth.all("manager/attendance/category").customGET("leafs", {PagIsAscending: true});
        }

        function deleteAll(ids) {
            return RestangularAuth.one('manager/attendance/category', ids).remove();
        }

        function deleteById(id) {
            return RestangularAuth.one('manager/attendance/category/'+id).remove();
        }

        function getById(id) {
            return RestangularAuth.one('manager/attendance/category', id).get();
        }

        function postCategory(category) {
            return RestangularAuth.all('manager/attendance/category').post(category);
        }

        function putCategory(category) {
            return RestangularAuth.all('manager/attendance/category/' + category.id).customPUT(category);
        }

        function post(motivo) {
            return RestangularAuth.all('manager/attendance/category').post(motivo);
        }

        function geListMappings() {
            return RestangularAuth.one('manager/integration/mapping/attendance').get();
        }

        function getServiceById(id) {
            return RestangularAuth.one('manager/attendance/service', id).get();
        }

        function getArchiveStatus() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.archiveBool);
            return deferred.promise;
        }

        function iconsListMobileCare() {
            var iconsCategory = [];
            
            iconsCategory.push({ id: '&#xe9da' });
            iconsCategory.push({ id: '&#xe98a' });
            iconsCategory.push({ id: '&#xe91b' });
            iconsCategory.push({ id: '&#xe922' });
            iconsCategory.push({ id: '&#xe972' });
            iconsCategory.push({ id: '&#xe98b' });
            iconsCategory.push({ id: '&#xe98c' });
            iconsCategory.push({ id: '&#xe98d' });
            iconsCategory.push({ id: '&#xe98e' });
            iconsCategory.push({ id: '&#xe98f' });
            iconsCategory.push({ id: '&#xe990' });
            iconsCategory.push({ id: '&#xe991' });
            iconsCategory.push({ id: '&#xe992' });
            iconsCategory.push({ id: '&#xe90f' });
            iconsCategory.push({ id: '&#xe993' });
            iconsCategory.push({ id: '&#xe980' });
            iconsCategory.push({ id: '&#xe994' });
            iconsCategory.push({ id: '&#xe981' });
            iconsCategory.push({ id: '&#xe097' });
            iconsCategory.push({ id: '&#xe996' });
            iconsCategory.push({ id: '&#xe997' });
            iconsCategory.push({ id: '&#xe096' });
            iconsCategory.push({ id: '&#xe999' });
            iconsCategory.push({ id: '&#xe99a' });
            iconsCategory.push({ id: '&#xe96d' });
            iconsCategory.push({ id: '&#xe107' });
            iconsCategory.push({ id: '&#xe99c' });
            iconsCategory.push({ id: '&#xe99b' });
            iconsCategory.push({ id: '&#xe99d' });
            iconsCategory.push({ id: '&#xe99f' });
            iconsCategory.push({ id: '&#xe99e' });
            iconsCategory.push({ id: '&#xe92d' });
            iconsCategory.push({ id: '&#xe92f' });
            iconsCategory.push({ id: '&#xe9a0' });
            iconsCategory.push({ id: '&#xe9a1' });
            iconsCategory.push({ id: '&#xe9a2' });
            iconsCategory.push({ id: '&#xe9a3' });
            iconsCategory.push({ id: '&#xe983' });
            iconsCategory.push({ id: '&#xe9a4' });
            iconsCategory.push({ id: '&#xe930' });
            iconsCategory.push({ id: '&#xe97c' });
            iconsCategory.push({ id: '&#xe910' });
            iconsCategory.push({ id: '&#xe911' });
            iconsCategory.push({ id: '&#xe912' });
            iconsCategory.push({ id: '&#xe9a5' });
            iconsCategory.push({ id: '&#xe9a6' });
            iconsCategory.push({ id: '&#xe97b' });
            iconsCategory.push({ id: '&#xe97b' });
            iconsCategory.push({ id: '&#xe9a9' });
            iconsCategory.push({ id: '&#xe9a7' });
            iconsCategory.push({ id: '&#xe9a8' });
            iconsCategory.push({ id: '&#xe901' });
            iconsCategory.push({ id: '&#xe116' });
            iconsCategory.push({ id: '&#xe9aa' });
            iconsCategory.push({ id: '&#xe9ab' });
            iconsCategory.push({ id: '&#xe9ac' });
            iconsCategory.push({ id: '&#xe945' });
            iconsCategory.push({ id: '&#xe946' });
            iconsCategory.push({ id: '&#xe947' });
            iconsCategory.push({ id: '&#xe948' });
            iconsCategory.push({ id: '&#xe9ad' });
            iconsCategory.push({ id: '&#xe9ae' });
            iconsCategory.push({ id: '&#xe9af' });
            iconsCategory.push({ id: '&#xe042' });
            iconsCategory.push({ id: '&#xe929' });
            iconsCategory.push({ id: '&#xe043' });
            iconsCategory.push({ id: '&#xe92a' });
            iconsCategory.push({ id: '&#xe92c' });
            iconsCategory.push({ id: '&#xe041' });
            iconsCategory.push({ id: '&#xe92e' });
            iconsCategory.push({ id: '&#xe040' });
            iconsCategory.push({ id: '&#xe92b' });
            iconsCategory.push({ id: '&#xe94a' });
            iconsCategory.push({ id: '&#xe94b' });
            iconsCategory.push({ id: '&#xe9b0' });
            iconsCategory.push({ id: '&#xe9b1' });
            iconsCategory.push({ id: '&#xe9b3' });
            iconsCategory.push({ id: '&#xe9b2' });
            iconsCategory.push({ id: '&#xe9b5' });
            iconsCategory.push({ id: '&#xe9b6' });
            iconsCategory.push({ id: '&#xe9b7' });
            iconsCategory.push({ id: '&#xe96b' });
            iconsCategory.push({ id: '&#xe932' });
            iconsCategory.push({ id: '&#xe933' });
            iconsCategory.push({ id: '&#xe913' });
            iconsCategory.push({ id: '&#xe111' });
            iconsCategory.push({ id: '&#xe90e' });
            iconsCategory.push({ id: '&#xe979' });
            iconsCategory.push({ id: '&#xe9b8' });
            iconsCategory.push({ id: '&#xe117' });
            iconsCategory.push({ id: '&#xe9b9' });
            iconsCategory.push({ id: '&#xe9ba' });
            iconsCategory.push({ id: '&#xe95b' });
            iconsCategory.push({ id: '&#xe954' });
            iconsCategory.push({ id: '&#xe955' });
            iconsCategory.push({ id: '&#xe956' });
            iconsCategory.push({ id: '&#xe957' });
            iconsCategory.push({ id: '&#xe958' });
            iconsCategory.push({ id: '&#xe959' });
            iconsCategory.push({ id: '&#xe9bb' });
            iconsCategory.push({ id: '&#xe967' });
            iconsCategory.push({ id: '&#xe926' });
            iconsCategory.push({ id: '&#xe927' });
            iconsCategory.push({ id: '&#xe9bd' });
            iconsCategory.push({ id: '&#xe9bc' });
            iconsCategory.push({ id: '&#xe9be' });
            iconsCategory.push({ id: '&#xe934' });
            iconsCategory.push({ id: '&#xe9bf' });
            iconsCategory.push({ id: '&#xe935' });
            iconsCategory.push({ id: '&#xe914' });
            iconsCategory.push({ id: '&#xe915' });
            iconsCategory.push({ id: '&#xe971' });
            iconsCategory.push({ id: '&#xe110' });
            iconsCategory.push({ id: '&#xe9c0' });
            iconsCategory.push({ id: '&#xe982' });
            iconsCategory.push({ id: '&#xe9c4' });
            iconsCategory.push({ id: '&#xe9c5' });
            iconsCategory.push({ id: '&#xe995' });
            iconsCategory.push({ id: '&#xe96c' });
            iconsCategory.push({ id: '&#xe975' });
            iconsCategory.push({ id: '&#xe9c6' });
            iconsCategory.push({ id: '&#xe9c7' });
            iconsCategory.push({ id: '&#xe9c8' });
            iconsCategory.push({ id: '&#xe9c9' });
            iconsCategory.push({ id: '&#xe917' });
            iconsCategory.push({ id: '&#xe900' });
            iconsCategory.push({ id: '&#xe94c' });
            iconsCategory.push({ id: '&#xe918' });
            iconsCategory.push({ id: '&#xe9ca' });
            iconsCategory.push({ id: '&#xe919' });
            iconsCategory.push({ id: '&#xe9cb' });
            iconsCategory.push({ id: '&#xe91a' });
            iconsCategory.push({ id: '&#xe9e6' });
            iconsCategory.push({ id: '&#xe9f8' });
            iconsCategory.push({ id: '&#xea0b' });
            iconsCategory.push({ id: '&#xe9cc' });
            iconsCategory.push({ id: '&#xe9cd' });
            iconsCategory.push({ id: '&#xe9ce' });
            iconsCategory.push({ id: '&#xe9cf' });
            iconsCategory.push({ id: '&#xe91c' });
            iconsCategory.push({ id: '&#xe91d' });
            iconsCategory.push({ id: '&#xe90c' });
            iconsCategory.push({ id: '&#xe962' });
            iconsCategory.push({ id: '&#xe966' });
            iconsCategory.push({ id: '&#xe9d0' });
            iconsCategory.push({ id: '&#xe122' });
            iconsCategory.push({ id: '&#xe9d1' });
            iconsCategory.push({ id: '&#xe9d2' });
            iconsCategory.push({ id: '&#xe9d3' });
            iconsCategory.push({ id: '&#xe976' });
            iconsCategory.push({ id: '&#xe90d' });
            iconsCategory.push({ id: '&#xe95c' });
            iconsCategory.push({ id: '&#xe95d' });
            iconsCategory.push({ id: '&#xe9d4' });
            iconsCategory.push({ id: '&#xe9d5' });
            iconsCategory.push({ id: '&#xe9d6' });
            iconsCategory.push({ id: '&#xe005' });
            iconsCategory.push({ id: '&#xe984' });
            iconsCategory.push({ id: '&#xe908' });
            iconsCategory.push({ id: '&#xe936' });
            iconsCategory.push({ id: '&#xe937' });
            iconsCategory.push({ id: '&#xe9d7' });
            iconsCategory.push({ id: '&#xe938' });
            iconsCategory.push({ id: '&#xe939' });
            iconsCategory.push({ id: '&#xe909' });
            iconsCategory.push({ id: '&#xe9d8' });
            iconsCategory.push({ id: '&#xe071' });
            iconsCategory.push({ id: '&#xe9d9' });
            iconsCategory.push({ id: '&#xe93a' });
            iconsCategory.push({ id: '&#xe93b' });
            iconsCategory.push({ id: '&#xe96f' });
            iconsCategory.push({ id: '&#xe9dc' });
            iconsCategory.push({ id: '&#xe9db' });
            iconsCategory.push({ id: '&#xe93d' });
            iconsCategory.push({ id: '&#xe998' });
            iconsCategory.push({ id: '&#xe112' });
            iconsCategory.push({ id: '&#xe9dd' });
            iconsCategory.push({ id: '&#xe9de' });
            iconsCategory.push({ id: '&#xe9c1' });
            iconsCategory.push({ id: '&#xe973' });
            iconsCategory.push({ id: '&#xe90a' });
            iconsCategory.push({ id: '&#xe90b' });
            iconsCategory.push({ id: '&#xe974' });
            iconsCategory.push({ id: '&#xe9df' });
            iconsCategory.push({ id: '&#xe9e1' });
            iconsCategory.push({ id: '&#xe9e0' });
            iconsCategory.push({ id: '&#xe048' });
            iconsCategory.push({ id: '&#xe94d' });
            iconsCategory.push({ id: '&#xe113' });
            iconsCategory.push({ id: '&#xe9e2' });
            iconsCategory.push({ id: '&#xe9e3' });
            iconsCategory.push({ id: '&#xe115' });
            iconsCategory.push({ id: '&#xe9e4' });
            iconsCategory.push({ id: '&#xe9e5' });
            iconsCategory.push({ id: '&#xe93c' });
            iconsCategory.push({ id: '&#xe95a' });
            iconsCategory.push({ id: '&#xe9e7' });
            iconsCategory.push({ id: '&#xe9e8' });
            iconsCategory.push({ id: '&#xe9e9' });
            iconsCategory.push({ id: '&#xe9ea' });
            iconsCategory.push({ id: '&#xe9eb' });
            iconsCategory.push({ id: '&#xe91e' });
            iconsCategory.push({ id: '&#xe91f' });
            iconsCategory.push({ id: '&#xe9ec' });
            iconsCategory.push({ id: '&#xe9c2' });
            iconsCategory.push({ id: '&#xe9ed' });
            iconsCategory.push({ id: '&#xe9c3' });
            iconsCategory.push({ id: '&#xe128' });
            iconsCategory.push({ id: '&#xe123' });
            iconsCategory.push({ id: '&#xe034' });
            iconsCategory.push({ id: '&#xe001' });
            iconsCategory.push({ id: '&#xe9ee' });
            iconsCategory.push({ id: '&#xe970' });
            iconsCategory.push({ id: '&#xe9f5' });
            iconsCategory.push({ id: '&#xe9ef' });
            iconsCategory.push({ id: '&#xe9f0' });
            iconsCategory.push({ id: '&#xe9f1' });
            iconsCategory.push({ id: '&#xe9f2' });
            iconsCategory.push({ id: '&#xe9f3' });
            iconsCategory.push({ id: '&#xe9f4' });
            iconsCategory.push({ id: '&#xe93e' });
            iconsCategory.push({ id: '&#xe949' });
            iconsCategory.push({ id: '&#xe9f6' });
            iconsCategory.push({ id: '&#xe9f7' });
            iconsCategory.push({ id: '&#xe9f9' });
            iconsCategory.push({ id: '&#xe9fa' });
            iconsCategory.push({ id: '&#xe9fb' });
            iconsCategory.push({ id: '&#xe9fc' });
            iconsCategory.push({ id: '&#xe964' });
            iconsCategory.push({ id: '&#xe9fd' });
            iconsCategory.push({ id: '&#xe96a' });
            iconsCategory.push({ id: '&#xe969' });
            iconsCategory.push({ id: '&#xe9fe' });
            iconsCategory.push({ id: '&#xe97a' });
            iconsCategory.push({ id: '&#xe968' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe977' });
            iconsCategory.push({ id: '&#xe9ff' });
            iconsCategory.push({ id: '&#xea00' });
            iconsCategory.push({ id: '&#xe95f' });
            iconsCategory.push({ id: '&#xe907' });
            iconsCategory.push({ id: '&#xe902' });
            iconsCategory.push({ id: '&#xe903' });
            iconsCategory.push({ id: '&#xe904' });
            iconsCategory.push({ id: '&#xe961' });
            iconsCategory.push({ id: '&#xea01' });
            iconsCategory.push({ id: '&#xea02' });
            iconsCategory.push({ id: '&#xea03' });
            iconsCategory.push({ id: '&#xea0c' });
            iconsCategory.push({ id: '&#xe916' });
            iconsCategory.push({ id: '&#xea04' });
            iconsCategory.push({ id: '&#xea05' });
            iconsCategory.push({ id: '&#xe93f' });
            iconsCategory.push({ id: '&#xe94e' });
            iconsCategory.push({ id: '&#xe905' });
            iconsCategory.push({ id: '&#xea06' });
            iconsCategory.push({ id: '&#xea1a' });
            iconsCategory.push({ id: '&#xe057' });
            iconsCategory.push({ id: '&#xea07' });
            iconsCategory.push({ id: '&#xe96e' });
            iconsCategory.push({ id: '&#xea08' });
            iconsCategory.push({ id: '&#xea09' });
            iconsCategory.push({ id: '&#xe985' });
            iconsCategory.push({ id: '&#xe986' });
            iconsCategory.push({ id: '&#xea0a' });
            iconsCategory.push({ id: '&#xe97d' });
            iconsCategory.push({ id: '&#xe97e' });
            iconsCategory.push({ id: '&#xe97f' });
            iconsCategory.push({ id: '&#xe076' });
            iconsCategory.push({ id: '&#xe046' });
            iconsCategory.push({ id: '&#xe94f' });
            iconsCategory.push({ id: '&#xe047' });
            iconsCategory.push({ id: '&#xe045' });
            iconsCategory.push({ id: '&#xe951' });
            iconsCategory.push({ id: '&#xe044' });
            iconsCategory.push({ id: '&#xe952' });
            iconsCategory.push({ id: '&#xe940' });
            iconsCategory.push({ id: '&#xe941' });
            iconsCategory.push({ id: '&#xea0d' });
            iconsCategory.push({ id: '&#xea0e' });
            iconsCategory.push({ id: '&#xea0f' });
            iconsCategory.push({ id: '&#xea2b' });
            iconsCategory.push({ id: '&#xe942' });
            iconsCategory.push({ id: '&#xe943' });
            iconsCategory.push({ id: '&#xea10' });
            iconsCategory.push({ id: '&#xea11' });
            iconsCategory.push({ id: '&#xe965' });
            iconsCategory.push({ id: '&#xea12' });
            iconsCategory.push({ id: '&#xea13' });
            iconsCategory.push({ id: '&#xea14' });
            iconsCategory.push({ id: '&#xe950' });
            iconsCategory.push({ id: '&#xea15' });
            iconsCategory.push({ id: '&#xea16' });
            iconsCategory.push({ id: '&#xe944' });
            iconsCategory.push({ id: '&#xea18' });
            iconsCategory.push({ id: '&#xea17' });
            iconsCategory.push({ id: '&#xea19' });
            iconsCategory.push({ id: '&#xe987' });
            iconsCategory.push({ id: '&#xea1b' });
            iconsCategory.push({ id: '&#xe906' });
            iconsCategory.push({ id: '&#xea1c' });
            iconsCategory.push({ id: '&#xea1e' });
            iconsCategory.push({ id: '&#xea1d' });
            iconsCategory.push({ id: '&#xea21' });
            iconsCategory.push({ id: '&#xea1f' });
            iconsCategory.push({ id: '&#xea20' });
            iconsCategory.push({ id: '&#xe921' });
            iconsCategory.push({ id: '&#xe920' });
            iconsCategory.push({ id: '&#xe95e' });
            iconsCategory.push({ id: '&#xe953' });
            iconsCategory.push({ id: '&#xea23' });
            iconsCategory.push({ id: '&#xea22' });
            iconsCategory.push({ id: '&#xe924' });
            iconsCategory.push({ id: '&#xe923' });
            iconsCategory.push({ id: '&#xe925' });
            iconsCategory.push({ id: '&#xe928' });
            iconsCategory.push({ id: '&#xe960' });
            iconsCategory.push({ id: '&#xe963' });
            iconsCategory.push({ id: '&#xea24' });
            iconsCategory.push({ id: '&#xe988' });
            iconsCategory.push({ id: '&#xea25' });
            iconsCategory.push({ id: '&#xea26' });
            iconsCategory.push({ id: '&#xea29' });
            iconsCategory.push({ id: '&#xea27' });
            iconsCategory.push({ id: '&#xea28' });
            iconsCategory.push({ id: '&#xe989' });
            iconsCategory.push({ id: '&#xea2a' });
            iconsCategory.push({ id: '&#xe037' });
            iconsCategory.push({ id: '&#xe038' });

            return iconsCategory;
        }

        function iconsList() {
            var iconsCategory = [];
            var iconsCategoryCode = [];

            iconsCategory.push({ description : '3d_rotation &#xe84d'});
            iconsCategory.push({ description : 'ac_unit &#xeb3b'});
            iconsCategory.push({ description : 'access_alarm &#xe190'});
            iconsCategory.push({ description : 'access_alarms &#xe191'});
            iconsCategory.push({ description : 'access_time &#xe192'});
            iconsCategory.push({ description : 'accessibility &#xe84e'});
            iconsCategory.push({ description : 'accessible &#xe914'});
            iconsCategory.push({ description : 'account_balance &#xe84f'});
            iconsCategory.push({ description : 'account_balance_wallet &#xe850'});
            iconsCategory.push({ description : 'account_box &#xe851'});
            iconsCategory.push({ description : 'account_circle &#xe853'});
            iconsCategory.push({ description : 'adb &#xe60e'});
            iconsCategory.push({ description : 'add &#xe145'});
            iconsCategory.push({ description : 'add_a_photo &#xe439'});
            iconsCategory.push({ description : 'add_alarm &#xe193'});
            iconsCategory.push({ description : 'add_alert &#xe003'});
            iconsCategory.push({ description : 'add_box &#xe146'});
            iconsCategory.push({ description : 'add_circle &#xe147'});
            iconsCategory.push({ description : 'add_circle_outline &#xe148'});
            iconsCategory.push({ description : 'add_location &#xe567'});
            iconsCategory.push({ description : 'add_shopping_cart &#xe854'});
            iconsCategory.push({ description : 'add_to_photos &#xe39d'});
            iconsCategory.push({ description : 'add_to_queue &#xe05c'});
            iconsCategory.push({ description : 'adjust &#xe39e'});
            iconsCategory.push({ description : 'airline_seat_flat &#xe630'});
            iconsCategory.push({ description : 'airline_seat_flat_angled &#xe631'});
            iconsCategory.push({ description : 'airline_seat_individual_suite &#xe632'});
            iconsCategory.push({ description : 'airline_seat_legroom_extra &#xe633'});
            iconsCategory.push({ description : 'airline_seat_legroom_normal &#xe634'});
            iconsCategory.push({ description : 'airline_seat_legroom_reduced &#xe635'});
            iconsCategory.push({ description : 'airline_seat_recline_extra &#xe636'});
            iconsCategory.push({ description : 'airline_seat_recline_normal &#xe637'});
            iconsCategory.push({ description : 'airplanemode_active &#xe195'});
            iconsCategory.push({ description : 'airplanemode_inactive &#xe194'});
            iconsCategory.push({ description : 'airplay &#xe055'});
            iconsCategory.push({ description : 'airport_shuttle &#xeb3c'});
            iconsCategory.push({ description : 'alarm &#xe855'});
            iconsCategory.push({ description : 'alarm_add &#xe856'});
            iconsCategory.push({ description : 'alarm_off &#xe857'});
            iconsCategory.push({ description : 'alarm_on &#xe858'});
            iconsCategory.push({ description : 'album &#xe019'});
            iconsCategory.push({ description : 'all_inclusive &#xeb3d'});
            iconsCategory.push({ description : 'all_out &#xe90b'});
            iconsCategory.push({ description : 'android &#xe859'});
            iconsCategory.push({ description : 'announcement &#xe85a'});
            iconsCategory.push({ description : 'apps &#xe5c3'});
            iconsCategory.push({ description : 'archive &#xe149'});
            iconsCategory.push({ description : 'arrow_back &#xe5c4'});
            iconsCategory.push({ description : 'arrow_downward &#xe5db'});
            iconsCategory.push({ description : 'arrow_drop_down &#xe5c5'});
            iconsCategory.push({ description : 'arrow_drop_down_circle &#xe5c6'});
            iconsCategory.push({ description : 'arrow_drop_up &#xe5c7'});
            iconsCategory.push({ description : 'arrow_forward &#xe5c8'});
            iconsCategory.push({ description : 'arrow_upward &#xe5d8'});
            iconsCategory.push({ description : 'art_track &#xe060'});
            iconsCategory.push({ description : 'aspect_ratio &#xe85b'});
            iconsCategory.push({ description : 'assessment &#xe85c'});
            iconsCategory.push({ description : 'assignment &#xe85d'});
            iconsCategory.push({ description : 'assignment_ind &#xe85e'});
            iconsCategory.push({ description : 'assignment_late &#xe85f'});
            iconsCategory.push({ description : 'assignment_return &#xe860'});
            iconsCategory.push({ description : 'assignment_returned &#xe861'});
            iconsCategory.push({ description : 'assignment_turned_in &#xe862'});
            iconsCategory.push({ description : 'assistant &#xe39f'});
            iconsCategory.push({ description : 'assistant_photo &#xe3a0'});
            iconsCategory.push({ description : 'attach_file &#xe226'});
            iconsCategory.push({ description : 'attach_money &#xe227'});
            iconsCategory.push({ description : 'attachment &#xe2bc'});
            iconsCategory.push({ description : 'audiotrack &#xe3a1'});
            iconsCategory.push({ description : 'autorenew &#xe863'});
            iconsCategory.push({ description : 'av_timer &#xe01b'});
            iconsCategory.push({ description : 'backspace &#xe14a'});
            iconsCategory.push({ description : 'backup &#xe864'});
            iconsCategory.push({ description : 'battery_alert &#xe19c'});
            iconsCategory.push({ description : 'battery_charging_full &#xe1a3'});
            iconsCategory.push({ description : 'battery_full &#xe1a4'});
            iconsCategory.push({ description : 'battery_std &#xe1a5'});
            iconsCategory.push({ description : 'battery_unknown &#xe1a6'});
            iconsCategory.push({ description : 'beach_access &#xeb3e'});
            iconsCategory.push({ description : 'beenhere &#xe52d'});
            iconsCategory.push({ description : 'block &#xe14b'});
            iconsCategory.push({ description : 'bluetooth &#xe1a7'});
            iconsCategory.push({ description : 'bluetooth_audio &#xe60f'});
            iconsCategory.push({ description : 'bluetooth_connected &#xe1a8'});
            iconsCategory.push({ description : 'bluetooth_disabled &#xe1a9'});
            iconsCategory.push({ description : 'bluetooth_searching &#xe1aa'});
            iconsCategory.push({ description : 'blur_circular &#xe3a2'});
            iconsCategory.push({ description : 'blur_linear &#xe3a3'});
            iconsCategory.push({ description : 'blur_off &#xe3a4'});
            iconsCategory.push({ description : 'blur_on &#xe3a5'});
            iconsCategory.push({ description : 'book &#xe865'});
            iconsCategory.push({ description : 'bookmark &#xe866'});
            iconsCategory.push({ description : 'bookmark_border &#xe867'});
            iconsCategory.push({ description : 'border_all &#xe228'});
            iconsCategory.push({ description : 'border_bottom &#xe229'});
            iconsCategory.push({ description : 'border_clear &#xe22a'});
            iconsCategory.push({ description : 'border_color &#xe22b'});
            iconsCategory.push({ description : 'border_horizontal &#xe22c'});
            iconsCategory.push({ description : 'border_inner &#xe22d'});
            iconsCategory.push({ description : 'border_left &#xe22e'});
            iconsCategory.push({ description : 'border_outer &#xe22f'});
            iconsCategory.push({ description : 'border_right &#xe230'});
            iconsCategory.push({ description : 'border_style &#xe231'});
            iconsCategory.push({ description : 'border_top &#xe232'});
            iconsCategory.push({ description : 'border_vertical &#xe233'});
            iconsCategory.push({ description : 'branding_watermark &#xe06b'});
            iconsCategory.push({ description : 'brightness_1 &#xe3a6'});
            iconsCategory.push({ description : 'brightness_2 &#xe3a7'});
            iconsCategory.push({ description : 'brightness_3 &#xe3a8'});
            iconsCategory.push({ description : 'brightness_4 &#xe3a9'});
            iconsCategory.push({ description : 'brightness_5 &#xe3aa'});
            iconsCategory.push({ description : 'brightness_6 &#xe3ab'});
            iconsCategory.push({ description : 'brightness_7 &#xe3ac'});
            iconsCategory.push({ description : 'brightness_auto &#xe1ab'});
            iconsCategory.push({ description : 'brightness_high &#xe1ac'});
            iconsCategory.push({ description : 'brightness_low &#xe1ad'});
            iconsCategory.push({ description : 'brightness_medium &#xe1ae'});
            iconsCategory.push({ description : 'broken_image &#xe3ad'});
            iconsCategory.push({ description : 'brush &#xe3ae'});
            iconsCategory.push({ description : 'bubble_chart &#xe6dd'});
            iconsCategory.push({ description : 'bug_report &#xe868'});
            iconsCategory.push({ description : 'build &#xe869'});
            iconsCategory.push({ description : 'burst_mode &#xe43c'});
            iconsCategory.push({ description : 'business &#xe0af'});
            iconsCategory.push({ description : 'business_center &#xeb3f'});
            iconsCategory.push({ description : 'cached &#xe86a'});
            iconsCategory.push({ description : 'cake &#xe7e9'});
            iconsCategory.push({ description : 'call &#xe0b0'});
            iconsCategory.push({ description : 'call_end &#xe0b1'});
            iconsCategory.push({ description : 'call_made &#xe0b2'});
            iconsCategory.push({ description : 'call_merge &#xe0b3'});
            iconsCategory.push({ description : 'call_missed &#xe0b4'});
            iconsCategory.push({ description : 'call_missed_outgoing &#xe0e4'});
            iconsCategory.push({ description : 'call_received &#xe0b5'});
            iconsCategory.push({ description : 'call_split &#xe0b6'});
            iconsCategory.push({ description : 'call_to_action &#xe06c'});
            iconsCategory.push({ description : 'camera &#xe3af'});
            iconsCategory.push({ description : 'camera_alt &#xe3b0'});
            iconsCategory.push({ description : 'camera_enhance &#xe8fc'});
            iconsCategory.push({ description : 'camera_front &#xe3b1'});
            iconsCategory.push({ description : 'camera_rear &#xe3b2'});
            iconsCategory.push({ description : 'camera_roll &#xe3b3'});
            iconsCategory.push({ description : 'cancel &#xe5c9'});
            iconsCategory.push({ description : 'card_giftcard &#xe8f6'});
            iconsCategory.push({ description : 'card_membership &#xe8f7'});
            iconsCategory.push({ description : 'card_travel &#xe8f8'});
            iconsCategory.push({ description : 'casino &#xeb40'});
            iconsCategory.push({ description : 'cast &#xe307'});
            iconsCategory.push({ description : 'cast_connected &#xe308'});
            iconsCategory.push({ description : 'center_focus_strong &#xe3b4'});
            iconsCategory.push({ description : 'center_focus_weak &#xe3b5'});
            iconsCategory.push({ description : 'change_history &#xe86b'});
            iconsCategory.push({ description : 'chat &#xe0b7'});
            iconsCategory.push({ description : 'chat_bubble &#xe0ca'});
            iconsCategory.push({ description : 'chat_bubble_outline &#xe0cb'});
            iconsCategory.push({ description : 'check &#xe5ca'});
            iconsCategory.push({ description : 'check_box &#xe834'});
            iconsCategory.push({ description : 'check_box_outline_blank &#xe835'});
            iconsCategory.push({ description : 'check_circle &#xe86c'});
            iconsCategory.push({ description : 'chevron_left &#xe5cb'});
            iconsCategory.push({ description : 'chevron_right &#xe5cc'});
            iconsCategory.push({ description : 'child_care &#xeb41'});
            iconsCategory.push({ description : 'child_friendly &#xeb42'});
            iconsCategory.push({ description : 'chrome_reader_mode &#xe86d'});
            iconsCategory.push({ description : 'class &#xe86e'});
            iconsCategory.push({ description : 'clear &#xe14c'});
            iconsCategory.push({ description : 'clear_all &#xe0b8'});
            iconsCategory.push({ description : 'close &#xe5cd'});
            iconsCategory.push({ description : 'closed_caption &#xe01c'});
            iconsCategory.push({ description : 'cloud &#xe2bd'});
            iconsCategory.push({ description : 'cloud_circle &#xe2be'});
            iconsCategory.push({ description : 'cloud_done &#xe2bf'});
            iconsCategory.push({ description : 'cloud_download &#xe2c0'});
            iconsCategory.push({ description : 'cloud_off &#xe2c1'});
            iconsCategory.push({ description : 'cloud_queue &#xe2c2'});
            iconsCategory.push({ description : 'cloud_upload &#xe2c3'});
            iconsCategory.push({ description : 'code &#xe86f'});
            iconsCategory.push({ description : 'collections &#xe3b6'});
            iconsCategory.push({ description : 'collections_bookmark &#xe431'});
            iconsCategory.push({ description : 'color_lens &#xe3b7'});
            iconsCategory.push({ description : 'colorize &#xe3b8'});
            iconsCategory.push({ description : 'comment &#xe0b9'});
            iconsCategory.push({ description : 'compare &#xe3b9'});
            iconsCategory.push({ description : 'compare_arrows &#xe915'});
            iconsCategory.push({ description : 'computer &#xe30a'});
            iconsCategory.push({ description : 'confirmation_number &#xe638'});
            iconsCategory.push({ description : 'contact_mail &#xe0d0'});
            iconsCategory.push({ description : 'contact_phone &#xe0cf'});
            iconsCategory.push({ description : 'contacts &#xe0ba'});
            iconsCategory.push({ description : 'content_copy &#xe14d'});
            iconsCategory.push({ description : 'content_cut &#xe14e'});
            iconsCategory.push({ description : 'content_paste &#xe14f'});
            iconsCategory.push({ description : 'control_point &#xe3ba'});
            iconsCategory.push({ description : 'control_point_duplicate &#xe3bb'});
            iconsCategory.push({ description : 'copyright &#xe90c'});
            iconsCategory.push({ description : 'create &#xe150'});
            iconsCategory.push({ description : 'create_new_folder &#xe2cc'});
            iconsCategory.push({ description : 'credit_card &#xe870'});
            iconsCategory.push({ description : 'crop &#xe3be'});
            iconsCategory.push({ description : 'crop_16_9 &#xe3bc'});
            iconsCategory.push({ description : 'crop_3_2 &#xe3bd'});
            iconsCategory.push({ description : 'crop_5_4 &#xe3bf'});
            iconsCategory.push({ description : 'crop_7_5 &#xe3c0'});
            iconsCategory.push({ description : 'crop_din &#xe3c1'});
            iconsCategory.push({ description : 'crop_free &#xe3c2'});
            iconsCategory.push({ description : 'crop_landscape &#xe3c3'});
            iconsCategory.push({ description : 'crop_original &#xe3c4'});
            iconsCategory.push({ description : 'crop_portrait &#xe3c5'});
            iconsCategory.push({ description : 'crop_rotate &#xe437'});
            iconsCategory.push({ description : 'crop_square &#xe3c6'});
            iconsCategory.push({ description : 'dashboard &#xe871'});
            iconsCategory.push({ description : 'data_usage &#xe1af'});
            iconsCategory.push({ description : 'date_range &#xe916'});
            iconsCategory.push({ description : 'dehaze &#xe3c7'});
            iconsCategory.push({ description : 'delete &#xe872'});
            iconsCategory.push({ description : 'delete_forever &#xe92b'});
            iconsCategory.push({ description : 'delete_sweep &#xe16c'});
            iconsCategory.push({ description : 'description &#xe873'});
            iconsCategory.push({ description : 'desktop_mac &#xe30b'});
            iconsCategory.push({ description : 'desktop_windows &#xe30c'});
            iconsCategory.push({ description : 'details &#xe3c8'});
            iconsCategory.push({ description : 'developer_board &#xe30d'});
            iconsCategory.push({ description : 'developer_mode &#xe1b0'});
            iconsCategory.push({ description : 'device_hub &#xe335'});
            iconsCategory.push({ description : 'devices &#xe1b1'});
            iconsCategory.push({ description : 'devices_other &#xe337'});
            iconsCategory.push({ description : 'dialer_sip &#xe0bb'});
            iconsCategory.push({ description : 'dialpad &#xe0bc'});
            iconsCategory.push({ description : 'directions &#xe52e'});
            iconsCategory.push({ description : 'directions_bike &#xe52f'});
            iconsCategory.push({ description : 'directions_boat &#xe532'});
            iconsCategory.push({ description : 'directions_bus &#xe530'});
            iconsCategory.push({ description : 'directions_car &#xe531'});
            iconsCategory.push({ description : 'directions_railway &#xe534'});
            iconsCategory.push({ description : 'directions_run &#xe566'});
            iconsCategory.push({ description : 'directions_subway &#xe533'});
            iconsCategory.push({ description : 'directions_transit &#xe535'});
            iconsCategory.push({ description : 'directions_walk &#xe536'});
            iconsCategory.push({ description : 'disc_full &#xe610'});
            iconsCategory.push({ description : 'dns &#xe875'});
            iconsCategory.push({ description : 'do_not_disturb &#xe612'});
            iconsCategory.push({ description : 'do_not_disturb_alt &#xe611'});
            iconsCategory.push({ description : 'do_not_disturb_off &#xe643'});
            iconsCategory.push({ description : 'do_not_disturb_on &#xe644'});
            iconsCategory.push({ description : 'dock &#xe30e'});
            iconsCategory.push({ description : 'domain &#xe7ee'});
            iconsCategory.push({ description : 'done &#xe876'});
            iconsCategory.push({ description : 'done_all &#xe877'});
            iconsCategory.push({ description : 'donut_large &#xe917'});
            iconsCategory.push({ description : 'donut_small &#xe918'});
            iconsCategory.push({ description : 'drafts &#xe151'});
            iconsCategory.push({ description : 'drag_handle &#xe25d'});
            iconsCategory.push({ description : 'drive_eta &#xe613'});
            iconsCategory.push({ description : 'dvr &#xe1b2'});
            iconsCategory.push({ description : 'edit &#xe3c9'});
            iconsCategory.push({ description : 'edit_location &#xe568'});
            iconsCategory.push({ description : 'eject &#xe8fb'});
            iconsCategory.push({ description : 'email &#xe0be'});
            iconsCategory.push({ description : 'enhanced_encryption &#xe63f'});
            iconsCategory.push({ description : 'equalizer &#xe01d'});
            iconsCategory.push({ description : 'error &#xe000'});
            iconsCategory.push({ description : 'error_outline &#xe001'});
            iconsCategory.push({ description : 'euro_symbol &#xe926'});
            iconsCategory.push({ description : 'ev_station &#xe56d'});
            iconsCategory.push({ description : 'event &#xe878'});
            iconsCategory.push({ description : 'event_available &#xe614'});
            iconsCategory.push({ description : 'event_busy &#xe615'});
            iconsCategory.push({ description : 'event_note &#xe616'});
            iconsCategory.push({ description : 'event_seat &#xe903'});
            iconsCategory.push({ description : 'exit_to_app &#xe879'});
            iconsCategory.push({ description : 'expand_less &#xe5ce'});
            iconsCategory.push({ description : 'expand_more &#xe5cf'});
            iconsCategory.push({ description : 'explicit &#xe01e'});
            iconsCategory.push({ description : 'explore &#xe87a'});
            iconsCategory.push({ description : 'exposure &#xe3ca'});
            iconsCategory.push({ description : 'exposure_neg_1 &#xe3cb'});
            iconsCategory.push({ description : 'exposure_neg_2 &#xe3cc'});
            iconsCategory.push({ description : 'exposure_plus_1 &#xe3cd'});
            iconsCategory.push({ description : 'exposure_plus_2 &#xe3ce'});
            iconsCategory.push({ description : 'exposure_zero &#xe3cf'});
            iconsCategory.push({ description : 'extension &#xe87b'});
            iconsCategory.push({ description : 'face &#xe87c'});
            iconsCategory.push({ description : 'fast_forward &#xe01f'});
            iconsCategory.push({ description : 'fast_rewind &#xe020'});
            iconsCategory.push({ description : 'favorite &#xe87d'});
            iconsCategory.push({ description : 'favorite_border &#xe87e'});
            iconsCategory.push({ description : 'featured_play_list &#xe06d'});
            iconsCategory.push({ description : 'featured_video &#xe06e'});
            iconsCategory.push({ description : 'feedback &#xe87f'});
            iconsCategory.push({ description : 'fiber_dvr &#xe05d'});
            iconsCategory.push({ description : 'fiber_manual_record &#xe061'});
            iconsCategory.push({ description : 'fiber_new &#xe05e'});
            iconsCategory.push({ description : 'fiber_pin &#xe06a'});
            iconsCategory.push({ description : 'fiber_smart_record &#xe062'});
            iconsCategory.push({ description : 'file_download &#xe2c4'});
            iconsCategory.push({ description : 'file_upload &#xe2c6'});
            iconsCategory.push({ description : 'filter &#xe3d3'});
            iconsCategory.push({ description : 'filter_1 &#xe3d0'});
            iconsCategory.push({ description : 'filter_2 &#xe3d1'});
            iconsCategory.push({ description : 'filter_3 &#xe3d2'});
            iconsCategory.push({ description : 'filter_4 &#xe3d4'});
            iconsCategory.push({ description : 'filter_5 &#xe3d5'});
            iconsCategory.push({ description : 'filter_6 &#xe3d6'});
            iconsCategory.push({ description : 'filter_7 &#xe3d7'});
            iconsCategory.push({ description : 'filter_8 &#xe3d8'});
            iconsCategory.push({ description : 'filter_9 &#xe3d9'});
            iconsCategory.push({ description : 'filter_9_plus &#xe3da'});
            iconsCategory.push({ description : 'filter_b_and_w &#xe3db'});
            iconsCategory.push({ description : 'filter_center_focus &#xe3dc'});
            iconsCategory.push({ description : 'filter_drama &#xe3dd'});
            iconsCategory.push({ description : 'filter_frames &#xe3de'});
            iconsCategory.push({ description : 'filter_hdr &#xe3df'});
            iconsCategory.push({ description : 'filter_list &#xe152'});
            iconsCategory.push({ description : 'filter_none &#xe3e0'});
            iconsCategory.push({ description : 'filter_tilt_shift &#xe3e2'});
            iconsCategory.push({ description : 'filter_vintage &#xe3e3'});
            iconsCategory.push({ description : 'find_in_page &#xe880'});
            iconsCategory.push({ description : 'find_replace &#xe881'});
            iconsCategory.push({ description : 'fingerprint &#xe90d'});
            iconsCategory.push({ description : 'first_page &#xe5dc'});
            iconsCategory.push({ description : 'fitness_center &#xeb43'});
            iconsCategory.push({ description : 'flag &#xe153'});
            iconsCategory.push({ description : 'flare &#xe3e4'});
            iconsCategory.push({ description : 'flash_auto &#xe3e5'});
            iconsCategory.push({ description : 'flash_off &#xe3e6'});
            iconsCategory.push({ description : 'flash_on &#xe3e7'});
            iconsCategory.push({ description : 'flight &#xe539'});
            iconsCategory.push({ description : 'flight_land &#xe904'});
            iconsCategory.push({ description : 'flight_takeoff &#xe905'});
            iconsCategory.push({ description : 'flip &#xe3e8'});
            iconsCategory.push({ description : 'flip_to_back &#xe882'});
            iconsCategory.push({ description : 'flip_to_front &#xe883'});
            iconsCategory.push({ description : 'folder &#xe2c7'});
            iconsCategory.push({ description : 'folder_open &#xe2c8'});
            iconsCategory.push({ description : 'folder_shared &#xe2c9'});
            iconsCategory.push({ description : 'folder_special &#xe617'});
            iconsCategory.push({ description : 'font_download &#xe167'});
            iconsCategory.push({ description : 'format_align_center &#xe234'});
            iconsCategory.push({ description : 'format_align_justify &#xe235'});
            iconsCategory.push({ description : 'format_align_left &#xe236'});
            iconsCategory.push({ description : 'format_align_right &#xe237'});
            iconsCategory.push({ description : 'format_bold &#xe238'});
            iconsCategory.push({ description : 'format_clear &#xe239'});
            iconsCategory.push({ description : 'format_color_fill &#xe23a'});
            iconsCategory.push({ description : 'format_color_reset &#xe23b'});
            iconsCategory.push({ description : 'format_color_text &#xe23c'});
            iconsCategory.push({ description : 'format_indent_decrease &#xe23d'});
            iconsCategory.push({ description : 'format_indent_increase &#xe23e'});
            iconsCategory.push({ description : 'format_italic &#xe23f'});
            iconsCategory.push({ description : 'format_line_spacing &#xe240'});
            iconsCategory.push({ description : 'format_list_bulleted &#xe241'});
            iconsCategory.push({ description : 'format_list_numbered &#xe242'});
            iconsCategory.push({ description : 'format_paint &#xe243'});
            iconsCategory.push({ description : 'format_quote &#xe244'});
            iconsCategory.push({ description : 'format_shapes &#xe25e'});
            iconsCategory.push({ description : 'format_size &#xe245'});
            iconsCategory.push({ description : 'format_strikethrough &#xe246'});
            iconsCategory.push({ description : 'format_textdirection_l_to_r &#xe247'});
            iconsCategory.push({ description : 'format_textdirection_r_to_l &#xe248'});
            iconsCategory.push({ description : 'format_underlined &#xe249'});
            iconsCategory.push({ description : 'forum &#xe0bf'});
            iconsCategory.push({ description : 'forward &#xe154'});
            iconsCategory.push({ description : 'forward_10 &#xe056'});
            iconsCategory.push({ description : 'forward_30 &#xe057'});
            iconsCategory.push({ description : 'forward_5 &#xe058'});
            iconsCategory.push({ description : 'free_breakfast &#xeb44'});
            iconsCategory.push({ description : 'fullscreen &#xe5d0'});
            iconsCategory.push({ description : 'fullscreen_exit &#xe5d1'});
            iconsCategory.push({ description : 'functions &#xe24a'});
            iconsCategory.push({ description : 'g_translate &#xe927'});
            iconsCategory.push({ description : 'gamepad &#xe30f'});
            iconsCategory.push({ description : 'games &#xe021'});
            iconsCategory.push({ description : 'gavel &#xe90e'});
            iconsCategory.push({ description : 'gesture &#xe155'});
            iconsCategory.push({ description : 'get_app &#xe884'});
            iconsCategory.push({ description : 'gif &#xe908'});
            iconsCategory.push({ description : 'golf_course &#xeb45'});
            iconsCategory.push({ description : 'gps_fixed &#xe1b3'});
            iconsCategory.push({ description : 'gps_not_fixed &#xe1b4'});
            iconsCategory.push({ description : 'gps_off &#xe1b5'});
            iconsCategory.push({ description : 'grade &#xe885'});
            iconsCategory.push({ description : 'gradient &#xe3e9'});
            iconsCategory.push({ description : 'grain &#xe3ea'});
            iconsCategory.push({ description : 'graphic_eq &#xe1b8'});
            iconsCategory.push({ description : 'grid_off &#xe3eb'});
            iconsCategory.push({ description : 'grid_on &#xe3ec'});
            iconsCategory.push({ description : 'group &#xe7ef'});
            iconsCategory.push({ description : 'group_add &#xe7f0'});
            iconsCategory.push({ description : 'group_work &#xe886'});
            iconsCategory.push({ description : 'hd &#xe052'});
            iconsCategory.push({ description : 'hdr_off &#xe3ed'});
            iconsCategory.push({ description : 'hdr_on &#xe3ee'});
            iconsCategory.push({ description : 'hdr_strong &#xe3f1'});
            iconsCategory.push({ description : 'hdr_weak &#xe3f2'});
            iconsCategory.push({ description : 'headset &#xe310'});
            iconsCategory.push({ description : 'headset_mic &#xe311'});
            iconsCategory.push({ description : 'healing &#xe3f3'});
            iconsCategory.push({ description : 'hearing &#xe023'});
            iconsCategory.push({ description : 'help &#xe887'});
            iconsCategory.push({ description : 'help_outline &#xe8fd'});
            iconsCategory.push({ description : 'high_quality &#xe024'});
            iconsCategory.push({ description : 'highlight &#xe25f'});
            iconsCategory.push({ description : 'highlight_off &#xe888'});
            iconsCategory.push({ description : 'history &#xe889'});
            iconsCategory.push({ description : 'home &#xe88a'});
            iconsCategory.push({ description : 'hot_tub &#xeb46'});
            iconsCategory.push({ description : 'hotel &#xe53a'});
            iconsCategory.push({ description : 'hourglass_empty &#xe88b'});
            iconsCategory.push({ description : 'hourglass_full &#xe88c'});
            iconsCategory.push({ description : 'http &#xe902'});
            iconsCategory.push({ description : 'https &#xe88d'});
            iconsCategory.push({ description : 'image &#xe3f4'});
            iconsCategory.push({ description : 'image_aspect_ratio &#xe3f5'});
            iconsCategory.push({ description : 'import_contacts &#xe0e0'});
            iconsCategory.push({ description : 'import_export &#xe0c3'});
            iconsCategory.push({ description : 'important_devices &#xe912'});
            iconsCategory.push({ description : 'inbox &#xe156'});
            iconsCategory.push({ description : 'indeterminate_check_box &#xe909'});
            iconsCategory.push({ description : 'info &#xe88e'});
            iconsCategory.push({ description : 'info_outline &#xe88f'});
            iconsCategory.push({ description : 'input &#xe890'});
            iconsCategory.push({ description : 'insert_chart &#xe24b'});
            iconsCategory.push({ description : 'insert_comment &#xe24c'});
            iconsCategory.push({ description : 'insert_drive_file &#xe24d'});
            iconsCategory.push({ description : 'insert_emoticon &#xe24e'});
            iconsCategory.push({ description : 'insert_invitation &#xe24f'});
            iconsCategory.push({ description : 'insert_link &#xe250'});
            iconsCategory.push({ description : 'insert_photo &#xe251'});
            iconsCategory.push({ description : 'invert_colors &#xe891'});
            iconsCategory.push({ description : 'invert_colors_off &#xe0c4'});
            iconsCategory.push({ description : 'iso &#xe3f6'});
            iconsCategory.push({ description : 'keyboard &#xe312'});
            iconsCategory.push({ description : 'keyboard_arrow_down &#xe313'});
            iconsCategory.push({ description : 'keyboard_arrow_left &#xe314'});
            iconsCategory.push({ description : 'keyboard_arrow_right &#xe315'});
            iconsCategory.push({ description : 'keyboard_arrow_up &#xe316'});
            iconsCategory.push({ description : 'keyboard_backspace &#xe317'});
            iconsCategory.push({ description : 'keyboard_capslock &#xe318'});
            iconsCategory.push({ description : 'keyboard_hide &#xe31a'});
            iconsCategory.push({ description : 'keyboard_return &#xe31b'});
            iconsCategory.push({ description : 'keyboard_tab &#xe31c'});
            iconsCategory.push({ description : 'keyboard_voice &#xe31d'});
            iconsCategory.push({ description : 'kitchen &#xeb47'});
            iconsCategory.push({ description : 'label &#xe892'});
            iconsCategory.push({ description : 'label_outline &#xe893'});
            iconsCategory.push({ description : 'landscape &#xe3f7'});
            iconsCategory.push({ description : 'language &#xe894'});
            iconsCategory.push({ description : 'laptop &#xe31e'});
            iconsCategory.push({ description : 'laptop_chromebook &#xe31f'});
            iconsCategory.push({ description : 'laptop_mac &#xe320'});
            iconsCategory.push({ description : 'laptop_windows &#xe321'});
            iconsCategory.push({ description : 'last_page &#xe5dd'});
            iconsCategory.push({ description : 'launch &#xe895'});
            iconsCategory.push({ description : 'layers &#xe53b'});
            iconsCategory.push({ description : 'layers_clear &#xe53c'});
            iconsCategory.push({ description : 'leak_add &#xe3f8'});
            iconsCategory.push({ description : 'leak_remove &#xe3f9'});
            iconsCategory.push({ description : 'lens &#xe3fa'});
            iconsCategory.push({ description : 'library_add &#xe02e'});
            iconsCategory.push({ description : 'library_books &#xe02f'});
            iconsCategory.push({ description : 'library_music &#xe030'});
            iconsCategory.push({ description : 'lightbulb_outline &#xe90f'});
            iconsCategory.push({ description : 'line_style &#xe919'});
            iconsCategory.push({ description : 'line_weight &#xe91a'});
            iconsCategory.push({ description : 'linear_scale &#xe260'});
            iconsCategory.push({ description : 'link &#xe157'});
            iconsCategory.push({ description : 'linked_camera &#xe438'});
            iconsCategory.push({ description : 'list &#xe896'});
            iconsCategory.push({ description : 'live_help &#xe0c6'});
            iconsCategory.push({ description : 'live_tv &#xe639'});
            iconsCategory.push({ description : 'local_activity &#xe53f'});
            iconsCategory.push({ description : 'local_airport &#xe53d'});
            iconsCategory.push({ description : 'local_atm &#xe53e'});
            iconsCategory.push({ description : 'local_bar &#xe540'});
            iconsCategory.push({ description : 'local_cafe &#xe541'});
            iconsCategory.push({ description : 'local_car_wash &#xe542'});
            iconsCategory.push({ description : 'local_convenience_store &#xe543'});
            iconsCategory.push({ description : 'local_dining &#xe556'});
            iconsCategory.push({ description : 'local_drink &#xe544'});
            iconsCategory.push({ description : 'local_florist &#xe545'});
            iconsCategory.push({ description : 'local_gas_station &#xe546'});
            iconsCategory.push({ description : 'local_grocery_store &#xe547'});
            iconsCategory.push({ description : 'local_hospital &#xe548'});
            iconsCategory.push({ description : 'local_hotel &#xe549'});
            iconsCategory.push({ description : 'local_laundry_service &#xe54a'});
            iconsCategory.push({ description : 'local_library &#xe54b'});
            iconsCategory.push({ description : 'local_mall &#xe54c'});
            iconsCategory.push({ description : 'local_movies &#xe54d'});
            iconsCategory.push({ description : 'local_offer &#xe54e'});
            iconsCategory.push({ description : 'local_parking &#xe54f'});
            iconsCategory.push({ description : 'local_pharmacy &#xe550'});
            iconsCategory.push({ description : 'local_phone &#xe551'});
            iconsCategory.push({ description : 'local_pizza &#xe552'});
            iconsCategory.push({ description : 'local_play &#xe553'});
            iconsCategory.push({ description : 'local_post_office &#xe554'});
            iconsCategory.push({ description : 'local_printshop &#xe555'});
            iconsCategory.push({ description : 'local_see &#xe557'});
            iconsCategory.push({ description : 'local_shipping &#xe558'});
            iconsCategory.push({ description : 'local_taxi &#xe559'});
            iconsCategory.push({ description : 'location_city &#xe7f1'});
            iconsCategory.push({ description : 'location_disabled &#xe1b6'});
            iconsCategory.push({ description : 'location_off &#xe0c7'});
            iconsCategory.push({ description : 'location_on &#xe0c8'});
            iconsCategory.push({ description : 'location_searching &#xe1b7'});
            iconsCategory.push({ description : 'lock &#xe897'});
            iconsCategory.push({ description : 'lock_open &#xe898'});
            iconsCategory.push({ description : 'lock_outline &#xe899'});
            iconsCategory.push({ description : 'looks &#xe3fc'});
            iconsCategory.push({ description : 'looks_3 &#xe3fb'});
            iconsCategory.push({ description : 'looks_4 &#xe3fd'});
            iconsCategory.push({ description : 'looks_5 &#xe3fe'});
            iconsCategory.push({ description : 'looks_6 &#xe3ff'});
            iconsCategory.push({ description : 'looks_one &#xe400'});
            iconsCategory.push({ description : 'looks_two &#xe401'});
            iconsCategory.push({ description : 'loop &#xe028'});
            iconsCategory.push({ description : 'loupe &#xe402'});
            iconsCategory.push({ description : 'low_priority &#xe16d'});
            iconsCategory.push({ description : 'loyalty &#xe89a'});
            iconsCategory.push({ description : 'mail &#xe158'});
            iconsCategory.push({ description : 'mail_outline &#xe0e1'});
            iconsCategory.push({ description : 'map &#xe55b'});
            iconsCategory.push({ description : 'markunread &#xe159'});
            iconsCategory.push({ description : 'markunread_mailbox &#xe89b'});
            iconsCategory.push({ description : 'memory &#xe322'});
            iconsCategory.push({ description : 'menu &#xe5d2'});
            iconsCategory.push({ description : 'merge_type &#xe252'});
            iconsCategory.push({ description : 'message &#xe0c9'});
            iconsCategory.push({ description : 'mic &#xe029'});
            iconsCategory.push({ description : 'mic_none &#xe02a'});
            iconsCategory.push({ description : 'mic_off &#xe02b'});
            iconsCategory.push({ description : 'mms &#xe618'});
            iconsCategory.push({ description : 'mode_comment &#xe253'});
            iconsCategory.push({ description : 'mode_edit &#xe254'});
            iconsCategory.push({ description : 'monetization_on &#xe263'});
            iconsCategory.push({ description : 'money_off &#xe25c'});
            iconsCategory.push({ description : 'monochrome_photos &#xe403'});
            iconsCategory.push({ description : 'mood &#xe7f2'});
            iconsCategory.push({ description : 'mood_bad &#xe7f3'});
            iconsCategory.push({ description : 'more &#xe619'});
            iconsCategory.push({ description : 'more_horiz &#xe5d3'});
            iconsCategory.push({ description : 'more_vert &#xe5d4'});
            iconsCategory.push({ description : 'motorcycle &#xe91b'});
            iconsCategory.push({ description : 'mouse &#xe323'});
            iconsCategory.push({ description : 'move_to_inbox &#xe168'});
            iconsCategory.push({ description : 'movie &#xe02c'});
            iconsCategory.push({ description : 'movie_creation &#xe404'});
            iconsCategory.push({ description : 'movie_filter &#xe43a'});
            iconsCategory.push({ description : 'multiline_chart &#xe6df'});
            iconsCategory.push({ description : 'music_note &#xe405'});
            iconsCategory.push({ description : 'music_video &#xe063'});
            iconsCategory.push({ description : 'my_location &#xe55c'});
            iconsCategory.push({ description : 'nature &#xe406'});
            iconsCategory.push({ description : 'nature_people &#xe407'});
            iconsCategory.push({ description : 'navigate_before &#xe408'});
            iconsCategory.push({ description : 'navigate_next &#xe409'});
            iconsCategory.push({ description : 'navigation &#xe55d'});
            iconsCategory.push({ description : 'near_me &#xe569'});
            iconsCategory.push({ description : 'network_cell &#xe1b9'});
            iconsCategory.push({ description : 'network_check &#xe640'});
            iconsCategory.push({ description : 'network_locked &#xe61a'});
            iconsCategory.push({ description : 'network_wifi &#xe1ba'});
            iconsCategory.push({ description : 'new_releases &#xe031'});
            iconsCategory.push({ description : 'next_week &#xe16a'});
            iconsCategory.push({ description : 'nfc &#xe1bb'});
            iconsCategory.push({ description : 'no_encryption &#xe641'});
            iconsCategory.push({ description : 'no_sim &#xe0cc'});
            iconsCategory.push({ description : 'not_interested &#xe033'});
            iconsCategory.push({ description : 'note &#xe06f'});
            iconsCategory.push({ description : 'note_add &#xe89c'});
            iconsCategory.push({ description : 'notifications &#xe7f4'});
            iconsCategory.push({ description : 'notifications_active &#xe7f7'});
            iconsCategory.push({ description : 'notifications_none &#xe7f5'});
            iconsCategory.push({ description : 'notifications_off &#xe7f6'});
            iconsCategory.push({ description : 'notifications_paused &#xe7f8'});
            iconsCategory.push({ description : 'offline_pin &#xe90a'});
            iconsCategory.push({ description : 'ondemand_video &#xe63a'});
            iconsCategory.push({ description : 'opacity &#xe91c'});
            iconsCategory.push({ description : 'open_in_browser &#xe89d'});
            iconsCategory.push({ description : 'open_in_new &#xe89e'});
            iconsCategory.push({ description : 'open_with &#xe89f'});
            iconsCategory.push({ description : 'pages &#xe7f9'});
            iconsCategory.push({ description : 'pageview &#xe8a0'});
            iconsCategory.push({ description : 'palette &#xe40a'});
            iconsCategory.push({ description : 'pan_tool &#xe925'});
            iconsCategory.push({ description : 'panorama &#xe40b'});
            iconsCategory.push({ description : 'panorama_fish_eye &#xe40c'});
            iconsCategory.push({ description : 'panorama_horizontal &#xe40d'});
            iconsCategory.push({ description : 'panorama_vertical &#xe40e'});
            iconsCategory.push({ description : 'panorama_wide_angle &#xe40f'});
            iconsCategory.push({ description : 'party_mode &#xe7fa'});
            iconsCategory.push({ description : 'pause &#xe034'});
            iconsCategory.push({ description : 'pause_circle_filled &#xe035'});
            iconsCategory.push({ description : 'pause_circle_outline &#xe036'});
            iconsCategory.push({ description : 'payment &#xe8a1'});
            iconsCategory.push({ description : 'people &#xe7fb'});
            iconsCategory.push({ description : 'people_outline &#xe7fc'});
            iconsCategory.push({ description : 'perm_camera_mic &#xe8a2'});
            iconsCategory.push({ description : 'perm_contact_calendar &#xe8a3'});
            iconsCategory.push({ description : 'perm_data_setting &#xe8a4'});
            iconsCategory.push({ description : 'perm_device_information &#xe8a5'});
            iconsCategory.push({ description : 'perm_identity &#xe8a6'});
            iconsCategory.push({ description : 'perm_media &#xe8a7'});
            iconsCategory.push({ description : 'perm_phone_msg &#xe8a8'});
            iconsCategory.push({ description : 'perm_scan_wifi &#xe8a9'});
            iconsCategory.push({ description : 'person &#xe7fd'});
            iconsCategory.push({ description : 'person_add &#xe7fe'});
            iconsCategory.push({ description : 'person_outline &#xe7ff'});
            iconsCategory.push({ description : 'person_pin &#xe55a'});
            iconsCategory.push({ description : 'person_pin_circle &#xe56a'});
            iconsCategory.push({ description : 'personal_video &#xe63b'});
            iconsCategory.push({ description : 'pets &#xe91d'});
            iconsCategory.push({ description : 'phone &#xe0cd'});
            iconsCategory.push({ description : 'phone_android &#xe324'});
            iconsCategory.push({ description : 'phone_bluetooth_speaker &#xe61b'});
            iconsCategory.push({ description : 'phone_forwarded &#xe61c'});
            iconsCategory.push({ description : 'phone_in_talk &#xe61d'});
            iconsCategory.push({ description : 'phone_iphone &#xe325'});
            iconsCategory.push({ description : 'phone_locked &#xe61e'});
            iconsCategory.push({ description : 'phone_missed &#xe61f'});
            iconsCategory.push({ description : 'phone_paused &#xe620'});
            iconsCategory.push({ description : 'phonelink &#xe326'});
            iconsCategory.push({ description : 'phonelink_erase &#xe0db'});
            iconsCategory.push({ description : 'phonelink_lock &#xe0dc'});
            iconsCategory.push({ description : 'phonelink_off &#xe327'});
            iconsCategory.push({ description : 'phonelink_ring &#xe0dd'});
            iconsCategory.push({ description : 'phonelink_setup &#xe0de'});
            iconsCategory.push({ description : 'photo &#xe410'});
            iconsCategory.push({ description : 'photo_album &#xe411'});
            iconsCategory.push({ description : 'photo_camera &#xe412'});
            iconsCategory.push({ description : 'photo_filter &#xe43b'});
            iconsCategory.push({ description : 'photo_library &#xe413'});
            iconsCategory.push({ description : 'photo_size_select_actual &#xe432'});
            iconsCategory.push({ description : 'photo_size_select_large &#xe433'});
            iconsCategory.push({ description : 'photo_size_select_small &#xe434'});
            iconsCategory.push({ description : 'picture_as_pdf &#xe415'});
            iconsCategory.push({ description : 'picture_in_picture &#xe8aa'});
            iconsCategory.push({ description : 'picture_in_picture_alt &#xe911'});
            iconsCategory.push({ description : 'pie_chart &#xe6c4'});
            iconsCategory.push({ description : 'pie_chart_outlined &#xe6c5'});
            iconsCategory.push({ description : 'pin_drop &#xe55e'});
            iconsCategory.push({ description : 'place &#xe55f'});
            iconsCategory.push({ description : 'play_arrow &#xe037'});
            iconsCategory.push({ description : 'play_circle_filled &#xe038'});
            iconsCategory.push({ description : 'play_circle_outline &#xe039'});
            iconsCategory.push({ description : 'play_for_work &#xe906'});
            iconsCategory.push({ description : 'playlist_add &#xe03b'});
            iconsCategory.push({ description : 'playlist_add_check &#xe065'});
            iconsCategory.push({ description : 'playlist_play &#xe05f'});
            iconsCategory.push({ description : 'plus_one &#xe800'});
            iconsCategory.push({ description : 'poll &#xe801'});
            iconsCategory.push({ description : 'polymer &#xe8ab'});
            iconsCategory.push({ description : 'pool &#xeb48'});
            iconsCategory.push({ description : 'portable_wifi_off &#xe0ce'});
            iconsCategory.push({ description : 'portrait &#xe416'});
            iconsCategory.push({ description : 'power &#xe63c'});
            iconsCategory.push({ description : 'power_input &#xe336'});
            iconsCategory.push({ description : 'power_settings_new &#xe8ac'});
            iconsCategory.push({ description : 'pregnant_woman &#xe91e'});
            iconsCategory.push({ description : 'present_to_all &#xe0df'});
            iconsCategory.push({ description : 'print &#xe8ad'});
            iconsCategory.push({ description : 'priority_high &#xe645'});
            iconsCategory.push({ description : 'public &#xe80b'});
            iconsCategory.push({ description : 'publish &#xe255'});
            iconsCategory.push({ description : 'query_builder &#xe8ae'});
            iconsCategory.push({ description : 'question_answer &#xe8af'});
            iconsCategory.push({ description : 'queue &#xe03c'});
            iconsCategory.push({ description : 'queue_music &#xe03d'});
            iconsCategory.push({ description : 'queue_play_next &#xe066'});
            iconsCategory.push({ description : 'radio &#xe03e'});
            iconsCategory.push({ description : 'radio_button_checked &#xe837'});
            iconsCategory.push({ description : 'radio_button_unchecked &#xe836'});
            iconsCategory.push({ description : 'rate_review &#xe560'});
            iconsCategory.push({ description : 'receipt &#xe8b0'});
            iconsCategory.push({ description : 'recent_actors &#xe03f'});
            iconsCategory.push({ description : 'record_voice_over &#xe91f'});
            iconsCategory.push({ description : 'redeem &#xe8b1'});
            iconsCategory.push({ description : 'redo &#xe15a'});
            iconsCategory.push({ description : 'refresh &#xe5d5'});
            iconsCategory.push({ description : 'remove &#xe15b'});
            iconsCategory.push({ description : 'remove_circle &#xe15c'});
            iconsCategory.push({ description : 'remove_circle_outline &#xe15d'});
            iconsCategory.push({ description : 'remove_from_queue &#xe067'});
            iconsCategory.push({ description : 'remove_red_eye &#xe417'});
            iconsCategory.push({ description : 'remove_shopping_cart &#xe928'});
            iconsCategory.push({ description : 'reorder &#xe8fe'});
            iconsCategory.push({ description : 'repeat &#xe040'});
            iconsCategory.push({ description : 'repeat_one &#xe041'});
            iconsCategory.push({ description : 'replay &#xe042'});
            iconsCategory.push({ description : 'replay_10 &#xe059'});
            iconsCategory.push({ description : 'replay_30 &#xe05a'});
            iconsCategory.push({ description : 'replay_5 &#xe05b'});
            iconsCategory.push({ description : 'reply &#xe15e'});
            iconsCategory.push({ description : 'reply_all &#xe15f'});
            iconsCategory.push({ description : 'report &#xe160'});
            iconsCategory.push({ description : 'report_problem &#xe8b2'});
            iconsCategory.push({ description : 'restaurant &#xe56c'});
            iconsCategory.push({ description : 'restaurant_menu &#xe561'});
            iconsCategory.push({ description : 'restore &#xe8b3'});
            iconsCategory.push({ description : 'restore_page &#xe929'});
            iconsCategory.push({ description : 'ring_volume &#xe0d1'});
            iconsCategory.push({ description : 'room &#xe8b4'});
            iconsCategory.push({ description : 'room_service &#xeb49'});
            iconsCategory.push({ description : 'rotate_90_degrees_ccw &#xe418'});
            iconsCategory.push({ description : 'rotate_left &#xe419'});
            iconsCategory.push({ description : 'rotate_right &#xe41a'});
            iconsCategory.push({ description : 'rounded_corner &#xe920'});
            iconsCategory.push({ description : 'router &#xe328'});
            iconsCategory.push({ description : 'rowing &#xe921'});
            iconsCategory.push({ description : 'rss_feed &#xe0e5'});
            iconsCategory.push({ description : 'rv_hookup &#xe642'});
            iconsCategory.push({ description : 'satellite &#xe562'});
            iconsCategory.push({ description : 'save &#xe161'});
            iconsCategory.push({ description : 'scanner &#xe329'});
            iconsCategory.push({ description : 'schedule &#xe8b5'});
            iconsCategory.push({ description : 'school &#xe80c'});
            iconsCategory.push({ description : 'screen_lock_landscape &#xe1be'});
            iconsCategory.push({ description : 'screen_lock_portrait &#xe1bf'});
            iconsCategory.push({ description : 'screen_lock_rotation &#xe1c0'});
            iconsCategory.push({ description : 'screen_rotation &#xe1c1'});
            iconsCategory.push({ description : 'screen_share &#xe0e2'});
            iconsCategory.push({ description : 'sd_card &#xe623'});
            iconsCategory.push({ description : 'sd_storage &#xe1c2'});
            iconsCategory.push({ description : 'search &#xe8b6'});
            iconsCategory.push({ description : 'security &#xe32a'});
            iconsCategory.push({ description : 'select_all &#xe162'});
            iconsCategory.push({ description : 'send &#xe163'});
            iconsCategory.push({ description : 'sentiment_dissatisfied &#xe811'});
            iconsCategory.push({ description : 'sentiment_neutral &#xe812'});
            iconsCategory.push({ description : 'sentiment_satisfied &#xe813'});
            iconsCategory.push({ description : 'sentiment_very_dissatisfied &#xe814'});
            iconsCategory.push({ description : 'sentiment_very_satisfied &#xe815'});
            iconsCategory.push({ description : 'settings &#xe8b8'});
            iconsCategory.push({ description : 'settings_applications &#xe8b9'});
            iconsCategory.push({ description : 'settings_backup_restore &#xe8ba'});
            iconsCategory.push({ description : 'settings_bluetooth &#xe8bb'});
            iconsCategory.push({ description : 'settings_brightness &#xe8bd'});
            iconsCategory.push({ description : 'settings_cell &#xe8bc'});
            iconsCategory.push({ description : 'settings_ethernet &#xe8be'});
            iconsCategory.push({ description : 'settings_input_antenna &#xe8bf'});
            iconsCategory.push({ description : 'settings_input_component &#xe8c0'});
            iconsCategory.push({ description : 'settings_input_composite &#xe8c1'});
            iconsCategory.push({ description : 'settings_input_hdmi &#xe8c2'});
            iconsCategory.push({ description : 'settings_input_svideo &#xe8c3'});
            iconsCategory.push({ description : 'settings_overscan &#xe8c4'});
            iconsCategory.push({ description : 'settings_phone &#xe8c5'});
            iconsCategory.push({ description : 'settings_power &#xe8c6'});
            iconsCategory.push({ description : 'settings_remote &#xe8c7'});
            iconsCategory.push({ description : 'settings_system_daydream &#xe1c3'});
            iconsCategory.push({ description : 'settings_voice &#xe8c8'});
            iconsCategory.push({ description : 'share &#xe80d'});
            iconsCategory.push({ description : 'shop &#xe8c9'});
            iconsCategory.push({ description : 'shop_two &#xe8ca'});
            iconsCategory.push({ description : 'shopping_basket &#xe8cb'});
            iconsCategory.push({ description : 'shopping_cart &#xe8cc'});
            iconsCategory.push({ description : 'short_text &#xe261'});
            iconsCategory.push({ description : 'show_chart &#xe6e1'});
            iconsCategory.push({ description : 'shuffle &#xe043'});
            iconsCategory.push({ description : 'signal_cellular_4_bar &#xe1c8'});
            iconsCategory.push({ description : 'signal_cellular_connected_no_internet_4_bar &#xe1cd'});
            iconsCategory.push({ description : 'signal_cellular_no_sim &#xe1ce'});
            iconsCategory.push({ description : 'signal_cellular_null &#xe1cf'});
            iconsCategory.push({ description : 'signal_cellular_off &#xe1d0'});
            iconsCategory.push({ description : 'signal_wifi_4_bar &#xe1d8'});
            iconsCategory.push({ description : 'signal_wifi_4_bar_lock &#xe1d9'});
            iconsCategory.push({ description : 'signal_wifi_off &#xe1da'});
            iconsCategory.push({ description : 'sim_card &#xe32b'});
            iconsCategory.push({ description : 'sim_card_alert &#xe624'});
            iconsCategory.push({ description : 'skip_next &#xe044'});
            iconsCategory.push({ description : 'skip_previous &#xe045'});
            iconsCategory.push({ description : 'slideshow &#xe41b'});
            iconsCategory.push({ description : 'slow_motion_video &#xe068'});
            iconsCategory.push({ description : 'smartphone &#xe32c'});
            iconsCategory.push({ description : 'smoke_free &#xeb4a'});
            iconsCategory.push({ description : 'smoking_rooms &#xeb4b'});
            iconsCategory.push({ description : 'sms &#xe625'});
            iconsCategory.push({ description : 'sms_failed &#xe626'});
            iconsCategory.push({ description : 'snooze &#xe046'});
            iconsCategory.push({ description : 'sort &#xe164'});
            iconsCategory.push({ description : 'sort_by_alpha &#xe053'});
            iconsCategory.push({ description : 'spa &#xeb4c'});
            iconsCategory.push({ description : 'space_bar &#xe256'});
            iconsCategory.push({ description : 'speaker &#xe32d'});
            iconsCategory.push({ description : 'speaker_group &#xe32e'});
            iconsCategory.push({ description : 'speaker_notes &#xe8cd'});
            iconsCategory.push({ description : 'speaker_notes_off &#xe92a'});
            iconsCategory.push({ description : 'speaker_phone &#xe0d2'});
            iconsCategory.push({ description : 'spellcheck &#xe8ce'});
            iconsCategory.push({ description : 'star &#xe838'});
            iconsCategory.push({ description : 'star_border &#xe83a'});
            iconsCategory.push({ description : 'star_half &#xe839'});
            iconsCategory.push({ description : 'stars &#xe8d0'});
            iconsCategory.push({ description : 'stay_current_landscape &#xe0d3'});
            iconsCategory.push({ description : 'stay_current_portrait &#xe0d4'});
            iconsCategory.push({ description : 'stay_primary_landscape &#xe0d5'});
            iconsCategory.push({ description : 'stay_primary_portrait &#xe0d6'});
            iconsCategory.push({ description : 'stop &#xe047'});
            iconsCategory.push({ description : 'stop_screen_share &#xe0e3'});
            iconsCategory.push({ description : 'storage &#xe1db'});
            iconsCategory.push({ description : 'store &#xe8d1'});
            iconsCategory.push({ description : 'store_mall_directory &#xe563'});
            iconsCategory.push({ description : 'straighten &#xe41c'});
            iconsCategory.push({ description : 'streetview &#xe56e'});
            iconsCategory.push({ description : 'strikethrough_s &#xe257'});
            iconsCategory.push({ description : 'style &#xe41d'});
            iconsCategory.push({ description : 'subdirectory_arrow_left &#xe5d9'});
            iconsCategory.push({ description : 'subdirectory_arrow_right &#xe5da'});
            iconsCategory.push({ description : 'subject &#xe8d2'});
            iconsCategory.push({ description : 'subscriptions &#xe064'});
            iconsCategory.push({ description : 'subtitles &#xe048'});
            iconsCategory.push({ description : 'subway &#xe56f'});
            iconsCategory.push({ description : 'supervisor_account &#xe8d3'});
            iconsCategory.push({ description : 'surround_sound &#xe049'});
            iconsCategory.push({ description : 'swap_calls &#xe0d7'});
            iconsCategory.push({ description : 'swap_horiz &#xe8d4'});
            iconsCategory.push({ description : 'swap_vert &#xe8d5'});
            iconsCategory.push({ description : 'swap_vertical_circle &#xe8d6'});
            iconsCategory.push({ description : 'switch_camera &#xe41e'});
            iconsCategory.push({ description : 'switch_video &#xe41f'});
            iconsCategory.push({ description : 'sync &#xe627'});
            iconsCategory.push({ description : 'sync_disabled &#xe628'});
            iconsCategory.push({ description : 'sync_problem &#xe629'});
            iconsCategory.push({ description : 'system_update &#xe62a'});
            iconsCategory.push({ description : 'system_update_alt &#xe8d7'});
            iconsCategory.push({ description : 'tab &#xe8d8'});
            iconsCategory.push({ description : 'tab_unselected &#xe8d9'});
            iconsCategory.push({ description : 'tablet &#xe32f'});
            iconsCategory.push({ description : 'tablet_android &#xe330'});
            iconsCategory.push({ description : 'tablet_mac &#xe331'});
            iconsCategory.push({ description : 'tag_faces &#xe420'});
            iconsCategory.push({ description : 'tap_and_play &#xe62b'});
            iconsCategory.push({ description : 'terrain &#xe564'});
            iconsCategory.push({ description : 'text_fields &#xe262'});
            iconsCategory.push({ description : 'text_format &#xe165'});
            iconsCategory.push({ description : 'textsms &#xe0d8'});
            iconsCategory.push({ description : 'texture &#xe421'});
            iconsCategory.push({ description : 'theaters &#xe8da'});
            iconsCategory.push({ description : 'thumb_down &#xe8db'});
            iconsCategory.push({ description : 'thumb_up &#xe8dc'});
            iconsCategory.push({ description : 'thumbs_up_down &#xe8dd'});
            iconsCategory.push({ description : 'time_to_leave &#xe62c'});
            iconsCategory.push({ description : 'timelapse &#xe422'});
            iconsCategory.push({ description : 'timeline &#xe922'});
            iconsCategory.push({ description : 'timer &#xe425'});
            iconsCategory.push({ description : 'timer_10 &#xe423'});
            iconsCategory.push({ description : 'timer_3 &#xe424'});
            iconsCategory.push({ description : 'timer_off &#xe426'});
            iconsCategory.push({ description : 'title &#xe264'});
            iconsCategory.push({ description : 'toc &#xe8de'});
            iconsCategory.push({ description : 'today &#xe8df'});
            iconsCategory.push({ description : 'toll &#xe8e0'});
            iconsCategory.push({ description : 'tonality &#xe427'});
            iconsCategory.push({ description : 'touch_app &#xe913'});
            iconsCategory.push({ description : 'toys &#xe332'});
            iconsCategory.push({ description : 'track_changes &#xe8e1'});
            iconsCategory.push({ description : 'traffic &#xe565'});
            iconsCategory.push({ description : 'train &#xe570'});
            iconsCategory.push({ description : 'tram &#xe571'});
            iconsCategory.push({ description : 'transfer_within_a_station &#xe572'});
            iconsCategory.push({ description : 'transform &#xe428'});
            iconsCategory.push({ description : 'translate &#xe8e2'});
            iconsCategory.push({ description : 'trending_down &#xe8e3'});
            iconsCategory.push({ description : 'trending_flat &#xe8e4'});
            iconsCategory.push({ description : 'trending_up &#xe8e5'});
            iconsCategory.push({ description : 'tune &#xe429'});
            iconsCategory.push({ description : 'turned_in &#xe8e6'});
            iconsCategory.push({ description : 'turned_in_not &#xe8e7'});
            iconsCategory.push({ description : 'tv &#xe333'});
            iconsCategory.push({ description : 'unarchive &#xe169'});
            iconsCategory.push({ description : 'undo &#xe166'});
            iconsCategory.push({ description : 'unfold_less &#xe5d6'});
            iconsCategory.push({ description : 'unfold_more &#xe5d7'});
            iconsCategory.push({ description : 'update &#xe923'});
            iconsCategory.push({ description : 'usb &#xe1e0'});
            iconsCategory.push({ description : 'verified_user &#xe8e8'});
            iconsCategory.push({ description : 'vertical_align_bottom &#xe258'});
            iconsCategory.push({ description : 'vertical_align_center &#xe259'});
            iconsCategory.push({ description : 'vertical_align_top &#xe25a'});
            iconsCategory.push({ description : 'vibration &#xe62d'});
            iconsCategory.push({ description : 'video_call &#xe070'});
            iconsCategory.push({ description : 'video_label &#xe071'});
            iconsCategory.push({ description : 'video_library &#xe04a'});
            iconsCategory.push({ description : 'videocam &#xe04b'});
            iconsCategory.push({ description : 'videocam_off &#xe04c'});
            iconsCategory.push({ description : 'videogame_asset &#xe338'});
            iconsCategory.push({ description : 'view_agenda &#xe8e9'});
            iconsCategory.push({ description : 'view_array &#xe8ea'});
            iconsCategory.push({ description : 'view_carousel &#xe8eb'});
            iconsCategory.push({ description : 'view_column &#xe8ec'});
            iconsCategory.push({ description : 'view_comfy &#xe42a'});
            iconsCategory.push({ description : 'view_compact &#xe42b'});
            iconsCategory.push({ description : 'view_day &#xe8ed'});
            iconsCategory.push({ description : 'view_headline &#xe8ee'});
            iconsCategory.push({ description : 'view_list &#xe8ef'});
            iconsCategory.push({ description : 'view_module &#xe8f0'});
            iconsCategory.push({ description : 'view_quilt &#xe8f1'});
            iconsCategory.push({ description : 'view_stream &#xe8f2'});
            iconsCategory.push({ description : 'view_week &#xe8f3'});
            iconsCategory.push({ description : 'vignette &#xe435'});
            iconsCategory.push({ description : 'visibility &#xe8f4'});
            iconsCategory.push({ description : 'visibility_off &#xe8f5'});
            iconsCategory.push({ description : 'voice_chat &#xe62e'});
            iconsCategory.push({ description : 'voicemail &#xe0d9'});
            iconsCategory.push({ description : 'volume_down &#xe04d'});
            iconsCategory.push({ description : 'volume_mute &#xe04e'});
            iconsCategory.push({ description : 'volume_off &#xe04f'});
            iconsCategory.push({ description : 'volume_up &#xe050'});
            iconsCategory.push({ description : 'vpn_key &#xe0da'});
            iconsCategory.push({ description : 'vpn_lock &#xe62f'});
            iconsCategory.push({ description : 'wallpaper &#xe1bc'});
            iconsCategory.push({ description : 'warning &#xe002'});
            iconsCategory.push({ description : 'watch &#xe334'});
            iconsCategory.push({ description : 'watch_later &#xe924'});
            iconsCategory.push({ description : 'wb_auto &#xe42c'});
            iconsCategory.push({ description : 'wb_cloudy &#xe42d'});
            iconsCategory.push({ description : 'wb_incandescent &#xe42e'});
            iconsCategory.push({ description : 'wb_iridescent &#xe436'});
            iconsCategory.push({ description : 'wb_sunny &#xe430'});
            iconsCategory.push({ description : 'wc &#xe63d'});
            iconsCategory.push({ description : 'web &#xe051'});
            iconsCategory.push({ description : 'web_asset &#xe069'});
            iconsCategory.push({ description : 'weekend &#xe16b'});
            iconsCategory.push({ description : 'whatshot &#xe80e'});
            iconsCategory.push({ description : 'widgets &#xe1bd'});
            iconsCategory.push({ description : 'wifi &#xe63e'});
            iconsCategory.push({ description : 'wifi_lock &#xe1e1'});
            iconsCategory.push({ description : 'wifi_tethering &#xe1e2'});
            iconsCategory.push({ description : 'work &#xe8f9'});
            iconsCategory.push({ description : 'wrap_text &#xe25b'});
            iconsCategory.push({ description : 'youtube_searched_for &#xe8fa'});
            iconsCategory.push({ description : 'zoom_in &#xe8ff'});
            iconsCategory.push({ description : 'zoom_out &#xe900'});
            iconsCategory.push({ description : 'zoom_out_map &#xe56b'});

            for (var i = 0; i < iconsCategory.length; i++) {
                iconsCategoryCode.push({ id: iconsCategory[i].description.split(' ')[1] });
            }

            return iconsCategoryCode;
        }

        return {
            get: get,
            getLeafs: getLeafs,
            deleteAll: deleteAll,
            deleteById: deleteById,
            getById: getById,
            postCategory: postCategory,
            putCategory: putCategory,
            post: post,
            iconsList: iconsList,
            iconsListMobileCare: iconsListMobileCare,
            geListMappings: geListMappings,
            getArchiveStatus:getArchiveStatus,
            getServiceById:getServiceById
        };
    }

    angular
        .module('app.category')
        .factory('Category', CategoryService);

})();

(function () {
    'use strict';

    /** @ngInject */
function CategoryCreateController(Company, $controller, Papel, Form, Attendance, $filter, $window, $interval, $rootScope, $scope, Category, Servico, Common, Security, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, DashboardCompany, $stateParams) {    
    var vm = this;
    vm.init = function(){
        vm.isLoading = true;        
        vm.isComponentLoading = true;        
        // Form Filter
        vm.filterForm = {};
        vm.filterForm.appCompanyId = vm.appCompany.id;
        vm.filterForm.modulo = 'Relacionamento';    
        vm.filterForm.activeIds = true;    
        // Papeis Filter
        vm.filterPapeis = {};
        vm.filterPapeis.companyId = vm.company.id;
        vm.service = {};
        // Start
        vm.initComponents();
        Category.getLeafs().then(function(categoriesLeaf){
            vm.listLeafsCategories = categoriesLeaf.itens;
            Attendance.getPublishLevel().then(function(publishLevels){
                vm.selectize_publish_levels_modal = publishLevels;
                Attendance.getSituations().then(function(situations){
                    vm.selectize_sources_situations_unmodified = situations;                    
                    Form.getSimple(vm.filterForm).then(function (forms){
                        vm.selectize_forms = forms;
                        Papel.get(vm.filterPapeis).then(function (papeis) {
                            vm.papeis = papeis;
                            Category.geListMappings().then(function(mappings) {
                                if (mappings) {
                                    for (var i = APPLICATION.INT_ZERO; i < mappings.length; i++) {
                                        vm.integrations_service_situation_modal.push({ id: mappings[i], description: mappings[i] });
                                    }                                    
                                }
                                vm.iconsCategoryCode = Category.iconsListMobileCare();
                                vm.file_attachments_type = [{id: ".xml", description:"XML"}, {id:".json", description:"JSON"}];
                                if($stateParams.id){
                                    vm.operacao = 'Editar';            
                                    vm.isEdit = true;
                                    Category.getServiceById($stateParams.id).then(function(service){
                                        vm.processService(service);
                                        vm.isLoading = false;
                                        vm.isComponentLoading = false;  
                                    });
                                }else{
                                    vm.isEdit = false;
                                    vm.operacao = 'Cadastrar';                                    
                                    vm.service.isActive = true;
                                    vm.service.serviceSituations = [];
                                    vm.service.accessPermissions = [];                                    
                                    vm.selectize_sources_situations = JSON.parse(JSON.stringify(vm.selectize_sources_situations_unmodified));
                                    vm.isLoading = false;
                                    vm.isComponentLoading = false;  
                                }
                            });
                        });
                    });
                })
            })
        })
    }

    vm.holdSituationModal = function() {
        vm.holdSituationModalItem = true;
    };

    vm.freeSituationModal = function() {
        vm.holdSituationModalItem = false;
    };

    vm.gatewaySituationsService = function(index, item, create, update) {
        if (index == 1) {
            if (!vm.holdSituationModalItem) {
                vm.openModalServiceSituation(item, create, update);    
            }                
        } else if (index == 2) {
            vm.removeSituationOfService(item); 
        }
    };

    vm.openModalServiceSituation = function(item, create, update) {        
        vm.isEditSituationModal = update;
        vm.isCreateSituationModal = create;        
        vm.tempServiceSituation = {};        
        var flagSituationAdded = false;

        if (vm.isCreateSituationModal) { 
            vm.integrationType = 'none';
            if (vm.service.serviceSituations) {
                for (var i = 0; i < vm.service.serviceSituations.length; i++) {
                    if (vm.service.serviceSituations[i].situationId == vm.filters.situationId) {
                        Common.mensagemError(APPLICATION.STRING_MSG_SITUACAO_JA_ADICIONADA);
                        flagSituationAdded = true;
                        break;
                    }
                }

                if (flagSituationAdded) {
                    return;
                }

                if (vm.service.serviceSituations.length == 0) {
                    vm.tempServiceSituation.isInitial = APPLICATION.BOOLEAN_TRUE;
                }
            } else {
                vm.tempServiceSituation.isInitial = APPLICATION.BOOLEAN_TRUE;
            }

            // Obtem o id e a descrição da situação selecionada.
            if (!flagSituationAdded) {
                for (var i = APPLICATION.INT_ZERO; i < vm.selectize_sources_situations.length; i++) {
                    if (vm.selectize_sources_situations[i].id == vm.filters.situationId) {
                        vm.tempServiceSituation.situationId = vm.selectize_sources_situations[i].id;
                        vm.tempServiceSituation.situation = {};
                        vm.tempServiceSituation.situation.id = vm.selectize_sources_situations[i].id;
                        vm.tempServiceSituation.situation.description = vm.selectize_sources_situations[i].description;
                        vm.tempServiceSituation.availableSituation = [];
                        vm.tempServiceSituation.reasons = [];
                        vm.tempServiceSituation.order = vm.service.serviceSituations.length;
                        break;
                    }
                }                     
            }
        } else if (vm.isEditSituationModal) {
            //avoid reference to the original object: Json.parse(json.stringfy(...))
            vm.integrationType = item.emailIntegrationConfig ? 'email' : item.mappingIntegrationConfig ? 'mapping': 'none';
            vm.tempServiceSituation = JSON.parse(JSON.stringify(item));
        }

        var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ADD_SITUACAO_SERVICO), {keyboard:false, bgclose:false});
        modal.show(); 
        $timeout(function() {
          $(vm.getHashTagField(APPLICATION.STRING_CAMPO_TAB_SITUACAO_MODAL)).click();  
        }, 200);
    }

    vm.AddKeyWordToEmailIntegration = function(keyWord){
        if(vm.tempServiceSituation.emailIntegrationConfig.to && vm.tempServiceSituation.emailIntegrationConfig.to.indexOf(keyWord) > -1){
            Common.mensagemError('Envio para o solicitante já foi parametrizado.');
        }else if(vm.tempServiceSituation.emailIntegrationConfig.to && vm.tempServiceSituation.emailIntegrationConfig.to.trim().length > 0){
            vm.tempServiceSituation.emailIntegrationConfig.to = vm.tempServiceSituation.emailIntegrationConfig.to + '; ' + keyWord;
        }else{
            vm.tempServiceSituation.emailIntegrationConfig.to = keyWord;
        }
        
        var customEmailInput = $window.document.getElementById('service_situation_to');
        customEmailInput.focus();
    }

    vm.AddKeyWordToProtocol = function(keyWord){
        if(!vm.service.customProtocol){
            vm.service.customProtocol = '';
        }
        vm.service.customProtocol = vm.service.customProtocol + keyWord;
        var customProtocolInput = $window.document.getElementById('customProtocol');
        customProtocolInput.focus();
    }

    vm.AddKeyWordToMessage = function(keyWord){
        vm.tempServiceSituation.returnMessage = vm.tempServiceSituation.returnMessage + ' ' + keyWord + ' ';
    }

    vm.AddKeyWordToMessagePush = function(keyWord){
        vm.tempServiceSituation.pushMessage = vm.tempServiceSituation.pushMessage + ' ' + keyWord + ' ';
    }

    vm.AddKeyWordToMessageInboxSubject = function(keyWord){
        vm.tempServiceSituation.subjectMessageInbox = vm.tempServiceSituation.subjectMessageInbox + ' ' + keyWord + ' ';
    }

    vm.AddKeyWordToMessageInbox = function(keyWord){
        vm.tempServiceSituation.inboxMessage = vm.tempServiceSituation.inboxMessage + ' ' + keyWord + ' ';
    }

    vm.validateDefaultSituation = function() {
        var index = APPLICATION.INT_ZERO;
        var flag = APPLICATION.BOOLEAN_FALSE;
        vm.tempServiceSituation.isInitial = !vm.tempServiceSituation.isInitial;
        if (vm.service.serviceSituations) {
            for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                if (vm.service.serviceSituations[i].isInitial && vm.service.serviceSituations[i].situationId != vm.tempServiceSituation.id) {
                    flag = APPLICATION.BOOLEAN_TRUE;
                    index = i;
                }
            }

            if (flag && !vm.tempServiceSituation.isInitial) {
                UIkit.modal.confirm(APPLICATION.STRING_MSG_EXISTE_SITUACAO_PADRAO, function () {                    
                    vm.tempServiceSituation.isInitial = APPLICATION.BOOLEAN_TRUE;
                });
            } else {
                vm.tempServiceSituation.isInitial = !vm.tempServiceSituation.isInitial;
            }
        } else {
            vm.tempServiceSituation.isInitial = !vm.tempServiceSituation.isInitial;
        }
    };

    vm.validateMappingIntegration = function(isCancel) {
        $scope.formServiceSituationIntegrationMapping.integration_type.$touched = !isCancel;
    };

    vm.addEditSituationOfService = function(create, update) {  
        var isValid = true;
        if(vm.tempServiceSituation.sendPush && !vm.tempServiceSituation.pushMessage){
            Common.mensagemError('Mensagem de notificação do push não informada')
            return;
        }

        if(vm.tempServiceSituation.sendEmail && !vm.tempServiceSituation.subjectMessageInbox){
            Common.mensagemError('Assunto da mensagem de notificação do inbox não informada')
            return;
        }

        if(vm.tempServiceSituation.sendEmail && !vm.tempServiceSituation.inboxMessage){
            Common.mensagemError('Mensagem de notificação do inbox não informada')
            return;
        }

        if(vm.tempServiceSituation.reasons && vm.tempServiceSituation.reasons.length > 0){
            for(var i = 0; i < vm.tempServiceSituation.reasons.length; i++){
                if(!vm.tempServiceSituation.reasons[i].description || (vm.tempServiceSituation.reasons[i].description && vm.tempServiceSituation.reasons[i].description === '')){
                    Common.mensagemError('Uma mais justificativas não foram preenchidas.');
                    isValid = false;
                    break;
                }
            }
        }

        if(!isValid){
            return;
        }

        if(vm.integrationType === 'none'){
            vm.tempServiceSituation.emailIntegrationConfig = null;
            vm.tempServiceSituation.mappingIntegrationConfig = null;
        }else if(vm.integrationType === 'email'){
            if (!$scope.formServiceSituationIntegrationEmail.$valid) {
                $scope.formServiceSituationIntegrationEmail.$submitted = true;
                Common.mensagemError('Um ou mais itens da configuração de integração não foram preenchidos.');
                return;
            }
            vm.tempServiceSituation.mappingIntegrationConfig = null;
        }else if(vm.integrationType === 'mapping'){
            if (!$scope.formServiceSituationIntegrationMapping.$valid) {                
                $scope.formServiceSituationIntegrationMapping.$submitted = true;
                Common.mensagemError('Um ou mais itens da configuração de integração não foram preenchidos.');
                return;
            }
            vm.tempServiceSituation.emailIntegrationConfig = null;
        }

        vm.service.serviceSituations = !vm.service.serviceSituations ? [] : vm.service.serviceSituations;
        
        if(update){
            for(var i = 0; i < vm.service.serviceSituations.length; i++){
                if(vm.service.serviceSituations[i].situation.id == vm.tempServiceSituation.situation.id){
                    vm.service.serviceSituations[i] = vm.tempServiceSituation;
                }else if(vm.service.serviceSituations[i].isInitial && vm.tempServiceSituation.isInitial){
                    vm.service.serviceSituations[i].isInitial = false;
                }
            }            
        }else{
            if(vm.tempServiceSituation.isInitial){
                for(var i = 0; i < vm.service.serviceSituations.length; i++){
                    vm.service.serviceSituations[i].isInitial = false;
                }
            } 
            vm.service.serviceSituations.push(vm.tempServiceSituation);
            vm.processService(vm.service);
        }
        vm.tempServiceSituation = {};
        $scope.formServiceSituationIntegrationMapping.integration_type.$touched = false;
        var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ADD_SITUACAO_SERVICO), {keyboard:false, bgclose:false});                
        modal.hide();
    }

    vm.selectTabWizard = function(itemNumber, formService) {
        if (itemNumber == APPLICATION.INT_UM) {
            vm.showWizard1();
        } else if (itemNumber == APPLICATION.INT_DOIS) {
            if (vm.formSubmitted(formService)) {
                vm.showWizard2();
            }
        } else if (itemNumber == APPLICATION.INT_TRES) {
            if (vm.formSubmitted(formService)) {
                vm.showWizard3();
            }
        } else if (itemNumber == APPLICATION.INT_QUATRO) {
            if (vm.formSubmitted(formService)) {
                vm.showWizard4();
            }
        }

        vm.configureSelectizeLayout();
    }

    vm.formSubmitted = function(formService) {
        formService.$submitted = APPLICATION.BOOLEAN_TRUE;
        if (formService.$error && formService.$error.required && formService.$error.required.length > 0) {
            return APPLICATION.BOOLEAN_FALSE;
        } else {
            return APPLICATION.BOOLEAN_TRUE;
        }
    };

    vm.addReason = function() {
        if (vm.tempServiceSituation.tempReason) {
            if (!vm.tempServiceSituation.reasons) {
                vm.tempServiceSituation.reasons = [];
            }
            vm.tempServiceSituation.reasons.push({ description: vm.tempServiceSituation.tempReason});    
            vm.tempServiceSituation.tempReason = APPLICATION.NULL;

            if (vm.tempServiceSituation.reasons.length > APPLICATION.INT_TRES) {
                $(vm.getHashTagField(APPLICATION.STRING_SRV_DIV_RSN_LST)).attr(APPLICATION.STRING_STYLE, 'margin-top:0px; height: 206px; overflow-y: scroll;');
            }
        } else {
            UIkit.modal.alert('Informe uma descrição para a justificativa.');
        }
    }

    vm.removeReasonOfSituationOfService = function(item) {
        for (var i = APPLICATION.INT_ZERO; i < vm.tempServiceSituation.reasons.length; i++) {
            if (vm.tempServiceSituation.reasons[i].id == item.id) {
                vm.tempServiceSituation.reasons.splice(i,1); // remove elemento do array;
                vm.tempServiceSituation.tempReason = APPLICATION.NULL;                
                break;
            }
        }

        if (vm.tempServiceSituation.reasons && vm.tempServiceSituation.reasons.length < APPLICATION.INT_QUATRO) {
            $(vm.getHashTagField(APPLICATION.STRING_SRV_DIV_RSN_LST)).attr(APPLICATION.STRING_STYLE, 'margin-top:0px; height: 206px;');
        }
    };

    vm.removeSituationOfService = function(item) {
        UIkit.modal.confirm(APPLICATION.STRING_MSG_DESEJA_EXCLUIR_SITUACAO + item.situation.description + APPLICATION.STRING_QUESTION +'<br><br> Atenção! Essa situação será automaticamente excluida das configurações do fluxo de atendimento.', function () {            
            
            for (var i =0; i < vm.service.serviceSituations.length; i++) {
                if (vm.service.serviceSituations[i].situationId == item.situationId) {                    
                    vm.service.serviceSituations.splice(i, APPLICATION.INT_UM);                    
                    break;
                }
            }
            // Refaz ordenação dos itens no caso de uma exclusao.
            for(var i = 0; i < vm.service.serviceSituations.length ; i++){
                vm.service.serviceSituations[i].order = i;
            }
            vm.processService(vm.service);
            Common.messageSuccess(APPLICATION.STRING_MSG_SITUACAO_REMOVIDA);      
        });
    };

    vm.showWizard1 = function() {
        vm.wizard1 = APPLICATION.BOOLEAN_TRUE;
        vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard3 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard4 = APPLICATION.BOOLEAN_FALSE;
        vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4));
    }

    vm.showWizard2 = function() {
        vm.wizard1 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard2 = APPLICATION.BOOLEAN_TRUE;
        vm.wizard3 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard4 = APPLICATION.BOOLEAN_FALSE;
        vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4));
    }

    vm.showWizard3 = function() {
        vm.wizard1 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard3 = APPLICATION.BOOLEAN_TRUE;
        vm.wizard4 = APPLICATION.BOOLEAN_FALSE;
        vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1));
        vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4));
    }

    vm.showWizard4 = function() {
        vm.wizard1 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard3 = APPLICATION.BOOLEAN_FALSE;
        vm.wizard4 = APPLICATION.BOOLEAN_TRUE;
        $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4)).show();
        $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2)).hide();
        $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3)).hide(); 
        $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1)).hide();
    }

    vm.moveItem = function (origin, destination) {
        var temp = vm.service.serviceSituations[destination];

        if (temp) {
            vm.service.serviceSituations[destination] = vm.service.serviceSituations[origin];
            vm.service.serviceSituations[destination].order = destination;
            vm.service.serviceSituations[origin] = temp;                  
            vm.service.serviceSituations[origin].order = origin;  
        }            
    };

    vm.listItemUp = function (itemIndex) {
        vm.moveItem(itemIndex, itemIndex - 1);
    };

    vm.listItemDown = function (itemIndex) {
        vm.moveItem(itemIndex, itemIndex + 1);
    };

    vm.getHashTagField = function(field) {
        return APPLICATION.STRING_HASHTAG + field;
    }

    vm.getClassField = function(field) {
        return APPLICATION.STRING_POINT + field;
    }

    vm.show = function(field) {
        $(field).show();
    };

    vm.hide = function(field) {
        $(field).hide();
    };

    vm.configureSelectizeLayout = function() {
        $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3)).find('.selectize-input').attr('style', 'border:none !important');
    }

    vm.processService = function (service){
        vm.service = service;
        if(!service.customProtocol){
            vm.service.customProtocol = '';
        }
        vm.service.sla = (service.slaTimeSeconds / APPLICATION.INT_HORA);     
        vm.selectize_sources_situations = JSON.parse(JSON.stringify(vm.selectize_sources_situations_unmodified)); // avoid reference copy of itens.
        // Distinct options for each service situation.
        for(var i = 0, len_i = vm.service.serviceSituations.length; i < len_i;  i++){
            var serviceSituationReference = vm.service.serviceSituations[i];
            for(var z = 0; z < vm.selectize_sources_situations.length; z++){
                if(vm.selectize_sources_situations[z].id === serviceSituationReference.situation.id){
                    vm.selectize_sources_situations.splice(z, 1);
                    break;
                }   
            }
            vm.workflowOptions[serviceSituationReference.situation.id] = {};
            vm.workflowOptions[serviceSituationReference.situation.id].itens = [];
            vm.workflowList[serviceSituationReference.situation.id] = {};
            vm.workflowList[serviceSituationReference.situation.id].itens = [];
            for(var q = 0, len_q = serviceSituationReference.availableSituation.length; q < len_q; q++){
                var availableSituation = serviceSituationReference.availableSituation[q];
                for(var w = 0; w < vm.service.serviceSituations.length; w++){
                    if(availableSituation.situationId === vm.service.serviceSituations[w].situation.id){
                        vm.workflowList[serviceSituationReference.situation.id].itens.push(availableSituation.situationId);
                        break;
                    }
                }
            };
            for(var j = 0, len_j = vm.service.serviceSituations.length; j < len_j; j++){
                var serviceSituation = vm.service.serviceSituations[j];
                if(serviceSituationReference.situation.id !== serviceSituation.situation.id){
                    vm.workflowOptions[serviceSituationReference.situation.id].itens.push({
                        id: null,
                        serviceSituatonId:serviceSituation.id,
                        situationId: serviceSituation.situation.id,
                        situation:{
                            id: serviceSituation.situation.id,
                            description: serviceSituation.situation.description
                        }
                    });
                }
            }           
            
        }

        for (var i = 0; i < vm.papeis.length; i++) {
            for(var j = 0; j < service.accessPermissions.length; j++)
            {
                if(service.accessPermissions[j].roleId === vm.papeis[i].id){
                    vm.papeis[i].checked = true;
                    break;
                }
            }            
        }
    }

    vm.submit = function(service){
        vm.isLoading = true;
        var isValid = vm.validate(service);
        if(isValid){
            service.slaTimeSeconds = (vm.service.sla * APPLICATION.INT_HORA);
            for(var i = 0; i < service.serviceSituations.length; i++){
                var serviceSituation = service.serviceSituations[i];
                var treatedListOfAvailableSituations = [];
                // transforma a list de situation id em objetos do tipo available situation, esperado pelo server;            
                for(var j = 0; j < vm.workflowList[serviceSituation.situation.id].itens.length; j++){
                    treatedListOfAvailableSituations.push({ situationId:  vm.workflowList[serviceSituation.situation.id].itens[j] });
                }
                serviceSituation.availableSituation = treatedListOfAvailableSituations;
            }
            for (var i = 0; i < vm.papeis.length; i++) {
                var founded = false;
                for(var j = 0; j < service.accessPermissions.length; j++)
                {
                    if(service.accessPermissions[j].roleId === vm.papeis[i].id && !vm.papeis[i].checked){
                        service.accessPermissions.splice(i,1);
                        founded = true;
                        break;
                    }else if(service.accessPermissions[j].roleId === vm.papeis[i].id && vm.papeis[i].checked){
                        founded = true;
                        break;
                    }
                }
                if (!founded && vm.papeis[i].checked) {                        
                    service.accessPermissions.push({roleId: vm.papeis[i].id})
                }                
            }
        
            if(vm.isEdit){
                Servico.updateService(service).then(function(result){
                    Common.messageSuccess('Serviço atualizado com sucesso.');
                    $state.go('private.painel.category.list');
                }, function(error) {
                    Common.mensagemError('Desculpe, ocorreu um erro ao tentar atualizar o serviço. Por favor, tente novamente ou contate o administrador do sistema para mais informações.');        
                }).finally(function() {
                    vm.isLoading = false;
                });
            }else{
                Servico.post(vm.getObjectToSubmit(service)).then(function(result){
                    Common.messageSuccess('Serviço cadastro com sucesso.');
                    $state.go('private.painel.category.list');
                }, function(error) {
                    Common.mensagemError('Desculpe, ocorreu um erro ao tentar cadastrar o serviço. Por favor, tente novamente ou contate o administrador do sistema para mais informações.');        
                }).finally(function() {
                    vm.isLoading = false;
                });
            }

        } else {
            vm.isLoading = false;
        }            
    }

    vm.getObjectToSubmit = function(service) {
        var preparedObject = JSON.parse(JSON.stringify(service));
        for(var i = 0; i < preparedObject.serviceSituations.length; i++){
            preparedObject.serviceSituations[i].situation = null;
        }
        return preparedObject;
    }

    vm.validateSLA = function (evt) {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        var regex = APPLICATION.STRING_PATTERN_ONLY_NUMBERS;

        if (theEvent.keyCode == APPLICATION.INT_OITO) {
            return APPLICATION.BOOLEAN_TRUE;
        }

        if (!regex.test(key)) {
            theEvent.returnValue = APPLICATION.BOOLEAN_FALSE;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    vm.validate = function(service){
        var countDefaultSituation = 0;
        if(service.serviceSituations){
            for(var i = 0; i < service.serviceSituations.length; i++){
                var serviceSituation = service.serviceSituations[i];
                if(serviceSituation.isInitial){
                    countDefaultSituation++;
                }            
            }
        }        

        if(countDefaultSituation === 0){
            Common.mensagemError('O Serviço deve possuir uma situação inicial padrão.');
            return false;
        }else if(countDefaultSituation > 1){
            Common.mensagemError('O Serviço deve possuir apenas umas situação inicial padrão.');
            return false;
        }
        return true;
    }

    vm.showIntegrationConfigNone = function() {
        vm.integrationType = "none";
        vm.tempServiceSituation.emailIntegrationConfig = null;
        vm.tempServiceSituation.mappingIntegrationConfig = null;        
    }

    vm.showIntegrationConfigEmail = function(emailIntegrationConfig) {
        vm.integrationType = "email";
        if(emailIntegrationConfig == null){
            vm.tempServiceSituation.emailIntegrationConfig = {};
        }else{
            vm.tempServiceSituation.emailIntegrationConfig = emailIntegrationConfig;
        }
    }

    vm.showIntegrationConfigExternal = function(mappingIntegrationConfig) {
        vm.integrationType = "mapping";
        if(mappingIntegrationConfig == null){
            vm.tempServiceSituation.mappingIntegrationConfig = {};
        }else{
            vm.tempServiceSituation.mappingIntegrationConfig = mappingIntegrationConfig;
        }
    }

    vm.selectNextWizard = function(formService) {
        if (vm.formSubmitted(formService)) {
            if (vm.wizard1) {
                vm.showWizard2();
            } else if (vm.wizard2) {
                vm.showWizard3();
            } else if (vm.wizard3) {
                vm.showWizard4();
            }
        }

        vm.configureSelectizeLayout();
    }

    vm.selectBackWizard = function() {
        if (vm.wizard2) {
            vm.showWizard1();
        } else if (vm.wizard3) {
            vm.showWizard2();
        } else if (vm.wizard4) {
            vm.showWizard3();
        }

        vm.configureSelectizeLayout();
    }

    vm.openModalConfirmacaoDeCancelamento = function() {
        var modalConfirmCancelamento = UIkit.modal('.cancelar', {keyboard:false, bgclose:false});
        modalConfirmCancelamento.show();
    }

    vm.openModalServiceIcons = function() {
        var modalIcons = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES_SERVICE), {keyboard:false, bgclose:false});        
        modalIcons.show();
    }

    vm.selectIconService = function(item) {
        vm.service.icon = item.id;
        var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES_SERVICE), {keyboard:false, bgclose:false});
        modal.hide();
    }    
    
    vm.options = {
        language: 'pt',
        allowedContent: true,
        entities: false,
        toolbar: 'custom',
        toolbar_custom: [            
            { 
                name: 'basicstyles', 
                items: ['Bold', 'Italic', 'Strike', 'Underline']
            }
        ]
    };

    vm.removeIcon = function() {
        vm.service.icon = null;
    }

    vm.initComponents = function(){
        vm.tempServiceSituation = {};
        vm.listLeafsCategories = [];
        vm.selectize_publish_levels_modal = [];
        vm.selectize_sources_situations_unmodified = [];
        vm.selectize_sources_situations = [];
        vm.selectize_forms = [];
        vm.workflowOptions = [];
        vm.workflowList = [];
        vm.papeis = [];
        vm.integrations_service_situation_modal = [];
        vm.wizard1 = true;
        vm.file_attachments_type = [];

        vm.selectize_config = {
            plugins: { remove_button: { label: '' } },
            maxItems: 1,
            valueField: APPLICATION.STRING_ID,
            labelField: APPLICATION.STRING_DESCRIPTION,
            create: APPLICATION.BOOLEAN_FALSE,
            sortField: {
                field: 'description',
                direction: 'asc'
            },
            render: {
                option: function (sources, escape) {
                    return '<div class="option">' +
                        '<span class="title">' + escape(sources.description) + '</span>' +
                        '</div>';
                },
                item: function (sources, escape) {
                    return '<div class="item">' + escape(sources.description) + '</div>';
                }
            }
        };
        vm.selectize_forms_config = {
            plugins: { remove_button: { label: '' } },
            maxItems: 1,
            valueField: 'rootParent',
            labelField: 'title',
            create: APPLICATION.BOOLEAN_FALSE,
            sortField: 'title',
            render: {
                option: function (sources, escape) {
                    return '<div class="option">' +
                        '<span class="title">' + escape(sources.title) + '</span>' +
                        '</div>';
                },
                item: function (sources, escape) {
                    return '<div class="item">' + escape(sources.title) + '</div>';
                }
            }
        };  
        vm.selectize_workflow_config = {
            plugins: { remove_button: { label: '' } },
            maxItems: APPLICATION.NULL,
            valueField: APPLICATION.STRING_SITUATION_ID,
            labelField: APPLICATION.STRING_DESCRIPTION,
            create: APPLICATION.BOOLEAN_FALSE,
            render: {
                option: function (sources, escape) {
                    return '<div class="option">' +
                        '<span class="title">' + escape(sources.situation.description) + '</span>' +
                        '</div>';
                },
                item: function (sources, escape) {
                    return '<div class="item">' + escape(sources.situation.description) + '</div>';
                }
            }
        };      
    }

    vm.accessIsAllowed = Security.exitsProfilePermission({ id: APPLICATION.INT_DOIS, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "C" }) 
        || Security.exitsProfilePermission({ id: APPLICATION.INT_TRES, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "U" });
    angular.extend(this, $controller('BaseApp', {$scope: this}));
    //vm.init();
}
    
angular.module('app.category')
    .controller('CategoryCreateController', CategoryCreateController);
})();

(function () {
    'use strict';

    /** @ngInject */
    function CategoryListController(Company, $controller, Papel, Form, Attendance, $filter, $interval, $rootScope, $scope, Category, Servico, Common, Security, APPLICATION, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, $state, DashboardCompany) {
        var vm = this;
        $rootScope.primarySidebarActive = true;

        /// <description>
        /// Método responsável por set true no field.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.setTrue = function(field) {
            field = APPLICATION.BOOLEAN_TRUE;
        };

        /// <description>
        /// Método responsável por set false no field.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.setFalse = function(field) {
            field = APPLICATION.BOOLEAN_FALSE;
        };

        //Permissões
        vm.setFalse(vm.isCategoryVisualizarPermitido);
        vm.setFalse(vm.isCategoryDeletarPermitido);
        vm.setFalse(vm.isCategoryCadastrarPermitido);
        vm.setFalse(vm.isCategoryEditarPermitido);

        /// <description>
        /// Método responsável pela configuração das permissões de acesso.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.configurarPermissoes = function () {
            vm.isCategoryVisualizarPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_UM, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "R" });
            vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_DOIS, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "C" });
            vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_TRES, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "U" });
            vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_QUATRO, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "S" });
            vm.isCategoryExcluirPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_CINCO, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "D" });
            vm.isCategoryAtivarPermitido = Security.exitsProfilePermission({ id: APPLICATION.INT_SEIS, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "AD" });
        };

        /// <description>
        /// Método responsável por retornar o campo tratado para o get no DOM.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getHashTagField = function(field) {
            return APPLICATION.STRING_HASHTAG + field;
        }

        /// <description>
        /// Método responsável por retornar o campo tratado como classe para o get no DOM.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getClassField = function(field) {
            return APPLICATION.STRING_POINT + field;
        }

        /// <description>
        /// Método responsável por exibir itens no DOM.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.show = function(field) {
            $(field).show();
        };

        /// <description>
        /// Método responsável por esconder itens no DOM.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.hide = function(field) {
            $(field).hide();
        };

        /// <description>
        /// Método responsável por efetuar toggle em itens no DOM.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.toggle = function(field, animationSlow) {
            if (animationSlow) {
                $(field).toggle(APPLICATION.STRING_SLOW);
            } else {
                $(field).toggle();    
            }            
        };

        /// <description>
        /// Método responsável pela listagem das categorias folha.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getLeafsCategories = function (filters) {
            vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;
            vm.isLoading = APPLICATION.BOOLEAN_TRUE;            

            // Listagem das categorias folhas.
            return Category.getLeafs(filters).then(function (categories) {
                // Obtém os itens das categorias folha.
                vm.listLeafsCategories = categories.itens;                
                return vm.listLeafsCategories;
            });
        };

        /// <description>
        /// Método responsável por adicionar recursivamente as categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.addRecursiveSubCategories = function(list) {
            if (list.subCategories && list.subCategories.length > 0) {
                for (var j = APPLICATION.INT_ZERO; j < list.subCategories.length; j++) {
                    if (list.subCategories[j].subCategories && list.subCategories[j].subCategories.length > 0) {
                        list.subCategories[j].marginLeft = (list.subCategories[j].level * 30) + 'px';
                        vm.newListCategoriesHierarchy.push(list.subCategories[j]);
                        vm.addRecursiveSubCategories(list.subCategories[j]);
                    } else {
                        list.subCategories[j].marginLeft = (list.subCategories[j].level * 30) + 'px';
                        vm.newListCategoriesHierarchy.push(list.subCategories[j]);
                        vm.addRecursiveSubCategories(list.subCategories[j]);
                    }                    
                }
            }
        };

        /// <description>
        /// Método responsável por calcular as categorias em hierarquia.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.calculateCategories = function() {
            vm.tempListCategory = JSON.parse(JSON.stringify(vm.newListCategories));

            for (var i = APPLICATION.INT_ZERO; i < vm.tempListCategory.length; i++) {
                vm.newListCategoriesHierarchy.push(vm.tempListCategory[i]);
                vm.addRecursiveSubCategories(vm.tempListCategory[i]);
            }

            return vm.newListCategoriesHierarchy;
        };

        /// <description>
        /// Método responsável por organizar as categorias de forma específica para hierarquização.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getCategoryByIdSpecific = function(list) {
            if (list && list.length > APPLICATION.INT_ZERO) {
                if (!list[APPLICATION.INT_ZERO].parentId) {
                    return Category.getById(list[APPLICATION.INT_ZERO].id).then(function (category) {
                        category.servicesCount = list[APPLICATION.INT_ZERO].servicesCount;
                        vm.newListCategories.push(category);
                        list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.getCategoryByIdSpecific(list);
                    });      
                } else {
                    list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.getCategoryByIdSpecific(list);
                }              
            } else {
                var categories = {};
                //categories.itens = vm.newListCategories;
                categories.itens = vm.calculateCategories();

                for (var i = APPLICATION.INT_ZERO; i < categories.itens.length; i++) {
                    for (var j = APPLICATION.INT_ZERO; j < vm.categoriesFather.length; j++) {
                        if (categories.itens[i].id == vm.categoriesFather[j].id) {
                            categories.itens[i].servicesCount = vm.categoriesFather[j].servicesCount;
                            break;
                        }
                    }                    
                }

                // Salva a lista de categorias e o backup para a pesquisa.
                vm.categories = categories.itens;
                vm.categories_backup = categories.itens;

                if (vm.categories && vm.selectedCategoryItem) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                        if (!vm.categories[i].subCategories || vm.categories[i].subCategories.length == APPLICATION.INT_ZERO) {
                            if (vm.categories[i].description == vm.selectedCategoryItem.description) {
                                vm.categories = vm.cleanSelectedCategorie(vm.categories);
                                vm.selectedCategory = vm.categories[i].description;
                                vm.selectedCategoryItem = vm.categories[i];
                                vm.categories[i].isSelected = true;
                                vm.getServices(vm.categories[i]);
                                break;
                            }
                        }
                    }
                }

                if (!vm.categories[vm.selectedCategoryIndex]) {
                    // Verifica se existem categorias na lista.
                    if (vm.categories.length > APPLICATION.INT_ZERO) {
                        // Seleciona a primeira categoria da lista.
                        vm.selectedCategory = vm.categories[APPLICATION.INT_ZERO].description;

                        var itemSelectedFuture = {}; 
                        var indexItemSelectedFuture = APPLICATION.INT_ZERO; 

                        for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                            if (!vm.categories[i].subCategories || vm.categories[i].subCategories.length == APPLICATION.INT_ZERO) {
                                itemSelectedFuture = vm.categories[i];
                                indexItemSelectedFuture = i;
                                break;
                            }
                        }

                        // Efetua a busca dos serviços daquela categoria.
                        vm.selectService(itemSelectedFuture, indexItemSelectedFuture);
                    } else {
                        // Informa o usuário que não existe categoria na lista.
                        vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;
                    }
                }         

                // Interrompe os loadings.
                vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
                vm.isLoading = APPLICATION.BOOLEAN_FALSE;

                vm.categoryModal = {};
                vm.categoryModal.parentId = APPLICATION.INT_ZERO;
                
                // Retorna a listagem de categorias.
                return vm.categories;
            }            
        };

        /// <description>
        /// Método responsável por organizar as categorias para hierarquização.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getCategoryById = function(list) {
            if (list && list.length > APPLICATION.INT_ZERO) {
                if (!list[APPLICATION.INT_ZERO].parentId) {
                    return Category.getById(list[APPLICATION.INT_ZERO].id).then(function (category) {
                        category.servicesCount = list[APPLICATION.INT_ZERO].servicesCount;
                        vm.newListCategories.push(category);
                        list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.getCategoryById(list);
                    });      
                } else {
                    list.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.getCategoryById(list);
                }              
            } else {
                var categories = {};
                //categories.itens = vm.newListCategories;
                categories.itens = vm.calculateCategories();

                for (var i = APPLICATION.INT_ZERO; i < categories.itens.length; i++) {
                    for (var j = APPLICATION.INT_ZERO; j < vm.categoriesFather.length; j++) {
                        if (categories.itens[i].id == vm.categoriesFather[j].id) {
                            categories.itens[i].servicesCount = vm.categoriesFather[j].servicesCount;
                            break;
                        }
                    }                    
                }

                // Salva a lista de categorias e o backup para a pesquisa.
                vm.categories = categories.itens;
                vm.categories_backup = categories.itens;

                // Verifica se existem categorias na lista.
                if (vm.categories.length > APPLICATION.INT_ZERO) {
                    // Seleciona a primeira categoria da lista.
                    vm.selectedCategory = vm.categories[APPLICATION.INT_ZERO].description;

                    var itemSelectedFuture = {}; 
                    var indexItemSelectedFuture = APPLICATION.INT_ZERO; 

                    for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                        if (!vm.categories[i].subCategories || vm.categories[i].subCategories.length == APPLICATION.INT_ZERO) {
                            itemSelectedFuture = vm.categories[i];
                            indexItemSelectedFuture = i;
                            break;
                        }
                    }

                    // Efetua a busca dos serviços daquela categoria.
                    vm.selectService(itemSelectedFuture, indexItemSelectedFuture);
                } else {
                    // Informa o usuário que não existe categoria na lista.
                    vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;
                }

                // Interrompe os loadings.
                vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
                vm.isLoading = APPLICATION.BOOLEAN_FALSE;
                
                // Retorna a listagem de categorias.
                return vm.categories;
            }            
        };

        /// <description>
        /// Método responsável por organizar as categorias para hierarquização (depreciado).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getCategoryByIdOld = function(list) {
            var listCategories = [];

            for (var i = APPLICATION.INT_ZERO; i < list.length; i++) {
                if (!list[i].parentId) {
                    listCategories.push(list[i]);
                    list.splice(i, APPLICATION.INT_UM);
                    break;
                }    
            }

            // Salva a lista de categorias e o backup para a pesquisa.
            vm.categories = list;
            vm.categories_backup = list;

            // Verifica se existem categorias na lista.
            if (vm.categories.length > APPLICATION.INT_ZERO) {
                // Seleciona a primeira categoria da lista.
                vm.selectedCategory = vm.categories[APPLICATION.INT_ZERO].description;

                // Efetua a busca dos serviços daquela categoria.
                vm.selectService(vm.categories[APPLICATION.INT_ZERO], APPLICATION.INT_ZERO);
            } else {
                // Informa o usuário que não existe categoria na lista.
                vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;
            }

            // Interrompe os loadings.
            vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
            vm.isLoading = APPLICATION.BOOLEAN_FALSE;
            
            // Retorna a listagem de categorias.
            return vm.categories;          
        };

        /// <description>
        /// Método responsável pela listagem das categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getCategories = function (filters) {
            vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;
            vm.isLoading = APPLICATION.BOOLEAN_TRUE;            

            // Listagem das categorias folhas.
            return Category.get(filters).then(function (categories) {
                vm.categories = [];
                vm.categoriesFather = [];
                vm.newListCategories = [];
                vm.newListCategoriesHierarchy = [];

                var categoriesFatherTemp = JSON.parse(JSON.stringify(categories.itens));

                if (categoriesFatherTemp) {
                    for (var i = APPLICATION.INT_ZERO; i < categoriesFatherTemp.length; i++) {
                        if (categoriesFatherTemp[i].servicesCount == 0) {
                            vm.categoriesFather.push(categoriesFatherTemp[i]);
                        }
                    }
                }

                vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: 'Sem categoria pai'});

                vm.getCategoryByIdSpecific(categories.itens);
                //vm.getCategoryById(categories.itens);
            });
        };

        /// <description>
        /// Método responsável pela listagem dos serviços.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getServices = function (filters, notLoadSpinner) {
            if(!notLoadSpinner){
                vm.isLoading = APPLICATION.BOOLEAN_TRUE;
            }

            // Listagem dos serviços por categoria selecionada.
            return Servico.getByCategorySimple(filters).then(function (services) {
                if (vm.selectize_forms) {
                    for (var j = APPLICATION.INT_ZERO; j < services.length; j++) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.selectize_forms.length; i++) {                        
                            if (services[j].formId == vm.selectize_forms[i].id ||
                                services[j].formId == vm.selectize_forms[i].rootParent) {
                                services[j].form = vm.selectize_forms[i];
                                break;
                            }
                        }
                        
                    }    
                }

                // Salva a lista de serviços e o backup para a pesquisa.
                vm.services = services;
                vm.services_backup = services;    

                // Efetua a atualização do count services para a categoria selecionada.
                vm.countServicesOfCategory(); 

                // Interrompe o loading.
                if(!notLoadSpinner){
                    vm.isLoading = APPLICATION.BOOLEAN_FALSE;
                }
                // Retorna a listagem de serviços.
                return vm.services;
            });
        };

        /// <description>
        /// Método responsável por verificar se o método foi alterado.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.isUpdatedFormService = function() {
            for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFather.length; i++) {
                if (vm.service.categoryId == vm.categoriesFather[i].id) {
                    vm.selectedCategoryItem = vm.categoriesFather[i];
                    break;
                }
            }
            
            if (vm.service && vm.serviceOrigin) {
                if (vm.service.categoryId != vm.serviceOrigin.categoryId ||
                    vm.service.description != vm.serviceOrigin.description ||
                    vm.service.formId != vm.serviceOrigin.formId ||
                    vm.service.publishLevelId != vm.serviceOrigin.publishLevelId ||
                    vm.service.sla != vm.serviceOrigin.sla ||
                    vm.service.icon != vm.serviceOrigin.icon) {
                    vm.isUpdatedFormServiceModel = true;
                }

                if (vm.service.serviceSituations && vm.serviceOrigin.serviceSituations) {
                    if (vm.service.serviceSituations.length != vm.serviceOrigin.serviceSituations.length) {
                        vm.isUpdatedFormServiceModel = true;
                    }
                    
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        if ((vm.service.serviceSituations[i] && vm.serviceOrigin.serviceSituations[i]) &&
                            (vm.service.serviceSituations[i].order != vm.serviceOrigin.serviceSituations[i].order)) {
                            vm.isUpdatedFormServiceModel = true;
                            break;
                        }

                        if (vm.service.serviceSituations.length != vm.serviceOrigin.serviceSituations.length) {
                            vm.isUpdatedFormServiceModel = true;
                            break;
                        } else {
                            if (vm.service.serviceSituations[i].situation) {
                                if (vm.service.serviceSituations[i].situation.description != vm.serviceOrigin.serviceSituations[i].situation.description) {
                                    vm.isUpdatedFormServiceModel = true;
                                    break;
                                }
                            } else {
                                if (vm.service.serviceSituations[i].description != vm.serviceOrigin.serviceSituations[i].description) {
                                    vm.isUpdatedFormServiceModel = true;
                                    break;
                                }
                            }
                        }
                    }
                }

                if (vm.papeis && vm.papeisOrigin) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.papeis.length; i++) {
                        if (vm.papeis[i].checked != vm.papeisOrigin[i].checked) {
                            vm.isUpdatedFormServiceModel = true;
                            break;
                        }
                    }
                }

                if (!vm.service.isActiveNew != vm.serviceOrigin.isActive) {
                    vm.isUpdatedFormServiceModel = true;
                }
            }
        };

        /// <description>
        /// Método responsável pela listagem de publish level.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getPublishLevel = function () {
            // Listagem de publish level.
            return Attendance.getPublishLevel().then(function (publishLevels) {
                // Salva a lista de publish level para a pesquisa e para o modal.
                vm.selectize_publish_levels_modal = JSON.parse(JSON.stringify(publishLevels));
                vm.selectize_publish_levels = JSON.parse(JSON.stringify(publishLevels));
                vm.selectize_publish_levels_search = JSON.parse(JSON.stringify(publishLevels));

                // Adiciona o item de pesquisa por todos.
                vm.selectize_publish_levels.push({id: APPLICATION.STRING_NUMERO_0, description: APPLICATION.STRING_TODOS});

                vm.selectize_publish_levels_search.push({id: APPLICATION.STRING_NUMERO_0, description: APPLICATION.STRING_TODOS});
                
                // Retorna a listagem de publish level.
                return vm.selectize_publish_levels;
            });
        };

        /// <description>
        /// Método responsável pela listagem de arquivados.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getArchived = function () {
            vm.archiveList.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_TODOS});
            vm.archiveList.push({ id: APPLICATION.INT_UM, description: APPLICATION.STRING_SIM_MIN });
            vm.archiveList.push({ id: APPLICATION.INT_DOIS, description: APPLICATION.STRING_NAO_MIN });
            
            vm.archivedCategoryDescription = APPLICATION.INT_DOIS;
            vm.archivedServiceDescription = APPLICATION.INT_DOIS;
        };

        /// <description>
        /// Método responsável pela listagem de formulários.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getForms = function () {
            // Zera o filtro principal;
            vm.filter = {};
            // Informa o app company id para a pesquisa.
            vm.filter.appCompanyId = vm.appCompany.id;
            // Informa o módulo par a pesquisa.
            vm.filter.Modulo = APPLICATION.STRING_RELACIONAMENTO;
            vm.filter.activeIds = true;
            // Carrega os dados de formulário.
            vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_TRUE;

            // Efetua a pesquisa de formulários baseada no filtro.
            return Form.getSimple(vm.filter).then(function (forms) {
                vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_FALSE;

                // Salva a lista de formulários para o combo do CRUD de serviços.
                vm.selectize_forms = forms;

                if (forms.length == APPLICATION.INT_ZERO) {
                    vm.selectize_forms_add.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_CADASTRAR });
                }

                // Efetua o carregamento para combo de situações.
                return vm.getSituations();
            });
        }; 

        vm.goToFeatureForms = function() {
            $state.go('private.painel.form.list');
        };

        /// <description>
        /// Método responsável pela listagem de situações.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getSituations = function () {
            // Listagem de situações.
            return Attendance.getSituations().then(function (result) {
                // Salva a lista de situações para o combo do CRUD de serviços.
                vm.selectize_sources_situations = result;

                // Retorna a listagem de situações.
                return vm.selectize_sources_situations;
            });
        };

        /// <description>
        /// Método responsável por fechar o modal de categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.closeModalCategory = function() {
            $timeout(function() {
                document.getElementById(APPLICATION.STRING_SRV_BTN_MDL_CAT).click();
            }, 200);
        };

        /// <description>
        /// Método responsável por limpar a seleção das categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.cleanSelectedCategorie = function(list) {
            if (list) {
                for (var i = APPLICATION.INT_ZERO; i < list.length; i++) {
                    list[i].isSelected = false;
                }    
            }   

            return list;         
        }

        /// <description>.
        /// Método responsável por fechar o modal de categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectService = function(item, index) {
            if (!item.subCategories || item.subCategories.length == 0) {
                vm.categories = vm.cleanSelectedCategorie(vm.categories);
                vm.categories[index].isSelected = true;
                vm.selectedCategory = item.description;
                vm.selectedCategoryItem = item;
                vm.selectedCategoryIndex = index;
                vm.getServices(item);
            }
        };

        /// <description>
        /// Método responsável pelo cadastro e atualização das categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitCategory = function(category) {
            category.publishLevelId = vm.filters.publishLevelsCategoryModalDescription;
            vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_TRUE;
            //vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;
            var itemCategoryUpdated = {};

            vm.categoryModal.parentId = vm.categoryModal.parentId == APPLICATION.INT_ZERO ? null : vm.categoryModal.parentId;
            category.id = vm.categoryModal.id;
            category.description = vm.categoryModal.description;
            category.icon = vm.categoryModal.icon;
            category.isActive = vm.categoryModal.isActive;
            category.parentId = vm.categoryModal.parentId;  
            category.publishLevelId = vm.categoryModal.publishLevelId === APPLICATION.INT_ZERO ? null : vm.categoryModal.publishLevelId;

            // Verifica se a requisição é de cadastro ou atualização.
            if (vm.category && vm.category.create) {
                for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFather.length; i++) {
                    if (vm.categoriesFather[i].id == category.parentId) {
                        category.level = (vm.categoriesFather[i].level + 1);
                        break;
                    }
                }

                // Efetua o cadastro da categoria.
                return Category.postCategory(category).then(function (response) {                    
                    Category.getLeafs().then(function (categories) { vm.listLeafsCategories = categories.itens; });
                    Common.messageSuccess(APPLICATION.STRING_MSG_CATEGORIA_CADASTRADA);
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    // vm.closeModalCategory();
                    vm.category = {}; 

                    // Listagem das categorias.
                    return Category.get(vm.filters).then(function (categories) {
                        if(!vm.selectedCategoryItem){
                            vm.selectedCategoryItem = {};
                        }
                        vm.selectedCategoryItem.description = response.description;
                        vm.selectedCategoryItem = response;
                        vm.categories = [];
                        vm.categoriesFather = [];
                        vm.newListCategories = [];
                        vm.newListCategoriesHierarchy = [];

                        vm.categoriesFatherTemp = JSON.parse(JSON.stringify(categories.itens));
                        if (vm.categoriesFatherTemp) {
                            for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFatherTemp.length; i++) {
                                if (vm.categoriesFatherTemp[i].servicesCount <= 0) {
                                    vm.categoriesFather.push(vm.categoriesFatherTemp[i]);
                                }
                            }
                        }

                        
                        vm.getCategoryByIdSpecific(categories.itens);
                        vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_MSG_SEM_CATEGORIA_PAI});

                        vm.categoryModal = {};
                        vm.categoryModal.parentId = APPLICATION.INT_ZERO;
                    });
                }, function(error) {
                    console.log(error);                    
                }).finally(function() {
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
                    vm.closeModalCategory();
                    vm.category = {}; 
                });
            } else if (vm.category && vm.category.update) {
                itemCategoryUpdated.id = category.id;
                itemCategoryUpdated.description = category.description;
                itemCategoryUpdated.appCompanyId = category.appCompanyId;
                itemCategoryUpdated.icon = category.icon;
                itemCategoryUpdated.isActive = category.isActive;
                itemCategoryUpdated.publishLevelId = category.publishLevelId;
                itemCategoryUpdated.parentId = vm.categoryModal.parentId;

                // Efetua a atualização da categoria.
                return Category.putCategory(itemCategoryUpdated).then(function (response) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                        if (vm.categories[i].id == response.id) {
                           vm.categories[i].isSelected = true;
                           vm.selectedCategoryItem = vm.categories[i];
                           vm.selectedCategory = vm.categories[i].description;
                        }
                    }

                    Category.getLeafs().then(function (categories) { vm.listLeafsCategories = categories.itens; });
                    Common.messageSuccess(APPLICATION.STRING_MSG_CATEGORIA_ATUALIZADA);
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    // vm.closeModalCategory();
                    vm.category = {};
                    
                    // Listagem das categorias.
                    return Category.get(vm.filters).then(function (categories) {
                        vm.categories = [];
                        vm.categoriesFather = [];
                        vm.newListCategories = [];
                        vm.newListCategoriesHierarchy = [];                        

                        vm.getCategoryByIdSpecific(categories.itens);
                        vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_MSG_SEM_CATEGORIA_PAI});

                        vm.categoryModal = {};
                        vm.categoryModal.parentId = APPLICATION.INT_ZERO;
                    });
                }, function(error) {
                    console.log(error);
                }).finally(function() {
                    vm.isLoadingCategoryForm = APPLICATION.BOOLEAN_FALSE;
                    //vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
                    vm.closeModalCategory();
                    vm.category = {}; 
                });
            }
        } 

        /// <description>
        /// Método responsável por abrir o modal de categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.openModalCategory = function(item, create, update, detail) {
            vm.isLoadingCategoryForm = true;
            vm.category = item != APPLICATION.NULL ? item : {};
            vm.category.create = create;
            vm.category.update = update;
            vm.category.detail = detail;
            vm.categoryModal = {};
            vm.categoryModal.parentId = APPLICATION.INT_ZERO;
            vm.categoryModal.publishLevelId = APPLICATION.INT_ZERO;

            if (item) {     
                vm.categoryModal.id = item.id;           
                vm.categoryModal.description = item.description;
                vm.categoryModal.icon = item.icon;
                vm.categoryModal.isActive = item.isActive;
                vm.categoryModal.isArquivado = !item.isActive;
                vm.categoryModal.parentId = item.parentId ? item.parentId: APPLICATION.INT_ZERO;
                if(item.publishLevel){
                    vm.categoryModal.publishLevelId = item.publishLevel.id;
                }
            }else{
                vm.categoryModal.isActive = true;
            }

            Category.get(vm.filters).then(function (categories) {
                vm.categoriesFather = [];

                vm.categoriesFatherTemp = JSON.parse(JSON.stringify(categories.itens));
                if (vm.categoriesFatherTemp) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.categoriesFatherTemp.length; i++) {
                        if (vm.categoriesFatherTemp[i].servicesCount <= 0) {
                            if((item && item.id !== vm.categoriesFatherTemp[i].id) || !item ){
                                vm.categoriesFather.push(vm.categoriesFatherTemp[i]);
                            }
                        }
                    }
                }                
                vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_MSG_SEM_CATEGORIA_PAI});
                vm.isLoadingCategoryForm = false;
            });

            // ByPass no ng-if - lentidão do angular.
            if (create) {
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_SALVAR_CATEGORIA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA));
                // vm.filters.publishLevelsCategoryModalDescription = APPLICATION.NULL;
            } else if (detail) {
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA));
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_SALVAR_CATEGORIA));
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA));                
            } else {
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_SALVAR_CATEGORIA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_ADICIONAR_ICONE_CATEGORIA));
            }

            if (vm.category.isActive || !item) {
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_INATIVA));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA_MODAL));
            } else {
                vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_ATIVA_MODAL));
                vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_CATEGORIA_INATIVA));
            }
            
            var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_CATEGORIAS), {keyboard:false, bgclose:false});
            modal.show();
        }

        /// <description>
        /// Método responsável por abrir o modal de ícones da categorias.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.openModalCategoryIcons = function() {
            if ((vm.category || !vm.category) && !vm.category.detail) {
                var modalIcons = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES), {keyboard:false, bgclose:false});
                modalIcons.show();
            }
        }

        vm.getStatus = function () {
            return Category.getArchiveStatus().then(function (status) {
                vm.selectize_status = status;
                return vm.selectize_status;
            });
        };

        /// <description>
        /// Método responsável por abrir o modal de ícones do serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.openModalServiceIcons = function() {
            var modalIcons = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES_SERVICE), {keyboard:false, bgclose:false});
            vm.isUpdatedFormService();
            modalIcons.show();
        }

        /// <description>
        /// Método responsável pelo tratamento de layout do modal de situação (hold).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.holdSituationModal = function() {
            vm.holdSituationModalItem = true;
        };

        /// <description>
        /// Método responsável pelo tratamento de layout do modal de situação (free).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.freeSituationModal = function() {
            vm.holdSituationModalItem = false;
        };

        /// <description>
        /// Método responsável pelo tratamento de layout do modal de situação (gateway).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.gatewaySituationsService = function(index, item, create, update) {
            if (index == 1) {
                if (!vm.holdSituationModalItem) {
                    vm.openModalServiceSituation(item, create, update);    
                }                
            } else if (index == 2) {
                vm.removeSituationOfService(item);
            }
        };

        /// <description>
        /// Método responsável por abrir o modal de service situations.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.openModalServiceSituation = function(item, create, update) {
            var flagSituationAdded = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations = {};
            vm.service.modalSituations.create = create;
            vm.service.modalSituations.update = update;
            vm.service.modalSituations.behavior = {};
            vm.service.modalSituations.reason = {};
            vm.service.modalSituations.communication = {};
            vm.service.modalSituations.flagCloseModalSituationOfService = APPLICATION.BOOLEAN_TRUE;

            // Verificação de cadastro.
            if (vm.service.modalSituations.create) {
                // Verificação de situaçao já adicionada.
                if (vm.service.serviceSituations) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        if (vm.service.serviceSituations[i].situationId == vm.filters.situationWorkFlowDescription) {
                            Common.mensagemError(APPLICATION.STRING_MSG_SITUACAO_JA_ADICIONADA);
                            flagSituationAdded = APPLICATION.BOOLEAN_TRUE;
                            break;
                        }
                    }

                    if (flagSituationAdded) {
                        return;
                    }

                    if (vm.service.serviceSituations.length == 0) {
                        vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_TRUE;
                    }
                } else {
                    vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_TRUE;
                }

                // Obtem o id e a descrição da situação selecionada.
                if (!flagSituationAdded) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.selectize_sources_situations.length; i++) {
                        if (vm.selectize_sources_situations[i].id == vm.filters.situationWorkFlowDescription) {
                            vm.service.modalSituations.id = vm.selectize_sources_situations[i].id;
                            vm.service.modalSituations.description = vm.selectize_sources_situations[i].description;
                            break;
                        }
                    }                     
                }
            } else if (vm.service.modalSituations.update) {
                // Verificação de atualização.
                vm.service.modalSituations.id = item.situationId;
                vm.service.modalSituations.description = item.description ? item.description : item.situation.description;

                // Preenchimento da aba comportamento.
                vm.service.modalSituations.behavior.sendPush = item.sendPush;
                vm.service.modalSituations.behavior.sendEmail = item.sendEmail;
                vm.service.modalSituations.behavior.isInitial = item.isInitial;
                vm.service.modalSituations.behavior.editEnableOnMobile = item.editEnableOnMobile;
                vm.service.modalSituations.behavior.deleteEnableOnMobile = item.deleteEnableOnMobile;
                vm.service.modalSituations.behavior.statusEnableOnMobile = item.statusEnableOnMobile;
                vm.service.modalSituations.behavior.situationChangeOnMobile = item.situationChangeOnMobile;
                vm.service.modalSituations.behavior.defaultMessage = item.defaultMessage;
                vm.service.modalSituations.behavior.isActive = item.isActive;
                vm.service.modalSituations.behavior.order = item.order;
                vm.service.modalSituations.behavior.qrCodeEnableOnMobile = item.qrCodeEnableOnMobile;

                // Preenchimento da aba justificativas.
                vm.service.modalSituations.reason.reasonsList = item.reasons;

                // Preenchimento da aba comunicação
                vm.service.modalSituations.communication = {};
                vm.service.modalSituations.communication.to = item.integration && item.integration.email ? item.integration.email.to : '';
                vm.service.modalSituations.communication.cc = item.integration && item.integration.email ? item.integration.email.cc : '';
                vm.service.modalSituations.communication.cco = item.integration && item.integration.email ? item.integration.email.cco : '';
                vm.service.modalSituations.communication.subject = item.integration && item.integration.email ? item.integration.email.subject : '';
                vm.service.modalSituations.communication.body = item.integration && item.integration.email ? item.integration.email.body : '';
                vm.service.modalSituations.communication.includeFormOnBody = item.integration && item.integration.email ? item.integration.email.includeFormOnBody : APPLICATION.NULL;
                vm.service.modalSituations.communication.attachmentJson = item.integration && item.integration.email && item.integration.email.includeFormAsAttachment && item.integration.email.includeFormAsAttachment.toLowerCase() == APPLICATION.STRING_JSON ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                vm.service.modalSituations.communication.attachmentXml = item.integration && item.integration.email && item.integration.email.includeFormAsAttachment && item.integration.email.includeFormAsAttachment.toLowerCase() == APPLICATION.STRING_XML ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;            

                // Comunicação Externa (Combo).
                vm.filters.integrations_service_situationDescription = item && item.integration && item.integration.external ? item.integration.external.name : APPLICATION.NULL;

                // Configuração dos radiobuttons e tipo de integração.
                if (!item.integration || (item.integration && !item.integration.email && !item.integration.external)) {
                    document.getElementById(APPLICATION.STRING_CAMPO_CHK_NAO).checked = APPLICATION.BOOLEAN_TRUE;
                    vm.showIntegrationConfigNone();
                } else if (item.integration && item.integration.email) {
                    document.getElementById(APPLICATION.STRING_CAMPO_CHK_EMAIL).checked = APPLICATION.BOOLEAN_TRUE;
                    vm.showIntegrationConfigEmail();
                } else if (item.integration && item.integration.external) {
                    document.getElementById(APPLICATION.STRING_CAMPO_CHK_EXTERNA).checked = APPLICATION.BOOLEAN_TRUE;
                    vm.showIntegrationConfigExternal();
                }                    
            }

            var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ADD_SITUACAO_SERVICO), {keyboard:false, bgclose:false});
            modal.show(); 
            $timeout(function() {
              $(vm.getHashTagField(APPLICATION.STRING_CAMPO_TAB_SITUACAO_MODAL)).click();  
            }, 200);
        }

        /// <description>
        /// Método responsável por selecionar o icone da categoria.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectIconCategory = function(item) {
            vm.category = vm.category ? vm.category : {};
            vm.category.icon = item.id;
            vm.categoryModal.icon = item.id;
            var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_CATEGORIAS), {keyboard:false, bgclose:false});
            modal.show();
        }

        /// <description>
        /// Método responsável por editar um serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.editService = function(item, formService) {
            vm.isLoading = APPLICATION.BOOLEAN_TRUE; 
            vm.getForms().then(function() {
                vm.isLoading = APPLICATION.BOOLEAN_FALSE; 
                if ((vm.selectize_sources_situations && vm.selectize_sources_situations.length > 0) && 
                    (vm.selectize_forms && vm.selectize_forms.length > 0)) {

                    vm.listOfServiceSituationsToRemove = [];

                    vm.telaInicial = APPLICATION.BOOLEAN_FALSE;

                    // Exibe a tela de serviços e reseta os dados;
                    vm.showWizardAddServiceEdit(formService);

                    item.serviceSituations = $filter('orderBy')(item.serviceSituations, 'order');                    

                    if (item && item.serviceSituations) {
                        for (var i = APPLICATION.INT_ZERO; i < item.serviceSituations.length; i++) {
                            if (item.serviceSituations[i].order)
                            item.serviceSituations[i].order = i;
                        }
                    }

                    // Envia o item para a tela de serviços.
                    vm.service = item;
                    vm.service.isActiveNew = !vm.service.isActive;

                    if (vm.selectize_forms) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.selectize_forms.length; i++) {
                            if (vm.service.formId == vm.selectize_forms[i].id ||
                                vm.service.formId == vm.selectize_forms[i].rootParent) {
                                vm.service.formId = vm.selectize_forms[i].rootParent;
                                vm.service.form = vm.selectize_forms[i];
                                break;
                            }
                        }
                    }

                    vm.serviceOrigin = JSON.parse(JSON.stringify(item));
                    vm.papeisOrigin = JSON.parse(JSON.stringify(vm.papeis));

                    // Seta o serviço para atualização.
                    vm.service.update = APPLICATION.BOOLEAN_TRUE;

                    // Efetua o cálculo de SLA de segundos para horas.
                    vm.service.sla = (vm.service.slaTimeSeconds / APPLICATION.INT_HORA);

                    // Preenche as permissões de acesso par ao serviço.
                    if (vm.service.accessPermissions && vm.papeis) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.service.accessPermissions.length; i++) {
                            for (var j = APPLICATION.INT_ZERO; j < vm.papeis.length; j++) {
                                if (vm.service.accessPermissions[i].roleId == vm.papeis[j].id) {
                                    vm.papeis[j].checked = APPLICATION.BOOLEAN_TRUE;
                                } 
                            }
                        }
                    }            

                    // Preenche as situações do serviço para edição.
                    if (vm.service.serviceSituations) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                            vm.service.serviceSituations[i].situationsSelected = [];

                            if (!vm.service.serviceSituations[i].listWorkflow) {
                                vm.service.serviceSituations[i].listWorkflow = [];
                            } 

                            vm.service.serviceSituations[i].listWorkflow.push({ situationId: vm.service.serviceSituations[i].situationId, description: vm.service.serviceSituations[i].description? vm.service.serviceSituations[i].description : vm.service.serviceSituations[i].situation.description });

                            for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].availableSituation.length; j++) {    
                                var selectedSituationId;
                                var selectedDescription;

                                selectedSituationId = vm.service.serviceSituations[i].availableSituation[j].situationId;

                                if (vm.service.serviceSituations[i].availableSituation[j].situation) {
                                    selectedDescription = vm.service.serviceSituations[i].availableSituation[j].situation.description;
                                } else {
                                    selectedDescription = vm.service.serviceSituations[i].availableSituation[j].description;
                                }

                                vm.service.serviceSituations[i].situationsSelected.push({ 'situationId': selectedSituationId, 'description': selectedDescription});
                            }            
                        } 
                    }  

                    // Tratamento da visibilidade do badge de motivos.
                    if (vm.service.serviceSituations) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                            vm.service.serviceSituations[i].showReason = APPLICATION.BOOLEAN_FALSE; 

                            if (vm.service.serviceSituations[i].reasons) {
                                for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].reasons.length; j++) {
                                    if (!vm.service.serviceSituations[i].reasons[j].isDeleted) {
                                        vm.service.serviceSituations[i].showReason = APPLICATION.BOOLEAN_TRUE;
                                        break;
                                    }
                                }
                            }
                        }    
                    }

                    // Tratamento para remover a situação atual da lista de situações possiveis para o workflow.
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        var listSituation = [];
                        vm.service.serviceSituations[i].listWorkflow = [];
                        vm.service.serviceSituations[i].situationsSelected = []; //vm.service.serviceSituations[i].situationsSelected && vm.service.serviceSituations[i].situationsSelected.length > 0 ? vm.service.serviceSituations[i].situationsSelected : [];

                        for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations.length; j++) {
                            if (vm.service.serviceSituations[i].situationId != vm.service.serviceSituations[j].situationId) {
                                listSituation.push(vm.service.serviceSituations[j].situation.description);
                            }
                        }

                        for (var x = APPLICATION.INT_ZERO; x < vm.service.serviceSituations[i].availableSituation.length; x++) {
                            vm.service.serviceSituations[i].situationsSelected.push(vm.service.serviceSituations[i].availableSituation[x].situation.description);
                        }

                        for (var x = APPLICATION.INT_ZERO; x < vm.service.serviceSituations[i].availableSituation.length; x++) {
                            for (var y = 0; y < listSituation.length; y++) {
                                if (listSituation[y] == vm.service.serviceSituations[i].availableSituation[x].situation.description) {
                                    listSituation.splice(y, APPLICATION.INT_UM);
                                }
                            }
                        }

                        vm.service.serviceSituations[i].listWorkflow = listSituation;
                    }

                    vm.isUpdatedFormServiceModel = false;

                    if (!vm.service.form) {
                        vm.service.formId = null;
                    }
                } else {
                    //Common.mensagemError('Olá, antes de adicionar um serviço, você precisa: <br />  - Adicionar Situações de atendimento <br /> - Adicionar Formulários');
                    var modal = UIkit.modal(vm.getHashTagField('modalInfoFormSituation'), {keyboard:false, bgclose:false});
                    modal.show();                    
                }
            }, function(error) {
                vm.isLoading = APPLICATION.BOOLEAN_FALSE; 
            });
        }

        /// <description>
        /// Método responsável por fechar o modal clone do serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.openModalCloneService = function(item) {
            vm.descriptionCloneService = item.description;            
            vm.itemCloneService = item;
            vm.modalCloneService.description = item.description;
            vm.modalCloneService.categoryId = vm.selectedCategoryItem.id;
            var modal = UIkit.modal(vm.getHashTagField('modalCloneService'), {keyboard:false, bgclose:false});
            modal.show(); 
        };

        /// <description>
        /// Método responsável por submeter o modal clone do serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitModalCloneService = function() {
            var service = {};
            var flag = false;
            vm.cloneServiceErrorCategoryId = false;
            service.description = vm.modalCloneService.description; 
            service.categoryId = vm.modalCloneService.categoryId;
            for(var i = 0; i < vm.categories.length; i++ ){
                if(vm.categories[i].id === vm.modalCloneService.categoryId){
                    vm.selectedCategoryItem = vm.categories[i];
                }    
            }

            vm.getServices(vm.selectedCategoryItem, true).then(function(servicesCompare){
                for (var i = APPLICATION.INT_ZERO; i < servicesCompare.length; i++) {
                    if (service.description.toLowerCase().trim() == servicesCompare[i].description.toLowerCase().trim()) {
                        flag = true;
                        break;
                    } 
                } 
                if(!vm.modalCloneService.categoryId){
                    vm.cloneServiceErrorCategoryId = true;
                    return;
                }
                if (flag) {
                    vm.cloneServiceErrorDescription = true;
                    return;
                } else {
                    vm.cloneServiceErrorDescription = false;
                    vm.isLoadingModalCloneService = true;
                    var modal = UIkit.modal(vm.getHashTagField('modalCloneService'), {keyboard:false, bgclose:false});
                    return Servico.clone(service, vm.itemCloneService.id).then(function (response) {
                        vm.isLoadingModalCloneService = false;
                        Common.messageSuccess(APPLICATION.STRING_MSG_SERVICO_COPIADO_SUCESSO);
                        
                        vm.getCategories(vm.filters)
                        vm.getServices(vm.selectedCategoryItem);
                        modal.hide();    
                        
                    }, function(error) {
                        vm.isLoadingModalCloneService = false;
                        vm.cloneServiceErrorDescription = true;
                        vm.hide(vm.getClassField('uk-notify-message-danger'));
                    }).finally(function() {
                        vm.modalCloneService.description = null;   
                        vm.hide(vm.getClassField('uk-notify-message-danger'));
                    });
                }   
            });            
        };

        /// <description>
        /// Método responsável por resetar o modal clone de serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.formResetModalCloneService = function(form) {
            form.$setPristine();
            form.$setUntouched();
            vm.modalCloneService.description = null;
            vm.cloneServiceErrorDescription = false;
        }

        /// <description>
        /// Método responsável por resetar o modal clone de categoria.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.formResetModalCategory = function(formCategory) {
            formCategory.$setPristine();
            formCategory.$setUntouched();
        }

        /// <description>
        /// Método responsável por selecionar o ícone do modal de serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectIconService = function(item) {
            vm.service = vm.service != APPLICATION.NULL ? vm.service : {};
            vm.service.icon = item.id;
            var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ICONES_SERVICE), {keyboard:false, bgclose:false});
            modal.hide();
        }

        /// <description>
        /// Método responsável por obter os ícones no service angular.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getIcons = function() {
            vm.iconsCategoryCode = Category.iconsListMobileCare();
            vm.getPublishLevel();
        }

        /// <description>
        /// Método responsável pelo tratamento de layout na exibição do wizard altair no serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showWizardAddService = function(formService) {
            vm.isLoading = APPLICATION.BOOLEAN_TRUE; 
            vm.getForms().then(function() {
                vm.isLoading = APPLICATION.BOOLEAN_FALSE; 
                if (vm.service && vm.service.serviceSituations) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        vm.service.serviceSituations[i].order = i;
                    }
                }

                if ((vm.selectize_sources_situations && vm.selectize_sources_situations.length > 0) && 
                    (vm.selectize_forms && vm.selectize_forms.length > 0)) {
                    vm.getForms();
                    vm.toggle(vm.getHashTagField(APPLICATION.STRING_CAMPO_SERVICE_ADD), APPLICATION.BOOLEAN_TRUE);
                    vm.toggle(vm.getHashTagField(APPLICATION.STRING_CAMPO_MAIN_BOARD));
                    vm.hide(vm.getHashTagField(APPLICATION.STRING_ITENS_CREATE));
                    vm.formReset(formService);
                    vm.toggle('#page_section_info');
                    vm.toggle('#actions-service-add');
                    vm.pageOverflowId = 'page_overflow_clean';
                    
                    vm.resetServiceForms();
                    vm.service.create = APPLICATION.BOOLEAN_TRUE;
                    vm.telaInicial = APPLICATION.BOOLEAN_FALSE;            
                    vm.showWizard1();        
                } else {                    
                    var modal = UIkit.modal(vm.getHashTagField('modalInfoFormSituation'), {keyboard:false, bgclose:false});
                    modal.show();               
                } 
            }, function(error) {
                vm.isLoading = APPLICATION.BOOLEAN_FALSE; 
            });   
        };

        /// <description>
        /// Método responsável pelo tratamento de layout na exibição do wizard altair no serviço (edição).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showWizardAddServiceEdit = function(formService) {
            vm.getForms();
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_MAIN_BOARD)).toggle();
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_SERVICE_ADD)).toggle(APPLICATION.STRING_SLOW);
            vm.toggle('#page_section_info');
            vm.toggle('#actions-service-add');            
            vm.pageOverflowId = 'page_overflow_clean';
            vm.formReset(formService);
            vm.resetServiceForms();
            vm.telaInicial = APPLICATION.BOOLEAN_FALSE;
            $(vm.getHashTagField(APPLICATION.STRING_ITENS_CREATE)).hide();
            vm.showWizard1();            
        };

        /// <description>
        /// Método responsável por remover o ícone do serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeIcon = function() {
            vm.isUpdatedFormService();
            if (vm.service) {
                vm.service.icon = APPLICATION.NULL;
            }
        }

        /// <description>
        /// Método responsável por esconder o wizard no cadastro/edição do serviço (cancelamento).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.hideWizardAddService = function(formService) {
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_MAIN_BOARD)).toggle(APPLICATION.STRING_SLOW);
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_SERVICE_ADD)).toggle();
            vm.toggle('#page_section_info');
            vm.hide('#actions-service-add');
            vm.pageOverflowId = 'page_overflow';
            vm.formReset(formService);
            vm.resetServiceForms();    
            vm.telaInicial = APPLICATION.BOOLEAN_TRUE;  
            $(vm.getHashTagField(APPLICATION.STRING_ITENS_CREATE)).hide();  
            vm.selectedCategoryItemBackup = JSON.parse(JSON.stringify(vm.selectedCategoryItem));  
        };

        vm.openModalConfirmacaoDeCancelamento = function() {
            var modalConfirmCancelamento = UIkit.modal('.cancelar', {keyboard:false, bgclose:false});
            modalConfirmCancelamento.show();
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair com problema).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showWizard1 = function() {
            vm.wizard1 = APPLICATION.BOOLEAN_TRUE;
            vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard3 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard4 = APPLICATION.BOOLEAN_FALSE;
            vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4));
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showWizard2 = function() {
            vm.wizard1 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard2 = APPLICATION.BOOLEAN_TRUE;
            vm.wizard3 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard4 = APPLICATION.BOOLEAN_FALSE;
            vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4));
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showWizard3 = function() {
            vm.wizard1 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard3 = APPLICATION.BOOLEAN_TRUE;
            vm.wizard4 = APPLICATION.BOOLEAN_FALSE;
            vm.show(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1));
            vm.hide(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4));
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showWizard4 = function() {
            vm.wizard1 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard3 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard4 = APPLICATION.BOOLEAN_TRUE;
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA4)).show();
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA2)).hide();
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3)).hide(); 
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA1)).hide();
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectTabWizard = function(itemNumber, formService) {
            if (itemNumber == APPLICATION.INT_UM) {
                vm.showWizard1();
            } else if (itemNumber == APPLICATION.INT_DOIS) {
                if (vm.formSubmitted(formService)) {
                    vm.showWizard2();
                }
            } else if (itemNumber == APPLICATION.INT_TRES) {
                if (vm.formSubmitted(formService)) {
                    vm.showWizard3();
                }
            } else if (itemNumber == APPLICATION.INT_QUATRO) {
                if (vm.formSubmitted(formService)) {
                    vm.showWizard4();
                }
            }

            vm.configureSelectizeLayout();
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectBackWizard = function() {
            if (vm.wizard2) {
                vm.showWizard1();
            } else if (vm.wizard3) {
                vm.showWizard2();
            } else if (vm.wizard4) {
                vm.showWizard3();
            }

            vm.configureSelectizeLayout();
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectNextWizard = function(formService) {
            if (vm.formSubmitted(formService)) {
                if (vm.wizard1) {
                    vm.showWizard2();
                } else if (vm.wizard2) {
                    vm.showWizard3();
                } else if (vm.wizard3) {
                    vm.showWizard4();
                }
            }

            vm.configureSelectizeLayout();
        }

        /// <description>
        /// Método responsável por executar tratamento de layout no wizard de serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.configureSelectizeLayout = function() {
            $(vm.getHashTagField(APPLICATION.STRING_CAMPO_DIV_ABA3)).find('.selectize-input').attr('style', 'border:none !important');
        }

        /// <description>
        /// Método responsável pela validação do preenchimento numérico do campo SLA.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.validate = function (evt) {
            vm.isUpdatedFormService();

            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
            var regex = APPLICATION.STRING_PATTERN_ONLY_NUMBERS;

            if (theEvent.keyCode == APPLICATION.INT_OITO) {
                return APPLICATION.BOOLEAN_TRUE;
            }

            if (!regex.test(key)) {
                theEvent.returnValue = APPLICATION.BOOLEAN_FALSE;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        }

        /// <description>
        /// Método responsável por excluir uma categoria.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.deleteById = function(item) {
            UIkit.modal.confirm(APPLICATION.STRING_MSG_DESEJA_EXCLUIR_CATEGORIA + item.description + APPLICATION.STRING_QUESTION, function () {
                Category.deleteById(item.id).then(function (result) {
                    if (result) {
                        vm.isLoadingCategory = APPLICATION.BOOLEAN_TRUE;           
                        Common.messageSuccess(APPLICATION.STRING_MSG_CATEGORIA_EXCLUIDA);
                        // Listagem das categorias folhas.
                        return Category.get(vm.filters).then(function (resultListCategories) {
                            if(item.id == vm.selectedCategoryItem.id){
                                vm.selectedCategoryItem.description = vm.categories[0].description;
                                vm.selectedCategoryItem = vm.categories[0];
                            }
                            vm.categories = [];
                            vm.categoriesFather = [];
                            vm.newListCategories = [];
                            vm.newListCategoriesHierarchy = [];                            

                            vm.getCategoryByIdSpecific(resultListCategories.itens);
                            vm.categoriesFather.push({id: APPLICATION.INT_ZERO, description: APPLICATION.STRING_MSG_SEM_CATEGORIA_PAI});
                        });                        
                    } else {
                        Common.mensagemError(result);
                    }
                });
            });
        }

        /// <description>
        /// Método responsável por excluir um serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.deleteServiceById = function(item) {
            UIkit.modal.confirm(APPLICATION.STRING_MSG_DESEJA_EXCLUIR_SERVICO + item.description + APPLICATION.STRING_QUESTION, function () {
                Servico.deleteById(item.id).then(function (result) {
                    if (result) {
                        //vm.selectedCategoryItem = vm.categories[0]; //take the first by default.
                        vm.getServices(vm.selectedCategoryItem);
                        Common.messageSuccess(APPLICATION.STRING_MSG_SERVICO_EXCLUIDO_SUCESSO);
                    } else {
                        Common.mensagemError(result + APPLICATION.STRING_POINT);
                    }
                })
            });
        };

        /// <description>
        /// Método responsável por efetuar a contagem de serviços por categoria.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.countServicesOfCategory = function() {
            if (vm.categories.length > 0) {
                for (var i = APPLICATION.INT_ZERO; i < vm.categories.length; i++) {
                    if (vm.categories[i].id == vm.selectedCategoryItem.id) {
                        vm.categories[i].servicesCount = vm.services.length;
                    }
                }
            }
        };

        /// <description>
        /// Método responsável por remover uma situação de serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeSituationOfService = function(item) {
            var situationName = item.description ? item.description : item.situation.description;
            vm.listOfServiceSituationsToRemove = vm.listOfServiceSituationsToRemove ? vm.listOfServiceSituationsToRemove : [];

            UIkit.modal.confirm(APPLICATION.STRING_MSG_DESEJA_EXCLUIR_SITUACAO + situationName + APPLICATION.STRING_QUESTION, function () {
                vm.isUpdatedFormService();
                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                    if (vm.service.serviceSituations[i].situationId == item.situationId) {
                        if (vm.service.serviceSituations[i].id) {
                            vm.listOfServiceSituationsToRemove.push(vm.service.serviceSituations[i]);    
                        }

                        Common.messageSuccess(APPLICATION.STRING_MSG_SITUACAO_REMOVIDA);      
                        vm.configureListWorkFlowDeleteItemOnUpdate(vm.service.serviceSituations[i]);                  
                        vm.service.serviceSituations.splice(i, APPLICATION.INT_UM);
                        vm.configureListWorkFlowOnCreate();
                        break;
                    }
                }
            });
        };

        /// <description>
        /// Método responsável por configurar o workflow.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.configureListWorkFlowDeleteItemOnUpdate = function(item) {
            var situation = item.situation ? item.situation.description : item.description;

            if (vm.service.update) {
                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                    if (vm.service.serviceSituations[i].situationsSelected) {
                        for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].situationsSelected.length; j++) {
                            if (vm.service.serviceSituations[i].situationsSelected[j] == situation) {
                                vm.service.serviceSituations[i].situationsSelected.splice(j, APPLICATION.INT_UM);
                                break;
                            }
                        }

                        for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].listWorkflow.length; j++) {
                            var situationTemp = vm.service.serviceSituations[i].listWorkflow[j].description ? vm.service.serviceSituations[i].listWorkflow[j].description : vm.service.serviceSituations[i].listWorkflow[j];
                            
                            if (situationTemp == situation) {
                                vm.service.serviceSituations[i].listWorkflow.splice(j, APPLICATION.INT_UM);
                                break;
                            }
                        }
                    }
                }
            }
        };

        /// <description>
        /// Método responsável por remover uma justificativa da situação específica.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeReasonOfSituationOfService = function(item) {
            for (var i = APPLICATION.INT_ZERO; i < vm.service.modalSituations.reason.reasonsList.length; i++) {
                if (vm.service.modalSituations.reason.reasonsList[i].id == item.id) {
                    vm.service.modalSituations.reason.reasonActive = APPLICATION.NULL;
                    vm.service.modalSituations.reason.reasonsList[i].isDeleted = APPLICATION.BOOLEAN_TRUE;
                    break;
                }
            }

            if (vm.service.modalSituations.reason.reasonsList && vm.service.modalSituations.reason.reasonsList.length < APPLICATION.INT_QUATRO) {
                $(vm.getHashTagField(APPLICATION.STRING_SRV_DIV_RSN_LST)).attr(APPLICATION.STRING_STYLE, 'margin-top:0px; height: 206px;');
            }
        };

        /// <description>
        /// Método responsável por validar uma situação padrão de serviço (obrigatório).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.validateDefaultSituation = function() {
            var index = APPLICATION.INT_ZERO;
            var flag = APPLICATION.BOOLEAN_FALSE;
            if (vm.service.serviceSituations) {
                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                    if (vm.service.serviceSituations[i].isInitial && vm.service.serviceSituations[i].situationId != vm.service.modalSituations.id) {
                        flag = APPLICATION.BOOLEAN_TRUE;
                        index = i;
                    }
                }

                if (flag) {
                    UIkit.modal.confirm(APPLICATION.STRING_MSG_EXISTE_SITUACAO_PADRAO, function () {
                        vm.service.serviceSituations[index].isInitial = APPLICATION.BOOLEAN_FALSE;
                        vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_TRUE;
                    });
                } else {
                    if (vm.service.modalSituations.behavior.isInitial) {
                        vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_FALSE;
                    } else {
                        vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_TRUE;
                    }
                }
            } else {
                if (vm.service.modalSituations.behavior.isInitial) {
                    vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_FALSE;
                } else {
                    vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_TRUE;
                }
            }
        };

        /// <description>
        /// Método responsável por validar uma situação padrão de serviço (obrigatório).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectIntegrationExtensionEmailJson = function() {
            if (vm.service.modalSituations.communication.attachmentJson) {
                vm.service.modalSituations.communication.attachmentXml = false;
            }
        };

        /// <description>
        /// Método responsável por validar uma situação padrão de serviço (obrigatório).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectIntegrationExtensionEmailXml = function() {
            if (vm.service.modalSituations.communication.attachmentXml) {
                vm.service.modalSituations.communication.attachmentJson = false;
            }
        };

        /// <description>
        /// Método responsável por configurar a listagem de workflow para o create.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.configureListWorkFlowOnCreate = function() {
            // CREATE SERVICE - OPTIONS
            if (vm.service.create) {
                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                    var listSituation = [];
                    vm.service.serviceSituations[i].listWorkflow = vm.service.serviceSituations[i].listWorkflow && vm.service.serviceSituations[i].listWorkflow.length > 0 ? vm.service.serviceSituations[i].listWorkflow : [];
                    vm.service.serviceSituations[i].situationsSelected = vm.service.serviceSituations[i].situationsSelected && vm.service.serviceSituations[i].situationsSelected.length > 0 ? vm.service.serviceSituations[i].situationsSelected : [];

                    // Adiciona as situações possíveis na lista de workflow sem a atual situação.
                    for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations.length; j++) {
                        if (vm.service.serviceSituations[i].situationId != vm.service.serviceSituations[j].situationId) {
                            if (vm.service.serviceSituations[j].situation) {
                                listSituation.push(vm.service.serviceSituations[j].situation.description);    
                            } else {
                                listSituation.push({ situationId: vm.service.serviceSituations[j].situationId, description: vm.service.serviceSituations[j].description }); 
                            }
                        }
                    }

                    vm.service.serviceSituations[i].listWorkflow = listSituation;
                }    
            }
        };

        /// <description>
        /// Método responsável por configurar a listagem de workflow para o update.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.configureListWorkFlowOnUpdate = function() {
            // UPDATE SERVICE - OPTIONS
            if (vm.service.update) {
                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                    var listSituation = [];
                    vm.service.serviceSituations[i].listWorkflow = vm.service.serviceSituations[i].listWorkflow && vm.service.serviceSituations[i].listWorkflow.length > 0 ? vm.service.serviceSituations[i].listWorkflow : [];
                    vm.service.serviceSituations[i].situationsSelected = vm.service.serviceSituations[i].situationsSelected && vm.service.serviceSituations[i].situationsSelected.length > 0 ? vm.service.serviceSituations[i].situationsSelected : [];

                    // Preenche a lista de situações possíveis para o workflow.
                    for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations.length; j++) {
                        if (vm.service.serviceSituations[i].situationId != vm.service.serviceSituations[j].situationId) {
                            if (vm.service.serviceSituations[j].situation) {
                                listSituation.push(vm.service.serviceSituations[j].situation.description);    
                            } else {
                                listSituation.push(vm.service.serviceSituations[j].description); 
                            }
                        }
                    }

                    vm.service.serviceSituations[i].listWorkflow = listSituation;
                }    
            }
        };

        /// <description>
        /// Método responsável por mover de origem para destino os itens da listagem de situações.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.moveItem = function (origin, destination) {
            var temp = vm.service.serviceSituations[destination];

            if (temp) {
                vm.isUpdatedFormService();
                vm.service.serviceSituations[destination] = vm.service.serviceSituations[origin];
                vm.service.serviceSituations[destination].order = destination;
                vm.service.serviceSituations[origin] = temp;                  
                vm.service.serviceSituations[origin].order = origin;  
            }            
        };

        /// <description>
        /// Método responsável por mover para cima os itens da listagem de situações.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.listItemUp = function (itemIndex) {
            vm.moveItem(itemIndex, itemIndex - 1);
        };

        /// <description>
        /// Método responsável por mover para baixo os itens da listagem de situações.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.listItemDown = function (itemIndex) {
            vm.moveItem(itemIndex, itemIndex + 1);
        };

        /// <description>
        /// Método responsável por adicionar/editar as situações do serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.addEditSituationOfService = function(create, update, form) {        
            vm.isUpdatedFormService();
            vm.service.serviceSituations = !vm.service.serviceSituations ? [] : vm.service.serviceSituations;
            var item = {};
            var flag = false;

            if (vm.service && vm.service.serviceSituations) {
                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                    vm.service.serviceSituations[i].order = i;
                }
            }

            if (vm.service && vm.service.modalSituations && vm.service.modalSituations.reason && vm.service.modalSituations.reason.reasonsList) {
                for (var i = APPLICATION.INT_ZERO; i < vm.service.modalSituations.reason.reasonsList.length; i++) {
                    if (!vm.service.modalSituations.reason.reasonsList[i].description || vm.service.modalSituations.reason.reasonsList[i].description.trim() == APPLICATION.STRING_EMPTY) {
                        if (!vm.service.modalSituations.reason.reasonsList[i].isDeleted) {
                            flag = true;
                            break;
                        }
                    }
                }
            }

            if (vm.service.modalSituations && !flag) {
                item.situationId = vm.service.modalSituations.id;  
                item.description = vm.service.modalSituations.description;

                // Aba comportamento.
                if (vm.service.modalSituations.behavior) {
                    item.sendPush = vm.service.modalSituations.behavior.sendPush ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.sendEmail = vm.service.modalSituations.behavior.sendEmail ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.isInitial = vm.service.modalSituations.behavior.isInitial ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.editEnableOnMobile = vm.service.modalSituations.behavior.editEnableOnMobile ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.deleteEnableOnMobile = vm.service.modalSituations.behavior.deleteEnableOnMobile ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.statusEnableOnMobile = vm.service.modalSituations.behavior.statusEnableOnMobile ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.situationChangeOnMobile = vm.service.modalSituations.behavior.situationChangeOnMobile ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.isActive = vm.service.modalSituations.behavior.isActive ? APPLICATION.BOOLEAN_TRUE : APPLICATION.BOOLEAN_FALSE;
                    item.defaultMessage = vm.service.modalSituations.behavior.defaultMessage ? vm.service.modalSituations.behavior.defaultMessage : APPLICATION.STRING_EMPTY;
                    item.qrCodeEnableOnMobile = vm.service.modalSituations.behavior.qrCodeEnableOnMobile ? vm.service.modalSituations.behavior.qrCodeEnableOnMobile : APPLICATION.BOOLEAN_FALSE;

                    if ((item.sendPush || item.sendEmail) && !vm.service.modalSituations.behavior.defaultMessage) {
                        UIkit.modal.alert(APPLICATION.STRING_MSG_SELECIONE_MENSAGEM_PUSH_INBOX);
                        return;
                    }   
                }

                // Aba justificativa.
                if (vm.service.modalSituations.reason) {
                    if (vm.service.modalSituations.reason.reasonsList) {
                        var reasonsList = [];
                        for (var i = APPLICATION.INT_ZERO; i < vm.service.modalSituations.reason.reasonsList.length; i++) {
                            reasonsList.push(vm.service.modalSituations.reason.reasonsList[i]);
                        }

                        item.reasons = reasonsList;
                    }
                }

                // Aba comunicação.
                if (vm.service.modalSituations.communication) {
                    if (vm.service.modalSituations.communication.flagIntegrationConfigEmail || vm.service.modalSituations.communication.flagIntegrationConfigExternal) {
                        item.communication = APPLICATION.BOOLEAN_TRUE;
                    }

                    item.integration = {};
                    item.integration.email = {};
                    item.integration.email.to = vm.service.modalSituations.communication.to;
                    item.integration.email.cc = vm.service.modalSituations.communication.cc;
                    item.integration.email.cco = vm.service.modalSituations.communication.cco;
                    item.integration.email.subject = vm.service.modalSituations.communication.subject;
                    item.integration.email.body = vm.service.modalSituations.communication.body;
                    item.integration.email.includeFormOnBody = vm.service.modalSituations.communication.includeFormOnBody ? vm.service.modalSituations.communication.includeFormOnBody: false;
                    item.integration.email.includeFormAsAttachment = vm.service.modalSituations.communication.attachmentJson ? APPLICATION.STRING_JSON : vm.service.modalSituations.communication.attachmentXml ? APPLICATION.STRING_XML : '';
                    
                    if (vm.service.modalSituations.communication.flagIntegrationConfigEmail) {
                        item.integration.external = null;
                        vm.filters.integrations_service_situationDescription = null;

                        if (!item.integration.email.to ||
                            !item.integration.email.subject ||
                            !item.integration.email.body) {
                            UIkit.modal.alert(APPLICATION.STRING_MSG_INFORME_CAMPOS_OBRIGATORIOS_COMUNICACAO_EXTERNA);
                            return;
                        }
                    } else if (vm.service.modalSituations.communication.flagIntegrationConfigExternal) {
                        item.integration.email = null;
                        item.integration.external = {};
                        item.integration.external.name = vm.filters.integrations_service_situationDescription;
                        
                        if (!vm.filters.integrations_service_situationDescription) {
                            if (!vm.errorGetListMappingsAttendance) {
                                UIkit.modal.alert(APPLICATION.STRING_MSG_INFORME_INTEGRACAO_EXTERNA);    
                            } else {
                                Common.mensagemError(APPLICATION.STRING_MSG_NAO_EXISTE_MAPEAMENTO);
                            }
                            
                            return;
                        }
                    } else {
                        item.integration.external = null;
                        item.integration.email = null;
                    }
                }

                if (create) {
                    item.listWorkflow = [];
                    item.order = vm.service.serviceSituations ? vm.service.serviceSituations.length : 0;
                    vm.service.serviceSituations.push(item);
                } else if (update) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        if (vm.service.serviceSituations[i].situationId == item.situationId) {
                            vm.service.serviceSituations[i].sendPush = item.sendPush;
                            vm.service.serviceSituations[i].sendEmail = item.sendEmail;
                            vm.service.serviceSituations[i].isInitial = item.isInitial;
                            vm.service.serviceSituations[i].editEnableOnMobile = item.editEnableOnMobile;
                            vm.service.serviceSituations[i].deleteEnableOnMobile = item.deleteEnableOnMobile;
                            vm.service.serviceSituations[i].statusEnableOnMobile = item.statusEnableOnMobile;
                            vm.service.serviceSituations[i].situationChangeOnMobile = item.situationChangeOnMobile;
                            vm.service.serviceSituations[i].isActive = item.isActive;
                            vm.service.serviceSituations[i].defaultMessage = item.defaultMessage;
                            vm.service.serviceSituations[i].order = i;
                            vm.service.serviceSituations[i].description = item.description;
                            vm.service.serviceSituations[i].situationId = item.situationId;
                            vm.service.serviceSituations[i].reasons = item.reasons;
                            vm.service.serviceSituations[i].qrCodeEnableOnMobile = item.qrCodeEnableOnMobile;
                            vm.service.serviceSituations[i].communication = item.communication;
                            vm.service.serviceSituations[i].integration = item.integration;
                            break;
                        }
                    }
                }

                vm.configureListWorkFlowOnCreate();
                vm.configureListWorkFlowOnUpdate();

                if (vm.service.serviceSituations) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        vm.service.serviceSituations[i].showReason = APPLICATION.BOOLEAN_FALSE; 

                        if (vm.service.serviceSituations[i].reasons) {
                            for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].reasons.length; j++) {
                                if (!vm.service.serviceSituations[i].reasons[j].isDeleted) {
                                    vm.service.serviceSituations[i].showReason = APPLICATION.BOOLEAN_TRUE;
                                    break;
                                }
                            }
                        }
                    }    
                } 

                if (form) {
                    form.$setPristine();
                    form.$setUntouched();                    
                }

                vm.showIntegrationConfigNone();
                document.getElementById(APPLICATION.STRING_CAMPO_CHK_NAO).checked = APPLICATION.BOOLEAN_TRUE;
                document.getElementById(APPLICATION.STRING_CAMPO_CHK_EMAIL).checked = APPLICATION.BOOLEAN_FALSE;
                document.getElementById(APPLICATION.STRING_CAMPO_CHK_EXTERNA).checked = APPLICATION.BOOLEAN_FALSE;

                vm.filters.situationWorkFlowDescription = null;
                var modal = UIkit.modal(vm.getClassField(APPLICATION.STRING_CAMPO_MODAL_ADD_SITUACAO_SERVICO), {keyboard:false, bgclose:false});                
                modal.hide();
            }
        }

        /// <description>
        /// Método responsável por submeter o serviço tanto em create quanto em update.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitService = function(formService) {
            vm.serviceSituationsBackupAddForReasons = [];
            vm.serviceSituationsBackupForReasons = [];
            vm.service.accessPermissionsToRemove = [];
            vm.service.accessPermissionsToAdd = [];
            vm.listOfServiceSituationsToAdd = [];
            vm.avaliableSituationsBackup = [];
            vm.listOfServiceSituations = [];            
            var service = {};
            var flagInitialSituation = false;
            var flagInitialSituationCount = 0;

            for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                if (vm.service.serviceSituations[i].isInitial == APPLICATION.BOOLEAN_TRUE) {
                    flagInitialSituation = true;
                    flagInitialSituationCount++;
                }
            }

            if (flagInitialSituation && flagInitialSituationCount == APPLICATION.INT_UM) {
                if (vm.formSubmitted(formService)) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                        vm.service.serviceSituations[i].order = i;
                    }

                    if (vm.service.create) {
                        service.description = vm.service.description;
                        service.formId = vm.service.formId;
                        //service.categoryId = vm.selectedCategoryItem.id;
                        service.categoryId = vm.service.categoryId;
                        service.icon = vm.service.icon;
                        service.slaTimeSeconds = vm.service.sla ? (vm.service.sla * APPLICATION.INT_HORA) : APPLICATION.INT_ZERO;
                        service.publishLevelId = vm.service.publishLevelId;
                        service.isActive = !vm.service.isActiveNew;
                        vm.service.isActive = !vm.service.isActiveNew;

                        for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                            delete vm.service.serviceSituations[i].availableSituation;

                            if (vm.service.serviceSituations[i].reasons) {
                                for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].reasons.length; j++) {
                                    vm.service.serviceSituations[i].reasons[j].id = APPLICATION.NULL;
                                }
                            }
                        }

                        service.serviceSituations = vm.service.serviceSituations;
                        service.accessPermissions = [];

                        for (var i = APPLICATION.INT_ZERO; i < vm.papeis.length; i++) {
                            if (vm.papeis[i].checked) {
                                service.accessPermissions.push({ roleId: vm.papeis[i].id });
                            }                
                        }

                        vm.serviceBkp = service;
                        vm.isLoading = APPLICATION.BOOLEAN_TRUE;
                        vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_TRUE;

                        return Servico.post(service).then(function (response) {
                            vm.avaliableSituationsBackup = [];

                            if (response.serviceSituations) {
                                for (var i = APPLICATION.INT_ZERO; i < response.serviceSituations.length; i++) {
                                    response.serviceSituations[i].avaliableSituations = vm.serviceBkp.serviceSituations[i].situationsSelected;
                                    
                                    if (response.serviceSituations[i].avaliableSituations) {
                                        for (var j = APPLICATION.INT_ZERO; j < response.serviceSituations[i].avaliableSituations.length; j++) {
                                            var item = {};
                                            item.serviceSituationId = response.serviceSituations[i].id;
                                            item.situationId = response.serviceSituations[i].avaliableSituations[j];
                                            item.serviceId = response.id;
                                            vm.avaliableSituationsBackup.push(item);
                                        }
                                    }
                                    
                                }
                            }                    

                            vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_FALSE;

                            vm.filters = {};
                            vm.service = {};                
                            vm.service.modalSituations = {};
                            vm.service.serviceSituations = [];
                            vm.service.modalSituations.reason = {};
                            vm.service.modalSituations.behavior = {};
                            vm.service.modalSituations.communication = {};                
                            vm.formReset(formService);
                            vm.telaInicial = APPLICATION.BOOLEAN_TRUE;
                            $(vm.getHashTagField(APPLICATION.STRING_ITENS_CREATE)).hide();
                            vm.submitWorkFlow();
                        }, function(error) {
                            vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_FALSE;
                        });
                    } else if (vm.service.update) {
                        if (vm.isUpdatedFormServiceModel) {
                            service.id = vm.service.id; 
                            service.description = vm.service.description;
                            service.formId = vm.service.formId;
                            service.categoryId = vm.service.categoryId;
                            service.icon = vm.service.icon;
                            service.slaTimeSeconds = (vm.service.sla * APPLICATION.INT_HORA);
                            service.publishLevelId = vm.service.publishLevelId;
                            service.isActive = !vm.service.isActiveNew;
                            vm.service.isActive = !vm.service.isActiveNew;

                            service.accessPermissions = [];

                            for (var i = APPLICATION.INT_ZERO; i < vm.papeis.length; i++) {
                                if (vm.papeis[i].checked) {                        
                                    service.accessPermissions.push({ roleId: vm.papeis[i].id });
                                }                
                            }

                            vm.service.accessPermissionsToRemove = vm.service.accessPermissions;
                            vm.service.accessPermissionsToAdd = service.accessPermissions;
                            vm.listOfServiceSituations = JSON.parse(JSON.stringify(vm.service.serviceSituations));

                            vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_TRUE;

                            vm.listOfServiceSituationsToAdd = vm.listOfServiceSituationsToAdd ? vm.listOfServiceSituationsToAdd : [];

                            vm.serviceSituationsBackupAddForReasons = [];
                            vm.listOfServiceSituationsToAdd = [];

                            if (vm.service.serviceSituations) {
                                for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                                    if (!vm.service.serviceSituations[i].id) {
                                        vm.service.serviceSituations[i].serviceId = vm.service.id;
                                        vm.listOfServiceSituationsToAdd.push(vm.service.serviceSituations[i]);
                                    }

                                    if (vm.service.serviceSituations[i].reasons) {
                                        for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].reasons.length; j++) {
                                            //if (vm.service.serviceSituations[i].id && !vm.service.serviceSituations[i].reasons[j].isDeleted && !vm.service.serviceSituations[i].reasons[j].serviceSituationId) {
                                            if (vm.service.serviceSituations[i].id && !vm.service.serviceSituations[i].reasons[j].isDeleted) {
                                                var listTempReasonsToAdd = [];
                                                var itemTempReasonToAdd = {};

                                                itemTempReasonToAdd.description = vm.service.serviceSituations[i].reasons[j].description;
                                                itemTempReasonToAdd.serviceSituationId = vm.service.serviceSituations[i].id;

                                                listTempReasonsToAdd.push(itemTempReasonToAdd);

                                                vm.serviceSituationsBackupAddForReasons.push(listTempReasonsToAdd);
                                            }
                                        }
                                    }
                                }
                            }               

                            vm.serviceSituationsBackupForReasons = JSON.parse(JSON.stringify(vm.service.serviceSituations));
                            //vm.serviceSituationsBackupAddForReasons = vm.serviceSituationsBackupAddForReasons && vm.serviceSituationsBackupAddForReasons.length == 0 ? JSON.parse(JSON.stringify(vm.service.serviceSituations)) : [];

                            vm.isLoading = APPLICATION.BOOLEAN_TRUE;

                            return Servico.updateService(service).then(function (response) {
                                // Ajustes para atualização de workflow.
                                vm.avaliableSituationsBackup = [];

                                // Ajustes para integração email/externa.
                                vm.availableSituationIntegrationRemove = [];
                                vm.availableSituationIntegrationAdd = [];

                                if (vm.service.serviceSituations) {
                                    for (var i = APPLICATION.INT_ZERO; i < vm.service.serviceSituations.length; i++) {
                                        vm.service.serviceSituations[i].avaliableSituations = [];

                                        if (vm.selectize_sources_situations) {
                                            for (var j = APPLICATION.INT_ZERO; j < vm.selectize_sources_situations.length; j++) {
                                                if (vm.service.serviceSituations[i].situationsSelected) {
                                                    for (var x = APPLICATION.INT_ZERO; x < vm.service.serviceSituations[i].situationsSelected.length; x++) {
                                                        if (vm.selectize_sources_situations[j].description == vm.service.serviceSituations[i].situationsSelected[x]) {
                                                            vm.service.serviceSituations[i].avaliableSituations.push(vm.selectize_sources_situations[j].id);
                                                        }
                                                    }
                                                }                                    
                                            }  
                                        }                                

                                        if (vm.service.serviceSituations[i].avaliableSituations) {
                                            for (var j = APPLICATION.INT_ZERO; j < vm.service.serviceSituations[i].avaliableSituations.length; j++) {
                                                var item = {};
                                                item.serviceSituationId = vm.service.serviceSituations[i].id;
                                                item.situationId = vm.service.serviceSituations[i].avaliableSituations[j];
                                                item.serviceId = vm.service.id;
                                                vm.avaliableSituationsBackup.push(item);
                                            }
                                        }    

                                        // Integração email/externa.
                                        if (vm.service.serviceSituations[i].integration) {
                                            if (vm.service.serviceSituations[i].integration.email) {
                                                if (vm.service.serviceSituations[i].integration.id) {
                                                    vm.availableSituationIntegrationRemove.push({ serviceSituationId: vm.service.serviceSituations[i].id, email: vm.service.serviceSituations[i].integration.email });
                                                } else {
                                                    vm.availableSituationIntegrationAdd.push({ serviceSituationId: vm.service.serviceSituations[i].id, email: vm.service.serviceSituations[i].integration.email });
                                                }
                                            } else if (vm.service.serviceSituations[i].integration.external) {
                                                if (vm.service.serviceSituations[i].integration.id) {
                                                    vm.availableSituationIntegrationRemove.push({ serviceSituationId: vm.service.serviceSituations[i].id, mapping: vm.service.serviceSituations[i].integration.external });
                                                } else {
                                                    vm.availableSituationIntegrationAdd.push({ serviceSituationId: vm.service.serviceSituations[i].id, mapping: vm.service.serviceSituations[i].integration.external });
                                                }
                                            }
                                        }
                                    }
                                } 

                                vm.hide(vm.getHashTagField(APPLICATION.STRING_ITENS_CREATE));
                                vm.formReset(formService);
                                vm.updateServiceSituations();
                                vm.telaInicial = APPLICATION.BOOLEAN_TRUE;
                            }).finally(function(){
                                vm.isLoading = APPLICATION.BOOLEAN_TRUE;
                                vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_FALSE;
                            });
                        } 
                    } 
                }    
            } else {
                Common.mensagemError('O Serviço deve possuir uma situação inicial padrão.');
            }
        };

        /// <description>
        /// Método responsável por remover a lista de integrações para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeIntegrationServiceSituationsFromServer = function() {
            if (vm.availableSituationIntegrationRemove && vm.availableSituationIntegrationRemove.length > APPLICATION.INT_ZERO) {
                return Servico.deleteIntegration(vm.service, vm.availableSituationIntegrationRemove[0]).then(function (response) {
                    vm.availableSituationIntegrationRemove.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.removeIntegrationServiceSituationsFromServer();
                });
            } else if (!vm.availableSituationIntegrationRemove || vm.availableSituationIntegrationRemove.length == APPLICATION.INT_ZERO) {
                vm.addIntegrationServiceSituationsFromServer();
            }
        };

        /// <description>
        /// Método responsável por adicionar a lista de integrações para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.addIntegrationServiceSituationsFromServer = function() {
            if (vm.availableSituationIntegrationAdd && vm.availableSituationIntegrationAdd.length > APPLICATION.INT_ZERO) {
                return Servico.postIntegration(vm.service, vm.availableSituationIntegrationAdd[0]).then(function (response) {
                    vm.availableSituationIntegrationAdd.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.addIntegrationServiceSituationsFromServer();
                });
            } else if (!vm.availableSituationIntegrationAdd || vm.availableSituationIntegrationAdd.length == APPLICATION.INT_ZERO) {
                vm.removeReasonsFromServer();
            }
        };

        /// <description>
        /// Método responsável por cadastrar a lista de situações para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.addServiceSituationsFromServer = function() {
            if (vm.listOfServiceSituationsToAdd && vm.listOfServiceSituationsToAdd.length > APPLICATION.INT_ZERO) {
                return Servico.postSituationService(vm.service, vm.listOfServiceSituationsToAdd).then(function (response) {
                    //vm.listOfServiceSituationsToAdd = [];
                    vm.listOfServiceSituationsToAdd.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.addServiceSituationsFromServer();
                });
            } else if (!vm.listOfServiceSituationsToAdd || vm.listOfServiceSituationsToAdd.length == APPLICATION.INT_ZERO) {
                vm.removeIntegrationServiceSituationsFromServer();
            }
        };

        /// <description>
        /// Método responsável por remover a lista de situações para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeServiceSituationsFromServer = function() {
            if (vm.listOfServiceSituationsToRemove && vm.listOfServiceSituationsToRemove.length > APPLICATION.INT_ZERO) {
                return Servico.deleteSituationService(vm.service, vm.listOfServiceSituationsToRemove[APPLICATION.INT_ZERO]).then(function (response) {
                    vm.listOfServiceSituationsToRemove.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.removeServiceSituationsFromServer();
                });
            } else if (!vm.listOfServiceSituationsToRemove || vm.listOfServiceSituationsToRemove.length == APPLICATION.INT_ZERO) {
                vm.addServiceSituationsFromServer();
            }
        };

        /// <description>
        /// Método responsável por atualizar a lista de situações para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.updateServiceSituations = function() {
            if (vm.listOfServiceSituations && vm.listOfServiceSituations.length > APPLICATION.INT_ZERO) {
                if (vm.listOfServiceSituations[APPLICATION.INT_ZERO].id) {
                    return Servico.updateServiceSituations(vm.service, vm.listOfServiceSituations[APPLICATION.INT_ZERO]).then(function (response) {
                        vm.listOfServiceSituations.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.updateServiceSituations();
                    });    
                } else {
                    vm.listOfServiceSituations.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.updateServiceSituations();
                }      
            } else if (!vm.listOfServiceSituations || vm.listOfServiceSituations.length == APPLICATION.INT_ZERO) {
                //Common.messageSuccess(APPLICATION.STRING_MSG_SITUACOES_ATUALIZADAS_SUCESSO);
                vm.removeServiceSituationsFromServer();                
            }
        };

        /// <description>
        /// Método responsável por remover a lista de permissões de acesso para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeAccessPermission = function() {
            if (vm.service.accessPermissionsToRemove && vm.service.accessPermissionsToRemove.length > APPLICATION.INT_ZERO) {
                return Servico.deleteAccessPermissions(vm.service, vm.service.accessPermissionsToRemove[APPLICATION.INT_ZERO].id).then(function (response) {
                    vm.service.accessPermissionsToRemove.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.removeAccessPermission();
                });
            } else if (!vm.service.accessPermissionsToRemove || vm.service.accessPermissionsToRemove.length == APPLICATION.INT_ZERO) {
                vm.submitAccessPermission();
            }
        }

        /// <description>
        /// Método responsável por cadastrar a lista de permissões de acesso para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitAccessPermission = function() {
            if (vm.service.accessPermissionsToAdd && vm.service.accessPermissionsToAdd.length > APPLICATION.INT_ZERO) {
                return Servico.postAccessPermissions(vm.service, vm.service.accessPermissionsToAdd[APPLICATION.INT_ZERO].roleId).then(function (response) {
                    if (vm.service && vm.service.accessPermissionsToAdd) {
                        vm.service.accessPermissionsToAdd.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    }
                    
                    vm.submitAccessPermission();
                });
            } else if (!vm.service.accessPermissionsToAdd || vm.service.accessPermissionsToAdd.length == APPLICATION.INT_ZERO) {
                //Common.messageSuccess(APPLICATION.STRING_MSG_PERMISSOES_ATUALIZADAS_SUCESSO);

                Servico.getByCategory(vm.selectedCategoryItem).then(function (services) {
                    vm.serviceSituationsBackupForWorkFlow = [];

                    for (var i = APPLICATION.INT_ZERO; i < services.length; i++) {
                        if (services[i].id == vm.service.id) {
                            vm.serviceSituationsBackupForWorkFlow = JSON.parse(JSON.stringify(services[i].serviceSituations));
                            break;
                        }
                    }                    
                    
                    vm.removeWorkFlowFromServer();
                });                
            }
        }

        /// <description>
        /// Método responsável por remover a lista de justificativas para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeReasonsFromServer = function() {
            if (vm.serviceSituationsBackupForReasons && vm.serviceSituationsBackupForReasons.length > APPLICATION.INT_ZERO) {
                var flagRemoveReason = APPLICATION.BOOLEAN_FALSE;
                var reasonsDeleteFromServer = {};
                reasonsDeleteFromServer.ids = [];

                if (vm.serviceSituationsBackupForReasons[APPLICATION.INT_ZERO].reasons) {
                    for (var j = APPLICATION.INT_ZERO; j < vm.serviceSituationsBackupForReasons[APPLICATION.INT_ZERO].reasons.length; j++) {
                        if (vm.serviceSituationsBackupForReasons[APPLICATION.INT_ZERO].reasons[j].id && vm.serviceSituationsBackupForReasons[APPLICATION.INT_ZERO].reasons[j].id.toString().indexOf('-') > -1) {
                            reasonsDeleteFromServer.ids.push(vm.serviceSituationsBackupForReasons[APPLICATION.INT_ZERO].reasons[j].id);
                            flagRemoveReason = APPLICATION.BOOLEAN_TRUE;
                        }
                    }
                }                

                if (flagRemoveReason) {
                    return Servico.deleteReasons(vm.service, vm.serviceSituationsBackupForReasons[APPLICATION.INT_ZERO], reasonsDeleteFromServer).then(function (response) {
                        vm.serviceSituationsBackupForReasons.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.removeReasonsFromServer();
                    });
                } else {
                    vm.serviceSituationsBackupForReasons.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.removeReasonsFromServer();
                }                
            } else if (!vm.serviceSituationsBackupForReasons || vm.serviceSituationsBackupForReasons.length == APPLICATION.INT_ZERO) {
                vm.addReasonsFromServer();
            }
        };

        /// <description>
        /// Método responsável por remover a lista de workflow para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.removeWorkFlowFromServer = function() {
            if (vm.serviceSituationsBackupForWorkFlow && vm.serviceSituationsBackupForWorkFlow.length > APPLICATION.INT_ZERO) {
                var flagRemoveWorkFlow = APPLICATION.BOOLEAN_FALSE;
                var workFlowDeleteFromServer = {};
                workFlowDeleteFromServer.ids = [];

                if (vm.serviceSituationsBackupForWorkFlow[APPLICATION.INT_ZERO].availableSituation) {
                    for (var j = APPLICATION.INT_ZERO; j < vm.serviceSituationsBackupForWorkFlow[APPLICATION.INT_ZERO].availableSituation.length; j++) {
                        if (vm.serviceSituationsBackupForWorkFlow[APPLICATION.INT_ZERO].availableSituation[j].id) {
                            workFlowDeleteFromServer.ids.push(vm.serviceSituationsBackupForWorkFlow[APPLICATION.INT_ZERO].availableSituation[j].id);
                            flagRemoveWorkFlow = APPLICATION.BOOLEAN_TRUE;
                        }
                    }
                }                

                if (flagRemoveWorkFlow) {
                    return Servico.deleteWorkFlow(vm.service, vm.serviceSituationsBackupForWorkFlow[APPLICATION.INT_ZERO], workFlowDeleteFromServer).then(function (response) {
                        vm.serviceSituationsBackupForWorkFlow.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.removeWorkFlowFromServer();
                    });
                } else {
                    vm.serviceSituationsBackupForWorkFlow.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.removeWorkFlowFromServer();
                }                
            } else if (!vm.serviceSituationsBackupForWorkFlow || vm.serviceSituationsBackupForWorkFlow.length == APPLICATION.INT_ZERO) {
                vm.submitWorkFlowOnUpdate();
            }
        };

        /// <description>
        /// Método responsável por cadastrar a lista de justificativas para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.addReasonsFromServer = function() {
            if (vm.serviceSituationsBackupAddForReasons && vm.serviceSituationsBackupAddForReasons.length > APPLICATION.INT_ZERO) {
                return Servico.postReasons(vm.service, vm.serviceSituationsBackupAddForReasons[APPLICATION.INT_ZERO]).then(function (response) {
                    vm.serviceSituationsBackupAddForReasons.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.addReasonsFromServer();
                });
            } else if (vm.serviceSituationsBackupAddForReasons && vm.serviceSituationsBackupAddForReasons.length == APPLICATION.INT_ZERO) {
                //Common.messageSuccess(APPLICATION.STRING_MSG_JUSTIFICATIVAS_ATUALIZADAS_SUCESSO);
                vm.removeAccessPermission();
            }
        };

        /// <description>
        /// Método responsável por cadastrar a lista de workflow para o serviço de forma recursiva (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitWorkFlow = function() {
            if (vm.avaliableSituationsBackup && vm.avaliableSituationsBackup.length > APPLICATION.INT_ZERO) {
                return Servico.postItemWorkFlow(vm.avaliableSituationsBackup[APPLICATION.INT_ZERO]).then(function (response) {
                    vm.avaliableSituationsBackup.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.submitWorkFlow();
                });
            } else if (vm.avaliableSituationsBackup && vm.avaliableSituationsBackup.length == APPLICATION.INT_ZERO) {
                $(vm.getHashTagField(APPLICATION.STRING_CAMPO_MAIN_BOARD)).toggle(APPLICATION.STRING_SLOW);
                $(vm.getHashTagField(APPLICATION.STRING_CAMPO_SERVICE_ADD)).toggle();
                Common.messageSuccess(APPLICATION.STRING_MSG_SERVICO_CADASTRADO_SUCESSO);
                vm.getCategories(vm.filters);   
                vm.selectService(vm.selectedCategoryItem, vm.selectedCategoryIndex);               
            }
        }

        /// <description>
        /// Método responsável por cadastrar a lista de workflow para o serviço de forma recursiva na edição do serviço (requisição específica).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitWorkFlowOnUpdate = function() {
            if (vm.avaliableSituationsBackup && vm.avaliableSituationsBackup.length > APPLICATION.INT_ZERO) {
                if (vm.avaliableSituationsBackup[APPLICATION.INT_ZERO].serviceSituationId && vm.avaliableSituationsBackup[APPLICATION.INT_ZERO].situationId) {
                    return Servico.postItemWorkFlow(vm.avaliableSituationsBackup[APPLICATION.INT_ZERO]).then(function (response) {
                        vm.avaliableSituationsBackup.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                        vm.submitWorkFlowOnUpdate();
                    });
                } else {
                    vm.avaliableSituationsBackup.splice(APPLICATION.INT_ZERO, APPLICATION.INT_UM);
                    vm.submitWorkFlowOnUpdate();
                }
                
            } else if (vm.avaliableSituationsBackup && vm.avaliableSituationsBackup.length == APPLICATION.INT_ZERO) {
                //Common.messageSuccess(APPLICATION.STRING_MSG_FLUXO_ATENDIMENTO_ATUALIZADO_SUCESSO); 
                Common.messageSuccess(APPLICATION.STRING_MSG_SERVICO_ATUALIZADO_SUCESSO);
                setTimeout(function() {
                    vm.isLoadingServiceWizard = APPLICATION.BOOLEAN_FALSE;
                    vm.toggle(vm.getHashTagField(APPLICATION.STRING_CAMPO_MAIN_BOARD), APPLICATION.BOOLEAN_TRUE);
                    vm.toggle(vm.getHashTagField(APPLICATION.STRING_CAMPO_SERVICE_ADD)); 
                }, 1000);
                 
                vm.getCategories(vm.filters);  
                vm.selectService(vm.selectedCategoryItem, vm.selectedCategoryIndex);                
            }
        }

        /// <description>
        /// Método responsável por adicionar a justificativa na listagem de situações de forma específica.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.addReason = function() {
            if (vm.service.modalSituations.reason.reasonActive) {
                if (!vm.service.modalSituations.reason.reasonsList) {
                    vm.service.modalSituations.reason.reasonsList = [];
                }

                if (vm.service.modalSituations.reason.reasonsList.length == APPLICATION.INT_ZERO) {
                    vm.service.modalSituations.reason.reasonsList.push({ id: vm.service.modalSituations.reason.reasonsList.length+APPLICATION.INT_UM, description: vm.service.modalSituations.reason.reasonActive, isDeleted: APPLICATION.BOOLEAN_FALSE });    
                } else {
                    vm.service.modalSituations.reason.reasonsList.push({ id: (vm.service.modalSituations.reason.reasonsList[vm.service.modalSituations.reason.reasonsList.length-1].id+1), description: vm.service.modalSituations.reason.reasonActive, isDeleted: APPLICATION.BOOLEAN_FALSE });
                }
                
                vm.service.modalSituations.reason.reasonActive = APPLICATION.NULL;

                if (vm.service.modalSituations.reason.reasonsList.length > APPLICATION.INT_TRES) {
                    $(vm.getHashTagField(APPLICATION.STRING_SRV_DIV_RSN_LST)).attr(APPLICATION.STRING_STYLE, 'margin-top:0px; height: 206px; overflow-y: scroll;');
                }
            } else {
                UIkit.modal.alert('Informe uma descrição para a justificativa.');
            }
        }

        /// <description>
        /// Método responsável por arquivar o serviço.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.archiveService = function(item) {
            vm.filters = {};
            vm.filters.id = item.id; 
            vm.filters.description = item.description;
            vm.filters.formId = item.formId; 
            vm.filters.categoryId = item.categoryId;
            vm.filters.icon = item.icon; 
            vm.filters.slaTimeSeconds = item.slaTimeSeconds;
            vm.filters.publishLevelId = item.publishLevelId; 

            if (item.isActive) {
                vm.filters.isActive = APPLICATION.BOOLEAN_FALSE;
            } else {
                vm.filters.isActive = APPLICATION.BOOLEAN_TRUE;
            }

            return Servico.updateService(vm.filters).then(function (response) {
                if (response) {
                    vm.getServices(vm.selectedCategoryItem);
                    if (vm.filters.isActive) {
                        Common.messageSuccess("Serviço ativado com sucesso!");
                    } else {
                        Common.messageSuccess("Serviço arquivado com sucesso!");
                    }                    
                } else {
                    Common.mensagemError(result + ".");
                }
            });
        };

        /// <description>
        /// Método responsável por submeter o formulário de serviços.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.formSubmitted = function(formService) {
            formService.$submitted = APPLICATION.BOOLEAN_TRUE;
            if (formService.$error && formService.$error.required && formService.$error.required.length > 0) {
                return APPLICATION.BOOLEAN_FALSE;
            } else {
                return APPLICATION.BOOLEAN_TRUE;
            }
        };

        /// <description>
        /// Método responsável por resetar o formulário de serviços.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.formReset = function(formService) {
            formService.$setPristine();
            formService.$setUntouched();
        }

        /// <description>
        /// Método responsável por submeter situações de serviço (depreciado).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.submitServiceSituation = function() {
            
        };

        /// <description>
        /// Método responsável por executar tratamento de layout das tabs de situações do serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.nextStepServiceSituation = function() {
            $('#tabReasonsModal').click();
        };

        /// <description>
        /// Método responsável por executar tratamento de layout das tabs de situações do serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.nextStepServiceSituationReason = function() {
            $('#tabIntegrationModal').click();
        };

        /// <description>
        /// Método responsável por executar tratamento de layout das tabs de situações do serviço (altair manager bugfix).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectTabModalServiceSituationNew = function(item) {
            switch (item) {
                case 1: {
                    $('#situationsTabReal').show();
                    $('#reasonsTabReal').hide();
                    $('#integrationTabReal').hide();
                    vm.tabSituationsModal = true;
                    vm.tabReasonsModal = false;
                    vm.tabIntegrationModall = false;
                    break;
                }
                case 2: {
                    $('#situationsTabReal').hide();
                    $('#reasonsTabReal').show();
                    $('#integrationTabReal').hide();
                    vm.tabSituationsModal = false;
                    vm.tabReasonsModal = true;
                    vm.tabIntegrationModall = false;
                    break;
                }
                case 3: {
                    $('#situationsTabReal').hide();
                    $('#reasonsTabReal').hide();
                    $('#integrationTabReal').show();
                    vm.tabSituationsModal = false;
                    vm.tabReasonsModal = false;
                    vm.tabIntegrationModall = true;
                    break;
                }
            }
            
        };

        /// <description>
        /// Método responsável por resetar o formulário de serviços.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.resetServiceForms = function() {
            vm.filters = {};
            vm.wizard1 = APPLICATION.BOOLEAN_TRUE;
            vm.wizard2 = APPLICATION.BOOLEAN_FALSE;
            vm.wizard3 = APPLICATION.BOOLEAN_FALSE;

            vm.category = {};
            vm.category.detail = APPLICATION.BOOLEAN_FALSE;
            vm.category.update = APPLICATION.BOOLEAN_FALSE;
            vm.category.create = APPLICATION.BOOLEAN_FALSE;

            vm.service = {};
            vm.service.detail = APPLICATION.BOOLEAN_FALSE;
            vm.service.update = APPLICATION.BOOLEAN_FALSE;
            vm.service.create = APPLICATION.BOOLEAN_FALSE;
            
            vm.service.modalSituations = {};
            vm.service.modalSituations.behavior = {};
            vm.service.modalSituations.reason = {};
            vm.service.modalSituations.communication = {};

            vm.service.modalSituations.behavior.isInitial = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.behavior.statusEnableOnMobile = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.behavior.sendPush = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.behavior.sendMail = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.behavior.editEnableOnMobile = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.behavior.isActive = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.behavior.deleteEnableOnMobile = APPLICATION.BOOLEAN_FALSE;
            
            vm.service.modalSituations.communication.includeFormOnBody = APPLICATION.BOOLEAN_TRUE;
            vm.service.modalSituations.communication.attachmentJson = APPLICATION.BOOLEAN_TRUE;
            vm.service.modalSituations.communication.attachmentXml = APPLICATION.BOOLEAN_TRUE;
            vm.service.modalSituations.communication.flagIntegrationConfigEmail = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.communication.flagIntegrationConfigExternal = APPLICATION.BOOLEAN_FALSE;

            vm.service.modalSituations.reason.reasonsList = [];

            vm.service.modalSituations.flagCloseModalSituationOfService = APPLICATION.BOOLEAN_TRUE;

            vm.service.serviceSituations = [];

            if (vm.papeis) {
                for (var i = APPLICATION.INT_ZERO; i < vm.papeis.length; i++) {
                    vm.papeis[i].checked = APPLICATION.BOOLEAN_FALSE;
                }
            }
        };

        /// <description>
        /// Método responsável por iniciar os componentes da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.initComponents = function() {
            vm.isLoadingCategory = APPLICATION.BOOLEAN_FALSE;
            vm.isLoading = APPLICATION.BOOLEAN_FALSE;
            vm.telaInicial = APPLICATION.BOOLEAN_TRUE;
            $(vm.getHashTagField(APPLICATION.STRING_ITENS_CREATE)).hide();
            
            vm.resetServiceForms();

            vm.getIcons();
            vm.selectize_publish_levels = [];
            vm.selectize_publish_levels_search = [];
            vm.selectize_publish_levels_modal = [];
            vm.selectize_status = []
            vm.selectize_forms = [];
            vm.selectize_forms_add = [];
            vm.selectize_sources_situations = [];
            vm.integrations_service_situation_modal = [];
            vm.service.serviceSituations = [];
            vm.listLeafsCategories = [];
            vm.categories = [];
            vm.categoriesFather = [];
            vm.newListCategories = [];
            vm.newListCategoriesHierarchy = [];
            vm.archiveList = [];
            vm.getArchived();
            vm.getStatus();
            vm.services = [];
            vm.selectedCategory = APPLICATION.STRING_MSG_NENHUMA_CATEGORIA_SELECIONADA;
            vm.modalCloneService = {};
            vm.showErrorModalCloneService = true;

            vm.dtOptions = DTOptionsBuilder
                .newOptions()
                .withPaginationType('full_numbers')
                .withDisplayLength(10)
                .withDOM('rtip') //original: lfrtip
                .withLanguage(APPLICATION.dataTablesLanguage)
                .withOption('initComplete', function () {
                    $timeout(function () {
                        $compile($('.dt-uikit .md-input'))($scope);
                    })
                });

            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0),
                DTColumnDefBuilder.newColumnDef(1),
                DTColumnDefBuilder.newColumnDef(2),
                DTColumnDefBuilder.newColumnDef(3),
                DTColumnDefBuilder.newColumnDef(4)
            ];

            vm.selectize_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE,
                placeholder: 'Todas',
                sortField: {
                    field: 'description',
                    direction: 'asc'
                },
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            // var status = vm.selectize_status;
            vm.selectize_status_config = {
                plugins: {
                    'remove_button': {
                        label: ''
                    }
                },
                maxItems: 1,
                placeholder: 'Todos',
                valueField: 'id',
                labelField: 'description',
                searchField: 'description',
                create: false,
                render: {
                    option: function (status, escape) {
                        return '<div class="dropdown_selectize_options">' +
                            '<span class="itens">' + escape(status.description) + '</span>' +
                            '</div>';
                    },
                    item: function (status, escape) {
                        return '<div class="dropdown_selectize_selected">' + escape(status.description) + '</div>';
                    }
                }
            };

            vm.selectize_forms_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: 'rootParent',
                labelField: 'title',
                create: APPLICATION.BOOLEAN_FALSE,
                sortField: 'title'
            };

            vm.selectize_workflow_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: APPLICATION.NULL,
                valueField: APPLICATION.STRING_SITUATION_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            vm.selectize_situations_selected_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_SITUATION_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                create: APPLICATION.BOOLEAN_FALSE
            };

            var newFilter = {};
            newFilter.companyId = vm.company.id;
            Papel.get(newFilter).then(function (papeis) {
                vm.papeis = papeis;
            });
        };

        /// <description>
        /// Método responsável por remover a configuração de integração externa/email do atendimento.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showIntegrationConfigNone = function() {
            vm.service.modalSituations.integration = {};
            vm.service.modalSituations.communication.flagIntegrationConfigEmail = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.communication.flagIntegrationConfigExternal = APPLICATION.BOOLEAN_FALSE;
        }

        /// <description>
        /// Método responsável por exibir a configuração de integração por email do atendimento.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showIntegrationConfigEmail = function() {
            vm.service.modalSituations.communication.flagIntegrationConfigEmail = APPLICATION.BOOLEAN_TRUE;
            vm.service.modalSituations.communication.flagIntegrationConfigExternal = APPLICATION.BOOLEAN_FALSE;

            if (vm.service.modalSituations.integration) {
                vm.service.modalSituations.integration.external = {};    
            }            
        }

        /// <description>
        /// Método responsável por exibir a configuração de integração externa do atendimento.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.showIntegrationConfigExternal = function() {
            vm.service.modalSituations.communication.flagIntegrationConfigEmail = APPLICATION.BOOLEAN_FALSE;
            vm.service.modalSituations.communication.flagIntegrationConfigExternal = APPLICATION.BOOLEAN_TRUE;

            if (vm.service.modalSituations.integration) {
                vm.service.modalSituations.integration.email = {};
            }
        }

        /// <description>
        /// Método responsável por obter a listagem de mapeamentos de integração externa do atendimento.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getListMappingsAttendance = function() {
            Category.geListMappings().then(function(response) {
                if (response) {
                    for (var i = APPLICATION.INT_ZERO; i < response.length; i++) {
                        vm.integrations_service_situation_modal.push({ id: response[i], description: response[i] });
                    }
                    vm.errorGetListMappingsAttendance = false;
                } else {
                    //Common.messageSuccess('Não existe mapeamento cadastrado.');
                    vm.errorGetListMappingsAttendance = true;
                }
                
            }, function(error) {
                vm.errorGetListMappingsAttendance = true;
            });
        };

        /// <description>
        /// Método responsável por iniciar a aplicação.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.init = function () {            
            vm.isUpdatedFormServiceModel = false;
            vm.pageOverflowId = 'page_overflow';
            vm.categoryFilters = {};
            vm.configurarPermissoes();
            vm.initComponents();
            vm.filters = {};
            vm.getCategories(vm.filters);  
            vm.getForms();
            vm.getLeafsCategories();   
            vm.getListMappingsAttendance();
        };

        // vm.init();
        vm.accessIsAllowed = Security.exitsProfilePermission({ id: APPLICATION.INT_UM, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "R" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
    }

    angular.module('app.category')
        .controller('CategoryListController', CategoryListController);

})();

(function() {
    'use strict';

    /** @ngInject */
    function CategoryDetailController($interval, $controller, $rootScope, $scope, $stateParams, Category, Common, $state, DTOptionsBuilder, DTColumnDefBuilder, $timeout, $compile, APPLICATION, Security) { //
        var vm = this;
        vm.id = $stateParams.id;
        
        //Authorization credentials
        vm.isCategoryDeletarPermitido = false;
        vm.isCategoryEditarPermitido = false;
        vm.configurarPermissoes = function() {
            vm.isCategoryVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Categorias de Relacionamento", action: "R" });
            vm.isCategoryCadastrarPermitido = Security.exitsProfilePermission({ id: 2, name: "Categorias de Relacionamento", action: "C" });
            vm.isCategoryEditarPermitido = Security.exitsProfilePermission({ id: 3, name: "Categorias de Relacionamento", action: "U" });
            vm.isCategoryPesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Categorias de Relacionamento", action: "S" });
            vm.isCategoryExcluirPermitido = Security.exitsProfilePermission({ id: 5, name: "Categorias de Relacionamento", action: "D" });
            vm.isCategoryAtivarPermitido = Security.exitsProfilePermission({ id: 6, name: "Categorias de Relacionamento", action: "AD" });
        };

        vm.getCategory = function() {
            vm.isLoading = true;
            return Category.getById(vm.id).then(function(category) {
                vm.category = category;
                vm.isLoading = false;
                return vm.category;
            });
        };

        vm.confirmRemoval = function(category) {
            UIkit.modal.confirm('Deseja realmente excluir a categoria ' + category.name + '?', function() {
                Category.deleteAll(vm.id).then(function(result) {
                    if (result) {
                        Common.messageSuccess('Category', 'D', 'M');
                        $state.go('private.painel.category.list');
                    } else {
                        Common.mensagemError("Esse item não pode ser excluído.");
                    }
                })
            });

        };



        vm.init = function() {
            //vm.configurarPermissoes();
            vm.getCategory().then(function() {
               //
            });

        };
        
        vm.accessIsAllowed = Security.exitsProfilePermission({ id: APPLICATION.INT_UM, name: APPLICATION.STRING_CATEGORIAS_RELACIONAMENTO, action: "R" });
        angular.extend(this, $controller('BaseApp', {$scope: this}));
        //vm.init();
    }

    angular.module('app.category')
        .controller('CategoryDetailController', CategoryDetailController);

})();

(function () {
    'use strict';
  
    angular
      .module('app.baseCompany', []);        
  })();
  
(function () {
    'use strict';

    /** @ngInject */
    /** O intuinto desse controller é servir como base para as demais controllers das rotas permitidas para o appCompany.
    Assim, esse controller tem a principal função de abstrair métodos e funções mais utilizadas bem como tratamento e comportamentos padrões para as telas de acesso permitido quando o appCompany está selecionado.*/
    function BaseCompanyController(Company, DashboardCompany, $rootScope, $scope, $state) {
        var vm = $scope;
        // vm.company = Company.getCompanySelected();
        // vm.appCompany = DashboardCompany.obterAppSelecionada();
        // if(!vm.appCompany){
        //     $rootScope.$broadcast('reload-company'); 
        // }else{
        //     $rootScope.$broadcast('update-appCompany');
        // }

        // // wait for a change on appCompany
        // $rootScope.$on('set-appCompany', function (event) {
        //     vm.appCompany = DashboardCompany.obterAppSelecionada();
        // });

        // check for the permission to enter the window
        if(!vm.accessIsAllowed){
            $state.go('private.painel.error.notallowedaccess');
            return;
        }

        // call the init function of the children controller
        vm.init();
    }
    
    angular.module('app.baseCompany')
        .controller('BaseCompany', BaseCompanyController);
        

})();
(function () {
    'use strict';
  
    angular
      .module('app.baseApp', []);        
  })();
  
(function () {
    'use strict';

    /** @ngInject */
    /** O intuinto desse controller é servir como base para as demais controllers das rotas permitidas para o appCompany.
    Assim, esse controller tem a principal função de abstrair métodos e funções mais utilizadas bem como tratamento e comportamentos padrões para as telas de acesso permitido quando o appCompany está selecionado.*/
    function BaseAppController(Company, DashboardCompany, $rootScope, $scope, $state) {
        var vm = $scope;
        vm.company = Company.getCompanySelected();
        vm.appCompany = DashboardCompany.obterAppSelecionada();
        if(!vm.appCompany){
            $rootScope.$broadcast('reload-company'); 
        }else{
            $rootScope.$broadcast('update-appCompany');
        }

        // wait for a change on appCompany
        $rootScope.$on('set-appCompany', function (event) {
            vm.appCompany = DashboardCompany.obterAppSelecionada();
        });

        // check for the permission to enter the window
        if(!vm.accessIsAllowed){
            $state.go('private.painel.error.notallowedaccess');
            return;
        }

        // call the init function of the children controller
        vm.init();
    }
    
    angular.module('app.baseApp')
        .controller('BaseApp', BaseAppController);
        

})();
(function () {
  'use strict';

  angular
    .module('app.attendance', []);
})();


(function () {
    'use strict';

    /** @ngInject */
    function AttendanceService(Common, RestangularAuth, Restangular, APPLICATION, Session) {

        function getAttendancesHistoryPush(filters) {
            var clonedFilter = JSON.parse(JSON.stringify(filters));
            // clonedFilter.pagStart = clonedFilter.pagStart || 0;
            // clonedFilter.pagEnd = clonedFilter.pagEnd || 9;
            clonedFilter.dateIni = Common.convertToDate(clonedFilter.dateIni);
            clonedFilter.dateEnd = Common.convertToDate(clonedFilter.dateEnd);
            clonedFilter.orderField = 'date';
            //clonedFilter.pagIsAscending = false;

            if (clonedFilter.dateEnd == undefined) {
                clonedFilter.dateEnd = clonedFilter.dateIni;
            }
            return RestangularAuth.all('manager/attendance/GetAllAttendanceHistoryPush').getList(clonedFilter);
        }

        function saveAttendancesHistoryPush(model) {
            return RestangularAuth.all('manager/attendance/SaveAttendanceHistoryPush').post(model);
        }

        function getPublishLevel() {
            return RestangularAuth.all('manager/attendance/publishlevel').getList();
        }

        function getAttendances(filters) {
            var clonedFilter = JSON.parse(JSON.stringify(filters));
            var objectArray = '[object Array]';

            clonedFilter.pagStart = clonedFilter.pagStart || 0;
            clonedFilter.pagEnd = clonedFilter.pagEnd || 9;
            clonedFilter.dateIni = Common.convertToDate(clonedFilter.dateIni);
            clonedFilter.dateEnd = Common.convertToDate(clonedFilter.dateEnd);
            clonedFilter.orderField = filters.orderField;
            //clonedFilter.pagIsAscending = false;
            if (filters.categoryDescription != null && Object.prototype.toString.call(filters.categoryDescription) === objectArray) {
                clonedFilter.CategoryId = filters.categoryDescription[0];
            } else if (filters.categoryDescription != null) {
                clonedFilter.CategoryId = filters.categoryDescription;
            }

            if (filters.serviceDescription != null && Object.prototype.toString.call(filters.serviceDescription) === objectArray) {
                clonedFilter.ServiceId = filters.serviceDescription[0];
            } else if (filters.serviceDescription != null) {
                clonedFilter.ServiceId = filters.serviceDescription;
            }

            if (filters.usersDescription != null && Object.prototype.toString.call(filters.usersDescription) === objectArray) {
                clonedFilter.UserId = filters.usersDescription[0];
            } else if (filters.usersDescription != null) {
                clonedFilter.UserId = filters.usersDescription;
            }

            if (filters.situationDescription != null && Object.prototype.toString.call(filters.situationDescription) === objectArray) {
                clonedFilter.StateId = filters.situationDescription[0];
            } else if (filters.situationDescription != null) {
                clonedFilter.StateId = filters.situationDescription;
            }

            if (clonedFilter.dateEnd == undefined) {
                clonedFilter.dateEnd = clonedFilter.dateIni;
            }
            return RestangularAuth.one('manager/attendance').get(clonedFilter);
        }

        // Deprecated.
        function getFormImages(attendanceId) {
            return RestangularAuth.all('manager/content/photos/' + attendanceId.trim() + '/800/800').getList();
        }

        function getFormImagesInFiles(attendanceId, appSelecionado) {  
            var token = Session && Session.getToken() ? Session.getToken() : null;

            return Restangular.all('mobile/attendance/' + attendanceId.trim() + '/file/photo').getList(
                undefined, { 
                'Content-Type': 'application/json', 
                'AppId': appSelecionado.app.id, 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });
        }

        function getAttendance(id) {
            return RestangularAuth.one('manager/attendance', id).get();
        }

        function getOcurrenceSources() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.ocurrenceSources);
            return deferred.promise;
        }

        function getSituations(filters) {
            return RestangularAuth.all('manager/attendance/situation').getList(filters);
        }

        function getServicos(filters) {
            return RestangularAuth.all('manager/attendance/service').getList(filters);
        }

        function getUsers(filters) {
            return RestangularAuth.all('manager/attendance/user').getList(filters);
        }

        function setUpdateHistoryStateOfAttendance(attendance) {
            return RestangularAuth.all('manager/attendance/UpdateStateAttendanceAdmin').customPUT(attendance);
        }

        function updateStateAttendance(attendance, appSelecionado) {
            var token = Session && Session.getToken() ? Session.getToken() : null;
            return RestangularAuth.all('manager/attendance/'+attendance.id+'/situation').customPUT(attendance,undefined,undefined, { 
                'Content-Type': 'application/json', 
                'AppId': appSelecionado.app.id, 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });
        }

        function reintegrateAttendance(attendanceHistoryId, appSelecionado) {
            var token = Session && Session.getToken() ? Session.getToken() : null;
            return RestangularAuth.all('manager/attendance/'+attendanceHistoryId+'/reintegrate').customPUT(null,undefined,undefined, { 
                'Content-Type': 'application/json', 
                'AppId': appSelecionado.app.id, 
                'AppCompanyId': appSelecionado.id,
                'Authorization': 'Bearer ' + token
            });
        }

        function associateUserToAttendance(userData) {
            return RestangularAuth.all('manager/attendance/'+userData.id+'/associateuser').customPUT(userData.associatedUser);
        }

        function sendPush(message, token) {
            /*return RestangularAuth.all('mobile/device/push').post(message);*/

            return RestangularAuth.all('mobile/device/push').post(message,
                undefined, { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + token });
        }

        function getWorkFlow(serviceId, stateId) {
            return RestangularAuth.all('manager/attendance/service/' + serviceId + '/workflow/' + stateId).getList();
        }

        function getWorkFlowMobileCare(serviceId) {
            return RestangularAuth.all('manager/attendance/workflow/service/' + serviceId + '/situation').getList();
        }

        function getReasons(serviceId) {
            return RestangularAuth.all('manager/attendance/service/' + serviceId).customGET();
        }

        function getDashBoardDefaults(filters) {
            return RestangularAuth.all('manager/attendance/GetDashboardDefaults/?months=' + filters.months).customGET();
        }

        function getSlaList() {
            return RestangularAuth.all('manager/attendance/service/sla').getList();
        }

        function getDate() {
            return RestangularAuth.all('manager/attendance/GetDate').customGET();
        }

        function isFormInUse(formId) {
            return RestangularAuth.one('manager/attendance/formisinuse', formId).get();
        }

        function getSlaStatus() {
            var deferred = Common.$q.defer();
            deferred.resolve(APPLICATION.statusSla);
            return deferred.promise;
        }
        return {
            getAttendances: getAttendances,
            getAttendance: getAttendance,
            getOcurrenceSources: getOcurrenceSources,
            getFormImages: getFormImages,
            getFormImagesInFiles: getFormImagesInFiles,
            getSituations: getSituations,
            getServicos: getServicos,
            getUsers: getUsers,
            setUpdateHistoryStateOfAttendance: setUpdateHistoryStateOfAttendance,
            sendPush: sendPush,
            getAttendancesHistoryPush: getAttendancesHistoryPush,
            saveAttendancesHistoryPush: saveAttendancesHistoryPush,
            getWorkFlow: getWorkFlow,
            getWorkFlowMobileCare: getWorkFlowMobileCare,
            getReasons: getReasons,
            getDashBoardDefaults: getDashBoardDefaults,
            getSlaList: getSlaList,
            getDate: getDate,
            getPublishLevel: getPublishLevel,
            getSlaStatus: getSlaStatus,
            updateStateAttendance: updateStateAttendance,
            isFormInUse: isFormInUse,
            associateUserToAttendance:associateUserToAttendance,
            reintegrateAttendance:reintegrateAttendance
        };
    }

    angular
        .module('app.attendance')
        .factory('Attendance', AttendanceService);
})();

(function () {
  'use strict';

  /** @ngInject */
  function AttendanceDetailController(DashboardCompany, $controller, Cliente,Company, UsuarioAdmin, $interval, $http, $timeout, $rootScope, $scope, $stateParams, Attendance, Category, APPLICATION, Common, Security, Login) {
    var vm = this;
    vm.count = 0;

    var timeout1 = undefined;
    var timeout2 = undefined;
    var timeout3 = undefined;
    var timeout4 = undefined;
    var timeout5 = undefined;
    var timeout6 = undefined;

    /// <description>
    /// Método responsável por setar a imagem para o modal.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.setPic = function (pic) {
      var imgTempLocal = document.createElement("IMG");
      imgTempLocal.src = pic;

      vm.imgTemp = {};

      vm.imgTemp.width = imgTempLocal.width > 1200 ? 800 + 'px' : imgTempLocal.width + 'px';
      vm.imgTemp.height = imgTempLocal.width > 1200 ? 'auto' : imgTempLocal.height + 'px';
      vm.imgTemp.link = pic;
    };

    /// <description>
    /// Método responsável por obter as situações.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.getSituations = function () {
      return Attendance.getSituations().then(function (result) {
        vm.selectize_sources_situations = result;
        return vm.selectize_sources_situations;
      });
    }    

    /// <description>
    /// Método responsável pela estruturação do JSON do push notification.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.jsonPush = function (situationDescription, protocolMobile) {
      var idAttendance;
      var idUser;

      if (vm && vm.attendance && vm.attendance.id) {
        idAttendance = vm.attendance.id;
      }

      if (vm && vm.attendance && vm.attendance.userId) {
        idUser = vm.attendance.userId;
      }

      if (idUser == null || idUser == APPLICATION.STRING_EMPTY || idUser == APPLICATION.STRING_GUID_EMPTY) {
        return null;
      }

      var retorno = {
        "Title": "Notificação Web",
        "Body": "Notificação Web",
        "UserKey": idUser,
        "Sender": "Notificação Web",
        "Tags": [],
        "Platforms": {
          "gcm": {
            "data": {
              "body": "Sua solicitação " + protocolMobile + " teve o status alterado para: " + situationDescription + ".",
              "title": "Solicitação: " + situationDescription,
              "cn": {
                "ac": "situationChanged",
                "id": idAttendance
              },
              "userKey": idUser
            }
          },
          "apns": {
            "aps": {
              "alert": {
                "body": "Sua solicitação " + protocolMobile + " teve o status alterado para: " + situationDescription + ".",
                "title": "Solicitação: " + situationDescription,
              }
            },
            "cn": {
              "ac": "situationChanged",
              "id": idAttendance
            },
            "userKey": idUser
          }
        }
      };

      return retorno;
    }

    /// <description>
    /// Método responsável por enviar o push e obter os dados do atendimento com informaçoes espcíficas.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.getAttendanceSpecific = function (sucsess, item) {
      // Obtem o atendimento atualizado.               
      return vm.getAttendance(vm.attendance.id).then(function () {
        if (sucsess) {          
          $scope.$emit('updateAttendanceSituation', vm.attendance);

          // Envia o push de alteração do atendimento.
          var situationDescription;
          for (var i = 0; i < vm.selectize_sources_situations.length; i++) {
            if (vm.selectize_sources_situations[i].id == item) {
              situationDescription = vm.selectize_sources_situations[i].description;
              break;
            }
          }

          var retornoPush = vm.jsonPush(situationDescription, vm.attendance.protocol);

          if (retornoPush == null || retornoPush == APPLICATION.STRING_NULL) {
            timeout1 = $timeout(function () {
              updateGridTrick();
            }, 500);
            vm.filters.situationDescriptionDetail = [];
            vm.progressiveCount();
            vm.attendance.SituationId = item;
            return;
          }
        }
      });
    }

    /// <description>
    /// Método responsável por setar o integrationResponse e a razão.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.detailHistory = function (integrationResponse, reason) {
      vm.integrationResponse = integrationResponse;
      vm.reason = reason;
    }

    /// <description>
    /// Método responsável pela atualização da situação no atendimento atual e envio do push notification, informando motivo e observação.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.changeSituation = function (item, vm) {
      vm.attendance.SituationId = item;
      var item = {};

      item.internalComments = vm.filters.internalComments ? vm.filters.internalComments : APPLICATION.STRING_EMPTY;
      item.externalComments = vm.filters.externalComments ? vm.filters.externalComments : APPLICATION.STRING_EMPTY;
      item.externalProtocol = vm.filters.externalProtocol ? vm.filters.externalProtocol : APPLICATION.STRING_EMPTY;

      item.reasonId = vm.filters.reasonDescriptionDetail ? vm.filters.reasonDescriptionDetail : null;
      item.situationId = vm.filters.situationDescriptionDetail ? vm.filters.situationDescriptionDetail : null;

      if(vm.filters.associatedUser.id){
        item.associatedUser = {};
        item.associatedUser.id = vm.filters.associatedUser.id;
        var usersOption = JSON.parse(JSON.stringify(vm.selectize_sources_associate_user));
        for(var i = 0; i < usersOption.length; i++){
          if(usersOption[i].id == vm.filters.associatedUser.id){
            item.associatedUser.name = usersOption[i].name;
            item.associatedUser.email = usersOption[i].email;
            item.associatedUser.internalComments = vm.filters.internalComments ? vm.filters.internalComments : APPLICATION.STRING_EMPTY;
            item.associatedUser.externalProtocol = vm.filters.externalProtocol ? vm.filters.externalProtocol : APPLICATION.STRING_EMPTY;
            item.associatedUser.occurrenceSource = 2;
            break;
          }
        }
      }
      
      item.occurrenceSource = 2;
      item.id = vm.attendance.id;

      if (vm.filters.situationDescriptionDetail) {
        if (vm.showReasonCombo && !vm.filters.reasonDescriptionDetail) {
          Common.mensagemError(APPLICATION.STRING_MSG_INFORME_JUSTIFICATIVA);
          return;
        }

        vm.isLoadingDetail = true;
        return Attendance.updateStateAttendance(item, vm.appCompany).then(function (responseUpdateAttendance) {
          //vm.getAttendanceSpecific(true, item);
          $rootScope.$broadcast('finish_situation_change', {isUpdateSituation: true});
          Common.messageSuccess(APPLICATION.STRING_MSG_SITUACAO_ATUALIZADA_COM_SUCESSO);   
          vm.filters ={};       
        }, function (error) {          
        });
      } else if(vm.filters.associatedUser.id) {
        return Attendance.associateUserToAttendance(item).then(function (response) {
          //vm.getAttendanceSpecific(true, item);          
          $rootScope.$broadcast('finish_situation_change');
          Common.messageSuccess("Usuário atribuido com sucesso");
          vm.filters ={};
        }, function (error) {          
        });
      }else{
        Common.mensagemError("É necessário informar ao menos uma situação ou um usuário para ser associado.");
      }

      return;
    }

    /// <description>
    /// Método responsável por obter a data e hora atual do servidor e executar o calculo progressivo de SLA.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.getDateOfServer = function () {
      Attendance.getDate().then(function (response) { //BUG "An item with the same key has already been added.
        var parseDataAtualServidor = Date.parse(response.month + APPLICATION.STRING_BAR + response.day + APPLICATION.STRING_BAR + response.year + APPLICATION.STRING_SPACE + response.hour);
        vm.dataAtualServidor = new Date(parseDataAtualServidor);
        vm.dateOfServer = true;

        if (vm.attendance.dateSLA && vm.attendance.dateSLA.length > 10) {
          var day = vm.attendance.dateSLA.substring(0, 2);
          var month = vm.attendance.dateSLA.substring(3, 5);
          var year = vm.attendance.dateSLA.substring(6, 10);
          var hour = vm.attendance.dateSLA.split(' ')[1];
        }

        // Efetua o parse da data inicial do atendimento.
        var dataSla = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);

        if (vm.dataAtualServidor > new Date(dataSla)) {
          //console.log('Expirou');
          vm.progressiveCount();
        } else {
          //console.log('Dentro do limite');
          vm.processAttendanceWithSla();
        }

      }, function () {
        vm.dateOfServer = false;
        vm.processAttendanceWithSla();
      });
    }

    /// <description>
    /// Método responsável pelo processamento dos SLAs de cada atendimento.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.processAttendanceWithSla = function () {
      vm.progressive = false;
      // Verificação de existência do atendimento.
      if (vm.attendance) {
        // Verificação de existência de SLA para o serviço do atendimento atual.
        if (vm.attendance.service.slaTimeSeconds) {
          var parseDataInicial = null;
          var novaDataInicial = null;
          var parseDataAtual = null;
          var dataInicial = null;
          var dataAtual = null;
          var diferenca = null;
          var dias = null;
          var horas = null;
          var mins = null;
          var secs = null;
          var day = null;
          var month = null;
          var year = null;
          var hour = null;

          if (vm.dateOfServer) {
            dataAtual = vm.dataAtualServidor;
          } else {
            dataAtual = new Date();
          }

          if (vm.attendance.dateSLA && vm.attendance.dateSLA.length > 10) {
            var day = vm.attendance.dateSLA.substring(0, 2);
            var month = vm.attendance.dateSLA.substring(3, 5);
            var year = vm.attendance.dateSLA.substring(6, 10);
            var hour = vm.attendance.dateSLA.split(' ')[1];
          }

          // Efetua o parse da data inicial do atendimento.
          parseDataInicial = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);

          // Após o parse, converte a data inicial para date do browser a fim de calcular a diferença das datas (inicial do atendimento) e atual (servidor ou browser).
          dataInicial = new Date(parseDataInicial);

          // Adiciona o tempo de SLA na data inicial do cadastro do atendimento.
          novaDataInicial = new Date(dataInicial);
          //novaDataInicial.setSeconds(novaDataInicial.getSeconds() + vm.attendance.service.slaTimeSeconds);

          // Efetua o cálculo do tempo restante de SLA para o atendimento atual.
          diferenca = (novaDataInicial - dataAtual);
          dias = Math.floor(diferenca / (60 * 60 * 1000 * 24) * 1);
          horas = Math.floor((diferenca % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000) * 1);
          mins = Math.floor(((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000) * 1);
          secs = Math.floor((((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) / 1000 * 1);

          // Seta o tempo restante de SLA em cada item da lista.
          vm.dias = dias;
          vm.horas = horas;
          vm.minutos = mins;
          vm.segundos = secs;
          vm.slaExcedido = false;


          // Recursividade para executar o timer.
          timeout2 = $timeout(function () {
            // Adiciona 1 segundo no horário do servidor (salvo em sessão do angular) a cada recursividade (para não onerar o servidor).
            vm.dataAtualServidor = new Date(vm.dataAtualServidor.setSeconds(vm.dataAtualServidor.getSeconds() + 1))
            vm.processAttendanceWithSla();
          }, 1000);
        } else {
          // Serviço do atendimento atual não possui SLA vinculado.
          vm.possuiSla = false;

          // Recursividade para executar o timer.
          timeout3 = $timeout(function () {
            // Adiciona 1 segundo no horário do servidor (salvo em sessão do angular) a cada recursividade (para não onerar o servidor).
            vm.dataAtualServidor = new Date(vm.dataAtualServidor.setSeconds(vm.dataAtualServidor.getSeconds() + 1))
            vm.processAttendanceWithSla();
          }, 1000);
        }
      } else {
        // Recursividade para executar o timer.
        timeout4 = $timeout(function () {
          // Adiciona 1 segundo no horário do servidor (salvo em sessão do angular) a cada recursividade (para não onerar o servidor).
          vm.dataAtualServidor = new Date(vm.dataAtualServidor.setSeconds(vm.dataAtualServidor.getSeconds() + 1))
          vm.processAttendanceWithSla();
        }, 1000);
      }
    }

    /// <description>
    /// Método responsável por calcular o tempo de SLA em andamento a partir da data de criação do atendimento e a data atual.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.progressiveCount = function () {
      vm.progressive = true;
      // Verificação de existência do atendimento.    
      if (vm.attendance != null) {
        // Verificação de existência de SLA para o serviço do atendimento atual.
        if (vm.attendance.service.slaTimeSeconds) {
          var day = null;
          var month = null;
          var year = null;
          var hour = null;

          if (vm.attendance.dateSLA && vm.attendance.dateSLA.length > 10) {
            var day = vm.attendance.dateSLA.substring(0, 2);
            var month = vm.attendance.dateSLA.substring(3, 5);
            var year = vm.attendance.dateSLA.substring(6, 10);
            var hour = vm.attendance.dateSLA.split(' ')[1];
          }

          var parseDataInicial = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);
          var dataAtual = null;

          if (vm.dateOfServer) {
            dataAtual = vm.dataAtualServidor;
          } else {
            dataAtual = new Date();
          }

          var dataInicial = new Date(parseDataInicial);
          var diferenca = (dataAtual - dataInicial);

          if (diferenca > 0) {
            var dias = Math.floor(diferenca / (60 * 60 * 1000 * 24) * 1);
            var horas = Math.floor((diferenca % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000) * 1);
            var mins = Math.floor(((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000) * 1);
            var secs = Math.floor((((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) / 1000 * 1);

            vm.dias = dias;
            vm.horas = horas;
            vm.minutos = mins;
            vm.segundos = secs;

            // Adiciona o tempo de SLA na data inicial do cadastro do atendimento.
            var novaDataInicial = new Date(dataInicial);
            novaDataInicial.setSeconds(novaDataInicial.getSeconds() + vm.attendance.service.slaTimeSeconds);

            vm.slaExcedido = true;

            // Recursividade para executar o timer.
            timeout5 = $timeout(function () {
              // Adiciona 1 segundo no horário do servidor (salvo em sessão do angular) a cada recursividade (para não onerar o servidor).
              vm.dataAtualServidor = new Date(vm.dataAtualServidor.setSeconds(vm.dataAtualServidor.getSeconds() + 1))
              vm.progressiveCount();
            }, 1000);
          }
        } else {
          // Serviço do atendimento atual não possui SLA vinculada.
          vm.possuiSla = false;
        }
      } else {
        timeout6 = $timeout(function () {
          // Recursividade para executar o timer.
          vm.progressiveCount();
        }, 1000);
      }
    }

    /// <description>
    /// Método responsável por validar o conteúdo de dois parâmetros.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.validateContent = function (param1, param2) {
      if (param1.toLowerCase().indexOf(param2.toLowerCase()) != -1) {
        return true;
      } else {
        return false;
      }
    }

    /// <description>
    /// Método responsável por setar o tamanho do accordion;
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.accordion = function () {
      vm.marginAccordion = APPLICATION.STRING_500PX;
    }

    /// <description>
    /// Método responsável por obter o atendimento selecionado e efetuar as configurações de visualização dos mesmos em tela com o formulário dinâmico.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.getAttendance = function (id) {
      vm.isLoadingDetail = true;
      var flagExibirResposta = false;
      return Attendance.getAttendance(id).then(function (attendance) {
        var attendanceDate = {};
        var attendanceDateSla = {};

        if (attendance.attendanceDate && attendance.attendanceDate.length > 10) {
          attendanceDate.day = attendance.attendanceDate.substring(0, 2);
          attendanceDate.month = attendance.attendanceDate.substring(3, 5);
          attendanceDate.year = attendance.attendanceDate.substring(6, 10);
          attendanceDate.hour = attendance.attendanceDate.split(' ')[1];
        }

        if (attendance.dateSLA && attendance.dateSLA.length > 10) {
          attendanceDateSla.day = attendance.dateSLA.substring(0, 2);
          attendanceDateSla.month = attendance.dateSLA.substring(3, 5);
          attendanceDateSla.year = attendance.dateSLA.substring(6, 10);
          attendanceDateSla.hour = attendance.dateSLA.split(' ')[1];
        }

        attendanceDate.date = new Date(attendanceDate.month + APPLICATION.STRING_BAR + attendanceDate.day + APPLICATION.STRING_BAR + attendanceDate.year + APPLICATION.STRING_SPACE + attendanceDate.hour);
        attendanceDateSla.date = new Date(attendanceDateSla.month + APPLICATION.STRING_BAR + attendanceDateSla.day + APPLICATION.STRING_BAR + attendanceDateSla.year + APPLICATION.STRING_SPACE + attendanceDateSla.hour);

        vm.slaCalculated = parseInt((attendanceDateSla.date - attendanceDate.date) / 3600000);

        vm.showSlaOfTypeSituation = attendance && attendance.situation && attendance.situation.type && attendance.situation.type == 1 ? true : false;
        var flagShowDate = false;
        vm.isLoadingDetailIntegration = [];
        for (var i = 0; i < attendance.attendanceHistory.length; i++) {
          try {
            vm.isLoadingDetailIntegration.push(false);

            if (i == 0) {
              attendance.attendanceHistory[i].showDate = true;
            } else {
              var lastDay = parseInt(attendance.attendanceHistory[i -1].date.split(' ')[0].substring(0, 2));
              var actualDay = parseInt(attendance.attendanceHistory[i].date.split(' ')[0].substring(0, 2));
              var lastMonth = parseInt(attendance.attendanceHistory[i - 1].date.split(' ')[0].substring(3, 5));
              var actualMonth = parseInt(attendance.attendanceHistory[i].date.split(' ')[0].substring(3, 5));
              var lastYear = parseInt(attendance.attendanceHistory[i -1].date.split(' ')[0].substring(6, 10));
              var actualYear = parseInt(attendance.attendanceHistory[i].date.split(' ')[0].substring(6, 10));
              var lastDate = new Date(lastYear + '/' + lastMonth + '/' + lastDay);
              var actualDate = new Date(actualYear + '/' + actualMonth + '/' + actualDay);

              if (lastDate.getTime() == actualDate.getTime()) {
                attendance.attendanceHistory[i].showDate = false;
              } else {
                attendance.attendanceHistory[i].showDate = true;
              }
            }

            /*if (i > 0 && i < attendance.attendanceHistory.length) {
              var firstDay = parseInt(attendance.attendanceHistory[i - 1].date.split(' ')[0].substring(0, 2));
              var firstMonth = parseInt(attendance.attendanceHistory[i - 1].date.split(' ')[0].substring(3, 5));
              var firstYear = parseInt(attendance.attendanceHistory[i - 1].date.split(' ')[0].substring(6, 10));
              //var firstDate = new Date(firstYear, firstMonth, firstDay);
              var firstDate = new Date(firstYear + '/' + firstMonth + '/' + firstDay);

              if (((firstDate.getTime() === lastDate.getTime()) && flagShowDate) || (lastDate.getTime() === createdDate.getTime())) {
                attendance.attendanceHistory[i].showDate = false;
              } else {
                attendance.attendanceHistory[i].showDate = true;
                flagShowDate = true;
              }
            } else {
              if (lastDate.getTime() === createdDate.getTime()) {
                attendance.attendanceHistory[i].showDate = false;
              } else {
                attendance.attendanceHistory[i].showDate = true;
                flagShowDate = true;
              }
            }*/

            if (attendance.attendanceHistory[i].situation) {
              attendance.attendanceHistory[i].situation.icon = '&#x' + attendance.attendanceHistory[i].situation.icon;
            }

          } catch (e) {
            attendance.attendanceHistory[i].showDate = true;
            flagShowDate = true;
          }
        }

        vm.attendance = attendance;
        var userFilter = {};        
        userFilter.rolesId = [];
        for(var i = 0; i < attendance.service.accessPermissions.length; i++){
          userFilter.rolesId.push(attendance.service.accessPermissions[i].roleId);
        }

        UsuarioAdmin.getByAppCompany(vm.company, vm.appCompany.id, userFilter).then(function (users) {
          vm.selectize_sources_associate_user = users;          
        });

        return Attendance.getReasons(vm.attendance.service.id).then(function (response) {
          vm.selectize_sources_situations = [];
          vm.selectize_sources_reason = [];
          vm.filters.situationDescriptionDetail = null;

          Attendance.getFormImagesInFiles(vm.attendance.id, vm.appCompany).then(function (images) {
            vm.attendance.images = images;

            if (vm.attendance && vm.attendance.images) {
              for (var j = APPLICATION.INT_ZERO; j < vm.attendance.anwsersForm.length; j++) {
                if (vm.attendance.anwsersForm[j].fieldType.toUpperCase() == "IMAGE") {
                  for (var i = APPLICATION.INT_ZERO; i < vm.attendance.images.length; i++) {  
                    for (var x = APPLICATION.INT_ZERO; x < vm.attendance.anwsersForm[j].fieldValue.length; x++) {
                      if (vm.attendance.images[i].name.toUpperCase() == vm.attendance.anwsersForm[j].fieldValue[x].toUpperCase()) {
                        vm.attendance.anwsersForm[j].fieldValue[x] = vm.attendance.images[i].link;
                        break;
                      }
                    }
                  }
                }
              }
            }

            Cliente.getUserProfileById(vm.attendance.userId).then(function (response) {
              vm.attendance.userName = response ? response.name + ' ' + response.surname : "Sem informações";
              vm.attendance.userLogin = response ? response.mail : "Sem informações";
              vm.attendance.userEmail = response ? response.mail : "Sem informações";
              vm.attendance.userTelephone = response ? response.phone : "Sem informações";
              vm.attendance.sex = response ? response.sex : "Sem informações";
              vm.attendance.documentType = response ? response.documentType : "Sem informações";
              vm.attendance.documentNumber = response ? response.documentNumber : "Sem informações";
              vm.attendance.birthDate = response ? response.birthDate : "Sem informações";
              vm.attendance.address = response ? response.address : "Sem informações";
              vm.isLoadingDetail = false;
            }, function (error) {
              vm.isLoadingDetail = false;
            });
          }, function (error) {
            vm.isLoadingDetail = false;
          });

          var itensExibidos = 0;
          for (var i = 0; i < vm.attendance.anwsersForm.length; i++) {
            vm.attendance.anwsersForm[i].fieldLabel = vm.attendance.anwsersForm[i].fieldLabel
              .replace(APPLICATION.STRING_TAG_HTML, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_HTML_CLOSE, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_ITALIC, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_ITALIC_CLOSE, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_BOLD, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_BOLD_CLOSE, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_DYNAMIC_FORM, APPLICATION.STRING_EMPTY)
              .replace(APPLICATION.STRING_TAG_BODY_CLOSE, APPLICATION.STRING_EMPTY);

            for (var j = 0; j < vm.attendance.anwsersForm[i].fieldValue.length; j++) {
              if (vm.attendance.anwsersForm[i].fieldValue[j] != APPLICATION.STRING_EMPTY & vm.attendance.anwsersForm[i].fieldValue[j] != null & vm.attendance.anwsersForm[i].fieldValue[j] != 0) {
                flagExibirResposta = true;
                itensExibidos++;
                break;
              }
            }

            if (vm.attendance.anwsersForm[i].fieldLabel.toString().toUpperCase() != APPLICATION.STRING_DADOS) {
              vm.attendance.anwsersForm[i].flagExibirResposta = flagExibirResposta;
            } else {
              vm.attendance.anwsersForm[i].flagExibirResposta = true;
            }
            flagExibirResposta = false;
          }

          for (var i = 0; i < vm.attendance.availableServiceSituations.length; i++) {
            vm.selectize_sources_situations.push({ id: vm.attendance.availableServiceSituations[i].situationId, description: vm.attendance.availableServiceSituations[i].situation.description });
          }


        }, function (error) {
          vm.isLoadingDetail = false;
        });
      }, function (error) {
        vm.isLoadingDetail = false;
      });
    };

    vm.integrationResponseTryAgain = function(attendanceHistoryId, index) {      
      vm.isLoadingDetailIntegration[index] = true
      Attendance.reintegrateAttendance(attendanceHistoryId, vm.appCompany).then(function(result){
        vm.getAttendanceSpecific(true, vm.attendance);                          
        Common.messageSuccess("Integração realizada com sucesso!");
        vm.isLoadingDetailIntegration[index] = false;
      }, function (error) {
        vm.getAttendanceSpecific(true, vm.attendance);          
        vm.isLoadingDetailIntegration[index] = false;
      });
    };

    vm.changeReasonNew = function () {
      vm.showReasonCombo = false;

      if (vm.filters.situationDescriptionDetail) {
        vm.selectize_sources_reason = [];

        for (var i = 0; i < vm.attendance.availableServiceSituations.length; i++) {
          if (vm.attendance.availableServiceSituations[i].situationId == vm.filters.situationDescriptionDetail &&
            vm.attendance.availableServiceSituations[i].reasons && vm.attendance.availableServiceSituations[i].reasons.length > 0) {
            vm.showReasonCombo = true;
            for (var j = 0; j < vm.attendance.availableServiceSituations[i].reasons.length; j++) {
              vm.selectize_sources_reason.push({ id: vm.attendance.availableServiceSituations[i].reasons[j].id, description: vm.attendance.availableServiceSituations[i].reasons[j].description });
            }
          }
        }
      }
    };

    /// <description>
    /// Método responsável pela formatação do CEP.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    vm.processAttendanceAnswer = function (value, mask) {
      if (mask != undefined) {
        if (/\d{3}.\d{3}.\d{3}-\d{2}/.test(mask)) {
          value = Common.formatarCPFExibicaoApenas(value);
          return value;
        }
      }
      return value;
    }

    /// <description>
    /// Método responsável pela inicialização dos componentes de combo da tela.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.initComponents = function () {
      vm.isLoadingDetail = false;
      vm.showReasonCombo = false;

      vm.imgTemp = {};
      vm.imgTemp.width = 800;
      vm.imgTemp.height = 800;

      // Combo de situações.
      vm.selectize_sources_associate_user_config = {
        plugins: { 'remove_button': { label: APPLICATION.STRING_EMPTY } },
        maxItems: 1,
        valueField: APPLICATION.STRING_ID,
        labelField: 'name',
        searchField: 'name',
        create: false,
        render: {
          option: function (sources, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(sources.name) +' (' + sources.email +')'+ '</span>' +
              '</div>';
          },
          item: function (sources, escape) {
            return '<div class="item">' + escape(sources.name) + ' (' + sources.email +')'+'</div>';
          }
        }
      };


      vm.selectize_sources_situations_config = {
        plugins: { 'remove_button': { label: APPLICATION.STRING_EMPTY } },
        maxItems: 1,
        valueField: APPLICATION.STRING_ID,
        labelField: APPLICATION.STRING_DESCRIPTION,
        searchField: APPLICATION.STRING_DESCRIPTION,
        create: false,
        render: {
          option: function (sources, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(sources.description) + '</span>' +
              '</div>';
          },
          item: function (sources, escape) {
            return '<div class="item">' + escape(sources.description) + '</div>';
          }
        }
      };

      // Combo de motivos.
      vm.selectize_sources_reason_config = {
        plugins: { 'remove_button': { label: APPLICATION.STRING_EMPTY } },
        maxItems: 1,
        valueField: APPLICATION.STRING_ID,
        labelField: APPLICATION.STRING_DESCRIPTION,
        searchField: APPLICATION.STRING_DESCRIPTION,
        create: false,
        render: {
          option: function (sources, escape) {
            return '<div class="option">' +
              '<span class="title">' + escape(sources.description) + '</span>' +
              '</div>';
          },
          item: function (sources, escape) {
            return '<div class="item">' + escape(sources.description) + '</div>';
          }
        }
      };
    };

    /// <description>
    /// Método responsável pela atualização do gridtrick.
    /// </description>
    /// <author>
    /// Legado.
    /// </author>
    function updateGridTrick() {
      UIkit.$html.trigger('changed.uk.dom');
      $('#fotosDiv').trigger('display.uk.check');
      UIkit.init('#fotosDiv');

      $('#detalheDiv').trigger('display.uk.check');
      UIkit.init('#detalheDiv');

      $('#acatCancelDiv').trigger('display.uk.check');
      UIkit.init('#acatCancelDiv');
      UIkit.$html.trigger('changed.uk.dom');
      vm.isLoadingFiltros = false;
    }

    /// <description>
    /// Método responsável pela inicialização da tela.
    /// </description>
    /// <author>
    /// Gabriel Souza.
    /// </author>
    vm.init = function () {
      vm.marginAccordion = APPLICATION.STRING_300PX;
      //vm.configurarPermissoes();
      vm.datePickerFormat = APPLICATION.uiKitDatePickerFormat;
      vm.filters = {};
      vm.filters.situationDescriptionDetail = [];
      vm.filters.associatedUser = {};
      vm.associateUser = {};
      vm.selectize_sources_associate_user = [];
      vm.selectize_sources_associate_user_config = [];
      vm.initComponents();
      var attendanceId = $stateParams.id;
      vm.isLoadingFiltros = true;
      vm.showSlaOfTypeSituation = false;
      vm.possuiSla = false;
      vm.slaExcedido = true;            
      vm.getAttendance(attendanceId).then(function () {
        vm.getDateOfServer();
        updateGridTrick();
      });
    };

    //vm.init();

    $scope.$on('$destroy', function () {
      $timeout.cancel(timeout1);
      $timeout.cancel(timeout2);
      $timeout.cancel(timeout3);
      $timeout.cancel(timeout4);
      $timeout.cancel(timeout5);
      $timeout.cancel(timeout6);
    });

    vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Solicitações/Atendimentos", action: "R" });;
    angular.extend(this, $controller('BaseApp', {$scope: this}));
  }

  angular.module('app.attendance')
    .controller('AttendanceDetailController', AttendanceDetailController);

})();

(function () {
    'use strict';

    /** @ngInject */
    function AttendanceController($q, $controller, Situacao, UsuarioAdmin, $interval, $timeout, $rootScope, $scope, $filter, $state, Attendance, Category, Servico, Cliente, Common, APPLICATION, Security, Session, $window) {        
        var vm = this;

        $scope.$on('finish_situation_change', function(scope, args){
            // if(args && args.isUpdateSituation){
            //     vm.selectedIndex = 0;    
            // }
            vm.search(vm.filters, 'attendanceDate', vm.selectedIndex);
        });

        /// <description>
        /// Lógica necessária para esconder o menu, e configurações de início de página.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        $rootScope.primarySidebarActive = true;
        vm.isAttendanceVisualizarPermitido = false;
        vm.onlyNumbers = /^\d+$/;
        vm.attendances = [];
        vm.isLastPage = false;
        vm.itensPorPagina = 100;
        vm.totalItens = 0;
        vm.busy = false;
        var USERID = Session.getAccessKey();

        /// <description>
        /// Método responsável pela aplicação das regras de permissão;
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.configurarPermissoes = function () {
            vm.isAttendanceVisualizarPermitido = Security.exitsProfilePermission({ id: 1, name: "Solicitações/Atendimentos", action: "R" });
            vm.isAttendanceEditarPermitido = Security.exitsProfilePermission({ id: 2, name: "Solicitações/Atendimentos", action: "U" });
            vm.isAttendanceExportarPermitido = Security.exitsProfilePermission({ id: 3, name: "Solicitações/Atendimentos", action: "EX" });
            vm.isAttendancePesquisarPermitido = Security.exitsProfilePermission({ id: 4, name: "Solicitações/Atendimentos", action: "S" });
        };

        /// <description>
        /// Método responsável pela atualização da situaçao do atendimento selecionado (caso seja alterada no detalhe).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        $scope.$on('updateAttendanceSituation', function (event, data) {
            for (var i = 0; i < vm.attendances.length; i++) {
                if (vm.attendances[i].id == data.id) {
                    vm.attendances[i].situation.description = data.situation.description;
                    vm.attendances[i].situation.id = data.situation.id;
                    vm.attendances[i].situationId = data.situation.id;
                    break;
                }
            }
        });

        /// <description>
        /// Método responsável pela aplicação da regra de cascata dos combos Categoria/Serviços (caso categoria seja selecionada, exibe somente os serviços dela).
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.changeCategory = function () {
            var listServices = [];

            if (vm.filters.categoryDescription == null) {
                vm.selectize_sources_services = vm.selectize_sources_services_backup;
            } else {
                for (var i = 0; i < vm.selectize_sources_services_backup.length; i++) {
                    if (vm.selectize_sources_services_backup[i].category.id == vm.filters.categoryDescription) {
                        listServices.push(vm.selectize_sources_services_backup[i]);
                    }
                }
                vm.selectize_sources_services = listServices;
            }
        };

        /// <description>
        /// Método responsável por obter a lista de atendimentos e efetuar a verificação do sla restante (método "vm.slaRemainingCount(attendances)").
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getAttendances = function (filters) {
            vm.isLoadingAttendances = true;
            return Attendance.getAttendances(filters).then(function (attendances) { //BUG "An item with the same key has already been added.
                vm.isLoadingAttendances = false;
                vm.totalPages = attendances.totalPages;
                vm.totalItens = attendances.total;
                vm.attendances = attendances.result;
                vm.attendances = vm.slaRemainingCount(vm.attendances);
                vm.attendancesBackup = vm.attendances;
                var list = [];

                if (vm.filters.slaSelected == APPLICATION.INT_ZERO) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.attendances.length; i++) {
                        if (vm.attendances[i].slaIsValid && vm.attendances[i].situation.type==1 && vm.attendances[i].service.slaTimeSeconds > 0) {
                            list.push(vm.attendances[i]);
                        }
                    }
                } else if (vm.filters.slaSelected == APPLICATION.INT_UM) {
                    for (var i = APPLICATION.INT_ZERO; i < vm.attendances.length; i++) {
                        if (!vm.attendances[i].slaIsValid && vm.attendances[i].situation.type==1 && vm.attendances[i].service.slaTimeSeconds > 0) {
                            list.push(vm.attendances[i]);
                        }
                    }
                } else {
                    list = vm.attendancesBackup;
                }

                vm.attendances = list;

                // Validação de exibição de atendimentos somente pela permissão de papel de usuário para o serviço do atendimento.
                var attendancesNewWithPermissions = [];
                vm.total = 0;
                if (vm.selectize_sources_services_backup) {
                    for (var j = 0; j < vm.attendances.length; j++) {
                        for (var i = 0; i < vm.selectize_sources_services_backup.length; i++) {
                            if (vm.attendances[j].service.id == vm.selectize_sources_services_backup[i].id) {
                                vm.attendances[j].visible = true;
                                vm.total++;
                                break;
                            }
                        }    
                    }

                    var attendancesNewWithPermissions = [];
                    for (var i = 0; i < vm.attendances.length; i++) {
                        if (vm.attendances[i].visible) {
                            attendancesNewWithPermissions.push(vm.attendances[i]);
                        }
                    }

                    vm.attendances = attendancesNewWithPermissions;
                }

                return $q.when(vm.attendances);
            });
        };

        vm.exportData = function () {
            vm.isLoadingReport = true;
            var relBase = 
            '<html>'+
                '<head>'+
                    '<meta http-equiv="content-type" content="text/html; charset=utf-8" />'+
                '</head>'+
                '<body>'+
                    '<div id="exportable">'+
                        '<table width="100%">'+
                            '<thead>'+
                                '<tr>'+
                                    '<th>Protocolo</th>'+
                                    '<th>Protocolo Externo</th>'+
                                    '<th>Data</th>'+
                                    '<th>Categoria</th>'+
                                    '<th>Serviço</th>'+
                                    '<th>Nome Usuário</th>'+
                                    '<th>E-mail Usuário</th>'+
                                    '<th>Situação</th>'+
                                    '<th>Data de Expiração</th>'+
                                '</tr>'+
                            '</thead>'+
                            '<tbody>'+                        
                                '##data##'+
                            '</tbody>'+
                        '</table>'+
                    '</div>'+
                '</body>'+
            '</html>';

            
            var reportFilter = JSON.parse(JSON.stringify(vm.filters));
            reportFilter.pageNumber = null;
            reportFilter.pagIsAscending = null;
            reportFilter.totalItens = null;
            Attendance.getAttendances(reportFilter).then(function(itensReport){
                for(var i = 0; i < itensReport.result.length; i++){
                    relBase = relBase.replace('##data##', '<tr><td>'+ itensReport.result[i].protocol +'</td>'+                                            
                    '<td>'+ (itensReport.result[i].externalProtocol == undefined ? ' ': itensReport.result[i].externalProtocol) +'</td>'+                                            
                    '<td>'+ itensReport.result[i].attendanceDate +'</td>'+                                            
                    '<td>'+ itensReport.result[i].service.category.description +'</td>'+                                            
                    '<td>'+ itensReport.result[i].service.description +'</td>'+                                            
                    '<td>'+ itensReport.result[i].userName +'</td>'+                                            
                    '<td>'+ itensReport.result[i].userEmail +'</td>'+                                            
                    '<td>'+ itensReport.result[i].situation.description +'</td>'+                                            
                    '<td>'+ (itensReport.result[i].dateSLA == undefined ? ' ': itensReport.result[i].dateSLA) +'</td></tr>##data##')
                }
                relBase = relBase.replace('##data##', ' ');
                var blob = new Blob([relBase], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                });
                var datePickerFormat = APPLICATION.uiKitDatePickerFormatDateTime;
                var today = moment().format(datePickerFormat.format);
                var reportFileName = "solicitacoes_" + today.toString() + ".xls";
                saveAs(blob, reportFileName);
                vm.isLoadingReport = false;
            }, function(erro){
                vm.isLoadingReport = false;
            });
            
            
        };

        /// <description>
        /// Método responsável pelo carregamento dos dados através do scroll na lista (infinite-sroll do angularjs).
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.getNextPageAttendances = function () {
            if(vm.busy == false && vm.totalPages > vm.filters.pageNumber){ //Evita multiplas requisições ao efetuar varios scroll. So vai permitira uma nova requisição quando vm.busy == false, ou seja, quando a requisição anterior tiver sido finalizada.
                vm.filters.pageNumber++;
                vm.filters.totalItens = vm.itensPorPagina;
                //vm.filters.pageNumber += vm.itensPorPagina;
                //vm.filters.totalItens += vm.itensPorPagina - 1;
                vm.pgStr = vm.filters.pageNumber;
                vm.pgEnd = vm.filters.totalItens;
                vm.busy = true;
                vm.filterAttendanceRelatorio = vm.filters;
            
                var filtersTemp = JSON.parse(JSON.stringify(vm.filters));
                delete filtersTemp.sort;
                if (filtersTemp.pagIsAscending != 0)
                    filtersTemp.pagIsAscending = vm.filters.pagIsAscending == 1 ? true : false; 

                Attendance.getAttendances(filtersTemp).then(function (attendances) {
                    // Lógica para verificar se o atendimento já existe na lista atual.
                    for (var i = 0; i < attendances.result.length; i++) {
                        vm.attendanceExists = false;

                        for (var j = 0; j < vm.attendances.length; j++) {
                            if (attendances.result[i].id == vm.attendances[j].id) {
                                vm.attendanceExists = true;
                                break;
                            }
                        }

                        // Se o atendimento não existir na lista atual o mesmo é adiconado. 
                        if (!vm.attendanceExists) {
                            vm.attendances.push(attendances.result[i]);
                        }
                    }

                    vm.attendances = vm.slaRemainingCount(vm.attendances);
                    if (attendances.result.length < vm.itensPorPagina) {
                        vm.isLastPage = true;
                    } else {
                        vm.isLastPage = false;
                    }

                    var list = [];

                    /*if (vm.filters.slaSelected == APPLICATION.INT_ZERO) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.attendances.length; i++) {
                            if (vm.attendances[i].slaIsValid && vm.attendances[i].situation.type==1 && vm.attendances[i].service.slaTimeSeconds > 0) {
                                list.push(vm.attendances[i]);
                            }
                        }
                    } else if (vm.filters.slaSelected == APPLICATION.INT_UM) {
                        for (var i = APPLICATION.INT_ZERO; i < vm.attendances.length; i++) {
                            if (!vm.attendances[i].slaIsValid && vm.attendances[i].situation.type==1 && vm.attendances[i].service.slaTimeSeconds > 0) {
                                list.push(vm.attendances[i]);
                            }
                        }
                    } else {
                        list = vm.attendancesBackup;
                    }
                    vm.attendances = list;*/
                    vm.busy = false;

                    // Validação de exibição de atendimentos somente pela permissão de papel de usuário para o serviço do atendimento.
                    var attendancesNewWithPermissions = [];
                    if (vm.selectize_sources_services_backup) {
                        for (var j = 0; j < vm.attendances.length; j++) {
                            for (var i = 0; i < vm.selectize_sources_services_backup.length; i++) {
                                if (vm.attendances[j].service.id == vm.selectize_sources_services_backup[i].id) {
                                    vm.attendances[j].visible = true;
                                    vm.total++;
                                    break;
                                }
                            }    
                        }

                        var attendancesNewWithPermissions = [];
                        for (var i = 0; i < vm.attendances.length; i++) {
                            if (vm.attendances[i].visible) {
                                attendancesNewWithPermissions.push(vm.attendances[i]);
                            }
                        }

                        vm.attendances = attendancesNewWithPermissions;
                    }
                }).catch(function () {
                    vm.busy = false;
                });
            }
        };

        /// <description>
        /// Método responsável pelo carregamento dos dados da rotina em detalhe.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.detailAttendance = function (id, $index) {
            $timeout(function () {
                vm.selectedIndex = $index;
            }, 250);
            $state.go('private.painel.attendance.list.detail', { 'id': id, 'hidePreloader': 1 });

        };

        /// <description>
        /// Método responsável pela exportação dos dados atuais para o relatório analítico.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.relatorioAttendance = function () {
            $rootScope.filterAttendanceRelatorio.pageNumber = vm.pgStr;
            $rootScope.filterAttendanceRelatorio.totalItens = vm.pgEnd;
            $state.go('private.painel.atendimento.list', { 'hidePreloader': 1 });
        };

        /// <description>
        /// Método responsável por obter as categorias.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.getCategories = function () {
            return Category.get().then(function (result) { //BUG "An item with the same key has already been added.
                vm.selectize_sources_categories = result;
                return vm.selectize_sources_categories;
            });
        }

        /// <description>
        /// Método responsável por obter os serviços.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.getServices = function () {
            var filters = {};
            filters.IntegratorType = APPLICATION.STRING_WEB;
            return Attendance.getServicos(filters).then(function (result) {
                vm.selectize_sources_services = result;
                return vm.selectize_sources_services;
            });
        }

        /// <description>
        /// Método responsável por obter as situações.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.getSituations = function () {
            return Attendance.getSituations().then(function (result) {
                vm.selectize_sources_situations = result;
                return vm.selectize_sources_situations;
            });
        }

        /// <description>
        /// Método responsável por obter os usuários.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.getUsers = function () {
            return UsuarioAdmin.get(vm.company, filters).then(function (result) {
                var lista = [];
                var item = {};
                for (var i = 0; i < result.length; i++) {
                    item = {};
                    item = result[i].profiles[0];
                    lista.push(item);
                }

                vm.selectize_sources_users = lista;
                return vm.selectize_sources_users;
            });
        }

        /// <description>
        /// Método responsável pela atualização dos dados a partir do detalhe.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        $rootScope.refreshOfDetail = function () {
            var filter = {};
            var datePickerFormat = APPLICATION.uiKitDatePickerFormat;
            var today = moment().format(datePickerFormat.format);
            filter.dateIni = moment().add(-1, APPLICATION.STRING_DAYS).format(datePickerFormat.format);
            filter.dateEnd = today;
            filter.pageNumber = 1;
            filter.totalItens = vm.itensPorPagina;

            vm.searchRefresh(filter);
        }

        /// <description>
        /// Método responsável pela atualização da lista de atendimentos a partir do refreshOfDetail.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.searchRefresh = function (filters) {
            vm.isLoadingAttendances = true;
            var filters = angular.copy(vm.filters);
            Attendance.getAttendances(filters).then(function (attendances) {
                vm.totalItens = attendances.total
                if (vm.attendances == undefined) {
                    vm.attendances = [];
                }
                vm.attendances = attendances;
                vm.isLoadingAttendances = false;
                vm.attendances = vm.slaRemainingCount(vm.attendances);
            });
        };

        /// <description>
        /// Método responsável pela validação da data (regra cliente), não pode haver diferença de 6 meses entre as datas, fora validações padrão.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.validateDate = function (filters) {
            // Validação de data final, deve ser menor que a atual.
            if (filters.dateEnd) {
                var dateEndDivide = filters.dateEnd.toString().indexOf(APPLICATION.STRING_POINT) >= 0 ? filters.dateEnd.toString().split(APPLICATION.STRING_POINT) : filters.dateEnd.toString().split(APPLICATION.STRING_BAR);
                if (dateEndDivide.length == 3) {
                    var dateEndParse = Date.parse(dateEndDivide[1] + APPLICATION.STRING_BAR + dateEndDivide[0] + APPLICATION.STRING_BAR + dateEndDivide[2] + APPLICATION.STRING_ZERO_HORA);

                    if (new Date(dateEndParse) > new Date()) {
                        Common.mensagemError(APPLICATION.STRING_MSG_DATA_FINAL_NAO_PODE_SER_MAIOR_QUE_ATUAL);
                        return false;
                    }
                } else {
                    Common.mensagemError(APPLICATION.STRING_MSG_DATA_FINAL_INCORRETA);
                    return false;
                }
            }

            // Validação de data inicial, deve ser menor que a final.
            if (filters.dateIni) {
                var dateIniDivide = filters.dateIni.toString().indexOf(APPLICATION.STRING_POINT) >= 0 ? filters.dateIni.toString().split(APPLICATION.STRING_POINT) : filters.dateIni.toString().split(APPLICATION.STRING_BAR);
                if (dateIniDivide.length == 3) {
                    var dateIniParse = Date.parse(dateIniDivide[1] + APPLICATION.STRING_BAR + dateIniDivide[0] + APPLICATION.STRING_BAR + dateIniDivide[2] + APPLICATION.STRING_ZERO_HORA);

                    if (new Date(dateIniParse) > new Date()) {
                        Common.mensagemError(APPLICATION.STRING_MSG_DATA_INICIAL_NAO_PODE_SER_MAIOR_QUE_ATUAL);
                        return false;
                    }

                    if (filters.dateEnd) {
                        var dateEndDivide = filters.dateEnd.toString().indexOf(APPLICATION.STRING_POINT) >= 0 ? filters.dateEnd.toString().split(APPLICATION.STRING_POINT) : filters.dateEnd.toString().split(APPLICATION.STRING_BAR);

                        if (dateEndDivide.length == 3) {
                            var dateEndParse = Date.parse(dateEndDivide[1] + APPLICATION.STRING_BAR + dateEndDivide[0] + APPLICATION.STRING_BAR + dateEndDivide[2] + APPLICATION.STRING_ZERO_HORA);

                            if (new Date(dateIniParse) > new Date(dateEndParse)) {
                                Common.mensagemError(APPLICATION.STRING_MSG_DATA_INICIAL_NAO_PODE_SER_MAIOR_QUE_FINAL);
                                return false;
                            }

                            // Calcula a diferença entre as datas.
                            var timeDiff = Math.abs(new Date(dateEndParse).getTime() - new Date(dateIniParse).getTime());
                            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

                            // Período de datas não pode ser maior que 6 meses.
                            if (diffDays > 180) {
                                Common.mensagemError(APPLICATION.STRING_MSG_PERIODO_PESQUISADO_NAO_PODE_SER_MAIOR_QUE_6_MESES);
                                return false;
                            }

                        } else {
                            Common.mensagemError(APPLICATION.STRING_MSG_DATA_FINAL_INCORRETA);
                            return false;
                        }
                    }
                } else {
                    Common.mensagemError(APPLICATION.STRING_MSG_DATA_INICIAL_INCORRETA);
                    return false;
                }
            }

            return true;
        }

        /// <description>
        /// Método responsável pela pesquisa dos atendimentos baseada no filtro informado.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.search = function (filters, columnSorting, index) {
            if(!index){
                index = 0;
            }
            var filtersTemp = JSON.parse(JSON.stringify(filters));
            delete filtersTemp.sort;
            filtersTemp.pageNumber = 1;
            filtersTemp.totalItens = vm.itensPorPagina;
            if (filtersTemp.pagIsAscending != 0)
            filtersTemp.pagIsAscending = vm.filters.pagIsAscending == 1 ? true : false;                
            filtersTemp.pageNumber = 1;
            filtersTemp.totalItens = vm.itensPorPagina;
            vm.isLastPage = false;
            if (vm.validateDate(filters)) {
                $rootScope.filters = filters;
                $rootScope.filterAttendanceRelatorio = filters;
                vm.filters = filtersTemp;
                
                
                vm.attendances = [];
                vm.resetFiltersPaginationQuery(columnSorting);
                $window.scrollTo(0, 0);
                vm.pgStr = filtersTemp.pageNumber;
                vm.pgEnd = filtersTemp.totalItens;

                $rootScope.filterAttendanceRelatorio.pageNumber = vm.pgStr;
                $rootScope.filterAttendanceRelatorio.totalItens = vm.pgEnd;

                //filters.orderField = vm.orderFieldSelectedRadio ? vm.orderFieldSelectedRadio : 'attendanceDate';
                var pagIsAscendingTemp = filtersTemp.pagIsAscending;
                filtersTemp.sort = filtersTemp.orderField;

                vm.getAttendances(filtersTemp).then(function (data) {
                    if (pagIsAscendingTemp !== APPLICATION.STRING_NUMERO_0) {
                        vm.filters.pagIsAscending = pagIsAscendingTemp ? 1 : 2;    
                    }
                    
                    if (data && data.length && data.length > 0) {
                        vm.FILTERS_REFRESH = JSON.parse(JSON.stringify(filters));
                        var att = data[index];
                        if(!att){
                            index = 0;
                        }
                        vm.detailAttendance(data[index].id, index);
                    } else {
                        vm.attendances = [];
                    }
                });
            }
        };

        /// <description>
        /// Método responsável por obter o status do SLA>
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.getSlaStatus = function () {
            return Attendance.getSlaStatus().then(function (result) {
                vm.selectize_sources_sla = result;
                return vm.selectize_sources_sla;
            });
        };

        /// <description>
        /// Método responsável por selecionar a ordenação da lista no filtro.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectOrderField = function(orderField) {
            switch(orderField) {
                case 1: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_ATTENDANCE_DATE; break;
                case 2: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_SERVICE; break;
                case 3: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_PROTOCOL; break;
                case 4: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_USER; break;
                default: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_ATTENDANCE_DATE; break;
            }
        };

         /// <description>
        /// Método responsável por selecionar a ordenação da lista no filtro.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.selectOrderFieldByChange = function() {
            switch(vm.filters.orderBy) {
                case APPLICATION.STRING_COLUMN_ORDER_ATTENDANCE_DATE: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_ATTENDANCE_DATE; break;
                case APPLICATION.STRING_COLUMN_ORDER_SERVICE: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_SERVICE; break;
                case APPLICATION.STRING_COLUMN_ORDER_PROTOCOL: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_PROTOCOL; break;
                case APPLICATION.STRING_COLUMN_ORDER_USER: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_USER; break;
                default: vm.orderFieldSelectedRadio = APPLICATION.STRING_COLUMN_ORDER_ATTENDANCE_DATE; break;
            }
        };


        function distinctRole(value, index, self) { 
            return self.indexOf(value) === index;
        }

        function getId(item, index) { 
            return item.roleId;
        }
        /// <description>
        /// Método responsável pelo carregamento dos filtros e dos itens iniciais da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.loadFilters = function () {
            // Configuração dos filtros iniciais, data, paginação, etc.
            vm.filters = {};
            vm.filters.situationTypes = ['1'];
            vm.filters.pageNumber = 1;
            vm.filters.totalItens = vm.itensPorPagina;
            vm.filters.orderField = 'attendanceDate';
            vm.resetFiltersPaginationQuery(APPLICATION.STRING_COLUMN_ORDER);

            // Visibilidade dos filtros.
            vm.isDateIniFilterChecked = true;
            vm.isDateEndFilterChecked = true;
            vm.isServiceDescriptionFilterChecked = true;
            vm.isOcurrenceSituationFilterChecked = true;
            vm.isTypeSituationFilterChecked = true;
            vm.isUserNameFilterChecked = true;
            vm.isEmailFilterChecked = true;
            vm.isProtocolFilterChecked = true;
            vm.isSlaFilterChecked = true;
            vm.isOrderFilterChecked = true;
            vm.isPeriodFilterChecked = true;
            vm.isExternalProtocolFilterChecked = true;

            // Configuraçao dos loadings.
            vm.usuarioIsLoad = false;
            vm.isLoadingFiltros = true;

            // Configuração dos combos.
            vm.selectize_sources_categories = [];
            vm.selectize_sources_services = [];
            vm.selectize_sources_situations = [];
            vm.selectize_sources_users = [];
            vm.selectize_sources_users2 = [];
            vm.selectize_sources_users2.push(APPLICATION.STRING_CARREGANDO);
            vm.selectize_sources_sla = [];
            vm.selectize_sources_types = [];
            vm.selectize_sla_options = [];

            vm.tuple = false;

            // Configuração de paginação
            vm.total = 0;

            vm.selectize_sla_options.push({id: APPLICATION.INT_ZERO, description: 'No prazo'});
            vm.selectize_sla_options.push({id: APPLICATION.INT_UM, description: 'Excedida'});
            vm.selectize_sla_options.push({id: APPLICATION.INT_DOIS, description: 'Ambas'});

            // Configuração do filtro para a exportação do relatório.
            $rootScope.filterAttendanceRelatorio = vm.filters;
            vm.rolesIds = JSON.parse(localStorage.getItem('mt-account-permissions')).map(getId).filter(distinctRole);
            vm.filters.accessPermissionIds = vm.rolesIds;
            // Carrega a lista de solicitrações.
            vm.getAttendances(vm.filters).then(function (attendancesList) {
                // Carrega a lista de situações.
                Attendance.getSituations().then(function (situationsList) {
                    vm.attendances = vm.slaRemainingCount(vm.attendances);
                    // Carrega a lista de tipos de situações.
                    Situacao.getSituationTypes(null, vm.appCompany.id).then(function (result) {
                        vm.selectize_sources_types = result;
                        // Carrega a lista de status SLA.
                        Attendance.getSlaStatus().then(function (result) {
                            vm.selectize_sources_sla = result;
                            // Carrega a lista de serviços.
                            Attendance.getServicos().then(function (servicesList) {
                                
                                var servicesListNew = [];
                                var breakNew = false;
                                
                                for (var j = 0; j < servicesList.length; j++) {
                                    if (servicesList[j].accessPermissions) {
                                        for (var x = 0; x < servicesList[j].accessPermissions.length; x++) {
                                            for (var i = 0; i < vm.rolesIds.length; i++) {
                                                if (servicesList[j].accessPermissions[x].roleId == vm.rolesIds[i]) {
                                                    servicesListNew.push(servicesList[j]);
                                                    breakNew = true;
                                                    break;
                                                } 
                                            }  

                                            if (breakNew) {
                                                breakNew = false;
                                                break;
                                            }
                                        }
                                    }                    
                                }                                

                                vm.selectize_sources_services = servicesListNew;
                                vm.selectize_sources_services_backup = servicesListNew;
                                vm.isLoadingFiltros = false;

                                // Validação de exibição de atendimentos somente pela permissão de papel de usuário para o serviço do atendimento.
                                vm.total = 0;                                
                                for (var j = 0; j < vm.attendances.length; j++) {
                                    for (var i = 0; i < vm.selectize_sources_services_backup.length; i++) {                                    
                                        if (vm.attendances[j].service.id == vm.selectize_sources_services_backup[i].id) {
                                            vm.attendances[j].visible = true;
                                            vm.total++;
                                            //attendancesNewWithPermissions.push(vm.attendances[j]);
                                            break;
                                        }
                                    }    
                                }

                                var attendancesNewWithPermissions = [];
                                for (var i = 0; i < vm.attendances.length; i++) {
                                    if (vm.attendances[i].visible) {
                                        attendancesNewWithPermissions.push(JSON.parse(JSON.stringify(vm.attendances[i])));
                                    }
                                }
                                
                                vm.attendances = attendancesNewWithPermissions;

                                vm.tuple = true;

                                // Executa a tela de detalhamento com o primeiro item da lista de atendimentos selecionado.
                                if (vm.attendances && vm.attendances.length && vm.attendances.length > 0) {
                                    vm.FILTERS_REFRESH = JSON.parse(JSON.stringify(vm.filters));
                                    vm.detailAttendance(vm.attendances[0].id, 0);
                                } else {
                                    vm.attendances = [];
                                }
                                // Inicializa os componentes com base nos dados obtidos do servidor.                           
                                vm.initComponents();
                            });
                        });
                    });

                    vm.selectize_sources_situations = situationsList;

                    if (vm.attendances) {
                        for (var i = 0; i < vm.attendances.length; i++) {
                            for (var j = 0; j < situationsList.length; j++) {
                                if (vm.attendances[i].situationId == situationsList[j].id && situationsList[j].type == 1) {
                                    vm.attendances[i].showSlaOfTypeSituation = true;
                                    break;
                                }
                            }
                        }
                    }
                });
            });
        };

        /// <description>
        /// Método responsável pela inicialização dos componentes de combo da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.initComponents = function () {
            vm.listOrderBy = [];
            vm.listOrderBy.push({ id: 0, description: 'Selecione'});
            vm.listOrderBy.push({ id: 'attendancedate', description: 'Data'});
            vm.listOrderBy.push({ id: 'servicedescription', description: 'Serviço'});
            vm.listOrderBy.push({ id: 'protocol', description: 'Protocolo'});
            vm.listOrderBy.push({ id: 'username', description: 'Solicitante'});
            vm.filters.orderField = 'attendancedate';

            vm.listAscending = [];
            vm.listAscending.push({ id: 0, description: 'Selecione'});
            vm.listAscending.push({ id: 1, description: 'Crescente'});
            vm.listAscending.push({ id: 2, description: 'Decrescente'});
            vm.filters.pagIsAscending = 2;

            // Combo generico.
            vm.selectize_generic_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                searchField: APPLICATION.STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            // Combo de serviços.
            vm.selectize_sources_services_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: null,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                searchField: APPLICATION.STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            // Combo de situações.
            vm.selectize_sources_situations_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: null,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                searchField: APPLICATION.STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            vm.selectize_sources_sla_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: null,
                valueField: APPLICATION.STRING_ID,
                labelField: APPLICATION.STRING_DESCRIPTION,
                searchField: APPLICATION.STRING_DESCRIPTION,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.description) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.description) + '</div>';
                    }
                }
            };

            vm.selectize_sources_types_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: null,
                valueField: 'valor',
                labelField: 'name',
                searchField: 'name',
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.name) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.name) + '</div>';
                    }
                }
            };

            // Combo de usuários.
            vm.selectize_sources_users_config = {
                plugins: { remove_button: { label: '' } },
                maxItems: 1,
                valueField: APPLICATION.STRING_USER_ID,
                labelField: APPLICATION.STRING_NAME,
                searchField: APPLICATION.STRING_NAME,
                create: false,
                render: {
                    option: function (sources, escape) {
                        return '<div class="option">' +
                            '<span class="title">' + escape(sources.name) + '</span>' +
                            '</div>';
                    },
                    item: function (sources, escape) {
                        return '<div class="item">' + escape(sources.name) + '</div>';
                    }
                }
            };
        };

        /// <description>
        /// Método responsável pelo reset da ordenação de paginação da lista.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        vm.resetFiltersPaginationQuery = function (columnSorting) {
            vm.filters.sort = columnSorting;
        };

        /// <description>
        /// Método responsável pela atualização.
        /// </description>
        /// <author>
        /// Legado.
        /// </author>
        function atualizarAttendancesAposAcatamentoCancelamento(attendanceAtualizado) {
            for (var i = 0; i < vm.attendances.length; i++) {
                if (vm.attendances[i].id == attendanceAtualizado.id) {
                    vm.attendances.splice(i, 1, attendanceAtualizado);
                    break;
                }
            }
        };

        /// <description>
        /// Método responsável por obter a data do servidor e executar o cálculo do tempo de SLA restante para cada atendimento.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.slaRemainingCount = function (attendancesList) {
            Attendance.getDate().then(function (response) {
                var parseDataAtualServidor = Date.parse(response.month + APPLICATION.STRING_BAR + response.day + APPLICATION.STRING_BAR + response.year + APPLICATION.STRING_SPACE + response.hour);
                vm.dataAtualServidor = new Date(parseDataAtualServidor);
                vm.dateOfServer = true;

                for (var i = 0; i < attendancesList.length; i++) {
                    if (attendancesList[i].dateSLA && attendancesList[i].dateSLA.length > 10) {
                        var day = attendancesList[i].dateSLA.substring(0,2);
                        var month = attendancesList[i].dateSLA.substring(3,5);
                        var year = attendancesList[i].dateSLA.substring(6,10);
                        var hour = attendancesList[i].dateSLA.split(' ')[1];
                    }

                    // Efetua o parse da data inicial do atendimento.
                    var dataSla = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);

                    if (vm.dataAtualServidor > new Date(dataSla)) {
                      //console.log('Expirou');
                      vm.progressiveCount(attendancesList[i], response, true);
                    } else {
                      //console.log('Dentro do limite');
                      vm.processAttendanceWithSla(attendancesList[i], response, true);
                    }
                }                
            });

            return attendancesList;
        }

        /// <description>
        /// Método responsável por calcular o tempo de SLA em andamento a partir da data de criação do atendimento e a data atual.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.progressiveCount = function (attendancesList, responseServer, dateOfServer) {
          vm.progressive = true;
            // Verificação de existência do atendimento.    
            if (attendancesList != null) {
                var day = null;
                var month = null;
                var year = null;
                var hour = null;
                var parseDataAtual = null;

                if (attendancesList && vm.selectize_sources_situations) {
                    for (var j = 0; j < vm.selectize_sources_situations.length; j++) {
                        if (attendancesList.situationId == vm.selectize_sources_situations[j].id && vm.selectize_sources_situations[j].type == 1) {
                            attendancesList.showSlaOfTypeSituation = true;
                            break;
                        }
                    }
                }

                  // Tratamento para o cálculo do SLA / Serviço.
                    if (attendancesList.dateSLA && attendancesList.dateSLA.length > 10) {
                        var day = attendancesList.dateSLA.substring(0,2);
                        var month = attendancesList.dateSLA.substring(3,5);
                        var year = attendancesList.dateSLA.substring(6,10);
                        var hour = attendancesList.dateSLA.split(' ')[1];
                    }

                    var parseDataInicial = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);
                    var dataAtual = null;

                    if (dateOfServer) {
                        // Data obtida através do servidor.
                        parseDataAtual = Date.parse(responseServer.month + APPLICATION.STRING_BAR + responseServer.day + APPLICATION.STRING_BAR + responseServer.year + APPLICATION.STRING_SPACE + responseServer.hour);
                        dataAtual = new Date(parseDataAtual);
                    } else {
                        // Data obtida localmente (browser - caso o servidor não retorne).
                        dataAtual = new Date();
                    }

                    var dataInicial = new Date(parseDataInicial);
                    var diferenca = (dataAtual - dataInicial);

                    if (diferenca > 0) {
                        var dias = Math.floor(diferenca / (60 * 60 * 1000 * 24) * 1);
                        var horas = Math.floor((diferenca % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000) * 1);
                        var mins = Math.floor(((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000) * 1);
                        var secs = Math.floor((((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) / 1000 * 1);

                        attendancesList.dias = dias;
                        attendancesList.horas = horas;
                        attendancesList.minutos = mins;
                        attendancesList.segundos = secs;

                        // Adiciona o tempo de SLA na data inicial do cadastro do atendimento.
                        var novaDataInicial = new Date(dataInicial);
                        novaDataInicial.setSeconds(novaDataInicial.getSeconds() + attendancesList.service.slaTimeSeconds);

                        attendancesList.slaExcedido = true;
                    }
            }
        };

        /// <description>
        /// Método responsável pelo processamento dos SLAs de cada atendimento
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.processAttendanceWithSla = function (attendancesList, responseServer, dateOfServer) {
            var dataAtual = null;

            // Verificação de existência do atendimento.
            //if (attendancesList != null && attendancesList.length > 0) {
                if (attendancesList && vm.selectize_sources_situations) {
                    for (var j = 0; j < vm.selectize_sources_situations.length; j++) {
                        if (attendancesList.situationId == vm.selectize_sources_situations[j].id && vm.selectize_sources_situations[j].type == 1) {
                            attendancesList.showSlaOfTypeSituation = true;
                            break;
                        }
                    }
                }

                // Tratamento para o cálculo do SLA / Serviço.
                if (attendancesList.dateSLA && attendancesList.dateSLA.length > 10) {
                    var day = attendancesList.dateSLA.substring(0,2);
                    var month = attendancesList.dateSLA.substring(3,5);
                    var year = attendancesList.dateSLA.substring(6,10);
                    var hour = attendancesList.dateSLA.split(' ')[1];
                }

                // Efetua o parse da data inicial do atendimento.
                var dataSla = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);

                if (dateOfServer) {
                    // Data obtida através do servidor.
                    parseDataAtual = Date.parse(responseServer.month + APPLICATION.STRING_BAR + responseServer.day + APPLICATION.STRING_BAR + responseServer.year + APPLICATION.STRING_SPACE + responseServer.hour);
                    dataAtual = new Date(parseDataAtual);
                } else {
                    // Data obtida localmente (browser - caso o servidor não retorne).
                    dataAtual = new Date();
                }

                if (dataAtual < new Date(dataSla)) {

                    // Verificação de existência de SLA para o serviço do atendimento atual.
                    if (attendancesList.service.slaTimeSeconds) {
                        var parseDataInicial = null;
                        var novaDataInicial = null;
                        var parseDataAtual = null;
                        var dataInicial = null;
                        var diferenca = null;
                        var dias = null;
                        var horas = null;
                        var mins = null;
                        var secs = null;
                        var day = null;
                        var month = null;
                        var year = null;
                        var hour = null;

                        if (attendancesList.dateSLA && attendancesList.dateSLA.length > 10) {
                          var day = attendancesList.dateSLA.substring(0,2);
                          var month = attendancesList.dateSLA.substring(3,5);
                          var year = attendancesList.dateSLA.substring(6,10);
                          var hour = attendancesList.dateSLA.split(' ')[1];
                        }

                        // Efetua o parse da data inicial do atendimento.
                        parseDataInicial = Date.parse(month + APPLICATION.STRING_BAR + day + APPLICATION.STRING_BAR + year + APPLICATION.STRING_SPACE + hour);

                        // Após o parse, converte a data inicial para date do browser a fim de calcular a diferença das datas (inicial do atendimento) e atual (servidor ou browser).
                        dataInicial = new Date(parseDataInicial);

                        // Adiciona o tempo de SLA na data inicial do cadastro do atendimento.
                        novaDataInicial = new Date(dataInicial);
                        //novaDataInicial.setSeconds(novaDataInicial.getSeconds() + attendancesList.service.slaTimeSeconds);

                        // Efetua o cálculo do tempo restante de SLA para o atendimento atual.
                        diferenca = (novaDataInicial - dataAtual);
                        dias = Math.floor(diferenca / (60 * 60 * 1000 * 24) * 1);
                        horas = Math.floor((diferenca % (60 * 60 * 1000 * 24)) / (60 * 60 * 1000) * 1);
                        mins = Math.floor(((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) / (60 * 1000) * 1);
                        secs = Math.floor((((diferenca % (60 * 60 * 1000 * 24)) % (60 * 60 * 1000)) % (60 * 1000)) / 1000 * 1);

                        // Seta o tempo restante de SLA em cada item da lista.
                        attendancesList.dias = dias;
                        attendancesList.horas = horas;
                        attendancesList.minutos = mins;
                        attendancesList.segundos = secs;
                        attendancesList.slaExcedido = false;
                    
                    } else {
                        // Serviço do atendimento atual não possui SLA vinculado.
                        attendancesList.possuiSla = false;
                    }
                } else {
                    attendancesList.slaExcedido = true;
                }
            //}
        };

        vm.printDetails = function() {
            var printDetailsPage = window.open();
            printDetailsPage.document.write(document.getElementById('printDetails').innerHTML.replace('VER INFORMAÇÕES', '').replace('ALTERAR', '').replace('<h2 style="text-align:right" class="md-card-toolbar-heading-text">', '<h2 style="text-align:left" class="md-card-toolbar-heading-text">'));
            printDetailsPage.print();
        }

        /// <description>
        /// Método responsável pela inicialização da tela.
        /// </description>
        /// <author>
        /// Gabriel Souza.
        /// </author>
        vm.init = function () {           
            vm.configurarPermissoes();
            vm.loadFilters();
        };

        //vm.init();
        vm.accessIsAllowed = Security.exitsProfilePermission({ id: 1, name: "Solicitações/Atendimentos", action: "R" });;
        angular.extend(this, $controller('BaseApp', {$scope: this}));
    }

    angular.module('app.attendance')
        .controller('AttendanceController', AttendanceController);

})();

(function () {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $stateParams, $http, $window, $timeout, $document, DashboardCompany, variables, Session, Idle, AUTH_EVENTS, SignalR, Analytics) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        
        //Google Analytics
        var lstnrClbAnalytics = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
            var titleNew = toState && toState.data ? toState.data.title : null;
            Analytics.trackPage(Analytics.getUrl(), titleNew);
            Analytics.pageView();
        });

        $rootScope.$on('$destroy', function () {
            [lstnrClbAnalytics].forEach(function (fn) {
                fn();
            });
        });


        var lstnrClb1 = $rootScope.$on('$stateChangeSuccess', function () {
            // scroll view to top
            angular.element("html, body").animate({
                scrollTop: 0
            }, 200);

            $timeout(function () {
                $rootScope.pageLoading = false;
                angular.element($window).resize();
            }, 300);

            $timeout(function () {
                $rootScope.pageLoaded = true;
                $rootScope.appInitialized = true;
                // wave effects
                $window.Waves.attach('.md-btn-wave,.md-fab-wave', ['waves-button']);
                $window.Waves.attach('.md-btn-wave-light,.md-fab-wave-light', ['waves-button', 'waves-light']);
            }, 600);

        });

        var lstnrClb2 = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            // main search
            $rootScope.mainSearchActive = false;
            // single card
            $rootScope.headerDoubleHeightActive = false;
            // top bar
            $rootScope.toBarActive = false;
            // page heading
            $rootScope.pageHeadingActive = false;
            // top menu
            $rootScope.topMenuActive = false;
            // full header
            $rootScope.fullHeaderActive = false;
            // full height
            $rootScope.page_full_height = true;
            // secondary sidebar
            $rootScope.sidebar_secondary = false;
            $rootScope.secondarySidebarHiddenLarge = false;

            if (angular.element($window).width() < 1220) {
                // hide primary sidebar
                $rootScope.primarySidebarActive = false;
                $rootScope.hide_content_sidebar = false;
            }
            if (!toParams.hasOwnProperty('hidePreloader')) {
                $rootScope.pageLoading = true;
                $rootScope.pageLoaded = false;
            }
        });

        // fastclick (eliminate the 300ms delay between a physical tap and the firing of a click event on mobile browsers)
        // TODO Remover
        FastClick.attach($document.body);

        // get version from package.json
        // $http.get('./package.json').success(function(response) {
        //     $rootScope.appVer = response.version;
        // });

        // modernizr
        $rootScope.Modernizr = Modernizr;

        // get window width
        var w = angular.element($window);
        $rootScope.largeScreen = w.width() >= 1220;

        w.on('resize', function () {
            var isLargeScreen = w.width() >= 1220;
            $rootScope.largeScreen = isLargeScreen;

            return $rootScope.largeScreen;
        });

        // show/hide main menu on page load
        //inicia o sistema com o menu fechado
        $rootScope.primarySidebarOpen = false;// ($rootScope.largeScreen) ? true : false;

        $rootScope.pageLoading = true;

        // wave effects
        $window.Waves.init();

        $rootScope.$on('$destroy', function () {
            [
                lstnrClb1,
                lstnrClb2
            ].forEach(function (fn) {
                fn();
            });
        });

        //Sair
        $rootScope.logout = function () {
            UIkit.modal.confirm('Tem certeza que deseja sair da aplicação?', function () {
                DashboardCompany.removerAppSelecionada();
                // $rootScope.$broadcast('reload-menu');
                $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
            });
        }

        $rootScope.idleLogout = function () {
            $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
        }

        //Idle timeout
        $rootScope.$on('IdleTimeout', function () {
            $rootScope.idleLogout();
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider, $urlMatcherFactoryProvider) {

        $urlMatcherFactoryProvider.strictMode(false);

        //login
        $stateProvider
            .state('public', {
                abstract: true,
                template: '<ui-view/>',
                checkAppCompany: false

            })
            .state('public.login', {
                url: '/',
                controllerAs: 'vm',
                controller: 'LoginCtrl',
                templateUrl: 'app/login/login.html',
                reloadCompany: false
            })

            .state('public.esqueceusenha', {
                url: '/esqueceusenha?:op&:email',
                controllerAs: 'vm',
                controller: 'EsqueceuSenhaCtrl',
                templateUrl: 'app/login/esqueceusenha.html',
                reloadCompany: false
            })
            .state('public.recuperarsenha', {
                url: '/recuperarsenha',
                controllerAs: 'vm',
                controller: 'RecuperarSenhaCtrl',
                templateUrl: 'app/login/recuperarsenha.html',
                reloadCompany: false
            })
            .state('public.ativacao', {
                url: '/ativacao',
                controllerAs: 'vm',
                controller: 'AtivacaoCtrl',
                templateUrl: 'app/login/ativacao.html',
                reloadCompany: false
            })
            .state('public.temporarypwd', {
                url: '/temporarypwd?:userId&:code&:codeRecoverPassword',
                controllerAs: 'vm',
                controller: 'ChangeTemporaryPasswordCtrl',
                templateUrl: 'app/login/temporarypwd.html',
                reloadCompany: false
            })

        //menu
        $stateProvider
            .state('private', {
                abstract: true,
                template: '<ui-view class="uk-height-1-1"/>',
                reloadCompany: false
            })
            .state('private.painel', {
                url: '/admin',
                controllerAs: 'vm',
                controller: 'PainelController',
                templateUrl: 'app/painel/painel.html',
                data: {
                    title: 'Painel'
                },
                reloadCompany: false
            })

            // Attendances
            .state('private.painel.attendance', {
                abstract: true,
                url:'/attendance',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })            
            .state('private.painel.attendance.list', {
                url: '/list',
                views: {
                    main_view:{
                        controllerAs: 'vm',
                        controller: 'AttendanceController',
                        templateUrl: 'app/attendance/attendance.html'
                    }
                }
            })
            .state('private.painel.attendance.list.detail', {
                url: '/:id?hidePreloader',
                controllerAs: 'vm',
                controller: 'AttendanceDetailController',
                templateUrl: 'app/attendance/attendance.detail.html',
                data: {
                    title: 'Atendimentos'
                }
            }) 
            .state('private.painel.attendance.form',{
                url:'/form',                
            })
            .state('private.painel.attendance.form.list', {
                url: '/list/:modulo',
                views:{
                    "main_view@private.painel.attendance":{
                        controllerAs: 'vm',
                        controller: 'FormListController',
                        templateUrl: 'app/form/form.list.html',
                    }
                },
                params:{
                    modulo:{
                        value:'Relacionamento'
                    }
                }
            })
            .state('private.painel.attendance.form.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.attendance":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }

            })
            .state('private.painel.attendance.form.list.answers', {
                url: '/answers/:id/:formName',
                views:{
                    "main_view@private.painel.attendance":{
                        controllerAs: 'vm',
                        controller: 'FormAnswersController',
                        templateUrl: 'app/form/form.answers.html',
                    }
                }
            })
            .state('private.painel.attendance.form.list.statistics', {
                url: '/statistics/:id/:formName',
                views:{
                    "main_view@private.painel.attendance":{
                        controllerAs: 'vm',
                        controller: 'FormStatisticsController',
                        templateUrl: 'app/form/form.statistics.html',
                    }
                }
            })
            .state('private.painel.attendance.form.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.attendance":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }
            })
            
            // Push
            .state('private.painel.mensagem', {
                abstract: true,
                url: '/mensagem',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })
            .state('private.painel.mensagem.list', {
                url: '/list',
                views: {
                    main_view:{
                        controllerAs: 'vm',
                        controller: 'PushListController',
                        templateUrl: 'app/push/push.list.html',
                    }
                }
            })
            .state('private.painel.mensagem.list.detail', {
                url: '/detail/:id?hidePreloader',
                controllerAs: 'vm',
                controller: 'PushDetailController',
                templateUrl: 'app/push/push.detail.html',
                data: {
                    title: 'Mensagens'
                }
            })
            .state('private.painel.mensagem.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.mensagem":{
                        controllerAs: 'vm',
                        controller: 'PushCreateController',
                        templateUrl: 'app/push/push.create.html',
                    }
                }
            })
            .state('private.painel.mensagem.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.mensagem":{
                        controllerAs: 'vm',
                        controller: 'PushCreateController',
                        templateUrl: 'app/push/push.create.html',
                    }
                }
            })
            // Push Log
            .state('private.painel.mensagemlog', {
                abstract: true,
                url: '/mensagemlog',
                template: '<ui-view class="uk-height-1-1"/>'
            })
            .state('private.painel.mensagemlog.list', {
                url: '/list',
                controllerAs: 'vm',
                controller: 'PushLogListController',
                templateUrl: 'app/push.api.log/pushlog.list.html',
                data: {
                    title: 'Log de API'
                },
            })
            .state('private.painel.mensagemlog.list.detail', {
                url: '/detail/:id?hidePreloader',
                controllerAs: 'vm',
                controller: 'PushLogDetailController',
                templateUrl: 'app/push.api.log/pushlog.detail.html',
                data: {
                    title: 'Log de API'
                }
            })
            //Categoria
            .state('private.painel.category', {
                abstract: true,
                url: '/category',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })
            .state('private.painel.category.list', {
                url: '/list',                
                views:{
                    main_view:{                        
                        controllerAs: 'vm',
                        controller: 'CategoryListController',
                        templateUrl: 'app/category/category.list.html',
                    }
                }
            })
            .state('private.painel.category.detail', {
                url: '/detail/:id',
                controllerAs: 'vm',
                controller: 'CategoryDetailController',
                templateUrl: 'app/category/category.detail.html',
                data: {
                    title: 'Categorias'
                }
            })
            .state('private.painel.category.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.category":{                        
                        controllerAs: 'vm',
                        controller: 'CategoryCreateController',
                        templateUrl: 'app/category/category.list.create.html',
                    }
                }
            })
            .state('private.painel.category.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.category":{                        
                        controllerAs: 'vm',
                        controller: 'CategoryCreateController',
                        templateUrl: 'app/category/category.list.create.html',
                    }
                }
            })
            // Dashboard-Relacionamento
            .state('private.painel.dashboard.relacionamento', {
                url: '/dashboard',
                controllerAs: 'vm',
                controller: 'DashboardController',
                templateUrl: 'app/dashboard.relacionamento/dashboard.html',
                data: {
                    title: 'Dashboard'
                }
            })
            //DASHBOARD
            .state('private.painel.dashboard', {
                abstract: true,
                url: '/dashboard',
                template: '<ui-view/>'
            })
            .state('private.painel.dashboard.main', {
                url: '/company/:key',
                controllerAs: 'vm',
                controller: 'DashboardCompanyController',
                templateUrl: 'app/dashboard.company/dashboard.company.html',
                data: {
                    title: 'Dashboard'
                },
                reloadCompany: false
            })
            .state('private.painel.dashboard.geral', {
                url: '/geral',
                controllerAs: 'vm',
                controller: 'DashboardGeralController',
                templateUrl: 'app/dashboard.geral/dashboard.geral.html',
                data: {
                    title: 'Dashboard'
                },
                reloadCompany: false
            })
            .state('private.painel.dashboard.menuapp', {
                url: '/app',
                controllerAs: 'vm',
                controller: 'DashboardMenuAppController',
                templateUrl: 'app/dashboard.menu.app/dashboard.menu.app.html',
                data: {
                    title: 'Dashboard'
                }
            })
            .state('private.painel.dashboard.app', {
                url: '/app/:key/:firstAccess',
                controllerAs: 'vm',
                controller: 'DashboardAppController',
                templateUrl: 'app/dashboard.app/dashboard.app.html',
                data: {
                    title: 'APP Dashboard'
                }
            })
            // // Dashboard Company
            // .state('private.painel.dashboard', {
            //     url: '/dashboard',
            //     controllerAs: 'vm',
            //     controller: 'DashboardCompanyController',
            //     templateUrl: 'app/dashboard.company/dashboard.company.html',
            //     data: {
            //         title: 'Dashboard'
            //     }
            // })
            // // Dashboard App
            // .state('private.painel.dashboardapp', {
            //     url: '/appdashboard',
            //     controllerAs: 'vm',
            //     controller: 'DashboardAppController',
            //     templateUrl: 'app/dashboard.app/dashboard.app.html',
            //     data: {
            //         title: 'APP Dashboard'
            //     }
            // })

            //Serviço
            .state('private.painel.servico', {
                abstract: true,
                url: '/servico',
                template: '<ui-view/>'
            })
            .state('private.painel.servico.list', {
                url: '/list',
                controllerAs: 'vm',
                controller: 'ServicoListController',
                templateUrl: 'app/servico/servico.list.html',
                data: {
                    title: 'Cardápio de Serviços'
                }
            })
            .state('private.painel.servico.detail', {
                url: '/detail/:id',
                controllerAs: 'vm',
                controller: 'ServicoDetailController',
                templateUrl: 'app/servico/servico.detail.html',
                data: {
                    title: 'Cardápio de Serviços'
                }
            })
            .state('private.painel.servico.edit', {
                url: '/edit/:id',
                controllerAs: 'vm',
                controller: 'ServicoCreateController',
                templateUrl: 'app/servico/servico.create.html',
                data: {
                    title: 'Cardápio de Serviços'
                }
            })
            .state('private.painel.servico.create', {
                url: '/create',
                controllerAs: 'vm',
                controller: 'ServicoCreateController',
                templateUrl: 'app/servico/servico.create.html',
                data: {
                    title: 'Cardápio de Serviços'
                }
            })
            // Configuracao
            .state('private.painel.configuracao', {
                url: '/configuracao',
                controllerAs: 'vm',
                controller: 'ConfiguracaoController',
                templateUrl: 'app/configuracao/configuracao.html',
                data: {
                    title: 'Configuração'
                }
            })
            //Cliente
            .state('private.painel.cliente', {
                abstract: true,
                url: '/cliente',
                template: '<ui-view class="uk-height-1-1"/>'
            })
            .state('private.painel.cliente.list', {
                url: '/list',
                cache: false,
                controllerAs: 'vm',
                controller: 'ClienteListController',
                templateUrl: 'app/usuario.mobile/cliente.list.html',
                data: {
                    title: 'Clientes'
                }
            })
            .state('private.painel.cliente.list.detail', {
                url: '/detail/:id?hidePreloader',
                cache: false,
                controllerAs: 'vm',
                controller: 'ClienteDetailController',
                templateUrl: 'app/usuario.mobile/cliente.detail.html',
                data: {
                    title: 'Clientes'
                }
            })
            .state('private.painel.cliente.edit', {
                url: '/edit/:id',
                controllerAs: 'vm',
                controller: 'ClienteCreateController',
                templateUrl: 'app/usuario.mobile/cliente.create.html',
                data: {
                    title: 'Usuários'
                }
            })
            .state('private.painel.cliente.create', {
                url: '/create',
                controllerAs: 'vm',
                controller: 'ClienteCreateController',
                templateUrl: 'app/usuario.mobile/cliente.create.html',
                data: {
                    title: 'Clientes'
                }
            })
            //Usuario
            .state('private.painel.usuario', {
                abstract: true,
                url: '/usuario',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>',
                reloadCompany: false
            })
            .state('private.painel.usuario.list', {
                url: '/list',
                cache: false,                
                views:{
                    main_view:{                        
                        controllerAs: 'vm',
                        controller: 'UsuarioListController',
                        templateUrl: 'app/usuario.admin/usuario.list.html'
                    }
                },
                reloadCompany: false
            })
            .state('private.painel.usuario.list.detail', {
                url: '/detail/:id?hidePreloader?papel',
                cache: false,
                controllerAs: 'vm',
                controller: 'UsuarioDetailController',
                templateUrl: 'app/usuario.admin/usuario.detail.html',
                data: {
                    title: 'Usuários'
                },
                reloadCompany: false
            })
            .state('private.painel.usuario.list.edit', {
                url: '/edit/:id',                
                views:{
                    "main_view@private.painel.usuario":{
                        controllerAs: 'vm',
                        controller: 'UsuarioCreateController',
                        templateUrl: 'app/usuario.admin/usuario.create.html',
                    }
                },
                reloadCompany: false
            })
            .state('private.painel.usuario.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.usuario":{
                        controllerAs: 'vm',
                        controller: 'UsuarioCreateController',
                        templateUrl: 'app/usuario.admin/usuario.create.html',
                    }
                },
                reloadCompany: false
            })
            //Relatórios
            .state('private.painel.atendimento', {
                abstract: true,
                url: '/relatorios',
                template: '<ui-view class="uk-height-1-1"/>'
            })
            .state('private.painel.atendimento.list', {
                url: '/atendimento',
                controllerAs: 'vm',
                controller: 'AtendimentoListController',
                templateUrl: 'app/relatorios/atendimento.list.html',
                data: {
                    title: 'Relatório Analítico de Atendimento'
                }
            })
            .state('private.painel.atendimento.grouplist', {
                url: '/atendimento/sintetico',
                controllerAs: 'vm',
                controller: 'AtendimentoSinteticoListController',
                templateUrl: 'app/relatorios/atendimento.grouplist.html',
                data: {
                    title: 'Relatório Sintético de Atendimento'
                }
            })
            //Relatorios Mensagens Achados
            .state('private.painel.relatorio', {
                abstract: true,
                url: '/relatorio',
                template: '<ui-view/>'
            })
            .state('private.painel.relatorio.mensagens', {
                url: '/mensagens',
                controllerAs: 'vm',
                controller: 'MensagensListController',
                templateUrl: 'app/relatorios/mensagens.list.html',
                data: {
                    title: 'Relatórios de Mensagens Enviadas'
                }
            })

            //MessagePriority
            .state('private.painel.messagepriority', {
                abstract: true,
                url: '/messagepriority',
                template: '<ui-view class="uk-height-1-1"/>'
            })
            .state('private.painel.messagepriority.list', {
                url: '/list',
                controllerAs: 'vm',
                controller: 'MessagePriorityListController',
                templateUrl: 'app/message.priority/message.priority.list.html',
                data: {
                    title: 'Prioridade da Mensagem'
                }
            })
            .state('private.painel.messagepriority.detail', {
                url: '/detail/:id',
                controllerAs: 'vm',
                controller: 'MessagePriorityDetailController',
                templateUrl: 'app/message.priority/message.priority.detail.html',
                data: {
                    title: 'Prioridade da Mensagem'
                }
            })
            .state('private.painel.messagepriority.edit', {
                url: '/edit/:id',
                controllerAs: 'vm',
                controller: 'MessagePriorityCreateController',
                templateUrl: 'app/message.priority/message.priority.create.html',
                data: {
                    title: 'Prioridade da Mensagem'
                }
            })
            .state('private.painel.messagepriority.create', {
                url: '/create',
                controllerAs: 'vm',
                controller: 'MessagePriorityCreateController',
                templateUrl: 'app/message.priority/message.priority.create.html',
                data: {
                    title: 'Prioridade da Mensagem'
                }
            })
            //MessageTemplate
            .state('private.painel.messagetemplate', {
                abstract: true,
                url: '/messagetemplate',
                template: '<ui-view class="uk-height-1-1"/>'
            })
            .state('private.painel.messagetemplate.list', {
                url: '/list',
                controllerAs: 'vm',
                controller: 'MessageTemplateListController',
                templateUrl: 'app/message.template/message.template.list.html',
                data: {
                    title: 'Mensagens Padrão'
                }
            })
            .state('private.painel.messagetemplate.detail', {
                url: '/detail/:id',
                controllerAs: 'vm',
                controller: 'MessageTemplateDetailController',
                templateUrl: 'app/message.template/message.template.detail.html',
                data: {
                    title: 'Mensagens Padrão'
                }
            })
            .state('private.painel.messagetemplate.edit', {
                url: '/edit/:id',
                controllerAs: 'vm',
                controller: 'MessageTemplateCreateController',
                templateUrl: 'app/message.template/message.template.create.html',
                data: {
                    title: 'Mensagens Padrão'
                }
            })
            .state('private.painel.messagetemplate.create', {
                url: '/create',
                controllerAs: 'vm',
                controller: 'MessageTemplateCreateController',
                templateUrl: 'app/message.template/message.template.create.html',
                data: {
                    title: 'Mensagens Padrão'
                }
            })            
            //Papel
            .state('private.painel.papel', {
                abstract: true,
                url: '/papel',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>',
                reloadCompany: false
            })
            .state('private.painel.papel.list', {
                url: '/list',
                views:{
                    main_view:{
                        controllerAs: 'vm',
                        controller: 'PapelListController',
                        templateUrl: 'app/papel/papel.list.html',
                    }
                },
                reloadCompany: false
            })
            .state('private.painel.papel.list.detail', {
                url: '/detail/:id',
                views:{
                    "main_view@private.painel.papel":{
                        controllerAs: 'vm',
                        controller: 'PapelDetailController',
                        templateUrl: 'app/papel/papel.detail.html',
                    }
                },
                reloadCompany: false
            })
            .state('private.painel.papel.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.papel":{
                        controllerAs: 'vm',
                        controller: 'PapelCreateController',
                        templateUrl: 'app/papel/papel.create.html',
                    }
                },
                reloadCompany: false
            })
            .state('private.painel.papel.list.create', {
                url: '/create',                
                views:{
                    "main_view@private.painel.papel":{
                        controllerAs: 'vm',
                        controller: 'PapelCreateController',
                        templateUrl: 'app/papel/papel.create.html',
                    }
                },
                reloadCompany: false
            })
            //situacao
            .state('private.painel.situacao', {
                abstract: true,
                url: '/situacao',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })
            .state('private.painel.situacao.list', {
                url: '/list',
                views:{
                    main_view:{
                        controllerAs: 'vm',
                        controller: 'SituacaoListController',
                        templateUrl: 'app/situacao/situacao.list.html',
                    }
                }
            })
            .state('private.painel.situacao.list.detail', {
                url: '/detail/:id',
                views:{
                    "main_view@private.painel.situacao":{
                        controllerAs: 'vm',
                        controller: 'SituacaoDetailController',
                        templateUrl: 'app/situacao/situacao.detail.html',
                    }
                }
            })
            .state('private.painel.situacao.list.edit', {
                url: '/edit/:id',                
                views:{
                    "main_view@private.painel.situacao":{
                        controllerAs: 'vm',
                        controller: 'SituacaoCreateController',
                        templateUrl: 'app/situacao/situacao.create.html',
                    }
                }
            })
            .state('private.painel.situacao.list.create', {
                url: '/create',                
                views:{
                    "main_view@private.painel.situacao":{
                        controllerAs: 'vm',
                        controller: 'SituacaoCreateController',
                        templateUrl: 'app/situacao/situacao.create.html',
                    }
                }
            })

            // É necessário incluir uma rota para cada modulo do form visto para que esse não se perca na arvore do menu.
            //Form Integracao
            .state('private.painel.integracao',{
                abstract: true,
                url:'/integracao',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })
            .state('private.painel.integracao.form', {
                url:'/form',   
            })            
            .state('private.painel.integracao.form.list', {
                url: '/list/:modulo',
                views:{
                    "main_view@private.painel.integracao":{
                        controllerAs: 'vm',
                        controller: 'FormListController',
                        templateUrl: 'app/form/form.list.html',
                    }
                },
                params:{
                    modulo:{
                        value:'Integracao'
                    }
                }

            })
            .state('private.painel.integracao.form.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.integracao":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }

            })
            .state('private.painel.integracao.form.list.answers', {
                url: '/answers/:id/:formName',
                views:{
                    "main_view@private.painel.integracao":{
                        controllerAs: 'vm',
                        controller: 'FormAnswersController',
                        templateUrl: 'app/form/form.answers.html',
                    }
                }
            })
            .state('private.painel.integracao.form.list.statistics', {
                url: '/statistics/:id/:formName',
                views:{
                    "main_view@private.painel.integracao":{
                        controllerAs: 'vm',
                        controller: 'FormStatisticsController',
                        templateUrl: 'app/form/form.statistics.html',
                    }
                }
            })
            .state('private.painel.integracao.form.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.integracao":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }
            })

            //Form NPS
            .state('private.painel.pesquisa',{
                abstract: true,
                url:'/pesquisa',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })
            .state('private.painel.pesquisa.form', {
                url:'/form',   
            })            
            .state('private.painel.pesquisa.form.list', {
                url: '/list/:modulo',
                views:{
                    "main_view@private.painel.pesquisa":{
                        controllerAs: 'vm',
                        controller: 'FormListController',
                        templateUrl: 'app/form/form.list.html',
                    }
                },
                params:{
                    modulo:{
                        value:'Nps'
                    }
                }

            })
            .state('private.painel.pesquisa.form.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.pesquisa":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }

            })
            .state('private.painel.pesquisa.form.list.answers', {
                url: '/answers/:id/:formName',
                views:{
                    "main_view@private.painel.pesquisa":{
                        controllerAs: 'vm',
                        controller: 'FormAnswersController',
                        templateUrl: 'app/form/form.answers.html',
                    }
                }
            })
            .state('private.painel.pesquisa.form.list.statistics', {
                url: '/statistics/:id/:formName',
                views:{
                    "main_view@private.painel.pesquisa":{
                        controllerAs: 'vm',
                        controller: 'FormStatisticsController',
                        templateUrl: 'app/form/form.statistics.html',
                    }
                }
            })
            .state('private.painel.pesquisa.form.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.pesquisa":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }
            })

            //Form Coleta
            .state('private.painel.coleta',{
                abstract: true,
                url:'/coleta',
                template: '<div ui-view="main_view" class="uk-height-1-1"></div>'
            })
            .state('private.painel.coleta.form', {
                url:'/form',   
            })            
            .state('private.painel.coleta.form.list', {
                url: '/list/:modulo',
                views:{
                    "main_view@private.painel.coleta":{
                        controllerAs: 'vm',
                        controller: 'FormListController',
                        templateUrl: 'app/form/form.list.html',
                    }
                },
                params:{
                    modulo:{
                        value:'FormGeral'
                    }
                }

            })
            .state('private.painel.coleta.form.list.edit', {
                url: '/edit/:id',
                views:{
                    "main_view@private.painel.coleta":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }

            })
            .state('private.painel.coleta.form.list.answers', {
                url: '/answers/:id/:formName',
                views:{
                    "main_view@private.painel.coleta":{
                        controllerAs: 'vm',
                        controller: 'FormAnswersController',
                        templateUrl: 'app/form/form.answers.html',
                    }
                }
            })
            .state('private.painel.coleta.form.list.statistics', {
                url: '/statistics/:id/:formName',
                views:{
                    "main_view@private.painel.coleta":{
                        controllerAs: 'vm',
                        controller: 'FormStatisticsController',
                        templateUrl: 'app/form/form.statistics.html',
                    }
                }
            })
            .state('private.painel.coleta.form.list.create', {
                url: '/create',
                views:{
                    "main_view@private.painel.coleta":{
                        controllerAs: 'vm',
                        controller: 'FormCreateController',
                        templateUrl: 'app/form/form.create.html',
                    }
                }
            })

            // Not Found
            .state('private.painel.error', {
                abstract: true,
                url: '/error',
                template: '<ui-view class="uk-height-1-1"/>'
            })
            .state('private.painel.error.notfound', {
                url: '/notfound',
                templateUrl: 'app/error/404.html',
                data: {
                    title: 'Em construção'
                },
            })
            .state('private.painel.error.notallowedaccess', {
                url: '/notallowedaccess',
                templateUrl: 'app/error/notallowedaccess.html',
                data: {
                    title: 'Accesso não permitido'
                },
            })
        $urlRouterProvider.otherwise('/');
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('variables', {
      header__main_height: 48,
      easing_swiftOut: [ 0.4,0,0.2,1 ],
      bez_easing_swiftOut: $.bez([ 0.4,0,0.2,1 ])
    });

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(config);

    /** @ngInject */
    function config($logProvider, toastrConfig, RestangularProvider, $httpProvider, $rootScopeProvider) { // MapConfigProvider
        // Enable log
        $logProvider.debugEnabled(true);
        //workaround for diget cycle errors in form creation - default limit is 10
        $rootScopeProvider.digestTtl(15);
    }
    


})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/attendance/attendance.detail.html","<div id=\"printDetails\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingDetail\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingDetail\" class=\"uk-text-small\"><div id=\"scrum_column_inProgress\"><div class=\"md-card grow1\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-file-text fleury-color-default\" style=\"padding-right:5px\"></i> ATENDIMENTO</span></h2></div><div class=\"md-card-content\"><span>Protocolo Interno: <b>{{vm.attendance.protocol}}</b>.</span><br><span>Protocolo Externo: <b ng-show=\"vm.attendance.externalProtocol\">{{vm.attendance.externalProtocol}}</b> <b ng-show=\"!vm.attendance.externalProtocol\">Nenhum</b>.</span><br><span>Aberto via: <b ng-show=\"vm.attendance.occurrenceSource == 1\">Mobile</b> <b ng-show=\"vm.attendance.occurrenceSource != 1\">Manager</b>.</span><br><span class=\"uk-text\">Categoria: <b>{{vm.attendance.service.category.description}}</b>.</span><br><span class=\"uk-text\">Serviço: <b>{{vm.attendance.service.description}}</b>.</span> <span class=\"uk-text\" ng-if=\"vm.attendance.associatedUserId\"><br>Atribuído para: <b>{{vm.attendance.associatedUserName}}</b>.</span></div><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-user fleury-color-default\" style=\"padding-right:5px\"></i> SOLICITANTE</span></h2></div><div class=\"md-card-content\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-xLarge-10-10 uk-width-large-10-10 uk-width-medium-10-10 uk-width-small-10-10 md-list-outside-wrapper\"><span class=\"uk-text\" ng-if=\"vm.attendance.userName\"><b>Nome do Solicitante:</b> {{vm.attendance.userName}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userName\"><b>Nome do Solicitante:</b> Não existem informações de <b>nome</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.userLogin\"><b>Login:</b> {{vm.attendance.userLogin}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userLogin\"><b>Login:</b> Não existem informações de <b>login</b>.<br></span><span class=\"uk-text\" ng-if=\"vm.attendance.userTelephone\"><b>Telefone:</b> {{vm.attendance.userTelephone.text.replace(\"|\",\" \").replace(\"|\",\" \")}}</span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userTelephone\"><b>Telefone:</b> Não existem informações de <b>telefone</b>.</span><br><span class=\"uk-text\" ng-if=\"vm.attendance.documentType\"><b>Documento:</b>{{vm.attendance.documentType}} - {{vm.attendance.documentNumber}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.sex\"><b>Documento:</b> Não existem informações de <b>documento</b>.<br></span> <a data-uk-modal=\"{target:\'#modalInfoUser\'}\" class=\"md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light\" style=\"float:right; margin-top:-45px; font-size: 11px !important; padding:0px 15px 0px 15px !important;\">VER INFORMAÇÕES</a></div></div></div><div class=\"md-card-toolbar\" style=\"text-align:right\"><h2 style=\"text-align:right\" class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-clock-o fleury-color-default\" style=\"padding-right:5px\"></i> PRAZOS</span></h2></div><div class=\"md-card-content\"><span class=\"uk-text\">Iniciado em: <b>{{vm.attendance.attendanceDate}}</b></span><br><span class=\"uk-text\" ng-if=\"vm.attendance.service.slaTimeSeconds > 0\">SLA: <span style=\"margin-bottom:3px;\" class=\"uk-badge\" ng-if=\"vm.attendance.service.slaTimeSeconds > 0\"><b ng-if=\"vm.slaCalculated\">{{vm.slaCalculated}}h</b> <b ng-if=\"!vm.slaCalculated\">{{vm.attendance.service.slaDescription}}</b></span> - <span ng-if=\"!vm.progressive\"><b>{{vm.attendance.dateSLA}}</b></span> <span ng-if=\"vm.progressive\"><b>{{vm.attendance.dateSLA}}</b></span> <span ng-if=\"vm.showSlaOfTypeSituation\">-</span> <span ng-if=\"vm.slaExcedido && !vm.progressive && vm.showSlaOfTypeSituation\" class=\"uk-badge\" style=\"background-color: #aaa !important\" data-uk-alert=\"\">Carregando...</span><span ng-if=\"vm.attendance.service.slaTimeSeconds > 0 && vm.slaExcedido && vm.progressive && vm.showSlaOfTypeSituation\" class=\"uk-badge uk-badge-danger grow-scale2\" data-uk-alert=\"\" style=\"margin-left:2px\">Expirada há: <span ng-if=\"vm.dias > 0\">{{vm.dias}}d</span> <span ng-if=\"vm.horas > 0\">{{vm.horas}}h</span> <span ng-if=\"vm.minutos > 0\">{{vm.minutos}}m</span> <span ng-if=\"vm.segundos > 0\">{{vm.segundos}}s.</span></span><span ng-if=\"vm.attendance.service.slaTimeSeconds > 0 && !vm.slaExcedido && !vm.progressive && vm.showSlaOfTypeSituation\" class=\"uk-badge uk-badge-success grow-scale2\" data-uk-alert=\"\" style=\"margin-left:2px\">Restam: <span ng-if=\"vm.dias > 0\">{{vm.dias}}d</span> <span ng-if=\"vm.horas > 0\">{{vm.horas}}h</span> <span ng-if=\"vm.minutos > 0\">{{vm.minutos}}m</span> <span ng-if=\"vm.segundos > 0\">{{vm.segundos}}s.</span></span></span><br><span class=\"uk-text\" ng-if=\"vm.attendance.dateFinishProcess\"><span ng-if=\"vm.attendance.situation.type==2 || vm.attendance.situation.type==3\">Encerrado</span> <span ng-if=\"vm.attendance.situation.type==4\">Cancelado</span> em: <b>{{vm.attendance.dateFinishProcess}}</b></span></div></div><div class=\"md-card grow2\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-tag fleury-color-default\" style=\"padding-right:5px\"></i> ATUALIZAÇÃO DA SOLICITAÇÃO</span></h2></div><div class=\"md-card-content\"><div class=\"uk-accordion\" id=\"accordionContent\" ng-if=\"!vm.attendance.availableServiceSituations || vm.attendance.availableServiceSituations.length == 0\"><h3 class=\"uk-accordion-title uk-text-small\" style=\"padding:10px; content: none;\"><span><b>Situação:</b> {{vm.attendance.situation.description}} <span ng-if=\"vm.attendance.situation.type==1\">(Aberta)</span> <span ng-if=\"vm.attendance.situation.type==2\">(Encerramento Com Sucesso)</span> <span ng-if=\"vm.attendance.situation.type==3\">(Encerramento Sem Sucesso)</span> <span ng-if=\"vm.attendance.situation.type==4\">(Cancelamento)</span></span> <b><i style=\"margin-left:5px;\" class=\"mobilecare-icons\" tooltips=\"\" tooltip-size=\"medium\" tooltip-side=\"top\" tooltip-template=\"Não existe fluxo de atendimento para esta situação.\">&#xe98c;</i></b></h3></div><div class=\"uk-accordion\" id=\"accordionContent\" data-uk-accordion=\"{showfirst:false}\" ng-if=\"vm.attendance.availableServiceSituations && vm.attendance.availableServiceSituations.length > 0\"><h3 class=\"uk-accordion-title uk-text-small\" style=\"padding:10px; content: none;\"><span><b>Situação:</b> {{vm.attendance.situation.description}} <span ng-if=\"vm.attendance.situation.type==1\">(Aberta)</span> <span ng-if=\"vm.attendance.situation.type==2\">(Encerramento Com Sucesso)</span> <span ng-if=\"vm.attendance.situation.type==3\">(Encerramento Sem Sucesso)</span> <span ng-if=\"vm.attendance.situation.type==4\">(Cancelamento)</span></span> <label type=\"submit\" class=\"md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light\" style=\"float:right; margin-top:-5px; font-size: 11px !important; padding:0px 15px 0px 15px !important;\">ALTERAR</label></h3><div class=\"uk-accordion-content\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label style=\"color:#727272; margin-left:5px; font-size:12px !important\">Situação</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Não alterar situação\" id=\"situation_name_filter\" name=\"situation_name_filter\" config=\"vm.selectize_sources_situations_config\" options=\"vm.selectize_sources_situations\" position=\"bottom\" ng-model=\"vm.filters.situationDescriptionDetail\" ng-change=\"vm.changeReasonNew()\"></selectize></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label style=\"color:#727272; margin-left:5px; font-size:12px !important\">Associar ao usuário</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" id=\"associate_user_select\" name=\"associate_user_select\" config=\"vm.selectize_sources_associate_user_config\" options=\"vm.selectize_sources_associate_user\" position=\"bottom\" ng-model=\"vm.filters.associatedUser.id\"></selectize><div ng-show=\"form.$submitted || form.associate_user_select.$touched\"><span ng-show=\"form.associate_user_select.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-form-row grow-scale\" mtm-show-errors=\"\" ng-show=\"vm.showReasonCombo\"><label style=\"color:#727272; margin-left:5px; font-size:12px !important\">Justificativa</label><div id=\"reason_name_filter\" class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" name=\"reason_name_filter\" config=\"vm.selectize_sources_reason_config\" options=\"vm.selectize_sources_reason\" position=\"bottom\" ng-model=\"vm.filters.reasonDescriptionDetail\"></selectize></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Protocolo Externo</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_name\" name=\"usuario_filter\" value=\"\" ng-model=\"vm.filters.externalProtocol\" tooltips=\"\" tooltip-size=\"medium\" tooltip-side=\"bottom\" tooltip-template=\"Protocolo gerado pelo sistema legado.\" md-input=\"\"></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Comentário Interno</label><div class=\"md-input-wrapper\"><textarea type=\"text\" rows=\"2\" class=\"md-input-2\" id=\"attendance_motivo\" name=\"attendance_motivo\" ng-model=\"vm.filters.internalComments\" md-input=\"\"></textarea></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\" ng-show=\"vm.filters.situationDescriptionDetail\"><label>Comentário para o solicitante</label><div class=\"md-input-wrapper\"><textarea type=\"text\" rows=\"2\" class=\"md-input-2\" id=\"attendance_motivo\" name=\"attendance_motivo\" ng-model=\"vm.filters.externalComments\" md-input=\"\"></textarea></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><button type=\"submit\" class=\"md-btn md-btn-block md-btn-primary md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.changeSituation(vm.filters.situationDescriptionDetail, vm)\">Atualizar solicitação</button></div></div></div></div></div><div class=\"md-card grow3\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-edit fleury-color-default\" style=\"padding-right:5px\"></i> {{vm.attendance.service.description.toUpperCase()}} - FORMULÁRIO</span></h2></div><div data-uk-observe=\"\"><div class=\"md-card-content\"><div ng-if=\"!vm.exibirMensagemFormSemItens\" class=\"md-list-content\" ng-repeat=\"itemResposta in vm.attendance.anwsersForm\"><div><div ng-if=\'itemResposta.fieldType.toUpperCase() !=\"IMAGE\"\'><div ng-if=\'itemResposta.fieldType.toUpperCase() ==\"SUBFORM\"\'><div class=\"md-list-heading md-bg-grey-400 uk-text-bold md-color-grey-900\" style=\"padding:8px 8px;\"><span>{{itemResposta.fieldOrder}}&nbsp - &nbsp{{ itemResposta.fieldLabel.toUpperCase()}}</span></div></div><div ng-if=\'itemResposta.fieldType.toUpperCase() ==\"TITLE\"\'><div class=\"md-list-heading md-bg-grey-300 uk-text-bold md-color-grey-900\" style=\"padding:8px 8px;\"><span>&nbsp&nbsp&nbsp{{itemResposta.fieldLabel}}</span></div></div><div ng-if=\'itemResposta.fieldType.toUpperCase() !=\"TITLE\" && itemResposta.fieldType.toUpperCase() !=\"SUBFORM\"\'><div class=\"md-list-heading\" style=\"margin-top: 10px; margin-bottom: 5px;\"><span style=\"color: #1e88e5;\">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{itemResposta.fieldLabel}}</span></div></div><div class=\"uk-text-muted\" ng-if=\"itemResposta.flagExibirResposta && itemResposta.fieldType.toUpperCase() !=\'TITLE\' && itemResposta.fieldType.toUpperCase() !=\'SUBFORM\'\"><span ng-repeat=\"name in itemResposta.fieldValue track by $index\" ng-if=\"name\">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp<span ng-bind=\"vm.processAttendanceAnswer(name, \'\')\" class=\"uk-text-small uk-text-break uk-text-muted\"></span></span> <span ng-repeat=\"nameLabel in itemResposta.fieldValueLabel\" ng-if=\"nameLabel\">- <span ng-bind=\"vm.processAttendanceAnswer(nameLabel, \'\')\" class=\"uk-text-small uk-text-break uk-text-muted\"></span></span></div><div class=\"uk-text-muted\"><span ng-if=\"(!itemResposta.fieldValue || itemResposta.fieldValue.length == 0) || !itemResposta.fieldValue[0] && itemResposta.fieldType.toUpperCase() !=\'SUBFORM\' && itemResposta.fieldType.toUpperCase() !=\'TITLE\'\">&nbsp&nbsp&nbsp&nbsp&nbsp Não informado.</span></div><div ng-if=\'itemResposta.fieldType.toUpperCase() !=\"TITLE\" && itemResposta.fieldType.toUpperCase() !=\"SUBFORM\"\'><hr></div></div><div ng-if=\'itemResposta.fieldType.toUpperCase() == \"IMAGE\"\'><div class=\"md-list-heading\"><span style=\"color: #1e88e5;\">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{itemResposta.fieldLabel}}</span></div><div id=\"fotosDiv\" class=\"gallery_grid uk-grid-width-medium-1-1\" data-uk-grid=\"{gutter: 16}\"><div><div class=\"md-card md-card-hover\" ng-if=\"itemResposta.fieldValue && itemResposta.fieldValue.length > 0 && itemResposta.fieldValue[0].length > 0\"><div class=\"md-card-content\"><span ng-repeat=\"pic in itemResposta.fieldValue track by $index\"><a href=\"\" ng-click=\"vm.setPic(pic)\" data-uk-modal=\"{target:\'#modal_lightbox\'}\"><img ng-src=\"{{pic}}\" style=\"border-radius: 6px; padding: 3px; max-width: 100px; max-height: 100px; width: auto; height: auto;\" alt=\"\"></a><div class=\"uk-modal\" id=\"modal_lightbox\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox\" style=\"width: {{vm.imgTemp.width}}; min-width: {{vm.imgTemp.width}}; height: {{vm.imgTemp.height}}; min-height: {{vm.imgTemp.height}}; top: 110px !important; max-width: 800px !important; max-height: 800px !important;\"><button type=\"button\" class=\"uk-modal-close uk-close uk-close-alt\"></button> <img ng-src=\"{{vm.imgTemp.link}}\" alt=\"\"></div></div></span></div></div><div class=\"uk-text-muted\" style=\"margin-top:6px; margin-bottom:2px\"><span ng-if=\"!itemResposta.fieldValue || (itemResposta.fieldValue && itemResposta.fieldValue.length > 0 && itemResposta.fieldValue[0].length == 0)\">&nbsp&nbsp&nbsp&nbsp&nbsp Não informado.</span></div></div></div><hr></div></div></div></div></div></div><div class=\"md-card grow4\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-history fleury-color-default\" style=\"padding-right:5px\"></i> HISTÓRICO DE AÇÕES</span></h2></div><div class=\"md-card-content\"><div class=\"uk-overflow-container\"><div class=\"timeline\"><div class=\"timeline_item\" ng-repeat=\"item in vm.attendance.attendanceHistory | orderBy:date\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingDetailIntegration[$index]\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingDetailIntegration[$index]\"><div ng-if=\"item.event === 1\"><div class=\"timeline_icon timeline_icon_default\" ng-if=\"!item.situation.icon\"><i class=\"material-icons\">&#xe876;</i></div><div class=\"timeline_icon timeline_icon_default\" ng-if=\"item.situation.icon\" style=\"background:#{{item.situation.iconColor}} !important\"><i class=\"mobilecare-icons\" style=\"padding-top:9px; color:#fff !important\" ng-bind-html=\"item.situation.icon.replace(\'&#x\', \'\')\"></i></div><div class=\"timeline_date\" style=\"width:80px !important\"><div ng-if=\"item.showDate\">{{item.date.split(\' \')[0]}}</div><span>{{item.date.split(\' \')[1]}}</span></div><div class=\"timeline_content\"><span class=\"uk-text-primary\">Situação iniciada em:&nbsp;</span> <b>{{item.situation.description}}</b> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==1\">(Aberta)</span> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==2\">(Encerramento Com Sucesso)</span> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==3\">(Encerramento Sem Sucesso)</span> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==4\">(Cancelamento)</span> <span><span ng-if=\"item.externalProtocol\"><br><span class=\"uk-text-primary\">Protocolo Externo:</span> <span class=\"uk-text-black uk-text-italic\">{{item.externalProtocol}}</span></span> <span ng-if=\"item.reason\"><br><span class=\"uk-text-primary\">Justificativa:</span> <span class=\"uk-text-black uk-text-italic\">{{item.reason.description}}</span></span> <span ng-if=\"item.internalComments\"><br><span class=\"uk-text-primary\">Comentário Interno:</span> <span class=\"uk-text-black uk-text-italic\">{{item.internalComments}}</span></span> <span ng-if=\"item.externalComments\"><br><span class=\"uk-text-primary\">Comentário solicitante:</span> <span class=\"uk-text-black uk-text-italic\">{{item.externalComments}}</span></span> <span ng-if=\"item.sendInboxStatus == 1 || item.sendInboxStatus == 2\"><br><br><span class=\"uk-text-primary\">Notificações:</span><br><i class=\"uk-text-success\" ng-if=\"item.sendPushStatus == 1\">Push enviado para o solicitante.</i> <i class=\"uk-text-danger\" ng-if=\"item.sendPushStatus == 2\" title=\"Ocorreu um erro de servidor.\">Push não enviado para o solicitante. <i style=\"margin-left:2px;\" class=\"mobilecare-icons uk-text-danger\">&#xe98c;</i></i> <i class=\"uk-text-success\" ng-if=\"item.sendInboxStatus == 1\"><br>Inbox enviado para o solicitante.</i> <i class=\"uk-text-danger\" ng-if=\"item.sendInboxStatus == 2\" title=\"Ocorreu um erro de servidor.\"><br>Inbox não enviado para o solicitante. <i style=\"margin-left:2px;\" class=\"mobilecare-icons uk-text-danger\" title=\"Ocorreu um erro de servidor.\">&#xe98c;</i></i></span><span ng-if=\"item.integrationResponse\"><br><br><span class=\"uk-text-primary\">Integração Externa:</span><br><span ng-if=\"item.integrationResponse.statusCode == 200 || item.integrationResponse.statusCode == \'200\'\"><span class=\"uk-text-success\">Realizada com sucesso.</span></span> <span ng-if=\"item.integrationResponse.statusCode != 200 || item.integrationResponse.statusCode != \'200\'\" title=\"Ocorreu um erro de servidor.\"><span class=\"uk-text-danger\">Erro: {{item.integrationResponse.statusCode}}, {{item.integrationResponse.message}}.</span> <i style=\"margin-left:2px; cursor: pointer;\" class=\"mobilecare-icons uk-text-danger\" title=\"Tentar novamente\" ng-click=\"vm.integrationResponseTryAgain(item.id, $index)\">&#xea00;</i></span></span></span></div></div><div ng-if=\"item.event === 2\"><div class=\"timeline_icon timeline_icon_default\" style=\"background:rgb(244, 164, 96)\"><i class=\"material-icons\">&#xE150;</i></div><div class=\"timeline_date\" style=\"width:80px !important\"><span>{{item.date.split(\' \')[1]}}</span></div><div class=\"timeline_content\"><span class=\"uk-text-primary\">Solicitação alterada</span></div></div><div ng-if=\"item.event === 3\"><div class=\"timeline_icon timeline_icon_default\" ng-if=\"!item.situation.icon\"><i class=\"material-icons\">&#xe876;</i></div><div class=\"timeline_icon timeline_icon_default\" ng-if=\"item.situation.icon\" style=\"background:#{{item.situation.iconColor}} !important\"><i class=\"mobilecare-icons\" style=\"padding-top:9px; color:#fff !important\" ng-bind-html=\"item.situation.icon.replace(\'&#x\', \'\')\"></i></div><div class=\"timeline_date\" style=\"width:80px !important\"><div ng-if=\"item.showDate\">{{item.date.split(\' \')[0]}}</div><span>{{item.date.split(\' \')[1]}}</span></div><div class=\"timeline_content\"><span class=\"uk-text-primary\">Situação alterada para:&nbsp;</span> <b>{{item.situation.description}}</b> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==1\">(Aberta)</span> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==2\">(Encerramento Com Sucesso)</span> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==3\">(Encerramento Sem Sucesso)</span> <span class=\"uk-text-italic\" ng-if=\"vm.attendance.situation.type==4\">(Cancelamento)</span><span ng-if=\"item.associatedUserId\"><br><span class=\"uk-text-primary\">Atribuído para:</span> <span class=\"uk-text-black\"><b>{{item.associatedUserName}}</b> <span class=\"uk-text-italic\">({{item.associatedUserEmail}})</span></span></span> <span ng-if=\"item.externalProtocol\"><br><span class=\"uk-text-primary\">Protocolo Externo:</span> <span class=\"uk-text-black uk-text-italic\">{{item.externalProtocol}}</span></span> <span ng-if=\"item.reason\"><br><span class=\"uk-text-primary\">Justificativa:</span> <span class=\"uk-text-black uk-text-italic\">{{item.reason.description}}</span></span> <span ng-if=\"item.internalComments\"><br><span class=\"uk-text-primary\">Comentário Interno:</span> <span class=\"uk-text-black uk-text-italic\">{{item.internalComments}}</span></span> <span ng-if=\"item.externalComments\"><br><span class=\"uk-text-primary\">Comentário solicitante:</span> <span class=\"uk-text-black uk-text-italic\">{{item.externalComments}}</span></span> <span ng-if=\"item.sendInboxStatus == 1 || item.sendInboxStatus == 2\"><br><br><span class=\"uk-text-primary\">Notificações:</span><br><i class=\"uk-text-success\" ng-if=\"item.sendPushStatus == 1\">Push enviado para o solicitante.</i> <i class=\"uk-text-danger\" ng-if=\"item.sendPushStatus == 2\" title=\"Ocorreu um erro de servidor.\">Push não enviado para o solicitante. <i style=\"margin-left:2px;\" class=\"mobilecare-icons uk-text-danger\">&#xe98c;</i></i> <i class=\"uk-text-success\" ng-if=\"item.sendInboxStatus == 1\"><br>Inbox enviado para o solicitante.</i> <i class=\"uk-text-danger\" ng-if=\"item.sendInboxStatus == 2\" title=\"Ocorreu um erro de servidor.\"><br>Inbox não enviado para o solicitante. <i style=\"margin-left:2px;\" class=\"mobilecare-icons uk-text-danger\" title=\"Ocorreu um erro de servidor.\">&#xe98c;</i></i></span><span ng-if=\"item.integrationResponse\"><br><br><span class=\"uk-text-primary\">Integração Externa:</span><br><span ng-if=\"item.integrationResponse.statusCode == 200 || item.integrationResponse.statusCode == \'200\'\"><span class=\"uk-text-success\">Realizada com sucesso.</span></span> <span ng-if=\"item.integrationResponse.statusCode != 200 || item.integrationResponse.statusCode != \'200\'\" title=\"Ocorreu um erro de servidor.\"><span class=\"uk-text-danger\">Erro: {{item.integrationResponse.statusCode}}, {{item.integrationResponse.message}}.</span> <i style=\"margin-left:2px; cursor: pointer;\" class=\"mobilecare-icons uk-text-danger\" title=\"Tentar novamente\" ng-click=\"vm.integrationResponseTryAgain(item.id, $index)\">&#xea00;</i></span></span></div></div><div ng-if=\"item.event === 4\"><div class=\"timeline_icon timeline_icon_default\" style=\"background:#50a0e6;\"><i class=\"material-icons\">&#xE8D4;</i></div><div class=\"timeline_date\" style=\"width:80px !important\"><span>{{item.date.split(\' \')[1]}}</span></div><div class=\"timeline_content\"><span ng-if=\"item.associatedUserId\"><span class=\"uk-text-primary\">Atribuído para:</span> <span class=\"uk-text-black\"><b>{{item.associatedUserName}}</b> <span class=\"uk-text-italic\">({{item.associatedUserEmail}})</span></span></span><span ng-if=\"item.externalProtocol\"><br><span class=\"uk-text-primary\">Protocolo Externo:</span> <span class=\"uk-text-black uk-text-italic\">{{item.externalProtocol}}</span></span> <span ng-if=\"item.internalComments\"><br><span class=\"uk-text-primary\">Comentário Interno:</span> <span class=\"uk-text-black uk-text-italic\">{{item.internalComments}}</span></span></div></div></div></div></div></div></div></div><br></div></div></div><div class=\"uk-modal custom modalAddApp\" id=\"modalInfoUser\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\" style=\"margin-top: 5%;\"><button type=\"button\" id=\"btnCloseModalInfoUser\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Informações do Solicitante</h3></div><div style=\"padding: 0 30px 5px 30px;\"><br><span class=\"uk-text\" ng-if=\"vm.attendance.userName\"><b>Solicitante:</b> {{vm.attendance.userName}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userName\"><b>Solicitante:</b> Não existem informações de <b>nome</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.userLogin\"><b>Login:</b> {{vm.attendance.userLogin}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userLogin\"><b>Login:</b> Não existem informações de <b>login</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.userEmail\"><b>E-mail:</b> {{vm.attendance.userEmail}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userEmail\"><b>E-mail:</b> Não existem informações de <b>e-mail</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.userTelephone\"><b>Telefone:</b> {{vm.attendance.userTelephone.text.replace(\"|\",\" \").replace(\"|\",\" \")}}</span> <span class=\"uk-text\" ng-if=\"!vm.attendance.userTelephone\"><b>Telefone:</b> Não existem informações de <b>telefone</b>.</span><br><span class=\"uk-text\" ng-if=\"vm.attendance.documentType\"><b>Documento:</b>{{vm.attendance.documentType}} - {{vm.attendance.documentNumber}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.sex\"><b>Documento:</b> Não existem informações de <b>documento</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.sex\"><b>Sexo:</b> {{vm.attendance.sex}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.sex\"><b>Sexo:</b> Não existem informações de <b>sexo</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.birthDate\"><b>Data de Nascimento:</b> {{vm.attendance.birthDate.split(\' \')[0]}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.birthDate\"><b>Data de Nascimento:</b> Não existem informações de <b>data de nascimento</b>.<br></span> <span class=\"uk-text\" ng-if=\"vm.attendance.address && vm.attendance.address.addressLine1\"><b>Endereço:</b> {{vm.attendance.address.formatedText}}.<br></span> <span class=\"uk-text\" ng-if=\"!vm.attendance.address || !vm.attendance.address.addressLine1\"><b>Endereço:</b> Não existem informações de <b>endereço</b>.<br></span><br></div></div></div></div><style type=\"text/css\">\r\n@keyframes anim-ltr {0% {left: 10000px;}100% {left: 0;}}\r\n.grow1 {animation: anim-ltr 600ms;} \r\n.grow2 {animation: anim-ltr 800ms;} \r\n.grow3 {animation: anim-ltr 1100ms;} \r\n.grow4 {animation: anim-ltr 1500ms;} \r\n.uk-text-black {color:#333 !important;}\r\n.uk-text-italic {font-style: italic !important;}\r\n.uk-accordion-title:after {content: \'\';} \r\n.fleury-color-default{color: #666 !important;} \r\n.md-card .md-card-toolbar {\r\n  border-bottom:1px solid rgba(0, 0, 0, 0.12) !important; \r\n  border-top:1px solid rgba(0, 0, 0, 0.12) !important;\r\n}\r\n.grow-scale {animation: anim-sc 400ms;}\r\n.grow-scale2 {animation: anim-sc 500ms;}\r\n@keyframes anim-sc {0% {transform: scale(0);}100% {transform: scale(1);}}\r\n</style>");
$templateCache.put("app/attendance/attendance.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\"><a ng-click=\"vm.printDetails()\" tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"Imprimir detalhes.\" class=\"md-fab md-fab-small md-fab-primary\"><i class=\"mobilecare-icons\">&#xe9fd;</i></a></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Solicitações</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><div class=\"md-card-dropdown\" data-uk-dropdown=\"{pos:\'bottom-right\'}\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D4;</i><div class=\"uk-dropdown uk-dropdown-top\" style=\"margin-top: 8px !important;\"><ul class=\"uk-nav\"><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isOrderFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"orderCheck\" id=\"orderCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isOrderFilterChecked\" icheck=\"\"></span> <label for=\"orderCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Ordenação</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isPeriodFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"periodCheck\" id=\"periodCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isPeriodFilterChecked\" icheck=\"\"></span> <label for=\"periodCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Período</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isServiceDescriptionFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"serviceCheck\" id=\"serviceCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isServiceDescriptionFilterChecked\" icheck=\"\"></span> <label for=\"serviceCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Serviço</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isOcurrenceSituationFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"situationCheck\" id=\"situationCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isOcurrenceSituationFilterChecked\" icheck=\"\"></span> <label for=\"situationCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Situação</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isTypeSituationFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"typeSituationCheck\" id=\"typeSituationCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isTypeSituationFilterChecked\" icheck=\"\"></span> <label for=\"typeSituationCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Tipo da Situação</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isSlaFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"isSlaFilterChecked\" id=\"isSlaFilterChecked\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isSlaFilterChecked\" icheck=\"\"></span> <label for=\"isSlaFilterChecked\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">SLA</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserNameFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"userNameCheck\" id=\"userNameCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserNameFilterChecked\" icheck=\"\"></span> <label for=\"userNameCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Nome do Solicitante</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isEmailFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"emailCheck\" id=\"emailCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isEmailFilterChecked\" icheck=\"\"></span> <label for=\"emailCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">E-mail</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isDocumentNumberFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"documentNumberCheck\" id=\"documentNumberCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isDocumentNumberFilterChecked\" icheck=\"\"></span> <label for=\"documentNumberCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Número do documento</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isAssociatedUserNameFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"associatedUserNameCheck\" id=\"associatedUserNameCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isAssociatedUserNameFilterChecked\" icheck=\"\"></span> <label for=\"associatedUserNameCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Nome do usuário associado</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isAssociatedEmailFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"associatedEmailCheck\" id=\"associatedEmailCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isAssociatedEmailFilterChecked\" icheck=\"\"></span> <label for=\"associatedEmailCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">E-mail do usuário associado</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isProtocolFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"protocolCheck\" id=\"protocolCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isProtocolFilterChecked\" icheck=\"\"></span> <label for=\"protocolCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Protocolo Interno</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isExternalProtocolFilterChecked\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"externalProtocolCheck\" id=\"externalProtocolCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isExternalProtocolFilterChecked\" icheck=\"\"></span> <label for=\"externalProtocolCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Protocolo Externo</label></div></li></ul></div></div></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">PESQUISA</h3></div></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><span ng-show=\"vm.tuple\"><div class=\"uk-badge\" style=\"margin-top:-8px\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Número de registros da listagem.\">({{vm.totalItens}}) Registro<span ng-show=\"(vm.attendances.length && vm.attendances.length > 1) || vm.attendances.length == 0\">s</span></div></span><span ng-if=\"vm.isLoadingReport\" class=\"loading-spinner\"><svg class=\"spinner\" width=\"20px\" height=\"20px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></span><a ng-if=\"!vm.isLoadingReport\" tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"Exportar lista como excel.\" ng-click=\"vm.exportData()\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE8E5;</i></a> <a tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"Atualizar lista de atendimentos.\" ng-click=\"vm.search(vm.FILTERS_REFRESH, vm.FILTERS_REFRESH.sort)\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D5;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">SOLICITAÇÕES</h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">DETALHES</h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoadingFiltros\" name=\"formSearch\" id=\"formSearch\" mt-validate-submit=\"vm.search(vm.filters, \'attendanceDate\')\" novalidate=\"\"><div ng-if=\"vm.isOrderFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Ordenar por</label><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><selectize style=\"display: inline !important;\" class=\"custom_selectize\" placeholder=\"Selecione\" id=\"sla_name_order_by\" name=\"sla_name_order_by\" config=\"vm.selectize_generic_config\" ng-change=\"vm.selectOrderFieldByChange()\" options=\"vm.listOrderBy\" position=\"bottom\" ng-model=\"vm.filters.orderField\"></selectize></div><div class=\"uk-width-1-2\"><selectize style=\"display: inline !important;\" class=\"custom_selectize\" placeholder=\"Selecione\" id=\"sla_name_order_asc\" name=\"sla_name_order_asc\" config=\"vm.selectize_generic_config\" ng-change=\"vm.selectOrderFieldByChange()\" options=\"vm.listAscending\" position=\"bottom\" ng-model=\"vm.filters.pagIsAscending\"></selectize></div></div></div></div><div ng-if=\"vm.isPeriodFilterChecked\" class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período</label><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dateIni\" ng-required=\"vm.filters.dateIni\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"formSearch.$submitted || formSearch.uk_dp_start.$touched\"><span ng-show=\"formSearch.uk_dp_start.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dateEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"formSearch.$submitted || formSearch.uk_dp_end.$touched\"><span ng-show=\"formSearch.uk_dp_end.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div ng-if=\"vm.isServiceDescriptionFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Serviço</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"services_name_filter\" name=\"services_name_filter\" config=\"vm.selectize_sources_services_config\" options=\"vm.selectize_sources_services\" position=\"bottom\" ng-model=\"vm.filters.serviceIds\"></selectize></div></div></div><div ng-if=\"vm.isOcurrenceSituationFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Situação</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"situation_name_filter\" name=\"situation_name_filter\" config=\"vm.selectize_sources_situations_config\" options=\"vm.selectize_sources_situations\" position=\"bottom\" ng-model=\"vm.filters.situationsIds\"></selectize></div></div></div><div ng-if=\"vm.isTypeSituationFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Tipo da Situação</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"situation_type_filter\" name=\"situation_type_filter\" config=\"vm.selectize_sources_types_config\" options=\"vm.selectize_sources_types\" position=\"bottom\" ng-model=\"vm.filters.situationTypes\"></selectize></div></div></div><div ng-if=\"vm.isSlaFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>SLA</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Ambas\" id=\"sla_name_filter\" name=\"sla_name_filter\" config=\"vm.selectize_generic_config\" options=\"vm.selectize_sla_options\" position=\"bottom\" ng-model=\"vm.filters.slaSelected\"></selectize></div></div></div><div ng-if=\"vm.isUserNameFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome do Solicitante</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_name\" name=\"usuario_filter\" value=\"\" ng-model=\"vm.filters.userName\" md-input=\"\"></div></div></div><div ng-if=\"vm.isEmailFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>E-mail</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_email\" name=\"usuario_filter_email\" value=\"\" ng-model=\"vm.filters.userEmail\" md-input=\"\"></div></div></div><div ng-if=\"vm.isDocumentNumberFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Número do Documento</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_document\" name=\"usuario_filter_document\" value=\"\" ng-model=\"vm.filters.documentNumber\" md-input=\"\"></div></div></div><div ng-if=\"vm.isAssociatedUserNameFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome do usuário associado</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"associated_usuario_filter_name\" name=\"associated_usuario_filter_name\" value=\"\" ng-model=\"vm.filters.associatedUserName\" md-input=\"\"></div></div></div><div ng-if=\"vm.isAssociatedEmailFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>E-mail do usuário associado</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"associated_usuario_filter_email\" name=\"associated_usuario_filter_email\" value=\"\" ng-model=\"vm.filters.associatedUserEmail\" md-input=\"\"></div></div></div><div ng-if=\"vm.isProtocolFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Protocolo Interno</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_protocolo\" name=\"usuario_filter_protocolo\" value=\"\" ng-model=\"vm.filters.protocol\" md-input=\"\"></div></div></div><div ng-if=\"vm.isExternalProtocolFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Protocolo Externo</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_external_protocol\" name=\"usuario_filter_external_protocol\" value=\"\" ng-model=\"vm.filters.externalProtocol\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div><div id=\"colunaAttendances\" class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingAttendances\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingAttendances && vm.attendances.length === 0 && vm.isAttendanceVisualizarPermitido\" class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum registro encontrado.</span></h3></div></div><div ng-if=\"!vm.isLoadingAttendances && !vm.isAttendanceVisualizarPermitido\" class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Você não possui permissão de visualização.</span></h3></div></div><div ng-if=\"!vm.isLoadingAttendances && vm.attendances.length > 0 && vm.isAttendanceVisualizarPermitido\"><div><div infinite-scroll-disabled=\"vm.busy || vm.isLastPage\" infinite-scroll=\"vm.getNextPageAttendances()\" infinite-scroll-immediate-check=\"true\" infinite-scroll-distance=\"0\" infinite-scroll-container=\"\'#colunaAttendances\'\" infinite-scroll-parent=\"true\"><div class=\"scrum_task\" ng-repeat=\"item in vm.attendances track by $index\" ng-class=\"{ \'chamado-active\': $index == vm.selectedIndex}\" ng-click=\"vm.detailAttendance(item.id, $index)\" style=\"z-index:0;margin-bottom:5px;cursor:pointer\"><div class=\"critical\"><p class=\"scrum_task_title\">&raquo; <span style=\"text-transform: none !important;margin-right:15px;color: #07d;\"><span class=\"uk-text-bold uk-text-primary\">{{item.protocol}}</span> <span class=\"uk-text-bold\" style=\"color:#000;margin-left:30px;\">{{item.attendanceDate}}</span></span></p><p class=\"scrum_task_description\" ng-show=\"item.externalProtocol\"><b>Protocolo Externo</b> &raquo; <b ng-show=\"item.externalProtocol\">{{item.externalProtocol}}</b> <b ng-show=\"!item.externalProtocol\">Nenhum</b></p><p class=\"scrum_task_description\"><b>{{item.service.category.description}}</b> &raquo; <b>{{item.service.description}}</b></p><p ng-if=\"item.userEmail\" class=\"scrum_task_description\">{{item.userName}} ({{item.userEmail}})</p><p ng-if=\"!item.userEmail\" class=\"scrum_task_description\"><b>Sem usuário</b> <b>(Sem email)</b></p><p ng-if=\"item.associatedUserId\" class=\"scrum_task_description\"><span class=\"uk-text-primary\">Atribuído para: <span class=\"uk-text-black\"><b>{{item.associatedUserName}}</b> (<i>{{item.associatedUserEmail}})</i></span></span></p><span class=\"uk-badge\" style=\"background-color: #{{item.situation.iconColor}} !important\">{{item.situation.description}}</span> <span ng-if=\"item.service.slaTimeSeconds > 0 && item.showSlaOfTypeSituation\" style=\"margin-left:5px\"><span ng-if=\"!item.slaExcedido && item.segundos > 0\" class=\"uk-badge uk-badge-success\">Restam: <span ng-if=\"item.dias > 0\">{{item.dias}}d</span> <span ng-if=\"item.horas > 0\">{{item.horas}}h</span> <span ng-if=\"item.minutos > 0\">{{item.minutos}}m</span> <span ng-if=\"item.segundos > 0\">{{item.segundos}}s</span></span> <span ng-if=\"item.service.slaTimeSeconds > 0 && item.slaExcedido && item.showSlaOfTypeSituation\" class=\"uk-badge uk-badge-danger\" data-uk-alert=\"\">Expirada há: <span ng-if=\"item.dias > 0\">{{item.dias}}d</span> <span ng-if=\"item.horas > 0\">{{item.horas}}h</span> <span ng-if=\"item.minutos > 0\">{{item.minutos}}m</span> <span ng-if=\"item.segundos > 0\">{{item.segundos}}s.</span></span></span></div></div><div class=\"loading-spinner\" ng-if=\"vm.busy\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></div></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div ng-if=\"!vm.isLoadingAttendances && vm.attendances.length === 0 && vm.isAttendanceVisualizarPermitido\" class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Detalhe não disponível.</span></h3></div></div><div ng-if=\"!vm.isLoadingAttendances && !vm.isAttendanceVisualizarPermitido\" class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Você não possui permissão de visualização.</span></h3></div></div><div ng-if=\"vm.attendances.length > 0 && vm.isAttendanceVisualizarPermitido\" ui-view=\"\" auto-height=\"\"></div></div></div></div></div><style type=\"text/css\">\r\n    .grow-scale {\r\n        animation: anim-sc 400ms;\r\n    }\r\n\r\n    @keyframes anim-sc {\r\n        0% {\r\n            transform: scale(0);\r\n        }\r\n        100% {\r\n            transform: scale(1);\r\n        }\r\n    }\r\n</style>");
$templateCache.put("app/category/category.detail.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE8D2;</i>Cadastros</span></li><li><a ui-sref=\"private.painel.category.list\">Categorias</a></li><li><span>{{vm.category.description | limitTo:50 }}</span></li><li><span>Detalhar</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"md-card\"><div class=\"md-card-content\"><a class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.category.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a></div></div><div class=\"md-card\"><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Descrição</span> <span class=\"\">{{vm.category.description}}</span></div></li></ul></div></div></div></div></div>");
$templateCache.put("app/category/category.list.create.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar\" ng-click=\"vm.openModalConfirmacaoDeCancelamento()\"><i class=\"material-icons md-color-white\"></i></a> <label for=\"submitForm\" ng-if=\"!vm.isEdit\" class=\"labelAsButton\" title=\"Salvar\"><i class=\"material-icons md-color-white\"></i></label> <label for=\"submitForm\" ng-if=\"vm.isEdit\" class=\"labelAsButton\" title=\"Salvar\"><i class=\"material-icons md-color-white\"></i></label></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;{{vm.operacao}}</a><span ng-if=\"vm.service.description\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.service.description}}</span></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Configurações &raquo; Serviços</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove uk-overflow-container uk-height-1-1\"><div class=\"uk-width-medium-1-1 uk-width-large-8-10 uk-width-xlarge-7-10 uk-container-center reset-print\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"vm.isComponentLoading\" class=\"md-content uk-width-1-1 uk-text-center\">Aguarde! carregando componentes da tela...</div><div class=\"md-card\" ng-if=\"!vm.isLoading\"><form name=\"formService\" id=\"formService\" mt-validate-submit=\"vm.submit(vm.service)\" novalidate=\"\"><div id=\"wizard_advanced\" role=\"application\" class=\"wizard clearfix\"><div class=\"steps clearfix\"><ul role=\"tablist\"><li role=\"tab\" class=\"first selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard1}\" ng-click=\"vm.selectTabWizard(1, formService)\" aria-disabled=\"false\" aria-selected=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important; border-right: 1px solid #eee !important;\"><a id=\"btn-descricao\"><span class=\"number\">1</span> <span class=\"title\">Descrição</span></a></li><li role=\"tab\" class=\"disabled selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard2}\" ng-click=\"vm.selectTabWizard(2, formService)\" aria-disabled=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important; border-right: 1px solid #eee !important;\"><a id=\"btn-fluxo\"><span class=\"number\">2</span> <span class=\"title\">Situações Permitidas</span></a></li><li role=\"tab\" class=\"disabled selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard3}\" ng-click=\"vm.selectTabWizard(3, formService)\" aria-disabled=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important; border-right: 1px solid #eee !important;\"><a id=\"btn-fluxo\"><span class=\"number\">3</span> <span class=\"title\">Fluxo de Atendimento</span></a></li><li role=\"tab\" class=\"disabled last selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard4}\" ng-click=\"vm.selectTabWizard(4, formService)\" aria-disabled=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important;\"><a id=\"btn-permissoes\"><span class=\"number\">4</span> <span class=\"title\">Permissões</span></a></li></ul></div><div class=\"md-card-content\"><section id=\"div-aba1\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-0\" class=\"body step-0 current fade-in-mobilecare\" data-step=\"0\" aria-hidden=\"false\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Informações básicas do serviço.</h2><hr><div class=\"uk-grid\"><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Categoria *</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" id=\"form_categoria\" name=\"form_categoria\" config=\"vm.selectize_config\" required=\"\" options=\"vm.listLeafsCategories\" position=\"bottom\" ng-model=\"vm.service.categoryId\" ng-change=\"vm.isUpdatedFormService()\"></selectize></div><div ng-show=\"formService.$submitted || formService.form_categoria.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formService.form_categoria.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Classificação *</label><div class=\"md-input-wrapper2\"><selectize placeholder=\"Selecione\" class=\"custom_selectize\" required=\"\" id=\"publish_levels_service_filter\" name=\"publish_levels_service_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.service.publishLevelId\" ng-change=\"vm.isUpdatedFormService()\"></selectize></div><div ng-show=\"formService.$submitted || formService.publish_levels_service_filter.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formService.publish_levels_service_filter.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Nome do Serviço *</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"vm.category.detail\" class=\"md-input-2\" id=\"descricao\" name=\"descricao\" ng-model=\"vm.service.description\" required=\"\" style=\"padding-top:17px;\" ng-keypress=\"vm.isUpdatedFormService()\" ng-keyup=\"vm.isUpdatedFormService()\" ng-keydown=\"vm.isUpdatedFormService()\"></div><div ng-show=\"formService.$submitted || formService.descricao.$touched\"><span ng-show=\"formService.descricao.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Formulário de Perguntas *</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" id=\"form_filter\" name=\"form_filter\" config=\"vm.selectize_forms_config\" required=\"\" options=\"vm.selectize_forms\" position=\"bottom\" ng-model=\"vm.service.formId\" ng-change=\"vm.isUpdatedFormService()\"></selectize></div><div ng-show=\"formService.$submitted || formService.form_filter.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formService.form_filter.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Tempo de SLA (h)</label><div class=\"md-input-wrapper2\"><input type=\"text\" maxlength=\"3\" ng-minlength=\"0\" class=\"md-input-2\" id=\"sla\" name=\"sla\" ng-model=\"vm.service.sla\" ng-keypress=\"vm.validateSLA($event)\" onkeypress=\"return (event.charCode == 8 | (event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\" ng-keyup=\"vm.isUpdatedFormService()\" ng-keydown=\"vm.isUpdatedFormService()\"></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Ícone</label><div class=\"md-input-wrapper2\" ng-if=\"vm.service.icon\"><i class=\"mobilecare-icons md-user-image\" ng-show=\"vm.service.icon\" ng-bind-html=\"vm.service.icon\" style=\"font-size:30px; padding:5px 0 0 0;\"></i> <a class=\"md-btn md-btn-small md-btn-primary\" style=\"margin:-15px 0 0 30px\" ng-click=\"vm.openModalServiceIcons()\">Selecionar</a> <a class=\"md-btn md-btn-small md-btn-danger\" style=\"margin:-15px 0 0 10px\" ng-click=\"vm.removeIcon()\" ng-show=\"vm.service.icon\">Remover</a> <span class=\"md-input-bar\"></span></div><div class=\"md-input-wrapper2\" ng-if=\"!vm.service.icon\" style=\"padding:12px 0 0 0\"><span><i style=\"color:red;\">Nenhum</i></span> <a class=\"md-btn md-btn-small md-btn-primary\" style=\"margin:-15px 0 0 30px\" ng-click=\"vm.openModalServiceIcons()\">Selecionar</a></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label>Protocolo Customizado</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"vm.category.detail\" class=\"md-input-2\" placeholder=\"{dd}{MM}{yyyy}.{HH}{mm}{ss}/{inc:5}\" id=\"customProtocol\" name=\"customProtocol\" ng-model=\"vm.service.customProtocol\" style=\"padding-top:17px;\"> <a ng-click=\"vm.AddKeyWordToProtocol(\'{dd}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Será trocado pelo dia da solicitação.\">{dd}</a> <a ng-click=\"vm.AddKeyWordToProtocol(\'{MM}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Será trocado pelo mês da solicitação.\">{MM}</a> <a ng-click=\"vm.AddKeyWordToProtocol(\'{yyyy}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Será trocado pelo ano da solicitação.\">{yyyy}</a> <a ng-click=\"vm.AddKeyWordToProtocol(\'{HH}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Será trocado pela hora da solicitação.\">{HH}</a> <a ng-click=\"vm.AddKeyWordToProtocol(\'{mm}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Será trocado pelos minutos da solicitação.\">{mm}</a> <a ng-click=\"vm.AddKeyWordToProtocol(\'{ss}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Será trocado pelos segundos da solicitação.\">{ss}</a> <a ng-click=\"vm.AddKeyWordToProtocol(\'{inc:5}\')\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Informa que existe um incrementador de 5 casa numéricas. O valor pode ser informado.\">{inc:5}</a><br></div><span style=\"font-size: 12px; font-style:italic; margin-left:20px !important;\" ng-show=\"!vm.service.customProtocol\">* Obs.: A não customização desse campo implica na geração automática do protocolo pelo sistema adotando a mascára acima destacada.</span></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-form-row\"><label style=\"display: block !important;\">Status</label> <input type=\"checkbox\" ng-model=\"vm.service.isActive\" id=\"archiveService\" name=\"archiveService\" class=\"switch-input\" ng-click=\"vm.isUpdatedFormService()\"> <label for=\"archiveService\" class=\"switch-label\"><span class=\"toggle--on\">Ativo</span> <span class=\"toggle--off\">Arquivado</span></label></div></div></div></div></section><section id=\"div-aba2\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-1\" class=\"body step-1 fade-in-mobilecare\" data-step=\"1\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Defina abaixo as situações que as solicitações deste serviço devem percorrer desde a sua abertura até encerramento.</h2><hr><div class=\"uk-grid\"><div class=\"uk-width-small-2-3\"><label for=\"wizard_birth_place-selectized\"><b>Selecione a situação para adicioná-la a este serviço:</b></label><selectize placeholder=\"Selecione\" class=\"custom_selectize\" id=\"situation_name_filter\" name=\"situation_name_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_sources_situations\" position=\"bottom\" ng-model=\"vm.filters.situationId\" ng-change=\"vm.openModalServiceSituation(null, true, false)\"></selectize></div></div><hr class=\"md-hr\"><div class=\"uk-width-1-1 uk-container-center\"><ul class=\"uk-nestable md-card-list-wrapper\" data-uk-nestable=\"{handleClass:\'uk-nestable-handle\'}\"><li class=\"no-bg\" ng-repeat=\"item in vm.service.serviceSituations | orderBy: \'order\'\" style=\"margin-top:5px; outline:0;cursor:pointer;\"><div class=\"md-card-list\" style=\"margin-top:0;padding:2px;outline:0;cursor:pointer;\"><div id=\"divClickServiceSituation\" class=\"exact-padding uk-nestable-panel md-bg-grey-50\" ng-click=\"vm.gatewaySituationsService(1, item, false, true)\" style=\"outline:0;cursor:pointer;\"><a href=\"\" class=\"md-icon material-icons\" style=\"float:right; margin-top:30px; margin-right:20px\" ng-mouseleave=\"vm.freeSituationModal()\" ng-mouseover=\"vm.holdSituationModal()\" ng-click=\"vm.gatewaySituationsService(2, item, null, null)\"></a> <a href=\"\" class=\"md-icon material-icons\" style=\"float:right; margin-top:30px;\" ng-click=\"vm.gatewaySituationsService(1, item, false, true)\"></a> <a href=\"\" class=\"md-icon mobilecare-icons\" style=\"float:right; margin-top:30px; font-weight:bold\" ng-mouseleave=\"vm.freeSituationModal()\" ng-mouseover=\"vm.holdSituationModal()\" ng-click=\"vm.listItemUp($index)\" ng-class=\"{\'color-disabled-situation\': $first}\">&#xe096;</a> <a href=\"\" class=\"md-icon mobilecare-icons\" style=\"float:right; margin-top:30px; font-weight:bold\" ng-mouseleave=\"vm.freeSituationModal()\" ng-mouseover=\"vm.holdSituationModal()\" ng-click=\"vm.listItemDown($index)\" ng-class=\"{\'color-disabled-situation\': $last}\">&#xe097;</a><div class=\"md-card-list-item-select\" style=\"cursor:default\"><span class=\"uk-badge uk-badge-outline\" data-uk-tooltip=\"{pos:\'right\'}\">{{item.order}}</span></div><div class=\"md-card-list-item-subject\"><span style=\"padding:10px 0 5px 0\"><span ng-show=\"item.description\" class=\"uk-text-primary\">{{item.description}}</span> <span ng-show=\"!item.description\" class=\"uk-text-primary\">{{item.situation.description}}</span></span> <span><span class=\"uk-badge\" ng-if=\"item.isInitial\" ng-class=\"{ \'uk-badge-outline\' : !item.isInitial, \'uk-badge-warning\' : item.isInitial }\">Padrão</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.situationChangeOnMobile, \'uk-badge-primary\' : item.situationChangeOnMobile }\">Disponível no App</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.editEnableOnMobile, \'uk-badge-primary\' : item.editEnableOnMobile }\">Editar via App</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.deleteEnableOnMobile, \'uk-badge-primary\' : item.deleteEnableOnMobile }\">Excluir via App</span> <span class=\"uk-badge\" ng-if=\"!vm.service.create\" ng-class=\"{ \'uk-badge-outline\' : !item.statusEnableOnMobile, \'uk-badge-primary\' : item.statusEnableOnMobile }\">Arquivar via app</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.qrCodeEnableOnMobile, \'uk-badge-primary\' : item.qrCodeEnableOnMobile }\">Habilitar QRCode</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.sendPush, \'uk-badge-primary\' : item.sendPush }\">Notificação Push</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.sendEmail, \'uk-badge-primary\' : item.sendEmail }\">Notificação Inbox</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !(item.reasons.length > 0), \'uk-badge-primary\' : (item.reasons.length > 0) }\">Possui Justificativas</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !(item.emailIntegrationConfig || item.mappingIntegrationConfig), \'uk-badge-primary\': (item.emailIntegrationConfig || item.mappingIntegrationConfig)}\">Possui Integração</span></span> <span class=\"uk-text-small\"></span></div></div></div></li><li id=\"liSemSituacao\" class=\"uk-nestable-item no-bg grow-scale2\" ng-if=\"!vm.service.serviceSituations || vm.service.serviceSituations.length == 0\"><div class=\"md-card-list\" style=\"margin-top:0;padding:2px;\"><div class=\"exact-padding uk-nestable-panel md-bg-grey-50\"><div class=\"md-card-list-item-subject\" style=\"padding: 20px 0 20px 0;\"><span><span><i class=\"material-icons\" style=\"margin: 0 5px 0 20px; font-size:20px\">&#xe000;</i> Nenhuma situação.</span></span></div></div></div></li></ul></div></div></section><section id=\"div-aba3\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-2\" class=\"body step-2 fade-in-mobilecare\" data-step=\"2\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Defina abaixo o fluxo de atendimento especifico para cada situação.</h2><hr><div class=\"uk-width-1-1 uk-container-center\"><div class=\"uk-grid\" ng-repeat=\"item in vm.service.serviceSituations | orderBy: \'order\'\" style=\"margin-top:0;\">{{item.description}}<div class=\"uk-width-1-1\" style=\"padding-top: 15px\"><div class=\"uk-row-first\" style=\"margin:2px\"><div class=\"md-card\" ng-class=\"{\'rascunho\': !item.isInitial, \'beta\': item.isInitial}\"><div class=\"md-card-toolbar\" style=\"padding: 8px 0 8px 17px; height: 35px\"><h5><label>De</label> <label class=\"uk-text-bold\">{{item.situation.description}}</label> <label>pode ir para:</label></h5></div><div class=\"md-card-content\" style=\"padding: 5px 10px 0px 10px; border:none !important\"><selectize class=\"md-input uk-width-1-1\" placeholder=\"Selecione\" config=\"vm.selectize_workflow_config\" options=\"vm.workflowOptions[item.situation.id].itens\" position=\"bottom\" ng-model=\"vm.workflowList[item.situation.id].itens\" ng-change=\"vm.isUpdatedFormService()\"></selectize></div></div></div></div></div><div class=\"uk-nestable md-card-list-wrapper\" ng-if=\"!vm.service.serviceSituations || vm.service.serviceSituations.length == 0\"><div class=\"uk-nestable-item no-bg grow-scale2 ng-scope\"><div class=\"md-card-list\" style=\"margin-top:0;padding:2px;\"><div class=\"exact-padding uk-nestable-panel md-bg-grey-50\"><div class=\"md-card-list-item-subject\" style=\"padding: 20px 0 20px 0;\"><span><span><i class=\"material-icons\" style=\"margin: 0 5px 0 20px; font-size:20px\"></i> Nenhum fluxo de atendimento.</span></span></div></div></div></div></div></div></div></section><section id=\"div-aba4\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-2\" class=\"body step-2 fade-in-mobilecare\" data-step=\"2\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Defina abaixo quais Papéis e/ou Pessoas podem acessar as solicitações deste serviço na área de atendimento.</h2><hr><div class=\"uk-width-1-1 uk-container-center\"><div class=\"uk-grid\"><div class=\"uk-width-1-1\"><div class=\"uk-overflow-container\" style=\"margin:20px;\"><table class=\"uk-table uk-table-nowrap table_check uk-text-small\"><thead><tr><th class=\"uk-width-5-10\">Papéis</th><th class=\"uk-width-5-10\">Usuários</th></tr></thead><tbody><tr ng-repeat=\"item in vm.papeis\"><td><input type=\"checkbox\" ng-model=\"item.checked\" id=\"papel{{$index}}\" name=\"serviceIsInitial\" class=\"switch-input uk-width-1-1\" ng-click=\"vm.isUpdatedFormService()\"> <label for=\"papel{{$index}}\" class=\"switch-label uk-width-1-1\"><b>{{item.name}}:</b> <span class=\"toggle--on\">permitido.</span> <span class=\"toggle--off\">não permitido.</span></label></td><td style=\"padding-top: 30px\"><div ng-show=\"item.users && item.users.length > 0\">Sem usuários para este papel.</div><div ng-show=\"!item.users || item.users.length == 0\">Sem usuários para este papel.</div></td></tr></tbody></table></div></div></div></div><div></div></div></section><hr></div><div class=\"actions clearfix\"><ul role=\"menu\" aria-label=\"Pagination\"><li class=\"button_previous\" style=\"outline:0\" ng-class=\"{\'disabled\':vm.wizard1}\" aria-disabled=\"{{vm.wizard1}}\" ng-click=\"vm.selectBackWizard()\"><a><i class=\"material-icons\"></i> Anterior</a></li><li class=\"button_next\" style=\"outline:0\" ng-class=\"{\'disabled\':vm.wizard4}\" aria-hidden=\"false\" aria-disabled=\"false\" ng-click=\"vm.selectNextWizard(formService)\"><a>Próximo <i class=\"material-icons\"></i></a></li></ul><button type=\"submit\" id=\"submitForm\" style=\"visibility:hidden; display:none !important;\"></button></div></div></form></div><br></div></div></div></div><div class=\"uk-modal uk-open modalAddSituationOfService\" id=\"modalAddSituationOfService\" aria-hidden=\"false\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1 uk-width-large-8-10 uk-width-xlarge-7-10 uk-container-center reset-print\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\" style=\"width:auto !important;\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">{{vm.tempServiceSituation.situation.description}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><ul id=\"tabsModalServiceSituation\" class=\"uk-tab\" data-uk-tab=\"{connect:\'#tabs_4\', animation:\'slide-horizontal\', swiping: false}\"><li id=\"tabSituationsModal\" class=\"uk-width-1-4 uk-active\" aria-expanded=\"true\"><a href=\"#\">Comportamento</a></li><li id=\"tabNotificationsModal\" class=\"uk-width-1-4\" aria-expanded=\"false\"><a href=\"#\">Notificações</a></li><li id=\"tabReasonsModal\" class=\"uk-width-1-4\" aria-expanded=\"false\"><a href=\"#\">Justificativas</a></li><li id=\"tabComunicacaoExternaModal\" class=\"uk-width-1-4\" aria-expanded=\"false\"><a href=\"#\">Integrações</a></li></ul><ul id=\"tabs_4\" class=\"uk-switcher uk-margin\"><li aria-hidden=\"false\" class=\"uk-active\" style=\"animation-duration: 200ms;\"><form name=\"formServiceSituation\" id=\"formServiceSituation\" mt-validate-submit=\"vm.submitServiceSituation()\" novalidate=\"\"><div><h2 class=\"heading_a\">Defina abaixo as opções para as solicitações abertas para este serviço.</h2><hr><div class=\"uk-grid\"><div class=\"uk-width-1-1\"><label ng-class=\"{\'mobilecare-situation-default\':vm.tempServiceSituation.isInitial}\"><b>As novas solicitações devem sempre iniciar nesta situação?</b></label><br><input type=\"checkbox\" ng-click=\"vm.validateDefaultSituation()\" ng-model=\"vm.tempServiceSituation.isInitial\" id=\"serviceIsInitial\" name=\"serviceIsInitial\" class=\"switch-input-default\" ng-class=\"{\'mobilecare-situation-default\':vm.tempServiceSituation.isInitial}\"> <label for=\"serviceIsInitial\" class=\"switch-label-default\" ng-class=\"{\'mobilecare-situation-default\':vm.tempServiceSituation.isInitial}\" style=\"outline:0;\"><span class=\"toggle--on-default\" style=\"color: #ffa000\">Situação Padrão</span> <span class=\"toggle--off-default\">Não é situação padrão</span></label></div><br><br><div class=\"uk-width-1-1\"><label><b>Esta situação está disponível para ser selecionada pelo solicitante?</b></label><br><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.situationChangeOnMobile\" id=\"serviceStatusEnableOnMobile\" name=\"serviceStatusEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceStatusEnableOnMobile\" class=\"switch-label-mobilecare\"><span class=\"toggle--on-mobilecare\">Disponível</span> <span class=\"toggle--off-mobilecare\">Não se encontra disponível</span></label></div><br><div class=\"uk-width-1-1\"><label><b>O que o solicitante pode fazer quando a solicitação estiver nesta situação?</b></label><div class=\"uk-width-1-1\"><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.editEnableOnMobile\" id=\"serviceEditEnableOnMobile\" name=\"serviceEditEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceEditEnableOnMobile\" class=\"switch-label-mobilecare\">Pode Editar a solicitação <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label> <input type=\"checkbox\" ng-if=\"!vm.service.create\" ng-model=\"vm.tempServiceSituation.statusEnableOnMobile\" id=\"serviceIsActive\" name=\"serviceIsActive\" class=\"switch-input-mobilecare\"> <label for=\"serviceIsActive\" ng-if=\"!vm.service.create\" class=\"switch-label-mobilecare\">Pode Arquivar a solicitação <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label> <input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.deleteEnableOnMobile\" id=\"serviceDeleteEnableOnMobile\" name=\"serviceDeleteEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceDeleteEnableOnMobile\" class=\"switch-label-mobilecare\">Pode Excluir a solicitação <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label> <input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.qrCodeEnableOnMobile\" id=\"serviceQrCodeEnableOnMobile\" name=\"serviceQrCodeEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceQrCodeEnableOnMobile\" class=\"switch-label-mobilecare\">Pode Gerar Qr Code <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label></div></div></div></div></form></li><li aria-hidden=\"false\" class=\"\"><form name=\"frmServiceSituationNotification\" id=\"formServiceSituationNotification\" mt-validate-submit=\"vm.submitServiceSituation()\" novalidate=\"\" class=\"\"><h2 class=\"heading_a\">Defina abaixo as opções de notificações para esta situação.</h2><hr><div class=\"uk-grid\"><div class=\"uk-width-2-3 uk-overflow-container\" style=\"padding-right:10px;\"><div class=\"uk-width-1-1\"><label>Gostaria de padronizar uma mensagem de retorno para o usuário ao final da operação?</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"service_situation_message_return\" name=\"service_situation_message_return\" ng-model=\"vm.tempServiceSituation.returnMessage\" md-input=\"\"> <span>&nbsp;&nbsp; keys: &nbsp;</span> <a ng-click=\"vm.AddKeyWordToMessage(\'#data_abertura\')\">#data_abertura &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#data_mudança\')\">#data_mudança &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#serviço\')\">#serviço &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#situação\')\">#situação &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#protocolo_externo\')\">#protocolo_externo &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#protocolo_interno\')\">#protocolo_interno &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#nome_empresa\')\">#nome_empresa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#comentario\')\">#comentario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#justificativa\')\">#justificativa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#nome_usuario\')\">#nome_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#email_usuario\')\">#email_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessage(\'#documento_usuario\')\">#documento_usuario &nbsp;</a></div></div><br><br><div class=\"uk-width-1-1\"><label><b>Notificar o solicitante por push quando a solicitação entrar nesta situação?</b></label><br><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.sendPush\" id=\"serviceSendPush\" name=\"serviceSendPush\" class=\"switch-input-mobilecare\" ng-click=\"vm.tempServiceSituation.pushMessage = \'\'\"> <label for=\"serviceSendPush\" class=\"switch-label-mobilecare\">Notificar por Push <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label><br><div class=\"uk-width-1-1\" ng-show=\"vm.tempServiceSituation.sendPush\"><label>Qual mensagem deve ser enviada no push?</label><div class=\"md-input-wrapper2\"><input type=\"text\" maxlength=\"50\" class=\"md-input-2\" id=\"service_situation_send_push\" name=\"service_situation_send_push\" ng-model=\"vm.tempServiceSituation.pushMessage\" md-input=\"\" required=\"\"> <span>&nbsp;&nbsp; keys: &nbsp;</span> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#data_abertura\')\">#data_abertura &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#data_mudança\')\">#data_mudança &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#serviço\')\">#serviço &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#situação\')\">#situação &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#protocolo_externo\')\">#protocolo_externo &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#protocolo_interno\')\">#protocolo_interno &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#nome_empresa\')\">#nome_empresa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#comentario\')\">#comentario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#justificativa\')\">#justificativa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#nome_usuario\')\">#nome_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#email_usuario\')\">#email_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessagePush(\'#documento_usuario\')\">#documento_usuario &nbsp;</a></div><span ng-show=\"formServiceSituation.service_situation_send_push.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><br><br><div class=\"uk-width-1-1\" style=\"height:35px\"><label><b>Notificar o solicitante por inbox quando a solicitação entrar nesta situação?</b></label><br><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.sendEmail\" id=\"serviceSendInbox\" name=\"serviceSendInbox\" class=\"switch-input-mobilecare\" ng-click=\"vm.tempServiceSituation.subjectMessageInbox = vm.tempServiceSituation.inboxMessage = \'\'\"> <label for=\"serviceSendInbox\" class=\"switch-label-mobilecare\">Notificar Inbox <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label><br><div class=\"uk-width-1-1\" ng-show=\"vm.tempServiceSituation.sendEmail\"><label>Qual o assunto do inbox?</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"service_situation_inbox_message_subject\" name=\"service_situation_inbox_message_subject\" ng-model=\"vm.tempServiceSituation.subjectMessageInbox\" md-input=\"\" required=\"\"> <span>&nbsp;&nbsp; keys: &nbsp;</span> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#data_abertura\')\">#data_abertura &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#data_mudança\')\">#data_mudança &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#serviço\')\">#serviço &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#situação\')\">#situação &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#protocolo_externo\')\">#protocolo_externo &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#protocolo_interno\')\">#protocolo_interno &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#nome_empresa\')\">#nome_empresa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#comentario\')\">#comentario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#justificativa\')\">#justificativa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#nome_usuario\')\">#nome_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#email_usuario\')\">#email_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInboxSubject(\'#documento_usuario\')\">#documento_usuario &nbsp;</a></div><span ng-show=\"formServiceSituation.service_situation_inbox_message_subject.$error.required\" class=\"md-error\">Campo Obrigatório</span></div><br><div class=\"uk-width-1-1\" ng-show=\"vm.tempServiceSituation.sendEmail\"><label>Qual mensagem deve ser enviada no inbox?</label><div class=\"md-input-wrapper2\"><div id=\"inboxMessageCkeditor\" ckeditor=\"vm.options\" ng-model=\"vm.tempServiceSituation.inboxMessage\"></div><span>&nbsp;&nbsp; keys: &nbsp;</span> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#data_abertura\')\">#data_abertura &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#data_mudança\')\">#data_mudança &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#serviço\')\">#serviço &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#situação\')\">#situação &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#protocolo_externo\')\">#protocolo_externo &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#protocolo_interno\')\">#protocolo_interno &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#nome_empresa\')\">#nome_empresa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#comentario\')\">#comentario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#justificativa\')\">#justificativa &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#nome_usuario\')\">#nome_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#email_usuario\')\">#email_usuario &nbsp;</a> <a ng-click=\"vm.AddKeyWordToMessageInbox(\'#documento_usuario\')\">#documento_usuario &nbsp;</a></div><span ng-show=\"formServiceSituation.service_situation_inbox_message.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><br><br></div><div class=\"uk-width-1-3\"><span style=\"font-size:12px;\">As <i>Keys</i> são palavras reservadas utilizadas pelo sistema para identificar uma informção referente à solicitação do usuário.<br><br>Para tanto, segue a especificiação de cada uma delas:<br><br><ul style=\"margin-left:20px;\"><li><b>#data_abertura:</b> Data de abertura da solicitção;</li><li><b>#data_mudança:</b> Data de atualização da solicitação;</li><li><b>#serviço:</b> Nome do serviço associado à solicitação;</li><li><b>#situação:</b> Situação vigente da solitiação;</li><li><b>#protocolo_externo:</b> Protocolo gerado externamente ao sistema;</li><li><b>#protocolo_interno:</b> Protocolo da solicitação;</li><li><b>#nome_empresa:</b> Nome da empresa;</li><li><b>#comentario:</b> Comentário informado na mudança da solicitção;</li><li><b>#justificativa:</b> Justificativa informada na mudança da solicitação;</li><li><b>#nome_usuario:</b> Nome do usuário que registrou a solicitação;</li><li><b>#email_usuario:</b> E-mail do usuário que registrou a solicitação;</li><li><b>#documento_usuario:</b> Número do documento do usuário que registrou a solicitação.</li></ul></span></div></div></form></li><li aria-hidden=\"true\" class=\"\"><form name=\"formServiceSituationReasons\" id=\"formServiceSituationReasons\" mt-validate-submit=\"vm.submitServiceSituationReasons()\"><h2 class=\"heading_a\">Se for necessário, defina abaixo uma lista de justificativas para esta situação. Elas serão disponibilizadas para o usuário quando ele tentar alterar situação da solicitação.</h2><hr><div class=\"uk-grid\"><div class=\"uk-width-8-10\"><div class=\"uk-nestable-item no-bg exact-padding\"><label>Adicionar Justificativa</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-keyup=\"$event.keyCode == 13 ? vm.addReason() : null\" maxlength=\"50\" class=\"md-input-2\" id=\"service_situation_reason\" name=\"service_situation_reason\" ng-model=\"vm.tempServiceSituation.tempReason\" md-input=\"\" required=\"\" tabindex=\"1\"></div></div></div><div id=\"btnAddReason\" class=\"uk-width-medium-2-10\" style=\"padding:29px\"><a ng-click=\"vm.addReason()\" ng-keyup=\"$event.keyCode == 13 ? vm.addReason() : null\" title=\"Nova Justificativa\" class=\"md-btn md-btn-small md-btn-primary\" tabindex=\"2\"><i class=\"material-icons md-24 md-color-white\"></i></a></div></div><div id=\"divReasonsList\" class=\"uk-grid\" style=\"margin-top:0px; height: 206px;\"><div class=\"uk-width-1-1 uk-row-first md-card-list-wrapper\"><ul class=\"uk-nestable-item no-bg exact-padding\"><li ng-repeat=\"item in vm.tempServiceSituation.reasons | orderBy: \'description\'\"><div class=\"uk-grid\"><div class=\"uk-width-8-10\"><form name=\"formReasonsAddEdit\" id=\"formReasonsAddEdit\" novalidate=\"\"><input type=\"text\" class=\"md-input\" ng-model=\"item.description\" tooltips=\"\" tooltip-side=\"bottom\" tooltip-template=\"Clique para editar\" md-input=\"\" required=\"\" tabindex=\"{{$index + 3}}\"><div ng-show=\"!item.description || item.description.trim() == \'\'\"><span class=\"md-error\">Campo Obrigatório</span></div></form></div><div id=\"btnDeleteReason\" class=\"uk-width-2-10\" style=\"padding-top:15px; padding-left:32px !important;\"><a ng-click=\"vm.removeReasonOfSituationOfService(item)\" ng-keyup=\"$event.keyCode == 13 ? vm.removeReasonOfSituationOfService(item) : null\" title=\"Excluir justificativa\" class=\"md-btn md-btn-small md-btn-danger\" tabindex=\"{{$index + 4}}\"><i class=\"material-icons md-18 md-color-white\">&#xe872;</i></a></div></div></li></ul></div></div></form></li><li aria-hidden=\"true\" class=\"\"><h2 class=\"heading_a\">Informe abaixo se você deseja compartilhar a solicitação com outros sistemas.</h2><hr><div class=\"md-radio\"><input id=\"chkNao\" type=\"radio\" name=\"integracao\" ng-click=\"vm.showIntegrationConfigNone()\" ng-checked=\"vm.integrationType === \'none\'\"> <label for=\"chkNao\">Sem integração</label> <input id=\"chkEmail\" type=\"radio\" name=\"integracao\" ng-click=\"vm.showIntegrationConfigEmail(vm.tempServiceSituation.emailIntegrationConfig)\" ng-checked=\"vm.integrationType === \'email\'\"> <label for=\"chkEmail\">Integrar por e-mail</label> <input id=\"chkExterna\" type=\"radio\" name=\"integracao\" ng-click=\"vm.showIntegrationConfigExternal(vm.tempServiceSituation.mappingIntegrationConfig)\" ng-checked=\"vm.integrationType === \'mapping\'\"> <label for=\"chkExterna\">Integrar por serviço</label></div><form name=\"formServiceSituationIntegrationEmail\" id=\"formServiceSituationIntegrationEmail\" mt-validate-submit=\"vm.submitServiceSituationIntegration()\" novalidate=\"\"><div class=\"uk-grid\" ng-show=\"vm.integrationType === \'email\'\" style=\"min-height: 200px !important;\"><div class=\"uk-width-1-1\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>E-mail do Destinatário (separado por ponto e vírgula) *</label> <span class=\"md-input-wrapper2\"><input type=\"text\" maxlength=\"250\" class=\"md-input-2\" id=\"service_situation_to\" name=\"service_situation_to\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.to\" md-input=\"\" required=\"\"> <span>&nbsp;&nbsp; keys: &nbsp;</span> <a tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Essa marcação será subistituida pelo e-mail do solicitante no momento da integração.\" ng-click=\"vm.AddKeyWordToEmailIntegration(\'#email_solicitante\')\">#email_solicitante &nbsp;</a></span><div ng-show=\"formServiceSituationIntegrationEmail.$submitted || formServiceSituationIntegrationEmail.service_situation_to.$touched\"><span ng-show=\"formServiceSituationIntegrationEmail.service_situation_to.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Cc (separado por ponto e vírgula)</label> <span class=\"md-input-wrapper2\"><input type=\"text\" maxlength=\"250\" class=\"md-input-2\" id=\"service_situation_cc\" name=\"service_situation_cc\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.cc\" md-input=\"\"></span></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Cco (separado por ponto e vírgula)</label> <span class=\"md-input-wrapper2\"><input type=\"text\" maxlength=\"250\" class=\"md-input-2\" id=\"service_situation_cco\" name=\"service_situation_cco\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.cco\" md-input=\"\"></span></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Assunto *</label> <span class=\"md-input-wrapper2\"><input type=\"text\" maxlength=\"50\" class=\"md-input-2\" id=\"service_situation_subject\" name=\"service_situation_subject\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.subject\" md-input=\"\" required=\"\"></span><div ng-show=\"formServiceSituationIntegrationEmail.$submitted || formServiceSituationIntegrationEmail.service_situation_subject.$touched\"><span ng-show=\"formServiceSituationIntegrationEmail.service_situation_subject.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Mensagem *</label> <span class=\"md-input-wrapper2\"><textarea type=\"text\" rows=\"2\" class=\"md-input-2\" id=\"service_situation_body\" name=\"service_situation_body\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.body\" md-input=\"\" required=\"\"></textarea></span><div ng-show=\"formServiceSituationIntegrationEmail.$submitted || formServiceSituationIntegrationEmail.service_situation_body.$touched\"><span ng-show=\"formServiceSituationIntegrationEmail.service_situation_body.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\"><label>Informe o tipo de arquivo que deseja anexar as respostas do formulário</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" id=\"attachments_type\" name=\"form_filter\" config=\"vm.selectize_config\" options=\"vm.file_attachments_type\" position=\"bottom\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.includeFormAsAttachment\"></selectize></div></div><div class=\"uk-form-row\"><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.includeFormOnBody\" id=\"serviceIncludeFormOnBody\" name=\"serviceIncludeFormOnBody\" class=\"switch-input-mobilecare\"> <label for=\"serviceIncludeFormOnBody\" class=\"switch-label-mobilecare\">Incluir as respostas do formulário no corpo email? <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label></div><div class=\"uk-form-row\"><div class=\"uk-width-1-1\"><label><b>Interromper a ação realizada caso a integração apresente erro?</b></label></div><div class=\"uk-width-1-1\"><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.emailIntegrationConfig.stopAttendanceOnError\" id=\"serviceStopAttendanceOnErrorEmail\" name=\"serviceStopAttendanceOnErrorEmail\" class=\"switch-input-mobilecare\"> <label for=\"serviceStopAttendanceOnErrorEmail\" class=\"switch-label-mobilecare\"><span class=\"toggle--on-mobilecare\">Interromper</span> <span class=\"toggle--off-mobilecare\">Não interromper</span></label></div></div><br></div></div></form><form name=\"formServiceSituationIntegrationMapping\" id=\"formServiceSituationIntegrationMapping\" mt-validate-submit=\"vm.submitServiceSituationIntegration()\" novalidate=\"\"><div class=\"uk-grid\" ng-show=\"vm.integrationType === \'mapping\'\" style=\"min-height: 300px;\"><div class=\"uk-width-1-1\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Selecione a Integração *</label><div class=\"md-input-wrapper2\" ng-click=\"vm.validateMappingIntegration(false)\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" required=\"\" id=\"integration_type\" name=\"integration_type\" config=\"vm.selectize_config\" options=\"vm.integrations_service_situation_modal\" position=\"bottom\" ng-model=\"vm.tempServiceSituation.mappingIntegrationConfig.name\"></selectize></div><div ng-show=\"formServiceSituationIntegrationMapping.$submitted || formServiceSituationIntegrationMapping.integration_type.$touched\"><span ng-show=\"formServiceSituationIntegrationMapping.integration_type.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\"><div class=\"uk-width-1-1\"><label><b>Interromper a ação realizada caso a integração apresente erro?</b></label></div><div class=\"uk-width-1-1\"><input type=\"checkbox\" ng-model=\"vm.tempServiceSituation.mappingIntegrationConfig.stopAttendanceOnError\" id=\"serviceStopAttendanceOnErrorMapping\" name=\"serviceStopAttendanceOnErrorMapping\" class=\"switch-input-mobilecare\"> <label for=\"serviceStopAttendanceOnErrorMapping\" class=\"switch-label-mobilecare\"><span class=\"toggle--on-mobilecare\">Interromper</span> <span class=\"toggle--off-mobilecare\">Não interromper</span></label></div></div></div></div></form></li></ul></div></div></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\" ng-click=\"vm.validateMappingIntegration(true)\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</button> <button ng-if=\"vm.isCreateSituationModal\" ng-click=\"vm.addEditSituationOfService(true, false)\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Associar Situação</button> <button ng-if=\"vm.isEditSituationModal\" ng-click=\"vm.addEditSituationOfService(false, true)\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Atualizar Situação</button></span></div></div></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a ui-sref=\"private.painel.category.list\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\">Sim</a></div></div></div></div><div class=\"uk-modal uk-open modalIconsService\" id=\"modalIconsService\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalIconsService\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom\"><h3 class=\"uk-modal-title\">Icones</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-text-center uk-width-1-1\" style=\"padding-left:5px;\"><i ng-repeat=\"item in vm.iconsCategoryCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIconService(item)\"></i></div></div></div></div></div>");
$templateCache.put("app/category/category.list.html","<div id=\"page_content\"><div ng-attr-id=\"{{vm.pageOverflowId}}\"><div id=\"page_heading\"><div class=\"heading_actions\"><div id=\"actions-service-add\" class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" style=\"display: block; width: 112px;display:none;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar\" ng-click=\"vm.openModalConfirmacaoDeCancelamento()\"><i class=\"material-icons md-color-white\"></i></a> <a ng-if=\"vm.service.create\" title=\"Salvar\" ng-click=\"vm.wizard4 ? vm.submitService(formService): null\" ng-style=\"{\'cursor\': !vm.wizard4 ? \'not-allowed\': \'pointer\'}\"><i class=\"material-icons\" ng-style=\"{\'color\': !vm.wizard4 ? \'#ddd\': \'white\'}\"></i></a> <a ng-if=\"vm.service.update\" title=\"Salvar\" ng-click=\"vm.isUpdatedFormServiceModel ? vm.submitService(formService): null\" ng-style=\"{\'cursor\': !vm.isUpdatedFormServiceModel ? \'not-allowed\': \'pointer\'}\"><i class=\"material-icons\" ng-style=\"{\'color\': !vm.isUpdatedFormServiceModel ? \'#ddd\': \'white\'}\"></i></a></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Categorias e Serviços</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Configurações</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-3-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><div class=\"uk-badge\" tooltips=\"\" tooltip-size=\"small\" style=\"margin-top:-8px\" tooltip-side=\"bottom\" tooltip-template=\"Número de categorias da listagem.\">({{vm.categories.length}}) Categoria<span ng-show=\"vm.categories && vm.categories.length > 0\">s</span></div><a ng-click=\"vm.openModalCategory(null, true, false, false)\"><i class=\"md-icon material-icons uk-text-primary\">&#xE147;</i></a> <a id=\"open-barcontent-categories\" ng-click=\"vm.toggle(vm.getHashTagField(\'barcontent-categories\'), true)\" title=\"Pesquisar Categorias\"><i class=\"md-icon material-icons\">&#xE8B6;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">CATEGORIAS</h3></div></div></div><div class=\"uk-width-7-10\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions\"><div class=\"uk-badge\" tooltips=\"\" tooltip-size=\"small\" style=\"margin-top:-8px\" tooltip-side=\"bottom\" tooltip-template=\"Número de serviços da listagem.\">({{vm.services.length}}) Serviço<span ng-show=\"vm.services && vm.services.length > 0\">s</span></div><a ui-sref=\"private.painel.category.list.create\" title=\"Cadastrar Serviço\"><i class=\"md-icon material-icons uk-text-primary\">&#xE147;</i></a> <a id=\"open-barcontent-services\" ng-click=\"vm.toggle(vm.getHashTagField(\'barcontent-services\'), true)\" title=\"Pesquisar Serviços\"><i class=\"md-icon material-icons\">&#xE8B6;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">SERVIÇOS<span></span></h3></div></div></div></div></div><div id=\"main_board\" class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\" style=\"padding: 0px !important;\"><div class=\"uk-width-3-10 uk-overflow-container uk-border-right uk-height-1-1\"><div id=\"barcontent-categories\" class=\"md-card\" style=\"display:none;\"><div class=\"md-card-content uk-grid\"><div class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"searchCategory\" name=\"searchCategory\" ng-model=\"vm.categoryFilters.description\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-2-4 uk-row-first\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"selectize_publish_level_search\" class=\"custom_selectize\" ng-disabled=\"vm.category.detail\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.categoryFilters.publishLevelId\"></selectize></span></div><div class=\"uk-width-medium-1-1 uk-width-large-2-4 uk-row-first\"><label>Status</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"Selecione\" class=\"custom_selectize\" id=\"archived_category_filter\" name=\"archived_category_filter\" config=\"vm.selectize_status_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.categoryFilters.isActive\"></selectize></span></div></div></div><div id=\"category-list\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingCategory\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-width-1-1 uk-row-first md-card-list-wrapper\" ng-show=\"!vm.isLoadingCategory\"><div class=\"md-card\" style=\"margin: 10px !important;\" ng-if=\"(vm.categories.length == 0) || ((vm.categories | filter:vm.categoryFilters).length == 0)\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhuma categoria encontrada.</span></h3></div></div></div><div class=\"uk-width-1-1 uk-row-first md-card-list-wrapper\" ng-show=\"!vm.isLoadingCategory && (vm.categories.length != 0) && ((vm.categories | filter:vm.categoryFilters).length > 0)\"><div class=\"md-card-list uk-nestable\" style=\"margin-top:10px;\"><ul class=\"uk-nestable\" style=\"margin-top:0\"><li class=\"uk-nestable-item no-bg exact-padding\" ng-animate=\"\'animate\'\" ng-repeat=\"item in vm.categories | filter:vm.categoryFilters\" style=\"cursor: pointer !important; margin-left: {{item.marginLeft}}\"><div class=\"move uk-nestable-panel\" ng-class=\"{\'{{item.publishLevel.description.toLowerCase()}}\':item.isActive, \'arquivado\':!item.isActive, \'chamado-active\':item.isSelected, \'hierarquia\': (item.subCategories.length > 0)}\"><div class=\"md-card-list-item-menu uk-visible-large\"><a ng-if=\"vm.isCategoryEditarPermitido\" title=\"Editar Categoria\" ng-click=\"vm.openModalCategory(item, false, true, false)\"><i class=\"md-icon material-icons\">&#xE150;</i></a> <a ng-if=\"vm.isCategoryExcluirPermitido\" title=\"Excluir Categoria\" ng-class=\"{disabled_link: !(!item.servicesCount || item.servicesCount == 0)}\" ng-click=\"vm.deleteById(item)\"><i class=\"md-icon material-icons\">&#xE872;</i></a></div><div class=\"md-card-list-item-menu uk-visible-medium\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\" aria-haspopup=\"true\" aria-expanded=\"false\"><a href=\"#\" class=\"md-icon material-icons\"></a><div class=\"uk-dropdown uk-dropdown-small uk-dropdown-bottom\" aria-hidden=\"true\" tabindex=\"\" style=\"min-width: 160px; top: 36px; left: -128px;\"><ul class=\"uk-nav\"><li ng-if=\"vm.isCategoryEditarPermitido\"><a ng-click=\"vm.openModalCategory(item, false, true, false)\"><i class=\"material-icons\"></i> Editar</a></li><li ng-if=\"vm.isCategoryExcluirPermitido\"><a ng-click=\"vm.deleteById(item)\" ng-class=\"{disabled_link: !(!item.servicesCount || item.servicesCount == 0)}\"><i class=\"material-icons\">&#xe872;</i> Excluir</a></li></ul></div></div><span class=\"md-card-list-item-date publicacao-servico uk-hidden-small uk-hidden-medium\" ng-if=\"!item.subCategories || item.subCategories.length == 0\"><span ng-show=\"!item.isActive\" class=\"uk-badge uk-badge-muted\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:0\">Arquivado</span> <span class=\"uk-badge {{item.publishLevel.description.toLowerCase()}}\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:0\">{{item.publishLevel.description}}</span></span> <span ng-if=\"item.servicesCount > 0\" class=\"md-card-list-item-date\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:0\"><span class=\"uk-badge uk-badge-muted\" tooltips=\"\" tooltip-side=\"bottom\" tooltip-template=\"{{item.servicesCount}} Serviço(s) Cadastrados\">{{item.servicesCount}}</span></span><div class=\"md-card-list-item-select\" style=\"padding:0;\"><div class=\"md-icon uk-nestable-toggle\" data-nestable-action=\"toggle\"></div></div><div class=\"md-card-list-item-avatar-wrapper\"><span class=\"md-card-list-item-avatar md-bg-grey-50\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:none\"><i class=\"mobilecare-icons\" ng-bind-html=\"item.icon\"></i></span></div><div class=\"md-card-list-item-subject\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:none\"><span>{{item.description}}</span></div></div></li></ul></div></div></div></div><div class=\"uk-width-7-10 uk-overflow-container uk-height-1-1\" ng-if=\"vm.isCategoryVisualizarPermitido\"><div id=\"barcontent-services\" class=\"md-card\" style=\"display:none;\"><div class=\"md-card-content uk-grid\"><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"searchForm\" name=\"searchForm\" ng-model=\"vm.filters.description\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"selectize_publish_level_search_form\" class=\"custom_selectize\" ng-disabled=\"vm.item.detail\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.filters.publishLevelId\"></selectize></span></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Status</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"Selecione\" class=\"custom_selectize\" id=\"archived_form_filter\" name=\"archived_form_filter\" config=\"vm.selectize_status_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.filters.isActive\"></selectize></span></div></div></div></div><div id=\"form-list\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-grid uk-grid-collapse page_aside_inner\" data-uk-grid-margin=\"0\" style=\"margin-top: -13px !important;\" ng-if=\"!vm.isLoading\"><div class=\"md-card-list-wrapper uk-width-1-1\"><div class=\"uk-width-1-1 uk-container-center\"><div class=\"md-card-list\"><div class=\"md-card\" style=\"margin-top: 20px !important;\" ng-show=\"!vm.services || (vm.services.length == 0) || ((vm.services | filter:vm.filters).length == 0)\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum serviço encontrado.</span></h3></div></div><ul class=\"md-list-custom uk-nestable-list md-list-custom-outside\" ng-show=\"(vm.services.length != 0) && ((vm.services | filter:vm.filters).length > 0)\"><li ng-repeat=\"item in vm.services | filter: vm.filters\"><div class=\"md-card-list-item-menu uk-visible-large\"><a ng-if=\"vm.isCategoryEditarPermitido\" title=\"Copiar Serviço\" ng-click=\"vm.openModalCloneService(item)\"><i class=\"md-icon material-icons\">&#xE14D;</i></a> <a ng-if=\"vm.isCategoryEditarPermitido\" title=\"Editar Serviço\" ui-sref=\"private.painel.category.list.edit({id: item.id})\"><i class=\"md-icon material-icons\">&#xE150;</i></a> <a ng-if=\"vm.isCategoryExcluirPermitido\" title=\"Excluir Serviço\" ng-click=\"vm.deleteServiceById(item)\"><i class=\"md-icon material-icons\">&#xE872;</i></a></div><div class=\"md-card-list-item-menu uk-visible-medium\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\"><a href=\"#\" class=\"md-icon material-icons\">&#xE5D4;</a><div class=\"uk-dropdown uk-dropdown-small\"><ul class=\"uk-nav\"><li ng-if=\"vm.isCategoryEditarPermitido\"><a ng-click=\"vm.openModalCloneService(item)\"><i class=\"material-icons\">&#xE14D;</i> Copiar</a></li><li ng-if=\"vm.isCategoryEditarPermitido\"><a ng-click=\"vm.editService(item, formService)\"><i class=\"material-icons\">&#xE150;</i>Editar</a></li><li ng-if=\"vm.isCategoryExcluirPermitido\"><a title=\"Excluir\" ng-click=\"vm.deleteServiceById(item)\"><i class=\"material-icons\">&#xE872;</i> Excluir</a></li></ul></div></div><span class=\"md-card-list-item-date publicacao-servico\"><span class=\"uk-badge {{item.publishLevel.description.toLowerCase()}}\" style=\"outline:0\">{{item.publishLevel.description}}</span></span> <span ng-if=\"item.isActive\" class=\"md-card-list-item-date\"><span class=\"uk-badge uk-badge-primary\">Ativo</span></span> <span ng-if=\"!item.isActive\" class=\"md-card-list-item-date\"><span class=\"uk-badge uk-badge-muted\">Arquivado</span></span><div class=\"md-card-list-item-sender\"><span class=\"uk-text-primary\"><i class=\"mobilecare-icons\" ng-bind-html=\"item.icon\" ng-show=\"item.icon\"></i> &nbsp; {{item.description}}</span></div><div class=\"md-card-list-item-subject\"><div class=\"md-card-list-item-sender-small\"><span class=\"ng-binding ng-scope\">{{item.description}}</span></div><span class=\"ng-binding\" style=\"line-height: 34px;\"><span ng-if=\"item.form\">Formulário de {{item.form.title}}</span> <span ng-if=\"!item.form\">Sem formulário cadastrado <span style=\"color:red;\">*</span></span></span></div></li></ul></div></div></div></div><br></div></div></div><div id=\"service-add\" class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\" style=\"display:none\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><div class=\"md-card-toolbar-actions\" style=\"padding-top:5px !important;\"><a class=\"md-btn md-btn-danger\" ng-click=\"vm.hideWizardAddService(formService)\" style=\"display:none !important;\">CANCELAR</a> <a class=\"md-btn\" id=\"submitService\" ng-click=\"vm.submitService(formService);\" ng-class=\"{\'mobilecare-disabled\' : !vm.wizard4}\" ng-if=\"vm.service.create\" style=\"margin-right:5px; color: #fff; background-color:#7cb342; display:none !important;\">ADICIONAR SERVIÇO</a> <a class=\"md-btn\" id=\"submitEditService\" ng-click=\"vm.submitService(formService);\" ng-class=\"{\'mobilecare-disabled\' : !vm.isUpdatedFormServiceModel}\" ng-if=\"vm.service.update\" style=\"margin-right:5px; color: #fff; background-color:#7cb342; display:none !important;\">ATUALIZAR SERVIÇO</a></div><span class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-bold ng-binding\">ADICIONAR SERVIÇO</span></span></div><div class=\"md-card-content\"><form name=\"formService\" id=\"formService\" mt-validate-submit=\"vm.submitService(formService)\" novalidate=\"\"><div id=\"wizard_advanced\" role=\"application\" class=\"wizard clearfix\"><div class=\"steps clearfix\"><ul role=\"tablist\"><li role=\"tab\" class=\"first selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard1}\" ng-click=\"vm.selectTabWizard(1, formService)\" aria-disabled=\"false\" aria-selected=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important; border-right: 1px solid #eee !important;\"><a id=\"btn-descricao\"><span class=\"number\">1</span> <span class=\"title\">Descrição</span></a></li><li role=\"tab\" class=\"disabled selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard2}\" ng-click=\"vm.selectTabWizard(2, formService)\" aria-disabled=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important; border-right: 1px solid #eee !important;\"><a id=\"btn-fluxo\"><span class=\"number\">2</span> <span class=\"title\">Situações Permitidas</span></a></li><li role=\"tab\" class=\"disabled selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard3}\" ng-click=\"vm.selectTabWizard(3, formService)\" aria-disabled=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important; border-right: 1px solid #eee !important;\"><a id=\"btn-fluxo\"><span class=\"number\">3</span> <span class=\"title\">Fluxo de Atendimento</span></a></li><li role=\"tab\" class=\"disabled last selectedWizardNext\" ng-class=\"{\'selectedWizard\': vm.wizard4}\" ng-click=\"vm.selectTabWizard(4, formService)\" aria-disabled=\"true\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}; outline: 0 !important; border: none !important;\"><a id=\"btn-permissoes\"><span class=\"number\">4</span> <span class=\"title\">Permissões</span></a></li></ul></div><section id=\"div-aba1\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-0\" class=\"body step-0 current fade-in-mobilecare\" data-step=\"0\" aria-hidden=\"false\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Descrição <span class=\"sub-heading\">Informações básicas do serviço.</span></h2><div class=\"uk-grid\"><div class=\"uk-width-large-1-2 uk-width-medium-1-1\" style=\"padding-top:20px\"><label for=\"wizard_birth_place-selectized\"><b>Categoria</b> <span class=\"req\">*</span></label><selectize placeholder=\"Selecione\" id=\"form_categoria\" name=\"form_categoria\" config=\"vm.selectize_config\" required=\"\" options=\"vm.listLeafsCategories\" position=\"bottom\" ng-model=\"vm.service.categoryId\" ng-change=\"vm.isUpdatedFormService()\"></selectize><div ng-show=\"formService.$submitted || formService.form_categoria.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formService.form_categoria.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\" style=\"padding-top:20px\"><label for=\"wizard_birth_place-selectized\"><b>Classificação</b> <span class=\"req\">*</span></label><selectize placeholder=\"Selecione\" required=\"\" id=\"publish_levels_service_filter\" name=\"publish_levels_service_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.service.publishLevelId\" ng-change=\"vm.isUpdatedFormService()\"></selectize><div ng-show=\"formService.$submitted || formService.publish_levels_service_filter.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formService.publish_levels_service_filter.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-grid\"><div class=\"uk-width-large-1-2 uk-width-medium-1-1\" mtm-show-errors=\"\" style=\"padding-top:20px\"><label for=\"wizard_fullname\"><b>Nome do Serviço</b> <span class=\"req\">*</span></label> <input type=\"text\" ng-disabled=\"vm.category.detail\" class=\"md-input\" id=\"descricao_service\" name=\"descricao\" ng-model=\"vm.service.description\" required=\"\" placeholder=\"*\" style=\"padding-top:17px;\" ng-keypress=\"vm.isUpdatedFormService()\" ng-keyup=\"vm.isUpdatedFormService()\" ng-keydown=\"vm.isUpdatedFormService()\"><div ng-show=\"formService.$submitted || formService.descricao.$touched\"><span ng-show=\"formService.descricao.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\" style=\"width:220px; margin-top:15px\"><label for=\"wizard_address\"><b>Ícone</b></label><div class=\"md-input-wrapper\" style=\"width:300px\"><i class=\"material-icons md-user-image\" ng-if=\"!vm.service.icon\" style=\"font-size:30px; padding:5px 0 0 0;\">&#xe611;</i> <i class=\"mobilecare-icons md-user-image\" ng-if=\"vm.service.icon\" ng-bind-html=\"vm.service.icon\" style=\"font-size:30px; padding:5px 0 0 0;\"></i> <a class=\"md-btn md-btn-small\" style=\"margin:-15px 0 0 30px\" ng-click=\"vm.openModalServiceIcons()\">Selecionar</a> <a class=\"md-btn md-btn-small md-btn-danger\" style=\"margin:-15px 0 0 10px\" ng-click=\"vm.removeIcon()\" ng-show=\"vm.service.icon\">Remover</a> <span class=\"md-input-bar\"></span></div></div></div><div class=\"uk-grid\"><div ng-if=\"vm.selectize_forms && vm.selectize_forms.length > 0\" class=\"uk-width-large-1-2 uk-width-medium-1-1\" style=\"margin-bottom:20px\"><label for=\"wizard_birth_place-selectized\"><b>Formulário de Perguntas</b> <span class=\"req\">*</span></label><selectize placeholder=\"Selecione\" id=\"form_filter\" name=\"form_filter\" config=\"vm.selectize_forms_config\" required=\"\" options=\"vm.selectize_forms\" position=\"bottom\" ng-model=\"vm.service.formId\" ng-change=\"vm.isUpdatedFormService()\"></selectize><div ng-show=\"formService.$submitted || formService.form_filter.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formService.form_filter.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><label for=\"wizard_fullname\"><b>Tempo de SLA (h)</b></label> <input type=\"text\" maxlength=\"3\" ng-minlength=\"0\" class=\"md-input\" id=\"sla\" name=\"sla\" ng-model=\"vm.service.sla\" ng-keypress=\"vm.validate($event)\" style=\"padding-top:17px;\" onkeypress=\"return (event.charCode == 8 | (event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\" ng-keyup=\"vm.isUpdatedFormService()\" ng-keydown=\"vm.isUpdatedFormService()\"></div></div><div class=\"uk-grid\" ng-if=\"vm.service.update\"><div class=\"uk-width-1-2\"><input type=\"checkbox\" ng-model=\"vm.service.isActiveNew\" id=\"archiveService\" name=\"archiveService\" class=\"switch-input\" ng-click=\"vm.isUpdatedFormService()\"> <label for=\"archiveService\" class=\"switch-label\">Arquivado</label></div></div></div></section><section id=\"div-aba2\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-1\" class=\"body step-1 fade-in-mobilecare\" data-step=\"1\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Situações Permitidas <span class=\"sub-heading\">Defina abaixo as situações que as solicitações deste serviço devem percorrer desde a sua abertura até encerramento.</span></h2><div class=\"uk-grid\"><div class=\"uk-width-small-2-3\"><label for=\"wizard_birth_place-selectized\"><b>Selecione a situação para adicioná-la a este serviço:</b></label><selectize placeholder=\"Selecione\" id=\"situation_name_filter\" name=\"situation_name_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_sources_situations\" position=\"bottom\" ng-model=\"vm.filters.situationWorkFlowDescription\" ng-change=\"vm.openModalServiceSituation(null, true, false)\"></selectize></div></div><hr class=\"md-hr\"><div class=\"uk-width-1-1 uk-container-center\"><ul class=\"uk-nestable md-card-list-wrapper\" data-uk-nestable=\"{handleClass:\'uk-nestable-handle\'}\"><li class=\"no-bg\" ng-repeat=\"item in vm.service.serviceSituations | orderBy: \'order\'\" style=\"margin-top:5px; outline:0;cursor:pointer;\"><div class=\"md-card-list\" style=\"margin-top:0;padding:2px;outline:0;cursor:pointer;\"><div id=\"divClickServiceSituation\" class=\"exact-padding uk-nestable-panel md-bg-grey-50\" ng-click=\"vm.gatewaySituationsService(1, item, false, true)\" style=\"outline:0;cursor:pointer;\"><a href=\"\" class=\"md-icon material-icons\" style=\"float:right; margin-top:30px; margin-right:20px\" ng-mouseleave=\"vm.freeSituationModal()\" ng-mouseover=\"vm.holdSituationModal()\" ng-click=\"vm.gatewaySituationsService(2, item, null, null)\"></a> <a href=\"\" class=\"md-icon material-icons\" style=\"float:right; margin-top:30px;\" ng-click=\"vm.gatewaySituationsService(1, item, false, true)\"></a> <a href=\"\" class=\"mobilecare-icons\" style=\"float:right; margin-top:30px; font-size:27px; font-weight:bold\" ng-mouseleave=\"vm.freeSituationModal()\" ng-mouseover=\"vm.holdSituationModal()\" ng-click=\"vm.listItemUp($index)\" ng-class=\"{\'color-disabled-situation\': $first}\">&#xe096;</a> <a href=\"\" class=\"mobilecare-icons\" style=\"float:right; margin-top:30px; font-size:27px; font-weight:bold\" ng-mouseleave=\"vm.freeSituationModal()\" ng-mouseover=\"vm.holdSituationModal()\" ng-click=\"vm.listItemDown($index)\" ng-class=\"{\'color-disabled-situation\': $last}\">&#xe097;</a><div class=\"md-card-list-item-select\" style=\"cursor:default\"><i class=\"uk-nestable-handle material-icons\" style=\"cursor:default\"></i><br><span class=\"uk-badge uk-badge-outline\" data-uk-tooltip=\"{pos:\'right\'}\">{{item.order}}</span></div><div class=\"md-card-list-item-subject\"><span style=\"padding:10px 0 5px 0\"><span ng-show=\"item.description\" class=\"uk-text-primary\">{{item.description}}</span> <span ng-show=\"!item.description\" class=\"uk-text-primary\">{{item.situation.description}}</span></span> <span><span class=\"uk-badge\" ng-if=\"item.isInitial\" ng-class=\"{ \'uk-badge-outline\' : !item.isInitial, \'uk-badge-warning\' : item.isInitial }\">Padrão</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.qrCodeEnableOnMobile, \'uk-badge-primary\' : item.qrCodeEnableOnMobile }\">Habilita QRCode</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.sendPush, \'uk-badge-primary\' : item.sendPush }\">Envia Push</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.sendEmail, \'uk-badge-primary\' : item.sendEmail }\">Envia Inbox</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.editEnableOnMobile, \'uk-badge-primary\' : item.editEnableOnMobile }\">Edição via app</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.deleteEnableOnMobile, \'uk-badge-primary\' : item.deleteEnableOnMobile }\">Exclusão via app</span> <span class=\"uk-badge\" ng-if=\"!vm.service.create\" ng-class=\"{ \'uk-badge-outline\' : !item.statusEnableOnMobile, \'uk-badge-primary\' : item.statusEnableOnMobile }\">Arquivar via app</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.situationChangeOnMobile, \'uk-badge-primary\' : item.situationChangeOnMobile }\">Disponível no app</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.showReason, \'uk-badge-primary\' : item.showReason }\">Motivos</span> <span class=\"uk-badge\" ng-class=\"{ \'uk-badge-outline\' : !item.communication, \'uk-badge-primary\' : item.communication }\">Integração Externa</span></span> <span class=\"uk-text-small\"></span></div></div></div></li><li id=\"liSemSituacao\" class=\"uk-nestable-item no-bg grow-scale2\" ng-if=\"!vm.service.serviceSituations || vm.service.serviceSituations.length == 0\"><div class=\"md-card-list\" style=\"margin-top:0;padding:2px;\"><div class=\"exact-padding uk-nestable-panel md-bg-grey-50\"><div class=\"md-card-list-item-subject\" style=\"padding: 20px 0 20px 0;\"><span><span><i class=\"material-icons\" style=\"margin: 0 5px 0 20px; font-size:20px\">&#xe000;</i> Nenhuma situação.</span></span></div></div></div></li></ul></div></div></section><section id=\"div-aba3\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-2\" class=\"body step-2 fade-in-mobilecare\" data-step=\"2\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Fluxo de Atendimento <span class=\"sub-heading\">Defina abaixo o fluxo de atendimento especifico para cada situação.</span></h2><hr><div class=\"uk-width-1-1 uk-container-center\"><div class=\"uk-grid\" ng-repeat=\"item in vm.service.serviceSituations\" style=\"margin-top:0;\"><div class=\"uk-width-7-10\" style=\"padding-top: 15px\"><div class=\"uk-row-first\" style=\"margin:2px\"><div class=\"md-card\" ng-class=\"{\'rascunho\': !item.isInitial, \'beta\': item.isInitial}\"><div class=\"md-card-toolbar\" style=\"padding: 8px 0 8px 17px; height: 35px\"><h5><label>De</label> <label ng-if=\"item.description\" class=\"uk-text-bold\">{{item.description}}</label> <label ng-if=\"!item.description\" class=\"uk-text-bold\">{{item.situation.description}}</label> <label>pode ir para:</label></h5></div><div class=\"md-card-content\" style=\"padding: 5px 10px 0px 10px; border:none !important\"><selectize class=\"md-input uk-width-1-1\" placeholder=\"Selecione\" config=\"vm.selectize_workflow_config\" options=\"item.listWorkflow\" position=\"bottom\" ng-model=\"vm.service.serviceSituations[$index].situationsSelected\" ng-change=\"vm.isUpdatedFormService()\"></selectize></div></div></div></div></div><div class=\"uk-nestable md-card-list-wrapper\" ng-if=\"!vm.service.serviceSituations || vm.service.serviceSituations.length == 0\"><div class=\"uk-nestable-item no-bg grow-scale2 ng-scope\"><div class=\"md-card-list\" style=\"margin-top:0;padding:2px;\"><div class=\"exact-padding uk-nestable-panel md-bg-grey-50\"><div class=\"md-card-list-item-subject\" style=\"padding: 20px 0 20px 0;\"><span><span><i class=\"material-icons\" style=\"margin: 0 5px 0 20px; font-size:20px\"></i> Nenhum fluxo de atendimento.</span></span></div></div></div></div></div></div></div></section><section id=\"div-aba4\" role=\"tabpanel\" aria-labelledby=\"wizard_advanced-h-2\" class=\"body step-2 fade-in-mobilecare\" data-step=\"2\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingServiceWizard\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingServiceWizard\"><br><h2 class=\"heading_a\">Permissões para Acompanhar o Atendimento <span class=\"sub-heading\">Defina abaixo quais Papéis e/ou Pessoas podem acessar as solicitações deste serviço na área de atendimento.</span></h2><hr><div class=\"uk-width-1-1 uk-container-center\"><div class=\"uk-grid\"><div class=\"uk-width-1-1\"><div class=\"uk-overflow-container\" style=\"margin:20px;\"><table class=\"uk-table uk-table-nowrap table_check uk-text-small\"><thead><tr><th class=\"uk-width-5-10\">Papéis</th><th class=\"uk-width-5-10\">Usuários</th></tr></thead><tbody><tr ng-repeat=\"item in vm.papeis\"><td><input type=\"checkbox\" ng-model=\"item.checked\" id=\"papel{{$index}}\" name=\"serviceIsInitial\" class=\"switch-input uk-width-1-1\" ng-click=\"vm.isUpdatedFormService()\"> <label for=\"papel{{$index}}\" class=\"switch-label uk-width-1-1\"><b>{{item.name}}:</b> <span class=\"toggle--on\">permitido.</span> <span class=\"toggle--off\">não permitido.</span></label></td><td style=\"padding-top: 30px\"><div ng-show=\"item.users && item.users.length > 0\">Sem usuários para este papel.</div><div ng-show=\"!item.users || item.users.length == 0\">Sem usuários para este papel.</div></td></tr></tbody></table></div></div></div></div><div></div></div></section><br><hr><div class=\"actions clearfix\" style=\"margin-top:50px\"><ul role=\"menu\" aria-label=\"Pagination\"><li class=\"button_previous\" ng-class=\"{\'disabled\':vm.wizard1}\" aria-disabled=\"{{vm.wizard1}}\" ng-click=\"vm.selectBackWizard()\"><a><i class=\"material-icons\"></i> Anterior</a></li><li class=\"button_next\" ng-class=\"{\'disabled\':vm.wizard4}\" aria-hidden=\"false\" aria-disabled=\"false\" ng-click=\"vm.selectNextWizard(formService)\"><a>Próximo <i class=\"material-icons\"></i></a></li></ul></div><br></div></form></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a ng-click=\"vm.hideWizardAddService(formService)\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\">Sim</a></div></div></div></div></div></div><div class=\"uk-modal custom modalCategorias\" id=\"modalCategorias\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalCategory\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"visibility:hidden\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Categoria</h3></div><div class=\"uk-modal-body-custom\" style=\"overflow-y:unset !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingCategoryForm\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoadingCategoryForm\" name=\"formCategory\" id=\"formCategory\" mt-validate-submit=\"vm.submitCategory(vm.category)\" novalidate=\"\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Categoria Superior</label> <span class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Sem categoria pai\" ng-disabled=\"vm.category.detail\" config=\"vm.selectize_config\" options=\"vm.categoriesFather\" position=\"bottom\" ng-model=\"vm.categoryModal.parentId\"></selectize></span></div><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"vm.category.detail\" class=\"md-input-2\" id=\"descricao_category\" name=\"descricao\" ng-model=\"vm.categoryModal.description\" md-input=\"\" required=\"\"></div><div ng-show=\"formCategory.$submitted || formCategory.descricao.$touched\"><span ng-show=\"formCategory.descricao.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\"><div class=\"uk-width-10-10 uk-width-small-10-10\"><label>Ícone</label></div><div class=\"uk-width-1-10 uk-width-small-1-10\" style=\"width:5px !important\"><i class=\"material-icons md-user-image\" ng-if=\"!vm.categoryModal.icon\" style=\"font-size:30px; padding:5px 0 0 0;\">&#xe611;</i> <i class=\"mobilecare-icons md-user-image\" ng-if=\"vm.categoryModal.icon\" ng-bind-html=\"vm.categoryModal.icon\" style=\"font-size:30px; padding:12px 0 0 0;\"></i><br><span style=\"font-size:10px; font-style:italic; padding-left:4px;\" ng-if=\"vm.categoryModal.icon\">{{vm.category.icon.replace(\'&#x\', \'\')}}</span></div><div class=\"uk-width-9-10 uk-width-small-9-10\" style=\"padding:5px 0px 0 40px;\"><a id=\"btnAddCategoryIcon\" class=\"md-btn md-btn-flat md-btn-small md-btn-primary\" ng-disabled=\"vm.category.detail\" ng-click=\"vm.openModalCategoryIcons()\">Selecionar</a></div><div class=\"uk-width-1-1\"><input type=\"text\" ng-disabled=\"true\" class=\"md-input\" id=\"icone\" name=\"icone\" ng-model=\"vm.categoryModal.icon\" md-input=\"\" required=\"\" style=\"display:none; height:0; margin:0;\"><div ng-show=\"formCategory.$submitted || formCategory.icone.$touched\" style=\"margin-top:0\"><span ng-show=\"formCategory.icone.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" ng-model=\"vm.categoryModal.publishLevelId\" placeholder=\"Selecione\" required=\"\" ng-disabled=\"vm.category.detail\" id=\"publish_levels_modal_filter\" name=\"publish_levels_modal_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\"></selectize></span><div ng-show=\"formCategory.$submitted || formCategory.publish_levels_modal_filter.$touched\"><span ng-show=\"formCategory.publish_levels_modal_filter.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\" id=\"categoryIsActive\" ng-if=\"!vm.category.create\"><div class=\"uk-width-10-10 uk-width-small-10-10\"><label>Status</label></div><div class=\"uk-width-10-10 uk-width-small-10-10\"><input type=\"checkbox\" ng-model=\"vm.categoryModal.isActive\" id=\"archiveCategory\" name=\"archiveCategory\" class=\"switch-input\" ng-disabled=\"vm.category.detail\"> <label for=\"archiveCategory\" class=\"switch-label\" ng-disabled=\"vm.category.detail\" style=\"padding: 0px 0px 0px 50px !important;\"><span ng-if=\"vm.categoryModal.isActive\">Ativa</span> <span ng-if=\"!vm.categoryModal.isActive\">Arquivada</span></label></div></div></div></div></form></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</button> <button form=\"formCategory\" type=\"submit\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\" ng-disabled=\"vm.category.detail\" id=\"btnSaveCategory\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Salvar</button></span></div></div></div></div><div class=\"uk-modal uk-open modalAddSituationOfService\" id=\"modalAddSituationOfService\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">CADASTRO DE SITUAÇÃO &raquo; {{vm.service.modalSituations.description.toUpperCase()}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><ul id=\"tabsModalServiceSituation\" class=\"uk-tab\" data-uk-tab=\"{connect:\'#tabs_4\', animation:\'slide-horizontal\', swiping: false}\"><li id=\"tabSituationsModal\" class=\"uk-width-1-3 uk-active\" aria-expanded=\"true\"><a href=\"#\">Comportamento</a></li><li id=\"tabReasonsModal\" class=\"uk-width-1-3\" aria-expanded=\"false\"><a href=\"#\">Justificativas</a></li><li id=\"tabComunicacaoExternaModal\" class=\"uk-width-1-3\" aria-expanded=\"false\"><a href=\"#\">Comunicação Externa</a></li></ul><ul id=\"tabs_4\" class=\"uk-switcher uk-margin\"><li aria-hidden=\"false\" class=\"uk-active\" style=\"animation-duration: 200ms;\"><form name=\"formServiceSituation\" id=\"formServiceSituation\" mt-validate-submit=\"vm.submitServiceSituation()\" novalidate=\"\"><div><h2 class=\"heading_a\">Comportamento da Situação <span class=\"sub-heading\">Defina abaixo as opções para as solicitações abertas para este serviço.</span></h2><br><hr><div class=\"uk-grid\"><div class=\"uk-width-1-1\"><label ng-class=\"{\'mobilecare-situation-default\':vm.service.modalSituations.behavior.isInitial}\"><b>As novas solicitações devem sempre iniciar nesta situação?</b></label><br><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.behavior.isInitial\" id=\"serviceIsInitial\" name=\"serviceIsInitial\" class=\"switch-input-default\" ng-class=\"{\'mobilecare-situation-default\':vm.service.modalSituations.behavior.isInitial}\"> <label for=\"serviceIsInitial\" class=\"switch-label-default\" ng-class=\"{\'mobilecare-situation-default\':vm.service.modalSituations.behavior.isInitial}\" ng-click=\"vm.validateDefaultSituation()\" onclick=\"return false;\" style=\"outline:0;\">Situação Padrão <span class=\"toggle--on-default\" style=\"color: #ffa000\"></span> <span class=\"toggle--off-default\" style=\"color: #ffa000\"></span></label></div><br><br><div class=\"uk-width-1-1\"><label><b>Esta situação está disponível para ser selecionada pelo solicitante?</b></label><br><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.behavior.situationChangeOnMobile\" id=\"serviceStatusEnableOnMobile\" name=\"serviceStatusEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceStatusEnableOnMobile\" class=\"switch-label-mobilecare\">Disponível <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label></div><br><br><div class=\"uk-width-1-1\"><label><b>Notificar o solicitante quando a solicitação entrar nesta situação?</b></label><div class=\"uk-width-1-1\" style=\"height:35px\"><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.behavior.sendPush\" id=\"serviceSendPush\" name=\"serviceSendPush\" class=\"switch-input-mobilecare\"> <label for=\"serviceSendPush\" class=\"switch-label-mobilecare\">Notificar por Push <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label> <input type=\"checkbox\" ng-model=\"vm.service.modalSituations.behavior.sendEmail\" id=\"serviceSendMail\" name=\"serviceSendMail\" class=\"switch-input-mobilecare\"> <label for=\"serviceSendMail\" class=\"switch-label-mobilecare\">Notificar Inbox <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label></div><br><div class=\"uk-width-2-3\"><label>Qual mensagem deve ser enviada?</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"service_situation_message_default\" name=\"service_situation_message_default\" ng-model=\"vm.service.modalSituations.behavior.defaultMessage\" md-input=\"\" required=\"\" ng-if=\"vm.service.modalSituations.behavior.sendPush\"> <input type=\"text\" class=\"md-input\" id=\"service_situation_message_default\" name=\"service_situation_message_default\" ng-model=\"vm.service.modalSituations.behavior.defaultMessage\" md-input=\"\" required=\"\" ng-if=\"!vm.service.modalSituations.behavior.sendPush\"><div ng-show=\"vm.service.modalSituations.behavior.sendEmail || vm.service.modalSituations.behavior.sendPush\"><span ng-show=\"formServiceSituation.service_situation_message_default.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><br></div><br><div class=\"uk-width-1-1\"><label><b>O que o solicitante pode fazer quando a solicitação estiver nesta situação?</b></label><div class=\"uk-width-1-1\"><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.behavior.editEnableOnMobile\" id=\"serviceEditEnableOnMobile\" name=\"serviceEditEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceEditEnableOnMobile\" class=\"switch-label-mobilecare\">Pode Editar a solicitação <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label> <input type=\"checkbox\" ng-if=\"!vm.service.create\" ng-model=\"vm.service.modalSituations.behavior.statusEnableOnMobile\" id=\"serviceIsActive\" name=\"serviceIsActive\" class=\"switch-input-mobilecare\"> <label for=\"serviceIsActive\" ng-if=\"!vm.service.create\" class=\"switch-label-mobilecare\">Pode Arquivar a solicitação <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label> <input type=\"checkbox\" ng-model=\"vm.service.modalSituations.behavior.deleteEnableOnMobile\" id=\"serviceDeleteEnableOnMobile\" name=\"serviceDeleteEnableOnMobile\" class=\"switch-input-mobilecare\"> <label for=\"serviceDeleteEnableOnMobile\" class=\"switch-label-mobilecare\">Pode Excluir a solicitação <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label></div></div></div></div></form></li><li aria-hidden=\"true\" class=\"\"><form name=\"formServiceSituationReasons\" id=\"formServiceSituationReasons\" mt-validate-submit=\"vm.submitServiceSituationReasons()\"><h2 class=\"heading_a\">Justificativas da Situação <span class=\"sub-heading\">Se for necessário, defina abaixo uma lista de justificativas para esta situação.<br>Elas serão disponibilizadas para o usuário quando ele tentar alterar situação da solicitação.</span></h2><br><div class=\"uk-grid\"><div class=\"uk-width-8-10\"><div class=\"uk-nestable-item no-bg exact-padding\"><div class=\"rascunho move uk-nestable-panel\" style=\"padding:15px\"><label>Justificativa</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"service_situation_reason\" name=\"service_situation_reason\" ng-model=\"vm.service.modalSituations.reason.reasonActive\" md-input=\"\" required=\"\"></div></div></div><div id=\"btnAddReason\" class=\"uk-width-medium-2-10\" style=\"padding:22px\"><button class=\"md-btn md-btn-small md-btn-primary uk-text-right\" ng-click=\"vm.addReason()\" style=\"background-color:#2494d8\">Adicionar</button></div></div><div id=\"divReasonsList\" class=\"uk-grid\" style=\"margin-top:0px; height: 206px;\"><div class=\"uk-width-1-1 uk-row-first md-card-list-wrapper\"><div class=\"md-card-list uk-nestable\" style=\"margin:0\"><div class=\"md-card-list\" style=\"margin-top: 5px; padding-left:5px; padding-right:10px;\"><ul><li class=\"anim-list ng-scope rascunho\" ng-repeat=\"item in vm.service.modalSituations.reason.reasonsList | orderBy: \'description\'\" ng-if=\"!item.isDeleted\" style=\"margin-bottom:2px;\"><span style=\"float:right\"><a ng-click=\"vm.removeReasonOfSituationOfService(item)\"><i class=\"material-icons\" style=\"margin: 10px 15px 10px 20px; font-size:20px;\">&#xe872;</i></a></span><div class=\"md-card-list-item-subject\"><form name=\"formReasonsAddEdit\" id=\"formReasonsAddEdit\" novalidate=\"\"><span style=\"padding-top:0px;\" class=\"ng-binding\"><input type=\"text\" class=\"md-input\" ng-model=\"item.description\" md-input=\"\" required=\"\"></span><div ng-show=\"!item.description || item.description.trim() == \'\'\"><span class=\"help-block\">Campo Obrigatório</span></div></form></div></li></ul></div></div></div></div></form></li><li aria-hidden=\"true\" class=\"\"><form name=\"formServiceSituationIntegration\" id=\"formServiceSituationIntegration\" mt-validate-submit=\"vm.submitServiceSituationIntegration()\" novalidate=\"\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\" style=\"min-height: 500px; height: 500px;\"><h2 class=\"heading_a\">Comunicação Externa <span class=\"sub-heading\">Informe abaixo se você deseja compartilhar a solicitação com outros sistemas.</span></h2><br><div class=\"md-radio\"><input id=\"chkNao\" type=\"radio\" name=\"integracao\" ng-click=\"vm.showIntegrationConfigNone()\"> <label for=\"chkNao\">Não</label> <input id=\"chkEmail\" type=\"radio\" name=\"integracao\" ng-click=\"vm.showIntegrationConfigEmail()\"> <label for=\"chkEmail\">Sim, por Email</label> <input id=\"chkExterna\" type=\"radio\" name=\"integracao\" ng-click=\"vm.showIntegrationConfigExternal()\"> <label for=\"chkExterna\">Sim, por Integração Externa</label></div><div class=\"uk-grid grow-scale2\" ng-show=\"vm.service.modalSituations.communication.flagIntegrationConfigEmail\"><div class=\"uk-width-1-1\"><div class=\"uk-width-9-10\"><br><label>Email do Destinatário (separado por ponto e vírgula)</label> <input type=\"text\" maxlength=\"250\" class=\"md-input\" id=\"service_situation_to\" name=\"service_situation_to\" ng-model=\"vm.service.modalSituations.communication.to\" md-input=\"\" required=\"\"><div ng-show=\"formServiceSituationIntegration.$submitted || formServiceSituationIntegration.service_situation_to.$touched\"><span ng-show=\"formServiceSituationIntegration.service_situation_to.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><br><div class=\"uk-width-9-10\"><label>Cc (separado por ponto e vírgula)</label> <input type=\"text\" maxlength=\"250\" class=\"md-input\" id=\"service_situation_cc\" name=\"service_situation_cc\" ng-model=\"vm.service.modalSituations.communication.cc\" md-input=\"\"></div><br><div class=\"uk-width-9-10\"><br><label>Cco (separado por ponto e vírgula)</label> <input type=\"text\" maxlength=\"250\" class=\"md-input\" id=\"service_situation_cco\" name=\"service_situation_cco\" ng-model=\"vm.service.modalSituations.communication.cco\" md-input=\"\"></div><br><div class=\"uk-width-9-10\"><label>Assunto</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"service_situation_subject\" name=\"service_situation_subject\" ng-model=\"vm.service.modalSituations.communication.subject\" md-input=\"\" required=\"\"><div ng-show=\"formServiceSituationIntegration.$submitted || formServiceSituationIntegration.service_situation_subject.$touched\"><span ng-show=\"formServiceSituationIntegration.service_situation_subject.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><br><div class=\"uk-width-1-1\"><label>Mensagem</label> <textarea type=\"text\" rows=\"2\" class=\"md-input\" id=\"service_situation_body\" name=\"service_situation_body\" ng-model=\"vm.service.modalSituations.communication.body\" md-input=\"\" required=\"\"></textarea><div ng-show=\"formServiceSituationIntegration.$submitted || formServiceSituationIntegration.service_situation_body.$touched\"><span ng-show=\"formServiceSituationIntegration.service_situation_body.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-1-1\"><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.communication.includeFormOnBody\" id=\"serviceIncludeFormOnBody\" name=\"serviceIncludeFormOnBody\" class=\"switch-input-mobilecare\"> <label for=\"serviceIncludeFormOnBody\" class=\"switch-label-mobilecare\">Incluir as respostas do formulário no corpo email? <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label><br><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.communication.attachmentJson\" id=\"serviceAttachmentJson\" name=\"serviceAttachmentJson\" class=\"switch-input-mobilecare\"> <label for=\"serviceAttachmentJson\" class=\"switch-label-mobilecare\">Anexar as respostas do formulário como arquivo Json? <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label><br><input type=\"checkbox\" ng-model=\"vm.service.modalSituations.communication.attachmentXml\" id=\"serviceAttachmentXml\" name=\"serviceAttachmentXml\" class=\"switch-input-mobilecare\"> <label for=\"serviceAttachmentXml\" class=\"switch-label-mobilecare\">Anexar as respostas do formulário como arquivo XML? <span class=\"toggle--on-mobilecare\"></span> <span class=\"toggle--off-mobilecare\"></span></label></div></div></div><div class=\"uk-grid grow-scale2\" ng-show=\"vm.service.modalSituations.communication.flagIntegrationConfigExternal\"><div class=\"uk-width-1-1\"><label><b>Selecione a Integração</b><span class=\"req\">*</span></label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Selecione\" required=\"\" id=\"integrations_service_situation_filter\" name=\"integrations_service_situation_filter\" config=\"vm.selectize_config\" options=\"vm.integrations_service_situation_modal\" position=\"bottom\" ng-model=\"vm.filters.integrations_service_situationDescription\"></selectize><div ng-show=\"formServiceSituationIntegration.$submitted || formServiceSituationIntegration.integrations_service_situation_filter.$touched\" style=\"margin-top:5px;\"><span ng-show=\"formServiceSituationIntegration.integrations_service_situation_filter.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></div></div></form></li></ul></div></div></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</button> <button ng-if=\"vm.service.modalSituations.create && vm.service.modalSituations.flagCloseModalSituationOfService\" ng-click=\"vm.addEditSituationOfService(true, false)\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Adicionar Situação</button> <button ng-if=\"vm.service.modalSituations.update && vm.service.modalSituations.flagCloseModalSituationOfService\" ng-click=\"vm.addEditSituationOfService(false, true)\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Atualizar Situação</button></span></div></div></div></div><div class=\"uk-modal custom uk-open modalIcons\" id=\"modalIcons\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom\"><h3 class=\"uk-modal-title\">Icones</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-text-center uk-width-1-1\" style=\"padding-left:5px;\"><i ng-repeat=\"item in vm.iconsCategoryCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIconCategory(item)\"></i></div></div></div></div></div><div class=\"uk-modal uk-open modalIconsService\" id=\"modalIconsService\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalIconsService\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom\"><h3 class=\"uk-modal-title\">Icones</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-text-center uk-width-1-1\" style=\"padding-left:5px;\"><i ng-repeat=\"item in vm.iconsCategoryCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIconService(item)\"></i></div></div></div></div></div><div class=\"uk-modal uk-open\" id=\"modalCloneService\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">COPIAR SERVIÇO: {{vm.descriptionCloneService}}</h3></div><div class=\"uk-modal-body-custom\" style=\"min-height: 400px;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingModalCloneService\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoadingModalCloneService\" name=\"formModalCloneService\" id=\"formModalCloneService\" mt-validate-submit=\"vm.submitModalCloneService()\" novalidate=\"\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Nome do Serviço</label> <span class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"descricao\" name=\"descricao\" ng-model=\"vm.modalCloneService.description\" md-input=\"\" required=\"\"></span><div ng-show=\"formModalCloneService.$submitted || formModalCloneService.descricao.$touched\"><span ng-show=\"formModalCloneService.descricao.$error.required\" class=\"md-error\">Campo Obrigatório</span></div><span ng-show=\"vm.cloneServiceErrorDescription\" class=\"md-error\">Este serviço já existe. Informe outro nome.</span></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Categoria</label> <span class=\"md-input-wrapper2\"><selectize id=\"category_selectize_modal_clone_service\" class=\"custom_selectize\" config=\"vm.selectize_config\" options=\"vm.categories\" position=\"bottom\" ng-model=\"vm.modalCloneService.categoryId\"></selectize></span> <span ng-show=\"vm.cloneServiceErrorCategoryId\" class=\"md-error\">Campo Obrigatório.</span></div></form></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</button> <button type=\"submit\" form=\"formModalCloneService\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Salvar</button></span></div></div></div></div><div class=\"uk-modal uk-open\" id=\"modalInfoFormSituation\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\" style=\"padding:10px;\"><button type=\"button\" id=\"btnCloseModalInfoUser\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Informativo!</h3></div><div class=\"uk-modal-body-custom\">Olá, antes de adicionar um serviço, você precisa:<br><br>- Adicionar <b>Situações</b> de atendimento.<br>- Adicionar <b>Formulários</b> de atendimento.</div></div></div></div><style type=\"text/css\">\r\n    .hierarquia {\r\n        background-color:#eee !important;\r\n        cursor: not-allowed!important;\r\n    }\r\n\r\n    .mobilecare-margin-new {\r\n        margin-top: 5px !important;\r\n    }\r\n\r\n    .mobilecare-align-new {\r\n        text-align: right !important;\r\n    }\r\n\r\n    .mobilecare-situation-default {\r\n        color: #ffa000 !important;\r\n    }\r\n\r\n    .mobilecare-situation-default2 {\r\n        color: #000 !important;\r\n    }\r\n\r\n    .color-disabled-situation {\r\n        color:#ccc !important;\r\n        cursor: not-allowed !important;\r\n    }\r\n</style>");
$templateCache.put("app/configuracao/configuracao.html","<div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"uk-icon-bullhorn\"></i> Atendimento</span></li><li><span>Configurações básicas</span></li></ul></div><div id=\"page_heading\"><h1>Configurações básicas</h1></div><div id=\"page_content_inner\"><form name=\"formConfiguracao\" id=\"formConfiguracao\" mt-validate-submit=\"vm.submit(vm.configuracao)\" class=\"uk-form-stacked\" novalidate=\"\"><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-large-1-3 uk-width-medium-1-1\"><div class=\"md-card\"><div class=\"md-card-content\"><div class=\"uk-form-row\" mt-show-errors=\"\"><label for=\"settings_site_name\">Tempo de SLA (min)</label> <input class=\"md-input\" type=\"number\" id=\"sla\" name=\"sla\" ng-model=\"vm.configuracao.tempoSLA\" md-input=\"\" required=\"\"><div ng-show=\"formConfiguracao.$submitted || formConfiguracao.sla.$touched\"><span ng-show=\"formConfiguracao.sla.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></div></div><div class=\"md-fab-wrapper\"><button type=\"submit\" class=\"md-fab md-fab-primary\" id=\"page_settings_submit\"><i class=\"material-icons\">&#xE161;</i></button></div></form></div></div>");
$templateCache.put("app/dashboard.app/dashboard.app.html","<style type=\"text/css\">\r\n    .fleury-color-white {\r\n        color: #eee !important;\r\n    }\r\n\r\n    .fleury-color-default {\r\n        color: #ef025e !important;\r\n    }\r\n\r\n    .fleury-color-default2 {\r\n        color: #8A2BE2 !important;\r\n    }\r\n\r\n    .fleury-color-green {\r\n        color: #00b200 !important;\r\n    }\r\n\r\n    .md-bg-fleury {\r\n        background: #ef025e;\r\n        background: -moz-linear-gradient(-45deg, #ef025e 0%, #c90655 100%);\r\n        background: -webkit-linear-gradient(-45deg, #ef025e 0%, #c90655 100%);\r\n        background: linear-gradient(135deg, #ef025e 0%, #c90655 100%);\r\n    }\r\n</style><div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span ng-show=\"vm.appSelecionado\" style=\"display: initial !important; padding-left: 25px !important;\">&nbsp;&nbsp;<img style=\"width:25px!important;height: 25px !important\" class=\"md-user-image\" ng-src=\"data:image/png;base64,{{vm.appSelecionado.logoSecondary}}\" alt=\"\" src=\"data:image/png;base64,{{vm.appSelecionado.logoSecondary}}\"> &nbsp; {{vm.appSelecionado.name}} - {{vm.appSelecionado.name}}</span></li><li><span>Dashboard</span></li></ul></div><div id=\"page_content_inner\" style=\"padding-top: 114px !important\"><div style=\"background-color: #ccc !important\" class=\"error_page_header\"><div class=\"uk-width-8-10 uk-container-center\">Em construção!</div></div><div class=\"error_page_content\"><div class=\"uk-width-8-10 uk-container-center\"><p class=\"heading_b\">Página não encontrada</p><p class=\"uk-text-large\">A página está indisponível ou em construção!</p></div></div></div></div>");
$templateCache.put("app/dashboard.company/dashboard.company.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE871;</i><a target=\"#\">&nbsp;Endpoints</a></h1><span ng-if=\"vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.company.name}}</span> <span ng-if=\"!vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">&nbsp;</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px 30px !important;\"><div ng-show=\"!vm.isLoading\" class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-large-3-10\"><div class=\"md-card uk-margin-medium-bottom\"><div class=\"md-card-content\"><label>Pesquisar APP</label> <input type=\"text\" class=\"md-input\" id=\"app_search\" name=\"app_search\" ng-model=\"vm.filterApp\" md-input=\"\"></div></div></div></div></div><div class=\"loading-spinner\" ng-show=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-show=\"!vm.isLoading\" class=\"\"><div class=\"uk-text-center uk-margin-large-top\" ng-if=\"(!vm.applications || vm.applications.length == 0) || ((vm.applications | filter: {name: vm.filterApp}).length == 0)\"><div class=\"uk-form-row\"><i class=\"material-icons md-48\">&#xE7F3;</i><div class=\"uk-margin-top\"><h3>Nenhum aplicativo encontrado.</h3></div></div></div><div ng-if=\"vm.applications.length > 0\" class=\"uk-grid\"><div class=\"uk-width-small-5-10 uk-width-medium-3-10 uk-width-large-3-10 uk-margin-medium-bottom\" ng-repeat=\"application in vm.applications | orderBy: \'name\' | filter: {name: vm.filterApp} track by $index\"><div class=\"md-card\" ng-click=\"vm.selecionarApp(application, application.app, application.id)\" style=\"cursor: pointer;\"><div class=\"md-card-head\" style=\"background-color:{{application.appStyle.colorBase}}\"><div class=\"uk-text-center\"><img class=\"md-card-head-avatar\" ng-src=\"data:image/png;base64,{{application.logoSecondary}}\" alt=\"\"></div><h3 class=\"md-card-head-text uk-text-center md-color-white\">{{application.name}} <span>{{application.app.name}}</span></h3></div><div class=\"md-card-content\" style=\"min-height: 130px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\">&#xE55F;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\">{{application.city}}, {{application.state}}</span> <span class=\"uk-text-small uk-text-muted\">Endereço</span></div></li><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\">&#xE001;</i></div><div class=\"md-list-content\"><span ng-if=\"application.status==0\" class=\"md-list-heading\">Sem informação</span> <span ng-if=\"application.status==1\" class=\"md-list-heading\">Público</span> <span ng-if=\"application.status==2\" class=\"md-list-heading\">Pré-venda</span> <span ng-if=\"application.status==3\" class=\"md-list-heading\">Degustação</span> <span class=\"uk-text-small uk-text-muted\">Status</span></div></li></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard.geral/dashboard.geral.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xe88a;</i><a target=\"#\">&nbsp;Home Geral</a></h1><span class=\"uk-text-muted uk-text-upper uk-text-small\">Início</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\" data-uk-sortable=\"\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 30px 30px !important;\"><div class=\"uk-grid uk-text-center\" data-uk-sortable=\"\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-width-medium-large-1-2 uk-width-large-1-2 uk-width-xlarge-1-3\"><a ui-sref=\"private.painel.dashboard.main\"><div class=\"md-card md-bg-blue-grey-400 md-color-grey-50\"><div class=\"md-card-content\"><div class=\"uk-float-right uk-margin-top uk-margin-small-right\"><i class=\"uk-icon-tablet uk-icon-medium md-color-grey-50\"></i></div><span class=\"uk-text-muted uk-text-small md-color-grey-50\">Gerenciar Endpoints</span><h2 class=\"uk-margin-remove md-color-grey-50\">Endpoints</h2></div></div></a></div><div ng-if=\"vm.isUsuarioVisualizarPermitido\" class=\"uk-width-small-1-1 uk-width-medium-large-1-2 uk-width-large-1-2 uk-width-xlarge-1-3\"><a ui-sref=\"private.painel.usuario.list\"><div class=\"md-card md-bg-blue-grey-400 md-color-grey-50\"><div class=\"md-card-content\"><div class=\"uk-float-right uk-margin-top uk-margin-small-right\"><i class=\"uk-icon-group uk-icon-medium md-color-grey-50\"></i></div><span class=\"uk-text-muted uk-text-small md-color-grey-50\">Gerencie os usuários do manager</span><h2 class=\"uk-margin-remove md-color-grey-50\">Colaboradores</h2></div></div></a></div><div ng-if=\"vm.isPapelVisualizarPermitido\" class=\"uk-width-small-1-1 uk-width-medium-large-1-2 uk-width-large-1-2 uk-width-xlarge-1-3\"><a ui-sref=\"private.painel.papel.list\"><div class=\"md-card md-bg-blue-grey-400 md-color-grey-50\"><div class=\"md-card-content\"><div class=\"uk-float-right uk-margin-top uk-margin-small-right\"><i class=\"uk-icon-user-secret uk-icon-medium md-color-grey-50\"></i></div><span class=\"uk-text-muted uk-text-small md-color-grey-50\">Gerenciar perfis de acesso</span><h2 class=\"uk-margin-remove md-color-grey-50\">Perfis de Acesso</h2></div></div></a></div></div></div></div></div></div>");
$templateCache.put("app/dashboard.menu.app/dashboard.menu.app.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xe88a;</i><a target=\"#\">&nbsp;Aplicativo</a></h1><span ng-show=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}}</span> <span ng-show=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove uk-overflow-container\"><div class=\"uk-width-large-2-10 uk-width-medium-10-10 uk-width-small-10-10\"></div><div class=\"uk-width-large-6-10 uk-width-medium-10-10 uk-width-small-10-10\" style=\"padding:30px 114px 10px 114px !important\"><div ng-if=\"vm.isUsuarioVisualizarPermitido\" ui-sref=\"private.painel.cliente.list\" class=\"md-card\" style=\"cursor: pointer; margin:0 0 5px 0;\"><div class=\"md-card-content\" style=\"min-height: 80px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">&#xE8D3;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">Usuários Mobile</span> <span class=\"uk-text-small uk-text-muted\">Fluxo de usuários do aplicativo mobile.</span></div></li></ul></div></div><div ng-if=\"vm.isDashboardVisualizarPermitido || vm.isAttendanceVisualizarPermitido || vm.isRelAnaliticoVisualizarPermitido || vm.isRelSinteticoVisualizarPermitido || vm.isCategoryVisualizarPermitido ||vm.isFormRelacionamentoVisualizarPermitido || vm.isSituacaoVisualizarPermitido\" class=\"md-card\" style=\"cursor:pointer; margin:0 0 5px 0;\" onclick=\"$(\'#divRelacionamentos\').toggle(\'slow\');\"><div class=\"md-card-content\" style=\"min-height: 80px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">&#xE89C;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">Atendimento</span> <span class=\"uk-text-small uk-text-muted\">Fluxo de atendimentos do sistema.</span></div><i class=\"md-list-addon-icon mobilecare-icons\" style=\"float:right;\">&#xe945;</i></li></ul></div></div><div ng-if=\"vm.isDashboardVisualizarPermitido || vm.isAttendanceVisualizarPermitido || vm.isRelAnaliticoVisualizarPermitido || vm.isRelSinteticoVisualizarPermitido || vm.isCategoryVisualizarPermitido ||vm.isFormRelacionamentoVisualizarPermitido || vm.isSituacaoVisualizarPermitido\" id=\"divRelacionamentos\" style=\"display:none\"><div ng-if=\"vm.isDashboardVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.dashboard.relacionamento\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 20px 10px 20px; cursor:pointer; background-color:{{vm.appCompany.appStyle.colorBase}}\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff;\">&#xe99b;</i> <span class=\"uk-text-small uk-text-muted\" style=\"color: #fff !important;\">Dashboard</span></li></ul></div><div ng-if=\"vm.isAttendanceVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.attendance.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 20px 10px 20px; cursor:pointer; background-color:{{vm.appCompany.appStyle.colorBase}}\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff;\">&#xe97b;</i> <span class=\"uk-text-small uk-text-muted\" style=\"color: #fff !important;\">Solicitações</span></li></ul></div><div ng-if=\"vm.isRelAnaliticoVisualizarPermitido || vm.isRelSinteticoVisualizarPermitido\" class=\"md-card\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 20px 10px 20px; cursor:pointer; background-color:{{vm.appCompany.appStyle.colorBase}}\" onclick=\"$(\'#divRelatorios\').toggle(\'slow\');\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff;\">&#xe034;</i> <span class=\"uk-text-small uk-text-muted\" style=\"color: #fff !important;\">Relatórios</span> <i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff; float:right;\">&#xe945;</i></li></ul></div><div ng-if=\"vm.isRelAnaliticoVisualizarPermitido || vm.isRelSinteticoVisualizarPermitido\" id=\"divRelatorios\" style=\"display:none\"><div ng-if=\"vm.isRelAnaliticoVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.atendimento.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 40px 10px 40px; cursor:pointer;\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\">&#xe9df;</i> <span class=\"uk-text-small uk-text-muted\">Relatório Analítico</span></li></ul></div><div ng-if=\"vm.isRelSinteticoVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.atendimento.grouplist\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 40px 10px 40px; cursor:pointer;\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\">&#xe9df;</i> <span class=\"uk-text-small uk-text-muted\">Relatório Sintético</span></li></ul></div></div><div ng-if=\"vm.isCategoryVisualizarPermitido || vm.isFormRelacionamentoVisualizarPermitido ||vm.isSituacaoVisualizarPermitido\" class=\"md-card\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 20px 10px 20px; cursor:pointer; background-color:{{vm.appCompany.appStyle.colorBase}}\" onclick=\"$(\'#divConfiguracoes\').toggle(\'slow\');\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff;\">&#xe933;</i> <span class=\"uk-text-small uk-text-muted\" style=\"color: #fff !important;\">Configurações</span> <i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff; float:right;\">&#xe945;</i></li></ul></div><div ng-if=\"vm.isCategoryVisualizarPermitido || vm.isFormRelacionamentoVisualizarPermitido ||vm.isSituacaoVisualizarPermitido\" id=\"divConfiguracoes\" style=\"display:none\"><div ng-if=\"vm.isCategoryVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.category.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 40px 10px 40px; cursor:pointer;\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\">&#xe9df;</i> <span class=\"uk-text-small uk-text-muted\">Categorias e Serviços</span></li></ul></div><div ng-if=\"vm.isFormRelacionamentoVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.attendance.form.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 40px 10px 40px; cursor:pointer;\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\">&#xe9df;</i> <span class=\"uk-text-small uk-text-muted\">Forms de Atendimento</span></li></ul></div><div ng-if=\"vm.isSituacaoVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.situacao.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 40px 10px 40px; cursor:pointer;\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\">&#xe9df;</i> <span class=\"uk-text-small uk-text-muted\">Situações</span></li></ul></div></div></div><div ng-if=\"vm.isFormNPSVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.pesquisa.form.list\" style=\"cursor:pointer; margin:0 0 5px 0;\" onclick=\"$(\'#divNps\').toggle(\'slow\');\"><div class=\"md-card-content\" style=\"min-height: 80px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">&#xE7F2;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">Questionários</span> <span class=\"uk-text-small uk-text-muted\">Fluxo de pesquisa do sistema.</span></div></li></ul></div></div><div ng-if=\"vm.isFormColetaPermitido\" class=\"md-card\" ui-sref=\"private.painel.coleta.form.list\" style=\"cursor:pointer; margin:0 0 5px 0;\" onclick=\"$(\'#divFormsGerais\').toggle(\'slow\');\"><div class=\"md-card-content\" style=\"min-height: 80px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">&#xE85D;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">Forms de Coleta</span> <span class=\"uk-text-small uk-text-muted\">Formulários gerais do sistema.</span></div></li></ul></div></div><div ng-if=\"vm.isMensagemVisualizarPermitido || vm.isLogApiVisualizarPermitido\" class=\"md-card\" style=\"cursor:pointer; margin:0 0 5px 0;\" onclick=\"$(\'#divMensageria\').toggle(\'slow\');\"><div class=\"md-card-content\" style=\"min-height: 80px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">&#xe0c9;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">Mensageria</span> <span class=\"uk-text-small uk-text-muted\">Fluxo de mensagens do sistema.</span></div><i class=\"md-list-addon-icon mobilecare-icons\" style=\"float:right;\">&#xe945;</i></li></ul></div></div><div ng-if=\"vm.isMensagemVisualizarPermitido || vm.isLogApiVisualizarPermitido\" id=\"divMensageria\" style=\"display:none\"><div ng-if=\"vm.isMensagemVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.mensagem.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 20px 10px 20px; cursor:pointer; background-color:{{vm.appCompany.appStyle.colorBase}}\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff !important;\">&#xe93a;</i> <span class=\"uk-text-small uk-text-muted\" style=\"color: #fff !important;\">&nbsp;&nbsp;&nbsp;Mensagens</span></li></ul></div><div ng-if=\"vm.isLogApiVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.mensagemlog.list\" style=\"padding:10px 10px 10px 20px; color: #999; margin:10px 20px 10px 20px; cursor:pointer; background-color:{{vm.appCompany.appStyle.colorBase}}\"><ul><li><i class=\"md-list-addon-icon mobilecare-icons\" style=\"color: #fff !important;\">&#xe910;</i> <span class=\"uk-text-small uk-text-muted\" style=\"color: #fff !important;\">&nbsp;&nbsp;&nbsp;Log da API</span></li></ul></div></div><div ng-if=\"vm.isFormIntegracaoVisualizarPermitido\" class=\"md-card\" ui-sref=\"private.painel.integracao.form.list\" style=\"cursor:pointer; margin:0 0 5px 0;\"><div class=\"md-card-content\" style=\"min-height: 80px;\"><ul class=\"md-list md-list-addon\"><li><div class=\"md-list-addon-element\"><i class=\"md-list-addon-icon material-icons\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">&#xE8B8;</i></div><div class=\"md-list-content\"><span class=\"md-list-heading\" style=\"color: {{vm.appCompany.appStyle.colorBase}} !important\">Forms de Integração</span> <span class=\"uk-text-small uk-text-muted\">Fluxo de integrações do sistema.</span></div></li></ul></div></div></div><div class=\"uk-width-large-2-10 uk-width-medium-10-10 uk-width-small-10-10\"></div></div></div></div>");
$templateCache.put("app/dashboard.relacionamento/dashboard.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Dashboard</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions\"><span ng-if=\"vm.updateDashBoard && !vm.initializingDash\" class=\"loading-spinner\"><svg class=\"spinner\" width=\"20px\" height=\"20px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></span> <span ng-if=\"vm.updateDashBoard && !vm.initializingDash\">Atualizando Dashboard...</span> <span ng-if=\"!vm.updateDashBoard && !vm.initializingDash\">Última atualização em: <b>{{vm.ultimaAtualizacao | date:\'dd/MM/yyyy HH:mm:ss\'}} &nbsp;&nbsp;&nbsp;</b></span> <a id=\"fn-dashboard-search\" data-uk-tooltip=\"{pos:\'bottom\'}\" title=\"Pesquisar\"><i class=\"md-icon material-icons\">&#xE8B6;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">DASHBOARD <span ng-if=\"vm.DateIniHeader\">({{vm.DateIniHeader}} <span ng-if=\"vm.DateEndHeader > vm.DateIniHeader\" style=\"text-transform: none !important;\">a {{vm.DateEndHeader}})</span><span ng-if=\"vm.DateEndHeader <= vm.DateIniHeader\">)</span></span></h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-border-right uk-height-1-1\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-small-1-1\"><div id=\"dashboard-search\" class=\"md-card\" style=\"display: none; margin-top: 10px;\"><div class=\"md-card-content\"><form name=\"form\" id=\"form\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"md-card-content uk-grid\"><div class=\"uk-width-medium-5-10 uk-width-small-1-1\"><label for=\"services_name_filter\">Serviço</label><selectize placeholder=\"Todos\" id=\"services_name_filter\" name=\"services_name_filter\" config=\"vm.selectize_sources_services_config\" options=\"vm.selectize_sources_services\" position=\"bottom\" ng-model=\"vm.filters.serviceIds\"></selectize></div><div class=\"uk-width-medium-4-10 uk-width-small-1-1\"><label for=\"divPeriodoSolicitacoes\" class=\"uk-text-small\" style=\"padding-left:7px;\">Período de Solicitações</label><div class=\"bottom\" id=\"divFiltroPeriodoCadastro\"><div id=\'divPeriodoSolicitacoes\"\"\' class=\"md-card\"><div class=\"md-card-content\"><ul class=\"uk-subnav uk-subnav-pill\" data-uk-switcher=\"{connect:\'#switcher-content-a-fade\', animation: \'fade\'}\"><li><a href=\"\" ng-click=\"vm.setDefaultDate(1)\">Hoje</a></li><li class=\"uk-active\"><a href=\"\" ng-click=\"vm.setDefaultDate(2)\">Esta Semana</a></li><li><a href=\"\" ng-click=\"vm.setDefaultDate(3)\">Este Mês</a></li><li><a href=\"\" ng-click=\"vm.setDefaultDate(0)\">Customizado</a></li></ul><ul id=\"switcher-content-a-fade\" class=\"uk-switcher\"><li></li><li></li><li></li><li><br><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-large-1-2 uk-width-medium-1-1 uk-row-first\"><div class=\"uk-margin-bottom\" mtm-show-errors=\"\"><label for=\"uk_dp_start\">Data Inicial</label> <input class=\"md-input\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.DateIniSet\" ng-required=\"vm.DateIniSet\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-large-1-2 uk-width-medium-1-1\"><div class=\"uk-margin-bottom\" mtm-show-errors=\"\"><label for=\"uk_dp_end\">Data Final</label> <input class=\"md-input\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.DateEndSet\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></li></ul></div></div></div></div><div class=\"uk-width-medium-1-10 uk-width-small-1-1\" style=\"padding-left:15px\"><br><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div></div><div ng-if=\"vm.graphCount <= 0\" class=\"md-card\" style=\"margin-top: 10px !important;\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhuma solicitação foi encontrada.</span></h3></div></div><div class=\"md-card\" ng-repeat=\"x in [] | range:vm.graphCount\" ng-if=\"vm.graphCount > 0\" style=\"margin-top: 10px !important;\"><div class=\"md-card-toolbar\"><div class=\"md-card-toolbar-actions\"><card-toggle></card-toggle></div><h3 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-bold\"><i class=\"uk-icon-bar-chart uk-icon-medium\" style=\"color:{{vm.appCompany.appStyle.colorBase}} !important; padding-right:5px;\"></i> {{vm.graphServiceNames[$index]}}</span></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-2-3\"><h3 class=\"heading_c uk-margin-bottom\">Qntd. de Solicitações x Tipo de Situação / (SLA)</h3><div id=\"c3_chart_bar_stacked_{{$index}}\" class=\"c3chart\"></div></div><div class=\"uk-width-small-1-3\"><h3 class=\"heading_c uk-margin-bottom\">Qntd. de Solicitações x Situação</h3><div id=\"c3_chart_donut_{{$index}}\" class=\"c3chart\"></div></div></div></div></div><br></div></div></div></div></div></div><style type=\"text/css\">\r\n    .mobilecare-color-dark {color: #999 !important;}\r\n    .mobilecare-color-default {color: #3399ff !important;}\r\n    .mobilecare-color-green {color: #00b200 !important;}\r\n    .padding-cards {padding-top: 114px !important}\r\n    .padding-mobilecare {padding: 0 5px 5px 0;}\r\n    .grow {animation: anim-ltr 1200ms;} @keyframes anim-ltr {0% {left: 10000px;}100% {left: 0;}}\r\n    .grow-slow {animation: anim-rtl 1200ms;} @keyframes anim-rtl {0% {right: 10000px;}100% {right: 0;}}\r\n    .grow-scale {animation: anim-sc 800ms;} @keyframes anim-sc {0% {transform: scale(0);}100% {transform: scale(1);}}\r\n    .uk-subnav-pill > .uk-active > * {\r\n        background: #00a8e6;\r\n    }\r\n</style><script>\r\n    $(function(){\r\n        $(\"#fn-dashboard-search\").click(function() {\r\n            $( \"#dashboard-search\").toggle(\"slow\");\r\n        });               \r\n    });                                 \r\n</script>");
$templateCache.put("app/error/404.html","<div id=\"page_content\"><div class=\"error_page_header\" style=\"background-color: #bbb !important\"><div class=\"uk-width-8-10 uk-container-center\" style=\"background-color: #bbb !important\">404!</div></div><div class=\"error_page_content\"><div class=\"uk-width-8-10 uk-container-center\"><p class=\"heading_b\">Página não encontrada</p><p class=\"uk-text-large\">A página está indisponível ou em construção!</p></div></div></div>");
$templateCache.put("app/error/notallowedaccess.html","<div id=\"page_content\"><div class=\"error_page_header\" style=\"background-color: #bbb !important\"><div class=\"uk-width-8-10 uk-container-center\" style=\"background-color: #bbb !important\">Acesso negado!</div></div><div class=\"error_page_content\"><div class=\"uk-width-8-10 uk-container-center center\"><h1 class=\"heading_b\">Desculpe, o acesso essa página não foi liberado.</h1><p class=\"uk-text-large\">Contate o(a) administrador(a) do sistema para solicitar o acesso!</p></div></div></div>");
$templateCache.put("app/form/form.answers.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\"><a class=\"md-fab md-fab-small md-fab-primary\" ng-click=\"vm.goRoute(\'statistic\', vm.formId, vm.formName)\" title=\"Análise\"><i class=\"material-icons\">&#xE01D;</i></a></div><a class=\"md-fab md-fab-small md-fab-primary md-fab-back\" ng-click=\"vm.goRoute(\'back\', null, null)\"><i class=\"uk-icon-angle-left\"></i></a><h1 ng-if=\"vm.modulo==\'Relacionamento\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Submissões</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><h1 ng-if=\"vm.modulo==\'Integracao\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8B8;</i><a target=\"#\">&nbsp;Submissões</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><h1 ng-if=\"vm.modulo==\'Nps\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE7F2;</i> <a target=\"#\">&nbsp;Submissões</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><h1 ng-if=\"vm.modulo==\'FormGeral\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE85D;</i><a target=\"#\">&nbsp;Submissões</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><span ng-if=\"vm.modulo==\'Relacionamento\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Relacionamento</span> <span ng-if=\"vm.modulo==\'Integracao\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Integração</span> <span ng-if=\"vm.modulo==\'Nps\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Questionários</span> <span ng-if=\"vm.modulo==\'FormGeral\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Formulário de Coleta</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">FILTROS</h3></div></div></div><div class=\"uk-width-3-10 uk-overflow-container uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\" ng-click=\"vm.printListReport(\'exportableList\')\" title=\"Exportar\">&#xE8D7;</i></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">SUBMISSÕES</h3></div></div></div><div class=\"uk-width-5-10 uk-overflow-container uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><i class=\"md-icon material-icons\" id=\"invoice_print\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\" ng-click=\"vm.printDetailReport(\'exportableDetail\')\" title=\"Imprimir\">&#xE8AD;</i></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">RESPOSTAS</h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><form name=\"formSearchSubmissions\" id=\"formSearchSubmissions\" mt-validate-submit=\"vm.search(vm.filter)\" novalidate=\"\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Submissão</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1 uk-row-first\"><selectize id=\"selectize_period\" class=\"custom_selectize\" config=\"vm.selectize_config\" options=\"vm.selectize_period_options\" position=\"bottom\" ng-model=\"vm.filter.periodType\" ng-change=\"vm.changeSubmissionPeriod()\"></selectize></div><div ng-show=\"vm.showCustomPeriodSearch\" class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><i class=\"uk-input-group-icon uk-icon-calendar\"></i> <label>Início</label><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"dd/mm/yyyy\" type=\"text\" id=\"uk_dp_start\" md-input=\"\" ng-model=\"vm.filter.dateIni\" data-uk-datepicker=\"{{vm.datePickerFormat}}\"></div></div><div ng-show=\"vm.showCustomPeriodSearch\" class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><i class=\"uk-input-group-icon uk-icon-calendar\"></i> <label>Fim</label><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"dd/mm/yyyy\" type=\"text\" id=\"uk_dp_end\" md-input=\"\" ng-model=\"vm.filter.dateEnd\" data-uk-datepicker=\"{{vm.datePickerFormat}}\"></div></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"search_name\" name=\"search_name\" ng-model=\"vm.filter.username\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>E-mail</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"search_email\" name=\"searchForm\" ng-model=\"vm.filter.useremail\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light md-btn-icon waves-effect waves-button waves-light\" id=\"btnSearchForm\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div></div><br></div><div id=\"exportableList\" class=\"uk-width-3-10 uk-overflow-container uk-border-right uk-height-1-1\"><div ng-if=\"vm.loadingList\" class=\"loading-spinner\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.loadingList\" class=\"md-list-outside-wrapper page_aside_inner\"><div class=\"uk-width-medium-1-1\" ng-if=\"vm.submissionsGroup.length == 0\"><div class=\"md-card\" style=\"margin-top: 20px !important;\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhuma resposta encontrada.</span></h3></div></div></div><ul ng-if=\"vm.submissionsGroup.length > 0\" class=\"md-list md-list-custom md-list-outside md-list-custom-outside invoices_list\" ng-repeat=\"group in vm.submissionsGroup\" ng-class=\"\" id=\"invoices_list\"><li class=\"heading_list\" style=\"margin-top: 20px !important;\">{{group.referenceGroup}}</li><li ng-class=\"{\'md-list-item-active\': $parent.$index == vm.selectedIndex.split(\'|\')[0] && $index == vm.selectedIndex.split(\'|\')[1] }\" ng-repeat=\"item in group.submissions\"><a ng-click=\"vm.submissionDetail(item, $parent.$index.toString() +\'|\'+ $index.toString())\" class=\"md-list-content\" data-invoice-id=\"2\"><table width=\"100%\"><tr><td><span class=\"md-list-heading uk-text-truncate\"><b>{{item.submissionFormDate | limitTo:16 }}</b></span> <span class=\"uk-text-muted\">{{item.userName}}</span></td><td><i class=\"uk-icon-angle-right uk-icon-medium\"></i></td></tr></table></a></li></ul></div><br></div><div class=\"uk-width-5-10 uk-overflow-container uk-border-right uk-height-1-1\"><div ng-if=\"vm.loadingDetail\" class=\"loading-spinner\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.loadingDetail\" class=\"uk-grid uk-grid-collapse page_aside_inner\"><div id=\"exportableDetail\" class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1\" ng-if=\"!vm.submissonDetail\"><div class=\"md-card\" style=\"margin-top: 20px !important;\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Detalhe não disponível.</span></h3></div></div></div><div class=\"uk-width-medium-1-1\" ng-if=\"vm.submissonDetail\"><div class=\"md-card\" style=\"margin-top: 20px !important;\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><b>Informações Gerais</b></h3></div><div class=\"md-card-content\" style=\"padding: 1px !important;\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\" style=\"padding-left: 15px !important;\"><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Data de Submissão</label><div class=\"md-input-wrapper2\">{{vm.submissonDetail.submissionFormDate | limitTo: 16}}</div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\">{{vm.submissonDetail.userName}}</div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>E-mail</label><div class=\"md-input-wrapper2\">{{vm.submissonDetail.userEmail}}</div></div></div></div><br></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><b>Respostas</b></h3></div><div class=\"md-card-content\"><div class=\"uk-width-medium-1-1 uk-row-first\" style=\"padding-left: 15px !important;\"><div class=\"uk-form-row row-form\" ng-repeat=\"item in vm.submissonDetail.submissionValues\"><div ng-if=\"item.fieldType.toUpperCase() == \'SUBFORM\'\" class=\"subFormPrint\"><span class=\"md-btn disabled md-btn-block md-bg-grey-400 uk-text-bold md-color-grey-900\" href=\"javascript:void(0)\">{{item.fieldLabel.toUpperCase()}}</span></div><div ng-if=\"item.fieldType.toUpperCase() == \'TITLE\'\" class=\"titlePrint\"><span class=\"md-btn disabled md-btn-block md-bg-grey-300 uk-text-bold md-color-grey-900\" href=\"javascript:void(0)\">{{item.fieldLabel.toUpperCase()}}</span></div><div class=\"answerPrint\" ng-if=\"item.fieldType.toUpperCase() != \'IMAGE\' && item.fieldType.toUpperCase() != \'TITLE\' && item.fieldType.toUpperCase() != \'SUBFORM\'\"><label>{{item.fieldLabel}}</label><div class=\"md-input-wrapper2\"><div ng-if=\"item.fieldLabelValues.length > 0\" ng-repeat=\"answerValueLabel in item.fieldLabelValues\">{{answerValueLabel}}<br></div><div ng-if=\"(!item.fieldLabelValues || item.fieldLabelValues && item.fieldLabelValues.length <= 0) && item.fieldValue.length > 0\" ng-repeat=\"answerValue in item.fieldValue\">{{answerValue}}<br></div></div></div><div ng-if=\"item.fieldType.toUpperCase() == \'IMAGE\'\"><label>Fotos</label><div class=\"md-input-wrapper2\"><div class=\"uk-grid uk-grid-collapse\"><div ng-repeat=\"link in item.fieldValue.split(\'|\')\" class=\"gallery_grid uk-width-small-1-3 uk-width-large-1-5 galleryGrid\" style=\"padding-right: 10px !important; padding-bottom: 10px !important;\"><div class=\"md-card md-card-hover\"><div class=\"gallery_grid_item md-card-content\"><div class=\"gallery_grid_item md-card-content\"><a href=\"{{link}}\" data-uk-lightbox=\"{group:\'gallery\'}\"><img src=\"{{link}}\" alt=\"\"></a></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div><br></div></div></div></div>");
$templateCache.put("app/form/form.create.html","<script type=\"text/ng-template\" id=\"list.html\"><!--<ul dnd-list=\"list\" dnd-inserted=\"item.ruleControlId = vm.generateComponentGuidId(item)\">--> <!--a função do dnd-allowed-types é não permir inserção subform dentro de grupo de repetição ou subform dentro de subform (só um nível de profundidade)--> <ul dnd-list=\"list\" dnd-inserted=\"vm.dropCallback(event, index, item)\" dnd-allowed-types=\"item.allowedTypes\"> <li ng-repeat=\"item in list\" dnd-draggable=\"item\" dnd-type=\"item.dropType\" dnd-effect-allowed=\"move\" dnd-moved=\"list.splice($index, 1)\" dnd-selected=\"vm.models.selected = item\" ng-class=\"{selected: vm.models.selected === item}\" ng-include=\"item.draggableType + \'.html\'\"> </li> </ul></script><script type=\"text/ng-template\" id=\"container.html\"><div class=\"container-element box box-blue\" ng-click=\"vm.detailComponent(item)\" style=\"padding-bottom: 20px !important; padding-top: 20px !important\"> <h3> <i class=\"material-icons md-24 uk-margin-right\" ng-bind-html=\"item.icon\"></i> {{ item.title | limitTo: 77 }}{{item.title.length > 77 ? \'...\' : \'\'}} <div class=\"icones-acoes\" style=\"margin-bottom: 15px !important;\"> <i title=\"Copiar item\" class=\"material-icons md-24\" ng-click=\"vm.dropItemManually(item, true, true, $index);$event.stopPropagation();\">&#xE14D;</i> <i title=\"Excluir campo\" class=\"material-icons md-24\" ng-click=\"vm.removeComponent(list, $index, item.ruleControlId, item)\">&#xE872;</i> <i title=\"Esse item pode ser reordenado\" class=\"material-icons md-24\">swap_vert</i> <!--<i class=\"material-icons md-24\">chevron_right</i> --> </div> </h3> <div class=\"column\" ng-repeat=\"(key, list) in item\"> <!--verificar \'key\' do array: Resolve o problema do array desnecessário dentro do children. Antes estava ng-repeat=list in item.children--> <div ng-include=\"\'list.html\'\" ng-if=\"key == \'children\'\"> </div> </div> <div class=\"clearfix\"></div> </div></script><script type=\"text/ng-template\" id=\"item.html\"><div class=\"item\" ng-click=\"vm.detailComponent(item)\" style=\"padding-bottom: 20px !important; padding-top: 20px !important\"> <i class=\"material-icons md-24 uk-margin-right\" ng-bind-html=\"item.icon\"></i> {{ item.title | limitTo: 77 }}{{item.title.length > 77 ? \'...\' : \'\'}} <div class=\"icones-acoes\" style=\"margin-bottom: 15px !important;\"> <i title=\"Copiar item\" class=\"material-icons md-24\" ng-click=\"vm.dropItemManually(item, true, false, $index, list);$event.stopPropagation();\">&#xE14D;</i> <i title=\"Excluir campo\" class=\"material-icons md-24\" ng-click=\"vm.removeComponent(list, $index, item.ruleControlId, item)\">&#xE872;</i> <i title=\"Esse item pode ser reordenado\" class=\"material-icons md-24\">swap_vert</i> <!-- <i class=\"material-icons md-24\">chevron_right</i> --> </div> </div></script><script type=\"text/ng-template\" id=\"rpnList.html\"><ul dnd-list=\"list\" dnd-allowed-types=\"item.allowedTypes\"> <li ng-repeat=\"item in list\" dnd-draggable=\"item\" dnd-type=\"item.dropType\" dnd-effect-allowed=\"move\" dnd-moved=\"list.splice($index, 1)\" dnd-selected=\"vm.rpnModels.selected = item\" dnd-dragend=\"vm.adjustLogicalOperatorField(vm.ruleItem_form.structuredRule)\" ng-class=\"{selected: vm.rpnModels.selected === item}\" ng-include=\"item.draggableType + \'.html\'\"> </li> </ul></script><script type=\"text/ng-template\" id=\"rpnContainer.html\"><div ng-click=\"vm.rpnPropertyModalOpen(item, false, $index)\" class=\"container-element box box-blue\"> <h3> <i class=\"material-icons md-24 uk-margin-right\" ng-bind-html=\"item.icon\"></i> <span style=\"font-weight: bold;\">{{ vm.translateOps(\'logicalOperator\', item.logicalOperator) }}</span> <div class=\"icones-acoes\"> <i title=\"Copiar container\" class=\"material-icons md-24\" ng-click=\"vm.copyRpnComponent(item);$event.stopPropagation();\">&#xE14D;</i> <i title=\"Excluir container\" class=\"material-icons md-24\" ng-click=\"vm.removeRpnComponent(list, $index);$event.stopPropagation();\">&#xE872;</i> <!-- <i class=\"material-icons md-24\">swap_vert</i> --> </div> </h3> <div class=\"column\" ng-repeat=\"(key, list) in item\"> <!--verificar \'key\' do array: Resolve o problema do array desnecessário dentro do childrenN (structuredRule). Antes estava ng-repeat=list in item.structuredRule--> <div ng-include=\"\'rpnList.html\'\" ng-if=\"key == \'structuredRule\'\"> </div> </div> <div class=\"clearfix\"></div> </div></script><script type=\"text/ng-template\" id=\"rpnItem.html\"><div ng-click=\"vm.rpnPropertyModalOpen(item, true, $index)\" class=\"item\"> <i class=\"material-icons md-24 uk-margin-right\" ng-bind-html=\"item.icon\"></i> <span style=\"font-weight: bold;\">{{ vm.translateOps(\'logicalOperator\', item.logicalOperator) }}</span> <span ng-if=\"item.conditionTypeOrderLeft != \'ByExpression\'\"> {{ vm.translateOps(\'componentOrderLeft\', item.componentOrderLeft, item.conditionTypeOrderLeft) }} </span> <span ng-if=\"item.conditionTypeOrderLeft == \'ByExpression\'\"> {{ vm.translateOps(\'componentOrderLeftOperandLeft\', item.componentOrderLeftOperandLeft) }} {{item.componentOrderLeftArithmeticOperator}} {{item.componentOrderLeftOperandRight}} </span> <span style=\"font-weight: bold;\">{{ vm.translateOps(\'logicalCondition\', item.logicalCondition) }} </span> <span ng-if=\"item.conditionTypeOrderRight != \'ByExpression\'\"> {{ vm.translateOps(\'componentOrderRight\', item.componentOrderRight, item.conditionTypeOrderRight) }} </span> <span ng-if=\"item.conditionTypeOrderRight == \'ByExpression\'\"> {{ vm.translateOps(\'componentOrderRightOperandLeft\', item.componentOrderRightOperandLeft) }} {{item.componentOrderRightArithmeticOperator}} {{item.componentOrderRightOperandRight}} </span> <div class=\"icones-acoes\"> <i title=\"Copiar expressão\" class=\"material-icons md-24\" ng-click=\"vm.copyRpnComponent(item);$event.stopPropagation();\">&#xE14D;</i> <i title=\"Excluir expressão\" class=\"material-icons md-24\" ng-click=\"vm.removeRpnComponent(list, $index);$event.stopPropagation();\">&#xE872;</i> <!-- <i class=\"material-icons md-24\">swap_vert</i> --> </div> </div></script><div id=\"page_content\" class=\"\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: auto;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar edição do formulário corrente\" ng-click=\"vm.cancelForm()\"><i class=\"material-icons md-color-white\"></i></a> <label for=\"submitForm\" tabindex=\"0\" class=\"labelAsButton\" title=\"Salvar formulário e continuar a edição\"><i class=\"material-icons md-color-white\"></i></label> <label for=\"submitFormAndLeave\" tabindex=\"0\" class=\"labelAsButton\" title=\"Salvar formulário e sair\">&nbsp; <i class=\"material-icons md-color-white\">&#xE879;</i></label></div></div></div><h1 ng-if=\"vm.modulo==\'Relacionamento\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;{{vm.operation}}</a><span ng-if=\"vm.form.title\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.form.title}}</span></h1><h1 ng-if=\"vm.modulo==\'Integracao\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8B8;</i><a target=\"#\">&nbsp;{{vm.operation}}</a><span ng-if=\"vm.form.title\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.form.title}}</span></h1><h1 ng-if=\"vm.modulo==\'Nps\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE7F2;</i> <a target=\"#\">&nbsp;{{vm.operation}}</a><span ng-if=\"vm.form.title\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.form.title}}</span></h1><h1 ng-if=\"vm.modulo==\'FormGeral\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE85D;</i><a target=\"#\">&nbsp;{{vm.operation}}</a><span ng-if=\"vm.form.title\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.form.title}}</span></h1><span ng-if=\"vm.modulo==\'Relacionamento\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Formulário de Relacionamento</span> <span ng-if=\"vm.modulo==\'Integracao\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Formulário de Integração</span> <span ng-if=\"vm.modulo==\'Nps\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Questionários</span> <span ng-if=\"vm.modulo==\'FormGeral\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Formulário de Coleta</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-small-1-10 uk-width-medium-1-10 uk-width-large-2-10 uk-overflow-container uk-height-1-1 hidden-overflow-mobilecare\" style=\"padding:10px 0px 0px 0px; background: #0152A4\"><div id=\"menuColumn\"><div id=\"sourceContainer\" class=\"lista-itens-form\"><div ng-hide=\"(item.immutableTitle == \'NPS\' && vm.modulo!=\'Nps\') || (item.immutableTitle == \'Página\') || item.type == \'Observation\'\" ng-repeat=\"item in vm.models.components\" class=\"form-item-drag form-item-out ui-draggable ui-draggable-handle\" dnd-draggable=\"item\" dnd-effect-allowed=\"copy\" dnd-type=\"item.dropType\" ng-click=\"vm.dropItemManually(item)\"><i class=\"material-icons md-24 uk-margin-right\" style=\"color: rgb(255, 255, 255)\" ng-bind-html=\"item.icon\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"{{item.immutableTitle}}\"></i> <span class=\"uk-hidden-medium uk-hidden-small\">{{item.immutableTitle}}</span></div></div></div></div><div class=\"uk-width-small-5-10 uk-width-medium-5-10 uk-width-large-5-10 uk-overflow-container uk-height-1-1\" style=\"padding:10px 0px 0px 20px;\"><div id=\"middleColumn\"><div style=\"margin-top:50% !important\" class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form style=\"background: white\" ng-if=\"!vm.isLoading\" name=\"formFormData\" id=\"formFormData\" mt-validate-submit=\"vm.saveForm(vm.form)\" novalidate=\"\"><div id=\"selectedComponentsColumn\" style=\"background: white\" class=\"md-card\" auto-height=\"\" auto-height-full-height=\"true\"><div style=\"background: white\" class=\"md-card-content\"><ul class=\"uk-tab uk-tab-grid uk-margin-top\" data-uk-tab=\"{connect:\'#tabs_4\'}\"><li class=\"uk-width-1-2\"><a href=\"#\">Dados do formulário</a></li><li id=\"FieldsTab\" class=\"uk-width-1-2\"><a href=\"#\">Campos</a></li></ul><ul id=\"tabs_4\" class=\"uk-switcher uk-margin\"><li class=\"uk-margin-top\"><div ng-if=\"vm.modulo == \'Nps\' || vm.modulo == \'FormGeral\'\" class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"catForm\">Categoria do formulário *</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_category_config\" options=\"vm.selectize_category.options\" ng-model=\"vm.form.categoryId\" name=\"catForm\" id=\"catForm\" selectize=\"\" required=\"\"><div class=\"uk-margin-top\" ng-show=\"form.$submitted || form.catForm.$touched\"><span ng-show=\"form.catForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"nomeForm\">Nome do formulário *</label> <input ng-model=\"vm.form.title\" type=\"text\" ondrop=\"return false;\" id=\"nomeForm\" name=\"nomeForm\" class=\"md-input\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.nomeForm.$touched\"><span ng-show=\"form.nomeForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"shortTitle\">Nome do formulário reduzido *</label> <input ng-model=\"vm.form.shortTitle\" type=\"text\" ondrop=\"return false;\" id=\"shortTitle\" name=\"shortTitle\" class=\"md-input\" md-input=\"\" required=\"\" ng-maxlength=\"30\" maxlength=\"31\"><div ng-show=\"form.$submitted || form.shortTitle.$touched\"><span ng-show=\"form.shortTitle.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"form.shortTitle.$error.maxlength\" class=\"help-block\">O campo deve possuir no máximo 30 caracteres</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"descForm\">Descrição do formulário</label> <input ng-model=\"vm.form.description\" type=\"text\" ondrop=\"return false;\" id=\"descForm\" name=\"descForm\" class=\"md-input\" md-input=\"\"><div ng-show=\"form.$submitted || form.descForm.$touched\"><span ng-show=\"form.descForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"finalMessageForm\">Mensagem exibida para o usuário após o envio com sucesso</label> <input ng-model=\"vm.form.finalMessage\" type=\"text\" ondrop=\"return false;\" id=\"finalMessageForm\" name=\"finalMessageForm\" class=\"md-input\" md-input=\"\"><div ng-show=\"form.$submitted || form.finalMessageForm.$touched\"><span ng-show=\"form.finalMessageForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><label for=\"okButtonForm\">Botão de confirmação (Texto do botão) *</label> <input ng-model=\"vm.form.okButtonLabel\" type=\"text\" ondrop=\"return false;\" id=\"okButtonForm\" name=\"okButtonForm\" class=\"md-input\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.okButtonForm.$touched\"><span ng-show=\"form.okButtonForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1 uk-width-large-2-4 uk-row-first\"><label>Situação *</label> <span class=\"md-input-wrapper2\"><selectize id=\"selectize_publish_level\" name=\"selectize_publish_level\" class=\"custom_selectize\" required=\"\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.form.publishLevelId\"></selectize></span><div style=\"margin-top: 10px;\" ng-show=\"form.$submitted || form.selectize_publish_level.$touched\"><span ng-show=\"form.selectize_publish_level.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><br><hr><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-1\"><p><input type=\"checkbox\" name=\"screenRevision\" id=\"screenRevision\" icheck=\"\" ng-model=\"vm.form.screenRevision\"> <label for=\"screenRevision\" class=\"inline-label\">Exibir a tela para revisão dos dados preenchidos antes do envio do formulário</label></p></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-1\"><p><input type=\"checkbox\" name=\"stepsHeader\" id=\"stepsHeader\" icheck=\"\" ng-model=\"vm.form.hasStepsHeader\"> <label for=\"stepsHeader\" class=\"inline-label\">Exibir a barra de indicação dos passos no cabeçalho do formulário</label></p></div></div></div><br><br></li><li><div class=\"uk-form-row uk-margin-top\"><div class=\"md-card-toolbar-actions uk-float-right\"><a ng-click=\"vm.dropItemManually(vm.models.components[0], false, true)\" title=\"Nova página\" href=\"javascript:void(0)\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons\" style=\"color:white\">&#xE2C7;</i> Adicionar Página</a></div></div><div class=\"uk-form-row nestedDemo uk-margin-small-top\" mtm-show-errors=\"\"><div ng-repeat=\"(zone, list) in vm.form\"><div ng-if=\"zone == \'children\'\"><div class=\"dropzone box\" ng-class=\"{ \'placeholder-msg\': vm.form.children.length == 0}\"><ul dnd-list=\"list\" dnd-inserted=\"vm.dropCallback(event, index, item)\" dnd-allowed-types=\"[\'container\']\"><li ng-repeat=\"item in list\" dnd-draggable=\"item\" dnd-type=\"item.draggableType\" dnd-effect-allowed=\"move\" dnd-moved=\"list.splice($index, 1)\" dnd-selected=\"vm.models.selected = item\" ng-class=\"{selected: vm.models.selected === item}\" ng-include=\"item.draggableType + \'.html\'\"></li></ul></div></div></div></div></li></ul></div></div><div class=\"md-fab-wrapper\" style=\"display:none !important\"><div class=\"md-fab md-fab-toolbar md-fab-primary\" md-fab-toolbar=\"\"><i class=\"material-icons\">&#xE8BE;</i><div class=\"md-fab-toolbar-actions\"><button style=\"margin-top: -7px;\" id=\"submitForm\" ng-click=\"vm.saveExit = false;\" type=\"submit\" title=\"Salvar formulário e continuar a edição\"><i class=\"material-icons md-color-white\">&#xE161;</i></button> <button style=\"margin-top: -7px;\" id=\"submitFormAndLeave\" ng-click=\"vm.saveExit = true;\" type=\"submit\" title=\"Salvar formulário e sair\"><i class=\"material-icons md-color-white\">&#xE879;</i></button> <button style=\"margin-top: -7px;\" type=\"button\" ng-click=\"vm.cancelForm()\" title=\"Cancelar edição do formulário corrente\"><i class=\"material-icons md-color-white\">&#xE5C9;</i></button></div></div></div></form><div class=\"uk-modal\" id=\"modalCustomPropertiesFormConfig\"><div class=\"uk-modal-dialog uk-modal-dialog-large\"><div class=\"uk-modal-header\"><h3 class=\"uk-modal-title\">Propriedades Customizadas - {{vm.form.title}}</h3></div><form name=\"formCustomPropertiesForm\" id=\"formCustomPropertiesForm\" mt-validate-submit=\"vm.saveCustomPropertiesFormModal()\" novalidate=\"\"><div class=\"uk-grid\"><div class=\"uk-width-4-10\"><label for=\"headerKeyItemObject\">Chave</label> <input ng-model=\"vm.tempCustomPropertiesForm.key\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" md-input=\"\"></div><div class=\"uk-width-4-10\"><label for=\"headerValueItemObject\">Valor</label> <input ng-model=\"vm.tempCustomPropertiesForm.value\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" md-input=\"\"></div><div class=\"uk-width-2-10 uk-margin-top uk-text-center\"><a ng-click=\"vm.addCustomPropertiesFormCondition(vm.tempCustomPropertiesForm)\" href=\"\" class=\"md-btn\"><i class=\"material-icons md-24\">&#xE145;</i></a></div></div><div ng-hide=\"vm.checkNullObjectProperties(vm.customPropertiesFormObject)\" class=\"md-card\"><div class=\"md-card-content\"><div class=\"uk-overflow-container\"><table class=\"uk-table uk-table-striped\"><thead><tr><th>Chave</th><th>Valor</th><th>Ação</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in vm.customPropertiesFormObject\"><td>{{key}}</td><td>{{value}}</td><td><a title=\"Excluir item\" ng-click=\"vm.removeCustomPropertiesFormCondition(key)\" href=\"\" class=\"md-btn md-btn-danger\"><i class=\"material-icons md-24\" style=\"color:white\">&#xE872;</i></a></td></tr></tbody></table></div></div></div><div class=\"uk-modal-footer uk-text-right\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalCustomPropertiesFormConfig\')\" class=\"md-btn md-btn-flat uk-modal-close\">Cancelar</button> <button type=\"submit\" class=\"md-btn md-btn-flat md-btn-flat-primary\">Aplicar</button></div></form></div></div></div></div><div class=\"uk-width-small-4-10 uk-width-medium-4-10 uk-width-large-3-10 uk-overflow-container uk-height-1-1\" style=\"padding:10px 0px 0px 20px;\"><div id=\"detailColumnOutter\" ng-if=\"vm.focusedComponent\"><div id=\"detailColumn\" class=\"md-card\" style=\"background: white\" auto-height=\"\" auto-height-full-height=\"true\"><div class=\"md-card-content\" style=\"background: white\"><h3 class=\"heading_c uk-margin-medium-bottom\">Configurações do campo - <i class=\"material-icons md-24\" ng-bind-html=\"vm.focusedComponent.icon\"></i> <span class=\"uk-text-bold uk-text-muted\">{{vm.focusedComponent.immutableTitle}}</span></h3><div class=\"uk-form-row\" id=\"sharedPropertiesAlwaysVisibleTitle\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.titulos}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"labelForm\">Título</label> <input ng-model=\"vm.focusedComponent.title\" type=\"text\" ondrop=\"return false;\" id=\"labelForm\" name=\"labelForm\" class=\"md-input\" md-input=\"\"></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltip=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.identificador}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"identifierForm\">Identificador</label> <input ng-model=\"vm.focusedComponent.identifier\" type=\"text\" ondrop=\"return false;\" id=\"identifierForm\" name=\"labelForm\" class=\"md-input\" md-input=\"\"></div></div></div><div ng-hide=\"vm.focusedComponent.type==\'Title\' || vm.focusedComponent.type==\'SimpleSelect\' || vm.focusedComponent.type==\'NpsSelect\' || vm.focusedComponent.type==\'MultipleSelect\' || vm.focusedComponent.type==\'Image\' || vm.focusedComponent.type==\'Signature\' || vm.focusedComponent.type==\'Sketch\' || vm.focusedComponent.type==\'SubForm\' || vm.focusedComponent.type==\'Observation\' || vm.focusedComponent.type==\'Audio\'\" class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.resposta_inicial}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"initialanswerForm\">Resposta inicial</label> <input ng-model=\"vm.focusedComponent.initialAnswer\" type=\"text\" ondrop=\"return false;\" id=\"initialanswerForm\" name=\"labelForm\" class=\"md-input\" md-input=\"\"></div></div></div><div class=\"uk-form-row\" ng-hide=\"vm.focusedComponent.type==\'SimpleSelect\' || vm.focusedComponent.type==\'Location\' || vm.focusedComponent.type==\'NpsSelect\' || vm.focusedComponent.type==\'MultipleSelect\'\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.dica_de_texto}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"placeholderForm\">Dica de texto (placeholder)</label> <input ng-model=\"vm.focusedComponent.placeholder\" type=\"text\" ondrop=\"return false;\" id=\"placeholderForm\" name=\"labelForm\" class=\"md-input\" md-input=\"\"></div></div></div><div ng-if=\"vm.focusedComponent.type==\'FreeText\'\" class=\"uk-form-row\" id=\"freeTextSpecificProperties\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.texto_livre_tipo}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label class=\"uk-form-label\">Tipo:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_textTypeFreeTextComponent_config\" options=\"vm.selectize_textTypeFreeTextComponent.options\" ng-model=\"vm.focusedComponent.textType\" ng-change=\"vm.textTypeStateChanged(vm.focusedComponent.textType)\" name=\"textTypeForm\" id=\"textTypeForm\" selectize=\"\"></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.permitir_multiplas_linhas}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><p><input ng-disabled=\"vm.focusedComponent.textType!=\'FreeText\'\" type=\"checkbox\" name=\"allowMultipleLineForm\" id=\"allowMultipleLineForm\" icheck=\"\" ng-model=\"vm.focusedComponent.allowMultipleLine\"> <label for=\"allowMultipleLineForm\" class=\"inline-label\">Permitir múltiplas linhas</label></p></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.tamanho_maximo}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"maxLengthForm\">Tamanho máximo</label> <input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"vm.focusedComponent.maxLength\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"maxLengthForm\" name=\"maxLengthForm\" md-input=\"\"></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'SimpleSelect\' || vm.focusedComponent.type==\'NpsSelect\' || vm.focusedComponent.type==\'MultipleSelect\'\" class=\"uk-form-row\" id=\"selectsSpecificProperties\"><div ng-if=\"vm.focusedComponent.type==\'SimpleSelect\'\" class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.texto_livre_tipo}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-5-10\"><label class=\"uk-form-label\">Tipo:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_selectTypeSimpleSelectComponent_config\" options=\"vm.selectize_selectTypeSimpleSelectComponent.options\" ng-model=\"vm.focusedComponent.selectType\" name=\"textTypeForm\" id=\"textTypeForm\" selectize=\"\"></div><div class=\"uk-width-4-10 uk-width-small-10-10\" ng-if=\"vm.focusedComponent.selectType != \'YesOrNo\' && vm.focusedComponent.npsSelectType != \'YesOrNo\'\"><br><button data-uk-modal=\"{target:\'#modalOptionsConfig\',bgclose:false}\" class=\"md-btn-primary md-btn-wave waves-effect waves-button\" ng-click=\"vm.modalOptionsOpenProcess(\'requiredRuleSet\', \'Obrigatório\', vm.focusedComponent.ruleControlId)\">Editar itens da lista</button></div></div></div><div ng-if=\"vm.focusedComponent.type==\'NpsSelect\'\" class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.texto_livre_tipo}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-5-10\"><label class=\"uk-form-label\">Tipo:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_selectTypeSimpleSelectComponent_config\" options=\"vm.selectize_selectTypeSimpleSelectComponent.options\" ng-model=\"vm.focusedComponent.npsSelectType\" name=\"textTypeForm\" id=\"textTypeForm\" selectize=\"\"></div><div class=\"uk-width-4-10 uk-width-small-10-10\" ng-if=\"vm.focusedComponent.selectType != \'YesOrNo\' && vm.focusedComponent.npsSelectType != \'YesOrNo\'\"><br><button data-uk-modal=\"{target:\'#modalOptionsConfig\',bgclose:false}\" class=\"md-btn-primary md-btn-wave waves-effect waves-button\" ng-click=\"vm.modalOptionsOpenProcess(\'requiredRuleSet\', \'Obrigatório\', vm.focusedComponent.ruleControlId)\">Editar itens da lista</button></div></div></div><div ng-if=\"vm.focusedComponent.type==\'MultipleSelect\'\" class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.texto_livre_tipo}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-5-10\"><label class=\"uk-form-label\">Tipo:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_selectTypeMultipleSelectComponent_config\" options=\"vm.selectize_selectTypeMultipleSelectComponent.options\" ng-model=\"vm.focusedComponent.multipleSelectType\" name=\"textTypeForm\" id=\"textTypeForm\" selectize=\"\"></div><div class=\"uk-width-4-10 uk-width-small-10-10\" ng-if=\"vm.focusedComponent.selectType != \'YesOrNo\' && vm.focusedComponent.npsSelectType != \'YesOrNo\'\"><br><button data-uk-modal=\"{target:\'#modalOptionsConfig\',bgclose:false}\" class=\"md-btn-primary md-btn-wave waves-effect waves-button\" ng-click=\"vm.modalOptionsOpenProcess(\'requiredRuleSet\', \'Obrigatório\', vm.focusedComponent.ruleControlId)\">Editar itens da lista</button></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'Number\'\" class=\"uk-form-row\" id=\"numberSpecificProperties\"><div class=\"uk-form-row\" id=\"allOptions\" ng-show=\"vm.focusedComponent.type==\'Number\'\"><div class=\"uk-form-row\" id=\"sharedProperties\"><div class=\"uk-form-row uk-margin-remove\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.tipo_data}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-7-10\"><label class=\"uk-form-label\">Tipo Numérico</label></div></div></div><div class=\"uk-form-row uk-margin-remove\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_type_number_config\" options=\"vm.selectize_type_number.options\" ng-model=\"vm.focusedComponent.numberType\" ng-change=\"vm.visibleBehaviourStateChanged(vm.focusedComponent.numberType)\" name=\"visivelForm\" id=\"visivelForm\" selectize=\"\"></div></div></div></div></div><div ng-if=\"vm.focusedComponent.numberType==\'Decimal\'\" class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.decimal_places}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"decimalPlaces\">Casas decimais:</label> <input onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 || event.charCode == 0\" ng-model=\"vm.focusedComponent.decimalPlaces\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"decimalPlaces\" name=\"decimalPlaces\" md-input=\"\"></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'Location\'\" class=\"uk-form-row\" id=\"locationSpecificProperties\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.localizacao_obter_formulario_aberto}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label>Tipo de seleção da localização</label></div><div class=\"uk-width-1-10\">&nbsp;</div><div class=\"uk-width-9-10\"><div class=\"uk-width-medium-3-5\"><span class=\"icheck-inline\"><input type=\"radio\" name=\"radio_demo_inline\" id=\"radio_demo_inline_1\" icheck=\"\" ng-model=\"vm.focusedComponent.getOpenForm\" ng-value=\"true\"> <label for=\"radio_demo_inline_1\" class=\"inline-label\">Automática</label></span> <span class=\"icheck-inline\"><input type=\"radio\" name=\"radio_demo_inline\" id=\"radio_demo_inline_2\" icheck=\"\" ng-model=\"vm.focusedComponent.getOpenForm\" ng-init=\"vm.focusedComponent.getOpenForm = vm.focusedComponent.getOpenForm ? vm.focusedComponent.getOpenForm: false\" ng-value=\"false\" ng-checked=\"true\"> <label for=\"radio_demo_inline_2\" class=\"inline-label\">Manual</label></span></div></div></div></div><div class=\"uk-form-row\" ng-show=\"!vm.focusedComponent.getOpenForm\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.localizacao_permitir_alteracao_manual}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><p><input type=\"checkbox\" name=\"allowManualChange\" id=\"allowManualChange\" icheck=\"\" ng-model=\"vm.focusedComponent.allowManualChange\" ng-disabled=\"vm.focusedComponent.getOpenForm\"> <label for=\"allowManualChange\" class=\"inline-label\">Habilitar sugestão ao digitar o endereço</label></p></div></div></div><div class=\"uk-form-row\" ng-show=\"!vm.focusedComponent.getOpenForm\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.localizacao_usar_mapas}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><p><input type=\"checkbox\" name=\"useMaps\" id=\"useMaps\" icheck=\"\" ng-model=\"vm.focusedComponent.useMaps\" ng-disabled=\"vm.focusedComponent.getOpenForm\"> <label for=\"useMaps\" class=\"inline-label\">Habilitar seleção pelo mapa</label></p></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'Image\'\" class=\"uk-form-row\" id=\"imageSpecificProperties\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.imagem_quantidade_minima}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"MinQtdImages\">Quantidade Mínima:</label> <input ng-change=\"vm.imageMinQtdImagesStateChanged(vm.focusedComponent.minQtdImages)\" onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"vm.focusedComponent.minQtdImages\" ng-blur=\"vm.validateRange(\'minQtdImages\', \'maxQtdImages\', true)\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"MinQtdImages\" name=\"MinQtdImages\" md-input=\"\"></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.imagem_quantidade_maxima}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"MaxQtdImages\">Quantidade Máxima:</label> <input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"vm.focusedComponent.maxQtdImages\" ng-blur=\"vm.validateRange(\'minQtdImages\', \'maxQtdImages\', false)\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"MaxQtdImages\" name=\"MaxQtdImages\" md-input=\"\"></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.imagem_origem}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label class=\"uk-form-label\">Origem:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_originImageComponent_config\" options=\"vm.selectize_originImageComponent.options\" ng-model=\"vm.focusedComponent.originImage\" name=\"originImage\" id=\"originImage\" selectize=\"\"></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'Audio\'\" class=\"uk-form-row\" id=\"audioSpecificProperties\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.audio_duracao}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"AudioDuracao\">Duração máxima (min):</label> <input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"vm.focusedComponent.mediaMaxLength\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"AudioDuracao\" name=\"AudioDuracao\" md-input=\"\"></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'QrCode\'\" class=\"uk-form-row\" id=\"qrCodeSpecificProperties\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.barcode_permitir_alteracao_valor}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><p><input type=\"checkbox\" name=\"allowChangeValue\" id=\"allowChangeValue\" icheck=\"\" ng-model=\"vm.focusedComponent.allowChangeValue\"> <label for=\"allowChangeValue\" class=\"inline-label\">Permitir alteração de valor</label></p></div></div></div></div><div ng-if=\"vm.focusedComponent.type==\'SubForm\'\" class=\"uk-form-row\" id=\"subformSpecificProperties\"><div ng-if=\"vm.focusedComponent.isRepeatable\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.repeticao_minima}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"minOccurs\">Repetição mínima</label> <input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"vm.focusedComponent.minOccurs\" ng-blur=\"vm.validateRange(\'minOccurs\', \'maxOccurs\', true)\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"minOccurs\" name=\"minOccurs\" md-input=\"\"></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.repeticao_maxima}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"maxOccurs\">Repetição máxima</label> <input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-model=\"vm.focusedComponent.maxOccurs\" ng-blur=\"vm.validateRange(\'minOccurs\', \'maxOccurs\', false)\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" id=\"maxOccurs\" name=\"maxOccurs\" md-input=\"\"></div></div></div></div><div ng-if=\"!vm.focusedComponent.isRepeatable\"><div ng-if=\"vm.form.hasStepsHeader\" class=\"uk-form-row\" id=\"stepTitle\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.step_title}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><label for=\"stepTitle\">Cabeçalho da etapa</label> <input ng-model=\"vm.focusedComponent.stepTitle\" type=\"text\" ondrop=\"return false;\" id=\"stepTitle\" name=\"stepTitle\" class=\"md-input\" md-input=\"\"></div></div></div></div></div><div class=\"uk-form-row\" id=\"allOptions\"><div class=\"uk-form-row\" id=\"sharedProperties\"><div class=\"uk-form-row uk-margin-remove\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.visivel}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-7-10\"><label class=\"uk-form-label\">Visível</label> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.visibleRuleSet && vm.focusedComponent.ruleConfig.visibleRuleSet.length > 0 && vm.focusedComponent.ruleConfig.visibleBehavior == \'WhenOnly\'\" class=\"uk-badge uk-badge-muted\">{{vm.focusedComponent.ruleConfig.visibleRuleSet.length}}</span> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.visibleRuleSet && !vm.focusedComponent.ruleConfig.visibleRuleSet.length && vm.focusedComponent.ruleConfig.visibleBehavior == \'WhenOnly\'\" class=\"uk-badge uk-badge-muted\">0</span></div></div></div><div class=\"uk-form-row uk-margin-remove\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_behaviors_config\" options=\"vm.selectize_behaviors.options\" ng-model=\"vm.focusedComponent.ruleConfig.visibleBehavior\" ng-change=\"vm.visibleBehaviourStateChanged(vm.focusedComponent.ruleConfig.visibleBehavior)\" name=\"visivelForm\" id=\"visivelForm\" selectize=\"\"></div></div></div><div class=\"uk-form-row uk-margin-top\" ng-if=\"vm.focusedComponent.ruleConfig.visibleBehavior == \'WhenOnly\'\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><div style=\"overflow-y: auto;box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);\" class=\"uk-overflow-container\"><table ng-if=\"vm.focusedComponent.ruleConfig.visibleRuleSet.length > 0\" class=\"uk-table uk-table-striped\"><tbody><tr style=\"background-color: transparent !important;\" class=\"uk-table-middle\"><td style=\"background-color: transparent !important;\" colspan=\"3\" class=\"uk-width-10-10 uk-text-center\"><a style=\"width:100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'visibleRuleSet\',\'Visível\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr><tr class=\"uk-table-middle\" ng-repeat-start=\"rule in vm.focusedComponent.ruleConfig.visibleRuleSet\"><td class=\"uk-width-8-10\"><span>{{$index + 1}} -</span> {{ rule.title | limitTo: 30 }}{{rule.title.length > 30 ? \'...\' : \'\'}}</td><td class=\"uk-width-2-10 uk-text-nowrap\"><i title=\"Editar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" ng-click=\"vm.openRuleItem($event,$index,rule,\'visibleRuleSet\',\'Visível\', vm.focusedComponent.ruleControlId)\">&#xE3C9;</i> <i title=\"Copiar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.copyRuleItem(rule, \'visibleRuleSet\')\">&#xE14D;</i> <i title=\"Excluir regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.removeRuleItem(\'visibleRuleSet\',$index)\">&#xE872;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemUp($index, vm.focusedComponent.ruleConfig.visibleRuleSet)\">&#xe096;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemDown($index, vm.focusedComponent.ruleConfig.visibleRuleSet)\">&#xe097;</i></td></tr><tr class=\"uk-table-middle\" ng-repeat-end=\"\" ng-if=\"$last\"></tr></tbody></table><table ng-if=\"!vm.focusedComponent.ruleConfig.visibleRuleSet.length || vm.focusedComponent.ruleConfig.visibleRuleSet.length == 0\" class=\"uk-table\"><tbody><tr class=\"uk-table-middle\"><td class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'visibleRuleSet\',\'Visível\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr></tbody></table></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.somente_leitura}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-7-10\"><label class=\"uk-form-label\">Somente leitura</label> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.readOnlyRuleSet && vm.focusedComponent.ruleConfig.readOnlyRuleSet.length > 0 && vm.focusedComponent.ruleConfig.readOnlyBehavior == \'WhenOnly\'\" class=\"uk-badge uk-badge-muted\">{{vm.focusedComponent.ruleConfig.readOnlyRuleSet.length}}</span> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.readOnlyRuleSet && !vm.focusedComponent.ruleConfig.readOnlyRuleSet.length && vm.focusedComponent.ruleConfig.readOnlyBehavior == \'WhenOnly\'\" class=\"uk-badge uk-badge-muted\">0</span></div></div></div><div class=\"uk-form-row uk-margin-remove\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><input class=\"custom_selectize\" position=\"bottom\" ng-disabled=\"vm.focusedComponent.ruleConfig.visibleBehavior==\'Never\'\" config=\"vm.selectize_behaviors_config\" options=\"vm.selectize_behaviors.options\" ng-model=\"vm.focusedComponent.ruleConfig.readOnlyBehavior\" ng-change=\"vm.readOnlyBehaviourStateChanged(vm.focusedComponent.ruleConfig.readOnlyBehavior)\" name=\"readOnlyForm\" id=\"readOnlyForm\" selectize=\"\"></div></div></div><div class=\"uk-form-row uk-margin-top\" ng-if=\"vm.focusedComponent.ruleConfig.readOnlyBehavior == \'WhenOnly\'\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><div style=\"overflow-y: auto;box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);\" class=\"uk-overflow-container\"><table ng-if=\"vm.focusedComponent.ruleConfig.readOnlyRuleSet.length > 0\" class=\"uk-table uk-table-striped\"><tbody><tr style=\"background-color: transparent !important;\" class=\"uk-table-middle\"><td style=\"background-color: transparent !important;\" colspan=\"3\" class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'readOnlyRuleSet\',\'Somente leitura\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr><tr class=\"uk-table-middle\" ng-repeat-start=\"rule in vm.focusedComponent.ruleConfig.readOnlyRuleSet\"><td class=\"uk-width-8-10\"><span>{{$index + 1}} -</span> {{ rule.title | limitTo: 30 }}{{rule.title.length > 30 ? \'...\' : \'\'}}</td><td class=\"uk-width-2-10 uk-text-nowrap\"><i title=\"Editar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" ng-click=\"vm.openRuleItem($event,$index,rule,\'readOnlyRuleSet\',\'Somente leitura\', vm.focusedComponent.ruleControlId)\">&#xE3C9;</i> <i title=\"Copiar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.copyRuleItem(rule, \'readOnlyRuleSet\')\">&#xE14D;</i> <i title=\"Excluir regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.removeRuleItem(\'readOnlyRuleSet\',$index)\">&#xE872;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemUp($index, vm.focusedComponent.ruleConfig.readOnlyRuleSet)\">&#xe096;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemDown($index, vm.focusedComponent.ruleConfig.readOnlyRuleSet)\">&#xe097;</i></td></tr><tr class=\"uk-table-middle\" ng-repeat-end=\"\" ng-if=\"$last\"></tr></tbody></table><table ng-if=\"!vm.focusedComponent.ruleConfig.readOnlyRuleSet.length || vm.focusedComponent.ruleConfig.readOnlyRuleSet.length == 0\" class=\"uk-table\"><tbody><tr class=\"uk-table-middle\"><td class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'readOnlyRuleSet\',\'Somente leitura\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr></tbody></table></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.obrigatorio}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-7-10\"><label class=\"uk-form-label\">Obrigatório</label> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.requiredRuleSet && vm.focusedComponent.ruleConfig.requiredRuleSet.length > 0 && vm.focusedComponent.ruleConfig.requiredBehavior == \'WhenOnly\'\" class=\"uk-badge uk-badge-muted\">{{vm.focusedComponent.ruleConfig.requiredRuleSet.length}}</span> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.requiredRuleSet && !vm.focusedComponent.ruleConfig.requiredRuleSet.length && vm.focusedComponent.ruleConfig.requiredBehavior == \'WhenOnly\'\" class=\"uk-badge uk-badge-muted\">0</span></div></div></div><div class=\"uk-form-row uk-margin-remove\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><input class=\"custom_selectize\" position=\"bottom\" ng-disabled=\"vm.focusedComponent.ruleConfig.visibleBehavior==\'Never\' || vm.focusedComponent.ruleConfig.readOnlyBehavior ==\'Always\'\" config=\"vm.selectize_behaviors_config\" options=\"vm.selectize_behaviors.options\" ng-model=\"vm.focusedComponent.ruleConfig.requiredBehavior\" name=\"obrigatorioForm\" id=\"obrigatorioForm\" selectize=\"\"></div></div></div><div class=\"uk-form-row uk-margin-top\" ng-if=\"vm.focusedComponent.ruleConfig.requiredBehavior == \'WhenOnly\'\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><div style=\"overflow-y: auto;box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);\" class=\"uk-overflow-container\"><table ng-if=\"vm.focusedComponent.ruleConfig.requiredRuleSet.length > 0\" class=\"uk-table uk-table-striped\"><tbody><tr style=\"background-color: transparent !important;\" class=\"uk-table-middle\"><td style=\"background-color: transparent !important;\" colspan=\"3\" class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'requiredRuleSet\',\'Obrigatório\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr><tr class=\"uk-table-middle\" ng-repeat-start=\"rule in vm.focusedComponent.ruleConfig.requiredRuleSet\"><td class=\"uk-width-8-10\"><span>{{$index + 1}} -</span> {{ rule.title | limitTo: 30 }}{{rule.title.length > 30 ? \'...\' : \'\'}}</td><td class=\"uk-width-2-10 uk-text-nowrap\"><i title=\"Editar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" ng-click=\"vm.openRuleItem($event,$index,rule,\'requiredRuleSet\',\'Obrigatório\', vm.focusedComponent.ruleControlId)\">&#xE3C9;</i> <i title=\"Copiar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.copyRuleItem(rule, \'requiredRuleSet\')\">&#xE14D;</i> <i title=\"Excluir regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.removeRuleItem(\'requiredRuleSet\',$index)\">&#xE872;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemUp($index, vm.focusedComponent.ruleConfig.requiredRuleSet)\">&#xe096;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemDown($index, vm.focusedComponent.ruleConfig.requiredRuleSet)\">&#xe097;</i></td></tr><tr class=\"uk-table-middle\" ng-repeat-end=\"\" ng-if=\"$last\"></tr></tbody></table><table ng-if=\"!vm.focusedComponent.ruleConfig.requiredRuleSet.length || vm.focusedComponent.ruleConfig.requiredRuleSet.length == 0\" class=\"uk-table\"><tbody><tr class=\"uk-table-middle\"><td class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'requiredRuleSet\',\'Obrigatório\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr></tbody></table></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.validacao_campo}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-7-10\"><label class=\"uk-form-label\">Validação</label> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.validationRuleSet && vm.focusedComponent.ruleConfig.validationRuleSet.length > 0\" class=\"uk-badge uk-badge-muted\">{{vm.focusedComponent.ruleConfig.validationRuleSet.length}}</span> <span style=\"margin-top: -4px;\" ng-if=\"vm.focusedComponent.ruleConfig.validationRuleSet && !vm.focusedComponent.ruleConfig.validationRuleSet.length\" class=\"uk-badge uk-badge-muted\">0</span></div></div></div><div class=\"uk-form-row uk-margin-top\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"></div><div class=\"uk-width-9-10\"><div style=\"overflow-y: auto;box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);\" class=\"uk-overflow-container\"><table ng-if=\"vm.focusedComponent.ruleConfig.validationRuleSet.length > 0\" class=\"uk-table uk-table-striped\"><tbody><tr style=\"background-color: transparent !important;\" class=\"uk-table-middle\"><td style=\"background-color: transparent !important;\" colspan=\"3\" class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'validationRuleSet\',\'Validação\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr><tr class=\"uk-table-middle\" ng-repeat-start=\"rule in vm.focusedComponent.ruleConfig.validationRuleSet\"><td class=\"uk-width-8-10\"><span>{{$index + 1}} -</span> {{ rule.title | limitTo: 20 }}{{rule.title.length > 20 ? \'...\' : \'\'}}</td><td class=\"uk-width-2-10 uk-text-nowrap\"><i title=\"Editar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" ng-click=\"vm.openRuleItem($event,$index,rule,\'validationRuleSet\',\'Validação\', vm.focusedComponent.ruleControlId)\">&#xE3C9;</i> <i title=\"Copiar regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.copyRuleItem(rule, \'validationRuleSet\')\">&#xE14D;</i> <i title=\"Excluir regra\" class=\"material-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.removeRuleItem(\'validationRuleSet\',$index)\">&#xE872;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemUp($index, vm.focusedComponent.ruleConfig.validationRuleSet)\">&#xe096;</i> <i title=\"Alterar ordem\" class=\"mobilecare-icons md-24\" style=\"cursor: pointer\" ng-click=\"vm.listItemDown($index, vm.focusedComponent.ruleConfig.validationRuleSet)\">&#xe097;</i></td></tr><tr class=\"uk-table-middle\" ng-repeat-end=\"\" ng-if=\"$last\"></tr></tbody></table><table ng-if=\"!vm.focusedComponent.ruleConfig.validationRuleSet.length || vm.focusedComponent.ruleConfig.validationRuleSet.length == 0\" class=\"uk-table\"><tbody><tr class=\"uk-table-middle\"><td class=\"uk-width-10-10 uk-text-center\"><a style=\"width: 100% !important\" data-uk-modal=\"{target:\'#modalRuleConfig\',bgclose:false,modal:false}\" id=\"\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\" ng-click=\"vm.newRuleItem($event,\'validationRuleSet\',\'Validação\', vm.focusedComponent.ruleControlId)\">Adicionar regra</a></td></tr></tbody></table></div></div></div></div><div ng-if=\"vm.form.screenRevision\" class=\"uk-form-row\" id=\"showOnConfirmationFlag\"><div class=\"uk-grid\"><div class=\"uk-width-1-10\"><i tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"{{vm.tooltips.revisao_tela}}\" class=\"material-icons\">help</i></div><div class=\"uk-width-9-10\"><p><input type=\"checkbox\" name=\"showOnConfirmationFlag\" id=\"showOnConfirmationFlag\" icheck=\"\" ng-model=\"vm.focusedComponent.ruleConfig.screenRevision\"> <label for=\"showOnConfirmationFlag\" class=\"inline-label\">Exibir na revisão do formulário</label></p></div></div></div></div></div><div class=\"uk-form-row\"></div><div class=\"uk-form-row\"></div><div class=\"uk-form-row\"></div></div></div><div class=\"uk-modal custom\" id=\"modalRuleConfig\" ng-keydown=\"vm.captureKeyboardEvent($event)\" tabindex=\"0\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-large uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Condição - {{vm.focusedComponent.title}} ({{vm.modalTitle}})</h3></div><div class=\"uk-modal-body-custom\"><form name=\"formModalRuleConfig\" id=\"formModalRuleConfig\" mt-validate-submit=\"vm.saveRuleItem($event,vm.ruleItem_form)\" novalidate=\"\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-3-6\"><label for=\"RuleTitleMessage\">Título da regra *</label> <span class=\"md-input-wrapper2\"><input ng-model=\"vm.ruleItem_form.title\" type=\"text\" ondrop=\"return false;\" id=\"RuleTitleMessage\" name=\"RuleTitleMessage\" class=\"md-input-2\" md-input=\"\" required=\"\"></span><div ng-show=\"form.$submitted || form.RuleTitleMessage.$touched\"><span ng-show=\"form.RuleTitleMessage.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div ng-if=\"vm.modalTitle ==\'Obrigatório\' || vm.modalTitle ==\'Validação\'\" class=\"uk-width-3-6\"><label for=\"RuleErrorMessage\">Mensagem de validação</label> <span class=\"md-input-wrapper2\"><input ng-model=\"vm.ruleItem_form.message\" type=\"text\" ondrop=\"return false;\" id=\"RuleErrorMessage\" name=\"RuleErrorMessage\" class=\"md-input-2\" md-input=\"\"></span><div ng-show=\"form.$submitted || form.RuleErrorMessage.$touched\"><span ng-show=\"form.RuleErrorMessage.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row uk-margin-small-bottom\"><div class=\"md-card-toolbar-actions uk-float-right\"><a ng-click=\"vm.dropRpnItemManually(vm.rpnModels.components[0])\" title=\"Nova expressão\" href=\"javascript:void(0)\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons\" style=\"color:white\">&#xE24A;</i> Adicionar Expressão</a> <a ng-click=\"vm.dropRpnItemManually(vm.rpnModels.components[1])\" title=\"Novo container\" href=\"javascript:void(0)\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons\" style=\"color:white\">&#xE069;</i> Adicionar Container de Regras</a></div></div><div class=\"uk-form-row nestedDemo uk-margin-small-top\" style=\"overflow-y: auto\" mtm-show-errors=\"\"><div ng-repeat=\"(zone, list) in vm.ruleItem_form\"><div ng-if=\"zone == \'structuredRule\'\"><div class=\"dropzone box\" ng-class=\"{ \'placeholder-msg-rpn\': vm.ruleItem_form.structuredRule.length == 0}\"><div ng-include=\"\'rpnList.html\'\"></div></div></div></div></div></form></div><div class=\"uk-modal-footer-custom\"><button id=\"modalRuleConfigCloseButton\" ng-click=\"vm.closeModal(\'modalRuleConfig\')\" type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i>Cancelar</button> <button form=\"formModalRuleConfig\" type=\"submit\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i>Salvar</button></div></div></div></div><div class=\"uk-modal custom modalOptionsConfig\" id=\"modalOptionsConfig\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-large uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Editar itens da lista - {{vm.focusedComponent.title}}</h3></div><form name=\"formOptions\" id=\"formOptions\" mt-validate-submit=\"vm.saveOptionsModal()\" novalidate=\"\"><div class=\"uk-modal-body-custom\"><ul class=\"uk-tab uk-tab-grid\" data-uk-tab=\"{connect:\'#tabs_3\'}\"><li id=\"manualList\" ng-click=\"vm.selectListOptionsTab(0)\" class=\"uk-width-1-2\"><a href=\"#\">Utilizar lista manual</a></li><li id=\"connectionList\" ng-click=\"vm.selectListOptionsTab(1)\" class=\"uk-width-1-2\"><a href=\"#\">Utilizar lista por conexão</a></li></ul><ul id=\"tabs_3\" class=\"uk-switcher\"><li><div id=\"ListaManual\"><div class=\"uk-form-row\"><div class=\"md-card-toolbar-actions uk-float-right\"><button ng-show=\"vm.bulkInsert\" type=\"button\" ng-click=\"vm.cancelbulkInsertOptionsModal()\" class=\"md-btn md-btn-danger md-btn-small md-btn-wave-light waves-effect waves-button waves-light\">Cancelar inserção em lote</button> <button ng-show=\"vm.bulkInsert\" type=\"button\" ng-click=\"vm.bulkInsertOptionsModal(vm.optionsValues)\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\">Finalizar inserção em lote</button> <a ng-show=\"!vm.bulkInsert\" ng-click=\"vm.insertInLote()\" href=\"javascript:void(0)\" class=\"md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light\">Inserir em lote</a></div><span class=\"help-block\" ng-show=\"!vm.bulkInsert && vm.options.length > vm.optionsTableLimit\">Utilize o modo \"INSERIR EM LOTE\" para edição de lista acima de {{vm.optionsTableLimit}} opções. Quantidade atual: {{vm.options.length}}</span></div><div ng-show=\"!vm.bulkInsert\"><table class=\"uk-table\" cellspacing=\"0\" width=\"100%\" style=\"padding-top: 0 !important;\"><thead><tr><th>Texto</th><th>Valor</th><th class=\"uk-text-center\">Valor padrão?</th><th class=\"uk-text-center\">Ações</th></tr></thead><tbody><tr class=\"uk-table-middle\" ng-repeat=\"item in vm.options | limitTo:vm.optionsTableLimit\"><td class=\"uk-width-3-10\" style=\"padding: 0px 10px 0px 10px\"><input style=\"padding: 0px 0px !important;\" ng-model=\"item.text\" type=\"text\" name=\"formOptionsText{{$index}}\" id=\"formOptionsText{{$index}}\" ondrop=\"return false;\" class=\"md-input\" md-input=\"\"></td><td ng-if=\"vm.focusedComponent.type == \'NpsSelect\'\" class=\"uk-width-3-10\" style=\"padding: 0px 10px 10px 0px\"><input style=\"padding: 0px 0px !important;\" onkeypress=\"return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 || event.charCode == 0\" ng-model=\"item.value\" type=\"text\" name=\"formOptionsValue{{$index}}\" id=\"formOptionsValue{{$index}}\" md-input=\"\" class=\"md-input\"></td><td ng-if=\"vm.focusedComponent.type != \'NpsSelect\'\" class=\"uk-width-3-10 uk-text-center\" style=\"padding: 0px 10px 0px 10px\"><input style=\"padding: 0px 0px !important;\" ng-model=\"item.value\" type=\"text\" name=\"formOptionsValue{{$index}}\" id=\"formOptionsValue{{$index}}\" class=\"md-input\" md-input=\"\"></td><td class=\"uk-width-2-10 uk-text-nowrap uk-text-center\" style=\"padding: 0px 10px 0px 10px\"><input ng-change=\"vm.checkedOptionSelectionsStateChanged(vm.focusedComponent.type, $index, item.checked)\" type=\"checkbox\" name=\"checkOptionsItem{{$index}}\" id=\"checkOptionsItem{{$index}}\" icheck=\"\" ng-model=\"item.checked\"></td><td class=\"uk-width-2-10 uk-text-center\" style=\"padding: 0px 10px 0px 10px\"><i ng-click=\"vm.addOptionsCondition($index)\" title=\"Adicionar item\" class=\"md-icon material-icons\">&#xE145;</i> <i ng-show=\"vm.options.length > 1\" ng-click=\"vm.removeOptionsCondition($index)\" title=\"Excluir item\" class=\"md-icon material-icons\">&#xE872;</i></td></tr></tbody></table></div><div ng-show=\"vm.bulkInsert\" class=\"uk-grid uk-margin-small-top\"><div class=\"uk-width-1-1\"><div class=\"parsley-row\"><textarea placeholder=\"Copie e cole os valores no seguinte formato, separados por ponto e vírgula. Ex: texto;valor;true\" id=\"message\" class=\"md-input-2\" name=\"message\" cols=\"10\" rows=\"8\" md-input=\"\" ng-model=\"vm.optionsValues\"></textarea></div></div></div></div></li><li><div id=\"ListaConexao\" class=\"uk-overflow-container\" style=\"min-height: 350px\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-width-1-3\"><label class=\"uk-form-label\">Selecione o mapeamento da requisição</label> <span class=\"md-input-wrapper\"><input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_methodSelectsComponent_config\" options=\"vm.selectize_methodSelectsComponent.options\" ng-model=\"vm.tempExternalDataSource.path\" name=\"SelectsMethodValue\" id=\"SelectsMethodValue\" selectize=\"\" ng-required=\"vm.listOptionsType == 1\"></span><div class=\"uk-margin-top\" ng-show=\"formOptions.$submitted || formOptions.SelectsMethodValue.$touched\"><span ng-show=\"formOptions.SelectsMethodValue.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\"><div class=\"uk-width-10-10 uk-margin-bottom\"><label>Se necessário, insira os parâmetros adicionais para executar a requisição:</label></div><div class=\"uk-width-3-10\"><label for=\"parameterValue\">Parâmetro</label> <span class=\"md-input-wrapper2\"><input id=\"parameterValue\" ng-model=\"vm.tempUrlParams.key\" type=\"text\" ondrop=\"return false;\" class=\"md-input-2\" md-input=\"\"></span><div class=\"uk-margin-top\" ng-show=\"rpnPropertyForm.$submitted || rpnPropertyForm.logicalOperatorForm.$touched\"><span ng-show=\"rpnPropertyForm.logicalOperatorForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-3-10\"><label for=\"parameterType\">Tipo de Parâmetro</label> <span class=\"md-input-wrapper\"><input type=\"button\" config=\"vm.selectize_parametersTypes_config\" options=\"vm.selectize_parametersTypes.options\" ng-model=\"vm.tempUrlParams.type\" name=\"parameterType\" id=\"parameterType\" selectize=\"\" ng-required=\"vm.rpnProperty_Index > 0\"></span></div><div class=\"uk-width-3-10\" ng-if=\"vm.tempUrlParams.type == \'ByComponent\'\"><label for=\"parametersComponent\">Componente</label> <span class=\"md-input-wrapper\"><input ng-if=\"vm.tempUrlParams.type == \'ByComponent\'\" config=\"vm.selectize_components_config\" options=\"vm.selectize_components.options\" ng-model=\"vm.tempUrlParams.component\" name=\"parametersComponent\" id=\"parametersComponent\" selectize=\"\" ng-required=\"vm.tempUrlParams.type == \'ByComponent\'\"></span></div><div class=\"uk-width-3-10\" ng-if=\"vm.tempUrlParams.type == \'ByValue\' || vm.tempUrlParams.type != \'ByComponent\'\"><label for=\"tempUrlParamsValue\">Valor do parâmetro</label> <span class=\"md-input-wrapper2\"><input id=\"tempUrlParamsValue\" ng-model=\"vm.tempUrlParams.value\" type=\"text\" ng-readonly=\"vm.tempUrlParams.type != \'ByValue\'\" ondrop=\"return false;\" class=\"md-input-2\" md-input=\"\"></span></div><div class=\"uk-width-1-10 uk-text-center uk-margin-top\"><a ng-click=\"vm.addUrlParamsCondition(vm.tempUrlParams)\" href=\"\" class=\"md-fab md-fab-small md-fab-primary ng-scope\"><i class=\"material-icons md-24\">&#xE145;</i></a></div></div><div class=\"uk-form-row\" ng-show=\"vm.hasValues(vm.tempExternalDataSource.parameters[0].urlParams)\"><table class=\"uk-table uk-table-condensed\"><thead><tr><th>Chave</th><th>Valor</th><th class=\"uk-text-center\">Ação</th></tr></thead><tbody><tr class=\"uk-table-middle\" ng-repeat=\"(key, value) in vm.tempExternalDataSource.parameters[0].urlParams\"><td class=\"uk-with-4-10\">{{key}}</td><td class=\"uk-with-5-10\">{{vm.translateParamValue(value)}}</td><td class=\"uk-with-1-10 uk-text-center\"><i class=\"material-icons md-icon\" title=\"Excluir item\" ng-click=\"vm.removeUrlParamsCondition(key)\">&#xE872;</i></td></tr></tbody></table></div></div></li></ul></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalOptionsConfig\')\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</button> <button type=\"submit\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Salvar</button></span></div></form></div></div></div><div class=\"uk-modal\" id=\"modalCustomPropertiesComponentConfig\"><div class=\"uk-modal-dialog uk-modal-dialog-large\"><div class=\"uk-modal-header\"><h3 class=\"uk-modal-title\">Propriedades Customizadas - {{vm.focusedComponent.title}}</h3></div><form name=\"formCustomPropertiesComponent\" id=\"formCustomPropertiesComponent\" mt-validate-submit=\"vm.saveCustomPropertiesComponentModal()\" novalidate=\"\"><div class=\"uk-grid\"><div class=\"uk-width-4-10\"><label for=\"headerKeyItemObject\">Chave</label> <input ng-model=\"vm.tempCustomPropertiesComponent.key\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" md-input=\"\"></div><div class=\"uk-width-4-10\"><label for=\"headerValueItemObject\">Valor</label> <input ng-model=\"vm.tempCustomPropertiesComponent.value\" type=\"text\" ondrop=\"return false;\" class=\"md-input\" md-input=\"\"></div><div class=\"uk-width-2-10 uk-margin-top uk-text-center\"><a ng-click=\"vm.addCustomPropertiesComponentCondition(vm.tempCustomPropertiesComponent)\" href=\"\" class=\"md-btn\"><i class=\"material-icons md-24\">&#xE145;</i></a></div></div><div ng-hide=\"vm.checkNullObjectProperties(vm.customPropertiesComponentObject)\" class=\"md-card\"><div class=\"md-card-content\"><div class=\"uk-overflow-container\"><table class=\"uk-table uk-table-striped\"><thead><tr><th>Chave</th><th>Valor</th><th>Ação</th></tr></thead><tbody><tr ng-repeat=\"(key, value) in vm.customPropertiesComponentObject\"><td>{{key}}</td><td>{{value}}</td><td><a title=\"Excluir item\" ng-click=\"vm.removeCustomPropertiesComponentCondition(key)\" href=\"\" class=\"md-btn md-btn-danger\"><i class=\"material-icons md-24\" style=\"color:white\">&#xE872;</i></a></td></tr></tbody></table></div></div></div><div class=\"uk-modal-footer uk-text-right\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalCustomPropertiesComponentConfig\')\" class=\"md-btn md-btn-flat uk-modal-close\">Cancelar</button> <button type=\"submit\" class=\"md-btn md-btn-flat md-btn-flat-primary\">Aplicar</button></div></form></div></div><div class=\"uk-modal custom\" id=\"rpnRuleProperty\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalCategory\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"visibility:hidden\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-body-custom\" style=\"min-height: 450px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingModal\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingModal\"><form name=\"rpnPropertyForm\" id=\"rpnPropertyForm\" mt-validate-submit=\"vm.saveRpnPropertyModalModal()\" novalidate=\"\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div ng-show=\"vm.rpnProperty_Index > 0\" class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"logicalOperatorForm\">Operador lógico:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_logicalOperators_config\" options=\"vm.selectize_logicalOperators.options\" ng-model=\"vm.rpnProperty.logicalOperator\" name=\"logicalOperatorForm\" id=\"logicalOperatorForm\" selectize=\"\" ng-required=\"vm.rpnProperty_Index > 0\"><div class=\"uk-margin-top\" ng-show=\"rpnPropertyForm.$submitted || rpnPropertyForm.logicalOperatorForm.$touched\"><span ng-show=\"rpnPropertyForm.logicalOperatorForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div ng-if=\"vm.rpnProperty_IsItem\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"logicalComponentFormLeft\">Componente:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_components_config\" options=\"vm.selectize_components.options\" ng-model=\"vm.rpnProperty.componentOrderLeft\" name=\"logicalComponentFormLeft\" id=\"logicalComponentFormLeft\" selectize=\"\" required=\"\"><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.logicalComponentFormLeft.$touched\"><span ng-if=\"rpnPropertyForm.logicalComponentFormLeft.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"logicalConditionalForm\">Condição:</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_logicalConditional_config\" options=\"vm.selectize_logicalConditional.options\" ng-model=\"vm.rpnProperty.logicalCondition\" name=\"logicalConditionalForm\" ng-change=\"vm.rpnPropertyLogicalConditionalStateChanged()\" id=\"logicalConditionalForm\" selectize=\"\" required=\"\"><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.logicalConditionalForm.$touched\"><span ng-if=\"rpnPropertyForm.logicalConditionalForm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"loading-spinner\" ng-if=\"vm.reloadLogicalCondition\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.reloadLogicalCondition && !vm.isDisabled\"><label for=\"conditionTypeRight\">Tipo de condição (operando direito):</label> <input class=\"custom_selectize\" position=\"bottom\" ng-disabled=\"vm.isDisabled\" type=\"button\" config=\"vm.selectize_conditionTypes_config\" options=\"vm.selectize_conditionTypes.options\" ng-model=\"vm.rpnProperty.conditionTypeOrderRight\" name=\"conditionTypeRight\" id=\"conditionTypeRight\" selectize=\"\" required=\"\" ng-change=\"vm.rpnPropertyConditionTypeStateChanged(false)\"><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.conditionTypeRight.$touched\"><span ng-if=\"rpnPropertyForm.conditionTypeRight.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"logicalComponentFormRight\" ng-if=\"vm.rpnProperty.conditionTypeOrderRight == \'ByComponent\'\">Componente:</label> <input class=\"custom_selectize\" position=\"bottom\" ng-if=\"vm.rpnProperty.conditionTypeOrderRight == \'ByComponent\'\" config=\"vm.selectize_components_config\" options=\"vm.selectize_components.options\" ng-model=\"vm.rpnProperty.componentOrderRight\" name=\"logicalComponentFormRight\" id=\"logicalComponentFormRight\" selectize=\"\" ng-required=\"vm.rpnProperty.conditionTypeOrderRight == \'ByComponent\'\"> <label for=\"logicalComponentFormRight\" ng-if=\"vm.rpnProperty.conditionTypeOrderRight == \'ByReservedWord\'\">Palavra reservada:</label> <input class=\"custom_selectize\" position=\"bottom\" ng-if=\"vm.rpnProperty.conditionTypeOrderRight == \'ByReservedWord\'\" config=\"vm.selectize_reservedWords_config\" options=\"vm.selectize_reservedWords.options\" ng-model=\"vm.rpnProperty.componentOrderRight\" name=\"logicalComponentFormRight\" id=\"logicalComponentFormRight\" selectize=\"\" ng-required=\"vm.rpnProperty.conditionTypeOrderRight == \'ByReservedWord\'\"> <input ng-if=\"vm.rpnProperty.conditionTypeOrderRight == \'ByValue\' || vm.rpnProperty.logicalCondition == \'IsValid\'\" type=\"text\" class=\"md-input\" name=\"logicalComponentFormRight\" id=\"logicalComponentFormRight\" ng-required=\"vm.rpnProperty.logicalCondition == \'IsValid\'\" placeholder=\"Insira o valor desejado ou deixe vazio\" value=\"\" ng-model=\"vm.rpnProperty.componentOrderRight\" md-input=\"\"><div ng-if=\"vm.rpnProperty.conditionTypeOrderRight == \'ByExpression\'\" class=\"uk-grid\"><div class=\"uk-width-1-3\"><label for=\"componentOrderRightOperandLeft\">Expressão:</label> <span class=\"md-input-wrapper\"><input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_arithmeticExpressionJoined_config\" options=\"vm.selectize_arithmeticExpressionJoined.options\" ng-model=\"vm.rpnProperty.componentOrderRightOperandLeft\" name=\"componentOrderRightOperandLeft\" id=\"componentOrderRightOperandLeft\" selectize=\"\" ng-required=\"vm.rpnProperty.conditionTypeOrderRight == \'ByExpression\'\"></span><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.componentOrderRightOperandLeft.$touched\"><span ng-if=\"rpnPropertyForm.componentOrderRightOperandLeft.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-1-3\"><label for=\"co\'mponentOrderRightArithmeticOperator\">Operador:</label> <span class=\"md-input-wrapper\"><input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_arithmeticOperators_config\" options=\"vm.selectize_arithmeticOperators.options\" ng-model=\"vm.rpnProperty.componentOrderRightArithmeticOperator\" name=\"componentOrderRightArithmeticOperator\" id=\"componentOrderRightArithmeticOperator\" selectize=\"\" ng-required=\"vm.rpnProperty.conditionTypeOrderRight == \'ByExpression\'\"></span><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.componentOrderRightArithmeticOperator.$touched\"><span ng-if=\"rpnPropertyForm.componentOrderRightArithmeticOperator.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-1-3\"><label for=\"componentOrderRightOperandRight\">Valor:</label> <span class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" name=\"componentOrderRightOperandRight\" id=\"componentOrderRightOperandRight\" ng-required=\"vm.rpnProperty.conditionTypeOrderRight == \'ByExpression\'\" value=\"\" ng-model=\"vm.rpnProperty.componentOrderRightOperandRight\" md-input=\"\"></span><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.componentOrderRightOperandRight.$touched\"><span ng-if=\"rpnPropertyForm.componentOrderRightOperandRight.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-margin-top\" ng-if=\"rpnPropertyForm.$submitted || rpnPropertyForm.logicalComponentFormRight.$touched\"><span ng-if=\"rpnPropertyForm.logicalComponentFormRight.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></div></form></div></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button id=\"rpnRulePropertyCloseButton\" ng-click=\"vm.closeModal(\'rpnPropertyForm\')\" type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i>Cancelar</button> <button form=\"rpnPropertyForm\" type=\"submit\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i>Salvar</button></span></div></div></div></div><div class=\"uk-modal uk-open modalIcons\" id=\"modalIcons\" aria-hidden=\"false\" style=\"z-index: 100000; display: none; overflow-y: scroll;\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox\" style=\"padding:10px;\"><button type=\"button\" id=\"btnCloseModalIcons\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000\"></button><div class=\"uk-width-medium-1-1\"></div><div class=\"uk-width-medium-1-1\" style=\"height:400px; min-height:400px; overflow-y: scroll;\"><div class=\"md-card\"><div class=\"md-card-toolbar\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}};\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-bold uk-text-center\" style=\"font-size:16px; color:#fff;\">ÍCONES</span></h2></div><div class=\"md-card-content uk-text-center uk-width-1-1\" style=\"padding-left:5px;\"><i ng-repeat=\"item in vm.iconsCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIcon(item)\"></i></div></div></div></div></div></div><div ng-show=\"!vm.focusedComponent\"><div class=\"md-card\" auto-height=\"\" auto-height-full-height=\"true\"><div class=\"md-card-content\"><div class=\"uk-alert uk-text-center\" data-uk-alert=\"\"><span>Nenhum campo selecionado.</span></div></div></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a type=\"button\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\" ng-click=\"vm.goRoute(\'back\', null, null);\">Sim</a></div></div></div></div></div></div><style>\r\n.form-item-drag:active {\r\n    background-color: #2494d8 !important;\r\n    box-shadow: #2494d8 !important;\r\n    outline: 0;\r\n}\r\n\r\n.hidden-overflow-mobilecare {\r\n    -ms-overflow-style: none;  /* IE 10+ */\r\n    overflow: -moz-scrollbars-none;  /* Firefox */\r\n}\r\n.hidden-overflow-mobilecare::-webkit-scrollbar { \r\n    display: none;  /* Safari and Chrome */\r\n}\r\n</style>");
$templateCache.put("app/form/form.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\"><a ng-if=\"vm.layoutConfig == 2\" class=\"md-fab md-fab-small md-fab-primary\" ng-click=\"vm.goRoute(\'create\', null, null)\" title=\"Cadastrar Formulário\"><i class=\"material-icons\">&#xE145;</i></a></div><h1 ng-if=\"vm.modulo==\'Relacionamento\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Formulários de Atendimento</a></h1><h1 ng-if=\"vm.modulo==\'Integracao\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8B8;</i><a target=\"#\">&nbsp;Formulários de Integração</a></h1><h1 ng-if=\"vm.modulo==\'Nps\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE7F2;</i> <a target=\"#\">&nbsp;Questionários</a></h1><h1 ng-if=\"vm.modulo==\'FormGeral\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE85D;</i><a target=\"#\">&nbsp;Formulários de Coleta</a></h1><span class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} <span ng-if=\"vm.modulo==\'Relacionamento\'\">&raquo; Relacionamento &raquo; Configurações</span> <span ng-if=\"vm.modulo==\'Integracao\'\"></span> <span ng-if=\"vm.modulo==\'Nps\'\"></span> <span ng-if=\"vm.modulo==\'FormGeral\'\"></span></span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div ng-class=\"{1:\'uk-width-3-10 uk-overflow-container uk-border-right\', 2:\'uk-width-2-10 uk-overflow-container uk-border-right\'}[vm.layoutConfig]\"><div class=\"uk-width-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div ng-if=\"vm.layoutConfig == 1\" class=\"md-card-toolbar-actions\"><a ng-click=\"vm.openModalCategory(null, true, false, false)\" title=\"Adicionar Categoria\"><i class=\"md-icon material-icons uk-text-primary\">&#xE147;</i></a> <a id=\"open-barcontent-categories\" ng-click=\"vm.toggle(vm.getHashTagField(\'barcontent-categories\'), true)\" title=\"Pesquisar Categoria\"><i class=\"md-icon material-icons\">&#xE8B6;</i></a></div><h3 ng-if=\"vm.layoutConfig == 1\" class=\"md-card-toolbar-heading-text uk-text-primary\">CATEGORIAS</h3><h3 ng-if=\"vm.layoutConfig == 2\" class=\"md-card-toolbar-heading-text uk-text-primary\">PESQUISA</h3></div></div></div></div><div ng-class=\"{1:\'uk-width-7-10 uk-overflow-container uk-border-right\', 2:\'uk-width-8-10 uk-overflow-container uk-border-right\'}[vm.layoutConfig]\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions\"><a ng-if=\"vm.layoutConfig == 1\" ng-click=\"vm.goRoute(\'create\', null, null)\" title=\"Adicionar Formulário\"><i class=\"md-icon material-icons uk-text-primary\">&#xE147;</i></a> <a ng-if=\"vm.layoutConfig == 1\" id=\"open-barcontent-categories\" ng-click=\"vm.toggle(vm.getHashTagField(\'barcontent-form\'), true)\" title=\"Pesquisar Formulário\"><i class=\"md-icon material-icons\">&#xE8B6;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">FORMULÁRIOS <span ng-if=\"vm.forms\">({{vm.forms.length}}) Registro(s)</span></h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div ng-class=\"{1:\'uk-width-3-10 uk-overflow-container uk-border-right uk-height-1-1\', 2:\'uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\'}[vm.layoutConfig]\"><div ng-if=\"vm.layoutConfig == 1\" id=\"barcontent-categories\" class=\"md-card\" style=\"display:none;\"><div class=\"md-card-content uk-grid\"><div class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"searchCategory\" name=\"searchCategory\" ng-model=\"vm.categoryFilters.description\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-2-4 uk-row-first\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"selectize_publish_level_search\" class=\"custom_selectize\" ng-disabled=\"vm.category.detail\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.categoryFilters.publishLevelId\"></selectize></span></div><div class=\"uk-width-medium-1-1 uk-width-large-2-4 uk-row-first\"><label>Status</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"Selecione\" class=\"custom_selectize\" id=\"archived_category_filter\" name=\"archived_category_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.categoryFilters.isActive\"></selectize></span></div></div></div><div ng-if=\"vm.layoutConfig == 1\" id=\"category-list\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingCategory\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-width-1-1 uk-row-first md-card-list-wrapper\" ng-show=\"!vm.isLoadingCategory\"><div class=\"md-card\" style=\"margin: 10px !important;\" ng-if=\"(vm.categories.length == 0) || ((vm.categories | filter:vm.categoryFilters).length == 0)\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhuma categoria encontrada.</span></h3></div></div></div><div class=\"uk-width-1-1 uk-row-first md-card-list-wrapper\" ng-show=\"!vm.isLoadingCategory && (vm.categories.length != 0) && ((vm.categories | filter:vm.categoryFilters).length > 0)\"><div class=\"md-card-list uk-nestable\" style=\"margin-top:10px;\"><ul class=\"uk-nestable\" style=\"margin-top:0\"><li class=\"uk-nestable-item no-bg exact-padding\" ng-animate=\"\'animate\'\" ng-repeat=\"item in vm.categories | filter:vm.categoryFilters\" style=\"cursor: pointer !important; margin-left: {{item.marginLeft}}\"><div class=\"move uk-nestable-panel\" ng-class=\"{\'{{item.publishLevel.description.toLowerCase()}}\':item.isActive, \'arquivado\':!item.isActive, \'chamado-active\':item.isSelected, \'hierarquia\': (item.subCategories.length > 0)}\"><div class=\"md-card-list-item-menu\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\" aria-haspopup=\"true\" aria-expanded=\"false\"><a href=\"#\" class=\"md-icon material-icons\"></a><div class=\"uk-dropdown uk-dropdown-small uk-dropdown-bottom\" aria-hidden=\"true\" tabindex=\"\" style=\"min-width: 160px; top: 36px; left: -128px;\" ng-click=\"vm.selectForm(item, $index)\"><ul class=\"uk-nav\"><li ng-if=\"vm.isCategoryEditarPermitido\"><a ng-click=\"vm.openModalCategory(item, false, true, false)\"><i class=\"material-icons\"></i> Editar</a></li><li ng-if=\"vm.isCategoryDeletarPermitido && (!item.formsCount || item.formsCount == 0)\"><a ng-click=\"vm.confirmCategoryRemoval(item)\"><i class=\"material-icons\">&#xe872;</i> Excluir</a></li></ul></div></div><span class=\"md-card-list-item-date publicacao-servico uk-hidden-small uk-hidden-medium\" ng-if=\"!item.subCategories || item.subCategories.length == 0\"><span ng-show=\"!item.isActive\" class=\"uk-badge uk-badge-muted\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:0\">Arquivado</span> <span class=\"uk-badge {{item.publishLevel.description.toLowerCase()}}\" ng-click=\"vm.selectService(item, $index)\" style=\"outline:0\">{{item.publishLevel.description}}</span></span> <span ng-if=\"item.formsCount > 0\" class=\"md-card-list-item-date\" ng-click=\"vm.selectForm(item, $index)\" style=\"outline:0\"><span class=\"uk-badge uk-badge-muted\" tooltips=\"\" tooltip-side=\"bottom\" tooltip-template=\"{{item.formsCount}} Formulários(s) Cadastrados\">{{item.formsCount}}</span></span><div class=\"md-card-list-item-select\" style=\"padding:0;\"><div class=\"md-icon uk-nestable-toggle\" data-nestable-action=\"toggle\"></div></div><div class=\"md-card-list-item-avatar-wrapper\"><span class=\"md-card-list-item-avatar md-bg-grey-50\" ng-click=\"vm.selectForm(item, $index)\" style=\"outline:none\"><i class=\"mobilecare-icons\" ng-bind-html=\"item.icon\"></i></span></div><div class=\"md-card-list-item-subject\" ng-click=\"vm.selectForm(item, $index)\" style=\"outline:none\"><span>{{item.description}} {{console.dir(item.description)}}</span></div></div></li></ul></div></div></div><div ng-if=\"vm.layoutConfig == 2\" id=\"category-list\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"searchForm\" name=\"searchForm\" ng-model=\"vm.filters.description\" md-input=\"\"></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"selectize_publish_level_search_form\" class=\"custom_selectize\" ng-disabled=\"vm.form.detail\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.filters.publishLevelId\"></selectize></span></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Status</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"Selecione\" class=\"custom_selectize\" id=\"archived_form_filter\" name=\"archived_form_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.filters.active\"></selectize></span></div></div></div></div></div></div><div ng-class=\"{1:\'uk-width-7-10 uk-overflow-container uk-border-right uk-height-1-1\', 2:\'uk-width-8-10 uk-overflow-container uk-border-right uk-height-1-1\'}[vm.layoutConfig]\"><div ng-if=\"vm.layoutConfig == 1\" id=\"barcontent-form\" class=\"md-card\" style=\"display:none;\"><div class=\"md-card-content uk-grid\"><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"searchForm\" name=\"searchForm\" ng-model=\"vm.filters.description\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"selectize_publish_level_search_form\" class=\"custom_selectize\" ng-disabled=\"vm.form.detail\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.filters.publishLevelId\"></selectize></span></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-3 uk-row-first\"><div class=\"uk-form-row\"><label>Status</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"Selecione\" class=\"custom_selectize\" id=\"archived_form_filter\" name=\"archived_form_filter\" config=\"vm.selectize_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.filters.active\"></selectize></span></div></div></div></div><div id=\"form-list\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-grid uk-grid-collapse page_aside_inner\" data-uk-grid-margin=\"0\" style=\"margin-top: -13px !important;\" ng-if=\"!vm.isLoading\"><div class=\"md-card-list-wrapper uk-width-1-1\"><div class=\"uk-width-1-1 uk-container-center\"><div class=\"md-card-list\"><div class=\"md-card\" style=\"margin-top: 20px !important;\" ng-show=\"!vm.forms || (vm.forms.length == 0) || ((vm.forms | filter:vm.filters).length == 0)\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum formulário encontrado.</span></h3></div></div><ul class=\"md-list-custom uk-nestable-list md-list-custom-outside\" ng-show=\"(vm.forms.length != 0) && ((vm.forms | filter:vm.filters).length > 0)\"><li ng-repeat=\"form in vm.forms | filter: vm.filters\"><div class=\"md-card-list-item-menu uk-visible-large\"><a ng-if=\"vm.isFormSubmissionsPermitido\" ng-click=\"vm.goRoute(\'submissions\', form.rootParent, form.title)\" title=\"Respostas\"><i class=\"md-icon material-icons\">&#xE873;</i></a> <a ng-if=\"vm.isFormEstatisticaPermitido\" ng-click=\"vm.goRoute(\'statistic\', form.id, form.title)\" title=\"Estatísticas\"><i class=\"md-icon material-icons\">&#xE01D;</i></a> <a ng-if=\"vm.isFormCopiarPermitido\" title=\"Copiar\" ng-click=\"vm.openModalCopyForm(form)\"><i class=\"md-icon material-icons\">&#xE14D;</i></a> <a ng-if=\"vm.isFormEditarPermitido\" ng-click=\"vm.goRoute(\'edit\', form.id)\" title=\"Editar\"><i class=\"md-icon material-icons\">&#xE150;</i></a> <a ng-if=\"vm.isFormDeletarPermitido\" title=\"Excluir\" ng-click=\"vm.confirmRemoval(form)\"><i class=\"md-icon material-icons\">&#xE872;</i></a></div><div class=\"md-card-list-item-menu uk-visible-medium\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\"><a href=\"#\" class=\"md-icon material-icons\">&#xE5D4;</a><div class=\"uk-dropdown uk-dropdown-small\"><ul class=\"uk-nav\"><li ng-if=\"vm.isFormSubmissionsPermitido\"><a ng-click=\"vm.goRoute(\'submissions\', form.rootParent, form.title)\" title=\"Respostas\"><i class=\"material-icons\">&#xE873;</i>Submissões</a></li><li ng-if=\"vm.isFormEstatisticaPermitido\"><a ng-click=\"vm.goRoute(\'statistic\', form.id, form.title)\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\" title=\"Estatísticas\"><i class=\"material-icons\">&#xE01D;</i>Estatísticas</a></li><li ng-if=\"vm.isFormCopiarPermitido\"><a title=\"Copiar\" ng-click=\"vm.openModalCopyForm(form)\"><i class=\"material-icons\">&#xE14D;</i> Copiar</a></li><li ng-if=\"vm.isFormEditarPermitido\"><a ng-click=\"vm.goRoute(\'edit\', form.id)\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\" title=\"Editar\"><i class=\"material-icons\">&#xE150;</i>Editar</a></li><li ng-if=\"vm.isFormDeletarPermitido\"><a title=\"Excluir\" ng-click=\"vm.confirmRemoval(form)\"><i class=\"material-icons\">&#xE872;</i> Excluir</a></li></ul></div></div><span class=\"md-card-list-item-date publicacao-servico\"><span class=\"uk-badge {{form.publishLevel.description.toLowerCase()}}\" style=\"outline:0\">{{form.publishLevel.description}}</span></span> <span ng-if=\"form.active\" class=\"md-card-list-item-date\"><span class=\"uk-badge uk-badge-primary\">Ativo</span></span> <span ng-if=\"!form.active\" class=\"md-card-list-item-date\"><span class=\"uk-badge uk-badge-muted\">Arquivado</span></span><span class=\"md-card-list-item-date\">versão {{form.version}}</span><div class=\"md-card-list-item-sender\"><span class=\"uk-text-primary\">{{form.title}}</span></div><div class=\"md-card-list-item-subject\"><div class=\"md-card-list-item-sender-small\"><span class=\"ng-binding ng-scope\">{{form.title}}</span></div><span class=\"ng-binding\" style=\"line-height: 34px; font-size: 13px;\">Atualizado em {{form.dtLastUpdate}}</span></div></li></ul></div></div></div></div><br></div></div></div></div><div class=\"uk-modal custom uk-open modalIcons\" id=\"modalIcons\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Icones</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-text-center uk-width-1-1\"><i ng-repeat=\"item in vm.iconsCategoryCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIconCategory(item)\"></i></div></div></div></div></div><div class=\"uk-modal custom modalCategorias\" id=\"modalCategorias\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalCategory\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"visibility:hidden\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Categoria</h3></div><div class=\"uk-modal-body-custom\" style=\"overflow-y:unset !important;\"><form ng-if=\"!vm.isLoadingCategoryForm\" name=\"formCategory\" id=\"formCategory\" mt-validate-submit=\"vm.submitCategory(vm.category)\" novalidate=\"\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Categoria Superior</label> <span class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" ng-disabled=\"vm.category.detail\" config=\"vm.selectize_config\" options=\"vm.categoriesFather\" position=\"bottom\" ng-model=\"vm.categoryModal.parentId\"></selectize></span></div><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"vm.category.detail\" class=\"md-input-2\" id=\"descricao\" name=\"descricao\" ng-model=\"vm.categoryModal.description\" md-input=\"\" required=\"\"></div><div ng-show=\"formCategory.$submitted || formCategory.descricao.$touched\"><span ng-show=\"formCategory.descricao.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\"><div class=\"uk-width-10-10 uk-width-small-10-10\"><label>Ícone</label></div><div class=\"uk-width-1-10 uk-width-small-1-10\" style=\"width:5px !important\"><i class=\"material-icons md-user-image\" ng-if=\"!vm.categoryModal.icon\" style=\"font-size:30px; padding:5px 0 0 0;\">&#xe611;</i> <i class=\"mobilecare-icons md-user-image\" ng-if=\"vm.categoryModal.icon\" ng-bind-html=\"vm.categoryModal.icon\" style=\"font-size:30px; padding:12px 0 0 0;\"></i><br><span style=\"font-size:10px; font-style:italic; padding-left:4px;\" ng-if=\"vm.category.icon\">{{vm.category.icon.replace(\'&#x\', \'\')}}</span></div><div class=\"uk-width-9-10 uk-width-small-9-10\" style=\"padding:5px 0px 0 40px;\"><a id=\"btnAddCategoryIcon\" class=\"md-btn md-btn-flat md-btn-small md-btn-primary\" ng-disabled=\"vm.category.detail\" ng-click=\"vm.openModalCategoryIcons()\">Selecionar</a></div><div class=\"uk-width-1-1\"><input type=\"text\" ng-disabled=\"true\" class=\"md-input\" id=\"icone\" name=\"icone\" ng-model=\"vm.category.icon\" md-input=\"\" required=\"\" style=\"display:none; height:0; margin:0;\"><div ng-show=\"formCategory.$submitted || formCategory.icone.$touched\" style=\"margin-top:0\"><span ng-show=\"formCategory.icone.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"publishLevelAddCat\" name=\"publishLevelAddCat\" class=\"custom_selectize\" ng-disabled=\"vm.category.detail\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.categoryModal.publishLevelId\" required=\"\"></selectize></span><div ng-show=\"formCategory.$submitted || formCategory.publishLevelAddCat.$touched\"><span ng-show=\"formCategory.publishLevelAddCat.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\" id=\"categoryIsActive\"><div class=\"uk-width-10-10 uk-width-small-10-10\"><label>Status</label></div><div class=\"uk-width-10-10 uk-width-small-10-10\"><input type=\"checkbox\" ng-model=\"vm.categoryModal.isActive\" id=\"archiveCategory\" name=\"archiveCategory\" class=\"switch-input\" ng-disabled=\"vm.category.detail\"> <label for=\"archiveCategory\" class=\"switch-label\" ng-disabled=\"vm.category.detail\" style=\"padding: 0px 0px 0px 50px !important;\"><span ng-if=\"vm.categoryModal.isActive\">Ativa</span> <span ng-if=\"!vm.categoryModal.isActive\">Arquivada</span></label></div></div></div></div></form></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</button> <button type=\"submit\" form=\"formCategory\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\" ng-disabled=\"vm.category.detail\" id=\"btnSaveCategory\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Salvar</button></span></div></div></div></div><div class=\"uk-modal modalCopyForm\" id=\"modalCopyForm\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Cópia de formulário - {{vm.selectedCopyFormItem.title}}</h3></div><div class=\"uk-modal-body-custom\"><form name=\"formOptions\" id=\"formOptions\" mt-validate-submit=\"vm.copyForm(vm.selectedCopyFormItem, vm.selectedCopyFormItem.id, vm.copyFormOptions.appCompanyId, vm.copyFormOptions.modulo, vm.copyFormOptions.publishLevelId, vm.copyFormOptions.formNewTitle)\" novalidate=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"uk-form-row\"><label>Nome do formulário</label><div class=\"md-input-wrapper2\"><input type=\"text\" id=\"formName\" class=\"md-input-2\" ng-model=\"vm.copyFormOptions.formNewTitle\" md-input=\"\" required=\"\"></div><div class=\"uk-margin-small-top\" ng-show=\"formOptions.$submitted || formOptions.formName.$touched\"><span ng-show=\"formOptions.formName.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><h5>Informe o local e o módulo de destino para cópia do formulário:</h5><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Empresa</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"\" id=\"companies\" class=\"custom_selectize\" name=\"companies\" config=\"vm.selectize_companies_config\" options=\"vm.companies\" position=\"bottom\" ng-model=\"vm.copyFormOptions.companyKey\" ng-change=\"vm.getApplications(vm.copyFormOptions.companyKey)\" required=\"\"></selectize></span></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingApps && vm.copyFormOptions.companyKey\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><span ng-if=\"!vm.isLoadingApps\"><label>Local</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"\" id=\"apps\" class=\"custom_selectize\" name=\"apps\" config=\"vm.selectize_apps_config\" options=\"vm.applications\" position=\"bottom\" ng-model=\"vm.copyFormOptions.appCompanyId\" required=\"\"></selectize></span></span><div class=\"uk-margin-small-top\" ng-show=\"formOptions.$submitted || formOptions.apps.$touched\"><span ng-show=\"formOptions.apps.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Módulo</label> <span class=\"md-input-wrapper2\"><selectize placeholder=\"\" id=\"modulos\" class=\"custom_selectize\" name=\"modulos\" config=\"vm.selectize_companies_config\" options=\"vm.selectize_modulos\" position=\"bottom\" ng-model=\"vm.copyFormOptions.modulo\" required=\"\"></selectize></span><div class=\"uk-margin-small-top\" ng-show=\"formOptions.$submitted || formOptions.modulos.$touched\"><span ng-show=\"formOptions.modulos.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Situação</label> <span class=\"md-input-wrapper2\"><selectize id=\"publishLevel\" class=\"custom_selectize\" config=\"vm.selectize_config\" options=\"vm.selectize_publish_levels_modal\" position=\"bottom\" ng-model=\"vm.copyFormOptions.publishLevelId\" required=\"\"></selectize></span><div class=\"uk-margin-small-top\" ng-show=\"formOptions.$submitted || formOptions.publishLevel.$touched\"><span ng-show=\"formOptions.publishLevel.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></form></div><div class=\"uk-modal-footer-custom\" style=\"text-align: right !important;\"><span class=\"ng-binding uk-text-right\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\"><i class=\"material-icons md-18 md-light\" style=\"color: #fff;\">&#xE925;</i> Cancelar</button> <button type=\"submit\" form=\"formOptions\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\" id=\"btnSaveCopyForm\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Salvar</button></span></div></div></div></div></div><style type=\"text/css\">\r\n   .uk-pagination>li.uk-active>a,\r\n   .uk-pagination>li.uk-active>span {\r\n   background: #2494d8;\r\n   }\r\n\r\n   .hierarquia {\r\n        background-color:#eee !important;\r\n        cursor: not-allowed!important;\r\n    }\r\n\r\n    .mobilecare-margin-new {\r\n        margin-top: 5px !important;\r\n    }\r\n\r\n    .mobilecare-align-new {\r\n        text-align: right !important;\r\n    }\r\n\r\n    .mobilecare-situation-default {\r\n        color: #ffa000 !important;\r\n    }\r\n\r\n    .mobilecare-situation-default2 {\r\n        color: #000 !important;\r\n    }\r\n\r\n    .color-disabled-situation {\r\n        color:#ccc !important;\r\n        cursor: not-allowed !important;\r\n    }\r\n</style>");
$templateCache.put("app/form/form.statistics.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\"><a class=\"md-fab md-fab-small md-fab-primary\" ng-click=\"vm.goRoute(\'submissions\', vm.formId, vm.formName)\" title=\"Respostas\"><i class=\"material-icons\">&#xE873;</i></a></div><a class=\"md-fab md-fab-small md-fab-primary md-fab-back\" ng-click=\"vm.goRoute(\'back\', null, null)\"><i class=\"uk-icon-angle-left\"></i></a><h1 ng-if=\"vm.modulo==\'Relacionamento\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Estatísticas</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><h1 ng-if=\"vm.modulo==\'Integracao\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8B8;</i><a target=\"#\">&nbsp;Estatísticas</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><h1 ng-if=\"vm.modulo==\'Nps\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE7F2;</i> <a target=\"#\">&nbsp;Estatísticas</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><h1 ng-if=\"vm.modulo==\'FormGeral\'\"><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE85D;</i><a target=\"#\">&nbsp;Estatísticas</a><span ng-if=\"vm.formName\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.formName}}</span></h1><span ng-if=\"vm.modulo==\'Relacionamento\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Relacionamento</span> <span ng-if=\"vm.modulo==\'Integracao\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Integração</span> <span ng-if=\"vm.modulo==\'Nps\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Questionários</span> <span ng-if=\"vm.modulo==\'FormGeral\'\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Formulário de Coleta</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right\"><div class=\"uk-width-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">FILTROS</h3></div></div></div></div><div class=\"uk-width-8-10 uk-overflow-container uk-border-right\"><div class=\"uk-width-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">ANÁLISE DAS RESPOSTAS <span ng-if=\"vm.filter.dateIni || vm.filter.dateEnd\">-</span><span ng-if=\"vm.filter.dateIni && !vm.filter.dateEnd\">A partir de</span><span ng-if=\"vm.filter.dateIni\">{{vm.filter.dateIni}} <span ng-if=\"vm.filter.dateEnd\" style=\"text-transform: none !important;\">a {{vm.filter.dateEnd}}</span></span></h3></div></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><form name=\"formSearchSubmissions\" id=\"formSearchSubmissions\" mt-validate-submit=\"vm.search(vm.filter)\" novalidate=\"\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Submissão</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1 uk-row-first\"><selectize id=\"selectize_period\" class=\"custom_selectize\" config=\"vm.selectize_config\" options=\"vm.selectize_period_options\" position=\"bottom\" ng-model=\"vm.filter.periodType\" ng-change=\"vm.changeSubmissionPeriod()\"></selectize></div><div ng-show=\"vm.showCustomPeriodSearch\" class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><i class=\"uk-input-group-icon uk-icon-calendar\"></i> <label>Início</label><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"dd/mm/yyyy\" type=\"text\" id=\"uk_dp_start\" md-input=\"\" ng-model=\"vm.filter.dateIni\" data-uk-datepicker=\"{{vm.datePickerFormat}}\"></div></div><div ng-show=\"vm.showCustomPeriodSearch\" class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><i class=\"uk-input-group-icon uk-icon-calendar\"></i> <label>Fim</label><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"dd/mm/yyyy\" type=\"text\" id=\"uk_dp_end\" md-input=\"\" ng-model=\"vm.filter.dateEnd\" data-uk-datepicker=\"{{vm.datePickerFormat}}\"></div></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light md-btn-icon waves-effect waves-button waves-light\" id=\"btnSearchForm\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div></div></div><div id=\"exportableList\" class=\"uk-width-8-10 uk-overflow-container uk-border-right uk-height-1-1\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div ng-if=\"!vm.hasInfo\" class=\"uk-width-medium-1-1 uk-container-center uk-width-large-9-10 uk-width-xlarge-8-10\"><div class=\"uk-width-medium-1-1\"><div class=\"md-card\" style=\"margin-top: 20px !important;\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhuma informação encontrada.</span></h3></div></div></div></div><div ng-if=\"vm.hasInfo\" class=\"uk-width-medium-1-1 uk-container-center uk-width-large-9-10 uk-width-xlarge-8-10\"><div ng-if=\"vm.generalVisionData.answersCount > 0\" class=\"md-card\" style=\"margin-top: 20px !important;\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">VISÃO GERAL</h3></div><div class=\"md-card-content\"><div class=\"uk-width-small-1-1\"><p class=\"uk-text-bold\">Respostas: {{vm.generalVisionData.answersCount}}</p></div><div class=\"uk-width-small-1-1\"><div id=\"c3_generalVision\" class=\"c3chart\"></div></div></div></div><div ng-repeat=\"item in vm.singleChoiceData\" class=\"md-card\" style=\"margin-top: 20px !important;\" ng-if=\"!vm.isLoadingGraph\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">{{item.title.toUpperCase()}}</h3></div><div class=\"md-card-content\"><div class=\"uk-width-small-1-1\"><p class=\"uk-text-bold\">Respostas: {{item.answersCount}}</p></div><div class=\"uk-grid\"><div class=\"uk-width-small-1-2\"><div id=\"c3_simpleSelect_{{$index}}\" class=\"c3chart\"></div></div><div class=\"uk-width-small-1-2\"><div id=\"c3_pie_simpleSelect_{{$index}}\" class=\"c3chart\"></div></div></div></div></div><div ng-repeat=\"item in vm.multipleChoiceData\" class=\"md-card\" style=\"margin-top: 20px !important;\" ng-if=\"!vm.isLoadingGraph\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">{{item.title.toUpperCase()}}</h3></div><div class=\"md-card-content\"><div class=\"uk-width-small-1-1\"><p class=\"uk-text-bold\">Respostas: {{item.answersCount}}</p></div><div class=\"uk-grid\"><div class=\"uk-width-small-1-2\"><div id=\"c3_multipleSelect_{{$index}}\" class=\"c3chart\"></div></div><div class=\"uk-width-small-1-2\"><div id=\"c3_pie_multipleSelect_{{$index}}\" class=\"c3chart\"></div></div></div></div></div><div ng-repeat=\"item in vm.npsData\" class=\"md-card\" style=\"margin-top: 20px !important;\" ng-if=\"!vm.isLoadingGraph\"><div class=\"md-card-toolbar\"><div class=\"md-card-toolbar-actions\" style=\"padding-right: 5px !important;\"><span ng-if=\"item.score >= 0\" class=\"md-btn md-btn-flat md-bg-grey-900 md-color-grey-50\" style=\"padding: 0 5px !important;\">NPS SCORE &nbsp; {{item.score}}%</span> <span ng-if=\"item.score < 0\" class=\"md-btn md-btn-flat md-btn-danger md-color-grey-50\" style=\"padding: 0 5px !important;\">NPS SCORE &nbsp; {{item.score}}%</span></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">{{item.title.toUpperCase()}}</h3></div><div class=\"md-card-content\"><div class=\"uk-width-small-1-1\"><p class=\"uk-text-bold\">Respostas: {{item.answersCount}}</p></div><div class=\"uk-grid\"><div class=\"uk-width-small-1-2\"><div id=\"c3_nps_{{$index}}\" class=\"c3chart\"></div></div><div class=\"uk-width-small-1-2\"><div id=\"c3_pie_nps_{{$index}}\" class=\"c3chart\"></div></div></div></div></div><div ng-repeat=\"item in vm.freeTextData\" class=\"md-card\" style=\"margin-top: 20px !important;\" ng-if=\"!vm.isLoadingFreeText\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">{{item.title.toUpperCase()}}</h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><table id=\"tableRelatorio\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\" class=\"uk-table uk-table-nowrap table_check\" cellspacing=\"0\" width=\"100%\" style=\"padding-top: 0 !important;\"><thead><tr><th class=\"uk-width-2-10\">Data</th><th class=\"uk-width-8-10\">Resposta</th></tr></thead><tbody><tr ng-repeat=\"dataItem in item.dataTableValues\"><td>{{dataItem.split(\'|\')[0]}}</td><td>{{dataItem.split(\'|\')[1]}}</td></tr></tbody></table></div></div></div></div><div ng-repeat=\"item in vm.imageData\" class=\"md-card\" style=\"margin-top: 20px !important;\" ng-if=\"!vm.isLoadingImages\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">{{item.title.toUpperCase()}}</h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><table id=\"tableRelatorio\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\" class=\"uk-table uk-table-nowrap table_check\" cellspacing=\"0\" width=\"100%\" style=\"padding-top: 0 !important;\"><thead><tr><th class=\"uk-width-2-10\">Data</th><th class=\"uk-width-8-10\">Resposta</th></tr></thead><tbody><tr ng-repeat=\"dataItem in item.dataTableValues\" style=\"width: 35px;\"><td>{{dataItem.split(\'|\')[0]}}</td><td class=\"uk-grid uk-grid-collapse\"><div ng-repeat=\"link in dataItem.split(\'|\')\" ng-if=\"!$index == 0\" class=\"gallery_grid uk-width-small-1-10 galleryGrid\" style=\"padding-right: 10px !important; padding-bottom: 10px !important;\"><div class=\"gallery_grid_item\"><a href=\"{{link}}\" data-uk-lightbox=\"{group:\'gallery\'}\"><img src=\"{{link}}\" alt=\"\"></a></div></div></td></tr></tbody></table></div></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoadingGraph || vm.isLoadingFreeText || vm.isLoadingImages\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><br></div></div></div></div></div></div>");
$templateCache.put("app/log/log.detail.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><a ui-sref=\"private.painel.log.list\"><i class=\"material-icons\">&#xE8F4;</i> Auditoria</a></li><li><span>Detalhar</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"uk-grid\"><div class=\"uk-width-xLarge-1-1 uk-width-large-1-1 uk-width-small-1-1\"><div class=\"md-card\"><div class=\"md-card-content large-padding\"><div class=\"uk-grid uk-grid-divider uk-grid-medium\"><div class=\"uk-width-large-1-2\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Login</span></div><div class=\"uk-width-large-2-3\">{{vm.log.login}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Data de acesso</span></div><div class=\"uk-width-large-2-3\">{{vm.log.dtAcesso}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Erro</span></div><div class=\"uk-width-large-2-3\"><span class=\"uk-text-success\" ng-if=\"!vm.log.erro\">Não</span> <span class=\"uk-text-danger\" ng-if=\"vm.log.erro\">Sim</span></div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Versão do App</span></div><div class=\"uk-width-large-2-3\">{{vm.log.versaoApp}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Versão da API</span></div><div class=\"uk-width-large-2-3\">{{vm.log.versaoApi}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Uri</span></div><div class=\"uk-width-large-2-3\">{{vm.log.uri}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Método</span></div><div class=\"uk-width-large-2-3\">{{vm.log.requestMethod}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Status Code</span></div><div class=\"uk-width-large-2-3\">{{vm.log.statusCode}}</div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Azure Row Key</span></div><div class=\"uk-width-large-2-3\">{{vm.log.rowKey}}</div></div><hr class=\"uk-grid-divider uk-hidden-large\"></div><div class=\"uk-width-large-1-2\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Header</span></div><div class=\"uk-width-large-2-3\"><span class=\"uk-text-break\">{{vm.log.header}}</span></div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Request</span></div><div class=\"uk-width-large-2-3\"><span class=\"uk-text-break\">{{vm.log.jsonRequest}}</span></div></div><hr class=\"uk-grid-divider\"><div class=\"uk-grid uk-grid-small\"><div class=\"uk-width-large-1-3\"><span class=\"uk-text-muted uk-text-small\">Response</span></div><div class=\"uk-width-large-2-3\"><span class=\"uk-text-break\">{{vm.log.jsonResponse}}</span></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/log/log.list.html","<div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE8F4;</i> Auditoria</span></li></ul></div><div class=\"scrum_board_overflow page-padding-top\"><div id=\"scrum_board\" class=\"uk-clearfix\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-small-2-10\"><form style=\"height: 40em\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><i id=\"search-action-2\" class=\"uk-icon-search\"></i> <span class=\"uk-text-bold\">PESQUISA</span></span></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\" class=\"scrum_column\"><div id=\"scrum_column_todo md-card\"><div class=\"uk-text-small uk-text-muted\"><div class=\"uk-margin-bottom\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><label for=\"uk_dp_start\">Data Inicial</label> <input class=\"md-input\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtInicial\" required=\"\"></div><div class=\"uk-width-1-2\"><label for=\"hora_inicial\">Hora Inicial</label> <input ng-model=\"vm.filters.hrInicial\" type=\"text\" class=\"md-input\" id=\"hora_inicial\" name=\"hora_inicial\" md-input=\"\" data-uk-timepicker=\"\"></div></div><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-margin-bottom\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><label for=\"uk_dp_end\">Data Final</label> <input class=\"md-input\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtFim\" required=\"\"></div><div class=\"uk-width-1-2\"><label for=\"hora_fim\">Hora Final</label> <input ng-model=\"vm.filters.hrFim\" type=\"text\" class=\"md-input\" id=\"hora_fim\" name=\"hora_fim\" md-input=\"\" data-uk-timepicker=\"\"></div></div><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\"><input ng-model=\"vm.filters.erro\" type=\"text\" config=\"vm.selectize_status_config\" options=\"vm.selectize_status.options\" name=\"selectize_c\" id=\"selectize_c\" selectize=\"\"></div><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\"><input ng-model=\"vm.filters.requisicao\" type=\"text\" config=\"vm.selectize_requisicao_config\" options=\"vm.selectize_requisicao.options\" name=\"selectize_d\" id=\"selectize_d\" selectize=\"\"></div><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\"><label for=\"usuario_filter\">Login</label> <input type=\"text\" class=\"md-input\" id=\"usuario_filter\" name=\"usuario_filter\" value=\"\" ng-model=\"vm.filters.login\" md-input=\"\"></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\">Pesquisar</button></div></div></div></div></form></div><div class=\"uk-width-small-8-10\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><span class=\"uk-text-bold\">AUDITORIA</span></span></div></div></div><div class=\"scrum_column\"><div class=\"md-card\" style=\"background: white;\"><div class=\"md-card-content\"><div class=\"uk-overflow-container uk-margin-bottom\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading && !vm.logs\" class=\"uk-alert uk-text-center\" data-uk-alert=\"\"><span>Selecione os critérios de pesquisa.</span></div><table ng-if=\"!vm.isLoading && vm.logs.length >= 0\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" class=\"uk-table uk-table-nowrap\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Status</th><th class=\"uk-text-center\">Data</th><th class=\"uk-text-center\">Método</th><th class=\"uk-text-center\">Login</th><th class=\"uk-text-center\">Url</th><th class=\"uk-text-center\">Erro</th><th class=\"uk-text-center\">Ações</th></tr></thead><tfoot><tr><th class=\"uk-text-center\">Status</th><th class=\"uk-text-center\">Data</th><th class=\"uk-text-center\">Método</th><th class=\"uk-text-center\">Login</th><th class=\"uk-text-center\">Url</th><th class=\"uk-text-center\">Erro</th><th class=\"uk-text-center\">Ações</th></tr></tfoot><tbody><tr ng-repeat=\"item in vm.logs\"><td class=\"uk-text-nowrap uk-text-center\">{{item.StatusCode}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.DtAcesso}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.RequestMethod}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.Login}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.Uri.slice(43) | limitTo: 60 }}{{item.Uri.length > 60 ? \'...\' : \'\'}}</td><td class=\"uk-text-center\"><span class=\"uk-badge uk-badge-notification uk-badge-success\" ng-if=\"!item.Erro\">Não</span> <span class=\"uk-badge uk-badge-notification uk-badge-danger\" ng-if=\"item.Erro\">Sim</span></td><td class=\"uk-text-center\"><a ui-sref=\"private.painel.log.detail({id: item.RowKey})\" target=\"_blank\"><i class=\"md-icon material-icons\">&#xE8F4;</i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div ng-if=\"!vm.isLoading && vm.isUsuarioCadastrarPermitido\" class=\"md-fab-wrapper\"><a class=\"md-fab md-fab-accent\" ui-sref=\"private.painel.usuario.create\"><i class=\"material-icons\">&#xE145;</i></a></div>");
$templateCache.put("app/main/____main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><a class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</a></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"col\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{ awesomeThing.url }}\">{{ awesomeThing.url }}</a></p></div></div></div></div>");
$templateCache.put("app/login/ativacao.html","<div class=\"login_page\"><div class=\"login_page_wrapper\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-show=\"vm.isAtivacaoProcessValid && !vm.isLoading\" class=\"md-card\" id=\"login_card_disabled\"><div class=\"md-card-content large-padding\"><form name=\"form2\" class=\"form-horizontal\" role=\"form\" novalidate=\"\"><center><img src=\"assets/img/sabesp/ok.png\" style=\"outline:none; text-decoration:none;border:none;display:block;height:64px;width:64px\"><h5 class=\"uk-text-success\">Parabéns!</h5><p class=\"uk-text-success\">Ativação de conta realizada com sucesso!<br></p></center></form></div></div><div ng-show=\"!vm.isAtivacaoProcessValid && !vm.isLoading\" class=\"md-card\" id=\"login_card_disabled\"><div class=\"md-card-content large-padding\"><form name=\"form2\" class=\"form-horizontal\" role=\"form\" novalidate=\"\"><center><img src=\"assets/img/sabesp/warning.png\" style=\"outline:none; text-decoration:none;border:none;display:block;height:64px;width:64px\"><h5 class=\"uk-text-danger\">Desculpe, esse link não está mais disponível.</h5><p>Esse link está expirado e será necessário realizar uma nova solicitação de ativação de conta.<br>Qualquer dúvida, entre em contato com o administrador.<br></p></center></form></div></div></div></div>");
$templateCache.put("app/login/esqueceusenha.html","<div class=\"login_page\" style=\"background-color:#e7e7e7;\"><div class=\"login_page_wrapper\" custom-height=\"\" custom-height-value=\"20\"><div class=\"md-card\" id=\"login_card\"><div ng-if=\"vm.op == \'recuperarSenha\'\" class=\"md-card-content large-padding\" id=\"login_form\"><h2 class=\"heading_a uk-margin-medium-bottom\">Esqueceu sua senha?</h2><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" class=\"form-horizontal\" role=\"form\" novalidate=\"\" mt-validate-submit=\"vm.submit(vm.user)\"><div class=\"uk-form-row\" mt-show-errors=\"\"><div class=\"uk-form-row\"><h5 class=\"\">Insira seu e-mail</h5><input class=\"md-input\" type=\"email\" id=\"login_username\" ng-model=\"vm.user.email\" name=\"username\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.username.$touched\"><span ng-show=\"form.username.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"form.username.$error.Email\" class=\"md-error\">E-mail inválido</span></div></div><p class=\"uk-text-small uk-text-muted\">Primeiro, tente o mais simples: se você lembra sua senha, mas ela não está funcionando, certifique-se de que a tecla Caps Lock está desligada, e que seu login está escrito corretamente, então tente novamente.</p><div class=\"uk-margin-medium-top\"><button class=\"md-btn md-btn-primary md-btn-block md-btn-large\" type=\"submit\">Enviar</button></div></form></div><div ng-if=\"vm.op == \'recuperarLogin\'\" class=\"md-card-content large-padding\" id=\"login_form\"><h2 class=\"heading_a uk-margin-medium-bottom\">Esqueceu seu login?</h2><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" class=\"form-horizontal\" role=\"form\" novalidate=\"\" mt-validate-submit=\"vm.submit(vm.user)\"><div class=\"uk-form-row\" mt-show-errors=\"\"><h5 class=\"\">Insira seu nome</h5><input class=\"md-input\" type=\"text\" id=\"login_username\" ng-model=\"vm.user.name\" name=\"login_username\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.login_username.$touched\"><span ng-show=\"form.login_username.$error.required\" class=\"md-error\">Campo Obrigatório</span></div><div class=\"uk-form-row uk-margin-top\" mt-show-errors=\"\"><h5 class=\"\">Insira o número do documento</h5><input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" class=\"md-input\" type=\"text\" id=\"doc_username\" ng-model=\"vm.user.documentNumber\" name=\"doc_username\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.doc_username.$touched\"><span ng-show=\"form.doc_username.$error.required\" class=\"md-error\">Campo Obrigatório</span></div><div class=\"uk-form-row uk-margin-top\" mt-show-errors=\"\"><h5 class=\"\">Insira sua data de nascimento</h5><input class=\"md-input\" type=\"date\" id=\"date_username\" ng-model=\"vm.user.birthDate\" name=\"date_username\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.date_username.$touched\"><span ng-show=\"form.date_username.$error.required\" class=\"md-error\">Campo Obrigatório</span></div><div class=\"uk-margin-medium-top\"><button class=\"md-btn md-btn-primary md-btn-block md-btn-large\" type=\"submit\">Enviar</button></div></form></div></div><div class=\"uk-margin-top uk-text-center\"><a ui-sref=\"public.login\" id=\"signup_form_show\" style=\"color:white !important\">Voltar</a></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"uk-cover-background login_page\"><div class=\"login_page_wrapper\" custom-height=\"\" custom-height-value=\"20\"><div class=\"md-card\" id=\"login_card\"><div class=\"md-card-content large-padding\" id=\"login_form\"><div class=\"login_heading\"><div class=\"user_avatar\"></div></div><form name=\"form\" class=\"form-horizontal\" role=\"form\" novalidate=\"\" mt-validate-submit=\"vm.submit(vm.user)\"><div class=\"uk-form-row\" mt-show-errors=\"\"><div class=\"uk-form-row\"><label for=\"login_username\">{{vm.userLabel}}</label> <input ng-blur=\"vm.isValidADLogin(vm.user.username)\" maxlength=\"50\" class=\"md-input\" type=\"text\" id=\"login_username\" ng-model=\"vm.user.username\" name=\"username\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.username.$touched\"><span ng-show=\"form.username.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"form.username.$error.Email\" class=\"md-error\">E-mail inválido</span></div></div><div class=\"uk-form-row\" mt-show-errors=\"\"><div class=\"uk-form-row\"><label for=\"login_password\">Senha</label> <input class=\"md-input\" type=\"password\" id=\"login_password\" ng-model=\"vm.user.password\" name=\"password\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.password.$touched\"><span ng-show=\"form.password.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-margin-top\"><button class=\"md-btn md-btn-primary md-btn-block md-btn-large\" type=\"submit\">Entrar</button></div><div class=\"uk-margin-top uk-text-center\"><a href=\"#\" id=\"login_help_show\" ng-click=\"vm.loginHelp($event, \'recuperarSenha\')\">Esqueci minha senha</a></div><div class=\"uk-margin-top uk-text-center\"><span class=\"uk-text-small\">{{vm.appVersion}}</span></div></form></div><div class=\"md-card-content large-padding uk-position-relative\" id=\"login_help\" style=\"display: none\"><button type=\"button\" class=\"uk-position-top-right uk-close uk-margin-right uk-margin-top back_to_login\" ng-click=\"vm.backToLogin($event)\"></button><h2 class=\"heading_b uk-text-success\">Não consegue entrar?</h2><p>As informações abaixo irão ajudar você a recuperar sua conta o mais rápido possível.</p><p>Primeiro, tente o mais simples: se você lembra sua senha, mas ela não está funcionando, certifique-se de que a tecla Caps Lock está desligada, e que seu login está escrito corretamente, então tente novamente.</p><p>Se mesmo assim, nada funcionar, é hora de <a ng-if=\"vm.operacaoRecuperacao == \'recuperarSenha\'\" ui-sref=\"public.esqueceusenha({op: vm.operacaoRecuperacao})\" id=\"password_reset_show\">redefinir sua senha</a> <a ng-if=\"vm.operacaoRecuperacao == \'recuperarLogin\'\" ui-sref=\"public.esqueceusenha({op: vm.operacaoRecuperacao})\" id=\"password_reset_show\">recuperar seu login</a> .</p></div></div></div></div>");
$templateCache.put("app/login/recuperarsenha.html","<div class=\"uk-cover-background login_page\"><div class=\"login_page_wrapper\"><div ng-show=\"vm.isRecoverProcessValid\" class=\"md-card\" id=\"login_card\"><div class=\"md-card-content large-padding\" id=\"login_form\"><h2 class=\"heading_a uk-margin-medium-bottom\">Recuperação de Senha</h2><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" class=\"form-horizontal\" role=\"form\" novalidate=\"\" mt-validate-submit=\"vm.submit(vm.user)\"><div class=\"uk-form-row\" mt-show-errors=\"\"><div class=\"uk-form-row\"><label for=\"login_password\">Nova senha</label> <input minlength=\"6\" class=\"md-input\" type=\"password\" id=\"password\" ng-model=\"vm.user.password\" name=\"password\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.password.$touched\"><span ng-show=\"form.password.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span class=\"md-error\" ng-show=\"form.password.$error.minlength\">A senha deve possuir no mínimo 6 caracteres</span></div></div><div class=\"uk-form-row\" mt-show-errors=\"\"><div class=\"uk-form-row\"><label for=\"confirmPassword\">Confirmar nova senha</label> <input class=\"md-input\" type=\"password\" id=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" name=\"confirmPassword\" pw-check=\"password\" required=\"\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.confirmPassword.$touched\"><span ng-show=\"form.confirmPassword.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span class=\"md-error\" ng-show=\"form.confirmPassword.$error.pwmatch\">Senhas não conferem</span></div></div><div class=\"uk-margin-medium-top\"><button class=\"md-btn md-btn-primary md-btn-block md-btn-large\" type=\"submit\">Alterar</button></div></form></div></div><div ng-show=\"!vm.isRecoverProcessValid && !vm.isLoading\" class=\"md-card\" id=\"login_card_disabled\"><div class=\"md-card-content large-padding\"><form name=\"form2\" class=\"form-horizontal\" role=\"form\" novalidate=\"\"><center><img src=\"assets/img/sabesp/warning.png\" style=\"outline:none; text-decoration:none;border:none;display:block;height:64px;width:64px\"><h5 class=\"uk-text-danger\">Desculpe, esse link não está mais disponível.</h5><p>Esse link está expirado e será necessário realizar uma nova solicitação de recuperação de senha.<br>Qualquer dúvida, entre em contato com o administrador.<br></p></center></form></div></div><div class=\"uk-margin-top uk-text-center\"><a ui-sref=\"public.login\" id=\"signup_form_show\" class=\"\">Voltar</a></div></div></div>");
$templateCache.put("app/login/temporarypwd.html","<div class=\"uk-cover-background login_page\"><div class=\"login_page_wrapper\" custom-height=\"\" custom-height-value=\"20\"><div class=\"md-card\" id=\"login_card\"><div class=\"md-card-content large-padding\" id=\"login_form\"><div class=\"login_heading\"><div class=\"user_avatar\"></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" class=\"form-horizontal\" role=\"form\" novalidate=\"\" mt-validate-submit=\"vm.submit(vm.user)\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-form-row\"><label for=\"password\">Senha</label><input minlength=\"6\" maxlength=\"12\" class=\"md-input\" type=\"password\" id=\"password\" ng-model=\"vm.user.password\" name=\"password\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.password.$touched\"><span ng-show=\"form.password.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span class=\"md-error\" ng-show=\"form.password.$error.minlength\">A senha deve possuir no mínimo 6 caracteres.</span></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-form-row\"><label for=\"confirmPassword\">Confirmar senha</label> <input minlength=\"6\" maxlength=\"12\" class=\"md-input\" type=\"password\" id=\"confirmPassword\" ng-model=\"vm.user.confirmPassword\" name=\"confirmPassword\" pw-check=\"password\" required=\"\" md-input=\"\"><div ng-show=\"form.$submitted || form.confirmPassword.$touched\"><span ng-show=\"form.confirmPassword.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span class=\"md-error\" ng-show=\"form.confirmPassword.$error.pwmatch\">Senhas não conferem</span></div></div></div><div class=\"uk-margin-medium-top\"><button class=\"md-btn md-btn-primary md-btn-block md-btn-large\" type=\"submit\">Salvar</button></div><div class=\"uk-margin-top uk-text-center\"><a href=\"#\" id=\"login_help_show\" ng-click=\"vm.backToLogin(event)\">Cancelar</a></div><div class=\"uk-text-center\"><span class=\"uk-text-small\">{{vm.appVersion}}</span></div></form></div></div></div></div>");
$templateCache.put("app/message.priority/message.priority.create.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a ui-sref=\"private.painel.messagepriority.list\">Prioridades da Mensagem</a></li><li ng-if=\"vm.messagePriority && vm.isEdicao\"><span>{{vm.messagePriority.description | limitTo:50 }}</span></li><li><span>{{vm.operacao}}</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.submit(vm.messagePriority)\" novalidate=\"\"><div><div class=\"md-card\"><div class=\"md-card-content\"><a style=\"visibility:hidden\" class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.messagepriority.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a> <button type=\"submit\" class=\"md-btn md-btn-primary uk-float-right\"><i class=\"material-icons md-color-white\">&#xE5CA;</i> Salvar</button> <a href=\"\" class=\"md-btn md-btn-danger uk-float-right\" ng-click=\"vm.cancelar()\"><i class=\"material-icons md-color-white\">&#xE5C9;</i> Cancelar</a></div></div><div class=\"md-card\"><div class=\"md-card-content\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Descrição</label> <input type=\"text\" class=\"md-input\" id=\"messagePriority_descricao\" name=\"messagePriority_descricao\" ng-model=\"vm.messagePriority.description\" md-input=\"\" ng-maxlength=\"120\" required=\"\"><div ng-show=\"form.$submitted || form.messagePriority_descricao.$touched\"><span ng-show=\"form.messagePriority_descricao.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"form.messagePriority_descricao.$error.maxlength\" class=\"help-block\">O campo deve possuir no máximo 120 caracteres</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2\"><label>Prioridade da Mensagem</label> <input ng-model=\"vm.messagePriority.level\" type=\"text\" config=\"vm.selectize_priorities_config\" options=\"vm.selectize_priorities.options\" name=\"selectize_c\" id=\"selectize_c\" selectize=\"\" required=\"\"><div ng-show=\"form.$submitted || form.selectize_c.$touched\"><span ng-show=\"form.selectize_c.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.messagePriority.isPushNotificationAllowed\" id=\"sendPush\" name=\"sendPush\"> <label for=\"sendPush\" class=\"inline-label\">Envia Push?</label><div ng-show=\"form.$submitted || form.sendPush.$touched\"><span ng-show=\"form.sendPush.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.messagePriority.isTopCritical\" id=\"critical\" name=\"critical\"> <label for=\"critical\" class=\"inline-label\">É Crítico?</label><div ng-show=\"form.$submitted || form.critical.$touched\"><span ng-show=\"form.critical.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div ng-if=\"vm.isEdicao\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.messagePriority.active\" id=\"messagePriority_ativo\" name=\"messagePriority_ativo\"> <label for=\"messagePriority_ativo\" class=\"inline-label\">Ativo</label><div ng-show=\"form.$submitted || form.messagePriority_ativo.$touched\"><span ng-show=\"form.messagePriority_ativo.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></div></div></form></div></div>");
$templateCache.put("app/message.priority/message.priority.detail.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a ui-sref=\"private.painel.messagepriority.list\">Prioridades da Mensagem</a></li><li><span>{{vm.messagePriority.description | limitTo:50 }}</span></li><li><span>Detalhar</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"md-card\"><div class=\"md-card-content\"><a class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.messagepriority.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a> <a ng-if=\"vm.isMessagePriorityEditarPermitido\" class=\"md-btn md-btn-primary uk-float-right\" ui-sref=\"private.painel.messagepriority.edit({id: vm.messagePriority.id})\"><i class=\"material-icons md-color-white\">&#xE150;</i></a> <a ng-if=\"vm.isMessagePriorityDeletarPermitido\" href=\"\" class=\"md-btn md-btn-danger uk-float-right\" ng-click=\"vm.confirmExcluir(vm.messagePriority)\"><i class=\"material-icons md-color-white\">&#xE872;</i></a></div></div><div class=\"md-card\"><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Descrição</span> <span class=\"\">{{vm.messagePriority.description}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Prioridade da Mensagem</span> <span ng-if=\"vm.messagePriority.level==\'Leve\'\" class=\"\" style=\"color:gold\">{{vm.messagePriority.level}}</span> <span ng-if=\"vm.messagePriority.level==\'Moderado\'\" class=\"\" style=\"color:orange\">{{vm.messagePriority.level}}</span> <span ng-if=\"vm.messagePriority.level==\'Crítico\'\" class=\"\" style=\"color:red\">{{vm.messagePriority.level}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Envia Push?</span> <span class=\"uk-text-success\" ng-if=\"vm.messagePriority.isPushNotificationAllowed\">Sim</span> <span class=\"uk-text-danger\" ng-if=\"!vm.messagePriority.isPushNotificationAllowed\">Não</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">É Crítico?</span> <span class=\"uk-text-success\" ng-if=\"vm.messagePriority.isTopCritical\">Sim</span> <span class=\"uk-text-danger\" ng-if=\"!vm.messagePriority.isTopCritical\">Não</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Status</span> <span class=\"uk-text-success\" ng-if=\"vm.messagePriority.active\">Ativo</span> <span class=\"uk-text-danger\" ng-if=\"!vm.messagePriority.active\">Inativo</span></div></li></ul></div></div></div></div></div>");
$templateCache.put("app/message.priority/message.priority.list.html","<div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a ui-sref=\"private.painel.messagepriority.list\" ui-sref-opts=\"{reload: true}\">Prioridades da Mensagem</a></li></ul></div><div class=\"scrum_board_overflow page-padding-top\"><div id=\"scrum_board\" class=\"uk-clearfix\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-small-2-10\"><form style=\"height: 15em\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><i id=\"search-action-2\" class=\"uk-icon-search\"></i> <span class=\"uk-text-bold\">PESQUISA</span></span></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\" class=\"scrum_column\" auto-height=\"\" auto-height-full-height=\"true\"><div id=\"scrum_column_todo md-card\"><div class=\"uk-text-small uk-text-muted\"><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\" mtm-show-errors=\"\"><label for=\"messagePriority_filter\">Descrição</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"messagePriority_filter\" name=\"messagePriority_filter\" value=\"\" ng-model=\"vm.filters.description\" md-input=\"\"><div ng-show=\"form.$submitted || form.messagePriority_filter.$touched\"><span ng-show=\"form.messagePriority_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Prioridade da Mensagem</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_priorities_config\" options=\"vm.selectize_priorities\" position=\"bottom\" ng-model=\"vm.filters.priorityLevelIds\"></selectize></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Envia Push?</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_bool_status_config\" options=\"vm.selectize_bool_status\" position=\"bottom\" ng-model=\"vm.filters.isPushNotificationAllowedIds\"></selectize></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">É Crítico?</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_bool_status_config\" options=\"vm.selectize_bool_status\" position=\"bottom\" ng-model=\"vm.filters.IsTopCriticalIds\"></selectize></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Status</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_status_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.filters.statusIds\"></selectize></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\">Pesquisar</button></div></div></div></div></form></div><div class=\"uk-width-small-8-10\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><span class=\"uk-text-bold\">PRIORIDADES DA MENSAGEM</span></span></div></div></div><div class=\"scrum_column\" auto-height=\"\" auto-height-full-height=\"true\"><div class=\"md-card\" style=\"background: white;\"><div class=\"md-card-content\"><div class=\"uk-overflow-container uk-margin-bottom\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><table ng-if=\"!vm.isLoading\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" class=\"uk-table uk-table-nowrap\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Descrição</th><th class=\"uk-text-center\">Prioridade da Mensagem</th><th class=\"uk-text-center\">Envia Push?</th><th class=\"uk-text-center\">É Crítico?</th><th class=\"uk-text-center\">Status</th><th class=\"uk-text-center\">Ações</th></tr></thead><tfoot><tr><th class=\"uk-text-center\">Descrição</th><th class=\"uk-text-center\">Prioridade da Mensagem</th><th class=\"uk-text-center\">Envia Push?</th><th class=\"uk-text-center\">É Crítico?</th><th class=\"uk-text-center\">Status</th><th class=\"uk-text-center\">Ações</th></tr></tfoot><tbody><tr ng-repeat=\"item in vm.messagePriorities\"><td class=\"uk-text-nowrap\">{{item.description}}</td><td ng-if=\"item.level==\'Leve\'\" class=\"uk-text-nowrap\" style=\"color:gold\">{{item.level}}</td><td ng-if=\"item.level==\'Moderado\'\" class=\"uk-text-nowrap\" style=\"color:orange\">{{item.level}}</td><td ng-if=\"item.level==\'Crítico\'\" class=\"uk-text-nowrap\" style=\"color:red\">{{item.level}}</td><td class=\"uk-text-center\"><span class=\"uk-badge uk-badge-notification uk-badge-success\" title=\"Push Ativo\" ng-if=\"item.isPushNotificationAllowed\">Sim</span> <span class=\"uk-badge uk-badge-notification uk-badge-danger\" title=\"Push Inativo\" ng-if=\"!item.isPushNotificationAllowed\">Não</span></td><td class=\"uk-text-center\"><span class=\"uk-badge uk-badge-notification uk-badge-success\" title=\"Crítico Ativo\" ng-if=\"item.isTopCritical\">Sim</span> <span class=\"uk-badge uk-badge-notification uk-badge-danger\" title=\"Crítico Inativo\" ng-if=\"!item.isTopCritical\">Não</span></td><td class=\"uk-text-center\"><span class=\"uk-badge uk-badge-notification uk-badge-success\" title=\"Prioridade Ativo\" ng-if=\"item.active\">Ativo</span> <span class=\"uk-badge uk-badge-notification uk-badge-danger\" title=\"Prioridade Inativo\" ng-if=\"!item.active\">Inativo</span></td><td class=\"uk-text-nowrap uk-text-center\"><a ui-sref=\"private.painel.messagepriority.detail({id: item.id})\" title=\"Visualizar item\"><i class=\"md-icon material-icons\">&#xE8F4;</i></a> <a ng-if=\"vm.isMessagePriorityEditarPermitido\" title=\"Editar item\" ui-sref=\"private.painel.messagepriority.edit({id: item.id})\"><i class=\"md-icon material-icons\">&#xE3C9;</i></a> <button ng-if=\"vm.isMessagePriorityDeletarPermitido\" class=\"md-icon-mtm\" ng-click=\"vm.confirmExcluir(item)\" title=\"Excluir item\"><i class=\"md-icon material-icons\">&#xE872;</i></button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div ng-if=\"!vm.isLoading && vm.isMessagePriorityCadastrarPermitido\" class=\"md-fab-wrapper\"><a class=\"md-fab md-fab-accent\" ui-sref=\"private.painel.messagepriority.create\"><i class=\"material-icons\">&#xE145;</i></a></div>");
$templateCache.put("app/message.template/message.template.create.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a ui-sref=\"private.painel.messagetemplate.list\">Mensagens Padrão</a></li><li ng-if=\"vm.messageTemplate && vm.isEdicao\"><span>{{vm.messageTemplate.title | limitTo:50 }}</span></li><li><span>{{vm.operacao}}</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.submit(vm.messageTemplate)\" novalidate=\"\"><div><div class=\"md-card\"><div class=\"md-card-content\"><a style=\"visibility:hidden\" class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.messagetemplate.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a> <button type=\"submit\" class=\"md-btn md-btn-primary uk-float-right\"><i class=\"material-icons md-color-white\">&#xE5CA;</i> Salvar</button> <a href=\"\" class=\"md-btn md-btn-danger uk-float-right\" ng-click=\"vm.cancelar()\"><i class=\"material-icons md-color-white\">&#xE5C9;</i> Cancelar</a></div></div><div class=\"md-card\"><div class=\"md-card-content\"><div class=\"uk-grid uk-grid-divider uk-grid-medium\"><div class=\"uk-width-large-1-2\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Título</label> <input type=\"text\" class=\"md-input\" id=\"messageTemplate_titulo\" name=\"messageTemplate_titulo\" ng-model=\"vm.messageTemplate.title\" md-input=\"\" ng-maxlength=\"100\" required=\"\"><div ng-show=\"form.$submitted || form.messageTemplate_titulo.$touched\"><span ng-show=\"form.messageTemplate_titulo.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"form.messageTemplate_titulo.$error.maxlength\" class=\"help-block\">O campo deve possuir no máximo 100 caracteres</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Descrição</label> <textarea rows=\"3\" type=\"text\" class=\"md-input\" id=\"messageTemplate_descricao\" name=\"messageTemplate_descricao\" ng-model=\"vm.messageTemplate.description\" md-input=\"\" ng-maxlength=\"200\" required=\"\"> </textarea><div ng-show=\"form.$submitted || form.messageTemplate_descricao.$touched\"><span ng-show=\"form.messageTemplate_descricao.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"form.messageTemplate_descricao.$error.maxlength\" class=\"help-block\">O campo deve possuir no máximo 200 caracteres</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2\"><label>Prioridade da Mensagem</label> <input ng-model=\"vm.messageTemplate.messagePriority.id\" type=\"text\" config=\"vm.selectize_priorities_config\" options=\"vm.selectize_priorities.options\" name=\"selectize_c\" id=\"selectize_c\" selectize=\"\" required=\"\"><div ng-show=\"form.$submitted || form.selectize_c.$touched\"><span ng-show=\"form.selectize_c.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div ng-if=\"vm.isEdicao\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.messageTemplate.active\" id=\"messageTemplate_ativo\" name=\"messageTemplate_ativo\"> <label for=\"messageTemplate_ativo\" class=\"inline-label\">Ativo</label><div ng-show=\"form.$submitted || form.messageTemplate_ativo.$touched\"><span ng-show=\"form.messageTemplate_ativo.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-large-1-2\"><p><span class=\"uk-display-block uk-margin-small-bottom\">Tabela de Tags:</span></p><p><span class=\"uk-text-muted uk-text-small\">{codPaciente}</span></p><p><span class=\"uk-text-muted uk-text-small\">{dataExame}</span></p><p><span class=\"uk-text-muted uk-text-small\">{nomExame}</span></p><p><span class=\"uk-text-muted uk-text-small\">{nomPaciente}</span></p><p></p></div></div></div></div></div></form></div></div>");
$templateCache.put("app/message.template/message.template.detail.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a ui-sref=\"private.painel.messagetemplate.list\">Mensagens Padrão</a></li><li><span>{{vm.messageTemplate.title | limitTo:50 }}</span></li><li><span>Detalhar</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"md-card\"><div class=\"md-card-content\"><a class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.messagetemplate.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a> <a ng-if=\"vm.isMessageTemplateEditarPermitido\" class=\"md-btn md-btn-primary uk-float-right\" ui-sref=\"private.painel.messagetemplate.edit({id: vm.messageTemplate.id})\"><i class=\"material-icons md-color-white\">&#xE150;</i></a> <a ng-if=\"vm.isMessageTemplateDeletarPermitido\" href=\"\" class=\"md-btn md-btn-danger uk-float-right\" ng-click=\"vm.confirmExcluir(vm.messageTemplate)\"><i class=\"material-icons md-color-white\">&#xE872;</i></a></div></div><div class=\"md-card\"><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Título</span> <span class=\"\">{{vm.messageTemplate.title}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Descrição</span> <span class=\"\">{{vm.messageTemplate.description}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Prioridade da Mensagem</span> <span class=\"\">{{vm.messageTemplate.messagePriority.description}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Status</span> <span class=\"uk-text-success\" ng-if=\"vm.messageTemplate.active\">Ativo</span> <span class=\"uk-text-danger\" ng-if=\"!vm.messageTemplate.active\">Inativo</span></div></li></ul></div></div></div></div></div>");
$templateCache.put("app/message.template/message.template.list.html","<div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a ui-sref=\"private.painel.messagetemplate.list\" ui-sref-opts=\"{reload: true}\">Mensagens Padrão</a></li></ul></div><div class=\"scrum_board_overflow page-padding-top\"><div id=\"scrum_board\" class=\"uk-clearfix\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-small-2-10\"><form style=\"height: 15em\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><i id=\"search-action-2\" class=\"uk-icon-search\"></i> <span class=\"uk-text-bold\">PESQUISA</span></span></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\" class=\"scrum_column\" auto-height=\"\" auto-height-full-height=\"true\"><div id=\"scrum_column_todo md-card\"><div class=\"uk-text-small uk-text-muted\"><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\" mtm-show-errors=\"\"><label for=\"messageTemplate_filter\">Título</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"messageTemplateTitle_filter\" name=\"messageTemplateTitle_filter\" value=\"\" ng-model=\"vm.filters.title\" md-input=\"\"><div ng-show=\"form.$submitted || form.messageTemplateTitle_filter.$touched\"><span ng-show=\"form.messageTemplateTitle_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\" mtm-show-errors=\"\"><label for=\"messageTemplate_filter\">Descrição</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"messageTemplateDescription_filter\" name=\"messageTemplateDescription_filter\" value=\"\" ng-model=\"vm.filters.description\" md-input=\"\"><div ng-show=\"form.$submitted || form.messageTemplateDescription_filter.$touched\"><span ng-show=\"form.messageTemplateDescription_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Prioridade da Mensagem</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_priorities_config\" options=\"vm.selectize_priorities\" position=\"bottom\" ng-model=\"vm.filters.messagePriorityIds\"></selectize></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Status</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_status_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.filters.statusIds\"></selectize></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\">Pesquisar</button></div></div></div></div></form></div><div class=\"uk-width-small-8-10\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><span class=\"uk-text-bold\">MENSAGENS PADRÃO</span></span></div></div></div><div class=\"scrum_column\" auto-height=\"\" auto-height-full-height=\"true\"><div class=\"md-card\" style=\"background: white;\"><div class=\"md-card-content\"><div class=\"uk-overflow-container uk-margin-bottom\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" class=\"uk-table uk-table-nowrap\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Título</th><th class=\"uk-text-center\">Descrição</th><th class=\"uk-text-center\">Prioridade da Mensagem</th><th class=\"uk-text-center\">Status</th><th class=\"uk-text-center\">Ações</th></tr></thead><tfoot><tr><th class=\"uk-text-center\">Título</th><th class=\"uk-text-center\">Descrição</th><th class=\"uk-text-center\">Prioridade da Mensagem</th><th class=\"uk-text-center\">Status</th><th class=\"uk-text-center\">Ações</th></tr></tfoot><tbody><tr ng-repeat=\"item in vm.messageTemplates\"><td class=\"uk-text-nowrap\">{{item.title}}</td><td class=\"uk-text-nowrap\">{{item.description | limitTo: 70 }}{{item.description.length > 70 ? \'...\' : \'\'}}</td><td class=\"uk-text-nowrap\">{{item.messagePriority.description}}</td><td class=\"uk-text-center\"><span class=\"uk-badge uk-badge-notification uk-badge-success\" title=\"Item Ativo\" ng-if=\"item.active\">Ativo</span> <span class=\"uk-badge uk-badge-notification uk-badge-danger\" title=\"Item Inativo\" ng-if=\"!item.active\">Inativo</span></td><td class=\"uk-text-nowrap uk-text-center\"><a ui-sref=\"private.painel.messagetemplate.detail({id: item.id})\" title=\"Visualizar item\"><i class=\"md-icon material-icons\">&#xE8F4;</i></a> <a ng-if=\"vm.isMessageTemplateEditarPermitido\" title=\"Editar item\" ui-sref=\"private.painel.messagetemplate.edit({id: item.id})\"><i class=\"md-icon material-icons\">&#xE3C9;</i></a> <button ng-if=\"vm.isMessageTemplateDeletarPermitido\" class=\"md-icon-mtm\" ng-click=\"vm.confirmExcluir(item)\" title=\"Excluir item\"><i class=\"md-icon material-icons\">&#xE872;</i></button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div><div ng-if=\"!vm.isLoading && vm.isMessageTemplateCadastrarPermitido\" class=\"md-fab-wrapper\"><a class=\"md-fab md-fab-accent\" ui-sref=\"private.painel.messagetemplate.create\"><i class=\"material-icons\">&#xE145;</i></a></div>");
$templateCache.put("app/painel/painel.html","<header id=\"header_main\" style=\"background:{{vm.appSelecionado.appStyle.colorBase}}\"><div class=\"header_main_content\" style=\"z-index:10000\"><nav class=\"uk-navbar\"><div class=\"main_logo_top\" ng-if=\"topMenuActive || fullHeaderActive\"><a ui-sref=\"painel.dashboard\"><img ng-src=\"assets/img/logo_main_white.png\" alt=\"\" add-image-prop=\"\"></a></div><sidebar-primary-toggle></sidebar-primary-toggle><sidebar-secondary-toggle ng-class=\"{ \'uk-hidden-large\': secondarySidebarHiddenLarge }\"></sidebar-secondary-toggle><div ng-hide=\"topMenuActive\"><div ng-show=\"vm.company.name\" class=\"uk-navbar-flip\" style=\"float:left;\"><ul class=\"uk-navbar-nav user_actions\"><li data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\"><a href=\"\" class=\"user_action_image\"><b>{{vm.company.name}} <i class=\"material-icons md-light\">keyboard_arrow_down</i></b></a><div class=\"uk-dropdown uk-dropdown-small\" style=\"max-height: 100vh !important; width: auto !important; right: auto !important\"><ul class=\"uk-nav js-uk-prevent\"><li ng-repeat=\"companie in vm.companies | custom_unique | orderBy:\'name\'\"><a href=\"\" ng-click=\"vm.selectCompany(companie.id, true)\" class=\"uk-dropdown-close\">{{companie.name}}</a></li></ul></div></li></ul></div></div><div ng-hide=\"topMenuActive\"><div ng-show=\"vm.company\" class=\"uk-navbar-flip\" style=\"float:left;\"><ul class=\"uk-navbar-nav user_actions\"><li ng-if=\"vm.isLoadingApp\"><a href=\"\" class=\"user_action_image\"><b>Atualizando Endpoints...</b></a></li><li ng-if=\"!vm.isLoadingApp\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\"><a ng-if=\"vm.appSelecionado\" href=\"\" class=\"user_action_image\"><img ng-if=\"vm.appSelecionado.logoSecondary\" img=\"\" ng-src=\"data:image/png;base64,{{vm.appSelecionado.logoSecondary}}\" alt=\"\" style=\"width: 32px; height: 32px; border-radius: 50%; border: 2px solid #fff;\" width=\"32\" height=\"32\"> <b>{{vm.appSelecionado.name}} <i class=\"material-icons md-light\">keyboard_arrow_down</i></b></a> <a ng-if=\"!vm.appSelecionado\" href=\"\" class=\"user_action_image\"><b>Selecione um endpoint <i class=\"material-icons md-light\">keyboard_arrow_down</i></b></a><div class=\"uk-dropdown uk-dropdown-small\" style=\"max-height: 100vh !important; width: auto !important; right: auto !important\"><ul class=\"uk-nav js-uk-prevent\"><li ng-repeat=\"appCompany in vm.applications | custom_unique | orderBy:\'name\'\"><a href=\"\" ng-click=\"vm.selectAppCompany(appCompany.id, true)\" class=\"uk-dropdown-close\">{{appCompany.name}}</a></li></ul></div></li></ul></div></div><ul class=\"uk-navbar-nav user_actions\"><li><a href=\"\" style=\"padding-top:3px;padding-left: 0px;\"></a></li></ul><div class=\"uk-navbar-flip\"><ul class=\"uk-navbar-nav user_actions\"><li><a href=\"\" style=\"padding-top:3px\">{{vm.usuarioLogado}}</a></li><li data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\"><a href=\"#\"><i class=\"material-icons md-24 md-light\">&#xE5D4;</i></a><div class=\"uk-dropdown uk-dropdown-small\"><ul class=\"uk-nav js-uk-prevent\"><li><a ng-click=\"vm.abrirModalSenha()\">Trocar Senha</a></li><li><a data-uk-modal=\"{target:\'#modal_header_footer_account\',bgclose:false}\" ng-click=\"vm.getAccountProfile()\">Meu Perfil</a></li><li><a ng-click=\"logout()\">Sair</a></li></ul></div></li></ul></div></nav></div><div class=\"uk-modal\" id=\"modal_header_footer_senha\" style=\"z-index:10000\"><div class=\"uk-modal-dialog\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"uk-modal-header\"><h3 class=\"uk-modal-title\">Trocar Senha</h3></div><form name=\"vm.formSenha\" id=\"vm.formSenha\" mt-validate-submit=\"vm.submitTrocaSenha(vm.user)\" novalidate=\"\"><div class=\"uk-form-row uk-width-1-2\" mt-show-errors=\"\"><div class=\"uk-form-row\"><h5 class=\"\">Senha atual</h5><input class=\"md-input\" type=\"password\" id=\"senhaAtual\" ng-model=\"vm.user.senhaAtual\" name=\"senhaAtual\" required=\"\" md-input=\"\"> <a href=\"\" class=\"uk-form-password-toggle\" data-uk-form-password=\"\">Mostrar</a></div><div class=\"uk-margin-top\" ng-show=\"vm.formSenha.$submitted || vm.formSenha.senhaAtual.$touched\"><span ng-show=\"vm.formSenha.senhaAtual.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span class=\"help-block\" ng-show=\"vm.formSenha.senhaAtual.$error.minlength\">A senha deve possuir no mínimo 6 caracteres</span></div></div><div class=\"uk-form-row uk-width-1-2\" mt-show-errors=\"\"><div class=\"uk-form-row\"><h5 class=\"\">Nova senha</h5><input minlength=\"6\" class=\"md-input\" type=\"password\" id=\"password\" ng-model=\"vm.user.password\" name=\"password\" required=\"\" md-input=\"\"> <a href=\"\" class=\"uk-form-password-toggle\" data-uk-form-password=\"\">Mostrar</a></div><div class=\"uk-form-row uk-width-medium-1-2\"><div class=\"uk-progress uk-progress-striped uk-active uk-progress-small\"><div class=\"uk-progress-bar\" ng-style=\"{\'width\': vm.calcularForcaSenha()+\'%\'}\"></div></div></div><div ng-show=\"vm.formSenha.$submitted || vm.formSenha.password.$touched\"><span ng-show=\"vm.formSenha.password.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span class=\"help-block\" ng-show=\"vm.formSenha.password.$error.minlength\">A senha deve possuir no mínimo 6 caracteres</span></div></div><div class=\"uk-modal-footer uk-text-right\"><button type=\"button\" ng-click=\"vm.fecharModalSenha()\" class=\"md-btn md-btn-flat uk-modal-close\">Cancelar</button> <button type=\"submit\" class=\"md-btn md-btn-flat md-btn-flat-primary\">Aplicar</button></div></form></div></div></div><div class=\"uk-modal\" id=\"modal_header_footer_account\" style=\"z-index:10000\"><div class=\"uk-modal-dialog\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingModal\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingModal\"><div class=\"uk-modal-header\"><h3 class=\"uk-modal-title\">Editar perfil</h3></div><form name=\"form\" id=\"form\" mt-validate-submit=\"vm.submitAccountProfile(vm.accountInfo)\" novalidate=\"\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><div class=\"uk-form-row\" mt-show-errors=\"\"><label for=\"settings_site_name\">Nome</label> <input class=\"md-input\" type=\"text\" id=\"accNome\" name=\"accNome\" ng-model=\"vm.accountInfo.profiles[0].name\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.accNome.$touched\"><span ng-show=\"form.accNome.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-1-2\"><div class=\"uk-form-row\" mt-show-errors=\"\"><label for=\"settings_site_name\">Sobrenome</label><input class=\"md-input\" type=\"text\" id=\"accSobrenome\" name=\"accSobrenome\" ng-model=\"vm.accountInfo.profiles[0].surname\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.accSobrenome.$touched\"><span ng-show=\"form.accSobrenome.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><div class=\"uk-form-row\" mt-show-errors=\"\"><label for=\"settings_site_name\">E-mail</label> <input class=\"md-input\" ng-disabled=\"true\" type=\"text\" id=\"accEmail\" name=\"accEmail\" ng-model=\"vm.accountInfo.profiles[0].mail\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.accEmail.$touched\"><span ng-show=\"form.accEmail.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-1-2\"><div class=\"uk-form-row\" mt-show-errors=\"\"><label for=\"settings_site_name\">Telefone</label> <input class=\"md-input\" type=\"text\" id=\"accTel\" name=\"accTel\" ng-model=\"vm.accountInfo.profiles[0].phone.phoneNumber\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.accTel.$touched\"><span ng-show=\"form.accTel.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div></div><div class=\"uk-modal-footer uk-text-right\"><button type=\"button\" ng-click=\"vm.fecharModalAccount()\" class=\"md-btn md-btn-flat uk-modal-close\">Cancelar</button> <button type=\"submit\" class=\"md-btn md-btn-flat md-btn-flat-primary\">Aplicar</button></div></form></div></div></div><div class=\"header_main_search_form\" style=\"z-index:9999\"><main-search-hide></main-search-hide><form class=\"uk-form\"><input type=\"text\" class=\"header_main_search_input\"> <button class=\"header_main_search_btn uk-button-link\"><i class=\"md-icon material-icons\">&#xE8B6;</i></button></form></div></header><div ui-view=\"\" ng-class=\"{ \'uk-height-1-1\': page_full_height }\"></div><style-switcher></style-switcher><div ng-hide=\"topMenuActive\"><aside id=\"sidebar_main\" sidebar-primary=\"\" custom-scrollbar=\"\" ng-class=\"{ \'accordion_mode\': menuAccordionMode }\"><div class=\"sidebar_main_header\" ng-if=\"!fullHeaderActive\"><div class=\"user_avatar\"></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoadingMenu\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div id=\"main_menu\" ng-if=\"!vm.isLoadingMenu\" class=\"menu_section\"><ul><li ng-if=\"section.isVisible\" ui-sref-active=\"current_section\" ng-repeat=\"section in vm.sectionsShowed\" ng-switch=\"section.link.length > 0\" ng-class=\"{\'submenu_trigger\': (section.submenu.length > 0) && !miniSidebarActive, \'sidebar_submenu\': (section.submenu.length > 0) && miniSidebarActive}\" on-last-repeat=\"\"><a ng-switch-when=\"true\" ng-click=\"vm.acessarRota(section.link, section.resetApp)\" ui-sref=\"{{section.link}}\" ng-class=\"{\'menu_tooltip\' : miniSidebarActive}\"><span class=\"menu_icon\"><i class=\"material-icons\" ng-bind-html=\"section.icon\"></i></span> <span class=\"menu_title\">{{section.title}}</span></a> <a ng-switch-when=\"false\" ng-if=\"!section.appInfoMenuDivider\" href=\"#\" ng-click=\"submenuToggle($event)\"><span class=\"menu_icon\"><i class=\"material-icons\" ng-bind-html=\"section.icon\"></i></span> <span class=\"menu_title\">{{section.title}}</span></a><hr ng-if=\"section.appInfoMenuDivider\" class=\"uk-grid-divider\"><div ng-if=\"section.appInfoMenuDivider\" style=\"margin-bottom: 5px !important;\"><span title=\"{{section.title}}\" style=\"font-weight: bold; color: #aaa; padding: 0px 30px 15px 10px !important;\">{{ vm.appSelecionado.name}}</span></div><ul id=\"{{section.title}}\" ng-if=\"section.submenu\"><li ng-if=\"section.submenu_title\" class=\"submenu-title\">{{section.submenu_title}}</li><li ng-repeat-start=\"item in section.submenu\" ng-if=\"item.group\" class=\"menu_subtitle\">{{item.group}}</li><li ng-show=\"item.isVisible\" ng-repeat-end=\"\" ng-class=\"{ act_item: $state.includes(item.link), \'submenu_trigger\': (item.submenu.length > 0) && !miniSidebarActive, \'sidebar_submenu\': (item.submenu.length > 0) && miniSidebarActive }\" ng-include=\"\'submenuTree\'\"></li></ul></li></ul></div></aside><script type=\"text/ng-template\" id=\"submenuTree\"><a ng-if=\"item.link\" ui-sref=\"{{item.link}}\" >{{item.title}}</a> <a ng-if=\"!item.link\" href=\"#\" ng-click=\"submenuToggle($event)\">{{item.title}}</a> <ul ng-if=\"item.submenu\"> <li ng-repeat=\"item in item.submenu\" ng-include=\"\'submenuTree\'\" ng-class=\"{ act_item: $state.includes(item.link), \'submenu_trigger\': (item.submenu.length > 0) && !miniSidebarActive, \'sidebar_submenu\': (item.submenu.length > 0) && miniSidebarActive }\"> <a ng-if=\"item.link\" ui-sref=\"{{item.link}}\">{{item.title}}</a> <a ng-if=\"!item.link\" href=\"#\" ng-click=\"submenuToggle($event)\">{{item.title}}</a> </li> </ul></script><script>\r\n        function setMenuItensColor(){\r\n            [].every.call( document.styleSheets, function ( sheet ) {\r\n                return [].every.call( sheet.cssRules, function ( rule ) {                \r\n                    if ( rule.selectorText === \'#sidebar_main .menu_section > ul > li ul li.act_item a\' || rule.selectorText === \'#sidebar_main .menu_section > ul > li.current_section > a .menu_title\' || rule.selectorText === \'#sidebar_main .menu_section > ul > li.current_section > a > .menu_icon .material-icons\' ) {\r\n                        rule.style.color = \'red\';\r\n                    }\r\n                    return true;\r\n                });\r\n            });\r\n        }\r\n    </script></div><style type=\"text/css\">\r\n    .uk-pagination > li.uk-active > a, .uk-pagination > li.uk-active > span {\r\n        background: {{vm.appSelecionado.appStyle.colorBase}} !important;\r\n    }\r\n    .uk-subnav-pill > .uk-active > * {\r\n            background: #00a8e6;\r\n        }\r\n    .uk-pagination > li.uk-active > a, .uk-pagination > li.uk-active > span {\r\n        background: #2494d8;\r\n    }\r\n</style>");
$templateCache.put("app/papel/papel.create.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar\" ng-click=\"vm.openModalConfirmacaoDeCancelamento()\"><i class=\"material-icons md-color-white\"></i></a> <label for=\"submitForm\" tabindex=\"0\" class=\"labelAsButton\" title=\"Salvar\"><i class=\"material-icons md-color-white\"></i></label></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE32A;</i><a target=\"#\">&nbsp;{{vm.operacao}}</a><span ng-if=\"vm.papel.name\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.papel.name}}</span></h1><span ng-if=\"vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.company.name}} &raquo; Papéis</span> <span ng-if=\"!vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">&nbsp;</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\" class=\"uk-width-medium-1-1 uk-width-large-7-10 uk-width-xlarge-6-10 uk-container-center reset-print\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-row-first\"><form name=\"form\" id=\"form\" mt-validate-submit=\"vm.submit(vm.papel)\" novalidate=\"\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"display:none\"></button> <b>Informações Gerais</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"papel_titulo\" name=\"papel_titulo\" ng-model=\"vm.papel.name\" md-input=\"\" ng-maxlength=\"100\" required=\"\"></div><div ng-show=\"form.$submitted || form.papel_titulo.$touched\"><span ng-show=\"form.papel_titulo.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"form.papel_titulo.$error.maxlength\" class=\"md-error\">O campo deve possuir no máximo 100 caracteres</span></div></div></div></div></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"display:none\"></button> <b>Permissões</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\" ng-repeat=\"modulo in vm.superPermissions | orderBy:\'modulo\'\"><h5 class=\"heading_c full_width_in_card\" style=\"margin: 0 -16px 0 -16px !important; font-size:14px !important;\"><b>{{::modulo.modulo}}</b></h5><div class=\"uk-width-1-1\" ng-repeat=\"permission in modulo.permissions | orderBy:\'name\'\"><fieldset class=\"uk-margin-top\" style=\"border:1px solid lightgray;\" data-uk-margin=\"\"><legend style=\"margin-left:-2px\"><input ng-change=\"vm.batchSelectActions(permission.id, permission.checked)\" type=\"checkbox\" name=\"\" id=\"\" icheck=\"\" ng-model=\"permission.checked\"> <span class=\"uk-text-bold\">{{::permission.name}}</span> <i tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"{{::permission.functionalityTooltip}}\" class=\"material-icons\">help</i></legend><span class=\"icheck-inline\" ng-repeat=\"action in permission.actions | orderBy:\'description\'\"><input type=\"checkbox\" name=\"papel{{$parent.$parent.$index}}{{$parent.$index}}{{$index}}\" id=\"papel{{$parent.$parent.$index}}{{$parent.$index}}{{$index}}\" icheck=\"\" ng-model=\"action.checked\"> <label title=\"{{::action.actionTooltip}}\" for=\"papel{{$parent.$parent.$index}}{{$parent.$index}}{{$index}}\" class=\"inline-label\">{{::action.description}}</label></span></fieldset></div></div></div></div></div></div></form></div></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a type=\"button\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\" ui-sref=\"private.painel.papel.list\">Sim</a></div></div></div></div></div></div>");
$templateCache.put("app/papel/papel.detail.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><a class=\"md-fab md-fab-small md-fab-primary md-fab-back\" ui-sref=\"private.painel.papel.list\"><i class=\"uk-icon-angle-left\"></i></a><div ng-if=\"(vm.isPapelEditarPermitido || vm.isPapelDeletarPermitido) && !vm.papel.isAdmin\" class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Editar\" ng-if=\"vm.isPapelEditarPermitido && !vm.papel.isAdmin\" ui-sref=\"private.painel.papel.list.edit({id: vm.papel.id})\"><i class=\"material-icons md-color-white\">&#xE150;</i></a> <a title=\"Excluir\" ng-if=\"vm.isPapelDeletarPermitido && !vm.papel.isAdmin\" ng-click=\"vm.confirmExcluir(vm.papel)\"><i class=\"material-icons md-color-white\">&#xe872;</i></a></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE32A;</i><a target=\"#\">&nbsp;Visualizar</a><span ng-if=\"vm.papel.name\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.papel.name}}</span></h1><span ng-if=\"vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.company.name}} &raquo; Papéis</span> <span ng-if=\"!vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">&nbsp;</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\" class=\"uk-width-medium-1-1 uk-width-large-7-10 uk-width-xlarge-6-10 uk-container-center reset-print\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-row-first\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"display:none\"></button> <b>Informações Gerais</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"true\" class=\"md-input-2\" id=\"papel_titulo\" name=\"papel_titulo\" ng-model=\"vm.papel.name\" md-input=\"\" ng-maxlength=\"100\" required=\"\"></div></div></div></div></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"display:none\"></button> <b>Permissões</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\" ng-repeat=\"modulo in vm.superPermissions | orderBy:\'modulo\'\"><h5 class=\"heading_c full_width_in_card\" style=\"margin: 0 -16px 0 -16px !important; font-size:14px !important;\"><b>{{::modulo.modulo}}</b></h5><div class=\"uk-width-1-1\" ng-repeat=\"permission in modulo.permissions | orderBy:\'name\'\"><fieldset class=\"uk-margin-top\" style=\"border:1px solid lightgray;\" data-uk-margin=\"\"><legend style=\"margin-left:-2px\"><input ng-disabled=\"true\" ng-change=\"vm.batchSelectActions(permission.id, permission.checked)\" type=\"checkbox\" name=\"\" id=\"\" icheck=\"\" ng-model=\"permission.checked\"> <span class=\"uk-text-bold\">{{::permission.name}}</span> <i tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"{{::permission.functionalityTooltip}}\" class=\"material-icons\">help</i></legend><span class=\"icheck-inline\" ng-repeat=\"action in permission.actions | orderBy:\'description\'\"><input enable=\"false\" ng-disabled=\"true\" type=\"checkbox\" name=\"papel{{$parent.$parent.$index}}{{$parent.$index}}{{$index}}\" id=\"papel{{$parent.$parent.$index}}{{$parent.$index}}{{$index}}\" icheck=\"\" ng-model=\"action.checked\"> <label title=\"{{::action.actionTooltip}}\" for=\"papel{{$parent.$parent.$index}}{{$parent.$index}}{{$index}}\" class=\"inline-label\">{{::action.description}}</label></span></fieldset></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/papel/papel.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\"><a ng-if=\"!vm.isLoading && vm.isPapelCadastrarPermitido\" class=\"md-fab md-fab-small md-fab-primary\" ui-sref=\"private.painel.papel.list.create\"><i class=\"material-icons\">&#xE145;</i></a></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE32A;</i><a target=\"#\">&nbsp;Papéis</a></h1><span ng-if=\"vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.company.name}}</span> <span ng-if=\"!vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">&nbsp;</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"\">PESQUISA</h3></div></div></div><div class=\"uk-width-8-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">PAPÉIS <span ng-show=\"vm.papeis.length\">({{vm.papeis.length}}) Registro(s)</span></h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><form ng-if=\"vm.isPapelPesquisarPermitido\" style=\"height: 15em\" name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\" class=\"scrum_column\" auto-height=\"\" auto-height-full-height=\"false\"><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome</label><div class=\"md-input-wrapper\"><input ng-minlength=\"3\" type=\"text\" class=\"md-input-2\" id=\"papel_filter\" name=\"papel_filter\" value=\"\" ng-model=\"vm.filters.name\" md-input=\"\"><div ng-show=\"form.$submitted || form.papel_filter.$touched\"><span ng-show=\"form.papel_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></div></form></div><div class=\"uk-width-8-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding:10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div id=\"services-list\" class=\"md-card-list-wrapper\" ng-if=\"!vm.isLoading && vm.papeis.length > 0\"><div class=\"md-card-list\" style=\"margin-top: 0px\"><ul class=\"md-list-custom uk-nestable-list md-list-custom-outside\"><li ng-repeat=\"item in vm.papeis | orderBy: \'name\'\"><div class=\"md-card-list-item-menu uk-visible-large\" aria-haspopup=\"true\" aria-expanded=\"false\"><a ui-sref=\"private.painel.papel.list.detail({id: item.id})\" title=\"Visualizar\"><i class=\"md-icon material-icons\">&#xE8F4;</i></a> <a ng-show=\"!item.isAdmin && vm.isPapelEditarPermitido\" title=\"Editar\" ui-sref=\"private.painel.papel.list.edit({id: item.id})\"><i class=\"md-icon material-icons\">&#xE3C9;</i></a> <a ng-show=\"!item.isAdmin && vm.isPapelExcluirPermitido\" ng-click=\"vm.confirmExcluir(item)\" href=\"\" title=\"Excluir\"><i class=\"md-icon material-icons\">&#xE872;</i></a></div><div class=\"md-card-list-item-menu uk-visible-medium\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\" aria-haspopup=\"true\" aria-expanded=\"false\"><a href=\"#\" class=\"md-icon material-icons\"></a><div class=\"uk-dropdown uk-dropdown-small\" aria-hidden=\"true\"><ul class=\"uk-nav\"><li><a ui-sref=\"private.painel.papel.list.detail({id: item.id})\" title=\"Visualizar\"><i class=\"material-icons\">&#xE8F4;</i>Visualizar</a></li><li ng-show=\"!item.isAdmin\"><a ng-if=\"vm.isPapelEditarPermitido\" title=\"Editar\" ui-sref=\"private.painel.papel.list.edit({id: item.id})\"><i class=\"material-icons\">&#xE3C9;</i>Editar</a></li><li ng-show=\"!item.isAdmin\"><a ng-if=\"vm.isPapelExcluirPermitido\" ng-click=\"vm.confirmExcluir(item)\" href=\"\" title=\"Excluir\"><i class=\"material-icons\">&#xE872;</i>Excluir</a></li></ul></div></div><div class=\"md-card-list-item-subject\"><span style=\"padding-top:8px;\">{{item.name}}</span></div></li></ul></div></div><div class=\"md-card\" ng-show=\"!vm.isLoading && vm.papeis.length == 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum papel encontrado.</span></h3></div></div></div></div></div></div>");
$templateCache.put("app/push/push.create.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar\" ng-click=\"vm.openModalConfirmacaoDeCancelamento()\"><i class=\"material-icons md-color-white\"></i></a> <label for=\"submitForm\" tabindex=\"0\" class=\"labelAsButton\" title=\"Salvar\"><i class=\"material-icons md-color-white\"></i></label></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xe0c9;</i><a target=\"#\">&nbsp;{{vm.operacao}}</a><span ng-if=\"vm.push.subject\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.push.subject}}</span></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Mensageria</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-width-medium-1-1 uk-width-large-7-10 uk-width-xlarge-6-10 uk-container-center reset-print\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-row-first\"><form ng-if=\"!vm.isLoading\" name=\"formPush\" id=\"formPush\" mt-validate-submit=\"vm.submit(vm.push)\" novalidate=\"\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"display:none\" ng-click=\"vm.submitAction = \'enviar\'\"></button> <b>Informações Gerais</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\"><div class=\"row uk-margin-top uk-margin-bottom uk-text-bold\"><span>Enviar mensagem:</span></div><div ng-init=\"vm.push.momentoEnvio = !vm.push.momentoEnvio ? 0 : vm.push.momentoEnvio\" mtm-show-errors=\"\"><span class=\"icheck-inline\"><input ng-change=\"vm.clearTargets()\" type=\"radio\" name=\"momento_acatado\" class=\"radio_demo_inline\" id=\"momento_acatado\" ng-model=\"vm.push.momentoEnvio\" value=\"0\" icheck=\"\"> <label for=\"momento_acatado_id\" class=\"inline-label\">Agora</label></span> <span class=\"icheck-inline\"><input ng-change=\"vm.clearTargets()\" type=\"radio\" name=\"momento_nao_acatado\" class=\"radio_demo_inline\" id=\"momento_nao_acatado\" ng-model=\"vm.push.momentoEnvio\" value=\"1\" icheck=\"\"> <label for=\"momento_nao_acatado_id\" class=\"inline-label\">Agendar para:</label></span><div ng-show=\"formPush.$submitted || formPush.momento_acatado.$touched\"><span ng-show=\"formPush.momento_acatado.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div ng-if=\"vm.push.momentoEnvio==1\" class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2\"><label for=\"uk_dp_start\">Data do agendamento</label><div class=\"md-input-wrapper2\"><input class=\"md-input-2\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormatNotime}}\" md-input=\"\" ng-model=\"vm.push.scheduleToDate\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\" ng-required=\"vm.push.momentoEnvio==1\"></div><div ng-show=\"formPush.$submitted || formPush.uk_dp_start.$touched\"><span ng-show=\"formPush.uk_dp_start.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-1-2\"><label for=\"hora_inicial\">Hora do agendamento</label><div class=\"md-input-wrapper2\"><input ng-model=\"vm.push.scheduleToDateHour\" type=\"text\" class=\"md-input-2\" id=\"hora_inicial\" name=\"hora_inicial\" md-input=\"\" data-uk-timepicker=\"\" ng-required=\"vm.push.momentoEnvio==1\"></div><div ng-show=\"formPush.$submitted || formPush.hora_inicial.$touched\"><span ng-show=\"formPush.hora_inicial.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1\"><label>Assunto</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"push_surname\" name=\"push_surname\" ng-model=\"vm.push.subject\" md-input=\"\" required=\"\"></div><div ng-show=\"formPush.$submitted ||formPush.push_surname.$touched\"><span ng-show=\"formPush.push_surname.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1\"><label>Tipo da mensagem</label><selectize options=\"vm.selectize_tipos\" class=\"custom_selectize\" placeholder=\"Selecione\" position=\"bottom\" name=\"tipoMensagem\" id=\"tipoMensagem\" config=\"vm.selectize_tipos_config\" ng-model=\"vm.push.tiposArray\" required=\"\"></selectize><div class=\"uk-margin-top\" ng-show=\"formPush.$submitted || formPush.tipoMensagem.$touched\"><span ng-show=\"formPush.tipoMensagem.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div ng-if=\"vm.validarConteudo(\'0\')\" class=\"uk-width-medium-1-1\"><label>Conteúdo Push</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" ng-maxlength=\"50\" maxlength=\"51\" id=\"contentPush\" name=\"contentPush\" ng-model=\"vm.push.contentPush\" md-input=\"\" ng-required=\"vm.validarConteudo(\'0\')\"></div><div ng-show=\"formPush.$submitted || formPush.contentPush.$touched\"><span ng-show=\"formPush.contentPush.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"formPush.contentPush.$error.maxlength\" class=\"md-error\">O campo deve possuir no máximo 50 caracteres</span></div></div><div ng-if=\"vm.validarConteudo(\'1\')\" class=\"uk-width-medium-1-1\"><label>Conteúdo Inbox</label><trix-editor id=\"contentInbox\" name=\"contentInbox\" angular-trix=\"\" ng-model=\"vm.push.content\" ng-required=\"vm.validarConteudo(\'1\')\"></trix-editor><div ng-show=\"formPush.$submitted || formPush.contentInbox.$touched\"><span ng-show=\"formPush.contentInbox.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div></div></div></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><b>Destinatários</b></h3></div><div class=\"md-card-content\"><div class=\"uk-form-row\"><div class=\"row uk-margin-top uk-margin-bottom uk-text-bold\"><span>Escolha o tipo de envio:</span></div><div ng-init=\"vm.push.tipoEnvio = !vm.push.tipoEnvio ? 0 : vm.push.tipoEnvio\" mtm-show-errors=\"\"><span class=\"icheck-inline\"><input ng-change=\"vm.clearTargets()\" type=\"radio\" name=\"radio_acatado\" class=\"radio_demo_inline\" id=\"radio_acatado\" ng-model=\"vm.push.tipoEnvio\" value=\"0\" icheck=\"\"> <label for=\"radio_acatado_id\" class=\"inline-label\">Todos</label></span> <span class=\"icheck-inline\"><input ng-change=\"vm.clearTargets()\" type=\"radio\" name=\"radio_nao_acatado\" class=\"radio_demo_inline\" id=\"radio_nao_acatado\" ng-model=\"vm.push.tipoEnvio\" value=\"1\" icheck=\"\"> <label for=\"radio_nao_acatado_id\" class=\"inline-label\">Por usuário</label></span> <span class=\"icheck-inline\"><input ng-change=\"vm.clearTargets()\" type=\"radio\" name=\"radio_nao_broad\" class=\"radio_demo_inline\" id=\"radio_nao_broad\" ng-model=\"vm.push.tipoEnvio\" value=\"2\" icheck=\"\"> <label for=\"radio_nao_broad\" class=\"inline-label\">Por critério</label></span><div ng-show=\"formPush.$submitted || formPush.radio_acatado.$touched\"><span ng-show=\"formPush.radio_acatado.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div ng-if=\"vm.push.tipoEnvio == 1\"><div class=\"uk-grid\"><div class=\"uk-width-1-2\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"cliente_filter_name\">Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_name\" name=\"cliente_filter\" value=\"\" ng-model=\"vm.usuarioFilters.Name\" md-input=\"\"></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label for=\"cliente_filter_email\">E-mail</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_email\" name=\"cliente_filter\" value=\"\" ng-model=\"vm.usuarioFilters.mail\" md-input=\"\"></div></div><div class=\"uk-form-row uk-text-right\" mtm-show-errors=\"\"><button ng-click=\"vm.pesquisarUsuarios(vm.usuarioFilters)\" type=\"button\" class=\"uk-margin-top md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light\"><i title=\"Pesquisar usuários\" style=\"color: white;\" class=\"material-icons md-24\">&#xE8B6;</i> Pesquisar Usuários</button></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFilters\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFilters\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1\"><label>Usuários</label><div ng-if=\"vm.selectize_usuarios && vm.selectize_usuarios.length > 0\" class=\"uk-form-row uk-margin-top\"><span class=\"icheck-inline\" ng-repeat=\"user in vm.selectize_usuarios | orderBy:\'userName\'\"><input type=\"checkbox\" name=\"papel{{$index}}\" id=\"papel{{$index}}\" icheck=\"\" ng-model=\"user.checked\" ng-change=\"vm.addUsersSelected(user, $index)\"> <label for=\"papel{{$index}}\" class=\"inline-label\">{{::user.profiles[0].name | uppercase}} {{::user.profiles[0].surname | uppercase}} ({{::user.userName | lowercase}})</label></span></div><div ng-if=\"!vm.selectize_usuarios || vm.selectize_usuarios.length == 0\" class=\"uk-bg-primary uk-alert uk-text-center uk-margin-top\" data-uk-alert=\"\"><span>Nenhum usuário encontrado.</span></div></div></div></div></div></div><div class=\"uk-width-1-2\"><label>Usuários Selecionados</label><div ng-if=\"vm.selectedUsers && vm.selectedUsers.length > 0\" class=\"uk-form-row uk-margin-top\"><span class=\"icheck-inline\" ng-repeat=\"user in vm.selectedUsers | orderBy:\'userName\'\"><input type=\"checkbox\" name=\"papel{{$index}}\" id=\"papel{{$index}}\" icheck=\"\" ng-model=\"user.checked\" ng-change=\"vm.removeUsersSelected(user, $index)\"> <label for=\"papel{{$index}}\" class=\"inline-label\">{{::user.profiles[0].name | uppercase}} {{::user.profiles[0].surname | uppercase}} ({{::user.userName | lowercase}})</label></span></div><div ng-if=\"!vm.selectedUsers || vm.selectedUsers.length == 0\" class=\"uk-bg-primary uk-alert uk-text-center uk-margin-top\" data-uk-alert=\"\"><span>Nenhum usuário selecionado.</span></div></div></div></div><div ng-if=\"vm.push.tipoEnvio == 2\"><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2\"><label for=\"uk_dp_end\">Data de Cadasto Inicial</label><div class=\"md-input-wrapper2\"><input class=\"md-input-2\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormatNotime}}\" md-input=\"\" ng-model=\"vm.push.targets.registeredIn.dtIni\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div></div><div class=\"uk-width-medium-1-2\"><label for=\"uk_dp_end\">Data de Cadasto Final</label><div class=\"md-input-wrapper2\"><input class=\"md-input-2\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormatNotime}}\" md-input=\"\" ng-model=\"vm.push.targets.registeredIn.dtEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2\"><label for=\"uk_dp_end\">Data de Nascimento Inicial</label><div class=\"md-input-wrapper2\"><input class=\"md-input-2\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormatNotime}}\" md-input=\"\" ng-model=\"vm.push.targets.bornIn.dtIni\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div></div><div class=\"uk-width-medium-1-2\"><label for=\"uk_dp_end\">Data de Nascimento Final</label><div class=\"md-input-wrapper2\"><input class=\"md-input-2\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormatNotime}}\" md-input=\"\" ng-model=\"vm.push.targets.bornIn.dtEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2\"><label>Sexo</label><selectize class=\"custom_selectize\" config=\"vm.selectize_gender_config\" options=\"vm.selectize_gender_data\" ng-model=\"vm.push.targets.gender\" name=\"gender\" id=\"gender\" position=\"bottom\"></selectize></div><div class=\"uk-width-medium-1-2\"><label>Especialidade</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Adicione um ou mais itens\" options=\"vm.selectize_especialidadesMensagem\" name=\"espec\" id=\"spec\" config=\"vm.selectize_especialidadesMensagem_config\" ng-model=\"vm.push.targets.specialty\" position=\"bottom\"></selectize></div></div></div></div><div class=\"uk-form-row\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1\"><label>Cidade</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Adicione um ou mais itens\" options=\"vm.myOptions2\" name=\"espec\" id=\"spec\" config=\"vm.myConfig2\" ng-model=\"vm.push.targets.addressCity\"></selectize></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1\"><label>Estado</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Adicione um ou mais itens\" options=\"vm.myOptions3\" name=\"espec\" id=\"spec\" config=\"vm.myConfig3\" ng-model=\"vm.push.targets.addressState\"></selectize></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-1\"><label>País</label><div class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" placeholder=\"Adicione um ou mais itens\" options=\"vm.myOptions4\" name=\"espec\" id=\"spec\" config=\"vm.myConfig4\" ng-model=\"vm.push.targets.addressCountry\"></selectize></div></div></div></div></div></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><b>Ações</b></h3></div><div class=\"md-card-content\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-2-3\"><label>Adicionar ação</label><div class=\"md-input-wrapper2\"><selectize options=\"vm.selectize_acoes\" placeholder=\"Selecione\" class=\"custom_selectize\" position=\"bottom\" name=\"acoes\" id=\"acoes\" config=\"vm.selectize_acoes_config\" ng-model=\"vm.selectedAcao\"></selectize></div><div class=\"uk-margin-top\" ng-show=\"formPush.$submitted || formPush.acoes.$touched\"><span ng-show=\"formPush.acoes.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-1-3\"><label>&nbsp;</label><div class=\"md-input-wrapper2\" style=\"padding-top:5px !important;\"><button ng-click=\"vm.adicionarAcao(vm.selectedAcao)\" type=\"button\" ng-disabled=\"!vm.selectedAcao\" class=\"md-btn md-btn-primary md-btn-small\"><i title=\"Adicionar ação\" style=\"color: white;\" class=\"material-icons md-24\">&#xE145;</i>Adicionar ação</button></div></div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><div ng-if=\"!vm.push.actions || vm.push.actions.length == 0\" class=\"uk-alert uk-text-center uk-bg-primary\" data-uk-alert=\"\"><span>Nenhuma ação adicionada.</span></div><div ng-hide=\"vm.push.actions == undefined || vm.push.actions.length == 0\" class=\"\"><div class=\"uk-width-medium-1-1\"><div class=\"md-card\"><div class=\"md-card-content\"><div class=\"uk-form-row\" ng-repeat=\"action in vm.push.actions\"><h3 ng-if=\"action.name==\'call\'\">{{$index+1}}. Ação Ligar <i title=\"Excluir ação\" class=\"md-icon material-icons\" ng-click=\"vm.removerAcao($index)\">&#xE872;</i></h3><h3 ng-if=\"action.name==\'email\'\">{{$index+1}}. Ação E-mail <i title=\"Excluir ação\" class=\"md-icon material-icons\" ng-click=\"vm.removerAcao($index)\">&#xE872;</i></h3><h3 ng-if=\"action.name==\'link\'\">{{$index+1}}. Ação Abrir URL <i title=\"Excluir ação\" class=\"md-icon material-icons\" ng-click=\"vm.removerAcao($index)\">&#xE872;</i></h3><div class=\"uk-form-row\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-2-4\"><label>Título</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"action_title\" name=\"action_title\" ng-model=\"action.title\" md-input=\"\"></div></div><div class=\"uk-width-medium-2-4\"><div class=\"uk-grid\" ng-if=\"vm.validarConteudo(\'1\')\"><div class=\"uk-width-2-10 uk-width-small-2-10\"><label class=\"uk-text-small\">Ícone</label> <i class=\"material-icons md-user-image\" ng-if=\"!action.icon\" style=\"font-size:30px; padding:12px 0 0 0;\">&#xe611;</i> <i class=\"mobilecare-icons md-user-image\" ng-if=\"action.icon\" ng-bind-html=\"\'&#x\' + action.icon\" style=\"font-size:30px; padding:12px 0 0 0;\"></i> <span style=\"font-size:10px; font-style:italic; padding-left:4px;\">{{action.icon}}</span></div><div class=\"uk-width-8-10 uk-width-small-8-10\"><a id=\"btnAddCategoryIcon\" class=\"md-btn md-btn-flat md-btn-small md-btn-primary\" style=\"margin:30px;\" ng-click=\"vm.openModalIcons(action)\">Selecionar</a></div></div></div></div></div><div class=\"uk-form-row\"><div ng-if=\"!action.parameters || action.parameters.length == 0\" class=\"uk-alert uk-bg-primary uk-text-center\" data-uk-alert=\"\"><span>Nenhum parâmetro adicionado. Clique o <i class=\"material-icons\">&#xE145;</i> para adicionar um novo parâmetro.</span></div><h4 ng-if=\"action.parameters && action.parameters.length > 0\" class=\"heading_c full_width_in_card\" style=\"margin: 0 -16px 0 -16px !important;\">Parâmetros</h4><div ng-if=\"action.parameters && action.parameters.length > 0\" class=\"uk-overflow-container uk-margin-top\"><table class=\"uk-table\"><tbody><tr ng-repeat=\"param in action.parameters\"><td class=\"uk-width-3-10\"><label>Insira uma descrição</label><div class=\"md-input-wrapper2\" style=\"padding-top:5px !important;\"><input type=\"text\" class=\"md-input-2\" id=\"param_desc\" name=\"param_desc\" ng-model=\"param.title\" md-input=\"\"></div></td><td ng-if=\"action.name==\'call\'\" class=\"uk-width-3-10\"><label>Insira um telefone válido</label><div class=\"md-input-wrapper2\" style=\"padding-top:5px !important;\"><input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" type=\"text\" ng-minlength=\"11\" class=\"md-input-2\" id=\"param_val{{$parent.$index}}{{$index}}_call\" name=\"param_val{{$parent.$index}}{{$index}}_call\" ng-model=\"param.value\" md-input=\"\" required=\"\"></div><div ng-show=\"formPush.$submitted || formPush.param_val{{$parent.$index}}{{$index}}_call.$touched\"><span ng-show=\"formPush.param_val{{$parent.$index}}{{$index}}_call.$error.required || formPush.param_val{{$parent.$index}}{{$index}}_call.$error.number\" class=\"md-error\">Campo Obrigatório</span></div><div ng-show=\"formPush.$submitted || formPush.param_val{{$parent.$index}}{{$index}}_call.$touched\"><span ng-show=\"((formPush.param_val{{$parent.$index}}{{$index}}_call.$error.minlength || formPush.param_val{{$parent.$index}}{{$index}}_call.$error.maxlength) && formPush.param_val{{$parent.$index}}{{$index}}_call.$dirty)\" class=\"md-error\">Número de telefone deve possuir no mínimo 11 caracteres</span></div></td><td ng-if=\"action.name==\'email\'\" class=\"uk-width-3-10\"><label>Insira um e-mail válido</label><div class=\"md-input-wrapper2\" style=\"padding-top:5px !important;\"><input type=\"email\" class=\"md-input-2\" id=\"param_val{{$parent.$index}}{{$index}}_email\" name=\"param_val{{$parent.$index}}{{$index}}_email\" ng-model=\"param.value\" md-input=\"\" required=\"\"></div><div ng-show=\"formPush.$submitted || formPush.param_val{{$parent.$index}}{{$index}}_email.$touched\"><span ng-show=\"formPush.param_val{{$parent.$index}}{{$index}}_email.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"formPush.param_val{{$parent.$index}}{{$index}}_email.$error.email\" class=\"md-error\">E-mail inválido</span></div></td><td ng-if=\"action.name==\'link\'\" class=\"uk-width-3-10\"><label>Insira uma URL válida</label><div class=\"md-input-wrapper2\" style=\"padding-top:5px !important;\"><input type=\"text\" class=\"md-input-2\" id=\"param_val{{$parent.$index}}{{$index}}_link\" name=\"param_val{{$parent.$index}}{{$index}}_link\" ng-model=\"param.value\" md-input=\"\" ng-pattern=\"/^(http[s]?:\\/\\/){0,1}(www\\.){0,1}[a-zA-Z0-9\\.\\-]+\\.[a-zA-Z]{2,5}[\\.]{0,1}/\" required=\"\"></div><div ng-show=\"formPush.$submitted || formPush.param_val{{$parent.$index}}{{$index}}_link.$touched\"><span ng-show=\"formPush.param_val{{$parent.$index}}{{$index}}_link.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"formPush.param_val{{$parent.$index}}{{$index}}_link.$error.pattern\" class=\"md-error\">Url inválida</span></div></td><td class=\"uk-width-3-10 uk-text-center\"><label>&nbsp;</label><div class=\"md-input-wrapper2\" style=\"padding-top:5px !important;\"><button ng-show=\"!$last\" type=\"button\" style=\"color: transparent; background-color: transparent; border-color: transparent; cursor: default;box-shadow: none !important;\" disabled=\"\" class=\"uk-margin-small-top md-btn\"></button> <button ng-show=\"$last\" title=\"Adicionar novo parâmetro\" ng-click=\"vm.inserirNovoParametro(action)\" type=\"button\" class=\"uk-margin-small-top md-btn\"><i class=\"material-icons md-24\">&#xE145;</i></button> <a ng-show=\"!$first\" title=\"Excluir item\" ng-click=\"vm.removerParametro(action.parameters, $index)\" href=\"\" class=\"md-btn md-btn-danger uk-margin-small-top\"><i class=\"material-icons\" style=\"color:white\">&#xE872;</i></a></div></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></form></div></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a type=\"button\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\" ui-sref=\"private.painel.mensagem.list\">Sim</a></div></div></div></div></div><div class=\"uk-modal custom uk-open modalIcons\" id=\"modalIcons\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Ícones</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-text-center uk-width-1-1\"><i ng-repeat=\"item in vm.iconsCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIcon(item)\"></i></div></div></div></div></div></div>");
$templateCache.put("app/push/push.detail.html","<div class=\"loading-spinner\" ng-if=\"vm.isLoadingDetail\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingDetail\" class=\"scrum_column\"><div id=\"scrum_column_inProgress\"><div><div id=\"detalheDiv\" data-uk-grid=\"{gutter:15}\" class=\"uk-text-small\"><div class=\"uk-width-medium-1-1\"><div class=\"md-card grow1\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-file-text fleury-color-default\" style=\"padding-right:5px\"></i> DADOS GERAIS</span></h2><button ng-if=\"vm.isMensagemEditarPermitido && !vm.mensagem.alreadySent\" title=\"Excluir mensagem\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" ng-click=\"vm.confirmRemoval(vm.mensagem)\"><i class=\"md-icon material-icons\">&#xE872;</i></button> <button ng-if=\"vm.isMensagemEditarPermitido && !vm.mensagem.alreadySent\" ui-sref=\"private.painel.mensagem.edit({id: vm.mensagem.id})\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Editar mensagem\"><i class=\"md-icon material-icons\">&#xE3C9;</i></button></div><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data/Hora de Criação</span> <span class=\"\">{{vm.mensagem.dtCreated}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data/Hora de Agendamento</span> <span class=\"\">{{vm.mensagem.dtSchedule}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data/Hora do Envio</span> <span class=\"\">{{vm.mensagem.dtSent}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Tipo</span> <span ng-if=\"vm.mensagem.sendPush && vm.mensagem.sendInbox\">Ambos</span> <span ng-if=\"vm.mensagem.sendPush && !vm.mensagem.sendInbox\">Push</span> <span ng-if=\"vm.mensagem.sendInbox && !vm.mensagem.sendPush\">Inbox</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Assunto</span> <span class=\"\">{{vm.mensagem.subject}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Texto Push</span> <span class=\"\">{{vm.mensagem.contentPush}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Texto Inbox</span> <span ng-bind-html=\"vm.mensagem.content\"></span></div></li></ul></div></div></div><div class=\"uk-width-medium-1-1\" style=\"z-index:10;\"><div class=\"md-card grow2\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-user fleury-color-default\" style=\"padding-right:5px\"></i> DESTINATÁRIOS</span></h2></div><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Público alcançado (inbox)</span> <span class=\"\">{{vm.mensagem.totalInbox}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Público alcançado (push)</span> <span class=\"\">{{vm.mensagem.totalPush}}</span></div></li></ul></div></div></div><div class=\"uk-width-medium-1-1\"><div class=\"md-card grow3\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-edit fleury-color-default\" style=\"padding-right:5px\"></i> AÇÕES</span></h2></div><div data-uk-observe=\"\"><div class=\"md-card-content\"><div ng-if=\"!vm.mensagem.actions || vm.mensagem.actions.length == 0\" class=\"uk-alert uk-text-center uk-bg-primary\" data-uk-alert\"=\"\"><span>Nenhuma ação cadastrada para essa mensagem/notificação.</span></div><div ng-if=\"vm.mensagem.actions && vm.mensagem.actions.length > 0\" class=\"md-list-content\" ng-repeat=\"action in vm.mensagem.actions\"><div><div class=\"md-list-heading md-bg-grey-400 uk-text-bold md-color-grey-900\" style=\"padding:8px 8px;\"><span ng-if=\"action.Title\">{{action.Title}}</span> <span ng-if=\"action.title\">{{action.title}}</span> <span ng-if=\"action.Name\">- {{action.Name}}</span> <span ng-if=\"action.name\">- {{action.name}}</span></div><div class=\"md-list-heading md-bg-grey-300 uk-text-bold md-color-grey-900\" style=\"padding:8px 8px;\"><span>Parâmetros</span></div><div ng-if=\"action.Parameters\" class=\"uk-text-muted uk-margin-top\" ng-repeat=\"param in action.Parameters\"><ul class=\"uk-margin-left\"><li><span ng-if=\"param.Title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.Title}}</span> <span ng-if=\"param.title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.title}}</span></li><li><span ng-if=\"param.Value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.Value}}</span> <span ng-if=\"param.value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.value}}</span></li></ul><hr></div><div ng-if=\"action.parameters\" class=\"uk-text-muted uk-margin-top\" ng-repeat=\"param in action.parameters\"><ul class=\"uk-margin-left\"><li><span ng-if=\"param.Title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.Title}}</span> <span ng-if=\"param.title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.title}}</span></li><li><span ng-if=\"param.Value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.Value}}</span> <span ng-if=\"param.value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.value}}</span></li></ul><hr></div></div></div></div></div></div></div></div></div></div></div><style type=\"text/css\">\r\n  @keyframes anim-ltr {\r\n    0% {\r\n      left: 10000px;\r\n    }\r\n    100% {\r\n      left: 0;\r\n    }\r\n  }\r\n\r\n  .grow1 {\r\n    animation: anim-ltr 600ms;\r\n  }\r\n\r\n  .grow2 {\r\n    animation: anim-ltr 800ms;\r\n  }\r\n\r\n  .grow3 {\r\n    animation: anim-ltr 1100ms;\r\n  }\r\n\r\n  .grow4 {\r\n    animation: anim-ltr 1500ms;\r\n  }\r\n\r\n  .uk-text-black {\r\n    color: #333 !important;\r\n  }\r\n\r\n  .uk-text-italic {\r\n    font-style: italic !important;\r\n  }\r\n\r\n  .uk-accordion-title:after {\r\n    content: \'\';\r\n  }\r\n\r\n  .fleury-color-default {\r\n    color: #666 !important;\r\n  }\r\n\r\n  .md-card .md-card-toolbar {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;\r\n  }\r\n</style>");
$templateCache.put("app/push/push.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\" ng-if=\"vm.isMensagemCadastrarPermitido\"><a class=\"md-fab md-fab-small md-fab-primary\" ui-sref=\"private.painel.mensagem.list.create\"><i class=\"material-icons\">&#xE145;</i></a></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xe0c9;</i><a target=\"#\">&nbsp;Mensagens</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Mensageria</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">PESQUISA</h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><a title=\"Atualizar lista de mensagens\" ng-click=\"vm.search(vm.FILTERS_REFRESH, vm.FILTERS_REFRESH.sort)\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D5;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">MENSAGENS <span ng-show=\"vm.mensagens.length\">({{vm.mensagens.length}}) Registro(s)</span></h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">DETALHES</h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><form ng-if=\"vm.isMensagemPesquisarPermitido\" style=\"height: 15em\" name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.search(vm.filters)\" novalidate=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Criação</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start_create\" name=\"uk_dp_start_create\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtCreatedStart\" ng-required=\"vm.filters.dtCreatedStart\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start_create.$touched\"><span ng-show=\"form.uk_dp_start_create.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end_create\" name=\"uk_dp_end_create\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtCreatedEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end_create.$touched\"><span ng-show=\"form.uk_dp_end_create.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Agendamento</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start_schedule\" name=\"uk_dp_start_schedule\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtScheduleStart\" ng-required=\"vm.filters.dtScheduleStart\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start_schedule.$touched\"><span ng-show=\"form.uk_dp_start_schedule.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end_schedule\" name=\"uk_dp_end_schedule\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtScheduleEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end_schedule.$touched\"><span ng-show=\"form.uk_dp_end_schedule.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Envio</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start_send\" name=\"uk_dp_start_send\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtSentStart\" ng-required=\"vm.filters.dtSentStart\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start_send.$touched\"><span ng-show=\"form.uk_dp_start_send.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end_send\" name=\"uk_dp_end_send\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtSentEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end_send.$touched\"><span ng-show=\"form.uk_dp_end_send.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Tipo</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"category_name_filter\" name=\"category_name_filter\" config=\"vm.selectize_tipos_config\" options=\"vm.selectize_tipos\" position=\"bottom\" ng-model=\"vm.filters.selectize_tiposModel\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Assunto</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"form_filter\" name=\"form_filter\" value=\"\" ng-model=\"vm.filters.subject\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></div></form></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.mensagens.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum registro encontrado.</span></h3></div></div><div ng-if=\"!vm.isLoading && vm.mensagens.length > 0\" auto-height=\"\"><div id=\"colunaAttendances\" class=\"scrum_column\"><div id=\"chamadosLista\"><div class=\"scrum_task\" ng-repeat=\"item in vm.mensagens\" ng-class=\"{ \'chamado-active\': $index == vm.selectedIndex}\" ng-click=\"vm.detailMensagem(item.id, $index)\" style=\"z-index:0;margin-bottom:5px;cursor:pointer\"><div class=\"critical\"><p class=\"scrum_task_description\">&raquo; <b>Data/Hora de Criação:</b> &nbsp; {{item.dtCreated}}</p><p class=\"scrum_task_description\">&raquo; <b>Data/Hora de Agendamento:</b> &nbsp; {{item.dtSchedule}}</p><p class=\"scrum_task_description\">&raquo; <b>Data/Hora do Envio:</b> &nbsp; {{item.dtSent}}</p><p class=\"scrum_task_description\">&raquo; <b>Tipo:</b> &nbsp; <span ng-if=\"item.sendPush && item.sendInbox\">Ambos</span> <span ng-if=\"item.sendPush && !item.sendInbox\">Push</span> <span ng-if=\"item.sendInbox && !item.sendPush\">Inbox</span></p><p class=\"scrum_task_description\">&raquo; <b>Assunto:</b> &nbsp; {{item.subject}}</p></div></div></div></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.mensagens.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Detalhe não disponível.</span></h3></div></div><div ng-if=\"vm.mensagens.length > 0 && vm.isMensagemVisualizarPermitido\" ui-view=\"\" auto-height=\"\"></div></div></div></div></div><style type=\"text/css\">\r\n    .grow-scale {\r\n        animation: anim-sc 400ms;\r\n    }\r\n\r\n    @keyframes anim-sc {\r\n        0% {\r\n            transform: scale(0);\r\n        }\r\n        100% {\r\n            transform: scale(1);\r\n        }\r\n    }\r\n</style>");
$templateCache.put("app/push.api.log/pushlog.detail.html","<div class=\"loading-spinner\" ng-if=\"vm.isLoadingDetail\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingDetail\" class=\"scrum_column\"><div id=\"scrum_column_inProgress\"><div><div id=\"detalheDiv\" data-uk-grid=\"{gutter:15}\" class=\"uk-text-small\"><br><div class=\"uk-width-medium-1-1\"><div class=\"md-card grow1\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-file-text fleury-color-default\" style=\"padding-right:5px\"></i> DADOS GERAIS</span></h2></div><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data/Hora de Criação</span> <span class=\"\">{{vm.mensagem.dtCreated}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data/Hora de Agendamento</span> <span class=\"\">{{vm.mensagem.dtSchedule}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data/Hora do Envio</span> <span class=\"\">{{vm.mensagem.dtSent}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Criado por</span> <span class=\"\">{{vm.mensagem.author}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Tipo</span> <span ng-if=\"vm.mensagem.sendPush && vm.mensagem.sendInbox\">Ambos</span> <span ng-if=\"vm.mensagem.sendPush && !vm.mensagem.sendInbox\">Push</span> <span ng-if=\"vm.mensagem.sendInbox && !vm.mensagem.sendPush\">Inbox</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Assunto</span> <span class=\"\">{{vm.mensagem.subject}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Texto Push</span> <span class=\"\">{{vm.mensagem.contentPush}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Texto Inbox</span> <span ng-bind-html=\"vm.mensagem.content\"></span></div></li></ul></div></div></div><div class=\"uk-width-medium-1-1\" style=\"z-index:10;\"><div class=\"md-card grow2\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-user fleury-color-default\" style=\"padding-right:5px\"></i> DESTINATÁRIOS</span></h2></div><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Público alcançado (inbox)</span> <span class=\"\">{{vm.mensagem.targetsCountInbox}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Público alcançado (push)</span> <span class=\"\">{{vm.mensagem.targetsCountPush}}</span></div></li></ul></div></div></div><div class=\"uk-width-medium-1-1\"><div class=\"md-card grow3\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-medium uk-icon-edit fleury-color-default\" style=\"padding-right:5px\"></i> AÇÕES</span></h2></div><div data-uk-observe=\"\"><div class=\"md-card-content\"><div ng-if=\"!vm.mensagem.actions || vm.mensagem.actions.length == 0\" class=\"uk-alert uk-text-center\" data-uk-alert=\"\" style=\"background-color:{{vm.appCompany.appStyle.colorBase}}\"><span>Nenhuma ação cadastrada para essa mensagem/notificação.</span></div><div ng-if=\"vm.mensagem.actions && vm.mensagem.actions.length > 0\" class=\"md-list-content\" ng-repeat=\"action in vm.mensagem.actions\"><div><div class=\"md-list-heading md-bg-grey-400 uk-text-bold md-color-grey-900\" style=\"padding:8px 8px;\"><span ng-if=\"action.Title\">{{action.Title}}</span> <span ng-if=\"action.title\">{{action.title}}</span> <span ng-if=\"action.Name\">- {{action.Name}}</span> <span ng-if=\"action.name\">- {{action.name}}</span></div><div class=\"md-list-heading md-bg-grey-300 uk-text-bold md-color-grey-900\" style=\"padding:8px 8px;\"><span>Parâmetros</span></div><div ng-if=\"action.Parameters\" class=\"uk-text-muted uk-margin-top\" ng-repeat=\"param in action.Parameters\"><ul class=\"uk-margin-left\"><li><span ng-if=\"param.Title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.Title}}</span> <span ng-if=\"param.title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.title}}</span></li><li><span ng-if=\"param.Value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.Value}}</span> <span ng-if=\"param.value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.value}}</span></li></ul><hr></div><div ng-if=\"action.parameters\" class=\"uk-text-muted uk-margin-top\" ng-repeat=\"param in action.parameters\"><ul class=\"uk-margin-left\"><li><span ng-if=\"param.Title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.Title}}</span> <span ng-if=\"param.title\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Título:</b> {{param.title}}</span></li><li><span ng-if=\"param.Value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.Value}}</span> <span ng-if=\"param.value\" class=\"uk-text-small uk-text-break uk-text-muted\"><b>Valor:</b> {{param.value}}</span></li></ul><hr></div></div></div></div></div></div></div></div></div></div></div><style type=\"text/css\">\r\n  @keyframes anim-ltr {\r\n    0% {\r\n      left: 10000px;\r\n    }\r\n    100% {\r\n      left: 0;\r\n    }\r\n  }\r\n\r\n  .grow1 {\r\n    animation: anim-ltr 600ms;\r\n  }\r\n\r\n  .grow2 {\r\n    animation: anim-ltr 800ms;\r\n  }\r\n\r\n  .grow3 {\r\n    animation: anim-ltr 1100ms;\r\n  }\r\n\r\n  .grow4 {\r\n    animation: anim-ltr 1500ms;\r\n  }\r\n\r\n  .uk-text-black {\r\n    color: #333 !important;\r\n  }\r\n\r\n  .uk-text-italic {\r\n    font-style: italic !important;\r\n  }\r\n\r\n  .uk-accordion-title:after {\r\n    content: \'\';\r\n  }\r\n\r\n  .fleury-color-default {\r\n    color: #666 !important;\r\n  }\r\n\r\n  .md-card .md-card-toolbar {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;\r\n  }\r\n</style>");
$templateCache.put("app/push.api.log/pushlog.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xe0c9;</i><a target=\"#\">&nbsp;Log da API</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Mensageria</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">PESQUISA</h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><a title=\"Atualizar lista de mensagens\" ng-click=\"vm.search(vm.FILTERS_REFRESH, vm.FILTERS_REFRESH.sort)\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D5;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">MENSAGENS <span ng-show=\"vm.mensagens.length\">({{vm.mensagens.length}}) Registro(s)</span></h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">DETALHES</h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><form ng-if=\"vm.isMensagemPesquisarPermitido\" style=\"height: 15em\" name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.search(vm.filters)\" novalidate=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Criação</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start_create\" name=\"uk_dp_start_create\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtCreatedStart\" ng-required=\"vm.filters.dtCreatedStart\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start_create.$touched\"><span ng-show=\"form.uk_dp_start_create.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end_create\" name=\"uk_dp_end_create\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtCreatedEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end_create.$touched\"><span ng-show=\"form.uk_dp_end_create.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Agendamento</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start_schedule\" name=\"uk_dp_start_schedule\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtScheduleStart\" ng-required=\"vm.filters.dtScheduleStart\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start_schedule.$touched\"><span ng-show=\"form.uk_dp_start_schedule.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end_schedule\" name=\"uk_dp_end_schedule\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtScheduleEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end_schedule.$touched\"><span ng-show=\"form.uk_dp_end_schedule.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Envio</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start_send\" name=\"uk_dp_start_send\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtSentStart\" ng-required=\"vm.filters.dtSentStart\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start_send.$touched\"><span ng-show=\"form.uk_dp_start_send.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtSentEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Tipo</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"category_name_filter\" name=\"category_name_filter\" config=\"vm.selectize_tipos_config\" options=\"vm.selectize_tipos\" position=\"bottom\" ng-model=\"vm.filters.selectize_tiposModel\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Assunto</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"form_filter\" name=\"form_filter\" value=\"\" ng-model=\"vm.filters.subject\" md-input=\"\"></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></div></form></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.mensagens.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum registro encontrado.</span></h3></div></div><div ng-if=\"!vm.isLoading && vm.mensagens.length > 0\" auto-height=\"\"><div id=\"colunaAttendances\" class=\"scrum_column\"><div id=\"chamadosLista\"><div class=\"scrum_task\" ng-repeat=\"item in vm.mensagens\" ng-class=\"{ \'chamado-active\': $index == vm.selectedIndex}\" ng-click=\"vm.detailMensagem(item.id, $index)\" style=\"z-index:0;margin-bottom:5px;cursor:pointer\"><div class=\"critical\"><p class=\"scrum_task_description\">&raquo; <b>Data/Hora de Criação:</b> &nbsp; {{item.dtCreated}}</p><p class=\"scrum_task_description\">&raquo; <b>Data/Hora de Agendamento:</b> &nbsp; {{item.dtSchedule}}</p><p class=\"scrum_task_description\">&raquo; <b>Data/Hora do Envio:</b> &nbsp; {{item.dtSent}}</p><p class=\"scrum_task_description\">&raquo; <b>Tipo:</b> &nbsp; <span ng-if=\"item.sendPush && item.sendInbox\">Ambos</span> <span ng-if=\"item.sendPush && !item.sendInbox\">Push</span> <span ng-if=\"item.sendInbox && !item.sendPush\">Inbox</span></p><p class=\"scrum_task_description\">&raquo; <b>Assunto:</b> &nbsp; {{item.subject}}</p></div></div></div></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.mensagens.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Detalhe não disponível.</span></h3></div></div><div ng-if=\"vm.mensagens.length > 0 && vm.isMensagemVisualizarPermitido\" ui-view=\"\" auto-height=\"\"></div></div></div></div></div><style type=\"text/css\">\r\n    .grow-scale {\r\n        animation: anim-sc 400ms;\r\n    }\r\n\r\n    @keyframes anim-sc {\r\n        0% {\r\n            transform: scale(0);\r\n        }\r\n        100% {\r\n            transform: scale(1);\r\n        }\r\n    }\r\n</style>");
$templateCache.put("app/relatorios/atendimento.grouplist.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Relatório Sintético</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Relatórios</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">PESQUISA</h3></div></div></div></div><div class=\"uk-width-8-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">SOLICITAÇÕES</h3></div></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><form name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.search(vm.filters)\" novalidate=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\" class=\"scrum_column\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período</label><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.dateIniSet\" ng-required=\"vm.dateIniSet\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.dateEndSet\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Agrupar período informado por</label><div class=\"md-input-wrapper\" style=\"border-top: 1px solid #ccc\"><ul class=\"uk-subnav uk-subnav-pill\" data-uk-switcher=\"{connect:\'#switcher-content-a-fade\', animation: \'fade\'}\"><li><a href=\"\" ng-click=\"vm.setGroupPeriodType(0)\">Período</a></li><li><a href=\"\" ng-click=\"vm.setGroupPeriodType(1)\">Dia</a></li><li class=\"uk-active\"><a href=\"\" ng-click=\"vm.setGroupPeriodType(2)\">Mês</a></li><li><a href=\"\" ng-click=\"vm.setGroupPeriodType(3)\">Ano</a></li></ul></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Categoria</label> <span ng-if=\"vm.filters.groupByCategory\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(124, 179, 66, 0.498039) 0px 0px 0px 7px inset; border-color: rgba(124, 179, 66, 0.498039); background-color: #bedff4; transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small style=\"left: 18px; background-color: #2494d8; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableCategory()\"></small></span> <span style=\"color:#00a8e6; width:150px\">Ativo</span></span> <span ng-if=\"!vm.filters.groupByCategory\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive_category\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: rgb(250, 250, 250); transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableCategory()\"></small></span> <span style=\"color:red; width:150px\">Inativo</span></span><div class=\"md-input-wrapper\" ng-if=\"vm.filters.groupByCategory\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"category_name_filter\" ng-change=\"vm.changeCategory()\" ng-keyup=\"vm.changeCategory()\" name=\"category_name_filter\" config=\"vm.selectize_sources_categories_config\" options=\"vm.selectize_sources_categories\" position=\"bottom\" ng-model=\"vm.filters.categoryId\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Serviço</label> <span class=\"\" style=\"color:green; width:150px\" ng-if=\"vm.filters.groupByService\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(124, 179, 66, 0.498039) 0px 0px 0px 7px inset; border-color: rgba(124, 179, 66, 0.498039); background-color: #bedff4; transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small style=\"left: 18px; background-color: #2494d8; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableService()\"></small></span> <span style=\"color:#00a8e6; width:150px\">Ativo</span></span> <span class=\"\" style=\"color:red; width:150px\" ng-if=\"!vm.filters.groupByService\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive_service\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: rgb(250, 250, 250); transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableService()\"></small></span> <span style=\"color:red; width:150px\">Inativo</span></span><div class=\"md-input-wrapper\" ng-if=\"vm.filters.groupByService\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"services_name_filter\" name=\"services_name_filter\" config=\"vm.selectize_sources_services_config\" options=\"vm.selectize_sources_services\" position=\"bottom\" ng-model=\"vm.filters.serviceIds\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Situação</label> <span class=\"\" style=\"color:green; width:150px\" ng-if=\"vm.filters.groupBySituation\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(124, 179, 66, 0.498039) 0px 0px 0px 7px inset; border-color: rgba(124, 179, 66, 0.498039); background-color: #bedff4; transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small style=\"left: 18px; background-color: #2494d8; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableSituation()\"></small></span> <span style=\"color:#00a8e6; width:150px\">Ativo</span></span> <span class=\"\" style=\"color:red; width:150px\" ng-if=\"!vm.filters.groupBySituation\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive_situation\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: rgb(250, 250, 250); transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableSituation()\"></small></span> <span style=\"color:red; width:150px\">Inativo</span></span><div class=\"md-input-wrapper\" ng-if=\"vm.filters.groupBySituation\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"situation_name_filter\" name=\"situation_name_filter\" config=\"vm.selectize_sources_situations_config\" options=\"vm.selectize_sources_situations\" position=\"bottom\" ng-model=\"vm.filters.situationIds\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Usuário</label> <span class=\"\" style=\"color:green; width:150px\" ng-if=\"vm.filters.groupByUser\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(124, 179, 66, 0.498039) 0px 0px 0px 7px inset; border-color: rgba(124, 179, 66, 0.498039); background-color: #bedff4; transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small style=\"left: 18px; background-color: #2494d8; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableUser()\"></small></span> <span style=\"color:#00a8e6; width:150px\">Ativo</span></span> <span class=\"\" style=\"color:red; width:150px\" ng-if=\"!vm.filters.groupByUser\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive_user\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: rgb(250, 250, 250); transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.enableUser()\"></small></span> <span style=\"color:red; width:150px\">Inativo</span></span><div class=\"md-input-wrapper\" ng-if=\"vm.filters.groupByUser\"><input class=\"md-input-2\" type=\"text\" id=\"uk_user\" name=\"uk_user\" md-input=\"\" ng-model=\"vm.filters.userDescription\" ng-required=\"vm.filters.userDescription\"></div></div></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div><div class=\"uk-width-8-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"scrum_column\" ng-if=\"!vm.isLoading\"><div class=\"md-card grow-rtf\" style=\"background: white;\"><div ng-if=\"!vm.isLoadingTable && !vm.isLoading\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-th-list uk-icon-medium\" style=\"color:{{vm.appCompany.appStyle.colorBase}} !important; padding-right:5px;\"></i> INFORMAÇÕES DAS SOLICITAÇÕES</span></h2></div><div class=\"md-card-content\"><div class=\"uk-overflow-container\"><table id=\"tableRelatorio\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" class=\"uk-table\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Data</th><th ng-if=\"vm.showCategory\" class=\"uk-text-center\">Categoria</th><th ng-if=\"vm.showService\" class=\"uk-text-center\">Serviço</th><th ng-if=\"vm.showSituation\" class=\"uk-text-center\">Situação</th><th ng-if=\"vm.showUser\" class=\"uk-text-center\">Usuário</th><th class=\"uk-text-center\">Total</th><th class=\"uk-text-center\">Sla Vigente</th><th class=\"uk-text-center\">Sla Expirado</th><th class=\"uk-text-center\">Aberta</th><th class=\"uk-text-center\">Encerrada com Sucesso</th><th class=\"uk-text-center\">Encerrada sem Sucesso</th><th class=\"uk-text-center\">Cancelada</th></tr></thead><tbody><tr ng-repeat=\"item in vm.relatorio\"><td class=\"uk-text-nowrap uk-text-center\">{{item.dateGroupFormatted}}</td><td ng-if=\"vm.showCategory\" class=\"uk-text-nowrap uk-text-center\">{{item.categoryDescription}}</td><td ng-if=\"vm.showService\" class=\"uk-text-nowrap uk-text-center\">{{item.serviceDescription}}</td><td ng-if=\"vm.showSituation\" class=\"uk-text-nowrap uk-text-center\">{{item.situationDescription}}</td><td ng-if=\"vm.showUser\" class=\"uk-text-nowrap uk-text-center\">{{item.userDescription}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.total}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.totalInSla}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.totalOutSla}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.totalSituationType_Aberta}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.totalSituationType_EncerramentoComSucesso}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.totalSituationType_EncerramentoSemSucesso}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.totalSituationType_Cancelamento}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div><style type=\"text/css\">\r\n.grow-scale {animation: anim-sc 400ms;} @keyframes anim-sc {0% {transform: scale(0);} 100% {transform: scale(1);}}\r\n.grow-rtf {animation: anim-ltr 700ms;} @keyframes anim-ltr {0% {left: 10000px;}100% {left: 0;}}\r\n.uk-pagination > li.uk-active > a, .uk-pagination > li.uk-active > span {\r\n    background: {{vm.appCompany.appStyle.colorBase}} !important;\r\n}\r\n.uk-subnav-pill > .uk-active > * {\r\n        background: #00a8e6;\r\n    }\r\n.uk-pagination > li.uk-active > a, .uk-pagination > li.uk-active > span {\r\n    background: #2494d8;\r\n}\r\n</style>");
$templateCache.put("app/relatorios/atendimento.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Relatório Analítico</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Relatórios</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">PESQUISA</h3></div></div></div></div><div class=\"uk-width-8-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">SOLICITAÇÕES</h3></div></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><form name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\"><div class=\"uk-text-small uk-text-muted\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período</label><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.dateIniSet\" ng-required=\"vm.dateIniSet\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.dateEndSet\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Categoria</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"category_name_filter\" ng-change=\"vm.changeCategory()\" ng-keyup=\"vm.changeCategory()\" name=\"category_name_filter\" config=\"vm.selectize_sources_categories_config\" options=\"vm.selectize_sources_categories\" position=\"bottom\" ng-model=\"vm.filters.categoryId\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Serviço</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"services_name_filter\" name=\"services_name_filter\" config=\"vm.selectize_sources_services_config\" options=\"vm.selectize_sources_services\" position=\"bottom\" ng-model=\"vm.filters.serviceDescription\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Situação</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"situation_name_filter\" name=\"situation_name_filter\" config=\"vm.selectize_sources_situations_config\" options=\"vm.selectize_sources_situations\" position=\"bottom\" ng-model=\"vm.filters.situationIds\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Solicitante</label><div class=\"md-input-wrapper\"><input class=\"md-input-2\" type=\"text\" id=\"uk_user_name\" name=\"uk_user_name\" md-input=\"\" ng-model=\"vm.filters.userName\"></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>E-mail Solicitante</label><div class=\"md-input-wrapper\"><input class=\"md-input-2\" type=\"text\" id=\"uk_user_email\" name=\"uk_user_email\" md-input=\"\" ng-model=\"vm.filters.userEmail\"></div></div></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></div></form></div><div class=\"uk-width-8-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingTable\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card grow-rtf2\" style=\"background: white;\" ng-if=\"vm.visibleDataAbertura || vm.visibleNumeroOcorrencia || vm.visibleCategoria || vm.visibleServico || vm.visibleNomeUsuario || vm.visibleSituacao\"><div ng-if=\"!vm.isLoadingTable\"><div class=\"md-card-toolbar\"><p class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\"><i class=\"uk-icon-th-list uk-icon-medium\" style=\"color:{{vm.appCompany.appStyle.colorBase}} !important; padding-right:5px;\"></i> INFORMAÇÕES DAS SOLICITAÇÕES</span></p><div ng-if=\"vm.processingImages < 100\" class=\"md-card-toolbar-actions\">Processando Imagens: {{vm.processingImages | number:2}}%</div><div style=\"padding-top:10px;\" class=\"md-card-toolbar-actions\"><div ng-if=\"vm.processingImages < 100\" class=\"loading-spinner\"><svg class=\"spinner\" width=\"20px\" height=\"20px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></div><div ng-if=\"vm.processingImages == 100\" class=\"md-card-toolbar-actions\"><div class=\"dt-button buttons-print\" ng-click=\"vm.printDiv(\'exportable\')\">Imprimir</div></div></div><div class=\"md-card-content\" style=\"padding-top: 0 !important;\"><table id=\"tableRelatorio\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-instance=\"vm.dtInstance\" class=\"uk-table\" cellspacing=\"0\" width=\"100%\" style=\"padding-top: 0 !important;\"><thead><tr><th class=\"uk-text-center\"><h2 class=\"reportTitle\">Relatório Analítico de Solicitações</h2><h5 class=\"reportTitle\">{{vm.period}}</h5></th></tr></thead><tbody><tr ng-repeat=\"item in vm.relatorio\"><td class=\"uk-text-wrap uk-text-center ng-scope sorting_1\"><div class=\"md-card\" style=\"padding: 7; margin-bottom: 5px; border: 1px solid #AAAAAA !important; page-break-inside: avoid !important;\"><div class=\"md-card-content uk-grid uk-width-1-1\" style=\"text-align: left;\"><div class=\"uk-width-1-1\"><h4 style=\"margin-bottom: 0px;\">&raquo; <b>{{item.service.description}}</b></h4><hr class=\"sectionDivisor\"><br></div><br><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Ocorrência</b></div><div class=\"columnValue\">{{item.protocol}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Data Abertura</b></div><div class=\"columnValue\">{{item.attendanceDate}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Categoria</b></div><div class=\"columnValue\">{{item.service.category.description}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Solicitante</b></div><div class=\"columnValue\">{{item.userName}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>E-mail</b></div><div class=\"columnValue\">{{item.userEmail}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Situação</b></div><div class=\"columnValue\">{{item.situation.description}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Tipo de Situação</b></div><div class=\"columnValue\">{{item.situation.typeDescription}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Data Encerramento</b></div><div class=\"columnValue\">{{item.dateFinishProcess}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Data SLA</b></div><div ng-if=\"item.slaExpiredInSeconds > 0\" class=\"columnValue\">{{item.dateSLA}}<span>- excedido em: {{item.slaExpiredInSeconds | secondsToDateTime}}</span></div><div ng-if=\"item.slaExpiredInSeconds <= 0\" class=\"columnValue\">{{item.dateSLA}}<span>- restando: {{item.slaExpiredInSeconds | secondsToDateTime}}</span></div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Tempo SLA</b></div><div class=\"columnValue\">{{item.service.slaTimeSeconds | secondsToDateTime}}</div></div><div class=\"uk-width-1-1\" style=\"margin:20px 0 10px 0;\"><hr class=\"sectionDivisor\"><b class=\"columnHeader\">Respostas do formulário</b><hr class=\"sectionDivisor\"></div><div class=\"uk-width-2-10\" ng-repeat=\"itemResposta in item.answersNoImg\"><div ng-if=\'itemResposta.fieldType.toUpperCase() != \"IMAGE\"\'><div ng-if=\'itemResposta.fieldType.toUpperCase() != \"TITLE\" && itemResposta.fieldType.toUpperCase() !=\"SUBFORM\"\'><span ng-if=\"itemResposta.fieldValue[0]\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\">{{itemResposta.fieldValue[0]}}</div></span> <span ng-if=\"!itemResposta.fieldValue[0]\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\">-</div></span></div></div></div><div class=\"uk-width-1-1\" ng-repeat=\"itemResposta in item.aswersOnlyImages\"><div ng-if=\'itemResposta.fieldType.toUpperCase() == \"IMAGE\"\'><span ng-if=\"itemResposta.fieldValue.length > 0\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div id=\"fotosDiv\" class=\"gallery_grid uk-grid-width-medium-1-1\" data-uk-grid=\"{gutter: 16}\"><div><span ng-repeat=\"pic in itemResposta.images\"><a href=\"\" ng-click=\"vm.setPic(pic)\" data-uk-modal=\"{target:\'#modal_lightbox\'}\"><img ng-src=\"{{pic.link}}\" style=\"border-radius: 6px; padding: 3px; max-width: 100px; max-height: 100px; width: auto; height: auto;\" alt=\"\"></a><div class=\"uk-modal\" id=\"modal_lightbox\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox\" style=\"width: {{vm.imgTemp.width}}; min-width: {{vm.imgTemp.width}}; height: {{vm.imgTemp.height}}; min-height: {{vm.imgTemp.height}}; top: 110px !important; max-width: 800px !important; max-height: 800px !important;\"><button type=\"button\" class=\"uk-modal-close uk-close uk-close-alt\"></button> <img ng-src=\"{{vm.imgTemp.link}}\" alt=\"\"></div></div></span></div></div></span> <span ng-if=\"itemResposta.fieldValue.length == 0\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\">-</div></span></div></div></div></div></td></tr></tbody></table><div id=\"report\" hidden=\"report\"><table id=\"exportable\" datatable=\"ng\" dt-options=\"vm.dtOptionsExportable\" class=\"uk-table\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\"><h2 class=\"reportTitle\">Relatório Analítico de Solicitações</h2><h5 class=\"reportTitle\">{{vm.period}}</h5></th></tr></thead><tbody><tr ng-repeat=\"item in vm.relatorio\"><td class=\"uk-text-wrap uk-text-center ng-scope sorting_1\"><div class=\"md-card\" style=\"padding: 7; margin-bottom: 5px; border: 1px solid #AAAAAA !important; page-break-inside: avoid !important;\"><div class=\"md-card-content uk-grid uk-width-1-1\" style=\"text-align: left;\"><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Data Abertura</b></div><div class=\"columnValue\">{{item.attendanceDate}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Ocorrência</b></div><div class=\"columnValue\">{{item.protocol}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Solicitante</b></div><div class=\"columnValue\">{{item.userName}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>E-mail</b></div><div class=\"columnValue\">{{item.userEmail}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Categoria</b></div><div class=\"columnValue\">{{item.category.description}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Serviço</b></div><div class=\"columnValue\">{{item.service.description}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Situação</b></div><div class=\"columnValue\">{{item.situation.description}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Tipo de Situação</b></div><div class=\"columnValue\">{{item.situation.typeDescription}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Data Encerramento</b></div><div class=\"columnValue\">{{item.dateFinishProcess}}</div></div><div class=\"uk-width-2-10\"><div class=\"columnHeader\"><b>Data SLA</b></div><div ng-if=\"slaIsValid\" class=\"columnValue\">{{item.dateSLA}}</div><div ng-if=\"!slaIsValid\" class=\"columnValue\">{{item.dateSLA}}</div></div><div class=\"uk-width-1-1\" style=\"margin:20px 0 10px 0;\"><hr class=\"sectionDivisor\"><b class=\"columnHeader\">Respostas do formulário</b><hr class=\"sectionDivisor\"></div><div class=\"uk-width-2-10\" ng-repeat=\"itemResposta in item.answersNoImg\"><div ng-if=\'itemResposta.fieldType.toUpperCase() != \"IMAGE\"\'><div ng-if=\'itemResposta.fieldType.toUpperCase() != \"TITLE\" && itemResposta.fieldType.toUpperCase() !=\"SUBFORM\"\'><span ng-if=\"itemResposta.fieldValue[0]\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\">{{itemResposta.fieldValue[0]}}</div></span> <span ng-if=\"!itemResposta.fieldValue[0]\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\">-</div></span></div></div></div><div class=\"uk-width-1-1\" ng-repeat=\"itemResposta in item.aswersOnlyImages\"><div ng-if=\'itemResposta.fieldType.toUpperCase() == \"IMAGE\"\'><span ng-if=\"itemResposta.fieldValue.length > 0\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\" style=\"height: 100px !important;\"><div id=\"fotosDiv\" class=\"gallery_grid uk-grid-width-medium-1-1\" data-uk-grid=\"{gutter: 16}\"><div><span ng-repeat=\"pic in itemResposta.images\"><img ng-src=\"{{pic.link}}\" style=\"border-radius: 6px; padding: 3px; max-width: 100px; max-height: 100px; width: auto; height: auto;\" alt=\"\"><div class=\"uk-modal\" id=\"modal_lightbox\" aria-hidden=\"true\" style=\"display: none;\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox\" style=\"width: {{vm.imgTemp.width}}; min-width: {{vm.imgTemp.width}}; height: {{vm.imgTemp.height}}; min-height: {{vm.imgTemp.height}}; top: 110px !important; max-width: 800px !important; max-height: 800px !important;\"><button type=\"button\" class=\"uk-modal-close uk-close uk-close-alt\"></button> <img ng-src=\"{{vm.imgTemp.link}}\" alt=\"\"></div></div></span></div></div></div></span> <span ng-if=\"itemResposta.fieldValue.length == 0\"><div class=\"columnHeader\"><b>{{itemResposta.fieldLabel}}</b></div><div class=\"columnValue\">-</div></span></div></div></div></div></td></tr><h3 class=\"pag pag1\"></h3><div class=\"insert\"></div></tbody></table></div></div></div></div><div class=\"md-card\" style=\"background: white;\" ng-if=\"!vm.visibleDataAbertura && !vm.visibleNumeroOcorrencia && !vm.visibleCategoria && !vm.visibleServico && !vm.visibleNomeUsuario && !vm.visibleSituacao && !vm.isLoadingTable\"><div class=\"md-card-content\"><div class=\"uk-overflow-container uk-margin-bottom uk-text-center\"><hr><i class=\"uk-icon-info-circle uk-icon-medium\" style=\"color:{{vm.appCompany.appStyle.colorBase}} !important; padding-right:5px;\"></i> Não existem dados.<hr></div></div></div></div></div></div></div></div><style type=\"text/css\">\r\n.columnHeader{font-size:13px;}\r\n.columnValue{margin-left:12px; font-size:12px;}\r\n.sectionDivisor{margin: 0px 0px 0px 0px; border: 1px 0px 0px 0px solid #AAAAAA; height: 1px;}\r\n.reportTitle{margin:5px 0px 5px 0px; text-align:center;}\r\n.grow-scale {animation: anim-sc 400ms;} @keyframes anim-sc {0% {transform: scale(0);} 100% {transform: scale(1);}}\r\n.grow-rtf {animation: anim-ltr 700ms;} @keyframes anim-ltr {0% {left: 10000px;}100% {left: 0;}}\r\n.grow-rtf2 {animation: anim-ltr 1000ms;} @keyframes anim-ltr {0% {left: 10000px;}100% {left: 0;}}\r\n.uk-pagination > li.uk-active > a, .uk-pagination > li.uk-active > span {\r\n    background: #2494d8;\r\n}\r\n\r\n\r\n\r\n@page {\r\n  size: A4;\r\n  margin: 5%;\r\n  padding: 0 0 10%;\r\n}\r\n\r\nh3.pag {\r\n  display: none;\r\n  position: absolute;\r\n  page-break-before: always;\r\n  page-break-after: always;\r\n  bottom: 0;\r\n  right: 0;\r\n}\r\n\r\nh3::before {\r\n  position: relative;\r\n  bottom: -15px;\r\n}\r\n\r\n@media print {\r\n  h3.pag {\r\n    display: initial;\r\n  }\r\n  .print {\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n</style>");
$templateCache.put("app/relatorios/mensagens.list.html","<div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE85A;</i>Achados Críticos</span></li><li><a>Relatório de Mensagens</a></li></ul></div><div class=\"scrum_board_overflow page-padding-top\"><div id=\"scrum_board\" class=\"uk-clearfix\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-small-2-10\" auto-height=\"\" auto-height-full-height=\"false\"><form style=\"height: 40em\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><i id=\"search-action-2\" class=\"uk-icon-search\"></i> <span class=\"uk-text-bold\">PESQUISA</span></span></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingFiltros\" class=\"scrum_column\" auto-height=\"\" auto-height-full-height=\"false\"><div id=\"scrum_column_todo md-card\"><div class=\"uk-text-small uk-text-muted\"><div class=\"uk-margin-bottom\" mtm-show-errors=\"\"><label for=\"uk_dp_start\">Data de Envio Inicial</label> <input class=\"md-input\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtInicio\" ng-required=\"vm.filters.dtFim\"><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-margin-bottom\" mtm-show-errors=\"\"><label for=\"uk_dp_end\">Data de Envio Final</label> <input class=\"md-input\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.dtFim\"><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroNome\" mtm-show-errors=\"\"><label for=\"form_filter\">Destinatário</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"formdest_filter\" name=\"formdest_filter\" value=\"\" ng-model=\"vm.filters.receiverName\" md-input=\"\"><div ng-show=\"form.$submitted || form.formdest_filter.$touched\"><span ng-show=\"form.formdest_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroNome\" mtm-show-errors=\"\"><label for=\"form_filter\">Remetente</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"formrem_filter\" name=\"formrem_filter\" value=\"\" ng-model=\"vm.filters.senderName\" md-input=\"\"><div ng-show=\"form.$submitted || form.formrem_filter.$touched\"><span ng-show=\"form.formrem_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\"><label for=\"select_demo_status\">Prioridade da Mensagem</label><selectize placeholder=\"\" id=\"polos\" name=\"polos\" config=\"vm.selectize_priorities_config\" options=\"vm.selectize_priorities\" position=\"bottom\" ng-model=\"vm.filters.messagePriorityIds\"></selectize></div><div class=\"uk-margin-bottom\" id=\"divFiltroNome\" mtm-show-errors=\"\"><label for=\"form_filter\">Telefone</label> <input onkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"formtel_filter\" name=\"formtel_filter\" value=\"\" ng-model=\"vm.filters.telephoneNumber\" md-input=\"\"><div ng-show=\"form.$submitted || form.formtel_filter.$touched\"><span ng-show=\"form.formtel_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroNome\" mtm-show-errors=\"\"><label for=\"form_filter\">Descrição do Exame/Procedimento</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"formexam_filter\" name=\"formexam_filter\" value=\"\" ng-model=\"vm.filters.examName\" md-input=\"\"><div ng-show=\"form.$submitted || form.formexam_filter.$touched\"><span ng-show=\"form.formexam_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroNome\" mtm-show-errors=\"\"><label for=\"form_filter\">Nome do Paciente</label> <input ng-minlength=\"3\" type=\"text\" class=\"md-input\" id=\"formpac_filter\" name=\"formpac_filter\" value=\"\" ng-model=\"vm.filters.patientName\" md-input=\"\"><div ng-show=\"form.$submitted || form.formpac_filter.$touched\"><span ng-show=\"form.formpac_filter.$error.minlength\" class=\"help-block\">O campo deve possuir no mínimo 3 caracteres</span></div></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Contato Telefônico?</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_bool_status_config\" options=\"vm.selectize_bool_status\" position=\"bottom\" ng-model=\"vm.filters.isPhoneContactIds\"></selectize></div><div class=\"uk-margin-bottom\" id=\"divFiltroStatus\"><label for=\"select_demo_status\">Desistência?</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_bool_status_config\" options=\"vm.selectize_bool_status\" position=\"bottom\" ng-model=\"vm.filters.isNoShowIds\"></selectize></div><div class=\"uk-margin-bottom\"><label for=\"select_demo_status\">Status da Mensagem</label><selectize placeholder=\"\" id=\"status\" name=\"status\" config=\"vm.selectize_status_config\" options=\"vm.selectize_status\" position=\"bottom\" ng-model=\"vm.filters.messageReportStatusIds\"></selectize></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\">Pesquisar</button></div></div></div></div></form></div><div class=\"uk-width-small-8-10\" auto-height=\"\" auto-height-full-height=\"false\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><span class=\"uk-text-bold\">RELATÓRIO - MENSAGENS ENVIADAS</span></span></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"scrum_column\" ng-if=\"!vm.isLoading\" auto-height=\"\" auto-height-full-height=\"false\"><div class=\"md-card\" style=\"background: white;\"><div class=\"md-card-content\"><div class=\"uk-overflow-container uk-margin-bottom\"><table id=\"tableRelatorio\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" dt-instance=\"vm.dtInstance\" class=\"uk-table\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Data/Hora de Envio da Mensagem</th><th class=\"uk-text-center hide\">Data/Hora de Mensagem Recebida</th><th class=\"uk-text-center hide\">Data/Hora de Mensagem Lida</th><th class=\"uk-text-center hide\">Push Enviado?</th><th class=\"uk-text-center hide\">Tipo da Passagem</th><th class=\"uk-text-center hide\">Unidade de Realização do Exame/Procedimento</th><th class=\"uk-text-center hide\">Número de Acesso do Exame/Procedimento (Accession Number)</th><th class=\"uk-text-center hide\">Número do Prontuário</th><th class=\"uk-text-center hide\">CRM Destinatário</th><th class=\"uk-text-center\">Destinatário</th><th class=\"uk-text-center hide\">CRM Remetente</th><th class=\"uk-text-center\">Remetente</th><th class=\"uk-text-center\">Prioridade da Mensagem</th><th class=\"uk-text-center hide\">Data de Realização do Exame/Procedimento</th><th class=\"uk-text-center\">Descrição do Exame/Procedimento</th><th class=\"uk-text-center\">Nome do Paciente</th><th class=\"uk-text-center\">Telefone</th><th class=\"uk-text-center\">Status da Mensagem</th><th class=\"uk-text-center hide\">Título da Mensagem</th><th class=\"uk-text-center hide\">Conteúdo da Mensagem</th><th class=\"uk-text-center hide\">Url</th><th class=\"uk-text-center hide\">Contato Telefônico</th><th class=\"uk-text-center hide\">Data/Hora do Contato Telefônico</th><th class=\"uk-text-center hide\">Desistência</th><th class=\"uk-text-center hide\">Data/Hora da Desistência</th><th class=\"uk-text-center hide\">Data/Hora Abertura do Laudo</th><th class=\"uk-text-center hide\">Data/Hora Abertura da Imagem</th><th class=\"uk-text-center hide\">Observação</th><th class=\"uk-text-center\">Ações</th></tr></thead><tfoot><tr><th class=\"uk-text-center\">Data/Hora de Envio da Mensagem</th><th class=\"uk-text-center hide\">Data/Hora de Mensagem Recebida</th><th class=\"uk-text-center hide\">Data/Hora de Mensagem Lida</th><th class=\"uk-text-center hide\">Push Enviado?</th><th class=\"uk-text-center hide\">Tipo da Passagem</th><th class=\"uk-text-center hide\">Unidade de Realização do Exame/Procedimento</th><th class=\"uk-text-center hide\">Número de Acesso do Exame/Procedimento (Accession Number)</th><th class=\"uk-text-center hide\">Número do Prontuário</th><th class=\"uk-text-center hide\">CRM Destinatário</th><th class=\"uk-text-center\">Destinatário</th><th class=\"uk-text-center hide\">CRM Remetente</th><th class=\"uk-text-center\">Remetente</th><th class=\"uk-text-center\">Prioridade da Mensagem</th><th class=\"uk-text-center hide\">Data de Realização do Exame/Procedimento</th><th class=\"uk-text-center\">Descrição do Exame/Procedimento</th><th class=\"uk-text-center\">Nome do Paciente</th><th class=\"uk-text-center\">Telefone</th><th class=\"uk-text-center\">Status da Mensagem</th><th class=\"uk-text-center hide\">Título da Mensagem</th><th class=\"uk-text-center hide\">Conteúdo da Mensagem</th><th class=\"uk-text-center hide\">Url</th><th class=\"uk-text-center hide\">Contato Telefônico</th><th class=\"uk-text-center hide\">Data/Hora do Contato Telefônico</th><th class=\"uk-text-center hide\">Desistência</th><th class=\"uk-text-center hide\">Data/Hora da Desistência</th><th class=\"uk-text-center hide\">Data/Hora Abertura do Laudo</th><th class=\"uk-text-center hide\">Data/Hora Abertura da Imagem</th><th class=\"uk-text-center hide\">Observação</th><th class=\"uk-text-center\">Ações</th></tr></tfoot><tbody><tr ng-repeat=\"item in vm.relatorio\"><td class=\"uk-text-nowrap uk-text-center\">{{item.dtCreated}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtReceived}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtRead}}</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"item.isPushSent\">Sim</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"!item.isPushSent\">Não</td><td class=\"uk-text-nowrap uk-text-center\">{{item.movingType}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.examUnit}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.accessionNumber}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.medicalRecordNumber}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.receiverCrm}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.receiverName}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.senderCrm}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.senderName}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.messagePriority.description}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtExam}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.examName}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.patientName}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.receiverTelephoneNumber | brPhoneNumber}}</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"!item.dtReceived\">Criada</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"item.dtReceived && !item.dtRead\">Recebida</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"item.dtRead\">Lida</td><td class=\"uk-text-nowrap uk-text-center\">{{item.messageTitle }}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.messageContent | limitTo: 120 }}{{item.messageContent.length > 120 ? \'...\' : \'\' }}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.url}}</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"item.isPhoneContact\">Sim</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"!item.isPhoneContact\">Não</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtPhoneContact}}</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"item.isNoShow\">Sim</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"!item.isNoShow\">Não</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtNowShow}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtMedicalReportAccessed}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.dtMedicalReportImageAccessed}}</td><td class=\"uk-text-nowrap uk-text-center\">{{item.notes }}</td><td class=\"uk-text-nowrap uk-text-center\"><button type=\"button\" data-uk-modal=\"{target:\'#modalDetailMessage\',bgclose:false}\" title=\"Detalhar mensagem\" class=\"md-icon-mtm\" ng-click=\"vm.modalMessageOpenProcess(item.id)\"><i class=\"md-icon material-icons\">&#xE8F4;</i></button> <button ng-if=\"vm.isMessageReportEditarPermitido\" type=\"button\" data-uk-modal=\"{target:\'#modalEditMessage\',bgclose:false}\" title=\"Acompanhar mensagem\" class=\"md-icon-mtm\" ng-click=\"vm.modalMessageOpenProcess(item.id)\"><i class=\"md-icon material-icons\">&#xE3C9;</i></button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div class=\"uk-modal\" id=\"modalDetailMessage\"><div class=\"uk-modal-dialog\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalDetailMessage\')\" class=\"uk-modal-close uk-close\"></button><div class=\"uk-modal-header\"><h3 class=\"uk-modal-title\">Detalhes da mensagem</h3></div><div class=\"loading-spinner\" ng-show=\"vm.isLoadingModal\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-show=\"!vm.isLoadingModal\" class=\"uk-overflow-container\"><ul class=\"md-list\"><li><span class=\"md-list-heading uk-text-truncate\">Nome do Paciente</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.patientName}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Número do Prontuário</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.medicalRecordNumber}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Descrição do Exame/Procedimento</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.examName}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Número de Acesso do Exame/Procedimento (Accession Number)</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.accessionNumber}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data de Realização do Exame/Procedimento</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtExam}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Unidade de Realização do Exame/Procedimento</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.examUnit}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Tipo da Passagem</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.movingType}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Status da Mensagem</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"!vm.message.dtReceived\">Criada</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"vm.message.dtReceived && !vm.message.dtRead\">Recebida</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"vm.message.dtRead\">Lida</span></li><li><span class=\"md-list-heading uk-text-truncate\">Prioridade da Mensagem</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.messagePriority.level}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Push Enviado?</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"vm.message.isPushSent\">Sim</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"!vm.message.isPushSent\">Não</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora de Envio da Mensagem</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtCreated}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora de Mensagem Recebida</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtReceived}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora de Mensagem Lida</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtRead}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">CRM Remetente</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.senderCrm}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Remetente</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.senderName}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">CRM Destinatário</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.receiverCrm}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Destinatário</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.receiverName}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Telefone</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.receiverTelephoneNumber | brPhoneNumber}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Título da Mensagem</span> <span class=\"uk-text-small uk-text-muted uk-text-break\">{{vm.message.messageTitle}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Conteúdo da Mensagem</span> <span class=\"uk-text-small uk-text-muted uk-text-break\">{{vm.message.messageContent}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Url</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.url}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora Abertura do Laudo</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtMedicalReportAccessed}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora Abertura da Imagem</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtMedicalReportImageAccessed}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Contato Telefônico</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"vm.message.isPhoneContact\">Sim</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"!vm.message.isPhoneContact\">Não</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora do Contato Telefônico</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtPhoneContact}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Desistência</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"vm.message.isNoShow\">Sim</span> <span class=\"uk-text-small uk-text-muted\" ng-if=\"!vm.message.isNoShow\">Não</span></li><li><span class=\"md-list-heading uk-text-truncate\">Data/Hora da Desistência</span> <span class=\"uk-text-small uk-text-muted\">{{vm.message.dtNowShow}}</span></li><li><span class=\"md-list-heading uk-text-truncate\">Observação</span> <span class=\"uk-text-small uk-text-muted uk-text-break\">{{vm.message.notes}}</span></li></ul></div><div class=\"uk-modal-footer uk-text-right\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalDetailMessage\')\" class=\"md-btn md-btn-flat uk-modal-close\">Fechar</button></div></div></div><div class=\"uk-modal\" id=\"modalEditMessage\"><div class=\"uk-modal-dialog\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalEditMessage\')\" class=\"uk-modal-close uk-close\"></button><div class=\"uk-modal-header\"><h3 class=\"uk-modal-title\">Acompanhar mensagem</h3></div><div class=\"loading-spinner\" ng-show=\"vm.isLoadingModal\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingModal\"><form name=\"form\" id=\"form\" mt-validate-submit=\"vm.putMessage(vm.message)\" novalidate=\"\"><div class=\"uk-form-row\"><div><input ng-disabled=\"vm.message.dtPhoneContact\" type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.message.isPhoneContact\" id=\"message_isPhoneContact\" name=\"message_isPhoneContact\"> <label for=\"message_isPhoneContact\" class=\"inline-label\">Contato telefônico</label><div ng-show=\"vm.message.dtPhoneContact\">Alterado em: {{vm.message.dtPhoneContact}}</div></div></div><div class=\"uk-form-row\"><div><input ng-disabled=\"vm.message.dtNowShow\" type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.message.isNoShow\" id=\"message_isNoShow\" name=\"message_isNoShow\"> <label for=\"message_isNoShow\" class=\"inline-label\">Desistência</label><div ng-show=\"vm.message.dtNowShow\">Alterado em: {{vm.message.dtNowShow}}</div></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Observação</label> <textarea rows=\"3\" type=\"text\" class=\"md-input\" id=\"message_note\" name=\"message_note\" ng-model=\"vm.message.notes\" md-input=\"\" ng-maxlength=\"500\"> </textarea><div ng-show=\"form.$submitted || form.message_note.$touched\"><span ng-show=\"form.message_note.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"form.message_note.$error.maxlength\" class=\"help-block\">O campo deve possuir no máximo 500 caracteres</span></div></div><div class=\"uk-modal-footer uk-text-right\"><button type=\"button\" ng-click=\"vm.closeModal(\'modalEditMessage\')\" class=\"md-btn md-btn-flat uk-modal-close\">Fechar</button> <button type=\"submit\" class=\"md-btn md-btn-flat md-btn-flat-primary\">Aplicar</button></div></form></div></div></div>");
$templateCache.put("app/servico/servico.create.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><a ui-sref=\"private.painel\">Home</a></li><li><span>Atendimento</span></li><li><a ui-sref=\"private.painel.servico.list\">Cardápio de Serviços</a></li><li><span>{{vm.formulario.Name}}</span></li><li><span>{{vm.operacao}}</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card\" ng-show=\"!vm.isLoading\"><div class=\"md-card-content\"><form class=\"chamado-acatado-disable\" name=\"vm.form\" novalidate=\"\" mt-validate-submit=\"vm.submit(vm.formulario)\"><div class=\"uk-form-row\" mt-show-errors=\"\"><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-8-10\"><label>Qual é o endereço da ocorrência? *</label> <input ng-model=\"vm.formulario.endereco\" type=\"text\" class=\"md-input\" id=\"endereco\" name=\"endereco\" required=\"\" autocomplete=\"off\" readonly=\"\" maxlength=\"150\" md-input=\"\"></div><div class=\"uk-width-2-10\"><button type=\"button\" class=\"uk-button md-btn-block\" ng-class=\"vm.formulario.options.button\"><i class=\"md-icon md-light material-icons\">&#xE567;</i></button></div></div><div ng-show=\"vm.form.$submitted || vm.form.endereco.$touched\"><span ng-show=\"vm.form.endereco.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div style=\"margin-top:25px\" ng-repeat=\"formularioQuestao in vm.formulario.formularioQuestoes | orderBy : \'ordem\'\"><div class=\"uk-form-row\" ng-if=\"vm.isFormularioQuestaoVisivel(formularioQuestao) && formularioQuestao.tipo.Name.toLowerCase() === \'text\'\"><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1\" mt-show-errors=\"vm.inputName(formularioQuestao.id)\"><label>{{formularioQuestao.Name}} <label ng-if=\"formularioQuestao.obrigatorio\">*</label></label> <input type=\"text\" class=\"md-input\" id=\"{{vm.inputName(formularioQuestao.id)}}\" maxlength=\"150\" name=\"{{vm.inputName(formularioQuestao.id)}}\" ng-model=\"formularioQuestao.ngModel\" ng-required=\"formularioQuestao.obrigatorio\" ng-pattern=\"formularioQuestao.validacaoRegex\" ui-mask=\"{{formularioQuestao.mask}}\" autocomplete=\"off\" md-input=\"\"></div><div ng-show=\"vm.form.$submitted || vm.form[vm.inputName(formularioQuestao.id)].$touched\"><span ng-show=\"vm.form[vm.inputName(formularioQuestao.id)].$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"vm.form[vm.inputName(formularioQuestao.id)].$error.pattern\" class=\"help-block\">{{campo.validacaoMensagem || \'Valor inválido\'}}</span></div></div></div><div class=\"uk-form-row\" ng-if=\"vm.isFormularioQuestaoVisivel(formularioQuestao) && formularioQuestao.tipo.Name.toLowerCase() === \'label\'\"><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1\" mt-show-errors=\"vm.inputName(formularioQuestao.id)\"><label>{{formularioQuestao.Name}} <label ng-if=\"formularioQuestao.obrigatorio\">*</label></label></div></div></div><div class=\"uk-form-row\" ng-if=\"vm.isFormularioQuestaoVisivel(formularioQuestao) && formularioQuestao.tipo.Name.toLowerCase() === \'radio\'\"><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1\" mt-show-errors=\"vm.inputName(formularioQuestao.id)\"><label>{{formularioQuestao.Name}} <label ng-if=\"formularioQuestao.obrigatorio\">*</label></label><div data-uk-button-radio=\"\"><button class=\"uk-button md-btn-block servico-button-light\" ng-class=\"vm.formulario.options.button\" ng-attr-id=\"{{vm.inputName(formularioQuestao.id)}}\" ng-attr-name=\"{{vm.inputName(formularioQuestao.id)}}\" ng-model=\"formularioQuestao.ngModel\" ng-repeat=\"formularioQuestaoOpcao in formularioQuestao.formularioQuestaoOpcoes\" ng-value=\"formularioQuestaoOpcao\">{{formularioQuestaoOpcao.Name}}</button></div></div></div></div><div class=\"uk-form-row\" ng-if=\"vm.isFormularioQuestaoVisivel(formularioQuestao) && formularioQuestao.tipo.Name.toLowerCase() === \'imagens\'\"><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-1-1\" mt-show-errors=\"vm.inputName(formularioQuestao.id)\"><label>{{formularioQuestao.Name}} <label ng-if=\"formularioQuestao.obrigatorio\">*</label></label><div class=\"uk-grid uk-container-center\"><div class=\"uk-width-medium-1-{{formularioQuestao.formularioQuestaoOpcoes.length}}\" ng-repeat=\"formularioQuestaoOpcao in formularioQuestao.formularioQuestaoOpcoes\"><img class=\"{{vm.formulario.options.button}}-border\" src=\"assets/img/sabesp/placeholder_200x100.svg\" width=\"200\" height=\"100\" alt=\"\" style=\"margin: auto;display: block !important;\"></div></div><input type=\"hidden\" id=\"{{vm.inputName(formularioQuestao.id)}}\" name=\"{{vm.inputName(formularioQuestao.id)}}\" ng-model=\"formularioQuestao.ngModel\" ng-required=\"formularioQuestao.obrigatorio\"></div><div ng-show=\"vm.form.$submitted\"><span ng-show=\"vm.form[vm.inputName(formularioQuestao.id)].$error.required\" class=\"help-block\">Imagem Obrigatória</span></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/servico/servico.detail.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE873;</i> Atendimento</span></li><li><a ui-sref=\"private.painel.servico.list\">Cardápio de Serviços (SLA)</a></li><li><span>{{vm.servico.description}}</span></li><li><span>Detalhar</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoading\"><form ng-if=\"!vm.isLoading\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.setUpdateService(vm.filters)\" novalidate=\"\"><div class=\"md-card\"><div class=\"md-card-content\"><a class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.servico.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a><button type=\"submit\" class=\"md-btn md-btn-primary uk-float-right\"><i class=\"material-icons md-color-white\">&#xE5CA;</i> Alterar Serviço</button></div></div><div class=\"uk-grid\"><div class=\"uk-width-xLarge-1-1 uk-width-large-1-1 uk-width-small-1-1\"><div class=\"md-card\"><div class=\"md-card-content large-padding\"><div class=\"uk-grid uk-grid-divider uk-grid-medium\"><div class=\"uk-width-large-1-2\"><p><span class=\"uk-text-muted uk-text-small uk-display-block uk-margin-small-bottom\">Definir SLA:</span></p><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Nome</span> <span class=\"\">{{vm.servico.description}}</span></div></li><br><li><div class=\"uk-width-1-4\" style=\"z-index: 1000;\"><label for=\"sla_time\" class=\"uk-text-small uk-text-muted uk-display-block\">Tempo de SLA (horas)</label> <input type=\"text\" maxlength=\"3\" ng-minlength=\"0\" class=\"md-input\" id=\"sla_time\" name=\"sla_time\" ng-model=\"vm.filters.slaTimeSeconds\" md-input=\"\" ng-keypress=\"vm.validate($event)\" onkeypress=\"return (event.charCode == 8 | (event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div></li></ul><hr class=\"uk-grid-divider uk-hidden-large\"></div><div class=\"uk-width-large-1-2\"><p><span class=\"uk-text-muted uk-text-small uk-display-block uk-margin-small-bottom\">Definir motivos:</span></p><div ng-if=\"!vm.servico.availableStates.length\" class=\"alert alert-info alert-dismissable\" type=\"info\"><div class=\"text-center\"><span>Nenhum estado existente.</span></div></div><div class=\"table-responsive\" ng-if=\"vm.servico.availableStates.length\"><table class=\"uk-table uk-table-striped\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Estado</th><th class=\"uk-text-center\">Motivo</th><th class=\"uk-text-center\">Opções</th></tr></thead><tbody><tr ng-repeat=\"item in vm.servico.availableStates\" ng-class=\"{ \'active123\': item.$edit }\" mtm-show-errors=\"\"><td>{{item.defaultMessage}}</td><td><span ng-if=\"!item.$edit\">{{ item.reasons[0] }}</span><div ng-if=\"item.$edit\"><input class=\"md-input\" type=\"text\" ng-model=\"item.reasons[0]\" name=\"reasonField{{$index}}\" id=\"reasonField{{$index}}\" maxlength=\"70\" required=\"\"><div class=\"uk-margin-top\" ng-show=\"form.$submitted || form.reasonField{{$index}}.$invalid\"><span ng-show=\"form.reasonField{{$index}}.$error.required\" class=\"help-block\" style=\"color:red !important; display: initial !important;\">O campo é obrigatório</span></div></div></td><td class=\"uk-text-center\"><a title=\"Editar item\" ng-if=\"!item.$edit\" ng-click=\"item.$edit = true\"><i class=\"md-icon material-icons\">&#xE254;</i></a> <a title=\"Confirmar item\" ng-if=\"item.$edit\" ng-click=\"vm.updateReason(item, form, $index)\"><i style=\"color:#7cb342\" class=\"md-icon material-icons\">&#xE86C;</i></a></td></tr></tbody></table></div></div></div></div></div></div></div></form></div></div></div>");
$templateCache.put("app/servico/servico.list.html","<div id=\"page_content\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span><i class=\"material-icons\">&#xE873;</i> Atendimento</span></li><li><a ui-sref=\"private.painel.servico.list\" ui-sref-opts=\"{reload: true}\">Cardápio de Serviços (SLA)</a></li></ul></div><div class=\"scrum_board_overflow page-padding-top\"><div id=\"scrum_board\" class=\"uk-clearfix\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-small-2-10\"><form style=\"height: 15em\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.search(vm.filters)\" novalidate=\"\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><i id=\"search-action-2\" class=\"uk-icon-search\"></i> <span class=\"uk-text-bold\">PESQUISA</span></span></div></div></div><div class=\"scrum_column\"><div id=\"scrum_column_todo md-card\"><div class=\"uk-text-small uk-text-muted\"><div class=\"uk-margin-bottom\" id=\"divFiltroPolo\"><label for=\"polo_filter\">Nome</label> <input type=\"text\" class=\"md-input\" id=\"polo_filter\" name=\"polo_filter\" value=\"\" ng-model=\"vm.filters.description\" md-input=\"\"></div><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\">Pesquisar</button></div></div></div></div></form></div><div class=\"uk-width-small-8-10\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow: 0 0px #fff\"><div class=\"md-card-toolbar\" style=\"height: 38px;\"><div class=\"md-card-toolbar-actions\" style=\"padding-top: 0\"></div><span class=\"md-card-toolbar-heading-text\" style=\"height: 38px; margin-top: -8px\"><span class=\"uk-text-bold\">SERVIÇOS</span></span></div></div></div><div class=\"scrum_column\"><div class=\"md-card\" style=\"background: white;\"><div class=\"md-card-content\"><div class=\"uk-overflow-container uk-margin-bottom\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><table ng-if=\"!vm.isLoading\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\" class=\"uk-table uk-table-nowrap\" cellspacing=\"0\" width=\"100%\"><thead><tr><th class=\"uk-text-center\">Nome Serviço</th><th class=\"uk-text-center\">Tempo de SLA (horas)</th><th class=\"uk-text-center\">Detalhes</th></tr></thead><tfoot><tr><th class=\"uk-text-center\">Nome Serviço</th><th class=\"uk-text-center\">Tempo de SLA (horas)</th><th class=\"uk-text-center\">Detalhes</th></tr></tfoot><tbody><tr ng-repeat=\"item in vm.servicos\"><td class=\"uk-text-nowrap uk-text-center\">{{item.description}}</td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"item.slaTimeSeconds\"><span class=\"uk-badge uk-badge-notification uk-badge-success\" title=\"Serviço Ativo\">{{(item.slaTimeSeconds/3600)}} hora(s)</span></td><td class=\"uk-text-nowrap uk-text-center\" ng-if=\"!item.slaTimeSeconds\"><span class=\"uk-badge uk-badge-notification uk-badge-info\" title=\"Serviço Ativo\">Não possui SLA</span></td><td class=\"uk-text-nowrap uk-text-center\"><a ui-sref=\"private.painel.servico.detail({id: item.id})\"><i class=\"md-icon material-icons\">&#xE8F4;</i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/situacao/situacao.create.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar\" ng-click=\"vm.openModalConfirmacaoDeCancelamento()\"><i class=\"material-icons md-color-white\"></i></a> <label for=\"submitForm\" tabindex=\"0\" class=\"labelAsButton\" title=\"Salvar\"><i class=\"material-icons md-color-white\"></i></label></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;{{vm.operacao}}</a><span ng-if=\"vm.situacao.description\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.situacao.description}}</span></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Configurações &raquo; Situações</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-width-medium-1-1 uk-width-large-7-10 uk-width-xlarge-6-10 uk-container-center reset-print\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-row-first\"><form ng-if=\"!vm.isLoading\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.submit(vm.situacao)\" novalidate=\"\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"visibility:hidden;\"></button> <b>Informações Gerais</b></h3></div><div class=\"\"></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"situacao_titulo\" name=\"situacao_titulo\" ng-model=\"vm.situacao.description\" md-input=\"\" ng-maxlength=\"100\" required=\"\"></div><div ng-show=\"form.$submitted || form.situacao_titulo.$touched\"><span ng-show=\"form.situacao_titulo.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"form.situacao_titulo.$error.maxlength\" class=\"md-error\">O campo deve possuir no máximo 100 caracteres</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Tipo</label><div class=\"md-input-wrapper2\"><input ng-model=\"vm.situacao.type\" class=\"custom_selectize\" position=\"bottom\" type=\"text\" config=\"vm.selectize_types_config\" options=\"vm.selectize_types.options\" name=\"selectize_c\" id=\"selectize_c\" selectize=\"\" required=\"\"></div><div ng-show=\"form.$submitted || form.selectize_c.$touched\"><span ng-show=\"form.selectize_c.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\"><div class=\"uk-width-1-10 uk-width-small-1-10\" style=\"width:5px !important\"><label class=\"uk-text-small\" style=\"padding-left:4px;\">Ícone</label><br><i class=\"material-icons md-user-image\" ng-if=\"!vm.situacao.icon\" style=\"font-size:30px; padding:12px 0 0 0; color:{{vm.situacao.iconColor}}\">&#xe611;</i> <i class=\"mobilecare-icons md-user-image\" ng-if=\"vm.situacao.icon\" ng-bind-html=\"vm.situacao.icon\" style=\"font-size:30px; padding:12px 0 0 0; color:{{vm.situacao.iconColor}}\"></i><br><span style=\"font-size:10px; font-style:italic; padding-left:4px;\" ng-if=\"vm.situacao.icon\">{{vm.situacao.icon.replace(\'&#x\', \'\')}}</span></div><div class=\"uk-width-4-10 uk-width-small-4-10\"><a id=\"btnAddCategoryIcon\" class=\"md-btn md-btn-primary md-btn-small\" style=\"margin:30px;\" ng-disabled=\"vm.situacao.detail\" ng-click=\"vm.openModalIcons()\">Selecionar</a></div><div class=\"uk-width-1-1\"><input type=\"text\" ng-disabled=\"true\" class=\"md-input\" id=\"icone\" name=\"icone\" ng-model=\"vm.situacao.icon\" md-input=\"\" required=\"\" style=\"display:none; height:0; margin:0;\"><div ng-show=\"form.$submitted || form.icone.$touched\" style=\"margin-top:0\"><span ng-show=\"form.icone.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-form-row uk-grid\" mtm-show-errors=\"\" style=\"margin-top:0;padding-top:0\"><div class=\"uk-width-3-10 uk-width-small-1-1\"><label class=\"uk-text-small\">Cor do Ícone</label><br><input type=\"color\" class=\"jscolor\" ng-model=\"vm.situacao.iconColor\" style=\"margin-top:8px\"></div></div><div ng-if=\"vm.isSituacaoAtivarPermitido\" class=\"uk-form-row\" mtm-show-errors=\"\"><div ng-if=\"vm.isEdicao\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"vm.situacao.isActive\" id=\"situacao_ativo\" name=\"situacao_ativo\"> <label for=\"situacao_ativo\" class=\"inline-label\">Ativo</label><div ng-show=\"form.$submitted || form.situacao_ativo.$touched\"><span ng-show=\"form.situacao_ativo.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div></div></div></div></form></div></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a type=\"button\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\" ui-sref=\"private.painel.situacao.list\">Sim</a></div></div></div></div></div></div><div class=\"uk-modal custom uk-open modalIcons\" id=\"modalIcons\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalIcons\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000\"></button><div class=\"uk-modal-header uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Icones</h3></div><div class=\"uk-overflow-container\" style=\"max-height: 500px;\"><div class=\"md-card\"><div class=\"md-card-content uk-text-center uk-width-1-1\" style=\"padding-left:5px;\"><i ng-repeat=\"item in vm.iconsCode\" class=\"mobilecare-icons\" style=\"font-size:30px; cursor: pointer; margin:8px\" ng-bind-html=\"item.id\" ng-click=\"vm.selectIcon(item)\"></i></div></div></div></div></div>");
$templateCache.put("app/situacao/situacao.detail.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><a class=\"md-fab md-fab-small md-fab-primary md-fab-back\" ui-sref=\"private.painel.situacao.list\"><i class=\"uk-icon-angle-left\"></i></a><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Editar\" ng-if=\"vm.isSituacaoEditarPermitido\" ui-sref=\"private.painel.situacao.list.edit({id: vm.situacao.id})\"><i class=\"material-icons md-color-white\">&#xE150;</i></a> <a title=\"Excluir\" ng-if=\"vm.isSituacaoEditarPermitido\" ng-click=\"vm.confirmExcluir(vm.situacao)\"><i class=\"material-icons md-color-white\">&#xe872;</i></a></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Visualizar</a><span ng-if=\"vm.situacao.description\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.situacao.description}}</span></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Configurações &raquo; Situações</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-width-medium-1-1 uk-width-large-7-10 uk-width-xlarge-6-10 uk-container-center reset-print\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-row-first\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><b>Informações Gerais</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"true\" class=\"md-input-2\" id=\"situacao_description\" name=\"situacao_description\" ng-model=\"vm.situacao.description\" md-input=\"\" ng-maxlength=\"100\" required=\"\"></div></div><div class=\"uk-form-row\"><label>Tipo</label><div class=\"md-input-wrapper2\"><input type=\"text\" ng-disabled=\"true\" class=\"md-input-2\" id=\"situacao_type\" name=\"situacao_type\" ng-model=\"vm.situacao.type\" md-input=\"\" ng-maxlength=\"100\" required=\"\"></div></div><div class=\"uk-form-row\"><label>Ícone</label><div class=\"md-input-wrapper2\"><i class=\"mobilecare-icons md-36\" ng-bind-html=\"vm.situacao.icon\" ng-show=\"vm.situacao.icon\" style=\"color:#{{vm.situacao.iconColor}} !important; padding: 10px 12px;\"></i> <i class=\"material-icons md-36\" ng-show=\"!vm.situacao.icon\" style=\"color:#{{vm.situacao.iconColor}} !important; padding: 10px 12px;\">&#xe14b;</i></div></div><div class=\"uk-form-row\"><label>Status</label><div class=\"md-input-wrapper2\"><input ng-disabled=\"true\" class=\"md-input-2 uk-text-success\" ng-if=\"vm.situacao.isActive\" value=\"Ativo\"> <input ng-disabled=\"true\" class=\"md-input-2 uk-text-danger\" ng-if=\"!vm.situacao.isActive\" value=\"Arquivado\"></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/situacao/situacao.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\" ng-if=\"vm.isSituacaoCadastrarPermitido\"><a class=\"md-fab md-fab-small md-fab-primary\" ui-sref=\"private.painel.situacao.list.create\"><i class=\"material-icons\">&#xE145;</i></a></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE89C;</i><a target=\"#\">&nbsp;Situações</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}} &raquo; Atendimento &raquo; Configurações</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">PESQUISA</h3></div></div></div><div class=\"uk-width-8-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">SITUAÇÕES <span ng-show=\"vm.situacoes\">({{vm.situacoes.length}}) Registros</span></h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoadingFiltros\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div ng-if=\"vm.isSituacaoPesquisarPermitido\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome</label><div class=\"md-input-wrapper2\"><input ng-minlength=\"3\" type=\"text\" class=\"md-input-2\" id=\"situacao_filter\" name=\"situacao_filter\" value=\"\" ng-model=\"vm.filters.description\" md-input=\"\"></div><div ng-show=\"form.$submitted || form.situacao_filter.$touched\"><span ng-show=\"form.situacao_filter.$error.minlength\" class=\"md-error\">O campo deve possuir no mínimo 3 caracteres</span></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div></div></div><div class=\"uk-width-8-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.situacoes.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhuma situação encontrada.</span></h3></div></div><div id=\"services-list\" class=\"md-card-list-wrapper\" ng-if=\"!vm.isLoading && vm.situacoes.length > 0\"><div class=\"md-card-list\" style=\"margin-top: 0px\"><ul class=\"md-list-custom uk-nestable-list md-list-custom-outside\"><li class=\"anim-list\" ng-repeat=\"item in vm.situacoes\"><div class=\"md-card-list-item-menu uk-visible-large\"><a ui-sref=\"private.painel.situacao.list.detail({id: item.id})\" title=\"Visualizar\"><i class=\"md-icon material-icons\">&#xE8F4;</i></a> <a ng-if=\"vm.isSituacaoEditarPermitido\" ui-sref=\"private.painel.situacao.list.edit({id: item.id})\" title=\"Editar\"><i class=\"md-icon material-icons\">&#xE3C9;</i></a> <a ng-if=\"vm.isSituacaoAtivarPermitido && item.isActive\" title=\"Arquivar\" ng-click=\"vm.archiveSituation(item)\"><i class=\"md-icon material-icons\"></i></a> <a ng-if=\"vm.isSituacaoAtivarPermitido && !item.isActive\" title=\"Ativar\" ng-click=\"vm.archiveSituation(item)\"><i class=\"md-icon material-icons\">&#xe862;</i></a> <a ng-if=\"vm.isSituacaoExcluirPermitido\" title=\"Excluir\" ng-click=\"vm.confirmExcluir(item)\"><i class=\"md-icon material-icons\">&#xE872;</i></a></div><div class=\"md-card-list-item-menu uk-visible-medium\" data-uk-dropdown=\"{mode:\'click\',pos:\'bottom-right\'}\" aria-haspopup=\"true\" aria-expanded=\"false\"><a href=\"#\" class=\"md-icon material-icons\"></a><div class=\"uk-dropdown uk-dropdown-small\" aria-hidden=\"true\"><ul class=\"uk-nav\"><li><a ui-sref=\"private.painel.situacao.list.detail({id: item.id})\" title=\"Visualizar item\"><i class=\"material-icons\">&#xE8F4;</i>Visualizar</a></li><li><a ng-if=\"vm.isSituacaoEditarPermitido\" title=\"Editar item\" ui-sref=\"private.painel.situacao.list.edit({id: item.id})\"><i class=\"material-icons\">&#xE3C9;</i>Editar</a></li><li ng-if=\"vm.isSituacaoAtivarPermitido\"><a ng-if=\"item.isActive\" ng-click=\"vm.archiveSituation(item)\"><i class=\"material-icons\"></i> Arquivar</a> <a ng-if=\"!item.isActive\" ng-click=\"vm.archiveSituation(item)\"><i class=\"material-icons\">&#xe862;</i> Ativar</a></li><li><a ng-if=\"vm.isSituacaoExcluirPermitido\" ng-click=\"vm.confirmExcluir(item)\" href=\"\" title=\"Excluir item\"><i class=\"material-icons\">&#xE872;</i>Excluir</a></li></ul></div></div><span class=\"md-card-list-item-date publicacao-servico uk-hidden-small uk-hidden-medium\"><span ng-show=\"!item.isActive\" class=\"uk-badge uk-badge-muted\" style=\"outline:0; border:none !important;\" ng-class=\"{\'{{item.publishLevel.description.toLowerCase()}}\':item.isActive, \'arquivado\':!item.isActive}\">Arquivado</span></span><div class=\"md-card-list-item-avatar-wrapper\"><span class=\"md-card-list-item-avatar md-bg-grey-100\"><i class=\"mobilecare-icons\" ng-bind-html=\"item.icon\" ng-show=\"item.icon\" style=\"color:#{{item.iconColor}} !important\"></i> <i class=\"material-icons\" ng-show=\"!item.icon\">&#xe14b;</i></span></div><div class=\"md-card-list-item-subject\"><span style=\"padding-top:8px;\">{{item.description}}</span></div></li></ul></div></div></div></div></div></div>");
$templateCache.put("app/usuario.admin/usuario.create.html","<div id=\"page_content\"><div id=\"page_overflow_clean\"><div id=\"page_heading\"><div class=\"heading_actions\"><div class=\"md-fab md-fab-toolbar md-fab-small md-fab-primary md-fab-animated md-fab-active\" id=\"bar-save\" style=\"display: block; width: 112px;\"><i class=\"material-icons\"></i><div class=\"md-fab-toolbar-actions\"><a title=\"Cancelar\" ng-click=\"vm.openModalConfirmacaoDeCancelamento()\"><i class=\"material-icons md-color-white\"></i></a> <label for=\"submitForm\" tabindex=\"0\" class=\"labelAsButton\" title=\"Salvar\"><i class=\"material-icons md-color-white\"></i></label></div></div></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8D3;</i><a target=\"#\">&nbsp;{{vm.operacao}}</a><span ng-if=\"vm.usuario.name || vm.usuario.surname\" class=\"uk-text-muted\">&nbsp;&raquo;&nbsp;{{vm.usuario.name}}&nbsp;{{vm.usuario.surname}}</span></h1><span ng-if=\"vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.company.name}} &raquo; Colaboradores</span> <span ng-if=\"!vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">&nbsp;</span></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-1-1 uk-overflow-container uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"uk-width-medium-1-1 uk-width-large-7-10 uk-width-xlarge-6-10 uk-container-center reset-print\"><div class=\"uk-grid uk-grid-collapse\" data-uk-grid-margin=\"\"><div class=\"uk-width-small-1-1 uk-row-first\"><form ng-if=\"!vm.isLoading\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.submit(vm.usuario)\" novalidate=\"\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><button type=\"submit\" id=\"submitForm\" style=\"display:none\"></button> <b>Informações Gerais</b></h3></div><div class=\"md-card-content\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\"><label>Nome</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_descricao\" name=\"usuario_descricao\" ng-model=\"vm.usuario.name\" md-input=\"\" required=\"\"></div><div ng-show=\"form.$submitted || form.usuario_descricao.$touched\"><span ng-show=\"form.usuario_descricao.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\"><label>Sobrenome</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_surname\" name=\"usuario_surname\" ng-model=\"vm.usuario.surname\" md-input=\"\" required=\"\"></div><div ng-show=\"form.$submitted || form.usuario_surname.$touched\"><span ng-show=\"form.usuario_surname.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div><div class=\"uk-form-row\"><label>E-mail</label><div class=\"md-input-wrapper2\"><input type=\"email\" maxlength=\"50\" class=\"md-input-2\" id=\"usuario_email\" name=\"usuario_email\" ng-model=\"vm.usuario.email\" md-input=\"\" required=\"\" ng-disabled=\"vm.isEdicao\" ng-blur=\"vm.emailIsAvailable()\"></div><div ng-show=\"form.$submitted || form.usuario_email.$touched\"><span ng-show=\"form.usuario_email.$error.required\" class=\"md-error\">Campo Obrigatório</span> <span ng-show=\"form.usuario_email.$error.email\" class=\"md-error\">E-mail inválido</span> <span ng-show=\"vm.emailIsNotAvailable\" class=\"md-error\">E-mail não está disponível</span></div></div><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Papel da Empresa</label> <input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_roles_config\" options=\"vm.selectize_roles\" ng-model=\"vm.roleGeral\" name=\"roleGeral\" id=\"roleGeral\" selectize=\"\"><div class=\"uk-margin-top\" ng-show=\"form.$submitted || form.roles.$touched\"><span ng-show=\"form.roles.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\"><b>Permissões para locais</b></h3></div><div class=\"md-card-content\"><div ng-repeat=\"item in vm.usuario.roles\" class=\"uk-grid uk-grid-collapse\" ng-class-odd=\"\'md-bg-blue-50\'\" ng-class-even=\"\'md-bg-purple-50\'\" style=\"padding: 10px !important; margin-top:10px !important;\"><div class=\"uk-width-small-3-5 uk-width-1-1 uk-row-first\" style=\"padding-top:5px;\"><div class=\"uk-form-row\" style=\"margin: 0 !important;\"><img class=\"md-user-image\" ng-src=\"data:image/png;base64,{{item.logoSecondary}}\" alt=\"\" src=\"data:image/png;base64,{{item.logoSecondary}}\"><b>&nbsp;&nbsp; {{item.local}}</b></div></div><div class=\"uk-width-small-2-5 uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\" style=\"margin: 0 !important;\"><input class=\"custom_selectize\" position=\"bottom\" config=\"vm.selectize_roles_config\" options=\"vm.selectize_roles\" ng-model=\"item.name\" selectize=\"\"></div></div></div></div></div></form></div></div></div></div></div></div><div class=\"uk-modal cancelar\" id=\"cancelar\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\"><i class=\"uk-icon-hover uk-icon-trash-o\"></i> Cancelar {{vm.operacao.toLowerCase() === \'editar\' ? \'Edição\': \'Cadastro\'}}</h3></div><div class=\"uk-modal-body-custom\"><div class=\"md-card-content uk-width-1-1\"><p>Confirmar o cancelamento {{vm.operacao.toLowerCase() === \'editar\' ? \'da edição\': \'do cadastro\'}}?<br><br><span class=\"uk-text-small uk-text-italic uk-text-mutted\">Atenção pois esta ação não pode ser desfeita.</span></p></div></div><div class=\"uk-modal-footer-custom\"><button type=\"button\" class=\"md-btn md-btn-small md-btn-danger uk-modal-close\">Não</button> <a type=\"button\" class=\"md-btn md-btn-small md-btn-success uk-modal-close\" ui-sref=\"private.painel.usuario.list\">Sim</a></div></div></div></div></div>");
$templateCache.put("app/usuario.admin/usuario.detail.html","<div class=\"loading-spinner\" ng-if=\"vm.isLoadingDetail\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingDetail\" class=\"scrum_column\"><div id=\"scrum_column_inProgress\"><div id=\"detalheDiv\" class=\"uk-text-small\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\">CONTA</span></h2><button ng-if=\"vm.usuario.confirmedEmail && vm.isUsuarioReenviarEmailPermitido\" ng-disabled=\"true\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Reenviar e-mail confirmação\" ng-click=\"vm.confirmSendEmail(vm.usuario)\"><i class=\"md-icon material-icons md-dark md-inactive\">&#xE0E1;</i></button> <button ng-if=\"!vm.usuario.confirmedEmail && vm.isUsuarioReenviarEmailPermitido\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Reenviar e-mail confirmação\" ng-click=\"vm.confirmSendEmail(vm.usuario)\"><i class=\"md-icon material-icons\">&#xE0E1;</i></button> <button ng-if=\"!vm.isUsuarioReenviarEmailPermitido\" ng-disabled=\"true\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Reenviar e-mail confirmação\"><i class=\"md-icon material-icons md-dark md-inactive\">&#xE0E1;</i></button> <button ng-if=\"vm.isUsuarioReenviarEmailPermitido\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Reenviar e-mail de redefinição de senha\" ng-click=\"vm.confirmSendForgotPasswordEmail(vm.usuario)\"><i class=\"md-icon material-icons\">&#xE158;</i></button><button ng-if=\"vm.isUsuarioEditarPermitido\" ui-sref=\"private.painel.usuario.list.edit({id: vm.usuario.id})\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Editar usuário\"><i class=\"md-icon material-icons\">&#xE3C9;</i></button> <button ng-if=\"!vm.isUsuarioEditarPermitido\" ng-disabled=\"true\" class=\"md-card-toolbar md-icon-mtm uk-float-right\" title=\"Editar usuário\"><i class=\"md-icon material-icons md-dark md-inactive\">&#xE3C9;</i></button></div><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data do Cadastro</span> <span class=\"\">{{vm.usuario.registerDate}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Login</span> <span class=\"\">{{vm.usuario.userName}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Papel</span> <span class=\"\">{{vm.usuario.extraRole}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Status do E-mail</span> <span class=\"uk-text-primary\" ng-if=\"vm.usuario.emailConfirmed\">Confirmado</span> <span class=\"\" style=\"color:#fd6800;\" ng-if=\"!vm.usuario.emailConfirmed\">Pendente</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Status da Conta</span> <span class=\"uk-text-primary\" ng-if=\"vm.usuario.enabled && vm.isUsuarioInativarPermitido\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 7px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small class=\"uk-bg-primary\" style=\"left: 18px; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirm(vm.usuario)\"></small></span> Ativa</span> <span class=\"uk-text-primary\" ng-if=\"vm.usuario.enabled && !vm.isUsuarioInativarPermitido\">Ativa</span> <span class=\"\" style=\"color:#fd6800;\" ng-if=\"!vm.usuario.enabled && !vm.isUsuarioInativarPermitido\">Inativa</span> <span class=\"\" style=\"color:red;\" ng-if=\"!vm.usuario.enabled && vm.isUsuarioInativarPermitido\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: rgb(250, 250, 250); transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirm(vm.usuario)\"></small></span> Inativa</span></div></li></ul></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\">PERFIL</span></h2></div><div class=\"md-card-content\"><div class=\"uk-width-xLarge-1-1 uk-width-large-1-1 uk-width-small-1-1\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Nome</span> <span class=\"\">{{vm.usuario.profiles[0].name}} {{vm.usuario.profiles[0].surname}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">E-mail</span> <span>{{vm.usuario.userName}}</span></div></li></ul></div></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\">LOCAIS</span></h2></div><div class=\"md-card-content\"><div class=\"uk-width-xLarge-1-1 uk-width-large-1-1 uk-width-small-1-1\"><ul class=\"md-list md-list-addon\"><li ng-repeat=\"item in vm.usuario.roles\" ng-if=\"item.name\"><div class=\"md-list-addon-element\"><img class=\"md-user-image md-list-addon-avatar\" ng-src=\"data:image/png;base64,{{item.logoSecondary}}\" alt=\"\" add-image-prop=\"\" width=\"34\" height=\"34\"></div><div class=\"md-list-content\"><span class=\"md-list-heading\"><b>{{item.local}}<b></b></b></span> <span class=\"uk-text-small uk-text-muted\">{{item.name}}</span></div></li></ul></div></div></div><br></div></div></div>");
$templateCache.put("app/usuario.admin/usuario.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\" ng-if=\"vm.isUsuarioCadastrarPermitido\"><a class=\"md-fab md-fab-small md-fab-primary\" ui-sref=\"private.painel.usuario.list.create\"><i class=\"material-icons\">&#xE145;</i></a></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8D3;</i><a target=\"#\">&nbsp;Colaboradores</a></h1><span ng-if=\"vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.company.name}}</span> <span ng-if=\"!vm.company\" class=\"uk-text-muted uk-text-upper uk-text-small\">&nbsp;</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><div class=\"md-card-dropdown\" data-uk-dropdown=\"{pos:\'bottom-right\'}\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D4;</i><div class=\"uk-dropdown uk-dropdown-small uk-dropdown-top\" style=\"margin-top: 8px !important;\"><ul class=\"uk-nav\"><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isStatusContaFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"situationCheck\" id=\"situationCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isStatusContaFilterChecked\" icheck=\"\"></span> <label for=\"situationCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Status Conta</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isStatusEmailFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"serviceCheck\" id=\"serviceCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isStatusEmailFilterChecked\" icheck=\"\"></span> <label for=\"serviceCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Status E-mail</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserNameFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"catCheck\" id=\"catCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserNameFilterChecked\" icheck=\"\" ng-value=\"true\" ng-checked=\"true\"></span> <label for=\"catCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Nome</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserEmailFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserEmailFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">E-mail</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isPapelFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isPapelFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Papel</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isLocalFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isLocalFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Local</label></div></li></ul></div></div></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">PESQUISA</h3></div></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><a title=\"Atualizar lista de usuários\" ng-click=\"vm.pesquisar(vm.filters)\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\" title=\"Atualizar\">&#xE5D5;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">COLABORADORES <span ng-show=\"vm.total\">({{vm.total}}) Registro(s)</span></h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">DETALHES</h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"vm.isUsuarioPesquisarPermitido && !vm.isLoadingFiltros\" name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div ng-if=\"vm.isStatusContaFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Status da Conta</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Ativa\" id=\"status_conta\" name=\"status_conta\" config=\"vm.selectize_sources_status_config\" options=\"vm.selectize_sources_status\" position=\"bottom\" ng-model=\"vm.filters.Enabled\"></selectize></div></div></div><div ng-if=\"vm.isStatusEmailFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Status do E-mail</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"status_email\" name=\"status_email\" config=\"vm.selectize_sources_status_email_config\" options=\"vm.selectize_sources_status_email\" position=\"bottom\" ng-model=\"vm.filters.emailConfirmed\"></selectize></div></div></div><div ng-if=\"vm.isUserNameFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_name\" name=\"usuario_filter\" value=\"\" ng-model=\"vm.filters.Name\" md-input=\"\"></div></div></div><div ng-if=\"vm.isUserEmailFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>E-mail</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"usuario_filter_email\" name=\"usuario_filter\" value=\"\" ng-model=\"vm.filters.Mail\" md-input=\"\"></div></div></div><div ng-if=\"vm.isPapelFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Papel</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"status\" name=\"status\" config=\"vm.selectize_roles_update_config\" options=\"vm.selectize_roles_update\" position=\"bottom\" ng-model=\"vm.filters.Roles\"></selectize></div></div></div><div ng-if=\"vm.isLocalFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Local</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"select_demo_locais\" name=\"select_demo_locais\" config=\"vm.selectize_apps_update_config\" options=\"vm.selectize_apps_update\" position=\"bottom\" ng-model=\"vm.filters.AppCompanyId\"></selectize></div></div></div><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Cadastro</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.DateIni\" ng-required=\"vm.filters.DateIni\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.DateEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.usuarios.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum registro encontrado.</span></h3></div></div><div id=\"colaboradores_list\" ng-if=\"!vm.isLoading && vm.usuarios.length > 0\"><div id=\"users_admin\" class=\"scrum_column ng-scope\"><div id=\"chamadosLista\" infinite-scroll-disabled=\"vm.busy || vm.isLastPage\" infinite-scroll=\"vm.getNextPageUsuarios()\" infinite-scroll-immediate-check=\"true\" infinite-scroll-distance=\"0\" infinite-scroll-container=\"\'#users_admin\'\"><div class=\"scrum_task\" ng-repeat=\"item in vm.usuarios\" ng-class=\"{ \'chamado-active\': $index == vm.selectedIndex}\" ng-click=\"vm.detailUsuario(item.id, $index, item.extraRole)\" style=\"z-index:0;margin-bottom:5px;cursor:pointer\"><div class=\"critical\"><div class=\"uk-grid uk-grid-collapse\"><div><div ng-if=\"item.profiles.length > 0\"><p class=\"uk-width-medium-10-10 uk-width-small-10-10 scrum_task_description\"><span ng-if=\"item.profiles[0].name\" style=\"font-size:13px;\"><b>{{item.profiles[0].name}} {{item.profiles[0].surname}}</b></span></p></div><span class=\"uk-width-medium-10-10 uk-width-small-10-10 scrum_task_description\"><span ng-if=\"item.email\">{{item.email}}</span></span><div ng-if=\"item.profiles.length > 0\"><p class=\"uk-width-medium-10-10 uk-width-small-10-10 scrum_task_description\"><span ng-if=\"item.extraRole\">{{item.extraRole}}</span></p></div><p class=\"scrum_task_description\"><span ng-if=\"item.enabled\"><i class=\"material-icons uk-text-primary\">&#xE86C;</i> <span class=\"uk-text-primary\">Conta Ativa</span> &nbsp &nbsp &nbsp <span ng-if=\"item.emailConfirmed\" class=\"uk-text-primary\"><i class=\"material-icons uk-text-primary\">&#xE86C;</i> E-mail Confirmado</span> <span ng-if=\"!item.emailConfirmed\" style=\"color:#fd6800 !important;\"><i class=\"material-icons\" style=\"color:#fd6800;\">&#xE8B5;</i> E-mail não confirmado</span></span> <span ng-if=\"!item.enabled\"><i class=\"material-icons\" style=\"color: red;\">&#xE001;</i> <span style=\"color: red;\">Conta Inativa</span> &nbsp &nbsp &nbsp <span ng-if=\"item.emailConfirmed\" class=\"uk-text-primary\"><i class=\"material-icons uk-text-primary\">&#xE86C;</i> E-mail Confirmado</span> <span ng-if=\"!item.emailConfirmed\" style=\"color:#fd6800;\"><i class=\"material-icons\" style=\"color:#fd6800;\">&#xE8B5;</i> E-mail não confirmado</span></span></p></div></div></div></div></div></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.usuarios.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Detalhe não disponível.</span></h3></div></div><div ng-if=\"!vm.isLoading && vm.usuarios.length > 0 && vm.isUsuarioVisualizarPermitido\" ui-view=\"\"></div></div></div></div></div>");
$templateCache.put("app/usuario.mobile/cliente.create.html","<div id=\"page_content\" class=\"polo-manutencao-detail\"><div id=\"top_bar\"><ul id=\"breadcrumbs\"><li><span ng-show=\"vm.appCompany\" style=\"display: initial !important; padding-left: 25px !important;\">&nbsp;&nbsp; <img style=\"width:25px!important;height: 25px !important\" class=\"md-user-image\" ng-src=\"data:image/png;base64,{{vm.appCompany.logoSecondary}}\" alt=\"\" src=\"data:image/png;base64,{{vm.appCompany.logoSecondary}}\"> &nbsp; {{vm.appCompany.name}} - {{vm.appCompany.name}}</span></li><li><a ui-sref=\"private.painel.cliente.list\">Usuários App</a></li><li ng-if=\"vm.cliente && vm.isEdicao\"><span>{{vm.cliente.name}}</span></li><li><span>{{vm.operacao}}</span></li></ul></div><div id=\"page_content_inner\" class=\"page-padding-top\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"!vm.isLoading\" name=\"form\" id=\"form\" mt-validate-submit=\"vm.submit(vm.cliente)\" novalidate=\"\"><div><div class=\"md-card\"><div class=\"md-card-content\"><a style=\"visibility:hidden\" class=\"md-btn md-bg-blue-grey-200 md-color-white\" ui-sref=\"private.painel.cliente.list\"><i class=\"material-icons md-color-white\">&#xE15E;</i> Voltar</a> <button type=\"submit\" class=\"md-btn md-btn-primary uk-float-right\" style=\"background-color:#7cb342 !important\"><i class=\"material-icons md-color-white\">&#xE5CA;</i> Salvar</button> <a href=\"\" class=\"md-btn md-btn-danger uk-float-right\" ng-click=\"vm.cancelar()\"><i class=\"material-icons md-color-white\">&#xE5C9;</i> Cancelar</a></div></div><br><div class=\"md-card\"><div class=\"md-card-content\"><input id=\"photoField\" ng-change=\"vm.configureImage();\" type=\"file\" ng-model=\"vm.photo\" base-sixty-four-input=\"\" style=\"display: none;\"><div><div ng-show=\"!vm.photo && vm.update\"><div class=\"user_heading_avatar\" style=\"margin-right:0; margin-left: 10px;\"><div class=\"thumbnail\" onclick=\"document.getElementById(\'photoField\').click();\" style=\"cursor: pointer;\"><img src=\"{{vm.photoAzure}}\"></div></div></div><div ng-show=\"vm.photo && !vm.update\"><div class=\"user_heading_avatar\" style=\"margin-right:0; margin-left: 10px;\"><div class=\"thumbnail\" onclick=\"document.getElementById(\'photoField\').click();\" style=\"cursor: pointer;\"><img src=\"data:image/jpg;base64,{{vm.photo.base64}}\"></div></div></div><div ng-show=\"!vm.photo && !vm.update\"><div class=\"user_heading_avatar\" style=\"margin-right:0; margin-left: 10px;\"><div class=\"thumbnail\" onclick=\"document.getElementById(\'photoField\').click();\" style=\"cursor: pointer;\"><img ng-src=\"../../assets/img/avatars/user-alt@2x.png\" style=\"max-width: 80px; max-height: 80px; width: auto; height: auto;\"></div></div></div></div><div class=\"uk-form-row mobile-care-margin-top-zero\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-5-10 mobile-care-padding-margin-responsive\"><label>Nome do Médico</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_name\" name=\"cliente_name\" ng-model=\"vm.cliente.name\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_name.$touched\"><span ng-show=\"form.cliente_name.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-5-10 mobile-care-padding-margin-responsive\"><label>Sobrenome</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_surname\" name=\"cliente_surname\" ng-model=\"vm.cliente.surname\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_surname.$touched\"><span ng-show=\"form.cliente_surname.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row mobile-care-margin-top-zero\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-2-10 mobile-care-padding-margin-responsive\"><label for=\"uk_dp_end\">Data de Nascimento</label> <input class=\"md-input\" type=\"text\" required=\"\" id=\"cliente_birth_date\" name=\"cliente_birth_date\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.cliente.birthDate\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.cliente_birth_date.$touched\"><span ng-show=\"form.cliente_birth_date.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-2-10 mobile-care-padding-margin-responsive\"><label>CRM</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_crm\" name=\"cliente_crm\" ng-model=\"vm.cliente.crm\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_crm.$touched\"><span ng-show=\"form.cliente_crm.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-6-10 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\" style=\"margin-top:-20px\"><label class=\"mobile-care-label-md-input-less\">Especialidade</label><selectize placeholder=\"Selecione\" id=\"cliente_specialty\" name=\"cliente_specialty\" config=\"vm.selectize_config\" required=\"\" options=\"vm.listSpecialty\" position=\"bottom\" ng-model=\"vm.cliente.specialty\"></selectize><div ng-show=\"form.$submitted || form.cliente_specialty.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_specialty.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row mobile-care-margin-top-zero\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-2-10 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\"><label class=\"mobile-care-label-md-input-less\">CEP</label> <input ui-mask=\"99.999-999\" style=\"padding-top:0px; margin-top:-3px;\" type=\"text\" maxlength=\"10\" class=\"md-input\" id=\"cliente_address_zipcode\" name=\"cliente_address_zipcode\" ng-model=\"vm.cliente.address.zipCode\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\" ng-blur=\"vm.getCep(vm.cliente.address.zipCode)\"></div><div class=\"uk-width-medium-3-10 mobile-care-padding-margin-responsive\"><label>Endereço</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_address_logradouro\" name=\"cliente_address_logradouro\" ng-model=\"vm.cliente.address.addressLine1\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_address_logradouro.$touched\"><span ng-show=\"form.cliente_address_logradouro.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-2-10 mobile-care-padding-margin-responsive\"><label>Bairro</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_address_district\" name=\"cliente_address_district\" ng-model=\"vm.cliente.address.district\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_address_district.$touched\"><span ng-show=\"form.cliente_address_district.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-2-10 mobile-care-padding-margin-responsive\"><label>Cidade</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_address_city\" name=\"cliente_address_city\" ng-model=\"vm.cliente.address.city\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_address_city.$touched\"><span ng-show=\"form.cliente_address_city.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-1-10 mobile-care-padding-margin-responsive\"><label>Estado</label> <input type=\"text\" maxlength=\"50\" class=\"md-input\" id=\"cliente_address_state\" name=\"cliente_address_state\" ng-model=\"vm.cliente.address.state\" md-input=\"\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_address_state.$touched\"><span ng-show=\"form.cliente_address_state.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row mobile-care-margin-top-zero\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-4 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\" style=\"margin-top:5px;\"><label class=\"mobile-care-label-md-input-less\">Telefone</label> <input ui-mask=\"(99) 99999-9999\" type=\"text\" class=\"md-input\" id=\"cliente_phone\" name=\"cliente_phone\" ng-model=\"vm.cliente.phone.phoneNumber\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_phone.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_phone.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-1-4 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\" style=\"margin-top:0px\"><label class=\"mobile-care-label-md-input-less\">Sexo</label><selectize placeholder=\"Selecione\" id=\"cliente_sexo\" name=\"cliente_sexo\" config=\"vm.selectize_config\" required=\"\" options=\"vm.listSex\" position=\"bottom\" ng-model=\"vm.cliente.sex\"></selectize><div ng-show=\"form.$submitted || form.cliente_sexo.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_sexo.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-form-row mobile-care-margin-top-zero\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-2 mobile-care-padding-margin-responsive\"><label>E-mail</label> <input type=\"email\" maxlength=\"50\" class=\"md-input\" id=\"cliente_email\" name=\"cliente_email\" ng-model=\"vm.cliente.email\" md-input=\"\" required=\"\" ng-disabled=\"vm.isEdicao\"><div ng-show=\"form.$submitted || form.cliente_email.$touched\"><span ng-show=\"form.cliente_email.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span ng-show=\"form.cliente_email.$error.email\" class=\"help-block\">E-mail Inválido</span></div></div></div></div><div class=\"uk-form-row mobile-care-margin-top-zero\" mtm-show-errors=\"\"><div class=\"uk-grid\"><div class=\"uk-width-medium-1-4 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\"><label class=\"mobile-care-label-md-input-less\">Tipo de Documento</label><selectize placeholder=\"Selecione\" id=\"cliente_document_type\" name=\"cliente_document_type\" config=\"vm.selectize_config\" required=\"\" options=\"vm.listDocumentType\" position=\"bottom\" ng-model=\"vm.cliente.documentType\" ng-change=\"vm.cleanDocumentNumberError()\"></selectize><div ng-show=\"form.$submitted || form.cliente_document_type.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_document_type.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div><div class=\"uk-width-medium-1-4 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\" style=\"margin-top:5px\" ng-if=\"vm.cliente.documentType == \'CPF\'\"><label class=\"mobile-care-label-md-input-less\">CPF</label> <input type=\"text\" maxlength=\"18\" ng-minlength=\"14\" class=\"md-input\" id=\"cliente_document_number\" required=\"\" name=\"cliente_document_number\" ng-model=\"vm.cliente.documentNumber\" ui-mask=\"999.999.999-99\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\" ng-blur=\"vm.validateCpf(vm.cliente.documentNumber)\"><div ng-show=\"form.$submitted || form.cliente_document_number.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_document_number.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span class=\"help-block\" ng-show=\"vm.invalidCpf\">Dígito verificador do CPF é inválido.</span></div></div><div class=\"uk-width-medium-1-4 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\" style=\"margin-top:5px;\" ng-if=\"vm.cliente.documentType == \'CNPJ\'\"><label>CNPJ</label> <input type=\"text\" maxlength=\"18\" ng-minlength=\"14\" class=\"md-input\" id=\"cliente_document_number\" name=\"cliente_document_number\" ng-model=\"vm.cliente.documentNumber\" ui-mask=\"99.999.999/9999-99\" required=\"\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\" ng-blur=\"vm.validateCnpj(vm.cliente.documentNumber)\"><div ng-show=\"form.$submitted || form.cliente_document_number.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_document_number.$error.required\" class=\"help-block\">Campo Obrigatório</span> <span class=\"help-block\" ng-show=\"vm.invalidCnpj\">Dígito verificador do CNPJ é inválido.</span></div></div><div class=\"uk-width-medium-1-4 mobile-care-padding-margin-responsive mobile-care-margin-md-input-less\" style=\"margin-top:5px;\" ng-if=\"vm.cliente.documentType == \'RNE\'\"><label>RNE</label> <input type=\"text\" class=\"md-input\" id=\"cliente_rne\" name=\"cliente_rne\" ng-model=\"vm.cliente.documentNumber\" ui-mask=\"A999999A\" required=\"\"><div ng-show=\"form.$submitted || form.cliente_rne.$touched\" style=\"margin-top:13px\"><span ng-show=\"form.cliente_rne.$error.required\" class=\"help-block\">Campo Obrigatório</span></div></div></div></div><br></div></div></div></form></div></div>");
$templateCache.put("app/usuario.mobile/cliente.detail.html","<div class=\"loading-spinner\" ng-if=\"vm.isLoadingDetail\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div ng-if=\"!vm.isLoadingDetail\" class=\"scrum_column\"><div id=\"scrum_column_inProgress\"><div><div id=\"detalheDiv\"><div class=\"md-card\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\">CONTA</span></h2><div class=\"md-card-toolbar-actions hidden-print\"><div class=\"md-card-dropdown\" data-uk-dropdown=\"{pos:\'bottom-right\'}\" aria-haspopup=\"true\" aria-expanded=\"false\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\"></i><div class=\"uk-dropdown uk-dropdown-scrollable uk-dropdown-bottom\" aria-hidden=\"true\" style=\"min-width: 200px;\" tabindex=\"\"><ul class=\"uk-nav uk-nav-dropdown\"><li class=\"mobile-care-item\" ng-click=\"vm.confirmSendForgotPasswordEmail(vm.cliente)\" style=\"outline: 0; cursor: pointer;\"><div class=\"uk-input-group\" style=\"padding-left:20px;\"><a style=\"color: #000 !important;\"><i class=\"material-icons\">&#xE158;</i> Redefinir Senha</a></div></li><li class=\"mobile-care-item\" ng-click=\"vm.confirmSendEmail(vm.cliente)\" style=\"outline: 0; cursor: pointer;\"><div class=\"uk-input-group\" style=\"padding-left:20px;\"><a style=\"color: #000 !important;\"><i class=\"material-icons\">&#xE0E1;</i> Reenviar Confirmação</a></div></li></ul></div></div></div></div><div class=\"md-card-content\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data do Cadastro</span> <span class=\"\">{{vm.cliente.registerDate}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Login</span> <span class=\"\">{{vm.cliente.userName}}</span></div></li><li ng-if=\"vm.isUsuarioReenviarEmailPermitido\"><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Status de Confirmação do E-mail</span> <span class=\"uk-text-primary\" ng-if=\"vm.cliente.emailConfirmed\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 7px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small class=\"uk-bg-primary\" style=\"left: 18px; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirmEmail(vm.cliente)\"></small></span> Confirmado</span> <span class=\"\" style=\"color:red;\" ng-if=\"!vm.cliente.emailConfirmed\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: #fd6800; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirmEmail(vm.cliente)\"></small></span> Pendente</span></div></li><li ng-if=\"vm.isUsuarioInativarPermitido\"><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Status da Conta</span> <span class=\"uk-text-primary\" ng-if=\"vm.cliente.enabled\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 7px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small class=\"uk-bg-primary\" style=\"left: 18px; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirm(vm.cliente)\"></small></span> Ativa</span> <span class=\"\" style=\"color:red;\" ng-if=\"!vm.cliente.enabled\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: #fd6800; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirm(vm.cliente)\"></small></span> Inativa</span></div></li><li ng-if=\"vm.isUsuarioInativarPermitido\"><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Usuário Beta</span> <span class=\"uk-text-primary\" ng-if=\"vm.cliente.beta\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_active\" class=\"ng-untouched ng-valid ng-isolate-scope ng-not-empty ng-dirty ng-valid-parse\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 7px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s, background-color 1.2s;\"><small class=\"uk-bg-primary\" style=\"left: 18px; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirmBeta(vm.cliente)\"></small></span> Sim</span> <span class=\"\" style=\"color:red;\" ng-if=\"!vm.cliente.beta\"><input type=\"checkbox\" ui-switch=\"\" ng-model=\"switches.switch_i\" color=\"#7cb342\" checked=\"\" id=\"checkbox_inactive\" class=\"ng-untouched ng-valid ng-isolate-scope ng-dirty ng-valid-parse ng-empty\" style=\"display: none;\" data-switchery=\"true\"> <span class=\"switchery switchery-default\" style=\"box-shadow: rgba(0, 0, 0, 0.258824) 0px 0px 0px 0px inset; border-color: rgba(0, 0, 0, 0.258824); background-color: rgba(0, 0, 0, 0.258824); transition: border 0.4s, box-shadow 0.4s;\"><small style=\"left: 0px; background-color: #fd6800; transition: background-color 0.4s, left 0.2s;\" ng-click=\"vm.confirmBeta(vm.cliente)\"></small></span> Não</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Credencial Validada?</span> <span class=\"uk-text-primary\" ng-if=\"vm.cliente.validClientCredentials\">Sim</span> <span style=\"color:red;\" ng-if=\"!vm.cliente.validClientCredentials\">Não</span></div></li></ul></div></div><div class=\"md-card\"><div class=\"md-card-toolbar\"><h2 class=\"md-card-toolbar-heading-text\"><span class=\"uk-text-small uk-text-bold\">PERFIL</span></h2></div><div class=\"md-card-content\"><div class=\"uk-width-xLarge-1-1 uk-width-large-1-1 uk-width-small-1-1\"><ul class=\"md-list\"><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Nome</span> <span class=\"\">{{vm.cliente.profiles[0].name}} {{vm.cliente.profiles[0].surname}}</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Data de Aniversário</span> <span ng-if=\"vm.cliente.profiles[0].birthDate\">{{vm.cliente.profiles[0].birthDate.split(\' \')[0]}}</span> <span ng-if=\"!vm.cliente.profiles[0].birthDate\">Sem data de aniversário informada.</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">CRM</span> <span ng-if=\"vm.cliente.profiles[0].crm\">{{vm.cliente.profiles[0].crm}}</span> <span ng-if=\"!vm.cliente.profiles[0].crm\" class=\"\">Sem CRM</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Especialidade</span> <span class=\"\" ng-if=\"vm.cliente.profiles[0].specialty\">{{vm.cliente.profiles[0].specialty}}</span> <span class=\"\" ng-if=\"!vm.cliente.profiles[0].specialty\">Sem especialidade informada.</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Endereço</span> <span><label ng-if=\"!vm.cliente.profiles[0].address.addressLine1 || vm.cliente.profiles[0].address.addressLine1.length == 0\">Não possui endereço.</label> <label ng-if=\"vm.cliente.profiles[0].address.addressLine1\">{{vm.cliente.profiles[0].address.addressLine1}}</label> <label ng-if=\"vm.cliente.profiles[0].address.district\" style=\"margin-left:-2px\">, {{vm.cliente.profiles[0].address.district}}</label> <label ng-if=\"vm.cliente.profiles[0].address.city\" style=\"margin-left:-2px\">, {{vm.cliente.profiles[0].address.city}}</label> <label ng-if=\"vm.cliente.profiles[0].address.zipCode\">- CEP: {{vm.cliente.profiles[0].address.zipCode}}</label></span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Telefone</span> <span ng-if=\"vm.cliente.profiles[0].phone\">{{vm.cliente.profiles[0].phone.text.replace(\"|\",\" \").replace(\"|\",\" \")}}</span> <span ng-if=\"!vm.cliente.profiles[0].phone\" class=\"\">Sem telefone</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Sexo</span> <span ng-if=\"vm.cliente.profiles[0].sex\">{{vm.cliente.profiles[0].sex}}</span> <span ng-if=\"!vm.cliente.profiles[0].sex\">Sem sexo informado.</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Email</span> <span ng-if=\"vm.cliente.profiles[0].mail\">{{vm.cliente.profiles[0].mail}}</span> <span ng-if=\"!vm.cliente.profiles[0].mail\" class=\"\">Sem endereço de email</span></div></li><li><div class=\"md-list-content\"><span class=\"uk-text-small uk-text-muted uk-display-block\">Documento</span> <span ng-if=\"vm.cliente.profiles[0].documentType\">{{vm.cliente.profiles[0].documentType}}: {{vm.cliente.profiles[0].documentNumber}}</span> <span ng-if=\"!vm.cliente.profiles[0].documentType\" class=\"\">Sem documento</span></div></li></ul></div></div></div></div></div></div><br></div>");
$templateCache.put("app/usuario.mobile/cliente.list.html","<div id=\"page_content\"><div id=\"page_overflow\"><div id=\"page_heading\"><div class=\"heading_actions\"><a ng-click=\"vm.addAppCompany(vm.cliente)\" tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"Associar Usuário Mobile a Este Local\" class=\"md-fab md-fab-small md-fab-primary\"><i class=\"mobilecare-icons\">&#xea20;</i></a></div><div class=\"heading_actions\" ng-if=\"vm.isUsuarioCadastrarPermitido\"><a class=\"md-fab md-fab-small md-fab-primary\" ui-sref=\"private.painel.cliente.create\"><i class=\"material-icons\">&#xE145;</i></a></div><h1><i class=\"material-icons\" style=\"font-size: 30px;\">&#xE8D3;</i><a target=\"#\">Usuários Mobile</a></h1><span ng-if=\"vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">{{vm.appCompany.company.name}} &raquo; {{vm.appCompany.name}}</span> <span ng-if=\"!vm.appCompany\" class=\"uk-text-muted uk-text-upper uk-text-small\">Nenhum App Selecionado</span></div><div id=\"page_section_info\"><div class=\"uk-grid uk-grid-collapse\"><div class=\"uk-width-2-10 uk-border-right uk-height-1-1\"><div class=\"scrum_column_heading\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><div class=\"md-card-dropdown\" data-uk-dropdown=\"{pos:\'bottom-right\'}\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D4;</i><div class=\"uk-dropdown uk-dropdown-small uk-dropdown-top\" style=\"margin-top: 8px !important;\"><ul class=\"uk-nav\"><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isStatusContaFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"situationCheck\" id=\"situationCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isStatusContaFilterChecked\" icheck=\"\"></span> <label for=\"situationCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Status Conta</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isStatusEmailFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"serviceCheck\" id=\"serviceCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isStatusEmailFilterChecked\" icheck=\"\"></span> <label for=\"serviceCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Status E-mail</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserNameFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"catCheck\" id=\"catCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserNameFilterChecked\" icheck=\"\" ng-value=\"true\" ng-checked=\"true\"></span> <label for=\"catCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Nome</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserEmailFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserEmailFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">E-mail</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserCityFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserCityFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Cidade</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserStateFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserStateFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Estado</label></div></li><li style=\"margin-top: 5px !important;\"><div style=\"margin-left:-5px\" ng-init=\"vm.isUserDocumentNumberFilterChecked=true\" class=\"uk-input-group\"><span class=\"uk-input-group-addon\"><input name=\"usersCheck\" id=\"usersCheck\" type=\"checkbox\" class=\"ckbFilter\" ng-model=\"vm.isUserDocumentNumberFilterChecked\" icheck=\"\"></span> <label for=\"usersCheck\" style=\"margin-left:-13px\" class=\"uk-text-xsmall uk-text-truncate\">Número Documento</label></div></li></ul></div></div></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">PESQUISA</h3></div></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"><span><div class=\"uk-badge\" style=\"margin-top:-8px\" tooltips=\"\" tooltip-size=\"small\" tooltip-side=\"bottom\" tooltip-template=\"Número de registros da listagem.\">({{vm.total}}) Registro<span ng-show=\"vm.total && vm.total > 0\">s</span></div></span> <a tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"Exportar lista como excel\" ng-click=\"vm.exportData()\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE8E5;</i></a> <a tooltips=\"\" tooltip-size=\"small\" style=\"color: lightgray !important;\" tooltip-side=\"bottom\" tooltip-template=\"Atualizar lista de usuários\" ng-click=\"vm.pesquisar(vm.filters)\"><i class=\"md-icon material-icons\" data-uk-tooltip=\"{cls:\'uk-tooltip-small\',pos:\'bottom\'}\">&#xE5D5;</i></a></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\" title=\"Exportar\">USUÁRIOS ASSOCIADOS</h3></div></div></div><div class=\"uk-width-4-10 uk-border-right\"><div class=\"md-card\" style=\"box-shadow:none; shadow:none;\"><div class=\"md-card-toolbar\" style=\"border: none !important;\"><div class=\"md-card-toolbar-actions hidden-print\"></div><h3 class=\"md-card-toolbar-heading-text uk-text-primary\">DETALHES</h3></div></div></div></div></div><div class=\"uk-grid uk-grid-collapse uk-height-1-1 uk-margin-remove\"><div class=\"uk-width-2-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"uk-grid uk-grid-collapse page_aside_inner\"><div class=\"uk-width-medium-1-1 uk-row-first\"><div class=\"loading-spinner\" ng-if=\"vm.isLoadingFiltros\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><form ng-if=\"vm.isUsuarioPesquisarPermitido && !vm.isLoadingFiltros\" name=\"form\" id=\"form_search\" mt-validate-submit=\"vm.pesquisar(vm.filters)\" novalidate=\"\"><div ng-if=\"vm.isStatusContaFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Status da Conta</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todas\" id=\"status\" name=\"status\" config=\"vm.selectize_sources_status_config\" options=\"vm.selectize_sources_status\" position=\"bottom\" ng-model=\"vm.filters.Enabled\"></selectize></div></div></div><div ng-if=\"vm.isStatusEmailFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Status do E-mail</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"status_email\" name=\"status\" config=\"vm.selectize_sources_status_email_config\" options=\"vm.selectize_sources_status_email\" position=\"bottom\" ng-model=\"vm.filters.emailConfirmed\"></selectize></div></div></div><div ng-if=\"vm.isUserNameFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Nome</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_name\" name=\"cliente_filter\" value=\"\" ng-model=\"vm.filters.Name\" md-input=\"\"></div></div></div><div ng-if=\"vm.isUserEmailFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>E-mail</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_email\" name=\"cliente_filter\" value=\"\" ng-model=\"vm.filters.Mail\" md-input=\"\"></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Sexo</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"status_gender\" name=\"status_gender\" config=\"vm.selectize_gender_config\" options=\"vm.selectize_gender.options\" position=\"bottom\" ng-model=\"vm.filters.gender\"></selectize></div></div></div><div class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Usuário Beta</label><div class=\"md-input-wrapper\"><selectize class=\"custom_selectize\" placeholder=\"Todos\" id=\"status_beta\" name=\"status_beta\" config=\"vm.selectize_beta_config\" options=\"vm.selectize_beta.options\" position=\"bottom\" ng-model=\"vm.filters.beta\"></selectize></div></div></div><div ng-if=\"vm.appCompany.type==\'Doctor\'\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>CRM</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_crm\" name=\"cliente_filter_crm\" value=\"\" ng-model=\"vm.filters.crm\" md-input=\"\"></div></div></div><div ng-if=\"vm.isUserCityFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Cidade</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_cidade\" name=\"cliente_filter_cidade\" value=\"\" ng-model=\"vm.filters.addressCity\" md-input=\"\"></div></div></div><div ng-if=\"vm.isUserStateFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Estado</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_estado\" name=\"cliente_filter_estado\" value=\"\" ng-model=\"vm.filters.addressState\" md-input=\"\"></div></div></div><div ng-if=\"vm.isUserDocumentNumberFilterChecked\" class=\"uk-width-1-1 uk-row-first\"><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Número do Documento</label><div class=\"md-input-wrapper\"><input type=\"text\" class=\"md-input-2\" id=\"cliente_filter_cpf\" name=\"cliente_filter_cpf\" value=\"\" ng-model=\"vm.filters.Cpf\" md-input=\"\"></div></div></div><div class=\"uk-form-row\"><i class=\"uk-icon-filter uk-text-muted-light\"></i> <label>Período de Cadastro</label><div class=\"uk-grid\" data-uk-grid-margin=\"\"><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input placeholder=\"Início\" class=\"md-input-2\" type=\"text\" id=\"uk_dp_start\" name=\"uk_dp_start\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.DateIni\" ng-required=\"vm.filters.DateIni\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"><div ng-show=\"form.$submitted || form.uk_dp_start.$touched\"><span ng-show=\"form.uk_dp_start.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-medium-1-2 uk-width-1-1 uk-row-first\"><div class=\"md-input-wrapper\"><input class=\"md-input-2\" placeholder=\"Fim\" type=\"text\" id=\"uk_dp_end\" name=\"uk_dp_end\" data-uk-datepicker=\"{{vm.datePickerFormat}}\" md-input=\"\" ng-model=\"vm.filters.DateEnd\" onkeypress=\"return ((event.charCode == 8 | event.charCode >= 48 && event.charCode <= 57))\" onselectstart=\"return false\" onpaste=\"return false;\" oncopy=\"return false\" oncut=\"return false\" ondrag=\"return false\" ondrop=\"return false\"></div><div ng-show=\"form.$submitted || form.uk_dp_end.$touched\"><span ng-show=\"form.uk_dp_end.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div></div><div class=\"uk-width-medium-1-1 uk-width-large-1-1 uk-row-first\"><div class=\"uk-form-row\"><button type=\"submit\" class=\"md-btn md-btn-primary md-btn-block md-btn-wave-light waves-effect waves-button waves-light\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Pesquisar</button></div></div></form></div></div></div><div id=\"users_cliente\" class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"loading-spinner\" ng-if=\"vm.isLoading\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.clientes.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Nenhum registro encontrado.</span></h3></div></div><div ng-if=\"!vm.isLoading && vm.clientes.length > 0\" auto-height=\"\"><div infinite-scroll-disabled=\"vm.busy || vm.isLastPage\" infinite-scroll=\"vm.getNextPageClientes()\" infinite-scroll-immediate-check=\"true\" infinite-scroll-distance=\"0\" infinite-scroll-container=\"\'#users_cliente\'\" infinite-scroll-parent=\"true\"><div class=\"scrum_task\" ng-repeat=\"item in vm.clientes\" ng-class=\"{ \'chamado-active\': $index == vm.selectedIndex}\" ng-click=\"vm.detailClient(item.id, $index)\" style=\"z-index:0;margin-bottom:5px;cursor:pointer\"><div class=\"critical\"><div><table><tbody><td><div class=\"\"><div ng-if=\"!item.img\"><div class=\"user_heading_avatar\"><div class=\"thumbnail\"><img ng-src=\"https://mobilecare.blob.core.windows.net/{{item.appId}}/{{item.id}}/{{item.id}}.jpg\" onerror=\"this.src=\'assets/img/avatars/user-alt@2x.png\'\"></div></div></div><div ng-if=\"item.img\"><div class=\"user_heading_avatar\"><div class=\"thumbnail\"><img ng-src=\"data:image/gif; base64, {{item.img}}\" style=\"max-width: 80px; max-height: 80px; width: auto; height: auto;\"></div></div></div></div></td><td><div class=\"md-list-outside-wrapper\"><div ng-if=\"item.profiles.length > 0\"><p class=\"uk-width-medium-10-10 uk-width-small-10-10 scrum_task_description\"><b>{{item.profiles[0].name}} {{item.profiles[0].surname}}</b></p></div><p class=\"scrum_task_description\">{{item.email}}</p><div ng-if=\"item.profiles.length > 0\"><p class=\"uk-width-medium-10-10 uk-width-small-10-10 scrum_task_description\"><span ng-if=\"item.profiles[0].documentType\">{{item.profiles[0].documentType}}: {{item.profiles[0].documentNumber}}</span></p></div><p class=\"scrum_task_description\"><span ng-if=\"item.enabled\"><i class=\"material-icons uk-text-primary\">&#xE86C;</i> <span class=\"uk-text-primary\">Conta Ativa</span> &nbsp &nbsp &nbsp <span ng-if=\"item.emailConfirmed\" class=\"uk-text-primary\"><i class=\"material-icons uk-text-primary\">&#xE86C;</i> E-mail Confirmado</span> <span ng-if=\"!item.emailConfirmed\" style=\"color:#fd6800;\"><i class=\"material-icons\" style=\"color:#fd6800;\">&#xE8B5;</i> E-mail não confirmado</span></span> <span ng-if=\"!item.enabled\"><i class=\"material-icons\" style=\"color: red;\">&#xE001;</i> <span style=\"color: red;\">Conta Inativa</span> &nbsp &nbsp &nbsp <span ng-if=\"item.emailConfirmed\" class=\"uk-text-primary\"><i class=\"material-icons uk-text-primary\">&#xE86C;</i> E-mail Confirmado</span> <span ng-if=\"!item.emailConfirmed\" style=\"color:#fd6800;\"><i class=\"material-icons\" style=\"color:#fd6800;\">&#xE8B5;</i> E-mail não confirmado</span></span></p></div></td></tbody></table></div></div></div><div class=\"loading-spinner\" ng-if=\"vm.busy\"><svg class=\"spinner\" width=\"65px\" height=\"65px\" viewbox=\"0 0 66 66\" xmlns=\"http://www.w3.org/2000/svg\"><circle class=\"path\" fill=\"none\" stroke-width=\"6\" cx=\"33\" cy=\"33\" r=\"30\"></circle></svg></div></div></div></div><div class=\"uk-width-4-10 uk-overflow-container uk-border-right uk-height-1-1\" style=\"padding: 10px !important;\"><div class=\"md-card\" ng-if=\"!vm.isLoading && vm.clientes.length === 0\"><div class=\"md-card-toolbar\"><h3 class=\"md-card-toolbar-heading-text\" style=\"width: 100% !important; text-align: center !important;\"><span><i class=\"material-icons\">&#xe000;</i> Detalhe não disponível.</span></h3></div></div><div ng-if=\"!vm.isLoading && vm.clientes.length > 0 && vm.isUsuarioVisualizarPermitido\" ui-view=\"\" auto-height=\"\"></div></div></div></div></div><div id=\"exportable\" style=\"display:none; z-index:-1;\"><table width=\"100%\"><thead><tr><th>Nome</th><th>Email</th><th>Endereco</th><th>Documento</th><th>Sexo</th><th>Telefone</th><th>CRM</th><th>Data de Aniversario</th><th>Especialidade</th></tr></thead><tbody><tr ng-repeat=\"item in vm.excel\"><td>{{item.Nome}}</td><td>{{item.Email}}</td><td>{{item.Endereco}}</td><td>{{item.Documento}}</td><td>{{item.Sexo}}</td><td>{{item.Telefone}}</td><td>{{item.CRM}}</td><td>{{item.BirthDate}}</td><td>{{item.Especialidade}}</td></tr></tbody></table></div><div class=\"uk-modal custom modalAddApp\" id=\"modalAddApp\" aria-hidden=\"false\"><div class=\"uk-modal-dialog uk-modal-dialog-lightbox uk-modal-config uk-modal-dialog-custom\"><button type=\"button\" id=\"btnCloseModalCategory\" class=\"uk-modal-close uk-close uk-close-alt\" style=\"z-index:1000; visibility:hidden\"></button><div class=\"uk-modal-container-custom\"><div class=\"uk-modal-header-custom md-bg-grey-200\"><h3 class=\"uk-modal-title\">Associar Usuário Mobile a Este Local</h3></div><form name=\"formApp\" id=\"formApp\" mt-validate-submit=\"vm.submitApp(vm.modalAddApp)\" novalidate=\"\"><div class=\"uk-modal-body-custom\"><div class=\"uk-grid\"><div class=\"uk-width-small-1-1\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Email</label><div class=\"md-input-wrapper2\"><input type=\"text\" class=\"md-input-2\" id=\"email\" name=\"email\" ng-model=\"vm.modalAddApp.email\" md-input=\"\" required=\"\" placeholder=\"nome@email.com\"></div><div ng-show=\"formApp.$submitted || formApp.email.$touched\"><span ng-show=\"formApp.email.$error.required\" class=\"md-error\">Campo Obrigatório</span></div></div></div><div class=\"uk-width-small-1-1\" ng-show=\"vm.appList && vm.appList.length == 1 || vm.appList.length > 0\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>App</label> <span class=\"md-input-wrapper2\"><selectize class=\"custom_selectize\" required=\"\" placeholder=\"Selecione\" config=\"vm.selectize_config\" options=\"vm.appList\" position=\"bottom\" ng-model=\"vm.modalAddApp.app\" id=\"app\" name=\"name\" ng-disabled=\"vm.disableAppList\"></selectize></span><div ng-show=\"formApp.$submitted || formApp.name.$touched\"><span ng-show=\"formApp.name.$error.required\" class=\"md-error\">Campo Obrigatório</span></div><br><br></div></div><div class=\"uk-width-small-1-1\" ng-show=\"vm.appList && vm.appList.length == 0\"><div class=\"uk-form-row\" mtm-show-errors=\"\"><label>Este Local não ainda não está vinculado a um aplicativo. Por favor, contate o administrador do sistema.</label><br><br></div></div></div></div><div class=\"uk-modal-footer-custom\"><span class=\"ng-binding uk-text-right\"><a ng-click=\"vm.resetFormModalApp(formApp)\" class=\"md-btn md-btn-small md-btn-danger\"><i class=\"material-icons md-18 md-light\">&#xE925;</i> Cancelar</a> <button form=\"formApp\" type=\"submit\" class=\"md-btn md-btn-small md-btn-primary uk-text-right\" id=\"btnSave\"><i class=\"material-icons md-18 md-light\">&#xE14D;</i> Salvar</button></span></div></form></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar\"><a href=\"https://github.com/Swiip/generator-gulp-angular\">Gulp Angular</a><ul><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></nav>");}]);